var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import { l as PropTypes, _ as _inheritsLoose, n as _extends$4, o as _assertThisInitialized$2, p as get$3, k as getDefaultExportFromCjs, q as commonjsGlobal, r as omit, m as merge, s as propTypesExports, t as getAugmentedNamespace, u as isEqual$3, v as _setPrototypeOf$2, w as _isNativeReflectConstruct$2, x as _getPrototypeOf$2, d as curriedTransparentize$1, y as FONT_FILE_MAPPINGS, P as PURPLE_THEME } from "./purpleTheme-C7Ke6SEd.mjs";
import { B, z, F, A, e, g, C } from "./purpleTheme-C7Ke6SEd.mjs";
import { A as AXCELUS_THEME, B as BESTOW_THEME, L as LANTERN_THEME, E as EQUITABLE_THEME, T as TRANSAMERICA_THEME, U as USAA_THEME, N as NATIONWIDE_THEME } from "./axcelusTheme-Qcy7Z2ll.mjs";
import { j as jsxRuntimeExports } from "./jsx-runtime-ClFauRgV.mjs";
import { T as TOKENS, S as SEMANTIC_TOKENS, g as STATIC_VALUES, h as STATIC_TOKENS, u as useKindredConfigOptional, f as fontSizeRem, e as bodyStyles, B as BREAKPOINTS } from "./Body-BIpqC0h-.mjs";
import { K } from "./Body-BIpqC0h-.mjs";
import * as React from "react";
import React__default, { useRef, useCallback, useContext, useState, useEffect, useMemo, forwardRef, useId as useId$2, isValidElement, cloneElement, Children, Fragment, useReducer, useImperativeHandle, createRef, createContext as createContext$1, useLayoutEffect, Component, memo, useSyncExternalStore, createElement, PureComponent } from "react";
import * as ReactDOM from "react-dom";
import ReactDOM__default, { createPortal } from "react-dom";
import { a as compose, s as space, l as layout, b as color, d as background, e as border, p as position$1, f as composeWrapper, g as flexbox, h as grid, i as padding, t as typography, c as createContext, j as system, k as shadow, P as Pseudostate, m as svg, n as pseudostatePropsArray, o as borderColor, q as borderTop, r as borderLeft, u as borderBottom, v as borderRight, x as borderWidth, y as borderStyle, z as margin } from "./withKindredTheme-Bll45cUk.mjs";
import { w } from "./withKindredTheme-Bll45cUk.mjs";
import { k as kindredShouldForwardProp, m as memoize$2 } from "./shouldForwardProp-BVWMire5.mjs";
import { styled, css as css$3, keyframes as keyframes$1, createGlobalStyle, useTheme, StyleSheetManager, ThemeProvider } from "styled-components";
import { v4 } from "uuid";
import Select$1, { defaultTheme as defaultTheme$1, components as components$1 } from "react-select";
const CDN_BASE = "https://static.bestow.com/fonts";
const SYSTEM_FONTS = /* @__PURE__ */ new Set(["Arial", "Georgia"]);
const toStaticFontName = (fontFamily) => fontFamily.replace(/\s+/g, "");
const fontStylesheetHref = (fontFamily) => {
  const name = toStaticFontName(fontFamily);
  return `${CDN_BASE}/${name}/${name}.css`;
};
const KindredFontLink = ({
  tokens
}) => {
  var _a2;
  const {
    primary,
    accent,
    tertiary,
    signature
  } = ((_a2 = tokens.text) == null ? void 0 : _a2.fontFamily) ?? {};
  const fontsToLoad = [.../* @__PURE__ */ new Set([primary, accent, tertiary, signature])].filter((name) => typeof name === "string" && name.length > 0 && !SYSTEM_FONTS.has(name));
  return /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: fontsToLoad.map((fontFamily) => /* @__PURE__ */ jsxRuntimeExports.jsx("link", { rel: "stylesheet", href: fontStylesheetHref(fontFamily), "data-kindred": `font-${toStaticFontName(fontFamily)}` }, fontFamily)) });
};
const RESET_CSS = `
  *,
  *::before,
  *::after {
    box-sizing: border-box;
  }

  html,
  body {
    height: 100%;
    width: 100%;
    margin: 0;
  }

  #root {
    height: 100%;
  }
`;
const BASE_FONT_CSS = `
  body {
    font-family: var(${TOKENS.text.fontFamily.primary});
    color: var(${TOKENS.color.foreground.default});
  }
`;
const KindredGlobalStyle = () => /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
  /* @__PURE__ */ jsxRuntimeExports.jsx("style", { "data-kindred": "css-reset", children: RESET_CSS }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("style", { "data-kindred": "base-font", children: BASE_FONT_CSS })
] });
function isRecord(value) {
  return typeof value === "object" && value !== null;
}
function serializeKindredTokens(tokens) {
  const pairs = [];
  walkTokens(SEMANTIC_TOKENS, tokens, pairs);
  return pairs.join("; ");
}
function walkTokens(schema, values3, acc) {
  const valueRecord = isRecord(values3) ? values3 : {};
  Object.keys(schema).forEach((key) => {
    const schemaNode = schema[key];
    const valueNode = valueRecord[key];
    if (typeof schemaNode === "string") {
      if (valueNode === void 0) return;
      acc.push(`${schemaNode}: ${String(valueNode)}`);
    } else if (schemaNode) {
      walkTokens(schemaNode, valueNode, acc);
    }
  });
}
function serializeStaticTokens() {
  const pairs = [];
  walkTokens(STATIC_TOKENS, STATIC_VALUES, pairs);
  return pairs.join("; ");
}
const KindredTokenStyle = ({
  tokens
}) => {
  const css4 = `:root { ${[serializeKindredTokens(tokens), serializeStaticTokens()].filter(Boolean).join("; ")}; }`;
  return /* @__PURE__ */ jsxRuntimeExports.jsx("style", { "data-kindred": "tokens", children: css4 });
};
const KindredHead = ({
  tokens
}) => /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
  /* @__PURE__ */ jsxRuntimeExports.jsx(KindredFontLink, { tokens }),
  /* @__PURE__ */ jsxRuntimeExports.jsx(KindredTokenStyle, { tokens }),
  /* @__PURE__ */ jsxRuntimeExports.jsx(KindredGlobalStyle, {})
] });
const BESTOW_ENTERPRISE_MISC = {
  inputAllCaps: false,
  labelAllCaps: true
};
const BESTOW_ENTERPRISE_TOKENS = {
  color: {
    foreground: {
      default: "#344054",
      subdued: "#667085",
      onNavigation: "#101828",
      primary: "#344054",
      interaction: {
        onAccent: "#ffffff",
        onSelected: "#344054",
        disabled: "#667085",
        onDisabled: "#667085",
        accent: "#5e65fb",
        accentHover: "#3538cd",
        accentActive: "#2d31a6",
        onReverse: "#ffffff",
        onReverseHover: "#ffffffcc",
        onReverseActive: "#ffffffe6",
        onFeedback: "#344054",
        onFeedbackHover: "#667085",
        onFeedbackActive: "#475467",
        onAccentSubdued: "#5e65fb",
        onDanger: "#ffffff",
        dangerHover: "#e5271d",
        dangerActive: "#bb1b13"
      },
      feedback: {
        success: "#00563e",
        warning: "#914f00",
        danger: "#921009",
        info: "#5e65fb"
      },
      series: {
        onData01: "#ffffff",
        onData02: "#ffffff",
        onData03: "#ffffff",
        onData04: "#344054",
        onData05: "#ffffff",
        onData06: "#344054",
        onData07: "#344054",
        onData08: "#344054",
        onData09: "#344054",
        onData10: "#344054",
        onData11: "#ffffff",
        onData12: "#ffffff",
        onData13: "#ffffff",
        onData14: "#ffffff"
      }
    },
    background: {
      surface0: "#ffffff",
      surface1: "#f9fafb",
      surface2: "#f2f4f7",
      surface3: "#e4e7ec",
      application: "#f9fafb",
      reverse: "#101828",
      surfaceOverlay: "#e4e7ec99",
      surfaceObscure: "#10182899",
      navigation: "#ffffff",
      interaction: {
        accent: "#5e65fb",
        accentHover: "#3538cd",
        accentActive: "#2d31a6",
        transparent: "#ffffff00",
        accentSubdued: "#ebf4ff",
        accentSubduedHover: "#deedff",
        accentSubduedActive: "#c3d4ff",
        danger: "#e5271d",
        dangerHover: "#bb1b13",
        dangerActive: "#921009",
        disabled: "#e4e7ec",
        neutral: "#ffffff",
        neutralHover: "#f2f4f7",
        neutralActive: "#c4c9d2",
        neutralSelected: "#c3d4ff",
        neutralSelectedHover: "#9fb2ff",
        neutralActivated: "#7988ff",
        neutralUnactivated: "#e4e7ec",
        neutralEmphasized: "#ebf4ff",
        neutralEmphasizedHover: "#deedff",
        neutralDisabled: "#f2f4f7",
        dangerSubduedHover: "#ffe3e1",
        dangerSubduedActive: "#fac4c0",
        dangerSelected: "#fac4c0"
      },
      feedback: {
        info: "#ebf4ff",
        success: "#ebfef6",
        warning: "#fff5c6",
        danger: "#fff2f1",
        infoStrong: "#5e65fb",
        successStrong: "#009c71",
        warningStrong: "#fab636",
        dangerStrong: "#e5271d"
      },
      series: {
        data01: "#5e65fb",
        data02: "#667085",
        data03: "#009c71",
        data04: "#f9a207",
        data05: "#9f1ab1",
        data06: "#deedff",
        data07: "#e4e7ec",
        data08: "#b0f7dc",
        data09: "#fff5c6",
        data10: "#f6d0fe",
        data11: "#2d31a6",
        data12: "#344054",
        data13: "#006d4f",
        data14: "#6f1877"
      }
    },
    border: {
      default: "#e4e7ec",
      brand: "#5e65fb",
      onColor: "#ffffff33",
      subtle: "#f9fafb",
      focus: "#5e65fb",
      focusDanger: "#e5271d",
      navigation: "#e4e7ec",
      interaction: {
        accent: "#ebf4ff",
        accentHover: "#deedff",
        accentActive: "#c3d4ff",
        accentDisabled: "#858d9e",
        danger: "#e5271d",
        neutral: "#c4c9d2",
        neutralHover: "#858d9e",
        neutralActive: "#475467",
        neutralSelected: "#7988ff",
        neutralEmphasized: "#7988ff"
      },
      feedback: {
        success: "#009c71",
        warning: "#fab636",
        danger: "#e5271d",
        info: "#5e65fb"
      }
    }
  },
  dimension: {
    borderWidth: {
      division: "1px",
      interaction: "2px",
      focus: "2px",
      selection: "3px"
    },
    radius: {
      surface0: "4px",
      surface1: "8px",
      surface2: "12px",
      surface3: "16px",
      surface4: "24px",
      surfaceRound: "100px",
      interaction: {
        action: "100px",
        actionFocus: "100px",
        inputSmall: "4px",
        inputSmallFocus: "6px",
        inputLarge: "12px",
        inputLargeFocus: "14px"
      }
    }
  },
  shadow: {
    level1: {
      bright: {
        offsetX: "0",
        offsetY: "0",
        blurRadius: "1",
        spreadRadius: "0",
        color: "#00194c40"
      },
      dim: {
        offsetX: "0",
        offsetY: "2",
        blurRadius: "2",
        spreadRadius: "0",
        color: "#00194c1a"
      }
    },
    level2: {
      bright: {
        offsetX: "0",
        offsetY: "0",
        blurRadius: "2",
        spreadRadius: "0",
        color: "#00194c33"
      },
      dim: {
        offsetX: "0",
        offsetY: "3",
        blurRadius: "10",
        spreadRadius: "0",
        color: "#00194c14"
      }
    },
    level3: {
      dim: {
        offsetX: "0",
        offsetY: "2",
        blurRadius: "5",
        spreadRadius: "0",
        color: "#00194c33"
      }
    },
    level4: {
      bright: {
        offsetX: "0",
        offsetY: "0",
        blurRadius: "1",
        spreadRadius: "0",
        color: "#00194c4c"
      },
      dim: {
        offsetX: "0",
        offsetY: "24",
        blurRadius: "40",
        spreadRadius: "-16",
        color: "#00194c40"
      }
    }
  },
  text: {
    fontFamily: {
      primary: "Figtree",
      accent: "Figtree",
      tertiary: "Figtree",
      signature: "Caveat"
    },
    fontWeight: {
      headline: "300",
      header: "600",
      default: "400",
      label: "600",
      hyperlink: "400",
      disclaimer: "400",
      action: "500"
    },
    letterSpacing: {
      default: "0px",
      headlineLarge: "-1.28px",
      headlineMedium: "-0.96px",
      headlineSmall: "-0.8px",
      headlineXsmall: "-0.64px",
      headerXlarge: "-0.48px",
      headerLarge: "-0.12px",
      label: "1.96px"
    }
  },
  logo: {
    brand: "Bestow Enterprise"
  }
};
const BESTOW_ENTERPRISE_CONFIG = {
  tokens: BESTOW_ENTERPRISE_TOKENS,
  misc: BESTOW_ENTERPRISE_MISC
};
const $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c$1 = typeof document !== "undefined" ? React__default.useLayoutEffect : () => {
};
function $8ae05eaa5c114e9c$export$7f54fc3180508a52(fn2) {
  const ref2 = useRef(null);
  $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c$1(() => {
    ref2.current = fn2;
  }, [
    fn2
  ]);
  return useCallback((...args) => {
    const f2 = ref2.current;
    return f2 === null || f2 === void 0 ? void 0 : f2(...args);
  }, []);
}
const $b5e257d569688ac6$var$defaultContext$1 = {
  prefix: String(Math.round(Math.random() * 1e10)),
  current: 0
};
const $b5e257d569688ac6$var$SSRContext$1 = /* @__PURE__ */ React__default.createContext($b5e257d569688ac6$var$defaultContext$1);
const $b5e257d569688ac6$var$IsSSRContext$1 = /* @__PURE__ */ React__default.createContext(false);
let $b5e257d569688ac6$var$canUseDOM$1 = Boolean(typeof window !== "undefined" && window.document && window.document.createElement);
let $b5e257d569688ac6$var$componentIds$1 = /* @__PURE__ */ new WeakMap();
function $b5e257d569688ac6$var$useCounter$1(isDisabled = false) {
  let ctx = useContext($b5e257d569688ac6$var$SSRContext$1);
  let ref2 = useRef(null);
  if (ref2.current === null && !isDisabled) {
    var _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner, _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    let currentOwner = (_React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = React__default.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED) === null || _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED === void 0 ? void 0 : (_React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner = _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner) === null || _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner === void 0 ? void 0 : _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner.current;
    if (currentOwner) {
      let prevComponentValue = $b5e257d569688ac6$var$componentIds$1.get(currentOwner);
      if (prevComponentValue == null)
        $b5e257d569688ac6$var$componentIds$1.set(currentOwner, {
          id: ctx.current,
          state: currentOwner.memoizedState
        });
      else if (currentOwner.memoizedState !== prevComponentValue.state) {
        ctx.current = prevComponentValue.id;
        $b5e257d569688ac6$var$componentIds$1.delete(currentOwner);
      }
    }
    ref2.current = ++ctx.current;
  }
  return ref2.current;
}
function $b5e257d569688ac6$var$useLegacySSRSafeId$1(defaultId) {
  let ctx = useContext($b5e257d569688ac6$var$SSRContext$1);
  if (ctx === $b5e257d569688ac6$var$defaultContext$1 && !$b5e257d569688ac6$var$canUseDOM$1) console.warn("When server rendering, you must wrap your application in an <SSRProvider> to ensure consistent ids are generated between the client and server.");
  let counter = $b5e257d569688ac6$var$useCounter$1(!!defaultId);
  let prefix2 = ctx === $b5e257d569688ac6$var$defaultContext$1 && process.env.NODE_ENV === "test" ? "react-aria" : `react-aria${ctx.prefix}`;
  return defaultId || `${prefix2}-${counter}`;
}
function $b5e257d569688ac6$var$useModernSSRSafeId$1(defaultId) {
  let id2 = React__default.useId();
  let [didSSR] = useState($b5e257d569688ac6$export$535bd6ca7f90a273$1());
  let prefix2 = didSSR || process.env.NODE_ENV === "test" ? "react-aria" : `react-aria${$b5e257d569688ac6$var$defaultContext$1.prefix}`;
  return defaultId || `${prefix2}-${id2}`;
}
typeof React__default["useId"] === "function" ? $b5e257d569688ac6$var$useModernSSRSafeId$1 : $b5e257d569688ac6$var$useLegacySSRSafeId$1;
function $b5e257d569688ac6$var$getSnapshot$1() {
  return false;
}
function $b5e257d569688ac6$var$getServerSnapshot$1() {
  return true;
}
function $b5e257d569688ac6$var$subscribe$1(onStoreChange) {
  return () => {
  };
}
function $b5e257d569688ac6$export$535bd6ca7f90a273$1() {
  if (typeof React__default["useSyncExternalStore"] === "function") return React__default["useSyncExternalStore"]($b5e257d569688ac6$var$subscribe$1, $b5e257d569688ac6$var$getSnapshot$1, $b5e257d569688ac6$var$getServerSnapshot$1);
  return useContext($b5e257d569688ac6$var$IsSSRContext$1);
}
function $ff5963eb1fccf552$export$e08e3b67e392101e(...callbacks) {
  return (...args) => {
    for (let callback of callbacks) if (typeof callback === "function") callback(...args);
  };
}
const $431fbd86ca7dc216$export$b204af158042fbac$1 = (el) => {
  var _el_ownerDocument;
  return (_el_ownerDocument = el === null || el === void 0 ? void 0 : el.ownerDocument) !== null && _el_ownerDocument !== void 0 ? _el_ownerDocument : document;
};
const $431fbd86ca7dc216$export$f21a1ffae260145a$1 = (el) => {
  if (el && "window" in el && el.window === el) return el;
  const doc = $431fbd86ca7dc216$export$b204af158042fbac$1(el);
  return doc.defaultView || window;
};
function r$1(e3) {
  var t2, f2, n2 = "";
  if ("string" == typeof e3 || "number" == typeof e3) n2 += e3;
  else if ("object" == typeof e3) if (Array.isArray(e3)) {
    var o = e3.length;
    for (t2 = 0; t2 < o; t2++) e3[t2] && (f2 = r$1(e3[t2])) && (n2 && (n2 += " "), n2 += f2);
  } else for (f2 in e3) e3[f2] && (n2 && (n2 += " "), n2 += f2);
  return n2;
}
function clsx() {
  for (var e3, t2, f2 = 0, n2 = "", o = arguments.length; f2 < o; f2++) (e3 = arguments[f2]) && (t2 = r$1(e3)) && (n2 && (n2 += " "), n2 += t2);
  return n2;
}
function $7215afc6de606d6b$export$de79e2c695e052f3$1(element) {
  if ($7215afc6de606d6b$var$supportsPreventScroll$1()) element.focus({
    preventScroll: true
  });
  else {
    let scrollableElements = $7215afc6de606d6b$var$getScrollableElements$1(element);
    element.focus();
    $7215afc6de606d6b$var$restoreScrollPosition$1(scrollableElements);
  }
}
let $7215afc6de606d6b$var$supportsPreventScrollCached$1 = null;
function $7215afc6de606d6b$var$supportsPreventScroll$1() {
  if ($7215afc6de606d6b$var$supportsPreventScrollCached$1 == null) {
    $7215afc6de606d6b$var$supportsPreventScrollCached$1 = false;
    try {
      let focusElem = document.createElement("div");
      focusElem.focus({
        get preventScroll() {
          $7215afc6de606d6b$var$supportsPreventScrollCached$1 = true;
          return true;
        }
      });
    } catch {
    }
  }
  return $7215afc6de606d6b$var$supportsPreventScrollCached$1;
}
function $7215afc6de606d6b$var$getScrollableElements$1(element) {
  let parent = element.parentNode;
  let scrollableElements = [];
  let rootScrollingElement = document.scrollingElement || document.documentElement;
  while (parent instanceof HTMLElement && parent !== rootScrollingElement) {
    if (parent.offsetHeight < parent.scrollHeight || parent.offsetWidth < parent.scrollWidth) scrollableElements.push({
      element: parent,
      scrollTop: parent.scrollTop,
      scrollLeft: parent.scrollLeft
    });
    parent = parent.parentNode;
  }
  if (rootScrollingElement instanceof HTMLElement) scrollableElements.push({
    element: rootScrollingElement,
    scrollTop: rootScrollingElement.scrollTop,
    scrollLeft: rootScrollingElement.scrollLeft
  });
  return scrollableElements;
}
function $7215afc6de606d6b$var$restoreScrollPosition$1(scrollableElements) {
  for (let { element, scrollTop, scrollLeft } of scrollableElements) {
    element.scrollTop = scrollTop;
    element.scrollLeft = scrollLeft;
  }
}
function $c87311424ea30a05$var$testUserAgent$1(re) {
  var _window_navigator_userAgentData;
  if (typeof window === "undefined" || window.navigator == null) return false;
  return ((_window_navigator_userAgentData = window.navigator["userAgentData"]) === null || _window_navigator_userAgentData === void 0 ? void 0 : _window_navigator_userAgentData.brands.some((brand) => re.test(brand.brand))) || re.test(window.navigator.userAgent);
}
function $c87311424ea30a05$var$testPlatform$1(re) {
  var _window_navigator_userAgentData;
  return typeof window !== "undefined" && window.navigator != null ? re.test(((_window_navigator_userAgentData = window.navigator["userAgentData"]) === null || _window_navigator_userAgentData === void 0 ? void 0 : _window_navigator_userAgentData.platform) || window.navigator.platform) : false;
}
function $c87311424ea30a05$var$cached$1(fn2) {
  let res = null;
  return () => {
    if (res == null) res = fn2();
    return res;
  };
}
const $c87311424ea30a05$export$9ac100e40613ea10$1 = $c87311424ea30a05$var$cached$1(function() {
  return $c87311424ea30a05$var$testPlatform$1(/^Mac/i);
});
const $c87311424ea30a05$export$186c6964ca17d99$1 = $c87311424ea30a05$var$cached$1(function() {
  return $c87311424ea30a05$var$testPlatform$1(/^iPhone/i);
});
const $c87311424ea30a05$export$7bef049ce92e4224$1 = $c87311424ea30a05$var$cached$1(function() {
  return $c87311424ea30a05$var$testPlatform$1(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
  $c87311424ea30a05$export$9ac100e40613ea10$1() && navigator.maxTouchPoints > 1;
});
const $c87311424ea30a05$export$fedb369cb70207f1$1 = $c87311424ea30a05$var$cached$1(function() {
  return $c87311424ea30a05$export$186c6964ca17d99$1() || $c87311424ea30a05$export$7bef049ce92e4224$1();
});
const $c87311424ea30a05$export$6446a186d09e379e$1 = $c87311424ea30a05$var$cached$1(function() {
  return $c87311424ea30a05$var$testUserAgent$1(/Chrome/i);
});
const $c87311424ea30a05$export$a11b0059900ceec8$1 = $c87311424ea30a05$var$cached$1(function() {
  return $c87311424ea30a05$var$testUserAgent$1(/Android/i);
});
let $bbed8b41f857bcc0$var$transitionsByElement$1 = /* @__PURE__ */ new Map();
let $bbed8b41f857bcc0$var$transitionCallbacks$1 = /* @__PURE__ */ new Set();
function $bbed8b41f857bcc0$var$setupGlobalEvents$1() {
  if (typeof window === "undefined") return;
  function isTransitionEvent(event) {
    return "propertyName" in event;
  }
  let onTransitionStart = (e3) => {
    if (!isTransitionEvent(e3) || !e3.target) return;
    let transitions2 = $bbed8b41f857bcc0$var$transitionsByElement$1.get(e3.target);
    if (!transitions2) {
      transitions2 = /* @__PURE__ */ new Set();
      $bbed8b41f857bcc0$var$transitionsByElement$1.set(e3.target, transitions2);
      e3.target.addEventListener("transitioncancel", onTransitionEnd, {
        once: true
      });
    }
    transitions2.add(e3.propertyName);
  };
  let onTransitionEnd = (e3) => {
    if (!isTransitionEvent(e3) || !e3.target) return;
    let properties2 = $bbed8b41f857bcc0$var$transitionsByElement$1.get(e3.target);
    if (!properties2) return;
    properties2.delete(e3.propertyName);
    if (properties2.size === 0) {
      e3.target.removeEventListener("transitioncancel", onTransitionEnd);
      $bbed8b41f857bcc0$var$transitionsByElement$1.delete(e3.target);
    }
    if ($bbed8b41f857bcc0$var$transitionsByElement$1.size === 0) {
      for (let cb of $bbed8b41f857bcc0$var$transitionCallbacks$1) cb();
      $bbed8b41f857bcc0$var$transitionCallbacks$1.clear();
    }
  };
  document.body.addEventListener("transitionrun", onTransitionStart);
  document.body.addEventListener("transitionend", onTransitionEnd);
}
if (typeof document !== "undefined") {
  if (document.readyState !== "loading") $bbed8b41f857bcc0$var$setupGlobalEvents$1();
  else document.addEventListener("DOMContentLoaded", $bbed8b41f857bcc0$var$setupGlobalEvents$1);
}
function $bbed8b41f857bcc0$export$24490316f764c430$1(fn2) {
  requestAnimationFrame(() => {
    if ($bbed8b41f857bcc0$var$transitionsByElement$1.size === 0) fn2();
    else $bbed8b41f857bcc0$var$transitionCallbacks$1.add(fn2);
  });
}
function $cc38e7bd3fc7b213$export$2bb74740c4e19def(node2, checkForOverflow) {
  if (!node2) return false;
  let style = window.getComputedStyle(node2);
  let isScrollable = /(auto|scroll)/.test(style.overflow + style.overflowX + style.overflowY);
  if (isScrollable && checkForOverflow) isScrollable = node2.scrollHeight !== node2.clientHeight || node2.scrollWidth !== node2.clientWidth;
  return isScrollable;
}
function $62d8ded9296f3872$export$cfa2225e87938781(node2, checkForOverflow) {
  let scrollableNode = node2;
  if ($cc38e7bd3fc7b213$export$2bb74740c4e19def(scrollableNode, checkForOverflow)) scrollableNode = scrollableNode.parentElement;
  while (scrollableNode && !$cc38e7bd3fc7b213$export$2bb74740c4e19def(scrollableNode, checkForOverflow)) scrollableNode = scrollableNode.parentElement;
  return scrollableNode || document.scrollingElement || document.documentElement;
}
function $6a7db85432448f7f$export$60278871457622de$1(event) {
  if (event.mozInputSource === 0 && event.isTrusted) return true;
  if ($c87311424ea30a05$export$a11b0059900ceec8$1() && event.pointerType) return event.type === "click" && event.buttons === 1;
  return event.detail === 0 && !event.pointerType;
}
function __awaiter(thisArg, _arguments, P2, generator) {
  function adopt(value) {
    return value instanceof P2 ? value : new P2(function(resolve) {
      resolve(value);
    });
  }
  return new (P2 || (P2 = Promise))(function(resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e3) {
        reject(e3);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e3) {
        reject(e3);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}
typeof SuppressedError === "function" ? SuppressedError : function(error2, suppressed, message2) {
  var e3 = new Error(message2);
  return e3.name = "SuppressedError", e3.error = error2, e3.suppressed = suppressed, e3;
};
class $8a9cb279dc87e130$export$905e7fc544a71f36 {
  isDefaultPrevented() {
    return this.nativeEvent.defaultPrevented;
  }
  preventDefault() {
    this.defaultPrevented = true;
    this.nativeEvent.preventDefault();
  }
  stopPropagation() {
    this.nativeEvent.stopPropagation();
    this.isPropagationStopped = () => true;
  }
  isPropagationStopped() {
    return false;
  }
  persist() {
  }
  constructor(type2, nativeEvent) {
    this.nativeEvent = nativeEvent;
    this.target = nativeEvent.target;
    this.currentTarget = nativeEvent.currentTarget;
    this.relatedTarget = nativeEvent.relatedTarget;
    this.bubbles = nativeEvent.bubbles;
    this.cancelable = nativeEvent.cancelable;
    this.defaultPrevented = nativeEvent.defaultPrevented;
    this.eventPhase = nativeEvent.eventPhase;
    this.isTrusted = nativeEvent.isTrusted;
    this.timeStamp = nativeEvent.timeStamp;
    this.type = type2;
  }
}
function $8a9cb279dc87e130$export$715c682d09d639cc(onBlur) {
  let stateRef = useRef({
    isFocused: false,
    observer: null
  });
  $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c$1(() => {
    const state = stateRef.current;
    return () => {
      if (state.observer) {
        state.observer.disconnect();
        state.observer = null;
      }
    };
  }, []);
  let dispatchBlur = $8ae05eaa5c114e9c$export$7f54fc3180508a52((e3) => {
    onBlur === null || onBlur === void 0 ? void 0 : onBlur(e3);
  });
  return useCallback((e3) => {
    if (e3.target instanceof HTMLButtonElement || e3.target instanceof HTMLInputElement || e3.target instanceof HTMLTextAreaElement || e3.target instanceof HTMLSelectElement) {
      stateRef.current.isFocused = true;
      let target = e3.target;
      let onBlurHandler = (e4) => {
        stateRef.current.isFocused = false;
        if (target.disabled)
          dispatchBlur(new $8a9cb279dc87e130$export$905e7fc544a71f36("blur", e4));
        if (stateRef.current.observer) {
          stateRef.current.observer.disconnect();
          stateRef.current.observer = null;
        }
      };
      target.addEventListener("focusout", onBlurHandler, {
        once: true
      });
      stateRef.current.observer = new MutationObserver(() => {
        if (stateRef.current.isFocused && target.disabled) {
          var _stateRef_current_observer;
          (_stateRef_current_observer = stateRef.current.observer) === null || _stateRef_current_observer === void 0 ? void 0 : _stateRef_current_observer.disconnect();
          let relatedTargetEl = target === document.activeElement ? null : document.activeElement;
          target.dispatchEvent(new FocusEvent("blur", {
            relatedTarget: relatedTargetEl
          }));
          target.dispatchEvent(new FocusEvent("focusout", {
            bubbles: true,
            relatedTarget: relatedTargetEl
          }));
        }
      });
      stateRef.current.observer.observe(target, {
        attributes: true,
        attributeFilter: [
          "disabled"
        ]
      });
    }
  }, [
    dispatchBlur
  ]);
}
let $507fabe10e71c6fb$var$currentModality$1 = null;
let $507fabe10e71c6fb$var$changeHandlers = /* @__PURE__ */ new Set();
let $507fabe10e71c6fb$export$d90243b58daecda7$1 = /* @__PURE__ */ new Map();
let $507fabe10e71c6fb$var$hasEventBeforeFocus$1 = false;
let $507fabe10e71c6fb$var$hasBlurredWindowRecently$1 = false;
function $507fabe10e71c6fb$var$triggerChangeHandlers$1(modality, e3) {
  for (let handler of $507fabe10e71c6fb$var$changeHandlers) handler(modality, e3);
}
function $507fabe10e71c6fb$var$isValidKey$1(e3) {
  return !(e3.metaKey || !$c87311424ea30a05$export$9ac100e40613ea10$1() && e3.altKey || e3.ctrlKey || e3.key === "Control" || e3.key === "Shift" || e3.key === "Meta");
}
function $507fabe10e71c6fb$var$handleKeyboardEvent$1(e3) {
  $507fabe10e71c6fb$var$hasEventBeforeFocus$1 = true;
  if ($507fabe10e71c6fb$var$isValidKey$1(e3)) {
    $507fabe10e71c6fb$var$currentModality$1 = "keyboard";
    $507fabe10e71c6fb$var$triggerChangeHandlers$1("keyboard", e3);
  }
}
function $507fabe10e71c6fb$var$handlePointerEvent$1(e3) {
  $507fabe10e71c6fb$var$currentModality$1 = "pointer";
  if (e3.type === "mousedown" || e3.type === "pointerdown") {
    $507fabe10e71c6fb$var$hasEventBeforeFocus$1 = true;
    $507fabe10e71c6fb$var$triggerChangeHandlers$1("pointer", e3);
  }
}
function $507fabe10e71c6fb$var$handleClickEvent$1(e3) {
  if ($6a7db85432448f7f$export$60278871457622de$1(e3)) {
    $507fabe10e71c6fb$var$hasEventBeforeFocus$1 = true;
    $507fabe10e71c6fb$var$currentModality$1 = "virtual";
  }
}
function $507fabe10e71c6fb$var$handleFocusEvent$1(e3) {
  if (e3.target === window || e3.target === document) return;
  if (!$507fabe10e71c6fb$var$hasEventBeforeFocus$1 && !$507fabe10e71c6fb$var$hasBlurredWindowRecently$1) {
    $507fabe10e71c6fb$var$currentModality$1 = "virtual";
    $507fabe10e71c6fb$var$triggerChangeHandlers$1("virtual", e3);
  }
  $507fabe10e71c6fb$var$hasEventBeforeFocus$1 = false;
  $507fabe10e71c6fb$var$hasBlurredWindowRecently$1 = false;
}
function $507fabe10e71c6fb$var$handleWindowBlur$1() {
  $507fabe10e71c6fb$var$hasEventBeforeFocus$1 = false;
  $507fabe10e71c6fb$var$hasBlurredWindowRecently$1 = true;
}
function $507fabe10e71c6fb$var$setupGlobalFocusEvents$1(element) {
  if (typeof window === "undefined" || $507fabe10e71c6fb$export$d90243b58daecda7$1.get($431fbd86ca7dc216$export$f21a1ffae260145a$1(element))) return;
  const windowObject = $431fbd86ca7dc216$export$f21a1ffae260145a$1(element);
  const documentObject = $431fbd86ca7dc216$export$b204af158042fbac$1(element);
  let focus = windowObject.HTMLElement.prototype.focus;
  windowObject.HTMLElement.prototype.focus = function() {
    $507fabe10e71c6fb$var$hasEventBeforeFocus$1 = true;
    focus.apply(this, arguments);
  };
  documentObject.addEventListener("keydown", $507fabe10e71c6fb$var$handleKeyboardEvent$1, true);
  documentObject.addEventListener("keyup", $507fabe10e71c6fb$var$handleKeyboardEvent$1, true);
  documentObject.addEventListener("click", $507fabe10e71c6fb$var$handleClickEvent$1, true);
  windowObject.addEventListener("focus", $507fabe10e71c6fb$var$handleFocusEvent$1, true);
  windowObject.addEventListener("blur", $507fabe10e71c6fb$var$handleWindowBlur$1, false);
  if (typeof PointerEvent !== "undefined") {
    documentObject.addEventListener("pointerdown", $507fabe10e71c6fb$var$handlePointerEvent$1, true);
    documentObject.addEventListener("pointermove", $507fabe10e71c6fb$var$handlePointerEvent$1, true);
    documentObject.addEventListener("pointerup", $507fabe10e71c6fb$var$handlePointerEvent$1, true);
  } else {
    documentObject.addEventListener("mousedown", $507fabe10e71c6fb$var$handlePointerEvent$1, true);
    documentObject.addEventListener("mousemove", $507fabe10e71c6fb$var$handlePointerEvent$1, true);
    documentObject.addEventListener("mouseup", $507fabe10e71c6fb$var$handlePointerEvent$1, true);
  }
  windowObject.addEventListener("beforeunload", () => {
    $507fabe10e71c6fb$var$tearDownWindowFocusTracking$1(element);
  }, {
    once: true
  });
  $507fabe10e71c6fb$export$d90243b58daecda7$1.set(windowObject, {
    focus
  });
}
const $507fabe10e71c6fb$var$tearDownWindowFocusTracking$1 = (element, loadListener) => {
  const windowObject = $431fbd86ca7dc216$export$f21a1ffae260145a$1(element);
  const documentObject = $431fbd86ca7dc216$export$b204af158042fbac$1(element);
  if (loadListener) documentObject.removeEventListener("DOMContentLoaded", loadListener);
  if (!$507fabe10e71c6fb$export$d90243b58daecda7$1.has(windowObject)) return;
  windowObject.HTMLElement.prototype.focus = $507fabe10e71c6fb$export$d90243b58daecda7$1.get(windowObject).focus;
  documentObject.removeEventListener("keydown", $507fabe10e71c6fb$var$handleKeyboardEvent$1, true);
  documentObject.removeEventListener("keyup", $507fabe10e71c6fb$var$handleKeyboardEvent$1, true);
  documentObject.removeEventListener("click", $507fabe10e71c6fb$var$handleClickEvent$1, true);
  windowObject.removeEventListener("focus", $507fabe10e71c6fb$var$handleFocusEvent$1, true);
  windowObject.removeEventListener("blur", $507fabe10e71c6fb$var$handleWindowBlur$1, false);
  if (typeof PointerEvent !== "undefined") {
    documentObject.removeEventListener("pointerdown", $507fabe10e71c6fb$var$handlePointerEvent$1, true);
    documentObject.removeEventListener("pointermove", $507fabe10e71c6fb$var$handlePointerEvent$1, true);
    documentObject.removeEventListener("pointerup", $507fabe10e71c6fb$var$handlePointerEvent$1, true);
  } else {
    documentObject.removeEventListener("mousedown", $507fabe10e71c6fb$var$handlePointerEvent$1, true);
    documentObject.removeEventListener("mousemove", $507fabe10e71c6fb$var$handlePointerEvent$1, true);
    documentObject.removeEventListener("mouseup", $507fabe10e71c6fb$var$handlePointerEvent$1, true);
  }
  $507fabe10e71c6fb$export$d90243b58daecda7$1.delete(windowObject);
};
function $507fabe10e71c6fb$export$2f1888112f558a7d$1(element) {
  const documentObject = $431fbd86ca7dc216$export$b204af158042fbac$1(element);
  let loadListener;
  if (documentObject.readyState !== "loading") $507fabe10e71c6fb$var$setupGlobalFocusEvents$1(element);
  else {
    loadListener = () => {
      $507fabe10e71c6fb$var$setupGlobalFocusEvents$1(element);
    };
    documentObject.addEventListener("DOMContentLoaded", loadListener);
  }
  return () => $507fabe10e71c6fb$var$tearDownWindowFocusTracking$1(element, loadListener);
}
if (typeof document !== "undefined") $507fabe10e71c6fb$export$2f1888112f558a7d$1();
function $507fabe10e71c6fb$export$630ff653c5ada6a9$1() {
  return $507fabe10e71c6fb$var$currentModality$1;
}
function $9ab94262bd0047c7$export$420e68273165f4ec(props) {
  let { isDisabled, onBlurWithin, onFocusWithin, onFocusWithinChange } = props;
  let state = useRef({
    isFocusWithin: false
  });
  let onBlur = useCallback((e3) => {
    if (state.current.isFocusWithin && !e3.currentTarget.contains(e3.relatedTarget)) {
      state.current.isFocusWithin = false;
      if (onBlurWithin) onBlurWithin(e3);
      if (onFocusWithinChange) onFocusWithinChange(false);
    }
  }, [
    onBlurWithin,
    onFocusWithinChange,
    state
  ]);
  let onSyntheticFocus = $8a9cb279dc87e130$export$715c682d09d639cc(onBlur);
  let onFocus2 = useCallback((e3) => {
    if (!state.current.isFocusWithin && document.activeElement === e3.target) {
      if (onFocusWithin) onFocusWithin(e3);
      if (onFocusWithinChange) onFocusWithinChange(true);
      state.current.isFocusWithin = true;
      onSyntheticFocus(e3);
    }
  }, [
    onFocusWithin,
    onFocusWithinChange,
    onSyntheticFocus
  ]);
  if (isDisabled) return {
    focusWithinProps: {
      // These should not have been null, that would conflict in mergeProps
      onFocus: void 0,
      onBlur: void 0
    }
  };
  return {
    focusWithinProps: {
      onFocus: onFocus2,
      onBlur
    }
  };
}
function $e0b6e0b68ec7f50f$export$872b660ac5a1ff98(props) {
  let { ref: ref2, onInteractOutside, isDisabled, onInteractOutsideStart } = props;
  let stateRef = useRef({
    isPointerDown: false,
    ignoreEmulatedMouseEvents: false
  });
  let onPointerDown = $8ae05eaa5c114e9c$export$7f54fc3180508a52((e3) => {
    if (onInteractOutside && $e0b6e0b68ec7f50f$var$isValidEvent(e3, ref2)) {
      if (onInteractOutsideStart) onInteractOutsideStart(e3);
      stateRef.current.isPointerDown = true;
    }
  });
  let triggerInteractOutside = $8ae05eaa5c114e9c$export$7f54fc3180508a52((e3) => {
    if (onInteractOutside) onInteractOutside(e3);
  });
  useEffect(() => {
    let state = stateRef.current;
    if (isDisabled) return;
    const element = ref2.current;
    const documentObject = $431fbd86ca7dc216$export$b204af158042fbac$1(element);
    if (typeof PointerEvent !== "undefined") {
      let onPointerUp = (e3) => {
        if (state.isPointerDown && $e0b6e0b68ec7f50f$var$isValidEvent(e3, ref2)) triggerInteractOutside(e3);
        state.isPointerDown = false;
      };
      documentObject.addEventListener("pointerdown", onPointerDown, true);
      documentObject.addEventListener("pointerup", onPointerUp, true);
      return () => {
        documentObject.removeEventListener("pointerdown", onPointerDown, true);
        documentObject.removeEventListener("pointerup", onPointerUp, true);
      };
    } else {
      let onMouseUp = (e3) => {
        if (state.ignoreEmulatedMouseEvents) state.ignoreEmulatedMouseEvents = false;
        else if (state.isPointerDown && $e0b6e0b68ec7f50f$var$isValidEvent(e3, ref2)) triggerInteractOutside(e3);
        state.isPointerDown = false;
      };
      let onTouchEnd = (e3) => {
        state.ignoreEmulatedMouseEvents = true;
        if (state.isPointerDown && $e0b6e0b68ec7f50f$var$isValidEvent(e3, ref2)) triggerInteractOutside(e3);
        state.isPointerDown = false;
      };
      documentObject.addEventListener("mousedown", onPointerDown, true);
      documentObject.addEventListener("mouseup", onMouseUp, true);
      documentObject.addEventListener("touchstart", onPointerDown, true);
      documentObject.addEventListener("touchend", onTouchEnd, true);
      return () => {
        documentObject.removeEventListener("mousedown", onPointerDown, true);
        documentObject.removeEventListener("mouseup", onMouseUp, true);
        documentObject.removeEventListener("touchstart", onPointerDown, true);
        documentObject.removeEventListener("touchend", onTouchEnd, true);
      };
    }
  }, [
    ref2,
    isDisabled,
    onPointerDown,
    triggerInteractOutside
  ]);
}
function $e0b6e0b68ec7f50f$var$isValidEvent(event, ref2) {
  if (event.button > 0) return false;
  if (event.target) {
    const ownerDocument = event.target.ownerDocument;
    if (!ownerDocument || !ownerDocument.documentElement.contains(event.target)) return false;
    if (event.target.closest("[data-react-aria-top-layer]")) return false;
  }
  return ref2.current && !ref2.current.contains(event.target);
}
function $6a99195332edec8b$export$80f3e147d781571c(element) {
  const ownerDocument = $431fbd86ca7dc216$export$b204af158042fbac$1(element);
  if ($507fabe10e71c6fb$export$630ff653c5ada6a9$1() === "virtual") {
    let lastFocusedElement = ownerDocument.activeElement;
    $bbed8b41f857bcc0$export$24490316f764c430$1(() => {
      if (ownerDocument.activeElement === lastFocusedElement && element.isConnected) $7215afc6de606d6b$export$de79e2c695e052f3$1(element);
    });
  } else $7215afc6de606d6b$export$de79e2c695e052f3$1(element);
}
function $645f2e67b85a24c9$var$isStyleVisible(element) {
  const windowObject = $431fbd86ca7dc216$export$f21a1ffae260145a$1(element);
  if (!(element instanceof windowObject.HTMLElement) && !(element instanceof windowObject.SVGElement)) return false;
  let { display, visibility } = element.style;
  let isVisible = display !== "none" && visibility !== "hidden" && visibility !== "collapse";
  if (isVisible) {
    const { getComputedStyle: getComputedStyle2 } = element.ownerDocument.defaultView;
    let { display: computedDisplay, visibility: computedVisibility } = getComputedStyle2(element);
    isVisible = computedDisplay !== "none" && computedVisibility !== "hidden" && computedVisibility !== "collapse";
  }
  return isVisible;
}
function $645f2e67b85a24c9$var$isAttributeVisible(element, childElement) {
  return !element.hasAttribute("hidden") && // Ignore HiddenSelect when tree walking.
  !element.hasAttribute("data-react-aria-prevent-focus") && (element.nodeName === "DETAILS" && childElement && childElement.nodeName !== "SUMMARY" ? element.hasAttribute("open") : true);
}
function $645f2e67b85a24c9$export$e989c0fffaa6b27a(element, childElement) {
  return element.nodeName !== "#comment" && $645f2e67b85a24c9$var$isStyleVisible(element) && $645f2e67b85a24c9$var$isAttributeVisible(element, childElement) && (!element.parentElement || $645f2e67b85a24c9$export$e989c0fffaa6b27a(element.parentElement, element));
}
const $9bf71ea28793e738$var$FocusContext = /* @__PURE__ */ React__default.createContext(null);
const $9bf71ea28793e738$var$RESTORE_FOCUS_EVENT = "react-aria-focus-scope-restore";
let $9bf71ea28793e738$var$activeScope = null;
function $9bf71ea28793e738$export$20e40289641fbbb6(props) {
  let { children, contain, restoreFocus, autoFocus } = props;
  let startRef = useRef(null);
  let endRef = useRef(null);
  let scopeRef = useRef([]);
  let { parentNode } = useContext($9bf71ea28793e738$var$FocusContext) || {};
  let node2 = useMemo(() => new $9bf71ea28793e738$var$TreeNode({
    scopeRef
  }), [
    scopeRef
  ]);
  $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c$1(() => {
    let parent = parentNode || $9bf71ea28793e738$export$d06fae2ee68b101e.root;
    if ($9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode(parent.scopeRef) && $9bf71ea28793e738$var$activeScope && !$9bf71ea28793e738$var$isAncestorScope($9bf71ea28793e738$var$activeScope, parent.scopeRef)) {
      let activeNode = $9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode($9bf71ea28793e738$var$activeScope);
      if (activeNode) parent = activeNode;
    }
    parent.addChild(node2);
    $9bf71ea28793e738$export$d06fae2ee68b101e.addNode(node2);
  }, [
    node2,
    parentNode
  ]);
  $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c$1(() => {
    let node3 = $9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode(scopeRef);
    if (node3) node3.contain = !!contain;
  }, [
    contain
  ]);
  $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c$1(() => {
    var _startRef_current;
    let node3 = (_startRef_current = startRef.current) === null || _startRef_current === void 0 ? void 0 : _startRef_current.nextSibling;
    let nodes = [];
    let stopPropagation = (e3) => e3.stopPropagation();
    while (node3 && node3 !== endRef.current) {
      nodes.push(node3);
      node3.addEventListener($9bf71ea28793e738$var$RESTORE_FOCUS_EVENT, stopPropagation);
      node3 = node3.nextSibling;
    }
    scopeRef.current = nodes;
    return () => {
      for (let node4 of nodes) node4.removeEventListener($9bf71ea28793e738$var$RESTORE_FOCUS_EVENT, stopPropagation);
    };
  }, [
    children
  ]);
  $9bf71ea28793e738$var$useActiveScopeTracker(scopeRef, restoreFocus, contain);
  $9bf71ea28793e738$var$useFocusContainment(scopeRef, contain);
  $9bf71ea28793e738$var$useRestoreFocus(scopeRef, restoreFocus, contain);
  $9bf71ea28793e738$var$useAutoFocus(scopeRef, autoFocus);
  useEffect(() => {
    const activeElement = $431fbd86ca7dc216$export$b204af158042fbac$1(scopeRef.current ? scopeRef.current[0] : void 0).activeElement;
    let scope = null;
    if ($9bf71ea28793e738$var$isElementInScope(activeElement, scopeRef.current)) {
      for (let node3 of $9bf71ea28793e738$export$d06fae2ee68b101e.traverse()) if (node3.scopeRef && $9bf71ea28793e738$var$isElementInScope(activeElement, node3.scopeRef.current)) scope = node3;
      if (scope === $9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode(scopeRef)) $9bf71ea28793e738$var$activeScope = scope.scopeRef;
    }
  }, [
    scopeRef
  ]);
  $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c$1(() => {
    return () => {
      var _focusScopeTree_getTreeNode_parent, _focusScopeTree_getTreeNode;
      var _focusScopeTree_getTreeNode_parent_scopeRef;
      let parentScope = (_focusScopeTree_getTreeNode_parent_scopeRef = (_focusScopeTree_getTreeNode = $9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode(scopeRef)) === null || _focusScopeTree_getTreeNode === void 0 ? void 0 : (_focusScopeTree_getTreeNode_parent = _focusScopeTree_getTreeNode.parent) === null || _focusScopeTree_getTreeNode_parent === void 0 ? void 0 : _focusScopeTree_getTreeNode_parent.scopeRef) !== null && _focusScopeTree_getTreeNode_parent_scopeRef !== void 0 ? _focusScopeTree_getTreeNode_parent_scopeRef : null;
      if ((scopeRef === $9bf71ea28793e738$var$activeScope || $9bf71ea28793e738$var$isAncestorScope(scopeRef, $9bf71ea28793e738$var$activeScope)) && (!parentScope || $9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode(parentScope))) $9bf71ea28793e738$var$activeScope = parentScope;
      $9bf71ea28793e738$export$d06fae2ee68b101e.removeTreeNode(scopeRef);
    };
  }, [
    scopeRef
  ]);
  let focusManager = useMemo(() => $9bf71ea28793e738$var$createFocusManagerForScope(scopeRef), []);
  let value = useMemo(() => ({
    focusManager,
    parentNode: node2
  }), [
    node2,
    focusManager
  ]);
  return /* @__PURE__ */ React__default.createElement($9bf71ea28793e738$var$FocusContext.Provider, {
    value
  }, /* @__PURE__ */ React__default.createElement("span", {
    "data-focus-scope-start": true,
    hidden: true,
    ref: startRef
  }), children, /* @__PURE__ */ React__default.createElement("span", {
    "data-focus-scope-end": true,
    hidden: true,
    ref: endRef
  }));
}
function $9bf71ea28793e738$export$10c5169755ce7bd7() {
  var _useContext;
  return (_useContext = useContext($9bf71ea28793e738$var$FocusContext)) === null || _useContext === void 0 ? void 0 : _useContext.focusManager;
}
function $9bf71ea28793e738$var$createFocusManagerForScope(scopeRef) {
  return {
    focusNext(opts = {}) {
      let scope = scopeRef.current;
      let { from: from2, tabbable, wrap, accept } = opts;
      let node2 = from2 || $431fbd86ca7dc216$export$b204af158042fbac$1(scope[0]).activeElement;
      let sentinel = scope[0].previousElementSibling;
      let scopeRoot = $9bf71ea28793e738$var$getScopeRoot(scope);
      let walker = $9bf71ea28793e738$export$2d6ec8fc375ceafa(scopeRoot, {
        tabbable,
        accept
      }, scope);
      walker.currentNode = $9bf71ea28793e738$var$isElementInScope(node2, scope) ? node2 : sentinel;
      let nextNode = walker.nextNode();
      if (!nextNode && wrap) {
        walker.currentNode = sentinel;
        nextNode = walker.nextNode();
      }
      if (nextNode) $9bf71ea28793e738$var$focusElement(nextNode, true);
      return nextNode;
    },
    focusPrevious(opts = {}) {
      let scope = scopeRef.current;
      let { from: from2, tabbable, wrap, accept } = opts;
      let node2 = from2 || $431fbd86ca7dc216$export$b204af158042fbac$1(scope[0]).activeElement;
      let sentinel = scope[scope.length - 1].nextElementSibling;
      let scopeRoot = $9bf71ea28793e738$var$getScopeRoot(scope);
      let walker = $9bf71ea28793e738$export$2d6ec8fc375ceafa(scopeRoot, {
        tabbable,
        accept
      }, scope);
      walker.currentNode = $9bf71ea28793e738$var$isElementInScope(node2, scope) ? node2 : sentinel;
      let previousNode = walker.previousNode();
      if (!previousNode && wrap) {
        walker.currentNode = sentinel;
        previousNode = walker.previousNode();
      }
      if (previousNode) $9bf71ea28793e738$var$focusElement(previousNode, true);
      return previousNode;
    },
    focusFirst(opts = {}) {
      let scope = scopeRef.current;
      let { tabbable, accept } = opts;
      let scopeRoot = $9bf71ea28793e738$var$getScopeRoot(scope);
      let walker = $9bf71ea28793e738$export$2d6ec8fc375ceafa(scopeRoot, {
        tabbable,
        accept
      }, scope);
      walker.currentNode = scope[0].previousElementSibling;
      let nextNode = walker.nextNode();
      if (nextNode) $9bf71ea28793e738$var$focusElement(nextNode, true);
      return nextNode;
    },
    focusLast(opts = {}) {
      let scope = scopeRef.current;
      let { tabbable, accept } = opts;
      let scopeRoot = $9bf71ea28793e738$var$getScopeRoot(scope);
      let walker = $9bf71ea28793e738$export$2d6ec8fc375ceafa(scopeRoot, {
        tabbable,
        accept
      }, scope);
      walker.currentNode = scope[scope.length - 1].nextElementSibling;
      let previousNode = walker.previousNode();
      if (previousNode) $9bf71ea28793e738$var$focusElement(previousNode, true);
      return previousNode;
    }
  };
}
const $9bf71ea28793e738$var$focusableElements = [
  "input:not([disabled]):not([type=hidden])",
  "select:not([disabled])",
  "textarea:not([disabled])",
  "button:not([disabled])",
  "a[href]",
  "area[href]",
  "summary",
  "iframe",
  "object",
  "embed",
  "audio[controls]",
  "video[controls]",
  '[contenteditable]:not([contenteditable^="false"])'
];
const $9bf71ea28793e738$var$FOCUSABLE_ELEMENT_SELECTOR = $9bf71ea28793e738$var$focusableElements.join(":not([hidden]),") + ",[tabindex]:not([disabled]):not([hidden])";
$9bf71ea28793e738$var$focusableElements.push('[tabindex]:not([tabindex="-1"]):not([disabled])');
const $9bf71ea28793e738$var$TABBABLE_ELEMENT_SELECTOR = $9bf71ea28793e738$var$focusableElements.join(':not([hidden]):not([tabindex="-1"]),');
function $9bf71ea28793e738$var$getScopeRoot(scope) {
  return scope[0].parentElement;
}
function $9bf71ea28793e738$var$shouldContainFocus(scopeRef) {
  let scope = $9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode($9bf71ea28793e738$var$activeScope);
  while (scope && scope.scopeRef !== scopeRef) {
    if (scope.contain) return false;
    scope = scope.parent;
  }
  return true;
}
function $9bf71ea28793e738$var$useFocusContainment(scopeRef, contain) {
  let focusedNode = useRef(void 0);
  let raf = useRef(void 0);
  $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c$1(() => {
    let scope = scopeRef.current;
    if (!contain) {
      if (raf.current) {
        cancelAnimationFrame(raf.current);
        raf.current = void 0;
      }
      return;
    }
    const ownerDocument = $431fbd86ca7dc216$export$b204af158042fbac$1(scope ? scope[0] : void 0);
    let onKeyDown = (e3) => {
      if (e3.key !== "Tab" || e3.altKey || e3.ctrlKey || e3.metaKey || !$9bf71ea28793e738$var$shouldContainFocus(scopeRef) || e3.isComposing) return;
      let focusedElement = ownerDocument.activeElement;
      let scope2 = scopeRef.current;
      if (!scope2 || !$9bf71ea28793e738$var$isElementInScope(focusedElement, scope2)) return;
      let scopeRoot = $9bf71ea28793e738$var$getScopeRoot(scope2);
      let walker = $9bf71ea28793e738$export$2d6ec8fc375ceafa(scopeRoot, {
        tabbable: true
      }, scope2);
      if (!focusedElement) return;
      walker.currentNode = focusedElement;
      let nextElement = e3.shiftKey ? walker.previousNode() : walker.nextNode();
      if (!nextElement) {
        walker.currentNode = e3.shiftKey ? scope2[scope2.length - 1].nextElementSibling : scope2[0].previousElementSibling;
        nextElement = e3.shiftKey ? walker.previousNode() : walker.nextNode();
      }
      e3.preventDefault();
      if (nextElement) $9bf71ea28793e738$var$focusElement(nextElement, true);
    };
    let onFocus2 = (e3) => {
      if ((!$9bf71ea28793e738$var$activeScope || $9bf71ea28793e738$var$isAncestorScope($9bf71ea28793e738$var$activeScope, scopeRef)) && $9bf71ea28793e738$var$isElementInScope(e3.target, scopeRef.current)) {
        $9bf71ea28793e738$var$activeScope = scopeRef;
        focusedNode.current = e3.target;
      } else if ($9bf71ea28793e738$var$shouldContainFocus(scopeRef) && !$9bf71ea28793e738$var$isElementInChildScope(e3.target, scopeRef)) {
        if (focusedNode.current) focusedNode.current.focus();
        else if ($9bf71ea28793e738$var$activeScope && $9bf71ea28793e738$var$activeScope.current) $9bf71ea28793e738$var$focusFirstInScope($9bf71ea28793e738$var$activeScope.current);
      } else if ($9bf71ea28793e738$var$shouldContainFocus(scopeRef)) focusedNode.current = e3.target;
    };
    let onBlur = (e3) => {
      if (raf.current) cancelAnimationFrame(raf.current);
      raf.current = requestAnimationFrame(() => {
        let modality = $507fabe10e71c6fb$export$630ff653c5ada6a9$1();
        let shouldSkipFocusRestore = (modality === "virtual" || modality === null) && $c87311424ea30a05$export$a11b0059900ceec8$1() && $c87311424ea30a05$export$6446a186d09e379e$1();
        if (!shouldSkipFocusRestore && ownerDocument.activeElement && $9bf71ea28793e738$var$shouldContainFocus(scopeRef) && !$9bf71ea28793e738$var$isElementInChildScope(ownerDocument.activeElement, scopeRef)) {
          $9bf71ea28793e738$var$activeScope = scopeRef;
          if (ownerDocument.body.contains(e3.target)) {
            var _focusedNode_current;
            focusedNode.current = e3.target;
            (_focusedNode_current = focusedNode.current) === null || _focusedNode_current === void 0 ? void 0 : _focusedNode_current.focus();
          } else if ($9bf71ea28793e738$var$activeScope.current) $9bf71ea28793e738$var$focusFirstInScope($9bf71ea28793e738$var$activeScope.current);
        }
      });
    };
    ownerDocument.addEventListener("keydown", onKeyDown, false);
    ownerDocument.addEventListener("focusin", onFocus2, false);
    scope === null || scope === void 0 ? void 0 : scope.forEach((element) => element.addEventListener("focusin", onFocus2, false));
    scope === null || scope === void 0 ? void 0 : scope.forEach((element) => element.addEventListener("focusout", onBlur, false));
    return () => {
      ownerDocument.removeEventListener("keydown", onKeyDown, false);
      ownerDocument.removeEventListener("focusin", onFocus2, false);
      scope === null || scope === void 0 ? void 0 : scope.forEach((element) => element.removeEventListener("focusin", onFocus2, false));
      scope === null || scope === void 0 ? void 0 : scope.forEach((element) => element.removeEventListener("focusout", onBlur, false));
    };
  }, [
    scopeRef,
    contain
  ]);
  $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c$1(() => {
    return () => {
      if (raf.current) cancelAnimationFrame(raf.current);
    };
  }, [
    raf
  ]);
}
function $9bf71ea28793e738$var$isElementInAnyScope(element) {
  return $9bf71ea28793e738$var$isElementInChildScope(element);
}
function $9bf71ea28793e738$var$isElementInScope(element, scope) {
  if (!element) return false;
  if (!scope) return false;
  return scope.some((node2) => node2.contains(element));
}
function $9bf71ea28793e738$var$isElementInChildScope(element, scope = null) {
  if (element instanceof Element && element.closest("[data-react-aria-top-layer]")) return true;
  for (let { scopeRef: s2 } of $9bf71ea28793e738$export$d06fae2ee68b101e.traverse($9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode(scope))) {
    if (s2 && $9bf71ea28793e738$var$isElementInScope(element, s2.current)) return true;
  }
  return false;
}
function $9bf71ea28793e738$export$1258395f99bf9cbf(element) {
  return $9bf71ea28793e738$var$isElementInChildScope(element, $9bf71ea28793e738$var$activeScope);
}
function $9bf71ea28793e738$var$isAncestorScope(ancestor, scope) {
  var _focusScopeTree_getTreeNode;
  let parent = (_focusScopeTree_getTreeNode = $9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode(scope)) === null || _focusScopeTree_getTreeNode === void 0 ? void 0 : _focusScopeTree_getTreeNode.parent;
  while (parent) {
    if (parent.scopeRef === ancestor) return true;
    parent = parent.parent;
  }
  return false;
}
function $9bf71ea28793e738$var$focusElement(element, scroll = false) {
  if (element != null && !scroll) try {
    (0, $6a99195332edec8b$export$80f3e147d781571c)(element);
  } catch {
  }
  else if (element != null) try {
    element.focus();
  } catch {
  }
}
function $9bf71ea28793e738$var$getFirstInScope(scope, tabbable = true) {
  let sentinel = scope[0].previousElementSibling;
  let scopeRoot = $9bf71ea28793e738$var$getScopeRoot(scope);
  let walker = $9bf71ea28793e738$export$2d6ec8fc375ceafa(scopeRoot, {
    tabbable
  }, scope);
  walker.currentNode = sentinel;
  let nextNode = walker.nextNode();
  if (tabbable && !nextNode) {
    scopeRoot = $9bf71ea28793e738$var$getScopeRoot(scope);
    walker = $9bf71ea28793e738$export$2d6ec8fc375ceafa(scopeRoot, {
      tabbable: false
    }, scope);
    walker.currentNode = sentinel;
    nextNode = walker.nextNode();
  }
  return nextNode;
}
function $9bf71ea28793e738$var$focusFirstInScope(scope, tabbable = true) {
  $9bf71ea28793e738$var$focusElement($9bf71ea28793e738$var$getFirstInScope(scope, tabbable));
}
function $9bf71ea28793e738$var$useAutoFocus(scopeRef, autoFocus) {
  const autoFocusRef = React__default.useRef(autoFocus);
  useEffect(() => {
    if (autoFocusRef.current) {
      $9bf71ea28793e738$var$activeScope = scopeRef;
      const ownerDocument = $431fbd86ca7dc216$export$b204af158042fbac$1(scopeRef.current ? scopeRef.current[0] : void 0);
      if (!$9bf71ea28793e738$var$isElementInScope(ownerDocument.activeElement, $9bf71ea28793e738$var$activeScope.current) && scopeRef.current) $9bf71ea28793e738$var$focusFirstInScope(scopeRef.current);
    }
    autoFocusRef.current = false;
  }, [
    scopeRef
  ]);
}
function $9bf71ea28793e738$var$useActiveScopeTracker(scopeRef, restore, contain) {
  $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c$1(() => {
    if (restore || contain) return;
    let scope = scopeRef.current;
    const ownerDocument = $431fbd86ca7dc216$export$b204af158042fbac$1(scope ? scope[0] : void 0);
    let onFocus2 = (e3) => {
      let target = e3.target;
      if ($9bf71ea28793e738$var$isElementInScope(target, scopeRef.current)) $9bf71ea28793e738$var$activeScope = scopeRef;
      else if (!$9bf71ea28793e738$var$isElementInAnyScope(target)) $9bf71ea28793e738$var$activeScope = null;
    };
    ownerDocument.addEventListener("focusin", onFocus2, false);
    scope === null || scope === void 0 ? void 0 : scope.forEach((element) => element.addEventListener("focusin", onFocus2, false));
    return () => {
      ownerDocument.removeEventListener("focusin", onFocus2, false);
      scope === null || scope === void 0 ? void 0 : scope.forEach((element) => element.removeEventListener("focusin", onFocus2, false));
    };
  }, [
    scopeRef,
    restore,
    contain
  ]);
}
function $9bf71ea28793e738$var$shouldRestoreFocus(scopeRef) {
  let scope = $9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode($9bf71ea28793e738$var$activeScope);
  while (scope && scope.scopeRef !== scopeRef) {
    if (scope.nodeToRestore) return false;
    scope = scope.parent;
  }
  return (scope === null || scope === void 0 ? void 0 : scope.scopeRef) === scopeRef;
}
function $9bf71ea28793e738$var$useRestoreFocus(scopeRef, restoreFocus, contain) {
  const nodeToRestoreRef = useRef(typeof document !== "undefined" ? $431fbd86ca7dc216$export$b204af158042fbac$1(scopeRef.current ? scopeRef.current[0] : void 0).activeElement : null);
  $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c$1(() => {
    let scope = scopeRef.current;
    const ownerDocument = $431fbd86ca7dc216$export$b204af158042fbac$1(scope ? scope[0] : void 0);
    if (!restoreFocus || contain) return;
    let onFocus2 = () => {
      if ((!$9bf71ea28793e738$var$activeScope || $9bf71ea28793e738$var$isAncestorScope($9bf71ea28793e738$var$activeScope, scopeRef)) && $9bf71ea28793e738$var$isElementInScope(ownerDocument.activeElement, scopeRef.current)) $9bf71ea28793e738$var$activeScope = scopeRef;
    };
    ownerDocument.addEventListener("focusin", onFocus2, false);
    scope === null || scope === void 0 ? void 0 : scope.forEach((element) => element.addEventListener("focusin", onFocus2, false));
    return () => {
      ownerDocument.removeEventListener("focusin", onFocus2, false);
      scope === null || scope === void 0 ? void 0 : scope.forEach((element) => element.removeEventListener("focusin", onFocus2, false));
    };
  }, [
    scopeRef,
    contain
  ]);
  $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c$1(() => {
    const ownerDocument = $431fbd86ca7dc216$export$b204af158042fbac$1(scopeRef.current ? scopeRef.current[0] : void 0);
    if (!restoreFocus) return;
    let onKeyDown = (e3) => {
      if (e3.key !== "Tab" || e3.altKey || e3.ctrlKey || e3.metaKey || !$9bf71ea28793e738$var$shouldContainFocus(scopeRef) || e3.isComposing) return;
      let focusedElement = ownerDocument.activeElement;
      if (!$9bf71ea28793e738$var$isElementInChildScope(focusedElement, scopeRef) || !$9bf71ea28793e738$var$shouldRestoreFocus(scopeRef)) return;
      let treeNode = $9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode(scopeRef);
      if (!treeNode) return;
      let nodeToRestore = treeNode.nodeToRestore;
      let walker = $9bf71ea28793e738$export$2d6ec8fc375ceafa(ownerDocument.body, {
        tabbable: true
      });
      walker.currentNode = focusedElement;
      let nextElement = e3.shiftKey ? walker.previousNode() : walker.nextNode();
      if (!nodeToRestore || !ownerDocument.body.contains(nodeToRestore) || nodeToRestore === ownerDocument.body) {
        nodeToRestore = void 0;
        treeNode.nodeToRestore = void 0;
      }
      if ((!nextElement || !$9bf71ea28793e738$var$isElementInChildScope(nextElement, scopeRef)) && nodeToRestore) {
        walker.currentNode = nodeToRestore;
        do
          nextElement = e3.shiftKey ? walker.previousNode() : walker.nextNode();
        while ($9bf71ea28793e738$var$isElementInChildScope(nextElement, scopeRef));
        e3.preventDefault();
        e3.stopPropagation();
        if (nextElement) $9bf71ea28793e738$var$focusElement(nextElement, true);
        else if (!$9bf71ea28793e738$var$isElementInAnyScope(nodeToRestore)) focusedElement.blur();
        else $9bf71ea28793e738$var$focusElement(nodeToRestore, true);
      }
    };
    if (!contain) ownerDocument.addEventListener("keydown", onKeyDown, true);
    return () => {
      if (!contain) ownerDocument.removeEventListener("keydown", onKeyDown, true);
    };
  }, [
    scopeRef,
    restoreFocus,
    contain
  ]);
  $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c$1(() => {
    const ownerDocument = $431fbd86ca7dc216$export$b204af158042fbac$1(scopeRef.current ? scopeRef.current[0] : void 0);
    if (!restoreFocus) return;
    let treeNode = $9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode(scopeRef);
    if (!treeNode) return;
    var _nodeToRestoreRef_current;
    treeNode.nodeToRestore = (_nodeToRestoreRef_current = nodeToRestoreRef.current) !== null && _nodeToRestoreRef_current !== void 0 ? _nodeToRestoreRef_current : void 0;
    return () => {
      let treeNode2 = $9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode(scopeRef);
      if (!treeNode2) return;
      let nodeToRestore = treeNode2.nodeToRestore;
      if (restoreFocus && nodeToRestore && (ownerDocument.activeElement && $9bf71ea28793e738$var$isElementInChildScope(ownerDocument.activeElement, scopeRef) || ownerDocument.activeElement === ownerDocument.body && $9bf71ea28793e738$var$shouldRestoreFocus(scopeRef))) {
        let clonedTree = $9bf71ea28793e738$export$d06fae2ee68b101e.clone();
        requestAnimationFrame(() => {
          if (ownerDocument.activeElement === ownerDocument.body) {
            let treeNode3 = clonedTree.getTreeNode(scopeRef);
            while (treeNode3) {
              if (treeNode3.nodeToRestore && treeNode3.nodeToRestore.isConnected) {
                $9bf71ea28793e738$var$restoreFocusToElement(treeNode3.nodeToRestore);
                return;
              }
              treeNode3 = treeNode3.parent;
            }
            treeNode3 = clonedTree.getTreeNode(scopeRef);
            while (treeNode3) {
              if (treeNode3.scopeRef && treeNode3.scopeRef.current && $9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode(treeNode3.scopeRef)) {
                let node2 = $9bf71ea28793e738$var$getFirstInScope(treeNode3.scopeRef.current, true);
                $9bf71ea28793e738$var$restoreFocusToElement(node2);
                return;
              }
              treeNode3 = treeNode3.parent;
            }
          }
        });
      }
    };
  }, [
    scopeRef,
    restoreFocus
  ]);
}
function $9bf71ea28793e738$var$restoreFocusToElement(node2) {
  if (node2.dispatchEvent(new CustomEvent($9bf71ea28793e738$var$RESTORE_FOCUS_EVENT, {
    bubbles: true,
    cancelable: true
  }))) $9bf71ea28793e738$var$focusElement(node2);
}
function $9bf71ea28793e738$export$2d6ec8fc375ceafa(root2, opts, scope) {
  let selector = (opts === null || opts === void 0 ? void 0 : opts.tabbable) ? $9bf71ea28793e738$var$TABBABLE_ELEMENT_SELECTOR : $9bf71ea28793e738$var$FOCUSABLE_ELEMENT_SELECTOR;
  let walker = $431fbd86ca7dc216$export$b204af158042fbac$1(root2).createTreeWalker(root2, NodeFilter.SHOW_ELEMENT, {
    acceptNode(node2) {
      var _opts_from;
      if (opts === null || opts === void 0 ? void 0 : (_opts_from = opts.from) === null || _opts_from === void 0 ? void 0 : _opts_from.contains(node2)) return NodeFilter.FILTER_REJECT;
      if (node2.matches(selector) && $645f2e67b85a24c9$export$e989c0fffaa6b27a(node2) && (!scope || $9bf71ea28793e738$var$isElementInScope(node2, scope)) && (!(opts === null || opts === void 0 ? void 0 : opts.accept) || opts.accept(node2))) return NodeFilter.FILTER_ACCEPT;
      return NodeFilter.FILTER_SKIP;
    }
  });
  if (opts === null || opts === void 0 ? void 0 : opts.from) walker.currentNode = opts.from;
  return walker;
}
class $9bf71ea28793e738$var$Tree {
  get size() {
    return this.fastMap.size;
  }
  getTreeNode(data) {
    return this.fastMap.get(data);
  }
  addTreeNode(scopeRef, parent, nodeToRestore) {
    let parentNode = this.fastMap.get(parent !== null && parent !== void 0 ? parent : null);
    if (!parentNode) return;
    let node2 = new $9bf71ea28793e738$var$TreeNode({
      scopeRef
    });
    parentNode.addChild(node2);
    node2.parent = parentNode;
    this.fastMap.set(scopeRef, node2);
    if (nodeToRestore) node2.nodeToRestore = nodeToRestore;
  }
  addNode(node2) {
    this.fastMap.set(node2.scopeRef, node2);
  }
  removeTreeNode(scopeRef) {
    if (scopeRef === null) return;
    let node2 = this.fastMap.get(scopeRef);
    if (!node2) return;
    let parentNode = node2.parent;
    for (let current of this.traverse()) if (current !== node2 && node2.nodeToRestore && current.nodeToRestore && node2.scopeRef && node2.scopeRef.current && $9bf71ea28793e738$var$isElementInScope(current.nodeToRestore, node2.scopeRef.current)) current.nodeToRestore = node2.nodeToRestore;
    let children = node2.children;
    if (parentNode) {
      parentNode.removeChild(node2);
      if (children.size > 0) children.forEach((child) => parentNode && parentNode.addChild(child));
    }
    this.fastMap.delete(node2.scopeRef);
  }
  // Pre Order Depth First
  *traverse(node2 = this.root) {
    if (node2.scopeRef != null) yield node2;
    if (node2.children.size > 0) for (let child of node2.children) yield* this.traverse(child);
  }
  clone() {
    var _node_parent;
    let newTree = new $9bf71ea28793e738$var$Tree();
    var _node_parent_scopeRef;
    for (let node2 of this.traverse()) newTree.addTreeNode(node2.scopeRef, (_node_parent_scopeRef = (_node_parent = node2.parent) === null || _node_parent === void 0 ? void 0 : _node_parent.scopeRef) !== null && _node_parent_scopeRef !== void 0 ? _node_parent_scopeRef : null, node2.nodeToRestore);
    return newTree;
  }
  constructor() {
    this.fastMap = /* @__PURE__ */ new Map();
    this.root = new $9bf71ea28793e738$var$TreeNode({
      scopeRef: null
    });
    this.fastMap.set(null, this.root);
  }
}
class $9bf71ea28793e738$var$TreeNode {
  addChild(node2) {
    this.children.add(node2);
    node2.parent = this;
  }
  removeChild(node2) {
    this.children.delete(node2);
    node2.parent = void 0;
  }
  constructor(props) {
    this.children = /* @__PURE__ */ new Set();
    this.contain = false;
    this.scopeRef = props.scopeRef;
  }
}
let $9bf71ea28793e738$export$d06fae2ee68b101e = new $9bf71ea28793e738$var$Tree();
const $a11501f3d1d39e6c$var$visibleOverlays = [];
function $a11501f3d1d39e6c$export$ea8f71083e90600f(props, ref2) {
  let { onClose, shouldCloseOnBlur, isOpen, isDismissable = false, isKeyboardDismissDisabled = false, shouldCloseOnInteractOutside } = props;
  useEffect(() => {
    if (isOpen) $a11501f3d1d39e6c$var$visibleOverlays.push(ref2);
    return () => {
      let index2 = $a11501f3d1d39e6c$var$visibleOverlays.indexOf(ref2);
      if (index2 >= 0) $a11501f3d1d39e6c$var$visibleOverlays.splice(index2, 1);
    };
  }, [
    isOpen,
    ref2
  ]);
  let onHide = () => {
    if ($a11501f3d1d39e6c$var$visibleOverlays[$a11501f3d1d39e6c$var$visibleOverlays.length - 1] === ref2 && onClose) onClose();
  };
  let onInteractOutsideStart = (e3) => {
    if (!shouldCloseOnInteractOutside || shouldCloseOnInteractOutside(e3.target)) {
      if ($a11501f3d1d39e6c$var$visibleOverlays[$a11501f3d1d39e6c$var$visibleOverlays.length - 1] === ref2) {
        e3.stopPropagation();
        e3.preventDefault();
      }
    }
  };
  let onInteractOutside = (e3) => {
    if (!shouldCloseOnInteractOutside || shouldCloseOnInteractOutside(e3.target)) {
      if ($a11501f3d1d39e6c$var$visibleOverlays[$a11501f3d1d39e6c$var$visibleOverlays.length - 1] === ref2) {
        e3.stopPropagation();
        e3.preventDefault();
      }
      onHide();
    }
  };
  let onKeyDown = (e3) => {
    if (e3.key === "Escape" && !isKeyboardDismissDisabled && !e3.nativeEvent.isComposing) {
      e3.stopPropagation();
      e3.preventDefault();
      onHide();
    }
  };
  $e0b6e0b68ec7f50f$export$872b660ac5a1ff98({
    ref: ref2,
    onInteractOutside: isDismissable && isOpen ? onInteractOutside : void 0,
    onInteractOutsideStart
  });
  let { focusWithinProps } = $9ab94262bd0047c7$export$420e68273165f4ec({
    isDisabled: !shouldCloseOnBlur,
    onBlurWithin: (e3) => {
      if (!e3.relatedTarget || $9bf71ea28793e738$export$1258395f99bf9cbf(e3.relatedTarget)) return;
      if (!shouldCloseOnInteractOutside || shouldCloseOnInteractOutside(e3.relatedTarget)) onClose === null || onClose === void 0 ? void 0 : onClose();
    }
  });
  let onPointerDownUnderlay = (e3) => {
    if (e3.target === e3.currentTarget) e3.preventDefault();
  };
  return {
    overlayProps: {
      onKeyDown,
      ...focusWithinProps
    },
    underlayProps: {
      onPointerDown: onPointerDownUnderlay
    }
  };
}
const $49c51c25361d4cd2$var$visualViewport = typeof document !== "undefined" && window.visualViewport;
const $49c51c25361d4cd2$var$nonTextInputTypes = /* @__PURE__ */ new Set([
  "checkbox",
  "radio",
  "range",
  "color",
  "file",
  "image",
  "button",
  "submit",
  "reset"
]);
let $49c51c25361d4cd2$var$preventScrollCount = 0;
let $49c51c25361d4cd2$var$restore;
function $49c51c25361d4cd2$export$ee0f7cc6afcd1c18(options2 = {}) {
  let { isDisabled } = options2;
  $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c$1(() => {
    if (isDisabled) return;
    $49c51c25361d4cd2$var$preventScrollCount++;
    if ($49c51c25361d4cd2$var$preventScrollCount === 1) {
      if ($c87311424ea30a05$export$fedb369cb70207f1$1()) $49c51c25361d4cd2$var$restore = $49c51c25361d4cd2$var$preventScrollMobileSafari();
      else $49c51c25361d4cd2$var$restore = $49c51c25361d4cd2$var$preventScrollStandard();
    }
    return () => {
      $49c51c25361d4cd2$var$preventScrollCount--;
      if ($49c51c25361d4cd2$var$preventScrollCount === 0) $49c51c25361d4cd2$var$restore();
    };
  }, [
    isDisabled
  ]);
}
function $49c51c25361d4cd2$var$preventScrollStandard() {
  return $ff5963eb1fccf552$export$e08e3b67e392101e($49c51c25361d4cd2$var$setStyle(document.documentElement, "paddingRight", `${window.innerWidth - document.documentElement.clientWidth}px`), $49c51c25361d4cd2$var$setStyle(document.documentElement, "overflow", "hidden"));
}
function $49c51c25361d4cd2$var$preventScrollMobileSafari() {
  let scrollable;
  let restoreScrollableStyles;
  let onTouchStart = (e3) => {
    scrollable = $62d8ded9296f3872$export$cfa2225e87938781(e3.target, true);
    if (scrollable === document.documentElement && scrollable === document.body) return;
    if (scrollable instanceof HTMLElement && window.getComputedStyle(scrollable).overscrollBehavior === "auto") restoreScrollableStyles = $49c51c25361d4cd2$var$setStyle(scrollable, "overscrollBehavior", "contain");
  };
  let onTouchMove = (e3) => {
    if (!scrollable || scrollable === document.documentElement || scrollable === document.body) {
      e3.preventDefault();
      return;
    }
    if (scrollable.scrollHeight === scrollable.clientHeight && scrollable.scrollWidth === scrollable.clientWidth) e3.preventDefault();
  };
  let onTouchEnd = () => {
    if (restoreScrollableStyles) restoreScrollableStyles();
  };
  let onFocus2 = (e3) => {
    let target = e3.target;
    if ($49c51c25361d4cd2$var$willOpenKeyboard(target)) {
      setupStyles();
      target.style.transform = "translateY(-2000px)";
      requestAnimationFrame(() => {
        target.style.transform = "";
        if ($49c51c25361d4cd2$var$visualViewport) {
          if ($49c51c25361d4cd2$var$visualViewport.height < window.innerHeight)
            requestAnimationFrame(() => {
              $49c51c25361d4cd2$var$scrollIntoView(target);
            });
          else
            $49c51c25361d4cd2$var$visualViewport.addEventListener("resize", () => $49c51c25361d4cd2$var$scrollIntoView(target), {
              once: true
            });
        }
      });
    }
  };
  let restoreStyles = null;
  let setupStyles = () => {
    if (restoreStyles) return;
    let onWindowScroll = () => {
      window.scrollTo(0, 0);
    };
    let scrollX = window.pageXOffset;
    let scrollY = window.pageYOffset;
    restoreStyles = $ff5963eb1fccf552$export$e08e3b67e392101e($49c51c25361d4cd2$var$addEvent(window, "scroll", onWindowScroll), $49c51c25361d4cd2$var$setStyle(document.documentElement, "paddingRight", `${window.innerWidth - document.documentElement.clientWidth}px`), $49c51c25361d4cd2$var$setStyle(document.documentElement, "overflow", "hidden"), $49c51c25361d4cd2$var$setStyle(document.body, "marginTop", `-${scrollY}px`), () => {
      window.scrollTo(scrollX, scrollY);
    });
    window.scrollTo(0, 0);
  };
  let removeEvents = $ff5963eb1fccf552$export$e08e3b67e392101e($49c51c25361d4cd2$var$addEvent(document, "touchstart", onTouchStart, {
    passive: false,
    capture: true
  }), $49c51c25361d4cd2$var$addEvent(document, "touchmove", onTouchMove, {
    passive: false,
    capture: true
  }), $49c51c25361d4cd2$var$addEvent(document, "touchend", onTouchEnd, {
    passive: false,
    capture: true
  }), $49c51c25361d4cd2$var$addEvent(document, "focus", onFocus2, true));
  return () => {
    restoreScrollableStyles === null || restoreScrollableStyles === void 0 ? void 0 : restoreScrollableStyles();
    restoreStyles === null || restoreStyles === void 0 ? void 0 : restoreStyles();
    removeEvents();
  };
}
function $49c51c25361d4cd2$var$setStyle(element, style, value) {
  let cur = element.style[style];
  element.style[style] = value;
  return () => {
    element.style[style] = cur;
  };
}
function $49c51c25361d4cd2$var$addEvent(target, event, handler, options2) {
  target.addEventListener(event, handler, options2);
  return () => {
    target.removeEventListener(event, handler, options2);
  };
}
function $49c51c25361d4cd2$var$scrollIntoView(target) {
  let root2 = document.scrollingElement || document.documentElement;
  let nextTarget = target;
  while (nextTarget && nextTarget !== root2) {
    let scrollable = $62d8ded9296f3872$export$cfa2225e87938781(nextTarget);
    if (scrollable !== document.documentElement && scrollable !== document.body && scrollable !== nextTarget) {
      let scrollableTop = scrollable.getBoundingClientRect().top;
      let targetTop = nextTarget.getBoundingClientRect().top;
      if (targetTop > scrollableTop + nextTarget.clientHeight) scrollable.scrollTop += targetTop - scrollableTop;
    }
    nextTarget = scrollable.parentElement;
  }
}
function $49c51c25361d4cd2$var$willOpenKeyboard(target) {
  return target instanceof HTMLInputElement && !$49c51c25361d4cd2$var$nonTextInputTypes.has(target.type) || target instanceof HTMLTextAreaElement || target instanceof HTMLElement && target.isContentEditable;
}
const $f57aed4a881a3485$var$Context = /* @__PURE__ */ React__default.createContext(null);
function $f57aed4a881a3485$export$178405afcd8c5eb(props) {
  let { children } = props;
  let parent = useContext($f57aed4a881a3485$var$Context);
  let [modalCount, setModalCount] = useState(0);
  let context = useMemo(() => ({
    parent,
    modalCount,
    addModal() {
      setModalCount((count2) => count2 + 1);
      if (parent) parent.addModal();
    },
    removeModal() {
      setModalCount((count2) => count2 - 1);
      if (parent) parent.removeModal();
    }
  }), [
    parent,
    modalCount
  ]);
  return /* @__PURE__ */ React__default.createElement($f57aed4a881a3485$var$Context.Provider, {
    value: context
  }, children);
}
function $f57aed4a881a3485$export$d9aaed4c3ece1bc0() {
  let context = useContext($f57aed4a881a3485$var$Context);
  return {
    modalProviderProps: {
      "aria-hidden": context && context.modalCount > 0 ? true : void 0
    }
  };
}
function $f57aed4a881a3485$var$OverlayContainerDOM(props) {
  let { modalProviderProps } = $f57aed4a881a3485$export$d9aaed4c3ece1bc0();
  return /* @__PURE__ */ React__default.createElement("div", {
    "data-overlay-container": true,
    ...props,
    ...modalProviderProps
  });
}
function $f57aed4a881a3485$export$bf688221f59024e5(props) {
  return /* @__PURE__ */ React__default.createElement($f57aed4a881a3485$export$178405afcd8c5eb, null, /* @__PURE__ */ React__default.createElement($f57aed4a881a3485$var$OverlayContainerDOM, props));
}
function $f57aed4a881a3485$export$b47c3594eab58386(props) {
  let isSSR = $b5e257d569688ac6$export$535bd6ca7f90a273$1();
  let { portalContainer = isSSR ? null : document.body, ...rest } = props;
  React__default.useEffect(() => {
    if (portalContainer === null || portalContainer === void 0 ? void 0 : portalContainer.closest("[data-overlay-container]")) throw new Error("An OverlayContainer must not be inside another container. Please change the portalContainer prop.");
  }, [
    portalContainer
  ]);
  if (!portalContainer) return null;
  let contents = /* @__PURE__ */ React__default.createElement($f57aed4a881a3485$export$bf688221f59024e5, rest);
  return /* @__PURE__ */ ReactDOM__default.createPortal(contents, portalContainer);
}
function $f57aed4a881a3485$export$33ffd74ebf07f060(options2) {
  let context = useContext($f57aed4a881a3485$var$Context);
  if (!context) throw new Error("Modal is not contained within a provider");
  useEffect(() => {
    if (!context || !context.parent) return;
    context.parent.addModal();
    return () => {
      if (context && context.parent) context.parent.removeModal();
    };
  }, [
    context,
    context.parent,
    void 0
  ]);
  return {
    modalProps: {
      "data-ismodal": true
    }
  };
}
const $337b884510726a0d$export$a2200b96afd16271 = /* @__PURE__ */ React__default.createContext(null);
function $337b884510726a0d$export$14c98a7594375490() {
  let ctx = useContext($337b884510726a0d$export$a2200b96afd16271);
  let setContain = ctx === null || ctx === void 0 ? void 0 : ctx.setContain;
  $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c$1(() => {
    setContain === null || setContain === void 0 ? void 0 : setContain(true);
  }, [
    setContain
  ]);
}
const DIVIDER_VARIANT_STYLES = {
  default: css$3`
    background-color: var(${TOKENS.color.border.default});
  `,
  onColor: css$3`
    background-color: var(${TOKENS.color.border.onColor});
    opacity: 0.2;
  `,
  accent: css$3`
    background: var(${TOKENS.color.background.interaction.accent});
  `
};
const HRElement = styled.div`
  height: 1px;
  width: 100%;
  ${(props) => props.vertical && css$3`
      height: 100%;
      width: 1px;
    `}
  ${({
  variant = "default"
}) => DIVIDER_VARIANT_STYLES[variant]}
  border: none;
  ${compose(space, layout, color, background, border, position$1)}
`;
const Divider = forwardRef(({
  variant,
  ...rest
}, ref2) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(HRElement, { variant, ...rest, ref: ref2 });
});
Divider.displayName = "Divider";
if (typeof window !== "undefined") {
  import("./programmaticFocusPolyfill-CO__AbBX.mjs").then(() => {
    window.polyfillsLoaded = true;
  });
}
const stringifyBorderProps = (props) => Object.entries(props || {}).reduce((final, [key, value]) => {
  let stringifiedValue = value;
  if (typeof value === "number") {
    stringifiedValue = `${value}px`;
  }
  if (typeof value === "symbol") {
    console.error("Symbol is not a valid input");
  }
  return {
    ...final,
    [key]: stringifiedValue
  };
}, {});
const getResolvedBorderValues = ({
  borderWidth: borderWidth2,
  borderBottomWidth,
  borderRightWidth,
  borderLeftWidth,
  borderTopWidth,
  borderRadius: borderRadius2,
  borderTopLeftRadius,
  borderBottomLeftRadius,
  borderBottomRightRadius,
  borderTopRightRadius
}) => ({
  borderTopWidth: borderTopWidth || borderWidth2 || "0px",
  borderBottomWidth: borderBottomWidth || borderWidth2 || "0px",
  borderRightWidth: borderRightWidth || borderWidth2 || "0px",
  borderLeftWidth: borderLeftWidth || borderWidth2 || "0px",
  borderTopLeftRadius: borderTopLeftRadius || borderRadius2 || "0px",
  borderTopRightRadius: borderTopRightRadius || borderRadius2 || "0px",
  borderBottomLeftRadius: borderBottomLeftRadius || borderRadius2 || "0px",
  borderBottomRightRadius: borderBottomRightRadius || borderRadius2 || "0px"
});
const RawFocusRing = ({
  width: ringWidth = "1px",
  color: ringColor = "blue",
  gap: ringGap = "0px",
  borderRadius: borderRadius2 = "0px",
  elementBorderProps
}) => {
  const resolvedBorderValues = getResolvedBorderValues(stringifyBorderProps({
    borderRadius: borderRadius2,
    ...elementBorderProps
  }));
  return css$3`
    box-sizing: border-box;
    box-shadow: 0 0 0 ${ringGap} white,
      0 0 0 calc(${ringGap} + ${ringWidth}) ${ringColor};
    border-top-left-radius: ${resolvedBorderValues.borderTopLeftRadius};
    border-top-right-radius: ${resolvedBorderValues.borderTopRightRadius};
    border-bottom-right-radius: ${resolvedBorderValues.borderBottomRightRadius};
    border-bottom-left-radius: ${resolvedBorderValues.borderBottomLeftRadius};
  `;
};
const FocusRing = ({
  width: width2 = "1px",
  color: color2 = "blue",
  gap = "0px",
  borderRadius: borderRadius2 = "0px",
  elementBorderProps,
  background: background2
}) => {
  return css$3`
    // We use box-shadow to style this now instead

    &:focus {
      outline: none;
    }
    /* includes .focus-visible class due to programmaticFocusPolyfill.ts dynamically adding class for programmatic focus */
    /* on mouse clicks that doesn't trigger :focus-visible css selector */
    &.focus-visible,
    &:focus-visible {
      outline: none;
      ${background2 && `background-color: ${background2};`}
      ${RawFocusRing({
    width: width2,
    color: color2,
    gap,
    borderRadius: borderRadius2,
    elementBorderProps
  })}
    }
  `;
};
const Accordion$1 = styled.div`
  display: flex;
  flex-direction: column;
  ${composeWrapper([space, layout, flexbox, grid, background, border, position$1])}
`;
const AccordionItem$1 = styled.div`
  display: flex;
  flex-direction: column;
  ${composeWrapper([space, padding, layout, flexbox, background, border])}
`;
const AccordionItemTrigger = styled.button`
  ${(props) => FocusRing({
  gap: "1px",
  width: "2px",
  borderRadius: "4px",
  color: `var(${TOKENS.color.border.focus})`,
  ...props.focusRingStyle
})}
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: none;
  background: unset;
  padding: 24px;
  width: 100%;
  ${composeWrapper([space, padding, color, layout, flexbox, background, border])}

  ${({
  disabled
}) => disabled && "pointer-events: none;"};
  cursor: pointer;

  svg {
    transition: transform 0.25s ease-in-out;
    transform: ${({
  open,
  rotateDeg = 180
}) => open ? `rotate(${rotateDeg}deg)` : "none"};
  }
`;
const AccordionItemBody = styled.section`
  overflow: hidden;
`;
const AccordionItemRegion = styled.div`
  padding-left: 24px;
  padding-right: 24px;
  padding-bottom: 24px;
  ${composeWrapper([space, layout, flexbox, background, border, grid, position$1, typography, color])}
`;
const [AccordionItemProvider, useAccordionItemContext] = createContext({
  name: "AccordionItemContext",
  hookName: "useAccordionItemContext",
  providerName: "<AccordionItemProvider/>"
});
const AccordionItem = forwardRef((props, ref2) => {
  const {
    children,
    value,
    hideDivider,
    ...rest
  } = props;
  const triggerId = useId$2();
  const regionId = useId$2();
  const {
    openedItems,
    showDivider = true
  } = useAccordionContext();
  const open = useMemo(() => openedItems.includes(value), [value, openedItems]);
  const itemProviderValues = useMemo(() => ({
    open,
    value,
    regionId,
    triggerId,
    ...rest
  }), [rest, value, open, triggerId, regionId]);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(AccordionItemProvider, { value: itemProviderValues, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(AccordionItem$1, { ref: ref2, ...rest, children }),
    showDivider && !hideDivider && /* @__PURE__ */ jsxRuntimeExports.jsx(Divider, { "data-divider": true })
  ] });
});
const AccordionTrigger = forwardRef((props, ref2) => {
  const {
    children,
    rotateDeg: pRotateDeg,
    onClick,
    forceOpen,
    forceOpenTimestamp,
    ...rest
  } = props;
  const {
    rotateDeg,
    disabled: allDisabled,
    toggleItem
  } = useAccordionContext();
  const {
    triggerId,
    regionId,
    open,
    value,
    disabled
  } = useAccordionItemContext();
  useEffect(() => {
    if (forceOpen && !open) {
      toggleItem(value);
    }
  }, [forceOpen, forceOpenTimestamp]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(AccordionItemTrigger, { ref: ref2, id: triggerId, type: "button", open, "aria-expanded": open, "aria-controls": regionId, rotateDeg: rotateDeg || pRotateDeg, disabled: allDisabled || disabled, onClick: (e3) => {
    e3.stopPropagation();
    onClick == null ? void 0 : onClick(e3);
    toggleItem(value);
  }, ...rest, children });
});
function _objectWithoutPropertiesLoose$4(r2, e3) {
  if (null == r2) return {};
  var t2 = {};
  for (var n2 in r2) if ({}.hasOwnProperty.call(r2, n2)) {
    if (-1 !== e3.indexOf(n2)) continue;
    t2[n2] = r2[n2];
  }
  return t2;
}
function hasClass(element, className) {
  if (element.classList) return !!className && element.classList.contains(className);
  return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}
function addClass(element, className) {
  if (element.classList) element.classList.add(className);
  else if (!hasClass(element, className)) if (typeof element.className === "string") element.className = element.className + " " + className;
  else element.setAttribute("class", (element.className && element.className.baseVal || "") + " " + className);
}
function replaceClassName(origClass, classToRemove) {
  return origClass.replace(new RegExp("(^|\\s)" + classToRemove + "(?:\\s|$)", "g"), "$1").replace(/\s+/g, " ").replace(/^\s*|\s*$/g, "");
}
function removeClass$1(element, className) {
  if (element.classList) {
    element.classList.remove(className);
  } else if (typeof element.className === "string") {
    element.className = replaceClassName(element.className, className);
  } else {
    element.setAttribute("class", replaceClassName(element.className && element.className.baseVal || "", className));
  }
}
var config = {
  disabled: false
};
var timeoutsShape = process.env.NODE_ENV !== "production" ? PropTypes.oneOfType([PropTypes.number, PropTypes.shape({
  enter: PropTypes.number,
  exit: PropTypes.number,
  appear: PropTypes.number
}).isRequired]) : null;
var classNamesShape = process.env.NODE_ENV !== "production" ? PropTypes.oneOfType([PropTypes.string, PropTypes.shape({
  enter: PropTypes.string,
  exit: PropTypes.string,
  active: PropTypes.string
}), PropTypes.shape({
  enter: PropTypes.string,
  enterDone: PropTypes.string,
  enterActive: PropTypes.string,
  exit: PropTypes.string,
  exitDone: PropTypes.string,
  exitActive: PropTypes.string
})]) : null;
var TransitionGroupContext = React__default.createContext(null);
var forceReflow = function forceReflow2(node2) {
  return node2.scrollTop;
};
var UNMOUNTED = "unmounted";
var EXITED = "exited";
var ENTERING = "entering";
var ENTERED = "entered";
var EXITING = "exiting";
var Transition = /* @__PURE__ */ function(_React$Component) {
  _inheritsLoose(Transition2, _React$Component);
  function Transition2(props, context) {
    var _this;
    _this = _React$Component.call(this, props, context) || this;
    var parentGroup = context;
    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
    var initialStatus;
    _this.appearStatus = null;
    if (props.in) {
      if (appear) {
        initialStatus = EXITED;
        _this.appearStatus = ENTERING;
      } else {
        initialStatus = ENTERED;
      }
    } else {
      if (props.unmountOnExit || props.mountOnEnter) {
        initialStatus = UNMOUNTED;
      } else {
        initialStatus = EXITED;
      }
    }
    _this.state = {
      status: initialStatus
    };
    _this.nextCallback = null;
    return _this;
  }
  Transition2.getDerivedStateFromProps = function getDerivedStateFromProps(_ref3, prevState) {
    var nextIn = _ref3.in;
    if (nextIn && prevState.status === UNMOUNTED) {
      return {
        status: EXITED
      };
    }
    return null;
  };
  var _proto = Transition2.prototype;
  _proto.componentDidMount = function componentDidMount() {
    this.updateStatus(true, this.appearStatus);
  };
  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var nextStatus = null;
    if (prevProps !== this.props) {
      var status = this.state.status;
      if (this.props.in) {
        if (status !== ENTERING && status !== ENTERED) {
          nextStatus = ENTERING;
        }
      } else {
        if (status === ENTERING || status === ENTERED) {
          nextStatus = EXITING;
        }
      }
    }
    this.updateStatus(false, nextStatus);
  };
  _proto.componentWillUnmount = function componentWillUnmount() {
    this.cancelNextCallback();
  };
  _proto.getTimeouts = function getTimeouts() {
    var timeout2 = this.props.timeout;
    var exit, enter, appear;
    exit = enter = appear = timeout2;
    if (timeout2 != null && typeof timeout2 !== "number") {
      exit = timeout2.exit;
      enter = timeout2.enter;
      appear = timeout2.appear !== void 0 ? timeout2.appear : enter;
    }
    return {
      exit,
      enter,
      appear
    };
  };
  _proto.updateStatus = function updateStatus(mounting, nextStatus) {
    if (mounting === void 0) {
      mounting = false;
    }
    if (nextStatus !== null) {
      this.cancelNextCallback();
      if (nextStatus === ENTERING) {
        if (this.props.unmountOnExit || this.props.mountOnEnter) {
          var node2 = this.props.nodeRef ? this.props.nodeRef.current : ReactDOM__default.findDOMNode(this);
          if (node2) forceReflow(node2);
        }
        this.performEnter(mounting);
      } else {
        this.performExit();
      }
    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
      this.setState({
        status: UNMOUNTED
      });
    }
  };
  _proto.performEnter = function performEnter(mounting) {
    var _this2 = this;
    var enter = this.props.enter;
    var appearing = this.context ? this.context.isMounting : mounting;
    var _ref22 = this.props.nodeRef ? [appearing] : [ReactDOM__default.findDOMNode(this), appearing], maybeNode = _ref22[0], maybeAppearing = _ref22[1];
    var timeouts = this.getTimeouts();
    var enterTimeout = appearing ? timeouts.appear : timeouts.enter;
    if (!mounting && !enter || config.disabled) {
      this.safeSetState({
        status: ENTERED
      }, function() {
        _this2.props.onEntered(maybeNode);
      });
      return;
    }
    this.props.onEnter(maybeNode, maybeAppearing);
    this.safeSetState({
      status: ENTERING
    }, function() {
      _this2.props.onEntering(maybeNode, maybeAppearing);
      _this2.onTransitionEnd(enterTimeout, function() {
        _this2.safeSetState({
          status: ENTERED
        }, function() {
          _this2.props.onEntered(maybeNode, maybeAppearing);
        });
      });
    });
  };
  _proto.performExit = function performExit() {
    var _this3 = this;
    var exit = this.props.exit;
    var timeouts = this.getTimeouts();
    var maybeNode = this.props.nodeRef ? void 0 : ReactDOM__default.findDOMNode(this);
    if (!exit || config.disabled) {
      this.safeSetState({
        status: EXITED
      }, function() {
        _this3.props.onExited(maybeNode);
      });
      return;
    }
    this.props.onExit(maybeNode);
    this.safeSetState({
      status: EXITING
    }, function() {
      _this3.props.onExiting(maybeNode);
      _this3.onTransitionEnd(timeouts.exit, function() {
        _this3.safeSetState({
          status: EXITED
        }, function() {
          _this3.props.onExited(maybeNode);
        });
      });
    });
  };
  _proto.cancelNextCallback = function cancelNextCallback() {
    if (this.nextCallback !== null) {
      this.nextCallback.cancel();
      this.nextCallback = null;
    }
  };
  _proto.safeSetState = function safeSetState(nextState, callback) {
    callback = this.setNextCallback(callback);
    this.setState(nextState, callback);
  };
  _proto.setNextCallback = function setNextCallback(callback) {
    var _this4 = this;
    var active = true;
    this.nextCallback = function(event) {
      if (active) {
        active = false;
        _this4.nextCallback = null;
        callback(event);
      }
    };
    this.nextCallback.cancel = function() {
      active = false;
    };
    return this.nextCallback;
  };
  _proto.onTransitionEnd = function onTransitionEnd(timeout2, handler) {
    this.setNextCallback(handler);
    var node2 = this.props.nodeRef ? this.props.nodeRef.current : ReactDOM__default.findDOMNode(this);
    var doesNotHaveTimeoutOrListener = timeout2 == null && !this.props.addEndListener;
    if (!node2 || doesNotHaveTimeoutOrListener) {
      setTimeout(this.nextCallback, 0);
      return;
    }
    if (this.props.addEndListener) {
      var _ref3 = this.props.nodeRef ? [this.nextCallback] : [node2, this.nextCallback], maybeNode = _ref3[0], maybeNextCallback = _ref3[1];
      this.props.addEndListener(maybeNode, maybeNextCallback);
    }
    if (timeout2 != null) {
      setTimeout(this.nextCallback, timeout2);
    }
  };
  _proto.render = function render() {
    var status = this.state.status;
    if (status === UNMOUNTED) {
      return null;
    }
    var _this$props = this.props, children = _this$props.children;
    _this$props.in;
    _this$props.mountOnEnter;
    _this$props.unmountOnExit;
    _this$props.appear;
    _this$props.enter;
    _this$props.exit;
    _this$props.timeout;
    _this$props.addEndListener;
    _this$props.onEnter;
    _this$props.onEntering;
    _this$props.onEntered;
    _this$props.onExit;
    _this$props.onExiting;
    _this$props.onExited;
    _this$props.nodeRef;
    var childProps = _objectWithoutPropertiesLoose$4(_this$props, ["children", "in", "mountOnEnter", "unmountOnExit", "appear", "enter", "exit", "timeout", "addEndListener", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "nodeRef"]);
    return (
      // allows for nested Transitions
      /* @__PURE__ */ React__default.createElement(TransitionGroupContext.Provider, {
        value: null
      }, typeof children === "function" ? children(status, childProps) : React__default.cloneElement(React__default.Children.only(children), childProps))
    );
  };
  return Transition2;
}(React__default.Component);
Transition.contextType = TransitionGroupContext;
Transition.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * A React reference to DOM element that need to transition:
   * https://stackoverflow.com/a/51127130/4671932
   *
   *   - When `nodeRef` prop is used, `node` is not passed to callback functions
   *      (e.g. `onEnter`) because user already has direct access to the node.
   *   - When changing `key` prop of `Transition` in a `TransitionGroup` a new
   *     `nodeRef` need to be provided to `Transition` with changed `key` prop
   *     (see
   *     [test/CSSTransition-test.js](https://github.com/reactjs/react-transition-group/blob/13435f897b3ab71f6e19d724f145596f5910581c/test/CSSTransition-test.js#L362-L437)).
   */
  nodeRef: PropTypes.shape({
    current: typeof Element === "undefined" ? PropTypes.any : function(propValue, key, componentName, location, propFullName, secret) {
      var value = propValue[key];
      return PropTypes.instanceOf(value && "ownerDocument" in value ? value.ownerDocument.defaultView.Element : Element)(propValue, key, componentName, location, propFullName, secret);
    }
  }),
  /**
   * A `function` child can be used instead of a React element. This function is
   * called with the current transition status (`'entering'`, `'entered'`,
   * `'exiting'`, `'exited'`), which can be used to apply context
   * specific props to a component.
   *
   * ```jsx
   * <Transition in={this.state.in} timeout={150}>
   *   {state => (
   *     <MyComponent className={`fade fade-${state}`} />
   *   )}
   * </Transition>
   * ```
   */
  children: PropTypes.oneOfType([PropTypes.func.isRequired, PropTypes.element.isRequired]).isRequired,
  /**
   * Show the component; triggers the enter or exit states
   */
  in: PropTypes.bool,
  /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */
  mountOnEnter: PropTypes.bool,
  /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */
  unmountOnExit: PropTypes.bool,
  /**
   * By default the child component does not perform the enter transition when
   * it first mounts, regardless of the value of `in`. If you want this
   * behavior, set both `appear` and `in` to `true`.
   *
   * > **Note**: there are no special appear states like `appearing`/`appeared`, this prop
   * > only adds an additional enter transition. However, in the
   * > `<CSSTransition>` component that first enter transition does result in
   * > additional `.appear-*` classes, that way you can choose to style it
   * > differently.
   */
  appear: PropTypes.bool,
  /**
   * Enable or disable enter transitions.
   */
  enter: PropTypes.bool,
  /**
   * Enable or disable exit transitions.
   */
  exit: PropTypes.bool,
  /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEndListener` is provided.
   *
   * You may specify a single timeout for all transitions:
   *
   * ```jsx
   * timeout={500}
   * ```
   *
   * or individually:
   *
   * ```jsx
   * timeout={{
   *  appear: 500,
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * - `appear` defaults to the value of `enter`
   * - `enter` defaults to `0`
   * - `exit` defaults to `0`
   *
   * @type {number | { enter?: number, exit?: number, appear?: number }}
   */
  timeout: function timeout(props) {
    var pt = timeoutsShape;
    if (!props.addEndListener) pt = pt.isRequired;
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }
    return pt.apply(void 0, [props].concat(args));
  },
  /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. Timeouts are still used as a fallback if provided.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */
  addEndListener: PropTypes.func,
  /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEnter: PropTypes.func,
  /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,
  /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEntered: PropTypes.func,
  /**
   * Callback fired before the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExit: PropTypes.func,
  /**
   * Callback fired after the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExiting: PropTypes.func,
  /**
   * Callback fired after the "exited" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExited: PropTypes.func
} : {};
function noop$5() {
}
Transition.defaultProps = {
  in: false,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  enter: true,
  exit: true,
  onEnter: noop$5,
  onEntering: noop$5,
  onEntered: noop$5,
  onExit: noop$5,
  onExiting: noop$5,
  onExited: noop$5
};
Transition.UNMOUNTED = UNMOUNTED;
Transition.EXITED = EXITED;
Transition.ENTERING = ENTERING;
Transition.ENTERED = ENTERED;
Transition.EXITING = EXITING;
var _addClass = function addClass$1(node2, classes) {
  return node2 && classes && classes.split(" ").forEach(function(c2) {
    return addClass(node2, c2);
  });
};
var removeClass = function removeClass2(node2, classes) {
  return node2 && classes && classes.split(" ").forEach(function(c2) {
    return removeClass$1(node2, c2);
  });
};
var CSSTransition = /* @__PURE__ */ function(_React$Component) {
  _inheritsLoose(CSSTransition2, _React$Component);
  function CSSTransition2() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.appliedClasses = {
      appear: {},
      enter: {},
      exit: {}
    };
    _this.onEnter = function(maybeNode, maybeAppearing) {
      var _this$resolveArgument = _this.resolveArguments(maybeNode, maybeAppearing), node2 = _this$resolveArgument[0], appearing = _this$resolveArgument[1];
      _this.removeClasses(node2, "exit");
      _this.addClass(node2, appearing ? "appear" : "enter", "base");
      if (_this.props.onEnter) {
        _this.props.onEnter(maybeNode, maybeAppearing);
      }
    };
    _this.onEntering = function(maybeNode, maybeAppearing) {
      var _this$resolveArgument2 = _this.resolveArguments(maybeNode, maybeAppearing), node2 = _this$resolveArgument2[0], appearing = _this$resolveArgument2[1];
      var type2 = appearing ? "appear" : "enter";
      _this.addClass(node2, type2, "active");
      if (_this.props.onEntering) {
        _this.props.onEntering(maybeNode, maybeAppearing);
      }
    };
    _this.onEntered = function(maybeNode, maybeAppearing) {
      var _this$resolveArgument3 = _this.resolveArguments(maybeNode, maybeAppearing), node2 = _this$resolveArgument3[0], appearing = _this$resolveArgument3[1];
      var type2 = appearing ? "appear" : "enter";
      _this.removeClasses(node2, type2);
      _this.addClass(node2, type2, "done");
      if (_this.props.onEntered) {
        _this.props.onEntered(maybeNode, maybeAppearing);
      }
    };
    _this.onExit = function(maybeNode) {
      var _this$resolveArgument4 = _this.resolveArguments(maybeNode), node2 = _this$resolveArgument4[0];
      _this.removeClasses(node2, "appear");
      _this.removeClasses(node2, "enter");
      _this.addClass(node2, "exit", "base");
      if (_this.props.onExit) {
        _this.props.onExit(maybeNode);
      }
    };
    _this.onExiting = function(maybeNode) {
      var _this$resolveArgument5 = _this.resolveArguments(maybeNode), node2 = _this$resolveArgument5[0];
      _this.addClass(node2, "exit", "active");
      if (_this.props.onExiting) {
        _this.props.onExiting(maybeNode);
      }
    };
    _this.onExited = function(maybeNode) {
      var _this$resolveArgument6 = _this.resolveArguments(maybeNode), node2 = _this$resolveArgument6[0];
      _this.removeClasses(node2, "exit");
      _this.addClass(node2, "exit", "done");
      if (_this.props.onExited) {
        _this.props.onExited(maybeNode);
      }
    };
    _this.resolveArguments = function(maybeNode, maybeAppearing) {
      return _this.props.nodeRef ? [_this.props.nodeRef.current, maybeNode] : [maybeNode, maybeAppearing];
    };
    _this.getClassNames = function(type2) {
      var classNames2 = _this.props.classNames;
      var isStringClassNames = typeof classNames2 === "string";
      var prefix2 = isStringClassNames && classNames2 ? classNames2 + "-" : "";
      var baseClassName = isStringClassNames ? "" + prefix2 + type2 : classNames2[type2];
      var activeClassName = isStringClassNames ? baseClassName + "-active" : classNames2[type2 + "Active"];
      var doneClassName = isStringClassNames ? baseClassName + "-done" : classNames2[type2 + "Done"];
      return {
        baseClassName,
        activeClassName,
        doneClassName
      };
    };
    return _this;
  }
  var _proto = CSSTransition2.prototype;
  _proto.addClass = function addClass2(node2, type2, phase) {
    var className = this.getClassNames(type2)[phase + "ClassName"];
    var _this$getClassNames = this.getClassNames("enter"), doneClassName = _this$getClassNames.doneClassName;
    if (type2 === "appear" && phase === "done" && doneClassName) {
      className += " " + doneClassName;
    }
    if (phase === "active") {
      if (node2) forceReflow(node2);
    }
    if (className) {
      this.appliedClasses[type2][phase] = className;
      _addClass(node2, className);
    }
  };
  _proto.removeClasses = function removeClasses(node2, type2) {
    var _this$appliedClasses$ = this.appliedClasses[type2], baseClassName = _this$appliedClasses$.base, activeClassName = _this$appliedClasses$.active, doneClassName = _this$appliedClasses$.done;
    this.appliedClasses[type2] = {};
    if (baseClassName) {
      removeClass(node2, baseClassName);
    }
    if (activeClassName) {
      removeClass(node2, activeClassName);
    }
    if (doneClassName) {
      removeClass(node2, doneClassName);
    }
  };
  _proto.render = function render() {
    var _this$props = this.props;
    _this$props.classNames;
    var props = _objectWithoutPropertiesLoose$4(_this$props, ["classNames"]);
    return /* @__PURE__ */ React__default.createElement(Transition, _extends$4({}, props, {
      onEnter: this.onEnter,
      onEntered: this.onEntered,
      onEntering: this.onEntering,
      onExit: this.onExit,
      onExiting: this.onExiting,
      onExited: this.onExited
    }));
  };
  return CSSTransition2;
}(React__default.Component);
CSSTransition.defaultProps = {
  classNames: ""
};
CSSTransition.propTypes = process.env.NODE_ENV !== "production" ? _extends$4({}, Transition.propTypes, {
  /**
   * The animation classNames applied to the component as it appears, enters,
   * exits or has finished the transition. A single name can be provided, which
   * will be suffixed for each stage, e.g. `classNames="fade"` applies:
   *
   * - `fade-appear`, `fade-appear-active`, `fade-appear-done`
   * - `fade-enter`, `fade-enter-active`, `fade-enter-done`
   * - `fade-exit`, `fade-exit-active`, `fade-exit-done`
   *
   * A few details to note about how these classes are applied:
   *
   * 1. They are _joined_ with the ones that are already defined on the child
   *    component, so if you want to add some base styles, you can use
   *    `className` without worrying that it will be overridden.
   *
   * 2. If the transition component mounts with `in={false}`, no classes are
   *    applied yet. You might be expecting `*-exit-done`, but if you think
   *    about it, a component cannot finish exiting if it hasn't entered yet.
   *
   * 2. `fade-appear-done` and `fade-enter-done` will _both_ be applied. This
   *    allows you to define different behavior for when appearing is done and
   *    when regular entering is done, using selectors like
   *    `.fade-enter-done:not(.fade-appear-done)`. For example, you could apply
   *    an epic entrance animation when element first appears in the DOM using
   *    [Animate.css](https://daneden.github.io/animate.css/). Otherwise you can
   *    simply use `fade-enter-done` for defining both cases.
   *
   * Each individual classNames can also be specified independently like:
   *
   * ```js
   * classNames={{
   *  appear: 'my-appear',
   *  appearActive: 'my-active-appear',
   *  appearDone: 'my-done-appear',
   *  enter: 'my-enter',
   *  enterActive: 'my-active-enter',
   *  enterDone: 'my-done-enter',
   *  exit: 'my-exit',
   *  exitActive: 'my-active-exit',
   *  exitDone: 'my-done-exit',
   * }}
   * ```
   *
   * If you want to set these classes using CSS Modules:
   *
   * ```js
   * import styles from './styles.css';
   * ```
   *
   * you might want to use camelCase in your CSS file, that way could simply
   * spread them instead of listing them one by one:
   *
   * ```js
   * classNames={{ ...styles }}
   * ```
   *
   * @type {string | {
   *  appear?: string,
   *  appearActive?: string,
   *  appearDone?: string,
   *  enter?: string,
   *  enterActive?: string,
   *  enterDone?: string,
   *  exit?: string,
   *  exitActive?: string,
   *  exitDone?: string,
   * }}
   */
  classNames: classNamesShape,
  /**
   * A `<Transition>` callback fired immediately after the 'enter' or 'appear' class is
   * applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEnter: PropTypes.func,
  /**
   * A `<Transition>` callback fired immediately after the 'enter-active' or
   * 'appear-active' class is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,
  /**
   * A `<Transition>` callback fired immediately after the 'enter' or
   * 'appear' classes are **removed** and the `done` class is added to the DOM node.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntered: PropTypes.func,
  /**
   * A `<Transition>` callback fired immediately after the 'exit' class is
   * applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement)
   */
  onExit: PropTypes.func,
  /**
   * A `<Transition>` callback fired immediately after the 'exit-active' is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement)
   */
  onExiting: PropTypes.func,
  /**
   * A `<Transition>` callback fired immediately after the 'exit' classes
   * are **removed** and the `exit-done` class is added to the DOM node.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement)
   */
  onExited: PropTypes.func
}) : {};
function getChildMapping(children, mapFn) {
  var mapper = function mapper2(child) {
    return mapFn && isValidElement(child) ? mapFn(child) : child;
  };
  var result = /* @__PURE__ */ Object.create(null);
  if (children) Children.map(children, function(c2) {
    return c2;
  }).forEach(function(child) {
    result[child.key] = mapper(child);
  });
  return result;
}
function mergeChildMappings(prev2, next2) {
  prev2 = prev2 || {};
  next2 = next2 || {};
  function getValueForKey(key) {
    return key in next2 ? next2[key] : prev2[key];
  }
  var nextKeysPending = /* @__PURE__ */ Object.create(null);
  var pendingKeys = [];
  for (var prevKey in prev2) {
    if (prevKey in next2) {
      if (pendingKeys.length) {
        nextKeysPending[prevKey] = pendingKeys;
        pendingKeys = [];
      }
    } else {
      pendingKeys.push(prevKey);
    }
  }
  var i;
  var childMapping = {};
  for (var nextKey in next2) {
    if (nextKeysPending[nextKey]) {
      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
        var pendingNextKey = nextKeysPending[nextKey][i];
        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
      }
    }
    childMapping[nextKey] = getValueForKey(nextKey);
  }
  for (i = 0; i < pendingKeys.length; i++) {
    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
  }
  return childMapping;
}
function getProp(child, prop, props) {
  return props[prop] != null ? props[prop] : child.props[prop];
}
function getInitialChildMapping(props, onExited) {
  return getChildMapping(props.children, function(child) {
    return cloneElement(child, {
      onExited: onExited.bind(null, child),
      in: true,
      appear: getProp(child, "appear", props),
      enter: getProp(child, "enter", props),
      exit: getProp(child, "exit", props)
    });
  });
}
function getNextChildMapping(nextProps, prevChildMapping, onExited) {
  var nextChildMapping = getChildMapping(nextProps.children);
  var children = mergeChildMappings(prevChildMapping, nextChildMapping);
  Object.keys(children).forEach(function(key) {
    var child = children[key];
    if (!isValidElement(child)) return;
    var hasPrev = key in prevChildMapping;
    var hasNext = key in nextChildMapping;
    var prevChild = prevChildMapping[key];
    var isLeaving = isValidElement(prevChild) && !prevChild.props.in;
    if (hasNext && (!hasPrev || isLeaving)) {
      children[key] = cloneElement(child, {
        onExited: onExited.bind(null, child),
        in: true,
        exit: getProp(child, "exit", nextProps),
        enter: getProp(child, "enter", nextProps)
      });
    } else if (!hasNext && hasPrev && !isLeaving) {
      children[key] = cloneElement(child, {
        in: false
      });
    } else if (hasNext && hasPrev && isValidElement(prevChild)) {
      children[key] = cloneElement(child, {
        onExited: onExited.bind(null, child),
        in: prevChild.props.in,
        exit: getProp(child, "exit", nextProps),
        enter: getProp(child, "enter", nextProps)
      });
    }
  });
  return children;
}
var values = Object.values || function(obj) {
  return Object.keys(obj).map(function(k2) {
    return obj[k2];
  });
};
var defaultProps$2 = {
  component: "div",
  childFactory: function childFactory(child) {
    return child;
  }
};
var TransitionGroup = /* @__PURE__ */ function(_React$Component) {
  _inheritsLoose(TransitionGroup2, _React$Component);
  function TransitionGroup2(props, context) {
    var _this;
    _this = _React$Component.call(this, props, context) || this;
    var handleExited = _this.handleExited.bind(_assertThisInitialized$2(_this));
    _this.state = {
      contextValue: {
        isMounting: true
      },
      handleExited,
      firstRender: true
    };
    return _this;
  }
  var _proto = TransitionGroup2.prototype;
  _proto.componentDidMount = function componentDidMount() {
    this.mounted = true;
    this.setState({
      contextValue: {
        isMounting: false
      }
    });
  };
  _proto.componentWillUnmount = function componentWillUnmount() {
    this.mounted = false;
  };
  TransitionGroup2.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref3) {
    var prevChildMapping = _ref3.children, handleExited = _ref3.handleExited, firstRender = _ref3.firstRender;
    return {
      children: firstRender ? getInitialChildMapping(nextProps, handleExited) : getNextChildMapping(nextProps, prevChildMapping, handleExited),
      firstRender: false
    };
  };
  _proto.handleExited = function handleExited(child, node2) {
    var currentChildMapping = getChildMapping(this.props.children);
    if (child.key in currentChildMapping) return;
    if (child.props.onExited) {
      child.props.onExited(node2);
    }
    if (this.mounted) {
      this.setState(function(state) {
        var children = _extends$4({}, state.children);
        delete children[child.key];
        return {
          children
        };
      });
    }
  };
  _proto.render = function render() {
    var _this$props = this.props, Component2 = _this$props.component, childFactory2 = _this$props.childFactory, props = _objectWithoutPropertiesLoose$4(_this$props, ["component", "childFactory"]);
    var contextValue = this.state.contextValue;
    var children = values(this.state.children).map(childFactory2);
    delete props.appear;
    delete props.enter;
    delete props.exit;
    if (Component2 === null) {
      return /* @__PURE__ */ React__default.createElement(TransitionGroupContext.Provider, {
        value: contextValue
      }, children);
    }
    return /* @__PURE__ */ React__default.createElement(TransitionGroupContext.Provider, {
      value: contextValue
    }, /* @__PURE__ */ React__default.createElement(Component2, props, children));
  };
  return TransitionGroup2;
}(React__default.Component);
TransitionGroup.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * `<TransitionGroup>` renders a `<div>` by default. You can change this
   * behavior by providing a `component` prop.
   * If you use React v16+ and would like to avoid a wrapping `<div>` element
   * you can pass in `component={null}`. This is useful if the wrapping div
   * borks your css styles.
   */
  component: PropTypes.any,
  /**
   * A set of `<Transition>` components, that are toggled `in` and out as they
   * leave. the `<TransitionGroup>` will inject specific transition props, so
   * remember to spread them through if you are wrapping the `<Transition>` as
   * with our `<Fade>` example.
   *
   * While this component is meant for multiple `Transition` or `CSSTransition`
   * children, sometimes you may want to have a single transition child with
   * content that you want to be transitioned out and in when you change it
   * (e.g. routes, images etc.) In that case you can change the `key` prop of
   * the transition child as you change its content, this will cause
   * `TransitionGroup` to transition the child out and back in.
   */
  children: PropTypes.node,
  /**
   * A convenience prop that enables or disables appear animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  appear: PropTypes.bool,
  /**
   * A convenience prop that enables or disables enter animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  enter: PropTypes.bool,
  /**
   * A convenience prop that enables or disables exit animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  exit: PropTypes.bool,
  /**
   * You may need to apply reactive updates to a child as it is exiting.
   * This is generally done by using `cloneElement` however in the case of an exiting
   * child the element has already been removed and not accessible to the consumer.
   *
   * If you do need to update a child as it leaves you can provide a `childFactory`
   * to wrap every child, even the ones that are leaving.
   *
   * @type Function(child: ReactElement) -> ReactElement
   */
  childFactory: PropTypes.func
} : {};
TransitionGroup.defaultProps = defaultProps$2;
var MapShim = function() {
  if (typeof Map !== "undefined") {
    return Map;
  }
  function getIndex(arr, key) {
    var result = -1;
    arr.some(function(entry, index2) {
      if (entry[0] === key) {
        result = index2;
        return true;
      }
      return false;
    });
    return result;
  }
  return (
    /** @class */
    function() {
      function class_1() {
        this.__entries__ = [];
      }
      Object.defineProperty(class_1.prototype, "size", {
        /**
         * @returns {boolean}
         */
        get: function() {
          return this.__entries__.length;
        },
        enumerable: true,
        configurable: true
      });
      class_1.prototype.get = function(key) {
        var index2 = getIndex(this.__entries__, key);
        var entry = this.__entries__[index2];
        return entry && entry[1];
      };
      class_1.prototype.set = function(key, value) {
        var index2 = getIndex(this.__entries__, key);
        if (~index2) {
          this.__entries__[index2][1] = value;
        } else {
          this.__entries__.push([key, value]);
        }
      };
      class_1.prototype.delete = function(key) {
        var entries = this.__entries__;
        var index2 = getIndex(entries, key);
        if (~index2) {
          entries.splice(index2, 1);
        }
      };
      class_1.prototype.has = function(key) {
        return !!~getIndex(this.__entries__, key);
      };
      class_1.prototype.clear = function() {
        this.__entries__.splice(0);
      };
      class_1.prototype.forEach = function(callback, ctx) {
        if (ctx === void 0) {
          ctx = null;
        }
        for (var _i = 0, _a2 = this.__entries__; _i < _a2.length; _i++) {
          var entry = _a2[_i];
          callback.call(ctx, entry[1], entry[0]);
        }
      };
      return class_1;
    }()
  );
}();
var isBrowser$1 = typeof window !== "undefined" && typeof document !== "undefined" && window.document === document;
var global$1 = function() {
  if (typeof global !== "undefined" && global.Math === Math) {
    return global;
  }
  if (typeof self !== "undefined" && self.Math === Math) {
    return self;
  }
  if (typeof window !== "undefined" && window.Math === Math) {
    return window;
  }
  return Function("return this")();
}();
var requestAnimationFrame$1 = function() {
  if (typeof requestAnimationFrame === "function") {
    return requestAnimationFrame.bind(global$1);
  }
  return function(callback) {
    return setTimeout(function() {
      return callback(Date.now());
    }, 1e3 / 60);
  };
}();
var trailingTimeout = 2;
function throttle(callback, delay) {
  var leadingCall = false, trailingCall = false, lastCallTime = 0;
  function resolvePending() {
    if (leadingCall) {
      leadingCall = false;
      callback();
    }
    if (trailingCall) {
      proxy();
    }
  }
  function timeoutCallback() {
    requestAnimationFrame$1(resolvePending);
  }
  function proxy() {
    var timeStamp = Date.now();
    if (leadingCall) {
      if (timeStamp - lastCallTime < trailingTimeout) {
        return;
      }
      trailingCall = true;
    } else {
      leadingCall = true;
      trailingCall = false;
      setTimeout(timeoutCallback, delay);
    }
    lastCallTime = timeStamp;
  }
  return proxy;
}
var REFRESH_DELAY = 20;
var transitionKeys = ["top", "right", "bottom", "left", "width", "height", "size", "weight"];
var mutationObserverSupported = typeof MutationObserver !== "undefined";
var ResizeObserverController = (
  /** @class */
  function() {
    function ResizeObserverController2() {
      this.connected_ = false;
      this.mutationEventsAdded_ = false;
      this.mutationsObserver_ = null;
      this.observers_ = [];
      this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
      this.refresh = throttle(this.refresh.bind(this), REFRESH_DELAY);
    }
    ResizeObserverController2.prototype.addObserver = function(observer) {
      if (!~this.observers_.indexOf(observer)) {
        this.observers_.push(observer);
      }
      if (!this.connected_) {
        this.connect_();
      }
    };
    ResizeObserverController2.prototype.removeObserver = function(observer) {
      var observers2 = this.observers_;
      var index2 = observers2.indexOf(observer);
      if (~index2) {
        observers2.splice(index2, 1);
      }
      if (!observers2.length && this.connected_) {
        this.disconnect_();
      }
    };
    ResizeObserverController2.prototype.refresh = function() {
      var changesDetected = this.updateObservers_();
      if (changesDetected) {
        this.refresh();
      }
    };
    ResizeObserverController2.prototype.updateObservers_ = function() {
      var activeObservers = this.observers_.filter(function(observer) {
        return observer.gatherActive(), observer.hasActive();
      });
      activeObservers.forEach(function(observer) {
        return observer.broadcastActive();
      });
      return activeObservers.length > 0;
    };
    ResizeObserverController2.prototype.connect_ = function() {
      if (!isBrowser$1 || this.connected_) {
        return;
      }
      document.addEventListener("transitionend", this.onTransitionEnd_);
      window.addEventListener("resize", this.refresh);
      if (mutationObserverSupported) {
        this.mutationsObserver_ = new MutationObserver(this.refresh);
        this.mutationsObserver_.observe(document, {
          attributes: true,
          childList: true,
          characterData: true,
          subtree: true
        });
      } else {
        document.addEventListener("DOMSubtreeModified", this.refresh);
        this.mutationEventsAdded_ = true;
      }
      this.connected_ = true;
    };
    ResizeObserverController2.prototype.disconnect_ = function() {
      if (!isBrowser$1 || !this.connected_) {
        return;
      }
      document.removeEventListener("transitionend", this.onTransitionEnd_);
      window.removeEventListener("resize", this.refresh);
      if (this.mutationsObserver_) {
        this.mutationsObserver_.disconnect();
      }
      if (this.mutationEventsAdded_) {
        document.removeEventListener("DOMSubtreeModified", this.refresh);
      }
      this.mutationsObserver_ = null;
      this.mutationEventsAdded_ = false;
      this.connected_ = false;
    };
    ResizeObserverController2.prototype.onTransitionEnd_ = function(_a2) {
      var _b = _a2.propertyName, propertyName = _b === void 0 ? "" : _b;
      var isReflowProperty = transitionKeys.some(function(key) {
        return !!~propertyName.indexOf(key);
      });
      if (isReflowProperty) {
        this.refresh();
      }
    };
    ResizeObserverController2.getInstance = function() {
      if (!this.instance_) {
        this.instance_ = new ResizeObserverController2();
      }
      return this.instance_;
    };
    ResizeObserverController2.instance_ = null;
    return ResizeObserverController2;
  }()
);
var defineConfigurable = function(target, props) {
  for (var _i = 0, _a2 = Object.keys(props); _i < _a2.length; _i++) {
    var key = _a2[_i];
    Object.defineProperty(target, key, {
      value: props[key],
      enumerable: false,
      writable: false,
      configurable: true
    });
  }
  return target;
};
var getWindowOf = function(target) {
  var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;
  return ownerGlobal || global$1;
};
var emptyRect = createRectInit(0, 0, 0, 0);
function toFloat(value) {
  return parseFloat(value) || 0;
}
function getBordersSize(styles) {
  var positions = [];
  for (var _i = 1; _i < arguments.length; _i++) {
    positions[_i - 1] = arguments[_i];
  }
  return positions.reduce(function(size2, position2) {
    var value = styles["border-" + position2 + "-width"];
    return size2 + toFloat(value);
  }, 0);
}
function getPaddings(styles) {
  var positions = ["top", "right", "bottom", "left"];
  var paddings = {};
  for (var _i = 0, positions_1 = positions; _i < positions_1.length; _i++) {
    var position2 = positions_1[_i];
    var value = styles["padding-" + position2];
    paddings[position2] = toFloat(value);
  }
  return paddings;
}
function getSVGContentRect(target) {
  var bbox = target.getBBox();
  return createRectInit(0, 0, bbox.width, bbox.height);
}
function getHTMLElementContentRect(target) {
  var clientWidth = target.clientWidth, clientHeight = target.clientHeight;
  if (!clientWidth && !clientHeight) {
    return emptyRect;
  }
  var styles = getWindowOf(target).getComputedStyle(target);
  var paddings = getPaddings(styles);
  var horizPad = paddings.left + paddings.right;
  var vertPad = paddings.top + paddings.bottom;
  var width2 = toFloat(styles.width), height2 = toFloat(styles.height);
  if (styles.boxSizing === "border-box") {
    if (Math.round(width2 + horizPad) !== clientWidth) {
      width2 -= getBordersSize(styles, "left", "right") + horizPad;
    }
    if (Math.round(height2 + vertPad) !== clientHeight) {
      height2 -= getBordersSize(styles, "top", "bottom") + vertPad;
    }
  }
  if (!isDocumentElement$1(target)) {
    var vertScrollbar = Math.round(width2 + horizPad) - clientWidth;
    var horizScrollbar = Math.round(height2 + vertPad) - clientHeight;
    if (Math.abs(vertScrollbar) !== 1) {
      width2 -= vertScrollbar;
    }
    if (Math.abs(horizScrollbar) !== 1) {
      height2 -= horizScrollbar;
    }
  }
  return createRectInit(paddings.left, paddings.top, width2, height2);
}
var isSVGGraphicsElement = function() {
  if (typeof SVGGraphicsElement !== "undefined") {
    return function(target) {
      return target instanceof getWindowOf(target).SVGGraphicsElement;
    };
  }
  return function(target) {
    return target instanceof getWindowOf(target).SVGElement && typeof target.getBBox === "function";
  };
}();
function isDocumentElement$1(target) {
  return target === getWindowOf(target).document.documentElement;
}
function getContentRect(target) {
  if (!isBrowser$1) {
    return emptyRect;
  }
  if (isSVGGraphicsElement(target)) {
    return getSVGContentRect(target);
  }
  return getHTMLElementContentRect(target);
}
function createReadOnlyRect(_a2) {
  var x2 = _a2.x, y2 = _a2.y, width2 = _a2.width, height2 = _a2.height;
  var Constr = typeof DOMRectReadOnly !== "undefined" ? DOMRectReadOnly : Object;
  var rect = Object.create(Constr.prototype);
  defineConfigurable(rect, {
    x: x2,
    y: y2,
    width: width2,
    height: height2,
    top: y2,
    right: x2 + width2,
    bottom: height2 + y2,
    left: x2
  });
  return rect;
}
function createRectInit(x2, y2, width2, height2) {
  return { x: x2, y: y2, width: width2, height: height2 };
}
var ResizeObservation = (
  /** @class */
  function() {
    function ResizeObservation2(target) {
      this.broadcastWidth = 0;
      this.broadcastHeight = 0;
      this.contentRect_ = createRectInit(0, 0, 0, 0);
      this.target = target;
    }
    ResizeObservation2.prototype.isActive = function() {
      var rect = getContentRect(this.target);
      this.contentRect_ = rect;
      return rect.width !== this.broadcastWidth || rect.height !== this.broadcastHeight;
    };
    ResizeObservation2.prototype.broadcastRect = function() {
      var rect = this.contentRect_;
      this.broadcastWidth = rect.width;
      this.broadcastHeight = rect.height;
      return rect;
    };
    return ResizeObservation2;
  }()
);
var ResizeObserverEntry = (
  /** @class */
  /* @__PURE__ */ function() {
    function ResizeObserverEntry2(target, rectInit) {
      var contentRect = createReadOnlyRect(rectInit);
      defineConfigurable(this, { target, contentRect });
    }
    return ResizeObserverEntry2;
  }()
);
var ResizeObserverSPI = (
  /** @class */
  function() {
    function ResizeObserverSPI2(callback, controller, callbackCtx) {
      this.activeObservations_ = [];
      this.observations_ = new MapShim();
      if (typeof callback !== "function") {
        throw new TypeError("The callback provided as parameter 1 is not a function.");
      }
      this.callback_ = callback;
      this.controller_ = controller;
      this.callbackCtx_ = callbackCtx;
    }
    ResizeObserverSPI2.prototype.observe = function(target) {
      if (!arguments.length) {
        throw new TypeError("1 argument required, but only 0 present.");
      }
      if (typeof Element === "undefined" || !(Element instanceof Object)) {
        return;
      }
      if (!(target instanceof getWindowOf(target).Element)) {
        throw new TypeError('parameter 1 is not of type "Element".');
      }
      var observations = this.observations_;
      if (observations.has(target)) {
        return;
      }
      observations.set(target, new ResizeObservation(target));
      this.controller_.addObserver(this);
      this.controller_.refresh();
    };
    ResizeObserverSPI2.prototype.unobserve = function(target) {
      if (!arguments.length) {
        throw new TypeError("1 argument required, but only 0 present.");
      }
      if (typeof Element === "undefined" || !(Element instanceof Object)) {
        return;
      }
      if (!(target instanceof getWindowOf(target).Element)) {
        throw new TypeError('parameter 1 is not of type "Element".');
      }
      var observations = this.observations_;
      if (!observations.has(target)) {
        return;
      }
      observations.delete(target);
      if (!observations.size) {
        this.controller_.removeObserver(this);
      }
    };
    ResizeObserverSPI2.prototype.disconnect = function() {
      this.clearActive();
      this.observations_.clear();
      this.controller_.removeObserver(this);
    };
    ResizeObserverSPI2.prototype.gatherActive = function() {
      var _this = this;
      this.clearActive();
      this.observations_.forEach(function(observation) {
        if (observation.isActive()) {
          _this.activeObservations_.push(observation);
        }
      });
    };
    ResizeObserverSPI2.prototype.broadcastActive = function() {
      if (!this.hasActive()) {
        return;
      }
      var ctx = this.callbackCtx_;
      var entries = this.activeObservations_.map(function(observation) {
        return new ResizeObserverEntry(observation.target, observation.broadcastRect());
      });
      this.callback_.call(ctx, entries, ctx);
      this.clearActive();
    };
    ResizeObserverSPI2.prototype.clearActive = function() {
      this.activeObservations_.splice(0);
    };
    ResizeObserverSPI2.prototype.hasActive = function() {
      return this.activeObservations_.length > 0;
    };
    return ResizeObserverSPI2;
  }()
);
var observers = typeof WeakMap !== "undefined" ? /* @__PURE__ */ new WeakMap() : new MapShim();
var ResizeObserver$1 = (
  /** @class */
  /* @__PURE__ */ function() {
    function ResizeObserver2(callback) {
      if (!(this instanceof ResizeObserver2)) {
        throw new TypeError("Cannot call a class as a function.");
      }
      if (!arguments.length) {
        throw new TypeError("1 argument required, but only 0 present.");
      }
      var controller = ResizeObserverController.getInstance();
      var observer = new ResizeObserverSPI(callback, controller, this);
      observers.set(this, observer);
    }
    return ResizeObserver2;
  }()
);
[
  "observe",
  "unobserve",
  "disconnect"
].forEach(function(method) {
  ResizeObserver$1.prototype[method] = function() {
    var _a2;
    return (_a2 = observers.get(this))[method].apply(_a2, arguments);
  };
});
var index$3 = function() {
  if (typeof global$1.ResizeObserver !== "undefined") {
    return global$1.ResizeObserver;
  }
  return ResizeObserver$1;
}();
function useCollapsibleHeight({
  observeHeight = true
} = {}) {
  const [ref2, setRef] = useState();
  const [height2, setHeight] = useState(0);
  const heightRef = useRef(height2);
  const observerRef = useRef();
  const callbackRef = useCallback((element) => {
    if (element !== null) setRef(element);
  }, []);
  useEffect(() => {
    if (ref2 && observeHeight) {
      observerRef.current = new index$3(() => {
        if (ref2 && heightRef.current !== ref2.offsetHeight) {
          heightRef.current = ref2.offsetHeight;
          setHeight(heightRef.current);
        }
      });
      observerRef.current.observe(ref2);
    }
    return () => {
      var _a2;
      if (!ref2) return;
      (_a2 = observerRef.current) == null ? void 0 : _a2.unobserve(ref2);
    };
  }, [ref2]);
  return [callbackRef, height2];
}
const applyRef = (ref2, el) => {
  if (el) ref2.current = el;
};
const getTransitionStyles = (height2) => ({
  entering: {
    height: `${height2}px`
  },
  entered: {
    height: `${height2}px`
  },
  exiting: {
    height: 0
  },
  exited: {
    height: 0
  }
});
const AccordionBody = forwardRef((props, ref2) => {
  const {
    children,
    ...rest
  } = props;
  const bodyTargetRef = useRef(null);
  const [bodyRef, height2] = useCollapsibleHeight();
  const {
    animated = true,
    unmountOnExit
  } = useAccordionContext();
  const {
    open,
    triggerId,
    regionId
  } = useAccordionItemContext();
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Transition, { in: open, timeout: 300, nodeRef: bodyTargetRef, unmountOnExit, children: (state) => {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(AccordionItemBody, { ref: ref2, style: {
      ...getTransitionStyles(height2)[state],
      ...animated ? {
        transition: "height 300ms ease-in-out"
      } : {}
    }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(AccordionItemRegion, { id: regionId, role: "region", "aria-labelledby": triggerId, ref: (el) => {
      applyRef(bodyTargetRef, el);
      bodyRef(el);
    }, ...rest, children }) });
  } });
});
const [AccordionProvider, useAccordionContext] = createContext({
  name: "AccordionContext",
  hookName: "useAccordionContext",
  providerName: "<AccordionProvider/>"
});
const AccordionRoot = forwardRef((props, ref2) => {
  const {
    children,
    className,
    multiple = true,
    defaultOpenItems,
    ...rest
  } = props;
  const [openedItems, setOpenedItems] = useState(defaultOpenItems || []);
  const toggleItem = useCallback((key) => {
    setOpenedItems((old) => {
      if (multiple) {
        return old.includes(key) ? old.filter((item) => item !== key) : [...old, key];
      }
      return old.includes(key) ? [] : [key];
    });
  }, [multiple]);
  const accordionContextValue = useMemo(() => ({
    ...rest,
    multiple,
    openedItems,
    toggleItem
  }), [openedItems, toggleItem]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(AccordionProvider, { value: accordionContextValue, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Accordion$1, { className, ref: ref2, ...rest, children }) });
});
const Root$2 = AccordionRoot;
const Item = AccordionItem;
const Trigger$1 = AccordionTrigger;
const Body$1 = AccordionBody;
Root$2.displayName = "Accordion.Root";
Item.displayName = "Accordion.Item";
Trigger$1.displayName = "Accordion.Trigger";
Body$1.displayName = "Accordion.Body";
const Accordion = {
  Root: Root$2,
  Trigger: Trigger$1,
  Item,
  Body: Body$1
};
const avatarColors = [{
  backgroundColor: `var(${TOKENS.color.background.series.data01})`,
  color: `var(${TOKENS.color.foreground.series.onData01})`
}, {
  backgroundColor: `var(${TOKENS.color.background.series.data02})`,
  color: `var(${TOKENS.color.foreground.series.onData02})`
}, {
  backgroundColor: `var(${TOKENS.color.background.series.data03})`,
  color: `var(${TOKENS.color.foreground.series.onData03})`
}, {
  backgroundColor: `var(${TOKENS.color.background.series.data04})`,
  color: `var(${TOKENS.color.foreground.series.onData04})`
}, {
  backgroundColor: `var(${TOKENS.color.background.series.data05})`,
  color: `var(${TOKENS.color.foreground.series.onData05})`
}, {
  backgroundColor: `var(${TOKENS.color.background.series.data06})`,
  color: `var(${TOKENS.color.foreground.series.onData06})`
}, {
  backgroundColor: `var(${TOKENS.color.background.series.data07})`,
  color: `var(${TOKENS.color.foreground.series.onData07})`
}, {
  backgroundColor: `var(${TOKENS.color.background.series.data08})`,
  color: `var(${TOKENS.color.foreground.series.onData08})`
}, {
  backgroundColor: `var(${TOKENS.color.background.series.data09})`,
  color: `var(${TOKENS.color.foreground.series.onData09})`
}, {
  backgroundColor: `var(${TOKENS.color.background.series.data10})`,
  color: `var(${TOKENS.color.foreground.series.onData10})`
}, {
  backgroundColor: `var(${TOKENS.color.background.series.data11})`,
  color: `var(${TOKENS.color.foreground.series.onData11})`
}, {
  backgroundColor: `var(${TOKENS.color.background.series.data12})`,
  color: `var(${TOKENS.color.foreground.series.onData12})`
}, {
  backgroundColor: `var(${TOKENS.color.background.series.data13})`,
  color: `var(${TOKENS.color.foreground.series.onData13})`
}, {
  backgroundColor: `var(${TOKENS.color.background.series.data14})`,
  color: `var(${TOKENS.color.foreground.series.onData14})`
}];
const getAvatarColor = (index2) => {
  const indexLoop = index2 % avatarColors.length;
  if (avatarColors[indexLoop]) {
    return avatarColors[indexLoop];
  }
  return avatarColors[0];
};
const AvatarCircle = styled.div`
  width: 40px;
  height: 40px;
  font-family: var(${TOKENS.text.fontFamily.primary});
  border-radius: 50%;
  font-weight: 700;
  font-size: 16px;

  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;

  color: ${(props) => props.avatarColor.color};
  background-color: ${(props) => props.avatarColor.backgroundColor};

  @media only screen and (max-width: 1120px) {
    width: 32px;
    height: 32px;
    font-size: 14px;
  }
`;
const Avatar = forwardRef(({
  children,
  idx,
  ...rest
}, ref2) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(AvatarCircle, { avatarColor: getAvatarColor(idx), ref: ref2, ...rest, children });
});
Avatar.displayName = "Avatar";
const textTransform = system({
  textTransform: {
    property: "textTransform"
  }
});
const fontSmoothing = system({
  fontSmoothing: {
    property: "WebkitFontSmoothing"
  }
});
const typographyStyledSystemFns = [space, layout, typography, color, border, position$1, shadow, textTransform, fontSmoothing];
const StyledText$1 = styled.p`
  font-style: normal;
  ${composeWrapper(typographyStyledSystemFns, [])}
`;
const RESPONSIVE_VARIANTS = {
  bodyLarge: {
    mobile: {
      fontSize: "1.125rem",
      lineHeight: "140%",
      letterSpacing: "0em"
    },
    desktop: {
      fontSize: "1.25rem",
      lineHeight: "140%",
      letterSpacing: "0em"
    }
  },
  bodyMedium: {
    mobile: {
      fontSize: "1rem",
      lineHeight: "140%",
      letterSpacing: "0em"
    },
    desktop: {
      fontSize: "1rem",
      lineHeight: "140%",
      letterSpacing: "0em"
    }
  },
  bodySmall: {
    mobile: {
      fontSize: "0.875rem",
      lineHeight: "140%",
      letterSpacing: "0em"
    },
    desktop: {
      fontSize: "0.875rem",
      lineHeight: "140%",
      letterSpacing: "0em"
    }
  },
  bodyXLarge: {
    mobile: {
      fontSize: "1.3125rem",
      lineHeight: "140%",
      letterSpacing: "0em"
    },
    desktop: {
      fontSize: "1.5rem",
      lineHeight: "140%",
      letterSpacing: "0em"
    }
  },
  bodyXSmall: {
    mobile: {
      fontSize: "0.75rem",
      lineHeight: "140%",
      letterSpacing: "0em"
    },
    desktop: {
      fontSize: "0.75rem",
      lineHeight: "140%",
      letterSpacing: "0em"
    }
  },
  disclaimerMedium: {
    mobile: {
      fontSize: "0.875rem",
      lineHeight: "150%",
      letterSpacing: "0rem"
    },
    desktop: {
      fontSize: "1rem",
      lineHeight: "150%",
      letterSpacing: "0rem"
    }
  },
  disclaimerSmall: {
    mobile: {
      fontSize: "0.6875rem",
      lineHeight: "160%",
      letterSpacing: "0rem"
    },
    desktop: {
      fontSize: "0.875rem",
      lineHeight: "160%",
      letterSpacing: "0rem"
    }
  },
  disclaimerXSmall: {
    mobile: {
      fontSize: "0.625rem",
      lineHeight: "140%",
      letterSpacing: "0rem"
    },
    desktop: {
      fontSize: "0.75rem",
      lineHeight: "140%",
      letterSpacing: "0rem"
    }
  },
  headerLarge: {
    mobile: {
      fontSize: "1.3125rem",
      lineHeight: "125%",
      letterSpacing: "0em"
    },
    desktop: {
      fontSize: "1.5rem",
      lineHeight: "120%",
      letterSpacing: "0em"
    }
  },
  headerMedium: {
    mobile: {
      fontSize: "1.125rem",
      lineHeight: "125%",
      letterSpacing: "0em"
    },
    desktop: {
      fontSize: "1.25rem",
      lineHeight: "130%",
      letterSpacing: "0em"
    }
  },
  headerSmall: {
    mobile: {
      fontSize: "1rem",
      lineHeight: "140%",
      letterSpacing: "0em"
    },
    desktop: {
      fontSize: "1rem",
      lineHeight: "140%",
      letterSpacing: "0em"
    }
  },
  headerXLarge: {
    mobile: {
      fontSize: "1.375rem",
      lineHeight: "120%",
      letterSpacing: "0em"
    },
    desktop: {
      fontSize: "2rem",
      lineHeight: "120%",
      letterSpacing: "-1.5%"
    }
  },
  headerXSmall: {
    mobile: {
      fontSize: "0.875rem",
      lineHeight: "140%",
      letterSpacing: "0em"
    },
    desktop: {
      fontSize: "0.875rem",
      lineHeight: "140%",
      letterSpacing: "0em"
    }
  },
  headlineLarge: {
    mobile: {
      fontSize: "3.25rem",
      lineHeight: "110%",
      letterSpacing: "-1%"
    },
    desktop: {
      fontSize: "4rem",
      lineHeight: "110%",
      letterSpacing: "-1%"
    }
  },
  headlineMedium: {
    mobile: {
      fontSize: "2.75rem",
      lineHeight: "110%",
      letterSpacing: "-0.005em"
    },
    desktop: {
      fontSize: "3rem",
      lineHeight: "110%",
      letterSpacing: "-0.01em"
    }
  },
  headlineSmall: {
    mobile: {
      fontSize: "2.25rem",
      lineHeight: "110%",
      letterSpacing: "-0.01em"
    },
    desktop: {
      fontSize: "2.5rem",
      lineHeight: "110%",
      letterSpacing: "-0.01em"
    }
  },
  headlineXSmall: {
    mobile: {
      fontSize: "1.75rem",
      lineHeight: "110%",
      letterSpacing: "-0.01em"
    },
    desktop: {
      fontSize: "2rem",
      lineHeight: "110%",
      letterSpacing: "-0.01em"
    }
  },
  hyperlinkLarge: {
    mobile: {
      fontSize: "1.125rem",
      lineHeight: "150%"
    },
    desktop: {
      fontSize: "1.25rem",
      lineHeight: "150%"
    }
  },
  hyperlinkMedium: {
    mobile: {
      fontSize: "1rem",
      lineHeight: "140%"
    },
    desktop: {
      fontSize: "1rem",
      lineHeight: "140%"
    }
  },
  hyperlinkSmall: {
    mobile: {
      fontSize: "0.875rem",
      lineHeight: "140%"
    },
    desktop: {
      fontSize: "0.875rem",
      lineHeight: "140%"
    }
  },
  hyperlinkXSmall: {
    mobile: {
      fontSize: "0.75rem",
      lineHeight: "140%"
    },
    desktop: {
      fontSize: "0.75rem",
      lineHeight: "140%"
    }
  },
  labelLarge: {
    mobile: {
      fontSize: "1rem",
      lineHeight: "140%",
      letterSpacing: "0.12em"
    },
    desktop: {
      fontSize: "1.125rem",
      lineHeight: "140%",
      letterSpacing: "0.12em"
    }
  },
  labelMedium: {
    mobile: {
      fontSize: "0.875rem",
      lineHeight: "140%",
      letterSpacing: "0.12em"
    },
    desktop: {
      fontSize: "1rem",
      lineHeight: "140%",
      letterSpacing: "0.12em"
    }
  },
  labelSmall: {
    mobile: {
      fontSize: "0.75rem",
      lineHeight: "140%",
      letterSpacing: "0.12em"
    },
    desktop: {
      fontSize: "0.875rem",
      lineHeight: "140%",
      letterSpacing: "0.12em"
    }
  },
  labelXSmall: {
    mobile: {
      fontSize: "0.625rem",
      lineHeight: "140%",
      letterSpacing: "0.12em"
    },
    desktop: {
      fontSize: "0.75rem",
      lineHeight: "140%",
      letterSpacing: "0.12em"
    }
  },
  signature: {
    mobile: {
      fontSize: "1.3125rem",
      lineHeight: "67%"
    },
    desktop: {
      fontSize: "1.5rem",
      lineHeight: "67%"
    }
  }
};
const GROUP_THEMED_PROPS = {
  headline: {
    margin: "0",
    color: `var(${TOKENS.color.foreground.primary})`,
    fontFamily: `var(${TOKENS.text.fontFamily.accent})`,
    fontWeight: `var(${TOKENS.text.fontWeight.headline})`
  },
  // NOTE: only `headline` sets a group-level `color`. The other groups
  // historically had no color in the theme typography group props, so they
  // inherit from their container (e.g. Badge sets `color: onColor` on colored
  // backgrounds and relies on the text inheriting it). Do not add `color` here.
  header: {
    margin: "0",
    fontFamily: `var(${TOKENS.text.fontFamily.primary})`,
    fontWeight: `var(${TOKENS.text.fontWeight.header})`
  },
  body: {
    margin: "0",
    fontFamily: `var(${TOKENS.text.fontFamily.primary})`,
    fontWeight: `var(${TOKENS.text.fontWeight.default})`
  },
  label: {
    margin: "0",
    fontFamily: `var(${TOKENS.text.fontFamily.primary})`,
    fontWeight: `var(${TOKENS.text.fontWeight.label})`
  },
  disclaimer: {
    margin: "0",
    fontFamily: `var(${TOKENS.text.fontFamily.primary})`,
    fontWeight: `var(${TOKENS.text.fontWeight.disclaimer})`
  },
  hyperlink: {
    margin: "0",
    fontFamily: `var(${TOKENS.text.fontFamily.primary})`,
    fontWeight: `var(${TOKENS.text.fontWeight.hyperlink})`
  },
  signature: {
    margin: "0",
    fontFamily: `var(${TOKENS.text.fontFamily.signature})`
  }
};
const getVariantGroup = (variant) => {
  if (variant.startsWith("headline")) return "headline";
  if (variant.startsWith("header")) return "header";
  if (variant.startsWith("label")) return "label";
  if (variant.startsWith("disclaimer")) return "disclaimer";
  if (variant.startsWith("hyperlink")) return "hyperlink";
  if (variant.startsWith("signature")) return "signature";
  return "body";
};
const Text = forwardRef(({
  variant = "bodyMedium.responsive",
  element = "p",
  ...rest
}, ref2) => {
  var _a2, _b;
  const labelAllCaps = ((_b = (_a2 = useKindredConfigOptional()) == null ? void 0 : _a2.misc) == null ? void 0 : _b.labelAllCaps) ?? false;
  const isResponsiveVariant = !!(variant == null ? void 0 : variant.endsWith(".responsive"));
  const genericVariantName = variant == null ? void 0 : variant.replace(/\.responsive|\.mobile|\.desktop/, "");
  const getResponsiveStyles = () => {
    if (!isResponsiveVariant) {
      return {};
    }
    if (genericVariantName && genericVariantName in RESPONSIVE_VARIANTS) {
      return {
        responsive: RESPONSIVE_VARIANTS[genericVariantName]
      };
    }
    return RESPONSIVE_VARIANTS.bodyMedium;
  };
  const responsiveStyles = getResponsiveStyles();
  const variantGroup = getVariantGroup(genericVariantName ?? "");
  const variantThemedProps = GROUP_THEMED_PROPS[variantGroup];
  const labelTransformProps = variantGroup === "label" ? {
    textTransform: labelAllCaps ? "uppercase" : "none"
  } : {};
  const breakpointSpecificThemedProps = genericVariantName !== variant && !isResponsiveVariant ? get$3(RESPONSIVE_VARIANTS, variant) : {};
  return /* @__PURE__ */ jsxRuntimeExports.jsx(StyledText$1, { ...variantThemedProps, ...labelTransformProps, ...breakpointSpecificThemedProps, ...responsiveStyles, ...rest, as: element, ref: ref2 });
});
Text.displayName = "Text";
const BADGE_SIZES = ["compact", "default", "subcompact"];
const BADGE_TEXT_TYPES = ["body", "label"];
const BADGE_TYPES = ["informationalWeak", "informationalModerate", "informationalStrong", "successWeak", "successModerate", "successStrong", "warningWeak", "warningModerate", "warningStrong", "errorWeak", "errorModerate", "errorStrong", "neutralWeak", "neutralModerate", "neutralStrong", "neutralSubduedWeak", "neutralSubduedModerate", "neutralSubduedStrong"];
const BADGE_VARIANT_STYLES = {
  informationalWeak: {
    backgroundColor: TOKENS.color.background.feedback.info,
    borderColor: TOKENS.color.background.feedback.info
  },
  informationalModerate: {
    backgroundColor: TOKENS.color.background.feedback.info,
    borderColor: TOKENS.color.border.feedback.info
  },
  informationalStrong: {
    backgroundColor: TOKENS.color.background.feedback.infoStrong,
    borderColor: TOKENS.color.background.feedback.infoStrong,
    color: TOKENS.color.foreground.interaction.onReverse
  },
  successWeak: {
    backgroundColor: TOKENS.color.background.feedback.success,
    borderColor: TOKENS.color.background.feedback.success
  },
  successModerate: {
    backgroundColor: TOKENS.color.background.feedback.success,
    borderColor: TOKENS.color.border.feedback.success
  },
  successStrong: {
    backgroundColor: TOKENS.color.background.feedback.successStrong,
    borderColor: TOKENS.color.background.feedback.successStrong,
    color: TOKENS.color.foreground.interaction.onReverse
  },
  warningWeak: {
    backgroundColor: TOKENS.color.background.feedback.warning,
    borderColor: TOKENS.color.background.feedback.warning
  },
  warningModerate: {
    backgroundColor: TOKENS.color.background.feedback.warning,
    borderColor: TOKENS.color.border.feedback.warning
  },
  warningStrong: {
    backgroundColor: TOKENS.color.background.feedback.warningStrong,
    borderColor: TOKENS.color.background.feedback.warningStrong
  },
  errorWeak: {
    backgroundColor: TOKENS.color.background.feedback.danger,
    borderColor: TOKENS.color.background.feedback.danger
  },
  errorModerate: {
    backgroundColor: TOKENS.color.background.feedback.danger,
    borderColor: TOKENS.color.border.feedback.danger
  },
  errorStrong: {
    backgroundColor: TOKENS.color.background.feedback.dangerStrong,
    borderColor: TOKENS.color.background.feedback.dangerStrong,
    color: TOKENS.color.foreground.interaction.onReverse
  },
  neutralWeak: {
    backgroundColor: TOKENS.color.background.surface0,
    borderColor: TOKENS.color.background.surface0
  },
  neutralModerate: {
    backgroundColor: TOKENS.color.background.surface0,
    borderColor: TOKENS.color.border.default
  },
  neutralStrong: {
    backgroundColor: TOKENS.color.background.surface1,
    borderColor: TOKENS.color.background.surface1
  },
  neutralSubduedWeak: {
    backgroundColor: TOKENS.color.background.surface2,
    borderColor: TOKENS.color.background.surface2
  },
  neutralSubduedModerate: {
    backgroundColor: TOKENS.color.background.surface1,
    borderColor: TOKENS.color.border.default
  },
  neutralSubduedStrong: {
    backgroundColor: TOKENS.color.background.surface3,
    borderColor: TOKENS.color.background.surface3
  }
};
const CompactSizeStyles = css$3`
  padding-left: 6px;
  padding-right: 6px;
  min-height: unset;
  border-radius: var(${TOKENS.dimension.radius.surface0});
  svg {
    width: 12px;
    height: 12px;
  }
`;
const SubcompactSizeStyles = css$3`
  padding-left: 4.5px;
  padding-right: 4.5px;
  border-radius: var(${TOKENS.dimension.radius.surfaceRound});
  svg {
    width: 9px;
    height: 9px;
  }
`;
const StyledText = styled(Text)`
  display: flex;
  align-items: center;

  // user agent style sheet override for badge doc example
  p {
    margin-block: 0;
  }
`;
const StyledBadge = styled.div`
  svg {
    width: 16px;
    height: 16px;
  }
  text-wrap: nowrap;
  display: inline-flex;
  justify-content: center;
  width: min-content;
  vertical-align: middle;
  font-weight: 400;
  font-size: 0.875rem;
  border-width: 1px;
  border-style: solid;
  padding: 3px 12px;
  border-radius: var(${TOKENS.dimension.radius.surface1});
  color: var(${TOKENS.color.foreground.interaction.onFeedback});
  ${({
  badgeType
}) => {
  if (!badgeType) return "";
  const variant = BADGE_VARIANT_STYLES[badgeType];
  return css$3`
      background-color: var(${variant.backgroundColor});
      border-color: var(${variant.borderColor});
      ${variant.color ? `color: var(${variant.color});` : ""}
    `;
}}
  ${compose(space, color, typography, layout, background, border)};
  ${({
  size: size2,
  $blicTopPadding,
  $blicBottomPadding
}) => size2 === "compact" && css$3`
      ${CompactSizeStyles};
      padding-top: ${$blicTopPadding};
      padding-bottom: ${$blicBottomPadding};
    `};
  ${({
  size: size2
}) => size2 === "subcompact" && css$3`
      ${SubcompactSizeStyles};
    `};
`;
const BadgeContentContainer = styled.div`
  display: flex;
  overflow: hidden;
`;
const IconContainer$4 = styled.div`
  display: flex;
  align-items: center;
  margin-right: ${({
  $iconPosition
}) => $iconPosition === "left" && "6px"};
  margin-left: ${({
  $iconPosition
}) => $iconPosition === "right" && "6px"};
  svg {
    fill: ${({
  $onColorIcon
}) => $onColorIcon && `var(${TOKENS.color.foreground.interaction.onReverse})`};
  }
`;
const getFontSizeAndLineHeight = (size2) => {
  switch (size2) {
    case "subcompact":
      return {
        fontSize: "10px",
        lineHeight: "11px"
      };
    case "compact":
      return {
        fontSize: "12px",
        lineHeight: "14px"
      };
    default:
      return {
        fontSize: "14px",
        lineHeight: "18px"
      };
  }
};
const Badge = forwardRef(({
  children,
  size: size2 = "default",
  useBodyText,
  badgeType,
  iconLeft,
  iconRight,
  ...rest
}, ref2) => {
  const onColorIcon = badgeType === "informationalStrong" || badgeType === "errorStrong" || badgeType === "successStrong";
  const isCompactLabel = size2 === "compact" && !useBodyText;
  const blicTopPadding = isCompactLabel ? "2px" : "1.5px";
  const blicBottomPadding = isCompactLabel ? "1px" : "1.5px";
  const {
    fontSize,
    lineHeight
  } = getFontSizeAndLineHeight(size2);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(StyledBadge, { ...rest, size: size2, badgeType, $blicBottomPadding: blicBottomPadding, $blicTopPadding: blicTopPadding, ref: ref2, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(BadgeContentContainer, { children: [
    iconLeft && /* @__PURE__ */ jsxRuntimeExports.jsx(IconContainer$4, { $iconPosition: "left", $onColorIcon: onColorIcon, "aria-hidden": true, children: iconLeft }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(StyledText, { element: "p", variant: useBodyText ? "bodySmall.desktop" : "labelSmall.desktop", fontSize, lineHeight, textTransform: useBodyText ? "none" : "uppercase", children }),
    iconRight && /* @__PURE__ */ jsxRuntimeExports.jsx(IconContainer$4, { $iconPosition: "right", $onColorIcon: onColorIcon, "aria-hidden": true, children: iconRight })
  ] }) });
});
Badge.displayName = "Badge";
const ICON_SIZE_MAPPINGS = {
  sm: 16,
  md: 24,
  lg: 32,
  xl: 40
};
const ICON_SIZE_DEFAULT = ICON_SIZE_MAPPINGS.md;
const ICON_FILL_DEFAULT = "#282624";
const AddOptionIcon = forwardRef((props, ref2) => {
  const defaultFill = "#ffffff";
  const {
    size: size2,
    title,
    ...rest
  } = props;
  const mappedSizeOrDefault = size2 ? ICON_SIZE_MAPPINGS[size2] : ICON_SIZE_DEFAULT;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { width: mappedSizeOrDefault, height: mappedSizeOrDefault, viewBox: "0 0 24 24", fill: defaultFill, xmlns: "http://www.w3.org/2000/svg", role: "img", "aria-label": "Add Option Icon", ...rest, ref: ref2, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("title", { children: title || "Add Option Icon" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("rect", { x: "2.5", y: "2.5", width: "19", height: "19", rx: "1.5", stroke: "#667085", strokeDasharray: "4 4" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.5421 8.09669C12.5421 7.79735 12.2994 7.55469 12.0001 7.55469C11.7008 7.55469 11.4581 7.79735 11.4581 8.09669V11.4571H8.09767C7.79833 11.4571 7.55566 11.6998 7.55566 11.9991C7.55566 12.2985 7.79833 12.5411 8.09767 12.5411H11.4581V15.9016C11.4581 16.2009 11.7008 16.4436 12.0001 16.4436C12.2994 16.4436 12.5421 16.2009 12.5421 15.9016V12.5411H15.9026C16.2019 12.5411 16.4446 12.2985 16.4446 11.9991C16.4446 11.6998 16.2019 11.4571 15.9026 11.4571H12.5421V8.09669Z", fill: "#667085" })
  ] });
});
AddOptionIcon.displayName = "AddOptionIcon";
const AddressPinIcon = forwardRef((props, ref2) => {
  const defaultFill = `var(${TOKENS.color.foreground.default}, ${ICON_FILL_DEFAULT})`;
  const {
    size: size2,
    title,
    ...rest
  } = props;
  const mappedSizeOrDefault = size2 ? ICON_SIZE_MAPPINGS[size2] : ICON_SIZE_DEFAULT;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { width: mappedSizeOrDefault, height: mappedSizeOrDefault, viewBox: "0 0 24 24", fill: defaultFill, xmlns: "http://www.w3.org/2000/svg", role: "img", "aria-label": "Address Pin Icon", ...rest, ref: ref2, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("title", { children: title || "Address Pin Icon" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.13864 5.26697C8.42795 3.97766 10.1766 3.25333 12 3.25333C13.8234 3.25333 15.572 3.97766 16.8614 5.26697C18.1507 6.55629 18.875 8.30497 18.875 10.1283C18.875 13.2242 17.5195 15.6525 15.9651 17.4237C14.4076 19.1985 12.675 20.283 11.9996 20.6687C11.3238 20.2824 9.59169 19.1975 8.03448 17.4228C6.48024 15.6515 5.125 13.2233 5.125 10.1283C5.125 8.30497 5.84933 6.55629 7.13864 5.26697ZM12 2.00333C9.84512 2.00333 7.77849 2.85936 6.25476 4.38309C4.73102 5.90682 3.875 7.97345 3.875 10.1283C3.875 13.615 5.40768 16.3244 7.0949 18.2472C8.7787 20.1662 10.641 21.332 11.3798 21.7543L11.38 21.7544C11.5687 21.8622 11.7823 21.9189 11.9996 21.9189C12.2169 21.9189 12.4305 21.8622 12.6192 21.7544C13.3582 21.3324 15.2207 20.167 16.9046 18.2482C18.5921 16.3254 20.125 13.6158 20.125 10.1283C20.125 7.97345 19.269 5.90682 17.7452 4.38309C16.2215 2.85936 14.1549 2.00333 12 2.00333ZM12 5.75333C10.8397 5.75333 9.72688 6.21427 8.90641 7.03474C8.08594 7.85521 7.625 8.96801 7.625 10.1283C7.625 11.2887 8.08594 12.4015 8.90641 13.2219C9.72688 14.0424 10.8397 14.5033 12 14.5033C13.1603 14.5033 14.2731 14.0424 15.0936 13.2219C15.9141 12.4015 16.375 11.2887 16.375 10.1283C16.375 8.96801 15.9141 7.85521 15.0936 7.03474C14.2731 6.21427 13.1603 5.75333 12 5.75333ZM9.79029 7.91862C10.3763 7.33257 11.1712 7.00333 12 7.00333C12.8288 7.00333 13.6237 7.33257 14.2097 7.91862C14.7958 8.50468 15.125 9.29953 15.125 10.1283C15.125 10.9571 14.7958 11.752 14.2097 12.338C13.6237 12.9241 12.8288 13.2533 12 13.2533C11.1712 13.2533 10.3763 12.9241 9.79029 12.338C9.20424 11.752 8.875 10.9571 8.875 10.1283C8.875 9.29953 9.20424 8.50468 9.79029 7.91862Z" })
  ] });
});
AddressPinIcon.displayName = "AddressPinIcon";
const AgentAppIcon = forwardRef((props, ref2) => {
  const defaultFill = `var(${TOKENS.color.foreground.default}, ${ICON_FILL_DEFAULT})`;
  const {
    size: size2,
    title,
    ...rest
  } = props;
  const mappedSizeOrDefault = size2 ? ICON_SIZE_MAPPINGS[size2] : ICON_SIZE_DEFAULT;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { width: mappedSizeOrDefault, height: mappedSizeOrDefault, viewBox: "0 0 24 24", fill: defaultFill, xmlns: "http://www.w3.org/2000/svg", role: "img", "aria-label": "Agent App Icon", ...rest, ref: ref2, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("title", { children: title || "Agent App Icon" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.58333 2C5.89298 2 5.33333 2.55964 5.33333 3.25V3.66667H3.875C3.37772 3.66667 2.90081 3.86421 2.54917 4.21584C2.19754 4.56747 2 5.04439 2 5.54167V20.125C2 20.6223 2.19754 21.0992 2.54917 21.4508C2.9008 21.8025 3.37772 22 3.875 22H15.125C15.6223 22 16.0992 21.8025 16.4508 21.4508C16.8025 21.0992 17 20.6223 17 20.125V17.625C17 17.2798 16.7202 17 16.375 17C16.0298 17 15.75 17.2798 15.75 17.625V20.125C15.75 20.2908 15.6842 20.4497 15.5669 20.5669C15.4497 20.6842 15.2908 20.75 15.125 20.75H3.875C3.70924 20.75 3.55027 20.6842 3.43306 20.5669C3.31585 20.4497 3.25 20.2908 3.25 20.125V5.54167C3.25 5.37591 3.31585 5.21694 3.43306 5.09973C3.55027 4.98251 3.70924 4.91667 3.875 4.91667H5.33333V5.33333C5.33333 6.02369 5.89298 6.58333 6.58333 6.58333H12.4167C13.107 6.58333 13.6667 6.02369 13.6667 5.33333V4.91667H15.125C15.2908 4.91667 15.4497 4.98251 15.5669 5.09973C15.6842 5.21694 15.75 5.37591 15.75 5.54167C15.75 5.88684 16.0298 6.16667 16.375 6.16667C16.7202 6.16667 17 5.88684 17 5.54167C17 5.04438 16.8025 4.56747 16.4508 4.21584C16.0992 3.86421 15.6223 3.66667 15.125 3.66667H13.6667V3.25C13.6667 2.55964 13.107 2 12.4167 2H6.58333ZM6.58333 5.33333H12.4167V3.25H6.58333V5.33333ZM10.8055 15.6285L18.6082 7.83396C18.8443 7.61739 19.1547 7.49964 19.4753 7.5053C19.7991 7.51101 20.1081 7.6422 20.3371 7.87122C20.5661 8.10024 20.6973 8.40922 20.703 8.73305C20.7087 9.05339 20.5911 9.36352 20.3749 9.59954L12.5812 17.3605L10.5128 17.6552L10.8055 15.6285ZM19.4973 6.25549C18.8497 6.24407 18.2228 6.48448 17.7489 6.92608C17.7436 6.93101 17.7384 6.93604 17.7333 6.94116L9.77496 14.8912C9.67943 14.9866 9.61738 15.1104 9.59808 15.244L9.15642 18.3023C9.12828 18.4972 9.19358 18.6939 9.33264 18.8332C9.4717 18.9725 9.66827 19.0382 9.86316 19.0104L12.9632 18.5688C13.0967 18.5497 13.2205 18.488 13.316 18.3929L21.266 10.4762C21.2715 10.4707 21.2769 10.4651 21.2823 10.4594C21.7239 9.98549 21.9643 9.35867 21.9528 8.711C21.9414 8.06333 21.679 7.44538 21.221 6.98734C20.763 6.52929 20.145 6.26692 19.4973 6.25549ZM5.75 9.29167C5.75 8.94649 6.02982 8.66667 6.375 8.66667H12.2083C12.5535 8.66667 12.8333 8.94649 12.8333 9.29167C12.8333 9.63684 12.5535 9.91667 12.2083 9.91667H6.375C6.02982 9.91667 5.75 9.63684 5.75 9.29167ZM6.375 12.4167C6.02982 12.4167 5.75 12.6965 5.75 13.0417C5.75 13.3868 6.02982 13.6667 6.375 13.6667H8.45833C8.80351 13.6667 9.08333 13.3868 9.08333 13.0417C9.08333 12.6965 8.80351 12.4167 8.45833 12.4167H6.375Z" })
  ] });
});
AgentAppIcon.displayName = "AgentAppIcon";
const AgentShieldIcon = forwardRef((props, ref2) => {
  const defaultFill = `var(${TOKENS.color.foreground.default}, ${ICON_FILL_DEFAULT})`;
  const {
    size: size2,
    title,
    ...rest
  } = props;
  const mappedSizeOrDefault = size2 ? ICON_SIZE_MAPPINGS[size2] : ICON_SIZE_DEFAULT;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { width: mappedSizeOrDefault, height: mappedSizeOrDefault, viewBox: "0 0 24 24", fill: defaultFill, xmlns: "http://www.w3.org/2000/svg", role: "img", "aria-label": "Agent Shield Icon", ...rest, ref: ref2, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("title", { children: title || "Agent Shield Icon" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3.875 3.25C3.70924 3.25 3.55027 3.31585 3.43306 3.43306C3.31585 3.55027 3.25 3.70924 3.25 3.875V10.2808V10.2809C3.24966 12.7921 4.13875 15.2222 5.75956 17.1402C7.35761 19.0313 9.56514 20.3041 12 20.7406C14.4349 20.3041 16.6424 19.0313 18.2404 17.1402C19.8612 15.2222 20.7503 12.7921 20.75 10.2809V10.2808V3.875C20.75 3.70924 20.6842 3.55027 20.5669 3.43306C20.4497 3.31585 20.2908 3.25 20.125 3.25H3.875ZM2.54918 2.54917C2.90081 2.19754 3.37772 2 3.875 2H20.125C20.6223 2 21.0992 2.19754 21.4508 2.54917C21.8025 2.9008 22 3.37772 22 3.875V10.2807V10.2808C22.0004 13.0874 21.0067 15.8034 19.1952 17.947C17.3837 20.0907 14.8715 21.5235 12.1042 21.9913C12.0352 22.0029 11.9648 22.0029 11.8958 21.9913C9.12851 21.5235 6.6163 20.0907 4.8048 17.947C2.99333 15.8034 1.99964 13.0874 2 10.2808V10.2807V3.875C2 3.37772 2.19754 2.90081 2.54918 2.54917ZM9.56932 6.75682C10.214 6.11216 11.0883 5.75 12 5.75C12.9117 5.75 13.786 6.11216 14.4307 6.75682C15.0753 7.40148 15.4375 8.27582 15.4375 9.1875C15.4375 10.0992 15.0753 10.9735 14.4307 11.6182C13.903 12.1458 13.2216 12.4842 12.4917 12.5897C13.366 12.666 14.2129 12.9452 14.964 13.4078C15.8552 13.9568 16.5764 14.7424 17.0473 15.6771C17.2026 15.9854 17.0786 16.3612 16.7704 16.5165C16.4621 16.6718 16.0863 16.5478 15.931 16.2395C15.5642 15.5115 15.0025 14.8997 14.3084 14.4721C13.6143 14.0446 12.8152 13.8182 12 13.8182C11.1848 13.8182 10.3857 14.0446 9.69157 14.4721C8.99749 14.8997 8.43577 15.5115 8.069 16.2395C7.9137 16.5478 7.5379 16.6718 7.22964 16.5165C6.92137 16.3612 6.79736 15.9854 6.95266 15.6771C7.42358 14.7424 8.14483 13.9568 9.03602 13.4078C9.78711 12.9452 10.634 12.666 11.5083 12.5897C10.7784 12.4842 10.097 12.1458 9.56932 11.6182C8.92466 10.9735 8.5625 10.0992 8.5625 9.1875C8.5625 8.27582 8.92466 7.40148 9.56932 6.75682ZM12 7C11.4198 7 10.8634 7.23047 10.4532 7.6407C10.043 8.05094 9.8125 8.60734 9.8125 9.1875C9.8125 9.76766 10.043 10.3241 10.4532 10.7343C10.8634 11.1445 11.4198 11.375 12 11.375C12.5802 11.375 13.1366 11.1445 13.5468 10.7343C13.957 10.3241 14.1875 9.76766 14.1875 9.1875C14.1875 8.60734 13.957 8.05094 13.5468 7.6407C13.1366 7.23047 12.5802 7 12 7Z" })
  ] });
});
AgentShieldIcon.displayName = "AgentShieldIcon";
const ArrowDownIcon = forwardRef((props, ref2) => {
  const defaultFill = `var(${TOKENS.color.foreground.default}, ${ICON_FILL_DEFAULT})`;
  const {
    size: size2,
    title,
    ...rest
  } = props;
  const mappedSizeOrDefault = size2 ? ICON_SIZE_MAPPINGS[size2] : ICON_SIZE_DEFAULT;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { width: mappedSizeOrDefault, height: mappedSizeOrDefault, viewBox: "0 0 24 24", fill: defaultFill, xmlns: "http://www.w3.org/2000/svg", role: "img", "aria-label": "Arrow  Down Icon", ...rest, ref: ref2, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("title", { children: title || "Arrow  Down Icon" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M21.1919 13.0669C21.436 12.8229 21.436 12.4271 21.1919 12.1831C20.9479 11.939 20.5521 11.939 20.3081 12.1831L12.625 19.8661L12.625 2.625C12.625 2.27982 12.3452 2 12 2C11.6548 2 11.375 2.27982 11.375 2.625L11.375 19.8661L3.69194 12.1831C3.44786 11.939 3.05214 11.939 2.80806 12.1831C2.56398 12.4271 2.56398 12.8229 2.80806 13.0669L11.5573 21.8162C11.5599 21.8188 11.5626 21.8214 11.5653 21.824C11.6863 21.9413 11.8432 22 12 22C12.0847 22 12.1655 21.9831 12.2392 21.9526C12.3113 21.9228 12.3789 21.8789 12.4378 21.821M21.1919 13.0669L12.4423 21.8165Z" })
  ] });
});
ArrowDownIcon.displayName = "ArrowDownIcon";
const ArrowLeftIcon = forwardRef((props, ref2) => {
  const defaultFill = `var(${TOKENS.color.foreground.default}, ${ICON_FILL_DEFAULT})`;
  const {
    size: size2,
    title,
    ...rest
  } = props;
  const mappedSizeOrDefault = size2 ? ICON_SIZE_MAPPINGS[size2] : ICON_SIZE_DEFAULT;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { width: mappedSizeOrDefault, height: mappedSizeOrDefault, viewBox: "0 0 24 24", fill: defaultFill, xmlns: "http://www.w3.org/2000/svg", role: "img", "aria-label": "Arrow  Left Icon", ...rest, ref: ref2, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("title", { children: title || "Arrow  Left Icon" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.9331 21.1919C11.1771 21.436 11.5729 21.436 11.8169 21.1919C12.061 20.9479 12.061 20.5521 11.8169 20.3081L4.13389 12.625L21.375 12.625C21.7202 12.625 22 12.3452 22 12C22 11.6548 21.7202 11.375 21.375 11.375L4.13389 11.375L11.8169 3.69194C12.061 3.44786 12.061 3.05213 11.8169 2.80806C11.5729 2.56398 11.1771 2.56398 10.9331 2.80806L2.18383 11.5573C2.18119 11.5599 2.17857 11.5626 2.17598 11.5653C2.05866 11.6863 2 11.8432 2 12C2 12.0847 2.01687 12.1655 2.04743 12.2392C2.07723 12.3113 2.12109 12.3789 2.179 12.4378M10.9331 21.1919L2.18345 12.4423Z" })
  ] });
});
ArrowLeftIcon.displayName = "ArrowLeftIcon";
const ArrowRightIcon = forwardRef((props, ref2) => {
  const defaultFill = `var(${TOKENS.color.foreground.default}, ${ICON_FILL_DEFAULT})`;
  const {
    size: size2,
    title,
    ...rest
  } = props;
  const mappedSizeOrDefault = size2 ? ICON_SIZE_MAPPINGS[size2] : ICON_SIZE_DEFAULT;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { width: mappedSizeOrDefault, height: mappedSizeOrDefault, viewBox: "0 0 24 24", fill: defaultFill, xmlns: "http://www.w3.org/2000/svg", role: "img", "aria-label": "Arrow  Right Icon", ...rest, ref: ref2, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("title", { children: title || "Arrow  Right Icon" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13.0669 2.80806C12.8229 2.56398 12.4271 2.56398 12.1831 2.80806C11.939 3.05214 11.939 3.44786 12.1831 3.69194L19.8661 11.375H2.625C2.27982 11.375 2 11.6548 2 12C2 12.3452 2.27982 12.625 2.625 12.625H19.8661L12.1831 20.3081C11.939 20.5521 11.939 20.9479 12.1831 21.1919C12.4271 21.436 12.8229 21.436 13.0669 21.1919L21.8162 12.4427C21.8188 12.4401 21.8214 12.4374 21.824 12.4347C21.9413 12.3137 22 12.1568 22 12C22 11.9153 21.9831 11.8345 21.9526 11.7608C21.9228 11.6887 21.8789 11.6211 21.821 11.5622M13.0669 2.80806L21.8165 11.5577Z" })
  ] });
});
ArrowRightIcon.displayName = "ArrowRightIcon";
const ArrowUpIcon = forwardRef((props, ref2) => {
  const defaultFill = `var(${TOKENS.color.foreground.default}, ${ICON_FILL_DEFAULT})`;
  const {
    size: size2,
    title,
    ...rest
  } = props;
  const mappedSizeOrDefault = size2 ? ICON_SIZE_MAPPINGS[size2] : ICON_SIZE_DEFAULT;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { width: mappedSizeOrDefault, height: mappedSizeOrDefault, viewBox: "0 0 24 24", fill: defaultFill, xmlns: "http://www.w3.org/2000/svg", role: "img", "aria-label": "Arrow  Up Icon", ...rest, ref: ref2, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("title", { children: title || "Arrow  Up Icon" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.80806 10.9331C2.56398 11.1771 2.56398 11.5729 2.80806 11.8169C3.05214 12.061 3.44786 12.061 3.69194 11.8169L11.375 4.13388L11.375 21.375C11.375 21.7202 11.6548 22 12 22C12.3452 22 12.625 21.7202 12.625 21.375L12.625 4.13388L20.3081 11.8169C20.5521 12.061 20.9479 12.061 21.1919 11.8169C21.436 11.5729 21.436 11.1771 21.1919 10.9331L12.4427 2.18382C12.4401 2.18118 12.4374 2.17857 12.4347 2.17598C12.3137 2.05866 12.1568 2 12 2C11.9153 2 11.8345 2.01687 11.7608 2.04742C11.6887 2.07723 11.6211 2.12109 11.5622 2.179M2.80806 10.9331L11.5577 2.18345Z" })
  ] });
});
ArrowUpIcon.displayName = "ArrowUpIcon";
const AuditIcon = forwardRef((props, ref2) => {
  const defaultFill = `var(${TOKENS.color.foreground.default}, ${ICON_FILL_DEFAULT})`;
  const {
    size: size2,
    title,
    ...rest
  } = props;
  const mappedSizeOrDefault = size2 ? ICON_SIZE_MAPPINGS[size2] : ICON_SIZE_DEFAULT;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { width: mappedSizeOrDefault, height: mappedSizeOrDefault, viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", fill: defaultFill, role: "img", "aria-label": "Audit Icon", ref: ref2, ...rest, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("title", { children: title || "Audit Icon" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M13.7203 2C14.2166 2.00011 14.6929 2.1974 15.0439 2.54821L17.4348 4.93905C17.7857 5.29015 17.9829 5.76637 17.983 6.26274V8.86721C17.983 9.21199 17.7035 9.4915 17.3587 9.4915C17.0139 9.4915 16.7344 9.21199 16.7344 8.86721V6.26274C16.7343 6.09745 16.6688 5.93881 16.552 5.82183L14.1612 3.43099C14.0442 3.31424 13.8855 3.24867 13.7203 3.24858H4.87287C4.7073 3.24858 4.54807 3.31392 4.43099 3.43099C4.31392 3.54807 4.24858 3.7073 4.24858 3.87287V17.6073C4.24858 17.7729 4.31392 17.9321 4.43099 18.0492C4.54807 18.1662 4.7073 18.2316 4.87287 18.2316H9.86721C10.212 18.2316 10.4915 18.5111 10.4915 18.8559C10.4915 19.2007 10.212 19.4802 9.86721 19.4802H4.87287C4.37616 19.4802 3.89944 19.2832 3.54821 18.932C3.19697 18.5807 3 18.104 3 17.6073V3.87287C3 3.37616 3.19697 2.89944 3.54821 2.54821C3.89944 2.19697 4.37616 2 4.87287 2H13.7203Z" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M12.9887 5.87061L13.1145 5.88329C13.399 5.94151 13.613 6.19322 13.613 6.4949C13.613 6.79658 13.399 7.04829 13.1145 7.10651L12.9887 7.11919H6.99547C6.65068 7.11919 6.37117 6.83969 6.37117 6.4949C6.37117 6.15011 6.65068 5.87061 6.99547 5.87061H12.9887Z" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M9.99093 9.36664L10.1168 9.37932C10.4012 9.43754 10.6152 9.68925 10.6152 9.99093C10.6152 10.2926 10.4012 10.5443 10.1168 10.6025L9.99093 10.6152H6.99547C6.65068 10.6152 6.37117 10.3357 6.37117 9.99093C6.37117 9.64614 6.65068 9.36664 6.99547 9.36664H9.99093Z" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15 10.375C17.5543 10.375 19.625 12.4457 19.625 15C19.625 16.0515 19.2727 17.02 18.6816 17.7969L20.917 20.0332C21.1608 20.2773 21.161 20.673 20.917 20.917C20.673 21.161 20.2773 21.1608 20.0332 20.917L17.7969 18.6816C17.02 19.2727 16.0515 19.625 15 19.625C12.4457 19.625 10.375 17.5543 10.375 15C10.375 12.4457 12.4457 10.375 15 10.375ZM15 11.625C13.136 11.625 11.625 13.136 11.625 15C11.625 16.864 13.136 18.375 15 18.375C16.864 18.375 18.375 16.864 18.375 15C18.375 13.136 16.864 11.625 15 11.625Z" })
  ] });
});
AuditIcon.displayName = "AuditIcon";
const AutomaticIcon = forwardRef((props, ref2) => {
  const defaultFill = `var(${TOKENS.color.foreground.default}, ${ICON_FILL_DEFAULT})`;
  const {
    size: size2,
    title,
    ...rest
  } = props;
  const mappedSizeOrDefault = size2 ? ICON_SIZE_MAPPINGS[size2] : ICON_SIZE_DEFAULT;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { width: mappedSizeOrDefault, height: mappedSizeOrDefault, viewBox: "0 0 24 24", fill: defaultFill, xmlns: "http://www.w3.org/2000/svg", role: "img", "aria-label": "Automatic Icon", ...rest, ref: ref2, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("title", { children: title || "Automatic Icon" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.875 4.70834C8.52982 4.70834 8.25 4.98816 8.25 5.33334C8.25 5.67851 8.52982 5.95834 8.875 5.95834H15.75C16.2473 5.95834 16.7242 6.15588 17.0758 6.50751C17.4275 6.85914 17.625 7.33606 17.625 7.83334V11.947L15.5669 9.8889C15.3229 9.64482 14.9271 9.64482 14.6831 9.8889C14.439 10.133 14.439 10.5287 14.6831 10.7728L17.776 13.8657C17.8906 13.999 18.0605 14.0833 18.25 14.0833C18.4395 14.0833 18.6094 13.999 18.724 13.8657L21.8169 10.7728C22.061 10.5287 22.061 10.133 21.8169 9.8889C21.5729 9.64482 21.1771 9.64482 20.9331 9.8889L18.875 11.947V7.83334C18.875 7.00453 18.5458 6.20968 17.9597 5.62363C17.3737 5.03758 16.5788 4.70834 15.75 4.70834H8.875ZM5.125 12.4647L3.06694 14.5228C2.82286 14.7669 2.42714 14.7669 2.18306 14.5228C1.93898 14.2787 1.93898 13.883 2.18306 13.6389L5.30806 10.5139C5.55214 10.2698 5.94786 10.2698 6.19194 10.5139L9.31694 13.6389C9.56102 13.883 9.56102 14.2787 9.31694 14.5228C9.07286 14.7669 8.67714 14.7669 8.43306 14.5228L6.375 12.4647V16.5833C6.375 17.0806 6.57254 17.5575 6.92417 17.9092C7.27581 18.2608 7.75272 18.4583 8.25 18.4583H15.125C15.4702 18.4583 15.75 18.7382 15.75 19.0833C15.75 19.4285 15.4702 19.7083 15.125 19.7083H8.25C7.4212 19.7083 6.62634 19.3791 6.04029 18.793C5.45424 18.207 5.125 17.4121 5.125 16.5833V12.4647Z" })
  ] });
});
AutomaticIcon.displayName = "AutomaticIcon";
const AvatarIcon = forwardRef((props, ref2) => {
  const defaultFill = `var(${TOKENS.color.foreground.default}, ${ICON_FILL_DEFAULT})`;
  const {
    size: size2,
    title,
    ...rest
  } = props;
  const mappedSizeOrDefault = size2 ? ICON_SIZE_MAPPINGS[size2] : ICON_SIZE_DEFAULT;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { width: mappedSizeOrDefault, height: mappedSizeOrDefault, viewBox: "0 0 24 24", fill: defaultFill, xmlns: "http://www.w3.org/2000/svg", role: "img", "aria-label": "Avatar Icon", ...rest, ref: ref2, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("title", { children: title || "Avatar Icon" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 2C9.34784 2 6.8043 3.05357 4.92893 4.92893C3.05357 6.8043 2 9.34784 2 12C2 14.6522 3.05357 17.1957 4.92893 19.0711C5.21673 19.3589 5.52026 19.6273 5.83751 19.8756C5.84955 19.8857 5.86188 19.8953 5.87448 19.9044C7.618 21.2556 9.77063 22 12 22C14.2294 22 16.382 21.2556 18.1255 19.9043C18.1381 19.8953 18.1504 19.8857 18.1625 19.8756C18.4797 19.6273 18.7833 19.3589 19.0711 19.0711C20.9464 17.1957 22 14.6522 22 12C22 9.34784 20.9464 6.8043 19.0711 4.92893C17.1957 3.05357 14.6522 2 12 2ZM17.787 18.563C17.9239 18.4423 18.0574 18.317 18.1872 18.1872C19.8281 16.5462 20.75 14.3206 20.75 12C20.75 9.67936 19.8281 7.45376 18.1872 5.81282C16.5462 4.17187 14.3206 3.25 12 3.25C9.67936 3.25 7.45376 4.17187 5.81282 5.81282C4.17187 7.45376 3.25 9.67936 3.25 12C3.25 14.3206 4.17187 16.5462 5.81282 18.1872C5.94262 18.317 6.07609 18.4423 6.21297 18.563C6.93226 17.9283 7.75208 17.4154 8.64015 17.0459C9.70491 16.6029 10.8468 16.3749 12 16.3749C13.1532 16.3749 14.2951 16.6029 15.3598 17.0459C16.2479 17.4154 17.0677 17.9283 17.787 18.563ZM7.2318 19.3367C8.6403 20.2521 10.2945 20.75 12 20.75C13.7055 20.75 15.3597 20.2521 16.7682 19.3367C16.1992 18.8677 15.563 18.4843 14.8797 18.2C13.9671 17.8203 12.9884 17.6249 12 17.6249C11.0116 17.6249 10.0329 17.8203 9.12031 18.2C8.43699 18.4843 7.80082 18.8677 7.2318 19.3367ZM8.46447 6.58947C9.40215 5.65178 10.6739 5.125 12 5.125C13.3261 5.125 14.5979 5.65178 15.5355 6.58947C16.4732 7.52715 17 8.79892 17 10.125C17 11.4511 16.4732 12.7229 15.5355 13.6605C14.5979 14.5982 13.3261 15.125 12 15.125C10.6739 15.125 9.40215 14.5982 8.46447 13.6605C7.52678 12.7229 7 11.4511 7 10.125C7 8.79892 7.52678 7.52715 8.46447 6.58947ZM12 6.375C11.0054 6.375 10.0516 6.77009 9.34835 7.47335C8.64509 8.17661 8.25 9.13044 8.25 10.125C8.25 11.1196 8.64509 12.0734 9.34835 12.7767C10.0516 13.4799 11.0054 13.875 12 13.875C12.9946 13.875 13.9484 13.4799 14.6517 12.7767C15.3549 12.0734 15.75 11.1196 15.75 10.125C15.75 9.13044 15.3549 8.17661 14.6517 7.47335C13.9484 6.77009 12.9946 6.375 12 6.375Z" })
  ] });
});
AvatarIcon.displayName = "AvatarIcon";
const BadgeIcon = forwardRef((props, ref2) => {
  const defaultFill = `var(${TOKENS.color.foreground.default}, ${ICON_FILL_DEFAULT})`;
  const {
    size: size2,
    title,
    ...rest
  } = props;
  const mappedSizeOrDefault = size2 ? ICON_SIZE_MAPPINGS[size2] : ICON_SIZE_DEFAULT;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { width: mappedSizeOrDefault, height: mappedSizeOrDefault, viewBox: "0 0 24 24", fill: defaultFill, xmlns: "http://www.w3.org/2000/svg", role: "img", "aria-label": "Badge Icon", ...rest, ref: ref2, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("title", { children: title || "Badge Icon" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M11.3799 2.375C11.6764 2.375 11.9692 2.44149 12.2365 2.56954C12.4504 2.67199 12.6438 2.81178 12.8079 2.98201L12.9253 3.11529L14.1856 4.68321C14.2626 4.77916 14.3626 4.85418 14.4762 4.90133C14.5519 4.93276 14.6322 4.95114 14.7134 4.95598L14.8356 4.95302L16.8342 4.73568C17.1298 4.70285 17.429 4.73692 17.7096 4.83535C17.9903 4.93377 18.2451 5.09405 18.4557 5.30453C18.6659 5.51479 18.8261 5.76962 18.9248 6.05046C19.0035 6.27497 19.041 6.51136 19.0361 6.74753L19.0245 6.92443L18.807 8.92402C18.7938 9.04649 18.8116 9.17022 18.8587 9.2838C18.8941 9.36907 18.9452 9.4466 19.0091 9.51265L19.0772 9.57473L20.6448 10.8348C20.876 11.0207 21.0624 11.256 21.1904 11.5233C21.3186 11.7908 21.3851 12.0836 21.3851 12.3802C21.3851 12.6768 21.3186 12.9696 21.1904 13.2369C21.0879 13.4509 20.9481 13.6443 20.777 13.8091L20.6429 13.9271L19.0723 15.1798C18.9763 15.257 18.9011 15.3573 18.8539 15.4712C18.8224 15.547 18.804 15.6274 18.7991 15.7087L18.802 15.831L19.0193 17.8289C19.0524 18.1247 19.0185 18.4242 18.9201 18.7051C18.8217 18.9859 18.6613 19.2408 18.4511 19.4511C18.2407 19.6616 17.9856 19.822 17.7044 19.9205C17.4797 19.9992 17.2432 20.0366 17.0072 20.0316L16.8306 20.0199L14.8307 19.8024C14.7084 19.7891 14.5847 19.8069 14.4712 19.8539C14.386 19.8892 14.3085 19.9403 14.2425 20.0043L14.1803 20.0725L12.9254 21.6342C12.7396 21.8654 12.5043 22.052 12.2369 22.1802C11.9694 22.3084 11.6765 22.375 11.3799 22.375C11.0832 22.375 10.7904 22.3085 10.5229 22.1802C10.3089 22.0777 10.1155 21.9377 9.95163 21.7675L9.83437 21.6343L8.57517 20.0675C8.49793 19.9714 8.39781 19.8963 8.28396 19.8491C8.20804 19.8177 8.1277 19.7993 8.04638 19.7944L7.9241 19.7974L5.92645 20.0146C5.63064 20.0479 5.33114 20.0142 5.05018 19.9159C4.76919 19.8176 4.51395 19.6572 4.30343 19.4467C4.09297 19.2362 3.93259 18.981 3.83421 18.6999C3.75555 18.4751 3.71821 18.2384 3.72335 18.0025L3.73519 17.826L3.95266 15.8263C3.96592 15.7038 3.94813 15.5799 3.90095 15.4661C3.86554 15.3807 3.81445 15.303 3.75055 15.2369L3.68248 15.1749L2.11597 13.9158C1.88466 13.73 1.69802 13.4947 1.56979 13.2272C1.44156 12.9596 1.375 12.6668 1.375 12.3702C1.375 12.0736 1.44157 11.7807 1.56981 11.5132C1.6724 11.2992 1.81237 11.1058 1.98251 10.942L2.11566 10.8248L3.68303 9.56427C3.77897 9.48734 3.85397 9.38746 3.9011 9.27388C3.93252 9.19815 3.95088 9.11796 3.9557 9.0367L3.95269 8.91443L3.7354 6.91634C3.70233 6.62063 3.73624 6.32126 3.83462 6.04042C3.93301 5.7596 4.09336 5.50452 4.30376 5.29412C4.51417 5.0837 4.76926 4.92335 5.05007 4.82497C5.27473 4.74625 5.51127 4.7088 5.74733 4.7138L5.9241 4.72552L7.9236 4.94297C8.04616 4.9562 8.17007 4.93838 8.28397 4.89115C8.36938 4.85574 8.44708 4.80464 8.51362 4.74021L8.57633 4.67143L9.83457 3.11507C10.0204 2.88405 10.2558 2.69764 10.5232 2.56957C10.7906 2.44149 11.0833 2.375 11.3799 2.375ZM11.3799 3.625C11.2702 3.625 11.162 3.64958 11.0631 3.69694C10.9972 3.72851 10.9365 3.76967 10.8828 3.81925L10.8076 3.8998L9.54947 5.45596C9.34085 5.71546 9.0703 5.9183 8.76276 6.04582C8.51672 6.14785 8.25329 6.19906 7.98802 6.19714L7.78896 6.1857L5.78705 5.96799C5.67779 5.95577 5.56717 5.9683 5.4634 6.00466C5.35963 6.04101 5.2654 6.10025 5.18766 6.17799C5.10991 6.25574 5.05066 6.34999 5.01432 6.45373C4.99008 6.52291 4.97643 6.59513 4.97371 6.66853L4.97787 6.77929L5.19537 8.77932C5.23136 9.11045 5.18331 9.44531 5.05566 9.75294C4.95354 9.99905 4.80311 10.2214 4.61434 10.4069L4.46573 10.5389L2.89877 11.7991C2.81332 11.8678 2.74436 11.9547 2.69698 12.0535C2.6496 12.1524 2.625 12.2606 2.625 12.3702C2.625 12.4798 2.64959 12.588 2.697 12.6869C2.72857 12.7528 2.76974 12.8134 2.81903 12.8668L2.89891 12.9414L4.46535 14.2004C4.725 14.4089 4.928 14.6795 5.05563 14.9873C5.15766 15.2334 5.20883 15.4969 5.20685 15.7621L5.19537 15.9611L4.9776 17.9635C4.96529 18.0727 4.97776 18.1833 5.01404 18.287C5.05037 18.3908 5.10962 18.4851 5.18729 18.5628C5.26502 18.6405 5.35925 18.6997 5.46296 18.736C5.53213 18.7602 5.60436 18.7738 5.67789 18.7765L5.78896 18.7722L7.78913 18.5547C8.12025 18.5188 8.45512 18.5669 8.76261 18.6944C9.00871 18.7964 9.23115 18.9467 9.4171 19.1357L9.54952 19.2845L10.8087 20.8512C10.8774 20.9367 10.9644 21.0057 11.0632 21.053C11.1621 21.1004 11.2703 21.125 11.3799 21.125C11.4894 21.125 11.5977 21.1004 11.6965 21.053C11.7624 21.0215 11.823 20.9803 11.8764 20.931L11.951 20.8512L13.2056 19.29C13.414 19.0301 13.6845 18.827 13.9923 18.6993C14.2384 18.5973 14.5018 18.5461 14.7669 18.5482L14.9657 18.5597L16.9678 18.7774C17.0769 18.7896 17.1875 18.7771 17.2912 18.7408C17.3951 18.7044 17.4893 18.6452 17.567 18.5674C17.6448 18.4896 17.7041 18.3954 17.7404 18.2916C17.7647 18.2225 17.7783 18.1503 17.781 18.0769L17.7768 17.9661L17.5592 15.9654C17.5236 15.6343 17.5717 15.2997 17.6993 14.9923C17.8013 14.7463 17.9515 14.5239 18.1413 14.3373L18.2909 14.2041L19.8615 12.9515C19.9468 12.8829 20.0157 12.7959 20.0631 12.6968C20.1105 12.598 20.1351 12.4898 20.1351 12.3802C20.1351 12.2705 20.1105 12.1624 20.0631 12.0634C20.0315 11.9974 19.9903 11.9368 19.9412 11.8834L19.8616 11.809L18.2945 10.5493C18.0348 10.3409 17.8318 10.0705 17.7042 9.76294C17.6021 9.51695 17.5509 9.25355 17.5529 8.98831L17.5643 8.78929L17.782 6.78783C17.7941 6.67848 17.7816 6.56783 17.7453 6.46434C17.7088 6.36044 17.6494 6.2661 17.5718 6.18844C17.4939 6.11056 17.3997 6.05131 17.2959 6.0149C17.2267 5.99063 17.1545 5.97694 17.0812 5.97416L16.9707 5.9782L14.9705 6.19572C14.6395 6.23161 14.3047 6.1835 13.9971 6.05588C13.7511 5.95378 13.5288 5.80342 13.3431 5.6146L13.211 5.46593L11.9512 3.89865C11.8824 3.81318 11.7955 3.74429 11.6965 3.69691C11.5977 3.64958 11.4895 3.625 11.3799 3.625ZM14.8799 10.0002C15.1284 10.1866 15.1986 10.5226 15.0591 10.7892L15.0049 10.8752L11.6872 15.2988C11.5797 15.442 11.4426 15.5604 11.2854 15.646C11.1281 15.7317 10.9543 15.7825 10.7757 15.7951C10.5972 15.8077 10.4181 15.7818 10.2505 15.7193C10.1246 15.6723 10.0075 15.6055 9.90341 15.5217L9.80384 15.4323L7.81301 13.4423C7.56888 13.1982 7.5688 12.8025 7.81283 12.5584C8.02974 12.3414 8.36651 12.3172 8.61013 12.4859L8.69671 12.5582L10.6876 14.5483L14.0049 10.1252C14.212 9.84906 14.6037 9.79309 14.8799 10.0002Z" })
  ] });
});
BadgeIcon.displayName = "BadgeIcon";
const BankIcon = forwardRef((props, ref2) => {
  const {
    size: size2
  } = props;
  const mappedSizeOrDefault = size2 ? ICON_SIZE_MAPPINGS[size2] : ICON_SIZE_DEFAULT;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { width: mappedSizeOrDefault, height: mappedSizeOrDefault, viewBox: "0 -4 16 24", fill: ICON_FILL_DEFAULT, xmlns: "http://www.w3.org/2000/svg", role: "img", "aria-label": "Bank Icon", ...props, ref: ref2, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("title", { children: "Bank Icon" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M7.50181 0.13125C7.80802 -0.04375 8.1861 -0.04375 8.49544 0.13125L13.8636 3.19688L13.9979 3.25V3.27813L15.4946 4.13438C15.8883 4.35938 16.0821 4.82188 15.9664 5.25938C15.8508 5.69688 15.454 6.00313 15.0009 6.00313H0.999447C0.546375 6.00313 0.149546 5.69688 0.033935 5.25938C-0.0816764 4.82188 0.112051 4.35938 0.505755 4.13438L1.99933 3.27813V3.25L2.13681 3.2L7.50181 0.13125ZM1.99933 7H3.99909V13H5.24895V7H7.24871V13H8.74854V7H10.7483V13H11.9982V7H13.9979V13.1344C14.0167 13.1437 14.0354 13.1562 14.0542 13.1687L15.554 14.1687C15.9196 14.4125 16.0852 14.8687 15.9571 15.2906C15.829 15.7125 15.4384 16 14.9978 16H0.999447C0.558873 16 0.171419 15.7125 0.0433089 15.2906C-0.084801 14.8687 0.0776799 14.4125 0.446387 14.1687L1.94621 13.1687C1.96496 13.1562 1.98371 13.1469 2.00245 13.1344V7H1.99933Z", fill: "#282624" })
  ] });
});
BankIcon.displayName = "BankIcon";
const BankWithLinesIcon = forwardRef((props, ref2) => {
  const {
    size: size2
  } = props;
  const mappedSizeOrDefault = size2 ? ICON_SIZE_MAPPINGS[size2] : ICON_SIZE_DEFAULT;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { width: mappedSizeOrDefault, height: mappedSizeOrDefault, viewBox: "0 0 24 24", fill: ICON_FILL_DEFAULT, xmlns: "http://www.w3.org/2000/svg", role: "img", "aria-label": "Bank Icon", ...props, ref: ref2, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("title", { children: "Bank With Lines Icon" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M21.242 21.149H2.625a.625.625 0 0 0 0 1.25h18.617a.625.625 0 0 0 0-1.25zM2.625 19.846h18.617a.625.625 0 0 0 0-1.25H2.625a.625.625 0 1 0 0 1.25zM3.33 10.285v6.383a.625.625 0 0 0 1.25 0v-6.383a.625.625 0 0 0-1.25 0zM5.989 10.285v6.383a.625.625 0 0 0 1.25 0v-6.383a.625.625 0 0 0-1.25 0zM9.979 10.285v6.383a.625.625 0 0 0 1.25 0v-6.383a.625.625 0 0 0-1.25 0zM12.638 10.285v6.383a.625.625 0 0 0 1.25 0v-6.383a.625.625 0 0 0-1.25 0zM16.628 10.285v6.383a.625.625 0 0 0 1.25 0v-6.383a.625.625 0 0 0-1.25 0zM19.287 10.285v6.383a.625.625 0 0 0 1.25 0v-6.383a.625.625 0 0 0-1.25 0zM2.625 8.357h18.617a.625.625 0 0 0 .31-1.168L12.971 2.29a2.004 2.004 0 0 0-2.075 0L2.315 7.189a.624.624 0 0 0 .31 1.168zm8.899-4.987a.751.751 0 0 1 .799-.011l.018.011 6.544 3.736H4.98l6.544-3.736z", fill: "#282624" })
  ] });
});
BankWithLinesIcon.displayName = "BankWithLinesIcon";
const BellIcon = forwardRef((props, ref2) => {
  const defaultFill = `var(${TOKENS.color.foreground.default}, ${ICON_FILL_DEFAULT})`;
  const {
    size: size2,
    title,
    ...rest
  } = props;
  const mappedSizeOrDefault = size2 ? ICON_SIZE_MAPPINGS[size2] : ICON_SIZE_DEFAULT;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { width: mappedSizeOrDefault, height: mappedSizeOrDefault, viewBox: "0 0 24 24", fill: defaultFill, xmlns: "http://www.w3.org/2000/svg", role: "img", "aria-label": "Bell Icon", ...rest, ref: ref2, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("title", { children: title || "Bell Icon" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 2C12.3452 2 12.625 2.27982 12.625 2.625V3.90345C14.2192 4.04892 15.7202 4.74748 16.8614 5.88864C18.1507 7.17795 18.875 8.92664 18.875 10.75C18.875 13.6464 19.1839 15.2964 19.4707 16.2003C19.6136 16.6506 19.749 16.9094 19.8333 17.0431C19.8754 17.1098 19.9047 17.1452 19.9158 17.1579L19.9179 17.1603C20.1048 17.3282 20.1737 17.5932 20.0896 17.8324C20.0016 18.0826 19.7652 18.25 19.5 18.25H4.5C4.26093 18.25 4.04281 18.1136 3.93812 17.8987C3.83476 17.6865 3.85983 17.4345 4.00229 17.247L4.00326 17.2456C4.00643 17.2411 4.01411 17.23 4.0257 17.2117C4.04886 17.1751 4.08772 17.1097 4.13736 17.0114C4.23659 16.8148 4.37931 16.4856 4.52555 15.99C4.81818 14.9984 5.125 13.3406 5.125 10.75C5.125 8.92664 5.84933 7.17795 7.13864 5.88864C8.2798 4.74748 9.78083 4.04892 11.375 3.90345V2.625C11.375 2.27982 11.6548 2 12 2ZM12 5.125C10.5082 5.125 9.07741 5.71763 8.02252 6.77252C6.96763 7.82742 6.375 9.25816 6.375 10.75C6.375 13.4378 6.05682 15.2175 5.72444 16.3438C5.65065 16.5938 5.57617 16.8116 5.50432 17H18.4277C18.3781 16.8733 18.3284 16.7332 18.2793 16.5784C17.9411 15.5127 17.625 13.7253 17.625 10.75C17.625 9.25816 17.0324 7.82742 15.9775 6.77252C14.9226 5.71763 13.4918 5.125 12 5.125ZM10.1573 19.5253C10.4885 19.4281 10.8358 19.6178 10.933 19.949C11.0008 20.18 11.1416 20.3828 11.3344 20.527C11.5271 20.6713 11.7613 20.7493 12.0021 20.7493C12.2428 20.7493 12.4771 20.6713 12.6698 20.527C12.8625 20.3828 13.0033 20.1799 13.0711 19.949C13.1684 19.6178 13.5157 19.4281 13.8469 19.5253C14.1781 19.6225 14.3678 19.9698 14.2705 20.301C14.1266 20.7912 13.8279 21.2216 13.4189 21.5277C13.01 21.8338 12.5129 21.9993 12.0021 21.9993C11.4912 21.9993 10.9942 21.8338 10.5852 21.5277C10.1763 21.2216 9.87752 20.7912 9.73364 20.301C9.63641 19.9698 9.82608 19.6225 10.1573 19.5253Z" })
  ] });
});
BellIcon.displayName = "BellIcon";
const CalendarIcon$1 = forwardRef((props, ref2) => {
  const defaultFill = `var(${TOKENS.color.foreground.default}, ${ICON_FILL_DEFAULT})`;
  const {
    size: size2,
    title,
    ...rest
  } = props;
  const mappedSizeOrDefault = size2 ? ICON_SIZE_MAPPINGS[size2] : ICON_SIZE_DEFAULT;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { width: mappedSizeOrDefault, height: mappedSizeOrDefault, viewBox: "0 0 24 24", fill: defaultFill, xmlns: "http://www.w3.org/2000/svg", role: "img", "aria-label": "Calendar Icon", ...rest, ref: ref2, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("title", { children: title || "Calendar Icon" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.62667 2C7.97185 2 8.25167 2.27982 8.25167 2.625V4.5H15.7517V2.625C15.7517 2.27982 16.0315 2 16.3767 2C16.7218 2 17.0017 2.27982 17.0017 2.625V4.5H20.1267C21.1622 4.5 22.0017 5.33947 22.0017 6.375V10.125V20.125C22.0017 21.1605 21.1622 22 20.1267 22H3.87667C2.84113 22 2.00167 21.1605 2.00167 20.125V10.125V6.375C2.00167 5.33947 2.84113 4.5 3.87667 4.5H7.00167V2.625C7.00167 2.27982 7.28149 2 7.62667 2ZM15.7517 5.75V7C15.7517 7.34518 16.0315 7.625 16.3767 7.625C16.7218 7.625 17.0017 7.34518 17.0017 7V5.75H20.1267C20.4718 5.75 20.7517 6.02982 20.7517 6.375V9.5H3.25167V6.375C3.25167 6.02982 3.53149 5.75 3.87667 5.75H7.00167V7C7.00167 7.34518 7.28149 7.625 7.62667 7.625C7.97185 7.625 8.25167 7.34518 8.25167 7V5.75H15.7517ZM20.7517 10.75V20.125C20.7517 20.4702 20.4718 20.75 20.1267 20.75H3.87667C3.53149 20.75 3.25167 20.4702 3.25167 20.125V10.75H20.7517Z" })
  ] });
});
CalendarIcon$1.displayName = "CalendarIcon";
const CaretDownIcon = forwardRef((props, ref2) => {
  const defaultFill = `var(${TOKENS.color.foreground.default}, ${ICON_FILL_DEFAULT})`;
  const {
    size: size2,
    title,
    ...rest
  } = props;
  const mappedSizeOrDefault = size2 ? ICON_SIZE_MAPPINGS[size2] : ICON_SIZE_DEFAULT;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { width: mappedSizeOrDefault, height: mappedSizeOrDefault, viewBox: "0 0 24 24", fill: defaultFill, xmlns: "http://www.w3.org/2000/svg", role: "img", "aria-label": "Caret Down Icon", ...rest, ref: ref2, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("title", { children: title || "Caret Down Icon" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.18304 7.65058C2.4271 7.40649 2.82283 7.40647 3.06692 7.65054L12 16.5828L20.9331 7.65054C21.1772 7.40647 21.5729 7.40649 21.817 7.65058C22.061 7.89467 22.061 8.29039 21.8169 8.53446L12.8839 17.4666C12.8838 17.4667 12.8837 17.4669 12.8836 17.467C12.7676 17.583 12.63 17.675 12.4784 17.7379C12.3268 17.8008 12.1642 17.8331 12 17.8331C11.8358 17.8331 11.6732 17.8008 11.5216 17.7379C11.37 17.675 11.2324 17.583 11.1164 17.467C11.1163 17.4669 11.1162 17.4667 11.1161 17.4666L2.18308 8.53446C1.93899 8.29039 1.93897 7.89467 2.18304 7.65058Z" })
  ] });
});
CaretDownIcon.displayName = "CaretDownIcon";
const CaretLeftCircleIcon = forwardRef((props, ref2) => {
  const defaultFill = `var(${TOKENS.color.foreground.default}, ${ICON_FILL_DEFAULT})`;
  const {
    size: size2,
    title,
    ...rest
  } = props;
  const mappedSizeOrDefault = size2 ? ICON_SIZE_MAPPINGS[size2] : ICON_SIZE_DEFAULT;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { width: mappedSizeOrDefault, height: mappedSizeOrDefault, viewBox: "0 0 43 44", stroke: defaultFill, xmlns: "http://www.w3.org/2000/svg", role: "img", fill: "transparent", "aria-label": "caret left circle Icon", ...rest, ref: ref2, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("title", { children: title || "caret left circle Icon" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M42 22C42 33.3218 32.8218 42.5 21.5 42.5C10.1782 42.5 1 33.3218 1 22C1 10.6782 10.1782 1.5 21.5 1.5C32.8218 1.5 42 10.6782 42 22Z", strokeWidth: "2" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M24 28.5L18 22.5L24 16.5", strokeWidth: "2" })
  ] });
});
CaretLeftCircleIcon.displayName = "CaretLeftCircleIcon";
const CaretLeftIcon = forwardRef((props, ref2) => {
  const defaultFill = `var(${TOKENS.color.foreground.default}, ${ICON_FILL_DEFAULT})`;
  const {
    size: size2,
    title,
    ...rest
  } = props;
  const mappedSizeOrDefault = size2 ? ICON_SIZE_MAPPINGS[size2] : ICON_SIZE_DEFAULT;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { width: mappedSizeOrDefault, height: mappedSizeOrDefault, viewBox: "0 0 24 24", fill: defaultFill, xmlns: "http://www.w3.org/2000/svg", role: "img", "aria-label": "Caret  Left Icon", ...rest, ref: ref2, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("title", { children: title || "Caret  Left Icon" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15.9836 2.18306C16.2277 2.42714 16.2277 2.82286 15.9836 3.06694L7.05055 12L15.9836 20.9331C16.2277 21.1771 16.2277 21.5729 15.9836 21.8169C15.7395 22.061 15.3438 22.061 15.0997 21.8169L6.1667 12.8839C6.16667 12.8839 6.16664 12.8839 6.16661 12.8838C6.05047 12.7678 5.95833 12.6301 5.89546 12.4784C5.83257 12.3268 5.8002 12.1642 5.8002 12C5.8002 11.8358 5.83257 11.6732 5.89546 11.5216C5.95833 11.3699 6.05047 11.2322 6.16661 11.1162C6.16664 11.1161 6.16667 11.1161 6.1667 11.1161L15.0997 2.18306C15.3438 1.93898 15.7395 1.93898 15.9836 2.18306Z" })
  ] });
});
CaretLeftIcon.displayName = "CaretLeftIcon";
const CaretRightCircleIcon = forwardRef((props, ref2) => {
  const defaultFill = `var(${TOKENS.color.foreground.default}, ${ICON_FILL_DEFAULT})`;
  const {
    size: size2,
    title,
    ...rest
  } = props;
  const mappedSizeOrDefault = size2 ? ICON_SIZE_MAPPINGS[size2] : ICON_SIZE_DEFAULT;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { width: mappedSizeOrDefault, height: mappedSizeOrDefault, viewBox: "0 0 43 44", stroke: defaultFill, fill: "transparent", xmlns: "http://www.w3.org/2000/svg", role: "img", "aria-label": "caret right circle Icon", ...rest, ref: ref2, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("title", { children: title || "caret right circle Icon" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M42 22C42 33.3218 32.8218 42.5 21.5 42.5C10.1782 42.5 1 33.3218 1 22C1 10.6782 10.1782 1.5 21.5 1.5C32.8218 1.5 42 10.6782 42 22Z", strokeWidth: "2" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M19 28L25 22L19 16", strokeWidth: "2" })
  ] });
});
CaretRightCircleIcon.displayName = "CaretRightCircleIcon";
const CaretRightIcon = forwardRef((props, ref2) => {
  const defaultFill = `var(${TOKENS.color.foreground.default}, ${ICON_FILL_DEFAULT})`;
  const {
    size: size2,
    title,
    ...rest
  } = props;
  const mappedSizeOrDefault = size2 ? ICON_SIZE_MAPPINGS[size2] : ICON_SIZE_DEFAULT;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { width: mappedSizeOrDefault, height: mappedSizeOrDefault, viewBox: "0 0 24 24", fill: defaultFill, xmlns: "http://www.w3.org/2000/svg", role: "img", "aria-label": "Caret  Right Icon", ...rest, ref: ref2, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("title", { children: title || "Caret  Right Icon" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.14139 2.18306C6.38546 1.93898 6.78119 1.93898 7.02527 2.18306L15.9583 11.1161C15.9584 11.1162 15.9585 11.1163 15.9586 11.1164C16.0746 11.2323 16.1667 11.37 16.2295 11.5216C16.2924 11.6732 16.3248 11.8358 16.3248 12C16.3248 12.1642 16.2924 12.3268 16.2295 12.4784C16.1667 12.63 16.0746 12.7677 15.9586 12.8836C15.9585 12.8837 15.9584 12.8838 15.9583 12.8839L7.02527 21.8169C6.78119 22.061 6.38546 22.061 6.14139 21.8169C5.89731 21.5729 5.89731 21.1771 6.14139 20.9331L15.0744 12L6.14139 3.06694C5.89731 2.82286 5.89731 2.42714 6.14139 2.18306Z" })
  ] });
});
CaretRightIcon.displayName = "CaretRightIcon";
const CaretUpIcon = forwardRef((props, ref2) => {
  const defaultFill = `var(${TOKENS.color.foreground.default}, ${ICON_FILL_DEFAULT})`;
  const {
    size: size2,
    title,
    ...rest
  } = props;
  const mappedSizeOrDefault = size2 ? ICON_SIZE_MAPPINGS[size2] : ICON_SIZE_DEFAULT;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { width: mappedSizeOrDefault, height: mappedSizeOrDefault, viewBox: "0 0 24 24", fill: defaultFill, xmlns: "http://www.w3.org/2000/svg", role: "img", "aria-label": "Caret  Up Icon", ...rest, ref: ref2, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("title", { children: title || "Caret  Up Icon" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 7.83388L3.06692 16.7661C2.82283 17.0102 2.4271 17.0102 2.18304 16.7661C1.93897 16.522 1.93899 16.1263 2.18308 15.8822L11.1161 6.95004C11.1162 6.94993 11.1163 6.94982 11.1164 6.9497C11.2324 6.83368 11.37 6.74162 11.5216 6.6788C11.6732 6.61591 11.8358 6.58354 12 6.58354C12.1642 6.58354 12.3268 6.61591 12.4784 6.6788C12.6301 6.74168 12.7679 6.83386 12.8839 6.95004L21.8169 15.8822C22.061 16.1263 22.061 16.522 21.817 16.7661C21.5729 17.0102 21.1772 17.0102 20.9331 16.7661L12 7.83388Z" })
  ] });
});
CaretUpIcon.displayName = "CaretUpIcon";
const CashPaymentIcon = forwardRef((props, ref2) => {
  const defaultFill = `var(${TOKENS.color.foreground.default}, ${ICON_FILL_DEFAULT})`;
  const {
    size: size2,
    title,
    ...rest
  } = props;
  const mappedSizeOrDefault = size2 ? ICON_SIZE_MAPPINGS[size2] : ICON_SIZE_DEFAULT;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { width: mappedSizeOrDefault, height: mappedSizeOrDefault, viewBox: "0 0 24 24", fill: defaultFill, xmlns: "http://www.w3.org/2000/svg", role: "img", "aria-label": "Chat Filled Icon", ...rest, ref: ref2, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("title", { children: title || "Cash Payment Icon" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.0631 5.64302C12.3072 5.39894 12.7029 5.39894 12.947 5.64302L15.5986 8.29469C15.7158 8.4119 15.7817 8.57087 15.7817 8.73663C15.7817 8.90239 15.7158 9.06136 15.5986 9.17857L10.2953 14.4819C10.2152 14.562 10.1148 14.6189 10.0048 14.6463L6.469 15.5297C6.25601 15.5829 6.03073 15.5204 5.87552 15.3652C5.7203 15.2099 5.65793 14.9846 5.7112 14.7716L6.59536 11.2366C6.62284 11.1268 6.67966 11.0264 6.75974 10.9464L12.0631 5.64302ZM7.76601 11.7079L7.17658 14.0645L9.53386 13.4756L14.2728 8.73663L12.505 6.96884L7.76601 11.7079Z", fill: "#282624" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M17.8081 5.20064C18.0521 4.95656 18.4479 4.95656 18.6919 5.20064L19.5761 6.0848C20.3081 6.81699 20.3081 8.00393 19.5762 8.73612L16.8169 11.4954C16.5729 11.7394 16.1771 11.7394 15.9331 11.4954C15.689 11.2513 15.689 10.8555 15.9331 10.6115L18.6922 7.85237C18.6921 7.85239 18.6922 7.85235 18.6922 7.85237C18.9361 7.6083 18.9361 7.21266 18.6922 6.96862L17.8081 6.08452C17.564 5.84044 17.564 5.44471 17.8081 5.20064Z", fill: "#282624" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15.1565 2.54897C15.8887 1.81701 17.0755 1.81701 17.8077 2.54897L18.6919 3.43321C19.4239 4.1654 19.424 5.35234 18.692 6.08453L15.5987 9.1787C15.3546 9.42281 14.9589 9.42286 14.7148 9.17882C14.4707 8.93477 14.4706 8.53905 14.7147 8.29494L17.808 5.20077C18.052 4.95673 18.052 4.56116 17.8081 4.31709M16.9239 3.43292L17.8081 4.31709L16.9239 3.43292ZM16.9239 3.43292C16.6798 3.18901 16.2843 3.18903 16.0402 3.43298L12.9469 6.52549C12.7028 6.76953 12.307 6.76948 12.063 6.52537C11.819 6.28126 11.819 5.88553 12.0631 5.64148L15.1565 2.54897", fill: "#282624" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2 11.375C2 10.3395 2.83947 9.5 3.875 9.5H5.125C5.47018 9.5 5.75 9.77982 5.75 10.125C5.75 10.4702 5.47018 10.75 5.125 10.75H3.875C3.52982 10.75 3.25 11.0298 3.25 11.375V20.125C3.25 20.4702 3.52982 20.75 3.875 20.75H20.125C20.4702 20.75 20.75 20.4702 20.75 20.125V11.375C20.75 11.0298 20.4702 10.75 20.125 10.75C19.7798 10.75 19.5 10.4702 19.5 10.125C19.5 9.77982 19.7798 9.5 20.125 9.5C21.1605 9.5 22 10.3395 22 11.375V20.125C22 21.1605 21.1605 22 20.125 22H3.875C2.83947 22 2 21.1605 2 20.125V11.375Z", fill: "#282624" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.125 18.25C10.125 17.9048 10.4048 17.625 10.75 17.625H18.875C19.2202 17.625 19.5 17.9048 19.5 18.25C19.5 18.5952 19.2202 18.875 18.875 18.875H10.75C10.4048 18.875 10.125 18.5952 10.125 18.25Z", fill: "#282624" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.625 15.125C12.625 14.7798 12.9048 14.5 13.25 14.5H18.875C19.2202 14.5 19.5 14.7798 19.5 15.125C19.5 15.4702 19.2202 15.75 18.875 15.75H13.25C12.9048 15.75 12.625 15.4702 12.625 15.125Z", fill: "#282624" })
  ] });
});
CashPaymentIcon.displayName = "CashPaymentIcon";
const CertifiedRibbonIcon = forwardRef((props, ref2) => {
  const defaultFill = `var(${TOKENS.color.foreground.default}, ${ICON_FILL_DEFAULT})`;
  const {
    size: size2,
    title,
    ...rest
  } = props;
  const mappedSizeOrDefault = size2 ? ICON_SIZE_MAPPINGS[size2] : ICON_SIZE_DEFAULT;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { width: mappedSizeOrDefault, height: mappedSizeOrDefault, viewBox: "0 0 24 24", fill: defaultFill, xmlns: "http://www.w3.org/2000/svg", role: "img", "aria-label": "Certified Ribbon Icon", ...rest, ref: ref2, version: "1.1", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("title", { children: title || "Certified Ribbon Icon" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M10.57,9.062c-0.244-0.244-0.64-0.244-0.884,0s-0.244,0.64,0,0.884l1.43,1.43\n		c0.232,0.233,0.555,0.367,0.884,0.367s0.651-0.134,0.883-0.366l4.552-4.551c0.243-0.244,0.243-0.64,0-0.884\n		c-0.244-0.244-0.641-0.244-0.885,0l-4.549,4.551L10.57,9.062z" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M21.844,16.597l-2.86-3.496l0.059-0.039c0.489-0.32,0.692-0.947,0.483-1.491l-0.702-1.844\n		c-0.122-0.323-0.485-0.484-0.807-0.361c-0.322,0.123-0.484,0.484-0.361,0.807l0.703,1.843l-1.652,1.081\n		c-0.129,0.084-0.222,0.212-0.262,0.36l-0.514,1.905l-1.972-0.099c-0.155-0.015-0.304,0.041-0.424,0.138l-1.535,1.238l-1.537-1.241\n		c-0.119-0.097-0.272-0.149-0.424-0.138l-1.97,0.1l-0.516-1.905c-0.04-0.148-0.133-0.276-0.261-0.359l-1.652-1.082l0.702-1.841\n		c0.055-0.143,0.055-0.302,0-0.445L5.642,7.88l1.652-1.082c0.128-0.084,0.221-0.212,0.261-0.359l0.514-1.905l1.971,0.103\n		c0.154,0.007,0.304-0.041,0.424-0.137L12,3.265L13.537,4.5c0.269,0.216,0.661,0.174,0.879-0.096\n		c0.216-0.269,0.173-0.663-0.096-0.879l-1.536-1.234c-0.454-0.365-1.113-0.366-1.567,0L9.866,3.376l-1.734-0.09\n		c-0.578-0.041-1.115,0.358-1.267,0.92L6.411,5.883L4.958,6.834C4.466,7.154,4.263,7.785,4.474,8.328l0.617,1.623l-0.617,1.618\n		c-0.208,0.545-0.005,1.172,0.483,1.49l0.061,0.04l-2.862,3.498c-0.139,0.17-0.179,0.399-0.104,0.606\n		c0.074,0.206,0.25,0.359,0.466,0.402l2.765,0.553l1.133,3.398c0.076,0.229,0.278,0.395,0.518,0.423\n		c0.025,0.003,0.05,0.005,0.075,0.005c0.213,0,0.414-0.108,0.529-0.292l2.945-4.673l0.735,0.594\n		c0.227,0.183,0.505,0.273,0.783,0.273c0.279,0,0.557-0.092,0.784-0.274l0.735-0.592l2.945,4.672\n		c0.115,0.184,0.315,0.292,0.528,0.292c0.024,0,0.05-0.002,0.075-0.005c0.239-0.028,0.441-0.193,0.518-0.423l1.134-3.398\n		l2.765-0.553c0.215-0.043,0.392-0.196,0.466-0.402C22.022,16.996,21.983,16.767,21.844,16.597z M7.184,19.909l-0.831-2.49\n		c-0.071-0.213-0.25-0.372-0.47-0.416l-2.101-0.42l2.287-2.796l0.341,0.224l0.454,1.676c0.152,0.563,0.688,0.95,1.268,0.921\n		l1.169-0.059L7.184,19.909z M18.117,17.003c-0.22,0.044-0.399,0.203-0.47,0.416l-0.831,2.49L14.7,16.552l1.171,0.059\n		c0.585,0.027,1.109-0.35,1.266-0.922l0.453-1.676l0.342-0.224l2.286,2.794L18.117,17.003z" })
  ] });
});
CertifiedRibbonIcon.displayName = "CertifiedRibbonIcon";
const ChatFilledIcon = forwardRef((props, ref2) => {
  const defaultFill = "#ffffff";
  const {
    size: size2,
    title,
    ...rest
  } = props;
  const mappedSizeOrDefault = size2 ? ICON_SIZE_MAPPINGS[size2] : ICON_SIZE_DEFAULT;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { width: mappedSizeOrDefault, height: mappedSizeOrDefault, viewBox: "0 0 24 24", fill: defaultFill, xmlns: "http://www.w3.org/2000/svg", role: "img", "aria-label": "Chat Filled Icon", ...rest, ref: ref2, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("title", { children: title || "Chat Filled Icon" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M23.5 17.5C23.5 18.0523 23.0523 18.5 22.5 18.5H11.5L7.5 22.5V18.5H1.5C0.947715 18.5 0.5 18.0523 0.5 17.5V2.5C0.5 1.94772 0.947715 1.5 1.5 1.5H22.5C23.0523 1.5 23.5 1.94772 23.5 2.5V17.5Z" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6 10.5C6.82843 10.5 7.5 9.82843 7.5 9C7.5 8.17157 6.82843 7.5 6 7.5C5.17157 7.5 4.5 8.17157 4.5 9C4.5 9.82843 5.17157 10.5 6 10.5Z" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 10.5C12.8284 10.5 13.5 9.82843 13.5 9C13.5 8.17157 12.8284 7.5 12 7.5C11.1716 7.5 10.5 8.17157 10.5 9C10.5 9.82843 11.1716 10.5 12 10.5Z" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M18 10.5C18.8284 10.5 19.5 9.82843 19.5 9C19.5 8.17157 18.8284 7.5 18 7.5C17.1716 7.5 16.5 8.17157 16.5 9C16.5 9.82843 17.1716 10.5 18 10.5Z" })
  ] });
});
ChatFilledIcon.displayName = "ChatFilledIcon";
const ChatIcon = forwardRef((props, ref2) => {
  const defaultFill = `var(${TOKENS.color.foreground.default}, ${ICON_FILL_DEFAULT})`;
  const {
    size: size2,
    title,
    ...rest
  } = props;
  const mappedSizeOrDefault = size2 ? ICON_SIZE_MAPPINGS[size2] : ICON_SIZE_DEFAULT;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { fill: defaultFill, role: "img", "aria-label": "Chat Icon", ...rest, ref: ref2, height: mappedSizeOrDefault, width: mappedSizeOrDefault, viewBox: "0 0 24 24", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("title", { children: title || "Chat Icon" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M7.5 23h-.2c-.2-.1-.3-.3-.3-.5V19H1.5C.7 19 0 18.3 0 17.5v-15C0 1.7.7 1 1.5 1h21c.8 0 1.5.7 1.5 1.5v15c0 .8-.7 1.5-1.5 1.5H11.7l-3.9 3.9s-.2.1-.3.1zm-6-21c-.3 0-.5.2-.5.5v15c0 .3.2.5.5.5h6c.3 0 .5.2.5.5v2.8l3.1-3.1c.1-.1.2-.1.4-.1h11c.3 0 .5-.2.5-.5v-15c0-.4-.2-.6-.5-.6h-21z", className: "st0" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M6 11c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm0-3c-.6 0-1 .4-1 1s.4 1 1 1 1-.4 1-1-.4-1-1-1zM12 11c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm0-3c-.6 0-1 .4-1 1s.4 1 1 1 1-.4 1-1-.4-1-1-1zM18 11c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm0-3c-.6 0-1 .4-1 1s.4 1 1 1 1-.4 1-1-.4-1-1-1z", className: "st0" })
  ] });
});
ChatIcon.displayName = "ChatIcon";
const CheckmarkCircleIcon = forwardRef((props, ref2) => {
  const defaultFill = `var(${TOKENS.color.foreground.default}, ${ICON_FILL_DEFAULT})`;
  const {
    size: size2,
    title,
    ...rest
  } = props;
  const mappedSizeOrDefault = size2 ? ICON_SIZE_MAPPINGS[size2] : ICON_SIZE_DEFAULT;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { width: mappedSizeOrDefault, height: mappedSizeOrDefault, viewBox: "0 0 24 24", fill: defaultFill, xmlns: "http://www.w3.org/2000/svg", role: "img", "aria-label": "Checkmark Circle Icon", ...rest, ref: ref2, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("title", { children: title || "Checkmark Circle Icon" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 1.99916C9.34784 1.99916 6.8043 3.05273 4.92893 4.92809C3.05357 6.80346 2 9.347 2 11.9992C2 14.6513 3.05357 17.1949 4.92893 19.0702C6.8043 20.9456 9.34783 21.9992 12 21.9992C14.6522 21.9992 17.1957 20.9456 19.0711 19.0702C20.9464 17.1949 22 14.6513 22 11.9992C22 9.347 20.9464 6.80346 19.0711 4.92809C17.1957 3.05273 14.6522 1.99916 12 1.99916ZM5.81282 5.81198C7.45376 4.17103 9.67936 3.24916 12 3.24916C14.3206 3.24916 16.5462 4.17103 18.1872 5.81198C19.8281 7.45292 20.75 9.67852 20.75 11.9992C20.75 14.3198 19.8281 16.5454 18.1872 18.1863C16.5462 19.8273 14.3206 20.7492 12 20.7492C9.67936 20.7492 7.45376 19.8273 5.81282 18.1863C4.17187 16.5454 3.25 14.3198 3.25 11.9992C3.25 9.67852 4.17187 7.45292 5.81282 5.81198ZM17.4903 8.07755C17.7044 7.80674 17.6584 7.4137 17.3876 7.19966C17.1167 6.98562 16.7237 7.03164 16.5097 7.30244L9.97383 15.5716L9.97374 15.5715L9.96649 15.5811C9.94248 15.6127 9.91128 15.6381 9.87548 15.6552C9.83967 15.6723 9.8003 15.6806 9.76064 15.6794C9.72097 15.6782 9.68217 15.6676 9.64745 15.6484C9.61273 15.6292 9.5831 15.6019 9.56103 15.569L9.55257 15.5567L7.51091 12.6592C7.31208 12.377 6.92217 12.3094 6.64 12.5083C6.35783 12.7071 6.29027 13.097 6.48909 13.3792L8.52704 16.2714C8.65934 16.4666 8.83587 16.6279 9.04229 16.7421C9.25119 16.8577 9.48468 16.9217 9.72331 16.9289C9.96195 16.936 10.1988 16.886 10.4143 16.7831C10.6276 16.6812 10.8139 16.5302 10.9577 16.3426L17.4903 8.07755Z" })
  ] });
});
CheckmarkCircleIcon.displayName = "CheckmarkCircleIcon";
const CheckmarkIcon = forwardRef((props, ref2) => {
  const defaultFill = `var(${TOKENS.color.foreground.default}, ${ICON_FILL_DEFAULT})`;
  const {
    size: size2,
    title,
    ...rest
  } = props;
  const mappedSizeOrDefault = size2 ? ICON_SIZE_MAPPINGS[size2] : ICON_SIZE_DEFAULT;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { width: mappedSizeOrDefault, height: mappedSizeOrDefault, viewBox: "0 0 24 24", fill: defaultFill, xmlns: "http://www.w3.org/2000/svg", role: "img", "aria-label": "Checkmark Icon", ...rest, ref: ref2, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("title", { children: title || "Checkmark Icon" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M21.7334 2.11216C22.0162 2.31011 22.085 2.69982 21.887 2.98259L9.31133 20.947C9.3112 20.9472 9.31147 20.9468 9.31133 20.947C9.08887 21.2665 8.79332 21.5291 8.44977 21.7122C8.10601 21.8954 7.72364 21.9943 7.33416 22.0008C6.94468 22.0072 6.55925 21.921 6.20963 21.7493C5.86026 21.5776 5.55664 21.3255 5.32376 21.0136C5.32359 21.0134 5.32393 21.0139 5.32376 21.0136L2.12502 16.7492C1.9179 16.4731 1.97384 16.0813 2.24997 15.8742C2.5261 15.6671 2.91785 15.723 3.12498 15.9991L6.32509 20.2654C6.43959 20.4189 6.58891 20.5429 6.76077 20.6273C6.93261 20.7117 7.12207 20.7541 7.3135 20.7509C7.50494 20.7478 7.69289 20.6992 7.86185 20.6091C8.03082 20.5191 8.17596 20.3901 8.28533 20.233L8.28632 20.2316L20.863 2.26574C21.0609 1.98297 21.4506 1.9142 21.7334 2.11216Z" })
  ] });
});
CheckmarkIcon.displayName = "CheckmarkIcon";
const CheckmarkShorterIcon = forwardRef((props, ref2) => {
  const defaultFill = `var(${TOKENS.color.border.feedback.success}, ${ICON_FILL_DEFAULT})`;
  const {
    size: size2,
    title,
    ...rest
  } = props;
  const mappedSizeOrDefault = size2 ? ICON_SIZE_MAPPINGS[size2] : ICON_SIZE_DEFAULT;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", width: mappedSizeOrDefault, height: mappedSizeOrDefault, viewBox: "0 0 24 24", fill: defaultFill, role: "img", "aria-label": "Checkmark Shorter Icon", ...rest, ref: ref2, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("title", { children: title || "Checkmark Shorter Icon" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M10.6636 16.3474C10.5324 16.3474 10.4064 16.2958 10.3128 16.2038L6.81596 12.7602C6.61916 12.5666 6.61676 12.2498 6.81036 12.053C7.00396 11.8562 7.32116 11.8538 7.51756 12.0474L10.628 15.1106L16.9816 7.51335C17.1584 7.30175 17.474 7.27295 17.686 7.45055C17.8976 7.62775 17.926 7.94295 17.7488 8.15495L11.0472 16.1678C10.9576 16.275 10.8272 16.3398 10.6876 16.3466C10.6796 16.3474 10.6716 16.3474 10.6636 16.3474Z", fill: defaultFill })
  ] });
});
CheckmarkShorterIcon.displayName = "CheckmarkShorterIcon";
const ChildcareIcon = forwardRef((props, ref2) => {
  const defaultFill = `var(${TOKENS.color.foreground.default}, ${ICON_FILL_DEFAULT})`;
  const {
    size: size2,
    title,
    ...rest
  } = props;
  const mappedSizeOrDefault = size2 ? ICON_SIZE_MAPPINGS[size2] : ICON_SIZE_DEFAULT;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { width: mappedSizeOrDefault, height: mappedSizeOrDefault, viewBox: "0 0 48 48", fill: defaultFill, xmlns: "http://www.w3.org/2000/svg", role: "img", "aria-label": "Childcare Icon", ...rest, ref: ref2, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("title", { children: title || "Childcare Icon" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { className: "st0", d: "M42.161,33.707c1.431-1.283,2.339-3.139,2.339-5.207c0-3.287-2.28-6.044-5.339-6.792\n	c1.431-1.283,2.339-3.139,2.339-5.208c0-3.86-3.141-7-7-7h-5V3c0-1.378-1.121-2.5-2.5-2.5h-6c-1.378,0-2.5,1.122-2.5,2.5v6.5h-5\n	c-3.86,0-7,3.14-7,7c0,2.069,0.907,3.925,2.339,5.208C5.78,22.456,3.5,25.213,3.5,28.5c0,2.068,0.907,3.925,2.339,5.207\n	C2.78,34.456,0.5,37.214,0.5,40.5c0,3.859,3.14,7,7,7h33c3.859,0,7-3.141,7-7C47.5,37.214,45.22,34.456,42.161,33.707z M20.5,3\n	c0-0.276,0.224-0.5,0.5-0.5h6c0.275,0,0.5,0.224,0.5,0.5v6.5h-7V3z M8.5,16.5c0-2.757,2.243-5,5-5h21c2.757,0,5,2.243,5,5\n	s-2.243,5-5,5h-21C10.743,21.5,8.5,19.257,8.5,16.5z M5.5,28.5c0-2.757,2.243-5,5-5h27c2.757,0,5,2.243,5,5s-2.243,5-5,5h-27\n	C7.743,33.5,5.5,31.257,5.5,28.5z M40.5,45.5h-33c-2.757,0-5-2.243-5-5s2.243-5,5-5h33c2.757,0,5,2.243,5,5S43.257,45.5,40.5,45.5z" })
  ] });
});
ChildcareIcon.displayName = "ChildcareIcon";
const ClipboardIcon = forwardRef((props, ref2) => {
  const {
    size: size2,
    title,
    ...rest
  } = props;
  const mappedSizeOrDefault = size2 ? ICON_SIZE_MAPPINGS[size2] : ICON_SIZE_DEFAULT;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { width: mappedSizeOrDefault, height: mappedSizeOrDefault, viewBox: "0 0 48 48", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img", "aria-label": "Clipboard Icon", ...rest, ref: ref2, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("title", { children: title || "Clipboard Icon" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M20 47H3C1.89543 47 1 46.1046 1 45V7C1 5.89543 1.89543 5 3 5H7", stroke: "#282624", strokeLinecap: "round", strokeLinejoin: "round" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M31 5H35C36.1046 5 37 5.89543 37 7V27.0534", stroke: "#282624", strokeLinecap: "round", strokeLinejoin: "round" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M23 5C23 2.79086 21.2091 1 19 1C16.7909 1 15 2.79086 15 5H11V11H27V5H23Z", stroke: "#282624", strokeLinecap: "round", strokeLinejoin: "round" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M33 25.7455V10C33 9.44772 32.5523 9 32 9H27", stroke: "#282624", strokeLinecap: "round", strokeLinejoin: "round" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M11 9H6C5.44772 9 5 9.44772 5 10V42C5 42.5523 5.44772 43 6 43H20", stroke: "#282624", strokeLinecap: "round", strokeLinejoin: "round" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M11 16.9961H27", stroke: "#282624", strokeLinecap: "round", strokeLinejoin: "round" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M11 22.9961H23", stroke: "#282624", strokeLinecap: "round", strokeLinejoin: "round" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M11 28.9961H19", stroke: "#282624", strokeLinecap: "round", strokeLinejoin: "round" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M31.8541 47.1241C36.915 47.1241 41.0177 43.0214 41.0177 37.9605C41.0177 32.8996 36.915 28.7969 31.8541 28.7969C26.7931 28.7969 22.6904 32.8996 22.6904 37.9605C22.6904 43.0214 26.7931 47.1241 31.8541 47.1241Z", fill: "#8560D0", stroke: "#282624", strokeLinecap: "round", strokeLinejoin: "round" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M35.7823 34.0391L31.6593 39.7082C31.4766 39.9641 31.1896 40.1189 30.883 40.1459C30.5764 40.1661 30.2763 40.0516 30.0545 39.8294L27.9277 37.6345", stroke: "#282624", strokeLinecap: "round", strokeLinejoin: "round" })
  ] });
});
ClipboardIcon.displayName = "ClipboardIcon";
const ClockIcon = forwardRef((props, ref2) => {
  const defaultFill = `var(${TOKENS.color.foreground.default}, ${ICON_FILL_DEFAULT})`;
  const {
    size: size2,
    title,
    ...rest
  } = props;
  const mappedSizeOrDefault = size2 ? ICON_SIZE_MAPPINGS[size2] : ICON_SIZE_DEFAULT;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { width: mappedSizeOrDefault, height: mappedSizeOrDefault, viewBox: "0 0 24 24", fill: defaultFill, xmlns: "http://www.w3.org/2000/svg", role: "img", "aria-label": "Clock Icon", ...rest, ref: ref2, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("title", { children: title || "Clock Icon" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.37087 5.37087C7.12903 3.61272 9.5136 2.625 12 2.625C14.4864 2.625 16.871 3.61272 18.6291 5.37087C20.3873 7.12903 21.375 9.5136 21.375 12C21.375 14.4864 20.3873 16.871 18.6291 18.6291C16.871 20.3873 14.4864 21.375 12 21.375C9.5136 21.375 7.12903 20.3873 5.37087 18.6291C3.61272 16.871 2.625 14.4864 2.625 12C2.625 9.5136 3.61272 7.12903 5.37087 5.37087ZM12 3.875C9.84512 3.875 7.77849 4.73102 6.25476 6.25476C4.73102 7.77849 3.875 9.84512 3.875 12C3.875 14.1549 4.73102 16.2215 6.25476 17.7452C7.77849 19.269 9.84512 20.125 12 20.125C14.1549 20.125 16.2215 19.269 17.7452 17.7452C19.269 16.2215 20.125 14.1549 20.125 12C20.125 9.84512 19.269 7.77849 17.7452 6.25476C16.2215 4.73102 14.1549 3.875 12 3.875ZM12 8.25C12.3452 8.25 12.625 8.52982 12.625 8.875V11.7412L16.3478 15.4648C16.5919 15.7089 16.5918 16.1046 16.3477 16.3487C16.1036 16.5927 15.7079 16.5927 15.4638 16.3486L11.558 12.4419C11.4981 12.382 11.4529 12.3129 11.4224 12.2392C11.3921 12.1661 11.3753 12.086 11.375 12.002C11.375 12.0013 11.375 12.0007 11.375 12V8.875C11.375 8.52982 11.6548 8.25 12 8.25Z" })
  ] });
});
ClockIcon.displayName = "ClockIcon";
const CloseIcon = forwardRef((props, ref2) => {
  const defaultFill = `var(${TOKENS.color.foreground.default}, ${ICON_FILL_DEFAULT})`;
  const {
    size: size2,
    title,
    ...rest
  } = props;
  const mappedSizeOrDefault = size2 ? ICON_SIZE_MAPPINGS[size2] : ICON_SIZE_DEFAULT;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { width: mappedSizeOrDefault, height: mappedSizeOrDefault, viewBox: "0 0 24 24", fill: defaultFill, xmlns: "http://www.w3.org/2000/svg", role: "img", "aria-label": "Close Icon", ...rest, ref: ref2, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("title", { children: title || "Close Icon" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M21.8169 3.06612C22.061 2.82204 22.061 2.42631 21.8169 2.18223C21.5729 1.93816 21.1771 1.93816 20.9331 2.18223L12 11.1153L3.06694 2.18223C2.82286 1.93816 2.42714 1.93816 2.18306 2.18223C1.93898 2.42631 1.93898 2.82204 2.18306 3.06612L11.1161 11.9992L2.18306 20.9322C1.93898 21.1763 1.93898 21.572 2.18306 21.8161C2.42714 22.0602 2.82286 22.0602 3.06694 21.8161L12 12.8831L20.9331 21.8161C21.1771 22.0602 21.5729 22.0602 21.8169 21.8161C22.061 21.572 22.061 21.1763 21.8169 20.9322L12.8839 11.9992L21.8169 3.06612Z" })
  ] });
});
CloseIcon.displayName = "CloseIcon";
const ConfettiIcon = forwardRef((props, ref2) => {
  const defaultFill = `var(${TOKENS.color.foreground.default}, ${ICON_FILL_DEFAULT})`;
  const {
    size: size2,
    title,
    ...rest
  } = props;
  const mappedSizeOrDefault = size2 ? ICON_SIZE_MAPPINGS[size2] : ICON_SIZE_DEFAULT;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { width: mappedSizeOrDefault, height: mappedSizeOrDefault, viewBox: "0 0 22 22", xmlns: "http://www.w3.org/2000/svg", role: "img", "aria-label": "Confetti Icon", ...rest, fill: "none", ref: ref2, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs("title", { children: [
      " ",
      title || "Confetti Icon",
      " "
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M13.7509 15.0033L2.67252 20.9236C2.09852 21.2307 1.38364 21.0137 1.07652 20.4397C0.891016 20.0914 0.891016 19.6741 1.07739 19.3258L6.99589 8.2483M1.34838 20.7737C1.69838 21.0799 2.21463 21.1587 2.65213 20.9312C2.66088 20.9312 2.66088 20.9224 2.66963 20.9224L13.7559 15.0074M14.9224 11.1888C16.6182 9.4957 19.3657 9.4957 21.0623 11.1888M10.7965 7.07825C12.4923 5.38338 12.4932 2.635 10.7983 0.93925L10.7965 0.9375M16.3153 7.71788L19.3856 6.69588M14.2687 5.67309L15.2925 2.60184M7.46865 4.67463C7.5894 4.67463 7.68741 4.77263 7.68741 4.89338M7.46865 4.67463L7.68741 4.89338M7.46865 4.67463C7.3479 4.67463 7.2499 4.77263 7.2499 4.89338M7.46865 4.67463L7.2499 4.89338M7.68741 4.89338C7.68741 5.01413 7.5894 5.11213 7.46865 5.11213M7.68741 4.89338L7.46865 5.11213M7.2499 4.89338C7.2499 5.01413 7.3479 5.11213 7.46865 5.11213M7.2499 4.89338L7.46865 5.11213M14.0312 7.29963C14.1528 7.29963 14.2499 7.39763 14.2499 7.51838M14.0312 7.29963L14.2499 7.51838M14.0312 7.29963C13.9104 7.29963 13.8124 7.39763 13.8124 7.51838M14.0312 7.29963L13.8124 7.51838M14.2499 7.51838C14.2499 7.63913 14.1528 7.73713 14.0312 7.73713M14.2499 7.51838L14.0312 7.73713M13.8124 7.51838C13.8124 7.63913 13.9104 7.73713 14.0312 7.73713M13.8124 7.51838L14.0312 7.73713M17.5312 12.5501C17.6528 12.5501 17.7499 12.6472 17.7499 12.7688M17.5312 12.5501L17.7499 12.7688M17.5312 12.5501C17.4104 12.5501 17.3124 12.6472 17.3124 12.7688M17.5312 12.5501L17.3124 12.7688M17.7499 12.7688C17.7499 12.8896 17.6528 12.9876 17.5312 12.9876M17.7499 12.7688L17.5312 12.9876M17.3124 12.7688C17.3124 12.8896 17.4104 12.9876 17.5312 12.9876M17.3124 12.7688L17.5312 12.9876M17.9687 3.79963C18.0903 3.79963 18.1874 3.89763 18.1874 4.01838M17.9687 3.79963L18.1874 4.01838M17.9687 3.79963C17.8479 3.79963 17.7499 3.89763 17.7499 4.01838M17.9687 3.79963L17.7499 4.01838M18.1874 4.01838C18.1874 4.13913 18.0903 4.23713 17.9687 4.23713M18.1874 4.01838L17.9687 4.23713M17.7499 4.01838C17.7499 4.13913 17.8479 4.23713 17.9687 4.23713M17.7499 4.01838L17.9687 4.23713M7.16022 8.03323C8.01509 7.17835 10.2306 8.0096 12.1101 9.8891C13.9896 11.7686 14.8208 13.985 13.966 14.839C13.112 15.693 10.8965 14.8626 9.01697 12.9822C7.13747 11.1036 6.30622 8.88723 7.16022 8.03323Z", stroke: props.fill ?? defaultFill })
  ] });
});
ConfettiIcon.displayName = "ConfettiIcon";
const CopyIcon = forwardRef((props, ref2) => {
  const defaultFill = `var(${TOKENS.color.foreground.default}, ${ICON_FILL_DEFAULT})`;
  const {
    size: size2,
    title,
    ...rest
  } = props;
  const mappedSizeOrDefault = size2 ? ICON_SIZE_MAPPINGS[size2] : ICON_SIZE_DEFAULT;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { width: mappedSizeOrDefault, height: mappedSizeOrDefault, viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg", fill: defaultFill, role: "img", "aria-label": "Copy Icon", ref: ref2, ...rest, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("title", { children: title || "Copy Icon" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M0.357147 2.85715C0.357147 1.47643 1.47644 0.357147 2.85715 0.357147H11.9048C13.2855 0.357147 14.4048 1.47644 14.4048 2.85715V4.28572C14.4048 4.61446 14.1383 4.88096 13.8095 4.88096C13.4808 4.88096 13.2143 4.61446 13.2143 4.28572V2.85715C13.2143 2.13392 12.628 1.54762 11.9048 1.54762H2.85715C2.13392 1.54762 1.54762 2.13392 1.54762 2.85715V11.9048C1.54762 12.628 2.13392 13.2143 2.85715 13.2143H4.28572C4.61446 13.2143 4.88096 13.4808 4.88096 13.8095C4.88096 14.1383 4.61446 14.4048 4.28572 14.4048H2.85715C1.47644 14.4048 0.357147 13.2855 0.357147 11.9048V2.85715Z" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M17.6191 7.38094H8.09525C7.70076 7.38094 7.38097 7.70073 7.38097 8.09522V17.619C7.38097 18.0135 7.70076 18.3333 8.09525 18.3333H17.6191C18.0136 18.3333 18.3333 18.0135 18.3333 17.619V8.09522C18.3333 7.70073 18.0136 7.38094 17.6191 7.38094ZM8.09525 6.19046C7.04328 6.19046 6.19049 7.04325 6.19049 8.09522V17.619C6.19049 18.671 7.04328 19.5238 8.09525 19.5238H17.6191C18.671 19.5238 19.5238 18.671 19.5238 17.619V8.09522C19.5238 7.04325 18.671 6.19046 17.6191 6.19046H8.09525Z" })
  ] });
});
CopyIcon.displayName = "CopyIcon";
const CreditCardIcon = forwardRef((props, ref2) => {
  const defaultFill = `var(${TOKENS.color.foreground.default}, ${ICON_FILL_DEFAULT})`;
  const {
    size: size2,
    title,
    ...rest
  } = props;
  const mappedSizeOrDefault = size2 ? ICON_SIZE_MAPPINGS[size2] : ICON_SIZE_DEFAULT;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { width: mappedSizeOrDefault, height: mappedSizeOrDefault, viewBox: "0 0 24 24", fill: defaultFill, xmlns: "http://www.w3.org/2000/svg", role: "img", "aria-label": "Credit Card Icon", ...rest, ref: ref2, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("title", { children: title || "Credit Card Icon" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3.25 6.375C3.25 6.02982 3.52982 5.75 3.875 5.75H20.125C20.4702 5.75 20.75 6.02982 20.75 6.375V8.25H3.25V6.375ZM2 8.875V6.375C2 5.33947 2.83947 4.5 3.875 4.5H20.125C21.1605 4.5 22 5.33947 22 6.375V8.875V17.625C22 18.6605 21.1605 19.5 20.125 19.5H3.875C2.83947 19.5 2 18.6605 2 17.625V8.875ZM20.75 9.5V17.625C20.75 17.9702 20.4702 18.25 20.125 18.25H3.875C3.52982 18.25 3.25 17.9702 3.25 17.625V9.5H20.75ZM5.75 12.625C5.75 12.2798 6.02982 12 6.375 12H13.25C13.5952 12 13.875 12.2798 13.875 12.625C13.875 12.9702 13.5952 13.25 13.25 13.25H6.375C6.02982 13.25 5.75 12.9702 5.75 12.625ZM6.375 14.5C6.02982 14.5 5.75 14.7798 5.75 15.125C5.75 15.4702 6.02982 15.75 6.375 15.75H10.75C11.0952 15.75 11.375 15.4702 11.375 15.125C11.375 14.7798 11.0952 14.5 10.75 14.5H6.375Z" })
  ] });
});
CreditCardIcon.displayName = "CreditCardIcon";
const CreditScoreIcon = forwardRef((props, ref2) => {
  const defaultFill = `var(${TOKENS.color.foreground.default}, ${ICON_FILL_DEFAULT})`;
  const {
    size: size2,
    title,
    ...rest
  } = props;
  const mappedSizeOrDefault = size2 ? ICON_SIZE_MAPPINGS[size2] : ICON_SIZE_DEFAULT;
  return /* @__PURE__ */ jsxRuntimeExports.jsx("svg", { version: "1.1", id: "Layer_1", width: mappedSizeOrDefault, height: mappedSizeOrDefault, viewBox: "0 0 32 36", fill: defaultFill, ref: ref2, ...rest, children: /* @__PURE__ */ jsxRuntimeExports.jsxs("g", { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("title", { children: title || "Credit Score Icon" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M29.9 14.1V14C27.1 9.1 21.8 6 16 6 10.3 6 5 9.1 2.1 14 .7 16.4 0 19 0 21.8s.8 5.6 2.2 8c.1.1.3.2.5.2.1 0 .2 0 .3-.1l5.9-3.4c.1-.1.2-.2.2-.3 0-.1 0-.3-.1-.4-.7-1.2-1.1-2.6-1.1-4.1 0-1.4.4-2.7 1.1-3.9 1.4-2.5 4.1-4 7-4 2.9 0 5.5 1.5 7 3.9v.1c.7 1.2 1 2.5 1.1 3.9 0 1.4-.4 2.8-1.1 4.1-.1.1-.1.3-.1.4 0 .1.1.2.2.3l6 3.4c.1 0 .2.1.3.1.2 0 .4-.1.4-.3 1.5-2.4 2.2-5.2 2.2-8 0-2.6-.7-5.3-2.1-7.6zm-27 14.7C.5 24.5.5 19.3 2.8 15l5.1 2.9c-1.3 2.5-1.2 5.5.1 8.1l-5.1 2.8zm12.5-16c-2.9.2-5.6 1.7-7.1 4.1l-5-2.9c2.6-4.2 7.2-6.8 12.2-7v5.8zm1.1 0V7c5 .2 9.6 2.8 12.2 7l-5.1 2.9c-1.5-2.4-4.2-3.9-7.1-4.1zm12.6 16L24 25.9c1.3-2.5 1.4-5.5.1-8.1l.7-.4 4.4-2.5c2.3 4.4 2.3 9.6-.1 13.9z" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M19.7 17.9c-.8-.4-1.7-.1-2.1.7l-2.5 4.7-.9-1c-.5-.7-1.5-.8-2.2-.2-.7.5-.8 1.5-.3 2.2l2.3 2.9c.3.4.8.6 1.2.6h.2c.5 0 1-.4 1.3-.8l3.6-6.8c.5-1 .2-1.9-.6-2.3z" })
  ] }) });
});
CreditScoreIcon.displayName = "CreditScoreIcon";
const CursorIcon = forwardRef((props, ref2) => {
  const defaultFill = `var(${TOKENS.color.foreground.default}, ${ICON_FILL_DEFAULT})`;
  const {
    size: size2,
    title,
    ...rest
  } = props;
  const mappedSizeOrDefault = size2 ? ICON_SIZE_MAPPINGS[size2] : ICON_SIZE_DEFAULT;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { width: mappedSizeOrDefault, height: mappedSizeOrDefault, viewBox: "0 0 24 24", fill: defaultFill, xmlns: "http://www.w3.org/2000/svg", role: "img", "aria-label": "Cursor Icon", ...rest, ref: ref2, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("title", { children: title || "Cursor Icon" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.22022 4.10726C5.46217 4.05885 5.71304 4.08312 5.94121 4.17703L18.7127 9.43614C18.9031 9.51444 19.0712 9.63854 19.2021 9.79741C19.3329 9.95628 19.4226 10.145 19.463 10.3468C19.5034 10.5487 19.4933 10.7574 19.4337 10.9544C19.374 11.1514 19.2667 11.3306 19.1211 11.4761C19.1211 11.4761 19.1211 11.4761 19.1211 11.4761L16.6906 13.9067L19.3418 16.5579C19.3419 16.558 19.3418 16.5579 19.3418 16.5579C19.4579 16.674 19.5501 16.8119 19.613 16.9635C19.6758 17.1152 19.7082 17.2779 19.7082 17.4421C19.7082 17.6063 19.6758 17.7689 19.613 17.9206C19.5502 18.0722 19.4582 18.2099 19.3422 18.3259L18.4588 19.2101L18.4576 19.2113C18.223 19.4448 17.9055 19.5758 17.5746 19.5758C17.2436 19.5758 16.9262 19.4448 16.6916 19.2113L16.6905 19.2102L14.0391 16.5581L11.6089 18.9883C11.6088 18.9884 11.609 18.9882 11.6089 18.9883C11.4635 19.1338 11.2842 19.2414 11.0874 19.3011C10.8905 19.3609 10.6819 19.3711 10.4801 19.3309C10.2783 19.2907 10.0895 19.2012 9.93055 19.0705C9.7716 18.9398 9.64737 18.7719 9.5689 18.5817L4.30958 5.8088C4.21568 5.58062 4.19136 5.32966 4.23977 5.08771C4.28818 4.84576 4.40712 4.62355 4.58159 4.44908C4.75607 4.2746 4.97828 4.15567 5.22022 4.10726ZM5.46547 5.33296L10.7245 18.105L13.5972 15.2322C13.7145 15.115 13.8734 15.0492 14.0392 15.0492C14.205 15.0492 14.364 15.115 14.4812 15.2323L17.5734 18.3254C17.5734 18.3254 17.5734 18.3253 17.5734 18.3254C17.5737 18.3256 17.5742 18.3258 17.5746 18.3258C17.575 18.3258 17.5754 18.3257 17.5757 18.3254C17.5757 18.3254 17.5757 18.3254 17.5757 18.3254L18.4579 17.4424L15.3647 14.3486C15.1207 14.1045 15.1207 13.7088 15.3647 13.4647L18.2372 10.5922L5.46547 5.33296Z" })
  ] });
});
CursorIcon.displayName = "CursorIcon";
const DashboardIcon = forwardRef((props, ref2) => {
  const defaultFill = `var(${TOKENS.color.foreground.default}, ${ICON_FILL_DEFAULT})`;
  const {
    size: size2,
    title,
    ...rest
  } = props;
  const mappedSizeOrDefault = size2 ? ICON_SIZE_MAPPINGS[size2] : ICON_SIZE_DEFAULT;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { width: mappedSizeOrDefault, height: mappedSizeOrDefault, viewBox: "0 0 24 24", fill: defaultFill, xmlns: "http://www.w3.org/2000/svg", role: "img", "aria-label": "Dashboard Icon", ...rest, ref: ref2, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("title", { children: title || "Dashboard Icon" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M9.30934 14.5C9.68918 14.4981 10.0543 14.647 10.3244 14.914C10.5608 15.1477 10.7075 15.4552 10.7421 15.7855L10.75 15.9283V19.9496C10.7488 20.138 10.7106 20.3243 10.6374 20.4979C10.5642 20.6715 10.4575 20.8291 10.3238 20.9611C10.1897 21.0936 10.0308 21.1984 9.8567 21.2691C9.72594 21.3224 9.58825 21.3559 9.44916 21.3689L9.30979 21.3751L2.81317 21.3642C2.43361 21.3656 2.06898 21.2165 1.79932 20.9494C1.5633 20.7156 1.41695 20.4081 1.38273 20.0783L1.375 19.9358V15.9251C1.37598 15.7369 1.41404 15.5506 1.48703 15.3771C1.56001 15.2036 1.66648 15.0462 1.80005 14.9142C1.93399 14.7816 2.09276 14.6768 2.2673 14.6057C2.39808 14.5525 2.53575 14.519 2.67412 14.506L2.8125 14.5H9.30934ZM19.9342 9.50001C20.1252 9.5006 20.3123 9.53841 20.487 9.61136C20.6614 9.68429 20.8199 9.79089 20.9529 9.92477C21.0862 10.0588 21.1917 10.2179 21.2639 10.3933C21.3176 10.5244 21.3517 10.6625 21.3652 10.8023L21.3717 10.9425V19.9206C21.3724 20.3018 21.222 20.6679 20.9533 20.9385C20.7182 21.1753 20.4093 21.3222 20.0788 21.3565L19.936 21.3642L13.4338 21.375C13.2446 21.3747 13.0574 21.3369 12.8825 21.2641C12.7078 21.1913 12.5492 21.0847 12.4158 20.9506C12.2824 20.8165 12.1767 20.6574 12.1047 20.4823C12.0507 20.3509 12.0166 20.2125 12.0032 20.0727L11.9967 19.9325V10.9448C11.996 10.7557 12.0327 10.5683 12.1046 10.3928C12.1765 10.218 12.282 10.0591 12.4155 9.92474C12.5488 9.79065 12.7072 9.68414 12.8814 9.61136C13.0123 9.55666 13.1503 9.52171 13.2917 9.5074L13.4342 9.50001H19.9342ZM9.31566 15.75H2.80848C2.78464 15.7498 2.76086 15.7544 2.73852 15.7635C2.71643 15.7725 2.69638 15.7857 2.67915 15.8028C2.66207 15.8197 2.64852 15.8397 2.63925 15.8618L2.62869 15.8955L2.62499 15.9283V19.9326C2.62524 19.981 2.6447 20.0273 2.67899 20.0613C2.70193 20.084 2.73027 20.1 2.762 20.1082L2.81187 20.1142L9.31428 20.1251C9.33883 20.1252 9.36287 20.1206 9.38557 20.1113C9.4077 20.1023 9.42798 20.0889 9.44548 20.0716C9.4625 20.0549 9.47617 20.0347 9.48558 20.0123L9.49626 19.9784L9.50001 19.9458V15.9322C9.49971 15.8836 9.48013 15.8371 9.44563 15.803C9.42257 15.7802 9.39411 15.7641 9.36328 15.756L9.31566 15.75ZM19.9323 10.75H13.4361C13.4111 10.75 13.3865 10.7551 13.3633 10.7647C13.3404 10.7743 13.3195 10.7884 13.3021 10.8059C13.2843 10.8238 13.2703 10.8449 13.261 10.8676L13.2502 10.9036L13.2467 10.9425V19.9348C13.2466 19.9596 13.2514 19.9842 13.2609 20.0072C13.2703 20.0302 13.2843 20.0513 13.302 20.0691C13.3195 20.0867 13.3405 20.1008 13.3633 20.1103L13.3989 20.1213L13.434 20.125L19.9318 20.1142C19.9823 20.114 20.0306 20.0937 20.0663 20.0578C20.09 20.0339 20.1068 20.0043 20.1153 19.972L20.1217 19.9217V10.9408C20.1217 10.9158 20.1169 10.8909 20.1075 10.8681C20.098 10.8448 20.084 10.8238 20.0663 10.8059C20.0488 10.7883 20.0279 10.7743 20.0051 10.7647L19.9694 10.7538L19.9323 10.75ZM2.81205 1.37502L9.31591 1.38585C9.69731 1.38742 10.0625 1.54022 10.3313 1.81073C10.5666 2.04743 10.7113 2.35734 10.7433 2.68578L10.75 2.82751V11.8071C10.7508 12.1887 10.6 12.5551 10.3308 12.8257C10.0953 13.0624 9.78599 13.2088 9.45536 13.2425L9.3125 13.25H2.81133C2.62212 13.2497 2.43484 13.212 2.26022 13.1391C2.08578 13.0664 1.92737 12.96 1.79376 12.8258C1.6605 12.6917 1.55491 12.5328 1.48297 12.3578C1.42908 12.2266 1.39497 12.0884 1.38152 11.9486L1.37499 11.8083V2.81794C1.37462 2.62885 1.41148 2.44153 1.48349 2.26666C1.5555 2.0918 1.66125 1.93284 1.79467 1.79888C1.92812 1.66487 2.08667 1.55846 2.26122 1.48576C2.39214 1.43122 2.53015 1.39641 2.67075 1.38226L2.81205 1.37502ZM2.814 2.625L2.77755 2.62874L2.74189 2.63964C2.71889 2.64922 2.69799 2.66325 2.68036 2.68095C2.66276 2.69862 2.64881 2.7196 2.63932 2.74265L2.62859 2.77849L2.62499 2.81668V11.8102C2.62492 11.8351 2.62975 11.8598 2.63914 11.8827C2.64863 11.9057 2.66259 11.9267 2.67993 11.9442C2.69749 11.9618 2.71841 11.9759 2.74152 11.9855L2.77673 11.9963L2.8125 12H9.31047C9.36089 11.9999 9.40919 11.9797 9.44475 11.944C9.46839 11.9202 9.48511 11.8908 9.4936 11.8585L9.5 11.8083V2.82624C9.50011 2.77591 9.48024 2.7276 9.44476 2.6919C9.42111 2.66811 9.39181 2.65121 9.36044 2.64254L9.31229 2.63584L2.814 2.625ZM19.928 1.37502L20.0696 1.38101C20.3977 1.41118 20.7071 1.55377 20.9439 1.78694C21.1808 2.02013 21.3282 2.32728 21.3635 2.65843L21.3717 2.80168V6.82803C21.3688 7.20769 21.2155 7.57069 20.9453 7.83717C20.7089 8.07053 20.3998 8.21339 20.0745 8.24392L19.9342 8.2501H13.4386C13.2505 8.25134 13.0639 8.21561 12.8896 8.14484C12.7153 8.07403 12.5565 7.96952 12.423 7.83761C12.289 7.70546 12.1824 7.54819 12.1092 7.37478C12.0544 7.24468 12.0191 7.10742 12.0044 6.96602L11.9967 6.82335V2.80872C11.999 2.42919 12.1519 2.06614 12.4217 1.79948C12.6578 1.56601 12.9666 1.42293 13.2914 1.39212L13.4315 1.38585L19.928 1.37502ZM19.9335 2.625L13.4293 2.63585C13.3811 2.6356 13.3349 2.65446 13.3005 2.68841C13.2777 2.71093 13.2615 2.73888 13.2532 2.76815L13.2467 2.81252V6.81982C13.2468 6.84338 13.2517 6.86689 13.261 6.88897C13.2703 6.91102 13.2837 6.9309 13.301 6.94788C13.3178 6.96452 13.3379 6.97773 13.36 6.9867L13.3947 6.99681L13.4342 7.00006H19.938C19.9864 7.00035 20.0329 6.98144 20.0674 6.94738C20.0903 6.92475 20.1067 6.89665 20.1151 6.86744L20.1217 6.82335V2.80693C20.1213 2.75825 20.1016 2.71181 20.067 2.67775C20.0439 2.65499 20.0154 2.63897 19.9836 2.63093L19.9335 2.625Z" })
  ] });
});
DashboardIcon.displayName = "DashboardIcon";
const DecreaseFaceIcon = forwardRef((props, ref2) => {
  const defaultFill = `var(${TOKENS.color.foreground.default}, ${ICON_FILL_DEFAULT})`;
  const {
    size: size2,
    title,
    ...rest
  } = props;
  const mappedSizeOrDefault = size2 ? ICON_SIZE_MAPPINGS[size2] : ICON_SIZE_DEFAULT;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { width: mappedSizeOrDefault, height: mappedSizeOrDefault, viewBox: "0 0 24 24", fill: defaultFill, xmlns: "http://www.w3.org/2000/svg", role: "img", "aria-label": "decrease face Icon", ...rest, ref: ref2, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("title", { children: title || "decrease face Icon" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M3.6056 12.1076L3.69213 12.1799L8.54861 17.0406C8.70358 17.1955 8.89663 17.307 9.10858 17.3637C9.27792 17.4091 9.45445 17.4182 9.62694 17.391L9.75538 17.3637L14.4986 16.097C14.9309 15.9678 15.3901 15.9579 15.8276 16.0684C16.2025 16.1632 16.5496 16.3433 16.8421 16.5937L16.9836 16.7248L20.125 19.8669V17.625C20.125 17.3112 20.3563 17.0514 20.6576 17.0068L20.75 17C21.0638 17 21.3236 17.2313 21.3682 17.5326L21.375 17.625V21.375L21.3713 21.4436L21.3554 21.5309L21.3308 21.6064L21.2978 21.6761L21.2591 21.7377C21.2315 21.7762 21.1998 21.8114 21.1646 21.8427L21.1155 21.8821L21.0311 21.9334L20.971 21.9598L20.8763 21.9872L20.7794 21.9993L17 22C16.6548 22 16.375 21.7202 16.375 21.375C16.375 21.0612 16.6063 20.8014 16.9076 20.7568L17 20.75L19.241 20.7499L16.0998 17.6087C15.9402 17.4491 15.7403 17.3357 15.5214 17.2804C15.3463 17.2361 15.1642 17.2304 14.9786 17.2656L14.8388 17.2996L10.0784 18.5712C9.65461 18.6847 9.20849 18.6847 8.78499 18.5711C8.42179 18.4738 8.08605 18.2961 7.80209 18.0519L7.66454 17.9243L2.80787 13.0635C2.5639 12.8193 2.56406 12.4235 2.80825 12.1796C3.0253 11.9627 3.36209 11.9387 3.6056 12.1076ZM13.1965 2.45308C14.3459 2.89088 15.3569 3.629 16.1239 4.59044C16.8909 5.55189 17.3859 6.70153 17.5574 7.91957C17.7288 9.13757 17.5704 10.3792 17.0986 11.515C16.6268 12.6508 15.859 13.6393 14.8751 14.3774C14.599 14.5846 14.2072 14.5287 14.0001 14.2526C13.7929 13.9765 13.8488 13.5847 14.1249 13.3776C14.93 12.7736 15.5582 11.9648 15.9442 11.0356C16.3302 10.1063 16.4598 9.09033 16.3196 8.0938C16.1793 7.09723 15.7743 6.15661 15.1467 5.36997C14.5192 4.58335 13.692 3.97942 12.7515 3.62122C11.8111 3.26305 10.7918 3.16372 9.79995 3.3336C8.80807 3.50347 7.87992 3.93634 7.11227 4.58705C6.34462 5.23776 5.7656 6.08249 5.43559 7.03316C5.10557 7.98384 5.03662 9.00564 5.23595 9.992C5.30432 10.3303 5.08547 10.66 4.74713 10.7284C4.40879 10.7968 4.07908 10.5779 4.01071 10.2396C3.76709 9.03403 3.85136 7.78517 4.25471 6.62323C4.65807 5.4613 5.36576 4.42885 6.304 3.63353C7.24223 2.83821 8.37664 2.30916 9.58894 2.10154C10.8012 1.8939 12.0471 2.01531 13.1965 2.45308ZM9.5 12.0033C9.15482 12.0033 8.875 11.7235 8.875 11.3783C8.875 11.0645 9.10626 10.8047 9.40764 10.7601L9.5 10.7533L11.1932 10.7533C11.3079 10.7534 11.4191 10.7136 11.5078 10.6405C11.5961 10.5677 11.6564 10.4662 11.6781 10.3536C11.6999 10.2409 11.6818 10.1242 11.6268 10.0236C11.5856 9.9481 11.5256 9.88514 11.4533 9.84043L11.3772 9.80203L9.65587 9.11399C9.28038 8.96291 8.96917 8.68589 8.77558 8.33042C8.58201 7.97497 8.51815 7.56323 8.59496 7.16585C8.67176 6.76846 8.88445 6.41017 9.19652 6.15246C9.46191 5.93328 9.78513 5.79845 10.1251 5.76283C10.125 5.40815 10.4048 5.12833 10.75 5.12833C11.0638 5.12833 11.3236 5.35959 11.3682 5.66097L11.375 5.75333H12C12.3452 5.75333 12.625 6.03315 12.625 6.37833C12.625 6.69213 12.3937 6.95191 12.0924 6.99655L12 7.00333L10.3063 7.00333C10.1917 7.00341 10.0808 7.04335 9.99249 7.11627C9.90417 7.18921 9.84398 7.2906 9.82224 7.40305C9.80051 7.5155 9.81858 7.63202 9.87335 7.7326C9.91444 7.80805 9.97425 7.871 10.0459 7.91558L10.1211 7.95381L11.8413 8.64138C12.2176 8.79192 12.5297 9.06888 12.724 9.42463C12.9182 9.78036 12.9823 10.1926 12.9055 10.5906C12.8286 10.9887 12.6154 11.3476 12.3027 11.6051C12.0375 11.8238 11.7148 11.9582 11.3761 11.9938L11.375 12.0033C11.375 12.3485 11.0952 12.6283 10.75 12.6283C10.4362 12.6283 10.1764 12.397 10.1318 12.0957L10.125 12.0033L9.5 12.0033Z" })
  ] });
});
DecreaseFaceIcon.displayName = "DecreaseFaceIcon";
const DocumentIcon = forwardRef((props, ref2) => {
  const defaultFill = `var(${TOKENS.color.foreground.default}, ${ICON_FILL_DEFAULT})`;
  const {
    size: size2,
    title,
    ...rest
  } = props;
  const mappedSizeOrDefault = size2 ? ICON_SIZE_MAPPINGS[size2] : ICON_SIZE_DEFAULT;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { width: mappedSizeOrDefault, height: mappedSizeOrDefault, viewBox: "0 0 24 24", fill: defaultFill, xmlns: "http://www.w3.org/2000/svg", role: "img", "aria-label": "Document Icon", ...rest, ref: ref2, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("title", { children: title || "Document Icon" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M17.0379 3.25C17.2009 3.24991 17.3575 3.31353 17.4743 3.42728L17.4745 3.4275L19.936 5.82978L19.9363 5.83006C19.996 5.88828 20.0435 5.95787 20.0759 6.03473C20.1083 6.11156 20.125 6.19411 20.125 6.2775V6.27756V20.125C20.125 20.2908 20.0592 20.4497 19.9419 20.5669C19.8247 20.6842 19.6658 20.75 19.5 20.75H4.5C4.33424 20.75 4.17527 20.6842 4.05806 20.5669C3.94085 20.4497 3.875 20.2908 3.875 20.125V3.875C3.875 3.70924 3.94085 3.55027 4.05806 3.43306C4.17527 3.31585 4.33424 3.25 4.5 3.25H17.0375H17.0379ZM18.3471 2.5325C17.9968 2.19091 17.5268 1.99982 17.0375 2H17.0374H4.5C4.00272 2 3.52581 2.19754 3.17417 2.54918C2.82254 2.90081 2.625 3.37772 2.625 3.875V20.125C2.625 20.6223 2.82254 21.0992 3.17417 21.4508C3.5258 21.8025 4.00272 22 4.5 22H19.5C19.9973 22 20.4742 21.8025 20.8258 21.4508C21.1775 21.0992 21.375 20.6223 21.375 20.125V6.2775V6.27744C21.375 6.0272 21.3249 5.7795 21.2276 5.54894C21.1304 5.31849 20.9881 5.10982 20.809 4.93522L20.8088 4.93494L18.3474 2.53272L18.3471 2.5325ZM7.03751 8.25C6.69233 8.25 6.41251 8.52982 6.41251 8.875C6.41251 9.22018 6.69233 9.5 7.03751 9.5H17.0375C17.3827 9.5 17.6625 9.22018 17.6625 8.875C17.6625 8.52982 17.3827 8.25 17.0375 8.25H7.03751ZM6.41251 12.625C6.41251 12.2798 6.69233 12 7.03751 12H17.0375C17.3827 12 17.6625 12.2798 17.6625 12.625C17.6625 12.9702 17.3827 13.25 17.0375 13.25H7.03751C6.69233 13.25 6.41251 12.9702 6.41251 12.625ZM7.03751 15.75C6.69233 15.75 6.41251 16.0298 6.41251 16.375C6.41251 16.7202 6.69233 17 7.03751 17H12.0375C12.3827 17 12.6625 16.7202 12.6625 16.375C12.6625 16.0298 12.3827 15.75 12.0375 15.75H7.03751Z" })
  ] });
});
DocumentIcon.displayName = "DocumentIcon";
const DocumentLoadingIcon = forwardRef((props, ref2) => {
  const defaultFill = `var(${TOKENS.color.foreground.default}, ${ICON_FILL_DEFAULT})`;
  const {
    size: size2,
    title,
    ...rest
  } = props;
  const mappedSizeOrDefault = size2 ? ICON_SIZE_MAPPINGS[size2] : ICON_SIZE_DEFAULT;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { width: mappedSizeOrDefault, height: mappedSizeOrDefault, viewBox: "0 0 24 24", fill: defaultFill, xmlns: "http://www.w3.org/2000/svg", role: "img", "aria-label": "Document Loading Icon", ...rest, ref: ref2, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("title", { children: title || "Document Loading Icon" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3.43306 3.43306C3.55027 3.31585 3.70924 3.25 3.875 3.25H12.7324H12.7325C12.898 3.25007 13.0568 3.3158 13.1739 3.43278L13.174 3.43292L15.5671 5.82597C15.6841 5.9431 15.7499 6.1019 15.75 6.2675V6.26763V8.875C15.75 9.22018 16.0298 9.5 16.375 9.5C16.7202 9.5 17 9.22018 17 8.875V6.2675V6.26737C16.9999 5.77043 16.8025 5.29386 16.4513 4.94237L16.4511 4.94222L14.0578 2.54889L14.0576 2.54875C13.7061 2.19748 13.2296 2.00011 12.7326 2H12.7325H3.875C3.37772 2 2.90081 2.19754 2.54917 2.54917C2.19754 2.90081 2 3.37772 2 3.875V17.625C2 18.1223 2.19754 18.5992 2.54917 18.9508C2.9008 19.3025 3.37772 19.5 3.875 19.5H8.875C9.22018 19.5 9.5 19.2202 9.5 18.875C9.5 18.5298 9.22018 18.25 8.875 18.25H3.875C3.70924 18.25 3.55027 18.1842 3.43306 18.0669C3.31585 17.9497 3.25 17.7908 3.25 17.625V3.875C3.25 3.70924 3.31585 3.55027 3.43306 3.43306ZM16.2583 10.7505C17.5253 10.724 18.7643 11.1261 19.7742 11.8918C20.1389 12.1682 20.466 12.4862 20.75 12.8374V11.375C20.75 11.0298 21.0298 10.75 21.375 10.75C21.7202 10.75 22 11.0298 22 11.375V15.125C22 15.4702 21.7202 15.75 21.375 15.75H21.2307C21.2216 15.7502 21.2125 15.7502 21.2034 15.75H18.25C17.9048 15.75 17.625 15.4702 17.625 15.125C17.625 14.7798 17.9048 14.5 18.25 14.5H20.3293C20.03 13.8689 19.5821 13.3147 19.0191 12.8879C18.2336 12.2924 17.27 11.9796 16.2844 12.0003C15.2989 12.0209 14.3493 12.3738 13.5894 13.0017C12.8295 13.6295 12.3039 14.4956 12.0978 15.4596C11.8917 16.4235 12.0172 17.4288 12.4539 18.3125C12.8906 19.1963 13.6129 19.9066 14.5038 20.3284C15.3947 20.7503 16.402 20.8589 17.3623 20.6367C18.3227 20.4145 19.1799 19.8745 19.7949 19.1042C20.0103 18.8344 20.4036 18.7904 20.6733 19.0058C20.9431 19.2211 20.9871 19.6144 20.7717 19.8841C19.9809 20.8745 18.8789 21.5688 17.6441 21.8545C16.4094 22.1402 15.1143 22.0006 13.9689 21.4582C12.8234 20.9158 11.8947 20.0025 11.3332 18.8663C10.7717 17.7301 10.6104 16.4376 10.8754 15.1982C11.1404 13.9589 11.8162 12.8453 12.7932 12.038C13.7702 11.2308 14.9912 10.7771 16.2583 10.7505Z" })
  ] });
});
DocumentLoadingIcon.displayName = "DocumentLoadingIcon";
const DollarIcon = forwardRef((props, ref2) => {
  const defaultFill = `var(${TOKENS.color.foreground.default}, ${ICON_FILL_DEFAULT})`;
  const {
    size: size2,
    title,
    ...rest
  } = props;
  const mappedSizeOrDefault = size2 ? ICON_SIZE_MAPPINGS[size2] : ICON_SIZE_DEFAULT;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { width: mappedSizeOrDefault, height: mappedSizeOrDefault, viewBox: "0 0 24 24", fill: defaultFill, xmlns: "http://www.w3.org/2000/svg", role: "img", "aria-label": "Dollar Icon", ...rest, ref: ref2, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("title", { children: title || "Dollar Icon" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 2C12.3452 2 12.625 2.27982 12.625 2.625V4.5H15.75C16.0952 4.5 16.375 4.77982 16.375 5.125C16.375 5.47018 16.0952 5.75 15.75 5.75H12H11C10.4364 5.75 9.89591 5.97388 9.4974 6.3724C9.09888 6.77091 8.875 7.31142 8.875 7.875C8.875 8.68297 9.22991 9.3004 9.8442 9.8635C10.4813 10.4475 11.3467 10.9274 12.3012 11.4524L12.3387 11.473C13.249 11.9736 14.2417 12.5195 15.0005 13.2151C15.7924 13.941 16.375 14.8705 16.375 16.125C16.375 17.0201 16.0194 17.8786 15.3865 18.5115C14.7535 19.1444 13.8951 19.5 13 19.5H12.625V21.375C12.625 21.7202 12.3452 22 12 22C11.6548 22 11.375 21.7202 11.375 21.375V19.5H8.25C7.90482 19.5 7.625 19.2202 7.625 18.875C7.625 18.5298 7.90482 18.25 8.25 18.25H12H13C13.5636 18.25 14.1041 18.0261 14.5026 17.6276C14.9011 17.2291 15.125 16.6886 15.125 16.125C15.125 15.317 14.7701 14.6996 14.1558 14.1365C13.5187 13.5525 12.6533 13.0726 11.6988 12.5476L11.6613 12.527C10.751 12.0264 9.75832 11.4805 8.99955 10.7849C8.20759 10.059 7.625 9.12953 7.625 7.875C7.625 6.97989 7.98058 6.12145 8.61351 5.48851C9.24645 4.85558 10.1049 4.5 11 4.5H11.375V2.625C11.375 2.27982 11.6548 2 12 2Z" })
  ] });
});
DollarIcon.displayName = "DollarIcon";
const DownloadDocumentIcon = forwardRef((props, ref2) => {
  const defaultFill = `var(${TOKENS.color.foreground.default}, ${ICON_FILL_DEFAULT})`;
  const {
    size: size2,
    title,
    ...rest
  } = props;
  const mappedSizeOrDefault = size2 ? ICON_SIZE_MAPPINGS[size2] : ICON_SIZE_DEFAULT;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { width: mappedSizeOrDefault, height: mappedSizeOrDefault, viewBox: "0 0 24 24", fill: defaultFill, xmlns: "http://www.w3.org/2000/svg", role: "img", "aria-label": "download document Icon", ...rest, ref: ref2, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("title", { children: title || "download document Icon" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3.43306 3.43306C3.55027 3.31585 3.70924 3.25 3.875 3.25H12.7324C12.8979 3.25007 13.0568 3.3158 13.1739 3.43278L15.5671 5.82597C15.6841 5.9431 15.7499 6.1019 15.75 6.2675V8.875C15.75 9.22018 16.0298 9.5 16.375 9.5C16.7202 9.5 17 9.22018 17 8.875V6.2675C16.9999 5.77057 16.8025 5.29386 16.4513 4.94237L14.0578 2.54889C13.7063 2.19762 13.2296 2.00011 12.7326 2H3.875C3.37772 2 2.90081 2.19754 2.54917 2.54917C2.19754 2.90081 2 3.37772 2 3.875V17.625C2 18.1223 2.19754 18.5992 2.54917 18.9508C2.9008 19.3025 3.37772 19.5 3.875 19.5H8.875C9.22018 19.5 9.5 19.2202 9.5 18.875C9.5 18.5298 9.22018 18.25 8.875 18.25H3.875C3.70924 18.25 3.55027 18.1842 3.43306 18.0669C3.31585 17.9497 3.25 17.7908 3.25 17.625V3.875C3.25 3.70924 3.31585 3.55027 3.43306 3.43306ZM12.3975 12.3975C13.4524 11.3426 14.8832 10.75 16.375 10.75C17.8668 10.75 19.2976 11.3426 20.3525 12.3975C21.4074 13.4524 22 14.8832 22 16.375C22 17.8668 21.4074 19.2976 20.3525 20.3525C19.2976 21.4074 17.8668 22 16.375 22C14.8832 22 13.4524 21.4074 12.3975 20.3525C11.3426 19.2976 10.75 17.8668 10.75 16.375C10.75 14.8832 11.3426 13.4524 12.3975 12.3975ZM16.375 12C15.2147 12 14.1019 12.4609 13.2814 13.2814C12.4609 14.1019 12 15.2147 12 16.375C12 17.5353 12.4609 18.6481 13.2814 19.4686C14.1019 20.2891 15.2147 20.75 16.375 20.75C17.5353 20.75 18.6481 20.2891 19.4686 19.4686C20.2891 18.6481 20.75 17.5353 20.75 16.375C20.75 15.2147 20.2891 14.1019 19.4686 13.2814C18.6481 12.4609 17.5353 12 16.375 12ZM16.375 13.25C16.7202 13.25 17 13.5298 17 13.875V17.3661L17.8081 16.5581C18.0521 16.314 18.4479 16.314 18.6919 16.5581C18.936 16.8021 18.936 17.1979 18.6919 17.4419L16.8169 19.3169C16.757 19.3769 16.688 19.4221 16.6142 19.4526C16.5452 19.4812 16.4698 19.4978 16.3908 19.4998L16.375 19.5C16.2903 19.5 16.2095 19.4831 16.1358 19.4526C16.062 19.4221 15.993 19.3769 15.9331 19.3169L14.0581 17.4419C13.814 17.1979 13.814 16.8021 14.0581 16.5581C14.3021 16.314 14.6979 16.314 14.9419 16.5581L15.75 17.3661V13.875C15.75 13.5298 16.0298 13.25 16.375 13.25Z" })
  ] });
});
DownloadDocumentIcon.displayName = "DownloadDocumentIcon";
const DownloadIcon = forwardRef((props, ref2) => {
  const defaultFill = `var(${TOKENS.color.foreground.default}, ${ICON_FILL_DEFAULT})`;
  const {
    size: size2,
    title,
    ...rest
  } = props;
  const mappedSizeOrDefault = size2 ? ICON_SIZE_MAPPINGS[size2] : ICON_SIZE_DEFAULT;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { width: mappedSizeOrDefault, height: mappedSizeOrDefault, viewBox: "0 0 24 24", fill: defaultFill, xmlns: "http://www.w3.org/2000/svg", role: "img", "aria-label": "Download Icon", ...rest, ref: ref2, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("title", { children: title || "Download Icon" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.0009 4.5C12.346 4.5 12.6259 4.77982 12.6259 5.125V13.6161L15.3089 10.9331C15.553 10.689 15.9487 10.689 16.1928 10.9331C16.4369 11.1771 16.4369 11.5729 16.1928 11.8169L12.4428 15.5669C12.3256 15.6842 12.1666 15.75 12.0009 15.75C11.8351 15.75 11.6761 15.6842 11.5589 15.5669L7.80891 11.8169C7.56484 11.5729 7.56484 11.1771 7.80891 10.9331C8.05299 10.689 8.44872 10.689 8.6928 10.9331L11.3759 13.6161V5.125C11.3759 4.77982 11.6557 4.5 12.0009 4.5ZM3.25085 15.125C3.25085 14.7798 2.97103 14.5 2.62585 14.5C2.28068 14.5 2.00085 14.7798 2.00085 15.125V16.375C2.00085 17.2038 2.33009 17.9987 2.91615 18.5847C3.5022 19.1708 4.29705 19.5 5.12585 19.5H18.8759C19.7047 19.5 20.4995 19.1708 21.0856 18.5847C21.6716 17.9987 22.0009 17.2038 22.0009 16.375V15.125C22.0009 14.7798 21.721 14.5 21.3759 14.5C21.0307 14.5 20.7509 14.7798 20.7509 15.125V16.375C20.7509 16.8723 20.5533 17.3492 20.2017 17.7008C19.85 18.0525 19.3731 18.25 18.8759 18.25H5.12585C4.62857 18.25 4.15166 18.0525 3.80003 17.7008C3.4484 17.3492 3.25085 16.8723 3.25085 16.375V15.125Z" })
  ] });
});
DownloadIcon.displayName = "DownloadIcon";
const EducationIcon = forwardRef((props, ref2) => {
  const defaultFill = `var(${TOKENS.color.foreground.default}, ${ICON_FILL_DEFAULT})`;
  const {
    size: size2,
    title,
    ...rest
  } = props;
  const mappedSizeOrDefault = size2 ? ICON_SIZE_MAPPINGS[size2] : ICON_SIZE_DEFAULT;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { width: mappedSizeOrDefault, height: mappedSizeOrDefault, viewBox: "0 0 56 56", fill: defaultFill, xmlns: "http://www.w3.org/2000/svg", role: "img", "aria-label": "Education Icon", ...rest, ref: ref2, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("title", { children: title || "Education Icon" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { className: "st0", d: "M54.24,19.01L28.628,8.988c-0.23-0.089-0.484-0.092-0.715-0.005L1.188,19.004\n	c-0.007,0.003-0.012,0.008-0.019,0.011c-0.029,0.012-0.052,0.03-0.079,0.045c-0.079,0.04-0.152,0.087-0.216,0.146\n	c-0.029,0.026-0.054,0.055-0.08,0.085c-0.054,0.061-0.098,0.128-0.135,0.2c-0.017,0.033-0.036,0.064-0.049,0.099\n	c-0.042,0.11-0.07,0.226-0.07,0.349c0,0.001,0,0.001,0,0.002v13.362c0,0.553,0.448,1,1,1s1-0.447,1-1V21.384l11.363,4.261v16.942\n	c0,0.439,0.287,0.828,0.708,0.956l13.363,4.08c0.095,0.029,0.193,0.044,0.292,0.044s0.197-0.015,0.292-0.044l13.363-4.08\n	c0.421-0.128,0.708-0.517,0.708-0.956V25.416l11.612-4.544c0.384-0.15,0.636-0.52,0.636-0.931S54.624,19.16,54.24,19.01z\n	 M40.628,41.847l-12.363,3.774l-12.363-3.774V26.395l12.011,4.504c0.113,0.042,0.232,0.063,0.351,0.063\n	c0.124,0,0.247-0.022,0.364-0.068l12-4.696V41.847z M28.256,28.892L4.387,19.941l23.869-8.951l22.875,8.951L28.256,28.892z" })
  ] });
});
EducationIcon.displayName = "EducationIcon";
const EldercareIcon = forwardRef((props, ref2) => {
  const defaultFill = `var(${TOKENS.color.foreground.default}, ${ICON_FILL_DEFAULT})`;
  const {
    size: size2,
    title,
    ...rest
  } = props;
  const mappedSizeOrDefault = size2 ? ICON_SIZE_MAPPINGS[size2] : ICON_SIZE_DEFAULT;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { width: mappedSizeOrDefault, height: mappedSizeOrDefault, viewBox: "0 0 48 49", fill: defaultFill, xmlns: "http://www.w3.org/2000/svg", role: "img", "aria-label": "Elder Care Icon", ...rest, ref: ref2, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("title", { children: title || "Elder Care Icon" }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("g", { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("path", { className: "st0", d: "M47.427,24.485c-0.77-3.013-3.119-5.363-6.133-6.132c-3.01-0.77-6.201,0.165-8.297,2.416l-6.326,6.326\n		c-0.014,0.013-0.033,0.017-0.047,0.031s-0.018,0.032-0.031,0.047l-6.35,6.35c-3.137,3.366-3.045,8.552,0.208,11.806\n		c1.665,1.665,3.835,2.501,6.009,2.501c2.074,0,4.152-0.762,5.796-2.293c0.009-0.008,0.018-0.016,0.025-0.024l6.361-6.362\n		c0.001-0.001,0.002-0.001,0.003-0.002s0.001-0.002,0.002-0.003l6.336-6.337C47.261,30.688,48.196,27.499,47.427,24.485z\n		 M30.882,44.084c-2.573,2.386-6.53,2.312-9.015-0.171c-2.488-2.488-2.558-6.454-0.184-9.003l5.657-5.657l9.187,9.186L30.882,44.084\n		z M37.94,37.025l-9.187-9.186l5.682-5.682c1.246-1.337,2.975-2.069,4.754-2.069c0.536,0,1.076,0.066,1.61,0.203\n		c2.304,0.589,4.101,2.386,4.689,4.69c0.589,2.304-0.127,4.742-1.893,6.388L37.94,37.025z" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("path", { className: "st0", d: "M26.5,14c0-7.168-5.832-13-13-13s-13,5.832-13,13s5.832,13,13,13S26.5,21.168,26.5,14z M13.5,25\n		c-6.065,0-11-4.935-11-11s4.935-11,11-11s11,4.935,11,11S19.565,25,13.5,25z" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("path", { className: "st0", d: "M18.804,13H14.5V8.696c0-0.552-0.448-1-1-1s-1,0.448-1,1V14c0,0.552,0.448,1,1,1h5.304c0.552,0,1-0.448,1-1\n		S19.356,13,18.804,13z" })
    ] })
  ] });
});
EldercareIcon.displayName = "EldercareIcon";
const EmailIcon = forwardRef((props, ref2) => {
  const defaultFill = `var(${TOKENS.color.foreground.default}, ${ICON_FILL_DEFAULT})`;
  const {
    size: size2,
    title,
    ...rest
  } = props;
  const mappedSizeOrDefault = size2 ? ICON_SIZE_MAPPINGS[size2] : ICON_SIZE_DEFAULT;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { width: mappedSizeOrDefault, height: mappedSizeOrDefault, viewBox: "0 0 24 24", fill: defaultFill, xmlns: "http://www.w3.org/2000/svg", role: "img", "aria-label": "Email Icon", ...rest, ref: ref2, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("title", { children: title || "Email Icon" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3.25 5.33333C2.90482 5.33333 2.625 5.61315 2.625 5.95833V18.4583C2.625 18.8035 2.90482 19.0833 3.25 19.0833H20.75C21.0952 19.0833 21.375 18.8035 21.375 18.4583V5.95833C21.375 5.61315 21.0952 5.33333 20.75 5.33333H3.25ZM3.875 7.46859V17.8333H20.125V7.46859L14.0619 12.132C13.4708 12.5868 12.7458 12.8334 12 12.8334C11.2542 12.8334 10.5292 12.5868 9.93808 12.132L3.875 7.46859ZM19.2257 6.58333H4.77433L10.7002 11.1413L10.7003 11.1413C11.0729 11.428 11.5299 11.5834 12 11.5834C12.4701 11.5834 12.9271 11.428 13.2998 11.1413L13.2998 11.1413L19.2257 6.58333Z" })
  ] });
});
EmailIcon.displayName = "EmailIcon";
const EncryptionIcon = forwardRef((props, ref2) => {
  const defaultFill = `var(${TOKENS.color.foreground.default}, ${ICON_FILL_DEFAULT})`;
  const {
    size: size2,
    title,
    ...rest
  } = props;
  const mappedSizeOrDefault = size2 ? ICON_SIZE_MAPPINGS[size2] : ICON_SIZE_DEFAULT;
  return /* @__PURE__ */ jsxRuntimeExports.jsx("svg", { version: "1.1", x: "0px", y: "0px", viewBox: "0 0 32 36", width: mappedSizeOrDefault, height: mappedSizeOrDefault, fill: defaultFill, ...rest, ref: ref2, children: /* @__PURE__ */ jsxRuntimeExports.jsxs("g", { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("title", { children: title || "Encryption Icon" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M27.8 9.1C21.6 9 17.6 4.7 16.5 3.3c-.2-.2-.5-.3-.7-.3s-.6.1-.8.3C13.9 4.7 9.9 9 3.7 9.1c-.4.1-.7.4-.7.8 0 10 3.4 15.6 6.2 18.6 1.7 1.9 3.9 3.3 6.4 4.1h.2c2.4-.8 4.6-2.2 6.4-4.1 2.8-3 6.3-8.6 6.3-18.6 0-.4-.3-.8-.7-.8zm-12 22.4c-2.2-.8-4.1-2.1-5.7-3.8-2.7-2.8-5.9-8.1-6-17.5 6.4-.3 10.5-4.7 11.7-6.1 1.2 1.5 5.3 5.9 11.7 6.1-.2 17-10.5 20.9-11.7 21.3z" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M12.2 14.3v2.5h-.1c-.3 0-.5.1-.7.3-.2.2-.3.4-.3.7v5.7c0 .3.1.5.3.7s.4.3.7.3h7.4c.3 0 .5-.1.7-.3.2-.2.3-.4.3-.7v-5.7c0-.3-.1-.5-.3-.7-.2-.2-.4-.3-.7-.3h-.1v-2.5c0-2-1.6-3.6-3.6-3.6s-3.6 1.6-3.6 3.6zm5.4 0v2.5h-3.7v-2.5c0-1 .8-1.9 1.9-1.9s1.8.9 1.8 1.9z" })
  ] }) });
});
EncryptionIcon.displayName = "EncryptionIcon";
const ErrorIcon = forwardRef((props, ref2) => {
  const defaultFill = `var(${TOKENS.color.foreground.default}, ${ICON_FILL_DEFAULT})`;
  const {
    size: size2,
    title,
    ...rest
  } = props;
  const mappedSizeOrDefault = size2 ? ICON_SIZE_MAPPINGS[size2] : ICON_SIZE_DEFAULT;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { width: mappedSizeOrDefault, height: mappedSizeOrDefault, viewBox: "0 0 24 24", fill: defaultFill, xmlns: "http://www.w3.org/2000/svg", role: "img", "aria-label": "Error Icon", ...rest, ref: ref2, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("title", { children: title || "Error Icon" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 2C9.34784 2 6.8043 3.05357 4.92893 4.92893C3.05357 6.8043 2 9.34784 2 12C2 14.6492 3.05124 17.1901 4.9227 19.0648C4.92475 19.0669 4.92681 19.069 4.92889 19.0711C4.93097 19.0732 4.93306 19.0753 4.93517 19.0773C6.80993 20.9488 9.35077 22 12 22C14.6522 22 17.1957 20.9464 19.0711 19.0711C20.9464 17.1957 22 14.6522 22 12C22 9.35077 20.9488 6.80993 19.0773 4.93517C19.0753 4.93306 19.0732 4.93097 19.0711 4.92889C19.069 4.92681 19.0669 4.92475 19.0648 4.9227C17.1901 3.05124 14.6492 2 12 2ZM17.7295 5.38667C16.1442 4.01314 14.1114 3.25 12 3.25C9.67936 3.25 7.45376 4.17187 5.81282 5.81282C4.17187 7.45376 3.25 9.67936 3.25 12C3.25 14.1114 4.01314 16.1442 5.38667 17.7295L17.7295 5.38667ZM6.27055 18.6133C7.85584 19.9869 9.88858 20.75 12 20.75C14.3206 20.75 16.5462 19.8281 18.1872 18.1872C19.8281 16.5462 20.75 14.3206 20.75 12C20.75 9.88858 19.9869 7.85584 18.6133 6.27055L6.27055 18.6133Z" })
  ] });
});
ErrorIcon.displayName = "ErrorIcon";
const ExpandIcon = forwardRef((props, ref2) => {
  const defaultFill = `var(${TOKENS.color.foreground.default}, ${ICON_FILL_DEFAULT})`;
  const {
    size: size2,
    title,
    ...rest
  } = props;
  const mappedSizeOrDefault = size2 ? ICON_SIZE_MAPPINGS[size2] : ICON_SIZE_DEFAULT;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { width: mappedSizeOrDefault, height: mappedSizeOrDefault, viewBox: "0 0 24 24", fill: defaultFill, xmlns: "http://www.w3.org/2000/svg", role: "img", "aria-label": "Expand Icon", ...rest, ref: ref2, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("title", { children: title || "Expand Icon" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M21.9526 2.38411C21.9221 2.3104 21.8769 2.24133 21.8169 2.18141C21.6949 2.05937 21.535 1.99835 21.375 1.99835H15.75C15.4048 1.99835 15.125 2.27817 15.125 2.62335C15.125 2.96853 15.4048 3.24835 15.75 3.24835H19.8661L12 11.1145L4.13388 3.24835H8.25C8.59518 3.24835 8.875 2.96853 8.875 2.62335C8.875 2.27817 8.59518 1.99835 8.25 1.99835H2.625C2.54026 1.99835 2.45945 2.01522 2.38576 2.04578C2.31263 2.07603 2.24408 2.12077 2.18449 2.17998C2.18401 2.18046 2.18353 2.18093 2.18306 2.18141C2.12314 2.24133 2.07792 2.3104 2.04742 2.38411C2.01687 2.4578 2 2.53861 2 2.62335V8.24835C2 8.59353 2.27982 8.87335 2.625 8.87335C2.97018 8.87335 3.25 8.59353 3.25 8.24835V4.13224L11.1161 11.9984L3.25 19.8645V15.7484C3.25 15.4032 2.97018 15.1234 2.625 15.1234C2.27982 15.1234 2 15.4032 2 15.7484V21.3734C2 21.5333 2.06102 21.6933 2.18306 21.8153C2.24298 21.8752 2.31204 21.9204 2.38576 21.9509C2.45778 21.9808 2.53659 21.9976 2.61923 21.9983L2.625 21.9984H2.62577H8.25C8.59518 21.9984 8.875 21.7185 8.875 21.3734C8.875 21.0282 8.59518 20.7484 8.25 20.7484H4.13388L12 12.8822L19.8661 20.7484H15.75C15.4048 20.7484 15.125 21.0282 15.125 21.3734C15.125 21.7185 15.4048 21.9984 15.75 21.9984H21.3742H21.375C21.3769 21.9984 21.3788 21.9983 21.3808 21.9983C21.4634 21.9976 21.5422 21.9808 21.6142 21.9509C21.688 21.9204 21.757 21.8752 21.8169 21.8153C21.8769 21.7554 21.9221 21.6863 21.9526 21.6126C21.9792 21.5483 21.9955 21.4785 21.9992 21.4055C21.9997 21.3949 22 21.3841 22 21.3734M22 21.3726V15.7484C22 15.4032 21.7202 15.1234 21.375 15.1234C21.0298 15.1234 20.75 15.4032 20.75 15.7484V19.8645L12.8839 11.9984L20.75 4.13224V8.24835C20.75 8.59353 21.0298 8.87335 21.375 8.87335C21.7202 8.87335 22 8.59353 22 8.24835V2.62413V2.62335L22 2.61758C21.9992 2.53494 21.9824 2.45613 21.9526 2.38411" })
  ] });
});
ExpandIcon.displayName = "ExpandIcon";
const EyeClosedIcon = forwardRef((props, ref2) => {
  const defaultFill = `var(${TOKENS.color.foreground.default}, ${ICON_FILL_DEFAULT})`;
  const {
    size: size2,
    title,
    ...rest
  } = props;
  const mappedSizeOrDefault = size2 ? ICON_SIZE_MAPPINGS[size2] : ICON_SIZE_DEFAULT;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { width: mappedSizeOrDefault, height: mappedSizeOrDefault, viewBox: "0 0 24 24", fill: defaultFill, xmlns: "http://www.w3.org/2000/svg", role: "img", "aria-label": "Eye  Closed Icon", ...rest, ref: ref2, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("title", { children: title || "Eye  Closed Icon" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M20.3925 4.06717C20.6316 4.31618 20.6235 4.71182 20.3745 4.95087L16.7265 8.45295C16.6937 8.49325 16.6566 8.5287 16.6161 8.55895L14.6249 10.4705C14.6102 10.4959 14.5936 10.5205 14.575 10.5442C14.5184 10.6163 14.4492 10.6725 14.3729 10.7123L10.0417 14.8703C9.99882 14.9449 9.93976 15.0118 9.86544 15.0653C9.841 15.083 9.81572 15.0986 9.7898 15.1122L7.64786 17.1684C7.64326 17.1774 7.63842 17.1863 7.63335 17.1951C7.56625 17.3117 7.46727 17.3985 7.35374 17.4508L4.74948 19.9509C4.50048 20.1899 4.10483 20.1818 3.86578 19.9328C3.62674 19.6838 3.63481 19.2882 3.88382 19.0491L6.04315 16.9762C4.73995 16.1369 3.55438 15.1255 2.51906 13.9684C2.18548 13.6005 2.00067 13.1217 2.00067 12.625C2.00067 12.1276 2.18604 11.648 2.52058 11.2799C3.6524 10.0315 5.12477 8.79792 6.75368 7.88044C8.3785 6.96526 10.1966 6.34387 12.0087 6.37505C13.4309 6.39025 14.8319 6.7071 16.1197 7.30265L19.5088 4.04913C19.7578 3.81009 20.1535 3.81816 20.3925 4.06717ZM15.1408 8.24242L13.9909 9.3463C13.362 8.99029 12.6414 8.81734 11.9118 8.85371C10.9892 8.8997 10.1143 9.27727 9.44794 9.91697C8.78158 10.5567 8.36863 11.4155 8.28504 12.3354C8.21893 13.0629 8.36233 13.79 8.69238 14.4329L6.97213 16.0843C5.663 15.2753 4.47634 14.2816 3.44915 13.1333L3.44575 13.1295C3.32023 12.9915 3.25067 12.8116 3.25067 12.625C3.25067 12.4384 3.32023 12.2585 3.44575 12.1205C4.49723 10.9606 5.86702 9.81449 7.36713 8.96956C8.87082 8.1226 10.4686 7.59829 11.9891 7.6249L11.9934 7.62496C13.0741 7.63627 14.1407 7.84647 15.1408 8.24242ZM13.0283 10.2705L9.65507 13.5087C9.54087 13.1705 9.4971 12.8096 9.52991 12.4485C9.58624 11.8286 9.86454 11.2498 10.3136 10.8187C10.7627 10.3876 11.3523 10.1332 11.974 10.1022C12.3361 10.0841 12.695 10.1426 13.0283 10.2705ZM17.953 9.03219C18.1561 8.75311 18.5471 8.69155 18.8261 8.89468C19.7905 9.59662 20.6799 10.3962 21.4801 11.2807C21.8142 11.6487 21.9993 12.1279 21.9993 12.625C21.9993 13.1223 21.8141 13.6017 21.4797 13.9697C19.3007 16.3784 15.6774 18.9346 11.9962 18.875C11.0867 18.8787 10.182 18.7426 9.31376 18.4716C8.98426 18.3688 8.80052 18.0183 8.90337 17.6888C9.00622 17.3593 9.35671 17.1755 9.68621 17.2784C10.4341 17.5118 11.2135 17.6287 11.997 17.625L12.0107 17.6249C15.1601 17.6787 18.4668 15.4371 20.5532 13.1307L20.5542 13.1295C20.6797 12.9915 20.7493 12.8116 20.7493 12.625C20.7493 12.4384 20.6797 12.2585 20.5542 12.1205L20.5532 12.1193C19.8106 11.2986 18.9854 10.5567 18.0905 9.90531C17.8114 9.70217 17.7499 9.31126 17.953 9.03219ZM15.75 12.625C15.75 12.2798 15.4702 12 15.125 12C14.7798 12 14.5 12.2798 14.5 12.625C14.5 12.9533 14.4353 13.2784 14.3097 13.5817C14.184 13.885 13.9999 14.1606 13.7678 14.3928C13.5356 14.6249 13.26 14.8091 12.9567 14.9347C12.6534 15.0603 12.3283 15.125 12 15.125C11.6548 15.125 11.375 15.4048 11.375 15.75C11.375 16.0952 11.6548 16.375 12 16.375C12.4924 16.375 12.9801 16.278 13.435 16.0895C13.89 15.9011 14.3034 15.6249 14.6516 15.2767C14.9999 14.9284 15.2761 14.515 15.4645 14.0601C15.653 13.6051 15.75 13.1175 15.75 12.625Z" })
  ] });
});
EyeClosedIcon.displayName = "EyeClosedIcon";
const EyeIcon = forwardRef((props, ref2) => {
  const defaultFill = `var(${TOKENS.color.foreground.default}, ${ICON_FILL_DEFAULT})`;
  const {
    size: size2,
    title,
    ...rest
  } = props;
  const mappedSizeOrDefault = size2 ? ICON_SIZE_MAPPINGS[size2] : ICON_SIZE_DEFAULT;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { width: mappedSizeOrDefault, height: mappedSizeOrDefault, viewBox: "0 0 24 24", fill: defaultFill, xmlns: "http://www.w3.org/2000/svg", role: "img", "aria-label": "Eye Icon", ...rest, ref: ref2, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("title", { children: title || "Eye Icon" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M21.4823 10.6503C19.2492 8.19501 15.6203 5.69465 12 5.75076C8.37967 5.69465 4.75075 8.19499 2.51988 10.6506L2.51987 10.6506L2.51809 10.6525C2.18543 11.0219 2.00134 11.5013 2.00134 11.9983C2.00134 12.4954 2.18543 12.9748 2.51809 13.3441L2.51809 13.3441L2.51975 13.346C4.70051 15.7479 8.31972 18.3054 12 18.2484C15.6802 18.3054 19.3002 15.7479 21.4825 13.3461L21.4844 13.3441C21.817 12.9748 22.0011 12.4954 22.0011 11.9983C22.0011 11.5013 21.817 11.0219 21.4844 10.6525L21.4823 10.6503ZM3.25134 11.9983C3.25134 11.8107 3.32071 11.6296 3.44609 11.49C5.58142 9.14004 8.8954 6.94856 11.9894 7.00075C11.9965 7.00087 12.0035 7.00087 12.0105 7.00075C15.1045 6.94856 18.4185 9.13998 20.5565 11.4902C20.6818 11.6298 20.7511 11.8107 20.7511 11.9983C20.7511 12.1859 20.6818 12.3669 20.5565 12.5065C18.4642 14.8088 15.1596 17.0514 12.0105 16.9984L11.9964 16.9984L11.9895 16.9984C8.84048 17.0514 5.53671 14.8089 3.44616 12.5068C3.32074 12.3671 3.25134 12.1861 3.25134 11.9983ZM12.0002 9.49916C12.3285 9.49908 12.6537 9.5637 12.9571 9.68934C13.2604 9.81498 13.5361 9.99917 13.7682 10.2314C14.0004 10.4636 14.1845 10.7393 14.3101 11.0427C14.4356 11.3461 14.5002 11.6713 14.5 11.9997V11.9998C14.4999 12.4943 14.3531 12.9775 14.0783 13.3886C13.8036 13.7996 13.4131 14.1199 12.9562 14.3091C12.4994 14.4982 11.9968 14.5476 11.5119 14.451C11.0269 14.3545 10.5815 14.1164 10.232 13.7667C9.88242 13.417 9.64438 12.9716 9.54797 12.4866C9.45157 12.0017 9.50111 11.4991 9.69035 11.0423C9.87959 10.5855 10.2 10.1951 10.6111 9.92044C11.0222 9.64577 11.5056 9.49916 12 9.49916H12.0002ZM13.4353 8.53446C12.9803 8.346 12.4925 8.24905 12 8.24916L15.75 12.0002C15.7502 11.5076 15.6534 11.0199 15.4651 10.5647C15.2767 10.1096 15.0005 9.69599 14.6522 9.34762C14.304 8.99926 13.8904 8.72294 13.4353 8.53446ZM9.9167 8.88108C10.5333 8.4691 11.2582 8.2492 11.9998 8.24916L15.75 12.0003C15.7498 12.7419 15.5297 13.4668 15.1175 14.0833C14.7053 14.6998 14.1196 15.1803 13.4344 15.464C12.7491 15.7477 11.9951 15.8218 11.2678 15.677C10.5404 15.5322 9.87233 15.1749 9.34798 14.6505C8.82363 14.126 8.46658 13.4578 8.32197 12.7304C8.17735 12.003 8.25168 11.249 8.53553 10.5639C8.81939 9.87871 9.30004 9.29309 9.9167 8.88108Z" })
  ] });
});
EyeIcon.displayName = "EyeIcon";
const FileFolderIcon = forwardRef((props, ref2) => {
  const defaultFill = `var(${TOKENS.color.foreground.default}, ${ICON_FILL_DEFAULT})`;
  const {
    size: size2,
    title,
    ...rest
  } = props;
  const mappedSizeOrDefault = size2 ? ICON_SIZE_MAPPINGS[size2] : ICON_SIZE_DEFAULT;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { width: mappedSizeOrDefault, height: mappedSizeOrDefault, viewBox: "0 0 24 24", fill: defaultFill, xmlns: "http://www.w3.org/2000/svg", role: "img", "aria-label": "file folder Icon", ...rest, ref: ref2, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("title", { children: title || "file folder Icon" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M8.82597 8.25082C9.16166 8.25143 9.48686 8.36783 9.74669 8.58037C10.0065 8.79292 10.1851 9.08859 10.2527 9.42L10.4839 10.5767C10.4935 10.6236 10.519 10.6659 10.5561 10.6962C10.5932 10.7266 10.6397 10.7432 10.6865 10.7433L20.5445 10.7433C20.7597 10.7438 20.9721 10.7919 21.1662 10.884C21.3606 10.9762 21.5321 11.1102 21.6686 11.2764C21.8051 11.4427 21.9031 11.6372 21.9557 11.8462C22.008 12.0547 22.0137 12.2722 21.9719 12.4851L20.3089 20.8284C20.2417 21.1573 20.0632 21.4529 19.8032 21.6656C19.5434 21.878 19.2184 21.9943 18.8815 21.995H5.6152C5.27963 21.9943 4.95454 21.878 4.69457 21.6654C4.43475 21.4528 4.25624 21.1572 4.18858 20.8256L2.02742 9.99061C1.98593 9.77967 1.99159 9.56218 2.04399 9.35368C2.09639 9.14519 2.19424 8.95085 2.33051 8.78462C2.4668 8.61837 2.63815 8.48431 2.83235 8.392C3.02651 8.29973 3.23866 8.25152 3.45364 8.25082H8.82597ZM8.82483 9.50082H3.45771C3.42696 9.50082 3.39664 9.50781 3.36895 9.52096C3.34118 9.53417 3.31669 9.55332 3.29721 9.57709C3.27775 9.60083 3.26377 9.62859 3.25628 9.65838C3.2488 9.68816 3.24799 9.71923 3.25359 9.74773L5.41388 20.5783C5.42347 20.6253 5.44897 20.6676 5.48598 20.6978C5.52315 20.7282 5.56972 20.745 5.6165 20.745H18.8802C18.9283 20.745 18.9748 20.7282 19.0119 20.698C19.0491 20.6675 19.0746 20.6253 19.0837 20.5806L20.7458 12.242C20.7517 12.2118 20.7509 12.1805 20.7434 12.1509C20.7359 12.1211 20.7219 12.0933 20.7024 12.0696C20.6829 12.0458 20.6584 12.0266 20.6305 12.0134C20.6028 12.0002 20.5725 11.9934 20.5431 11.9933L10.6854 11.9933C10.3497 11.9927 10.0245 11.8763 9.76466 11.6638C9.50482 11.4512 9.32626 11.1556 9.25862 10.8241L9.02746 9.66747C9.01787 9.6205 8.99237 9.57826 8.95524 9.54789C8.91813 9.51754 8.87166 9.50082 8.82483 9.50082ZM17.4023 2C17.7891 2 18.16 2.15364 18.4337 2.42725C18.6729 2.66656 18.8204 2.98043 18.8535 3.31293L18.8606 3.4564L18.8773 8.87307C18.8784 9.21825 18.5994 9.49893 18.2543 9.5C17.9405 9.50096 17.68 9.27051 17.6344 8.96926L17.6273 8.87693L17.6106 3.45833C17.6106 3.40306 17.5887 3.35001 17.5497 3.31105C17.5237 3.28499 17.4914 3.26655 17.4564 3.25714L17.4023 3.25H6.59983C6.54458 3.25 6.49158 3.27195 6.45252 3.31102C6.42647 3.33706 6.40804 3.36929 6.39864 3.40532L6.39149 3.4619L6.37482 6.37857C6.37285 6.72374 6.09143 7.00196 5.74626 6.99999C5.43247 6.9982 5.17401 6.76546 5.13109 6.46382L5.12484 6.37143L5.1415 3.45833C5.1415 3.07156 5.29514 2.70063 5.56863 2.42714C5.80793 2.18783 6.12185 2.04028 6.45569 2.00714L6.59983 2H17.4023ZM15.1248 7C15.47 7 15.7498 7.27982 15.7498 7.625C15.7498 7.9388 15.5186 8.19858 15.2172 8.24322L15.1248 8.25H11.9998C11.6547 8.25 11.3748 7.97018 11.3748 7.625C11.3748 7.3112 11.6061 7.05142 11.9075 7.00678L11.9998 7H15.1248ZM8.26045 4.49335L15.1254 4.50001C15.4706 4.50035 15.7502 4.78044 15.7498 5.12562C15.7495 5.43941 15.518 5.69898 15.2166 5.74332L15.1242 5.75001L8.25924 5.74335C7.91406 5.74301 7.63451 5.46292 7.63484 5.11774C7.63515 4.80395 7.86666 4.54438 8.16808 4.50004L8.26045 4.49335Z" })
  ] });
});
FileFolderIcon.displayName = "FileFolderIcon";
const FilterIcon = forwardRef((props, ref2) => {
  const defaultFill = `var(${TOKENS.color.foreground.default}, ${ICON_FILL_DEFAULT})`;
  const {
    size: size2,
    title,
    ...rest
  } = props;
  const mappedSizeOrDefault = size2 ? ICON_SIZE_MAPPINGS[size2] : ICON_SIZE_DEFAULT;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { width: mappedSizeOrDefault, height: mappedSizeOrDefault, viewBox: "0 0 24 24", fill: defaultFill, xmlns: "http://www.w3.org/2000/svg", role: "img", "aria-label": "Filter Icon", ...rest, ref: ref2, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("title", { children: title || "Filter Icon" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.625 4.95251C2.27982 4.95251 2 5.23234 2 5.57751C2 5.92269 2.27982 6.20251 2.625 6.20251H21.375C21.7202 6.20251 22 5.92269 22 5.57751C22 5.23234 21.7202 4.95251 21.375 4.95251H2.625ZM4.62167 9.23418C4.27649 9.23418 3.99667 9.514 3.99667 9.85918C3.99667 10.2044 4.27649 10.4842 4.62167 10.4842H19.3783C19.7235 10.4842 20.0033 10.2044 20.0033 9.85918C20.0033 9.514 19.7235 9.23418 19.3783 9.23418H4.62167ZM8.64167 18.4225C8.64167 18.0773 8.92149 17.7975 9.26667 17.7975H14.7333C15.0785 17.7975 15.3583 18.0773 15.3583 18.4225C15.3583 18.7677 15.0785 19.0475 14.7333 19.0475H9.26667C8.92149 19.0475 8.64167 18.7677 8.64167 18.4225ZM6.61917 13.5158C6.27399 13.5158 5.99417 13.7957 5.99417 14.1408C5.99417 14.486 6.27399 14.7658 6.61917 14.7658H17.3808C17.726 14.7658 18.0058 14.486 18.0058 14.1408C18.0058 13.7957 17.726 13.5158 17.3808 13.5158H6.61917Z" })
  ] });
});
FilterIcon.displayName = "FilterIcon";
const FlagIcon = forwardRef((props, ref2) => {
  const defaultFill = `var(${TOKENS.color.foreground.default}, ${ICON_FILL_DEFAULT})`;
  const {
    size: size2,
    title,
    ...rest
  } = props;
  const mappedSizeOrDefault = size2 ? ICON_SIZE_MAPPINGS[size2] : ICON_SIZE_DEFAULT;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { width: mappedSizeOrDefault, height: mappedSizeOrDefault, viewBox: "0 0 14 20", fill: defaultFill, xmlns: "http://www.w3.org/2000/svg", role: "img", "aria-label": "Flag Icon", ...rest, ref: ref2, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("title", { children: title || "Flag Icon" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M13.0128 6.11219C13.3653 6.25064 13.3653 6.74936 13.0128 6.88781L1 12L1 0.999999L13.0128 6.11219Z" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M1.41667 0.375C1.76185 0.375 2.04167 0.654822 2.04167 1L2.04167 19C2.04167 19.3452 1.76185 19.625 1.41667 19.625C1.07149 19.625 0.791672 19.3452 0.791672 19L0.791673 1C0.791673 0.654822 1.07149 0.375 1.41667 0.375Z" })
  ] });
});
FlagIcon.displayName = "FlagIcon";
const FlashIcon = forwardRef((props, ref2) => {
  const defaultFill = `var(${TOKENS.color.foreground.default}, ${ICON_FILL_DEFAULT})`;
  const {
    size: size2,
    title,
    ...rest
  } = props;
  const mappedSizeOrDefault = size2 ? ICON_SIZE_MAPPINGS[size2] : ICON_SIZE_DEFAULT;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { width: mappedSizeOrDefault, height: mappedSizeOrDefault, viewBox: "0 0 24 24", fill: defaultFill, xmlns: "http://www.w3.org/2000/svg", role: "img", "aria-label": "Flash Icon", ...rest, ref: ref2, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("title", { children: title || "Flash Icon" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("g", { clipPath: "url(#clip0_1263_42)", children: /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M11.0949 21.7003L17.4586 11.7802C17.7583 11.3107 17.7682 10.7213 17.4885 10.2418C17.2088 9.76224 16.6993 9.48252 16.1499 9.48252H13.7922V2.64936C13.7922 2.35965 13.6024 2.1099 13.3227 2.02998C13.043 1.95006 12.7533 2.05995 12.5934 2.29971L6.22978 12.2198C5.93008 12.6893 5.92009 13.2787 6.19981 13.7582C6.47953 14.2378 6.98902 14.5175 7.53847 14.5175H9.89611V21.3507C9.89611 21.6404 10.0859 21.8901 10.3656 21.97C10.6454 22.05 10.9351 21.9401 11.0949 21.7003ZM7.32868 12.9291L12.4935 4.86714V10.1319C12.4935 10.4915 12.7832 10.7812 13.1429 10.7812H16.1499C16.2498 10.7812 16.3297 10.8312 16.3596 10.8911C16.3896 10.9511 16.3896 11.021 16.3596 11.0709L11.1948 19.1329V13.8681C11.1948 13.5085 10.9051 13.2188 10.5455 13.2188H7.53847C7.43857 13.2188 7.35865 13.1688 7.32868 13.1089C7.29871 13.049 7.29871 12.979 7.32868 12.9291Z" }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("defs", { children: /* @__PURE__ */ jsxRuntimeExports.jsxs("clipPath", { id: "clip0_1263_42", children: [
      " ",
      /* @__PURE__ */ jsxRuntimeExports.jsx("rect", { width: "11.6883", height: "20", fill: "white", transform: "translate(6 2)" })
    ] }) })
  ] });
});
FlashIcon.displayName = "FlashIcon";
const FolderIcon = forwardRef((props, ref2) => {
  const defaultFill = `var(${TOKENS.color.foreground.default}, ${ICON_FILL_DEFAULT})`;
  const {
    size: size2,
    title,
    ...rest
  } = props;
  const mappedSizeOrDefault = size2 ? ICON_SIZE_MAPPINGS[size2] : ICON_SIZE_DEFAULT;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { width: mappedSizeOrDefault, height: mappedSizeOrDefault, viewBox: "0 0 24 24", fill: defaultFill, xmlns: "http://www.w3.org/2000/svg", role: "img", "aria-label": "Folder Icon", ...rest, ref: ref2, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("title", { children: title || "Folder Icon" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.54917 3.79917C2.90081 3.44754 3.37772 3.25 3.875 3.25H8.25C8.54108 3.25 8.82817 3.31777 9.08853 3.44795C9.34888 3.57813 9.57535 3.76713 9.75 4L11.0625 5.75H20.125C20.6223 5.75 21.0992 5.94754 21.4508 6.29917C21.8025 6.6508 22 7.12772 22 7.625V18.875C22 19.3723 21.8025 19.8492 21.4508 20.2008C21.0992 20.5525 20.6223 20.75 20.125 20.75H3.875C3.37772 20.75 2.9008 20.5525 2.54917 20.2008C2.19754 19.8492 2 19.3723 2 18.875V5.125C2 4.62772 2.19754 4.15081 2.54917 3.79917ZM3.875 4.5C3.70924 4.5 3.55027 4.56585 3.43306 4.68306C3.31585 4.80027 3.25 4.95924 3.25 5.125V18.875C3.25 19.0408 3.31585 19.1997 3.43306 19.3169C3.55027 19.4342 3.70924 19.5 3.875 19.5H20.125C20.2908 19.5 20.4497 19.4342 20.5669 19.3169C20.6842 19.1997 20.75 19.0408 20.75 18.875V7.625C20.75 7.45924 20.6842 7.30027 20.5669 7.18306C20.4497 7.06585 20.2908 7 20.125 7H10.75C10.5533 7 10.368 6.90738 10.25 6.75L8.75 4.75C8.69178 4.67238 8.61629 4.60938 8.52951 4.56598C8.44272 4.52259 8.34703 4.5 8.25 4.5H3.875Z" })
  ] });
});
FolderIcon.displayName = "FolderIcon";
const GearIcon = forwardRef((props, ref2) => {
  const defaultFill = `var(${TOKENS.color.foreground.default}, ${ICON_FILL_DEFAULT})`;
  const {
    size: size2,
    title,
    ...rest
  } = props;
  const mappedSizeOrDefault = size2 ? ICON_SIZE_MAPPINGS[size2] : ICON_SIZE_DEFAULT;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { width: mappedSizeOrDefault, height: mappedSizeOrDefault, viewBox: "0 0 24 24", fill: defaultFill, xmlns: "http://www.w3.org/2000/svg", role: "img", "aria-label": "Gear Icon", ...rest, ref: ref2, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("title", { children: title || "Gear Icon" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M14.0852 2.43021C14.5398 2.32777 15.015 2.36856 15.4455 2.54697C15.876 2.72538 16.2408 3.03266 16.4896 3.42648C16.7031 3.76412 16.8224 4.15132 16.8373 4.54817L16.836 4.74721L16.7768 5.91374C16.7697 6.05398 16.7921 6.19428 16.8426 6.32558C16.893 6.45671 16.9705 6.57592 17.0698 6.67546C17.1692 6.77494 17.2882 6.8525 17.4194 6.90319C17.5068 6.93694 17.5983 6.95826 17.6909 6.96671L17.8301 6.96967L18.9976 6.91046C19.4627 6.88753 19.9235 7.00899 20.3169 7.25821C20.7103 7.50742 21.0169 7.87219 21.1949 8.30257C21.3729 8.73292 21.4134 9.20777 21.3109 9.66204C21.2231 10.0515 21.0338 10.4094 20.7637 10.7006L20.622 10.8404L19.754 11.6235C19.6493 11.7181 19.5656 11.8335 19.5084 11.9625C19.4511 12.0913 19.4216 12.2307 19.4216 12.3718C19.4216 12.5129 19.4511 12.6523 19.5085 12.7814C19.5466 12.8672 19.5965 12.9471 19.6564 13.0187L19.7537 13.1198L20.6224 13.9034C20.9682 14.216 21.2088 14.6278 21.3112 15.0823C21.4136 15.5369 21.3729 16.0121 21.1945 16.4426C21.0161 16.8732 20.7088 17.238 20.3148 17.4869C19.9771 17.7003 19.59 17.8196 19.1932 17.8344L18.9942 17.8331L17.8272 17.7738C17.6865 17.7666 17.5457 17.789 17.4143 17.8395C17.2827 17.8901 17.1632 17.9678 17.0636 18.0674C16.9639 18.1671 16.8863 18.2865 16.8358 18.4179C16.8021 18.5057 16.7809 18.5975 16.7726 18.6907L16.7701 18.8314L16.8294 20.0019C16.85 20.465 16.7276 20.9233 16.4788 21.3142C16.2301 21.7052 15.8669 22.0102 15.4382 22.188C15.01 22.3652 14.5377 22.4066 14.0853 22.3063C13.6973 22.2203 13.3401 22.0336 13.0473 21.7649L12.9064 21.6238L12.1219 20.756C12.0276 20.6515 11.9122 20.5678 11.7834 20.5106C11.6546 20.4533 11.5152 20.4238 11.3743 20.4238C11.2332 20.4238 11.0938 20.4533 10.9652 20.5105C10.8792 20.5487 10.7993 20.5986 10.7272 20.659L10.6253 20.7573L9.83735 21.6253C9.52484 21.9688 9.114 22.2076 8.66086 22.3091C8.2077 22.4106 7.73425 22.3698 7.30506 22.1924C6.87594 22.015 6.51193 21.7095 6.26264 21.3177C6.04902 20.9818 5.92864 20.5965 5.91211 20.1989L5.91254 19.9993L5.97254 18.8326C5.97978 18.6918 5.95739 18.5512 5.90687 18.4197C5.85626 18.2881 5.77863 18.1687 5.67902 18.0691C5.57938 17.9695 5.4599 17.8918 5.32854 17.8413C5.24079 17.8076 5.14898 17.7864 5.05572 17.7782L4.91506 17.7756L3.74918 17.8347C3.28393 17.8589 2.82257 17.7386 2.42846 17.4902C2.03428 17.2418 1.72664 16.8774 1.54781 16.4471C1.36899 16.0169 1.32774 15.5419 1.4297 15.0872C1.5171 14.6975 1.70604 14.3393 1.97614 14.0476L2.11786 13.9075L2.98519 13.1243C3.08992 13.0297 3.17361 12.9142 3.23091 12.7852C3.28813 12.6565 3.31773 12.517 3.31773 12.376C3.31773 12.2349 3.28814 12.0954 3.23088 11.9666C3.19271 11.8806 3.14279 11.8007 3.08241 11.7286L2.98413 11.6266L2.1168 10.8393C1.77248 10.527 1.53302 10.1159 1.43115 9.66231C1.32929 9.20873 1.37 8.73476 1.5477 8.30521C1.72541 7.87563 2.03144 7.51142 2.42397 7.26236C2.76043 7.04888 3.14636 6.92894 3.54332 6.91306L3.74254 6.91384L4.91037 6.97306C5.05136 6.98048 5.19232 6.95815 5.32411 6.90754C5.45592 6.85692 5.5756 6.77914 5.67539 6.67925C5.77516 6.57938 5.85282 6.45963 5.90331 6.3278C5.93697 6.23989 5.95805 6.14792 5.96608 6.05355L5.96826 5.91039L5.9124 4.74234C5.89062 4.27822 6.01258 3.8187 6.26162 3.42648C6.51066 3.03425 6.87465 2.72841 7.30394 2.55069C7.73323 2.37298 8.20688 2.33205 8.66029 2.43349C9.04892 2.52043 9.40644 2.70835 9.69812 2.97734L9.83831 3.1185L10.6227 3.98472C10.7171 4.08941 10.8323 4.17311 10.961 4.2304C11.0898 4.28771 11.2291 4.31732 11.37 4.31732C11.511 4.31732 11.6503 4.28771 11.7791 4.23038C11.8649 4.19221 11.9447 4.14229 12.017 4.08143L12.1198 3.98205L12.9063 3.11906C13.2187 2.77325 13.6305 2.53262 14.0852 2.43021ZM14.8496 3.66136C14.6904 3.61741 14.5222 3.61307 14.3599 3.64964C14.1976 3.68621 14.0475 3.76224 13.9216 3.87122L13.832 3.95902L13.046 4.82148C12.8344 5.0563 12.5759 5.24398 12.2873 5.37239C11.9986 5.50091 11.6861 5.56732 11.37 5.56732C11.054 5.56732 10.7415 5.50091 10.4528 5.37241C10.2218 5.2696 10.0102 5.12889 9.827 4.95712L9.69512 4.82257L8.91271 3.95859C8.77318 3.80521 8.58973 3.6986 8.38738 3.65333C8.18503 3.60806 7.97365 3.62633 7.78206 3.70564C7.59048 3.78495 7.42803 3.92145 7.31688 4.09651C7.22796 4.23654 7.17535 4.39579 7.16282 4.55965L7.161 4.68318L7.21665 5.84711C7.23358 6.16314 7.18384 6.47921 7.07065 6.77481C6.95746 7.07038 6.78337 7.33883 6.5597 7.56271C6.33602 7.78661 6.06774 7.96096 5.77226 8.07444C5.53589 8.16522 5.28636 8.2154 5.03479 8.22337L4.84589 8.2214L3.68104 8.16232C3.4739 8.15242 3.26876 8.20673 3.09366 8.31783C2.91856 8.42893 2.78204 8.5914 2.70277 8.78304C2.6235 8.97465 2.60534 9.18608 2.65078 9.38842C2.68713 9.55029 2.76276 9.70002 2.87029 9.82485L2.9568 9.9136L3.82316 10.7001C4.05757 10.9118 4.24496 11.1704 4.37322 11.459C4.50146 11.7477 4.56773 12.0601 4.56773 12.376C4.56773 12.6918 4.50144 13.0043 4.37322 13.2928C4.27063 13.5237 4.13021 13.7354 3.95805 13.9193L3.82307 14.0519L2.95616 14.8347C2.80202 14.9742 2.69488 15.158 2.64941 15.3607C2.60392 15.5636 2.62232 15.7755 2.70209 15.9674C2.78188 16.1594 2.9191 16.3219 3.09488 16.4327C3.23556 16.5214 3.39546 16.5734 3.56051 16.5852L3.68504 16.5864L4.85137 16.5272C5.16673 16.511 5.482 16.5612 5.77706 16.6745C6.07186 16.7879 6.33959 16.9619 6.56277 17.1851C6.78612 17.4083 6.96015 17.6762 7.0736 17.9711C7.16427 18.207 7.21452 18.456 7.22268 18.7077L7.22089 18.8968L7.16106 20.06C7.15157 20.267 7.20615 20.4719 7.31736 20.6468C7.42861 20.8217 7.59109 20.958 7.78261 21.0372C7.97418 21.1164 8.18546 21.1346 8.38765 21.0893C8.54943 21.053 8.69914 20.9776 8.82374 20.8706L8.91228 20.7846L9.69868 19.9183C9.9103 19.6839 10.1688 19.4966 10.4576 19.3682C10.7462 19.24 11.0584 19.1738 11.3743 19.1738C11.69 19.1738 12.0023 19.24 12.2911 19.3683C12.522 19.471 12.7336 19.6114 12.9172 19.7833L13.0495 19.918L13.8311 20.7827C13.9708 20.9353 14.154 21.0412 14.3559 21.086C14.5577 21.1307 14.7688 21.1122 14.9598 21.0331C15.151 20.9538 15.3132 20.8177 15.4242 20.6432C15.513 20.5036 15.5658 20.3448 15.5787 20.183L15.5809 20.0613L15.5217 18.8951C15.5055 18.5797 15.5557 18.2645 15.669 17.9694C15.7824 17.6746 15.9564 17.4069 16.1797 17.1835C16.403 16.9602 16.6708 16.7862 16.9657 16.6728C17.2015 16.5822 17.4505 16.5319 17.702 16.5237L17.8909 16.5255L19.0576 16.5847C19.2654 16.5952 19.4713 16.5413 19.6471 16.4302C19.8229 16.3191 19.96 16.1563 20.0397 15.9641C20.1193 15.772 20.1375 15.56 20.0917 15.3569C20.0552 15.1947 19.9792 15.0446 19.8714 14.9199L19.7847 14.8312L18.9161 14.0477C18.6817 13.8359 18.4942 13.5773 18.3661 13.2888C18.2378 13.0001 18.1716 12.6877 18.1716 12.3718C18.1716 12.0558 18.2378 11.7434 18.366 11.455C18.4686 11.2241 18.609 11.0124 18.7813 10.8284L18.9164 10.6956L19.7843 9.91263C19.9385 9.7733 20.0458 9.58971 20.0916 9.38699C20.1373 9.18425 20.1192 8.97233 20.0398 8.78027C19.9603 8.58813 19.8235 8.42535 19.648 8.31416C19.5075 8.22516 19.3478 8.17267 19.1837 8.16045L19.06 8.1589L17.8922 8.21812C17.5774 8.23349 17.2628 8.18274 16.969 8.06919C16.6749 7.95561 16.408 7.7817 16.1853 7.55866C15.9626 7.33561 15.789 7.06841 15.6759 6.77429C15.5854 6.53889 15.5351 6.29044 15.5267 6.03926L15.5284 5.85052L15.5876 4.68382C15.5981 4.47602 15.5442 4.27014 15.433 4.09429C15.3441 3.95366 15.2222 3.83776 15.0786 3.75626L14.967 3.70173L14.8496 3.66136ZM11.3701 7.9972C12.5304 7.9972 13.6432 8.45814 14.4636 9.27859C15.2841 10.0991 15.7451 11.2119 15.7451 12.3722C15.7451 13.5325 15.2841 14.6453 14.4636 15.4658C13.6432 16.2862 12.5304 16.7472 11.3701 16.7472C10.2098 16.7472 9.09697 16.2862 8.27645 15.4658C7.45598 14.6453 6.99506 13.5325 6.99506 12.3722C6.99506 11.2119 7.456 10.0991 8.27646 9.27861C9.09693 8.45814 10.2097 7.9972 11.3701 7.9972ZM11.3701 9.2472C10.5413 9.2472 9.7464 9.57644 9.16035 10.1625C8.5743 10.7485 8.24506 11.5434 8.24506 12.3722C8.24506 13.201 8.57429 13.9958 9.16033 14.5819C9.7464 15.1679 10.5413 15.4972 11.3701 15.4972C12.1989 15.4972 12.9937 15.1679 13.5797 14.5819C14.1658 13.9958 14.4951 13.201 14.4951 12.3722C14.4951 11.5434 14.1658 10.7485 13.5797 10.1625C12.9937 9.57643 12.1989 9.2472 11.3701 9.2472Z" })
  ] });
});
GearIcon.displayName = "GearIcon";
const HandoffCompleteIcon = forwardRef((props, ref2) => {
  const {
    size: size2,
    title,
    strokeColor,
    ...rest
  } = props;
  const mappedSizeOrDefault = size2 ? ICON_SIZE_MAPPINGS[size2] : ICON_SIZE_DEFAULT;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { width: mappedSizeOrDefault, height: mappedSizeOrDefault, viewBox: "0 0 98 70", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img", "aria-label": "Handoff Complete Icon", ...rest, ref: ref2, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("title", { children: title || "Handoff Complete Icon" }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("g", { clipPath: "url(#clip0_handoff_complete)", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M74 41.5C79.799 41.5 84.5 36.799 84.5 31C84.5 25.201 79.799 20.5 74 20.5C68.201 20.5 63.5 25.201 63.5 31C63.5 36.799 68.201 41.5 74 41.5Z", stroke: "#282624", strokeWidth: "3", strokeLinecap: "round", strokeLinejoin: "round" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M54.5 65.5C54.5 54.7304 63.2304 46 74 46C84.7696 46 93.5 54.7304 93.5 65.5", stroke: "#282624", strokeWidth: "3", strokeLinecap: "round", strokeLinejoin: "round" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M27.9493 13.8711C30.0507 6.90839 36.2799 2.00593 43.521 1.61598C50.762 1.22603 57.4582 5.43243 60.2601 12.1311L62.0716 16.4699", stroke: "#0069B4", strokeWidth: "3", strokeLinecap: "round", strokeLinejoin: "round" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M65.4199 8.2771L62.065 16.4839L53.8869 13.1394", stroke: "#0069B4", strokeWidth: "3", strokeLinecap: "round", strokeLinejoin: "round" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M1.96875 63.2813C1.9728 57.3314 4.96155 51.7804 9.92641 48.5014C14.8913 45.2225 21.17 44.6531 26.6437 46.9853", stroke: "#282624", strokeWidth: "3", strokeLinecap: "round", strokeLinejoin: "round" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M19.6875 41.625C25.6677 41.625 30.5156 36.7771 30.5156 30.7969C30.5156 24.8167 25.6677 19.9688 19.6875 19.9688C13.7073 19.9688 8.85938 24.8167 8.85938 30.7969C8.85938 36.7771 13.7073 41.625 19.6875 41.625Z", stroke: "#282624", strokeWidth: "3", strokeLinecap: "round", strokeLinejoin: "round" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M35 68C40.5228 68 45 63.5228 45 58C45 52.4772 40.5228 48 35 48C29.4772 48 25 52.4772 25 58C25 63.5228 29.4772 68 35 68Z", stroke: "#13805C", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M39 55L34.2773 61.4974C34.0648 61.7889 33.7403 61.9711 33.3876 61.9969C33.0349 62.0226 32.6887 61.8893 32.4386 61.6316L30 59.1158", stroke: "#13805C", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("defs", { children: /* @__PURE__ */ jsxRuntimeExports.jsx("clipPath", { id: "clip0_handoff_complete", children: /* @__PURE__ */ jsxRuntimeExports.jsx("rect", { width: "98", height: "70", fill: "white" }) }) })
  ] });
});
HandoffCompleteIcon.displayName = "HandoffCompleteIcon";
const HandoffIcon = forwardRef((props, ref2) => {
  const {
    size: size2,
    title,
    strokeColor,
    ...rest
  } = props;
  const mappedSizeOrDefault = size2 ? ICON_SIZE_MAPPINGS[size2] : ICON_SIZE_DEFAULT;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { width: mappedSizeOrDefault, height: mappedSizeOrDefault, viewBox: "0 0 102 69", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img", "aria-label": "Handoff Icon", ...rest, ref: ref2, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("title", { children: title || "Handoff Icon" }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("g", { clipPath: "url(#clip0_handoff)", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M78 43.5C83.799 43.5 88.5 38.799 88.5 33C88.5 27.201 83.799 22.5 78 22.5C72.201 22.5 67.5 27.201 67.5 33C67.5 38.799 72.201 43.5 78 43.5Z", stroke: "#282624", strokeWidth: "3", strokeLinecap: "round", strokeLinejoin: "round" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M58.5 67.5C58.5 56.7304 67.2304 48 78 48C88.7696 48 97.5 56.7304 97.5 67.5", stroke: "#282624", strokeWidth: "3", strokeLinecap: "round", strokeLinejoin: "round" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M24 43.5C29.799 43.5 34.5 38.799 34.5 33C34.5 27.201 29.799 22.5 24 22.5C18.201 22.5 13.5 27.201 13.5 33C13.5 38.799 18.201 43.5 24 43.5Z", stroke: "#282624", strokeWidth: "3", strokeLinecap: "round", strokeLinejoin: "round" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M4.5 67.5C4.5 56.7304 13.2304 48 24 48C34.7696 48 43.5 56.7304 43.5 67.5", stroke: "#282624", strokeWidth: "3", strokeLinecap: "round", strokeLinejoin: "round" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M31.9493 15.8711C34.0507 8.90839 40.2799 4.00593 47.521 3.61598C54.762 3.22603 61.4582 7.43243 64.2601 14.1311L66.0716 18.4699", stroke: "#0069B4", strokeWidth: "3", strokeLinecap: "round", strokeLinejoin: "round" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M69.4199 10.2771L66.065 18.4839L57.8869 15.1394", stroke: "#0069B4", strokeWidth: "3", strokeLinecap: "round", strokeLinejoin: "round" })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("defs", { children: /* @__PURE__ */ jsxRuntimeExports.jsx("clipPath", { id: "clip0_handoff", children: /* @__PURE__ */ jsxRuntimeExports.jsx("rect", { width: "102", height: "69", fill: "white" }) }) })
  ] });
});
HandoffIcon.displayName = "HandoffIcon";
const HeartCircleIcon = forwardRef((props, ref2) => {
  const defaultFill = `var(${TOKENS.color.foreground.default}, ${ICON_FILL_DEFAULT})`;
  const {
    size: size2,
    title,
    ...rest
  } = props;
  const mappedSizeOrDefault = size2 ? ICON_SIZE_MAPPINGS[size2] : ICON_SIZE_DEFAULT;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { width: mappedSizeOrDefault, height: mappedSizeOrDefault, viewBox: "0 0 24 24", fill: defaultFill, xmlns: "http://www.w3.org/2000/svg", role: "img", "aria-label": "heart circle Icon", ...rest, ref: ref2, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("title", { children: title || "heart circle Icon" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 2C9.34784 2 6.8043 3.05357 4.92893 4.92893C3.05357 6.8043 2 9.34784 2 12C2 14.6522 3.05357 17.1957 4.92893 19.0711C6.8043 20.9464 9.34784 22 12 22C14.6522 22 17.1957 20.9464 19.0711 19.0711C20.9464 17.1957 22 14.6522 22 12C22 9.34784 20.9464 6.8043 19.0711 4.92893C17.1957 3.05357 14.6522 2 12 2ZM5.81282 5.81282C7.45376 4.17187 9.67936 3.25 12 3.25C14.3206 3.25 16.5462 4.17187 18.1872 5.81282C19.8281 7.45376 20.75 9.67936 20.75 12C20.75 14.3206 19.8281 16.5462 18.1872 18.1872C16.5462 19.8281 14.3206 20.75 12 20.75C9.67936 20.75 7.45376 19.8281 5.81282 18.1872C4.17187 16.5462 3.25 14.3206 3.25 12C3.25 9.67936 4.17187 7.45376 5.81282 5.81282ZM9.57507 9.36453C9.82238 9.3244 10.0757 9.34359 10.3141 9.42053C10.5526 9.49747 10.7693 9.62995 10.9465 9.80706L10.9473 9.80785L11.559 10.417C11.8032 10.6602 12.1982 10.6598 12.4419 10.4161L13.051 9.80706L13.0511 9.80694C13.2283 9.62989 13.445 9.49745 13.6834 9.42053C13.9218 9.34359 14.1751 9.3244 14.4224 9.36453C14.6697 9.40466 14.904 9.50296 15.1058 9.65135C15.3075 9.7996 15.4712 9.99359 15.5833 10.2174C15.731 10.5145 15.7816 10.8505 15.728 11.1779C15.6744 11.5056 15.5192 11.8081 15.2842 12.0427L15.2841 12.0426L15.2745 12.0527L11.9998 15.4716L8.72289 12.0525L8.723 12.0524L8.71303 12.0425C8.47799 11.8081 8.32267 11.5056 8.26907 11.178C8.2155 10.8506 8.26625 10.5146 8.41415 10.2176C8.52626 9.9937 8.68991 9.79964 8.89166 9.65135C9.09353 9.50296 9.32777 9.40466 9.57507 9.36453ZM16.702 9.65986L16.1425 9.93832L16.7014 9.65866C16.5007 9.25753 16.2076 8.90982 15.8462 8.64416C15.4847 8.37851 15.0654 8.20251 14.6226 8.13067C14.1799 8.05882 13.7264 8.09319 13.2995 8.23093C12.8726 8.36868 12.4846 8.60586 12.1673 8.92294L12.1672 8.92306L11.9991 9.09119L11.8302 8.92294L11.8297 8.92251C11.5125 8.60564 11.1247 8.36861 10.698 8.23093C10.2711 8.09319 9.81762 8.05882 9.37486 8.13067C8.93211 8.20251 8.51275 8.37851 8.15134 8.64416C7.78992 8.90982 7.49678 9.25753 7.29607 9.65866L7.855 9.93834L7.29562 9.65955C7.03052 10.1915 6.93951 10.7933 7.03547 11.3798C7.13103 11.9639 7.40718 12.5033 7.82502 12.9222L11.5488 16.8075C11.6667 16.9305 11.8297 17 12.0001 17C12.1705 17 12.3335 16.9304 12.4514 16.8073L16.1727 12.9221C16.5902 12.503 16.8661 11.9637 16.9616 11.3798C17.0576 10.7934 16.9668 10.1918 16.702 9.65986Z" })
  ] });
});
HeartCircleIcon.displayName = "HeartCircleIcon";
const HelpIcon = forwardRef((props, ref2) => {
  const defaultFill = `var(${TOKENS.color.foreground.default}, ${ICON_FILL_DEFAULT})`;
  const {
    size: size2,
    title,
    ...rest
  } = props;
  const mappedSizeOrDefault = size2 ? ICON_SIZE_MAPPINGS[size2] : ICON_SIZE_DEFAULT;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { width: mappedSizeOrDefault, height: mappedSizeOrDefault, viewBox: "0 0 24 24", fill: defaultFill, xmlns: "http://www.w3.org/2000/svg", role: "img", "aria-label": "Help Icon", ...rest, ref: ref2, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("title", { children: title || "Help Icon" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11.975 3.21459C11.0527 3.21459 10.1399 3.40176 9.29204 3.76478C8.44416 4.1278 7.67876 4.65911 7.04218 5.32655C6.40561 5.99399 5.91111 6.78367 5.58861 7.64778C5.32424 8.35614 5.17997 9.10245 5.16059 9.85599C5.45364 9.94051 5.73153 10.0787 5.97916 10.2666C6.5048 10.6655 6.85136 11.256 6.9434 11.9093L7.4347 15.1153C7.5335 15.7715 7.36822 16.4402 6.97505 16.9748C6.58189 17.5094 5.99288 17.8664 5.33703 17.9677L5.3266 17.9693C4.67615 18.0585 4.0167 17.8882 3.49072 17.4952C2.96474 17.1023 2.61443 16.5182 2.51547 15.8692L2.5152 15.8674L2.03233 12.6371C1.98082 12.313 1.99385 11.9819 2.07068 11.6628C2.14778 11.3426 2.28761 11.0408 2.48208 10.775C2.67656 10.5091 2.92181 10.2845 3.20366 10.114C3.42345 9.98109 3.6621 9.88317 3.91101 9.82337C3.934 8.93181 4.10472 8.04882 4.41751 7.21071C4.79915 6.18814 5.38433 5.25366 6.13763 4.46383C6.89094 3.674 7.79669 3.04526 8.80006 2.61567C9.80343 2.18609 10.8835 1.96459 11.975 1.96459C13.0665 1.96459 14.1466 2.18609 15.1499 2.61567C16.1533 3.04526 17.0591 3.674 17.8124 4.46383C18.5657 5.25366 19.1509 6.18814 19.5325 7.21071C19.8405 8.03588 20.0107 8.90455 20.0378 9.78207C20.3115 9.84027 20.5737 9.94437 20.8133 10.0903C21.0976 10.2635 21.3442 10.4921 21.5384 10.7625C21.7326 11.0329 21.8704 11.3396 21.9437 11.6643C22.0162 11.9858 22.0241 12.3184 21.9668 12.6428L21.4872 15.8515C21.4538 16.1832 21.3541 16.505 21.1941 16.7976C21.031 17.0956 20.8088 17.3572 20.5409 17.5662C20.2731 17.7752 19.9653 17.9273 19.6365 18.013C19.3078 18.0987 18.965 18.1162 18.6292 18.0646C18.582 18.0573 18.5351 18.0487 18.4885 18.0388C17.9337 18.7124 17.2723 19.2924 16.5293 19.755C15.7272 20.2544 14.8441 20.6083 13.9209 20.8012C13.5644 21.516 12.8284 22.0083 11.975 22.0083C10.7706 22.0083 9.8 21.0277 9.8 19.825C9.8 18.6223 10.7706 17.6417 11.975 17.6417C13.0569 17.6417 13.9502 18.4331 14.1207 19.4659C14.7355 19.2925 15.3241 19.0329 15.8686 18.6938C16.4173 18.3522 16.9133 17.9349 17.3425 17.4551C17.197 17.3243 17.0671 17.1766 16.9556 17.0147C16.763 16.7348 16.6296 16.4185 16.5637 16.0852C16.4991 15.7585 16.5007 15.4223 16.5682 15.0964L17.0555 11.9163C17.0945 11.59 17.1979 11.2748 17.3597 10.9887C17.5235 10.6989 17.744 10.445 18.008 10.2422C18.2424 10.062 18.5069 9.92525 18.7889 9.83822C18.7678 9.09071 18.6237 8.35057 18.3614 7.64778C18.0389 6.78367 17.5444 5.99399 16.9078 5.32655C16.2712 4.65911 15.5058 4.1278 14.658 3.76478C13.8101 3.40176 12.8973 3.21459 11.975 3.21459ZM12.8666 20.0746C12.8884 19.9952 12.9 19.9116 12.9 19.825C12.9 19.3064 12.4827 18.8917 11.975 18.8917C11.4673 18.8917 11.05 19.3064 11.05 19.825C11.05 20.3436 11.4673 20.7583 11.975 20.7583C12.3934 20.7583 12.7504 20.4767 12.8631 20.0873C12.8642 20.0831 12.8654 20.0788 12.8666 20.0746ZM19.3788 11.0076C19.3509 11.0063 19.3235 11.0032 19.2968 10.9984C19.268 11.0037 19.2393 11.0101 19.2108 11.0175C19.0508 11.0591 18.9008 11.1325 18.7697 11.2332C18.6386 11.334 18.5291 11.4601 18.4477 11.604C18.3664 11.7479 18.3147 11.9067 18.296 12.071C18.295 12.0789 18.294 12.0868 18.2928 12.0947L17.8011 15.303C17.7992 15.3154 17.7969 15.3278 17.7943 15.3401C17.7586 15.5056 17.7571 15.6766 17.79 15.8427C17.8228 16.0088 17.8893 16.1664 17.9853 16.3059C18.0639 16.4202 18.1611 16.5203 18.2725 16.6022C18.4666 16.5857 18.6795 16.6726 18.8072 16.8272L18.8192 16.8291C18.9866 16.8548 19.1574 16.8461 19.3212 16.8034C19.4851 16.7607 19.6384 16.6849 19.7719 16.5808C19.9054 16.4766 20.0162 16.3463 20.0974 16.1977C20.1786 16.0492 20.2287 15.8856 20.2444 15.717C20.2454 15.7055 20.2468 15.694 20.2485 15.6826L20.7319 12.4493L20.735 12.4305C20.7644 12.2678 20.7608 12.1008 20.7244 11.9396C20.688 11.7783 20.6195 11.626 20.5231 11.4917C20.4266 11.3574 20.3042 11.2438 20.163 11.1578C20.0218 11.0718 19.8647 11.0151 19.7011 10.9909C19.6659 10.9858 19.6305 10.9821 19.595 10.98C19.527 11.0013 19.4541 11.0112 19.3788 11.0076ZM3.85054 11.1836C3.98972 11.0994 4.14408 11.0434 4.30482 11.0188C4.63112 10.9759 4.96125 11.0633 5.22351 11.2624C5.48695 11.4623 5.66043 11.7585 5.70595 12.086L5.70721 12.0947L6.19863 15.3014C6.24796 15.6303 6.16513 15.9662 5.96804 16.2342C5.77185 16.501 5.47845 16.6796 5.15152 16.7315C4.82799 16.7745 4.5004 16.6892 4.23881 16.4938C3.97605 16.2975 3.80097 16.0058 3.75132 15.6816L3.26813 12.4493L3.26712 12.4427C3.24112 12.2806 3.24752 12.115 3.28595 11.9554C3.32437 11.7958 3.39405 11.6455 3.49096 11.513C3.58787 11.3805 3.71009 11.2686 3.85054 11.1836Z" })
  ] });
});
HelpIcon.displayName = "HelpIcon";
const HomeIcon = forwardRef((props, ref2) => {
  const defaultFill = `var(${TOKENS.color.foreground.default}, ${ICON_FILL_DEFAULT})`;
  const {
    size: size2,
    title,
    ...rest
  } = props;
  const mappedSizeOrDefault = size2 ? ICON_SIZE_MAPPINGS[size2] : ICON_SIZE_DEFAULT;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { width: mappedSizeOrDefault, height: mappedSizeOrDefault, viewBox: "0 0 48 48", fill: defaultFill, xmlns: "http://www.w3.org/2000/svg", role: "img", "aria-label": "Home Icon", ...rest, ref: ref2, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("title", { children: title || "Home Icon" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { className: "st0", d: "M45.623,23.634l-6-5.995c0,0,0,0,0,0L26.739,4.765c-0.753-0.758-1.756-1.178-2.825-1.182\n	c-0.004,0-0.008,0-0.013,0c-1.064,0-2.065,0.413-2.823,1.166L8.211,17.628C8.21,17.629,8.209,17.63,8.208,17.63l-5.999,6.004\n	c-0.39,0.391-0.39,1.024,0,1.414c0.195,0.195,0.451,0.293,0.707,0.293s0.512-0.098,0.708-0.293l4.292-4.296v21.589\n	c0,0.553,0.448,1,1,1h30c0.553,0,1-0.447,1-1V20.759l4.293,4.29c0.391,0.391,1.023,0.391,1.414,0S46.014,24.025,45.623,23.634z\n	 M28.916,41.342h-10v-8c0-2.757,2.243-5,5-5s5,2.243,5,5V41.342z M37.916,41.342h-7v-8c0-3.859-3.141-7-7-7c-3.86,0-7,3.141-7,7v8\n	h-7V18.751L22.491,6.166c0.377-0.375,0.878-0.582,1.41-0.582c0.002,0,0.004,0,0.006,0c0.535,0.002,1.037,0.212,1.416,0.594\n	l12.593,12.583V41.342z" })
  ] });
});
HomeIcon.displayName = "HomeIcon";
const HorizontalDotsIcon = forwardRef((props, ref2) => {
  const defaultFill = `var(${TOKENS.color.foreground.default}, ${ICON_FILL_DEFAULT})`;
  const {
    size: size2,
    title,
    ...rest
  } = props;
  const mappedSizeOrDefault = size2 ? ICON_SIZE_MAPPINGS[size2] : ICON_SIZE_DEFAULT;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { width: mappedSizeOrDefault, height: mappedSizeOrDefault, viewBox: "0 0 24 24", fill: defaultFill, xmlns: "http://www.w3.org/2000/svg", role: "img", "aria-label": "horizontal dots Icon", ...rest, ref: ref2, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("title", { children: title || "horizontal dots Icon" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7 12C7 13.1046 6.10457 14 5 14C3.89543 14 3 13.1046 3 12C3 10.8954 3.89543 10 5 10C6.10457 10 7 10.8954 7 12ZM14 12C14 13.1046 13.1046 14 12 14C10.8954 14 10 13.1046 10 12C10 10.8954 10.8954 10 12 10C13.1046 10 14 10.8954 14 12ZM19 14C20.1046 14 21 13.1046 21 12C21 10.8954 20.1046 10 19 10C17.8954 10 17 10.8954 17 12C17 13.1046 17.8954 14 19 14Z" })
  ] });
});
HorizontalDotsIcon.displayName = "HorizontalDotsIcon";
const HorizontalDetailsDropdownIcon = forwardRef((props, ref2) => {
  const defaultFill = `var(${TOKENS.color.foreground.default}, ${ICON_FILL_DEFAULT})`;
  const {
    size: size2,
    title,
    fill,
    ...rest
  } = props;
  const mappedSizeOrDefault = size2 ? ICON_SIZE_MAPPINGS[size2] : ICON_SIZE_DEFAULT;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { width: mappedSizeOrDefault, height: mappedSizeOrDefault, viewBox: "0 0 6 12", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img", "aria-label": "Horizontal details dropdown icon", ref: ref2, ...rest, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("title", { children: title || "Horizontal details dropdown icon" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M5.583 5.307a1 1 0 0 1 0 1.386L1.721 10.707C1.096 11.356 0 10.914 0 10.014V1.986C0 1.086 1.096 0.644 1.721 1.293L5.583 5.307Z", fill: fill ?? defaultFill })
  ] });
});
HorizontalDetailsDropdownIcon.displayName = "HorizontalDetailsDropdownIcon";
const IdVerifyIcon = forwardRef((props, ref2) => {
  const defaultFill = `var(${TOKENS.color.foreground.default}, ${ICON_FILL_DEFAULT})`;
  const {
    size: size2,
    title,
    ...rest
  } = props;
  const mappedSizeOrDefault = size2 ? ICON_SIZE_MAPPINGS[size2] : ICON_SIZE_DEFAULT;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { width: mappedSizeOrDefault, height: mappedSizeOrDefault, viewBox: "0 0 32 36", version: "1.1", fill: defaultFill, ref: ref2, ...rest, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("title", { children: title || "Identify Verification Icon" }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("g", { id: "icon/mark/idVerify", stroke: "none", strokeWidth: "1", fillRule: "evenodd", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("title", { children: "Id Verify Icon" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M16.6003099,16.5906337 L16.1540599,16.5906337 C17.9572188,16.4619175 19.3347652,14.928648 19.2703662,13.1220483 C19.2059673,11.3154485 17.7227445,9.88415545 15.9149974,9.88415545 C14.1072502,9.88415545 12.6240274,11.3154485 12.5596285,13.1220483 C12.4952295,14.928648 13.872776,16.4619175 15.6759349,16.5906337 C12.533482,16.6953021 9.96031176,19.1227352 9.67280986,22.2537587 C9.66071544,22.4009082 9.7116684,22.5462728 9.81298588,22.6536693 C9.91430335,22.7610658 10.0564559,22.8203931 10.2040599,22.8168837 L21.5728099,22.8168837 C21.7204138,22.8203931 21.8625664,22.7610658 21.9638838,22.6536693 C22.0652013,22.5462728 22.1161543,22.4009082 22.1040599,22.2537587 C21.8503739,19.2970833 19.5485412,16.9285952 16.6003099,16.5906337 L16.6003099,16.5906337 Z", id: "Person" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M15.8884349,5.0625087 C20.6657558,5.0625087 24.9720621,7.94203083 26.7972716,12.356938 C28.6224812,16.7718452 27.606693,21.8516085 24.2240531,25.2251144 C20.8414131,28.5986203 15.7589217,29.6006695 11.3489659,27.7635291 C6.93901009,25.9263887 4.0711598,21.6123122 4.08401652,16.8350087 C4.10745489,10.3305118 9.38389847,5.06831604 15.8884349,5.0625087 M15.8884349,4.00000435 C10.675146,3.9957357 5.97361248,7.13512834 3.97958534,11.9520002 C1.9855582,16.7688721 3.09249014,22.3127792 6.78341221,25.9945578 C10.4743343,29.6763363 16.0209698,30.769514 20.832881,28.7635454 C25.6447922,26.7575768 28.7725137,22.0482709 28.7553805,16.8350087 C28.7377366,9.741281 22.9821843,4.00000435 15.8884349,4.00000435 Z", id: "MagnifyingGlass" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M28.7553099,32.1881337 C28.6171099,32.1868073 28.4844254,32.1337336 28.3834349,32.0393837 L23.6128099,27.2581337 C23.4799517,27.1252756 23.4280647,26.9316306 23.4766941,26.750143 C23.5253236,26.5686554 23.6670815,26.4268974 23.8485692,26.378268 C24.0300568,26.3296385 24.2237017,26.3815255 24.3565599,26.5143837 L29.1378099,31.2850087 C29.3415796,31.4951857 29.3415796,31.8292067 29.1378099,32.0393837 C29.033011,32.1344314 28.896789,32.1874066 28.7553099,32.1881337 L28.7553099,32.1881337 Z", id: "MagnifyingHandle" })
    ] })
  ] });
});
IdVerifyIcon.displayName = "IdVerifyIcon";
const InfoCircleIcon = forwardRef((props, ref2) => {
  const defaultFill = `var(${TOKENS.color.foreground.default}, ${ICON_FILL_DEFAULT})`;
  const {
    size: size2,
    title,
    ...rest
  } = props;
  const mappedSizeOrDefault = size2 ? ICON_SIZE_MAPPINGS[size2] : ICON_SIZE_DEFAULT;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { width: mappedSizeOrDefault, height: mappedSizeOrDefault, viewBox: "0 0 24 24", fill: defaultFill, xmlns: "http://www.w3.org/2000/svg", role: "img", "aria-label": "Info circle Icon", ...rest, ref: ref2, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("title", { children: title || "Info circle Icon" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M12 2C17.5229 2 22 6.47714 22 12C22 17.5229 17.5229 22 12 22C6.47714 22 2 17.5229 2 12C2 6.47715 6.47715 2 12 2ZM12 3.25C7.16751 3.25 3.25 7.16751 3.25 12C3.25 16.8325 7.1675 20.75 12 20.75C16.8325 20.75 20.75 16.8325 20.75 12C20.75 7.1675 16.8325 3.25 12 3.25ZM11.375 10.125C11.7066 10.125 12.0246 10.2567 12.2587 10.491C12.4598 10.6919 12.5853 10.9543 12.617 11.2339L12.625 11.375V14.5C12.625 14.6658 12.6909 14.8248 12.808 14.942C12.9018 15.0357 13.0223 15.0966 13.1516 15.1172L13.25 15.125H13.875C14.2202 15.125 14.5 15.4048 14.5 15.75C14.5 16.0638 14.2687 16.3236 13.9674 16.3682L13.875 16.375H13.25C12.7527 16.375 12.2758 16.1775 11.9242 15.8258C11.6116 15.5133 11.4208 15.1017 11.3823 14.6649L11.375 14.5L11.3748 11.3749L10.75 11.375C10.4048 11.375 10.125 11.0952 10.125 10.75C10.125 10.4362 10.3563 10.1764 10.6576 10.1318L10.75 10.125H11.375ZM11.6875 7C12.2053 7 12.625 7.41973 12.625 7.9375C12.625 8.41828 12.2631 8.81454 11.7968 8.86869L11.6875 8.875C11.1697 8.875 10.75 8.45527 10.75 7.9375C10.75 7.45672 11.1119 7.06046 11.5782 7.00631L11.6875 7Z" })
  ] });
});
InfoCircleIcon.displayName = "InfoCircleIcon";
const JobSearchIcon = forwardRef((props, ref2) => {
  const {
    size: size2,
    title,
    ...rest
  } = props;
  const mappedSizeOrDefault = size2 ? ICON_SIZE_MAPPINGS[size2] : ICON_SIZE_DEFAULT;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { width: mappedSizeOrDefault, height: mappedSizeOrDefault, viewBox: "0 0 48 48", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img", "aria-label": "Clipboard Icon", ...rest, ref: ref2, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("title", { children: title || "Job Search Icon" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M23.0001 47L17.6941 40.842C17.0078 40.0178 16.8134 38.89 17.184 37.8836C17.5546 36.8771 18.4341 36.1448 19.491 35.9626C20.548 35.7803 21.6218 36.1758 22.3081 37L27.0001 42.652V23C27.0001 21.3431 28.3433 20 30.0001 20C31.657 20 33.0001 21.3431 33.0001 23V35H39.0001C43.4184 35 47.0001 38.5817 47.0001 43V47", stroke: "#282624", strokeLinecap: "round", strokeLinejoin: "round" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M27 16V7C27 5.89543 26.1046 5 25 5H3C1.89543 5 1 5.89543 1 7V41C1 42.1046 1.89543 43 3 43H12", stroke: "#282624", strokeLinecap: "round", strokeLinejoin: "round" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M31 16V3C31 1.89543 30.1046 1 29 1H6", stroke: "#282624", strokeLinecap: "round", strokeLinejoin: "round" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M7 31H21", stroke: "#282624", strokeLinecap: "round", strokeLinejoin: "round" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14 18C15.933 18 17.5 16.433 17.5 14.5C17.5 12.567 15.933 11 14 11C12.067 11 10.5 12.567 10.5 14.5C10.5 16.433 12.067 18 14 18Z", stroke: "#282624", strokeLinecap: "round", strokeLinejoin: "round" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M21 25.0015C20.1841 21.8017 17.3022 19.5625 14 19.5625C10.6978 19.5625 7.81595 21.8017 7 25.0015H21Z", fill: "#7DD9E8", stroke: "#282624", strokeLinecap: "round", strokeLinejoin: "round" })
  ] });
});
JobSearchIcon.displayName = "CheckmarkIcon";
const LinkIcon = forwardRef((props, ref2) => {
  const defaultFill = `var(${TOKENS.color.foreground.default}, ${ICON_FILL_DEFAULT})`;
  const {
    size: size2,
    title,
    ...rest
  } = props;
  const mappedSizeOrDefault = size2 ? ICON_SIZE_MAPPINGS[size2] : ICON_SIZE_DEFAULT;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { width: mappedSizeOrDefault, height: mappedSizeOrDefault, viewBox: "0 0 24 24", fill: defaultFill, xmlns: "http://www.w3.org/2000/svg", role: "img", "aria-label": "Link Icon", ...rest, ref: ref2, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("title", { children: title || "Link Icon" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M17.625 1.99498C16.4647 1.99498 15.3519 2.45592 14.5314 3.27639L12.6564 5.15139L12.6553 5.15253C12.2231 5.58686 11.8876 6.10751 11.6704 6.68042C11.4533 7.25334 11.3595 7.86562 11.3952 8.47726C11.4153 8.82185 11.711 9.08489 12.0556 9.06477C12.4002 9.04466 12.6632 8.749 12.6431 8.40441C12.6176 7.96836 12.6845 7.53185 12.8393 7.12341C12.994 6.71521 13.2331 6.34424 13.5409 6.0347L15.4153 4.16028C16.0013 3.57422 16.7962 3.24498 17.625 3.24498C18.4538 3.24498 19.2487 3.57422 19.8347 4.16028C20.4208 4.74633 20.75 5.5412 20.75 6.37C20.75 7.19881 20.4208 7.99367 19.8347 8.57973L17.9601 10.4543C17.6508 10.7631 17.2798 11.003 16.8714 11.1584C16.463 11.3138 16.0263 11.3811 15.5901 11.356C15.2454 11.3362 14.95 11.5995 14.9302 11.9441C14.9104 12.2887 15.1737 12.5842 15.5183 12.604C16.1303 12.6392 16.7429 12.5447 17.3159 12.3267C17.8889 12.1087 18.4094 11.7721 18.8432 11.339L20.7186 9.46361C21.5391 8.64314 22 7.53033 22 6.37C22 5.20967 21.5391 4.09687 20.7186 3.27639C19.8981 2.45592 18.7853 1.99498 17.625 1.99498ZM16.8169 7.18223C17.061 7.42631 17.061 7.82203 16.8169 8.06611L8.06694 16.8161C7.82286 17.0602 7.42714 17.0602 7.18306 16.8161C6.93898 16.572 6.93898 16.1763 7.18306 15.9322L15.9331 7.18223C16.1771 6.93815 16.5729 6.93815 16.8169 7.18223ZM6.68408 11.6707C7.2571 11.4527 7.86971 11.3583 8.48178 11.3935C8.82639 11.4134 9.08965 11.7088 9.0698 12.0535C9.04994 12.3981 8.75449 12.6613 8.40988 12.6415C7.97363 12.6163 7.53698 12.6837 7.12856 12.839C6.72029 12.9944 6.34943 13.2342 6.04028 13.5428L4.16528 15.4178C3.57922 16.0038 3.24998 16.7987 3.24998 17.6275C3.24998 18.0379 3.33081 18.4443 3.48786 18.8234C3.6449 19.2025 3.87509 19.547 4.16528 19.8372C4.45546 20.1274 4.79996 20.3576 5.17911 20.5146C5.55825 20.6717 5.96462 20.7525 6.375 20.7525C7.20381 20.7525 7.99867 20.4233 8.58473 19.8372L10.4594 17.9626C10.768 17.6534 11.0081 17.2822 11.1635 16.8739C11.3188 16.4655 11.3862 16.0289 11.361 15.5926C11.3412 15.248 11.6044 14.9526 11.949 14.9327C12.2937 14.9128 12.5891 15.1761 12.609 15.5207C12.6442 16.1328 12.5498 16.7454 12.3318 17.3184C12.1138 17.8914 11.7771 18.4119 11.3439 18.8458L9.46861 20.7211C8.64813 21.5416 7.53533 22.0025 6.375 22.0025C5.80046 22.0025 5.23155 21.8894 4.70075 21.6695C4.16995 21.4496 3.68765 21.1274 3.28139 20.7211C2.87513 20.3149 2.55287 19.8326 2.33301 19.3018C2.11314 18.771 1.99998 18.202 1.99998 17.6275C1.99998 16.4672 2.46092 15.3544 3.28139 14.5339L5.15639 12.6589C5.59024 12.2257 6.11106 11.8887 6.68408 11.6707Z" })
  ] });
});
LinkIcon.displayName = "LinkIcon";
const LoadingIcon = forwardRef((props, ref2) => {
  const defaultFill = `var(${TOKENS.color.foreground.default}, ${ICON_FILL_DEFAULT})`;
  const {
    size: size2,
    title,
    ...rest
  } = props;
  const mappedSizeOrDefault = size2 ? ICON_SIZE_MAPPINGS[size2] : ICON_SIZE_DEFAULT;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { width: mappedSizeOrDefault, height: mappedSizeOrDefault, viewBox: "0 0 24 24", fill: defaultFill, xmlns: "http://www.w3.org/2000/svg", role: "img", "aria-label": "Loading Icon", ...rest, ref: ref2, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("title", { children: title || "Loading Icon" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13.9857 4.97794C12.4969 4.56921 10.9183 4.62985 9.4653 5.15161C8.0123 5.67336 6.75571 6.6308 5.86706 7.89324C4.97842 9.15567 4.50101 10.6616 4.5 12.2054V12.2058V12.572L3.06694 11.1389C2.82286 10.8948 2.42714 10.8948 2.18306 11.1389C1.93898 11.383 1.93898 11.7787 2.18306 12.0228L4.65099 14.4907C4.7656 14.624 4.93545 14.7083 5.125 14.7083C5.31455 14.7083 5.4844 14.624 5.59901 14.4907L8.06694 12.0228C8.31102 11.7787 8.31102 11.383 8.06694 11.1389C7.82286 10.8948 7.42714 10.8948 7.18306 11.1389L5.75 12.572V12.2061C5.75087 10.9196 6.14871 9.66473 6.88922 8.61275C7.62976 7.56072 8.67692 6.76286 9.88775 6.32806C11.0986 5.89326 12.4141 5.84272 13.6547 6.18334C14.8953 6.52396 16.0006 7.23913 16.8197 8.23124C17.0395 8.49743 17.4334 8.53506 17.6996 8.3153C17.9658 8.09555 18.0034 7.70161 17.7836 7.43543C16.8007 6.24489 15.4744 5.38668 13.9857 4.97794ZM18.9072 10.3316C18.8965 10.3311 18.8858 10.3308 18.875 10.3308C18.7903 10.3308 18.7095 10.3477 18.6358 10.3783C18.562 10.4088 18.493 10.454 18.4331 10.5139L15.9331 13.0139C15.689 13.258 15.689 13.6537 15.9331 13.8978C16.1771 14.1419 16.5729 14.1419 16.8169 13.8978L18.2444 12.4704C18.1951 13.6289 17.8243 14.7529 17.171 15.7152C16.4681 16.7506 15.4705 17.5511 14.3075 18.0131C13.1444 18.4752 11.8695 18.5774 10.6477 18.3066C9.42586 18.0358 8.31348 17.4045 7.45455 16.4944C7.21763 16.2433 6.82207 16.2319 6.57103 16.4688C6.31999 16.7057 6.30854 17.1013 6.54545 17.3523C7.57618 18.4445 8.91104 19.2021 10.3772 19.527C11.8434 19.852 13.3733 19.7293 14.769 19.1748C16.1646 18.6204 17.3617 17.6597 18.2052 16.4173C19.001 15.245 19.4475 13.8729 19.4956 12.4604L20.9331 13.8978C21.1771 14.1419 21.5729 14.1419 21.8169 13.8978C22.061 13.6537 22.061 13.258 21.8169 13.0139L19.3169 10.5139C19.257 10.454 19.188 10.4088 19.1142 10.3783C19.0499 10.3516 18.9802 10.3353 18.9072 10.3316Z" })
  ] });
});
LoadingIcon.displayName = "LoadingIcon";
const LockIcon = forwardRef((props, ref2) => {
  const defaultFill = `var(${TOKENS.color.foreground.default}, ${ICON_FILL_DEFAULT})`;
  const {
    size: size2,
    title,
    ...rest
  } = props;
  const mappedSizeOrDefault = size2 ? ICON_SIZE_MAPPINGS[size2] : ICON_SIZE_DEFAULT;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { width: mappedSizeOrDefault, height: mappedSizeOrDefault, viewBox: "0 0 24 24", fill: defaultFill, xmlns: "http://www.w3.org/2000/svg", role: "img", "aria-label": "Lock Icon", ...rest, ref: ref2, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("title", { children: title || "Lock Icon" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 3.25C11.0054 3.25 10.0516 3.64509 9.34835 4.34835C8.64509 5.05161 8.25 6.00544 8.25 7V9.5H15.75V7C15.75 6.00544 15.3549 5.05161 14.6517 4.34835C13.9484 3.64509 12.9946 3.25 12 3.25ZM7 7V9.5H6.375C5.33947 9.5 4.5 10.3395 4.5 11.375V20.125C4.5 21.1605 5.33947 22 6.375 22H17.625C18.6605 22 19.5 21.1605 19.5 20.125V11.375C19.5 10.3395 18.6605 9.5 17.625 9.5H17V7C17 5.67392 16.4732 4.40215 15.5355 3.46447C14.5979 2.52678 13.3261 2 12 2C10.6739 2 9.40215 2.52678 8.46447 3.46447C7.52678 4.40215 7 5.67392 7 7ZM5.75 11.375C5.75 11.0298 6.02982 10.75 6.375 10.75H7.625H16.375H17.625C17.9702 10.75 18.25 11.0298 18.25 11.375V20.125C18.25 20.4702 17.9702 20.75 17.625 20.75H6.375C6.02982 20.75 5.75 20.4702 5.75 20.125V11.375ZM12.625 14.5C12.625 14.1548 12.3452 13.875 12 13.875C11.6548 13.875 11.375 14.1548 11.375 14.5V17C11.375 17.3452 11.6548 17.625 12 17.625C12.3452 17.625 12.625 17.3452 12.625 17V14.5Z" })
  ] });
});
LockIcon.displayName = "LockIcon";
const LoginIcon = forwardRef((props, ref2) => {
  const defaultFill = `var(${TOKENS.color.foreground.default}, ${ICON_FILL_DEFAULT})`;
  const {
    size: size2,
    title,
    ...rest
  } = props;
  const mappedSizeOrDefault = size2 ? ICON_SIZE_MAPPINGS[size2] : ICON_SIZE_DEFAULT;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { width: mappedSizeOrDefault, height: mappedSizeOrDefault, viewBox: "0 0 24 24", fill: defaultFill, xmlns: "http://www.w3.org/2000/svg", role: "img", "aria-label": "Login Icon", ...rest, ref: ref2, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("title", { children: title || "Login Icon" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3.76084 2.625C3.75046 2.625 3.74009 2.62526 3.72972 2.62578C3.24844 2.64977 2.79627 2.86347 2.47221 3.22011C2.15169 3.57284 1.98232 4.03697 2.00001 4.51283V19.4874C1.98259 19.9631 2.15204 20.427 2.47246 20.7797C2.79638 21.1361 3.24824 21.3499 3.72929 21.3742C3.7398 21.3747 3.75032 21.375 3.76084 21.375H13.9883C13.9987 21.375 14.0091 21.3747 14.0195 21.3742C14.5007 21.3502 14.9529 21.1366 15.2771 20.7801C15.5978 20.4274 15.7674 19.9633 15.75 19.4874V15.75C15.75 15.4048 15.4702 15.125 15.125 15.125C14.7798 15.125 14.5 15.4048 14.5 15.75V19.5C14.5 19.5094 14.5002 19.5188 14.5006 19.5282C14.5075 19.6794 14.4541 19.8272 14.3523 19.9391C14.2533 20.048 14.1163 20.1144 13.9699 20.125H3.7795C3.63322 20.1143 3.49644 20.0478 3.39758 19.939C3.29583 19.8271 3.24254 19.6793 3.24937 19.5282C3.24979 19.5188 3.25001 19.5094 3.25001 19.5V4.5C3.25001 4.49045 3.24979 4.48091 3.24935 4.47137C3.24242 4.32031 3.29563 4.17265 3.39733 4.06074C3.49617 3.95196 3.63298 3.88556 3.77925 3.875H13.9699C14.1164 3.88556 14.2533 3.95201 14.3523 4.06085C14.4541 4.17284 14.5075 4.32061 14.5006 4.47182C14.5002 4.48121 14.5 4.4906 14.5 4.5V8.25C14.5 8.59518 14.7798 8.875 15.125 8.875C15.4702 8.875 15.75 8.59518 15.75 8.25V4.51263C15.7674 4.03668 15.5978 3.57256 15.2771 3.21989C14.9529 2.86338 14.5007 2.64976 14.0195 2.62577C14.0091 2.62526 13.9987 2.625 13.9883 2.625H3.76084ZM11.8169 8.43638C12.061 8.68046 12.061 9.07619 11.8169 9.32027L9.75889 11.3783H21.375C21.7202 11.3783 22 11.6581 22 12.0033C22 12.3485 21.7202 12.6283 21.375 12.6283H9.75889L11.8169 14.6864C12.061 14.9305 12.061 15.3262 11.8169 15.5703C11.5729 15.8143 11.1771 15.8143 10.9331 15.5703L7.80807 12.4453C7.74814 12.3853 7.70293 12.3163 7.67243 12.2426C7.64187 12.1689 7.62501 12.0881 7.62501 12.0033C7.62501 11.8434 7.68603 11.6834 7.80807 11.5614L10.9331 8.43638C11.1771 8.19231 11.5729 8.19231 11.8169 8.43638Z" })
  ] });
});
LoginIcon.displayName = "LoginIcon";
const LogoutIcon = forwardRef((props, ref2) => {
  const defaultFill = `var(${TOKENS.color.foreground.default}, ${ICON_FILL_DEFAULT})`;
  const {
    size: size2,
    title,
    ...rest
  } = props;
  const mappedSizeOrDefault = size2 ? ICON_SIZE_MAPPINGS[size2] : ICON_SIZE_DEFAULT;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { width: mappedSizeOrDefault, height: mappedSizeOrDefault, viewBox: "0 0 24 24", fill: defaultFill, xmlns: "http://www.w3.org/2000/svg", role: "img", "aria-label": "Logout Icon", ...rest, ref: ref2, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("title", { children: title || "Logout Icon" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3.76209 2.625C3.75171 2.625 3.74134 2.62526 3.73098 2.62578C3.24969 2.64977 2.79752 2.86347 2.47346 3.22011C2.15294 3.57284 1.98357 4.03697 2.00126 4.51283L2.00126 19.4874C1.98384 19.9631 2.15329 20.427 2.47371 20.7797C2.79763 21.1361 3.24949 21.3499 3.73054 21.3742C3.74105 21.3747 3.75157 21.375 3.76209 21.375H13.9896C14 21.375 14.0103 21.3747 14.0207 21.3742C14.502 21.3502 14.9542 21.1366 15.2784 20.7801C15.5991 20.4274 15.7687 19.9633 15.7513 19.4874V15.75C15.7513 15.4048 15.4714 15.125 15.1263 15.125C14.7811 15.125 14.5013 15.4048 14.5013 15.75V19.5C14.5013 19.5094 14.5015 19.5188 14.5019 19.5282C14.5087 19.6794 14.4554 19.8272 14.3535 19.9391C14.2546 20.048 14.1176 20.1144 13.9712 20.125H3.78075C3.63448 20.1143 3.49769 20.0478 3.39883 19.939C3.29708 19.8271 3.2438 19.6793 3.25062 19.5282C3.25105 19.5188 3.25126 19.5094 3.25126 19.5L3.25126 4.5C3.25126 4.49045 3.25104 4.48091 3.2506 4.47137C3.24367 4.32031 3.29688 4.17265 3.39858 4.06074C3.49742 3.95196 3.63423 3.88556 3.7805 3.875L13.9712 3.875C14.1176 3.88556 14.2546 3.95201 14.3535 4.06085C14.4554 4.17284 14.5087 4.32061 14.5019 4.47182C14.5015 4.48121 14.5013 4.4906 14.5013 4.5V8.25C14.5013 8.59518 14.7811 8.875 15.1263 8.875C15.4714 8.875 15.7513 8.59518 15.7513 8.25V4.51263C15.7687 4.03668 15.5991 3.57256 15.2784 3.21989C14.9542 2.86338 14.502 2.64976 14.0207 2.62577C14.0103 2.62526 14 2.625 13.9896 2.625L3.76209 2.625Z" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M17.1831 8.68306C16.939 8.92714 16.939 9.32286 17.1831 9.56694L19.2411 11.625L7.625 11.625C7.27982 11.625 7 11.9048 7 12.25C7 12.5952 7.27982 12.875 7.625 12.875L19.2411 12.875L17.1831 14.9331C16.939 15.1771 16.939 15.5729 17.1831 15.8169C17.4271 16.061 17.8229 16.061 18.0669 15.8169L21.1919 12.6919C21.2519 12.632 21.2971 12.563 21.3276 12.4892C21.3581 12.4155 21.375 12.3347 21.375 12.25C21.375 12.09 21.314 11.9301 21.1919 11.8081L18.0669 8.68306C17.8229 8.43898 17.4271 8.43898 17.1831 8.68306Z" })
  ] });
});
LogoutIcon.displayName = "LogoutIcon";
const MailIcon = forwardRef((props, ref2) => {
  const defaultFill = `var(${TOKENS.color.foreground.default}, ${ICON_FILL_DEFAULT})`;
  const {
    size: size2,
    title,
    ...rest
  } = props;
  const mappedSizeOrDefault = size2 ? ICON_SIZE_MAPPINGS[size2] : ICON_SIZE_DEFAULT;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { width: mappedSizeOrDefault, height: mappedSizeOrDefault, viewBox: "0 0 24 24", fill: defaultFill, xmlns: "http://www.w3.org/2000/svg", role: "img", "aria-label": "Mail Icon", ...rest, ref: ref2, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("title", { children: title || "Mail Icon" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 3.25V5.75H15.75C16.0815 5.75 16.3995 5.6183 16.6339 5.38388C16.8683 5.14946 17 4.83152 17 4.5C17 4.16848 16.8683 3.85054 16.6339 3.61612C16.3995 3.3817 16.0815 3.25 15.75 3.25H12ZM12 7H15.75C16.413 7 17.0489 6.73661 17.5178 6.26777C17.9866 5.79893 18.25 5.16304 18.25 4.5C18.25 3.83696 17.9866 3.20107 17.5178 2.73223C17.0489 2.26339 16.413 2 15.75 2H11.375C11.0298 2 10.75 2.27982 10.75 2.625V6.375V8.25H5.125C4.2962 8.25 3.50134 8.57924 2.91529 9.16529C2.32924 9.75134 2 10.5462 2 11.375V17C2 17.3315 2.1317 17.6495 2.36612 17.8839C2.60054 18.1183 2.91848 18.25 3.25 18.25H7.625H12V21.375C12 21.7202 12.2798 22 12.625 22C12.9702 22 13.25 21.7202 13.25 21.375V18.25H20.75C21.0815 18.25 21.3995 18.1183 21.6339 17.8839C21.8683 17.6495 22 17.3315 22 17V11.375C22 10.5462 21.6708 9.75134 21.0847 9.16529C20.4987 8.57924 19.7038 8.25 18.875 8.25H12V7ZM10.75 11.375V9.5H7.62502C8.02833 10.0377 8.25 10.6949 8.25 11.375V17H12.625H20.75V11.375C20.75 10.8777 20.5525 10.4008 20.2008 10.0492C19.8492 9.69754 19.3723 9.5 18.875 9.5H12V11.375C12 11.7202 11.7202 12 11.375 12C11.0298 12 10.75 11.7202 10.75 11.375ZM3.79917 10.0492C4.15081 9.69754 4.62772 9.5 5.125 9.5C5.62228 9.5 6.09919 9.69754 6.45082 10.0492C6.49478 10.0931 6.53632 10.139 6.57538 10.1867C6.84876 10.5204 7 10.9399 7 11.375V17H3.25V11.375C3.25 10.8777 3.44754 10.4008 3.79917 10.0492Z" })
  ] });
});
MailIcon.displayName = "MailIcon";
const MegaphoneIcon = forwardRef((props, ref2) => {
  const {
    size: size2,
    title,
    strokeColor
  } = props;
  const mappedSizeOrDefault = size2 ? ICON_SIZE_MAPPINGS[size2] : ICON_SIZE_DEFAULT;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { width: mappedSizeOrDefault, height: mappedSizeOrDefault, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img", "aria-label": "Megaphone Icon", ...props, ref: ref2, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("title", { children: title || "Megaphone Icon" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.32047 9.1665H3.88047C2.55499 9.1665 1.48047 8.04722 1.48047 6.6665C1.48047 5.28579 2.55499 4.1665 3.88047 4.1665H5.32047V9.1665Z", stroke: strokeColor || "#282624", strokeLinecap: "round", strokeLinejoin: "round" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.32031 9.1665C8.13705 9.16675 10.8907 10.0352 13.2346 11.6625L13.9603 12.1665V1.1665L13.2346 1.6705C10.8907 3.2978 8.13705 4.16625 5.32031 4.1665V9.1665Z", stroke: strokeColor || "#282624", strokeLinecap: "round", strokeLinejoin: "round" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M15.8809 5.6665V7.6665", stroke: strokeColor || "#282624", strokeLinecap: "round", strokeLinejoin: "round" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M5.32031 9.1665C5.31949 10.4895 5.84007 11.7547 6.76031 12.6665", stroke: strokeColor || "#282624", strokeLinecap: "round", strokeLinejoin: "round" })
  ] });
});
MegaphoneIcon.displayName = "MegaphoneIcon";
const MegaphoneNewIcon = forwardRef((props, ref2) => {
  const defaultFill = `var(${TOKENS.color.foreground.default}, ${ICON_FILL_DEFAULT})`;
  const {
    size: size2,
    title,
    ...rest
  } = props;
  const mappedSizeOrDefault = size2 ? ICON_SIZE_MAPPINGS[size2] : ICON_SIZE_DEFAULT;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { width: mappedSizeOrDefault, height: mappedSizeOrDefault, viewBox: "0 0 17 15", xmlns: "http://www.w3.org/2000/svg", fill: defaultFill, role: "img", "aria-label": "Megaphone Icon", ref: ref2, ...rest, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("title", { children: title || "Megaphone Icon" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M0.816984 4.45752L15.2026 0.0457525C15.3729 -0.00390901 15.5524 -0.0132939 15.7269 0.0183397C15.9014 0.0499733 16.0662 0.121759 16.2082 0.228023C16.3502 0.334288 16.4655 0.47212 16.5451 0.630628C16.6247 0.789137 16.6663 0.96398 16.6667 1.14134V12.906C16.6667 13.2094 16.5462 13.5003 16.3316 13.7148C16.1171 13.9293 15.8262 14.0498 15.5229 14.0498C15.4122 14.049 15.3022 14.0328 15.1961 14.0016L8.16992 11.844V12.906C8.16992 13.2094 8.04942 13.5003 7.83492 13.7148C7.62041 13.9293 7.32949 14.0498 7.02613 14.0498H4.41176C4.1084 14.0498 3.81748 13.9293 3.60297 13.7148C3.38847 13.5003 3.26796 13.2094 3.26796 12.906V10.3423L0.816984 9.5915C0.58123 9.52026 0.374592 9.37519 0.227505 9.17765C0.0804195 8.98012 0.000663757 8.74056 -9.53674e-06 8.49428V5.5531C0.000102997 5.30688 0.0796719 5.06726 0.226866 4.86987C0.37406 4.67249 0.58102 4.52787 0.816984 4.45752ZM15.4771 13.0629C15.5015 13.07 15.5271 13.0713 15.5521 13.0668C15.5771 13.0623 15.6006 13.052 15.6209 13.0368C15.6412 13.0215 15.6577 13.0018 15.669 12.9791C15.6804 12.9564 15.6863 12.9314 15.6863 12.906V1.14134C15.6863 1.11597 15.6804 1.09096 15.669 1.06827C15.6577 1.04558 15.6412 1.02584 15.6209 1.01062C15.5925 0.989667 15.5582 0.978229 15.5229 0.977942C15.5093 0.97825 15.4958 0.98045 15.4828 0.984478L8.16992 3.22712V10.8211L15.4771 13.0629ZM4.24836 12.906C4.24836 12.9494 4.26557 12.9909 4.29622 13.0216C4.32686 13.0522 4.36842 13.0694 4.41176 13.0694H7.02613C7.06947 13.0694 7.11103 13.0522 7.14167 13.0216C7.17232 12.9909 7.18953 12.9494 7.18953 12.906V11.5458L4.24836 10.6471V12.906ZM0.980383 8.49428C0.980383 8.52964 0.991849 8.56404 1.01306 8.59232C1.03428 8.6206 1.06409 8.64124 1.09803 8.65114H1.10457L7.18953 10.5204V3.52778L1.09803 5.39624C1.06409 5.40614 1.03428 5.42678 1.01306 5.45507C0.991849 5.48335 0.980383 5.51775 0.980383 5.5531V8.49428Z" })
  ] });
});
MegaphoneNewIcon.displayName = "MegaphoneNewIcon";
const MenuIcon = forwardRef((props, ref2) => {
  const defaultFill = `var(${TOKENS.color.foreground.default}, ${ICON_FILL_DEFAULT})`;
  const {
    size: size2,
    title,
    ...rest
  } = props;
  const mappedSizeOrDefault = size2 ? ICON_SIZE_MAPPINGS[size2] : ICON_SIZE_DEFAULT;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { width: mappedSizeOrDefault, height: mappedSizeOrDefault, viewBox: "0 0 24 24", fill: defaultFill, xmlns: "http://www.w3.org/2000/svg", role: "img", "aria-label": "Menu Icon", ...rest, ref: ref2, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("title", { children: title || "Menu Icon" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3.875 6.3775C3.52982 6.3775 3.25 6.65732 3.25 7.0025C3.25 7.34768 3.52982 7.6275 3.875 7.6275H20.125C20.4702 7.6275 20.75 7.34768 20.75 7.0025C20.75 6.65732 20.4702 6.3775 20.125 6.3775H3.875ZM3.25 12.0025C3.25 11.6573 3.52982 11.3775 3.875 11.3775H20.125C20.4702 11.3775 20.75 11.6573 20.75 12.0025C20.75 12.3477 20.4702 12.6275 20.125 12.6275H3.875C3.52982 12.6275 3.25 12.3477 3.25 12.0025ZM3.25 17.0025C3.25 16.6573 3.52982 16.3775 3.875 16.3775H20.125C20.4702 16.3775 20.75 16.6573 20.75 17.0025C20.75 17.3477 20.4702 17.6275 20.125 17.6275H3.875C3.52982 17.6275 3.25 17.3477 3.25 17.0025Z" })
  ] });
});
MenuIcon.displayName = "MenuIcon";
const MinusCircleIcon = forwardRef((props, ref2) => {
  const defaultFill = `var(${TOKENS.color.foreground.default}, ${ICON_FILL_DEFAULT})`;
  const {
    size: size2,
    title,
    ...rest
  } = props;
  const mappedSizeOrDefault = size2 ? ICON_SIZE_MAPPINGS[size2] : ICON_SIZE_DEFAULT;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { width: mappedSizeOrDefault, height: mappedSizeOrDefault, viewBox: "0 0 24 24", fill: defaultFill, xmlns: "http://www.w3.org/2000/svg", role: "img", "aria-label": "minus circle Icon", ...rest, ref: ref2, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("title", { children: title || "minus circle Icon" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 2C9.34784 2 6.8043 3.05357 4.92893 4.92893C3.05357 6.8043 2 9.34784 2 12C2 14.6522 3.05357 17.1957 4.92893 19.0711C6.8043 20.9464 9.34784 22 12 22C14.6522 22 17.1957 20.9464 19.0711 19.0711C20.9464 17.1957 22 14.6522 22 12C22 9.34784 20.9464 6.8043 19.0711 4.92893C17.1957 3.05357 14.6522 2 12 2ZM5.81282 5.81282C7.45376 4.17187 9.67936 3.25 12 3.25C14.3206 3.25 16.5462 4.17187 18.1872 5.81282C19.8281 7.45376 20.75 9.67936 20.75 12C20.75 14.3206 19.8281 16.5462 18.1872 18.1872C16.5462 19.8281 14.3206 20.75 12 20.75C9.67936 20.75 7.45376 19.8281 5.81282 18.1872C4.17187 16.5462 3.25 14.3206 3.25 12C3.25 9.67936 4.17187 7.45376 5.81282 5.81282ZM8.25 11.375C7.90482 11.375 7.625 11.6548 7.625 12C7.625 12.3452 7.90482 12.625 8.25 12.625H15.75C16.0952 12.625 16.375 12.3452 16.375 12C16.375 11.6548 16.0952 11.375 15.75 11.375H8.25Z" })
  ] });
});
MinusCircleIcon.displayName = "MinusCircleIcon";
const MinusIcon = forwardRef((props, ref2) => {
  const {
    size: size2
  } = props;
  const mappedSizeOrDefault = size2 ? ICON_SIZE_MAPPINGS[size2] : ICON_SIZE_DEFAULT;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { width: mappedSizeOrDefault, height: mappedSizeOrDefault, viewBox: "0 0 24 24", fill: ICON_FILL_DEFAULT, xmlns: "http://www.w3.org/2000/svg", role: "img", "aria-label": "minus Icon", ...props, ref: ref2, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("title", { children: "minus Icon" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2 12C2 11.3265 2.54599 10.7805 3.21951 10.7805H20.7805C21.454 10.7805 22 11.3265 22 12C22 12.6735 21.454 13.2195 20.7805 13.2195H3.21951C2.54599 13.2195 2 12.6735 2 12Z" })
  ] });
});
MinusIcon.displayName = "MinusIcon";
const MoneyPaymentIcon = forwardRef((props, ref2) => {
  const defaultFill = `var(${TOKENS.color.foreground.default}, ${ICON_FILL_DEFAULT})`;
  const {
    size: size2,
    title,
    ...rest
  } = props;
  const mappedSizeOrDefault = size2 ? ICON_SIZE_MAPPINGS[size2] : ICON_SIZE_DEFAULT;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { width: mappedSizeOrDefault, height: mappedSizeOrDefault, viewBox: "0 0 24 24", fill: defaultFill, xmlns: "http://www.w3.org/2000/svg", role: "img", "aria-label": "Money Payment Icon", ...rest, ref: ref2, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("title", { children: title || "Money Payment Icon" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.15849 7.27539C4.65567 7.27539 4.24805 7.68794 4.24805 8.19684C4.24805 8.70574 4.65567 9.11829 5.15849 9.11829C5.66132 9.11829 6.06894 8.70574 6.06894 8.19684C6.06894 7.68794 5.66132 7.27539 5.15849 7.27539Z" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.15849 11.2798C4.65567 11.2798 4.24805 11.6923 4.24805 12.2012C4.24805 12.7101 4.65567 13.1227 5.15849 13.1227C5.66132 13.1227 6.06894 12.7101 6.06894 12.2012C6.06894 11.6923 5.66132 11.2798 5.15849 11.2798Z" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14.5103 7.27539C14.0075 7.27539 13.5999 7.68794 13.5999 8.19684C13.5999 8.70574 14.0075 9.11829 14.5103 9.11829C15.0131 9.11829 15.4207 8.70574 15.4207 8.19684C15.4207 7.68794 15.0131 7.27539 14.5103 7.27539Z" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2 6.30064C2 5.58232 2.57537 5 3.28512 5H16.5859C17.2957 5 17.871 5.58232 17.871 6.30065V9.14083C17.871 9.49266 17.5892 9.77788 17.2416 9.77788C16.8939 9.77788 16.6121 9.49266 16.6121 9.14083V6.30065C16.6121 6.28599 16.6004 6.2741 16.5859 6.2741H3.28512C3.27063 6.2741 3.25889 6.28599 3.25889 6.30064V14.0742C3.25889 14.0888 3.27063 14.1007 3.28512 14.1007H12.206C12.5536 14.1007 12.8355 14.3859 12.8355 14.7378C12.8355 15.0896 12.5536 15.3748 12.206 15.3748H3.28512C2.57537 15.3748 2 14.7925 2 14.0742V6.30064Z" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.05811 10.1876C7.05811 8.57924 8.34639 7.27539 9.93557 7.27539C11.5248 7.27539 12.813 8.57924 12.813 10.1876C12.813 11.796 11.5248 13.0999 9.93557 13.0999C8.34639 13.0999 7.05811 11.796 7.05811 10.1876ZM9.93557 8.54949C9.04166 8.54949 8.317 9.28291 8.317 10.1876C8.317 11.0923 9.04166 11.8258 9.93557 11.8258C10.8295 11.8258 11.5541 11.0923 11.5541 10.1876C11.5541 9.28291 10.8295 8.54949 9.93557 8.54949Z" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M19.4896 8.41309C19.8373 8.41309 20.1191 8.6983 20.1191 9.05014V9.32316C20.1191 9.67499 19.8373 9.96021 19.4896 9.96021C19.142 9.96021 18.8602 9.67499 18.8602 9.32316V9.05014C18.8602 8.6983 19.142 8.41309 19.4896 8.41309ZM5.37207 17.0133C5.37207 16.6614 5.65388 16.3762 6.00152 16.3762H12.6781C13.0258 16.3762 13.3076 16.6614 13.3076 17.0133C13.3076 17.3651 13.0258 17.6503 12.6781 17.6503H6.00152C5.65388 17.6503 5.37207 17.3651 5.37207 17.0133Z" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M18.2399 10.7176C18.2402 11.0695 17.9586 11.3549 17.6109 11.3552C15.9182 11.3564 14.5298 12.6949 14.4501 14.3899C14.3705 16.0846 15.6268 17.5488 17.3116 17.7109C18.9967 17.8732 20.5067 16.6746 20.7475 14.9949C20.7974 14.6467 21.1168 14.4054 21.4608 14.4559C21.8048 14.5064 22.0433 14.8296 21.9934 15.1778C21.6554 17.5354 19.5402 19.2053 17.1924 18.9793C14.8441 18.7533 13.0808 16.7092 13.1927 14.3293C13.3045 11.9496 15.2514 10.0828 17.61 10.0811C17.9577 10.0808 18.2397 10.3658 18.2399 10.7176Z" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M21.8231 11.1251C22.0647 11.3781 22.0578 11.7814 21.8078 12.0259L18.4671 15.2925C18.0442 15.7049 17.3679 15.7055 16.9451 15.2931L16.9438 15.2918L15.8968 14.2646C15.6472 14.0197 15.641 13.6164 15.8829 13.3637C16.1249 13.1111 16.5234 13.1048 16.773 13.3497L17.706 14.2651L20.9331 11.1096C21.1831 10.8651 21.5816 10.872 21.8231 11.1251Z" })
  ] });
});
MoneyPaymentIcon.displayName = "MoneyPaymentIcon";
const NewTabIcon = forwardRef((props, ref2) => {
  const defaultFill = `var(${TOKENS.color.foreground.default}, ${ICON_FILL_DEFAULT})`;
  const {
    size: size2,
    title,
    ...rest
  } = props;
  const mappedSizeOrDefault = size2 ? ICON_SIZE_MAPPINGS[size2] : ICON_SIZE_DEFAULT;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { width: mappedSizeOrDefault, height: mappedSizeOrDefault, viewBox: "0 0 24 24", fill: defaultFill, xmlns: "http://www.w3.org/2000/svg", role: "img", "aria-label": "new tab Icon", ...rest, ref: ref2, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("title", { children: title || "new tab Icon" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14.0833 2.625C14.0833 2.27982 14.3632 2 14.7083 2H21.375C21.7202 2 22 2.27982 22 2.625V9.18417C22 9.52934 21.7202 9.80917 21.375 9.80917C21.0298 9.80917 20.75 9.52934 20.75 9.18417V4.08579L9.98785 14.8308C9.75925 15.059 9.39162 15.056 9.16673 14.824C8.94183 14.592 8.94483 14.2189 9.17344 13.9907L19.9312 3.25H14.7083C14.3632 3.25 14.0833 2.97018 14.0833 2.625ZM2.39663 6.56331C2.65058 6.30936 2.99502 6.16669 3.35417 6.16669H12.1042C12.4493 6.16669 12.7292 6.44651 12.7292 6.79169C12.7292 7.13687 12.4493 7.41669 12.1042 7.41669H3.35417C3.32654 7.41669 3.30004 7.42766 3.28051 7.4472C3.26097 7.46673 3.25 7.49323 3.25 7.52085V20.6459C3.25 20.6735 3.26098 20.7 3.28051 20.7195C3.30004 20.739 3.32654 20.75 3.35417 20.75H16.4792C16.5068 20.75 16.5333 20.739 16.5528 20.7195C16.5724 20.7 16.5833 20.6735 16.5833 20.6459V11.8959C16.5833 11.5507 16.8632 11.2709 17.2083 11.2709C17.5535 11.2709 17.8333 11.5507 17.8333 11.8959V20.6459C17.8333 21.005 17.6907 21.3494 17.4367 21.6034C17.1828 21.8574 16.8383 22 16.4792 22H3.35417C2.99502 22 2.65058 21.8573 2.39663 21.6034C2.14267 21.3494 2 21.005 2 20.6459V7.52085C2 7.16171 2.14267 6.81727 2.39663 6.56331Z" })
  ] });
});
NewTabIcon.displayName = "NewTabIcon";
const PanelLeftIcon = forwardRef((props, ref2) => {
  const defaultFill = `var(${TOKENS.color.foreground.default}, ${ICON_FILL_DEFAULT})`;
  const {
    size: size2,
    title,
    ...rest
  } = props;
  const mappedSizeOrDefault = size2 ? ICON_SIZE_MAPPINGS[size2] : ICON_SIZE_DEFAULT;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { width: mappedSizeOrDefault, height: mappedSizeOrDefault, viewBox: "0 0 20 20", fill: defaultFill, xmlns: "http://www.w3.org/2000/svg", role: "img", "aria-label": "Panel Left Icon", ...rest, ref: ref2, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("title", { children: title || "Panel Left Icon" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M4.99984 18.3334H14.9998C16.839 18.3334 18.3332 16.7878 18.3332 14.8851V5.11502C18.3332 3.21241 16.839 1.66675 14.9998 1.66675H4.99984C3.16064 1.66675 1.6665 3.21241 1.6665 5.11502V14.8851C1.6665 16.7878 3.16064 18.3334 4.99984 18.3334ZM8.05539 2.81617H14.9998C16.2249 2.81617 17.2221 3.84772 17.2221 5.11502V14.8851C17.2221 16.1524 16.2249 17.184 14.9998 17.184H8.05539V2.81617ZM2.77761 5.11502C2.77761 3.84772 3.77478 2.81617 4.99984 2.81617H6.94428V17.184H4.99984C3.77478 17.184 2.77761 16.1524 2.77761 14.8851V5.11502Z" })
  ] });
});
PanelLeftIcon.displayName = "PanelLeftIcon";
const PaperClipIcon = forwardRef((props, ref2) => {
  const defaultFill = `var(${TOKENS.color.foreground.default}, ${ICON_FILL_DEFAULT})`;
  const {
    size: size2,
    title,
    ...rest
  } = props;
  const mappedSizeOrDefault = size2 ? ICON_SIZE_MAPPINGS[size2] : ICON_SIZE_DEFAULT;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { width: mappedSizeOrDefault, height: mappedSizeOrDefault, viewBox: "0 0 24 24", fill: defaultFill, xmlns: "http://www.w3.org/2000/svg", role: "img", "aria-label": "Paper Clip Icon", ...rest, ref: ref2, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("title", { children: title || "Paper Clip Icon" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15.6665 3.64371C15.2824 3.48658 14.8709 3.40752 14.456 3.41112C14.0411 3.41473 13.631 3.50093 13.2497 3.66471C12.8685 3.82849 12.5237 4.06656 12.2354 4.36503L12.2278 4.37287L4.71444 11.8853C4.71443 11.8853 4.71445 11.8853 4.71444 11.8853C3.77677 12.823 3.24997 14.0948 3.24997 15.4208C3.24997 16.7469 3.77675 18.0187 4.71444 18.9564C5.65213 19.8941 6.92391 20.4209 8.25 20.4209C9.57608 20.4209 10.8479 19.8941 11.7855 18.9564C11.7855 18.9564 11.7855 18.9564 11.7855 18.9564L20.933 9.80808C21.1771 9.56399 21.5728 9.56397 21.8169 9.80804C22.061 10.0521 22.061 10.4478 21.817 10.6919L12.6695 19.8403C11.4974 21.0124 9.90761 21.6709 8.25 21.6709C6.59239 21.6709 5.00267 21.0124 3.83056 19.8403C2.65845 18.6682 1.99997 17.0784 1.99997 15.4208C1.99997 13.7632 2.65845 12.1735 3.83056 11.0014L11.3402 3.49257C11.743 3.07662 12.2243 2.74474 12.7564 2.5162C13.2902 2.28691 13.8642 2.16622 14.4451 2.16117C15.0261 2.15612 15.6022 2.26682 16.1398 2.48679C16.6775 2.70677 17.166 3.03163 17.5768 3.44241C17.9875 3.85319 18.3124 4.34167 18.5324 4.87934C18.7524 5.41701 18.863 5.99311 18.858 6.57402C18.853 7.15493 18.7323 7.72902 18.503 8.26278C18.2744 8.7948 17.9426 9.27614 17.5266 9.67892L10.0102 17.1996C9.53873 17.655 8.9072 17.907 8.25171 17.9014C7.59621 17.8959 6.96914 17.633 6.50555 17.1696C6.04195 16.7061 5.77893 16.0791 5.77313 15.4237C5.76733 14.7682 6.01922 14.1366 6.47454 13.665L6.48208 13.6572L13.9955 6.14147C14.2395 5.89735 14.6353 5.89728 14.8794 6.14132C15.1235 6.38536 15.1236 6.78108 14.8795 7.0252L7.37041 14.5368C7.14488 14.7722 7.0202 15.0865 7.02308 15.4126C7.02598 15.7403 7.1575 16.0538 7.38929 16.2856C7.62109 16.5173 7.93462 16.6487 8.26237 16.6515C8.58848 16.6543 8.9027 16.5295 9.13803 16.3039L16.6541 8.78371C16.9525 8.49544 17.1907 8.15068 17.3545 7.76942C17.5182 7.38815 17.6044 6.97809 17.608 6.56316C17.6117 6.14822 17.5326 5.73672 17.3755 5.35267C17.2183 4.96862 16.9863 4.61971 16.6929 4.32629C16.3995 4.03288 16.0505 3.80084 15.6665 3.64371Z" })
  ] });
});
PaperClipIcon.displayName = "PaperClipIcon";
const PencilIcon = forwardRef((props, ref2) => {
  const defaultFill = `var(${TOKENS.color.foreground.default}, ${ICON_FILL_DEFAULT})`;
  const {
    size: size2,
    title,
    ...rest
  } = props;
  const mappedSizeOrDefault = size2 ? ICON_SIZE_MAPPINGS[size2] : ICON_SIZE_DEFAULT;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { width: mappedSizeOrDefault, height: mappedSizeOrDefault, viewBox: "0 0 24 24", fill: defaultFill, xmlns: "http://www.w3.org/2000/svg", role: "img", "aria-label": "Pencil Icon", ...rest, ref: ref2, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("title", { children: title || "Pencil Icon" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M19.7368 2.27199C19.2896 2.08909 18.8107 1.9966 18.3276 1.99987C17.8445 2.00314 17.3669 2.10211 16.9222 2.29105C16.4788 2.4795 16.0769 2.75374 15.7398 3.09799L15.3986 3.43915L15.3964 3.44139L15.3941 3.44364L13.6537 5.18404L13.6514 5.18638L13.6491 5.18874L3.66231 15.1755C3.66102 15.1768 3.65974 15.178 3.65846 15.1793C3.57371 15.2642 3.51846 15.3674 3.4927 15.4762L2.01959 21.2197C1.96471 21.4337 2.02686 21.6608 2.18306 21.817C2.33925 21.9731 2.5663 22.0353 2.78027 21.9804L8.53444 20.5046C8.64291 20.4768 8.74192 20.4203 8.82111 20.3411L8.8257 20.3365L18.8136 10.3486L20.5586 8.60361L20.902 8.26021C21.2463 7.92309 21.5205 7.52125 21.709 7.07777C21.8979 6.63315 21.9969 6.1555 22.0001 5.6724C22.0034 5.18931 21.9109 4.71036 21.728 4.26322C21.5451 3.81608 21.2754 3.40962 20.9345 3.06731L20.4917 3.50834L20.9327 3.06549C20.5904 2.72459 20.1839 2.4549 19.7368 2.27199ZM8.38291 19.0115L17.4878 9.90667L14.0933 6.51222L4.98516 15.6204L8.38291 19.0115ZM4.43424 16.8366L7.16763 19.5647L3.4928 20.5072L4.43424 16.8366ZM14.9772 5.62833L18.3717 9.02278L19.2328 8.16167L15.8383 4.76722L14.9772 5.62833ZM20.1153 7.27643C20.301 7.07445 20.451 6.84198 20.5585 6.5889C20.6829 6.29626 20.748 5.98189 20.7502 5.66394C20.7523 5.34599 20.6914 5.03076 20.5711 4.73647C20.4508 4.44258 20.2737 4.17539 20.0497 3.95028C19.8246 3.72634 19.5574 3.54916 19.2635 3.42894C18.9692 3.30856 18.654 3.24769 18.3361 3.24984C18.0181 3.25199 17.7037 3.31713 17.4111 3.44148C17.158 3.54903 16.9256 3.69902 16.7236 3.8847L20.1153 7.27643Z" })
  ] });
});
PencilIcon.displayName = "PencilIcon";
const PenIcon = forwardRef((props, ref2) => {
  const defaultFill = `var(${TOKENS.color.foreground.default}, ${ICON_FILL_DEFAULT})`;
  const {
    size: size2,
    title,
    ...rest
  } = props;
  const mappedSizeOrDefault = size2 ? ICON_SIZE_MAPPINGS[size2] : ICON_SIZE_DEFAULT;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { width: mappedSizeOrDefault, height: mappedSizeOrDefault, viewBox: "0 0 24 24", fill: defaultFill, xmlns: "http://www.w3.org/2000/svg", role: "img", "aria-label": "Pen Icon", ...rest, ref: ref2, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("title", { children: title || "Pen Icon" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { className: "st0", d: "M20.97,3.036c-0.001-0.002-0.003-0.004-0.005-0.006c-0.608-0.6-1.412-0.957-2.263-1.005\n	c-0.858-0.047-1.693,0.215-2.337,0.723L8.044,8.607C7.924,8.691,7.838,8.814,7.8,8.956l-0.894,3.323\n	c-0.604,0.008-1.207,0.129-1.765,0.374c-0.579,0.253-1.089,0.618-1.499,1.063c-1.577,1.577-1.623,7.024-1.623,7.641\n	c0,0.082,0.017,0.163,0.048,0.239c0.026,0.063,0.067,0.118,0.112,0.169c0.009,0.01,0.013,0.024,0.023,0.034\n	c0.015,0.015,0.034,0.02,0.05,0.033c0.047,0.039,0.095,0.077,0.152,0.101c0.077,0.032,0.158,0.048,0.24,0.048\n	c0.615,0,6.042-0.046,7.631-1.613c0.459-0.426,0.82-0.934,1.072-1.508c0.246-0.56,0.368-1.155,0.376-1.766l3.32-0.893\n	c0.142-0.038,0.265-0.124,0.349-0.244l5.84-8.295c0.527-0.671,0.791-1.511,0.742-2.362C21.927,4.447,21.57,3.644,20.97,3.036z\n	 M10.203,18.357c-0.184,0.419-0.448,0.789-0.784,1.1c-0.006,0.005-0.012,0.011-0.018,0.017c-0.716,0.717-3.151,1.08-5.195,1.205\n	l3.559-3.559c0.244-0.244,0.244-0.641,0-0.885c-0.244-0.244-0.64-0.244-0.884,0l-3.56,3.56c0.125-2.045,0.492-4.483,1.222-5.214\n	c0.31-0.336,0.679-0.6,1.099-0.783c0.417-0.184,0.861-0.276,1.32-0.276c0.164,0,0.323,0.026,0.483,0.049\n	c0.135,0.023,0.269,0.048,0.4,0.086c0.031,0.009,0.061,0.02,0.091,0.029c0.529,0.172,1.015,0.47,1.421,0.877\n	c0.017,0.018,0.037,0.029,0.054,0.048c0.417,0.4,0.723,0.901,0.901,1.448c0.01,0.033,0.022,0.065,0.031,0.098\n	c0.038,0.13,0.063,0.264,0.086,0.398c0.024,0.159,0.049,0.318,0.049,0.482C10.48,17.494,10.386,17.938,10.203,18.357z M20.231,6.916\n	l-5.729,8.136l-2.942,0.792c-0.025-0.087-0.061-0.17-0.091-0.255c-0.042-0.124-0.067-0.253-0.12-0.375\n	c-0.055-0.125-0.133-0.231-0.197-0.349c-0.044-0.081-0.087-0.163-0.136-0.242c-0.08-0.128-0.162-0.249-0.252-0.366\n	c-0.144-0.189-0.297-0.369-0.468-0.532c-0.168-0.175-0.351-0.332-0.543-0.478c-0.121-0.095-0.248-0.18-0.378-0.262\n	c-0.071-0.044-0.144-0.083-0.217-0.123c-0.124-0.069-0.238-0.152-0.37-0.209c-0.117-0.052-0.243-0.075-0.364-0.116\n	c-0.089-0.031-0.175-0.069-0.266-0.095L8.95,9.5l8.163-5.749c0.431-0.34,0.986-0.51,1.52-0.477c0.546,0.031,1.062,0.259,1.452,0.644\n	c0.385,0.391,0.613,0.906,0.644,1.453C20.758,5.918,20.589,6.458,20.231,6.916z" })
  ] });
});
PenIcon.displayName = "PenIcon";
const PercentIcon = forwardRef((props, ref2) => {
  const defaultFill = `var(${TOKENS.color.foreground.default}, ${ICON_FILL_DEFAULT})`;
  const {
    size: size2,
    title,
    ...rest
  } = props;
  const mappedSizeOrDefault = size2 ? ICON_SIZE_MAPPINGS[size2] : ICON_SIZE_DEFAULT;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { width: mappedSizeOrDefault, height: mappedSizeOrDefault, viewBox: "0 0 24 24", fill: defaultFill, xmlns: "http://www.w3.org/2000/svg", role: "img", "aria-label": "Percent Icon", ...rest, ref: ref2, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("title", { children: title || "Percent Icon" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M20.5669 3.43306C20.811 3.67714 20.811 4.07286 20.5669 4.31694L4.31694 20.5669C4.07286 20.811 3.67714 20.811 3.43306 20.5669C3.18898 20.3229 3.18898 19.9271 3.43306 19.6831L19.6831 3.43306C19.9271 3.18898 20.3229 3.18898 20.5669 3.43306ZM15.4153 15.4153C16.0013 14.8292 16.7962 14.5 17.625 14.5C18.4538 14.5 19.2487 14.8292 19.8347 15.4153C20.4208 16.0013 20.75 16.7962 20.75 17.625C20.75 18.4538 20.4208 19.2487 19.8347 19.8347C19.2487 20.4208 18.4538 20.75 17.625 20.75C16.7962 20.75 16.0013 20.4208 15.4153 19.8347C14.8292 19.2487 14.5 18.4538 14.5 17.625C14.5 16.7962 14.8292 16.0013 15.4153 15.4153ZM17.625 15.75C17.1277 15.75 16.6508 15.9475 16.2992 16.2992C15.9475 16.6508 15.75 17.1277 15.75 17.625C15.75 18.1223 15.9475 18.5992 16.2992 18.9508C16.6508 19.3025 17.1277 19.5 17.625 19.5C18.1223 19.5 18.5992 19.3025 18.9508 18.9508C19.3025 18.5992 19.5 18.1223 19.5 17.625C19.5 17.1277 19.3025 16.6508 18.9508 16.2992C18.5992 15.9475 18.1223 15.75 17.625 15.75ZM6.375 3.25C5.5462 3.25 4.75134 3.57924 4.16529 4.16529C3.57924 4.75134 3.25 5.5462 3.25 6.375C3.25 7.2038 3.57924 7.99866 4.16529 8.58471C4.75134 9.17076 5.5462 9.5 6.375 9.5C7.2038 9.5 7.99866 9.17076 8.58471 8.58471C9.17076 7.99866 9.5 7.2038 9.5 6.375C9.5 5.5462 9.17076 4.75134 8.58471 4.16529C7.99866 3.57924 7.2038 3.25 6.375 3.25ZM5.04917 5.04917C5.40081 4.69754 5.87772 4.5 6.375 4.5C6.87228 4.5 7.34919 4.69754 7.70082 5.04917C8.05246 5.40081 8.25 5.87772 8.25 6.375C8.25 6.87228 8.05246 7.34919 7.70082 7.70082C7.34919 8.05246 6.87228 8.25 6.375 8.25C5.87772 8.25 5.40081 8.05246 5.04917 7.70082C4.69754 7.34919 4.5 6.87228 4.5 6.375C4.5 5.87772 4.69754 5.40081 5.04917 5.04917Z" })
  ] });
});
PercentIcon.displayName = "PercentIcon";
const PhoneIcon = forwardRef((props, ref2) => {
  const defaultFill = `var(${TOKENS.color.foreground.default}, ${ICON_FILL_DEFAULT})`;
  const {
    size: size2,
    title,
    ...rest
  } = props;
  const mappedSizeOrDefault = size2 ? ICON_SIZE_MAPPINGS[size2] : ICON_SIZE_DEFAULT;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { version: "1.1", width: mappedSizeOrDefault, height: mappedSizeOrDefault, viewBox: "0 0 24 24", xmlSpace: "preserve", fill: defaultFill, ref: ref2, ...rest, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("title", { children: title || "Phone Icon" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M18.5 23.5c-.8 0-1.5-.2-2.2-.7-6-4-11.2-9.1-15.2-15.2-1-1.6-.8-3.7.5-5L3 1.3C4.1.2 5.9.2 7 1.3l2.5 2.5c1.1 1.1 1.1 2.9 0 4l-.6.5c2.1 2.5 4.3 4.7 6.8 6.8l.5-.5c1-1 2.9-1 4 0l2.5 2.5c.5.5.8 1.2.8 2s-.3 1.5-.8 2l-1.3 1.3c-.8.7-1.9 1.1-2.9 1.1zM5 1.5c-.5 0-.9.2-1.3.5L2.4 3.4c-1 1-1.2 2.6-.4 3.7C5.9 13 11 18 16.9 22c1.2.8 2.7.6 3.7-.4l1.3-1.3c.3-.3.5-.8.5-1.3s-.2-.9-.5-1.3l-2.5-2.5c-.7-.7-1.9-.7-2.6 0l-.8.8c-.2.2-.5.2-.7 0-2.8-2.3-5.3-4.8-7.6-7.6 0-.1 0-.4.2-.5l.8-.9c.7-.7.7-1.9 0-2.6L6.3 2c-.4-.3-.8-.5-1.3-.5z", className: "st0" })
  ] });
});
PhoneIcon.displayName = "PhoneIcon";
const PieChartIcon = forwardRef((props, ref2) => {
  const defaultFill = `var(${TOKENS.color.foreground.default}, ${ICON_FILL_DEFAULT})`;
  const {
    size: size2,
    title,
    ...rest
  } = props;
  const mappedSizeOrDefault = size2 ? ICON_SIZE_MAPPINGS[size2] : ICON_SIZE_DEFAULT;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { width: mappedSizeOrDefault, height: mappedSizeOrDefault, viewBox: "0 0 24 24", fill: defaultFill, xmlns: "http://www.w3.org/2000/svg", role: "img", "aria-label": "pie chart Icon", ...rest, ref: ref2, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("title", { children: title || "pie chart Icon" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M18.9952 5.00476C17.4715 3.48102 15.4049 2.625 13.25 2.625V3.25H12.625V10.75C12.625 11.0952 12.9048 11.375 13.25 11.375H20.75C20.9158 11.375 21.0747 11.3092 21.1919 11.1919C21.3092 11.0747 21.375 10.9158 21.375 10.75C21.375 8.59512 20.519 6.52849 18.9952 5.00476ZM13.875 10.125V3.90345C15.4692 4.04892 16.9702 4.74748 18.1114 5.88864C19.2525 7.0298 19.9511 8.53084 20.0966 10.125H13.875ZM10.75 5.125C9.14303 5.125 7.57214 5.60152 6.236 6.49431C4.89985 7.3871 3.85844 8.65605 3.24348 10.1407C2.62852 11.6253 2.46762 13.259 2.78112 14.8351C3.09463 16.4112 3.86846 17.8589 5.00476 18.9952C6.14106 20.1315 7.5888 20.9054 9.1649 21.2189C10.741 21.5324 12.3747 21.3715 13.8593 20.7565C15.344 20.1416 16.6129 19.1002 17.5057 17.764C18.3985 16.4279 18.875 14.857 18.875 13.25C18.875 12.9048 18.5952 12.625 18.25 12.625H11.375V5.75C11.375 5.58424 11.3092 5.42527 11.1919 5.30806C11.0747 5.19085 10.9158 5.125 10.75 5.125ZM6.93046 7.53365C7.88705 6.89447 8.98584 6.50745 10.125 6.40346V13.25C10.125 13.5952 10.4048 13.875 10.75 13.875H17.5965C17.4926 15.0142 17.1055 16.113 16.4664 17.0695C15.7109 18.2001 14.6372 19.0813 13.381 19.6017C12.1247 20.122 10.7424 20.2582 9.40876 19.9929C8.07514 19.7276 6.85013 19.0728 5.88864 18.1114C4.92716 17.1499 4.27238 15.9249 4.0071 14.5912C3.74183 13.2576 3.87798 11.8753 4.39833 10.6191C4.91868 9.36281 5.79987 8.28908 6.93046 7.53365Z" })
  ] });
});
PieChartIcon.displayName = "PieChartIcon";
const PlusCircleIcon = forwardRef((props, ref2) => {
  const defaultFill = `var(${TOKENS.color.foreground.default}, ${ICON_FILL_DEFAULT})`;
  const {
    size: size2,
    title,
    ...rest
  } = props;
  const mappedSizeOrDefault = size2 ? ICON_SIZE_MAPPINGS[size2] : ICON_SIZE_DEFAULT;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { width: mappedSizeOrDefault, height: mappedSizeOrDefault, viewBox: "0 0 24 24", fill: defaultFill, xmlns: "http://www.w3.org/2000/svg", role: "img", "aria-label": "plus circle Icon", ...rest, ref: ref2, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("title", { children: title || "plus circle Icon" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 2C9.34784 2 6.8043 3.05357 4.92893 4.92893C3.05357 6.8043 2 9.34784 2 12C2 14.6522 3.05357 17.1957 4.92893 19.0711C6.8043 20.9464 9.34784 22 12 22C14.6522 22 17.1957 20.9464 19.0711 19.0711C20.9464 17.1957 22 14.6522 22 12C22 9.34784 20.9464 6.8043 19.0711 4.92893C17.1957 3.05357 14.6522 2 12 2ZM5.81282 5.81282C7.45376 4.17187 9.67936 3.25 12 3.25C14.3206 3.25 16.5462 4.17187 18.1872 5.81282C19.8281 7.45376 20.75 9.67936 20.75 12C20.75 14.3206 19.8281 16.5462 18.1872 18.1872C16.5462 19.8281 14.3206 20.75 12 20.75C9.67936 20.75 7.45376 19.8281 5.81282 18.1872C4.17187 16.5462 3.25 14.3206 3.25 12C3.25 9.67936 4.17187 7.45376 5.81282 5.81282ZM12 7.625C12.3452 7.625 12.625 7.90482 12.625 8.25V11.375H15.75C16.0952 11.375 16.375 11.6548 16.375 12C16.375 12.3452 16.0952 12.625 15.75 12.625H12.625V15.75C12.625 16.0952 12.3452 16.375 12 16.375C11.6548 16.375 11.375 16.0952 11.375 15.75V12.625H8.25C7.90482 12.625 7.625 12.3452 7.625 12C7.625 11.6548 7.90482 11.375 8.25 11.375H11.375V8.25C11.375 7.90482 11.6548 7.625 12 7.625Z" })
  ] });
});
PlusCircleIcon.displayName = "PlusCircleIcon";
const PlusIcon = forwardRef((props, ref2) => {
  const {
    size: size2
  } = props;
  const mappedSizeOrDefault = size2 ? ICON_SIZE_MAPPINGS[size2] : ICON_SIZE_DEFAULT;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { width: mappedSizeOrDefault, height: mappedSizeOrDefault, viewBox: "0 0 24 24", fill: ICON_FILL_DEFAULT, xmlns: "http://www.w3.org/2000/svg", role: "img", "aria-label": "plus Icon", ...props, ref: ref2, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("title", { children: "plus Icon" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13.2195 3.21951C13.2195 2.54599 12.6735 2 12 2C11.3265 2 10.7805 2.54599 10.7805 3.21951V10.7805H3.21951C2.54599 10.7805 2 11.3265 2 12C2 12.6735 2.54599 13.2195 3.21951 13.2195H10.7805V20.7805C10.7805 21.454 11.3265 22 12 22C12.6735 22 13.2195 21.454 13.2195 20.7805V13.2195H20.7805C21.454 13.2195 22 12.6735 22 12C22 11.3265 21.454 10.7805 20.7805 10.7805H13.2195V3.21951Z" })
  ] });
});
PlusIcon.displayName = "PlusIcon";
const PottedPlantIcon = forwardRef((props, ref2) => {
  const defaultFill = `var(${TOKENS.color.foreground.default}, ${ICON_FILL_DEFAULT})`;
  const {
    size: size2,
    title,
    ...rest
  } = props;
  const mappedSizeOrDefault = size2 ? ICON_SIZE_MAPPINGS[size2] : ICON_SIZE_DEFAULT;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { width: mappedSizeOrDefault, height: mappedSizeOrDefault, viewBox: "0 0 40 40", fill: defaultFill, xmlns: "http://www.w3.org/2000/svg", role: "img", "aria-label": "Potted Plant Icon", ...rest, ref: ref2, version: "1.1", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("title", { children: title || "Potted Plant Icon" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M34.998,8.679c-0.708-0.104-6.981-0.961-9.253,0.839c-0.641,0.454-1.172,1.023-1.581,1.691\n	c-0.408,0.667-0.673,1.4-0.786,2.178c-0.111,0.777-0.065,1.554,0.138,2.309c0.095,0.357,0.229,0.697,0.387,1.024\n	c-1.108,1.021-1.969,2.157-2.762,3.69c-0.074,0.143-0.146,0.286-0.214,0.43c-0.674-2.403-1.877-4.565-3.585-6.516\n	c0.626-1.025,0.991-2.194,1.037-3.417c0.068-1.79-0.538-3.524-1.76-4.942C14.013,3.385,6.024,3.534,5.123,3.56\n	C4.591,3.576,4.164,4.005,4.152,4.537c-0.021,0.895-0.125,8.819,2.479,11.422c0.018,0.018,0.037,0.035,0.056,0.052\n	c1.291,1.108,2.918,1.709,4.612,1.709c0.09,0,0.181-0.001,0.271-0.005c1.68-0.064,3.261-0.721,4.497-1.848\n	c2.182,2.584,3.322,5.567,3.501,9.077h-4.911c-0.287,0-0.56,0.123-0.75,0.338c-0.19,0.215-0.278,0.502-0.243,0.786l1.188,9.505\n	c0.062,0.5,0.488,0.876,0.992,0.876h9.504c0.504,0,0.93-0.376,0.992-0.876l1.188-9.505c0.036-0.284-0.053-0.57-0.242-0.786\n	c-0.19-0.215-0.463-0.338-0.75-0.338h-4.812c0.204-1.259,0.598-2.471,1.19-3.615c0.641-1.238,1.325-2.17,2.182-2.996\n	c0.369,0.356,0.766,0.679,1.22,0.927c0.688,0.375,1.434,0.603,2.214,0.677c0.182,0.017,0.363,0.025,0.543,0.025\n	c0.596,0,1.185-0.092,1.757-0.276c0.737-0.237,1.41-0.614,1.998-1.121c2.321-1.851,2.955-8.098,3.02-8.806\n	C35.898,9.23,35.525,8.756,34.998,8.679z M24.466,34.45h-7.739l-0.938-7.505h9.615L24.466,34.45z M11.493,15.717\n	c-1.275,0.06-2.503-0.376-3.474-1.197c-1.34-1.39-1.837-5.876-1.873-8.971c3.141,0.016,7.701,0.484,9.01,1.777\n	c0.838,0.975,1.272,2.22,1.223,3.504c-0.026,0.702-0.208,1.375-0.504,1.995c-1.228-1.137-2.637-2.202-4.269-3.181\n	c-0.474-0.285-1.088-0.131-1.372,0.343c-0.284,0.474-0.131,1.088,0.343,1.372c1.584,0.951,2.947,1.965,4.103,3.052\n	C13.799,15.2,12.684,15.672,11.493,15.717z M31.576,17.007c-0.014,0.011-0.026,0.021-0.04,0.033\n	c-0.387,0.336-0.829,0.586-1.316,0.742c-0.487,0.157-0.994,0.212-1.5,0.164c-0.509-0.048-0.995-0.197-1.444-0.441\n	c-0.448-0.244-0.836-0.572-1.153-0.975c-0.315-0.401-0.543-0.855-0.675-1.351c-0.132-0.493-0.162-1-0.09-1.505\n	c0.074-0.507,0.247-0.985,0.514-1.421c0.266-0.436,0.613-0.807,1.072-1.134c0.689-0.544,2.287-0.731,3.973-0.731\n	c0.967,0,1.962,0.061,2.832,0.152C33.416,13.01,32.624,16.188,31.576,17.007z" })
  ] });
});
PottedPlantIcon.displayName = "PottedPlantIcon";
const QuestionMarkCircleIcon = forwardRef((props, ref2) => {
  const defaultFill = `var(${TOKENS.color.foreground.default}, ${ICON_FILL_DEFAULT})`;
  const {
    size: size2,
    title,
    ...rest
  } = props;
  const mappedSizeOrDefault = size2 ? ICON_SIZE_MAPPINGS[size2] : ICON_SIZE_DEFAULT;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { width: mappedSizeOrDefault, height: mappedSizeOrDefault, viewBox: "0 0 24 24", fill: defaultFill, xmlns: "http://www.w3.org/2000/svg", role: "img", "aria-label": "question mark circle Icon", ...rest, ref: ref2, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("title", { children: title || "question mark circle Icon" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M12 2C17.5228 2 22 6.47716 22 12C22 17.5228 17.5228 22 12 22C6.47716 22 2 17.5228 2 12C2 6.47716 6.47716 2 12 2ZM12 3.25C7.16751 3.25 3.25 7.16751 3.25 12C3.25 16.8325 7.16751 20.75 12 20.75C16.8325 20.75 20.75 16.8325 20.75 12C20.75 7.16751 16.8325 3.25 12 3.25ZM12 15.75C12.5178 15.75 12.9375 16.1697 12.9375 16.6875C12.9375 17.1683 12.5756 17.5645 12.1093 17.6187L12 17.625C11.4822 17.625 11.0625 17.2053 11.0625 16.6875C11.0625 16.2067 11.4244 15.8105 11.8907 15.7563L12 15.75ZM12.0013 6.37551L12.2155 6.38295C12.7871 6.42246 13.3368 6.61833 13.8045 6.94914C14.2722 7.27997 14.64 7.733 14.8676 8.25861C15.0953 8.78432 15.1741 9.36252 15.0953 9.93001C15.0166 10.4975 14.7834 11.0324 14.4212 11.4762C14.0591 11.9201 13.5818 12.2558 13.0418 12.4467C12.9197 12.4899 12.8142 12.5697 12.7396 12.6752C12.6836 12.7545 12.6471 12.8453 12.6324 12.9404L12.625 13.0367V13.875C12.625 14.2202 12.3452 14.5 12 14.5C11.6862 14.5 11.4264 14.2687 11.3818 13.9674L11.375 13.875V13.0371C11.3748 12.6492 11.4949 12.2708 11.7188 11.9538C11.9107 11.6824 12.1707 11.4676 12.4714 11.3303L12.625 11.2682C12.9491 11.1537 13.2355 10.9522 13.4528 10.6859C13.67 10.4197 13.8099 10.0987 13.8572 9.75818C13.9044 9.4177 13.8572 9.07082 13.7205 8.75534C13.584 8.43998 13.3633 8.16817 13.0827 7.96968C12.8021 7.7712 12.4723 7.65369 12.1293 7.62998C11.7864 7.60627 11.4436 7.67728 11.1383 7.83525C10.833 7.99322 10.577 8.23205 10.3983 8.5257C10.2494 8.77038 10.1589 9.04526 10.1329 9.32901L10.125 9.50016C10.1249 9.84534 9.84505 10.1251 9.49988 10.125C9.1547 10.125 8.87493 9.84509 8.875 9.49991C8.87511 8.92702 9.0327 8.36519 9.33054 7.87582C9.6284 7.38642 10.055 6.98834 10.5638 6.72508C11.009 6.49471 11.5022 6.37529 12.0013 6.37551Z" })
  ] });
});
QuestionMarkCircleIcon.displayName = "QuestionMarkCircleIcon";
const QuestionMarkIcon = forwardRef((props, ref2) => {
  const defaultFill = `var(${TOKENS.color.foreground.default}, ${ICON_FILL_DEFAULT})`;
  const {
    size: size2,
    title,
    ...rest
  } = props;
  const mappedSizeOrDefault = size2 ? ICON_SIZE_MAPPINGS[size2] : ICON_SIZE_DEFAULT;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { width: mappedSizeOrDefault, height: mappedSizeOrDefault, viewBox: "0 0 24 24", fill: defaultFill, xmlns: "http://www.w3.org/2000/svg", role: "img", "aria-label": "question mark Icon", ...rest, ref: ref2, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("title", { children: title || "question mark Icon" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M12 2C17.5228 2 22 6.47716 22 12C22 17.5228 17.5228 22 12 22C6.47716 22 2 17.5228 2 12C2 6.47716 6.47716 2 12 2ZM12 3.25C7.16751 3.25 3.25 7.16751 3.25 12C3.25 16.8325 7.16751 20.75 12 20.75C16.8325 20.75 20.75 16.8325 20.75 12C20.75 7.16751 16.8325 3.25 12 3.25ZM12 15.75C12.5178 15.75 12.9375 16.1697 12.9375 16.6875C12.9375 17.1683 12.5756 17.5645 12.1093 17.6187L12 17.625C11.4822 17.625 11.0625 17.2053 11.0625 16.6875C11.0625 16.2067 11.4244 15.8105 11.8907 15.7563L12 15.75ZM12.0013 6.37551L12.2155 6.38295C12.7871 6.42246 13.3368 6.61833 13.8045 6.94914C14.2722 7.27997 14.64 7.733 14.8676 8.25861C15.0953 8.78432 15.1741 9.36252 15.0953 9.93001C15.0166 10.4975 14.7834 11.0324 14.4212 11.4762C14.0591 11.9201 13.5818 12.2558 13.0418 12.4467C12.9197 12.4899 12.8142 12.5697 12.7396 12.6752C12.6836 12.7545 12.6471 12.8453 12.6324 12.9404L12.625 13.0367V13.875C12.625 14.2202 12.3452 14.5 12 14.5C11.6862 14.5 11.4264 14.2687 11.3818 13.9674L11.375 13.875V13.0371C11.3748 12.6492 11.4949 12.2708 11.7188 11.9538C11.9107 11.6824 12.1707 11.4676 12.4714 11.3303L12.625 11.2682C12.9491 11.1537 13.2355 10.9522 13.4528 10.6859C13.67 10.4197 13.8099 10.0987 13.8572 9.75818C13.9044 9.4177 13.8572 9.07082 13.7205 8.75534C13.584 8.43998 13.3633 8.16817 13.0827 7.96968C12.8021 7.7712 12.4723 7.65369 12.1293 7.62998C11.7864 7.60627 11.4436 7.67728 11.1383 7.83525C10.833 7.99322 10.577 8.23205 10.3983 8.5257C10.2494 8.77038 10.1589 9.04526 10.1329 9.32901L10.125 9.50016C10.1249 9.84534 9.84505 10.1251 9.49988 10.125C9.1547 10.125 8.87493 9.84509 8.875 9.49991C8.87511 8.92702 9.0327 8.36519 9.33054 7.87582C9.6284 7.38642 10.055 6.98834 10.5638 6.72508C11.009 6.49471 11.5022 6.37529 12.0013 6.37551Z" })
  ] });
});
QuestionMarkIcon.displayName = "QuestionMarkIcon";
const RetryIcon = forwardRef((props, ref2) => {
  const defaultFill = `var(${TOKENS.color.foreground.default}, ${ICON_FILL_DEFAULT})`;
  const {
    size: size2,
    title,
    ...rest
  } = props;
  const mappedSizeOrDefault = size2 ? ICON_SIZE_MAPPINGS[size2] : ICON_SIZE_DEFAULT;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { width: mappedSizeOrDefault, height: mappedSizeOrDefault, viewBox: "0 0 24 24", fill: defaultFill, xmlns: "http://www.w3.org/2000/svg", role: "img", "aria-label": "Retry Icon", ...rest, ref: ref2, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("title", { children: title || "Retry Icon" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M17.9947 4.85261C16.2243 3.71089 14.1014 3.2461 12.0158 3.54359C9.93028 3.84107 8.02203 4.88086 6.6414 6.47205C5.26078 8.06324 4.50045 10.099 4.5 12.2057V12.2058V12.5719L3.06694 11.1389C2.82286 10.8948 2.42714 10.8948 2.18306 11.1389C1.93898 11.383 1.93898 11.7787 2.18306 12.0228L4.65099 14.4907C4.76561 14.624 4.93545 14.7083 5.125 14.7083C5.31455 14.7083 5.48439 14.624 5.59901 14.4907L8.06694 12.0228C8.31102 11.7787 8.31102 11.383 8.06694 11.1389C7.82286 10.8948 7.42714 10.8948 7.18306 11.1389L5.75 12.5719V12.206V12.2058C5.75042 10.4001 6.40215 8.65514 7.58555 7.29125C8.76898 5.92733 10.4047 5.03606 12.1923 4.78106C13.98 4.52607 15.7997 4.92447 17.3173 5.90312C18.8348 6.88176 19.9485 8.37498 20.4537 10.1086C20.959 11.8423 20.8219 13.7 20.0677 15.3407C19.3135 16.9814 17.9928 18.295 16.348 19.0404C14.7033 19.7857 12.8448 19.9128 11.1139 19.3982C9.38305 18.8836 7.89586 17.7619 6.9254 16.2391C6.7399 15.948 6.35354 15.8624 6.06245 16.0479C5.77135 16.2334 5.68576 16.6198 5.87126 16.9109C7.00342 18.6875 8.73843 19.996 10.7577 20.5964C12.7771 21.1967 14.9451 21.0485 16.864 20.1789C18.7828 19.3094 20.3236 17.7769 21.2035 15.8628C22.0833 13.9487 22.2432 11.7814 21.6538 9.75888C21.0644 7.73636 19.7651 5.99433 17.9947 4.85261Z" })
  ] });
});
RetryIcon.displayName = "RetryIcon";
const SavingsBankIcon = forwardRef((props, ref2) => {
  const defaultFill = `var(${TOKENS.color.foreground.default}, ${ICON_FILL_DEFAULT})`;
  const {
    size: size2,
    title,
    ...rest
  } = props;
  const mappedSizeOrDefault = size2 ? ICON_SIZE_MAPPINGS[size2] : ICON_SIZE_DEFAULT;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { width: mappedSizeOrDefault, height: mappedSizeOrDefault, viewBox: "0 0 24 24", fill: defaultFill, xmlns: "http://www.w3.org/2000/svg", role: "img", "aria-label": "Savings Bank Icon", ...rest, ref: ref2, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("title", { children: title || "Savings Bank Icon" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2 21.7739C2 21.4287 2.27982 21.1489 2.625 21.1489H21.242C21.5872 21.1489 21.867 21.4287 21.867 21.7739C21.867 22.1191 21.5872 22.3989 21.242 22.3989H2.625C2.27982 22.3989 2 22.1191 2 21.7739Z" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2 19.2207C2 18.8755 2.27982 18.5957 2.625 18.5957H21.242C21.5872 18.5957 21.867 18.8755 21.867 19.2207C21.867 19.5659 21.5872 19.8457 21.242 19.8457H2.625C2.27982 19.8457 2 19.5659 2 19.2207Z" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3.95508 9.65967C4.30026 9.65967 4.58008 9.93949 4.58008 10.2847V16.6676C4.58008 17.0128 4.30026 17.2926 3.95508 17.2926C3.6099 17.2926 3.33008 17.0128 3.33008 16.6676V10.2847C3.33008 9.93949 3.6099 9.65967 3.95508 9.65967Z" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.61426 9.65967C6.95944 9.65967 7.23926 9.93949 7.23926 10.2847V16.6676C7.23926 17.0128 6.95944 17.2926 6.61426 17.2926C6.26908 17.2926 5.98926 17.0128 5.98926 16.6676V10.2847C5.98926 9.93949 6.26908 9.65967 6.61426 9.65967Z" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.604 9.65967C10.9492 9.65967 11.229 9.93949 11.229 10.2847V16.6676C11.229 17.0128 10.9492 17.2926 10.604 17.2926C10.2588 17.2926 9.979 17.0128 9.979 16.6676V10.2847C9.979 9.93949 10.2588 9.65967 10.604 9.65967Z" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13.2632 9.65967C13.6084 9.65967 13.8882 9.93949 13.8882 10.2847V16.6676C13.8882 17.0128 13.6084 17.2926 13.2632 17.2926C12.918 17.2926 12.6382 17.0128 12.6382 16.6676V10.2847C12.6382 9.93949 12.918 9.65967 13.2632 9.65967Z" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M17.2529 9.65967C17.5981 9.65967 17.8779 9.93949 17.8779 10.2847V16.6676C17.8779 17.0128 17.5981 17.2926 17.2529 17.2926C16.9078 17.2926 16.6279 17.0128 16.6279 16.6676V10.2847C16.6279 9.93949 16.9078 9.65967 17.2529 9.65967Z" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M19.9121 9.65967C20.2573 9.65967 20.5371 9.93949 20.5371 10.2847V16.6676C20.5371 17.0128 20.2573 17.2926 19.9121 17.2926C19.5669 17.2926 19.2871 17.0128 19.2871 16.6676V10.2847C19.2871 9.93949 19.5669 9.65967 19.9121 9.65967Z" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.3243 3.35958C12.0875 3.21347 11.7796 3.21347 11.5428 3.35958C11.5367 3.36331 11.5306 3.36693 11.5245 3.37045L4.9804 7.1065H18.8867L12.3426 3.37045C12.3365 3.36693 12.3304 3.36331 12.3243 3.35958ZM12.9708 2.28968C12.3364 1.90344 11.5307 1.90344 10.8963 2.28969L2.31518 7.18872C2.06903 7.32925 1.94827 7.61783 2.02096 7.89179C2.09366 8.16575 2.34162 8.3565 2.62506 8.3565H21.242C21.5255 8.3565 21.7734 8.16575 21.8461 7.89179C21.9188 7.61783 21.7981 7.32925 21.5519 7.18872L12.9708 2.28968Z" })
  ] });
});
SavingsBankIcon.displayName = "SavingsBankIcon";
const SearchIcon = forwardRef((props, ref2) => {
  const defaultFill = `var(${TOKENS.color.foreground.default}, ${ICON_FILL_DEFAULT})`;
  const {
    size: size2,
    title,
    ...rest
  } = props;
  const mappedSizeOrDefault = size2 ? ICON_SIZE_MAPPINGS[size2] : ICON_SIZE_DEFAULT;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { width: mappedSizeOrDefault, height: mappedSizeOrDefault, viewBox: "0 0 24 24", fill: defaultFill, xmlns: "http://www.w3.org/2000/svg", role: "img", "aria-label": "Search Icon", ...rest, ref: ref2, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("title", { children: title || "Search Icon" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.97904 2.65075C4.98301 3.49904 3.40572 5.1055 2.59415 7.11674C1.78258 9.12798 1.80321 11.3792 2.6515 13.3753C3.49979 15.3713 5.10626 16.9486 7.11749 17.7602C9.12873 18.5717 11.38 18.5511 13.376 17.7028C14.155 17.3717 14.8702 16.9252 15.5011 16.3842L20.933 21.8169C21.1771 22.061 21.5728 22.061 21.8169 21.817C22.061 21.5729 22.061 21.1772 21.817 20.9331L16.3849 15.5003C16.9583 14.8318 17.4251 14.0689 17.7609 13.2368C18.5725 11.2256 18.5519 8.97432 17.7036 6.97829C16.8553 4.98226 15.2488 3.40497 13.2376 2.5934C11.2263 1.78183 8.97507 1.80245 6.97904 2.65075ZM15.0962 15.055C15.739 14.4069 16.2535 13.632 16.6017 12.7691C17.2892 11.0653 17.2718 9.15813 16.5531 7.46721C15.8345 5.77629 14.4736 4.4401 12.7698 3.75258C11.066 3.06506 9.15888 3.08254 7.46796 3.80116C5.77704 4.51979 4.44085 5.88069 3.75333 7.58449C3.06582 9.2883 3.08329 11.1954 3.80192 12.8864C4.52054 14.5773 5.88144 15.9135 7.58525 16.601C9.28905 17.2885 11.1962 17.271 12.8871 16.5524C13.7038 16.2053 14.4378 15.7084 15.0558 15.0954C15.0622 15.0884 15.0688 15.0815 15.0756 15.0747C15.0823 15.0679 15.0892 15.0614 15.0962 15.055Z" })
  ] });
});
SearchIcon.displayName = "SearchIcon";
const SendIcon = forwardRef((props, ref2) => {
  const defaultFill = `var(${TOKENS.color.foreground.default}, ${ICON_FILL_DEFAULT})`;
  const {
    size: size2,
    title,
    ...rest
  } = props;
  const mappedSizeOrDefault = size2 ? ICON_SIZE_MAPPINGS[size2] : ICON_SIZE_DEFAULT;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { width: mappedSizeOrDefault, height: mappedSizeOrDefault, viewBox: "0 0 24 24", fill: defaultFill, xmlns: "http://www.w3.org/2000/svg", role: "img", "aria-label": "Send Icon", ...rest, ref: ref2, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("title", { children: title || "Send Icon" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M19.3375 3.34019C19.3242 3.34743 19.3111 3.35509 19.2982 3.36314L19.298 3.36331L3.89546 12.9916C3.75522 13.0793 3.64733 13.2102 3.58808 13.3646C3.52883 13.519 3.52145 13.6885 3.56704 13.8475C3.61264 14.0065 3.70874 14.1463 3.84082 14.2458C3.97291 14.3453 4.13379 14.3992 4.29918 14.3992H9.16556L9.16666 14.3992L10.939 14.3992L19.3375 3.34019ZM20.4587 3.93057L12.0324 15.0262L16.0915 20.4448L16.0917 20.445C16.1804 20.5631 16.3014 20.6528 16.4402 20.7033C16.579 20.7538 16.7296 20.7628 16.8734 20.7293C17.0173 20.6958 17.1484 20.6211 17.2506 20.5145C17.3527 20.4079 17.4217 20.2739 17.4491 20.1288L17.4491 20.1285L20.4491 4.15133L20.4493 4.15005C20.4631 4.07735 20.4662 4.00342 20.4587 3.93057ZM4.29915 15.6492H8.54166V19.3333V19.3333C8.54165 19.6991 8.64139 20.0579 8.83016 20.3712C9.01893 20.6845 9.28959 20.9404 9.61297 21.1113C9.93636 21.2822 10.3002 21.3616 10.6654 21.3411C11.0306 21.3205 11.3832 21.2008 11.6853 20.9948L11.6855 20.9947L13.8411 19.5255L15.0914 21.1947L15.0918 21.1952C15.3261 21.5073 15.6461 21.7445 16.0128 21.8779C16.3795 22.0113 16.777 22.0352 17.1571 21.9467C17.5371 21.8582 17.8832 21.661 18.1531 21.3793C18.4231 21.0975 18.6053 20.7433 18.6775 20.3599L18.6776 20.3595L21.6774 4.38328L21.6774 4.38309C21.7503 3.99891 21.7096 3.6018 21.5603 3.24038C21.411 2.8789 21.1595 2.56881 20.8367 2.34809C20.5138 2.12736 20.1336 2.00559 19.7425 1.99767C19.3515 1.98976 18.9667 2.09605 18.6351 2.30353L3.23287 11.9317C2.86249 12.1632 2.57753 12.509 2.42105 12.9168C2.26456 13.3246 2.24506 13.7723 2.36549 14.1921C2.48592 14.612 2.73974 14.9813 3.08859 15.2441C3.43743 15.507 3.86236 15.6492 4.29915 15.6492ZM9.79166 19.3333V15.6492H10.9371L13.0898 18.5248L10.9813 19.9619L10.9812 19.962C10.8668 20.04 10.7334 20.0853 10.5952 20.0931C10.4571 20.1008 10.3194 20.0708 10.197 20.0061C10.0747 19.9414 9.97225 19.8446 9.90082 19.7261C9.8294 19.6075 9.79166 19.4718 9.79166 19.3334V19.3333Z" })
  ] });
});
SendIcon.displayName = "SendIcon";
const SettingsSlidersIcon = forwardRef((props, ref2) => {
  const defaultFill = `var(${TOKENS.color.foreground.default}, ${ICON_FILL_DEFAULT})`;
  const {
    size: size2,
    title,
    ...rest
  } = props;
  const mappedSizeOrDefault = size2 ? ICON_SIZE_MAPPINGS[size2] : ICON_SIZE_DEFAULT;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { width: mappedSizeOrDefault, height: mappedSizeOrDefault, viewBox: "0 0 24 24", fill: defaultFill, xmlns: "http://www.w3.org/2000/svg", role: "img", "aria-label": "Settings Sliders Icon", ...rest, ref: ref2, version: "1.1", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("title", { children: title || "Settings Sliders Icon" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M19.628,2.574H4.372c-0.992,0-1.799,0.807-1.799,1.798v15.256c0,0.991,0.807,1.798,1.799,1.798h15.256\n		c0.992,0,1.799-0.807,1.799-1.798V4.372C21.427,3.38,20.62,2.574,19.628,2.574z M20.177,19.628c0,0.302-0.246,0.548-0.549,0.548\n		H4.372c-0.303,0-0.549-0.246-0.549-0.548V4.372c0-0.302,0.246-0.548,0.549-0.548h15.256c0.303,0,0.549,0.246,0.549,0.548V19.628z" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M17.281,14.309h-4.165c-0.109-0.397-0.31-0.769-0.604-1.062c-0.451-0.45-1.051-0.698-1.688-0.698\n		c-1.097,0.001-2.013,0.75-2.29,1.761H6.719c-0.345,0-0.625,0.28-0.625,0.625s0.28,0.625,0.625,0.625h1.816\n		c0.108,0.397,0.307,0.764,0.606,1.062c0.45,0.45,1.049,0.697,1.684,0.697c0.001,0,0.002,0,0.003,0c1.098,0,2.015-0.749,2.291-1.76\n		h4.163c0.345,0,0.625-0.28,0.625-0.625S17.626,14.309,17.281,14.309z M10.826,16.069C10.826,16.069,10.826,16.069,10.826,16.069\n		c-0.304,0-0.588-0.118-0.802-0.332c-0.215-0.214-0.333-0.499-0.333-0.803c0-0.626,0.51-1.135,1.135-1.136\n		c0.303,0,0.588,0.118,0.803,0.333c0.212,0.211,0.333,0.504,0.333,0.803C11.962,15.56,11.453,16.069,10.826,16.069z" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M15.521,6.681L15.521,6.681c-0.638,0-1.236,0.248-1.687,0.698c-0.298,0.298-0.498,0.665-0.605,1.062h-6.51\n		c-0.345,0-0.625,0.28-0.625,0.625s0.28,0.625,0.625,0.625h6.51c0.107,0.396,0.307,0.763,0.605,1.061\n		c0.45,0.451,1.049,0.699,1.687,0.699c1.314,0,2.386-1.07,2.387-2.385v0C17.906,7.751,16.836,6.681,15.521,6.681z M15.52,10.202\n		c-0.303,0-0.588-0.118-0.802-0.333c-0.215-0.215-0.332-0.5-0.332-0.803c0-0.303,0.118-0.588,0.332-0.803\n		c0.215-0.214,0.499-0.332,0.802-0.332c0.001,0,0.001,0,0.001,0c0.626,0,1.136,0.509,1.136,1.135\n		C16.655,9.692,16.146,10.202,15.52,10.202z" })
  ] });
});
SettingsSlidersIcon.displayName = "SettingsSlidersIcon";
const ShareIcon = forwardRef((props, ref2) => {
  const defaultFill = `var(${TOKENS.color.foreground.default}, ${ICON_FILL_DEFAULT})`;
  const {
    size: size2,
    title,
    ...rest
  } = props;
  const mappedSizeOrDefault = size2 ? ICON_SIZE_MAPPINGS[size2] : ICON_SIZE_DEFAULT;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { width: mappedSizeOrDefault, height: mappedSizeOrDefault, viewBox: "0 0 24 24", fill: defaultFill, xmlns: "http://www.w3.org/2000/svg", role: "img", "aria-label": "Share Icon", ...rest, ref: ref2, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("title", { children: title || "Share Icon" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11.375 4.13388V11.375C11.375 11.7202 11.6548 12 12 12C12.3452 12 12.625 11.7202 12.625 11.375V4.13388L14.6831 6.19194C14.9271 6.43602 15.3229 6.43602 15.5669 6.19194C15.811 5.94786 15.811 5.55214 15.5669 5.30806L12.4421 2.18322C12.4421 2.18317 12.442 2.18311 12.4419 2.18306C12.382 2.12314 12.313 2.07792 12.2392 2.04742C12.1655 2.01687 12.0847 2 12 2C11.9153 2 11.8345 2.01687 11.7608 2.04742C11.687 2.07792 11.618 2.12314 11.5581 2.18306L11.5579 2.18322L8.43306 5.30806C8.18898 5.55214 8.18898 5.94786 8.43306 6.19194C8.67714 6.43602 9.07286 6.43602 9.31694 6.19194L11.375 4.13388ZM6.375 9.5C6.20924 9.5 6.05027 9.56585 5.93306 9.68306C5.81585 9.80027 5.75 9.95924 5.75 10.125V20.125C5.75 20.2908 5.81585 20.4497 5.93306 20.5669C6.05027 20.6842 6.20924 20.75 6.375 20.75H17.625C17.7908 20.75 17.9497 20.6842 18.0669 20.5669C18.1842 20.4497 18.25 20.2908 18.25 20.125V10.125C18.25 9.95924 18.1842 9.80027 18.0669 9.68306C17.9497 9.56585 17.7908 9.5 17.625 9.5H16.375C16.0298 9.5 15.75 9.22018 15.75 8.875C15.75 8.52982 16.0298 8.25 16.375 8.25H17.625C18.1223 8.25 18.5992 8.44754 18.9508 8.79917C19.3025 9.1508 19.5 9.62772 19.5 10.125V20.125C19.5 20.6223 19.3025 21.0992 18.9508 21.4508C18.5992 21.8025 18.1223 22 17.625 22H6.375C5.87772 22 5.4008 21.8025 5.04917 21.4508C4.69754 21.0992 4.5 20.6223 4.5 20.125V10.125C4.5 9.62772 4.69754 9.15081 5.04917 8.79917C5.40081 8.44754 5.87772 8.25 6.375 8.25H7.625C7.97018 8.25 8.25 8.52982 8.25 8.875C8.25 9.22018 7.97018 9.5 7.625 9.5H6.375Z" })
  ] });
});
ShareIcon.displayName = "ShareIcon";
const ShieldIcon = forwardRef((props, ref2) => {
  const defaultFill = `var(${TOKENS.color.foreground.default}, ${ICON_FILL_DEFAULT})`;
  const {
    size: size2,
    title,
    ...rest
  } = props;
  const mappedSizeOrDefault = size2 ? ICON_SIZE_MAPPINGS[size2] : ICON_SIZE_DEFAULT;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { width: mappedSizeOrDefault, height: mappedSizeOrDefault, viewBox: "0 0 24 24", fill: defaultFill, xmlns: "http://www.w3.org/2000/svg", role: "img", "aria-label": "Shield Icon", ...rest, ref: ref2, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("title", { children: title || "Shield Icon" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.625 6.87456C12.6253 7.21974 12.3456 7.49976 12.0005 7.50002C11.2818 7.50054 10.5784 7.70758 9.974 8.09648C9.36962 8.48537 8.88973 9.03975 8.59144 9.69362C8.29316 10.3475 8.18905 11.0733 8.29151 11.7846C8.39397 12.496 8.69868 13.1629 9.16937 13.706C9.64006 14.2491 10.2569 14.6455 10.9465 14.848C11.636 15.0506 12.3693 15.0507 13.0589 14.8484C13.7485 14.646 14.3655 14.2498 14.8363 13.7068C15.3072 13.1639 15.6121 12.497 15.7147 11.7857C15.7641 11.4441 16.081 11.2071 16.4226 11.2564C16.7643 11.3057 17.0012 11.6227 16.9519 11.9643C16.815 12.9127 16.4085 13.8018 15.7807 14.5258C15.1529 15.2497 14.3303 15.778 13.4108 16.0478C12.4913 16.3176 11.5136 16.3174 10.5942 16.0474C9.6748 15.7774 8.85235 15.2488 8.22476 14.5247C7.59717 13.8005 7.19089 12.9113 7.05428 11.9628C6.91767 11.0144 7.05648 10.0466 7.45419 9.17482C7.8519 8.303 8.49176 7.56383 9.29759 7.0453C10.1034 6.52677 11.0413 6.25072 11.9995 6.25002C12.3447 6.24976 12.6247 6.52938 12.625 6.87456ZM16.8169 8.41028C17.061 8.1662 17.061 7.77047 16.8169 7.5264C16.5729 7.28232 16.1771 7.28232 15.9331 7.5264L12.0001 11.4594L10.806 10.2613C10.5623 10.0168 10.1666 10.0162 9.92213 10.2598C9.67765 10.5035 9.67699 10.8992 9.92066 11.1437L11.1707 12.3979L11.1719 12.3992C11.3917 12.6184 11.6895 12.7416 12 12.7416C12.3105 12.7416 12.6083 12.6184 12.8281 12.3992L16.8169 8.41028Z" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M19.6517 4.06138C17.2393 3.00845 14.632 2.47641 12 2.5C9.36802 2.47641 6.76062 3.00836 4.34827 4.06129L4.33817 4.06592C4.01157 4.21543 3.73512 4.45612 3.54208 4.75904C3.34944 5.0613 3.24804 5.41268 3.25 5.77107L3.26867 12.7416C3.38253 14.6525 4.01475 16.5007 5.10293 18.0852C6.30981 19.8426 8.0211 21.193 10.0108 21.9584L10.8783 22.2918C11.6003 22.5694 12.3999 22.5694 13.1219 22.2917L13.9894 21.9584C15.9791 21.193 17.6902 19.8426 18.8971 18.0852C20.1039 16.3279 20.75 14.2461 20.75 12.1142V5.77119L20.75 5.77338L20.7486 5.68772C20.7357 5.35839 20.6356 5.03784 20.4579 4.75904C20.2649 4.45612 19.9885 4.21534 19.6619 4.06583L19.6517 4.06138ZM6.13333 17.3776C5.06948 15.8285 4.50001 13.9934 4.5 12.1142L4.49999 8.93961L4.49998 5.76502C4.49919 5.64668 4.53261 5.53063 4.59621 5.43083C4.63674 5.36723 4.68844 5.31195 4.74846 5.26747C4.77912 5.24475 4.81194 5.22485 4.84656 5.20809L4.84835 5.20701L4.85428 5.20443L4.85849 5.20248C7.10868 4.2219 9.53966 3.72734 11.9942 3.75011L12.0058 3.75C14.4604 3.72723 16.8922 4.22234 19.1424 5.20297L19.1415 5.20248L19.1457 5.20443L19.1516 5.20701L19.1539 5.20834C19.1808 5.22137 19.2066 5.2363 19.2311 5.25297C19.2999 5.29971 19.3587 5.36012 19.4038 5.43083C19.4674 5.53063 19.5008 5.64668 19.5 5.76502V12.1142C19.5 13.9934 18.9305 15.8285 17.8667 17.3776C16.8029 18.9266 15.2944 20.117 13.5406 20.7917L12.6731 21.125C12.2398 21.2917 11.7599 21.2916 11.3267 21.125L10.4592 20.7916C8.70535 20.1169 7.19714 18.9266 6.13333 17.3776Z" })
  ] });
});
ShieldIcon.displayName = "ShieldIcon";
const SignatureExampleIcon = forwardRef((props, ref2) => {
  const defaultFill = `var(${TOKENS.color.foreground.default}, ${ICON_FILL_DEFAULT})`;
  const {
    size: size2,
    title,
    ...rest
  } = props;
  const mappedSizeOrDefault = size2 ? ICON_SIZE_MAPPINGS[size2] : ICON_SIZE_DEFAULT;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { width: mappedSizeOrDefault, height: mappedSizeOrDefault, viewBox: "0 0 70 53", fill: defaultFill, xmlns: "http://www.w3.org/2000/svg", role: "img", "aria-label": "Signature Example Icon", ...rest, ref: ref2, version: "1.1", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("title", { children: title || "Signature Example Icon" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M34.683,5.794C31.03,1.072,25.91-.729,21.548.264c-4.435,1.009-7.771,4.846-7.771,10.599,0,8.86,5.229,14.98,11.374,19.41-2.972,2.727-5.229,5.901-6.575,8.981-.142.325-.275.651-.398.977H1.489c-.823,0-1.489.674-1.489,1.506s.667,1.506,1.489,1.506h15.847c-.206,1.172-.255,2.314-.119,3.389.295,2.336,1.476,4.357,3.712,5.488,2.381,1.204,4.674,1.096,6.71.139,1.963-.922,3.618-2.595,4.969-4.42,1.059-1.431,1.984-3.029,2.763-4.597h33.138c.823,0,1.489-.674,1.489-1.506s-.667-1.506-1.489-1.506h-31.785c.52-1.284.918-2.439,1.187-3.322.672-2.207,1.454-6.43,1.622-11.241.322-.102.634-.195.936-.279,2.04-.564,3.516-.673,4.483-.516.931.151,1.195.496,1.293.741.141.349.187,1.087-.336,2.371-.672,1.65-1.012,3.161-.689,4.368.181.673.574,1.264,1.196,1.641.588.356,1.236.433,1.801.398,1.096-.069,2.295-.588,3.398-1.26,1.14-.694,2.328-1.644,3.426-2.755.988-.999,2.002-1.911,2.957-2.625.974-.729,1.8-1.187,2.418-1.373.301-.09.484-.095.576-.084.062.008.074.02.081.027.063.061.361.467.361,1.86,0,2.581.682,4.61,2.519,5.353.833.337,1.691.3,2.416.147.731-.154,1.44-.449,2.061-.763.736-.372,1.034-1.277.666-2.021-.368-.744-1.262-1.045-1.998-.674-.496.251-.95.427-1.337.508-.392.082-.604.045-.703.005-.034-.013-.647-.258-.647-2.556,0-1.619-.308-3.096-1.281-4.036-1.073-1.036-2.463-.986-3.564-.655-1.104.332-2.256,1.027-3.341,1.839-1.105.827-2.231,1.845-3.291,2.916-.949.96-1.949,1.751-2.857,2.305-.092.056-.182.109-.269.159-.878.499-1.663-.195-1.314-1.142.05-.137.106-.282.169-.435.65-1.597.91-3.241.34-4.655-.612-1.519-1.984-2.319-3.581-2.578-1.56-.253-3.504-.033-5.74.585-.044.012-.089.025-.133.037-.146-5.737-1.311-12.133-4.868-16.728ZM33.487,40.231c.715-1.624,1.25-3.126,1.579-4.208.535-1.757,1.198-5.187,1.434-9.224-1.068.45-2.215.981-3.44,1.601-.977.494-1.91,1.046-2.795,1.644.333.201.669.399,1.007.594.714.413.962,1.333.554,2.055-.408.722-1.318.973-2.032.56-.692-.4-1.387-.818-2.077-1.253-2.866,2.486-5.034,5.425-6.309,8.23h12.08ZM20.374,43.243c-.249,1.116-.313,2.132-.202,3.007.189,1.497.874,2.561,2.09,3.175,1.528.773,2.866.692,4.123.102,1.33-.625,2.63-1.859,3.839-3.493.644-.871,1.239-1.821,1.777-2.792h-11.626ZM31.728,25.706c1.747-.883,3.368-1.609,4.861-2.186,0-.163-.003-.326-.006-.49-.091-5.631-1.194-11.439-4.245-15.38-3.048-3.939-7.051-5.149-10.136-4.448-3.011.685-5.447,3.248-5.447,7.661,0,7.758,4.724,13.23,10.792,17.43,1.296-.962,2.693-1.835,4.181-2.587Z", fillRule: "evenodd" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M11.106,23.729c.582.588.582,1.542,0,2.13l-3.043,3.077,3.043,3.077c.582.588.582,1.542,0,2.13-.582.588-1.525.588-2.106,0l-3.043-3.077-3.043,3.077c-.582.588-1.525.588-2.106,0-.582-.588-.582-1.542,0-2.13l3.043-3.077-3.043-3.077c-.582-.588-.582-1.542,0-2.13.582-.588,1.525-.588,2.106,0l3.043,3.077,3.043-3.077c.582-.588,1.525-.588,2.106,0Z" })
  ] });
});
SignatureExampleIcon.displayName = "SignatureExampleIcon";
const SignDocumentIcon = forwardRef((props, ref2) => {
  const defaultFill = `var(${TOKENS.color.foreground.default}, ${ICON_FILL_DEFAULT})`;
  const {
    size: size2,
    title,
    ...rest
  } = props;
  const mappedSizeOrDefault = size2 ? ICON_SIZE_MAPPINGS[size2] : ICON_SIZE_DEFAULT;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { width: mappedSizeOrDefault, height: mappedSizeOrDefault, viewBox: "0 0 24 24", fill: defaultFill, xmlns: "http://www.w3.org/2000/svg", role: "img", "aria-label": "Sign Document Icon", ...rest, ref: ref2, version: "1.1", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("title", { children: title || "Sign Document Icon" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M20.695,4.531c-0.759-0.756-1.908-0.873-2.8-0.372L17.46,3.723c-0.662-0.663-1.834-0.665-2.502,0l-2.831,2.831\n		c-0.244,0.244-0.244,0.64,0,0.884c0.122,0.122,0.282,0.183,0.442,0.183s0.32-0.061,0.442-0.183l2.83-2.831\n		c0.194-0.195,0.54-0.195,0.734,0l0.366,0.366l-6.029,6.028c-0.117,0.117-0.183,0.276-0.183,0.442c0,0.15,0.06,0.292,0.158,0.405\n		c-0.563,0.045-1.113,0.281-1.541,0.723c-0.759,0.767-1.292,3.264-1.437,4.013c-0.04,0.204,0.024,0.414,0.171,0.561\n		c0.118,0.119,0.278,0.184,0.442,0.184c0.04,0,0.079-0.004,0.119-0.012c0.751-0.145,3.259-0.679,4.014-1.434\n		c0.442-0.428,0.678-0.979,0.719-1.546c0.117,0.102,0.26,0.159,0.406,0.159c0.16,0,0.32-0.061,0.442-0.183l4.041-4.041\n		c0.001-0.001,0.003-0.002,0.004-0.003s0.002-0.003,0.003-0.004l2.425-2.425C21.603,6.928,21.603,5.445,20.695,4.531z\n		 M11.779,14.993c-0.263,0.264-1.333,0.621-2.434,0.891c0.27-1.101,0.627-2.17,0.891-2.433c0.002-0.003,0.005-0.006,0.007-0.008\n		c0.235-0.243,0.546-0.363,0.851-0.363c0.27,0,0.535,0.095,0.738,0.28C12.264,13.829,12.244,14.543,11.779,14.993z M13.782,12.987\n		l-1.543-1.543l3.16-3.16l1.543,1.543L13.782,12.987z M19.812,6.958l-1.985,1.985L16.284,7.4l1.983-1.983\n		c0,0,0.001-0.001,0.001-0.001c0,0,0-0.001,0.001-0.001c0.426-0.424,1.118-0.423,1.541-0.002C20.234,5.84,20.234,6.533,19.812,6.958\n		z" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M19.8,13.169c0-0.345-0.28-0.625-0.625-0.625s-0.625,0.28-0.625,0.625c0,0.471,0.008,0.911,0.015,1.325\n		c0.038,2.317,0.06,3.594-1.2,4.853l-0.78,0.781H4.343c1.535-1.584,1.523-2.827,1.475-8.359c-0.011-1.192-0.023-2.593-0.023-4.253\n		c0-1.872,1.228-2.983,1.888-3.581c0.023-0.021,0.046-0.042,0.068-0.062h3.213c0.345,0,0.625-0.28,0.625-0.625\n		s-0.28-0.625-0.625-0.625h-3.46c-0.166,0-0.325,0.066-0.442,0.183C7.006,2.862,6.932,2.929,6.844,3.008\n		C6.098,3.683,4.545,5.09,4.545,7.515c0,1.664,0.012,3.069,0.023,4.264c0.05,5.678,0.014,6.343-1.209,7.566l-0.468,0.469\n		c-0.262,0.264-0.339,0.655-0.197,0.998c0.142,0.344,0.474,0.565,0.846,0.565h13.18c0.24,0,0.468-0.092,0.649-0.268l0.879-0.88\n		c1.635-1.634,1.605-3.363,1.565-5.757C19.807,14.065,19.8,13.632,19.8,13.169z" })
  ] });
});
SignDocumentIcon.displayName = "SignDocumentIcon";
const SpinnerIcon = forwardRef((props, ref2) => {
  const defaultFill = `var(${TOKENS.color.foreground.default}, ${ICON_FILL_DEFAULT})`;
  const {
    size: size2,
    title,
    ...rest
  } = props;
  const mappedSizeOrDefault = size2 ? ICON_SIZE_MAPPINGS[size2] : ICON_SIZE_DEFAULT;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { width: mappedSizeOrDefault, height: mappedSizeOrDefault, viewBox: "0 0 24 24", fill: defaultFill, xmlns: "http://www.w3.org/2000/svg", role: "img", "aria-label": "Spinner Icon", ...rest, ref: ref2, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("title", { children: title || "Spinner Icon" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.0434 5.26114C11.4563 4.62217 13.0564 4.53131 14.5326 5.00621C15.9248 5.45405 17.113 6.37486 17.8941 7.60457L15.9443 7.08213C15.6108 6.99279 15.2681 7.19066 15.1788 7.52408C15.0895 7.85749 15.2873 8.2002 15.6207 8.28954L19.0052 9.19636C19.1675 9.24877 19.3505 9.23496 19.5098 9.14303C19.6645 9.05381 19.7666 8.90847 19.8052 8.74756L20.717 5.34772C20.8064 5.01433 20.6086 4.67157 20.2752 4.58216C19.9418 4.49275 19.5991 4.69054 19.5097 5.02394L18.983 6.9879C18.0463 5.48541 16.6062 4.36017 14.9155 3.81627C13.144 3.24639 11.2239 3.35542 9.52831 4.12219C9.2138 4.26441 9.07413 4.63468 9.21636 4.94919C9.35859 5.26371 9.72885 5.40337 10.0434 5.26114ZM20.0828 11.6966C20.1168 11.3531 19.8659 11.0471 19.5224 11.013C19.1789 10.979 18.8729 11.2299 18.8389 11.5734C18.686 13.1169 17.9648 14.5485 16.8153 15.5899C15.7307 16.5726 14.3379 17.1416 12.8811 17.2028L14.3111 15.7728C14.5552 15.5287 14.5552 15.133 14.3111 14.8889C14.067 14.6448 13.6713 14.6448 13.4272 14.8889L10.9272 17.3889C10.8049 17.5112 10.7439 17.6717 10.7442 17.8321L10.7442 17.8333C10.7442 18.0229 10.8285 18.1927 10.9618 18.3073L13.4272 20.7728C13.6713 21.0169 14.067 21.0169 14.3111 20.7728C14.5552 20.5287 14.5552 20.133 14.3111 19.8889L12.8761 18.4539C14.645 18.3932 16.3388 17.7084 17.6546 16.5163C19.0339 15.2666 19.8994 13.5488 20.0828 11.6966ZM7.07941 8.06477L7.6013 10.0126C7.69063 10.346 8.03334 10.5439 8.36676 10.4545C8.70017 10.3652 8.89804 10.0225 8.80871 9.68908L7.906 6.31997C7.87351 6.1469 7.76848 5.98853 7.604 5.89363C7.44781 5.80353 7.26892 5.78847 7.10907 5.83726L3.71325 6.74713C3.37983 6.83646 3.18196 7.17917 3.2713 7.51259C3.36063 7.846 3.70334 8.04387 4.03676 7.95454L6.0021 7.42795C5.16902 8.9904 4.91423 10.8002 5.28814 12.5365C5.67992 14.3558 6.73391 15.9645 8.24539 17.0501C8.52575 17.2515 8.91626 17.1875 9.11763 16.9071C9.319 16.6268 9.25497 16.2362 8.97461 16.0349C7.71499 15.1301 6.83662 13.7895 6.51013 12.2734C6.2024 10.8444 6.40565 9.35568 7.07941 8.06477Z" })
  ] });
});
SpinnerIcon.displayName = "SpinnerIcon";
const SortArrowDownIcon = forwardRef((props, ref2) => {
  const defaultFill = `var(${TOKENS.color.foreground.default}, ${ICON_FILL_DEFAULT})`;
  const {
    size: size2,
    title,
    fill = "currentColor",
    ...rest
  } = props;
  const mappedSizeOrDefault = size2 ? ICON_SIZE_MAPPINGS[size2] : ICON_SIZE_DEFAULT;
  const iconFill = fill === "currentColor" ? "currentColor" : fill || defaultFill;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { width: mappedSizeOrDefault, height: mappedSizeOrDefault, viewBox: "0 0 15 15", fill: iconFill, xmlns: "http://www.w3.org/2000/svg", role: "img", "aria-label": "Sort Arrow Down Icon", ...rest, ref: ref2, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("title", { children: title || "Sort Arrow Down Icon" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M7.95179 10.8517L9.85382 8.94964L9.92423 8.89143C10.0745 8.79211 10.2715 8.79227 10.4218 8.89143L10.4932 8.94964L10.5504 9.02005C10.6499 9.17043 10.6498 9.36719 10.5504 9.51764L10.4932 9.58899L7.81661 12.2647C7.79531 12.2856 7.77231 12.3041 7.74807 12.3201L7.67297 12.3595C7.61942 12.3817 7.56097 12.3942 7.50023 12.3942C7.38726 12.3942 7.27329 12.3514 7.18573 12.2666L7.18385 12.2656L7.18197 12.2628L7.18009 12.2619L4.5073 9.58899C4.33089 9.41257 4.33091 9.12607 4.5073 8.94964L4.57865 8.89143C4.72883 8.79252 4.92515 8.79243 5.07528 8.89143L5.14663 8.94964L7.04866 10.8517V4.05735C7.04883 3.80799 7.25083 3.60577 7.50023 3.60577L7.59129 3.61516C7.79695 3.65735 7.95165 3.83925 7.95179 4.05735V10.8517Z", fill: iconFill })
  ] });
});
SortArrowDownIcon.displayName = "SortArrowDownIcon";
const SortArrowUpIcon = forwardRef((props, ref2) => {
  const defaultFill = `var(${TOKENS.color.foreground.default}, ${ICON_FILL_DEFAULT})`;
  const {
    size: size2,
    title,
    fill = "currentColor",
    ...rest
  } = props;
  const mappedSizeOrDefault = size2 ? ICON_SIZE_MAPPINGS[size2] : ICON_SIZE_DEFAULT;
  const iconFill = fill === "currentColor" ? "currentColor" : fill || defaultFill;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { width: mappedSizeOrDefault, height: mappedSizeOrDefault, viewBox: "0 0 15 15", fill: iconFill, xmlns: "http://www.w3.org/2000/svg", role: "img", "aria-label": "Sort Arrow Up Icon", ...rest, ref: ref2, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("title", { children: title || "Sort Arrow Up Icon" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M7.55019 4.66076L5.65648 6.55452L5.58638 6.61247C5.43677 6.71136 5.24067 6.71121 5.09099 6.61247L5.01995 6.55452L4.96293 6.48442C4.86385 6.3347 4.864 6.1388 4.96293 5.98901L5.01995 5.91797L7.68478 3.25399C7.70598 3.23317 7.72889 3.21471 7.75302 3.19884L7.82779 3.15958C7.8811 3.13748 7.9393 3.12502 7.99978 3.125C8.11225 3.125 8.22572 3.16765 8.3129 3.25212L8.31477 3.25306L8.31664 3.25586L8.31851 3.2568L10.9796 5.91797C11.1552 6.09362 11.1552 6.37886 10.9796 6.55452L10.9086 6.61247C10.759 6.71095 10.5636 6.71104 10.4141 6.61247L10.3431 6.55452L8.44937 4.66076L8.44937 11.4254C8.4492 11.6737 8.24809 11.875 7.99978 11.875L7.90911 11.8657C7.70435 11.8236 7.55033 11.6425 7.55019 11.4254L7.55019 4.66076Z", fill: iconFill })
  ] });
});
SortArrowUpIcon.displayName = "SortArrowUpIcon";
const SortArrowBothIcon = forwardRef((props, ref2) => {
  const defaultFill = `var(${TOKENS.color.foreground.default}, ${ICON_FILL_DEFAULT})`;
  const {
    size: size2,
    title,
    fill = "currentColor",
    ...rest
  } = props;
  const mappedSizeOrDefault = size2 ? ICON_SIZE_MAPPINGS[size2] : ICON_SIZE_DEFAULT;
  const iconFill = fill === "currentColor" ? "currentColor" : fill || defaultFill;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { width: mappedSizeOrDefault, height: mappedSizeOrDefault, viewBox: "0 0 15 15", fill: iconFill, xmlns: "http://www.w3.org/2000/svg", role: "img", "aria-label": "Sort Arrow Both Icon", ...rest, ref: ref2, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("title", { children: title || "Sort Arrow Both Icon" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M4.46605 3.13435C4.67172 3.17636 4.82649 3.35754 4.82664 3.5747V10.3398L6.72909 8.44568L6.79952 8.38771C6.94977 8.28896 7.14693 8.28902 7.2972 8.38771L7.36857 8.44568L7.42585 8.5158C7.52522 8.66546 7.5251 8.86159 7.42585 9.01131L7.36857 9.08237L4.69142 11.746C4.67014 11.7668 4.64709 11.7853 4.62287 11.8011L4.54775 11.8404C4.49421 11.8625 4.4357 11.875 4.37497 11.875C4.26207 11.8749 4.14791 11.8323 4.0604 11.7478L4.05852 11.7469L4.05664 11.7441L4.05476 11.7432L1.38231 9.08237C1.20589 8.90671 1.20591 8.62135 1.38231 8.44568L1.45367 8.38771C1.60384 8.28929 1.80031 8.28916 1.95042 8.38771L2.02178 8.44568L3.9233 10.3398V3.5747C3.92347 3.32649 4.12567 3.12512 4.37497 3.125L4.46605 3.13435Z", fill: iconFill }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M10.6251 3.125C10.738 3.12506 10.8522 3.16774 10.9397 3.25215L10.9415 3.25309L10.9434 3.25589L10.9453 3.25682L13.6178 5.91763C13.7941 6.09325 13.794 6.37864 13.6178 6.55432L13.5464 6.61228C13.3962 6.71076 13.1998 6.71086 13.0496 6.61228L12.9783 6.55432L11.0768 4.66109V11.4253C11.0766 11.6735 10.8744 11.8749 10.6251 11.875L10.534 11.8657C10.3283 11.8236 10.1736 11.6425 10.1734 11.4253V4.66109L8.27097 6.55432L8.20054 6.61228C8.05027 6.71115 7.85319 6.71101 7.70286 6.61228L7.63149 6.55432L7.57421 6.4842C7.47498 6.33453 7.47494 6.13834 7.57421 5.98869L7.63149 5.91763L10.3086 3.25402C10.3299 3.23323 10.353 3.2147 10.3772 3.19886L10.4523 3.15959C10.5058 3.13753 10.5644 3.12502 10.6251 3.125Z", fill: iconFill })
  ] });
});
SortArrowBothIcon.displayName = "SortArrowBothIcon";
const TableSortIcon = forwardRef((props, ref2) => {
  const {
    direction,
    ...rest
  } = props;
  switch (direction) {
    case "asc":
      return /* @__PURE__ */ jsxRuntimeExports.jsx(SortArrowUpIcon, { ...rest, ref: ref2 });
    case "desc":
      return /* @__PURE__ */ jsxRuntimeExports.jsx(SortArrowDownIcon, { ...rest, ref: ref2 });
    default:
      return /* @__PURE__ */ jsxRuntimeExports.jsx(SortArrowBothIcon, { ...rest, ref: ref2 });
  }
});
TableSortIcon.displayName = "TableSortIcon";
const TaskListCompleteIcon = forwardRef((props, ref2) => {
  const {
    size: size2,
    title,
    strokeColor,
    ...rest
  } = props;
  const mappedSizeOrDefault = size2 ? ICON_SIZE_MAPPINGS[size2] : ICON_SIZE_DEFAULT;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { width: mappedSizeOrDefault, height: mappedSizeOrDefault, viewBox: "0 0 48 48", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img", "aria-label": "Task List Complete Icon", ...rest, ref: ref2, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("title", { children: title || "Task List Complete Icon" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M10.5 21.022H21", stroke: "#282624", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M10.5 28.522H16.5", stroke: "#282624", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M10.5 36.022H16.5", stroke: "#282624", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M19.5 46.522H4.5C2.84315 46.522 1.5 45.1788 1.5 43.522V12.022C1.5 10.3651 2.84315 9.02197 4.5 9.02197H12C12 4.87984 15.3579 1.52197 19.5 1.52197C23.6421 1.52197 27 4.87984 27 9.02197H34.5C36.1569 9.02197 37.5 10.3651 37.5 12.022V16.522", stroke: "#282624", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M19.5 7.52197C19.9142 7.52197 20.25 7.85776 20.25 8.27197C20.25 8.68619 19.9142 9.02197 19.5 9.02197C19.0858 9.02197 18.75 8.68619 18.75 8.27197C18.75 7.85776 19.0858 7.52197 19.5 7.52197", stroke: "#282624", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M34.5 46.522C41.1274 46.522 46.5 41.1494 46.5 34.522C46.5 27.8946 41.1274 22.522 34.5 22.522C27.8726 22.522 22.5 27.8946 22.5 34.522C22.5 41.1494 27.8726 46.522 34.5 46.522Z", stroke: "#13805C", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M39.8474 31.032L34.0374 38.78C33.776 39.1276 33.3767 39.3449 32.9429 39.3756C32.509 39.4063 32.0831 39.2474 31.7754 38.94L28.7754 35.94", stroke: "#13805C", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" })
  ] });
});
TaskListCompleteIcon.displayName = "TaskListCompleteIcon";
const TaskListIcon = forwardRef((props, ref2) => {
  const {
    size: size2,
    title,
    strokeColor,
    ...rest
  } = props;
  const mappedSizeOrDefault = size2 ? ICON_SIZE_MAPPINGS[size2] : ICON_SIZE_DEFAULT;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { width: mappedSizeOrDefault, height: mappedSizeOrDefault, viewBox: "0 0 48 48", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img", "aria-label": "Task List Icon", ...rest, ref: ref2, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("title", { children: title || "Task List Icon" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M22.5 28.522H33", stroke: "#282624", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M22.5 37.522H33", stroke: "#282624", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M16.5 27.772C16.9142 27.772 17.25 28.1078 17.25 28.522C17.25 28.9362 16.9142 29.272 16.5 29.272C16.0858 29.272 15.75 28.9362 15.75 28.522C15.75 28.1078 16.0858 27.772 16.5 27.772", stroke: "#282624", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M22.5 19.522H33", stroke: "#282624", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M16.5 18.772C16.9142 18.772 17.25 19.1078 17.25 19.522C17.25 19.9362 16.9142 20.272 16.5 20.272C16.0858 20.272 15.75 19.9362 15.75 19.522C15.75 19.1078 16.0858 18.772 16.5 18.772", stroke: "#282624", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M16.5 36.772C16.9142 36.772 17.25 37.1078 17.25 37.522C17.25 37.9362 16.9142 38.272 16.5 38.272C16.0858 38.272 15.75 37.9362 15.75 37.522C15.75 37.1078 16.0858 36.772 16.5 36.772", stroke: "#282624", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M31.5 9.02197H39C40.6569 9.02197 42 10.3651 42 12.022V43.522C42 45.1788 40.6569 46.522 39 46.522H9C7.34315 46.522 6 45.1788 6 43.522V12.022C6 10.3651 7.34315 9.02197 9 9.02197H16.5C16.5 4.87984 19.8579 1.52197 24 1.52197C28.1421 1.52197 31.5 4.87984 31.5 9.02197Z", stroke: "#282624", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M24 7.52197C24.4142 7.52197 24.75 7.85776 24.75 8.27197C24.75 8.68619 24.4142 9.02197 24 9.02197C23.5858 9.02197 23.25 8.68619 23.25 8.27197C23.25 7.85776 23.5858 7.52197 24 7.52197", stroke: "#282624", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" })
  ] });
});
TaskListIcon.displayName = "TaskListIcon";
const TextMessageIcon = forwardRef((props, ref2) => {
  const defaultFill = `var(${TOKENS.color.foreground.default}, ${ICON_FILL_DEFAULT})`;
  const {
    size: size2,
    title,
    ...rest
  } = props;
  const mappedSizeOrDefault = size2 ? ICON_SIZE_MAPPINGS[size2] : ICON_SIZE_DEFAULT;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { version: "1.1", width: mappedSizeOrDefault, height: mappedSizeOrDefault, viewBox: "0 0 40 40", xmlSpace: "preserve", fill: defaultFill, ...rest, ref: ref2, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("title", { children: title || "Text Message Icon" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.66667 4.37435C4.48054 4.37435 2.70833 6.14655 2.70833 8.33268V33.3327C2.70833 35.5188 4.48054 37.291 6.66667 37.291H16.6667C18.8528 37.291 20.625 35.5188 20.625 33.3327V24.166C20.625 23.5907 21.0914 23.1243 21.6667 23.1243C22.242 23.1243 22.7083 23.5907 22.7083 24.166V33.3327C22.7083 36.6694 20.0034 39.3743 16.6667 39.3743H6.66667C3.32995 39.3743 0.625 36.6694 0.625 33.3327V8.33268C0.625 4.99596 3.32995 2.29102 6.66667 2.29102H10C10.5753 2.29102 11.0417 2.75739 11.0417 3.33268C11.0417 3.90798 10.5753 4.37435 10 4.37435H6.66667Z" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.33317 2.29102C8.90847 2.29102 9.37484 2.75739 9.37484 3.33268V7.08268C9.37484 7.18693 9.40743 7.25715 9.43179 7.29102H9.99984C10.5751 7.29102 11.0415 7.75739 11.0415 8.33268C11.0415 8.90798 10.5751 9.37435 9.99984 9.37435H9.37484C8.05448 9.37435 7.2915 8.16244 7.2915 7.08268V3.33268C7.2915 2.75739 7.75787 2.29102 8.33317 2.29102Z" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13.9585 6.25065C13.9585 2.91393 16.6634 0.208984 20.0002 0.208984H33.7502C37.0869 0.208984 39.7918 2.91393 39.7918 6.25065V13.7507C39.7918 17.0874 37.0869 19.7923 33.7502 19.7923H32.9316L26.9867 25.7372C26.6888 26.0351 26.2408 26.1243 25.8515 25.963C25.4623 25.8018 25.2085 25.422 25.2085 25.0007V19.7923H20.0002C16.6634 19.7923 13.9585 17.0874 13.9585 13.7507V6.25065ZM20.0002 2.29232C17.814 2.29232 16.0418 4.06452 16.0418 6.25065V13.7507C16.0418 15.9368 17.814 17.709 20.0002 17.709H26.2502C26.8255 17.709 27.2918 18.1754 27.2918 18.7507V22.4858L31.7636 18.0141C31.9589 17.8187 32.2239 17.709 32.5002 17.709H33.7502C35.9363 17.709 37.7085 15.9368 37.7085 13.7507V6.25065C37.7085 4.06452 35.9363 2.29232 33.7502 2.29232H20.0002Z" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M18.9585 10.0007C18.9585 9.08018 19.7047 8.33398 20.6252 8.33398C21.5456 8.33398 22.2918 9.08018 22.2918 10.0007C22.2918 10.9211 21.5456 11.6673 20.6252 11.6673C19.7047 11.6673 18.9585 10.9211 18.9585 10.0007Z" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M25.2085 10.0007C25.2085 9.08018 25.9547 8.33398 26.8752 8.33398C27.7956 8.33398 28.5418 9.08018 28.5418 10.0007C28.5418 10.9211 27.7956 11.6673 26.8752 11.6673C25.9547 11.6673 25.2085 10.9211 25.2085 10.0007Z" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M31.4585 10.0007C31.4585 9.08018 32.2047 8.33398 33.1252 8.33398C34.0456 8.33398 34.7918 9.08018 34.7918 10.0007C34.7918 10.9211 34.0456 11.6673 33.1252 11.6673C32.2047 11.6673 31.4585 10.9211 31.4585 10.0007Z" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M21.6665 31.6673L1.6665 31.6673L1.6665 29.584L21.6665 29.584L21.6665 31.6673Z" })
  ] });
});
TextMessageIcon.displayName = "TextMessageIcon";
const TrashIcon = forwardRef((props, ref2) => {
  const defaultFill = `var(${TOKENS.color.foreground.default}, ${ICON_FILL_DEFAULT})`;
  const {
    size: size2,
    title,
    ...rest
  } = props;
  const mappedSizeOrDefault = size2 ? ICON_SIZE_MAPPINGS[size2] : ICON_SIZE_DEFAULT;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { width: mappedSizeOrDefault, height: mappedSizeOrDefault, viewBox: "0 0 24 24", fill: defaultFill, xmlns: "http://www.w3.org/2000/svg", role: "img", "aria-label": "Trash Icon", ...rest, ref: ref2, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("title", { children: title || "Trash Icon" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.125 3.875C9.62772 3.875 9.15081 4.07254 8.79917 4.42417C8.44754 4.77581 8.25 5.25272 8.25 5.75V6.375H6.375H3.875C3.52982 6.375 3.25 6.65482 3.25 7C3.25 7.34518 3.52982 7.625 3.875 7.625H5.75V18.25C5.75 18.7473 5.94754 19.2242 6.29917 19.5758C6.6508 19.9275 7.12772 20.125 7.625 20.125H16.375C16.8723 20.125 17.3492 19.9275 17.7008 19.5758C18.0525 19.2242 18.25 18.7473 18.25 18.25V7.625H20.125C20.4702 7.625 20.75 7.34518 20.75 7C20.75 6.65482 20.4702 6.375 20.125 6.375H17.625H15.75V5.75C15.75 5.25272 15.5525 4.77581 15.2008 4.42417C14.8492 4.07254 14.3723 3.875 13.875 3.875H10.125ZM14.5 6.375V5.75C14.5 5.58424 14.4342 5.42527 14.3169 5.30806C14.1997 5.19085 14.0408 5.125 13.875 5.125H10.125C9.95924 5.125 9.80027 5.19085 9.68306 5.30806C9.56585 5.42527 9.5 5.58424 9.5 5.75V6.375H14.5ZM8.875 7.625H7V18.25C7 18.4158 7.06585 18.5747 7.18306 18.6919C7.30027 18.8092 7.45924 18.875 7.625 18.875H16.375C16.5408 18.875 16.6997 18.8092 16.8169 18.6919C16.9342 18.5747 17 18.4158 17 18.25V7.625H15.125H8.875ZM10.125 10.125C10.4702 10.125 10.75 10.4048 10.75 10.75V15.75C10.75 16.0952 10.4702 16.375 10.125 16.375C9.77982 16.375 9.5 16.0952 9.5 15.75V10.75C9.5 10.4048 9.77982 10.125 10.125 10.125ZM14.5 10.75C14.5 10.4048 14.2202 10.125 13.875 10.125C13.5298 10.125 13.25 10.4048 13.25 10.75V15.75C13.25 16.0952 13.5298 16.375 13.875 16.375C14.2202 16.375 14.5 16.0952 14.5 15.75V10.75Z" })
  ] });
});
TrashIcon.displayName = "TrashIcon";
const UnderwriteIcon = forwardRef((props, ref2) => {
  const defaultFill = `var(${TOKENS.color.foreground.default}, ${ICON_FILL_DEFAULT})`;
  const {
    size: size2,
    title,
    ...rest
  } = props;
  const mappedSizeOrDefault = size2 ? ICON_SIZE_MAPPINGS[size2] : ICON_SIZE_DEFAULT;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { width: mappedSizeOrDefault, height: mappedSizeOrDefault, viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", fill: defaultFill, role: "img", "aria-label": "Underwrite Icon", ref: ref2, ...rest, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("title", { children: title || "Underwrite Icon" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M13.7203 3C14.2166 3.00011 14.6929 3.1974 15.0439 3.54821L17.4348 5.93905C17.7857 6.29015 17.9829 6.76637 17.983 7.26274V8.86721C17.983 9.21199 17.7035 9.4915 17.3587 9.4915C17.0139 9.4915 16.7344 9.21199 16.7344 8.86721V7.26274C16.7343 7.09745 16.6688 6.93881 16.552 6.82183L14.1612 4.43099C14.0442 4.31424 13.8855 4.24867 13.7203 4.24858H4.87287C4.7073 4.24858 4.54807 4.31392 4.43099 4.43099C4.31392 4.54807 4.24858 4.7073 4.24858 4.87287V18.6073C4.24858 18.7729 4.31392 18.9321 4.43099 19.0492C4.54807 19.1662 4.7073 19.2316 4.87287 19.2316H9.86721C10.212 19.2316 10.4915 19.5111 10.4915 19.8559C10.4915 20.2007 10.212 20.4802 9.86721 20.4802H4.87287C4.37616 20.4802 3.89944 20.2832 3.54821 19.932C3.19697 19.5807 3 19.104 3 18.6073V4.87287C3 4.37616 3.19697 3.89944 3.54821 3.54821C3.89944 3.19697 4.37616 3 4.87287 3H13.7203Z" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M20.1026 11.5548C19.6997 11.1518 19.0458 11.1518 18.6428 11.5548L12.9473 17.2503L12.8423 18.8137L14.4064 18.7094L20.1019 13.0139C20.5048 12.611 20.5053 11.9578 20.1026 11.5548ZM20.9865 10.6709C21.8774 11.562 21.8768 13.0067 20.9858 13.8978L15.148 19.7355C15.0254 19.8581 14.8626 19.9325 14.6895 19.9441L12.4494 20.0932C11.9471 20.1267 11.53 19.7096 11.5635 19.2073L11.7133 16.9679L11.7334 16.8401C11.7648 16.7155 11.8292 16.6007 11.9212 16.5087L17.759 10.6709C18.6501 9.77979 20.0954 9.77979 20.9865 10.6709Z" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M10.5361 6.58106C10.7675 6.32501 11.1628 6.30484 11.4189 6.53614C11.675 6.76753 11.6952 7.16285 11.4639 7.41895L9.09961 10.0352C8.83816 10.3241 8.38983 10.3399 8.1084 10.0703L6.56738 8.59376L6.48535 8.49805C6.31994 8.25891 6.33981 7.92808 6.54883 7.70997C6.75783 7.49214 7.08716 7.45834 7.33301 7.61329L7.43262 7.69141L8.55762 8.76954L10.5361 6.58106Z" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M10.5361 10.9144C10.7675 10.6584 11.1628 10.6382 11.4189 10.8695C11.675 11.1009 11.6952 11.4962 11.4639 11.7523L9.09961 14.3685C8.83816 14.6575 8.38983 14.6733 8.1084 14.4037L6.56738 12.9271L6.48535 12.8314C6.31994 12.5923 6.33981 12.2614 6.54883 12.0433C6.75783 11.8255 7.08716 11.7917 7.33301 11.9466L7.43262 12.0248L8.55762 13.1029L10.5361 10.9144Z" })
  ] });
});
UnderwriteIcon.displayName = "UnderwriteIcon";
const UnlockIcon = forwardRef((props, ref2) => {
  const defaultFill = `var(${TOKENS.color.foreground.default}, ${ICON_FILL_DEFAULT})`;
  const {
    size: size2,
    title,
    ...rest
  } = props;
  const mappedSizeOrDefault = size2 ? ICON_SIZE_MAPPINGS[size2] : ICON_SIZE_DEFAULT;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { width: mappedSizeOrDefault, height: mappedSizeOrDefault, viewBox: "0 0 24 24", fill: defaultFill, xmlns: "http://www.w3.org/2000/svg", role: "img", "aria-label": "Unlock Icon", ...rest, ref: ref2, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("title", { children: title || "Unlock Icon" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7 3.25C6.00544 3.25 5.05161 3.64509 4.34835 4.34835C3.64509 5.05161 3.25 6.00544 3.25 7V10.125C3.25 10.4702 2.97018 10.75 2.625 10.75C2.27982 10.75 2 10.4702 2 10.125V7C2 5.67392 2.52678 4.40215 3.46447 3.46447C4.40215 2.52678 5.67392 2 7 2C8.32608 2 9.59785 2.52678 10.5355 3.46447C11.4732 4.40215 12 5.67392 12 7V9.5H20.125C21.1605 9.5 22 10.3395 22 11.375V20.125C22 21.1605 21.1605 22 20.125 22H8.875C7.83947 22 7 21.1605 7 20.125V11.375C7 10.3395 7.83947 9.5 8.875 9.5H10.75V7C10.75 6.00544 10.3549 5.05161 9.65165 4.34835C8.94839 3.64509 7.99456 3.25 7 3.25ZM8.875 10.75H11.375H20.125C20.4702 10.75 20.75 11.0298 20.75 11.375V20.125C20.75 20.4702 20.4702 20.75 20.125 20.75H8.875C8.52982 20.75 8.25 20.4702 8.25 20.125V11.375C8.25 11.0298 8.52982 10.75 8.875 10.75ZM15.125 14.5C15.125 14.1548 14.8452 13.875 14.5 13.875C14.1548 13.875 13.875 14.1548 13.875 14.5V17C13.875 17.3452 14.1548 17.625 14.5 17.625C14.8452 17.625 15.125 17.3452 15.125 17V14.5Z" })
  ] });
});
UnlockIcon.displayName = "UnlockIcon";
const UploadIcon = forwardRef((props, ref2) => {
  const defaultFill = `var(${TOKENS.color.foreground.default}, ${ICON_FILL_DEFAULT})`;
  const {
    size: size2,
    title,
    ...rest
  } = props;
  const mappedSizeOrDefault = size2 ? ICON_SIZE_MAPPINGS[size2] : ICON_SIZE_DEFAULT;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { width: mappedSizeOrDefault, height: mappedSizeOrDefault, viewBox: "0 0 24 24", fill: defaultFill, xmlns: "http://www.w3.org/2000/svg", role: "img", "aria-label": "Upload Icon", ...rest, ref: ref2, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("title", { children: title || "Upload Icon" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.4359 4.67625C12.3233 4.56715 12.1699 4.5 12.0008 4.5C11.8351 4.5 11.6761 4.56585 11.5589 4.68306L11.5585 4.68343L7.80889 8.43306C7.56481 8.67714 7.56481 9.07286 7.80889 9.31694C8.05297 9.56102 8.4487 9.56102 8.69277 9.31694L11.3758 6.63388V15.125C11.3758 15.4702 11.6557 15.75 12.0008 15.75C12.346 15.75 12.6258 15.4702 12.6258 15.125V6.63388L15.3089 9.31694C15.553 9.56102 15.9487 9.56102 16.1928 9.31694C16.4369 9.07286 16.4369 8.67714 16.1928 8.43306L12.4428 4.68306L12.4359 4.67625ZM3.25083 15.125C3.25083 14.7798 2.97101 14.5 2.62583 14.5C2.28065 14.5 2.00083 14.7798 2.00083 15.125V16.375C2.00083 17.2038 2.33007 17.9987 2.91612 18.5847C3.50217 19.1708 4.29703 19.5 5.12583 19.5H18.8758C19.7046 19.5 20.4995 19.1708 21.0855 18.5847C21.6716 17.9987 22.0008 17.2038 22.0008 16.375V15.125C22.0008 14.7798 21.721 14.5 21.3758 14.5C21.0307 14.5 20.7508 14.7798 20.7508 15.125V16.375C20.7508 16.8723 20.5533 17.3492 20.2017 17.7008C19.85 18.0525 19.3731 18.25 18.8758 18.25H5.12583C4.62855 18.25 4.15164 18.0525 3.80001 17.7008C3.44838 17.3492 3.25083 16.8723 3.25083 16.375V15.125Z" })
  ] });
});
UploadIcon.displayName = "UploadIcon";
const UserAddIcon = forwardRef((props, ref2) => {
  const defaultFill = `var(${TOKENS.color.foreground.default}, ${ICON_FILL_DEFAULT})`;
  const {
    size: size2,
    title,
    ...rest
  } = props;
  const mappedSizeOrDefault = size2 ? ICON_SIZE_MAPPINGS[size2] : ICON_SIZE_DEFAULT;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { width: mappedSizeOrDefault, height: mappedSizeOrDefault, viewBox: "0 0 24 24", fill: defaultFill, xmlns: "http://www.w3.org/2000/svg", role: "img", "aria-label": "User Add Icon", ...rest, ref: ref2, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("title", { children: title || "User Add Icon" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.1494 12.2412C10.2113 12.2424 10.3001 12.2455 10.4082 12.25C10.6241 12.2591 10.9233 12.2769 11.2539 12.3135C11.8817 12.3829 12.7467 12.53 13.3389 12.8818C13.6316 13.0562 13.7264 13.4324 13.5508 13.7227C13.3749 14.0129 12.9953 14.1075 12.7021 13.9336C12.3626 13.7318 11.7412 13.6013 11.1162 13.5322C10.8206 13.4996 10.5502 13.4828 10.3545 13.4746C10.2576 13.4705 10.1792 13.4688 10.126 13.4678C10.0995 13.4673 10.0786 13.4669 10.0654 13.4668H10.0479C6.287 13.4669 3.23828 16.4875 3.23828 20.2129V20.7734H12.0947C12.4365 20.7737 12.7139 21.0481 12.7139 21.3867C12.7137 21.7252 12.4364 21.9998 12.0947 22H2.61914C2.27727 22 2.00014 21.7253 2 21.3867V20.2129C2 15.81 5.60309 12.2404 10.0479 12.2402H10.0771C10.0942 12.2404 10.1188 12.2406 10.1494 12.2412ZM17.125 12.5C17.4702 12.5 17.75 12.7798 17.75 13.125V16.5H21.375C21.7202 16.5 22 16.7798 22 17.125C22 17.4702 21.7202 17.75 21.375 17.75H17.75V21.375C17.75 21.7202 17.4702 22 17.125 22C16.7798 22 16.5 21.7202 16.5 21.375V17.75H13.125C12.7798 17.75 12.5 17.4702 12.5 17.125C12.5 16.7798 12.7798 16.5 13.125 16.5H16.5V13.125C16.5 12.7798 16.7798 12.5 17.125 12.5ZM9.94141 2C12.424 2.00012 14.4374 3.99391 14.4375 6.45312C14.4374 8.91232 12.424 10.9061 9.94141 10.9062C7.45878 10.9061 5.44641 8.91233 5.44629 6.45312C5.44639 3.9939 7.45877 2.00011 9.94141 2ZM9.94141 3.22656C8.14268 3.22667 6.68467 4.67137 6.68457 6.45312C6.68469 8.23487 8.14269 9.67958 9.94141 9.67969C11.7401 9.67957 13.1991 8.23486 13.1992 6.45312C13.1991 4.67137 11.7401 3.22668 9.94141 3.22656Z" })
  ] });
});
UserAddIcon.displayName = "UserAddIcon";
const UserContactCardIcon = forwardRef((props, ref2) => {
  const defaultFill = `var(${TOKENS.color.foreground.default}, ${ICON_FILL_DEFAULT})`;
  const {
    size: size2,
    title,
    ...rest
  } = props;
  const mappedSizeOrDefault = size2 ? ICON_SIZE_MAPPINGS[size2] : ICON_SIZE_DEFAULT;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { width: mappedSizeOrDefault, height: mappedSizeOrDefault, viewBox: "0 0 24 24", fill: defaultFill, xmlns: "http://www.w3.org/2000/svg", role: "img", "aria-label": "User Contact Card Icon", ...rest, ref: ref2, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("title", { children: title || "User Contact Card Icon" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M21 3.75C22.2426 3.75 23.25 4.75736 23.25 6V18C23.25 19.2426 22.2426 20.25 21 20.25H3C1.75736 20.25 0.75 19.2426 0.75 18V6C0.75 4.75736 1.75736 3.75 3 3.75H21ZM3 5C2.44772 5 2 5.44772 2 6V18L2.00488 18.1025C2.05621 18.6067 2.48232 19 3 19H21L21.1025 18.9951C21.573 18.9472 21.9472 18.573 21.9951 18.1025L22 18V6C22 5.48232 21.6067 5.05621 21.1025 5.00488L21 5H3ZM7.66699 13C10.0001 13.0002 11 15.1943 11 16.667V17H4V16.667C4 15.1943 4.99991 13.0002 7.33301 13H7.66699ZM18.375 13.75C18.7202 13.75 19 14.0298 19 14.375C19 14.7202 18.7202 15 18.375 15H13.625C13.2798 15 13 14.7202 13 14.375C13 14.0298 13.2798 13.75 13.625 13.75H18.375ZM7.5 7C8.88071 7 10 8.11929 10 9.5C10 10.8807 8.88071 12 7.5 12C6.11929 12 5 10.8807 5 9.5C5 8.11929 6.11929 7 7.5 7ZM16.375 10.75C16.7202 10.75 17 11.0298 17 11.375C17 11.7202 16.7202 12 16.375 12H13.625C13.2798 12 13 11.7202 13 11.375C13 11.0298 13.2798 10.75 13.625 10.75H16.375ZM18.375 7.75C18.7202 7.75 19 8.02982 19 8.375C19 8.72018 18.7202 9 18.375 9H13.625C13.2798 9 13 8.72018 13 8.375C13 8.02982 13.2798 7.75 13.625 7.75H18.375Z" })
  ] });
});
UserContactCardIcon.displayName = "UserContactCardIcon";
const VaseIcon = forwardRef((props, ref2) => {
  const defaultFill = `var(${TOKENS.color.foreground.default}, ${ICON_FILL_DEFAULT})`;
  const {
    size: size2,
    title,
    ...rest
  } = props;
  const mappedSizeOrDefault = size2 ? ICON_SIZE_MAPPINGS[size2] : ICON_SIZE_DEFAULT;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { width: mappedSizeOrDefault, height: mappedSizeOrDefault, viewBox: "0 0 48 49", fill: defaultFill, xmlns: "http://www.w3.org/2000/svg", role: "img", "aria-label": "Vase Icon", ...rest, ref: ref2, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("title", { children: title || "Vase Icon" }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("g", { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("path", { className: "st0", d: "M42.792,7.031c-0.816-0.628-1.784-0.974-2.796-0.951c-0.271-1.209-1.028-2.275-2.124-2.924\n		c-1.434-0.849-3.213-0.849-4.646,0c-1.093,0.647-1.85,1.709-2.122,2.915c-1.876-0.032-3.627,1.128-4.31,2.981\n		c-0.668,1.812-0.122,3.758,1.255,4.973c-1.962,2.328-3.422,5.053-4.281,7.975H21.09c0.071-2.172-0.393-4.311-1.353-6.271\n		c0.468-0.885,0.651-1.909,0.469-2.923c1.153-0.845,1.868-2.208,1.874-3.664c0-0.003,0-0.007,0-0.01\n		c-0.009-1.423-0.661-2.736-1.791-3.603c-0.818-0.627-1.803-0.932-2.798-0.948c-0.271-1.209-1.029-2.274-2.125-2.922\n		c-1.433-0.849-3.214-0.849-4.646,0C9.625,2.307,8.868,3.371,8.596,4.58C6.737,4.55,4.988,5.721,4.31,7.564\n		c-0.715,1.943-0.041,4.06,1.571,5.24c-0.329,1.832,0.495,3.716,2.141,4.704c0.73,0.438,1.54,0.65,2.343,0.65\n		c0.951,0,1.892-0.298,2.679-0.871c1.451,1.056,3.426,1.177,5.021,0.221c0.075-0.045,0.14-0.101,0.211-0.15\n		c0.595,1.475,0.877,3.048,0.815,4.642h-3.64c-1.329,0-2.567,0.657-3.312,1.757c-0.745,1.101-0.896,2.494-0.402,3.729l0.997,2.493\n		l-3.16,1.407c-2.673,1.187-4.729,3.462-5.639,6.242s-0.599,5.83,0.853,8.368c0.708,1.24,2.037,2.013,3.468,2.016h26.527\n		c1.434-0.004,2.764-0.781,3.47-2.027c1.453-2.539,1.764-5.589,0.854-8.369c-0.91-2.779-2.967-5.055-5.642-6.241l-3.157-1.398\n		l0.996-2.491c0.491-1.231,0.343-2.623-0.398-3.72c-0.74-1.1-1.974-1.759-3.305-1.764h-1.748c0.628-1.925,1.552-3.746,2.725-5.395\n		c0.341,0.975,1.003,1.838,1.945,2.403c1.596,0.958,3.569,0.836,5.021-0.221c0.787,0.573,1.728,0.872,2.679,0.872\n		c0.803,0,1.612-0.212,2.343-0.65c1.646-0.987,2.47-2.871,2.142-4.703c1.152-0.845,1.867-2.208,1.873-3.664c0-0.003,0-0.007,0-0.011\n		C44.57,9.21,43.919,7.898,42.792,7.031z M17.036,15.793c-1.061,0.637-2.424,0.422-3.239-0.511c-0.38-0.436-1.127-0.436-1.507,0\n		c-0.815,0.934-2.177,1.148-3.239,0.511c-1.062-0.637-1.514-1.94-1.073-3.098c0.185-0.485-0.033-1.031-0.501-1.257\n		c-1.192-0.573-1.747-1.942-1.29-3.184c0.378-1.029,1.342-1.674,2.389-1.674c0.217,0,0.438,0.028,0.657,0.086\n		c0.305,0.079,0.631,0.012,0.878-0.186s0.386-0.5,0.376-0.815c-0.031-0.935,0.449-1.811,1.252-2.287\n		c0.804-0.476,1.803-0.477,2.608,0c0.804,0.476,1.284,1.353,1.252,2.287c-0.01,0.315,0.128,0.617,0.375,0.814\n		c0.247,0.197,0.572,0.267,0.877,0.186c0.776-0.201,1.584-0.039,2.219,0.449c0.634,0.487,1.001,1.224,1.008,2.023\n		c-0.006,0.977-0.58,1.878-1.464,2.297c-0.472,0.223-0.692,0.772-0.507,1.259C18.549,13.853,18.098,15.156,17.036,15.793z\n		 M36.516,44.991c-0.001,0.002-0.001,0.003-0.002,0.005c-0.354,0.624-1.019,1.014-1.734,1.016H8.257\n		c-0.715-0.001-1.379-0.388-1.733-1.009C5.481,43.181,5.172,41.032,5.633,39h31.778C37.867,41.028,37.557,43.173,36.516,44.991z\n		 M29.246,24.882c0.371,0.55,0.445,1.245,0.199,1.861l-1.354,3.386c-0.199,0.499,0.032,1.067,0.524,1.285l4.039,1.788\n		c1.743,0.774,3.15,2.126,4.018,3.798H6.374c0.868-1.667,2.273-3.015,4.012-3.787l4.04-1.8c0.491-0.218,0.721-0.785,0.522-1.284\n		l-1.354-3.386c-0.247-0.617-0.172-1.314,0.201-1.865C14.168,24.329,14.787,24,15.452,24h12.144\n		C28.259,24.002,28.876,24.332,29.246,24.882z M41.115,12.936c-0.472,0.223-0.692,0.772-0.507,1.259\n		c0.44,1.158-0.011,2.461-1.073,3.098c-1.062,0.637-2.426,0.422-3.238-0.511c-0.19-0.218-0.465-0.343-0.754-0.343\n		s-0.563,0.125-0.754,0.343c-0.813,0.933-2.177,1.149-3.238,0.511c-1.062-0.637-1.514-1.939-1.073-3.098c0-0.001,0-0.001,0-0.002\n		c0.028-0.074,0.031-0.152,0.04-0.229c0.006-0.049,0.025-0.097,0.024-0.146c-0.001-0.057-0.023-0.11-0.034-0.166\n		c-0.013-0.067-0.019-0.135-0.045-0.197c-0.02-0.049-0.057-0.089-0.086-0.135c-0.039-0.063-0.075-0.127-0.128-0.18\n		c-0.009-0.009-0.012-0.021-0.021-0.03c-0.037-0.035-0.084-0.049-0.124-0.077c-0.045-0.032-0.081-0.073-0.133-0.097\n		c-1.202-0.571-1.762-1.942-1.301-3.192c0.46-1.249,1.776-1.927,3.062-1.582c0.306,0.084,0.634,0.015,0.882-0.182\n		c0.249-0.197,0.389-0.5,0.378-0.817c-0.031-0.934,0.449-1.81,1.253-2.287c0.805-0.477,1.803-0.477,2.607,0\n		c0.804,0.477,1.284,1.353,1.253,2.287c-0.011,0.315,0.128,0.617,0.374,0.814c0.245,0.198,0.57,0.265,0.876,0.188\n		c0.775-0.202,1.583-0.036,2.218,0.451c0.633,0.487,0.999,1.224,1.006,2.022C42.573,11.616,41.999,12.517,41.115,12.936z" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("path", { className: "st0", d: "M36.918,11.737c-0.003-0.456-0.187-0.902-0.509-1.223c-0.326-0.327-0.754-0.549-1.238-0.513\n		c0,0-0.001,0-0.001,0s-0.001,0-0.001,0c-0.001,0-0.001,0-0.002,0c-0.001,0-0.002,0.001-0.003,0.001\n		c-0.962,0.003-1.744,0.786-1.744,1.749s0.782,1.746,1.744,1.749c0.001,0,0.002,0.001,0.003,0.001c0.002,0,0.003,0,0.005,0\n		c0.461,0,0.912-0.187,1.236-0.512c0.323-0.323,0.507-0.768,0.51-1.224c0-0.003,0.002-0.005,0.002-0.009c0-0.002,0-0.003,0-0.005\n		s0-0.003,0-0.005C36.92,11.742,36.918,11.74,36.918,11.737z" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("path", { className: "st0", d: "M14.419,10.408c-0.002-0.46-0.187-0.908-0.511-1.231c-0.325-0.325-0.747-0.479-1.233-0.511\n		c-0.002,0-0.003-0.001-0.005-0.001c0,0-0.001,0-0.001,0c0,0-0.001,0-0.001,0c-0.001,0-0.002,0-0.002,0\n		c-0.963,0.003-1.745,0.786-1.745,1.75c0,0.962,0.78,1.744,1.74,1.749c0.002,0,0.003,0.001,0.005,0.001c0.003,0,0.005,0,0.008,0\n		c0.459,0,0.909-0.186,1.234-0.512c0.329-0.329,0.51-0.766,0.511-1.232c0-0.002,0.001-0.003,0.001-0.004c0-0.001,0-0.002,0-0.002\n		c0-0.001,0-0.002,0-0.003C14.42,10.411,14.419,10.41,14.419,10.408z" })
    ] })
  ] });
});
VaseIcon.displayName = "VaseIcon";
const WarningIcon = forwardRef((props, ref2) => {
  const defaultFill = `var(${TOKENS.color.foreground.default}, ${ICON_FILL_DEFAULT})`;
  const {
    size: size2,
    title,
    ...rest
  } = props;
  const mappedSizeOrDefault = size2 ? ICON_SIZE_MAPPINGS[size2] : ICON_SIZE_DEFAULT;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { width: mappedSizeOrDefault, height: mappedSizeOrDefault, viewBox: "0 0 24 24", fill: defaultFill, xmlns: "http://www.w3.org/2000/svg", role: "img", "aria-label": "Warning Icon", ...rest, ref: ref2, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("title", { children: title || "Warning Icon" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M12 2C12.3982 2 12.7884 2.11159 13.1261 2.32205C13.4158 2.50248 13.6572 2.74942 13.8308 3.04141L13.9119 3.19106L21.8059 19.2725C21.9478 19.5611 22.0138 19.8811 21.9976 20.2022C21.9815 20.5236 21.8838 20.8354 21.7137 21.1082C21.5436 21.3812 21.3067 21.6063 21.0255 21.7623C20.8004 21.8871 20.5529 21.9644 20.2986 21.9902L20.1067 21.9998H3.89393C3.57222 22.0001 3.25577 21.9183 2.97451 21.7623C2.69329 21.6063 2.45645 21.3812 2.28636 21.1082C2.11625 20.8353 2.01852 20.5235 2.00239 20.2022C1.98947 19.9453 2.02912 19.6891 2.11806 19.4493L2.19396 19.2728L10.0882 3.19096C10.2637 2.83362 10.5359 2.5326 10.8738 2.32209C11.2117 2.11159 11.6019 2 12 2ZM12 3.25C11.8355 3.25 11.6743 3.2961 11.5347 3.38306C11.43 3.44829 11.3406 3.53456 11.2718 3.63583L11.2102 3.74188L3.3159 19.8239C3.26773 19.9219 3.24533 20.0305 3.25081 20.1395C3.25629 20.2486 3.28946 20.3544 3.34722 20.4471C3.40499 20.5398 3.48543 20.6163 3.58093 20.6692C3.6445 20.7045 3.71339 20.7285 3.78477 20.7406L3.89335 20.7498H20.1073C20.2164 20.7498 20.3237 20.7222 20.4192 20.6692C20.5146 20.6163 20.595 20.5398 20.6529 20.4469C20.7106 20.3544 20.7437 20.2487 20.7492 20.1395C20.7529 20.0668 20.7441 19.9943 20.7236 19.9249L20.684 19.8236L12.7898 3.74198C12.7173 3.59437 12.6049 3.47004 12.4652 3.38302C12.3257 3.2961 12.1645 3.25 12 3.25ZM12 16.9998C12.5178 16.9998 12.9375 17.4195 12.9375 17.9373C12.9375 18.4181 12.5756 18.8143 12.1094 18.8685L12 18.8748C11.4822 18.8748 11.0625 18.455 11.0625 17.9373C11.0625 17.4565 11.4244 17.0602 11.8907 17.0061L12 16.9998ZM12 8.24979C12.3138 8.24979 12.5736 8.48105 12.6182 8.78243L12.625 8.87479V15.1248C12.625 15.4699 12.3452 15.7498 12 15.7498C11.6862 15.7498 11.4264 15.5185 11.3818 15.2171L11.375 15.1248V8.87479C11.375 8.52961 11.6548 8.24979 12 8.24979Z" })
  ] });
});
WarningIcon.displayName = "WarningIcon";
const WillDocumentIcon = forwardRef((props, ref2) => {
  const defaultFill = `var(${TOKENS.color.foreground.default}, ${ICON_FILL_DEFAULT})`;
  const {
    size: size2,
    title,
    ...rest
  } = props;
  const mappedSizeOrDefault = size2 ? ICON_SIZE_MAPPINGS[size2] : ICON_SIZE_DEFAULT;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { width: mappedSizeOrDefault, height: mappedSizeOrDefault, viewBox: "0 0 24 24", fill: defaultFill, xmlns: "http://www.w3.org/2000/svg", role: "img", "aria-label": "Will Document Icon", ...rest, ref: ref2, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("title", { children: title || "Will Document Icon" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.17499 5.53333C5.17499 3.78903 6.58902 2.375 8.33332 2.375H17.2C17.5452 2.375 17.825 2.65482 17.825 3V19.4667C17.825 20.5114 16.9781 21.3583 15.9333 21.3583C14.8886 21.3583 14.0417 20.5114 14.0417 19.4667V18.0683C13.9874 17.7688 13.7226 17.5507 13.4152 17.5581L13.4 16.9333V17.5583C13.0456 17.5583 12.7583 17.8456 12.7583 18.2V22C12.7583 22.3452 12.4785 22.625 12.1333 22.625C11.7881 22.625 11.5083 22.3452 11.5083 22V18.2C11.5083 17.1578 12.3512 16.3124 13.3924 16.3083C14.3483 16.2889 15.1657 16.9936 15.2866 17.9428C15.29 17.969 15.2917 17.9954 15.2917 18.0218V19.4667C15.2917 19.821 15.5789 20.1083 15.9333 20.1083C16.2877 20.1083 16.575 19.821 16.575 19.4667V3.625H8.33332C7.27938 3.625 6.42499 4.47939 6.42499 5.53333V16.9333C6.42499 17.2785 6.14517 17.5583 5.79999 17.5583C5.45481 17.5583 5.17499 17.2785 5.17499 16.9333V5.53333Z" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.53333 17.5584C3.47939 17.5584 2.625 18.4128 2.625 19.4667V21.3751H12.1333C12.4785 21.3751 12.7583 21.6549 12.7583 22.0001C12.7583 22.3453 12.4785 22.6251 12.1333 22.6251H2C1.65482 22.6251 1.375 22.3453 1.375 22.0001V19.4667C1.375 17.7224 2.78903 16.3084 4.53333 16.3084H13.4C13.7452 16.3084 14.025 16.5882 14.025 16.9334C14.025 17.2786 13.7452 17.5584 13.4 17.5584H4.53333Z" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11.5082 20.7334C11.5082 20.3882 11.788 20.1084 12.1332 20.1084H15.9332C16.2784 20.1084 16.5582 20.3882 16.5582 20.7334C16.5582 21.0786 16.2784 21.3584 15.9332 21.3584H12.1332C11.788 21.3584 11.5082 21.0786 11.5082 20.7334Z" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.70819 13.1334C7.70819 12.7882 7.98801 12.5084 8.33319 12.5084H14.6665C15.0117 12.5084 15.2915 12.7882 15.2915 13.1334C15.2915 13.4786 15.0117 13.7584 14.6665 13.7584H8.33319C7.98801 13.7584 7.70819 13.4786 7.70819 13.1334Z" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.70819 10.6C7.70819 10.2548 7.98801 9.97501 8.33319 9.97501H14.6665C15.0117 9.97501 15.2915 10.2548 15.2915 10.6C15.2915 10.9452 15.0117 11.225 14.6665 11.225H8.33319C7.98801 11.225 7.70819 10.9452 7.70819 10.6Z" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.70819 8.06659C7.70819 7.72141 7.98801 7.44159 8.33319 7.44159H14.6665C15.0117 7.44159 15.2915 7.72141 15.2915 8.06659C15.2915 8.41177 15.0117 8.69159 14.6665 8.69159H8.33319C7.98801 8.69159 7.70819 8.41177 7.70819 8.06659Z" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16.575 3C16.575 2.65482 16.8548 2.375 17.2 2.375H18.4667C20.211 2.375 21.625 3.78903 21.625 5.53333V6.8C21.625 7.14518 21.3452 7.425 21 7.425H17.2C16.8548 7.425 16.575 7.14518 16.575 6.8V3ZM17.825 3.625V6.175H20.375V5.53333C20.375 4.47939 19.5206 3.625 18.4667 3.625H17.825Z" })
  ] });
});
WillDocumentIcon.displayName = "WillDocumentIcon";
var icons = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  AddOptionIcon,
  AddressPinIcon,
  AgentAppIcon,
  AgentShieldIcon,
  ArrowDownIcon,
  ArrowLeftIcon,
  ArrowRightIcon,
  ArrowUpIcon,
  AuditIcon,
  AutomaticIcon,
  AvatarIcon,
  BadgeIcon,
  BankIcon,
  BankWithLinesIcon,
  BellIcon,
  CalendarIcon: CalendarIcon$1,
  CaretDownIcon,
  CaretLeftCircleIcon,
  CaretLeftIcon,
  CaretRightCircleIcon,
  CaretRightIcon,
  CaretUpIcon,
  CashPaymentIcon,
  CertifiedRibbonIcon,
  ChatFilledIcon,
  ChatIcon,
  CheckmarkCircleIcon,
  CheckmarkIcon,
  CheckmarkShorterIcon,
  ChildcareIcon,
  ClipboardIcon,
  ClockIcon,
  CloseIcon,
  ConfettiIcon,
  CopyIcon,
  CreditCardIcon,
  CreditScoreIcon,
  CursorIcon,
  DashboardIcon,
  DecreaseFaceIcon,
  DocumentIcon,
  DocumentLoadingIcon,
  DollarIcon,
  DownloadDocumentIcon,
  DownloadIcon,
  EducationIcon,
  EldercareIcon,
  EmailIcon,
  EncryptionIcon,
  ErrorIcon,
  ExpandIcon,
  EyeClosedIcon,
  EyeIcon,
  FileFolderIcon,
  FilterIcon,
  FlagIcon,
  FlashIcon,
  FolderIcon,
  GearIcon,
  HandoffCompleteIcon,
  HandoffIcon,
  HeartCircleIcon,
  HelpIcon,
  HomeIcon,
  HorizontalDetailsDropdownIcon,
  HorizontalDotsIcon,
  IdVerifyIcon,
  InfoCircleIcon,
  JobSearchIcon,
  LinkIcon,
  LoadingIcon,
  LockIcon,
  LoginIcon,
  LogoutIcon,
  MailIcon,
  MegaphoneIcon,
  MegaphoneNewIcon,
  MenuIcon,
  MinusCircleIcon,
  MinusIcon,
  MoneyPaymentIcon,
  NewTabIcon,
  PanelLeftIcon,
  PaperClipIcon,
  PenIcon,
  PencilIcon,
  PercentIcon,
  PhoneIcon,
  PieChartIcon,
  PlusCircleIcon,
  PlusIcon,
  PottedPlantIcon,
  QuestionMarkCircleIcon,
  QuestionMarkIcon,
  RetryIcon,
  SavingsBankIcon,
  SearchIcon,
  SendIcon,
  SettingsSlidersIcon,
  ShareIcon,
  ShieldIcon,
  SignDocumentIcon,
  SignatureExampleIcon,
  SpinnerIcon,
  TableSortIcon,
  TaskListCompleteIcon,
  TaskListIcon,
  TextMessageIcon,
  TrashIcon,
  UnderwriteIcon,
  UnlockIcon,
  UploadIcon,
  UserAddIcon,
  UserContactCardIcon,
  VaseIcon,
  WarningIcon,
  WillDocumentIcon
});
const outlineConfig = {
  outlineWidth: {
    property: "outlineWidth",
    scale: "spacing"
  },
  outlineColor: {
    property: "outlineColor",
    scale: "colors"
  },
  outlineStyle: {
    property: "outlineStyle"
  },
  outlineOffset: {
    property: "outlineOffset",
    scale: "spacing"
  },
  outline: {
    property: "outline"
  }
};
const outline = system(outlineConfig);
const transition = system({
  transition: {
    property: "transition"
  }
});
var __spreadArray$1 = function(to, from2, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l2 = from2.length, ar; i < l2; i++) {
    if (ar || !(i in from2)) {
      if (!ar) ar = Array.prototype.slice.call(from2, 0, i);
      ar[i] = from2[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from2));
};
var BrowserInfo = (
  /** @class */
  /* @__PURE__ */ function() {
    function BrowserInfo2(name, version, os) {
      this.name = name;
      this.version = version;
      this.os = os;
      this.type = "browser";
    }
    return BrowserInfo2;
  }()
);
var NodeInfo = (
  /** @class */
  /* @__PURE__ */ function() {
    function NodeInfo2(version) {
      this.version = version;
      this.type = "node";
      this.name = "node";
      this.os = process.platform;
    }
    return NodeInfo2;
  }()
);
var SearchBotDeviceInfo = (
  /** @class */
  /* @__PURE__ */ function() {
    function SearchBotDeviceInfo2(name, version, os, bot) {
      this.name = name;
      this.version = version;
      this.os = os;
      this.bot = bot;
      this.type = "bot-device";
    }
    return SearchBotDeviceInfo2;
  }()
);
var BotInfo = (
  /** @class */
  /* @__PURE__ */ function() {
    function BotInfo2() {
      this.type = "bot";
      this.bot = true;
      this.name = "bot";
      this.version = null;
      this.os = null;
    }
    return BotInfo2;
  }()
);
var ReactNativeInfo = (
  /** @class */
  /* @__PURE__ */ function() {
    function ReactNativeInfo2() {
      this.type = "react-native";
      this.name = "react-native";
      this.version = null;
      this.os = null;
    }
    return ReactNativeInfo2;
  }()
);
var SEARCHBOX_UA_REGEX = /alexa|bot|crawl(er|ing)|facebookexternalhit|feedburner|google web preview|nagios|postrank|pingdom|slurp|spider|yahoo!|yandex/;
var SEARCHBOT_OS_REGEX = /(nuhk|curl|Googlebot|Yammybot|Openbot|Slurp|MSNBot|Ask\ Jeeves\/Teoma|ia_archiver)/;
var REQUIRED_VERSION_PARTS = 3;
var userAgentRules = [
  ["aol", /AOLShield\/([0-9\._]+)/],
  ["edge", /Edge\/([0-9\._]+)/],
  ["edge-ios", /EdgiOS\/([0-9\._]+)/],
  ["yandexbrowser", /YaBrowser\/([0-9\._]+)/],
  ["kakaotalk", /KAKAOTALK\s([0-9\.]+)/],
  ["samsung", /SamsungBrowser\/([0-9\.]+)/],
  ["silk", /\bSilk\/([0-9._-]+)\b/],
  ["miui", /MiuiBrowser\/([0-9\.]+)$/],
  ["beaker", /BeakerBrowser\/([0-9\.]+)/],
  ["edge-chromium", /EdgA?\/([0-9\.]+)/],
  [
    "chromium-webview",
    /(?!Chrom.*OPR)wv\).*Chrom(?:e|ium)\/([0-9\.]+)(:?\s|$)/
  ],
  ["chrome", /(?!Chrom.*OPR)Chrom(?:e|ium)\/([0-9\.]+)(:?\s|$)/],
  ["phantomjs", /PhantomJS\/([0-9\.]+)(:?\s|$)/],
  ["crios", /CriOS\/([0-9\.]+)(:?\s|$)/],
  ["firefox", /Firefox\/([0-9\.]+)(?:\s|$)/],
  ["fxios", /FxiOS\/([0-9\.]+)/],
  ["opera-mini", /Opera Mini.*Version\/([0-9\.]+)/],
  ["opera", /Opera\/([0-9\.]+)(?:\s|$)/],
  ["opera", /OPR\/([0-9\.]+)(:?\s|$)/],
  ["pie", /^Microsoft Pocket Internet Explorer\/(\d+\.\d+)$/],
  ["pie", /^Mozilla\/\d\.\d+\s\(compatible;\s(?:MSP?IE|MSInternet Explorer) (\d+\.\d+);.*Windows CE.*\)$/],
  ["netfront", /^Mozilla\/\d\.\d+.*NetFront\/(\d.\d)/],
  ["ie", /Trident\/7\.0.*rv\:([0-9\.]+).*\).*Gecko$/],
  ["ie", /MSIE\s([0-9\.]+);.*Trident\/[4-7].0/],
  ["ie", /MSIE\s(7\.0)/],
  ["bb10", /BB10;\sTouch.*Version\/([0-9\.]+)/],
  ["android", /Android\s([0-9\.]+)/],
  ["ios", /Version\/([0-9\._]+).*Mobile.*Safari.*/],
  ["safari", /Version\/([0-9\._]+).*Safari/],
  ["facebook", /FB[AS]V\/([0-9\.]+)/],
  ["instagram", /Instagram\s([0-9\.]+)/],
  ["ios-webview", /AppleWebKit\/([0-9\.]+).*Mobile/],
  ["ios-webview", /AppleWebKit\/([0-9\.]+).*Gecko\)$/],
  ["curl", /^curl\/([0-9\.]+)$/],
  ["searchbot", SEARCHBOX_UA_REGEX]
];
var operatingSystemRules = [
  ["iOS", /iP(hone|od|ad)/],
  ["Android OS", /Android/],
  ["BlackBerry OS", /BlackBerry|BB10/],
  ["Windows Mobile", /IEMobile/],
  ["Amazon OS", /Kindle/],
  ["Windows 3.11", /Win16/],
  ["Windows 95", /(Windows 95)|(Win95)|(Windows_95)/],
  ["Windows 98", /(Windows 98)|(Win98)/],
  ["Windows 2000", /(Windows NT 5.0)|(Windows 2000)/],
  ["Windows XP", /(Windows NT 5.1)|(Windows XP)/],
  ["Windows Server 2003", /(Windows NT 5.2)/],
  ["Windows Vista", /(Windows NT 6.0)/],
  ["Windows 7", /(Windows NT 6.1)/],
  ["Windows 8", /(Windows NT 6.2)/],
  ["Windows 8.1", /(Windows NT 6.3)/],
  ["Windows 10", /(Windows NT 10.0)/],
  ["Windows ME", /Windows ME/],
  ["Windows CE", /Windows CE|WinCE|Microsoft Pocket Internet Explorer/],
  ["Open BSD", /OpenBSD/],
  ["Sun OS", /SunOS/],
  ["Chrome OS", /CrOS/],
  ["Linux", /(Linux)|(X11)/],
  ["Mac OS", /(Mac_PowerPC)|(Macintosh)/],
  ["QNX", /QNX/],
  ["BeOS", /BeOS/],
  ["OS/2", /OS\/2/]
];
function detect(userAgent) {
  if (!!userAgent) {
    return parseUserAgent(userAgent);
  }
  if (typeof document === "undefined" && typeof navigator !== "undefined" && navigator.product === "ReactNative") {
    return new ReactNativeInfo();
  }
  if (typeof navigator !== "undefined") {
    return parseUserAgent(navigator.userAgent);
  }
  return getNodeVersion();
}
function matchUserAgent(ua) {
  return ua !== "" && userAgentRules.reduce(function(matched, _a2) {
    var browser = _a2[0], regex = _a2[1];
    if (matched) {
      return matched;
    }
    var uaMatch = regex.exec(ua);
    return !!uaMatch && [browser, uaMatch];
  }, false);
}
function parseUserAgent(ua) {
  var matchedRule = matchUserAgent(ua);
  if (!matchedRule) {
    return null;
  }
  var name = matchedRule[0], match2 = matchedRule[1];
  if (name === "searchbot") {
    return new BotInfo();
  }
  var versionParts = match2[1] && match2[1].split(".").join("_").split("_").slice(0, 3);
  if (versionParts) {
    if (versionParts.length < REQUIRED_VERSION_PARTS) {
      versionParts = __spreadArray$1(__spreadArray$1([], versionParts, true), createVersionParts(REQUIRED_VERSION_PARTS - versionParts.length), true);
    }
  } else {
    versionParts = [];
  }
  var version = versionParts.join(".");
  var os = detectOS(ua);
  var searchBotMatch = SEARCHBOT_OS_REGEX.exec(ua);
  if (searchBotMatch && searchBotMatch[1]) {
    return new SearchBotDeviceInfo(name, version, os, searchBotMatch[1]);
  }
  return new BrowserInfo(name, version, os);
}
function detectOS(ua) {
  for (var ii = 0, count2 = operatingSystemRules.length; ii < count2; ii++) {
    var _a2 = operatingSystemRules[ii], os = _a2[0], regex = _a2[1];
    var match2 = regex.exec(ua);
    if (match2) {
      return os;
    }
  }
  return null;
}
function getNodeVersion() {
  var isNode2 = typeof process !== "undefined" && process.version;
  return isNode2 ? new NodeInfo(process.version.slice(1)) : null;
}
function createVersionParts(count2) {
  var output = [];
  for (var ii = 0; ii < count2; ii++) {
    output.push("0");
  }
  return output;
}
const SPINNER_DEFAULT_SIZE = "large";
const SPINNER_SIZE_MAP = {
  small: {
    height: "16px",
    width: "16px"
  },
  medium: {
    height: "32px",
    width: "32px"
  },
  large: {
    height: "56px",
    width: "56px"
  }
};
const isSpinnerSize = (value) => value === "small" || value === "medium" || value === "large";
const DEFAULT_TRACK_COLOR = `var(${TOKENS.color.background.interaction.neutralUnactivated}, #e4e7ec)`;
const DEFAULT_SPINNER_COLOR = `var(${TOKENS.color.foreground.interaction.accent}, #5e65fb)`;
const DEFAULT_SPIN_SPEED = "1s";
const rotate = (spinDirection = "clockwise") => keyframes$1`
// 0% and 100% required for safari
0% {
  transform: none;
}
100% {
  transform: rotate(${spinDirection === "counterClockwise" ? "-360deg" : "360deg"});
}
`;
const AnimatedClipPath = styled.clipPath`
  transform-origin: center;
  ${(props) => props.isRotating && css$3`
      animation: ${rotate(props.spinDirection)} ${props.spinSpeed || "1s"}
        linear infinite;
    `}
`;
const StyledSVG = styled.svg`
  overflow: visible;
  ${(props) => props.isRotating && css$3`
      animation: ${rotate(props.spinDirection)} ${props.spinSpeed || "1s"}
        linear infinite;
    `}
`;
function getGradientById(id2) {
  switch (id2) {
    case "purple_g2_gradient":
      return /* @__PURE__ */ jsxRuntimeExports.jsxs("linearGradient", { id: "purple_g2_gradient", x1: "0", x2: "28.745", y1: "0", y2: "9.673", gradientUnits: "userSpaceOnUse", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { offset: "0.016", stopColor: "#0B3741" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { offset: "0.546", stopColor: "#936293" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { offset: "1", stopColor: "#E48580" })
      ] });
    case "purple_g1_gradient":
      return /* @__PURE__ */ jsxRuntimeExports.jsxs("linearGradient", { id: "purple_g1_gradient", gradientUnits: "userSpaceOnUse", x1: "9.038", y1: "11.307", x2: "71.3304", y2: "69.0344", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { offset: "0", style: {
          stopColor: "#0B3741"
        } }, v4()),
        /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { offset: "0.6128", style: {
          stopColor: "#936293"
        } }, v4()),
        /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { offset: "1", style: {
          stopColor: "#E48580"
        } }, v4())
      ] });
    default:
      return null;
  }
}
const Spinner = forwardRef(({
  size: size2,
  ...rest
}, ref2) => {
  const resolvedSize = isSpinnerSize(size2) ? size2 : SPINNER_DEFAULT_SIZE;
  const defaultProps2 = {
    trackColor: DEFAULT_TRACK_COLOR,
    spinnerColor: DEFAULT_SPINNER_COLOR,
    spinSpeed: DEFAULT_SPIN_SPEED,
    ...SPINNER_SIZE_MAP[resolvedSize]
  };
  const browser = detect();
  const isSafariOrUnknown = !browser || (browser == null ? void 0 : browser.name) === "safari";
  const clipPathID = useMemo(() => v4(), []);
  const {
    height: height2,
    width: width2,
    trackColor,
    spinSpeed,
    spinnerColor,
    spinnerSVGGradient,
    spinDirection = "clockwise"
  } = {
    ...defaultProps2,
    ...rest
  };
  const gradient = getGradientById(spinnerSVGGradient == null ? void 0 : spinnerSVGGradient.id);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledSVG, { className: "loadermain", version: "1.1", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 64 64", ref: ref2, width: width2, height: height2, clipPathUnits: "objectBoundingBox", role: "img", "aria-label": "Loading Spinner Icon", isRotating: isSafariOrUnknown, spinDirection, spinSpeed, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("circle", { id: "bgcircle", cx: "32", cy: "32", r: "29", strokeWidth: "6px", stroke: trackColor, fill: "none" }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("defs", { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("path", { id: "arcpath", d: "M68,43c-1.7,0-3-1.3-3-3c0-13.8-11.2-25-25-25c-1.7,0-3-1.3-3-3s1.3-3,3-3c17.1,0,31,13.9,31,31\n	C71,41.7,69.7,43,68,43z", transform: "translate(-7 -9)" }),
      gradient
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(AnimatedClipPath, { id: clipPathID, spinSpeed, spinDirection, isRotating: !isSafariOrUnknown, children: /* @__PURE__ */ jsxRuntimeExports.jsx("use", { xlinkHref: "#arcpath" }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("rect", { id: "gradientRectangle", x: "-1", y: "-1", width: "66", height: "66", fill: spinnerSVGGradient !== void 0 ? `url(#${spinnerSVGGradient == null ? void 0 : spinnerSVGGradient.id}` : spinnerColor, clipPath: `url(#${clipPathID})` })
  ] });
});
Spinner.displayName = "Spinner";
const v$f = (token2) => `var(${token2})`;
const BASE_FOCUS_RING$1 = {
  gap: "1px",
  width: "2px",
  borderRadius: "4px",
  color: v$f(TOKENS.color.border.focus)
};
const DANGER_FOCUS_RING = {
  ...BASE_FOCUS_RING$1,
  color: v$f(TOKENS.color.border.focusDanger)
};
const BUTTON_BASE_STYLE = {
  fontFamily: v$f(TOKENS.text.fontFamily.primary),
  fontWeight: v$f(TOKENS.text.fontWeight.header),
  fontSize: "1rem",
  lineHeight: "140%",
  borderRadius: v$f(TOKENS.dimension.radius.interaction.action),
  borderWidth: "2px",
  borderStyle: "solid",
  transition: "background 150ms ease-in-out"
};
const BUTTON_SIZE_STYLE = {
  large: {
    padding: "10px 32px",
    iconSpacing: "8px"
  },
  medium: {
    padding: "7px 16px",
    iconSpacing: "8px",
    fontSize: "0.875rem"
  },
  small: {
    padding: "3px 12px",
    iconSpacing: "4px",
    fontSize: "0.875rem"
  }
};
const BUTTON_VARIANT_STYLE = {
  primary: {
    borderColor: "transparent",
    color: v$f(TOKENS.color.foreground.interaction.onAccent),
    fill: v$f(TOKENS.color.foreground.interaction.onAccent),
    backgroundColor: v$f(TOKENS.color.background.interaction.accent),
    hoverStyle: {
      backgroundColor: v$f(TOKENS.color.background.interaction.accentHover)
    },
    activeStyle: {
      backgroundColor: v$f(TOKENS.color.background.interaction.accentActive)
    },
    disabledStyle: {
      backgroundColor: v$f(TOKENS.color.background.interaction.disabled),
      color: v$f(TOKENS.color.foreground.interaction.onDisabled),
      fill: v$f(TOKENS.color.foreground.interaction.onDisabled),
      boxShadow: "none"
    },
    focusRingStyle: BASE_FOCUS_RING$1
  },
  outline: {
    borderColor: v$f(TOKENS.color.border.interaction.accent),
    color: v$f(TOKENS.color.foreground.interaction.onAccentSubdued),
    fill: v$f(TOKENS.color.foreground.interaction.onAccentSubdued),
    backgroundColor: v$f(TOKENS.color.background.interaction.accentSubdued),
    hoverStyle: {
      borderColor: v$f(TOKENS.color.background.interaction.accentSubduedHover),
      backgroundColor: v$f(TOKENS.color.background.interaction.accentSubduedHover)
    },
    activeStyle: {
      backgroundColor: v$f(TOKENS.color.background.interaction.accentSubduedActive)
    },
    disabledStyle: {
      borderColor: v$f(TOKENS.color.border.interaction.accentDisabled),
      color: v$f(TOKENS.color.foreground.interaction.disabled),
      fill: v$f(TOKENS.color.foreground.interaction.disabled),
      backgroundColor: v$f(TOKENS.color.background.interaction.transparent)
    },
    focusRingStyle: BASE_FOCUS_RING$1
  },
  destructivePrimary: {
    borderColor: "transparent",
    color: v$f(TOKENS.color.foreground.interaction.onDanger),
    fill: v$f(TOKENS.color.foreground.interaction.onDanger),
    backgroundColor: v$f(TOKENS.color.background.interaction.danger),
    hoverStyle: {
      backgroundColor: v$f(TOKENS.color.background.interaction.dangerHover)
    },
    activeStyle: {
      backgroundColor: v$f(TOKENS.color.background.interaction.dangerActive)
    },
    disabledStyle: {
      backgroundColor: v$f(TOKENS.color.background.interaction.disabled),
      borderColor: v$f(TOKENS.color.background.interaction.disabled),
      color: v$f(TOKENS.color.foreground.interaction.onDisabled),
      fill: v$f(TOKENS.color.foreground.interaction.onDisabled),
      boxShadow: "none"
    },
    focusRingStyle: BASE_FOCUS_RING$1
  },
  destructiveSecondary: {
    borderColor: v$f(TOKENS.color.border.interaction.danger),
    color: v$f(TOKENS.color.foreground.feedback.danger),
    fill: v$f(TOKENS.color.foreground.feedback.danger),
    backgroundColor: v$f(TOKENS.color.background.interaction.transparent),
    hoverStyle: {
      backgroundColor: v$f(TOKENS.color.background.interaction.dangerSubduedHover)
    },
    activeStyle: {
      backgroundColor: v$f(TOKENS.color.background.interaction.dangerSubduedActive)
    },
    disabledStyle: {
      color: v$f(TOKENS.color.foreground.interaction.disabled),
      borderColor: v$f(TOKENS.color.border.interaction.accentDisabled),
      fill: v$f(TOKENS.color.foreground.interaction.disabled),
      backgroundColor: v$f(TOKENS.color.background.interaction.transparent)
    },
    focusRingStyle: DANGER_FOCUS_RING
  },
  ghost: {
    borderColor: "transparent",
    color: v$f(TOKENS.color.foreground.interaction.accent),
    fill: v$f(TOKENS.color.foreground.interaction.accent),
    backgroundColor: v$f(TOKENS.color.background.interaction.transparent),
    hoverStyle: {
      backgroundColor: v$f(TOKENS.color.background.interaction.accentSubduedHover)
    },
    activeStyle: {
      backgroundColor: v$f(TOKENS.color.background.interaction.accentSubduedActive)
    },
    disabledStyle: {
      backgroundColor: v$f(TOKENS.color.background.interaction.transparent),
      color: v$f(TOKENS.color.foreground.interaction.disabled),
      fill: v$f(TOKENS.color.foreground.interaction.disabled),
      boxShadow: "none"
    },
    focusRingStyle: BASE_FOCUS_RING$1
  },
  destructiveGhost: {
    borderColor: "transparent",
    color: v$f(TOKENS.color.foreground.feedback.danger),
    fill: v$f(TOKENS.color.foreground.feedback.danger),
    backgroundColor: v$f(TOKENS.color.background.interaction.transparent),
    hoverStyle: {
      backgroundColor: v$f(TOKENS.color.background.interaction.dangerSubduedHover)
    },
    activeStyle: {
      backgroundColor: v$f(TOKENS.color.background.interaction.dangerSubduedActive)
    },
    disabledStyle: {
      backgroundColor: v$f(TOKENS.color.background.interaction.transparent),
      borderColor: v$f(TOKENS.color.background.interaction.transparent),
      color: v$f(TOKENS.color.foreground.interaction.disabled),
      fill: v$f(TOKENS.color.foreground.interaction.disabled),
      boxShadow: "none"
    },
    focusRingStyle: DANGER_FOCUS_RING
  }
};
const getButtonThemeProps = (variant, size2 = "large") => ({
  ...BUTTON_BASE_STYLE,
  ...BUTTON_SIZE_STYLE[size2],
  ...BUTTON_VARIANT_STYLE[variant]
});
const UnstyledButton = styled.button`
  border: none;
  position: relative;
  background: none;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  ${compose(layout, space, flexbox, position$1)}

  /* Focus ring */
  ${(props) => {
  var _a2;
  return FocusRing({
    gap: "3px",
    width: "2px",
    borderRadius: "4px",
    color: (_a2 = props.focusRingStyle) == null ? void 0 : _a2.color
  });
}}
`;
const StyledButton = styled.button`
  background: none;
  cursor: pointer;
  box-sizing: border-box;
  position: relative;
  border: none;
  display: inline-flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  gap: ${(props) => props.iconSpacing || "8px"}; /* defaulted to 4px icon spacing */
  /* Add a default border style so that borders can be added just by specifying a width. Just a little nice-to-have. Can always be overwritten */
  ${(props) => props.borderWidth && !props.borderStyle && "border-style: solid;"}

  &:disabled,
  &.disabled {
    cursor: not-allowed;
    background-color: none;
  }

  /* Styled System Props */
  ${(props) => composeWrapper([color, layout, flexbox, space, typography, border, position$1, shadow, svg, outline, transition], [...props.disabled ? [] : [Pseudostate.hover, Pseudostate.active], Pseudostate["focus-visible"], Pseudostate.disabled])}

  /* Focus ring */
  ${(props) => FocusRing({
  ...props.focusRingStyle,
  elementBorderProps: {
    borderRadius: props.borderRadius,
    borderWidth: props.borderWidth
  }
})}
`;
const StyledButtonLink = styled.a`
  background: none;
  cursor: pointer;
  box-sizing: border-box;
  position: relative;
  border: none;
  display: inline-flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  gap: ${(props) => props.iconSpacing || "8px"}; /* defaulted to 4px icon spacing */
  /* Add a default border style so that borders can be added just by specifying a width. Just a little nice-to-have. Can always be overwritten */
  ${(props) => props.borderWidth && !props.borderStyle && "border-style: solid;"}
  &:disabled,
  &.disabled {
    cursor: not-allowed;
  }

  /* Styled System Props */
  ${(props) => composeWrapper([color, layout, flexbox, space, typography, border, position$1, shadow, svg, outline, transition], [...props.disabled ? [] : [Pseudostate.hover, Pseudostate.active], Pseudostate["focus-visible"], Pseudostate.disabled])}
  /* Focus ring */
  ${(props) => FocusRing({
  ...props.focusRingStyle,
  elementBorderProps: {
    borderRadius: props.borderRadius,
    borderWidth: props.borderWidth
  }
})}
`;
const INFINITE_LOADING_TIMEOUT = -1;
const ButtonComponent = ({
  variant = "primary",
  type: type2 = "button",
  unstyled,
  size: size2,
  children,
  iconLeft,
  iconRight,
  loading = false,
  loadingText = "Saving",
  longLoadingText = "Still working",
  longLoadingTimeout = 1e4,
  spinnerProps = {},
  disabled,
  ...rest
  // Default HTML button props & styled system props
}, ref2) => {
  const themeProps = getButtonThemeProps(variant, size2);
  const [showLongLoading, setShowLongLoading] = useState(false);
  const loadingId = useId$2();
  useEffect(() => {
    if (loading && longLoadingTimeout !== INFINITE_LOADING_TIMEOUT) {
      const timer = setTimeout(() => setShowLongLoading(true), longLoadingTimeout);
      return () => clearTimeout(timer);
    }
    setShowLongLoading(false);
    return void 0;
  }, [loading, longLoadingTimeout]);
  const hasTextContent = Children.toArray(children).some((child) => typeof child === "string");
  const isIconOnly = !hasTextContent && isValidElement(children) && typeof children.type !== "string";
  const baseColor = "currentColor";
  const spinnerColor = baseColor;
  const trackColor = `rgba(from ${baseColor} r g b / 0.3)`;
  if (unstyled) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(UnstyledButton, { ...themeProps, ...rest, type: type2, ref: ref2, disabled: disabled || loading, children });
  }
  if (loading) {
    const spinnerCommonProps = {
      width: 16,
      height: 16,
      spinnerColor,
      trackColor,
      spinnerSVGGradient: void 0,
      ...spinnerProps
    };
    if (isIconOnly) {
      return /* @__PURE__ */ jsxRuntimeExports.jsx(StyledButton, { ...themeProps, type: type2, ...rest, ref: ref2, disabled: true, "aria-busy": "true", "aria-label": showLongLoading ? longLoadingText : loadingText, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Spinner, { ...spinnerCommonProps }) });
    }
    const spinnerOnRight = !iconLeft && iconRight;
    const SpinnerComponent = /* @__PURE__ */ jsxRuntimeExports.jsx("div", { style: {
      display: "inline-flex"
    }, "aria-hidden": true, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Spinner, { ...spinnerCommonProps }) });
    return /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledButton, { ...themeProps, type: type2, ...rest, ref: ref2, disabled: true, "aria-busy": "true", "aria-describedby": loadingId, children: [
      !spinnerOnRight && SpinnerComponent,
      /* @__PURE__ */ jsxRuntimeExports.jsx("span", { id: loadingId, style: {
        display: "flex",
        whiteSpace: "nowrap"
      }, children: showLongLoading ? longLoadingText : loadingText }),
      spinnerOnRight && SpinnerComponent
    ] });
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledButton, { ...themeProps, type: type2, ...rest, ref: ref2, disabled, children: [
    iconLeft && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { style: {
      display: "inline-flex"
    }, "aria-hidden": true, children: iconLeft }),
    children && /* @__PURE__ */ jsxRuntimeExports.jsx("span", { style: {
      display: "flex"
    }, children }),
    iconRight && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { style: {
      display: "inline-flex"
    }, "aria-hidden": true, children: iconRight })
  ] });
};
const Button = forwardRef(ButtonComponent);
Button.displayName = "Button";
const ButtonLinkComponent = ({
  variant = "primary",
  size: size2,
  children,
  iconLeft,
  iconRight,
  className,
  disabled,
  ...rest
  // Default HTML anchor props & styled system props
}, ref2) => {
  const themeProps = getButtonThemeProps(variant, size2);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledButtonLink, { ...themeProps, ...rest, ref: ref2, variant, className: `${className} ${disabled ? "disabled" : ""}`, children: [
    iconLeft && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { style: {
      display: "inline-flex"
    }, "aria-hidden": true, children: iconLeft }),
    children && /* @__PURE__ */ jsxRuntimeExports.jsx("span", { style: {
      display: "flex"
    }, children }),
    iconRight && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { style: {
      display: "inline-flex"
    }, "aria-hidden": true, children: iconRight })
  ] });
};
const ButtonLink = forwardRef(ButtonLinkComponent);
ButtonLink.displayName = "ButtonLink";
const IconSizes = {
  large: {
    padding: "12px",
    height: "max-content",
    width: "max-content"
  },
  medium: {
    padding: "8px",
    height: "max-content",
    width: "max-content"
  },
  small: {
    padding: "4px",
    height: "max-content",
    width: "max-content"
  }
};
const IconButton = forwardRef((props, ref2) => {
  const sizeProps = IconSizes[props.size] || IconSizes.large;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Button, { ref: ref2, ...sizeProps, ...props });
});
IconButton.displayName = "IconButton";
var MAX_SAFE_INTEGER$2 = 9007199254740991;
var argsTag$3 = "[object Arguments]", funcTag$2 = "[object Function]", genTag$1 = "[object GeneratorFunction]", symbolTag$2 = "[object Symbol]";
var freeGlobal$2 = typeof commonjsGlobal == "object" && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;
var freeSelf$1 = typeof self == "object" && self && self.Object === Object && self;
var root$9 = freeGlobal$2 || freeSelf$1 || Function("return this")();
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0:
      return func.call(thisArg);
    case 1:
      return func.call(thisArg, args[0]);
    case 2:
      return func.call(thisArg, args[0], args[1]);
    case 3:
      return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}
function arrayMap$2(array, iteratee) {
  var index2 = -1, length2 = array ? array.length : 0, result = Array(length2);
  while (++index2 < length2) {
    result[index2] = iteratee(array[index2], index2, array);
  }
  return result;
}
function arrayPush$2(array, values3) {
  var index2 = -1, length2 = values3.length, offset2 = array.length;
  while (++index2 < length2) {
    array[offset2 + index2] = values3[index2];
  }
  return array;
}
var objectProto$c = Object.prototype;
var hasOwnProperty$9 = objectProto$c.hasOwnProperty;
var objectToString$2 = objectProto$c.toString;
var Symbol$7 = root$9.Symbol, propertyIsEnumerable$2 = objectProto$c.propertyIsEnumerable, spreadableSymbol = Symbol$7 ? Symbol$7.isConcatSpreadable : void 0;
var nativeMax = Math.max;
function baseFlatten(array, depth, predicate2, isStrict, result) {
  var index2 = -1, length2 = array.length;
  predicate2 || (predicate2 = isFlattenable);
  result || (result = []);
  while (++index2 < length2) {
    var value = array[index2];
    if (predicate2(value)) {
      {
        arrayPush$2(result, value);
      }
    } else {
      result[result.length] = value;
    }
  }
  return result;
}
function basePick(object2, props) {
  object2 = Object(object2);
  return basePickBy(object2, props, function(value, key) {
    return key in object2;
  });
}
function basePickBy(object2, props, predicate2) {
  var index2 = -1, length2 = props.length, result = {};
  while (++index2 < length2) {
    var key = props[index2], value = object2[key];
    if (predicate2(value, key)) {
      result[key] = value;
    }
  }
  return result;
}
function baseRest(func, start2) {
  start2 = nativeMax(start2 === void 0 ? func.length - 1 : start2, 0);
  return function() {
    var args = arguments, index2 = -1, length2 = nativeMax(args.length - start2, 0), array = Array(length2);
    while (++index2 < length2) {
      array[index2] = args[start2 + index2];
    }
    index2 = -1;
    var otherArgs = Array(start2 + 1);
    while (++index2 < start2) {
      otherArgs[index2] = args[index2];
    }
    otherArgs[start2] = array;
    return apply(func, this, otherArgs);
  };
}
function isFlattenable(value) {
  return isArray$a(value) || isArguments$4(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
}
function toKey$5(value) {
  if (typeof value == "string" || isSymbol$5(value)) {
    return value;
  }
  var result = value + "";
  return result == "0" && 1 / value == -Infinity ? "-0" : result;
}
function isArguments$4(value) {
  return isArrayLikeObject(value) && hasOwnProperty$9.call(value, "callee") && (!propertyIsEnumerable$2.call(value, "callee") || objectToString$2.call(value) == argsTag$3);
}
var isArray$a = Array.isArray;
function isArrayLike$2(value) {
  return value != null && isLength$4(value.length) && !isFunction$6(value);
}
function isArrayLikeObject(value) {
  return isObjectLike$7(value) && isArrayLike$2(value);
}
function isFunction$6(value) {
  var tag = isObject$6(value) ? objectToString$2.call(value) : "";
  return tag == funcTag$2 || tag == genTag$1;
}
function isLength$4(value) {
  return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER$2;
}
function isObject$6(value) {
  var type2 = typeof value;
  return !!value && (type2 == "object" || type2 == "function");
}
function isObjectLike$7(value) {
  return !!value && typeof value == "object";
}
function isSymbol$5(value) {
  return typeof value == "symbol" || isObjectLike$7(value) && objectToString$2.call(value) == symbolTag$2;
}
var pick = baseRest(function(object2, props) {
  return object2 == null ? {} : basePick(object2, arrayMap$2(baseFlatten(props), toKey$5));
});
var lodash_pick = pick;
var pick$1 = /* @__PURE__ */ getDefaultExportFromCjs(lodash_pick);
const SPACE_PROPS = ["m", "margin", "mt", "marginTop", "mr", "marginRight", "mb", "marginBottom", "ml", "marginLeft", "mx", "my", "p", "padding", "pt", "paddingTop", "pr", "paddingRight", "pb", "paddingBottom", "pl", "paddingLeft", "px", "py"];
const COLOR_PROPS = ["color", "bg", "backgroundColor", "opacity"];
const TYPOGRAPHY_PROPS = ["fontFamily", "fontSize", "fontStyle", "fontWeight", "lineHeight", "letterSpacing", "textAlign"];
const LAYOUT_PROPS = ["width", "height", "minHeight", "minWidth", "maxWidth", "maxHeight", "size", "display", "verticalAlign", "overflow", "overflowX", "overflowY"];
const FLEXBOX_PROPS = ["alignContent", "alignItems", "alignSelf", "justifyContent", "justifyItems", "justifySelf", "flex", "flexBasis", "flexDirection", "flexGrow", "flexShrink", "flexWrap", "order"];
const GRID_PROPS = ["gridArea", "gridGap", "gridAutoColumns", "gridAutoFlow", "gridAutoRows", "gridColumn", "gridColumnGap", "gridRow", "gridRowGap", "gridTemplateAreas", "gridTemplateColumns", "gridTemplateRows"];
const BACKGROUND_PROPS = ["background", "backgroundImage", "backgroundPosition", "backgroundRepeat", "backgroundSize"];
const BORDER_PROPS = ["borderWidth", "borderBottomWidth", "borderRightWidth", "borderLeftWidth", "borderTopWidth", "borderRadius", "borderTopLeftRadius", "borderBottomLeftRadius", "borderBottomRightRadius", "borderTopRightRadius", "border", "borderBottom", "borderColor", "borderLeft", "borderX", "borderY", "borderTop", "borderRight", "borderBottomColor", "borderBottomStyle", "borderStyle", "borderLeftColor", "borderLeftStyle", "borderRightColor", "borderRightStyle", "borderTopColor", "borderTopStyle"];
const OUTLINE_PROPS = ["outlineWidth", "outlineColor", "outlineStyle", "outlineOffset", "outline"];
const POSITION_PROPS = ["position", "zIndex", "top", "bottom", "left", "right"];
const SHADOW_PROPS = ["textShadow", "boxShadow"];
const PROP_KEY_MAPPINGS = {
  space: SPACE_PROPS,
  color: COLOR_PROPS,
  typography: TYPOGRAPHY_PROPS,
  layout: LAYOUT_PROPS,
  flexbox: FLEXBOX_PROPS,
  grid: GRID_PROPS,
  background: BACKGROUND_PROPS,
  border: BORDER_PROPS,
  position: POSITION_PROPS,
  shadow: SHADOW_PROPS,
  outline: OUTLINE_PROPS
};
const ALL_STYLED_SYSTEM_PROPS = [...SPACE_PROPS, ...COLOR_PROPS, ...TYPOGRAPHY_PROPS, ...LAYOUT_PROPS, ...FLEXBOX_PROPS, ...GRID_PROPS, ...BACKGROUND_PROPS, ...BORDER_PROPS, ...POSITION_PROPS, ...SHADOW_PROPS];
const selectStyledSystemProps = (props, selectionList, includeStates) => {
  const selectedPropsList = selectionList.reduce((final, selection) => [...final, ...PROP_KEY_MAPPINGS[selection]], []);
  return {
    ...pick$1(props, selectedPropsList),
    ...includeStates && pick$1(props, pseudostatePropsArray)
  };
};
const LINK_VARIANT_TYPE = ["default", "onColor", "destructive", "auto"];
const LINK_SIZE_TYPE = ["xsmall", "small", "medium", "large"];
const v$e = (token2) => `var(${token2})`;
const BASE_FOCUS_RING = {
  gap: "1px",
  width: "2px",
  borderRadius: "4px",
  color: v$e(TOKENS.color.border.focus)
};
const LINK_BASE_STYLE = {
  fontFamily: v$e(TOKENS.text.fontFamily.primary),
  fontWeight: "500",
  letterSpacing: "0em",
  lineHeight: "140%",
  focusRingStyle: BASE_FOCUS_RING
};
const LINK_SIZE_STYLE = {
  large: {
    fontSize: "1rem"
  },
  medium: {
    fontSize: "0.875rem"
  },
  small: {
    fontSize: "0.875rem"
  },
  xsmall: {
    fontSize: "0.75rem"
  }
};
const LINK_VARIANT_STYLE = {
  default: {
    color: v$e(TOKENS.color.foreground.interaction.accent),
    fill: v$e(TOKENS.color.foreground.interaction.accent),
    hoverStyle: {
      color: v$e(TOKENS.color.foreground.interaction.accentHover),
      fill: v$e(TOKENS.color.foreground.interaction.accentHover)
    },
    activeStyle: {
      color: v$e(TOKENS.color.foreground.interaction.accentActive),
      fill: v$e(TOKENS.color.foreground.interaction.accentActive)
    },
    disabledStyle: {
      color: v$e(TOKENS.color.foreground.interaction.disabled),
      fill: v$e(TOKENS.color.foreground.interaction.disabled)
    }
  },
  onColor: {
    color: v$e(TOKENS.color.foreground.interaction.onReverse),
    fill: v$e(TOKENS.color.foreground.interaction.onReverse),
    hoverStyle: {
      color: v$e(TOKENS.color.foreground.interaction.onReverseHover),
      fill: v$e(TOKENS.color.foreground.interaction.onReverseHover)
    },
    activeStyle: {
      color: v$e(TOKENS.color.foreground.interaction.onReverseActive),
      fill: v$e(TOKENS.color.foreground.interaction.onReverseActive)
    },
    disabledStyle: {
      color: v$e(TOKENS.color.foreground.interaction.disabled),
      fill: v$e(TOKENS.color.foreground.interaction.disabled)
    }
  },
  destructive: {
    color: v$e(TOKENS.color.foreground.feedback.danger),
    fill: v$e(TOKENS.color.foreground.feedback.danger),
    hoverStyle: {
      color: v$e(TOKENS.color.foreground.interaction.dangerHover),
      fill: v$e(TOKENS.color.foreground.interaction.dangerHover)
    },
    activeStyle: {
      color: v$e(TOKENS.color.foreground.interaction.dangerActive),
      fill: v$e(TOKENS.color.foreground.interaction.dangerActive)
    },
    disabledStyle: {
      color: v$e(TOKENS.color.foreground.interaction.disabled),
      fill: v$e(TOKENS.color.foreground.interaction.disabled)
    }
  },
  auto: {
    color: v$e(TOKENS.color.foreground.interaction.accent),
    fill: v$e(TOKENS.color.foreground.interaction.accent),
    hoverStyle: {
      color: v$e(TOKENS.color.foreground.interaction.accentHover)
    },
    activeStyle: {
      color: v$e(TOKENS.color.foreground.interaction.accentActive)
    }
  }
};
const getLinkThemeProps = (variant = "default", size2 = "large") => ({
  ...LINK_BASE_STYLE,
  ...LINK_SIZE_STYLE[size2],
  ...LINK_VARIANT_STYLE[variant]
});
const InlineStyles = css$3`
  font-size: inherit;
  padding: 0;
  margin: 0;
  line-height: inherit;
  font-weight: inherit;
  letter-spacing: inherit;
  font-family: inherit;
`;
const LinkStyles = css$3`
  cursor: pointer;
  position: relative;
  /* Underline */
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  ${(props) => props.underlined && "text-decoration: underline;"}

  ${(props) => FocusRing({
  ...props.focusRingStyle,
  elementBorderProps: selectStyledSystemProps(props, ["border"])
})}
  ${(props) => composeWrapper([space, color, typography, background, border, position$1, shadow, svg], props.allowVisitedState ? [Pseudostate.visited, Pseudostate.hover, Pseudostate.active, Pseudostate.disabled] : [Pseudostate.hover, Pseudostate.active, Pseudostate.disabled])}
  ${(props) => props.inline && InlineStyles}
`;
const customDOMProps = [
  ...ALL_STYLED_SYSTEM_PROPS,
  "focusRingStyle",
  "allowVisitedState",
  "variant",
  "underlined",
  // Styled States
  "hoverStyle",
  "focusStyle",
  "activeStyle",
  "disabledStyle",
  "visitedStyle"
];
const StyledAnchorLink = styled.a.withConfig({
  shouldForwardProp: (prop, target) => {
    if (customDOMProps.includes(prop)) {
      return false;
    }
    return kindredShouldForwardProp(prop, target);
  }
})`
  ${LinkStyles}
`;
const StyledLinkButton$3 = styled.button.withConfig({
  shouldForwardProp: (prop, target) => {
    if (customDOMProps.includes(prop)) {
      return false;
    }
    return kindredShouldForwardProp(prop, target);
  }
})`
  outline: none;
  border: none;
  background: none;
  font: inherit;
  padding: 0;
  margin: 0;
  ${LinkStyles}
`;
const AnchorLink = ({
  variant,
  size: size2,
  underlined: underlinedProp,
  inline,
  ...rest
}, ref2) => {
  const themeProps = getLinkThemeProps(variant, size2);
  const underlined = underlinedProp === void 0 && inline ? true : underlinedProp;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(StyledAnchorLink, { ...themeProps, ...rest, variant, ref: ref2, underlined, "data-isunderlined": underlined, inline: inline ? "true" : void 0 });
};
const Link = forwardRef(AnchorLink);
Link.displayName = "Link";
const LinkButtonComponent = ({
  variant,
  underlined: underlinedProp,
  inline,
  size: size2,
  ...rest
}, ref2) => {
  const themeProps = getLinkThemeProps(variant, size2);
  const underlined = underlinedProp === void 0 && inline ? true : underlinedProp;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(StyledLinkButton$3, { ...themeProps, ...rest, ref: ref2, variant, underlined, "data-isunderlined": underlined, inline: inline ? "true" : void 0 });
};
const LinkButton = forwardRef(LinkButtonComponent);
LinkButton.displayName = "LinkButton";
const BANNER_VARIANTS = ["informational", "informationalWeak", "success", "successWeak", "warning", "warningWeak", "error", "errorWeak", "warningTA", "neutralSubduedWeak"];
const BANNER_VARIANT_STYLES = {
  informationalWeak: {
    bg: TOKENS.color.background.feedback.info,
    color: TOKENS.color.foreground.interaction.onFeedback,
    fill: TOKENS.color.foreground.interaction.onFeedback
  },
  informational: {
    bg: TOKENS.color.background.feedback.infoStrong,
    color: TOKENS.color.foreground.interaction.onReverse,
    fill: TOKENS.color.foreground.interaction.onReverse
  },
  successWeak: {
    bg: TOKENS.color.background.feedback.success,
    color: TOKENS.color.foreground.interaction.onFeedback,
    fill: TOKENS.color.foreground.interaction.onFeedback
  },
  success: {
    bg: TOKENS.color.background.feedback.successStrong,
    color: TOKENS.color.foreground.interaction.onReverse,
    fill: TOKENS.color.foreground.interaction.onReverse
  },
  warningWeak: {
    bg: TOKENS.color.background.feedback.warning,
    color: TOKENS.color.foreground.interaction.onFeedback,
    fill: TOKENS.color.foreground.interaction.onFeedback
  },
  warning: {
    bg: TOKENS.color.background.feedback.warningStrong,
    color: TOKENS.color.foreground.interaction.onFeedback,
    fill: TOKENS.color.foreground.interaction.onFeedback
  },
  errorWeak: {
    bg: TOKENS.color.background.feedback.danger,
    color: TOKENS.color.foreground.interaction.onFeedback,
    fill: TOKENS.color.foreground.interaction.onFeedback
  },
  error: {
    bg: TOKENS.color.background.feedback.dangerStrong,
    color: TOKENS.color.foreground.interaction.onReverse,
    fill: TOKENS.color.foreground.interaction.onReverse
  },
  warningTA: {},
  neutralSubduedWeak: {
    bg: TOKENS.color.background.surface2,
    color: TOKENS.color.foreground.interaction.onFeedback,
    fill: TOKENS.color.foreground.interaction.onFeedback
  }
};
const DEFAULT_BANNER_VARIANT = "informationalWeak";
const bannerStyledFns = [space, color, shadow, typography, layout, flexbox, grid, background, border, position$1, svg];
const StyledBanner = styled.div`
  text-align: left;
  display: flex;
  gap: ${({
  compact
}) => compact ? "0.75rem" : "1rem"};
  align-items: flex-start;
  flex-direction: row;
  /* padding and line-height have no --kindred-* token counterpart; these are the
     carrier-invariant literals from the legacy banner theme (py: 12px), inlined
     per the token-migration convention. line-height is the one flagged exception:
     140% held for 5 of 7 legacy themes (Transamerica/Lantern were 160%). */
  padding-top: 12px;
  padding-bottom: 12px;
  font-family: var(${TOKENS.text.fontFamily.primary});
  font-weight: var(${TOKENS.text.fontWeight.default});
  font-size: ${fontSizeRem("16")};
  line-height: 140%;
  ${({
  $variant
}) => {
  const {
    bg,
    color: fgColor,
    fill
  } = BANNER_VARIANT_STYLES[$variant];
  return css$3`
      ${bg ? `background-color: var(${bg});` : ""}
      ${fgColor ? `color: var(${fgColor});` : ""}
      /* Scope fill to descendant svgs so it wins over each icon's own fill
         presentation attribute (a CSS rule outranks a presentation attribute),
         keeping the variant icon color matched to the text — mirroring the
         legacy inherited-fill behavior before icons carried their own fill. */
      ${fill ? `svg { fill: var(${fill}); }` : ""}
    `;
}}
  ${composeWrapper(bannerStyledFns)};
  padding-left: ${({
  compact
}) => compact ? "0.75rem" : "1.5rem"};
  padding-right: ${({
  compact
}) => compact ? "0.75rem" : "1.5rem"};
  border-radius: ${({
  rounded
}) => rounded ? `var(${TOKENS.dimension.radius.surface1})` : "0"};
`;
const BannerContentContainer = styled.div`
  display: flex;
  width: 100%;
  padding-top: 2px;
  flex-direction: ${({
  wrapContent
}) => wrapContent ? "column" : "row"};
  align-items: ${({
  wrapContent
}) => wrapContent ? "flex-start" : "center"};
  justify-content: space-between;
  line-height: 1.8;
  ${composeWrapper([flexbox])};

  ${({
  compact
}) => (
  // TODO: this partially addresses the fact that we do not really constrain font-sizes, more info in [FEP2-2883]
  compact && `
    font-size: ${fontSizeRem("14")};
    p {
      margin: 0;
    }
  `
)}

  @media (max-width: 440px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;

    & * {
      text-align: left;
    }
  }
`;
const ContentAndLinkContainer = styled.div`
  display: flex;
  flex-direction: ${({
  buttonWrap
}) => buttonWrap ? "column" : "row"};
  gap: 0.5rem;
  justify-content: space-between;
  width: 100%;
`;
const BannerLinkButton = styled(LinkButton)`
  border: none;
  padding: 0;
  text-decoration: underline;
  white-space: nowrap;
  padding-top: 2px;
`;
const IconContainer$3 = styled.div`
  width: ${({
  compact
}) => compact ? "1.25rem" : "auto"};
  display: flex;
  align-items: center;
  justify-content: center;
`;
const CloseButton = styled(IconButton)`
  border: none;
  padding: 0;
  background-color: transparent;

  &:hover {
    background-color: transparent;
  }
`;
const StyledCloseIcon$2 = styled(CloseIcon)`
  width: ${({
  compact
}) => compact ? "1.25rem" : "auto"};
`;
const getBannerConfig = ({
  variant
}) => {
  switch (true) {
    case variant === "error":
      return {
        anchorOnColor: true,
        icon: /* @__PURE__ */ jsxRuntimeExports.jsx(ErrorIcon, {})
      };
    case variant === "errorWeak":
      return {
        anchorOnColor: false,
        icon: /* @__PURE__ */ jsxRuntimeExports.jsx(ErrorIcon, {})
      };
    case (variant === "warning" || variant === "warningWeak"):
      return {
        anchorOnColor: false,
        icon: /* @__PURE__ */ jsxRuntimeExports.jsx(WarningIcon, {})
      };
    case variant === "informational":
      return {
        anchorOnColor: true,
        icon: /* @__PURE__ */ jsxRuntimeExports.jsx(InfoCircleIcon, {})
      };
    case variant === "informationalWeak":
      return {
        anchorOnColor: false,
        icon: /* @__PURE__ */ jsxRuntimeExports.jsx(InfoCircleIcon, {})
      };
    case variant === "success":
      return {
        anchorOnColor: true,
        icon: /* @__PURE__ */ jsxRuntimeExports.jsx(CheckmarkCircleIcon, {})
      };
    case variant === "successWeak":
      return {
        anchorOnColor: false,
        icon: /* @__PURE__ */ jsxRuntimeExports.jsx(CheckmarkCircleIcon, {})
      };
    case variant === "neutralSubduedWeak":
      return {
        anchorOnColor: false,
        icon: /* @__PURE__ */ jsxRuntimeExports.jsx(InfoCircleIcon, {})
      };
    default:
      return {
        anchorOnColor: false,
        icon: /* @__PURE__ */ jsxRuntimeExports.jsx(InfoCircleIcon, {})
      };
  }
};
const Banner = forwardRef(({
  variant,
  size: size2,
  children,
  rounded = false,
  dismissible = false,
  showIcon = false,
  wrapContent = false,
  showLinkButton = false,
  linkText = "",
  buttonWrap = false,
  onLinkClick = () => void 0,
  isVisible = true,
  onClose = () => void 0,
  compact = false,
  icon: iconProp,
  ...rest
}, ref2) => {
  const [visible, setVisible] = useState(isVisible);
  const {
    icon: defaultIcon,
    anchorOnColor
  } = getBannerConfig({
    variant
  });
  const icon = iconProp ?? defaultIcon;
  const handleClose = () => {
    onClose();
    setVisible(false);
  };
  if (!visible) return null;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledBanner, { compact, dismissible, ...rest, $variant: variant ?? DEFAULT_BANNER_VARIANT, size: size2, ref: ref2, rounded, children: [
    showIcon && /* @__PURE__ */ jsxRuntimeExports.jsx(IconContainer$3, { compact, children: icon }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(ContentAndLinkContainer, { buttonWrap, className: "ContentAndLinkContainer", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(BannerContentContainer, { compact, className: "BannerContentContainer", wrapContent, children }),
      showLinkButton && /* @__PURE__ */ jsxRuntimeExports.jsx(BannerLinkButton, { variant: anchorOnColor ? "onColor" : "default", onClick: onLinkClick, size: compact ? "small" : "large", children: linkText })
    ] }),
    dismissible && /* @__PURE__ */ jsxRuntimeExports.jsx(CloseButton, { variant: "outline", onClick: handleClose, children: /* @__PURE__ */ jsxRuntimeExports.jsx(StyledCloseIcon$2, { compact }) })
  ] });
});
Banner.displayName = "Banner";
const StyledBannerStart = styled.div`
  display: flex;
  align-items: center;
  align-self: flex-start;
  ${composeWrapper(bannerStyledFns)}
`;
const BannerStart = forwardRef((props, ref2) => /* @__PURE__ */ jsxRuntimeExports.jsx(StyledBannerStart, { ...props, ref: ref2 }));
BannerStart.displayName = "BannerStart";
const StyledBannerEnd = styled.div`
  align-self: flex-end;
  display: flex;
  align-items: center;
  ${composeWrapper(bannerStyledFns)}
`;
const BannerEnd = forwardRef((props, ref2) => /* @__PURE__ */ jsxRuntimeExports.jsx(StyledBannerEnd, { ...props, ref: ref2 }));
BannerEnd.displayName = "BannerEnd";
const FONT_SIZE = "1rem";
const SYSTEM_FONT_FALLBACK = 'ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif';
const useAdyenStyleConfig = () => {
  var _a2, _b, _c, _d, _e, _f, _g;
  const tokens = (_a2 = useKindredConfigOptional()) == null ? void 0 : _a2.tokens;
  const color2 = (_c = (_b = tokens == null ? void 0 : tokens.color) == null ? void 0 : _b.foreground) == null ? void 0 : _c.default;
  const primaryFontFamily = (_e = (_d = tokens == null ? void 0 : tokens.text) == null ? void 0 : _d.fontFamily) == null ? void 0 : _e.primary;
  const fontFamily = primaryFontFamily ? `${primaryFontFamily}, ${SYSTEM_FONT_FALLBACK}` : SYSTEM_FONT_FALLBACK;
  const placeholderColor = (_g = (_f = tokens == null ? void 0 : tokens.color) == null ? void 0 : _f.foreground) == null ? void 0 : _g.subdued;
  return {
    styleSheet: {
      base: {
        color: color2,
        fontSize: FONT_SIZE,
        fontFamily,
        padding: "12px 12px 12px 4px"
      },
      placeholder: {
        // !important so Adyen's own placeholder rule does not win
        color: placeholderColor ? `${placeholderColor} !important` : void 0,
        fontSize: FONT_SIZE,
        fontFamily
      },
      validated: {
        color: color2
      }
    },
    translations: {
      "en-US": {
        "creditCard.cardNumber.label": "Card number",
        "creditCard.expiryDateField.title": "Expiration date",
        "creditCard.expiryDate.label": "Expiration date",
        "creditCard.cvcField.title": "Security code",
        "creditCard.securityCode.label": "Security code",
        "creditCard.securityCode.contextualText": "",
        "creditCard.holderName.label": "Cardholder name",
        "creditCard.securityCode.contextualText.3digits": "",
        "form.instruction": "",
        /* Error messages */
        "cc.num.902": "Enter a valid card number",
        "cc.num.903": "Enter a valid card number",
        "cc.num.905": "Enter a valid card number",
        "cc.dat.912": "Enter a valid expiration date",
        "cc.dat.913": "Enter a valid expiration date",
        "cc.dat.914": "Enter a valid expiration date",
        "cc.mth.915": "Enter a valid expiration month",
        "cc.yr.916": "Enter a valid expiration year",
        "cc.cvc.920": "Enter a valid security code",
        "cc.cvc.921": "Enter a valid security code",
        "cc.cvc.922": "Enter a valid security code",
        "cc.nm.926": "Enter the cardholder name",
        "cc.nm.927": "Enter a valid cardholder name"
      }
    }
  };
};
const AdyenCcContainer = styled.div`
  ${css$3`
    /* input field styles */
    .adyen-checkout__input {
      border-radius: var(${TOKENS.dimension.radius.interaction.inputLarge});
      border-color: var(${TOKENS.color.border.interaction.neutral}) !important;
      font-family: var(${TOKENS.text.fontFamily.primary});
      height: 46px;
      position: relative;
      line-height: 160%;
    }

    /* input field hover styles */
    .adyen-checkout__input:hover {
      outline: none;
      box-shadow: var(${TOKENS.color.border.interaction.neutral}) 0px 0px 0px
        1px;
      border-color: var(${TOKENS.color.border.interaction.neutral}) !important;
    }

    /* input field focus and focus:hover styles */
    .adyen-checkout__input--focus,
    .adyen-checkout__input--focus:hover {
      color: var(${TOKENS.color.border.interaction.neutralSelected});
    }

    /* input field error styles */
    .adyen-checkout__input--error,
    .adyen-checkout__input--error:hover {
      /* !important is being used here to override the the custom Adyen styles */
      box-shadow: 0 0 0 1px var(${TOKENS.color.border.feedback.danger}) !important;
      border: 1px solid var(${TOKENS.color.border.feedback.danger}) !important;
    }

    /* Ensure error border spans the full input (including prefixes/suffixes) */
    .adyen-checkout__field--error .adyen-checkout__input-wrapper {
      box-shadow: 0 0 0 1px var(${TOKENS.color.border.feedback.danger}) !important;
      border: 1px solid var(${TOKENS.color.border.feedback.danger}) !important;
      border-radius: var(${TOKENS.dimension.radius.interaction.inputLarge});
    }

    /* Neutralize inner input border so we don't get a double border effect */
    .adyen-checkout__field--error .adyen-checkout__input,
    .adyen-checkout__field--error .adyen-checkout__input:hover {
      box-shadow: none !important;
      border-color: transparent !important;
    }

    /* input field external label focus styles */
    .adyen-checkout__label--focused .adyen-checkout__label__text {
      color: var(${TOKENS.color.foreground.default});
    }

    /* input field external label error styles */
    /* !important is being used here to override the the custom Adyen styles */
    .adyen-checkout__label__text--error {
      color: var(${TOKENS.color.foreground.default}) !important;
    }

    /* input field text error styles */
    /* !important is being used here to override the the custom Adyen styles */
    .adyen-checkout__error-text {
      color: var(${TOKENS.color.foreground.feedback.danger}) !important;
    }

    /* space between bottom 2 input fields styles */
    .adyen-checkout__field-wrapper > .adyen-checkout__field:first-child {
      margin-right: 0;
    }

    /* hide supported card brands under the card number input */
    .adyen-checkout__card__brands {
      display: none !important;
    }

    /* Use wrapper for borders in all states so the border spans the full control */
    .adyen-checkout__input-wrapper {
      border: 1px solid var(${TOKENS.color.border.interaction.neutral}) !important;
      border-radius: var(${TOKENS.dimension.radius.interaction.inputLarge});
    }

    /* Hover state on wrapper */
    .adyen-checkout__input-wrapper:hover {
      outline: none;
      box-shadow: var(${TOKENS.color.border.interaction.neutral}) 0px 0px 0px
        1px;
      border-color: var(${TOKENS.color.border.interaction.neutral}) !important;
    }

    /* Focus state on wrapper */
    .adyen-checkout__input-wrapper--focus,
    .adyen-checkout__input-wrapper--focus:hover {
      box-shadow: 0 0 0 1px var(${TOKENS.color.border.interaction.neutral}) !important;
      border: 1px solid var(${TOKENS.color.border.interaction.neutral}) !important;
    }

    /* Focus state when applied to the field container */
    .adyen-checkout__field--focus .adyen-checkout__input-wrapper,
    .adyen-checkout__field--focus .adyen-checkout__input-wrapper:hover {
      box-shadow: 0 0 0 1px var(${TOKENS.color.border.interaction.neutral}) !important;
      border: 1px solid var(${TOKENS.color.border.interaction.neutral}) !important;
    }

    /* Neutralize inner input borders to avoid double borders when wrapper provides the border */
    .adyen-checkout__input,
    .adyen-checkout__input:hover,
    .adyen-checkout__input--focus,
    .adyen-checkout__input--focus:hover {
      box-shadow: none !important;
      border-color: transparent !important;
    }
  `}
`;
const AdyenPaymentContainer = forwardRef(({
  ...props
}, ref2) => /* @__PURE__ */ jsxRuntimeExports.jsx(AdyenCcContainer, { ...props, ref: ref2 }));
AdyenPaymentContainer.displayName = "AdyenPaymentContainer";
var reactResponsive = { exports: {} };
(function(module, exports$1) {
  (function webpackUniversalModuleDefinition(root2, factory) {
    module.exports = factory(React__default);
  })(commonjsGlobal, (__WEBPACK_EXTERNAL_MODULE_react__) => {
    return (
      /******/
      (() => {
        var __webpack_modules__ = {
          /***/
          "./node_modules/css-mediaquery/index.js": (
            /*!**********************************************!*\
              !*** ./node_modules/css-mediaquery/index.js ***!
              \**********************************************/
            /***/
            (__unused_webpack_module, exports$12) => {
              exports$12.match = matchQuery;
              exports$12.parse = parseQuery;
              var RE_MEDIA_QUERY = /(?:(only|not)?\s*([^\s\(\)]+)(?:\s*and)?\s*)?(.+)?/i, RE_MQ_EXPRESSION = /\(\s*([^\s\:\)]+)\s*(?:\:\s*([^\s\)]+))?\s*\)/, RE_MQ_FEATURE = /^(?:(min|max)-)?(.+)/, RE_LENGTH_UNIT = /(em|rem|px|cm|mm|in|pt|pc)?$/, RE_RESOLUTION_UNIT = /(dpi|dpcm|dppx)?$/;
              function matchQuery(mediaQuery, values3) {
                return parseQuery(mediaQuery).some(function(query) {
                  var inverse = query.inverse;
                  var typeMatch = query.type === "all" || values3.type === query.type;
                  if (typeMatch && inverse || !(typeMatch || inverse)) {
                    return false;
                  }
                  var expressionsMatch = query.expressions.every(function(expression) {
                    var feature = expression.feature, modifier = expression.modifier, expValue = expression.value, value = values3[feature];
                    if (!value) {
                      return false;
                    }
                    switch (feature) {
                      case "orientation":
                      case "scan":
                        return value.toLowerCase() === expValue.toLowerCase();
                      case "width":
                      case "height":
                      case "device-width":
                      case "device-height":
                        expValue = toPx(expValue);
                        value = toPx(value);
                        break;
                      case "resolution":
                        expValue = toDpi(expValue);
                        value = toDpi(value);
                        break;
                      case "aspect-ratio":
                      case "device-aspect-ratio":
                      case /* Deprecated */
                      "device-pixel-ratio":
                        expValue = toDecimal(expValue);
                        value = toDecimal(value);
                        break;
                      case "grid":
                      case "color":
                      case "color-index":
                      case "monochrome":
                        expValue = parseInt(expValue, 10) || 1;
                        value = parseInt(value, 10) || 0;
                        break;
                    }
                    switch (modifier) {
                      case "min":
                        return value >= expValue;
                      case "max":
                        return value <= expValue;
                      default:
                        return value === expValue;
                    }
                  });
                  return expressionsMatch && !inverse || !expressionsMatch && inverse;
                });
              }
              function parseQuery(mediaQuery) {
                return mediaQuery.split(",").map(function(query) {
                  query = query.trim();
                  var captures = query.match(RE_MEDIA_QUERY), modifier = captures[1], type2 = captures[2], expressions = captures[3] || "", parsed = {};
                  parsed.inverse = !!modifier && modifier.toLowerCase() === "not";
                  parsed.type = type2 ? type2.toLowerCase() : "all";
                  expressions = expressions.match(/\([^\)]+\)/g) || [];
                  parsed.expressions = expressions.map(function(expression) {
                    var captures2 = expression.match(RE_MQ_EXPRESSION), feature = captures2[1].toLowerCase().match(RE_MQ_FEATURE);
                    return {
                      modifier: feature[1],
                      feature: feature[2],
                      value: captures2[2]
                    };
                  });
                  return parsed;
                });
              }
              function toDecimal(ratio) {
                var decimal = Number(ratio), numbers;
                if (!decimal) {
                  numbers = ratio.match(/^(\d+)\s*\/\s*(\d+)$/);
                  decimal = numbers[1] / numbers[2];
                }
                return decimal;
              }
              function toDpi(resolution2) {
                var value = parseFloat(resolution2), units2 = String(resolution2).match(RE_RESOLUTION_UNIT)[1];
                switch (units2) {
                  case "dpcm":
                    return value / 2.54;
                  case "dppx":
                    return value * 96;
                  default:
                    return value;
                }
              }
              function toPx(length2) {
                var value = parseFloat(length2), units2 = String(length2).match(RE_LENGTH_UNIT)[1];
                switch (units2) {
                  case "em":
                    return value * 16;
                  case "rem":
                    return value * 16;
                  case "cm":
                    return value * 96 / 2.54;
                  case "mm":
                    return value * 96 / 2.54 / 10;
                  case "in":
                    return value * 96;
                  case "pt":
                    return value * 72;
                  case "pc":
                    return value * 72 / 12;
                  default:
                    return value;
                }
              }
            }
          ),
          /***/
          "./node_modules/hyphenate-style-name/index.js": (
            /*!****************************************************!*\
              !*** ./node_modules/hyphenate-style-name/index.js ***!
              \****************************************************/
            /***/
            (__unused_webpack_module, __webpack_exports__2, __webpack_require__2) => {
              __webpack_require__2.r(__webpack_exports__2);
              __webpack_require__2.d(__webpack_exports__2, {
                /* harmony export */
                "default": () => __WEBPACK_DEFAULT_EXPORT__
                /* harmony export */
              });
              var uppercasePattern = /[A-Z]/g;
              var msPattern = /^ms-/;
              var cache = {};
              function toHyphenLower(match2) {
                return "-" + match2.toLowerCase();
              }
              function hyphenateStyleName(name) {
                if (cache.hasOwnProperty(name)) {
                  return cache[name];
                }
                var hName = name.replace(uppercasePattern, toHyphenLower);
                return cache[name] = msPattern.test(hName) ? "-" + hName : hName;
              }
              const __WEBPACK_DEFAULT_EXPORT__ = hyphenateStyleName;
            }
          ),
          /***/
          "./node_modules/matchmediaquery/index.js": (
            /*!***********************************************!*\
              !*** ./node_modules/matchmediaquery/index.js ***!
              \***********************************************/
            /***/
            (module2, __unused_webpack_exports, __webpack_require__2) => {
              var staticMatch = __webpack_require__2(
                /*! css-mediaquery */
                "./node_modules/css-mediaquery/index.js"
              ).match;
              var dynamicMatch = typeof window !== "undefined" ? window.matchMedia : null;
              function Mql(query, values3, forceStatic) {
                var self2 = this;
                if (dynamicMatch && !forceStatic) {
                  var mql = dynamicMatch.call(window, query);
                  this.matches = mql.matches;
                  this.media = mql.media;
                  mql.addListener(update);
                } else {
                  this.matches = staticMatch(query, values3);
                  this.media = query;
                }
                this.addListener = addListener;
                this.removeListener = removeListener;
                this.dispose = dispose;
                function addListener(listener) {
                  if (mql) {
                    mql.addListener(listener);
                  }
                }
                function removeListener(listener) {
                  if (mql) {
                    mql.removeListener(listener);
                  }
                }
                function update(evt) {
                  self2.matches = evt.matches;
                  self2.media = evt.media;
                }
                function dispose() {
                  if (mql) {
                    mql.removeListener(update);
                  }
                }
              }
              function matchMedia(query, values3, forceStatic) {
                return new Mql(query, values3, forceStatic);
              }
              module2.exports = matchMedia;
            }
          ),
          /***/
          "./node_modules/object-assign/index.js": (
            /*!*********************************************!*\
              !*** ./node_modules/object-assign/index.js ***!
              \*********************************************/
            /***/
            (module2) => {
              /*
              object-assign
              (c) Sindre Sorhus
              @license MIT
              */
              var getOwnPropertySymbols = Object.getOwnPropertySymbols;
              var hasOwnProperty2 = Object.prototype.hasOwnProperty;
              var propIsEnumerable = Object.prototype.propertyIsEnumerable;
              function toObject(val) {
                if (val === null || val === void 0) {
                  throw new TypeError("Object.assign cannot be called with null or undefined");
                }
                return Object(val);
              }
              function shouldUseNative() {
                try {
                  if (!Object.assign) {
                    return false;
                  }
                  var test1 = new String("abc");
                  test1[5] = "de";
                  if (Object.getOwnPropertyNames(test1)[0] === "5") {
                    return false;
                  }
                  var test2 = {};
                  for (var i = 0; i < 10; i++) {
                    test2["_" + String.fromCharCode(i)] = i;
                  }
                  var order2 = Object.getOwnPropertyNames(test2).map(function(n2) {
                    return test2[n2];
                  });
                  if (order2.join("") !== "0123456789") {
                    return false;
                  }
                  var test3 = {};
                  "abcdefghijklmnopqrst".split("").forEach(function(letter) {
                    test3[letter] = letter;
                  });
                  if (Object.keys(Object.assign({}, test3)).join("") !== "abcdefghijklmnopqrst") {
                    return false;
                  }
                  return true;
                } catch (err) {
                  return false;
                }
              }
              module2.exports = shouldUseNative() ? Object.assign : function(target, source) {
                var from2;
                var to = toObject(target);
                var symbols;
                for (var s2 = 1; s2 < arguments.length; s2++) {
                  from2 = Object(arguments[s2]);
                  for (var key in from2) {
                    if (hasOwnProperty2.call(from2, key)) {
                      to[key] = from2[key];
                    }
                  }
                  if (getOwnPropertySymbols) {
                    symbols = getOwnPropertySymbols(from2);
                    for (var i = 0; i < symbols.length; i++) {
                      if (propIsEnumerable.call(from2, symbols[i])) {
                        to[symbols[i]] = from2[symbols[i]];
                      }
                    }
                  }
                }
                return to;
              };
            }
          ),
          /***/
          "./node_modules/prop-types/checkPropTypes.js": (
            /*!***************************************************!*\
              !*** ./node_modules/prop-types/checkPropTypes.js ***!
              \***************************************************/
            /***/
            (module2, __unused_webpack_exports, __webpack_require__2) => {
              var printWarning = function() {
              };
              {
                var ReactPropTypesSecret = __webpack_require__2(
                  /*! ./lib/ReactPropTypesSecret */
                  "./node_modules/prop-types/lib/ReactPropTypesSecret.js"
                );
                var loggedTypeFailures = {};
                var has = __webpack_require__2(
                  /*! ./lib/has */
                  "./node_modules/prop-types/lib/has.js"
                );
                printWarning = function(text) {
                  var message2 = "Warning: " + text;
                  if (typeof console !== "undefined") {
                    console.error(message2);
                  }
                  try {
                    throw new Error(message2);
                  } catch (x2) {
                  }
                };
              }
              function checkPropTypes(typeSpecs, values3, location, componentName, getStack) {
                {
                  for (var typeSpecName in typeSpecs) {
                    if (has(typeSpecs, typeSpecName)) {
                      var error2;
                      try {
                        if (typeof typeSpecs[typeSpecName] !== "function") {
                          var err = Error(
                            (componentName || "React class") + ": " + location + " type `" + typeSpecName + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof typeSpecs[typeSpecName] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
                          );
                          err.name = "Invariant Violation";
                          throw err;
                        }
                        error2 = typeSpecs[typeSpecName](values3, typeSpecName, componentName, location, null, ReactPropTypesSecret);
                      } catch (ex) {
                        error2 = ex;
                      }
                      if (error2 && !(error2 instanceof Error)) {
                        printWarning(
                          (componentName || "React class") + ": type specification of " + location + " `" + typeSpecName + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof error2 + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
                        );
                      }
                      if (error2 instanceof Error && !(error2.message in loggedTypeFailures)) {
                        loggedTypeFailures[error2.message] = true;
                        var stack = getStack ? getStack() : "";
                        printWarning(
                          "Failed " + location + " type: " + error2.message + (stack != null ? stack : "")
                        );
                      }
                    }
                  }
                }
              }
              checkPropTypes.resetWarningCache = function() {
                {
                  loggedTypeFailures = {};
                }
              };
              module2.exports = checkPropTypes;
            }
          ),
          /***/
          "./node_modules/prop-types/factoryWithTypeCheckers.js": (
            /*!************************************************************!*\
              !*** ./node_modules/prop-types/factoryWithTypeCheckers.js ***!
              \************************************************************/
            /***/
            (module2, __unused_webpack_exports, __webpack_require__2) => {
              var ReactIs = __webpack_require__2(
                /*! react-is */
                "./node_modules/react-is/index.js"
              );
              var assign2 = __webpack_require__2(
                /*! object-assign */
                "./node_modules/object-assign/index.js"
              );
              var ReactPropTypesSecret = __webpack_require__2(
                /*! ./lib/ReactPropTypesSecret */
                "./node_modules/prop-types/lib/ReactPropTypesSecret.js"
              );
              var has = __webpack_require__2(
                /*! ./lib/has */
                "./node_modules/prop-types/lib/has.js"
              );
              var checkPropTypes = __webpack_require__2(
                /*! ./checkPropTypes */
                "./node_modules/prop-types/checkPropTypes.js"
              );
              var printWarning = function() {
              };
              {
                printWarning = function(text) {
                  var message2 = "Warning: " + text;
                  if (typeof console !== "undefined") {
                    console.error(message2);
                  }
                  try {
                    throw new Error(message2);
                  } catch (x2) {
                  }
                };
              }
              function emptyFunctionThatReturnsNull() {
                return null;
              }
              module2.exports = function(isValidElement2, throwOnDirectAccess) {
                var ITERATOR_SYMBOL = typeof Symbol === "function" && Symbol.iterator;
                var FAUX_ITERATOR_SYMBOL = "@@iterator";
                function getIteratorFn(maybeIterable) {
                  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
                  if (typeof iteratorFn === "function") {
                    return iteratorFn;
                  }
                }
                var ANONYMOUS = "<<anonymous>>";
                var ReactPropTypes = {
                  array: createPrimitiveTypeChecker("array"),
                  bigint: createPrimitiveTypeChecker("bigint"),
                  bool: createPrimitiveTypeChecker("boolean"),
                  func: createPrimitiveTypeChecker("function"),
                  number: createPrimitiveTypeChecker("number"),
                  object: createPrimitiveTypeChecker("object"),
                  string: createPrimitiveTypeChecker("string"),
                  symbol: createPrimitiveTypeChecker("symbol"),
                  any: createAnyTypeChecker(),
                  arrayOf: createArrayOfTypeChecker,
                  element: createElementTypeChecker(),
                  elementType: createElementTypeTypeChecker(),
                  instanceOf: createInstanceTypeChecker,
                  node: createNodeChecker(),
                  objectOf: createObjectOfTypeChecker,
                  oneOf: createEnumTypeChecker,
                  oneOfType: createUnionTypeChecker,
                  shape: createShapeTypeChecker,
                  exact: createStrictShapeTypeChecker
                };
                function is(x2, y2) {
                  if (x2 === y2) {
                    return x2 !== 0 || 1 / x2 === 1 / y2;
                  } else {
                    return x2 !== x2 && y2 !== y2;
                  }
                }
                function PropTypeError(message2, data) {
                  this.message = message2;
                  this.data = data && typeof data === "object" ? data : {};
                  this.stack = "";
                }
                PropTypeError.prototype = Error.prototype;
                function createChainableTypeChecker(validate) {
                  {
                    var manualPropTypeCallCache = {};
                    var manualPropTypeWarningCount = 0;
                  }
                  function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
                    componentName = componentName || ANONYMOUS;
                    propFullName = propFullName || propName;
                    if (secret !== ReactPropTypesSecret) {
                      if (throwOnDirectAccess) {
                        var err = new Error(
                          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
                        );
                        err.name = "Invariant Violation";
                        throw err;
                      } else if (typeof console !== "undefined") {
                        var cacheKey = componentName + ":" + propName;
                        if (!manualPropTypeCallCache[cacheKey] && // Avoid spamming the console because they are often not actionable except for lib authors
                        manualPropTypeWarningCount < 3) {
                          printWarning(
                            "You are manually calling a React.PropTypes validation function for the `" + propFullName + "` prop on `" + componentName + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
                          );
                          manualPropTypeCallCache[cacheKey] = true;
                          manualPropTypeWarningCount++;
                        }
                      }
                    }
                    if (props[propName] == null) {
                      if (isRequired) {
                        if (props[propName] === null) {
                          return new PropTypeError("The " + location + " `" + propFullName + "` is marked as required " + ("in `" + componentName + "`, but its value is `null`."));
                        }
                        return new PropTypeError("The " + location + " `" + propFullName + "` is marked as required in " + ("`" + componentName + "`, but its value is `undefined`."));
                      }
                      return null;
                    } else {
                      return validate(props, propName, componentName, location, propFullName);
                    }
                  }
                  var chainedCheckType = checkType.bind(null, false);
                  chainedCheckType.isRequired = checkType.bind(null, true);
                  return chainedCheckType;
                }
                function createPrimitiveTypeChecker(expectedType) {
                  function validate(props, propName, componentName, location, propFullName, secret) {
                    var propValue = props[propName];
                    var propType = getPropType(propValue);
                    if (propType !== expectedType) {
                      var preciseType = getPreciseType(propValue);
                      return new PropTypeError(
                        "Invalid " + location + " `" + propFullName + "` of type " + ("`" + preciseType + "` supplied to `" + componentName + "`, expected ") + ("`" + expectedType + "`."),
                        { expectedType }
                      );
                    }
                    return null;
                  }
                  return createChainableTypeChecker(validate);
                }
                function createAnyTypeChecker() {
                  return createChainableTypeChecker(emptyFunctionThatReturnsNull);
                }
                function createArrayOfTypeChecker(typeChecker) {
                  function validate(props, propName, componentName, location, propFullName) {
                    if (typeof typeChecker !== "function") {
                      return new PropTypeError("Property `" + propFullName + "` of component `" + componentName + "` has invalid PropType notation inside arrayOf.");
                    }
                    var propValue = props[propName];
                    if (!Array.isArray(propValue)) {
                      var propType = getPropType(propValue);
                      return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected an array."));
                    }
                    for (var i = 0; i < propValue.length; i++) {
                      var error2 = typeChecker(propValue, i, componentName, location, propFullName + "[" + i + "]", ReactPropTypesSecret);
                      if (error2 instanceof Error) {
                        return error2;
                      }
                    }
                    return null;
                  }
                  return createChainableTypeChecker(validate);
                }
                function createElementTypeChecker() {
                  function validate(props, propName, componentName, location, propFullName) {
                    var propValue = props[propName];
                    if (!isValidElement2(propValue)) {
                      var propType = getPropType(propValue);
                      return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected a single ReactElement."));
                    }
                    return null;
                  }
                  return createChainableTypeChecker(validate);
                }
                function createElementTypeTypeChecker() {
                  function validate(props, propName, componentName, location, propFullName) {
                    var propValue = props[propName];
                    if (!ReactIs.isValidElementType(propValue)) {
                      var propType = getPropType(propValue);
                      return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected a single ReactElement type."));
                    }
                    return null;
                  }
                  return createChainableTypeChecker(validate);
                }
                function createInstanceTypeChecker(expectedClass) {
                  function validate(props, propName, componentName, location, propFullName) {
                    if (!(props[propName] instanceof expectedClass)) {
                      var expectedClassName = expectedClass.name || ANONYMOUS;
                      var actualClassName = getClassName(props[propName]);
                      return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + actualClassName + "` supplied to `" + componentName + "`, expected ") + ("instance of `" + expectedClassName + "`."));
                    }
                    return null;
                  }
                  return createChainableTypeChecker(validate);
                }
                function createEnumTypeChecker(expectedValues) {
                  if (!Array.isArray(expectedValues)) {
                    {
                      if (arguments.length > 1) {
                        printWarning(
                          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
                        );
                      } else {
                        printWarning("Invalid argument supplied to oneOf, expected an array.");
                      }
                    }
                    return emptyFunctionThatReturnsNull;
                  }
                  function validate(props, propName, componentName, location, propFullName) {
                    var propValue = props[propName];
                    for (var i = 0; i < expectedValues.length; i++) {
                      if (is(propValue, expectedValues[i])) {
                        return null;
                      }
                    }
                    var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
                      var type2 = getPreciseType(value);
                      if (type2 === "symbol") {
                        return String(value);
                      }
                      return value;
                    });
                    return new PropTypeError("Invalid " + location + " `" + propFullName + "` of value `" + String(propValue) + "` " + ("supplied to `" + componentName + "`, expected one of " + valuesString + "."));
                  }
                  return createChainableTypeChecker(validate);
                }
                function createObjectOfTypeChecker(typeChecker) {
                  function validate(props, propName, componentName, location, propFullName) {
                    if (typeof typeChecker !== "function") {
                      return new PropTypeError("Property `" + propFullName + "` of component `" + componentName + "` has invalid PropType notation inside objectOf.");
                    }
                    var propValue = props[propName];
                    var propType = getPropType(propValue);
                    if (propType !== "object") {
                      return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected an object."));
                    }
                    for (var key in propValue) {
                      if (has(propValue, key)) {
                        var error2 = typeChecker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret);
                        if (error2 instanceof Error) {
                          return error2;
                        }
                      }
                    }
                    return null;
                  }
                  return createChainableTypeChecker(validate);
                }
                function createUnionTypeChecker(arrayOfTypeCheckers) {
                  if (!Array.isArray(arrayOfTypeCheckers)) {
                    printWarning("Invalid argument supplied to oneOfType, expected an instance of array.");
                    return emptyFunctionThatReturnsNull;
                  }
                  for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
                    var checker = arrayOfTypeCheckers[i];
                    if (typeof checker !== "function") {
                      printWarning(
                        "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + getPostfixForTypeWarning(checker) + " at index " + i + "."
                      );
                      return emptyFunctionThatReturnsNull;
                    }
                  }
                  function validate(props, propName, componentName, location, propFullName) {
                    var expectedTypes = [];
                    for (var i2 = 0; i2 < arrayOfTypeCheckers.length; i2++) {
                      var checker2 = arrayOfTypeCheckers[i2];
                      var checkerResult = checker2(props, propName, componentName, location, propFullName, ReactPropTypesSecret);
                      if (checkerResult == null) {
                        return null;
                      }
                      if (checkerResult.data && has(checkerResult.data, "expectedType")) {
                        expectedTypes.push(checkerResult.data.expectedType);
                      }
                    }
                    var expectedTypesMessage = expectedTypes.length > 0 ? ", expected one of type [" + expectedTypes.join(", ") + "]" : "";
                    return new PropTypeError("Invalid " + location + " `" + propFullName + "` supplied to " + ("`" + componentName + "`" + expectedTypesMessage + "."));
                  }
                  return createChainableTypeChecker(validate);
                }
                function createNodeChecker() {
                  function validate(props, propName, componentName, location, propFullName) {
                    if (!isNode2(props[propName])) {
                      return new PropTypeError("Invalid " + location + " `" + propFullName + "` supplied to " + ("`" + componentName + "`, expected a ReactNode."));
                    }
                    return null;
                  }
                  return createChainableTypeChecker(validate);
                }
                function invalidValidatorError(componentName, location, propFullName, key, type2) {
                  return new PropTypeError(
                    (componentName || "React class") + ": " + location + " type `" + propFullName + "." + key + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + type2 + "`."
                  );
                }
                function createShapeTypeChecker(shapeTypes) {
                  function validate(props, propName, componentName, location, propFullName) {
                    var propValue = props[propName];
                    var propType = getPropType(propValue);
                    if (propType !== "object") {
                      return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + propType + "` " + ("supplied to `" + componentName + "`, expected `object`."));
                    }
                    for (var key in shapeTypes) {
                      var checker = shapeTypes[key];
                      if (typeof checker !== "function") {
                        return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
                      }
                      var error2 = checker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret);
                      if (error2) {
                        return error2;
                      }
                    }
                    return null;
                  }
                  return createChainableTypeChecker(validate);
                }
                function createStrictShapeTypeChecker(shapeTypes) {
                  function validate(props, propName, componentName, location, propFullName) {
                    var propValue = props[propName];
                    var propType = getPropType(propValue);
                    if (propType !== "object") {
                      return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + propType + "` " + ("supplied to `" + componentName + "`, expected `object`."));
                    }
                    var allKeys = assign2({}, props[propName], shapeTypes);
                    for (var key in allKeys) {
                      var checker = shapeTypes[key];
                      if (has(shapeTypes, key) && typeof checker !== "function") {
                        return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
                      }
                      if (!checker) {
                        return new PropTypeError(
                          "Invalid " + location + " `" + propFullName + "` key `" + key + "` supplied to `" + componentName + "`.\nBad object: " + JSON.stringify(props[propName], null, "  ") + "\nValid keys: " + JSON.stringify(Object.keys(shapeTypes), null, "  ")
                        );
                      }
                      var error2 = checker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret);
                      if (error2) {
                        return error2;
                      }
                    }
                    return null;
                  }
                  return createChainableTypeChecker(validate);
                }
                function isNode2(propValue) {
                  switch (typeof propValue) {
                    case "number":
                    case "string":
                    case "undefined":
                      return true;
                    case "boolean":
                      return !propValue;
                    case "object":
                      if (Array.isArray(propValue)) {
                        return propValue.every(isNode2);
                      }
                      if (propValue === null || isValidElement2(propValue)) {
                        return true;
                      }
                      var iteratorFn = getIteratorFn(propValue);
                      if (iteratorFn) {
                        var iterator = iteratorFn.call(propValue);
                        var step;
                        if (iteratorFn !== propValue.entries) {
                          while (!(step = iterator.next()).done) {
                            if (!isNode2(step.value)) {
                              return false;
                            }
                          }
                        } else {
                          while (!(step = iterator.next()).done) {
                            var entry = step.value;
                            if (entry) {
                              if (!isNode2(entry[1])) {
                                return false;
                              }
                            }
                          }
                        }
                      } else {
                        return false;
                      }
                      return true;
                    default:
                      return false;
                  }
                }
                function isSymbol2(propType, propValue) {
                  if (propType === "symbol") {
                    return true;
                  }
                  if (!propValue) {
                    return false;
                  }
                  if (propValue["@@toStringTag"] === "Symbol") {
                    return true;
                  }
                  if (typeof Symbol === "function" && propValue instanceof Symbol) {
                    return true;
                  }
                  return false;
                }
                function getPropType(propValue) {
                  var propType = typeof propValue;
                  if (Array.isArray(propValue)) {
                    return "array";
                  }
                  if (propValue instanceof RegExp) {
                    return "object";
                  }
                  if (isSymbol2(propType, propValue)) {
                    return "symbol";
                  }
                  return propType;
                }
                function getPreciseType(propValue) {
                  if (typeof propValue === "undefined" || propValue === null) {
                    return "" + propValue;
                  }
                  var propType = getPropType(propValue);
                  if (propType === "object") {
                    if (propValue instanceof Date) {
                      return "date";
                    } else if (propValue instanceof RegExp) {
                      return "regexp";
                    }
                  }
                  return propType;
                }
                function getPostfixForTypeWarning(value) {
                  var type2 = getPreciseType(value);
                  switch (type2) {
                    case "array":
                    case "object":
                      return "an " + type2;
                    case "boolean":
                    case "date":
                    case "regexp":
                      return "a " + type2;
                    default:
                      return type2;
                  }
                }
                function getClassName(propValue) {
                  if (!propValue.constructor || !propValue.constructor.name) {
                    return ANONYMOUS;
                  }
                  return propValue.constructor.name;
                }
                ReactPropTypes.checkPropTypes = checkPropTypes;
                ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
                ReactPropTypes.PropTypes = ReactPropTypes;
                return ReactPropTypes;
              };
            }
          ),
          /***/
          "./node_modules/prop-types/index.js": (
            /*!******************************************!*\
              !*** ./node_modules/prop-types/index.js ***!
              \******************************************/
            /***/
            (module2, __unused_webpack_exports, __webpack_require__2) => {
              {
                var ReactIs = __webpack_require__2(
                  /*! react-is */
                  "./node_modules/react-is/index.js"
                );
                var throwOnDirectAccess = true;
                module2.exports = __webpack_require__2(
                  /*! ./factoryWithTypeCheckers */
                  "./node_modules/prop-types/factoryWithTypeCheckers.js"
                )(ReactIs.isElement, throwOnDirectAccess);
              }
            }
          ),
          /***/
          "./node_modules/prop-types/lib/ReactPropTypesSecret.js": (
            /*!*************************************************************!*\
              !*** ./node_modules/prop-types/lib/ReactPropTypesSecret.js ***!
              \*************************************************************/
            /***/
            (module2) => {
              var ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
              module2.exports = ReactPropTypesSecret;
            }
          ),
          /***/
          "./node_modules/prop-types/lib/has.js": (
            /*!********************************************!*\
              !*** ./node_modules/prop-types/lib/has.js ***!
              \********************************************/
            /***/
            (module2) => {
              module2.exports = Function.call.bind(Object.prototype.hasOwnProperty);
            }
          ),
          /***/
          "./node_modules/react-is/cjs/react-is.development.js": (
            /*!***********************************************************!*\
              !*** ./node_modules/react-is/cjs/react-is.development.js ***!
              \***********************************************************/
            /***/
            (__unused_webpack_module, exports$12) => {
              /** @license React v16.13.1
               * react-is.development.js
               *
               * Copyright (c) Facebook, Inc. and its affiliates.
               *
               * This source code is licensed under the MIT license found in the
               * LICENSE file in the root directory of this source tree.
               */
              {
                (function() {
                  var hasSymbol = typeof Symbol === "function" && Symbol.for;
                  var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for("react.element") : 60103;
                  var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for("react.portal") : 60106;
                  var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for("react.fragment") : 60107;
                  var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for("react.strict_mode") : 60108;
                  var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for("react.profiler") : 60114;
                  var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for("react.provider") : 60109;
                  var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for("react.context") : 60110;
                  var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for("react.async_mode") : 60111;
                  var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for("react.concurrent_mode") : 60111;
                  var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for("react.forward_ref") : 60112;
                  var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for("react.suspense") : 60113;
                  var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for("react.suspense_list") : 60120;
                  var REACT_MEMO_TYPE = hasSymbol ? Symbol.for("react.memo") : 60115;
                  var REACT_LAZY_TYPE = hasSymbol ? Symbol.for("react.lazy") : 60116;
                  var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for("react.block") : 60121;
                  var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for("react.fundamental") : 60117;
                  var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for("react.responder") : 60118;
                  var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for("react.scope") : 60119;
                  function isValidElementType(type2) {
                    return typeof type2 === "string" || typeof type2 === "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
                    type2 === REACT_FRAGMENT_TYPE || type2 === REACT_CONCURRENT_MODE_TYPE || type2 === REACT_PROFILER_TYPE || type2 === REACT_STRICT_MODE_TYPE || type2 === REACT_SUSPENSE_TYPE || type2 === REACT_SUSPENSE_LIST_TYPE || typeof type2 === "object" && type2 !== null && (type2.$$typeof === REACT_LAZY_TYPE || type2.$$typeof === REACT_MEMO_TYPE || type2.$$typeof === REACT_PROVIDER_TYPE || type2.$$typeof === REACT_CONTEXT_TYPE || type2.$$typeof === REACT_FORWARD_REF_TYPE || type2.$$typeof === REACT_FUNDAMENTAL_TYPE || type2.$$typeof === REACT_RESPONDER_TYPE || type2.$$typeof === REACT_SCOPE_TYPE || type2.$$typeof === REACT_BLOCK_TYPE);
                  }
                  function typeOf2(object2) {
                    if (typeof object2 === "object" && object2 !== null) {
                      var $$typeof = object2.$$typeof;
                      switch ($$typeof) {
                        case REACT_ELEMENT_TYPE:
                          var type2 = object2.type;
                          switch (type2) {
                            case REACT_ASYNC_MODE_TYPE:
                            case REACT_CONCURRENT_MODE_TYPE:
                            case REACT_FRAGMENT_TYPE:
                            case REACT_PROFILER_TYPE:
                            case REACT_STRICT_MODE_TYPE:
                            case REACT_SUSPENSE_TYPE:
                              return type2;
                            default:
                              var $$typeofType = type2 && type2.$$typeof;
                              switch ($$typeofType) {
                                case REACT_CONTEXT_TYPE:
                                case REACT_FORWARD_REF_TYPE:
                                case REACT_LAZY_TYPE:
                                case REACT_MEMO_TYPE:
                                case REACT_PROVIDER_TYPE:
                                  return $$typeofType;
                                default:
                                  return $$typeof;
                              }
                          }
                        case REACT_PORTAL_TYPE:
                          return $$typeof;
                      }
                    }
                    return void 0;
                  }
                  var AsyncMode = REACT_ASYNC_MODE_TYPE;
                  var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
                  var ContextConsumer = REACT_CONTEXT_TYPE;
                  var ContextProvider = REACT_PROVIDER_TYPE;
                  var Element2 = REACT_ELEMENT_TYPE;
                  var ForwardRef = REACT_FORWARD_REF_TYPE;
                  var Fragment2 = REACT_FRAGMENT_TYPE;
                  var Lazy = REACT_LAZY_TYPE;
                  var Memo = REACT_MEMO_TYPE;
                  var Portal2 = REACT_PORTAL_TYPE;
                  var Profiler = REACT_PROFILER_TYPE;
                  var StrictMode = REACT_STRICT_MODE_TYPE;
                  var Suspense = REACT_SUSPENSE_TYPE;
                  var hasWarnedAboutDeprecatedIsAsyncMode = false;
                  function isAsyncMode(object2) {
                    {
                      if (!hasWarnedAboutDeprecatedIsAsyncMode) {
                        hasWarnedAboutDeprecatedIsAsyncMode = true;
                        console["warn"]("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.");
                      }
                    }
                    return isConcurrentMode(object2) || typeOf2(object2) === REACT_ASYNC_MODE_TYPE;
                  }
                  function isConcurrentMode(object2) {
                    return typeOf2(object2) === REACT_CONCURRENT_MODE_TYPE;
                  }
                  function isContextConsumer(object2) {
                    return typeOf2(object2) === REACT_CONTEXT_TYPE;
                  }
                  function isContextProvider(object2) {
                    return typeOf2(object2) === REACT_PROVIDER_TYPE;
                  }
                  function isElement2(object2) {
                    return typeof object2 === "object" && object2 !== null && object2.$$typeof === REACT_ELEMENT_TYPE;
                  }
                  function isForwardRef(object2) {
                    return typeOf2(object2) === REACT_FORWARD_REF_TYPE;
                  }
                  function isFragment(object2) {
                    return typeOf2(object2) === REACT_FRAGMENT_TYPE;
                  }
                  function isLazy(object2) {
                    return typeOf2(object2) === REACT_LAZY_TYPE;
                  }
                  function isMemo(object2) {
                    return typeOf2(object2) === REACT_MEMO_TYPE;
                  }
                  function isPortal(object2) {
                    return typeOf2(object2) === REACT_PORTAL_TYPE;
                  }
                  function isProfiler(object2) {
                    return typeOf2(object2) === REACT_PROFILER_TYPE;
                  }
                  function isStrictMode(object2) {
                    return typeOf2(object2) === REACT_STRICT_MODE_TYPE;
                  }
                  function isSuspense(object2) {
                    return typeOf2(object2) === REACT_SUSPENSE_TYPE;
                  }
                  exports$12.AsyncMode = AsyncMode;
                  exports$12.ConcurrentMode = ConcurrentMode;
                  exports$12.ContextConsumer = ContextConsumer;
                  exports$12.ContextProvider = ContextProvider;
                  exports$12.Element = Element2;
                  exports$12.ForwardRef = ForwardRef;
                  exports$12.Fragment = Fragment2;
                  exports$12.Lazy = Lazy;
                  exports$12.Memo = Memo;
                  exports$12.Portal = Portal2;
                  exports$12.Profiler = Profiler;
                  exports$12.StrictMode = StrictMode;
                  exports$12.Suspense = Suspense;
                  exports$12.isAsyncMode = isAsyncMode;
                  exports$12.isConcurrentMode = isConcurrentMode;
                  exports$12.isContextConsumer = isContextConsumer;
                  exports$12.isContextProvider = isContextProvider;
                  exports$12.isElement = isElement2;
                  exports$12.isForwardRef = isForwardRef;
                  exports$12.isFragment = isFragment;
                  exports$12.isLazy = isLazy;
                  exports$12.isMemo = isMemo;
                  exports$12.isPortal = isPortal;
                  exports$12.isProfiler = isProfiler;
                  exports$12.isStrictMode = isStrictMode;
                  exports$12.isSuspense = isSuspense;
                  exports$12.isValidElementType = isValidElementType;
                  exports$12.typeOf = typeOf2;
                })();
              }
            }
          ),
          /***/
          "./node_modules/react-is/index.js": (
            /*!****************************************!*\
              !*** ./node_modules/react-is/index.js ***!
              \****************************************/
            /***/
            (module2, __unused_webpack_exports, __webpack_require__2) => {
              {
                module2.exports = __webpack_require__2(
                  /*! ./cjs/react-is.development.js */
                  "./node_modules/react-is/cjs/react-is.development.js"
                );
              }
            }
          ),
          /***/
          "./node_modules/shallow-equal/dist/index.esm.js": (
            /*!******************************************************!*\
              !*** ./node_modules/shallow-equal/dist/index.esm.js ***!
              \******************************************************/
            /***/
            (__unused_webpack_module, __webpack_exports__2, __webpack_require__2) => {
              __webpack_require__2.r(__webpack_exports__2);
              __webpack_require__2.d(__webpack_exports__2, {
                /* harmony export */
                "shallowEqualArrays": () => (
                  /* binding */
                  shallowEqualArrays
                ),
                /* harmony export */
                "shallowEqualObjects": () => (
                  /* binding */
                  shallowEqualObjects
                )
                /* harmony export */
              });
              function shallowEqualObjects(objA, objB) {
                if (objA === objB) {
                  return true;
                }
                if (!objA || !objB) {
                  return false;
                }
                var aKeys = Object.keys(objA);
                var bKeys = Object.keys(objB);
                var len = aKeys.length;
                if (bKeys.length !== len) {
                  return false;
                }
                for (var i = 0; i < len; i++) {
                  var key = aKeys[i];
                  if (objA[key] !== objB[key] || !Object.prototype.hasOwnProperty.call(objB, key)) {
                    return false;
                  }
                }
                return true;
              }
              function shallowEqualArrays(arrA, arrB) {
                if (arrA === arrB) {
                  return true;
                }
                if (!arrA || !arrB) {
                  return false;
                }
                var len = arrA.length;
                if (arrB.length !== len) {
                  return false;
                }
                for (var i = 0; i < len; i++) {
                  if (arrA[i] !== arrB[i]) {
                    return false;
                  }
                }
                return true;
              }
            }
          ),
          /***/
          "./src/Component.ts": (
            /*!**************************!*\
              !*** ./src/Component.ts ***!
              \**************************/
            /***/
            function(__unused_webpack_module, exports$12, __webpack_require__2) {
              var __rest = this && this.__rest || function(s2, e3) {
                var t2 = {};
                for (var p2 in s2) if (Object.prototype.hasOwnProperty.call(s2, p2) && e3.indexOf(p2) < 0)
                  t2[p2] = s2[p2];
                if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
                  for (var i = 0, p2 = Object.getOwnPropertySymbols(s2); i < p2.length; i++) {
                    if (e3.indexOf(p2[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p2[i]))
                      t2[p2[i]] = s2[p2[i]];
                  }
                return t2;
              };
              var __importDefault = this && this.__importDefault || function(mod) {
                return mod && mod.__esModule ? mod : { "default": mod };
              };
              Object.defineProperty(exports$12, "__esModule", { value: true });
              var useMediaQuery_1 = __importDefault(__webpack_require__2(
                /*! ./useMediaQuery */
                "./src/useMediaQuery.ts"
              ));
              var MediaQuery = function(_a2) {
                var children = _a2.children, device = _a2.device, onChange2 = _a2.onChange, settings = __rest(_a2, ["children", "device", "onChange"]);
                var matches = (0, useMediaQuery_1.default)(settings, device, onChange2);
                if (typeof children === "function") {
                  return children(matches);
                }
                return matches ? children : null;
              };
              exports$12["default"] = MediaQuery;
            }
          ),
          /***/
          "./src/Context.ts": (
            /*!************************!*\
              !*** ./src/Context.ts ***!
              \************************/
            /***/
            (__unused_webpack_module, exports$12, __webpack_require__2) => {
              Object.defineProperty(exports$12, "__esModule", { value: true });
              var react_12 = __webpack_require__2(
                /*! react */
                "react"
              );
              var Context = (0, react_12.createContext)(void 0);
              exports$12["default"] = Context;
            }
          ),
          /***/
          "./src/index.ts": (
            /*!**********************!*\
              !*** ./src/index.ts ***!
              \**********************/
            /***/
            function(__unused_webpack_module, exports$12, __webpack_require__2) {
              var __importDefault = this && this.__importDefault || function(mod) {
                return mod && mod.__esModule ? mod : { "default": mod };
              };
              Object.defineProperty(exports$12, "__esModule", { value: true });
              exports$12.Context = exports$12.toQuery = exports$12.useMediaQuery = exports$12["default"] = void 0;
              var useMediaQuery_1 = __importDefault(__webpack_require__2(
                /*! ./useMediaQuery */
                "./src/useMediaQuery.ts"
              ));
              exports$12.useMediaQuery = useMediaQuery_1.default;
              var Component_1 = __importDefault(__webpack_require__2(
                /*! ./Component */
                "./src/Component.ts"
              ));
              exports$12["default"] = Component_1.default;
              var toQuery_1 = __importDefault(__webpack_require__2(
                /*! ./toQuery */
                "./src/toQuery.ts"
              ));
              exports$12.toQuery = toQuery_1.default;
              var Context_1 = __importDefault(__webpack_require__2(
                /*! ./Context */
                "./src/Context.ts"
              ));
              exports$12.Context = Context_1.default;
            }
          ),
          /***/
          "./src/mediaQuery.ts": (
            /*!***************************!*\
              !*** ./src/mediaQuery.ts ***!
              \***************************/
            /***/
            function(__unused_webpack_module, exports$12, __webpack_require__2) {
              var __assign2 = this && this.__assign || function() {
                __assign2 = Object.assign || function(t2) {
                  for (var s2, i = 1, n2 = arguments.length; i < n2; i++) {
                    s2 = arguments[i];
                    for (var p2 in s2) if (Object.prototype.hasOwnProperty.call(s2, p2))
                      t2[p2] = s2[p2];
                  }
                  return t2;
                };
                return __assign2.apply(this, arguments);
              };
              var __rest = this && this.__rest || function(s2, e3) {
                var t2 = {};
                for (var p2 in s2) if (Object.prototype.hasOwnProperty.call(s2, p2) && e3.indexOf(p2) < 0)
                  t2[p2] = s2[p2];
                if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
                  for (var i = 0, p2 = Object.getOwnPropertySymbols(s2); i < p2.length; i++) {
                    if (e3.indexOf(p2[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p2[i]))
                      t2[p2[i]] = s2[p2[i]];
                  }
                return t2;
              };
              var __importDefault = this && this.__importDefault || function(mod) {
                return mod && mod.__esModule ? mod : { "default": mod };
              };
              Object.defineProperty(exports$12, "__esModule", { value: true });
              var prop_types_1 = __importDefault(__webpack_require__2(
                /*! prop-types */
                "./node_modules/prop-types/index.js"
              ));
              var stringOrNumber = prop_types_1.default.oneOfType([
                prop_types_1.default.string,
                prop_types_1.default.number
              ]);
              var types = {
                all: prop_types_1.default.bool,
                grid: prop_types_1.default.bool,
                aural: prop_types_1.default.bool,
                braille: prop_types_1.default.bool,
                handheld: prop_types_1.default.bool,
                print: prop_types_1.default.bool,
                projection: prop_types_1.default.bool,
                screen: prop_types_1.default.bool,
                tty: prop_types_1.default.bool,
                tv: prop_types_1.default.bool,
                embossed: prop_types_1.default.bool
              };
              var matchers = {
                orientation: prop_types_1.default.oneOf([
                  "portrait",
                  "landscape"
                ]),
                scan: prop_types_1.default.oneOf([
                  "progressive",
                  "interlace"
                ]),
                aspectRatio: prop_types_1.default.string,
                deviceAspectRatio: prop_types_1.default.string,
                height: stringOrNumber,
                deviceHeight: stringOrNumber,
                width: stringOrNumber,
                deviceWidth: stringOrNumber,
                color: prop_types_1.default.bool,
                colorIndex: prop_types_1.default.bool,
                monochrome: prop_types_1.default.bool,
                resolution: stringOrNumber,
                type: Object.keys(types)
              };
              matchers.type;
              var featureMatchers = __rest(
                matchers,
                ["type"]
              );
              var features = __assign2({ minAspectRatio: prop_types_1.default.string, maxAspectRatio: prop_types_1.default.string, minDeviceAspectRatio: prop_types_1.default.string, maxDeviceAspectRatio: prop_types_1.default.string, minHeight: stringOrNumber, maxHeight: stringOrNumber, minDeviceHeight: stringOrNumber, maxDeviceHeight: stringOrNumber, minWidth: stringOrNumber, maxWidth: stringOrNumber, minDeviceWidth: stringOrNumber, maxDeviceWidth: stringOrNumber, minColor: prop_types_1.default.number, maxColor: prop_types_1.default.number, minColorIndex: prop_types_1.default.number, maxColorIndex: prop_types_1.default.number, minMonochrome: prop_types_1.default.number, maxMonochrome: prop_types_1.default.number, minResolution: stringOrNumber, maxResolution: stringOrNumber }, featureMatchers);
              var all = __assign2(__assign2({}, types), features);
              exports$12["default"] = {
                all,
                types,
                matchers,
                features
              };
            }
          ),
          /***/
          "./src/toQuery.ts": (
            /*!************************!*\
              !*** ./src/toQuery.ts ***!
              \************************/
            /***/
            function(__unused_webpack_module, exports$12, __webpack_require__2) {
              var __importDefault = this && this.__importDefault || function(mod) {
                return mod && mod.__esModule ? mod : { "default": mod };
              };
              Object.defineProperty(exports$12, "__esModule", { value: true });
              var hyphenate_style_name_1 = __importDefault(__webpack_require__2(
                /*! hyphenate-style-name */
                "./node_modules/hyphenate-style-name/index.js"
              ));
              var mediaQuery_1 = __importDefault(__webpack_require__2(
                /*! ./mediaQuery */
                "./src/mediaQuery.ts"
              ));
              var negate = function(cond) {
                return "not ".concat(cond);
              };
              var keyVal = function(k2, v2) {
                var realKey = (0, hyphenate_style_name_1.default)(k2);
                if (typeof v2 === "number") {
                  v2 = "".concat(v2, "px");
                }
                if (v2 === true) {
                  return realKey;
                }
                if (v2 === false) {
                  return negate(realKey);
                }
                return "(".concat(realKey, ": ").concat(v2, ")");
              };
              var join = function(conds) {
                return conds.join(" and ");
              };
              var toQuery = function(obj) {
                var rules = [];
                Object.keys(mediaQuery_1.default.all).forEach(function(k2) {
                  var v2 = obj[k2];
                  if (v2 != null) {
                    rules.push(keyVal(k2, v2));
                  }
                });
                return join(rules);
              };
              exports$12["default"] = toQuery;
            }
          ),
          /***/
          "./src/useMediaQuery.ts": (
            /*!******************************!*\
              !*** ./src/useMediaQuery.ts ***!
              \******************************/
            /***/
            function(__unused_webpack_module, exports$12, __webpack_require__2) {
              var __importDefault = this && this.__importDefault || function(mod) {
                return mod && mod.__esModule ? mod : { "default": mod };
              };
              Object.defineProperty(exports$12, "__esModule", { value: true });
              var react_12 = __webpack_require__2(
                /*! react */
                "react"
              );
              var matchmediaquery_1 = __importDefault(__webpack_require__2(
                /*! matchmediaquery */
                "./node_modules/matchmediaquery/index.js"
              ));
              var hyphenate_style_name_1 = __importDefault(__webpack_require__2(
                /*! hyphenate-style-name */
                "./node_modules/hyphenate-style-name/index.js"
              ));
              var shallow_equal_1 = __webpack_require__2(
                /*! shallow-equal */
                "./node_modules/shallow-equal/dist/index.esm.js"
              );
              var toQuery_1 = __importDefault(__webpack_require__2(
                /*! ./toQuery */
                "./src/toQuery.ts"
              ));
              var Context_1 = __importDefault(__webpack_require__2(
                /*! ./Context */
                "./src/Context.ts"
              ));
              var makeQuery = function(settings) {
                return settings.query || (0, toQuery_1.default)(settings);
              };
              var hyphenateKeys = function(obj) {
                if (!obj)
                  return void 0;
                var keys3 = Object.keys(obj);
                return keys3.reduce(function(result, key) {
                  result[(0, hyphenate_style_name_1.default)(key)] = obj[key];
                  return result;
                }, {});
              };
              var useIsUpdate = function() {
                var ref2 = (0, react_12.useRef)(false);
                (0, react_12.useEffect)(function() {
                  ref2.current = true;
                }, []);
                return ref2.current;
              };
              var useDevice = function(deviceFromProps) {
                var deviceFromContext = (0, react_12.useContext)(Context_1.default);
                var getDevice = function() {
                  return hyphenateKeys(deviceFromProps) || hyphenateKeys(deviceFromContext);
                };
                var _a2 = (0, react_12.useState)(getDevice), device = _a2[0], setDevice = _a2[1];
                (0, react_12.useEffect)(function() {
                  var newDevice = getDevice();
                  if (!(0, shallow_equal_1.shallowEqualObjects)(device, newDevice)) {
                    setDevice(newDevice);
                  }
                }, [deviceFromProps, deviceFromContext]);
                return device;
              };
              var useQuery = function(settings) {
                var getQuery = function() {
                  return makeQuery(settings);
                };
                var _a2 = (0, react_12.useState)(getQuery), query = _a2[0], setQuery = _a2[1];
                (0, react_12.useEffect)(function() {
                  var newQuery = getQuery();
                  if (query !== newQuery) {
                    setQuery(newQuery);
                  }
                }, [settings]);
                return query;
              };
              var useMatchMedia = function(query, device) {
                var getMatchMedia = function() {
                  return (0, matchmediaquery_1.default)(query, device || {}, !!device);
                };
                var _a2 = (0, react_12.useState)(getMatchMedia), mq = _a2[0], setMq = _a2[1];
                var isUpdate = useIsUpdate();
                (0, react_12.useEffect)(function() {
                  if (isUpdate) {
                    var newMq_1 = getMatchMedia();
                    setMq(newMq_1);
                    return function() {
                      if (newMq_1) {
                        newMq_1.dispose();
                      }
                    };
                  }
                }, [query, device]);
                return mq;
              };
              var useMatches = function(mediaQuery) {
                var _a2 = (0, react_12.useState)(mediaQuery.matches), matches = _a2[0], setMatches = _a2[1];
                (0, react_12.useEffect)(function() {
                  var updateMatches = function(ev) {
                    setMatches(ev.matches);
                  };
                  mediaQuery.addListener(updateMatches);
                  setMatches(mediaQuery.matches);
                  return function() {
                    mediaQuery.removeListener(updateMatches);
                  };
                }, [mediaQuery]);
                return matches;
              };
              var useMediaQuery = function(settings, device, onChange2) {
                var deviceSettings = useDevice(device);
                var query = useQuery(settings);
                if (!query)
                  throw new Error("Invalid or missing MediaQuery!");
                var mq = useMatchMedia(query, deviceSettings);
                var matches = useMatches(mq);
                var isUpdate = useIsUpdate();
                (0, react_12.useEffect)(function() {
                  if (isUpdate && onChange2) {
                    onChange2(matches);
                  }
                }, [matches]);
                (0, react_12.useEffect)(function() {
                  return function() {
                    if (mq) {
                      mq.dispose();
                    }
                  };
                }, []);
                return matches;
              };
              exports$12["default"] = useMediaQuery;
            }
          ),
          /***/
          "react": (
            /*!**************************************************************************************!*\
              !*** external {"commonjs":"react","commonjs2":"react","amd":"react","root":"React"} ***!
              \**************************************************************************************/
            /***/
            (module2) => {
              module2.exports = __WEBPACK_EXTERNAL_MODULE_react__;
            }
          )
          /******/
        };
        var __webpack_module_cache__ = {};
        function __webpack_require__(moduleId) {
          var cachedModule = __webpack_module_cache__[moduleId];
          if (cachedModule !== void 0) {
            return cachedModule.exports;
          }
          var module2 = __webpack_module_cache__[moduleId] = {
            /******/
            // no module.id needed
            /******/
            // no module.loaded needed
            /******/
            exports: {}
            /******/
          };
          __webpack_modules__[moduleId].call(module2.exports, module2, module2.exports, __webpack_require__);
          return module2.exports;
        }
        (() => {
          __webpack_require__.d = (exports$12, definition) => {
            for (var key in definition) {
              if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports$12, key)) {
                Object.defineProperty(exports$12, key, { enumerable: true, get: definition[key] });
              }
            }
          };
        })();
        (() => {
          __webpack_require__.o = (obj, prop) => Object.prototype.hasOwnProperty.call(obj, prop);
        })();
        (() => {
          __webpack_require__.r = (exports$12) => {
            if (typeof Symbol !== "undefined" && Symbol.toStringTag) {
              Object.defineProperty(exports$12, Symbol.toStringTag, { value: "Module" });
            }
            Object.defineProperty(exports$12, "__esModule", { value: true });
          };
        })();
        var __webpack_exports__ = __webpack_require__("./src/index.ts");
        return __webpack_exports__;
      })()
    );
  });
})(reactResponsive);
var reactResponsiveExports = reactResponsive.exports;
var e2, r, t, i$1 = function(e3) {
  return e3.replace(/[^\d]/g, "");
}, n = function(e3) {
  return e3.reduce(function(e4, r2) {
    return e4 + r2;
  }, 0);
}, a$1 = function(e3, r2) {
  return e3.slice(0, r2);
}, l = function(e3) {
  var r2 = e3.value;
  return e3.delimiters.forEach(function(e4) {
    e4.split("").forEach(function(e5) {
      r2 = r2.replace(new RegExp(e5.replace(/([.?*+^$[\]\\(){}|-])/g, "\\$1"), "g"), "");
    });
  }), r2;
}, u$1 = function(e3) {
  var r2 = e3.blocks, t2 = e3.delimiter, i = void 0 === t2 ? "" : t2, n2 = e3.delimiters, a2 = void 0 === n2 ? [] : n2, l2 = e3.delimiterLazyShow, u2 = void 0 !== l2 && l2, c2 = "", s2 = e3.value, o = "";
  return r2.forEach(function(e4, t3) {
    if (s2.length > 0) {
      var n3, l3 = s2.slice(0, e4), d2 = s2.slice(e4);
      o = a2.length > 0 ? null != (n3 = a2[u2 ? t3 - 1 : t3]) ? n3 : o : i, u2 ? (t3 > 0 && (c2 += o), c2 += l3) : (c2 += l3, l3.length === e4 && t3 < r2.length - 1 && (c2 += o)), s2 = d2;
    }
  }), c2;
}, c$2 = function(e3) {
  var r2 = e3.delimiter, t2 = e3.delimiters, i = e3.prefix, n2 = void 0 === i ? "" : i, a2 = e3.input;
  if (void 0 !== a2.CLEAVE_ZEN_cursor_tracker) return function() {
    a2.removeEventListener("input", a2.CLEAVE_ZEN_cursor_tracker), a2.CLEAVE_ZEN_cursor_tracker = void 0;
  };
  var u2 = [void 0 === r2 ? "" : r2].concat(void 0 === t2 ? [] : t2);
  return a2.CLEAVE_ZEN_cursor_tracker = function(e4) {
    var r3, t3 = e4.target;
    ("deleteContentBackward" === e4.inputType || t3.value.length !== t3.selectionEnd) && (t3.CLEAVE_ZEN_cleanCursorIndex = function(e5) {
      for (var r4 = e5.value, t4 = e5.dirtyCursorIndex, i2 = e5.delimiters, n3 = t4, a3 = 0; a3 < t4; a3++) i2.includes(r4[a3]) && n3--;
      return n3;
    }({ value: t3.value, dirtyCursorIndex: null != (r3 = t3.selectionEnd) ? r3 : 0, delimiters: u2 }), setTimeout(function() {
      var e5;
      if (l({ value: t3.value, delimiters: u2 }) !== n2) {
        var r4 = function(e6) {
          for (var r5 = e6.value, t4 = e6.delimiters, i2 = e6.cleanCursorIndex, n3 = 0; n3 < r5.length && (t4.includes(r5[n3]) && i2++, n3 !== i2 - 1); n3++) ;
          return i2;
        }({ value: t3.value, cleanCursorIndex: null != (e5 = t3.CLEAVE_ZEN_cleanCursorIndex) ? e5 : 0, delimiters: u2 });
        t3.setSelectionRange(r4, r4);
      }
    }, 0));
  }, a2.addEventListener("input", a2.CLEAVE_ZEN_cursor_tracker), function() {
    a2.removeEventListener("input", a2.CLEAVE_ZEN_cursor_tracker), a2.CLEAVE_ZEN_cursor_tracker = void 0;
  };
}, s$1 = function(e3, r2) {
  var t2 = r2.blocks, n2 = r2.delimiter, a2 = void 0 === n2 ? "" : n2, c2 = r2.delimiters, s2 = void 0 === c2 ? [] : c2, o = r2.delimiterLazyShow, d2 = void 0 !== o && o, v2 = r2.prefix, m2 = void 0 === v2 ? "" : v2, f2 = r2.numericOnly, p2 = void 0 !== f2 && f2, h2 = r2.uppercase, E2 = void 0 !== h2 && h2, g3 = r2.lowercase, I2 = void 0 !== g3 && g3;
  return a2.length > 0 && s2.push(a2), e3 = function(e4) {
    var r3 = e4.value, t3 = e4.prefix, i = e4.tailPrefix, n3 = t3.length;
    return 0 === n3 ? r3 : r3 === t3 && "" !== r3 ? "" : r3.slice(0, n3) === t3 || i ? r3.slice(-n3) !== t3 && i ? "" : i ? r3.slice(0, -n3) : r3.slice(n3) : "";
  }({ value: e3 = l({ value: e3, delimiters: s2 }), prefix: m2, tailPrefix: false }), e3 = p2 ? i$1(e3) : e3, e3 = E2 ? e3.toUpperCase() : e3, e3 = I2 ? e3.toLowerCase() : e3, m2.length > 0 && (e3 = m2 + e3), u$1({ value: e3, blocks: t2, delimiter: a2, delimiters: s2, delimiterLazyShow: d2 });
};
!function(e3) {
  e3.UATP = "uatp", e3.AMEX = "amex", e3.DINERS = "diners", e3.DISCOVER = "discover", e3.MASTERCARD = "mastercard", e3.DANKORT = "dankort", e3.INSTAPAYMENT = "instapayment", e3.JCB15 = "jcb15", e3.JCB = "jcb", e3.MAESTRO = "maestro", e3.VISA = "visa", e3.MIR = "mir", e3.UNIONPAY = "unionpay", e3.GENERAL = "general";
}(t || (t = {}));
var v$d;
(e2 = {})[t.UATP] = [4, 5, 6], e2[t.AMEX] = [4, 6, 5], e2[t.DINERS] = [4, 6, 4], e2[t.DISCOVER] = [4, 4, 4, 4], e2[t.MASTERCARD] = [4, 4, 4, 4], e2[t.DANKORT] = [4, 4, 4, 4], e2[t.INSTAPAYMENT] = [4, 4, 4, 4], e2[t.JCB15] = [4, 6, 5], e2[t.JCB] = [4, 4, 4, 4], e2[t.MAESTRO] = [4, 4, 4, 4], e2[t.VISA] = [4, 4, 4, 4], e2[t.MIR] = [4, 4, 4, 4], e2[t.UNIONPAY] = [4, 4, 4, 4], e2[t.GENERAL] = [4, 4, 4, 4], e2;
(r = {})[t.UATP] = /^(?!1800)1\d{0,14}/, r[t.AMEX] = /^3[47]\d{0,13}/, r[t.DISCOVER] = /^(?:6011|65\d{0,2}|64[4-9]\d?)\d{0,12}/, r[t.DINERS] = /^3(?:0([0-5]|9)|[689]\d?)\d{0,11}/, r[t.MASTERCARD] = /^(5[1-5]\d{0,2}|22[2-9]\d{0,1}|2[3-7]\d{0,2})\d{0,12}/, r[t.DANKORT] = /^(5019|4175|4571)\d{0,12}/, r[t.INSTAPAYMENT] = /^63[7-9]\d{0,13}/, r[t.JCB15] = /^(?:2131|1800)\d{0,11}/, r[t.JCB] = /^(?:35\d{0,2})\d{0,12}/, r[t.MAESTRO] = /^(?:5[0678]\d{0,2}|6304|67\d{0,2})\d{0,12}/, r[t.MIR] = /^220[0-4]\d{0,12}/, r[t.VISA] = /^4\d{0,15}/, r[t.UNIONPAY] = /^(62|81)\d{0,14}/, r;
!function(e3) {
  e3.THOUSAND = "thousand", e3.LAKH = "lakh", e3.WAN = "wan", e3.NONE = "none";
}(v$d || (v$d = {}));
var x$1 = v$d.THOUSAND, M$1 = function(e3, r2) {
  var t2 = null != r2 ? r2 : {}, i = t2.delimiter, n2 = t2.numeralThousandsGroupStyle, a2 = t2.numeralIntegerScale, l2 = t2.numeralDecimalMark, u2 = t2.numeralDecimalScale, c2 = t2.stripLeadingZeroes, s2 = t2.numeralPositiveOnly, o = t2.tailPrefix, d2 = t2.signBeforePrefix, m2 = t2.prefix;
  return function(e4) {
    var r3, t3, i2, n3 = e4.delimiter, a3 = e4.numeralDecimalMark, l3 = e4.numeralDecimalScale, u3 = e4.stripLeadingZeroes, c3 = e4.numeralPositiveOnly, s3 = e4.numeralIntegerScale, o2 = e4.numeralThousandsGroupStyle, d3 = e4.signBeforePrefix, m3 = e4.tailPrefix, f2 = e4.prefix, p2 = "", h2 = e4.value.replace(/[A-Za-z]/g, "").replace(a3, "M").replace(/[^\dM-]/g, "").replace(/^-/, "N").replace(/-/g, "").replace("N", null != c3 && c3 ? "" : "-").replace("M", a3);
    u3 && (h2 = h2.replace(/^(-)?0+(?=\d)/, "$1"));
    var E2 = "-" === h2.slice(0, 1) ? "-" : "";
    switch (t3 = d3 ? E2 + f2 : f2 + E2, i2 = h2, h2.includes(a3) && (i2 = (r3 = h2.split(a3))[0], p2 = a3 + r3[1].slice(0, l3)), "-" === E2 && (i2 = i2.slice(1)), s3 > 0 && (i2 = i2.slice(0, s3)), o2) {
      case v$d.LAKH:
        i2 = i2.replace(/(\d)(?=(\d\d)+\d$)/g, "$1" + n3);
        break;
      case v$d.WAN:
        i2 = i2.replace(/(\d)(?=(\d{4})+$)/g, "$1" + n3);
        break;
      case v$d.THOUSAND:
        i2 = i2.replace(/(\d)(?=(\d{3})+$)/g, "$1" + n3);
    }
    return m3 ? E2 + i2 + (l3 > 0 ? p2 : "") + f2 : t3 + i2 + (l3 > 0 ? p2 : "");
  }({ value: e3, delimiter: void 0 === i ? "," : i, numeralIntegerScale: void 0 === a2 ? 0 : a2, numeralDecimalMark: void 0 === l2 ? "." : l2, numeralDecimalScale: void 0 === u2 ? 2 : u2, stripLeadingZeroes: void 0 === c2 || c2, numeralPositiveOnly: void 0 !== s2 && s2, numeralThousandsGroupStyle: void 0 === n2 ? x$1 : n2, tailPrefix: void 0 !== o && o, signBeforePrefix: void 0 !== d2 && d2, prefix: void 0 === m2 ? "" : m2 });
}, k$2 = ["d", "m", "Y"], C$1 = function(e3, r2) {
  return r2 ? (e3 < 10 ? "000" : e3 < 100 ? "00" : e3 < 1e3 ? "0" : "") + e3 : (e3 < 10 ? "0" : "") + e3;
}, L$1 = function(e3) {
  return (e3 < 10 ? "0" : "") + e3;
}, P$1 = function(e3, r2, t2) {
  var i;
  return e3 = Math.min(e3, 31), t2 = null != (i = t2) ? i : 0, ((r2 = Math.min(r2, 12)) < 7 && r2 % 2 == 0 || r2 > 8 && r2 % 2 == 1) && (e3 = Math.min(e3, 2 === r2 ? function(e4) {
    return e4 % 4 == 0 && e4 % 100 != 0 || e4 % 400 == 0;
  }(t2) ? 29 : 28 : 30)), [e3, r2, t2];
}, y$1 = function(e3, r2) {
  var t2 = null != r2 ? r2 : {}, c2 = t2.delimiterLazyShow, s2 = void 0 !== c2 && c2, o = t2.delimiter, d2 = void 0 === o ? "/" : o, v2 = t2.datePattern, m2 = void 0 === v2 ? k$2 : v2, f2 = t2.dateMax, p2 = void 0 === f2 ? "" : f2, h2 = t2.dateMin, E2 = void 0 === h2 ? "" : h2;
  e3 = i$1(e3);
  var g3 = function(e4) {
    var r3 = [];
    return e4.forEach(function(e5) {
      r3.push("Y" === e5 ? 4 : 2);
    }), r3;
  }(m2), I2 = function(e4) {
    var r3 = e4.dateMax, t3 = e4.dateMin.split("-").reverse().map(function(e5) {
      return parseInt(e5, 10);
    });
    2 === t3.length && t3.unshift(0);
    var i = r3.split("-").reverse().map(function(e5) {
      return parseInt(e5, 10);
    });
    return 2 === i.length && i.unshift(0), { min: t3, max: i };
  }({ dateMax: p2, dateMin: E2 });
  e3 = function(e4) {
    var r3 = e4.value, t3 = void 0 === r3 ? "" : r3, i = e4.blocks, n2 = e4.datePattern, a2 = e4.min, l2 = e4.max, u2 = "";
    return (void 0 === i ? [] : i).forEach(function(e5, r4) {
      if (t3.length > 0) {
        var i2 = t3.slice(0, e5), a3 = i2.slice(0, 1), l3 = t3.slice(e5);
        switch (n2[r4]) {
          case "d":
            "00" === i2 ? i2 = "01" : parseInt(a3, 10) > 3 ? i2 = "0" + a3 : parseInt(i2, 10) > 31 && (i2 = "31");
            break;
          case "m":
            "00" === i2 ? i2 = "01" : parseInt(a3, 10) > 1 ? i2 = "0" + a3 : parseInt(i2, 10) > 12 && (i2 = "12");
        }
        u2 += i2, t3 = l3;
      }
    }), function(e5) {
      var r4, t4, i2, n3 = e5.value, a3 = void 0 === n3 ? "" : n3, l3 = e5.datePattern, u3 = e5.min, c3 = e5.max, s3 = [], o2 = 0, d3 = 0, v3 = 0, m3 = 0, f3 = 0, p3 = 0, h3 = false;
      return 4 === a3.length && "y" !== l3[0].toLowerCase() && "y" !== l3[1].toLowerCase() && (f3 = 2 - (m3 = "d" === l3[0] ? 0 : 2), r4 = parseInt(a3.slice(m3, m3 + 2), 10), t4 = parseInt(a3.slice(f3, f3 + 2), 10), s3 = P$1(r4, t4, 0)), 8 === a3.length && (l3.forEach(function(e6, r5) {
        switch (e6) {
          case "d":
            o2 = r5;
            break;
          case "m":
            d3 = r5;
            break;
          default:
            v3 = r5;
        }
      }), p3 = 2 * v3, m3 = o2 <= v3 ? 2 * o2 : 2 * o2 + 2, f3 = d3 <= v3 ? 2 * d3 : 2 * d3 + 2, r4 = parseInt(a3.slice(m3, m3 + 2), 10), t4 = parseInt(a3.slice(f3, f3 + 2), 10), i2 = parseInt(a3.slice(p3, p3 + 4), 10), h3 = 4 === a3.slice(p3, p3 + 4).length, s3 = P$1(r4, t4, i2)), 4 !== a3.length || "y" !== l3[0] && "y" !== l3[1] || (p3 = 2 - (f3 = "m" === l3[0] ? 0 : 2), t4 = parseInt(a3.slice(f3, f3 + 2), 10), i2 = parseInt(a3.slice(p3, p3 + 2), 10), h3 = 2 === a3.slice(p3, p3 + 2).length, s3 = [0, t4, i2]), 6 !== a3.length || "Y" !== l3[0] && "Y" !== l3[1] || (p3 = 2 - 0.5 * (f3 = "m" === l3[0] ? 0 : 4), t4 = parseInt(a3.slice(f3, f3 + 2), 10), i2 = parseInt(a3.slice(p3, p3 + 4), 10), h3 = 4 === a3.slice(p3, p3 + 4).length, s3 = [0, t4, i2]), 0 === (s3 = function(e6) {
        var r5 = e6.date, t5 = void 0 === r5 ? [] : r5, i3 = e6.min, n4 = e6.max;
        return 0 === t5.length || i3.length < 3 && n4.length < 3 || e6.datePattern.filter(function(e7) {
          return "y" === e7.toLowerCase();
        }).length > 0 && 0 === t5[2] ? t5 : n4.length > 0 && (n4[2] < t5[2] || n4[2] === t5[2] && (n4[1] < t5[1] || n4[1] === t5[1] && n4[0] < t5[0])) ? n4 : i3.length > 0 && (i3[2] > t5[2] || i3[2] === t5[2] && (i3[1] > t5[1] || i3[1] === t5[1] && i3[0] > t5[0])) ? i3 : t5;
      }({ date: s3, datePattern: l3, min: u3, max: c3 })).length ? a3 : l3.reduce(function(e6, r5) {
        switch (r5) {
          case "d":
            return e6 + (0 === s3[0] ? "" : L$1(s3[0]));
          case "m":
            return e6 + (0 === s3[1] ? "" : L$1(s3[1]));
          case "y":
            return e6 + (h3 ? C$1(s3[2], false) : "");
          case "Y":
            return e6 + (h3 ? C$1(s3[2], true) : "");
        }
        return e6;
      }, "");
    }({ value: u2, datePattern: n2, min: a2, max: l2 });
  }({ value: e3, blocks: g3, datePattern: m2, min: I2.min, max: I2.max }), e3 = l({ value: e3, delimiters: [d2] });
  var A3 = n(g3);
  return e3 = a$1(e3, A3), u$1({ value: e3, blocks: g3, delimiter: d2, delimiterLazyShow: s2 });
};
function useRefHandler(forwardedRef) {
  return useMemo(() => {
    const backupRef = {
      current: null
    };
    const shouldUseBackupRef = typeof forwardedRef === "function" || forwardedRef === void 0 || forwardedRef === null;
    const refToUse = shouldUseBackupRef ? backupRef : forwardedRef;
    const refHandler = (ref2) => {
      if (ref2) {
        backupRef.current = ref2;
        if (forwardedRef) {
          if (typeof forwardedRef === "function") {
            forwardedRef(ref2);
          }
          if (typeof forwardedRef === "object" && forwardedRef !== null) {
            forwardedRef.current = ref2;
          }
        }
      }
    };
    return {
      ref: refToUse,
      refHandler
    };
  }, [forwardedRef]);
}
function useCursorTracker(delimiters, forwardedRef) {
  const {
    ref: ref2,
    refHandler
  } = useRefHandler(forwardedRef);
  useEffect(() => {
    if (ref2 == null ? void 0 : ref2.current) {
      const unregister = c$2({
        // This is a bit of a hack to get around the fact that it is typed to not accept TextAreaElements, although it does support them.
        input: ref2.current,
        delimiters
      });
      return () => unregister();
    }
    return void 0;
  }, []);
  return {
    refHandler
  };
}
function useControlledInput({
  controlledValue,
  defaultValue,
  onChange: outerOnChange,
  formatter
}) {
  const [internalValue, setInternalValue] = useState(controlledValue ?? defaultValue ?? "");
  const onChange2 = (e3) => {
    if (formatter) {
      e3.target.value = formatter(e3.target.value);
    }
    if (outerOnChange) {
      outerOnChange(e3);
    }
    setInternalValue(e3.target.value);
  };
  const value = formatter ? formatter((controlledValue ?? internalValue).toString()) : controlledValue ?? internalValue;
  return [value, onChange2];
}
const caretColor = system({
  caretColor: {
    property: "caretColor"
  }
});
const getEffectiveMarginTop = (props) => props.marginTop || props.mt || props.my || props.margin || props.m;
const getEffectiveMarginBottom = (props) => props.marginBottom || props.mb || props.my || props.margin || props.m;
const getEffectiveMarginRight = (props) => props.marginRight || props.mr || props.mx || props.margin || props.m;
const getEffectiveMarginLeft = (props) => props.marginLeft || props.ml || props.mx || props.margin || props.m;
const positionInputElement$1 = (props) => css$3`
  margin-top: calc(${getEffectiveMarginTop(props)} * 1.5);
  margin-bottom: calc(${getEffectiveMarginBottom(props)} * 0.5);
  width: calc(
    100% - ${getEffectiveMarginLeft(props) || "0px"} -
      ${getEffectiveMarginRight(props) || "0px"}
  );
  height: calc(
    100% - ${getEffectiveMarginTop(props) || "0px"} -
      ${getEffectiveMarginBottom(props) || "0px"}
  );
`;
const MaskWrapperSpan = styled.span`
  /* Note: space props come from the parent container's styling, not maskStyles */
  position: absolute;
  top: 0;
  left: 0;
  margin: 0;
  /* Z index must be below the input element values (input is set to 2) */
  z-index: 1;
  box-sizing: border-box;
  border: none;
  opacity: 0;
  transition: opacity 0.2s ease;
  pointer-events: none;
  display: flex;
  align-items: center;
  ${compose(space, typography, color)};
  ${(props) => positionInputElement$1(props)}
  ${(props) => props.variant === "numeric" && `font-feature-settings: 'tnum' on, 'lnum' on;`}
`;
const MaskOffset = styled.div`
  ${compose(typography)};
`;
const InputMask = ({
  mask,
  value,
  spaceProps,
  typographyProps,
  ...rest
}) => {
  var _a2;
  const valueLength = ((_a2 = value == null ? void 0 : value.toString()) == null ? void 0 : _a2.length) ?? 0;
  const regexPattern = new RegExp(`^.{${valueLength}}`);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    MaskWrapperSpan,
    {
      ...spaceProps,
      ...typographyProps,
      ...rest,
      id: "axe-exclude",
      "aria-hidden": "true",
      translate: "no",
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(MaskOffset, { ...typographyProps, className: "fs-exclude", children: value }),
        mask.replace(regexPattern, "")
      ]
    }
  );
};
const inputStates = [Pseudostate.hover, Pseudostate.active, Pseudostate["focus-visible"], Pseudostate["focus-within"], Pseudostate.invalid, Pseudostate.disabled];
const AssistiveText = styled.div`
  ${composeWrapper([typography, color, layout, space, shadow, flexbox, grid], inputStates)}
`;
const AssistiveTextWrapper = ({
  assistiveText,
  assistiveTextPlacement = "bottom",
  invalid,
  children,
  className,
  id: id2,
  ...rest
}) => {
  if (assistiveTextPlacement === "top") {
    return /* @__PURE__ */ jsxRuntimeExports.jsxs(Fragment, { children: [
      assistiveText && /* @__PURE__ */ jsxRuntimeExports.jsx(AssistiveText, { id: `assistiveText-${id2}`, ...rest, className: `${className} ${invalid ? "invalid" : ""}`, children: assistiveText }),
      children
    ] });
  }
  if (assistiveTextPlacement === "bottom") {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(Fragment, { children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Fragment, { children: [
      children,
      assistiveText && /* @__PURE__ */ jsxRuntimeExports.jsx(AssistiveText, { id: `assistiveText-${id2}`, ...rest, className: `${className} ${invalid ? "invalid" : ""}`, children: assistiveText })
    ] }) });
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Fragment, { children });
};
const autofillAnimation = keyframes$1`
  from { display: block; }
`;
const AUTOFILL_ANIMATION_NAME = autofillAnimation.getName();
const autofillDetectionStyles = css$3`
  /* Deliberately two rules rather than one selector list: a pseudo-class the
     browser doesn't know invalidates the whole list, which would take the
     supported one down with it.

     MUI runs the same keyframe for 5000s so the animation stays live and a
     second one can signal the fill being cleared. We only ever read
     animationstart, so the duration is cut to the shortest thing that still
     emits it — which also keeps the discrete display flip sub-frame. */
  &:-webkit-autofill {
    animation-name: ${autofillAnimation};
    animation-duration: 1ms;
  }
  &:autofill {
    animation-name: ${autofillAnimation};
    animation-duration: 1ms;
  }
`;
const setValueUntrackedByReact = (node2, nextValue) => {
  var _a2;
  const prototype = node2 instanceof HTMLTextAreaElement ? HTMLTextAreaElement.prototype : HTMLInputElement.prototype;
  const setter = (_a2 = Object.getOwnPropertyDescriptor(prototype, "value")) == null ? void 0 : _a2.set;
  if (setter) {
    setter.call(node2, nextValue);
  } else {
    node2.value = nextValue;
  }
};
const textInputStates$1 = [Pseudostate.hover, Pseudostate.active, Pseudostate["focus-visible"], Pseudostate.invalid, Pseudostate["focus-within"], Pseudostate.disabled];
const labelTransformationStyles$2 = (marginTop) => css$3`
  transform: translateY(calc(-1 * (${marginTop} / 2)));
  /* TODO: hardcoded values, probably should be themed */
  margin-top: 12px;
  margin-bottom: 14px;
  font-size: 12px;
  line-height: 12px;
`;
const LabelTextStyles = css$3`
  transition: 0.2s all ease;
  position: absolute;
  cursor: text;
  left: 0;
  top: 0;
  line-height: 24px;
  height: calc(
    100% -
      ${(props) => `${getEffectiveMarginTop(props) || "0px"} - ${getEffectiveMarginBottom(props) || "0px"}`}
  );
  margin: 12px ${(props) => props.iconRight ? "0px" : "16px"} 14px
    ${(props) => props.iconLeft ? "0px" : "16px"};
  ${composeWrapper([typography, color], textInputStates$1)}
`;
const LabelTextSpan = styled.span`
  ${LabelTextStyles}
`;
const InputElementStyles = css$3`
  resize: none;
  overflow: auto;
  /* Width is set to 100% minus the margin on each side */
  width: calc(
    100% -
      ${(props) => `${getEffectiveMarginLeft(props) || "0px"} - ${getEffectiveMarginRight(props) || "0px"}`}
  );
  position: ${(props) => props.multiline ? "relative" : "absolute"};
  top: 0;
  left: 0;
  margin: 0;
  margin-top: 12px;
  margin-bottom: 14px;
  padding: 0;
  box-sizing: border-box;
  border: none;
  /* Z index needs to be above the mask (mask is set to 1) */
  z-index: 2;

  &::-webkit-input-placeholder {
    /* WebKit browsers */
    transition: opacity 0.2s ease;
    opacity: 0;
  }
  &:-moz-placeholder {
    /* Mozilla Firefox 4 to 18 */
    transition: opacity 0.2s ease;
    opacity: 0;
  }
  &::-moz-placeholder {
    /* Mozilla Firefox 19+ */
    transition: opacity 0.2s ease;
    opacity: 0;
  }
  &:-ms-input-placeholder {
    /* Internet Explorer 10+ */
    transition: opacity 0.2s ease;
    opacity: 0;
  }

  &:focus,
  &:focus-visible,
  &.focus-visible,
  &.focus {
    outline: none;
    &::-webkit-input-placeholder {
      /* WebKit browsers */
      opacity: 1;
    }
    &:-moz-placeholder {
      /* Mozilla Firefox 4 to 18 */
      opacity: 1;
    }
    &::-moz-placeholder {
      /* Mozilla Firefox 19+ */
      opacity: 1;
    }
    &:-ms-input-placeholder {
      /* Internet Explorer 10+ */
      opacity: 1;
    }
  }
  /* If the input is able to have a placeholder, (a text-based input), then we can translate the label based on
     when the placeholder is not shown; which is when there is a value in the input.
     This is a neat way using pure CSS to detect if a user has input any value */
  ${(props) => props.usesPlaceholder && css$3`
      &:not(:placeholder-shown) + ${LabelTextSpan} {
        ${labelTransformationStyles$2(props.marginTop || props.mt || props.my || props.margin || props.m || "0px")}
      }
    `};

  /* The CSS placeholder trick above only works on text based inputs. However, SelectInput also uses these styles
     and needs to have a JS value passed down to tell the input if the user has provided a value.
     So, whenever a value exists in the input, we translate the label above. */
  ${(props) => props.hasValue && css$3`
      & + ${LabelTextSpan}, & + label {
        ${labelTransformationStyles$2(props.marginTop || props.mt || props.my || props.margin || props.m || "0px")}
      }
    `}

  /* Translate the input halfway into the bottom padding */
  ${composeWrapper([space, typography, color], textInputStates$1)}
  /* Positions the input element to be in the lower 30% of the configured margin */
  ${(props) => positionInputElement$1(props)}
  background: none !important;
  /* WebKit/Blink paint a disabled input's value via -webkit-text-fill-color
     (a browser-default gray) which overrides \`color\`, so mirror the disabled
     value token here and reset the UA opacity to keep it exactly on-disabled. */
  &:disabled {
    -webkit-text-fill-color: var(${TOKENS.color.foreground.interaction.onDisabled});
    opacity: 1;
  }
  ${(props) => props.variant === "numeric" && `font-feature-settings: 'tnum' on, 'lnum' on;`}
`;
const StyledInput$2 = styled.input`
  ${InputElementStyles}
  ${autofillDetectionStyles}
`;
const InputContainer = styled.span`
  -webkit-font-smoothing: antialiased;
  position: relative;
  width: 100%;
  height: 100%;
  min-width: 1px;
  min-height: 1px;
  display: flex;
`;
const IconContainer$2 = styled.span`
  ${(props) => props.position === "left" && css$3`
      padding-right: ${props.iconSpacingToContent};
      padding-left: ${props.iconSpacingToEdge};
    `}
  ${(props) => props.position === "right" && css$3`
      padding-left: ${props.iconSpacingToContent};
      padding-right: ${props.iconSpacingToEdge};
    `}
  display: flex;
  align-items: center;
`;
const InputWrapperStyles = css$3`
  position: relative;
  display: flex;
  box-sizing: border-box;
  width: 100%;
  border-style: solid;
  outline-style: solid;
  outline-width: 0;
  cursor: text;
  ${composeWrapper([layout, background, position$1, shadow, border, outline, caretColor, color], textInputStates$1)}
  &:focus-within,
  &.focus-within {
    & ${MaskWrapperSpan} {
      opacity: 1;
    }
    & ${LabelTextSpan} {
      ${(props) => props.moveLabelOnFocus && labelTransformationStyles$2(props.marginTop || props.mt || props.my || props.margin || props.m || "0px")}
    }
  }
  ${(props) => props.forceShowMask && `    & ${MaskWrapperSpan} {
      opacity: 1;
    }`}
  &.disabled,
  &.disabled * {
    cursor: not-allowed;
  }
  ${(props) => props.multiline && "overflow: auto;"}
`;
const LabelWrapper = styled.label`
  /* Trap z-index inside so that we don't cause side effects due to z-index conflicts with consumers */
  isolation: isolate;
  ${InputWrapperStyles}
  ${(props) => props.isSafari && css$3`
      outline: none;
    `}
`;
const INPUT_STYLE_PROPS = {
  height: "48px",
  margin: "16px",
  marginBottom: "12px",
  marginTop: "14px",
  borderWidth: "1px",
  borderColor: `var(${TOKENS.color.border.interaction.neutral})`,
  borderRadius: `var(${TOKENS.dimension.radius.interaction.inputLarge})`,
  caretColor: `var(${TOKENS.color.border.focus})`,
  color: `var(${TOKENS.color.foreground.default})`,
  bg: `var(${TOKENS.color.background.surface0})`,
  iconSpacingToEdge: "14px",
  iconSpacingToContent: "10px",
  // Typography — headerSmall.desktop (fontSize/lineHeight carrier-invariant)
  fontFamily: `var(${TOKENS.text.fontFamily.primary})`,
  fontSize: "1rem",
  lineHeight: "140%",
  fontWeight: `var(${TOKENS.text.fontWeight.default})`,
  hoverStyle: {
    outlineWidth: "1px",
    outline: "none",
    boxShadow: `0 0 0 1px var(${TOKENS.color.border.interaction.neutralHover})`,
    borderColor: `var(${TOKENS.color.border.interaction.neutralHover})`
  },
  focusStyle: {
    boxShadow: `0 0 0 1px var(${TOKENS.color.border.focus})`,
    borderColor: `var(${TOKENS.color.border.focus})`,
    outlineColor: `var(${TOKENS.color.border.focus})`
  },
  invalidStyle: {
    boxShadow: `0 0 0 1px var(${TOKENS.color.border.feedback.danger})`,
    borderColor: `var(${TOKENS.color.border.feedback.danger})`,
    outlineColor: `var(${TOKENS.color.border.feedback.danger})`
  },
  disabledStyle: {
    backgroundColor: `var(${TOKENS.color.background.interaction.neutralDisabled})`,
    // Same as the base border, but explicit so it wins over hover styles
    borderColor: `var(${TOKENS.color.border.interaction.neutral})`,
    borderWidth: "1px",
    fontWeight: "400",
    boxShadow: "none",
    color: `var(${TOKENS.color.foreground.interaction.onDisabled})`
  },
  // For the Caret Down Icon within Selects
  selectIconColor: `var(${TOKENS.color.foreground.default})`,
  labelStyles: {
    // Typography — bodyMedium.desktop
    fontFamily: `var(${TOKENS.text.fontFamily.primary})`,
    fontSize: "1rem",
    lineHeight: "140%",
    color: `var(${TOKENS.color.foreground.subdued})`,
    fontWeight: `var(${TOKENS.text.fontWeight.default})`,
    // `disabledColor` is the scalar SelectInput reads; `disabledStyle` is what
    // composeWrapper applies for the base TextInput label's disabled state.
    disabledColor: `var(${TOKENS.color.foreground.interaction.onDisabled})`,
    disabledStyle: {
      color: `var(${TOKENS.color.foreground.interaction.onDisabled})`
    }
  },
  placeholderStyles: {
    // Typography — bodyMedium.desktop
    fontFamily: `var(${TOKENS.text.fontFamily.primary})`,
    fontSize: "1rem",
    lineHeight: "140%",
    color: `var(${TOKENS.color.foreground.subdued}) !important`
  },
  assistiveTextStyles: {
    marginTop: "4px",
    // Typography — bodyXSmall.desktop
    fontFamily: `var(${TOKENS.text.fontFamily.primary})`,
    fontSize: "0.75rem",
    lineHeight: "140%",
    color: `var(${TOKENS.color.foreground.default})`,
    invalidStyle: {
      color: `var(${TOKENS.color.foreground.feedback.danger})`
    }
  },
  maskStyles: {
    color: `var(${TOKENS.color.foreground.interaction.disabled})`
  }
};
const INPUT_NUMERIC_VARIANT_STYLE_PROPS = {
  fontFamily: `var(${TOKENS.text.fontFamily.primary})`
};
const TextInput = forwardRef((props, forwardedRef) => {
  var _a2;
  const {
    type: type2 = "text",
    variant,
    label,
    assistiveText,
    assistiveTextPlacement = "bottom",
    assistiveTextStyles,
    labelStyles,
    value: controlledValue,
    invalid,
    className = "",
    mask,
    iconRight,
    iconLeft,
    iconSpacing,
    disabled,
    maskStyles,
    id: id2,
    forceShowMask,
    multiline,
    placeholder,
    defaultValue,
    formatter,
    allCaps,
    replacementRegex,
    ...rest
  } = props;
  const kindredConfig = useKindredConfigOptional();
  const allCapsValue = allCaps ?? ((_a2 = kindredConfig == null ? void 0 : kindredConfig.misc) == null ? void 0 : _a2.inputAllCaps) ?? false;
  const regexFormatter = replacementRegex ? (value2) => value2.replace(new RegExp(replacementRegex, "g"), "") : void 0;
  const wrappedFormatter = (value2) => {
    let result = value2;
    if (regexFormatter) {
      result = regexFormatter(result);
    }
    if (formatter) {
      result = formatter(result);
    }
    if (allCapsValue) {
      result = result.toUpperCase();
    }
    return result;
  };
  const finalFormatter = regexFormatter || formatter || allCapsValue ? wrappedFormatter : void 0;
  const [value, onChange2] = useControlledInput({
    controlledValue,
    onChange: props.onChange,
    defaultValue,
    formatter: finalFormatter
  });
  const handleAnimationStart = (event) => {
    var _a3;
    (_a3 = rest.onAnimationStart) == null ? void 0 : _a3.call(rest, event);
    if (event.animationName !== AUTOFILL_ANIMATION_NAME) {
      return;
    }
    const node2 = event.currentTarget;
    const filledValue = node2.value;
    if (filledValue === String(value ?? "")) {
      return;
    }
    queueMicrotask(() => {
      if (node2.value !== filledValue) {
        setValueUntrackedByReact(node2, filledValue);
      }
      node2.dispatchEvent(new Event("input", {
        bubbles: true
      }));
    });
  };
  const inputRefForwarder = useMemo(() => (node2) => {
    if (typeof forwardedRef === "function") {
      forwardedRef(node2);
    } else if (forwardedRef) {
      forwardedRef.current = node2;
    }
  }, [forwardedRef]);
  const {
    refHandler
  } = useCursorTracker([], inputRefForwarder);
  const themedProps = {
    ...INPUT_STYLE_PROPS,
    ...variant === "numeric" ? INPUT_NUMERIC_VARIANT_STYLE_PROPS : {}
  };
  const allProps = {
    ...themedProps,
    ...props
  };
  const spaceProps = selectStyledSystemProps(allProps, ["space"]);
  const typographyProps = selectStyledSystemProps(allProps, ["typography"]);
  const layoutProps = selectStyledSystemProps(allProps, ["layout"]);
  const browser = useMemo(() => detect(), []);
  const isSafari = !browser || (browser == null ? void 0 : browser.name) === "safari";
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Fragment, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(AssistiveTextWrapper, { assistiveText, assistiveTextPlacement, id: id2, invalid, ...themedProps.assistiveTextStyles, ...assistiveTextStyles, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(LabelWrapper, { htmlFor: id2, ...themedProps, className: `${className} ${invalid ? "invalid" : ""} ${disabled ? "disabled" : ""}`, iconRight: !!iconRight, iconLeft: !!iconLeft, forceShowMask, moveLabelOnFocus: true, multiline, ...layoutProps, isSafari, children: [
    iconLeft && /* @__PURE__ */ jsxRuntimeExports.jsx(IconContainer$2, { ...spaceProps, iconSpacingToContent: iconSpacing || themedProps.iconSpacingToContent, iconSpacingToEdge: iconSpacing || themedProps.iconSpacingToEdge, position: "left", children: iconLeft }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(InputContainer, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        StyledInput$2,
        {
          ...themedProps,
          ...assistiveText ? {
            "aria-errormessage": `assistiveText-${id2}`
          } : {},
          ...rest,
          ...iconLeft && {
            marginLeft: "0px"
          },
          ...iconRight && {
            marginRight: "0px"
          },
          ...multiline && {
            marginLeft: "0px",
            marginRight: "0px",
            padding: "0px 16px"
          },
          type: type2,
          id: id2,
          value,
          ...assistiveText ? {
            "aria-describedby": `assistiveText-${id2}`
          } : {},
          disabled,
          onChange: onChange2,
          onAnimationStart: handleAnimationStart,
          "aria-label": label,
          hasValue: value !== void 0 && value !== "",
          variant,
          placeholder: placeholder || " ",
          usesPlaceholder: true,
          "data-isinvalid": !!invalid,
          "aria-invalid": !!invalid,
          ref: refHandler,
          as: multiline ? "textarea" : "input",
          multiline,
          ...multiline && {
            rows: "1"
          }
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        LabelTextSpan,
        {
          ...spaceProps,
          ...themedProps.labelStyles,
          ...labelStyles,
          className: disabled ? "disabled" : "",
          iconRight: !!iconRight,
          iconLeft: !!iconLeft,
          "aria-hidden": "true",
          children: label
        }
      ),
      mask && /* @__PURE__ */ jsxRuntimeExports.jsx(InputMask, { ...themedProps.maskStyles, ...maskStyles, ...disabled && {
        color: `var(${TOKENS.color.foreground.interaction.onDisabled})`
      }, ...iconLeft && {
        marginLeft: "0px"
      }, ...iconRight && {
        marginRight: "0px"
      }, typographyProps, spaceProps, mask, value, variant })
    ] }),
    iconRight && /* @__PURE__ */ jsxRuntimeExports.jsx(IconContainer$2, { ...spaceProps, iconSpacingToContent: iconSpacing || themedProps.iconSpacingToContent, iconSpacingToEdge: iconSpacing || themedProps.iconSpacingToEdge, position: "right", children: iconRight })
  ] }) }) });
});
TextInput.displayName = "TextInput";
const BUTTON_GROUP_SIZES = ["small", "medium", "large"];
const BUTTON_GROUP_PADDING_BY_SIZE = {
  small: {
    px: "16px",
    paddingTop: "11px",
    paddingBottom: "11px"
  },
  medium: {
    px: "16px",
    paddingTop: "15px",
    paddingBottom: "15px"
  },
  large: {
    px: "24px",
    paddingTop: "18px",
    paddingBottom: "18px"
  }
};
const VerticalContainerStyles = css$3`
  flex-direction: column;
  text-align: center;
  box-sizing: border-box;

  ${(props) => compose(layout, flexbox, border)(props.verticalStyle || {})}

  // Vertical styles
  // This compose has to go here in order to spread styles down to the lower elements (instead of on those elements)
  // This is because the container is the only component that knows about the vertical state
  & > label, & > label > input {
    border-radius: 0;
    ${(props) => compose(color, layout, grid, flexbox, padding, typography, position$1, shadow)(props.verticalStyle || {})}
  }
  & > label {
    border-left-width: ${(props) => props.$borderWidth || props.borderWidth || "1px"};
  }
  & > label:not(:first-of-type) {
    /* Allows the borders of the buttons to appear "collapsed", so a 1px border doesn't look like 2px */
    margin-top: -1px;
  }
  // Border at the bottom of each elemennt (except last)
  & > label:not(:last-child) {
    border-bottom-width: ${(props) => props.$borderWidth || props.borderWidth || "1px"};
  }
  // First element needs a border top
  & > label:first-of-type {
    border-top-width: ${(props) => `${props.$borderWidth || props.borderWidth || "1px"}`};
  }
  & > label:first-of-type,
  & > label:first-of-type > input {
    padding-top: ${(props) => props.$startPadding || props.startPadding};
    border-top-right-radius: var(${TOKENS.dimension.radius.surface2});
    border-top-left-radius: var(${TOKENS.dimension.radius.surface2});
  }

  & > label:last-child,
  & > label:last-child > input {
    padding-bottom: ${(props) => props.$endPadding || props.endPadding};
    border-bottom-right-radius: var(${TOKENS.dimension.radius.surface2});
    border-bottom-left-radius: var(${TOKENS.dimension.radius.surface2});
  }
`;
const HorizontalContainerStyles = css$3`
  & > label,
  & > label > input {
    border-radius: 0;
  }
  & > label:not(:last-child) {
    border-right-width: ${(props) => props.$borderWidth || props.borderWidth || "1px"};
  }

  & > label:first-of-type {
    border-left-width: ${(props) => `${props.$borderWidth || props.borderWidth || "1px"}`};
  }

  & > label:first-of-type,
  & > label:first-of-type > input {
    padding-left: ${(props) => props.$startPadding || props.startPadding};
    border-bottom-left-radius: var(${TOKENS.dimension.radius.surface2});
    border-top-left-radius: var(${TOKENS.dimension.radius.surface2});
  }

  & > label:last-child,
  & > label:last-child > input {
    padding-right: ${(props) => props.$endPadding || props.endPadding};
    border-bottom-right-radius: var(${TOKENS.dimension.radius.surface2});
    border-top-right-radius: var(${TOKENS.dimension.radius.surface2});
  }
`;
const v$c = (token2) => `var(${token2})`;
const BUTTON_GROUP_BASE_STYLE = {
  borderStyle: "solid",
  borderWidth: "1px",
  borderColor: v$c(TOKENS.color.border.interaction.neutral),
  bg: v$c(TOKENS.color.background.interaction.neutral),
  color: v$c(TOKENS.color.foreground.default),
  borderRadius: "6px",
  fontFamily: v$c(TOKENS.text.fontFamily.primary),
  fontWeight: v$c(TOKENS.text.fontWeight.default),
  fontSize: "1rem",
  letterSpacing: "0em",
  lineHeight: "1.125rem",
  hoverStyle: {
    bg: v$c(TOKENS.color.background.interaction.neutralHover),
    borderColor: v$c(TOKENS.color.border.interaction.neutralHover),
    borderStyle: "solid",
    borderWidth: "1px"
  },
  invalidStyle: {
    borderColor: v$c(TOKENS.color.border.feedback.danger)
  },
  unselectedStyle: {
    bg: v$c(TOKENS.color.background.interaction.neutral)
  },
  activeStyle: {
    bg: v$c(TOKENS.color.background.interaction.neutralActive),
    borderColor: v$c(TOKENS.color.border.interaction.neutralHover)
  },
  disabledStyle: {
    bg: v$c(TOKENS.color.background.interaction.neutralDisabled),
    color: v$c(TOKENS.color.foreground.interaction.disabled)
  },
  selectedDisabledStyle: {
    // Legacy: darken(0.15, forms.fill.disabled). `interaction.disabled` is the
    // token for "typically interactive but currently disabled" backgrounds,
    // which is the darker step this was reaching for.
    bg: v$c(TOKENS.color.background.interaction.disabled),
    color: v$c(TOKENS.color.foreground.default),
    // Same weight as the selected variant, for consistency across carriers.
    fontWeight: "500",
    borderColor: v$c(TOKENS.color.border.interaction.accentDisabled)
  },
  focusRingStyle: {
    gap: "1px",
    width: "2px",
    borderRadius: "4px",
    color: v$c(TOKENS.color.border.focus)
  },
  verticalStyle: {
    px: "24px",
    startPadding: void 0,
    endPadding: void 0
  }
};
const BUTTON_GROUP_SELECTED_STYLE = {
  fontWeight: "500",
  bg: v$c(TOKENS.color.background.interaction.neutralSelected),
  // The legacy theme computed this with readableColor() against the selected
  // fill's luminance; the token system expresses the same intent directly.
  color: v$c(TOKENS.color.foreground.interaction.onSelected),
  borderColor: v$c(TOKENS.color.border.interaction.neutralSelected),
  borderStyle: "solid",
  borderWidth: "1px",
  hoverStyle: {
    bg: v$c(TOKENS.color.background.interaction.neutralSelectedHover),
    borderColor: v$c(TOKENS.color.border.interaction.neutralSelected),
    borderStyle: "solid",
    borderWidth: "1px"
  },
  activeStyle: {
    bg: v$c(TOKENS.color.background.interaction.neutralSelectedHover),
    borderColor: v$c(TOKENS.color.border.interaction.neutralSelected),
    borderStyle: "solid",
    borderWidth: "1px"
  }
};
const buttonGroupStyle = (variant) => ({
  ...BUTTON_GROUP_BASE_STYLE,
  ...variant === "selected" ? BUTTON_GROUP_SELECTED_STYLE : {}
});
const ButtonGroupContainerFieldSet = styled.fieldset.withConfig({
  shouldForwardProp: kindredShouldForwardProp
})`
  position: relative;
  display: flex;
  width: min-content;
  margin: 0;
  padding: 0;
  border: none;
  /* Trap z-index inside so that we don't cause side effects due to z-index conflicts with consumers */
  isolation: isolate;
  ${(props) => props.$vertical || props.vertical ? VerticalContainerStyles : HorizontalContainerStyles}

  ${compose(layout, flexbox, margin)}
`;
const UnstyledLegend = styled.legend`
  display: none;
`;
const ButtonGroupContainer = ({
  variant,
  children,
  verticalStyle,
  size: size2,
  labelText,
  isVertical,
  setRef,
  // Destructure to prevent forwarding to DOM (styled-components v6 transient props pattern)
  vertical: _vertical,
  verticalSwapBreakpoint: _verticalSwapBreakpoint,
  ...rest
}) => {
  const themeProps = buttonGroupStyle(variant);
  const resolvedIsVertical = isVertical ?? _vertical ?? false;
  const verticalStyleProps = {
    ...themeProps.verticalStyle,
    ...verticalStyle
  };
  const combinedProps = {
    ...themeProps,
    ...rest,
    ...resolvedIsVertical && verticalStyleProps
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    ButtonGroupContainerFieldSet,
    {
      ...themeProps,
      ...rest,
      ...resolvedIsVertical && verticalStyleProps,
      $vertical: resolvedIsVertical,
      $borderWidth: combinedProps.borderWidth,
      $borderRadius: combinedProps.borderRadius,
      $startPadding: combinedProps.startPadding,
      $endPadding: combinedProps.endPadding,
      "data-isvertical": resolvedIsVertical,
      ref: (el) => {
        if (setRef) {
          setRef(el);
        }
      },
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(UnstyledLegend, { children: labelText }),
        children
      ]
    }
  );
};
const labelStyledSystemProps = [color, layout, grid, flexbox, padding, typography, position$1, shadow, outline];
const ButtonGroupLabelElement = styled.label.withConfig({
  shouldForwardProp: kindredShouldForwardProp
})`
  position: relative;
  cursor: pointer;
  border-style: solid;
  display: flex;
  align-items: center;
  justify-content: center;
  /* Set right margin to -1 so we can have 1px border pixel all the way around and have it only look like 1px instead of 2 between buttons */
  ${(props) => !props.$isVertical ? css$3`
          &:not(:last-child) {
            margin-right: -1px;
          }
        ` : null}

  /* The label is the visual container that has the text, background color, and outer border styles */
  ${(props) => composeWrapper([...labelStyledSystemProps, borderColor, borderTop, borderLeft, borderBottom, borderRight, borderWidth, borderStyle], [
  Pseudostate.selected,
  Pseudostate.unselected,
  Pseudostate.invalid,
  Pseudostate.disabled,
  Pseudostate.selectedDisabled,
  // Disabling the element doesn't disable the active or hover state from showing, so we have to work around it here
  ...props.disabled ? [] : [Pseudostate.hover, Pseudostate.active]
])}

  ${bodyStyles({
  responsive: false
})}
  line-height: normal;

  ${(props) => props.selected ? css$3`
          color: var(${TOKENS.color.foreground.interaction.onSelected});
        ` : null}

  ${(props) => {
  const btnGroupSize = BUTTON_GROUP_PADDING_BY_SIZE[props.size ?? "large"];
  return css$3`
      padding-top: ${btnGroupSize.paddingTop};
      padding-bottom: ${btnGroupSize.paddingBottom};
      padding-left: ${btnGroupSize.px};
      padding-right: ${btnGroupSize.px};
    `;
}}

  &.disabled {
    /* Need to default to previous to ensure no hover/active colors are showing */
    & > input {
      border: none;
      cursor: not-allowed;
    }
  }
  /* Bumps the z-index up for states that need their border to appear "on top" */
  /* Disabled buttons should not get z-index bump on hover/active to avoid border glitches */
  &.hover:not(.disabled),
  &:hover:not(.disabled),
  &.focus,
  &:focus,
  &.focus-visible,
  &:focus-visible,
  &.selected,
  &:checked,
  &.active:not(.disabled),
  &:active:not(.disabled) {
    z-index: 1;
  }

  ${(props) => props.selected ? css$3`
          z-index: 1;
        ` : null}
`;
const ButtonGroupLabel = forwardRef(({
  invalid,
  variant,
  disabled,
  size: size2,
  $isVertical,
  className: propsClassName,
  ...rest
}, ref2) => {
  const resolvedIsVertical = $isVertical ?? rest.isVertical ?? rest.vertical;
  const calculatedVariant = rest.selected ? "selected" : variant;
  const themeProps = buttonGroupStyle(calculatedVariant);
  const isSelectedDisabled = rest.selected && disabled;
  const computedClassName = `${invalid ? Pseudostate.invalid : ""} ${disabled ? Pseudostate.disabled : ""} ${isSelectedDisabled ? Pseudostate.selectedDisabled : ""} ${propsClassName || ""}`.trim();
  const labelSize = size2 === "small" || size2 === "medium" ? "small" : "medium";
  return /* @__PURE__ */ jsxRuntimeExports.jsx(ButtonGroupLabelElement, { ...themeProps, ...rest, size: size2, className: computedClassName, disabled, selectedDisabled: isSelectedDisabled, $isVertical: resolvedIsVertical, $size: labelSize, ref: ref2 });
});
ButtonGroupLabel.displayName = "ButtonGroupLabel";
const inputStyledSystemProps = [grid, flexbox, padding, typography, position$1, shadow];
const ButtonGroupInputElement = styled.input.withConfig({
  shouldForwardProp: kindredShouldForwardProp
})`
  appearance: none;
  background: none;
  position: absolute;
  width: 100%;
  height: 100%;
  cursor: pointer;
  margin: 0;
  padding: 0;
  top: 0;
  left: 0;

  /* Add the focus ring just for the buttons in the middle of the group (not the curved end ones)
     This is separate since it has different border radii */
  ${(props) => FocusRing({
  ...props.focusRingStyle,
  elementBorderProps: {
    ...selectStyledSystemProps(omit(props, "size"), ["border"]),
    borderRadius: "0px"
    /* 0 border radius since this is only applying to the inner ones */
  }
})};

  /* Elevating input z-index since focus ring is applied to input so that outline needs to be above other
     css displays from hover and interactions in label */
  &.hover,
  &:hover,
  &.focus,
  &:focus,
  &.focus-visible,
  &:focus-visible,
  &.selected,
  &:checked,
  &.active,
  &:active {
    z-index: 2;
  }

  ${composeWrapper(inputStyledSystemProps, [Pseudostate["focus-visible"]])}
`;
const ButtonGroupInput = forwardRef(({
  variant,
  size: size2,
  name,
  value,
  ...rest
}, ref2) => {
  const themeProps = buttonGroupStyle(variant);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(ButtonGroupInputElement, { ...themeProps, ...rest, name, value, "data-cy": `${name}.${value}`, type: "radio", ref: ref2 });
});
ButtonGroupInput.displayName = "ButtonGroupInput";
const shouldHaveRef = (value, optionValue, index2) => {
  if (value !== void 0) {
    return value === optionValue;
  }
  return index2 === 0;
};
const ButtonGroup = forwardRef(({
  options: options2,
  name,
  value,
  vertical: controlledVertical,
  verticalSwapBreakpoint,
  invalid,
  disabled,
  size: size2,
  labelText,
  assistiveText,
  assistiveTextPlacement = "bottom",
  assistiveTextStyles,
  ...rest
}, ref2) => {
  const themedProps = INPUT_STYLE_PROPS;
  const props = {
    ...rest
  };
  const styleProps = selectStyledSystemProps(omit(props, "size"), ["border", "color", "layout", "grid", "flexbox", "space", "typography", "position", "shadow"]);
  const isValidValue = options2.some((opt) => opt.value === value);
  const [horizontalBreakpoint, setHorizontalBreakpoint] = useState(0);
  const [containerRef, setRef] = useState(null);
  const [internalVerticalState, setInternalVerticalState] = useState(false);
  const isBelowVerticalBreakpoint = reactResponsiveExports.useMediaQuery({
    query: `(max-width: ${verticalSwapBreakpoint})`
  });
  const isVertical = controlledVertical ?? (verticalSwapBreakpoint !== void 0 ? isBelowVerticalBreakpoint : void 0) ?? internalVerticalState;
  useEffect(() => {
    if (!controlledVertical && containerRef && containerRef.parentElement && verticalSwapBreakpoint === void 0) {
      if (!horizontalBreakpoint) {
        setHorizontalBreakpoint(containerRef.getBoundingClientRect().width);
      }
      const observer = new index$3((entries) => {
        const entry = entries[0];
        if (!entry) return;
        const parentWidth = entry.contentRect.width;
        if (parentWidth < horizontalBreakpoint) {
          if (!internalVerticalState) {
            setInternalVerticalState(true);
          }
        } else if (internalVerticalState) {
          setInternalVerticalState(false);
        }
      });
      observer.observe(containerRef.parentElement);
      return () => {
        observer.disconnect();
      };
    }
    return () => null;
  }, [containerRef, horizontalBreakpoint, internalVerticalState]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(AssistiveTextWrapper, { assistiveText, assistiveTextPlacement, id: `bg-assistive-text-${name}`, invalid, ...themedProps.assistiveTextStyles, ...assistiveTextStyles, children: /* @__PURE__ */ jsxRuntimeExports.jsx(ButtonGroupContainer, { vertical: controlledVertical, "data-testid": "bgroup-container", size: size2, labelText: labelText ?? name, verticalSwapBreakpoint, isVertical, setRef, ...styleProps, children: options2.map((option, index2) => /* @__PURE__ */ jsxRuntimeExports.jsx(ButtonGroupLabel, { htmlFor: `${name}.${option.value}`, selected: value === option.value, unselected: isValidValue ? value !== option.value : false, "data-testid": "bgroup-label", invalid, size: size2, disabled, $isVertical: isVertical, ...option.tooltipTriggerProps, ...styleProps, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Fragment, { children: [
    option.label,
    /* @__PURE__ */ jsxRuntimeExports.jsx(ButtonGroupInput, { ...rest, name, checked: value === option.value, id: `${name}.${option.value}`, value: option.value, "data-testid": "bgroup-input", size: size2, disabled, tabIndex: 0, ...option.tooltipTriggerProps, ...shouldHaveRef(value, option.value, index2) && {
      ref: ref2
    } })
  ] }) }, `bgroup-${name}-${option.label}-${option.value}`)) }) });
});
ButtonGroup.displayName = "ButtonGroup";
const COMMON_MIME_TYPES = /* @__PURE__ */ new Map([
  // https://github.com/guzzle/psr7/blob/2d9260799e713f1c475d3c5fdc3d6561ff7441b2/src/MimeType.php
  ["1km", "application/vnd.1000minds.decision-model+xml"],
  ["3dml", "text/vnd.in3d.3dml"],
  ["3ds", "image/x-3ds"],
  ["3g2", "video/3gpp2"],
  ["3gp", "video/3gp"],
  ["3gpp", "video/3gpp"],
  ["3mf", "model/3mf"],
  ["7z", "application/x-7z-compressed"],
  ["7zip", "application/x-7z-compressed"],
  ["123", "application/vnd.lotus-1-2-3"],
  ["aab", "application/x-authorware-bin"],
  ["aac", "audio/x-acc"],
  ["aam", "application/x-authorware-map"],
  ["aas", "application/x-authorware-seg"],
  ["abw", "application/x-abiword"],
  ["ac", "application/vnd.nokia.n-gage.ac+xml"],
  ["ac3", "audio/ac3"],
  ["acc", "application/vnd.americandynamics.acc"],
  ["ace", "application/x-ace-compressed"],
  ["acu", "application/vnd.acucobol"],
  ["acutc", "application/vnd.acucorp"],
  ["adp", "audio/adpcm"],
  ["aep", "application/vnd.audiograph"],
  ["afm", "application/x-font-type1"],
  ["afp", "application/vnd.ibm.modcap"],
  ["ahead", "application/vnd.ahead.space"],
  ["ai", "application/pdf"],
  ["aif", "audio/x-aiff"],
  ["aifc", "audio/x-aiff"],
  ["aiff", "audio/x-aiff"],
  ["air", "application/vnd.adobe.air-application-installer-package+zip"],
  ["ait", "application/vnd.dvb.ait"],
  ["ami", "application/vnd.amiga.ami"],
  ["amr", "audio/amr"],
  ["apk", "application/vnd.android.package-archive"],
  ["apng", "image/apng"],
  ["appcache", "text/cache-manifest"],
  ["application", "application/x-ms-application"],
  ["apr", "application/vnd.lotus-approach"],
  ["arc", "application/x-freearc"],
  ["arj", "application/x-arj"],
  ["asc", "application/pgp-signature"],
  ["asf", "video/x-ms-asf"],
  ["asm", "text/x-asm"],
  ["aso", "application/vnd.accpac.simply.aso"],
  ["asx", "video/x-ms-asf"],
  ["atc", "application/vnd.acucorp"],
  ["atom", "application/atom+xml"],
  ["atomcat", "application/atomcat+xml"],
  ["atomdeleted", "application/atomdeleted+xml"],
  ["atomsvc", "application/atomsvc+xml"],
  ["atx", "application/vnd.antix.game-component"],
  ["au", "audio/x-au"],
  ["avi", "video/x-msvideo"],
  ["avif", "image/avif"],
  ["aw", "application/applixware"],
  ["azf", "application/vnd.airzip.filesecure.azf"],
  ["azs", "application/vnd.airzip.filesecure.azs"],
  ["azv", "image/vnd.airzip.accelerator.azv"],
  ["azw", "application/vnd.amazon.ebook"],
  ["b16", "image/vnd.pco.b16"],
  ["bat", "application/x-msdownload"],
  ["bcpio", "application/x-bcpio"],
  ["bdf", "application/x-font-bdf"],
  ["bdm", "application/vnd.syncml.dm+wbxml"],
  ["bdoc", "application/x-bdoc"],
  ["bed", "application/vnd.realvnc.bed"],
  ["bh2", "application/vnd.fujitsu.oasysprs"],
  ["bin", "application/octet-stream"],
  ["blb", "application/x-blorb"],
  ["blorb", "application/x-blorb"],
  ["bmi", "application/vnd.bmi"],
  ["bmml", "application/vnd.balsamiq.bmml+xml"],
  ["bmp", "image/bmp"],
  ["book", "application/vnd.framemaker"],
  ["box", "application/vnd.previewsystems.box"],
  ["boz", "application/x-bzip2"],
  ["bpk", "application/octet-stream"],
  ["bpmn", "application/octet-stream"],
  ["bsp", "model/vnd.valve.source.compiled-map"],
  ["btif", "image/prs.btif"],
  ["buffer", "application/octet-stream"],
  ["bz", "application/x-bzip"],
  ["bz2", "application/x-bzip2"],
  ["c", "text/x-c"],
  ["c4d", "application/vnd.clonk.c4group"],
  ["c4f", "application/vnd.clonk.c4group"],
  ["c4g", "application/vnd.clonk.c4group"],
  ["c4p", "application/vnd.clonk.c4group"],
  ["c4u", "application/vnd.clonk.c4group"],
  ["c11amc", "application/vnd.cluetrust.cartomobile-config"],
  ["c11amz", "application/vnd.cluetrust.cartomobile-config-pkg"],
  ["cab", "application/vnd.ms-cab-compressed"],
  ["caf", "audio/x-caf"],
  ["cap", "application/vnd.tcpdump.pcap"],
  ["car", "application/vnd.curl.car"],
  ["cat", "application/vnd.ms-pki.seccat"],
  ["cb7", "application/x-cbr"],
  ["cba", "application/x-cbr"],
  ["cbr", "application/x-cbr"],
  ["cbt", "application/x-cbr"],
  ["cbz", "application/x-cbr"],
  ["cc", "text/x-c"],
  ["cco", "application/x-cocoa"],
  ["cct", "application/x-director"],
  ["ccxml", "application/ccxml+xml"],
  ["cdbcmsg", "application/vnd.contact.cmsg"],
  ["cda", "application/x-cdf"],
  ["cdf", "application/x-netcdf"],
  ["cdfx", "application/cdfx+xml"],
  ["cdkey", "application/vnd.mediastation.cdkey"],
  ["cdmia", "application/cdmi-capability"],
  ["cdmic", "application/cdmi-container"],
  ["cdmid", "application/cdmi-domain"],
  ["cdmio", "application/cdmi-object"],
  ["cdmiq", "application/cdmi-queue"],
  ["cdr", "application/cdr"],
  ["cdx", "chemical/x-cdx"],
  ["cdxml", "application/vnd.chemdraw+xml"],
  ["cdy", "application/vnd.cinderella"],
  ["cer", "application/pkix-cert"],
  ["cfs", "application/x-cfs-compressed"],
  ["cgm", "image/cgm"],
  ["chat", "application/x-chat"],
  ["chm", "application/vnd.ms-htmlhelp"],
  ["chrt", "application/vnd.kde.kchart"],
  ["cif", "chemical/x-cif"],
  ["cii", "application/vnd.anser-web-certificate-issue-initiation"],
  ["cil", "application/vnd.ms-artgalry"],
  ["cjs", "application/node"],
  ["cla", "application/vnd.claymore"],
  ["class", "application/octet-stream"],
  ["clkk", "application/vnd.crick.clicker.keyboard"],
  ["clkp", "application/vnd.crick.clicker.palette"],
  ["clkt", "application/vnd.crick.clicker.template"],
  ["clkw", "application/vnd.crick.clicker.wordbank"],
  ["clkx", "application/vnd.crick.clicker"],
  ["clp", "application/x-msclip"],
  ["cmc", "application/vnd.cosmocaller"],
  ["cmdf", "chemical/x-cmdf"],
  ["cml", "chemical/x-cml"],
  ["cmp", "application/vnd.yellowriver-custom-menu"],
  ["cmx", "image/x-cmx"],
  ["cod", "application/vnd.rim.cod"],
  ["coffee", "text/coffeescript"],
  ["com", "application/x-msdownload"],
  ["conf", "text/plain"],
  ["cpio", "application/x-cpio"],
  ["cpp", "text/x-c"],
  ["cpt", "application/mac-compactpro"],
  ["crd", "application/x-mscardfile"],
  ["crl", "application/pkix-crl"],
  ["crt", "application/x-x509-ca-cert"],
  ["crx", "application/x-chrome-extension"],
  ["cryptonote", "application/vnd.rig.cryptonote"],
  ["csh", "application/x-csh"],
  ["csl", "application/vnd.citationstyles.style+xml"],
  ["csml", "chemical/x-csml"],
  ["csp", "application/vnd.commonspace"],
  ["csr", "application/octet-stream"],
  ["css", "text/css"],
  ["cst", "application/x-director"],
  ["csv", "text/csv"],
  ["cu", "application/cu-seeme"],
  ["curl", "text/vnd.curl"],
  ["cww", "application/prs.cww"],
  ["cxt", "application/x-director"],
  ["cxx", "text/x-c"],
  ["dae", "model/vnd.collada+xml"],
  ["daf", "application/vnd.mobius.daf"],
  ["dart", "application/vnd.dart"],
  ["dataless", "application/vnd.fdsn.seed"],
  ["davmount", "application/davmount+xml"],
  ["dbf", "application/vnd.dbf"],
  ["dbk", "application/docbook+xml"],
  ["dcr", "application/x-director"],
  ["dcurl", "text/vnd.curl.dcurl"],
  ["dd2", "application/vnd.oma.dd2+xml"],
  ["ddd", "application/vnd.fujixerox.ddd"],
  ["ddf", "application/vnd.syncml.dmddf+xml"],
  ["dds", "image/vnd.ms-dds"],
  ["deb", "application/x-debian-package"],
  ["def", "text/plain"],
  ["deploy", "application/octet-stream"],
  ["der", "application/x-x509-ca-cert"],
  ["dfac", "application/vnd.dreamfactory"],
  ["dgc", "application/x-dgc-compressed"],
  ["dic", "text/x-c"],
  ["dir", "application/x-director"],
  ["dis", "application/vnd.mobius.dis"],
  ["disposition-notification", "message/disposition-notification"],
  ["dist", "application/octet-stream"],
  ["distz", "application/octet-stream"],
  ["djv", "image/vnd.djvu"],
  ["djvu", "image/vnd.djvu"],
  ["dll", "application/octet-stream"],
  ["dmg", "application/x-apple-diskimage"],
  ["dmn", "application/octet-stream"],
  ["dmp", "application/vnd.tcpdump.pcap"],
  ["dms", "application/octet-stream"],
  ["dna", "application/vnd.dna"],
  ["doc", "application/msword"],
  ["docm", "application/vnd.ms-word.template.macroEnabled.12"],
  ["docx", "application/vnd.openxmlformats-officedocument.wordprocessingml.document"],
  ["dot", "application/msword"],
  ["dotm", "application/vnd.ms-word.template.macroEnabled.12"],
  ["dotx", "application/vnd.openxmlformats-officedocument.wordprocessingml.template"],
  ["dp", "application/vnd.osgi.dp"],
  ["dpg", "application/vnd.dpgraph"],
  ["dra", "audio/vnd.dra"],
  ["drle", "image/dicom-rle"],
  ["dsc", "text/prs.lines.tag"],
  ["dssc", "application/dssc+der"],
  ["dtb", "application/x-dtbook+xml"],
  ["dtd", "application/xml-dtd"],
  ["dts", "audio/vnd.dts"],
  ["dtshd", "audio/vnd.dts.hd"],
  ["dump", "application/octet-stream"],
  ["dvb", "video/vnd.dvb.file"],
  ["dvi", "application/x-dvi"],
  ["dwd", "application/atsc-dwd+xml"],
  ["dwf", "model/vnd.dwf"],
  ["dwg", "image/vnd.dwg"],
  ["dxf", "image/vnd.dxf"],
  ["dxp", "application/vnd.spotfire.dxp"],
  ["dxr", "application/x-director"],
  ["ear", "application/java-archive"],
  ["ecelp4800", "audio/vnd.nuera.ecelp4800"],
  ["ecelp7470", "audio/vnd.nuera.ecelp7470"],
  ["ecelp9600", "audio/vnd.nuera.ecelp9600"],
  ["ecma", "application/ecmascript"],
  ["edm", "application/vnd.novadigm.edm"],
  ["edx", "application/vnd.novadigm.edx"],
  ["efif", "application/vnd.picsel"],
  ["ei6", "application/vnd.pg.osasli"],
  ["elc", "application/octet-stream"],
  ["emf", "image/emf"],
  ["eml", "message/rfc822"],
  ["emma", "application/emma+xml"],
  ["emotionml", "application/emotionml+xml"],
  ["emz", "application/x-msmetafile"],
  ["eol", "audio/vnd.digital-winds"],
  ["eot", "application/vnd.ms-fontobject"],
  ["eps", "application/postscript"],
  ["epub", "application/epub+zip"],
  ["es", "application/ecmascript"],
  ["es3", "application/vnd.eszigno3+xml"],
  ["esa", "application/vnd.osgi.subsystem"],
  ["esf", "application/vnd.epson.esf"],
  ["et3", "application/vnd.eszigno3+xml"],
  ["etx", "text/x-setext"],
  ["eva", "application/x-eva"],
  ["evy", "application/x-envoy"],
  ["exe", "application/octet-stream"],
  ["exi", "application/exi"],
  ["exp", "application/express"],
  ["exr", "image/aces"],
  ["ext", "application/vnd.novadigm.ext"],
  ["ez", "application/andrew-inset"],
  ["ez2", "application/vnd.ezpix-album"],
  ["ez3", "application/vnd.ezpix-package"],
  ["f", "text/x-fortran"],
  ["f4v", "video/mp4"],
  ["f77", "text/x-fortran"],
  ["f90", "text/x-fortran"],
  ["fbs", "image/vnd.fastbidsheet"],
  ["fcdt", "application/vnd.adobe.formscentral.fcdt"],
  ["fcs", "application/vnd.isac.fcs"],
  ["fdf", "application/vnd.fdf"],
  ["fdt", "application/fdt+xml"],
  ["fe_launch", "application/vnd.denovo.fcselayout-link"],
  ["fg5", "application/vnd.fujitsu.oasysgp"],
  ["fgd", "application/x-director"],
  ["fh", "image/x-freehand"],
  ["fh4", "image/x-freehand"],
  ["fh5", "image/x-freehand"],
  ["fh7", "image/x-freehand"],
  ["fhc", "image/x-freehand"],
  ["fig", "application/x-xfig"],
  ["fits", "image/fits"],
  ["flac", "audio/x-flac"],
  ["fli", "video/x-fli"],
  ["flo", "application/vnd.micrografx.flo"],
  ["flv", "video/x-flv"],
  ["flw", "application/vnd.kde.kivio"],
  ["flx", "text/vnd.fmi.flexstor"],
  ["fly", "text/vnd.fly"],
  ["fm", "application/vnd.framemaker"],
  ["fnc", "application/vnd.frogans.fnc"],
  ["fo", "application/vnd.software602.filler.form+xml"],
  ["for", "text/x-fortran"],
  ["fpx", "image/vnd.fpx"],
  ["frame", "application/vnd.framemaker"],
  ["fsc", "application/vnd.fsc.weblaunch"],
  ["fst", "image/vnd.fst"],
  ["ftc", "application/vnd.fluxtime.clip"],
  ["fti", "application/vnd.anser-web-funds-transfer-initiation"],
  ["fvt", "video/vnd.fvt"],
  ["fxp", "application/vnd.adobe.fxp"],
  ["fxpl", "application/vnd.adobe.fxp"],
  ["fzs", "application/vnd.fuzzysheet"],
  ["g2w", "application/vnd.geoplan"],
  ["g3", "image/g3fax"],
  ["g3w", "application/vnd.geospace"],
  ["gac", "application/vnd.groove-account"],
  ["gam", "application/x-tads"],
  ["gbr", "application/rpki-ghostbusters"],
  ["gca", "application/x-gca-compressed"],
  ["gdl", "model/vnd.gdl"],
  ["gdoc", "application/vnd.google-apps.document"],
  ["geo", "application/vnd.dynageo"],
  ["geojson", "application/geo+json"],
  ["gex", "application/vnd.geometry-explorer"],
  ["ggb", "application/vnd.geogebra.file"],
  ["ggt", "application/vnd.geogebra.tool"],
  ["ghf", "application/vnd.groove-help"],
  ["gif", "image/gif"],
  ["gim", "application/vnd.groove-identity-message"],
  ["glb", "model/gltf-binary"],
  ["gltf", "model/gltf+json"],
  ["gml", "application/gml+xml"],
  ["gmx", "application/vnd.gmx"],
  ["gnumeric", "application/x-gnumeric"],
  ["gpg", "application/gpg-keys"],
  ["gph", "application/vnd.flographit"],
  ["gpx", "application/gpx+xml"],
  ["gqf", "application/vnd.grafeq"],
  ["gqs", "application/vnd.grafeq"],
  ["gram", "application/srgs"],
  ["gramps", "application/x-gramps-xml"],
  ["gre", "application/vnd.geometry-explorer"],
  ["grv", "application/vnd.groove-injector"],
  ["grxml", "application/srgs+xml"],
  ["gsf", "application/x-font-ghostscript"],
  ["gsheet", "application/vnd.google-apps.spreadsheet"],
  ["gslides", "application/vnd.google-apps.presentation"],
  ["gtar", "application/x-gtar"],
  ["gtm", "application/vnd.groove-tool-message"],
  ["gtw", "model/vnd.gtw"],
  ["gv", "text/vnd.graphviz"],
  ["gxf", "application/gxf"],
  ["gxt", "application/vnd.geonext"],
  ["gz", "application/gzip"],
  ["gzip", "application/gzip"],
  ["h", "text/x-c"],
  ["h261", "video/h261"],
  ["h263", "video/h263"],
  ["h264", "video/h264"],
  ["hal", "application/vnd.hal+xml"],
  ["hbci", "application/vnd.hbci"],
  ["hbs", "text/x-handlebars-template"],
  ["hdd", "application/x-virtualbox-hdd"],
  ["hdf", "application/x-hdf"],
  ["heic", "image/heic"],
  ["heics", "image/heic-sequence"],
  ["heif", "image/heif"],
  ["heifs", "image/heif-sequence"],
  ["hej2", "image/hej2k"],
  ["held", "application/atsc-held+xml"],
  ["hh", "text/x-c"],
  ["hjson", "application/hjson"],
  ["hlp", "application/winhlp"],
  ["hpgl", "application/vnd.hp-hpgl"],
  ["hpid", "application/vnd.hp-hpid"],
  ["hps", "application/vnd.hp-hps"],
  ["hqx", "application/mac-binhex40"],
  ["hsj2", "image/hsj2"],
  ["htc", "text/x-component"],
  ["htke", "application/vnd.kenameaapp"],
  ["htm", "text/html"],
  ["html", "text/html"],
  ["hvd", "application/vnd.yamaha.hv-dic"],
  ["hvp", "application/vnd.yamaha.hv-voice"],
  ["hvs", "application/vnd.yamaha.hv-script"],
  ["i2g", "application/vnd.intergeo"],
  ["icc", "application/vnd.iccprofile"],
  ["ice", "x-conference/x-cooltalk"],
  ["icm", "application/vnd.iccprofile"],
  ["ico", "image/x-icon"],
  ["ics", "text/calendar"],
  ["ief", "image/ief"],
  ["ifb", "text/calendar"],
  ["ifm", "application/vnd.shana.informed.formdata"],
  ["iges", "model/iges"],
  ["igl", "application/vnd.igloader"],
  ["igm", "application/vnd.insors.igm"],
  ["igs", "model/iges"],
  ["igx", "application/vnd.micrografx.igx"],
  ["iif", "application/vnd.shana.informed.interchange"],
  ["img", "application/octet-stream"],
  ["imp", "application/vnd.accpac.simply.imp"],
  ["ims", "application/vnd.ms-ims"],
  ["in", "text/plain"],
  ["ini", "text/plain"],
  ["ink", "application/inkml+xml"],
  ["inkml", "application/inkml+xml"],
  ["install", "application/x-install-instructions"],
  ["iota", "application/vnd.astraea-software.iota"],
  ["ipfix", "application/ipfix"],
  ["ipk", "application/vnd.shana.informed.package"],
  ["irm", "application/vnd.ibm.rights-management"],
  ["irp", "application/vnd.irepository.package+xml"],
  ["iso", "application/x-iso9660-image"],
  ["itp", "application/vnd.shana.informed.formtemplate"],
  ["its", "application/its+xml"],
  ["ivp", "application/vnd.immervision-ivp"],
  ["ivu", "application/vnd.immervision-ivu"],
  ["jad", "text/vnd.sun.j2me.app-descriptor"],
  ["jade", "text/jade"],
  ["jam", "application/vnd.jam"],
  ["jar", "application/java-archive"],
  ["jardiff", "application/x-java-archive-diff"],
  ["java", "text/x-java-source"],
  ["jhc", "image/jphc"],
  ["jisp", "application/vnd.jisp"],
  ["jls", "image/jls"],
  ["jlt", "application/vnd.hp-jlyt"],
  ["jng", "image/x-jng"],
  ["jnlp", "application/x-java-jnlp-file"],
  ["joda", "application/vnd.joost.joda-archive"],
  ["jp2", "image/jp2"],
  ["jpe", "image/jpeg"],
  ["jpeg", "image/jpeg"],
  ["jpf", "image/jpx"],
  ["jpg", "image/jpeg"],
  ["jpg2", "image/jp2"],
  ["jpgm", "video/jpm"],
  ["jpgv", "video/jpeg"],
  ["jph", "image/jph"],
  ["jpm", "video/jpm"],
  ["jpx", "image/jpx"],
  ["js", "application/javascript"],
  ["json", "application/json"],
  ["json5", "application/json5"],
  ["jsonld", "application/ld+json"],
  // https://jsonlines.org/
  ["jsonl", "application/jsonl"],
  ["jsonml", "application/jsonml+json"],
  ["jsx", "text/jsx"],
  ["jxr", "image/jxr"],
  ["jxra", "image/jxra"],
  ["jxrs", "image/jxrs"],
  ["jxs", "image/jxs"],
  ["jxsc", "image/jxsc"],
  ["jxsi", "image/jxsi"],
  ["jxss", "image/jxss"],
  ["kar", "audio/midi"],
  ["karbon", "application/vnd.kde.karbon"],
  ["kdb", "application/octet-stream"],
  ["kdbx", "application/x-keepass2"],
  ["key", "application/x-iwork-keynote-sffkey"],
  ["kfo", "application/vnd.kde.kformula"],
  ["kia", "application/vnd.kidspiration"],
  ["kml", "application/vnd.google-earth.kml+xml"],
  ["kmz", "application/vnd.google-earth.kmz"],
  ["kne", "application/vnd.kinar"],
  ["knp", "application/vnd.kinar"],
  ["kon", "application/vnd.kde.kontour"],
  ["kpr", "application/vnd.kde.kpresenter"],
  ["kpt", "application/vnd.kde.kpresenter"],
  ["kpxx", "application/vnd.ds-keypoint"],
  ["ksp", "application/vnd.kde.kspread"],
  ["ktr", "application/vnd.kahootz"],
  ["ktx", "image/ktx"],
  ["ktx2", "image/ktx2"],
  ["ktz", "application/vnd.kahootz"],
  ["kwd", "application/vnd.kde.kword"],
  ["kwt", "application/vnd.kde.kword"],
  ["lasxml", "application/vnd.las.las+xml"],
  ["latex", "application/x-latex"],
  ["lbd", "application/vnd.llamagraphics.life-balance.desktop"],
  ["lbe", "application/vnd.llamagraphics.life-balance.exchange+xml"],
  ["les", "application/vnd.hhe.lesson-player"],
  ["less", "text/less"],
  ["lgr", "application/lgr+xml"],
  ["lha", "application/octet-stream"],
  ["link66", "application/vnd.route66.link66+xml"],
  ["list", "text/plain"],
  ["list3820", "application/vnd.ibm.modcap"],
  ["listafp", "application/vnd.ibm.modcap"],
  ["litcoffee", "text/coffeescript"],
  ["lnk", "application/x-ms-shortcut"],
  ["log", "text/plain"],
  ["lostxml", "application/lost+xml"],
  ["lrf", "application/octet-stream"],
  ["lrm", "application/vnd.ms-lrm"],
  ["ltf", "application/vnd.frogans.ltf"],
  ["lua", "text/x-lua"],
  ["luac", "application/x-lua-bytecode"],
  ["lvp", "audio/vnd.lucent.voice"],
  ["lwp", "application/vnd.lotus-wordpro"],
  ["lzh", "application/octet-stream"],
  ["m1v", "video/mpeg"],
  ["m2a", "audio/mpeg"],
  ["m2v", "video/mpeg"],
  ["m3a", "audio/mpeg"],
  ["m3u", "text/plain"],
  ["m3u8", "application/vnd.apple.mpegurl"],
  ["m4a", "audio/x-m4a"],
  ["m4p", "application/mp4"],
  ["m4s", "video/iso.segment"],
  ["m4u", "application/vnd.mpegurl"],
  ["m4v", "video/x-m4v"],
  ["m13", "application/x-msmediaview"],
  ["m14", "application/x-msmediaview"],
  ["m21", "application/mp21"],
  ["ma", "application/mathematica"],
  ["mads", "application/mads+xml"],
  ["maei", "application/mmt-aei+xml"],
  ["mag", "application/vnd.ecowin.chart"],
  ["maker", "application/vnd.framemaker"],
  ["man", "text/troff"],
  ["manifest", "text/cache-manifest"],
  ["map", "application/json"],
  ["mar", "application/octet-stream"],
  ["markdown", "text/markdown"],
  ["mathml", "application/mathml+xml"],
  ["mb", "application/mathematica"],
  ["mbk", "application/vnd.mobius.mbk"],
  ["mbox", "application/mbox"],
  ["mc1", "application/vnd.medcalcdata"],
  ["mcd", "application/vnd.mcd"],
  ["mcurl", "text/vnd.curl.mcurl"],
  ["md", "text/markdown"],
  ["mdb", "application/x-msaccess"],
  ["mdi", "image/vnd.ms-modi"],
  ["mdx", "text/mdx"],
  ["me", "text/troff"],
  ["mesh", "model/mesh"],
  ["meta4", "application/metalink4+xml"],
  ["metalink", "application/metalink+xml"],
  ["mets", "application/mets+xml"],
  ["mfm", "application/vnd.mfmp"],
  ["mft", "application/rpki-manifest"],
  ["mgp", "application/vnd.osgeo.mapguide.package"],
  ["mgz", "application/vnd.proteus.magazine"],
  ["mid", "audio/midi"],
  ["midi", "audio/midi"],
  ["mie", "application/x-mie"],
  ["mif", "application/vnd.mif"],
  ["mime", "message/rfc822"],
  ["mj2", "video/mj2"],
  ["mjp2", "video/mj2"],
  ["mjs", "application/javascript"],
  ["mk3d", "video/x-matroska"],
  ["mka", "audio/x-matroska"],
  ["mkd", "text/x-markdown"],
  ["mks", "video/x-matroska"],
  ["mkv", "video/x-matroska"],
  ["mlp", "application/vnd.dolby.mlp"],
  ["mmd", "application/vnd.chipnuts.karaoke-mmd"],
  ["mmf", "application/vnd.smaf"],
  ["mml", "text/mathml"],
  ["mmr", "image/vnd.fujixerox.edmics-mmr"],
  ["mng", "video/x-mng"],
  ["mny", "application/x-msmoney"],
  ["mobi", "application/x-mobipocket-ebook"],
  ["mods", "application/mods+xml"],
  ["mov", "video/quicktime"],
  ["movie", "video/x-sgi-movie"],
  ["mp2", "audio/mpeg"],
  ["mp2a", "audio/mpeg"],
  ["mp3", "audio/mpeg"],
  ["mp4", "video/mp4"],
  ["mp4a", "audio/mp4"],
  ["mp4s", "application/mp4"],
  ["mp4v", "video/mp4"],
  ["mp21", "application/mp21"],
  ["mpc", "application/vnd.mophun.certificate"],
  ["mpd", "application/dash+xml"],
  ["mpe", "video/mpeg"],
  ["mpeg", "video/mpeg"],
  ["mpg", "video/mpeg"],
  ["mpg4", "video/mp4"],
  ["mpga", "audio/mpeg"],
  ["mpkg", "application/vnd.apple.installer+xml"],
  ["mpm", "application/vnd.blueice.multipass"],
  ["mpn", "application/vnd.mophun.application"],
  ["mpp", "application/vnd.ms-project"],
  ["mpt", "application/vnd.ms-project"],
  ["mpy", "application/vnd.ibm.minipay"],
  ["mqy", "application/vnd.mobius.mqy"],
  ["mrc", "application/marc"],
  ["mrcx", "application/marcxml+xml"],
  ["ms", "text/troff"],
  ["mscml", "application/mediaservercontrol+xml"],
  ["mseed", "application/vnd.fdsn.mseed"],
  ["mseq", "application/vnd.mseq"],
  ["msf", "application/vnd.epson.msf"],
  ["msg", "application/vnd.ms-outlook"],
  ["msh", "model/mesh"],
  ["msi", "application/x-msdownload"],
  ["msl", "application/vnd.mobius.msl"],
  ["msm", "application/octet-stream"],
  ["msp", "application/octet-stream"],
  ["msty", "application/vnd.muvee.style"],
  ["mtl", "model/mtl"],
  ["mts", "model/vnd.mts"],
  ["mus", "application/vnd.musician"],
  ["musd", "application/mmt-usd+xml"],
  ["musicxml", "application/vnd.recordare.musicxml+xml"],
  ["mvb", "application/x-msmediaview"],
  ["mvt", "application/vnd.mapbox-vector-tile"],
  ["mwf", "application/vnd.mfer"],
  ["mxf", "application/mxf"],
  ["mxl", "application/vnd.recordare.musicxml"],
  ["mxmf", "audio/mobile-xmf"],
  ["mxml", "application/xv+xml"],
  ["mxs", "application/vnd.triscape.mxs"],
  ["mxu", "video/vnd.mpegurl"],
  ["n-gage", "application/vnd.nokia.n-gage.symbian.install"],
  ["n3", "text/n3"],
  ["nb", "application/mathematica"],
  ["nbp", "application/vnd.wolfram.player"],
  ["nc", "application/x-netcdf"],
  ["ncx", "application/x-dtbncx+xml"],
  ["nfo", "text/x-nfo"],
  ["ngdat", "application/vnd.nokia.n-gage.data"],
  ["nitf", "application/vnd.nitf"],
  ["nlu", "application/vnd.neurolanguage.nlu"],
  ["nml", "application/vnd.enliven"],
  ["nnd", "application/vnd.noblenet-directory"],
  ["nns", "application/vnd.noblenet-sealer"],
  ["nnw", "application/vnd.noblenet-web"],
  ["npx", "image/vnd.net-fpx"],
  ["nq", "application/n-quads"],
  ["nsc", "application/x-conference"],
  ["nsf", "application/vnd.lotus-notes"],
  ["nt", "application/n-triples"],
  ["ntf", "application/vnd.nitf"],
  ["numbers", "application/x-iwork-numbers-sffnumbers"],
  ["nzb", "application/x-nzb"],
  ["oa2", "application/vnd.fujitsu.oasys2"],
  ["oa3", "application/vnd.fujitsu.oasys3"],
  ["oas", "application/vnd.fujitsu.oasys"],
  ["obd", "application/x-msbinder"],
  ["obgx", "application/vnd.openblox.game+xml"],
  ["obj", "model/obj"],
  ["oda", "application/oda"],
  ["odb", "application/vnd.oasis.opendocument.database"],
  ["odc", "application/vnd.oasis.opendocument.chart"],
  ["odf", "application/vnd.oasis.opendocument.formula"],
  ["odft", "application/vnd.oasis.opendocument.formula-template"],
  ["odg", "application/vnd.oasis.opendocument.graphics"],
  ["odi", "application/vnd.oasis.opendocument.image"],
  ["odm", "application/vnd.oasis.opendocument.text-master"],
  ["odp", "application/vnd.oasis.opendocument.presentation"],
  ["ods", "application/vnd.oasis.opendocument.spreadsheet"],
  ["odt", "application/vnd.oasis.opendocument.text"],
  ["oga", "audio/ogg"],
  ["ogex", "model/vnd.opengex"],
  ["ogg", "audio/ogg"],
  ["ogv", "video/ogg"],
  ["ogx", "application/ogg"],
  ["omdoc", "application/omdoc+xml"],
  ["onepkg", "application/onenote"],
  ["onetmp", "application/onenote"],
  ["onetoc", "application/onenote"],
  ["onetoc2", "application/onenote"],
  ["opf", "application/oebps-package+xml"],
  ["opml", "text/x-opml"],
  ["oprc", "application/vnd.palm"],
  ["opus", "audio/ogg"],
  ["org", "text/x-org"],
  ["osf", "application/vnd.yamaha.openscoreformat"],
  ["osfpvg", "application/vnd.yamaha.openscoreformat.osfpvg+xml"],
  ["osm", "application/vnd.openstreetmap.data+xml"],
  ["otc", "application/vnd.oasis.opendocument.chart-template"],
  ["otf", "font/otf"],
  ["otg", "application/vnd.oasis.opendocument.graphics-template"],
  ["oth", "application/vnd.oasis.opendocument.text-web"],
  ["oti", "application/vnd.oasis.opendocument.image-template"],
  ["otp", "application/vnd.oasis.opendocument.presentation-template"],
  ["ots", "application/vnd.oasis.opendocument.spreadsheet-template"],
  ["ott", "application/vnd.oasis.opendocument.text-template"],
  ["ova", "application/x-virtualbox-ova"],
  ["ovf", "application/x-virtualbox-ovf"],
  ["owl", "application/rdf+xml"],
  ["oxps", "application/oxps"],
  ["oxt", "application/vnd.openofficeorg.extension"],
  ["p", "text/x-pascal"],
  ["p7a", "application/x-pkcs7-signature"],
  ["p7b", "application/x-pkcs7-certificates"],
  ["p7c", "application/pkcs7-mime"],
  ["p7m", "application/pkcs7-mime"],
  ["p7r", "application/x-pkcs7-certreqresp"],
  ["p7s", "application/pkcs7-signature"],
  ["p8", "application/pkcs8"],
  ["p10", "application/x-pkcs10"],
  ["p12", "application/x-pkcs12"],
  ["pac", "application/x-ns-proxy-autoconfig"],
  ["pages", "application/x-iwork-pages-sffpages"],
  ["pas", "text/x-pascal"],
  ["paw", "application/vnd.pawaafile"],
  ["pbd", "application/vnd.powerbuilder6"],
  ["pbm", "image/x-portable-bitmap"],
  ["pcap", "application/vnd.tcpdump.pcap"],
  ["pcf", "application/x-font-pcf"],
  ["pcl", "application/vnd.hp-pcl"],
  ["pclxl", "application/vnd.hp-pclxl"],
  ["pct", "image/x-pict"],
  ["pcurl", "application/vnd.curl.pcurl"],
  ["pcx", "image/x-pcx"],
  ["pdb", "application/x-pilot"],
  ["pde", "text/x-processing"],
  ["pdf", "application/pdf"],
  ["pem", "application/x-x509-user-cert"],
  ["pfa", "application/x-font-type1"],
  ["pfb", "application/x-font-type1"],
  ["pfm", "application/x-font-type1"],
  ["pfr", "application/font-tdpfr"],
  ["pfx", "application/x-pkcs12"],
  ["pgm", "image/x-portable-graymap"],
  ["pgn", "application/x-chess-pgn"],
  ["pgp", "application/pgp"],
  ["php", "application/x-httpd-php"],
  ["php3", "application/x-httpd-php"],
  ["php4", "application/x-httpd-php"],
  ["phps", "application/x-httpd-php-source"],
  ["phtml", "application/x-httpd-php"],
  ["pic", "image/x-pict"],
  ["pkg", "application/octet-stream"],
  ["pki", "application/pkixcmp"],
  ["pkipath", "application/pkix-pkipath"],
  ["pkpass", "application/vnd.apple.pkpass"],
  ["pl", "application/x-perl"],
  ["plb", "application/vnd.3gpp.pic-bw-large"],
  ["plc", "application/vnd.mobius.plc"],
  ["plf", "application/vnd.pocketlearn"],
  ["pls", "application/pls+xml"],
  ["pm", "application/x-perl"],
  ["pml", "application/vnd.ctc-posml"],
  ["png", "image/png"],
  ["pnm", "image/x-portable-anymap"],
  ["portpkg", "application/vnd.macports.portpkg"],
  ["pot", "application/vnd.ms-powerpoint"],
  ["potm", "application/vnd.ms-powerpoint.presentation.macroEnabled.12"],
  ["potx", "application/vnd.openxmlformats-officedocument.presentationml.template"],
  ["ppa", "application/vnd.ms-powerpoint"],
  ["ppam", "application/vnd.ms-powerpoint.addin.macroEnabled.12"],
  ["ppd", "application/vnd.cups-ppd"],
  ["ppm", "image/x-portable-pixmap"],
  ["pps", "application/vnd.ms-powerpoint"],
  ["ppsm", "application/vnd.ms-powerpoint.slideshow.macroEnabled.12"],
  ["ppsx", "application/vnd.openxmlformats-officedocument.presentationml.slideshow"],
  ["ppt", "application/powerpoint"],
  ["pptm", "application/vnd.ms-powerpoint.presentation.macroEnabled.12"],
  ["pptx", "application/vnd.openxmlformats-officedocument.presentationml.presentation"],
  ["pqa", "application/vnd.palm"],
  ["prc", "application/x-pilot"],
  ["pre", "application/vnd.lotus-freelance"],
  ["prf", "application/pics-rules"],
  ["provx", "application/provenance+xml"],
  ["ps", "application/postscript"],
  ["psb", "application/vnd.3gpp.pic-bw-small"],
  ["psd", "application/x-photoshop"],
  ["psf", "application/x-font-linux-psf"],
  ["pskcxml", "application/pskc+xml"],
  ["pti", "image/prs.pti"],
  ["ptid", "application/vnd.pvi.ptid1"],
  ["pub", "application/x-mspublisher"],
  ["pvb", "application/vnd.3gpp.pic-bw-var"],
  ["pwn", "application/vnd.3m.post-it-notes"],
  ["pya", "audio/vnd.ms-playready.media.pya"],
  ["pyv", "video/vnd.ms-playready.media.pyv"],
  ["qam", "application/vnd.epson.quickanime"],
  ["qbo", "application/vnd.intu.qbo"],
  ["qfx", "application/vnd.intu.qfx"],
  ["qps", "application/vnd.publishare-delta-tree"],
  ["qt", "video/quicktime"],
  ["qwd", "application/vnd.quark.quarkxpress"],
  ["qwt", "application/vnd.quark.quarkxpress"],
  ["qxb", "application/vnd.quark.quarkxpress"],
  ["qxd", "application/vnd.quark.quarkxpress"],
  ["qxl", "application/vnd.quark.quarkxpress"],
  ["qxt", "application/vnd.quark.quarkxpress"],
  ["ra", "audio/x-realaudio"],
  ["ram", "audio/x-pn-realaudio"],
  ["raml", "application/raml+yaml"],
  ["rapd", "application/route-apd+xml"],
  ["rar", "application/x-rar"],
  ["ras", "image/x-cmu-raster"],
  ["rcprofile", "application/vnd.ipunplugged.rcprofile"],
  ["rdf", "application/rdf+xml"],
  ["rdz", "application/vnd.data-vision.rdz"],
  ["relo", "application/p2p-overlay+xml"],
  ["rep", "application/vnd.businessobjects"],
  ["res", "application/x-dtbresource+xml"],
  ["rgb", "image/x-rgb"],
  ["rif", "application/reginfo+xml"],
  ["rip", "audio/vnd.rip"],
  ["ris", "application/x-research-info-systems"],
  ["rl", "application/resource-lists+xml"],
  ["rlc", "image/vnd.fujixerox.edmics-rlc"],
  ["rld", "application/resource-lists-diff+xml"],
  ["rm", "audio/x-pn-realaudio"],
  ["rmi", "audio/midi"],
  ["rmp", "audio/x-pn-realaudio-plugin"],
  ["rms", "application/vnd.jcp.javame.midlet-rms"],
  ["rmvb", "application/vnd.rn-realmedia-vbr"],
  ["rnc", "application/relax-ng-compact-syntax"],
  ["rng", "application/xml"],
  ["roa", "application/rpki-roa"],
  ["roff", "text/troff"],
  ["rp9", "application/vnd.cloanto.rp9"],
  ["rpm", "audio/x-pn-realaudio-plugin"],
  ["rpss", "application/vnd.nokia.radio-presets"],
  ["rpst", "application/vnd.nokia.radio-preset"],
  ["rq", "application/sparql-query"],
  ["rs", "application/rls-services+xml"],
  ["rsa", "application/x-pkcs7"],
  ["rsat", "application/atsc-rsat+xml"],
  ["rsd", "application/rsd+xml"],
  ["rsheet", "application/urc-ressheet+xml"],
  ["rss", "application/rss+xml"],
  ["rtf", "text/rtf"],
  ["rtx", "text/richtext"],
  ["run", "application/x-makeself"],
  ["rusd", "application/route-usd+xml"],
  ["rv", "video/vnd.rn-realvideo"],
  ["s", "text/x-asm"],
  ["s3m", "audio/s3m"],
  ["saf", "application/vnd.yamaha.smaf-audio"],
  ["sass", "text/x-sass"],
  ["sbml", "application/sbml+xml"],
  ["sc", "application/vnd.ibm.secure-container"],
  ["scd", "application/x-msschedule"],
  ["scm", "application/vnd.lotus-screencam"],
  ["scq", "application/scvp-cv-request"],
  ["scs", "application/scvp-cv-response"],
  ["scss", "text/x-scss"],
  ["scurl", "text/vnd.curl.scurl"],
  ["sda", "application/vnd.stardivision.draw"],
  ["sdc", "application/vnd.stardivision.calc"],
  ["sdd", "application/vnd.stardivision.impress"],
  ["sdkd", "application/vnd.solent.sdkm+xml"],
  ["sdkm", "application/vnd.solent.sdkm+xml"],
  ["sdp", "application/sdp"],
  ["sdw", "application/vnd.stardivision.writer"],
  ["sea", "application/octet-stream"],
  ["see", "application/vnd.seemail"],
  ["seed", "application/vnd.fdsn.seed"],
  ["sema", "application/vnd.sema"],
  ["semd", "application/vnd.semd"],
  ["semf", "application/vnd.semf"],
  ["senmlx", "application/senml+xml"],
  ["sensmlx", "application/sensml+xml"],
  ["ser", "application/java-serialized-object"],
  ["setpay", "application/set-payment-initiation"],
  ["setreg", "application/set-registration-initiation"],
  ["sfd-hdstx", "application/vnd.hydrostatix.sof-data"],
  ["sfs", "application/vnd.spotfire.sfs"],
  ["sfv", "text/x-sfv"],
  ["sgi", "image/sgi"],
  ["sgl", "application/vnd.stardivision.writer-global"],
  ["sgm", "text/sgml"],
  ["sgml", "text/sgml"],
  ["sh", "application/x-sh"],
  ["shar", "application/x-shar"],
  ["shex", "text/shex"],
  ["shf", "application/shf+xml"],
  ["shtml", "text/html"],
  ["sid", "image/x-mrsid-image"],
  ["sieve", "application/sieve"],
  ["sig", "application/pgp-signature"],
  ["sil", "audio/silk"],
  ["silo", "model/mesh"],
  ["sis", "application/vnd.symbian.install"],
  ["sisx", "application/vnd.symbian.install"],
  ["sit", "application/x-stuffit"],
  ["sitx", "application/x-stuffitx"],
  ["siv", "application/sieve"],
  ["skd", "application/vnd.koan"],
  ["skm", "application/vnd.koan"],
  ["skp", "application/vnd.koan"],
  ["skt", "application/vnd.koan"],
  ["sldm", "application/vnd.ms-powerpoint.slide.macroenabled.12"],
  ["sldx", "application/vnd.openxmlformats-officedocument.presentationml.slide"],
  ["slim", "text/slim"],
  ["slm", "text/slim"],
  ["sls", "application/route-s-tsid+xml"],
  ["slt", "application/vnd.epson.salt"],
  ["sm", "application/vnd.stepmania.stepchart"],
  ["smf", "application/vnd.stardivision.math"],
  ["smi", "application/smil"],
  ["smil", "application/smil"],
  ["smv", "video/x-smv"],
  ["smzip", "application/vnd.stepmania.package"],
  ["snd", "audio/basic"],
  ["snf", "application/x-font-snf"],
  ["so", "application/octet-stream"],
  ["spc", "application/x-pkcs7-certificates"],
  ["spdx", "text/spdx"],
  ["spf", "application/vnd.yamaha.smaf-phrase"],
  ["spl", "application/x-futuresplash"],
  ["spot", "text/vnd.in3d.spot"],
  ["spp", "application/scvp-vp-response"],
  ["spq", "application/scvp-vp-request"],
  ["spx", "audio/ogg"],
  ["sql", "application/x-sql"],
  ["src", "application/x-wais-source"],
  ["srt", "application/x-subrip"],
  ["sru", "application/sru+xml"],
  ["srx", "application/sparql-results+xml"],
  ["ssdl", "application/ssdl+xml"],
  ["sse", "application/vnd.kodak-descriptor"],
  ["ssf", "application/vnd.epson.ssf"],
  ["ssml", "application/ssml+xml"],
  ["sst", "application/octet-stream"],
  ["st", "application/vnd.sailingtracker.track"],
  ["stc", "application/vnd.sun.xml.calc.template"],
  ["std", "application/vnd.sun.xml.draw.template"],
  ["stf", "application/vnd.wt.stf"],
  ["sti", "application/vnd.sun.xml.impress.template"],
  ["stk", "application/hyperstudio"],
  ["stl", "model/stl"],
  ["stpx", "model/step+xml"],
  ["stpxz", "model/step-xml+zip"],
  ["stpz", "model/step+zip"],
  ["str", "application/vnd.pg.format"],
  ["stw", "application/vnd.sun.xml.writer.template"],
  ["styl", "text/stylus"],
  ["stylus", "text/stylus"],
  ["sub", "text/vnd.dvb.subtitle"],
  ["sus", "application/vnd.sus-calendar"],
  ["susp", "application/vnd.sus-calendar"],
  ["sv4cpio", "application/x-sv4cpio"],
  ["sv4crc", "application/x-sv4crc"],
  ["svc", "application/vnd.dvb.service"],
  ["svd", "application/vnd.svd"],
  ["svg", "image/svg+xml"],
  ["svgz", "image/svg+xml"],
  ["swa", "application/x-director"],
  ["swf", "application/x-shockwave-flash"],
  ["swi", "application/vnd.aristanetworks.swi"],
  ["swidtag", "application/swid+xml"],
  ["sxc", "application/vnd.sun.xml.calc"],
  ["sxd", "application/vnd.sun.xml.draw"],
  ["sxg", "application/vnd.sun.xml.writer.global"],
  ["sxi", "application/vnd.sun.xml.impress"],
  ["sxm", "application/vnd.sun.xml.math"],
  ["sxw", "application/vnd.sun.xml.writer"],
  ["t", "text/troff"],
  ["t3", "application/x-t3vm-image"],
  ["t38", "image/t38"],
  ["taglet", "application/vnd.mynfc"],
  ["tao", "application/vnd.tao.intent-module-archive"],
  ["tap", "image/vnd.tencent.tap"],
  ["tar", "application/x-tar"],
  ["tcap", "application/vnd.3gpp2.tcap"],
  ["tcl", "application/x-tcl"],
  ["td", "application/urc-targetdesc+xml"],
  ["teacher", "application/vnd.smart.teacher"],
  ["tei", "application/tei+xml"],
  ["teicorpus", "application/tei+xml"],
  ["tex", "application/x-tex"],
  ["texi", "application/x-texinfo"],
  ["texinfo", "application/x-texinfo"],
  ["text", "text/plain"],
  ["tfi", "application/thraud+xml"],
  ["tfm", "application/x-tex-tfm"],
  ["tfx", "image/tiff-fx"],
  ["tga", "image/x-tga"],
  ["tgz", "application/x-tar"],
  ["thmx", "application/vnd.ms-officetheme"],
  ["tif", "image/tiff"],
  ["tiff", "image/tiff"],
  ["tk", "application/x-tcl"],
  ["tmo", "application/vnd.tmobile-livetv"],
  ["toml", "application/toml"],
  ["torrent", "application/x-bittorrent"],
  ["tpl", "application/vnd.groove-tool-template"],
  ["tpt", "application/vnd.trid.tpt"],
  ["tr", "text/troff"],
  ["tra", "application/vnd.trueapp"],
  ["trig", "application/trig"],
  ["trm", "application/x-msterminal"],
  ["ts", "video/mp2t"],
  ["tsd", "application/timestamped-data"],
  ["tsv", "text/tab-separated-values"],
  ["ttc", "font/collection"],
  ["ttf", "font/ttf"],
  ["ttl", "text/turtle"],
  ["ttml", "application/ttml+xml"],
  ["twd", "application/vnd.simtech-mindmapper"],
  ["twds", "application/vnd.simtech-mindmapper"],
  ["txd", "application/vnd.genomatix.tuxedo"],
  ["txf", "application/vnd.mobius.txf"],
  ["txt", "text/plain"],
  ["u8dsn", "message/global-delivery-status"],
  ["u8hdr", "message/global-headers"],
  ["u8mdn", "message/global-disposition-notification"],
  ["u8msg", "message/global"],
  ["u32", "application/x-authorware-bin"],
  ["ubj", "application/ubjson"],
  ["udeb", "application/x-debian-package"],
  ["ufd", "application/vnd.ufdl"],
  ["ufdl", "application/vnd.ufdl"],
  ["ulx", "application/x-glulx"],
  ["umj", "application/vnd.umajin"],
  ["unityweb", "application/vnd.unity"],
  ["uoml", "application/vnd.uoml+xml"],
  ["uri", "text/uri-list"],
  ["uris", "text/uri-list"],
  ["urls", "text/uri-list"],
  ["usdz", "model/vnd.usdz+zip"],
  ["ustar", "application/x-ustar"],
  ["utz", "application/vnd.uiq.theme"],
  ["uu", "text/x-uuencode"],
  ["uva", "audio/vnd.dece.audio"],
  ["uvd", "application/vnd.dece.data"],
  ["uvf", "application/vnd.dece.data"],
  ["uvg", "image/vnd.dece.graphic"],
  ["uvh", "video/vnd.dece.hd"],
  ["uvi", "image/vnd.dece.graphic"],
  ["uvm", "video/vnd.dece.mobile"],
  ["uvp", "video/vnd.dece.pd"],
  ["uvs", "video/vnd.dece.sd"],
  ["uvt", "application/vnd.dece.ttml+xml"],
  ["uvu", "video/vnd.uvvu.mp4"],
  ["uvv", "video/vnd.dece.video"],
  ["uvva", "audio/vnd.dece.audio"],
  ["uvvd", "application/vnd.dece.data"],
  ["uvvf", "application/vnd.dece.data"],
  ["uvvg", "image/vnd.dece.graphic"],
  ["uvvh", "video/vnd.dece.hd"],
  ["uvvi", "image/vnd.dece.graphic"],
  ["uvvm", "video/vnd.dece.mobile"],
  ["uvvp", "video/vnd.dece.pd"],
  ["uvvs", "video/vnd.dece.sd"],
  ["uvvt", "application/vnd.dece.ttml+xml"],
  ["uvvu", "video/vnd.uvvu.mp4"],
  ["uvvv", "video/vnd.dece.video"],
  ["uvvx", "application/vnd.dece.unspecified"],
  ["uvvz", "application/vnd.dece.zip"],
  ["uvx", "application/vnd.dece.unspecified"],
  ["uvz", "application/vnd.dece.zip"],
  ["vbox", "application/x-virtualbox-vbox"],
  ["vbox-extpack", "application/x-virtualbox-vbox-extpack"],
  ["vcard", "text/vcard"],
  ["vcd", "application/x-cdlink"],
  ["vcf", "text/x-vcard"],
  ["vcg", "application/vnd.groove-vcard"],
  ["vcs", "text/x-vcalendar"],
  ["vcx", "application/vnd.vcx"],
  ["vdi", "application/x-virtualbox-vdi"],
  ["vds", "model/vnd.sap.vds"],
  ["vhd", "application/x-virtualbox-vhd"],
  ["vis", "application/vnd.visionary"],
  ["viv", "video/vnd.vivo"],
  ["vlc", "application/videolan"],
  ["vmdk", "application/x-virtualbox-vmdk"],
  ["vob", "video/x-ms-vob"],
  ["vor", "application/vnd.stardivision.writer"],
  ["vox", "application/x-authorware-bin"],
  ["vrml", "model/vrml"],
  ["vsd", "application/vnd.visio"],
  ["vsf", "application/vnd.vsf"],
  ["vss", "application/vnd.visio"],
  ["vst", "application/vnd.visio"],
  ["vsw", "application/vnd.visio"],
  ["vtf", "image/vnd.valve.source.texture"],
  ["vtt", "text/vtt"],
  ["vtu", "model/vnd.vtu"],
  ["vxml", "application/voicexml+xml"],
  ["w3d", "application/x-director"],
  ["wad", "application/x-doom"],
  ["wadl", "application/vnd.sun.wadl+xml"],
  ["war", "application/java-archive"],
  ["wasm", "application/wasm"],
  ["wav", "audio/x-wav"],
  ["wax", "audio/x-ms-wax"],
  ["wbmp", "image/vnd.wap.wbmp"],
  ["wbs", "application/vnd.criticaltools.wbs+xml"],
  ["wbxml", "application/wbxml"],
  ["wcm", "application/vnd.ms-works"],
  ["wdb", "application/vnd.ms-works"],
  ["wdp", "image/vnd.ms-photo"],
  ["weba", "audio/webm"],
  ["webapp", "application/x-web-app-manifest+json"],
  ["webm", "video/webm"],
  ["webmanifest", "application/manifest+json"],
  ["webp", "image/webp"],
  ["wg", "application/vnd.pmi.widget"],
  ["wgt", "application/widget"],
  ["wks", "application/vnd.ms-works"],
  ["wm", "video/x-ms-wm"],
  ["wma", "audio/x-ms-wma"],
  ["wmd", "application/x-ms-wmd"],
  ["wmf", "image/wmf"],
  ["wml", "text/vnd.wap.wml"],
  ["wmlc", "application/wmlc"],
  ["wmls", "text/vnd.wap.wmlscript"],
  ["wmlsc", "application/vnd.wap.wmlscriptc"],
  ["wmv", "video/x-ms-wmv"],
  ["wmx", "video/x-ms-wmx"],
  ["wmz", "application/x-msmetafile"],
  ["woff", "font/woff"],
  ["woff2", "font/woff2"],
  ["word", "application/msword"],
  ["wpd", "application/vnd.wordperfect"],
  ["wpl", "application/vnd.ms-wpl"],
  ["wps", "application/vnd.ms-works"],
  ["wqd", "application/vnd.wqd"],
  ["wri", "application/x-mswrite"],
  ["wrl", "model/vrml"],
  ["wsc", "message/vnd.wfa.wsc"],
  ["wsdl", "application/wsdl+xml"],
  ["wspolicy", "application/wspolicy+xml"],
  ["wtb", "application/vnd.webturbo"],
  ["wvx", "video/x-ms-wvx"],
  ["x3d", "model/x3d+xml"],
  ["x3db", "model/x3d+fastinfoset"],
  ["x3dbz", "model/x3d+binary"],
  ["x3dv", "model/x3d-vrml"],
  ["x3dvz", "model/x3d+vrml"],
  ["x3dz", "model/x3d+xml"],
  ["x32", "application/x-authorware-bin"],
  ["x_b", "model/vnd.parasolid.transmit.binary"],
  ["x_t", "model/vnd.parasolid.transmit.text"],
  ["xaml", "application/xaml+xml"],
  ["xap", "application/x-silverlight-app"],
  ["xar", "application/vnd.xara"],
  ["xav", "application/xcap-att+xml"],
  ["xbap", "application/x-ms-xbap"],
  ["xbd", "application/vnd.fujixerox.docuworks.binder"],
  ["xbm", "image/x-xbitmap"],
  ["xca", "application/xcap-caps+xml"],
  ["xcs", "application/calendar+xml"],
  ["xdf", "application/xcap-diff+xml"],
  ["xdm", "application/vnd.syncml.dm+xml"],
  ["xdp", "application/vnd.adobe.xdp+xml"],
  ["xdssc", "application/dssc+xml"],
  ["xdw", "application/vnd.fujixerox.docuworks"],
  ["xel", "application/xcap-el+xml"],
  ["xenc", "application/xenc+xml"],
  ["xer", "application/patch-ops-error+xml"],
  ["xfdf", "application/vnd.adobe.xfdf"],
  ["xfdl", "application/vnd.xfdl"],
  ["xht", "application/xhtml+xml"],
  ["xhtml", "application/xhtml+xml"],
  ["xhvml", "application/xv+xml"],
  ["xif", "image/vnd.xiff"],
  ["xl", "application/excel"],
  ["xla", "application/vnd.ms-excel"],
  ["xlam", "application/vnd.ms-excel.addin.macroEnabled.12"],
  ["xlc", "application/vnd.ms-excel"],
  ["xlf", "application/xliff+xml"],
  ["xlm", "application/vnd.ms-excel"],
  ["xls", "application/vnd.ms-excel"],
  ["xlsb", "application/vnd.ms-excel.sheet.binary.macroEnabled.12"],
  ["xlsm", "application/vnd.ms-excel.sheet.macroEnabled.12"],
  ["xlsx", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"],
  ["xlt", "application/vnd.ms-excel"],
  ["xltm", "application/vnd.ms-excel.template.macroEnabled.12"],
  ["xltx", "application/vnd.openxmlformats-officedocument.spreadsheetml.template"],
  ["xlw", "application/vnd.ms-excel"],
  ["xm", "audio/xm"],
  ["xml", "application/xml"],
  ["xns", "application/xcap-ns+xml"],
  ["xo", "application/vnd.olpc-sugar"],
  ["xop", "application/xop+xml"],
  ["xpi", "application/x-xpinstall"],
  ["xpl", "application/xproc+xml"],
  ["xpm", "image/x-xpixmap"],
  ["xpr", "application/vnd.is-xpr"],
  ["xps", "application/vnd.ms-xpsdocument"],
  ["xpw", "application/vnd.intercon.formnet"],
  ["xpx", "application/vnd.intercon.formnet"],
  ["xsd", "application/xml"],
  ["xsl", "application/xml"],
  ["xslt", "application/xslt+xml"],
  ["xsm", "application/vnd.syncml+xml"],
  ["xspf", "application/xspf+xml"],
  ["xul", "application/vnd.mozilla.xul+xml"],
  ["xvm", "application/xv+xml"],
  ["xvml", "application/xv+xml"],
  ["xwd", "image/x-xwindowdump"],
  ["xyz", "chemical/x-xyz"],
  ["xz", "application/x-xz"],
  ["yaml", "text/yaml"],
  ["yang", "application/yang"],
  ["yin", "application/yin+xml"],
  ["yml", "text/yaml"],
  ["ymp", "text/x-suse-ymp"],
  ["z", "application/x-compress"],
  ["z1", "application/x-zmachine"],
  ["z2", "application/x-zmachine"],
  ["z3", "application/x-zmachine"],
  ["z4", "application/x-zmachine"],
  ["z5", "application/x-zmachine"],
  ["z6", "application/x-zmachine"],
  ["z7", "application/x-zmachine"],
  ["z8", "application/x-zmachine"],
  ["zaz", "application/vnd.zzazz.deck+xml"],
  ["zip", "application/zip"],
  ["zir", "application/vnd.zul"],
  ["zirz", "application/vnd.zul"],
  ["zmm", "application/vnd.handheld-entertainment+xml"],
  ["zsh", "text/x-scriptzsh"]
]);
function toFileWithPath(file, path, h2) {
  const f2 = withMimeType(file);
  const { webkitRelativePath } = file;
  const p2 = typeof path === "string" ? path : typeof webkitRelativePath === "string" && webkitRelativePath.length > 0 ? webkitRelativePath : `./${file.name}`;
  if (typeof f2.path !== "string") {
    setObjProp(f2, "path", p2);
  }
  setObjProp(f2, "relativePath", p2);
  return f2;
}
function withMimeType(file) {
  const { name } = file;
  const hasExtension = name && name.lastIndexOf(".") !== -1;
  if (hasExtension && !file.type) {
    const ext = name.split(".").pop().toLowerCase();
    const type2 = COMMON_MIME_TYPES.get(ext);
    if (type2) {
      Object.defineProperty(file, "type", {
        value: type2,
        writable: false,
        configurable: false,
        enumerable: true
      });
    }
  }
  return file;
}
function setObjProp(f2, key, value) {
  Object.defineProperty(f2, key, {
    value,
    writable: false,
    configurable: false,
    enumerable: true
  });
}
const FILES_TO_IGNORE = [
  // Thumbnail cache files for macOS and Windows
  ".DS_Store",
  // macOs
  "Thumbs.db"
  // Windows
];
function fromEvent(evt) {
  return __awaiter(this, void 0, void 0, function* () {
    if (isObject$5(evt) && isDataTransfer(evt.dataTransfer)) {
      return getDataTransferFiles(evt.dataTransfer, evt.type);
    } else if (isChangeEvt(evt)) {
      return getInputFiles(evt);
    } else if (Array.isArray(evt) && evt.every((item) => "getFile" in item && typeof item.getFile === "function")) {
      return getFsHandleFiles(evt);
    }
    return [];
  });
}
function isDataTransfer(value) {
  return isObject$5(value);
}
function isChangeEvt(value) {
  return isObject$5(value) && isObject$5(value.target);
}
function isObject$5(v2) {
  return typeof v2 === "object" && v2 !== null;
}
function getInputFiles(evt) {
  return fromList(evt.target.files).map((file) => toFileWithPath(file));
}
function getFsHandleFiles(handles) {
  return __awaiter(this, void 0, void 0, function* () {
    const files = yield Promise.all(handles.map((h2) => h2.getFile()));
    return files.map((file) => toFileWithPath(file));
  });
}
function getDataTransferFiles(dt, type2) {
  return __awaiter(this, void 0, void 0, function* () {
    if (dt.items) {
      const items = fromList(dt.items).filter((item) => item.kind === "file");
      if (type2 !== "drop") {
        return items;
      }
      const files = yield Promise.all(items.map(toFilePromises));
      return noIgnoredFiles(flatten(files));
    }
    return noIgnoredFiles(fromList(dt.files).map((file) => toFileWithPath(file)));
  });
}
function noIgnoredFiles(files) {
  return files.filter((file) => FILES_TO_IGNORE.indexOf(file.name) === -1);
}
function fromList(items) {
  if (items === null) {
    return [];
  }
  const files = [];
  for (let i = 0; i < items.length; i++) {
    const file = items[i];
    files.push(file);
  }
  return files;
}
function toFilePromises(item) {
  if (typeof item.webkitGetAsEntry !== "function") {
    return fromDataTransferItem(item);
  }
  const entry = item.webkitGetAsEntry();
  if (entry && entry.isDirectory) {
    return fromDirEntry(entry);
  }
  return fromDataTransferItem(item, entry);
}
function flatten(items) {
  return items.reduce((acc, files) => [
    ...acc,
    ...Array.isArray(files) ? flatten(files) : [files]
  ], []);
}
function fromDataTransferItem(item, entry) {
  return __awaiter(this, void 0, void 0, function* () {
    var _a2;
    if (globalThis.isSecureContext && typeof item.getAsFileSystemHandle === "function") {
      const h2 = yield item.getAsFileSystemHandle();
      if (h2 === null) {
        throw new Error(`${item} is not a File`);
      }
      if (h2 !== void 0) {
        const file2 = yield h2.getFile();
        file2.handle = h2;
        return toFileWithPath(file2);
      }
    }
    const file = item.getAsFile();
    if (!file) {
      throw new Error(`${item} is not a File`);
    }
    const fwp = toFileWithPath(file, (_a2 = entry === null || entry === void 0 ? void 0 : entry.fullPath) !== null && _a2 !== void 0 ? _a2 : void 0);
    return fwp;
  });
}
function fromEntry(entry) {
  return __awaiter(this, void 0, void 0, function* () {
    return entry.isDirectory ? fromDirEntry(entry) : fromFileEntry(entry);
  });
}
function fromDirEntry(entry) {
  const reader = entry.createReader();
  return new Promise((resolve, reject) => {
    const entries = [];
    function readEntries() {
      reader.readEntries((batch) => __awaiter(this, void 0, void 0, function* () {
        if (!batch.length) {
          try {
            const files = yield Promise.all(entries);
            resolve(files);
          } catch (err) {
            reject(err);
          }
        } else {
          const items = Promise.all(batch.map(fromEntry));
          entries.push(items);
          readEntries();
        }
      }), (err) => {
        reject(err);
      });
    }
    readEntries();
  });
}
function fromFileEntry(entry) {
  return __awaiter(this, void 0, void 0, function* () {
    return new Promise((resolve, reject) => {
      entry.file((file) => {
        const fwp = toFileWithPath(file, entry.fullPath);
        resolve(fwp);
      }, (err) => {
        reject(err);
      });
    });
  });
}
var _default$1 = function(file, acceptedFiles) {
  if (file && acceptedFiles) {
    var acceptedFilesArray = Array.isArray(acceptedFiles) ? acceptedFiles : acceptedFiles.split(",");
    if (acceptedFilesArray.length === 0) {
      return true;
    }
    var fileName = file.name || "";
    var mimeType = (file.type || "").toLowerCase();
    var baseMimeType = mimeType.replace(/\/.*$/, "");
    return acceptedFilesArray.some(function(type2) {
      var validType = type2.trim().toLowerCase();
      if (validType.charAt(0) === ".") {
        return fileName.toLowerCase().endsWith(validType);
      } else if (validType.endsWith("/*")) {
        return baseMimeType === validType.replace(/\/.*$/, "");
      }
      return mimeType === validType;
    });
  }
  return true;
};
function _toConsumableArray$2(arr) {
  return _arrayWithoutHoles$2(arr) || _iterableToArray$2(arr) || _unsupportedIterableToArray$2(arr) || _nonIterableSpread$2();
}
function _nonIterableSpread$2() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArray$2(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _arrayWithoutHoles$2(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray$2(arr);
}
function ownKeys$6(object2, enumerableOnly) {
  var keys3 = Object.keys(object2);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object2);
    enumerableOnly && (symbols = symbols.filter(function(sym) {
      return Object.getOwnPropertyDescriptor(object2, sym).enumerable;
    })), keys3.push.apply(keys3, symbols);
  }
  return keys3;
}
function _objectSpread$4(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys$6(Object(source), true).forEach(function(key) {
      _defineProperty$6(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$6(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _defineProperty$6(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _slicedToArray$2(arr, i) {
  return _arrayWithHoles$2(arr) || _iterableToArrayLimit$2(arr, i) || _unsupportedIterableToArray$2(arr, i) || _nonIterableRest$2();
}
function _nonIterableRest$2() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray$2(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray$2(o, minLen);
  var n2 = Object.prototype.toString.call(o).slice(8, -1);
  if (n2 === "Object" && o.constructor) n2 = o.constructor.name;
  if (n2 === "Map" || n2 === "Set") return Array.from(o);
  if (n2 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n2)) return _arrayLikeToArray$2(o, minLen);
}
function _arrayLikeToArray$2(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
function _iterableToArrayLimit$2(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _s, _e;
  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }
  return _arr;
}
function _arrayWithHoles$2(arr) {
  if (Array.isArray(arr)) return arr;
}
var accepts = typeof _default$1 === "function" ? _default$1 : _default$1.default;
var FILE_INVALID_TYPE = "file-invalid-type";
var FILE_TOO_LARGE = "file-too-large";
var FILE_TOO_SMALL = "file-too-small";
var TOO_MANY_FILES = "too-many-files";
var getInvalidTypeRejectionErr = function getInvalidTypeRejectionErr2() {
  var accept = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
  var acceptArr = accept.split(",");
  var msg = acceptArr.length > 1 ? "one of ".concat(acceptArr.join(", ")) : acceptArr[0];
  return {
    code: FILE_INVALID_TYPE,
    message: "File type must be ".concat(msg)
  };
};
var getTooLargeRejectionErr = function getTooLargeRejectionErr2(maxSize) {
  return {
    code: FILE_TOO_LARGE,
    message: "File is larger than ".concat(maxSize, " ").concat(maxSize === 1 ? "byte" : "bytes")
  };
};
var getTooSmallRejectionErr = function getTooSmallRejectionErr2(minSize) {
  return {
    code: FILE_TOO_SMALL,
    message: "File is smaller than ".concat(minSize, " ").concat(minSize === 1 ? "byte" : "bytes")
  };
};
var TOO_MANY_FILES_REJECTION = {
  code: TOO_MANY_FILES,
  message: "Too many files"
};
function fileAccepted(file, accept) {
  var isAcceptable = file.type === "application/x-moz-file" || accepts(file, accept);
  return [isAcceptable, isAcceptable ? null : getInvalidTypeRejectionErr(accept)];
}
function fileMatchSize(file, minSize, maxSize) {
  if (isDefined(file.size)) {
    if (isDefined(minSize) && isDefined(maxSize)) {
      if (file.size > maxSize) return [false, getTooLargeRejectionErr(maxSize)];
      if (file.size < minSize) return [false, getTooSmallRejectionErr(minSize)];
    } else if (isDefined(minSize) && file.size < minSize) return [false, getTooSmallRejectionErr(minSize)];
    else if (isDefined(maxSize) && file.size > maxSize) return [false, getTooLargeRejectionErr(maxSize)];
  }
  return [true, null];
}
function isDefined(value) {
  return value !== void 0 && value !== null;
}
function allFilesAccepted(_ref3) {
  var files = _ref3.files, accept = _ref3.accept, minSize = _ref3.minSize, maxSize = _ref3.maxSize, multiple = _ref3.multiple, maxFiles = _ref3.maxFiles, validator = _ref3.validator;
  if (!multiple && files.length > 1 || multiple && maxFiles >= 1 && files.length > maxFiles) {
    return false;
  }
  return files.every(function(file) {
    var _fileAccepted = fileAccepted(file, accept), _fileAccepted2 = _slicedToArray$2(_fileAccepted, 1), accepted = _fileAccepted2[0];
    var _fileMatchSize = fileMatchSize(file, minSize, maxSize), _fileMatchSize2 = _slicedToArray$2(_fileMatchSize, 1), sizeMatch = _fileMatchSize2[0];
    var customErrors = validator ? validator(file) : null;
    return accepted && sizeMatch && !customErrors;
  });
}
function isPropagationStopped(event) {
  if (typeof event.isPropagationStopped === "function") {
    return event.isPropagationStopped();
  } else if (typeof event.cancelBubble !== "undefined") {
    return event.cancelBubble;
  }
  return false;
}
function isEvtWithFiles(event) {
  if (!event.dataTransfer) {
    return !!event.target && !!event.target.files;
  }
  return Array.prototype.some.call(event.dataTransfer.types, function(type2) {
    return type2 === "Files" || type2 === "application/x-moz-file";
  });
}
function onDocumentDragOver(event) {
  event.preventDefault();
}
function isIe(userAgent) {
  return userAgent.indexOf("MSIE") !== -1 || userAgent.indexOf("Trident/") !== -1;
}
function isEdge(userAgent) {
  return userAgent.indexOf("Edge/") !== -1;
}
function isIeOrEdge() {
  var userAgent = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : window.navigator.userAgent;
  return isIe(userAgent) || isEdge(userAgent);
}
function composeEventHandlers$1() {
  for (var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++) {
    fns[_key] = arguments[_key];
  }
  return function(event) {
    for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      args[_key2 - 1] = arguments[_key2];
    }
    return fns.some(function(fn2) {
      if (!isPropagationStopped(event) && fn2) {
        fn2.apply(void 0, [event].concat(args));
      }
      return isPropagationStopped(event);
    });
  };
}
function canUseFileSystemAccessAPI() {
  return "showOpenFilePicker" in window;
}
function pickerOptionsFromAccept(accept) {
  if (isDefined(accept)) {
    var acceptForPicker = Object.entries(accept).filter(function(_ref22) {
      var _ref3 = _slicedToArray$2(_ref22, 2), mimeType = _ref3[0], ext = _ref3[1];
      var ok = true;
      if (!isMIMEType(mimeType)) {
        console.warn('Skipped "'.concat(mimeType, '" because it is not a valid MIME type. Check https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Common_types for a list of valid MIME types.'));
        ok = false;
      }
      if (!Array.isArray(ext) || !ext.every(isExt)) {
        console.warn('Skipped "'.concat(mimeType, '" because an invalid file extension was provided.'));
        ok = false;
      }
      return ok;
    }).reduce(function(agg, _ref4) {
      var _ref5 = _slicedToArray$2(_ref4, 2), mimeType = _ref5[0], ext = _ref5[1];
      return _objectSpread$4(_objectSpread$4({}, agg), {}, _defineProperty$6({}, mimeType, ext));
    }, {});
    return [{
      // description is required due to https://crbug.com/1264708
      description: "Files",
      accept: acceptForPicker
    }];
  }
  return accept;
}
function acceptPropAsAcceptAttr(accept) {
  if (isDefined(accept)) {
    return Object.entries(accept).reduce(function(a2, _ref6) {
      var _ref7 = _slicedToArray$2(_ref6, 2), mimeType = _ref7[0], ext = _ref7[1];
      return [].concat(_toConsumableArray$2(a2), [mimeType], _toConsumableArray$2(ext));
    }, []).filter(function(v2) {
      return isMIMEType(v2) || isExt(v2);
    }).join(",");
  }
  return void 0;
}
function isAbort(v2) {
  return v2 instanceof DOMException && (v2.name === "AbortError" || v2.code === v2.ABORT_ERR);
}
function isSecurityError(v2) {
  return v2 instanceof DOMException && (v2.name === "SecurityError" || v2.code === v2.SECURITY_ERR);
}
function isMIMEType(v2) {
  return v2 === "audio/*" || v2 === "video/*" || v2 === "image/*" || v2 === "text/*" || v2 === "application/*" || /\w+\/[-+.\w]+/g.test(v2);
}
function isExt(v2) {
  return /^.*\.[\w]+$/.test(v2);
}
var _excluded$7 = ["children"], _excluded2$2 = ["open"], _excluded3 = ["refKey", "role", "onKeyDown", "onFocus", "onBlur", "onClick", "onDragEnter", "onDragOver", "onDragLeave", "onDrop"], _excluded4 = ["refKey", "onChange", "onClick"];
function _toConsumableArray$1(arr) {
  return _arrayWithoutHoles$1(arr) || _iterableToArray$1(arr) || _unsupportedIterableToArray$1(arr) || _nonIterableSpread$1();
}
function _nonIterableSpread$1() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArray$1(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _arrayWithoutHoles$1(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray$1(arr);
}
function _slicedToArray$1(arr, i) {
  return _arrayWithHoles$1(arr) || _iterableToArrayLimit$1(arr, i) || _unsupportedIterableToArray$1(arr, i) || _nonIterableRest$1();
}
function _nonIterableRest$1() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray$1(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray$1(o, minLen);
  var n2 = Object.prototype.toString.call(o).slice(8, -1);
  if (n2 === "Object" && o.constructor) n2 = o.constructor.name;
  if (n2 === "Map" || n2 === "Set") return Array.from(o);
  if (n2 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n2)) return _arrayLikeToArray$1(o, minLen);
}
function _arrayLikeToArray$1(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
function _iterableToArrayLimit$1(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _s, _e;
  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }
  return _arr;
}
function _arrayWithHoles$1(arr) {
  if (Array.isArray(arr)) return arr;
}
function ownKeys$5(object2, enumerableOnly) {
  var keys3 = Object.keys(object2);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object2);
    enumerableOnly && (symbols = symbols.filter(function(sym) {
      return Object.getOwnPropertyDescriptor(object2, sym).enumerable;
    })), keys3.push.apply(keys3, symbols);
  }
  return keys3;
}
function _objectSpread$3(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys$5(Object(source), true).forEach(function(key) {
      _defineProperty$5(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$5(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _defineProperty$5(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _objectWithoutProperties$4(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose$3(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose$3(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
var Dropzone = /* @__PURE__ */ forwardRef(function(_ref3, ref2) {
  var children = _ref3.children, params = _objectWithoutProperties$4(_ref3, _excluded$7);
  var _useDropzone = useDropzone(params), open = _useDropzone.open, props = _objectWithoutProperties$4(_useDropzone, _excluded2$2);
  useImperativeHandle(ref2, function() {
    return {
      open
    };
  }, [open]);
  return /* @__PURE__ */ React__default.createElement(Fragment, null, children(_objectSpread$3(_objectSpread$3({}, props), {}, {
    open
  })));
});
Dropzone.displayName = "Dropzone";
var defaultProps$1 = {
  disabled: false,
  getFilesFromEvent: fromEvent,
  maxSize: Infinity,
  minSize: 0,
  multiple: true,
  maxFiles: 0,
  preventDropOnDocument: true,
  noClick: false,
  noKeyboard: false,
  noDrag: false,
  noDragEventsBubbling: false,
  validator: null,
  useFsAccessApi: false,
  autoFocus: false
};
Dropzone.defaultProps = defaultProps$1;
Dropzone.propTypes = {
  /**
   * Render function that exposes the dropzone state and prop getter fns
   *
   * @param {object} params
   * @param {Function} params.getRootProps Returns the props you should apply to the root drop container you render
   * @param {Function} params.getInputProps Returns the props you should apply to hidden file input you render
   * @param {Function} params.open Open the native file selection dialog
   * @param {boolean} params.isFocused Dropzone area is in focus
   * @param {boolean} params.isFileDialogActive File dialog is opened
   * @param {boolean} params.isDragActive Active drag is in progress
   * @param {boolean} params.isDragAccept Dragged files are accepted
   * @param {boolean} params.isDragReject Some dragged files are rejected
   * @param {File[]} params.acceptedFiles Accepted files
   * @param {FileRejection[]} params.fileRejections Rejected files and why they were rejected
   */
  children: PropTypes.func,
  /**
   * Set accepted file types.
   * Checkout https://developer.mozilla.org/en-US/docs/Web/API/window/showOpenFilePicker types option for more information.
   * Keep in mind that mime type determination is not reliable across platforms. CSV files,
   * for example, are reported as text/plain under macOS but as application/vnd.ms-excel under
   * Windows. In some cases there might not be a mime type set at all (https://github.com/react-dropzone/react-dropzone/issues/276).
   */
  accept: PropTypes.objectOf(PropTypes.arrayOf(PropTypes.string)),
  /**
   * Allow drag 'n' drop (or selection from the file dialog) of multiple files
   */
  multiple: PropTypes.bool,
  /**
   * If false, allow dropped items to take over the current browser window
   */
  preventDropOnDocument: PropTypes.bool,
  /**
   * If true, disables click to open the native file selection dialog
   */
  noClick: PropTypes.bool,
  /**
   * If true, disables SPACE/ENTER to open the native file selection dialog.
   * Note that it also stops tracking the focus state.
   */
  noKeyboard: PropTypes.bool,
  /**
   * If true, disables drag 'n' drop
   */
  noDrag: PropTypes.bool,
  /**
   * If true, stops drag event propagation to parents
   */
  noDragEventsBubbling: PropTypes.bool,
  /**
   * Minimum file size (in bytes)
   */
  minSize: PropTypes.number,
  /**
   * Maximum file size (in bytes)
   */
  maxSize: PropTypes.number,
  /**
   * Maximum accepted number of files
   * The default value is 0 which means there is no limitation to how many files are accepted.
   */
  maxFiles: PropTypes.number,
  /**
   * Enable/disable the dropzone
   */
  disabled: PropTypes.bool,
  /**
   * Use this to provide a custom file aggregator
   *
   * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
   */
  getFilesFromEvent: PropTypes.func,
  /**
   * Cb for when closing the file dialog with no selection
   */
  onFileDialogCancel: PropTypes.func,
  /**
   * Cb for when opening the file dialog
   */
  onFileDialogOpen: PropTypes.func,
  /**
   * Set to true to use the https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API
   * to open the file picker instead of using an `<input type="file">` click event.
   */
  useFsAccessApi: PropTypes.bool,
  /**
   * Set to true to focus the root element on render
   */
  autoFocus: PropTypes.bool,
  /**
   * Cb for when the `dragenter` event occurs.
   *
   * @param {DragEvent} event
   */
  onDragEnter: PropTypes.func,
  /**
   * Cb for when the `dragleave` event occurs
   *
   * @param {DragEvent} event
   */
  onDragLeave: PropTypes.func,
  /**
   * Cb for when the `dragover` event occurs
   *
   * @param {DragEvent} event
   */
  onDragOver: PropTypes.func,
  /**
   * Cb for when the `drop` event occurs.
   * Note that this callback is invoked after the `getFilesFromEvent` callback is done.
   *
   * Files are accepted or rejected based on the `accept`, `multiple`, `minSize` and `maxSize` props.
   * `accept` must be a valid [MIME type](http://www.iana.org/assignments/media-types/media-types.xhtml) according to [input element specification](https://www.w3.org/wiki/HTML/Elements/input/file) or a valid file extension.
   * If `multiple` is set to false and additional files are dropped,
   * all files besides the first will be rejected.
   * Any file which does not have a size in the [`minSize`, `maxSize`] range, will be rejected as well.
   *
   * Note that the `onDrop` callback will always be invoked regardless if the dropped files were accepted or rejected.
   * If you'd like to react to a specific scenario, use the `onDropAccepted`/`onDropRejected` props.
   *
   * `onDrop` will provide you with an array of [File](https://developer.mozilla.org/en-US/docs/Web/API/File) objects which you can then process and send to a server.
   * For example, with [SuperAgent](https://github.com/visionmedia/superagent) as a http/ajax library:
   *
   * ```js
   * function onDrop(acceptedFiles) {
   *   const req = request.post('/upload')
   *   acceptedFiles.forEach(file => {
   *     req.attach(file.name, file)
   *   })
   *   req.end(callback)
   * }
   * ```
   *
   * @param {File[]} acceptedFiles
   * @param {FileRejection[]} fileRejections
   * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
   */
  onDrop: PropTypes.func,
  /**
   * Cb for when the `drop` event occurs.
   * Note that if no files are accepted, this callback is not invoked.
   *
   * @param {File[]} files
   * @param {(DragEvent|Event)} event
   */
  onDropAccepted: PropTypes.func,
  /**
   * Cb for when the `drop` event occurs.
   * Note that if no files are rejected, this callback is not invoked.
   *
   * @param {FileRejection[]} fileRejections
   * @param {(DragEvent|Event)} event
   */
  onDropRejected: PropTypes.func,
  /**
   * Cb for when there's some error from any of the promises.
   *
   * @param {Error} error
   */
  onError: PropTypes.func,
  /**
   * Custom validation function. It must return null if there's no errors.
   * @param {File} file
   * @returns {FileError|FileError[]|null}
   */
  validator: PropTypes.func
};
var initialState = {
  isFocused: false,
  isFileDialogActive: false,
  isDragActive: false,
  isDragAccept: false,
  isDragReject: false,
  acceptedFiles: [],
  fileRejections: []
};
function useDropzone() {
  var props = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  var _defaultProps$props = _objectSpread$3(_objectSpread$3({}, defaultProps$1), props), accept = _defaultProps$props.accept, disabled = _defaultProps$props.disabled, getFilesFromEvent = _defaultProps$props.getFilesFromEvent, maxSize = _defaultProps$props.maxSize, minSize = _defaultProps$props.minSize, multiple = _defaultProps$props.multiple, maxFiles = _defaultProps$props.maxFiles, onDragEnter = _defaultProps$props.onDragEnter, onDragLeave = _defaultProps$props.onDragLeave, onDragOver = _defaultProps$props.onDragOver, onDrop = _defaultProps$props.onDrop, onDropAccepted = _defaultProps$props.onDropAccepted, onDropRejected = _defaultProps$props.onDropRejected, onFileDialogCancel = _defaultProps$props.onFileDialogCancel, onFileDialogOpen = _defaultProps$props.onFileDialogOpen, useFsAccessApi = _defaultProps$props.useFsAccessApi, autoFocus = _defaultProps$props.autoFocus, preventDropOnDocument = _defaultProps$props.preventDropOnDocument, noClick = _defaultProps$props.noClick, noKeyboard = _defaultProps$props.noKeyboard, noDrag = _defaultProps$props.noDrag, noDragEventsBubbling = _defaultProps$props.noDragEventsBubbling, onError = _defaultProps$props.onError, validator = _defaultProps$props.validator;
  var acceptAttr = useMemo(function() {
    return acceptPropAsAcceptAttr(accept);
  }, [accept]);
  var pickerTypes = useMemo(function() {
    return pickerOptionsFromAccept(accept);
  }, [accept]);
  var onFileDialogOpenCb = useMemo(function() {
    return typeof onFileDialogOpen === "function" ? onFileDialogOpen : noop$4;
  }, [onFileDialogOpen]);
  var onFileDialogCancelCb = useMemo(function() {
    return typeof onFileDialogCancel === "function" ? onFileDialogCancel : noop$4;
  }, [onFileDialogCancel]);
  var rootRef = useRef(null);
  var inputRef = useRef(null);
  var _useReducer = useReducer(reducer, initialState), _useReducer2 = _slicedToArray$1(_useReducer, 2), state = _useReducer2[0], dispatch = _useReducer2[1];
  var isFocused = state.isFocused, isFileDialogActive = state.isFileDialogActive;
  var fsAccessApiWorksRef = useRef(typeof window !== "undefined" && window.isSecureContext && useFsAccessApi && canUseFileSystemAccessAPI());
  var onWindowFocus = function onWindowFocus2() {
    if (!fsAccessApiWorksRef.current && isFileDialogActive) {
      setTimeout(function() {
        if (inputRef.current) {
          var files = inputRef.current.files;
          if (!files.length) {
            dispatch({
              type: "closeDialog"
            });
            onFileDialogCancelCb();
          }
        }
      }, 300);
    }
  };
  useEffect(function() {
    window.addEventListener("focus", onWindowFocus, false);
    return function() {
      window.removeEventListener("focus", onWindowFocus, false);
    };
  }, [inputRef, isFileDialogActive, onFileDialogCancelCb, fsAccessApiWorksRef]);
  var dragTargetsRef = useRef([]);
  var onDocumentDrop = function onDocumentDrop2(event) {
    if (rootRef.current && rootRef.current.contains(event.target)) {
      return;
    }
    event.preventDefault();
    dragTargetsRef.current = [];
  };
  useEffect(function() {
    if (preventDropOnDocument) {
      document.addEventListener("dragover", onDocumentDragOver, false);
      document.addEventListener("drop", onDocumentDrop, false);
    }
    return function() {
      if (preventDropOnDocument) {
        document.removeEventListener("dragover", onDocumentDragOver);
        document.removeEventListener("drop", onDocumentDrop);
      }
    };
  }, [rootRef, preventDropOnDocument]);
  useEffect(function() {
    if (!disabled && autoFocus && rootRef.current) {
      rootRef.current.focus();
    }
    return function() {
    };
  }, [rootRef, autoFocus, disabled]);
  var onErrCb = useCallback(function(e3) {
    if (onError) {
      onError(e3);
    } else {
      console.error(e3);
    }
  }, [onError]);
  var onDragEnterCb = useCallback(function(event) {
    event.preventDefault();
    event.persist();
    stopPropagation(event);
    dragTargetsRef.current = [].concat(_toConsumableArray$1(dragTargetsRef.current), [event.target]);
    if (isEvtWithFiles(event)) {
      Promise.resolve(getFilesFromEvent(event)).then(function(files) {
        if (isPropagationStopped(event) && !noDragEventsBubbling) {
          return;
        }
        var fileCount = files.length;
        var isDragAccept = fileCount > 0 && allFilesAccepted({
          files,
          accept: acceptAttr,
          minSize,
          maxSize,
          multiple,
          maxFiles,
          validator
        });
        var isDragReject = fileCount > 0 && !isDragAccept;
        dispatch({
          isDragAccept,
          isDragReject,
          isDragActive: true,
          type: "setDraggedFiles"
        });
        if (onDragEnter) {
          onDragEnter(event);
        }
      }).catch(function(e3) {
        return onErrCb(e3);
      });
    }
  }, [getFilesFromEvent, onDragEnter, onErrCb, noDragEventsBubbling, acceptAttr, minSize, maxSize, multiple, maxFiles, validator]);
  var onDragOverCb = useCallback(function(event) {
    event.preventDefault();
    event.persist();
    stopPropagation(event);
    var hasFiles = isEvtWithFiles(event);
    if (hasFiles && event.dataTransfer) {
      try {
        event.dataTransfer.dropEffect = "copy";
      } catch (_unused) {
      }
    }
    if (hasFiles && onDragOver) {
      onDragOver(event);
    }
    return false;
  }, [onDragOver, noDragEventsBubbling]);
  var onDragLeaveCb = useCallback(function(event) {
    event.preventDefault();
    event.persist();
    stopPropagation(event);
    var targets = dragTargetsRef.current.filter(function(target) {
      return rootRef.current && rootRef.current.contains(target);
    });
    var targetIdx = targets.indexOf(event.target);
    if (targetIdx !== -1) {
      targets.splice(targetIdx, 1);
    }
    dragTargetsRef.current = targets;
    if (targets.length > 0) {
      return;
    }
    dispatch({
      type: "setDraggedFiles",
      isDragActive: false,
      isDragAccept: false,
      isDragReject: false
    });
    if (isEvtWithFiles(event) && onDragLeave) {
      onDragLeave(event);
    }
  }, [rootRef, onDragLeave, noDragEventsBubbling]);
  var setFiles = useCallback(function(files, event) {
    var acceptedFiles = [];
    var fileRejections = [];
    files.forEach(function(file) {
      var _fileAccepted = fileAccepted(file, acceptAttr), _fileAccepted2 = _slicedToArray$1(_fileAccepted, 2), accepted = _fileAccepted2[0], acceptError = _fileAccepted2[1];
      var _fileMatchSize = fileMatchSize(file, minSize, maxSize), _fileMatchSize2 = _slicedToArray$1(_fileMatchSize, 2), sizeMatch = _fileMatchSize2[0], sizeError = _fileMatchSize2[1];
      var customErrors = validator ? validator(file) : null;
      if (accepted && sizeMatch && !customErrors) {
        acceptedFiles.push(file);
      } else {
        var errors = [acceptError, sizeError];
        if (customErrors) {
          errors = errors.concat(customErrors);
        }
        fileRejections.push({
          file,
          errors: errors.filter(function(e3) {
            return e3;
          })
        });
      }
    });
    if (!multiple && acceptedFiles.length > 1 || multiple && maxFiles >= 1 && acceptedFiles.length > maxFiles) {
      acceptedFiles.forEach(function(file) {
        fileRejections.push({
          file,
          errors: [TOO_MANY_FILES_REJECTION]
        });
      });
      acceptedFiles.splice(0);
    }
    dispatch({
      acceptedFiles,
      fileRejections,
      isDragReject: fileRejections.length > 0,
      type: "setFiles"
    });
    if (onDrop) {
      onDrop(acceptedFiles, fileRejections, event);
    }
    if (fileRejections.length > 0 && onDropRejected) {
      onDropRejected(fileRejections, event);
    }
    if (acceptedFiles.length > 0 && onDropAccepted) {
      onDropAccepted(acceptedFiles, event);
    }
  }, [dispatch, multiple, acceptAttr, minSize, maxSize, maxFiles, onDrop, onDropAccepted, onDropRejected, validator]);
  var onDropCb = useCallback(function(event) {
    event.preventDefault();
    event.persist();
    stopPropagation(event);
    dragTargetsRef.current = [];
    if (isEvtWithFiles(event)) {
      Promise.resolve(getFilesFromEvent(event)).then(function(files) {
        if (isPropagationStopped(event) && !noDragEventsBubbling) {
          return;
        }
        setFiles(files, event);
      }).catch(function(e3) {
        return onErrCb(e3);
      });
    }
    dispatch({
      type: "reset"
    });
  }, [getFilesFromEvent, setFiles, onErrCb, noDragEventsBubbling]);
  var openFileDialog = useCallback(function() {
    if (fsAccessApiWorksRef.current) {
      dispatch({
        type: "openDialog"
      });
      onFileDialogOpenCb();
      var opts = {
        multiple,
        types: pickerTypes
      };
      window.showOpenFilePicker(opts).then(function(handles) {
        return getFilesFromEvent(handles);
      }).then(function(files) {
        setFiles(files, null);
        dispatch({
          type: "closeDialog"
        });
      }).catch(function(e3) {
        if (isAbort(e3)) {
          onFileDialogCancelCb(e3);
          dispatch({
            type: "closeDialog"
          });
        } else if (isSecurityError(e3)) {
          fsAccessApiWorksRef.current = false;
          if (inputRef.current) {
            inputRef.current.value = null;
            inputRef.current.click();
          } else {
            onErrCb(new Error("Cannot open the file picker because the https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API is not supported and no <input> was provided."));
          }
        } else {
          onErrCb(e3);
        }
      });
      return;
    }
    if (inputRef.current) {
      dispatch({
        type: "openDialog"
      });
      onFileDialogOpenCb();
      inputRef.current.value = null;
      inputRef.current.click();
    }
  }, [dispatch, onFileDialogOpenCb, onFileDialogCancelCb, useFsAccessApi, setFiles, onErrCb, pickerTypes, multiple]);
  var onKeyDownCb = useCallback(function(event) {
    if (!rootRef.current || !rootRef.current.isEqualNode(event.target)) {
      return;
    }
    if (event.key === " " || event.key === "Enter" || event.keyCode === 32 || event.keyCode === 13) {
      event.preventDefault();
      openFileDialog();
    }
  }, [rootRef, openFileDialog]);
  var onFocusCb = useCallback(function() {
    dispatch({
      type: "focus"
    });
  }, []);
  var onBlurCb = useCallback(function() {
    dispatch({
      type: "blur"
    });
  }, []);
  var onClickCb = useCallback(function() {
    if (noClick) {
      return;
    }
    if (isIeOrEdge()) {
      setTimeout(openFileDialog, 0);
    } else {
      openFileDialog();
    }
  }, [noClick, openFileDialog]);
  var composeHandler = function composeHandler2(fn2) {
    return disabled ? null : fn2;
  };
  var composeKeyboardHandler = function composeKeyboardHandler2(fn2) {
    return noKeyboard ? null : composeHandler(fn2);
  };
  var composeDragHandler = function composeDragHandler2(fn2) {
    return noDrag ? null : composeHandler(fn2);
  };
  var stopPropagation = function stopPropagation2(event) {
    if (noDragEventsBubbling) {
      event.stopPropagation();
    }
  };
  var getRootProps = useMemo(function() {
    return function() {
      var _ref22 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _ref2$refKey = _ref22.refKey, refKey = _ref2$refKey === void 0 ? "ref" : _ref2$refKey, role = _ref22.role, onKeyDown = _ref22.onKeyDown, onFocus2 = _ref22.onFocus, onBlur = _ref22.onBlur, onClick = _ref22.onClick, onDragEnter2 = _ref22.onDragEnter, onDragOver2 = _ref22.onDragOver, onDragLeave2 = _ref22.onDragLeave, onDrop2 = _ref22.onDrop, rest = _objectWithoutProperties$4(_ref22, _excluded3);
      return _objectSpread$3(_objectSpread$3(_defineProperty$5({
        onKeyDown: composeKeyboardHandler(composeEventHandlers$1(onKeyDown, onKeyDownCb)),
        onFocus: composeKeyboardHandler(composeEventHandlers$1(onFocus2, onFocusCb)),
        onBlur: composeKeyboardHandler(composeEventHandlers$1(onBlur, onBlurCb)),
        onClick: composeHandler(composeEventHandlers$1(onClick, onClickCb)),
        onDragEnter: composeDragHandler(composeEventHandlers$1(onDragEnter2, onDragEnterCb)),
        onDragOver: composeDragHandler(composeEventHandlers$1(onDragOver2, onDragOverCb)),
        onDragLeave: composeDragHandler(composeEventHandlers$1(onDragLeave2, onDragLeaveCb)),
        onDrop: composeDragHandler(composeEventHandlers$1(onDrop2, onDropCb)),
        role: typeof role === "string" && role !== "" ? role : "presentation"
      }, refKey, rootRef), !disabled && !noKeyboard ? {
        tabIndex: 0
      } : {}), rest);
    };
  }, [rootRef, onKeyDownCb, onFocusCb, onBlurCb, onClickCb, onDragEnterCb, onDragOverCb, onDragLeaveCb, onDropCb, noKeyboard, noDrag, disabled]);
  var onInputElementClick = useCallback(function(event) {
    event.stopPropagation();
  }, []);
  var getInputProps = useMemo(function() {
    return function() {
      var _ref3 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _ref3$refKey = _ref3.refKey, refKey = _ref3$refKey === void 0 ? "ref" : _ref3$refKey, onChange2 = _ref3.onChange, onClick = _ref3.onClick, rest = _objectWithoutProperties$4(_ref3, _excluded4);
      var inputProps = _defineProperty$5({
        accept: acceptAttr,
        multiple,
        type: "file",
        style: {
          border: 0,
          clip: "rect(0, 0, 0, 0)",
          clipPath: "inset(50%)",
          height: "1px",
          margin: "0 -1px -1px 0",
          overflow: "hidden",
          padding: 0,
          position: "absolute",
          width: "1px",
          whiteSpace: "nowrap"
        },
        onChange: composeHandler(composeEventHandlers$1(onChange2, onDropCb)),
        onClick: composeHandler(composeEventHandlers$1(onClick, onInputElementClick)),
        tabIndex: -1
      }, refKey, inputRef);
      return _objectSpread$3(_objectSpread$3({}, inputProps), rest);
    };
  }, [inputRef, accept, multiple, onDropCb, disabled]);
  return _objectSpread$3(_objectSpread$3({}, state), {}, {
    isFocused: isFocused && !disabled,
    getRootProps,
    getInputProps,
    rootRef,
    inputRef,
    open: composeHandler(openFileDialog)
  });
}
function reducer(state, action) {
  switch (action.type) {
    case "focus":
      return _objectSpread$3(_objectSpread$3({}, state), {}, {
        isFocused: true
      });
    case "blur":
      return _objectSpread$3(_objectSpread$3({}, state), {}, {
        isFocused: false
      });
    case "openDialog":
      return _objectSpread$3(_objectSpread$3({}, initialState), {}, {
        isFileDialogActive: true
      });
    case "closeDialog":
      return _objectSpread$3(_objectSpread$3({}, state), {}, {
        isFileDialogActive: false
      });
    case "setDraggedFiles":
      return _objectSpread$3(_objectSpread$3({}, state), {}, {
        isDragActive: action.isDragActive,
        isDragAccept: action.isDragAccept,
        isDragReject: action.isDragReject
      });
    case "setFiles":
      return _objectSpread$3(_objectSpread$3({}, state), {}, {
        acceptedFiles: action.acceptedFiles,
        fileRejections: action.fileRejections,
        isDragReject: action.isDragReject
      });
    case "reset":
      return _objectSpread$3({}, initialState);
    default:
      return state;
  }
}
function noop$4() {
}
const FileUploadWrapper = styled.div`
  ${compose(space, color, typography, layout, flexbox, grid, background, border, position$1, shadow, padding)}
`;
const FileUploadTriggerContainer = styled.button`
  ${(props) => FocusRing({
  ...props.focusRingStyle
})}
  cursor: pointer;

  &:focus,
  &:focus-visible {
    outline: none;
  }

  ${compose(space, color, typography, layout, flexbox, grid, background, border, position$1, shadow, padding)}
`;
const FILE_UPLOAD_TRIGGER_STYLE = {
  backgroundColor: "transparent",
  border: "none",
  margin: "8px 0"
};
const FileUploadTrigger = forwardRef((props, ref2) => {
  const {
    children,
    ...rest
  } = props;
  const {
    dropzoneState
  } = useFileUploadContext();
  const themeProps = FILE_UPLOAD_TRIGGER_STYLE;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(FileUploadTriggerContainer, { ...dropzoneState.getRootProps(), ...themeProps, ref: ref2, ...rest, role: "button", type: "button", "aria-label": "Choose files to upload", "data-drag-active": dropzoneState.isDragActive, "data-testid": "file-upload-trigger", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("input", { ...dropzoneState.getInputProps(), "data-testid": "file-upload-input", "aria-hidden": "true", tabIndex: -1, hidden: true }),
    children
  ] });
});
const useFileUpload = () => {
  const [uploadFiles, setUploadFiles] = useState([]);
  const handleFile = useCallback((file, errors = [], status = UploadFileStatus.PENDING) => {
    setUploadFiles((prev2) => {
      if (!prev2.some((uploadFile) => uploadFile.file.name === file.name)) {
        return [...prev2, {
          file,
          errors,
          status
        }];
      }
      return prev2;
    });
  }, []);
  const handleFileUpdateStatus = useCallback((file, status) => {
    setUploadFiles((prev2) => prev2.map((uploadFile) => uploadFile.file.name === file.name ? {
      ...uploadFile,
      status
    } : uploadFile));
  }, []);
  const handleRemoveFile = useCallback((file) => {
    setUploadFiles((prev2) => prev2.filter((uploadFile) => uploadFile.file !== file));
  }, []);
  return {
    uploadFiles,
    handleFile,
    handleFileUpdateStatus,
    handleRemoveFile
  };
};
var UploadFileStatus = /* @__PURE__ */ ((UploadFileStatus2) => {
  UploadFileStatus2["PENDING"] = "pending";
  UploadFileStatus2["SUCCESS"] = "success";
  UploadFileStatus2["ERROR"] = "error";
  return UploadFileStatus2;
})(UploadFileStatus || {});
const [FileUploadProvider, useFileUploadContext] = createContext({
  name: "FileUploadContext",
  hookName: "useFileUploadContext",
  providerName: "<FileUploadProvider/>"
});
const FILE_UPLOAD_CONTAINER_STYLE = {
  display: "flex",
  flexDirection: "column",
  justifyContent: "flex-start",
  alignItems: "flex-start"
};
const FileUploadContainer = forwardRef((props, ref2) => {
  const {
    children,
    options: options2,
    onDropzoneStateChange,
    ...rest
  } = props;
  const dropzoneState = useDropzone(options2);
  const {
    isDragActive,
    isFocused,
    isDragAccept,
    isDragReject,
    isFileDialogActive
  } = dropzoneState;
  const stableDropzoneState = useMemo(() => ({
    isFocused,
    isDragActive,
    isDragAccept,
    isDragReject,
    isFileDialogActive
  }), [isFocused, isDragActive, isDragAccept, isDragReject, isFileDialogActive]);
  useEffect(() => {
    onDropzoneStateChange == null ? void 0 : onDropzoneStateChange(stableDropzoneState);
  }, [stableDropzoneState, onDropzoneStateChange]);
  const themeProps = FILE_UPLOAD_CONTAINER_STYLE;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(FileUploadProvider, { value: {
    dropzoneState
  }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(FileUploadWrapper, { ref: ref2, ...themeProps, ...rest, children }) });
});
const Container = FileUploadContainer;
const Trigger = FileUploadTrigger;
Container.displayName = "FileUploadContainer";
Trigger.displayName = "FileUploadTrigger";
const FileUpload = {
  Container,
  Trigger
};
const useTextAreaResize = ({
  resizeMode = "vertical",
  minWidth,
  minHeight,
  maxWidth
}) => {
  const textareaRef = useRef(null);
  const containerRef = useRef(null);
  const [maxWidthState, setMaxWidthState] = useState(maxWidth ? parseInt(maxWidth, 10) : null);
  const syncContainerSize = useCallback(() => {
    if (textareaRef.current && containerRef.current) {
      const textareaRect = textareaRef.current.getBoundingClientRect();
      const containerRect = containerRef.current.getBoundingClientRect();
      const borderWidth2 = 2;
      const newWidth = Math.max(textareaRect.width + borderWidth2, parseInt(minWidth || "100", 10));
      const newHeight = Math.max(textareaRect.height + borderWidth2, parseInt(minHeight || "50", 10));
      if (Math.abs(containerRect.width - newWidth) > 1 || Math.abs(containerRect.height - newHeight) > 1) {
        containerRef.current.style.width = `${newWidth}px`;
        containerRef.current.style.height = `${newHeight}px`;
      }
    }
  }, [maxWidthState, minWidth, minHeight]);
  const adjustHeight = useCallback(() => {
    if (resizeMode === "auto" && textareaRef.current) {
      const textarea = textareaRef.current;
      textarea.style.height = "auto";
      textarea.style.height = `${textarea.scrollHeight}px`;
      syncContainerSize();
    }
  }, [resizeMode, syncContainerSize]);
  useEffect(() => {
    if (textareaRef.current) {
      const initialWidth = textareaRef.current.getBoundingClientRect().width;
      setMaxWidthState(initialWidth);
      textareaRef.current.style.maxWidth = `${initialWidth}px`;
    }
  }, []);
  useEffect(() => {
    if (!textareaRef.current) return void 0;
    window.addEventListener("resize", syncContainerSize);
    const resizeObserver = new index$3(() => {
      syncContainerSize();
    });
    resizeObserver.observe(textareaRef.current);
    if (containerRef.current) {
      resizeObserver.observe(containerRef.current);
    }
    return () => {
      window.removeEventListener("resize", syncContainerSize);
      resizeObserver.disconnect();
    };
  }, [syncContainerSize]);
  return {
    textareaRef,
    containerRef,
    adjustHeight
  };
};
const textAreaStates = [Pseudostate.hover, Pseudostate.active, Pseudostate["focus-visible"], Pseudostate["focus-within"], Pseudostate.invalid, Pseudostate.disabled];
const labelTransformationStyles$1 = (paddingTop) => css$3`
  transform: translateY(calc(-1 * (${paddingTop} / 2)));
  padding-top: 12px;
  margin-top: 0;
  margin-bottom: 14px;
  font-size: 12px;
  line-height: 12px;
`;
const TextAreaLabelTextStyles = css$3`
  transition: 0.2s all ease;
  position: absolute;
  cursor: text;
  left: 16px;
  top: 0;
  margin-right: 16px;
  line-height: 24px;
  width: calc(100% - 40px);
  height: auto;
  margin: 12px 16px 14px 0;
  pointer-events: none;
  z-index: 1;
  background: ${(props) => props.disabled ? `var(${TOKENS.color.background.interaction.neutralDisabled})` : `var(${TOKENS.color.background.surface0})`};
  padding: 0;

  &.filled {
    ${labelTransformationStyles$1("0px")}
  }

  ${composeWrapper([typography, color], textAreaStates)}
`;
const TextAreaLabelTextSpan = styled.span`
  ${TextAreaLabelTextStyles}
`;
const RESIZE_MODE_OPTIONS = ["none", "vertical", "horizontal", "both", "auto"];
const TextAreaContainer = styled.div`
  position: relative;
  display: inline-block;
  width: 100%;
  outline-style: solid;
  outline-width: 0;
  border: 1px solid var(${TOKENS.color.border.interaction.neutral});
  ${composeWrapper([background, border, position$1, shadow, caretColor, color], textAreaStates)}
  min-width: ${(props) => props.minWidth || "144px"};
  max-width: ${(props) => props.maxWidth || "100%"};
  min-height: ${(props) => props.minHeight};
  max-height: ${(props) => props.maxHeight || "100%"};
  height: ${(props) => props.height || "auto"};
  cursor: text;

  &:focus-within {
    & ${TextAreaLabelTextSpan} {
      ${labelTransformationStyles$1("0px")}
    }
  }

  &.disabled,
  &.disabled * {
    cursor: not-allowed;
  }
`;
const TextAreaElementStyles = css$3`
  resize: ${({
  resizeMode = "vertical"
}) => {
  const resizeModes = {
    horizontal: "horizontal",
    both: "both",
    none: "none",
    auto: "none",
    // we handle this
    vertical: "vertical"
  };
  return resizeModes[resizeMode] ?? "vertical";
}};
  overflow: auto;
  width: 100%;
  position: relative;
  margin: 0 !important;
  padding: 24px 16px 16px 16px !important;
  box-sizing: border-box;
  border: none;
  min-height: 144px;
  height: 144px;
  min-width: 144px;
  cursor: text;
  background: none !important;
  display: block;
  white-space: pre-wrap;
  word-wrap: break-word;
  word-break: normal;

  &::-webkit-input-placeholder {
    transition: opacity 0.2s ease;
    opacity: ${(props) => props.hasValue ? 0 : 1};
  }
  &:-moz-placeholder {
    transition: opacity 0.2s ease;
    opacity: ${(props) => props.hasValue ? 0 : 1};
  }
  &::-moz-placeholder {
    transition: opacity 0.2s ease;
    opacity: ${(props) => props.hasValue ? 0 : 1};
  }
  &:-ms-input-placeholder {
    transition: opacity 0.2s ease;
    opacity: ${(props) => props.hasValue ? 0 : 1};
  }

  &:focus,
  &:focus-visible,
  &.focus-visible,
  &.focus {
    outline: none;
    &::-webkit-input-placeholder {
      opacity: 1;
    }
    &:-moz-placeholder {
      opacity: 1;
    }
    &::-moz-placeholder {
      opacity: 1;
    }
    &:-ms-input-placeholder {
      opacity: 1;
    }

    & + ${TextAreaLabelTextSpan} {
      ${labelTransformationStyles$1("0px")}
    }
  }

  & + ${TextAreaLabelTextSpan} {
    ${(props) => (props.usesPlaceholder || props.hasValue) && labelTransformationStyles$1(props.marginTop || props.mt || props.my || props.margin || props.m || "0px")}
  }

  &:focus + ${TextAreaLabelTextSpan} {
    ${(props) => labelTransformationStyles$1(props.marginTop || props.mt || props.my || props.margin || props.m || "0px")}
  }

  ${composeWrapper([space, typography, color], textAreaStates)}
`;
const StyledTextArea = styled.textarea`
  ${TextAreaElementStyles}
  min-height: ${(props) => props.minHeight};
  max-height: ${(props) => props.maxHeight || "100%"};
`;
const TextAreaInput = forwardRef((props, forwardedRef) => {
  var _a2;
  const {
    variant,
    label,
    assistiveText,
    assistiveTextPlacement = "bottom",
    assistiveTextStyles,
    labelStyles,
    value: controlledValue,
    invalid,
    className = "",
    disabled,
    id: id2,
    placeholder,
    defaultValue,
    formatter,
    allCaps,
    resizeMode = "vertical",
    width: width2,
    height: height2,
    minWidth,
    maxWidth,
    minHeight,
    maxHeight,
    ...rest
  } = props;
  const kindredConfig = useKindredConfigOptional();
  const allCapsValue = allCaps ?? ((_a2 = kindredConfig == null ? void 0 : kindredConfig.misc) == null ? void 0 : _a2.inputAllCaps) ?? false;
  const wrappedFormatter = allCapsValue ? (value2) => {
    const newValue = formatter ? formatter(value2) : value2;
    return newValue.toUpperCase();
  } : formatter;
  const [value, onChange2] = useControlledInput({
    controlledValue,
    onChange: props.onChange,
    defaultValue,
    formatter: wrappedFormatter
  });
  const {
    textareaRef,
    containerRef,
    adjustHeight
  } = useTextAreaResize({
    resizeMode,
    minWidth,
    minHeight,
    maxWidth
  });
  useEffect(() => {
    if (resizeMode === "auto") {
      adjustHeight();
    }
  }, [value, resizeMode, adjustHeight]);
  const combinedRef = useMemo(() => (node2) => {
    if (node2) {
      if (textareaRef.current !== node2) {
        textareaRef.current = node2;
      }
      if (typeof forwardedRef === "function") {
        forwardedRef(node2);
      } else if (forwardedRef) {
        forwardedRef.current = node2;
      }
    }
  }, [forwardedRef, textareaRef]);
  const themedProps = {
    ...INPUT_STYLE_PROPS,
    ...variant === "numeric" ? INPUT_NUMERIC_VARIANT_STYLE_PROPS : {}
  };
  const allProps = {
    ...themedProps,
    ...props
  };
  const spaceProps = selectStyledSystemProps(allProps, ["space"]);
  const containerStyleOverrides = selectStyledSystemProps(props, ["background", "border", "color", "layout", "position", "shadow"]);
  const containerProps = {
    ...themedProps,
    ...containerStyleOverrides,
    ...spaceProps
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Fragment, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(AssistiveTextWrapper, { assistiveText, assistiveTextPlacement, id: id2, invalid, ...themedProps.assistiveTextStyles, ...assistiveTextStyles, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(TextAreaContainer, { ref: containerRef, className: `${className} ${invalid ? "invalid" : ""} ${disabled ? "disabled" : ""}`, ...containerProps, width: width2, height: height2, minWidth, maxWidth: String(maxWidth), minHeight, maxHeight, "data-testid": `${id2}-container`, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(TextAreaLabelTextSpan, { ...spaceProps, ...themedProps.labelStyles, ...labelStyles, disabled, className: value || placeholder ? "filled" : "", "aria-hidden": "true", children: label }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(StyledTextArea, { ...themedProps, "aria-errormessage": `assistiveText-${id2}`, ...rest, id: id2, value, "aria-describedby": `assistiveText-${id2}`, disabled, onChange: onChange2, "aria-label": label, variant, placeholder: placeholder || " ", usesPlaceholder: Boolean(placeholder), "data-isinvalid": !!invalid, "aria-invalid": !!invalid, resizeMode, style: {
      maxWidth: maxWidth ? `${maxWidth}px` : void 0
    }, minHeight, maxHeight, ref: combinedRef })
  ] }) }) });
});
TextAreaInput.displayName = "TextAreaInput";
function calculateAgeFromDateString(dateStr) {
  const parts = dateStr.split("/");
  if (parts.length !== 3) return null;
  const month = parseInt(parts[0] ?? "", 10);
  const day = parseInt(parts[1] ?? "", 10);
  const year = parseInt(parts[2] ?? "", 10);
  if (!Number.isFinite(month) || !Number.isFinite(day) || !Number.isFinite(year)) return null;
  if (month < 1 || month > 12 || day < 1 || day > 31 || year < 1900) return null;
  const birth = new Date(year, month - 1, day);
  if (birth.getMonth() !== month - 1 || birth.getDate() !== day) return null;
  const today = /* @__PURE__ */ new Date();
  const age = today.getFullYear() - year - (today.getMonth() + 1 < month || today.getMonth() + 1 === month && today.getDate() < day ? 1 : 0);
  return age >= 0 ? age : null;
}
const dateCleaveOptions = {
  delimiterLazyShow: true,
  datePattern: ["m", "d", "Y"]
};
const DateInput = forwardRef(({
  cleaveOptions,
  showAge,
  ...props
}, forwardedRef) => {
  const {
    refHandler
  } = useCursorTracker(["/", "/"], forwardedRef);
  const formatter = (value) => {
    return y$1(value, {
      ...dateCleaveOptions,
      ...cleaveOptions
    });
  };
  const ageAssistiveText = showAge && typeof props.value === "string" ? (() => {
    const age = calculateAgeFromDateString(props.value);
    return age !== null ? `Age: ${age}` : void 0;
  })() : void 0;
  const textInput = /* @__PURE__ */ jsxRuntimeExports.jsx(
    TextInput,
    {
      mask: "mm/dd/yyyy",
      ref: refHandler,
      formatter,
      ...props,
      assistiveText: props.assistiveText ?? ageAssistiveText
    }
  );
  return showAge ? /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: textInput }) : textInput;
});
DateInput.displayName = "DateInput";
const dashDelimiter = ["-", "-"];
const parenthesesDelimiter = ["(", ")", "-"];
const PHONE_INPUT_FORMATS = ["dashes", "parentheses"];
const PhoneInput = forwardRef(({
  className,
  format: format2 = "dashes",
  ...rest
}, forwardedRef) => {
  const useParentheses = format2 === "parentheses";
  const mask = useParentheses ? "(555)555-5555" : "555-555-5555";
  const delimiters = useParentheses ? parenthesesDelimiter : dashDelimiter;
  const {
    refHandler
  } = useCursorTracker(delimiters, forwardedRef);
  const formatter = (value) => {
    return s$1(value, {
      delimiterLazyShow: true,
      delimiters,
      numericOnly: true,
      blocks: useParentheses ? [0, 3, 3, 4] : [3, 3, 4]
    });
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(TextInput, { className, formatter, mask, type: "tel", ...rest, ref: refHandler });
});
PhoneInput.displayName = "PhoneInput";
const PasswordInput = forwardRef(({
  defaultPasswordVisible,
  ...rest
}, ref2) => {
  const [isPasswordVisible, setIsPasswordVisible] = useState(defaultPasswordVisible);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(TextInput, { type: isPasswordVisible ? "text" : "password", allCaps: false, iconRight: /* @__PURE__ */ jsxRuntimeExports.jsx(Button, { p: "4px", onClick: (e3) => {
    e3.stopPropagation();
    setIsPasswordVisible(!isPasswordVisible);
  }, "aria-label": isPasswordVisible ? "Hide password text" : "Show password text", focusRingStyle: {
    color: `var(${TOKENS.color.border.focus})`
  }, unstyled: true, children: isPasswordVisible ? /* @__PURE__ */ jsxRuntimeExports.jsx(EyeClosedIcon, {}) : /* @__PURE__ */ jsxRuntimeExports.jsx(EyeIcon, {}) }), ...rest, ref: ref2 });
});
PasswordInput.displayName = "PasswordInput";
const REDACTED_STRING = "•••-••-••••";
const ssnCleaveOptions = {
  delimiterLazyShow: true,
  delimiters: ["-", "-"],
  numericOnly: true,
  blocks: [3, 2, 4]
};
const SSNInput = forwardRef(({
  redacted,
  value,
  onBlur,
  onFocus: onFocus2,
  forceShowFocus = false,
  name,
  id: id2,
  ...props
}, forwardedRef) => {
  const [isActive, setIsActive] = useState(forceShowFocus);
  const [redactedValue, setRedactedValue] = useState(redacted ? REDACTED_STRING : "");
  const [realValue, setRealValue] = useState(value || "");
  const showRedactedValue = !isActive && (redacted || !!value || value === 0 || !!realValue);
  const {
    refHandler
  } = useCursorTracker(dashDelimiter, forwardedRef);
  const formatter = (inputValue) => {
    return s$1(inputValue, ssnCleaveOptions);
  };
  const handleOnFocus = (event) => {
    setIsActive(true);
    if (onFocus2) {
      onFocus2(event);
    }
  };
  const handleOnBlur = (event) => {
    setIsActive(false);
    setRedactedValue(REDACTED_STRING.slice(0, event.target.value.length));
    if (onBlur) {
      onBlur(event);
    }
  };
  const handleOnChange = (event) => {
    setRealValue(event.target.value);
    if (props.onChange) {
      props.onChange(event);
    }
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("input", { type: "hidden", value: realValue, name, id: `${id2}-hidden` }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(TextInput, { type: "tel", iconRight: /* @__PURE__ */ jsxRuntimeExports.jsx(LockIcon, {}), minWidth: "200px", value: showRedactedValue ? redactedValue : realValue, showRedactedValue, onFocus: handleOnFocus, onBlur: handleOnBlur, minLength: 11, maxLength: 11, ref: refHandler, id: id2, ...props, onChange: handleOnChange, ...isActive && {
      formatter,
      mask: "XXX-XX-XXXX"
    } })
  ] });
});
SSNInput.displayName = "SSNInput";
const ITINInput = forwardRef(({
  redacted,
  value,
  onBlur,
  onFocus: onFocus2,
  forceShowFocus = false,
  name,
  id: id2,
  ...props
}, forwardedRef) => {
  const [isFocused, setIsFocused] = useState(false);
  const [realValue, setRealValue] = useState(value || "");
  const isActive = forceShowFocus || isFocused;
  const showRedactedValue = !isActive && (!!redacted || !!realValue);
  const redactedValue = realValue ? REDACTED_STRING.slice(0, String(realValue).length) : REDACTED_STRING;
  const {
    refHandler
  } = useCursorTracker(dashDelimiter, forwardedRef);
  const formatter = (inputValue) => {
    return s$1(inputValue, ssnCleaveOptions);
  };
  const handleOnFocus = (event) => {
    setIsFocused(true);
    if (onFocus2) {
      onFocus2(event);
    }
  };
  const handleOnBlur = (event) => {
    setIsFocused(false);
    if (onBlur) {
      onBlur(event);
    }
  };
  const handleOnChange = (event) => {
    setRealValue(event.target.value);
    if (props.onChange) {
      props.onChange(event);
    }
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("input", { type: "hidden", value: realValue, name, id: `${id2}-hidden` }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(TextInput, { type: "tel", iconRight: /* @__PURE__ */ jsxRuntimeExports.jsx(LockIcon, {}), minWidth: "200px", value: showRedactedValue ? redactedValue : realValue, showRedactedValue, onFocus: handleOnFocus, onBlur: handleOnBlur, minLength: 11, maxLength: 11, ref: refHandler, id: id2, ...props, onChange: handleOnChange, ...isActive && {
      formatter,
      mask: "XXX-XX-XXXX"
    } })
  ] });
});
ITINInput.displayName = "ITINInput";
const currencyCleaveOptions = (allowCents = false, allowNegative = false) => ({
  numeralDecimalScale: allowCents ? 2 : 0,
  numeralThousandsGroupStyle: v$d.THOUSAND,
  numeralPositiveOnly: !allowNegative
});
const CurrencyInput = forwardRef(({
  allowCents,
  allowNegative,
  ...rest
}, ref2) => {
  const cleaveOptions = currencyCleaveOptions(allowCents, allowNegative);
  const formatter = (value) => {
    return M$1(value, cleaveOptions);
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(TextInput, { inputMode: allowCents ? "decimal" : "numeric", iconLeft: /* @__PURE__ */ jsxRuntimeExports.jsx(DollarIcon, {}), formatter, ref: ref2, ...rest });
});
CurrencyInput.displayName = "CurrencyInput";
const bulletInputStates = [Pseudostate.active, Pseudostate.checked, Pseudostate["focus-visible"], Pseudostate.invalid, Pseudostate.disabled];
const bulletStyleFns = [color, background, border, outline, svg, shadow];
const StyledInput$1 = styled.input`
  /* Add if not using autoprefixer */
  display: flex;
  align-items: center;
  -webkit-appearance: none;
  appearance: none;
  opacity: 0;
  margin: 0;
  /* The input is shaped the same as the bullet box */
  width: ${(props) => props.bulletSize || "20px"};
  height: ${(props) => props.bulletSize || "20px"};

  position: absolute;
  outline: none;
  cursor: pointer;
  /* Trap z-index inside so that we don't cause side effects due to z-index conflicts with consumers */
  isolation: isolate;

  &.focus-visible + .bullet {
    ${(props) => compose(...bulletStyleFns)({
  ...props == null ? void 0 : props.focusStyle
})}
  }
  ${composeWrapper([typography], bulletInputStates)}
`;
const StyledRadioLabel = styled.label`
  display: flex;
  cursor: pointer;
  position: relative;
  align-items: center;

  ${(props) => props.disabled && css$3`
      cursor: not-allowed;
      & .bullet {
        cursor: not-allowed;
      }
    `}

  &:hover,
  &.hover {
    & .bullet {
      ${(props) => !props.disabled && compose(...bulletStyleFns)({
  ...props == null ? void 0 : props.hoverStyle
})}
    }
  }

  ${composeWrapper([space, layout, typography], bulletInputStates)}
  margin-bottom: ${(props) => props.marginBottom || props.mb || "0px"};
`;
const v$b = (token2) => `var(${token2})`;
const BULLET_INPUT_BASE_STYLE = {
  borderWidth: "1px",
  checkbox: {
    borderRadius: "3px"
  },
  bulletPadding: "8px",
  bulletSize: "20px",
  fill: v$b(TOKENS.color.foreground.default),
  fontFamily: v$b(TOKENS.text.fontFamily.primary),
  fontWeight: v$b(TOKENS.text.fontWeight.default),
  fontSize: "0.875rem",
  letterSpacing: "0em",
  lineHeight: "1.375rem",
  focusStyle: {
    boxShadow: `0 0 0 2px white, 0 0 0 4px var(${TOKENS.color.border.focus})`
  }
};
const BULLET_INPUT_VARIANT_STYLE = {
  unchecked: {
    background: v$b(TOKENS.color.background.interaction.neutral),
    borderColor: v$b(TOKENS.color.border.interaction.neutral),
    hoverStyle: {
      background: v$b(TOKENS.color.background.interaction.neutralHover),
      borderColor: v$b(TOKENS.color.border.interaction.neutralHover)
    }
  },
  checked: {
    background: v$b(TOKENS.color.background.interaction.neutralSelected),
    borderColor: v$b(TOKENS.color.border.interaction.neutralSelected),
    // The legacy theme computed this with readableColor() against the selected
    // fill's luminance; the token system expresses the same intent directly.
    fill: v$b(TOKENS.color.foreground.interaction.onSelected),
    hoverStyle: {
      background: v$b(TOKENS.color.background.interaction.neutralSelectedHover),
      borderColor: v$b(TOKENS.color.border.interaction.neutralSelected)
    }
  },
  invalid: {
    background: v$b(TOKENS.color.background.interaction.neutral),
    borderColor: v$b(TOKENS.color.border.feedback.danger),
    hoverStyle: {
      background: v$b(TOKENS.color.background.interaction.neutralHover)
    }
  },
  invalidChecked: {
    background: v$b(TOKENS.color.background.interaction.dangerSelected),
    borderColor: v$b(TOKENS.color.border.feedback.danger),
    fill: v$b(TOKENS.color.foreground.interaction.onSelected)
  },
  disabled: {
    background: v$b(TOKENS.color.background.interaction.neutralDisabled),
    borderColor: v$b(TOKENS.color.border.interaction.neutral)
  },
  disabledChecked: {
    background: v$b(TOKENS.color.background.interaction.neutralDisabled),
    borderColor: v$b(TOKENS.color.border.interaction.neutral),
    fill: v$b(TOKENS.color.foreground.interaction.onDisabled)
  }
};
const bulletInputStyleForVariant = (variant) => ({
  ...BULLET_INPUT_BASE_STYLE,
  ...variant ? BULLET_INPUT_VARIANT_STYLE[variant] : {}
});
const determineBulletInputVariant = (invalid, checked, disabled, indeterminate) => {
  if (disabled && (checked || indeterminate)) {
    return "disabledChecked";
  }
  if (disabled) {
    return "disabled";
  }
  if (invalid && (checked || indeterminate)) {
    return "invalidChecked";
  }
  if (invalid && !checked) {
    return "invalid";
  }
  if (checked || indeterminate) {
    return "checked";
  }
  return "unchecked";
};
const BulletInput = forwardRef((props, ref2) => {
  const {
    name,
    children,
    onChange: onChange2,
    checked,
    indeterminate,
    invalid,
    disabled,
    value,
    variant,
    className,
    interactiveParent = false,
    bulletRender,
    id: id2,
    ...rest
  } = props;
  const themedProps = bulletInputStyleForVariant(variant);
  const allProps = merge({}, themedProps, props);
  const bulletStyleProps = {
    ...selectStyledSystemProps(allProps, ["color", "border", "outline"], true),
    bulletSize: props.bulletSize || themedProps.bulletSize,
    bulletPadding: props.bulletPadding || themedProps.bulletPadding
  };
  const labelStyleProps = selectStyledSystemProps(allProps, ["space", "layout", "typography"]);
  const isFocussed = className == null ? void 0 : className.includes("focus-visible");
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledRadioLabel, { ...bulletStyleProps, ...labelStyleProps, ...(checked || indeterminate) && themedProps.checkedStyle, disabled, className, htmlFor: id2, children: [
    !interactiveParent && /* @__PURE__ */ jsxRuntimeExports.jsx(StyledInput$1, { ...themedProps, ...rest, name, ref: ref2, onChange: onChange2, disabled, value, "data-ischecked": checked, "data-isinvalid": invalid, checked, className: isFocussed ? "focus-visible" : "", id: id2 }),
    bulletRender && bulletRender({
      checked,
      invalid,
      disabled,
      ...bulletStyleProps
    }),
    children
  ] });
});
const StyledRadioBullet$1 = styled.span`
  box-sizing: border-box;
  cursor: pointer;
  border-style: solid;
  border-width: 0;
  outline-style: solid;
  outline-width: 0;
  background: none;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  width: ${(props) => props.bulletSize};
  height: ${(props) => props.bulletSize};
  flex-shrink: 0;
  margin-right: ${(props) => props.bulletPadding};
  ${composeWrapper(bulletStyleFns, bulletInputStates)};
  border-radius: 50%;

  input:focus-visible + & {
    ${(props) => compose(...bulletStyleFns)({
  ...props == null ? void 0 : props.focusStyle
})}
  }

  ${(props) => props.checked && css$3`
      &:before {
        content: "";
        border-radius: 50%;
        background: ${props.fill};
        width: 6px;
        height: 6px;
      }
    `}
`;
const RadioInput = forwardRef((props, ref2) => {
  const {
    checked,
    invalid,
    disabled
  } = props;
  const currentVariant = determineBulletInputVariant(invalid, checked, disabled);
  const themedProps = bulletInputStyleForVariant(currentVariant);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(BulletInput, { type: "radio", bulletRender: (renderProps) => /* @__PURE__ */ jsxRuntimeExports.jsx(StyledRadioBullet$1, { ...renderProps, ...themedProps, checked, className: `bullet ${invalid ? "invalid" : ""} ${disabled ? "disabled" : ""}` }), ...props, variant: currentVariant, ref: ref2 });
});
RadioInput.displayName = "RadioInput";
const radioContainedInputStates = [Pseudostate.active, Pseudostate.checked, Pseudostate.hover, Pseudostate["focus-visible"], Pseudostate.invalid, Pseudostate.disabled];
const StyledRadioContainer = styled.label`
  box-sizing: border-box;
  cursor: pointer;
  label {
    font-size: inherit;
  }
  ${composeWrapper([background, border, color, flexbox, shadow, layout, space, outline, typography], radioContainedInputStates)}
`;
const v$a = (token2) => `var(${token2})`;
const RADIO_CONTAINED_BASE_STYLE = {
  background: v$a(TOKENS.color.background.surface0),
  border: `2px solid transparent`,
  borderRadius: v$a(TOKENS.dimension.radius.interaction.inputLarge),
  boxShadow: `0 0 0 1px var(${TOKENS.color.border.interaction.neutral})`,
  display: "flex",
  flexDirection: "column",
  padding: "12px 16px",
  width: "100%",
  hoverStyle: {
    background: v$a(TOKENS.color.background.interaction.neutralHover),
    boxShadow: `0 0 0 1px var(${TOKENS.color.border.interaction.neutralHover})`
  },
  focusStyle: {
    boxShadow: `0 0 0 1px var(${TOKENS.color.border.interaction.neutral})`,
    outline: `2px solid var(${TOKENS.color.border.interaction.neutralSelected})`,
    outlineOffset: "2px"
  }
};
const RADIO_CONTAINED_VARIANT_STYLE = {
  unchecked: {
    border: "2px solid transparent"
  },
  checked: {
    border: `2px solid var(${TOKENS.color.border.interaction.neutralSelected})`,
    boxShadow: "none",
    hoverStyle: {
      background: v$a(TOKENS.color.background.interaction.neutralHover),
      boxShadow: "none"
    }
  },
  invalid: {
    borderColor: v$a(TOKENS.color.border.feedback.danger)
  },
  invalidChecked: {
    borderColor: v$a(TOKENS.color.border.feedback.danger)
  },
  disabled: {
    background: v$a(TOKENS.color.background.interaction.neutralDisabled),
    hoverStyle: {
      background: v$a(TOKENS.color.background.interaction.neutralDisabled),
      boxShadow: `0 0 0 1px var(${TOKENS.color.border.interaction.neutral})`
    }
  },
  disabledChecked: {
    background: v$a(TOKENS.color.background.interaction.neutralDisabled),
    hoverStyle: {
      background: v$a(TOKENS.color.background.interaction.neutralDisabled),
      boxShadow: `0 0 0 1px var(${TOKENS.color.border.interaction.neutral})`
    }
  }
};
const RADIO_CONTAINED_LABEL_STYLE = {
  fontFamily: v$a(TOKENS.text.fontFamily.primary),
  fontWeight: v$a(TOKENS.text.fontWeight.header),
  fontSize: "1rem",
  lineHeight: "140%",
  letterSpacing: "0em"
};
const StyledHelperText = styled.span`
  /* todo - find a better way to add padding here instead of hardcoding the value */
  padding-left: 36px;
  color: var(${TOKENS.color.foreground.subdued});
  ${composeWrapper([typography])};
`;
const StyledRadioBullet = styled.span`
  box-sizing: border-box;
  cursor: pointer;
  border-style: solid;
  border-width: 0;
  outline-style: solid;
  outline-width: 0;
  background: none;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  /* When text to the right of the bullet was more than 2 lines, bullet became an oval, below 2 lines fixes that. */
  max-width: ${(props) => props.bulletSize};
  width: 100%;
  height: ${(props) => props.bulletSize};
  margin-right: 16px;
  ${composeWrapper(bulletStyleFns, bulletInputStates)};
  border-radius: 50%;
  ${(props) => props.checked && css$3`
      &:before {
        content: "";
        border-radius: 50%;
        background: ${props.fill};
        width: 6px;
        height: 6px;
      }
    `}
`;
const RadioContainedAddon = styled.div`
  ${({
  $expanded
}) => css$3`
    margin: ${$expanded ? "15px 0 5px" : "0"};
    transition: all 0.3s ease-in-out;
    overflow: ${$expanded ? "auto" : "hidden"};
    visibility: ${$expanded ? "visible" : "hidden"};
    max-height: ${$expanded ? "700px" : "0"};
  `}
`;
const RadioContainedInput = forwardRef((props, ref2) => {
  const {
    checked,
    invalid,
    disabled,
    helperText,
    id: id2,
    addOn,
    forceShowAddon
  } = props;
  const currentVariant = determineBulletInputVariant(invalid, checked, disabled);
  const [, setIsBoxChecked] = useState(checked);
  const themedRadioInputProps = bulletInputStyleForVariant(currentVariant);
  const themedRadioContainerProps = {
    ...RADIO_CONTAINED_BASE_STYLE,
    ...RADIO_CONTAINED_VARIANT_STYLE[currentVariant]
  };
  const themedRadioContainerLabelProps = RADIO_CONTAINED_LABEL_STYLE;
  const isExpanded = Boolean(forceShowAddon || checked);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledRadioContainer, { onClick: () => {
    setIsBoxChecked(true);
  }, tabIndex: 0, htmlFor: id2, ...themedRadioContainerProps, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(BulletInput, { type: "radio", bulletRender: (renderProps) => /* @__PURE__ */ jsxRuntimeExports.jsx(StyledRadioBullet, { ...renderProps, ...themedRadioInputProps, checked, className: `bullet ${invalid ? "invalid" : ""} ${disabled ? "disabled" : ""}` }), ...props, ...themedRadioContainerLabelProps, variant: currentVariant, ref: ref2 }),
    helperText && /* @__PURE__ */ jsxRuntimeExports.jsx(StyledHelperText, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(Text, { variant: "bodySmall.desktop", element: "span", children: helperText }) }),
    addOn && /* @__PURE__ */ jsxRuntimeExports.jsx(RadioContainedAddon, { id: `addon-${id2}`, $expanded: isExpanded, children: addOn })
  ] });
});
RadioContainedInput.displayName = "RadioContainedInput";
const CheckboxCheckmarkIcon = (props) => /* @__PURE__ */ jsxRuntimeExports.jsx("svg", { width: "11", height: "12", viewBox: "0 0 13 15", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-label": "checkmark icon", "aria-hidden": true, ...props, children: /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11.9465 0.960773C12.6366 1.32158 12.9035 2.1735 12.5427 2.86359L6.63753 14.158C6.42439 14.5656 6.02579 14.8437 5.56962 14.9029C5.11344 14.9622 4.65704 14.7952 4.34684 14.4555L0.368838 10.0995C-0.156287 9.52449 -0.115836 8.63264 0.459187 8.10752C1.03421 7.5824 1.92606 7.62285 2.45118 8.19787L5.07141 11.0671L10.0437 1.55699C10.4045 0.866899 11.2564 0.599964 11.9465 0.960773Z" }) });
const CheckboxMinusIcon = (props) => /* @__PURE__ */ jsxRuntimeExports.jsx("svg", { width: "14", height: "3", viewBox: "0 0 14 3", xmlns: "http://www.w3.org/2000/svg", role: "img", "aria-label": "minus icon", "aria-hidden": true, ...props, children: /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M0 1.41C0 0.631278 0.631278 0 1.41 0L12.59 0C13.3687 0 14 0.631278 14 1.41C14 2.18872 13.3687 2.82 12.59 2.82H1.41C0.631278 2.82 0 2.18872 0 1.41Z" }) });
const DefaultCheckboxInput = forwardRef((props, ref2) => {
  const {
    internalChecked,
    indeterminate,
    invalid,
    disabled,
    className,
    checked: externalChecked,
    tabIndex = 0,
    onChangeHandler,
    ...remainingProps
  } = props;
  const checked = externalChecked ?? internalChecked;
  const currentVariant = determineBulletInputVariant(invalid, checked, disabled, indeterminate);
  const themedProps = bulletInputStyleForVariant(currentVariant);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(BulletInput, { ...remainingProps, indeterminate, invalid, disabled, checked, type: "checkbox", variant: currentVariant, ref: ref2, onChange: onChangeHandler, className: `${(className == null ? void 0 : className.includes("focus-visible")) ? "focus-visible" : ""}`, tabIndex: disabled ? -1 : tabIndex, bulletRender: ({
    bulletPadding,
    ...rest
  }) => /* @__PURE__ */ jsxRuntimeExports.jsxs(
    StyledCheckboxBullet,
    {
      ...rest,
      ...themedProps,
      bulletPadding,
      checked,
      invalid,
      className: `bullet ${invalid && !checked ? "invalid " : ""}${disabled ? "disabled " : ""}`,
      "aria-hidden": true,
      children: [
        checked && !indeterminate && /* @__PURE__ */ jsxRuntimeExports.jsx(CheckboxCheckmarkIcon, { "data-testid": "checkmark-icon", "aria-hidden": true }),
        indeterminate && /* @__PURE__ */ jsxRuntimeExports.jsx(CheckboxMinusIcon, { "data-testid": "minus-icon", "aria-hidden": true })
      ]
    }
  ) }) });
});
const DASHED_BORDER_MASK$1 = `url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' stroke='%23000' stroke-width='2' stroke-dasharray='6%2c 10' stroke-dashoffset='0' stroke-linecap='square'/%3e%3c/svg%3e")`;
const dashedBorder$1 = (color2) => css$3`
  &::before {
    content: "";
    position: absolute;
    inset: 0;
    pointer-events: none;
    background-color: ${color2};
    -webkit-mask-image: ${DASHED_BORDER_MASK$1};
    mask-image: ${DASHED_BORDER_MASK$1};
  }
`;
const HighlightCheckboxContainer = styled.div`
  ${({
  isCheckedOrIndeterminate
}) => css$3`
      border-radius: 1px;
      width: fit-content;
      position: relative;
      background: ${isCheckedOrIndeterminate ? "" : `var(${TOKENS.color.background.interaction.neutralEmphasized})`};
      ${isCheckedOrIndeterminate ? "" : dashedBorder$1(`var(${TOKENS.color.border.interaction.neutralEmphasized})`)}
      cursor: pointer;
      &:focus-within {
        outline-offset: 2px;
        outline: 2px solid var(${TOKENS.color.border.focus});
      }
      &.focus,
      &.focus-visible {
        outline-offset: 2px;
        outline: 2px solid var(${TOKENS.color.border.focus});
      }
      ${!isCheckedOrIndeterminate ? css$3`
            &:hover,
            &.hover {
              background: var(
                ${TOKENS.color.background.interaction.neutralEmphasizedHover}
              );
            }
            &.invalid {
              cursor: not-allowed;
              background: var(${TOKENS.color.background.feedback.danger});
              &::before {
                background-color: var(${TOKENS.color.border.feedback.danger});
              }
            }
            &.disabled {
              cursor: not-allowed;
              color: var(${TOKENS.color.foreground.interaction.disabled});
              background: var(
                ${TOKENS.color.background.interaction.neutralDisabled}
              );
              &::before {
                background-color: var(
                  ${TOKENS.color.border.interaction.neutral}
                );
              }
            }
          ` : ""}
    `}
`;
const StyledCheckboxBulletContainer = styled(BulletInput)`
  padding: 10px 10px 9px;
`;
const HighlightedCheckboxInput = forwardRef((props, ref2) => {
  const {
    indeterminate,
    invalid,
    disabled,
    className,
    onChangeHandler,
    checked: externalChecked,
    internalChecked,
    handleKeyDown,
    tabIndex = 0,
    onChange: _unusedOnChange,
    ...restProps
  } = props;
  const checked = externalChecked ?? internalChecked;
  const currentVariant = determineBulletInputVariant(invalid, checked, disabled, indeterminate);
  const themedProps = bulletInputStyleForVariant(currentVariant);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(HighlightCheckboxContainer, { isCheckedOrIndeterminate: checked || indeterminate, "data-testid": "highlighted_checkbox_container", className: `${disabled ? "disabled" : ""} ${invalid ? "invalid" : ""} ${className ?? ""}`, children: /* @__PURE__ */ jsxRuntimeExports.jsx(StyledCheckboxBulletContainer, { ...restProps, checked, type: "checkbox", variant: currentVariant, ref: ref2, onChange: onChangeHandler, tabIndex: disabled ? -1 : tabIndex, className: `${(className == null ? void 0 : className.includes("focus-visible")) ? "focus-visible" : ""}`, bulletRender: ({
    ...rest
  }) => /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledCheckboxBullet, { ...rest, ...themedProps, className: `${(className == null ? void 0 : className.includes("hover")) && "bullet hover"}`, checked, invalid, "aria-hidden": true, children: [
    checked && !indeterminate && /* @__PURE__ */ jsxRuntimeExports.jsx(CheckboxCheckmarkIcon, { "data-testid": "checkmark-icon", "aria-hidden": true }),
    indeterminate && /* @__PURE__ */ jsxRuntimeExports.jsx(CheckboxMinusIcon, { "data-testid": "minus-icon", "aria-hidden": true })
  ] }) }) }) });
});
const StyledCheckboxBullet = styled.span`
  box-sizing: border-box;
  cursor: pointer;
  border-style: solid;
  border-width: 0;
  outline-style: solid;
  outline-width: 0;
  background: none;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  transition: 100ms all ease-in-out;
  min-width: ${(props) => props.bulletSize};
  width: ${(props) => props.bulletSize};
  height: ${(props) => props.bulletSize};
  margin-right: ${(props) => props.bulletPadding};
  font-style: normal;
  ${composeWrapper(bulletStyleFns, bulletInputStates)};
  border-radius: ${(props) => {
  var _a2;
  return ((_a2 = props.checkbox) == null ? void 0 : _a2.borderRadius) || "4px";
}};
  align-self: flex-start;

  /* Add hover state styles */
  &:hover,
  &.hover,
  input:hover + & {
    ${(props) => props.hoverStyle && css$3`
        ${compose(...bulletStyleFns)(props.hoverStyle)}
      `}
  }

  input:focus-visible + & {
    ${(props) => compose(...bulletStyleFns)({
  ...props == null ? void 0 : props.focusStyle
})}
  }
`;
const CheckboxInput = forwardRef((props, ref2) => {
  const {
    disabled,
    highlighted
  } = props;
  const [internalChecked, setInternalChecked] = useState(props.checked ?? props.defaultChecked ?? false);
  const onChangeHandler = (e3) => {
    if (props.onChange) {
      props.onChange(e3);
    }
    setInternalChecked(!internalChecked);
  };
  const handleKeyDown = (e3) => {
    var _a2;
    if (e3.code === "Space" && !disabled) {
      e3.preventDefault();
      setInternalChecked(!internalChecked);
      (_a2 = props.onChange) == null ? void 0 : _a2.call(props, {
        target: {
          checked: !internalChecked
        }
      });
    }
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: highlighted ? /* @__PURE__ */ jsxRuntimeExports.jsx(HighlightedCheckboxInput, { ...props, handleKeyDown, onChangeHandler, internalChecked, ref: ref2 }) : /* @__PURE__ */ jsxRuntimeExports.jsx(DefaultCheckboxInput, { ...props, onChangeHandler, internalChecked, ref: ref2 }) });
});
CheckboxInput.displayName = "CheckboxInput";
var reactKeyedFlattenChildren = {};
var reactIs$3 = { exports: {} };
var reactIs_production_min$3 = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactIs_production_min$3;
function requireReactIs_production_min$3() {
  if (hasRequiredReactIs_production_min$3) return reactIs_production_min$3;
  hasRequiredReactIs_production_min$3 = 1;
  var b2 = "function" === typeof Symbol && Symbol.for, c2 = b2 ? Symbol.for("react.element") : 60103, d2 = b2 ? Symbol.for("react.portal") : 60106, e3 = b2 ? Symbol.for("react.fragment") : 60107, f2 = b2 ? Symbol.for("react.strict_mode") : 60108, g3 = b2 ? Symbol.for("react.profiler") : 60114, h2 = b2 ? Symbol.for("react.provider") : 60109, k2 = b2 ? Symbol.for("react.context") : 60110, l2 = b2 ? Symbol.for("react.async_mode") : 60111, m2 = b2 ? Symbol.for("react.concurrent_mode") : 60111, n2 = b2 ? Symbol.for("react.forward_ref") : 60112, p2 = b2 ? Symbol.for("react.suspense") : 60113, q2 = b2 ? Symbol.for("react.suspense_list") : 60120, r2 = b2 ? Symbol.for("react.memo") : 60115, t2 = b2 ? Symbol.for("react.lazy") : 60116, v2 = b2 ? Symbol.for("react.block") : 60121, w3 = b2 ? Symbol.for("react.fundamental") : 60117, x2 = b2 ? Symbol.for("react.responder") : 60118, y2 = b2 ? Symbol.for("react.scope") : 60119;
  function z3(a2) {
    if ("object" === typeof a2 && null !== a2) {
      var u2 = a2.$$typeof;
      switch (u2) {
        case c2:
          switch (a2 = a2.type, a2) {
            case l2:
            case m2:
            case e3:
            case g3:
            case f2:
            case p2:
              return a2;
            default:
              switch (a2 = a2 && a2.$$typeof, a2) {
                case k2:
                case n2:
                case t2:
                case r2:
                case h2:
                  return a2;
                default:
                  return u2;
              }
          }
        case d2:
          return u2;
      }
    }
  }
  function A3(a2) {
    return z3(a2) === m2;
  }
  reactIs_production_min$3.AsyncMode = l2;
  reactIs_production_min$3.ConcurrentMode = m2;
  reactIs_production_min$3.ContextConsumer = k2;
  reactIs_production_min$3.ContextProvider = h2;
  reactIs_production_min$3.Element = c2;
  reactIs_production_min$3.ForwardRef = n2;
  reactIs_production_min$3.Fragment = e3;
  reactIs_production_min$3.Lazy = t2;
  reactIs_production_min$3.Memo = r2;
  reactIs_production_min$3.Portal = d2;
  reactIs_production_min$3.Profiler = g3;
  reactIs_production_min$3.StrictMode = f2;
  reactIs_production_min$3.Suspense = p2;
  reactIs_production_min$3.isAsyncMode = function(a2) {
    return A3(a2) || z3(a2) === l2;
  };
  reactIs_production_min$3.isConcurrentMode = A3;
  reactIs_production_min$3.isContextConsumer = function(a2) {
    return z3(a2) === k2;
  };
  reactIs_production_min$3.isContextProvider = function(a2) {
    return z3(a2) === h2;
  };
  reactIs_production_min$3.isElement = function(a2) {
    return "object" === typeof a2 && null !== a2 && a2.$$typeof === c2;
  };
  reactIs_production_min$3.isForwardRef = function(a2) {
    return z3(a2) === n2;
  };
  reactIs_production_min$3.isFragment = function(a2) {
    return z3(a2) === e3;
  };
  reactIs_production_min$3.isLazy = function(a2) {
    return z3(a2) === t2;
  };
  reactIs_production_min$3.isMemo = function(a2) {
    return z3(a2) === r2;
  };
  reactIs_production_min$3.isPortal = function(a2) {
    return z3(a2) === d2;
  };
  reactIs_production_min$3.isProfiler = function(a2) {
    return z3(a2) === g3;
  };
  reactIs_production_min$3.isStrictMode = function(a2) {
    return z3(a2) === f2;
  };
  reactIs_production_min$3.isSuspense = function(a2) {
    return z3(a2) === p2;
  };
  reactIs_production_min$3.isValidElementType = function(a2) {
    return "string" === typeof a2 || "function" === typeof a2 || a2 === e3 || a2 === m2 || a2 === g3 || a2 === f2 || a2 === p2 || a2 === q2 || "object" === typeof a2 && null !== a2 && (a2.$$typeof === t2 || a2.$$typeof === r2 || a2.$$typeof === h2 || a2.$$typeof === k2 || a2.$$typeof === n2 || a2.$$typeof === w3 || a2.$$typeof === x2 || a2.$$typeof === y2 || a2.$$typeof === v2);
  };
  reactIs_production_min$3.typeOf = z3;
  return reactIs_production_min$3;
}
var reactIs_development$3 = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactIs_development$3;
function requireReactIs_development$3() {
  if (hasRequiredReactIs_development$3) return reactIs_development$3;
  hasRequiredReactIs_development$3 = 1;
  if (process.env.NODE_ENV !== "production") {
    (function() {
      var hasSymbol = typeof Symbol === "function" && Symbol.for;
      var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for("react.element") : 60103;
      var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for("react.portal") : 60106;
      var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for("react.fragment") : 60107;
      var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for("react.strict_mode") : 60108;
      var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for("react.profiler") : 60114;
      var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for("react.provider") : 60109;
      var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for("react.context") : 60110;
      var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for("react.async_mode") : 60111;
      var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for("react.concurrent_mode") : 60111;
      var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for("react.forward_ref") : 60112;
      var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for("react.suspense") : 60113;
      var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for("react.suspense_list") : 60120;
      var REACT_MEMO_TYPE = hasSymbol ? Symbol.for("react.memo") : 60115;
      var REACT_LAZY_TYPE = hasSymbol ? Symbol.for("react.lazy") : 60116;
      var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for("react.block") : 60121;
      var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for("react.fundamental") : 60117;
      var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for("react.responder") : 60118;
      var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for("react.scope") : 60119;
      function isValidElementType(type2) {
        return typeof type2 === "string" || typeof type2 === "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
        type2 === REACT_FRAGMENT_TYPE || type2 === REACT_CONCURRENT_MODE_TYPE || type2 === REACT_PROFILER_TYPE || type2 === REACT_STRICT_MODE_TYPE || type2 === REACT_SUSPENSE_TYPE || type2 === REACT_SUSPENSE_LIST_TYPE || typeof type2 === "object" && type2 !== null && (type2.$$typeof === REACT_LAZY_TYPE || type2.$$typeof === REACT_MEMO_TYPE || type2.$$typeof === REACT_PROVIDER_TYPE || type2.$$typeof === REACT_CONTEXT_TYPE || type2.$$typeof === REACT_FORWARD_REF_TYPE || type2.$$typeof === REACT_FUNDAMENTAL_TYPE || type2.$$typeof === REACT_RESPONDER_TYPE || type2.$$typeof === REACT_SCOPE_TYPE || type2.$$typeof === REACT_BLOCK_TYPE);
      }
      function typeOf2(object2) {
        if (typeof object2 === "object" && object2 !== null) {
          var $$typeof = object2.$$typeof;
          switch ($$typeof) {
            case REACT_ELEMENT_TYPE:
              var type2 = object2.type;
              switch (type2) {
                case REACT_ASYNC_MODE_TYPE:
                case REACT_CONCURRENT_MODE_TYPE:
                case REACT_FRAGMENT_TYPE:
                case REACT_PROFILER_TYPE:
                case REACT_STRICT_MODE_TYPE:
                case REACT_SUSPENSE_TYPE:
                  return type2;
                default:
                  var $$typeofType = type2 && type2.$$typeof;
                  switch ($$typeofType) {
                    case REACT_CONTEXT_TYPE:
                    case REACT_FORWARD_REF_TYPE:
                    case REACT_LAZY_TYPE:
                    case REACT_MEMO_TYPE:
                    case REACT_PROVIDER_TYPE:
                      return $$typeofType;
                    default:
                      return $$typeof;
                  }
              }
            case REACT_PORTAL_TYPE:
              return $$typeof;
          }
        }
        return void 0;
      }
      var AsyncMode = REACT_ASYNC_MODE_TYPE;
      var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
      var ContextConsumer = REACT_CONTEXT_TYPE;
      var ContextProvider = REACT_PROVIDER_TYPE;
      var Element2 = REACT_ELEMENT_TYPE;
      var ForwardRef = REACT_FORWARD_REF_TYPE;
      var Fragment2 = REACT_FRAGMENT_TYPE;
      var Lazy = REACT_LAZY_TYPE;
      var Memo = REACT_MEMO_TYPE;
      var Portal2 = REACT_PORTAL_TYPE;
      var Profiler = REACT_PROFILER_TYPE;
      var StrictMode = REACT_STRICT_MODE_TYPE;
      var Suspense = REACT_SUSPENSE_TYPE;
      var hasWarnedAboutDeprecatedIsAsyncMode = false;
      function isAsyncMode(object2) {
        {
          if (!hasWarnedAboutDeprecatedIsAsyncMode) {
            hasWarnedAboutDeprecatedIsAsyncMode = true;
            console["warn"]("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.");
          }
        }
        return isConcurrentMode(object2) || typeOf2(object2) === REACT_ASYNC_MODE_TYPE;
      }
      function isConcurrentMode(object2) {
        return typeOf2(object2) === REACT_CONCURRENT_MODE_TYPE;
      }
      function isContextConsumer(object2) {
        return typeOf2(object2) === REACT_CONTEXT_TYPE;
      }
      function isContextProvider(object2) {
        return typeOf2(object2) === REACT_PROVIDER_TYPE;
      }
      function isElement2(object2) {
        return typeof object2 === "object" && object2 !== null && object2.$$typeof === REACT_ELEMENT_TYPE;
      }
      function isForwardRef(object2) {
        return typeOf2(object2) === REACT_FORWARD_REF_TYPE;
      }
      function isFragment(object2) {
        return typeOf2(object2) === REACT_FRAGMENT_TYPE;
      }
      function isLazy(object2) {
        return typeOf2(object2) === REACT_LAZY_TYPE;
      }
      function isMemo(object2) {
        return typeOf2(object2) === REACT_MEMO_TYPE;
      }
      function isPortal(object2) {
        return typeOf2(object2) === REACT_PORTAL_TYPE;
      }
      function isProfiler(object2) {
        return typeOf2(object2) === REACT_PROFILER_TYPE;
      }
      function isStrictMode(object2) {
        return typeOf2(object2) === REACT_STRICT_MODE_TYPE;
      }
      function isSuspense(object2) {
        return typeOf2(object2) === REACT_SUSPENSE_TYPE;
      }
      reactIs_development$3.AsyncMode = AsyncMode;
      reactIs_development$3.ConcurrentMode = ConcurrentMode;
      reactIs_development$3.ContextConsumer = ContextConsumer;
      reactIs_development$3.ContextProvider = ContextProvider;
      reactIs_development$3.Element = Element2;
      reactIs_development$3.ForwardRef = ForwardRef;
      reactIs_development$3.Fragment = Fragment2;
      reactIs_development$3.Lazy = Lazy;
      reactIs_development$3.Memo = Memo;
      reactIs_development$3.Portal = Portal2;
      reactIs_development$3.Profiler = Profiler;
      reactIs_development$3.StrictMode = StrictMode;
      reactIs_development$3.Suspense = Suspense;
      reactIs_development$3.isAsyncMode = isAsyncMode;
      reactIs_development$3.isConcurrentMode = isConcurrentMode;
      reactIs_development$3.isContextConsumer = isContextConsumer;
      reactIs_development$3.isContextProvider = isContextProvider;
      reactIs_development$3.isElement = isElement2;
      reactIs_development$3.isForwardRef = isForwardRef;
      reactIs_development$3.isFragment = isFragment;
      reactIs_development$3.isLazy = isLazy;
      reactIs_development$3.isMemo = isMemo;
      reactIs_development$3.isPortal = isPortal;
      reactIs_development$3.isProfiler = isProfiler;
      reactIs_development$3.isStrictMode = isStrictMode;
      reactIs_development$3.isSuspense = isSuspense;
      reactIs_development$3.isValidElementType = isValidElementType;
      reactIs_development$3.typeOf = typeOf2;
    })();
  }
  return reactIs_development$3;
}
if (process.env.NODE_ENV === "production") {
  reactIs$3.exports = requireReactIs_production_min$3();
} else {
  reactIs$3.exports = requireReactIs_development$3();
}
var reactIsExports$1 = reactIs$3.exports;
Object.defineProperty(reactKeyedFlattenChildren, "__esModule", { value: true });
var react_1 = React__default;
var react_is_1 = reactIsExports$1;
function flattenChildren(children, depth, keys3) {
  if (depth === void 0) {
    depth = 0;
  }
  if (keys3 === void 0) {
    keys3 = [];
  }
  return react_1.Children.toArray(children).reduce(function(acc, node2, nodeIndex) {
    if (react_is_1.isFragment(node2)) {
      acc.push.apply(acc, flattenChildren(node2.props.children, depth + 1, keys3.concat(node2.key || nodeIndex)));
    } else {
      if (react_1.isValidElement(node2)) {
        acc.push(react_1.cloneElement(node2, {
          key: keys3.concat(String(node2.key)).join(".")
        }));
      } else if (typeof node2 === "string" || typeof node2 === "number") {
        acc.push(node2);
      }
    }
    return acc;
  }, []);
}
var _default = reactKeyedFlattenChildren.default = flattenChildren;
var OutsideClickHandler$1 = {};
var mocks;
var hasRequiredMocks;
function requireMocks() {
  if (hasRequiredMocks) return mocks;
  hasRequiredMocks = 1;
  function noop3() {
    return null;
  }
  noop3.isRequired = noop3;
  function noopThunk() {
    return noop3;
  }
  mocks = {
    and: noopThunk,
    between: noopThunk,
    booleanSome: noopThunk,
    childrenHavePropXorChildren: noopThunk,
    childrenOf: noopThunk,
    childrenOfType: noopThunk,
    childrenSequenceOf: noopThunk,
    componentWithName: noopThunk,
    disallowedIf: noopThunk,
    elementType: noopThunk,
    empty: noopThunk,
    explicitNull: noopThunk,
    forbidExtraProps: Object,
    integer: noopThunk,
    keysOf: noopThunk,
    mutuallyExclusiveProps: noopThunk,
    mutuallyExclusiveTrueProps: noopThunk,
    nChildren: noopThunk,
    nonNegativeInteger: noop3,
    nonNegativeNumber: noopThunk,
    numericString: noopThunk,
    object: noopThunk,
    or: noopThunk,
    predicate: noopThunk,
    range: noopThunk,
    ref: noopThunk,
    requiredBy: noopThunk,
    restrictedProp: noopThunk,
    sequenceOf: noopThunk,
    shape: noopThunk,
    stringEndsWith: noopThunk,
    stringStartsWith: noopThunk,
    uniqueArray: noopThunk,
    uniqueArrayOf: noopThunk,
    valuesOf: noopThunk,
    withShape: noopThunk
  };
  return mocks;
}
var toStr$2 = Object.prototype.toString;
var isArguments$3 = function isArguments(value) {
  var str = toStr$2.call(value);
  var isArgs2 = str === "[object Arguments]";
  if (!isArgs2) {
    isArgs2 = str !== "[object Array]" && value !== null && typeof value === "object" && typeof value.length === "number" && value.length >= 0 && toStr$2.call(value.callee) === "[object Function]";
  }
  return isArgs2;
};
var implementation$e;
var hasRequiredImplementation$6;
function requireImplementation$6() {
  if (hasRequiredImplementation$6) return implementation$e;
  hasRequiredImplementation$6 = 1;
  var keysShim2;
  if (!Object.keys) {
    var has = Object.prototype.hasOwnProperty;
    var toStr2 = Object.prototype.toString;
    var isArgs2 = isArguments$3;
    var isEnumerable = Object.prototype.propertyIsEnumerable;
    var hasDontEnumBug = !isEnumerable.call({ toString: null }, "toString");
    var hasProtoEnumBug = isEnumerable.call(function() {
    }, "prototype");
    var dontEnums = [
      "toString",
      "toLocaleString",
      "valueOf",
      "hasOwnProperty",
      "isPrototypeOf",
      "propertyIsEnumerable",
      "constructor"
    ];
    var equalsConstructorPrototype = function(o) {
      var ctor = o.constructor;
      return ctor && ctor.prototype === o;
    };
    var excludedKeys = {
      $applicationCache: true,
      $console: true,
      $external: true,
      $frame: true,
      $frameElement: true,
      $frames: true,
      $innerHeight: true,
      $innerWidth: true,
      $onmozfullscreenchange: true,
      $onmozfullscreenerror: true,
      $outerHeight: true,
      $outerWidth: true,
      $pageXOffset: true,
      $pageYOffset: true,
      $parent: true,
      $scrollLeft: true,
      $scrollTop: true,
      $scrollX: true,
      $scrollY: true,
      $self: true,
      $webkitIndexedDB: true,
      $webkitStorageInfo: true,
      $window: true
    };
    var hasAutomationEqualityBug = function() {
      if (typeof window === "undefined") {
        return false;
      }
      for (var k2 in window) {
        try {
          if (!excludedKeys["$" + k2] && has.call(window, k2) && window[k2] !== null && typeof window[k2] === "object") {
            try {
              equalsConstructorPrototype(window[k2]);
            } catch (e3) {
              return true;
            }
          }
        } catch (e3) {
          return true;
        }
      }
      return false;
    }();
    var equalsConstructorPrototypeIfNotBuggy = function(o) {
      if (typeof window === "undefined" || !hasAutomationEqualityBug) {
        return equalsConstructorPrototype(o);
      }
      try {
        return equalsConstructorPrototype(o);
      } catch (e3) {
        return false;
      }
    };
    keysShim2 = function keys3(object2) {
      var isObject2 = object2 !== null && typeof object2 === "object";
      var isFunction2 = toStr2.call(object2) === "[object Function]";
      var isArguments3 = isArgs2(object2);
      var isString = isObject2 && toStr2.call(object2) === "[object String]";
      var theKeys = [];
      if (!isObject2 && !isFunction2 && !isArguments3) {
        throw new TypeError("Object.keys called on a non-object");
      }
      var skipProto = hasProtoEnumBug && isFunction2;
      if (isString && object2.length > 0 && !has.call(object2, 0)) {
        for (var i = 0; i < object2.length; ++i) {
          theKeys.push(String(i));
        }
      }
      if (isArguments3 && object2.length > 0) {
        for (var j = 0; j < object2.length; ++j) {
          theKeys.push(String(j));
        }
      } else {
        for (var name in object2) {
          if (!(skipProto && name === "prototype") && has.call(object2, name)) {
            theKeys.push(String(name));
          }
        }
      }
      if (hasDontEnumBug) {
        var skipConstructor = equalsConstructorPrototypeIfNotBuggy(object2);
        for (var k2 = 0; k2 < dontEnums.length; ++k2) {
          if (!(skipConstructor && dontEnums[k2] === "constructor") && has.call(object2, dontEnums[k2])) {
            theKeys.push(dontEnums[k2]);
          }
        }
      }
      return theKeys;
    };
  }
  implementation$e = keysShim2;
  return implementation$e;
}
var slice$1 = Array.prototype.slice;
var isArgs = isArguments$3;
var origKeys = Object.keys;
var keysShim = origKeys ? function keys(o) {
  return origKeys(o);
} : requireImplementation$6();
var originalKeys = Object.keys;
keysShim.shim = function shimObjectKeys() {
  if (Object.keys) {
    var keysWorksWithArguments = function() {
      var args = Object.keys(arguments);
      return args && args.length === arguments.length;
    }(1, 2);
    if (!keysWorksWithArguments) {
      Object.keys = function keys3(object2) {
        if (isArgs(object2)) {
          return originalKeys(slice$1.call(object2));
        }
        return originalKeys(object2);
      };
    }
  } else {
    Object.keys = keysShim;
  }
  return Object.keys || keysShim;
};
var objectKeys = keysShim;
var $defineProperty$3 = Object.defineProperty || false;
if ($defineProperty$3) {
  try {
    $defineProperty$3({}, "a", { value: 1 });
  } catch (e3) {
    $defineProperty$3 = false;
  }
}
var esDefineProperty = $defineProperty$3;
var syntax = SyntaxError;
var type = TypeError;
var gOPD$1 = Object.getOwnPropertyDescriptor;
var $gOPD$1 = gOPD$1;
if ($gOPD$1) {
  try {
    $gOPD$1([], "length");
  } catch (e3) {
    $gOPD$1 = null;
  }
}
var gopd$1 = $gOPD$1;
var $defineProperty$2 = esDefineProperty;
var $SyntaxError$1 = syntax;
var $TypeError$4 = type;
var gopd = gopd$1;
var defineDataProperty$1 = function defineDataProperty(obj, property2, value) {
  if (!obj || typeof obj !== "object" && typeof obj !== "function") {
    throw new $TypeError$4("`obj` must be an object or a function`");
  }
  if (typeof property2 !== "string" && typeof property2 !== "symbol") {
    throw new $TypeError$4("`property` must be a string or a symbol`");
  }
  if (arguments.length > 3 && typeof arguments[3] !== "boolean" && arguments[3] !== null) {
    throw new $TypeError$4("`nonEnumerable`, if provided, must be a boolean or null");
  }
  if (arguments.length > 4 && typeof arguments[4] !== "boolean" && arguments[4] !== null) {
    throw new $TypeError$4("`nonWritable`, if provided, must be a boolean or null");
  }
  if (arguments.length > 5 && typeof arguments[5] !== "boolean" && arguments[5] !== null) {
    throw new $TypeError$4("`nonConfigurable`, if provided, must be a boolean or null");
  }
  if (arguments.length > 6 && typeof arguments[6] !== "boolean") {
    throw new $TypeError$4("`loose`, if provided, must be a boolean");
  }
  var nonEnumerable = arguments.length > 3 ? arguments[3] : null;
  var nonWritable = arguments.length > 4 ? arguments[4] : null;
  var nonConfigurable = arguments.length > 5 ? arguments[5] : null;
  var loose = arguments.length > 6 ? arguments[6] : false;
  var desc = !!gopd && gopd(obj, property2);
  if ($defineProperty$2) {
    $defineProperty$2(obj, property2, {
      configurable: nonConfigurable === null && desc ? desc.configurable : !nonConfigurable,
      enumerable: nonEnumerable === null && desc ? desc.enumerable : !nonEnumerable,
      value,
      writable: nonWritable === null && desc ? desc.writable : !nonWritable
    });
  } else if (loose || !nonEnumerable && !nonWritable && !nonConfigurable) {
    obj[property2] = value;
  } else {
    throw new $SyntaxError$1("This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.");
  }
};
var $defineProperty$1 = esDefineProperty;
var hasPropertyDescriptors = function hasPropertyDescriptors2() {
  return !!$defineProperty$1;
};
hasPropertyDescriptors.hasArrayLengthDefineBug = function hasArrayLengthDefineBug() {
  if (!$defineProperty$1) {
    return null;
  }
  try {
    return $defineProperty$1([], "length", { value: 1 }).length !== 1;
  } catch (e3) {
    return true;
  }
};
var hasPropertyDescriptors_1 = hasPropertyDescriptors;
var keys$3 = objectKeys;
var hasSymbols$2 = typeof Symbol === "function" && typeof Symbol("foo") === "symbol";
var toStr$1 = Object.prototype.toString;
var concat = Array.prototype.concat;
var defineDataProperty2 = defineDataProperty$1;
var isFunction$5 = function(fn2) {
  return typeof fn2 === "function" && toStr$1.call(fn2) === "[object Function]";
};
var supportsDescriptors = hasPropertyDescriptors_1();
var defineProperty = function(object2, name, value, predicate2) {
  if (name in object2) {
    if (predicate2 === true) {
      if (object2[name] === value) {
        return;
      }
    } else if (!isFunction$5(predicate2) || !predicate2()) {
      return;
    }
  }
  if (supportsDescriptors) {
    defineDataProperty2(object2, name, value, true);
  } else {
    defineDataProperty2(object2, name, value);
  }
};
var defineProperties = function(object2, map) {
  var predicates = arguments.length > 2 ? arguments[2] : {};
  var props = keys$3(map);
  if (hasSymbols$2) {
    props = concat.call(props, Object.getOwnPropertySymbols(map));
  }
  for (var i = 0; i < props.length; i += 1) {
    defineProperty(object2, props[i], map[props[i]], predicates[props[i]]);
  }
};
defineProperties.supportsDescriptors = !!supportsDescriptors;
var defineProperties_1 = defineProperties;
var callBind$1 = { exports: {} };
var esObjectAtoms = Object;
var esErrors = Error;
var _eval = EvalError;
var range$1 = RangeError;
var ref$1 = ReferenceError;
var uri = URIError;
var abs$2 = Math.abs;
var floor$4 = Math.floor;
var max$8 = Math.max;
var min$7 = Math.min;
var pow$1 = Math.pow;
var round$4 = Math.round;
var _isNaN$1 = Number.isNaN || function isNaN2(a2) {
  return a2 !== a2;
};
var $isNaN = _isNaN$1;
var sign$1 = function sign(number) {
  if ($isNaN(number) || number === 0) {
    return number;
  }
  return number < 0 ? -1 : 1;
};
var shams$1;
var hasRequiredShams$1;
function requireShams$1() {
  if (hasRequiredShams$1) return shams$1;
  hasRequiredShams$1 = 1;
  shams$1 = function hasSymbols2() {
    if (typeof Symbol !== "function" || typeof Object.getOwnPropertySymbols !== "function") {
      return false;
    }
    if (typeof Symbol.iterator === "symbol") {
      return true;
    }
    var obj = {};
    var sym = Symbol("test");
    var symObj = Object(sym);
    if (typeof sym === "string") {
      return false;
    }
    if (Object.prototype.toString.call(sym) !== "[object Symbol]") {
      return false;
    }
    if (Object.prototype.toString.call(symObj) !== "[object Symbol]") {
      return false;
    }
    var symVal = 42;
    obj[sym] = symVal;
    for (var _2 in obj) {
      return false;
    }
    if (typeof Object.keys === "function" && Object.keys(obj).length !== 0) {
      return false;
    }
    if (typeof Object.getOwnPropertyNames === "function" && Object.getOwnPropertyNames(obj).length !== 0) {
      return false;
    }
    var syms = Object.getOwnPropertySymbols(obj);
    if (syms.length !== 1 || syms[0] !== sym) {
      return false;
    }
    if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) {
      return false;
    }
    if (typeof Object.getOwnPropertyDescriptor === "function") {
      var descriptor = (
        /** @type {PropertyDescriptor} */
        Object.getOwnPropertyDescriptor(obj, sym)
      );
      if (descriptor.value !== symVal || descriptor.enumerable !== true) {
        return false;
      }
    }
    return true;
  };
  return shams$1;
}
var hasSymbols$1;
var hasRequiredHasSymbols;
function requireHasSymbols() {
  if (hasRequiredHasSymbols) return hasSymbols$1;
  hasRequiredHasSymbols = 1;
  var origSymbol = typeof Symbol !== "undefined" && Symbol;
  var hasSymbolSham = requireShams$1();
  hasSymbols$1 = function hasNativeSymbols() {
    if (typeof origSymbol !== "function") {
      return false;
    }
    if (typeof Symbol !== "function") {
      return false;
    }
    if (typeof origSymbol("foo") !== "symbol") {
      return false;
    }
    if (typeof Symbol("bar") !== "symbol") {
      return false;
    }
    return hasSymbolSham();
  };
  return hasSymbols$1;
}
var Reflect_getPrototypeOf;
var hasRequiredReflect_getPrototypeOf;
function requireReflect_getPrototypeOf() {
  if (hasRequiredReflect_getPrototypeOf) return Reflect_getPrototypeOf;
  hasRequiredReflect_getPrototypeOf = 1;
  Reflect_getPrototypeOf = typeof Reflect !== "undefined" && Reflect.getPrototypeOf || null;
  return Reflect_getPrototypeOf;
}
var Object_getPrototypeOf;
var hasRequiredObject_getPrototypeOf;
function requireObject_getPrototypeOf() {
  if (hasRequiredObject_getPrototypeOf) return Object_getPrototypeOf;
  hasRequiredObject_getPrototypeOf = 1;
  var $Object2 = esObjectAtoms;
  Object_getPrototypeOf = $Object2.getPrototypeOf || null;
  return Object_getPrototypeOf;
}
var ERROR_MESSAGE = "Function.prototype.bind called on incompatible ";
var toStr = Object.prototype.toString;
var max$7 = Math.max;
var funcType = "[object Function]";
var concatty = function concatty2(a2, b2) {
  var arr = [];
  for (var i = 0; i < a2.length; i += 1) {
    arr[i] = a2[i];
  }
  for (var j = 0; j < b2.length; j += 1) {
    arr[j + a2.length] = b2[j];
  }
  return arr;
};
var slicy = function slicy2(arrLike, offset2) {
  var arr = [];
  for (var i = offset2, j = 0; i < arrLike.length; i += 1, j += 1) {
    arr[j] = arrLike[i];
  }
  return arr;
};
var joiny = function(arr, joiner) {
  var str = "";
  for (var i = 0; i < arr.length; i += 1) {
    str += arr[i];
    if (i + 1 < arr.length) {
      str += joiner;
    }
  }
  return str;
};
var implementation$d = function bind(that) {
  var target = this;
  if (typeof target !== "function" || toStr.apply(target) !== funcType) {
    throw new TypeError(ERROR_MESSAGE + target);
  }
  var args = slicy(arguments, 1);
  var bound;
  var binder = function() {
    if (this instanceof bound) {
      var result = target.apply(
        this,
        concatty(args, arguments)
      );
      if (Object(result) === result) {
        return result;
      }
      return this;
    }
    return target.apply(
      that,
      concatty(args, arguments)
    );
  };
  var boundLength = max$7(0, target.length - args.length);
  var boundArgs = [];
  for (var i = 0; i < boundLength; i++) {
    boundArgs[i] = "$" + i;
  }
  bound = Function("binder", "return function (" + joiny(boundArgs, ",") + "){ return binder.apply(this,arguments); }")(binder);
  if (target.prototype) {
    var Empty = function Empty2() {
    };
    Empty.prototype = target.prototype;
    bound.prototype = new Empty();
    Empty.prototype = null;
  }
  return bound;
};
var implementation$c = implementation$d;
var functionBind = Function.prototype.bind || implementation$c;
var functionCall = Function.prototype.call;
var functionApply = Function.prototype.apply;
var reflectApply = typeof Reflect !== "undefined" && Reflect && Reflect.apply;
var bind$3 = functionBind;
var $apply$2 = functionApply;
var $call$2 = functionCall;
var $reflectApply = reflectApply;
var actualApply$1 = $reflectApply || bind$3.call($call$2, $apply$2);
var bind$2 = functionBind;
var $TypeError$3 = type;
var $call$1 = functionCall;
var $actualApply = actualApply$1;
var callBindApplyHelpers = function callBindBasic(args) {
  if (args.length < 1 || typeof args[0] !== "function") {
    throw new $TypeError$3("a function is required");
  }
  return $actualApply(bind$2, $call$1, args);
};
var get$2;
var hasRequiredGet;
function requireGet() {
  if (hasRequiredGet) return get$2;
  hasRequiredGet = 1;
  var callBind2 = callBindApplyHelpers;
  var gOPD2 = gopd$1;
  var hasProtoAccessor;
  try {
    hasProtoAccessor = /** @type {{ __proto__?: typeof Array.prototype }} */
    [].__proto__ === Array.prototype;
  } catch (e3) {
    if (!e3 || typeof e3 !== "object" || !("code" in e3) || e3.code !== "ERR_PROTO_ACCESS") {
      throw e3;
    }
  }
  var desc = !!hasProtoAccessor && gOPD2 && gOPD2(
    Object.prototype,
    /** @type {keyof typeof Object.prototype} */
    "__proto__"
  );
  var $Object2 = Object;
  var $getPrototypeOf = $Object2.getPrototypeOf;
  get$2 = desc && typeof desc.get === "function" ? callBind2([desc.get]) : typeof $getPrototypeOf === "function" ? (
    /** @type {import('./get')} */
    function getDunder(value) {
      return $getPrototypeOf(value == null ? value : $Object2(value));
    }
  ) : false;
  return get$2;
}
var getProto$1;
var hasRequiredGetProto;
function requireGetProto() {
  if (hasRequiredGetProto) return getProto$1;
  hasRequiredGetProto = 1;
  var reflectGetProto = requireReflect_getPrototypeOf();
  var originalGetProto = requireObject_getPrototypeOf();
  var getDunderProto = requireGet();
  getProto$1 = reflectGetProto ? function getProto2(O2) {
    return reflectGetProto(O2);
  } : originalGetProto ? function getProto2(O2) {
    if (!O2 || typeof O2 !== "object" && typeof O2 !== "function") {
      throw new TypeError("getProto: not an object");
    }
    return originalGetProto(O2);
  } : getDunderProto ? function getProto2(O2) {
    return getDunderProto(O2);
  } : null;
  return getProto$1;
}
var hasown;
var hasRequiredHasown;
function requireHasown() {
  if (hasRequiredHasown) return hasown;
  hasRequiredHasown = 1;
  var call = Function.prototype.call;
  var $hasOwn = Object.prototype.hasOwnProperty;
  var bind3 = functionBind;
  hasown = bind3.call(call, $hasOwn);
  return hasown;
}
var undefined$1;
var $Object = esObjectAtoms;
var $Error = esErrors;
var $EvalError = _eval;
var $RangeError = range$1;
var $ReferenceError = ref$1;
var $SyntaxError = syntax;
var $TypeError$2 = type;
var $URIError = uri;
var abs$1 = abs$2;
var floor$3 = floor$4;
var max$6 = max$8;
var min$6 = min$7;
var pow = pow$1;
var round$3 = round$4;
var sign2 = sign$1;
var $Function = Function;
var getEvalledConstructor = function(expressionSyntax) {
  try {
    return $Function('"use strict"; return (' + expressionSyntax + ").constructor;")();
  } catch (e3) {
  }
};
var $gOPD = gopd$1;
var $defineProperty = esDefineProperty;
var throwTypeError = function() {
  throw new $TypeError$2();
};
var ThrowTypeError = $gOPD ? function() {
  try {
    arguments.callee;
    return throwTypeError;
  } catch (calleeThrows) {
    try {
      return $gOPD(arguments, "callee").get;
    } catch (gOPDthrows) {
      return throwTypeError;
    }
  }
}() : throwTypeError;
var hasSymbols = requireHasSymbols()();
var getProto = requireGetProto();
var $ObjectGPO = requireObject_getPrototypeOf();
var $ReflectGPO = requireReflect_getPrototypeOf();
var $apply$1 = functionApply;
var $call = functionCall;
var needsEval = {};
var TypedArray = typeof Uint8Array === "undefined" || !getProto ? undefined$1 : getProto(Uint8Array);
var INTRINSICS = {
  __proto__: null,
  "%AggregateError%": typeof AggregateError === "undefined" ? undefined$1 : AggregateError,
  "%Array%": Array,
  "%ArrayBuffer%": typeof ArrayBuffer === "undefined" ? undefined$1 : ArrayBuffer,
  "%ArrayIteratorPrototype%": hasSymbols && getProto ? getProto([][Symbol.iterator]()) : undefined$1,
  "%AsyncFromSyncIteratorPrototype%": undefined$1,
  "%AsyncFunction%": needsEval,
  "%AsyncGenerator%": needsEval,
  "%AsyncGeneratorFunction%": needsEval,
  "%AsyncIteratorPrototype%": needsEval,
  "%Atomics%": typeof Atomics === "undefined" ? undefined$1 : Atomics,
  "%BigInt%": typeof BigInt === "undefined" ? undefined$1 : BigInt,
  "%BigInt64Array%": typeof BigInt64Array === "undefined" ? undefined$1 : BigInt64Array,
  "%BigUint64Array%": typeof BigUint64Array === "undefined" ? undefined$1 : BigUint64Array,
  "%Boolean%": Boolean,
  "%DataView%": typeof DataView === "undefined" ? undefined$1 : DataView,
  "%Date%": Date,
  "%decodeURI%": decodeURI,
  "%decodeURIComponent%": decodeURIComponent,
  "%encodeURI%": encodeURI,
  "%encodeURIComponent%": encodeURIComponent,
  "%Error%": $Error,
  "%eval%": eval,
  // eslint-disable-line no-eval
  "%EvalError%": $EvalError,
  "%Float32Array%": typeof Float32Array === "undefined" ? undefined$1 : Float32Array,
  "%Float64Array%": typeof Float64Array === "undefined" ? undefined$1 : Float64Array,
  "%FinalizationRegistry%": typeof FinalizationRegistry === "undefined" ? undefined$1 : FinalizationRegistry,
  "%Function%": $Function,
  "%GeneratorFunction%": needsEval,
  "%Int8Array%": typeof Int8Array === "undefined" ? undefined$1 : Int8Array,
  "%Int16Array%": typeof Int16Array === "undefined" ? undefined$1 : Int16Array,
  "%Int32Array%": typeof Int32Array === "undefined" ? undefined$1 : Int32Array,
  "%isFinite%": isFinite,
  "%isNaN%": isNaN,
  "%IteratorPrototype%": hasSymbols && getProto ? getProto(getProto([][Symbol.iterator]())) : undefined$1,
  "%JSON%": typeof JSON === "object" ? JSON : undefined$1,
  "%Map%": typeof Map === "undefined" ? undefined$1 : Map,
  "%MapIteratorPrototype%": typeof Map === "undefined" || !hasSymbols || !getProto ? undefined$1 : getProto((/* @__PURE__ */ new Map())[Symbol.iterator]()),
  "%Math%": Math,
  "%Number%": Number,
  "%Object%": $Object,
  "%Object.getOwnPropertyDescriptor%": $gOPD,
  "%parseFloat%": parseFloat,
  "%parseInt%": parseInt,
  "%Promise%": typeof Promise === "undefined" ? undefined$1 : Promise,
  "%Proxy%": typeof Proxy === "undefined" ? undefined$1 : Proxy,
  "%RangeError%": $RangeError,
  "%ReferenceError%": $ReferenceError,
  "%Reflect%": typeof Reflect === "undefined" ? undefined$1 : Reflect,
  "%RegExp%": RegExp,
  "%Set%": typeof Set === "undefined" ? undefined$1 : Set,
  "%SetIteratorPrototype%": typeof Set === "undefined" || !hasSymbols || !getProto ? undefined$1 : getProto((/* @__PURE__ */ new Set())[Symbol.iterator]()),
  "%SharedArrayBuffer%": typeof SharedArrayBuffer === "undefined" ? undefined$1 : SharedArrayBuffer,
  "%String%": String,
  "%StringIteratorPrototype%": hasSymbols && getProto ? getProto(""[Symbol.iterator]()) : undefined$1,
  "%Symbol%": hasSymbols ? Symbol : undefined$1,
  "%SyntaxError%": $SyntaxError,
  "%ThrowTypeError%": ThrowTypeError,
  "%TypedArray%": TypedArray,
  "%TypeError%": $TypeError$2,
  "%Uint8Array%": typeof Uint8Array === "undefined" ? undefined$1 : Uint8Array,
  "%Uint8ClampedArray%": typeof Uint8ClampedArray === "undefined" ? undefined$1 : Uint8ClampedArray,
  "%Uint16Array%": typeof Uint16Array === "undefined" ? undefined$1 : Uint16Array,
  "%Uint32Array%": typeof Uint32Array === "undefined" ? undefined$1 : Uint32Array,
  "%URIError%": $URIError,
  "%WeakMap%": typeof WeakMap === "undefined" ? undefined$1 : WeakMap,
  "%WeakRef%": typeof WeakRef === "undefined" ? undefined$1 : WeakRef,
  "%WeakSet%": typeof WeakSet === "undefined" ? undefined$1 : WeakSet,
  "%Function.prototype.call%": $call,
  "%Function.prototype.apply%": $apply$1,
  "%Object.defineProperty%": $defineProperty,
  "%Object.getPrototypeOf%": $ObjectGPO,
  "%Math.abs%": abs$1,
  "%Math.floor%": floor$3,
  "%Math.max%": max$6,
  "%Math.min%": min$6,
  "%Math.pow%": pow,
  "%Math.round%": round$3,
  "%Math.sign%": sign2,
  "%Reflect.getPrototypeOf%": $ReflectGPO
};
if (getProto) {
  try {
    null.error;
  } catch (e3) {
    var errorProto = getProto(getProto(e3));
    INTRINSICS["%Error.prototype%"] = errorProto;
  }
}
var doEval = function doEval2(name) {
  var value;
  if (name === "%AsyncFunction%") {
    value = getEvalledConstructor("async function () {}");
  } else if (name === "%GeneratorFunction%") {
    value = getEvalledConstructor("function* () {}");
  } else if (name === "%AsyncGeneratorFunction%") {
    value = getEvalledConstructor("async function* () {}");
  } else if (name === "%AsyncGenerator%") {
    var fn2 = doEval2("%AsyncGeneratorFunction%");
    if (fn2) {
      value = fn2.prototype;
    }
  } else if (name === "%AsyncIteratorPrototype%") {
    var gen = doEval2("%AsyncGenerator%");
    if (gen && getProto) {
      value = getProto(gen.prototype);
    }
  }
  INTRINSICS[name] = value;
  return value;
};
var LEGACY_ALIASES = {
  __proto__: null,
  "%ArrayBufferPrototype%": ["ArrayBuffer", "prototype"],
  "%ArrayPrototype%": ["Array", "prototype"],
  "%ArrayProto_entries%": ["Array", "prototype", "entries"],
  "%ArrayProto_forEach%": ["Array", "prototype", "forEach"],
  "%ArrayProto_keys%": ["Array", "prototype", "keys"],
  "%ArrayProto_values%": ["Array", "prototype", "values"],
  "%AsyncFunctionPrototype%": ["AsyncFunction", "prototype"],
  "%AsyncGenerator%": ["AsyncGeneratorFunction", "prototype"],
  "%AsyncGeneratorPrototype%": ["AsyncGeneratorFunction", "prototype", "prototype"],
  "%BooleanPrototype%": ["Boolean", "prototype"],
  "%DataViewPrototype%": ["DataView", "prototype"],
  "%DatePrototype%": ["Date", "prototype"],
  "%ErrorPrototype%": ["Error", "prototype"],
  "%EvalErrorPrototype%": ["EvalError", "prototype"],
  "%Float32ArrayPrototype%": ["Float32Array", "prototype"],
  "%Float64ArrayPrototype%": ["Float64Array", "prototype"],
  "%FunctionPrototype%": ["Function", "prototype"],
  "%Generator%": ["GeneratorFunction", "prototype"],
  "%GeneratorPrototype%": ["GeneratorFunction", "prototype", "prototype"],
  "%Int8ArrayPrototype%": ["Int8Array", "prototype"],
  "%Int16ArrayPrototype%": ["Int16Array", "prototype"],
  "%Int32ArrayPrototype%": ["Int32Array", "prototype"],
  "%JSONParse%": ["JSON", "parse"],
  "%JSONStringify%": ["JSON", "stringify"],
  "%MapPrototype%": ["Map", "prototype"],
  "%NumberPrototype%": ["Number", "prototype"],
  "%ObjectPrototype%": ["Object", "prototype"],
  "%ObjProto_toString%": ["Object", "prototype", "toString"],
  "%ObjProto_valueOf%": ["Object", "prototype", "valueOf"],
  "%PromisePrototype%": ["Promise", "prototype"],
  "%PromiseProto_then%": ["Promise", "prototype", "then"],
  "%Promise_all%": ["Promise", "all"],
  "%Promise_reject%": ["Promise", "reject"],
  "%Promise_resolve%": ["Promise", "resolve"],
  "%RangeErrorPrototype%": ["RangeError", "prototype"],
  "%ReferenceErrorPrototype%": ["ReferenceError", "prototype"],
  "%RegExpPrototype%": ["RegExp", "prototype"],
  "%SetPrototype%": ["Set", "prototype"],
  "%SharedArrayBufferPrototype%": ["SharedArrayBuffer", "prototype"],
  "%StringPrototype%": ["String", "prototype"],
  "%SymbolPrototype%": ["Symbol", "prototype"],
  "%SyntaxErrorPrototype%": ["SyntaxError", "prototype"],
  "%TypedArrayPrototype%": ["TypedArray", "prototype"],
  "%TypeErrorPrototype%": ["TypeError", "prototype"],
  "%Uint8ArrayPrototype%": ["Uint8Array", "prototype"],
  "%Uint8ClampedArrayPrototype%": ["Uint8ClampedArray", "prototype"],
  "%Uint16ArrayPrototype%": ["Uint16Array", "prototype"],
  "%Uint32ArrayPrototype%": ["Uint32Array", "prototype"],
  "%URIErrorPrototype%": ["URIError", "prototype"],
  "%WeakMapPrototype%": ["WeakMap", "prototype"],
  "%WeakSetPrototype%": ["WeakSet", "prototype"]
};
var bind$1 = functionBind;
var hasOwn$1 = requireHasown();
var $concat = bind$1.call($call, Array.prototype.concat);
var $spliceApply = bind$1.call($apply$1, Array.prototype.splice);
var $replace = bind$1.call($call, String.prototype.replace);
var $strSlice = bind$1.call($call, String.prototype.slice);
var $exec = bind$1.call($call, RegExp.prototype.exec);
var rePropName$1 = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var reEscapeChar$1 = /\\(\\)?/g;
var stringToPath$2 = function stringToPath(string) {
  var first = $strSlice(string, 0, 1);
  var last = $strSlice(string, -1);
  if (first === "%" && last !== "%") {
    throw new $SyntaxError("invalid intrinsic syntax, expected closing `%`");
  } else if (last === "%" && first !== "%") {
    throw new $SyntaxError("invalid intrinsic syntax, expected opening `%`");
  }
  var result = [];
  $replace(string, rePropName$1, function(match2, number, quote, subString) {
    result[result.length] = quote ? $replace(subString, reEscapeChar$1, "$1") : number || match2;
  });
  return result;
};
var getBaseIntrinsic = function getBaseIntrinsic2(name, allowMissing) {
  var intrinsicName = name;
  var alias;
  if (hasOwn$1(LEGACY_ALIASES, intrinsicName)) {
    alias = LEGACY_ALIASES[intrinsicName];
    intrinsicName = "%" + alias[0] + "%";
  }
  if (hasOwn$1(INTRINSICS, intrinsicName)) {
    var value = INTRINSICS[intrinsicName];
    if (value === needsEval) {
      value = doEval(intrinsicName);
    }
    if (typeof value === "undefined" && !allowMissing) {
      throw new $TypeError$2("intrinsic " + name + " exists, but is not available. Please file an issue!");
    }
    return {
      alias,
      name: intrinsicName,
      value
    };
  }
  throw new $SyntaxError("intrinsic " + name + " does not exist!");
};
var getIntrinsic = function GetIntrinsic(name, allowMissing) {
  if (typeof name !== "string" || name.length === 0) {
    throw new $TypeError$2("intrinsic name must be a non-empty string");
  }
  if (arguments.length > 1 && typeof allowMissing !== "boolean") {
    throw new $TypeError$2('"allowMissing" argument must be a boolean');
  }
  if ($exec(/^%?[^%]*%?$/, name) === null) {
    throw new $SyntaxError("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
  }
  var parts = stringToPath$2(name);
  var intrinsicBaseName = parts.length > 0 ? parts[0] : "";
  var intrinsic = getBaseIntrinsic("%" + intrinsicBaseName + "%", allowMissing);
  var intrinsicRealName = intrinsic.name;
  var value = intrinsic.value;
  var skipFurtherCaching = false;
  var alias = intrinsic.alias;
  if (alias) {
    intrinsicBaseName = alias[0];
    $spliceApply(parts, $concat([0, 1], alias));
  }
  for (var i = 1, isOwn = true; i < parts.length; i += 1) {
    var part = parts[i];
    var first = $strSlice(part, 0, 1);
    var last = $strSlice(part, -1);
    if ((first === '"' || first === "'" || first === "`" || (last === '"' || last === "'" || last === "`")) && first !== last) {
      throw new $SyntaxError("property names with quotes must have matching quotes");
    }
    if (part === "constructor" || !isOwn) {
      skipFurtherCaching = true;
    }
    intrinsicBaseName += "." + part;
    intrinsicRealName = "%" + intrinsicBaseName + "%";
    if (hasOwn$1(INTRINSICS, intrinsicRealName)) {
      value = INTRINSICS[intrinsicRealName];
    } else if (value != null) {
      if (!(part in value)) {
        if (!allowMissing) {
          throw new $TypeError$2("base intrinsic for " + name + " exists, but the property is not available.");
        }
        return void 0;
      }
      if ($gOPD && i + 1 >= parts.length) {
        var desc = $gOPD(value, part);
        isOwn = !!desc;
        if (isOwn && "get" in desc && !("originalValue" in desc.get)) {
          value = desc.get;
        } else {
          value = value[part];
        }
      } else {
        isOwn = hasOwn$1(value, part);
        value = value[part];
      }
      if (isOwn && !skipFurtherCaching) {
        INTRINSICS[intrinsicRealName] = value;
      }
    }
  }
  return value;
};
var GetIntrinsic$1 = getIntrinsic;
var define$3 = defineDataProperty$1;
var hasDescriptors = hasPropertyDescriptors_1();
var gOPD = gopd$1;
var $TypeError$1 = type;
var $floor = GetIntrinsic$1("%Math.floor%");
var setFunctionLength = function setFunctionLength2(fn2, length2) {
  if (typeof fn2 !== "function") {
    throw new $TypeError$1("`fn` is not a function");
  }
  if (typeof length2 !== "number" || length2 < 0 || length2 > 4294967295 || $floor(length2) !== length2) {
    throw new $TypeError$1("`length` must be a positive 32-bit integer");
  }
  var loose = arguments.length > 2 && !!arguments[2];
  var functionLengthIsConfigurable = true;
  var functionLengthIsWritable = true;
  if ("length" in fn2 && gOPD) {
    var desc = gOPD(fn2, "length");
    if (desc && !desc.configurable) {
      functionLengthIsConfigurable = false;
    }
    if (desc && !desc.writable) {
      functionLengthIsWritable = false;
    }
  }
  if (functionLengthIsConfigurable || functionLengthIsWritable || !loose) {
    if (hasDescriptors) {
      define$3(
        /** @type {Parameters<define>[0]} */
        fn2,
        "length",
        length2,
        true,
        true
      );
    } else {
      define$3(
        /** @type {Parameters<define>[0]} */
        fn2,
        "length",
        length2
      );
    }
  }
  return fn2;
};
var bind2 = functionBind;
var $apply = functionApply;
var actualApply = actualApply$1;
var applyBind = function applyBind2() {
  return actualApply(bind2, $apply, arguments);
};
(function(module) {
  var setFunctionLength$1 = setFunctionLength;
  var $defineProperty2 = esDefineProperty;
  var callBindBasic3 = callBindApplyHelpers;
  var applyBind$1 = applyBind;
  module.exports = function callBind2(originalFunction) {
    var func = callBindBasic3(arguments);
    var adjustedLength = originalFunction.length - (arguments.length - 1);
    return setFunctionLength$1(
      func,
      1 + (adjustedLength > 0 ? adjustedLength : 0),
      true
    );
  };
  if ($defineProperty2) {
    $defineProperty2(module.exports, "apply", { value: applyBind$1 });
  } else {
    module.exports.apply = applyBind$1;
  }
})(callBind$1);
var callBindExports = callBind$1.exports;
var GetIntrinsic2 = getIntrinsic;
var callBindBasic2 = callBindApplyHelpers;
var $indexOf = callBindBasic2([GetIntrinsic2("%String.prototype.indexOf%")]);
var callBound$2 = function callBoundIntrinsic(name, allowMissing) {
  var intrinsic = (
    /** @type {Parameters<typeof callBindBasic>[0][0]} */
    GetIntrinsic2(name, !!allowMissing)
  );
  if (typeof intrinsic === "function" && $indexOf(name, ".prototype.") > -1) {
    return callBindBasic2([intrinsic]);
  }
  return intrinsic;
};
var implementation$b;
var hasRequiredImplementation$5;
function requireImplementation$5() {
  if (hasRequiredImplementation$5) return implementation$b;
  hasRequiredImplementation$5 = 1;
  var objectKeys$1 = objectKeys;
  var hasSymbols2 = requireShams$1()();
  var callBound2 = callBound$2;
  var $Object2 = esObjectAtoms;
  var $push = callBound2("Array.prototype.push");
  var $propIsEnumerable = callBound2("Object.prototype.propertyIsEnumerable");
  var originalGetSymbols = hasSymbols2 ? $Object2.getOwnPropertySymbols : null;
  implementation$b = function assign2(target, source1) {
    if (target == null) {
      throw new TypeError("target must be an object");
    }
    var to = $Object2(target);
    if (arguments.length === 1) {
      return to;
    }
    for (var s2 = 1; s2 < arguments.length; ++s2) {
      var from2 = $Object2(arguments[s2]);
      var keys3 = objectKeys$1(from2);
      var getSymbols2 = hasSymbols2 && ($Object2.getOwnPropertySymbols || originalGetSymbols);
      if (getSymbols2) {
        var syms = getSymbols2(from2);
        for (var j = 0; j < syms.length; ++j) {
          var key = syms[j];
          if ($propIsEnumerable(from2, key)) {
            $push(keys3, key);
          }
        }
      }
      for (var i = 0; i < keys3.length; ++i) {
        var nextKey = keys3[i];
        if ($propIsEnumerable(from2, nextKey)) {
          var propValue = from2[nextKey];
          to[nextKey] = propValue;
        }
      }
    }
    return to;
  };
  return implementation$b;
}
var polyfill$9;
var hasRequiredPolyfill$5;
function requirePolyfill$5() {
  if (hasRequiredPolyfill$5) return polyfill$9;
  hasRequiredPolyfill$5 = 1;
  var implementation2 = requireImplementation$5();
  var lacksProperEnumerationOrder = function() {
    if (!Object.assign) {
      return false;
    }
    var str = "abcdefghijklmnopqrst";
    var letters = str.split("");
    var map = {};
    for (var i = 0; i < letters.length; ++i) {
      map[letters[i]] = letters[i];
    }
    var obj = Object.assign({}, map);
    var actual = "";
    for (var k2 in obj) {
      actual += k2;
    }
    return str !== actual;
  };
  var assignHasPendingExceptions = function() {
    if (!Object.assign || !Object.preventExtensions) {
      return false;
    }
    var thrower = Object.preventExtensions({ 1: 2 });
    try {
      Object.assign(thrower, "xy");
    } catch (e3) {
      return thrower[1] === "y";
    }
    return false;
  };
  polyfill$9 = function getPolyfill4() {
    if (!Object.assign) {
      return implementation2;
    }
    if (lacksProperEnumerationOrder()) {
      return implementation2;
    }
    if (assignHasPendingExceptions()) {
      return implementation2;
    }
    return Object.assign;
  };
  return polyfill$9;
}
var shim$9;
var hasRequiredShim$6;
function requireShim$6() {
  if (hasRequiredShim$6) return shim$9;
  hasRequiredShim$6 = 1;
  var define2 = defineProperties_1;
  var getPolyfill4 = requirePolyfill$5();
  shim$9 = function shimAssign() {
    var polyfill2 = getPolyfill4();
    define2(
      Object,
      { assign: polyfill2 },
      { assign: function() {
        return Object.assign !== polyfill2;
      } }
    );
    return polyfill2;
  };
  return shim$9;
}
var object_assign;
var hasRequiredObject_assign;
function requireObject_assign() {
  if (hasRequiredObject_assign) return object_assign;
  hasRequiredObject_assign = 1;
  var defineProperties2 = defineProperties_1;
  var callBind2 = callBindExports;
  var implementation2 = requireImplementation$5();
  var getPolyfill4 = requirePolyfill$5();
  var shim2 = requireShim$6();
  var polyfill2 = callBind2.apply(getPolyfill4());
  var bound = function assign2(target, source1) {
    return polyfill2(Object, arguments);
  };
  defineProperties2(bound, {
    getPolyfill: getPolyfill4,
    implementation: implementation2,
    shim: shim2
  });
  object_assign = bound;
  return object_assign;
}
var isarray;
var hasRequiredIsarray;
function requireIsarray() {
  if (hasRequiredIsarray) return isarray;
  hasRequiredIsarray = 1;
  var toString2 = {}.toString;
  isarray = Array.isArray || function(arr) {
    return toString2.call(arr) == "[object Array]";
  };
  return isarray;
}
var safePushApply;
var hasRequiredSafePushApply;
function requireSafePushApply() {
  if (hasRequiredSafePushApply) return safePushApply;
  hasRequiredSafePushApply = 1;
  var $TypeError2 = type;
  var isArray2 = requireIsarray();
  safePushApply = function safePushApply2(target, source) {
    if (!isArray2(target)) {
      throw new $TypeError2("target must be an array");
    }
    for (var i = 0; i < source.length; i++) {
      target[target.length] = source[i];
    }
  };
  return safePushApply;
}
var ownKeys$4;
var hasRequiredOwnKeys;
function requireOwnKeys() {
  if (hasRequiredOwnKeys) return ownKeys$4;
  hasRequiredOwnKeys = 1;
  var GetIntrinsic3 = getIntrinsic;
  var safePushApply2 = requireSafePushApply();
  var $ownKeys = GetIntrinsic3("%Reflect.ownKeys%", true);
  var $gOPN = GetIntrinsic3("%Object.getOwnPropertyNames%", true);
  var $gOPS = GetIntrinsic3("%Object.getOwnPropertySymbols%", true);
  var keys3 = objectKeys;
  ownKeys$4 = $ownKeys || function ownKeys2(source) {
    var sourceKeys = ($gOPN || keys3)(source);
    if ($gOPS) {
      safePushApply2(sourceKeys, $gOPS(source));
    }
    return sourceKeys;
  };
  return ownKeys$4;
}
var isPlainObject$1;
var hasRequiredIsPlainObject$1;
function requireIsPlainObject$1() {
  if (hasRequiredIsPlainObject$1) return isPlainObject$1;
  hasRequiredIsPlainObject$1 = 1;
  var isArray2 = requireIsarray();
  isPlainObject$1 = function isPlainObject2(x2) {
    return x2 && typeof x2 === "object" && !isArray2(x2);
  };
  return isPlainObject$1;
}
var src;
var hasRequiredSrc;
function requireSrc() {
  if (hasRequiredSrc) return src;
  hasRequiredSrc = 1;
  var assign2 = requireObject_assign();
  var hasOwn2 = requireHasown();
  var ownKeys2 = requireOwnKeys();
  var TypeError2 = type;
  var isPlainObject2 = requireIsPlainObject$1();
  var zeroWidthSpace = "​";
  var specialProperty = "prop-types-exact: " + zeroWidthSpace;
  var semaphore = typeof Symbol === "function" && typeof Symbol["for"] === "function" ? Symbol["for"](specialProperty) : (
    /* istanbul ignore next */
    specialProperty
  );
  var callBound2 = callBound$2;
  var isEnumerable = callBound2("Object.prototype.propertyIsEnumerable");
  function brand(fn2) {
    fn2[specialProperty] = semaphore;
    return fn2;
  }
  function isBranded(value) {
    return value && value[specialProperty] === semaphore;
  }
  src = function forbidExtraProps(propTypes) {
    if (!isPlainObject2(propTypes)) {
      throw new TypeError2("given propTypes must be an object");
    }
    if (hasOwn2(propTypes, specialProperty) && !isBranded(propTypes[specialProperty])) {
      throw new TypeError2("Against all odds, you created a propType for a prop that uses both the zero-width space and our custom string - which, sadly, conflicts with `prop-types-exact`");
    }
    var forbidden = {};
    forbidden[specialProperty] = brand(function forbidUnknownProps(props, _2, componentName) {
      var unknownProps = ownKeys2(props).filter(function(prop) {
        return !hasOwn2(propTypes, prop) && isEnumerable(props, prop);
      });
      if (unknownProps.length > 0) {
        return new TypeError2(componentName + ": unknown props found: " + unknownProps.join(", "));
      }
      return null;
    });
    return assign2({}, propTypes, forbidden);
  };
  return src;
}
var and = {};
var wrapValidator = {};
var hasRequiredWrapValidator;
function requireWrapValidator() {
  if (hasRequiredWrapValidator) return wrapValidator;
  hasRequiredWrapValidator = 1;
  (function(exports$1) {
    Object.defineProperty(exports$1, "__esModule", {
      value: true
    });
    exports$1["default"] = wrapValidator2;
    var _object = _interopRequireDefault(requireObject_assign());
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : { "default": obj };
    }
    function wrapValidator2(validator, typeName) {
      var typeChecker = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
      return (0, _object["default"])(validator.bind(), {
        typeName,
        typeChecker,
        isRequired: (0, _object["default"])(validator.isRequired.bind(), {
          typeName,
          typeChecker,
          typeRequired: true
        })
      });
    }
  })(wrapValidator);
  return wrapValidator;
}
var hasRequiredAnd;
function requireAnd() {
  if (hasRequiredAnd) return and;
  hasRequiredAnd = 1;
  (function(exports$1) {
    Object.defineProperty(exports$1, "__esModule", {
      value: true
    });
    exports$1["default"] = andValidator;
    var _wrapValidator = _interopRequireDefault(requireWrapValidator());
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : { "default": obj };
    }
    function andValidator(validators) {
      var name = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "and";
      if (!Array.isArray(validators)) {
        throw new TypeError("and: 2 or more validators are required");
      }
      if (validators.length <= 1) {
        throw new RangeError("and: 2 or more validators are required");
      }
      var validator = function and2() {
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }
        var firstError = null;
        validators.some(function(validatorFn) {
          firstError = validatorFn.apply(void 0, args);
          return firstError != null;
        });
        return firstError == null ? null : firstError;
      };
      validator.isRequired = function andIsRequired() {
        for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments[_key2];
        }
        var firstError = null;
        validators.some(function(validatorFn) {
          firstError = validatorFn.isRequired.apply(validatorFn, args);
          return firstError != null;
        });
        return firstError == null ? null : firstError;
      };
      return (0, _wrapValidator["default"])(validator, name, validators);
    }
  })(and);
  return and;
}
var between = {};
var $TypeError = type;
var RequireObjectCoercible$1 = function RequireObjectCoercible(value) {
  if (value == null) {
    throw new $TypeError(arguments.length > 0 && arguments[1] || "Cannot call method on " + value);
  }
  return value;
};
var callBound$1;
var hasRequiredCallBound;
function requireCallBound() {
  if (hasRequiredCallBound) return callBound$1;
  hasRequiredCallBound = 1;
  var GetIntrinsic3 = getIntrinsic;
  var callBind2 = callBindExports;
  var $indexOf2 = callBind2(GetIntrinsic3("String.prototype.indexOf"));
  callBound$1 = function callBoundIntrinsic2(name, allowMissing) {
    var intrinsic = GetIntrinsic3(name, !!allowMissing);
    if (typeof intrinsic === "function" && $indexOf2(name, ".prototype.") > -1) {
      return callBind2(intrinsic);
    }
    return intrinsic;
  };
  return callBound$1;
}
var implementation$a;
var hasRequiredImplementation$4;
function requireImplementation$4() {
  if (hasRequiredImplementation$4) return implementation$a;
  hasRequiredImplementation$4 = 1;
  var RequireObjectCoercible3 = RequireObjectCoercible$1;
  var callBound2 = requireCallBound();
  var $isEnumerable2 = callBound2("Object.prototype.propertyIsEnumerable");
  var $push = callBound2("Array.prototype.push");
  implementation$a = function entries(O2) {
    var obj = RequireObjectCoercible3(O2);
    var entrys = [];
    for (var key in obj) {
      if ($isEnumerable2(obj, key)) {
        $push(entrys, [key, obj[key]]);
      }
    }
    return entrys;
  };
  return implementation$a;
}
var polyfill$8;
var hasRequiredPolyfill$4;
function requirePolyfill$4() {
  if (hasRequiredPolyfill$4) return polyfill$8;
  hasRequiredPolyfill$4 = 1;
  var implementation2 = requireImplementation$4();
  polyfill$8 = function getPolyfill4() {
    return typeof Object.entries === "function" ? Object.entries : implementation2;
  };
  return polyfill$8;
}
var shim$8;
var hasRequiredShim$5;
function requireShim$5() {
  if (hasRequiredShim$5) return shim$8;
  hasRequiredShim$5 = 1;
  var getPolyfill4 = requirePolyfill$4();
  var define2 = defineProperties_1;
  shim$8 = function shimEntries() {
    var polyfill2 = getPolyfill4();
    define2(Object, { entries: polyfill2 }, {
      entries: function testEntries() {
        return Object.entries !== polyfill2;
      }
    });
    return polyfill2;
  };
  return shim$8;
}
var object_entries;
var hasRequiredObject_entries;
function requireObject_entries() {
  if (hasRequiredObject_entries) return object_entries;
  hasRequiredObject_entries = 1;
  var define2 = defineProperties_1;
  var callBind2 = callBindExports;
  var implementation2 = requireImplementation$4();
  var getPolyfill4 = requirePolyfill$4();
  var shim2 = requireShim$5();
  var polyfill2 = callBind2(getPolyfill4(), Object);
  define2(polyfill2, {
    getPolyfill: getPolyfill4,
    implementation: implementation2,
    shim: shim2
  });
  object_entries = polyfill2;
  return object_entries;
}
var shape = {};
var isPlainObject = {};
var hasRequiredIsPlainObject;
function requireIsPlainObject() {
  if (hasRequiredIsPlainObject) return isPlainObject;
  hasRequiredIsPlainObject = 1;
  (function(exports$1) {
    Object.defineProperty(exports$1, "__esModule", {
      value: true
    });
    exports$1["default"] = void 0;
    var _isPlainObject = _interopRequireDefault(requireIsPlainObject$1());
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : { "default": obj };
    }
    var _default2 = _isPlainObject["default"];
    exports$1["default"] = _default2;
  })(isPlainObject);
  return isPlainObject;
}
var hasRequiredShape;
function requireShape() {
  if (hasRequiredShape) return shape;
  hasRequiredShape = 1;
  (function(exports$1) {
    Object.defineProperty(exports$1, "__esModule", {
      value: true
    });
    exports$1["default"] = shapeValidator;
    var _isPlainObject = _interopRequireDefault(requireIsPlainObject());
    var _wrapValidator = _interopRequireDefault(requireWrapValidator());
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : { "default": obj };
    }
    function shapeValidator(shapeTypes) {
      if (!(0, _isPlainObject["default"])(shapeTypes)) {
        throw new TypeError("shape must be a normal object");
      }
      function shape2(props, propName, componentName, location) {
        var propValue = props[propName];
        if (propValue == null) {
          return null;
        }
        for (var _len = arguments.length, rest = new Array(_len > 4 ? _len - 4 : 0), _key = 4; _key < _len; _key++) {
          rest[_key - 4] = arguments[_key];
        }
        for (var key in shapeTypes) {
          var checker = shapeTypes[key];
          if (checker) {
            var error2 = checker.apply(void 0, [propValue, key, componentName, location].concat(rest));
            if (error2) {
              return error2;
            }
          }
        }
        return null;
      }
      shape2.isRequired = function shapeRequired(props, propName, componentName) {
        var propValue = props[propName];
        if (propValue == null) {
          return new TypeError("".concat(componentName, ": ").concat(propName, " is required."));
        }
        for (var _len2 = arguments.length, rest = new Array(_len2 > 3 ? _len2 - 3 : 0), _key2 = 3; _key2 < _len2; _key2++) {
          rest[_key2 - 3] = arguments[_key2];
        }
        return shape2.apply(void 0, [props, propName, componentName].concat(rest));
      };
      return (0, _wrapValidator["default"])(shape2, "shape", shapeTypes);
    }
  })(shape);
  return shape;
}
var valuesOf = {};
var isPrimitive$2 = {};
var hasRequiredIsPrimitive$2;
function requireIsPrimitive$2() {
  if (hasRequiredIsPrimitive$2) return isPrimitive$2;
  hasRequiredIsPrimitive$2 = 1;
  (function(exports$1) {
    Object.defineProperty(exports$1, "__esModule", {
      value: true
    });
    exports$1["default"] = isPrimitive2;
    function _typeof2(obj) {
      "@babel/helpers - typeof";
      if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
        _typeof2 = function _typeof3(obj2) {
          return typeof obj2;
        };
      } else {
        _typeof2 = function _typeof3(obj2) {
          return obj2 && typeof Symbol === "function" && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
        };
      }
      return _typeof2(obj);
    }
    function isPrimitive2(x2) {
      return !x2 || _typeof2(x2) !== "object" && typeof x2 !== "function";
    }
  })(isPrimitive$2);
  return isPrimitive$2;
}
var hasRequiredValuesOf;
function requireValuesOf() {
  if (hasRequiredValuesOf) return valuesOf;
  hasRequiredValuesOf = 1;
  (function(exports$1) {
    Object.defineProperty(exports$1, "__esModule", {
      value: true
    });
    exports$1["default"] = valuesOfValidator;
    var _isPrimitive = _interopRequireDefault(requireIsPrimitive$2());
    var _wrapValidator = _interopRequireDefault(requireWrapValidator());
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : { "default": obj };
    }
    function valuesOfValidator(propType) {
      if (typeof propType !== "function") {
        throw new TypeError("objectOf: propType must be a function");
      }
      var validator = function valuesOf2(props, propName, componentName, location, propFullName) {
        for (var _len = arguments.length, rest = new Array(_len > 5 ? _len - 5 : 0), _key = 5; _key < _len; _key++) {
          rest[_key - 5] = arguments[_key];
        }
        var propValue = props[propName];
        if (propValue == null || (0, _isPrimitive["default"])(propValue)) {
          return null;
        }
        var firstError;
        Object.keys(propValue).some(function(key) {
          firstError = propType.apply(void 0, [propValue, key, componentName, location, "".concat(propFullName, ".").concat(key)].concat(rest));
          return firstError;
        });
        return firstError || null;
      };
      validator.isRequired = function valuesOfRequired(props, propName, componentName) {
        var propValue = props[propName];
        if (propValue == null) {
          return new TypeError("".concat(componentName, ": ").concat(propName, " is required."));
        }
        for (var _len2 = arguments.length, rest = new Array(_len2 > 3 ? _len2 - 3 : 0), _key2 = 3; _key2 < _len2; _key2++) {
          rest[_key2 - 3] = arguments[_key2];
        }
        return validator.apply(void 0, [props, propName, componentName].concat(rest));
      };
      return (0, _wrapValidator["default"])(validator, "valuesOf", propType);
    }
  })(valuesOf);
  return valuesOf;
}
var hasRequiredBetween;
function requireBetween() {
  if (hasRequiredBetween) return between;
  hasRequiredBetween = 1;
  (function(exports$1) {
    Object.defineProperty(exports$1, "__esModule", {
      value: true
    });
    exports$1["default"] = betweenValidator;
    var _object = _interopRequireDefault(requireObject_entries());
    var _shape = _interopRequireDefault(requireShape());
    var _valuesOf = _interopRequireDefault(requireValuesOf());
    var _wrapValidator = _interopRequireDefault(requireWrapValidator());
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : { "default": obj };
    }
    function _typeof2(obj) {
      "@babel/helpers - typeof";
      if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
        _typeof2 = function _typeof3(obj2) {
          return typeof obj2;
        };
      } else {
        _typeof2 = function _typeof3(obj2) {
          return obj2 && typeof Symbol === "function" && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
        };
      }
      return _typeof2(obj);
    }
    function ownKeys2(object2, enumerableOnly) {
      var keys3 = Object.keys(object2);
      if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object2);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
          return Object.getOwnPropertyDescriptor(object2, sym).enumerable;
        });
        keys3.push.apply(keys3, symbols);
      }
      return keys3;
    }
    function _objectSpread3(target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) {
          ownKeys2(Object(source), true).forEach(function(key) {
            _defineProperty2(target, key, source[key]);
          });
        } else if (Object.getOwnPropertyDescriptors) {
          Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        } else {
          ownKeys2(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
          });
        }
      }
      return target;
    }
    function _defineProperty2(obj, key, value) {
      if (key in obj) {
        Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
      } else {
        obj[key] = value;
      }
      return obj;
    }
    function _slicedToArray2(arr, i) {
      return _arrayWithHoles2(arr) || _iterableToArrayLimit2(arr, i) || _unsupportedIterableToArray2(arr, i) || _nonIterableRest2();
    }
    function _nonIterableRest2() {
      throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    function _unsupportedIterableToArray2(o, minLen) {
      if (!o) return;
      if (typeof o === "string") return _arrayLikeToArray2(o, minLen);
      var n2 = Object.prototype.toString.call(o).slice(8, -1);
      if (n2 === "Object" && o.constructor) n2 = o.constructor.name;
      if (n2 === "Map" || n2 === "Set") return Array.from(o);
      if (n2 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n2)) return _arrayLikeToArray2(o, minLen);
    }
    function _arrayLikeToArray2(arr, len) {
      if (len == null || len > arr.length) len = arr.length;
      for (var i = 0, arr2 = new Array(len); i < len; i++) {
        arr2[i] = arr[i];
      }
      return arr2;
    }
    function _iterableToArrayLimit2(arr, i) {
      if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
      var _arr = [];
      var _n = true;
      var _d = false;
      var _e = void 0;
      try {
        for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
          _arr.push(_s.value);
          if (i && _arr.length === i) break;
        }
      } catch (err) {
        _d = true;
        _e = err;
      } finally {
        try {
          if (!_n && _i["return"] != null) _i["return"]();
        } finally {
          if (_d) throw _e;
        }
      }
      return _arr;
    }
    function _arrayWithHoles2(arr) {
      if (Array.isArray(arr)) return arr;
    }
    function number(props, propName, componentName) {
      var value = props[propName];
      if (typeof value === "number" && !isNaN(value)) {
        return null;
      }
      return new TypeError("".concat(componentName, ": ").concat(propName, " must be a non-NaN number."));
    }
    function numberOrPropsFunc(props, propName) {
      var value = props[propName];
      if (typeof value === "function") {
        return null;
      }
      if (typeof value === "number" && !isNaN(value)) {
        return null;
      }
      return new TypeError("".concat(propName, ": a function, or a non-NaN number is required"));
    }
    function lowerCompare(value, _ref3) {
      var gt = _ref3.gt, gte = _ref3.gte;
      if (typeof gt === "number") {
        return value > gt;
      }
      if (typeof gte === "number") {
        return value >= gte;
      }
      return true;
    }
    function upperCompare(value, _ref22) {
      var lt = _ref22.lt, lte = _ref22.lte;
      if (typeof lt === "number") {
        return value < lt;
      }
      if (typeof lte === "number") {
        return value <= lte;
      }
      return true;
    }
    function greaterThanError(_ref3) {
      var gt = _ref3.gt, gte = _ref3.gte;
      if (typeof gt === "number") {
        return "greater than ".concat(gt);
      }
      if (typeof gte === "number") {
        return "greater than or equal to ".concat(gte);
      }
      return "";
    }
    function lessThanError(_ref4) {
      var lt = _ref4.lt, lte = _ref4.lte;
      if (typeof lt === "number") {
        return "less than ".concat(lt);
      }
      if (typeof lte === "number") {
        return "less than or equal to ".concat(lte);
      }
      return "";
    }
    function errorMessage(componentName, propName, opts) {
      var errors = [greaterThanError(opts), lessThanError(opts)].filter(Boolean).join(" and ");
      return "".concat(componentName, ": ").concat(propName, " must be ").concat(errors);
    }
    function propsThunkify(opts) {
      return (0, _object["default"])(opts).reduce(function(acc, _ref5) {
        var _ref6 = _slicedToArray2(_ref5, 2), key = _ref6[0], value = _ref6[1];
        var numberThunk = typeof value === "number" ? function() {
          return value;
        } : value;
        return _objectSpread3(_objectSpread3({}, acc), {}, _defineProperty2({}, key, numberThunk));
      }, {});
    }
    function invokeWithProps(optsThunks, props) {
      return (0, _object["default"])(optsThunks).reduce(function(acc, _ref7) {
        var _ref8 = _slicedToArray2(_ref7, 2), key = _ref8[0], thunk = _ref8[1];
        var value = thunk(props);
        return _objectSpread3(_objectSpread3({}, acc), {}, _defineProperty2({}, key, value));
      }, {});
    }
    var argValidators = [(0, _shape["default"])({
      lt: numberOrPropsFunc,
      gt: numberOrPropsFunc
    }).isRequired, (0, _shape["default"])({
      lte: numberOrPropsFunc,
      gt: numberOrPropsFunc
    }).isRequired, (0, _shape["default"])({
      lt: numberOrPropsFunc,
      gte: numberOrPropsFunc
    }).isRequired, (0, _shape["default"])({
      lte: numberOrPropsFunc,
      gte: numberOrPropsFunc
    }).isRequired, (0, _shape["default"])({
      lt: numberOrPropsFunc
    }).isRequired, (0, _shape["default"])({
      lte: numberOrPropsFunc
    }).isRequired, (0, _shape["default"])({
      gt: numberOrPropsFunc
    }).isRequired, (0, _shape["default"])({
      gte: numberOrPropsFunc
    }).isRequired];
    function argValidator(props, propName) {
      return argValidators.every(function(validator) {
        return !!validator(props, propName);
      });
    }
    var thunkValueValidator = (0, _valuesOf["default"])(number).isRequired;
    function betweenValidator(options2) {
      var argError = argValidator({
        options: options2
      }, "options");
      if (argError) {
        throw new TypeError("between: only one of the pairs of `lt`/`lte`, and `gt`/`gte`, may be supplied, and at least one pair must be provided.");
      }
      var optsThunks = propsThunkify(options2);
      var validator = function between2(props, propName, componentName) {
        var propValue = props[propName];
        if (propValue == null) {
          return null;
        }
        if (typeof propValue !== "number") {
          return new RangeError("".concat(componentName, ": ").concat(propName, ' must be a number, got "').concat(_typeof2(propValue), '"'));
        }
        var opts = invokeWithProps(optsThunks, props);
        for (var _len = arguments.length, rest = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
          rest[_key - 3] = arguments[_key];
        }
        var thunkValuesError = thunkValueValidator.apply(void 0, [_defineProperty2({}, propName, opts), propName, componentName].concat(rest));
        if (thunkValuesError) {
          return thunkValuesError;
        }
        if (!lowerCompare(propValue, opts) || !upperCompare(propValue, opts)) {
          return new RangeError(errorMessage(componentName, propName, opts));
        }
        return null;
      };
      validator.isRequired = function betweenRequired(props, propName, componentName) {
        var propValue = props[propName];
        if (typeof propValue !== "number") {
          return new RangeError("".concat(componentName, ": ").concat(propName, ' must be a number, got "').concat(_typeof2(propValue), '"'));
        }
        var opts = invokeWithProps(optsThunks, props);
        for (var _len2 = arguments.length, rest = new Array(_len2 > 3 ? _len2 - 3 : 0), _key2 = 3; _key2 < _len2; _key2++) {
          rest[_key2 - 3] = arguments[_key2];
        }
        var thunkValuesError = thunkValueValidator.apply(void 0, [_defineProperty2({}, propName, opts), propName, componentName].concat(rest));
        if (thunkValuesError) {
          return thunkValuesError;
        }
        if (!lowerCompare(propValue, opts) || !upperCompare(propValue, opts)) {
          return new RangeError(errorMessage(componentName, propName, opts));
        }
        return null;
      };
      return (0, _wrapValidator["default"])(validator, "between", options2);
    }
  })(between);
  return between;
}
var booleanSome = {};
var hasRequiredBooleanSome;
function requireBooleanSome() {
  if (hasRequiredBooleanSome) return booleanSome;
  hasRequiredBooleanSome = 1;
  (function(exports$1) {
    Object.defineProperty(exports$1, "__esModule", {
      value: true
    });
    exports$1["default"] = booleanSomeValidator;
    var _propTypes = propTypesExports;
    var _wrapValidator = _interopRequireDefault(requireWrapValidator());
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : { "default": obj };
    }
    function booleanSomeValidator() {
      for (var _len = arguments.length, notAllPropsFalse = new Array(_len), _key = 0; _key < _len; _key++) {
        notAllPropsFalse[_key] = arguments[_key];
      }
      if (notAllPropsFalse.length < 1) {
        throw new TypeError("at least one prop (one of which must be `true`) is required");
      }
      if (!notAllPropsFalse.every(function(x2) {
        return typeof x2 === "string";
      })) {
        throw new TypeError("all booleanSome props must be strings");
      }
      var propsList = notAllPropsFalse.join(", or ");
      var validator = function booleanSome2(props, propName, componentName) {
        var countFalse = function countFalse2(count2, prop) {
          return count2 + (props[prop] === false ? 1 : 0);
        };
        var falsePropCount = notAllPropsFalse.reduce(countFalse, 0);
        if (falsePropCount === notAllPropsFalse.length) {
          return new Error("A ".concat(componentName, " must have at least one of these boolean props be `true`: ").concat(propsList));
        }
        for (var _len2 = arguments.length, rest = new Array(_len2 > 3 ? _len2 - 3 : 0), _key2 = 3; _key2 < _len2; _key2++) {
          rest[_key2 - 3] = arguments[_key2];
        }
        return _propTypes.bool.apply(void 0, [props, propName, componentName].concat(rest));
      };
      validator.isRequired = function booleanSomeRequired(props, propName, componentName) {
        var countFalse = function countFalse2(count2, prop) {
          return count2 + (props[prop] === false ? 1 : 0);
        };
        var falsePropCount = notAllPropsFalse.reduce(countFalse, 0);
        if (falsePropCount === notAllPropsFalse.length) {
          return new Error("A ".concat(componentName, " must have at least one of these boolean props be `true`: ").concat(propsList));
        }
        for (var _len3 = arguments.length, rest = new Array(_len3 > 3 ? _len3 - 3 : 0), _key3 = 3; _key3 < _len3; _key3++) {
          rest[_key3 - 3] = arguments[_key3];
        }
        return _propTypes.bool.isRequired.apply(_propTypes.bool, [props, propName, componentName].concat(rest));
      };
      return (0, _wrapValidator["default"])(validator, "booleanSome: ".concat(propsList), notAllPropsFalse);
    }
  })(booleanSome);
  return booleanSome;
}
var childrenHavePropXorChildren = {};
var hasRequiredChildrenHavePropXorChildren;
function requireChildrenHavePropXorChildren() {
  if (hasRequiredChildrenHavePropXorChildren) return childrenHavePropXorChildren;
  hasRequiredChildrenHavePropXorChildren = 1;
  (function(exports$1) {
    Object.defineProperty(exports$1, "__esModule", {
      value: true
    });
    exports$1["default"] = childrenHavePropXorChildren2;
    var _react = _interopRequireDefault(React__default);
    var _wrapValidator = _interopRequireDefault(requireWrapValidator());
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : { "default": obj };
    }
    function _typeof2(obj) {
      "@babel/helpers - typeof";
      if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
        _typeof2 = function _typeof3(obj2) {
          return typeof obj2;
        };
      } else {
        _typeof2 = function _typeof3(obj2) {
          return obj2 && typeof Symbol === "function" && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
        };
      }
      return _typeof2(obj);
    }
    function childrenHavePropXorChildren2(prop) {
      if (typeof prop !== "string" && _typeof2(prop) !== "symbol") {
        throw new TypeError("invalid prop: must be string or symbol");
      }
      var validator = function childrenHavePropXorChildrenWithProp(_ref3, _2, componentName) {
        var children = _ref3.children;
        var truthyChildrenCount = 0;
        var propCount = 0;
        var grandchildrenCount = 0;
        _react["default"].Children.forEach(children, function(child) {
          if (!child) {
            return;
          }
          truthyChildrenCount += 1;
          if (child.props[prop]) {
            propCount += 1;
          }
          if (_react["default"].Children.count(child.props.children)) {
            grandchildrenCount += 1;
          }
        });
        if (propCount === truthyChildrenCount && grandchildrenCount === 0 || propCount === 0 && grandchildrenCount === truthyChildrenCount || propCount === 0 && grandchildrenCount === 0) {
          return null;
        }
        return new TypeError("`".concat(componentName, "` requires children to all have prop “").concat(prop, "”, all have children, or all have neither."));
      };
      validator.isRequired = validator;
      return (0, _wrapValidator["default"])(validator, "childrenHavePropXorChildrenWithProp:".concat(prop), prop);
    }
  })(childrenHavePropXorChildren);
  return childrenHavePropXorChildren;
}
var childrenOf = {};
var renderableChildren = {};
var hasRequiredRenderableChildren;
function requireRenderableChildren() {
  if (hasRequiredRenderableChildren) return renderableChildren;
  hasRequiredRenderableChildren = 1;
  (function(exports$1) {
    Object.defineProperty(exports$1, "__esModule", {
      value: true
    });
    exports$1["default"] = renderableChildren2;
    var _react = _interopRequireDefault(React__default);
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : { "default": obj };
    }
    function renderableChildren2(childrenProp) {
      return _react["default"].Children.toArray(childrenProp).filter(function(child) {
        return child === 0 || child;
      });
    }
  })(renderableChildren);
  return renderableChildren;
}
var hasRequiredChildrenOf;
function requireChildrenOf() {
  if (hasRequiredChildrenOf) return childrenOf;
  hasRequiredChildrenOf = 1;
  (function(exports$1) {
    Object.defineProperty(exports$1, "__esModule", {
      value: true
    });
    exports$1["default"] = childrenOf2;
    var _renderableChildren = _interopRequireDefault(requireRenderableChildren());
    var _wrapValidator = _interopRequireDefault(requireWrapValidator());
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : { "default": obj };
    }
    function ownKeys2(object2, enumerableOnly) {
      var keys3 = Object.keys(object2);
      if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object2);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
          return Object.getOwnPropertyDescriptor(object2, sym).enumerable;
        });
        keys3.push.apply(keys3, symbols);
      }
      return keys3;
    }
    function _objectSpread3(target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) {
          ownKeys2(Object(source), true).forEach(function(key) {
            _defineProperty2(target, key, source[key]);
          });
        } else if (Object.getOwnPropertyDescriptors) {
          Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        } else {
          ownKeys2(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
          });
        }
      }
      return target;
    }
    function _defineProperty2(obj, key, value) {
      if (key in obj) {
        Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
      } else {
        obj[key] = value;
      }
      return obj;
    }
    function validateChildren(propType, children, props) {
      for (var _len = arguments.length, rest = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
        rest[_key - 3] = arguments[_key];
      }
      var error2;
      children.some(function(child) {
        error2 = propType.apply(void 0, [_objectSpread3(_objectSpread3({}, props), {}, {
          children: child
        }), "children"].concat(rest));
        return error2;
      });
      return error2 || null;
    }
    function childrenOf2(propType) {
      function childrenOfPropType(props, propName, componentName) {
        if (propName !== "children") {
          return new TypeError("".concat(componentName, ' is using the childrenOf validator on non-children prop "').concat(propName, '"'));
        }
        var propValue = props[propName];
        if (propValue == null) {
          return null;
        }
        var children = (0, _renderableChildren["default"])(propValue);
        if (children.length === 0) {
          return null;
        }
        for (var _len2 = arguments.length, rest = new Array(_len2 > 3 ? _len2 - 3 : 0), _key2 = 3; _key2 < _len2; _key2++) {
          rest[_key2 - 3] = arguments[_key2];
        }
        return validateChildren.apply(void 0, [propType, children, props, componentName].concat(rest));
      }
      childrenOfPropType.isRequired = function(props, propName, componentName) {
        if (propName !== "children") {
          return new TypeError("".concat(componentName, ' is using the childrenOf validator on non-children prop "').concat(propName, '"'));
        }
        var children = (0, _renderableChildren["default"])(props[propName]);
        if (children.length === 0) {
          return new TypeError("`".concat(componentName, "` requires at least one node of type ").concat(propType.typeName || propType.name));
        }
        for (var _len3 = arguments.length, rest = new Array(_len3 > 3 ? _len3 - 3 : 0), _key3 = 3; _key3 < _len3; _key3++) {
          rest[_key3 - 3] = arguments[_key3];
        }
        return validateChildren.apply(void 0, [propType, children, props, componentName].concat(rest));
      };
      return (0, _wrapValidator["default"])(childrenOfPropType, "childrenOf", propType);
    }
  })(childrenOf);
  return childrenOf;
}
var childrenOfType = {};
var ToObject;
var hasRequiredToObject;
function requireToObject() {
  if (hasRequiredToObject) return ToObject;
  hasRequiredToObject = 1;
  var $Object2 = esObjectAtoms;
  var RequireObjectCoercible3 = RequireObjectCoercible$1;
  ToObject = function ToObject2(value) {
    RequireObjectCoercible3(value);
    return $Object2(value);
  };
  return ToObject;
}
var maxSafeInteger;
var hasRequiredMaxSafeInteger;
function requireMaxSafeInteger() {
  if (hasRequiredMaxSafeInteger) return maxSafeInteger;
  hasRequiredMaxSafeInteger = 1;
  maxSafeInteger = /** @type {import('./maxSafeInteger')} */
  Number.MAX_SAFE_INTEGER || 9007199254740991;
  return maxSafeInteger;
}
var isPrimitive$1;
var hasRequiredIsPrimitive$1;
function requireIsPrimitive$1() {
  if (hasRequiredIsPrimitive$1) return isPrimitive$1;
  hasRequiredIsPrimitive$1 = 1;
  isPrimitive$1 = function isPrimitive2(value) {
    return value === null || typeof value !== "function" && typeof value !== "object";
  };
  return isPrimitive$1;
}
var isPrimitive;
var hasRequiredIsPrimitive;
function requireIsPrimitive() {
  if (hasRequiredIsPrimitive) return isPrimitive;
  hasRequiredIsPrimitive = 1;
  isPrimitive = function isPrimitive2(value) {
    return value === null || typeof value !== "function" && typeof value !== "object";
  };
  return isPrimitive;
}
var isCallable;
var hasRequiredIsCallable$1;
function requireIsCallable$1() {
  if (hasRequiredIsCallable$1) return isCallable;
  hasRequiredIsCallable$1 = 1;
  var fnToStr = Function.prototype.toString;
  var reflectApply2 = typeof Reflect === "object" && Reflect !== null && Reflect.apply;
  var badArrayLike;
  var isCallableMarker;
  if (typeof reflectApply2 === "function" && typeof Object.defineProperty === "function") {
    try {
      badArrayLike = Object.defineProperty({}, "length", {
        get: function() {
          throw isCallableMarker;
        }
      });
      isCallableMarker = {};
      reflectApply2(function() {
        throw 42;
      }, null, badArrayLike);
    } catch (_2) {
      if (_2 !== isCallableMarker) {
        reflectApply2 = null;
      }
    }
  } else {
    reflectApply2 = null;
  }
  var constructorRegex = /^\s*class\b/;
  var isES6ClassFn = function isES6ClassFunction(value) {
    try {
      var fnStr = fnToStr.call(value);
      return constructorRegex.test(fnStr);
    } catch (e3) {
      return false;
    }
  };
  var tryFunctionObject = function tryFunctionToStr(value) {
    try {
      if (isES6ClassFn(value)) {
        return false;
      }
      fnToStr.call(value);
      return true;
    } catch (e3) {
      return false;
    }
  };
  var toStr2 = Object.prototype.toString;
  var objectClass = "[object Object]";
  var fnClass = "[object Function]";
  var genClass = "[object GeneratorFunction]";
  var ddaClass = "[object HTMLAllCollection]";
  var ddaClass2 = "[object HTML document.all class]";
  var ddaClass3 = "[object HTMLCollection]";
  var hasToStringTag = typeof Symbol === "function" && !!Symbol.toStringTag;
  var isIE68 = !(0 in [,]);
  var isDDA = function isDocumentDotAll() {
    return false;
  };
  if (typeof document === "object") {
    var all = document.all;
    if (toStr2.call(all) === toStr2.call(document.all)) {
      isDDA = function isDocumentDotAll(value) {
        if ((isIE68 || !value) && (typeof value === "undefined" || typeof value === "object")) {
          try {
            var str = toStr2.call(value);
            return (str === ddaClass || str === ddaClass2 || str === ddaClass3 || str === objectClass) && value("") == null;
          } catch (e3) {
          }
        }
        return false;
      };
    }
  }
  isCallable = reflectApply2 ? function isCallable2(value) {
    if (isDDA(value)) {
      return true;
    }
    if (!value) {
      return false;
    }
    if (typeof value !== "function" && typeof value !== "object") {
      return false;
    }
    try {
      reflectApply2(value, null, badArrayLike);
    } catch (e3) {
      if (e3 !== isCallableMarker) {
        return false;
      }
    }
    return !isES6ClassFn(value) && tryFunctionObject(value);
  } : function isCallable2(value) {
    if (isDDA(value)) {
      return true;
    }
    if (!value) {
      return false;
    }
    if (typeof value !== "function" && typeof value !== "object") {
      return false;
    }
    if (hasToStringTag) {
      return tryFunctionObject(value);
    }
    if (isES6ClassFn(value)) {
      return false;
    }
    var strClass = toStr2.call(value);
    if (strClass !== fnClass && strClass !== genClass && !/^\[object HTML/.test(strClass)) {
      return false;
    }
    return tryFunctionObject(value);
  };
  return isCallable;
}
var shams;
var hasRequiredShams;
function requireShams() {
  if (hasRequiredShams) return shams;
  hasRequiredShams = 1;
  var hasSymbols2 = requireShams$1();
  shams = function hasToStringTagShams() {
    return hasSymbols2() && !!Symbol.toStringTag;
  };
  return shams;
}
var isDateObject;
var hasRequiredIsDateObject;
function requireIsDateObject() {
  if (hasRequiredIsDateObject) return isDateObject;
  hasRequiredIsDateObject = 1;
  var callBound2 = callBound$2;
  var getDay2 = callBound2("Date.prototype.getDay");
  var tryDateObject = function tryDateGetDayCall(value) {
    try {
      getDay2(value);
      return true;
    } catch (e3) {
      return false;
    }
  };
  var toStr2 = callBound2("Object.prototype.toString");
  var dateClass = "[object Date]";
  var hasToStringTag = requireShams()();
  isDateObject = function isDateObject2(value) {
    if (typeof value !== "object" || value === null) {
      return false;
    }
    return hasToStringTag ? tryDateObject(value) : toStr2(value) === dateClass;
  };
  return isDateObject;
}
var isSymbol$4 = { exports: {} };
var isRegex;
var hasRequiredIsRegex;
function requireIsRegex() {
  if (hasRequiredIsRegex) return isRegex;
  hasRequiredIsRegex = 1;
  var callBound2 = callBound$2;
  var hasToStringTag = requireShams()();
  var hasOwn2 = requireHasown();
  var gOPD2 = gopd$1;
  var fn2;
  if (hasToStringTag) {
    var $exec2 = callBound2("RegExp.prototype.exec");
    var isRegexMarker = {};
    var throwRegexMarker = function() {
      throw isRegexMarker;
    };
    var badStringifier = {
      toString: throwRegexMarker,
      valueOf: throwRegexMarker
    };
    if (typeof Symbol.toPrimitive === "symbol") {
      badStringifier[Symbol.toPrimitive] = throwRegexMarker;
    }
    fn2 = function isRegex2(value) {
      if (!value || typeof value !== "object") {
        return false;
      }
      var descriptor = (
        /** @type {NonNullable<typeof gOPD>} */
        gOPD2(
          /** @type {{ lastIndex?: unknown }} */
          value,
          "lastIndex"
        )
      );
      var hasLastIndexDataProperty = descriptor && hasOwn2(descriptor, "value");
      if (!hasLastIndexDataProperty) {
        return false;
      }
      try {
        $exec2(
          value,
          /** @type {string} */
          /** @type {unknown} */
          badStringifier
        );
      } catch (e3) {
        return e3 === isRegexMarker;
      }
    };
  } else {
    var $toString = callBound2("Object.prototype.toString");
    var regexClass = "[object RegExp]";
    fn2 = function isRegex2(value) {
      if (!value || typeof value !== "object" && typeof value !== "function") {
        return false;
      }
      return $toString(value) === regexClass;
    };
  }
  isRegex = fn2;
  return isRegex;
}
var safeRegexTest;
var hasRequiredSafeRegexTest;
function requireSafeRegexTest() {
  if (hasRequiredSafeRegexTest) return safeRegexTest;
  hasRequiredSafeRegexTest = 1;
  var callBound2 = callBound$2;
  var isRegex2 = requireIsRegex();
  var $exec2 = callBound2("RegExp.prototype.exec");
  var $TypeError2 = type;
  safeRegexTest = function regexTester(regex) {
    if (!isRegex2(regex)) {
      throw new $TypeError2("`regex` must be a RegExp");
    }
    return function test(s2) {
      return $exec2(regex, s2) !== null;
    };
  };
  return safeRegexTest;
}
var hasRequiredIsSymbol;
function requireIsSymbol() {
  if (hasRequiredIsSymbol) return isSymbol$4.exports;
  hasRequiredIsSymbol = 1;
  var callBound2 = callBound$2;
  var $toString = callBound2("Object.prototype.toString");
  var hasSymbols2 = requireHasSymbols()();
  var safeRegexTest2 = requireSafeRegexTest();
  if (hasSymbols2) {
    var $symToStr = callBound2("Symbol.prototype.toString");
    var isSymString = safeRegexTest2(/^Symbol\(.*\)$/);
    var isSymbolObject = function isRealSymbolObject(value) {
      if (typeof value.valueOf() !== "symbol") {
        return false;
      }
      return isSymString($symToStr(value));
    };
    isSymbol$4.exports = function isSymbol2(value) {
      if (typeof value === "symbol") {
        return true;
      }
      if (!value || typeof value !== "object" || $toString(value) !== "[object Symbol]") {
        return false;
      }
      try {
        return isSymbolObject(value);
      } catch (e3) {
        return false;
      }
    };
  } else {
    isSymbol$4.exports = function isSymbol2(value) {
      return false;
    };
  }
  return isSymbol$4.exports;
}
var es2015;
var hasRequiredEs2015;
function requireEs2015() {
  if (hasRequiredEs2015) return es2015;
  hasRequiredEs2015 = 1;
  var hasSymbols2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol";
  var isPrimitive2 = requireIsPrimitive();
  var isCallable2 = requireIsCallable$1();
  var isDate2 = requireIsDateObject();
  var isSymbol2 = requireIsSymbol();
  var ordinaryToPrimitive = function OrdinaryToPrimitive(O2, hint) {
    if (typeof O2 === "undefined" || O2 === null) {
      throw new TypeError("Cannot call method on " + O2);
    }
    if (typeof hint !== "string" || hint !== "number" && hint !== "string") {
      throw new TypeError('hint must be "string" or "number"');
    }
    var methodNames = hint === "string" ? ["toString", "valueOf"] : ["valueOf", "toString"];
    var method, result, i;
    for (i = 0; i < methodNames.length; ++i) {
      method = O2[methodNames[i]];
      if (isCallable2(method)) {
        result = method.call(O2);
        if (isPrimitive2(result)) {
          return result;
        }
      }
    }
    throw new TypeError("No default value");
  };
  var GetMethod = function GetMethod2(O2, P2) {
    var func = O2[P2];
    if (func !== null && typeof func !== "undefined") {
      if (!isCallable2(func)) {
        throw new TypeError(func + " returned for property " + String(P2) + " of object " + O2 + " is not a function");
      }
      return func;
    }
    return void 0;
  };
  es2015 = function ToPrimitive2(input) {
    if (isPrimitive2(input)) {
      return input;
    }
    var hint = "default";
    if (arguments.length > 1) {
      if (arguments[1] === String) {
        hint = "string";
      } else if (arguments[1] === Number) {
        hint = "number";
      }
    }
    var exoticToPrim;
    if (hasSymbols2) {
      if (Symbol.toPrimitive) {
        exoticToPrim = GetMethod(
          /** @type {Record<PropertyKey, unknown>} */
          input,
          Symbol.toPrimitive
        );
      } else if (isSymbol2(input)) {
        exoticToPrim = Symbol.prototype.valueOf;
      }
    }
    if (typeof exoticToPrim !== "undefined") {
      var result = exoticToPrim.call(input, hint);
      if (isPrimitive2(result)) {
        return result;
      }
      throw new TypeError("unable to convert exotic object to primitive");
    }
    if (hint === "default" && (isDate2(input) || isSymbol2(input))) {
      hint = "string";
    }
    return ordinaryToPrimitive(
      /** @type {object} */
      input,
      hint === "default" ? "number" : hint
    );
  };
  return es2015;
}
var ToPrimitive;
var hasRequiredToPrimitive;
function requireToPrimitive() {
  if (hasRequiredToPrimitive) return ToPrimitive;
  hasRequiredToPrimitive = 1;
  var toPrimitive2 = requireEs2015();
  ToPrimitive = function ToPrimitive2(input) {
    if (arguments.length > 1) {
      return toPrimitive2(input, arguments[1]);
    }
    return toPrimitive2(input);
  };
  return ToPrimitive;
}
var ToString;
var hasRequiredToString;
function requireToString() {
  if (hasRequiredToString) return ToString;
  hasRequiredToString = 1;
  var GetIntrinsic3 = getIntrinsic;
  var $String = GetIntrinsic3("%String%");
  var $TypeError2 = type;
  ToString = function ToString2(argument) {
    if (typeof argument === "symbol") {
      throw new $TypeError2("Cannot convert a Symbol value to a string");
    }
    return $String(argument);
  };
  return ToString;
}
var implementation$9;
var hasRequiredImplementation$3;
function requireImplementation$3() {
  if (hasRequiredImplementation$3) return implementation$9;
  hasRequiredImplementation$3 = 1;
  var RequireObjectCoercible3 = RequireObjectCoercible$1;
  var ToString2 = requireToString();
  var callBound2 = callBound$2;
  var $replace2 = callBound2("String.prototype.replace");
  var mvsIsWS = /^\s$/.test("᠎");
  var leftWhitespace = mvsIsWS ? /^[\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF]+/ : /^[\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF]+/;
  var rightWhitespace = mvsIsWS ? /[\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF]+$/ : /[\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF]+$/;
  implementation$9 = function trim2() {
    var S2 = ToString2(RequireObjectCoercible3(this));
    return $replace2($replace2(S2, leftWhitespace, ""), rightWhitespace, "");
  };
  return implementation$9;
}
var polyfill$7;
var hasRequiredPolyfill$3;
function requirePolyfill$3() {
  if (hasRequiredPolyfill$3) return polyfill$7;
  hasRequiredPolyfill$3 = 1;
  var implementation2 = requireImplementation$3();
  var zeroWidthSpace = "​";
  var mongolianVowelSeparator = "᠎";
  polyfill$7 = function getPolyfill4() {
    if (String.prototype.trim && zeroWidthSpace.trim() === zeroWidthSpace && mongolianVowelSeparator.trim() === mongolianVowelSeparator && ("_" + mongolianVowelSeparator).trim() === "_" + mongolianVowelSeparator && (mongolianVowelSeparator + "_").trim() === mongolianVowelSeparator + "_") {
      return String.prototype.trim;
    }
    return implementation2;
  };
  return polyfill$7;
}
var shim$7;
var hasRequiredShim$4;
function requireShim$4() {
  if (hasRequiredShim$4) return shim$7;
  hasRequiredShim$4 = 1;
  var supportsDescriptors2 = hasPropertyDescriptors_1();
  var defineDataProperty3 = defineDataProperty$1;
  var getPolyfill4 = requirePolyfill$3();
  shim$7 = function shimStringTrim() {
    var polyfill2 = getPolyfill4();
    if (String.prototype.trim !== polyfill2) {
      if (supportsDescriptors2) {
        defineDataProperty3(String.prototype, "trim", polyfill2, true);
      } else {
        defineDataProperty3(String.prototype, "trim", polyfill2);
      }
    }
    return polyfill2;
  };
  return shim$7;
}
var string_prototype_trim;
var hasRequiredString_prototype_trim;
function requireString_prototype_trim() {
  if (hasRequiredString_prototype_trim) return string_prototype_trim;
  hasRequiredString_prototype_trim = 1;
  var callBind2 = callBindExports;
  var define2 = defineProperties_1;
  var RequireObjectCoercible3 = RequireObjectCoercible$1;
  var implementation2 = requireImplementation$3();
  var getPolyfill4 = requirePolyfill$3();
  var shim2 = requireShim$4();
  var bound = callBind2(getPolyfill4());
  var boundMethod = function trim2(receiver) {
    RequireObjectCoercible3(receiver);
    return bound(receiver);
  };
  define2(boundMethod, {
    getPolyfill: getPolyfill4,
    implementation: implementation2,
    shim: shim2
  });
  string_prototype_trim = boundMethod;
  return string_prototype_trim;
}
var StringToNumber;
var hasRequiredStringToNumber;
function requireStringToNumber() {
  if (hasRequiredStringToNumber) return StringToNumber;
  hasRequiredStringToNumber = 1;
  var GetIntrinsic3 = getIntrinsic;
  var $RegExp = GetIntrinsic3("%RegExp%");
  var $TypeError2 = type;
  var $parseInteger = GetIntrinsic3("%parseInt%");
  var callBound2 = callBound$2;
  var regexTester = requireSafeRegexTest();
  var $strSlice2 = callBound2("String.prototype.slice");
  var isBinary = regexTester(/^0b[01]+$/i);
  var isOctal = regexTester(/^0o[0-7]+$/i);
  var isInvalidHexLiteral = regexTester(/^[-+]0x[0-9a-f]+$/i);
  var nonWS = ["", "​", "￾"].join("");
  var nonWSregex = new $RegExp("[" + nonWS + "]", "g");
  var hasNonWS = regexTester(nonWSregex);
  var $trim = requireString_prototype_trim();
  StringToNumber = function StringToNumber2(argument) {
    if (typeof argument !== "string") {
      throw new $TypeError2("Assertion failed: `argument` is not a String");
    }
    if (isBinary(argument)) {
      return +$parseInteger($strSlice2(argument, 2), 2);
    }
    if (isOctal(argument)) {
      return +$parseInteger($strSlice2(argument, 2), 8);
    }
    if (hasNonWS(argument) || isInvalidHexLiteral(argument)) {
      return NaN;
    }
    var trimmed = $trim(argument);
    if (trimmed !== argument) {
      return StringToNumber2(trimmed);
    }
    return +argument;
  };
  return StringToNumber;
}
var ToNumber;
var hasRequiredToNumber;
function requireToNumber() {
  if (hasRequiredToNumber) return ToNumber;
  hasRequiredToNumber = 1;
  var GetIntrinsic3 = getIntrinsic;
  var $TypeError2 = type;
  var $Number = GetIntrinsic3("%Number%");
  var isPrimitive2 = requireIsPrimitive$1();
  var ToPrimitive2 = requireToPrimitive();
  var StringToNumber2 = requireStringToNumber();
  ToNumber = function ToNumber2(argument) {
    var value = isPrimitive2(argument) ? argument : ToPrimitive2(argument, $Number);
    if (typeof value === "symbol") {
      throw new $TypeError2("Cannot convert a Symbol value to a number");
    }
    if (typeof value === "bigint") {
      throw new $TypeError2("Conversion from 'BigInt' to 'number' is not allowed.");
    }
    if (typeof value === "string") {
      return StringToNumber2(value);
    }
    return +value;
  };
  return ToNumber;
}
var floor$2;
var hasRequiredFloor;
function requireFloor() {
  if (hasRequiredFloor) return floor$2;
  hasRequiredFloor = 1;
  var $floor2 = floor$4;
  floor$2 = function floor2(x2) {
    if (typeof x2 === "bigint") {
      return x2;
    }
    return $floor2(x2);
  };
  return floor$2;
}
var truncate;
var hasRequiredTruncate;
function requireTruncate() {
  if (hasRequiredTruncate) return truncate;
  hasRequiredTruncate = 1;
  var floor2 = requireFloor();
  var $TypeError2 = type;
  truncate = function truncate2(x2) {
    if (typeof x2 !== "number" && typeof x2 !== "bigint") {
      throw new $TypeError2("argument must be a Number or a BigInt");
    }
    var result = x2 < 0 ? -floor2(-x2) : floor2(x2);
    return result === 0 ? 0 : result;
  };
  return truncate;
}
var _isFinite;
var hasRequired_isFinite;
function require_isFinite() {
  if (hasRequired_isFinite) return _isFinite;
  hasRequired_isFinite = 1;
  var $isNaN2 = _isNaN$1;
  _isFinite = function isFinite2(x2) {
    return (typeof x2 === "number" || typeof x2 === "bigint") && !$isNaN2(x2) && x2 !== Infinity && x2 !== -Infinity;
  };
  return _isFinite;
}
var ToIntegerOrInfinity;
var hasRequiredToIntegerOrInfinity;
function requireToIntegerOrInfinity() {
  if (hasRequiredToIntegerOrInfinity) return ToIntegerOrInfinity;
  hasRequiredToIntegerOrInfinity = 1;
  var ToNumber2 = requireToNumber();
  var truncate2 = requireTruncate();
  var $isNaN2 = _isNaN$1;
  var $isFinite = require_isFinite();
  ToIntegerOrInfinity = function ToIntegerOrInfinity2(value) {
    var number = ToNumber2(value);
    if ($isNaN2(number) || number === 0) {
      return 0;
    }
    if (!$isFinite(number)) {
      return number;
    }
    return truncate2(number);
  };
  return ToIntegerOrInfinity;
}
var ToLength;
var hasRequiredToLength;
function requireToLength() {
  if (hasRequiredToLength) return ToLength;
  hasRequiredToLength = 1;
  var MAX_SAFE_INTEGER2 = requireMaxSafeInteger();
  var ToIntegerOrInfinity2 = requireToIntegerOrInfinity();
  ToLength = function ToLength2(argument) {
    var len = ToIntegerOrInfinity2(argument);
    if (len <= 0) {
      return 0;
    }
    if (len > MAX_SAFE_INTEGER2) {
      return MAX_SAFE_INTEGER2;
    }
    return len;
  };
  return ToLength;
}
var IsCallable;
var hasRequiredIsCallable;
function requireIsCallable() {
  if (hasRequiredIsCallable) return IsCallable;
  hasRequiredIsCallable = 1;
  IsCallable = requireIsCallable$1();
  return IsCallable;
}
var implementation$8;
var hasRequiredImplementation$2;
function requireImplementation$2() {
  if (hasRequiredImplementation$2) return implementation$8;
  hasRequiredImplementation$2 = 1;
  var ToObject2 = requireToObject();
  var ToLength2 = requireToLength();
  var IsCallable2 = requireIsCallable();
  implementation$8 = function find(predicate2) {
    var list = ToObject2(this);
    var length2 = ToLength2(list.length);
    if (!IsCallable2(predicate2)) {
      throw new TypeError("Array#find: predicate must be a function");
    }
    if (length2 === 0) {
      return void 0;
    }
    var thisArg;
    if (arguments.length > 0) {
      thisArg = arguments[1];
    }
    for (var i = 0, value; i < length2; i++) {
      value = list[i];
      if (predicate2.apply(thisArg, [value, i, list])) {
        return value;
      }
    }
    return void 0;
  };
  return implementation$8;
}
var polyfill$6;
var hasRequiredPolyfill$2;
function requirePolyfill$2() {
  if (hasRequiredPolyfill$2) return polyfill$6;
  hasRequiredPolyfill$2 = 1;
  polyfill$6 = function getPolyfill4() {
    var implemented = Array.prototype.find && [, 1].find(function() {
      return true;
    }) !== 1;
    return implemented ? Array.prototype.find : requireImplementation$2();
  };
  return polyfill$6;
}
var esShimUnscopables;
var hasRequiredEsShimUnscopables;
function requireEsShimUnscopables() {
  if (hasRequiredEsShimUnscopables) return esShimUnscopables;
  hasRequiredEsShimUnscopables = 1;
  var hasOwn2 = requireHasown();
  var hasUnscopables = typeof Symbol === "function" && typeof Symbol.unscopables === "symbol";
  var map = hasUnscopables && Array.prototype[Symbol.unscopables];
  var $TypeError2 = TypeError;
  esShimUnscopables = function shimUnscopables(method) {
    if (typeof method !== "string" || !method) {
      throw new $TypeError2("method must be a non-empty string");
    }
    if (!hasOwn2(Array.prototype, method)) {
      throw new $TypeError2("method must be on Array.prototype");
    }
    if (hasUnscopables && map) {
      map[method] = true;
    }
  };
  return esShimUnscopables;
}
var shim$6;
var hasRequiredShim$3;
function requireShim$3() {
  if (hasRequiredShim$3) return shim$6;
  hasRequiredShim$3 = 1;
  var define2 = defineProperties_1;
  var shimUnscopables = requireEsShimUnscopables();
  var getPolyfill4 = requirePolyfill$2();
  shim$6 = function shimArrayPrototypeFind() {
    var polyfill2 = getPolyfill4();
    define2(
      Array.prototype,
      { find: polyfill2 },
      {
        find: function() {
          return Array.prototype.find !== polyfill2;
        }
      }
    );
    shimUnscopables("find");
    return polyfill2;
  };
  return shim$6;
}
var array_prototype_find;
var hasRequiredArray_prototype_find;
function requireArray_prototype_find() {
  if (hasRequiredArray_prototype_find) return array_prototype_find;
  hasRequiredArray_prototype_find = 1;
  var define2 = defineProperties_1;
  var callBound2 = requireCallBound();
  var RequireObjectCoercible3 = RequireObjectCoercible$1;
  var implementation2 = requireImplementation$2();
  var getPolyfill4 = requirePolyfill$2();
  var shim2 = requireShim$3();
  var $slice = callBound2("Array.prototype.slice");
  var polyfill2 = getPolyfill4();
  var boundFindShim = function find(array, predicate2) {
    RequireObjectCoercible3(array);
    var args = $slice(arguments, 1);
    return polyfill2.apply(array, args);
  };
  define2(boundFindShim, {
    getPolyfill: getPolyfill4,
    implementation: implementation2,
    shim: shim2
  });
  array_prototype_find = boundFindShim;
  return array_prototype_find;
}
var getComponentName = {};
var functionsHaveNames_1;
var hasRequiredFunctionsHaveNames;
function requireFunctionsHaveNames() {
  if (hasRequiredFunctionsHaveNames) return functionsHaveNames_1;
  hasRequiredFunctionsHaveNames = 1;
  var functionsHaveNames = function functionsHaveNames2() {
    return typeof (function f2() {
    }).name === "string";
  };
  var gOPD2 = Object.getOwnPropertyDescriptor;
  if (gOPD2) {
    try {
      gOPD2([], "length");
    } catch (e3) {
      gOPD2 = null;
    }
  }
  functionsHaveNames.functionsHaveConfigurableNames = function functionsHaveConfigurableNames() {
    if (!functionsHaveNames() || !gOPD2) {
      return false;
    }
    var desc = gOPD2(function() {
    }, "name");
    return !!desc && !!desc.configurable;
  };
  var $bind = Function.prototype.bind;
  functionsHaveNames.boundFunctionsHaveNames = function boundFunctionsHaveNames() {
    return functionsHaveNames() && typeof $bind === "function" && (function f2() {
    }).bind().name !== "";
  };
  functionsHaveNames_1 = functionsHaveNames;
  return functionsHaveNames_1;
}
var implementation$7;
var hasRequiredImplementation$1;
function requireImplementation$1() {
  if (hasRequiredImplementation$1) return implementation$7;
  hasRequiredImplementation$1 = 1;
  var IsCallable2 = requireIsCallable$1();
  var hasOwn2 = requireHasown();
  var functionsHaveNames = requireFunctionsHaveNames()();
  var callBound2 = callBound$2;
  var $functionToString = callBound2("Function.prototype.toString");
  var $stringMatch = callBound2("String.prototype.match");
  var toStr2 = callBound2("Object.prototype.toString");
  var classRegex = /^class /;
  var isClass = function isClassConstructor(fn2) {
    if (IsCallable2(fn2)) {
      return false;
    }
    if (typeof fn2 !== "function") {
      return false;
    }
    try {
      var match2 = $stringMatch($functionToString(fn2), classRegex);
      return !!match2;
    } catch (e3) {
    }
    return false;
  };
  var regex = /\s*function\s+([^(\s]*)\s*/;
  var isIE68 = !(0 in [,]);
  var objectClass = "[object Object]";
  var ddaClass = "[object HTMLAllCollection]";
  var functionProto = Function.prototype;
  var isDDA = function isDocumentDotAll() {
    return false;
  };
  if (typeof document === "object") {
    var all = document.all;
    if (toStr2(all) === toStr2(document.all)) {
      isDDA = function isDocumentDotAll(value) {
        if ((isIE68 || !value) && (typeof value === "undefined" || typeof value === "object")) {
          try {
            var str = toStr2(value);
            return (str === ddaClass || str === objectClass) && value("") == null;
          } catch (e3) {
          }
        }
        return false;
      };
    }
  }
  implementation$7 = function getName() {
    if (isDDA(this) || !isClass(this) && !IsCallable2(this)) {
      throw new TypeError("Function.prototype.name sham getter called on non-function");
    }
    if (functionsHaveNames && hasOwn2(this, "name")) {
      return this.name;
    }
    if (this === functionProto) {
      return "";
    }
    var str = $functionToString(this);
    var match2 = $stringMatch(str, regex);
    var name = match2 && match2[1];
    return name;
  };
  return implementation$7;
}
var polyfill$5;
var hasRequiredPolyfill$1;
function requirePolyfill$1() {
  if (hasRequiredPolyfill$1) return polyfill$5;
  hasRequiredPolyfill$1 = 1;
  var implementation2 = requireImplementation$1();
  polyfill$5 = function getPolyfill4() {
    return implementation2;
  };
  return polyfill$5;
}
var shim$5;
var hasRequiredShim$2;
function requireShim$2() {
  if (hasRequiredShim$2) return shim$5;
  hasRequiredShim$2 = 1;
  var supportsDescriptors2 = defineProperties_1.supportsDescriptors;
  var functionsHaveNames = requireFunctionsHaveNames()();
  var getPolyfill4 = requirePolyfill$1();
  var defineProperty2 = Object.defineProperty;
  var TypeErr = TypeError;
  shim$5 = function shimName() {
    var polyfill2 = getPolyfill4();
    if (functionsHaveNames) {
      return polyfill2;
    }
    if (!supportsDescriptors2) {
      throw new TypeErr("Shimming Function.prototype.name support requires ES5 property descriptor support.");
    }
    var functionProto = Function.prototype;
    defineProperty2(functionProto, "name", {
      configurable: true,
      enumerable: false,
      get: function() {
        var name = polyfill2.call(this);
        if (this !== functionProto) {
          defineProperty2(this, "name", {
            configurable: true,
            enumerable: false,
            value: name,
            writable: false
          });
        }
        return name;
      }
    });
    return polyfill2;
  };
  return shim$5;
}
var function_prototype_name;
var hasRequiredFunction_prototype_name;
function requireFunction_prototype_name() {
  if (hasRequiredFunction_prototype_name) return function_prototype_name;
  hasRequiredFunction_prototype_name = 1;
  var define2 = defineProperties_1;
  var callBind2 = callBindExports;
  var implementation2 = requireImplementation$1();
  var getPolyfill4 = requirePolyfill$1();
  var shim2 = requireShim$2();
  var bound = callBind2(implementation2);
  define2(bound, {
    getPolyfill: getPolyfill4,
    implementation: implementation2,
    shim: shim2
  });
  function_prototype_name = bound;
  return function_prototype_name;
}
var reactIs$2 = { exports: {} };
var reactIs_production_min$2 = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactIs_production_min$2;
function requireReactIs_production_min$2() {
  if (hasRequiredReactIs_production_min$2) return reactIs_production_min$2;
  hasRequiredReactIs_production_min$2 = 1;
  var b2 = "function" === typeof Symbol && Symbol.for, c2 = b2 ? Symbol.for("react.element") : 60103, d2 = b2 ? Symbol.for("react.portal") : 60106, e3 = b2 ? Symbol.for("react.fragment") : 60107, f2 = b2 ? Symbol.for("react.strict_mode") : 60108, g3 = b2 ? Symbol.for("react.profiler") : 60114, h2 = b2 ? Symbol.for("react.provider") : 60109, k2 = b2 ? Symbol.for("react.context") : 60110, l2 = b2 ? Symbol.for("react.async_mode") : 60111, m2 = b2 ? Symbol.for("react.concurrent_mode") : 60111, n2 = b2 ? Symbol.for("react.forward_ref") : 60112, p2 = b2 ? Symbol.for("react.suspense") : 60113, q2 = b2 ? Symbol.for("react.suspense_list") : 60120, r2 = b2 ? Symbol.for("react.memo") : 60115, t2 = b2 ? Symbol.for("react.lazy") : 60116, v2 = b2 ? Symbol.for("react.block") : 60121, w3 = b2 ? Symbol.for("react.fundamental") : 60117, x2 = b2 ? Symbol.for("react.responder") : 60118, y2 = b2 ? Symbol.for("react.scope") : 60119;
  function z3(a2) {
    if ("object" === typeof a2 && null !== a2) {
      var u2 = a2.$$typeof;
      switch (u2) {
        case c2:
          switch (a2 = a2.type, a2) {
            case l2:
            case m2:
            case e3:
            case g3:
            case f2:
            case p2:
              return a2;
            default:
              switch (a2 = a2 && a2.$$typeof, a2) {
                case k2:
                case n2:
                case t2:
                case r2:
                case h2:
                  return a2;
                default:
                  return u2;
              }
          }
        case d2:
          return u2;
      }
    }
  }
  function A3(a2) {
    return z3(a2) === m2;
  }
  reactIs_production_min$2.AsyncMode = l2;
  reactIs_production_min$2.ConcurrentMode = m2;
  reactIs_production_min$2.ContextConsumer = k2;
  reactIs_production_min$2.ContextProvider = h2;
  reactIs_production_min$2.Element = c2;
  reactIs_production_min$2.ForwardRef = n2;
  reactIs_production_min$2.Fragment = e3;
  reactIs_production_min$2.Lazy = t2;
  reactIs_production_min$2.Memo = r2;
  reactIs_production_min$2.Portal = d2;
  reactIs_production_min$2.Profiler = g3;
  reactIs_production_min$2.StrictMode = f2;
  reactIs_production_min$2.Suspense = p2;
  reactIs_production_min$2.isAsyncMode = function(a2) {
    return A3(a2) || z3(a2) === l2;
  };
  reactIs_production_min$2.isConcurrentMode = A3;
  reactIs_production_min$2.isContextConsumer = function(a2) {
    return z3(a2) === k2;
  };
  reactIs_production_min$2.isContextProvider = function(a2) {
    return z3(a2) === h2;
  };
  reactIs_production_min$2.isElement = function(a2) {
    return "object" === typeof a2 && null !== a2 && a2.$$typeof === c2;
  };
  reactIs_production_min$2.isForwardRef = function(a2) {
    return z3(a2) === n2;
  };
  reactIs_production_min$2.isFragment = function(a2) {
    return z3(a2) === e3;
  };
  reactIs_production_min$2.isLazy = function(a2) {
    return z3(a2) === t2;
  };
  reactIs_production_min$2.isMemo = function(a2) {
    return z3(a2) === r2;
  };
  reactIs_production_min$2.isPortal = function(a2) {
    return z3(a2) === d2;
  };
  reactIs_production_min$2.isProfiler = function(a2) {
    return z3(a2) === g3;
  };
  reactIs_production_min$2.isStrictMode = function(a2) {
    return z3(a2) === f2;
  };
  reactIs_production_min$2.isSuspense = function(a2) {
    return z3(a2) === p2;
  };
  reactIs_production_min$2.isValidElementType = function(a2) {
    return "string" === typeof a2 || "function" === typeof a2 || a2 === e3 || a2 === m2 || a2 === g3 || a2 === f2 || a2 === p2 || a2 === q2 || "object" === typeof a2 && null !== a2 && (a2.$$typeof === t2 || a2.$$typeof === r2 || a2.$$typeof === h2 || a2.$$typeof === k2 || a2.$$typeof === n2 || a2.$$typeof === w3 || a2.$$typeof === x2 || a2.$$typeof === y2 || a2.$$typeof === v2);
  };
  reactIs_production_min$2.typeOf = z3;
  return reactIs_production_min$2;
}
var reactIs_development$2 = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactIs_development$2;
function requireReactIs_development$2() {
  if (hasRequiredReactIs_development$2) return reactIs_development$2;
  hasRequiredReactIs_development$2 = 1;
  if (process.env.NODE_ENV !== "production") {
    (function() {
      var hasSymbol = typeof Symbol === "function" && Symbol.for;
      var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for("react.element") : 60103;
      var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for("react.portal") : 60106;
      var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for("react.fragment") : 60107;
      var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for("react.strict_mode") : 60108;
      var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for("react.profiler") : 60114;
      var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for("react.provider") : 60109;
      var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for("react.context") : 60110;
      var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for("react.async_mode") : 60111;
      var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for("react.concurrent_mode") : 60111;
      var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for("react.forward_ref") : 60112;
      var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for("react.suspense") : 60113;
      var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for("react.suspense_list") : 60120;
      var REACT_MEMO_TYPE = hasSymbol ? Symbol.for("react.memo") : 60115;
      var REACT_LAZY_TYPE = hasSymbol ? Symbol.for("react.lazy") : 60116;
      var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for("react.block") : 60121;
      var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for("react.fundamental") : 60117;
      var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for("react.responder") : 60118;
      var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for("react.scope") : 60119;
      function isValidElementType(type2) {
        return typeof type2 === "string" || typeof type2 === "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
        type2 === REACT_FRAGMENT_TYPE || type2 === REACT_CONCURRENT_MODE_TYPE || type2 === REACT_PROFILER_TYPE || type2 === REACT_STRICT_MODE_TYPE || type2 === REACT_SUSPENSE_TYPE || type2 === REACT_SUSPENSE_LIST_TYPE || typeof type2 === "object" && type2 !== null && (type2.$$typeof === REACT_LAZY_TYPE || type2.$$typeof === REACT_MEMO_TYPE || type2.$$typeof === REACT_PROVIDER_TYPE || type2.$$typeof === REACT_CONTEXT_TYPE || type2.$$typeof === REACT_FORWARD_REF_TYPE || type2.$$typeof === REACT_FUNDAMENTAL_TYPE || type2.$$typeof === REACT_RESPONDER_TYPE || type2.$$typeof === REACT_SCOPE_TYPE || type2.$$typeof === REACT_BLOCK_TYPE);
      }
      function typeOf2(object2) {
        if (typeof object2 === "object" && object2 !== null) {
          var $$typeof = object2.$$typeof;
          switch ($$typeof) {
            case REACT_ELEMENT_TYPE:
              var type2 = object2.type;
              switch (type2) {
                case REACT_ASYNC_MODE_TYPE:
                case REACT_CONCURRENT_MODE_TYPE:
                case REACT_FRAGMENT_TYPE:
                case REACT_PROFILER_TYPE:
                case REACT_STRICT_MODE_TYPE:
                case REACT_SUSPENSE_TYPE:
                  return type2;
                default:
                  var $$typeofType = type2 && type2.$$typeof;
                  switch ($$typeofType) {
                    case REACT_CONTEXT_TYPE:
                    case REACT_FORWARD_REF_TYPE:
                    case REACT_LAZY_TYPE:
                    case REACT_MEMO_TYPE:
                    case REACT_PROVIDER_TYPE:
                      return $$typeofType;
                    default:
                      return $$typeof;
                  }
              }
            case REACT_PORTAL_TYPE:
              return $$typeof;
          }
        }
        return void 0;
      }
      var AsyncMode = REACT_ASYNC_MODE_TYPE;
      var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
      var ContextConsumer = REACT_CONTEXT_TYPE;
      var ContextProvider = REACT_PROVIDER_TYPE;
      var Element2 = REACT_ELEMENT_TYPE;
      var ForwardRef = REACT_FORWARD_REF_TYPE;
      var Fragment2 = REACT_FRAGMENT_TYPE;
      var Lazy = REACT_LAZY_TYPE;
      var Memo = REACT_MEMO_TYPE;
      var Portal2 = REACT_PORTAL_TYPE;
      var Profiler = REACT_PROFILER_TYPE;
      var StrictMode = REACT_STRICT_MODE_TYPE;
      var Suspense = REACT_SUSPENSE_TYPE;
      var hasWarnedAboutDeprecatedIsAsyncMode = false;
      function isAsyncMode(object2) {
        {
          if (!hasWarnedAboutDeprecatedIsAsyncMode) {
            hasWarnedAboutDeprecatedIsAsyncMode = true;
            console["warn"]("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.");
          }
        }
        return isConcurrentMode(object2) || typeOf2(object2) === REACT_ASYNC_MODE_TYPE;
      }
      function isConcurrentMode(object2) {
        return typeOf2(object2) === REACT_CONCURRENT_MODE_TYPE;
      }
      function isContextConsumer(object2) {
        return typeOf2(object2) === REACT_CONTEXT_TYPE;
      }
      function isContextProvider(object2) {
        return typeOf2(object2) === REACT_PROVIDER_TYPE;
      }
      function isElement2(object2) {
        return typeof object2 === "object" && object2 !== null && object2.$$typeof === REACT_ELEMENT_TYPE;
      }
      function isForwardRef(object2) {
        return typeOf2(object2) === REACT_FORWARD_REF_TYPE;
      }
      function isFragment(object2) {
        return typeOf2(object2) === REACT_FRAGMENT_TYPE;
      }
      function isLazy(object2) {
        return typeOf2(object2) === REACT_LAZY_TYPE;
      }
      function isMemo(object2) {
        return typeOf2(object2) === REACT_MEMO_TYPE;
      }
      function isPortal(object2) {
        return typeOf2(object2) === REACT_PORTAL_TYPE;
      }
      function isProfiler(object2) {
        return typeOf2(object2) === REACT_PROFILER_TYPE;
      }
      function isStrictMode(object2) {
        return typeOf2(object2) === REACT_STRICT_MODE_TYPE;
      }
      function isSuspense(object2) {
        return typeOf2(object2) === REACT_SUSPENSE_TYPE;
      }
      reactIs_development$2.AsyncMode = AsyncMode;
      reactIs_development$2.ConcurrentMode = ConcurrentMode;
      reactIs_development$2.ContextConsumer = ContextConsumer;
      reactIs_development$2.ContextProvider = ContextProvider;
      reactIs_development$2.Element = Element2;
      reactIs_development$2.ForwardRef = ForwardRef;
      reactIs_development$2.Fragment = Fragment2;
      reactIs_development$2.Lazy = Lazy;
      reactIs_development$2.Memo = Memo;
      reactIs_development$2.Portal = Portal2;
      reactIs_development$2.Profiler = Profiler;
      reactIs_development$2.StrictMode = StrictMode;
      reactIs_development$2.Suspense = Suspense;
      reactIs_development$2.isAsyncMode = isAsyncMode;
      reactIs_development$2.isConcurrentMode = isConcurrentMode;
      reactIs_development$2.isContextConsumer = isContextConsumer;
      reactIs_development$2.isContextProvider = isContextProvider;
      reactIs_development$2.isElement = isElement2;
      reactIs_development$2.isForwardRef = isForwardRef;
      reactIs_development$2.isFragment = isFragment;
      reactIs_development$2.isLazy = isLazy;
      reactIs_development$2.isMemo = isMemo;
      reactIs_development$2.isPortal = isPortal;
      reactIs_development$2.isProfiler = isProfiler;
      reactIs_development$2.isStrictMode = isStrictMode;
      reactIs_development$2.isSuspense = isSuspense;
      reactIs_development$2.isValidElementType = isValidElementType;
      reactIs_development$2.typeOf = typeOf2;
    })();
  }
  return reactIs_development$2;
}
var hasRequiredReactIs;
function requireReactIs() {
  if (hasRequiredReactIs) return reactIs$2.exports;
  hasRequiredReactIs = 1;
  if (process.env.NODE_ENV === "production") {
    reactIs$2.exports = requireReactIs_production_min$2();
  } else {
    reactIs$2.exports = requireReactIs_development$2();
  }
  return reactIs$2.exports;
}
var hasRequiredGetComponentName;
function requireGetComponentName() {
  if (hasRequiredGetComponentName) return getComponentName;
  hasRequiredGetComponentName = 1;
  (function(exports$1) {
    Object.defineProperty(exports$1, "__esModule", {
      value: true
    });
    exports$1["default"] = getComponentName2;
    var _functionPrototype = _interopRequireDefault(requireFunction_prototype_name());
    var _reactIs = requireReactIs();
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : { "default": obj };
    }
    function getComponentName2(Component2) {
      if (typeof Component2 === "string") {
        return Component2;
      }
      if (typeof Component2 === "function") {
        return Component2.displayName || (0, _functionPrototype["default"])(Component2);
      }
      if ((0, _reactIs.isForwardRef)({
        type: Component2,
        $$typeof: _reactIs.Element
      })) {
        return Component2.displayName;
      }
      if ((0, _reactIs.isMemo)(Component2)) {
        return getComponentName2(Component2.type);
      }
      return null;
    }
  })(getComponentName);
  return getComponentName;
}
var hasRequiredChildrenOfType;
function requireChildrenOfType() {
  if (hasRequiredChildrenOfType) return childrenOfType;
  hasRequiredChildrenOfType = 1;
  (function(exports$1) {
    Object.defineProperty(exports$1, "__esModule", {
      value: true
    });
    exports$1["default"] = void 0;
    var _arrayPrototype = _interopRequireDefault(requireArray_prototype_find());
    var _getComponentName = _interopRequireDefault(requireGetComponentName());
    var _renderableChildren = _interopRequireDefault(requireRenderableChildren());
    var _wrapValidator = _interopRequireDefault(requireWrapValidator());
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : { "default": obj };
    }
    function onlyTypes(types, children, componentName) {
      if (!children.every(function(child) {
        return child && (0, _arrayPrototype["default"])(types, function(Type) {
          return Type === "*" || child.type === Type;
        });
      })) {
        var typeNames = types.map(_getComponentName["default"]).join(", or ");
        return new TypeError("`".concat(componentName, "` only accepts children of type ").concat(typeNames));
      }
      return null;
    }
    function isRequired(types, children, componentName) {
      if (children.length === 0) {
        var typeNames = types.map(_getComponentName["default"]).join(", or ");
        return new TypeError("`".concat(componentName, "` requires at least one node of type ").concat(typeNames));
      }
      return null;
    }
    function childrenOfType2() {
      for (var _len = arguments.length, types = new Array(_len), _key = 0; _key < _len; _key++) {
        types[_key] = arguments[_key];
      }
      if (types.length < 1) {
        throw new TypeError("childrenOfType: at least 1 type is required");
      }
      function validator(props, propName, componentName) {
        return onlyTypes(types, (0, _renderableChildren["default"])(props[propName]), componentName);
      }
      validator.isRequired = function(props, propName, componentName) {
        var children = (0, _renderableChildren["default"])(props[propName]);
        return isRequired(types, children, componentName) || onlyTypes(types, children, componentName);
      };
      return (0, _wrapValidator["default"])(validator, "childrenOfType", types);
    }
    var _default2 = childrenOfType2;
    exports$1["default"] = _default2;
  })(childrenOfType);
  return childrenOfType;
}
var childrenSequenceOf = {};
var sequenceOf = {};
var nonNegativeInteger = {};
var integer = {};
var isInteger = {};
var hasRequiredIsInteger;
function requireIsInteger() {
  if (hasRequiredIsInteger) return isInteger;
  hasRequiredIsInteger = 1;
  (function(exports$1) {
    Object.defineProperty(exports$1, "__esModule", {
      value: true
    });
    exports$1["default"] = void 0;
    var floor2 = Math.floor;
    var finite = isFinite;
    var _default2 = Number.isInteger || /* istanbul ignore next */
    function(x2) {
      return typeof x2 === "number" && finite(x2) && floor2(x2) === x2;
    };
    exports$1["default"] = _default2;
  })(isInteger);
  return isInteger;
}
var hasRequiredInteger;
function requireInteger() {
  if (hasRequiredInteger) return integer;
  hasRequiredInteger = 1;
  (function(exports$1) {
    Object.defineProperty(exports$1, "__esModule", {
      value: true
    });
    exports$1["default"] = void 0;
    var _isInteger = _interopRequireDefault(requireIsInteger());
    var _wrapValidator = _interopRequireDefault(requireWrapValidator());
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : { "default": obj };
    }
    function requiredInteger(props, propName, componentName) {
      var propValue = props[propName];
      if (propValue == null || !(0, _isInteger["default"])(propValue)) {
        return new RangeError("".concat(propName, " in ").concat(componentName, " must be an integer"));
      }
      return null;
    }
    var validator = function integer2(props, propName) {
      var propValue = props[propName];
      if (propValue == null) {
        return null;
      }
      for (var _len = arguments.length, rest = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
        rest[_key - 2] = arguments[_key];
      }
      return requiredInteger.apply(void 0, [props, propName].concat(rest));
    };
    validator.isRequired = requiredInteger;
    var _default2 = function _default3() {
      return (0, _wrapValidator["default"])(validator, "integer");
    };
    exports$1["default"] = _default2;
  })(integer);
  return integer;
}
var nonNegativeNumber = {};
var implementation$6;
var hasRequiredImplementation;
function requireImplementation() {
  if (hasRequiredImplementation) return implementation$6;
  hasRequiredImplementation = 1;
  var numberIsNaN = function(value) {
    return value !== value;
  };
  implementation$6 = function is(a2, b2) {
    if (a2 === 0 && b2 === 0) {
      return 1 / a2 === 1 / b2;
    }
    if (a2 === b2) {
      return true;
    }
    if (numberIsNaN(a2) && numberIsNaN(b2)) {
      return true;
    }
    return false;
  };
  return implementation$6;
}
var polyfill$4;
var hasRequiredPolyfill;
function requirePolyfill() {
  if (hasRequiredPolyfill) return polyfill$4;
  hasRequiredPolyfill = 1;
  var implementation2 = requireImplementation();
  polyfill$4 = function getPolyfill4() {
    return typeof Object.is === "function" ? Object.is : implementation2;
  };
  return polyfill$4;
}
var shim$4;
var hasRequiredShim$1;
function requireShim$1() {
  if (hasRequiredShim$1) return shim$4;
  hasRequiredShim$1 = 1;
  var getPolyfill4 = requirePolyfill();
  var define2 = defineProperties_1;
  shim$4 = function shimObjectIs() {
    var polyfill2 = getPolyfill4();
    define2(Object, { is: polyfill2 }, {
      is: function testObjectIs() {
        return Object.is !== polyfill2;
      }
    });
    return polyfill2;
  };
  return shim$4;
}
var objectIs;
var hasRequiredObjectIs;
function requireObjectIs() {
  if (hasRequiredObjectIs) return objectIs;
  hasRequiredObjectIs = 1;
  var define2 = defineProperties_1;
  var callBind2 = callBindExports;
  var implementation2 = requireImplementation();
  var getPolyfill4 = requirePolyfill();
  var shim2 = requireShim$1();
  var polyfill2 = callBind2(getPolyfill4(), Object);
  define2(polyfill2, {
    getPolyfill: getPolyfill4,
    implementation: implementation2,
    shim: shim2
  });
  objectIs = polyfill2;
  return objectIs;
}
var hasRequiredNonNegativeNumber;
function requireNonNegativeNumber() {
  if (hasRequiredNonNegativeNumber) return nonNegativeNumber;
  hasRequiredNonNegativeNumber = 1;
  (function(exports$1) {
    Object.defineProperty(exports$1, "__esModule", {
      value: true
    });
    exports$1["default"] = void 0;
    var _objectIs = _interopRequireDefault(requireObjectIs());
    var _wrapValidator = _interopRequireDefault(requireWrapValidator());
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : { "default": obj };
    }
    function isNonNegative(x2) {
      return typeof x2 === "number" && isFinite(x2) && x2 >= 0 && !(0, _objectIs["default"])(x2, -0);
    }
    function nonNegativeNumber2(props, propName, componentName) {
      var value = props[propName];
      if (value == null || isNonNegative(value)) {
        return null;
      }
      return new RangeError("".concat(propName, " in ").concat(componentName, " must be a non-negative number"));
    }
    function requiredNonNegativeNumber(props, propName, componentName) {
      var value = props[propName];
      if (isNonNegative(value)) {
        return null;
      }
      return new RangeError("".concat(propName, " in ").concat(componentName, " must be a non-negative number"));
    }
    nonNegativeNumber2.isRequired = requiredNonNegativeNumber;
    var _default2 = function _default3() {
      return (0, _wrapValidator["default"])(nonNegativeNumber2, "nonNegativeNumber");
    };
    exports$1["default"] = _default2;
  })(nonNegativeNumber);
  return nonNegativeNumber;
}
var hasRequiredNonNegativeInteger;
function requireNonNegativeInteger() {
  if (hasRequiredNonNegativeInteger) return nonNegativeInteger;
  hasRequiredNonNegativeInteger = 1;
  (function(exports$1) {
    Object.defineProperty(exports$1, "__esModule", {
      value: true
    });
    exports$1["default"] = void 0;
    var _and = _interopRequireDefault(requireAnd());
    var _integer = _interopRequireDefault(requireInteger());
    var _nonNegativeNumber = _interopRequireDefault(requireNonNegativeNumber());
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : { "default": obj };
    }
    var _default2 = (0, _and["default"])([(0, _integer["default"])(), (0, _nonNegativeNumber["default"])()], "nonNegativeInteger");
    exports$1["default"] = _default2;
  })(nonNegativeInteger);
  return nonNegativeInteger;
}
var object = {};
var typeOf = {};
var hasRequiredTypeOf;
function requireTypeOf() {
  if (hasRequiredTypeOf) return typeOf;
  hasRequiredTypeOf = 1;
  (function(exports$1) {
    Object.defineProperty(exports$1, "__esModule", {
      value: true
    });
    exports$1["default"] = typeOf2;
    var _react = _interopRequireDefault(React__default);
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : { "default": obj };
    }
    function _typeof2(obj) {
      "@babel/helpers - typeof";
      if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
        _typeof2 = function _typeof3(obj2) {
          return typeof obj2;
        };
      } else {
        _typeof2 = function _typeof3(obj2) {
          return obj2 && typeof Symbol === "function" && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
        };
      }
      return _typeof2(obj);
    }
    function typeOf2(child) {
      if (child === null) {
        return "null";
      }
      if (Array.isArray(child)) {
        return "array";
      }
      if (_typeof2(child) !== "object") {
        return _typeof2(child);
      }
      if (/* @__PURE__ */ _react["default"].isValidElement(child)) {
        return child.type;
      }
      return child;
    }
  })(typeOf);
  return typeOf;
}
var hasRequiredObject;
function requireObject() {
  if (hasRequiredObject) return object;
  hasRequiredObject = 1;
  (function(exports$1) {
    Object.defineProperty(exports$1, "__esModule", {
      value: true
    });
    exports$1["default"] = void 0;
    var _isPlainObject = _interopRequireDefault(requireIsPlainObject());
    var _typeOf = _interopRequireDefault(requireTypeOf());
    var _wrapValidator = _interopRequireDefault(requireWrapValidator());
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : { "default": obj };
    }
    var ReactPropTypeLocationNames = {
      prop: "prop",
      context: "context",
      childContext: "child context"
    };
    function object2(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (propValue == null) {
        return null;
      }
      if ((0, _isPlainObject["default"])(propValue)) {
        return null;
      }
      var locationName = ReactPropTypeLocationNames[location] || location;
      return new TypeError("Invalid ".concat(locationName, " `").concat(propFullName, "` of type `").concat((0, _typeOf["default"])(propValue), "` supplied to `").concat(componentName, "`, expected `object`."));
    }
    object2.isRequired = function objectRequired(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (propValue == null) {
        var locationName = ReactPropTypeLocationNames[location] || location;
        return new TypeError("The ".concat(locationName, " `").concat(propFullName, "` is marked as required in `").concat(componentName, "`, but its value is `").concat(propValue, "`."));
      }
      for (var _len = arguments.length, rest = new Array(_len > 5 ? _len - 5 : 0), _key = 5; _key < _len; _key++) {
        rest[_key - 5] = arguments[_key];
      }
      return object2.apply(void 0, [props, propName, componentName, location, propFullName].concat(rest));
    };
    var _default2 = function _default3() {
      return (0, _wrapValidator["default"])(object2, "object");
    };
    exports$1["default"] = _default2;
  })(object);
  return object;
}
var withShape = {};
var hasRequiredWithShape;
function requireWithShape() {
  if (hasRequiredWithShape) return withShape;
  hasRequiredWithShape = 1;
  (function(exports$1) {
    Object.defineProperty(exports$1, "__esModule", {
      value: true
    });
    exports$1["default"] = withShape2;
    var _and = _interopRequireDefault(requireAnd());
    var _shape = _interopRequireDefault(requireShape());
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : { "default": obj };
    }
    function withShape2(type2, shapeTypes) {
      if (typeof type2 !== "function") {
        throw new TypeError("type must be a valid PropType");
      }
      var shapeValidator = (0, _shape["default"])(shapeTypes);
      return (0, _and["default"])([type2, shapeValidator], "withShape");
    }
  })(withShape);
  return withShape;
}
var hasRequiredSequenceOf;
function requireSequenceOf() {
  if (hasRequiredSequenceOf) return sequenceOf;
  hasRequiredSequenceOf = 1;
  (function(exports$1) {
    Object.defineProperty(exports$1, "__esModule", {
      value: true
    });
    exports$1["default"] = sequenceOfValidator;
    var _propTypes = propTypesExports;
    var _and = _interopRequireDefault(requireAnd());
    var _between = _interopRequireDefault(requireBetween());
    var _nonNegativeInteger = _interopRequireDefault(requireNonNegativeInteger());
    var _object = _interopRequireDefault(requireObject());
    var _withShape = _interopRequireDefault(requireWithShape());
    var _typeOf = _interopRequireDefault(requireTypeOf());
    var _wrapValidator = _interopRequireDefault(requireWrapValidator());
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : { "default": obj };
    }
    function ownKeys2(object2, enumerableOnly) {
      var keys3 = Object.keys(object2);
      if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object2);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
          return Object.getOwnPropertyDescriptor(object2, sym).enumerable;
        });
        keys3.push.apply(keys3, symbols);
      }
      return keys3;
    }
    function _objectSpread3(target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) {
          ownKeys2(Object(source), true).forEach(function(key) {
            _defineProperty2(target, key, source[key]);
          });
        } else if (Object.getOwnPropertyDescriptors) {
          Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        } else {
          ownKeys2(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
          });
        }
      }
      return target;
    }
    function _defineProperty2(obj, key, value) {
      if (key in obj) {
        Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
      } else {
        obj[key] = value;
      }
      return obj;
    }
    var minValidator = _nonNegativeInteger["default"];
    var maxValidator = (0, _and["default"])([_nonNegativeInteger["default"], (0, _between["default"])({
      gte: 1
    })]);
    function validateRange(min2, max2) {
      if (typeof max2 !== "number" || typeof min2 !== "number") {
        return null;
      }
      if (min2 <= max2) {
        return null;
      }
      return new RangeError("min must be less than or equal to max");
    }
    var specifierShape = {
      validator: function validator(props, propName) {
        var propValue = props[propName];
        if (typeof propValue !== "function") {
          return new TypeError('"validator" must be a propType validator function');
        }
        return null;
      },
      min: function min2(props, propName) {
        return minValidator(props, propName) || validateRange(props.min, props.max);
      },
      max: function max2(props, propName) {
        return maxValidator(props, propName) || validateRange(props.min, props.max);
      }
    };
    function getMinMax(_ref3) {
      var min2 = _ref3.min, max2 = _ref3.max;
      var minimum;
      var maximum;
      if (typeof min2 !== "number" && typeof max2 !== "number") {
        minimum = 1;
        maximum = 1;
      } else {
        minimum = typeof min2 === "number" ? min2 : 1;
        maximum = typeof max2 === "number" ? max2 : Infinity;
      }
      return {
        minimum,
        maximum
      };
    }
    function chunkByType(items) {
      var chunk = [];
      var lastType;
      return items.reduce(function(chunks, item) {
        var itemType = (0, _typeOf["default"])(item);
        if (!lastType || itemType === lastType) {
          chunk.push(item);
        } else {
          chunks.push(chunk);
          chunk = [item];
        }
        lastType = itemType;
        return chunks;
      }, []).concat(chunk.length > 0 ? [chunk] : []);
    }
    function validateChunks(specifiers, props, propName, componentName) {
      var items = props[propName];
      var chunks = chunkByType(items);
      for (var _len = arguments.length, rest = new Array(_len > 4 ? _len - 4 : 0), _key = 4; _key < _len; _key++) {
        rest[_key - 4] = arguments[_key];
      }
      for (var i = 0; i < specifiers.length; i += 1) {
        var _specifiers$i = specifiers[i], validator = _specifiers$i.validator, min2 = _specifiers$i.min, max2 = _specifiers$i.max;
        var _getMinMax = getMinMax({
          min: min2,
          max: max2
        }), minimum = _getMinMax.minimum, maximum = _getMinMax.maximum;
        if (chunks.length === 0 && minimum === 0) {
          continue;
        }
        var arrayOfValidator = (0, _propTypes.arrayOf)(validator).isRequired;
        var chunk = chunks.shift();
        var chunkError = arrayOfValidator.apply(void 0, [_objectSpread3(_objectSpread3({}, props), {}, _defineProperty2({}, propName, chunk)), propName, componentName].concat(rest));
        if (chunkError) {
          if (minimum === 0) {
            chunks.unshift(chunk);
            continue;
          }
          return chunkError;
        }
        if (chunk.length < minimum) {
          return new RangeError("".concat(componentName, ": specifier index ").concat(i, " requires a minimum of ").concat(min2, " items, but only has ").concat(chunk.length, "."));
        }
        if (chunk.length > maximum) {
          return new RangeError("".concat(componentName, ": specifier index ").concat(i, " requires a maximum of ").concat(max2, " items, but has ").concat(chunk.length, "."));
        }
      }
      if (chunks.length > 0) {
        return new TypeError("".concat(componentName, ": after all ").concat(specifiers.length, " specifiers matched, ").concat(chunks.length, " types of items were remaining."));
      }
      return null;
    }
    var specifierValidator = (0, _withShape["default"])((0, _object["default"])(), specifierShape).isRequired;
    function sequenceOfValidator() {
      for (var _len2 = arguments.length, specifiers = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        specifiers[_key2] = arguments[_key2];
      }
      if (specifiers.length === 0) {
        throw new RangeError("sequenceOf: at least one specifier is required");
      }
      var errors = specifiers.map(function(specifier, i) {
        return specifierValidator({
          specifier
        }, "specifier", "sequenceOf specifier", "suequenceOf specifier, index ".concat(i), "specifier, index ".concat(i));
      });
      if (errors.some(Boolean)) {
        throw new TypeError("\n      sequenceOf: all specifiers must match the appropriate shape.\n\n      Errors:\n        ".concat(errors.map(function(e3, i) {
          return " - Argument index ".concat(i, ": ").concat(e3.message);
        }).join(",\n        "), "\n    "));
      }
      var validator = function sequenceOf2(props, propName) {
        var propValue = props[propName];
        if (propValue == null) {
          return null;
        }
        for (var _len3 = arguments.length, rest = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++) {
          rest[_key3 - 2] = arguments[_key3];
        }
        var error2 = _propTypes.array.apply(void 0, [props, propName].concat(rest));
        if (error2) {
          return error2;
        }
        return validateChunks.apply(void 0, [specifiers, props, propName].concat(rest));
      };
      validator.isRequired = function sequenceOfRequired(props, propName, componentName) {
        for (var _len4 = arguments.length, rest = new Array(_len4 > 3 ? _len4 - 3 : 0), _key4 = 3; _key4 < _len4; _key4++) {
          rest[_key4 - 3] = arguments[_key4];
        }
        var error2 = _propTypes.array.isRequired.apply(_propTypes.array, [props, propName, componentName].concat(rest));
        if (error2) {
          return error2;
        }
        return validateChunks.apply(void 0, [specifiers, props, propName, componentName].concat(rest));
      };
      return (0, _wrapValidator["default"])(validator, "sequenceOf", specifiers);
    }
  })(sequenceOf);
  return sequenceOf;
}
var hasRequiredChildrenSequenceOf;
function requireChildrenSequenceOf() {
  if (hasRequiredChildrenSequenceOf) return childrenSequenceOf;
  hasRequiredChildrenSequenceOf = 1;
  (function(exports$1) {
    Object.defineProperty(exports$1, "__esModule", {
      value: true
    });
    exports$1["default"] = childrenSequenceOfValidator;
    var _sequenceOf = _interopRequireDefault(requireSequenceOf());
    var _renderableChildren = _interopRequireDefault(requireRenderableChildren());
    var _wrapValidator = _interopRequireDefault(requireWrapValidator());
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : { "default": obj };
    }
    function ownKeys2(object2, enumerableOnly) {
      var keys3 = Object.keys(object2);
      if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object2);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
          return Object.getOwnPropertyDescriptor(object2, sym).enumerable;
        });
        keys3.push.apply(keys3, symbols);
      }
      return keys3;
    }
    function _objectSpread3(target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) {
          ownKeys2(Object(source), true).forEach(function(key) {
            _defineProperty2(target, key, source[key]);
          });
        } else if (Object.getOwnPropertyDescriptors) {
          Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        } else {
          ownKeys2(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
          });
        }
      }
      return target;
    }
    function _defineProperty2(obj, key, value) {
      if (key in obj) {
        Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
      } else {
        obj[key] = value;
      }
      return obj;
    }
    function childrenSequenceOfValidator() {
      for (var _len = arguments.length, specifiers = new Array(_len), _key = 0; _key < _len; _key++) {
        specifiers[_key] = arguments[_key];
      }
      var seq = _sequenceOf["default"].apply(void 0, specifiers);
      var validator = function childrenSequenceOf2(props, propName, componentName) {
        if (propName !== "children") {
          return new TypeError("".concat(componentName, ' is using the childrenSequenceOf validator on non-children prop "').concat(propName, '"'));
        }
        var propValue = props[propName];
        var children = (0, _renderableChildren["default"])(propValue);
        if (children.length === 0) {
          return null;
        }
        for (var _len2 = arguments.length, rest = new Array(_len2 > 3 ? _len2 - 3 : 0), _key2 = 3; _key2 < _len2; _key2++) {
          rest[_key2 - 3] = arguments[_key2];
        }
        return seq.apply(void 0, [_objectSpread3(_objectSpread3({}, props), {}, {
          children
        }), propName, componentName].concat(rest));
      };
      validator.isRequired = function childrenSequenceOfRequired(props, propName, componentName) {
        if (propName !== "children") {
          return new TypeError("".concat(componentName, ' is using the childrenSequenceOf validator on non-children prop "').concat(propName, '"'));
        }
        var propValue = props[propName];
        var children = (0, _renderableChildren["default"])(propValue);
        if (children.length === 0) {
          return new TypeError("".concat(componentName, ": renderable children are required."));
        }
        for (var _len3 = arguments.length, rest = new Array(_len3 > 3 ? _len3 - 3 : 0), _key3 = 3; _key3 < _len3; _key3++) {
          rest[_key3 - 3] = arguments[_key3];
        }
        return seq.isRequired.apply(seq, [_objectSpread3(_objectSpread3({}, props), {}, {
          children
        }), propName, componentName].concat(rest));
      };
      return (0, _wrapValidator["default"])(validator, "childrenSequenceOf", specifiers);
    }
  })(childrenSequenceOf);
  return childrenSequenceOf;
}
var componentWithName = {};
var hasRequiredComponentWithName;
function requireComponentWithName() {
  if (hasRequiredComponentWithName) return componentWithName;
  hasRequiredComponentWithName = 1;
  (function(exports$1) {
    Object.defineProperty(exports$1, "__esModule", {
      value: true
    });
    exports$1["default"] = componentWithName2;
    var _react = _interopRequireDefault(React__default);
    var _isRegex = _interopRequireDefault(requireIsRegex());
    var _arrayPrototype = _interopRequireDefault(requireArray_prototype_find());
    var _getComponentName = _interopRequireDefault(requireGetComponentName());
    var _wrapValidator = _interopRequireDefault(requireWrapValidator());
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : { "default": obj };
    }
    function stripHOCs(fullName, namesOfHOCsToStrip) {
      var innerName = fullName;
      while (/\([^()]*\)/g.test(innerName)) {
        var HOC = innerName;
        var previousHOC = void 0;
        do {
          previousHOC = HOC;
          HOC = previousHOC.replace(/\([^()]*\)/g, "");
        } while (previousHOC !== HOC);
        if (namesOfHOCsToStrip.indexOf(HOC) === -1) {
          return innerName;
        }
        innerName = innerName.replace(RegExp("^".concat(HOC, "\\(|\\)$"), "g"), "");
      }
      return innerName;
    }
    function hasName(name, namesOfHOCsToStrip, propValue, propName, componentName) {
      for (var _len = arguments.length, rest = new Array(_len > 5 ? _len - 5 : 0), _key = 5; _key < _len; _key++) {
        rest[_key - 5] = arguments[_key];
      }
      if (Array.isArray(propValue)) {
        return (0, _arrayPrototype["default"])(propValue.map(function(item) {
          return hasName.apply(void 0, [name, namesOfHOCsToStrip, item, propName, componentName].concat(rest));
        }), Boolean) || null;
      }
      if (!/* @__PURE__ */ _react["default"].isValidElement(propValue)) {
        return new TypeError("".concat(componentName, ".").concat(propName, " is not a valid React element"));
      }
      var type2 = propValue.type;
      var componentNameFromType = (0, _getComponentName["default"])(type2);
      var innerComponentName = namesOfHOCsToStrip.length > 0 ? stripHOCs(componentNameFromType, namesOfHOCsToStrip) : componentNameFromType;
      if ((0, _isRegex["default"])(name) && !name.test(innerComponentName)) {
        return new TypeError("`".concat(componentName, ".").concat(propName, "` only accepts components matching the regular expression ").concat(name));
      }
      if (!(0, _isRegex["default"])(name) && innerComponentName !== name) {
        return new TypeError("`".concat(componentName, ".").concat(propName, "` only accepts components named ").concat(name, ", got ").concat(innerComponentName));
      }
      return null;
    }
    function componentWithName2(name) {
      var options2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      if (typeof name !== "string" && !(0, _isRegex["default"])(name)) {
        throw new TypeError("name must be a string or a regex");
      }
      var passedOptions = Object.keys(options2);
      if (passedOptions.length > 1 || passedOptions.length === 1 && passedOptions[0] !== "stripHOCs") {
        throw new TypeError("The only options supported are: “stripHOCs”, got: “".concat(passedOptions.join("”, “"), "”"));
      }
      var _options$stripHOCs = options2.stripHOCs, namesOfHOCsToStrip = _options$stripHOCs === void 0 ? [] : _options$stripHOCs;
      var allHOCNamesAreValid = namesOfHOCsToStrip.every(function(x2) {
        if (typeof x2 !== "string" || /[()]/g.test(x2)) {
          return false;
        }
        return /^(?:[a-z][a-zA-Z0-9]+|[A-Z][a-z][a-zA-Z0-9]+)$/.test(x2);
      });
      if (!allHOCNamesAreValid) {
        throw new TypeError("every provided HOC name must be a string with no parens, and in camelCase");
      }
      function componentWithNameValidator(props, propName, componentName) {
        var propValue = props[propName];
        if (props[propName] == null) {
          return null;
        }
        for (var _len2 = arguments.length, rest = new Array(_len2 > 3 ? _len2 - 3 : 0), _key2 = 3; _key2 < _len2; _key2++) {
          rest[_key2 - 3] = arguments[_key2];
        }
        return hasName.apply(void 0, [name, namesOfHOCsToStrip, propValue, propName, componentName].concat(rest));
      }
      componentWithNameValidator.isRequired = function componentWithNameRequired(props, propName, componentName) {
        var propValue = props[propName];
        if (propValue == null) {
          return new TypeError("`".concat(componentName, ".").concat(propName, "` requires at least one component named ").concat(name));
        }
        for (var _len3 = arguments.length, rest = new Array(_len3 > 3 ? _len3 - 3 : 0), _key3 = 3; _key3 < _len3; _key3++) {
          rest[_key3 - 3] = arguments[_key3];
        }
        return hasName.apply(void 0, [name, namesOfHOCsToStrip, propValue, propName, componentName].concat(rest));
      };
      return (0, _wrapValidator["default"])(componentWithNameValidator, "componentWithName:".concat(name), name);
    }
  })(componentWithName);
  return componentWithName;
}
var disallowedIf = {};
var hasRequiredDisallowedIf;
function requireDisallowedIf() {
  if (hasRequiredDisallowedIf) return disallowedIf;
  hasRequiredDisallowedIf = 1;
  (function(exports$1) {
    Object.defineProperty(exports$1, "__esModule", {
      value: true
    });
    exports$1["default"] = disallowedIf2;
    var _wrapValidator = _interopRequireDefault(requireWrapValidator());
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : { "default": obj };
    }
    function disallowedIf2(propType, otherPropName, otherPropType) {
      if (typeof propType !== "function" || typeof propType.isRequired !== "function") {
        throw new TypeError("a propType validator is required; propType validators must also provide `.isRequired`");
      }
      if (typeof otherPropName !== "string") {
        throw new TypeError("other prop name must be a string");
      }
      if (typeof otherPropType !== "function") {
        throw new TypeError("other prop type validator is required");
      }
      function disallowedIfRequired(props, propName, componentName) {
        for (var _len = arguments.length, rest = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
          rest[_key - 3] = arguments[_key];
        }
        var error2 = propType.isRequired.apply(propType, [props, propName, componentName].concat(rest));
        if (error2) {
          return error2;
        }
        if (props[otherPropName] == null) {
          return null;
        }
        var otherError = otherPropType.apply(void 0, [props, otherPropName, componentName].concat(rest));
        if (otherError) {
          return null;
        }
        return new Error("prop “".concat(propName, "” is disallowed when “").concat(otherPropName, "” matches the provided validator"));
      }
      var validator = function disallowedIfPropType(props, propName) {
        if (props[propName] == null) {
          return null;
        }
        for (var _len2 = arguments.length, rest = new Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
          rest[_key2 - 2] = arguments[_key2];
        }
        return disallowedIfRequired.apply(void 0, [props, propName].concat(rest));
      };
      validator.isRequired = disallowedIfRequired;
      return (0, _wrapValidator["default"])(validator, "disallowedIf", {
        propType,
        otherPropName,
        otherPropType
      });
    }
  })(disallowedIf);
  return disallowedIf;
}
var elementType = {};
var hasRequiredElementType;
function requireElementType() {
  if (hasRequiredElementType) return elementType;
  hasRequiredElementType = 1;
  (function(exports$1) {
    Object.defineProperty(exports$1, "__esModule", {
      value: true
    });
    exports$1["default"] = elementTypeValidator;
    var _propTypes = propTypesExports;
    var _reactIs = requireReactIs();
    var _and = _interopRequireDefault(requireAnd());
    var _getComponentName = _interopRequireDefault(requireGetComponentName());
    var _wrapValidator = _interopRequireDefault(requireWrapValidator());
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : { "default": obj };
    }
    function _typeof2(obj) {
      "@babel/helpers - typeof";
      if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
        _typeof2 = function _typeof3(obj2) {
          return typeof obj2;
        };
      } else {
        _typeof2 = function _typeof3(obj2) {
          return obj2 && typeof Symbol === "function" && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
        };
      }
      return _typeof2(obj);
    }
    function getTypeName(Type) {
      if (typeof Type === "string") {
        return Type;
      }
      var type2 = (0, _getComponentName["default"])(Type);
      return type2 || "Anonymous Component";
    }
    function validateElementType(Type, props, propName, componentName) {
      var type2 = props[propName].type;
      if (type2 === Type) {
        return null;
      }
      return new TypeError("".concat(componentName, ".").concat(propName, " must be a React element of type ").concat(getTypeName(Type)));
    }
    function elementTypeValidator(Type) {
      if (Type === "*") {
        return (0, _wrapValidator["default"])(_propTypes.element, "elementType(*)", Type);
      }
      if (!(0, _reactIs.isValidElementType)(Type)) {
        throw new TypeError('Type must be a React Component, an HTML element tag name, or "*". Got an '.concat(_typeof2(Type)));
      }
      function elementType2(props, propName, componentName) {
        if (props[propName] == null) {
          return null;
        }
        for (var _len = arguments.length, rest = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
          rest[_key - 3] = arguments[_key];
        }
        return validateElementType.apply(void 0, [Type, props, propName, componentName].concat(rest));
      }
      elementType2.isRequired = elementType2;
      var typeName = getTypeName(Type);
      var validatorName = "elementType(".concat(typeName, ")");
      return (0, _wrapValidator["default"])((0, _and["default"])([_propTypes.element, elementType2], validatorName), validatorName, Type);
    }
  })(elementType);
  return elementType;
}
var empty = {};
var or = {};
var hasRequiredOr;
function requireOr() {
  if (hasRequiredOr) return or;
  hasRequiredOr = 1;
  (function(exports$1) {
    Object.defineProperty(exports$1, "__esModule", {
      value: true
    });
    exports$1["default"] = or2;
    var _propTypes = propTypesExports;
    var _wrapValidator = _interopRequireDefault(requireWrapValidator());
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : { "default": obj };
    }
    function _toConsumableArray2(arr) {
      return _arrayWithoutHoles2(arr) || _iterableToArray2(arr) || _unsupportedIterableToArray2(arr) || _nonIterableSpread2();
    }
    function _nonIterableSpread2() {
      throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    function _unsupportedIterableToArray2(o, minLen) {
      if (!o) return;
      if (typeof o === "string") return _arrayLikeToArray2(o, minLen);
      var n2 = Object.prototype.toString.call(o).slice(8, -1);
      if (n2 === "Object" && o.constructor) n2 = o.constructor.name;
      if (n2 === "Map" || n2 === "Set") return Array.from(o);
      if (n2 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n2)) return _arrayLikeToArray2(o, minLen);
    }
    function _iterableToArray2(iter) {
      if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
    }
    function _arrayWithoutHoles2(arr) {
      if (Array.isArray(arr)) return _arrayLikeToArray2(arr);
    }
    function _arrayLikeToArray2(arr, len) {
      if (len == null || len > arr.length) len = arr.length;
      for (var i = 0, arr2 = new Array(len); i < len; i++) {
        arr2[i] = arr[i];
      }
      return arr2;
    }
    function oneOfTypeValidator(validators) {
      var validator = function oneOfType(props, propName, componentName) {
        for (var _len = arguments.length, rest = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
          rest[_key - 3] = arguments[_key];
        }
        var propValue = props[propName];
        if (typeof propValue === "undefined") {
          return null;
        }
        var errors = validators.map(function(v2) {
          return v2.apply(void 0, [props, propName, componentName].concat(rest));
        }).filter(Boolean);
        if (errors.length < validators.length) {
          return null;
        }
        return new TypeError("".concat(componentName, ": invalid value supplied to ").concat(propName, "."));
      };
      validator.isRequired = function oneOfTypeRequired(props, propName, componentName) {
        for (var _len2 = arguments.length, rest = new Array(_len2 > 3 ? _len2 - 3 : 0), _key2 = 3; _key2 < _len2; _key2++) {
          rest[_key2 - 3] = arguments[_key2];
        }
        var propValue = props[propName];
        if (typeof propValue === "undefined") {
          return new TypeError("".concat(componentName, ": missing value for required ").concat(propName, "."));
        }
        var errors = validators.map(function(v2) {
          return v2.apply(void 0, [props, propName, componentName].concat(rest));
        }).filter(Boolean);
        if (errors.length === validators.length) {
          return new TypeError("".concat(componentName, ": invalid value ").concat(errors, " supplied to required ").concat(propName, "."));
        }
        return null;
      };
      return (0, _wrapValidator["default"])(validator, "oneOfType", validators);
    }
    function or2(validators) {
      var name = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "or";
      if (!Array.isArray(validators)) {
        throw new TypeError("or: 2 or more validators are required");
      }
      if (validators.length <= 1) {
        throw new RangeError("or: 2 or more validators are required");
      }
      var validator = oneOfTypeValidator([(0, _propTypes.arrayOf)(oneOfTypeValidator(validators))].concat(_toConsumableArray2(validators)));
      return (0, _wrapValidator["default"])(validator, name, validators);
    }
  })(or);
  return or;
}
var explicitNull = {};
var hasRequiredExplicitNull;
function requireExplicitNull() {
  if (hasRequiredExplicitNull) return explicitNull;
  hasRequiredExplicitNull = 1;
  (function(exports$1) {
    Object.defineProperty(exports$1, "__esModule", {
      value: true
    });
    exports$1["default"] = void 0;
    var _wrapValidator = _interopRequireDefault(requireWrapValidator());
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : { "default": obj };
    }
    function _typeof2(obj) {
      "@babel/helpers - typeof";
      if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
        _typeof2 = function _typeof3(obj2) {
          return typeof obj2;
        };
      } else {
        _typeof2 = function _typeof3(obj2) {
          return obj2 && typeof Symbol === "function" && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
        };
      }
      return _typeof2(obj);
    }
    function explicitNull2(props, propName, componentName) {
      if (props[propName] == null) {
        return null;
      }
      return new TypeError("".concat(componentName, ": prop “").concat(propName, "” must be null or undefined; received ").concat(_typeof2(props[propName])));
    }
    explicitNull2.isRequired = function explicitNullRequired(props, propName, componentName) {
      if (props[propName] === null) {
        return null;
      }
      return new TypeError("".concat(componentName, ": prop “").concat(propName, "” must be null; received ").concat(_typeof2(props[propName])));
    };
    var _default2 = function _default3() {
      return (0, _wrapValidator["default"])(explicitNull2, "explicitNull");
    };
    exports$1["default"] = _default2;
  })(explicitNull);
  return explicitNull;
}
var hasRequiredEmpty;
function requireEmpty() {
  if (hasRequiredEmpty) return empty;
  hasRequiredEmpty = 1;
  (function(exports$1) {
    Object.defineProperty(exports$1, "__esModule", {
      value: true
    });
    exports$1["default"] = void 0;
    var _propTypes = propTypesExports;
    var _or = _interopRequireDefault(requireOr());
    var _explicitNull = _interopRequireDefault(requireExplicitNull());
    var _withShape = _interopRequireDefault(requireWithShape());
    var _wrapValidator = _interopRequireDefault(requireWrapValidator());
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : { "default": obj };
    }
    var arrayOfValidator;
    var validator = (0, _or["default"])([
      _explicitNull["default"],
      // null/undefined
      (0, _propTypes.oneOf)([false, "", NaN]),
      (0, _withShape["default"])(_propTypes.array, {
        length: (0, _propTypes.oneOf)([0]).isRequired
      }).isRequired,
      function() {
        return arrayOfValidator.apply(void 0, arguments);
      }
    ]);
    arrayOfValidator = (0, _propTypes.arrayOf)(validator).isRequired;
    var _default2 = function _default3() {
      return (0, _wrapValidator["default"])(validator, "empty");
    };
    exports$1["default"] = _default2;
  })(empty);
  return empty;
}
var keysOf = {};
var hasRequiredKeysOf;
function requireKeysOf() {
  if (hasRequiredKeysOf) return keysOf;
  hasRequiredKeysOf = 1;
  (function(exports$1) {
    Object.defineProperty(exports$1, "__esModule", {
      value: true
    });
    exports$1["default"] = keysOfValidator;
    var _isPrimitive = _interopRequireDefault(requireIsPrimitive$2());
    var _wrapValidator = _interopRequireDefault(requireWrapValidator());
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : { "default": obj };
    }
    function _defineProperty2(obj, key, value) {
      if (key in obj) {
        Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
      } else {
        obj[key] = value;
      }
      return obj;
    }
    function keysOfValidator(propType) {
      var name = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "keysOf";
      if (typeof propType !== "function") {
        throw new TypeError("argument to keysOf must be a valid PropType function");
      }
      var validator = function keysOf2(props, propName, componentName, location, propFullName) {
        for (var _len = arguments.length, rest = new Array(_len > 5 ? _len - 5 : 0), _key = 5; _key < _len; _key++) {
          rest[_key - 5] = arguments[_key];
        }
        var propValue = props[propName];
        if (propValue == null || (0, _isPrimitive["default"])(propValue)) {
          return null;
        }
        var firstError = null;
        Object.keys(propValue).some(function(key) {
          firstError = propType.apply(void 0, [_defineProperty2({}, key, key), key, componentName, location, "(".concat(propFullName, ").").concat(key)].concat(rest));
          return firstError != null;
        });
        return firstError || null;
      };
      validator.isRequired = function keyedByRequired(props, propName, componentName) {
        var propValue = props[propName];
        if (propValue == null) {
          return new TypeError("".concat(componentName, ": ").concat(propName, " is required, but value is ").concat(propValue));
        }
        for (var _len2 = arguments.length, rest = new Array(_len2 > 3 ? _len2 - 3 : 0), _key2 = 3; _key2 < _len2; _key2++) {
          rest[_key2 - 3] = arguments[_key2];
        }
        return validator.apply(void 0, [props, propName, componentName].concat(rest));
      };
      return (0, _wrapValidator["default"])(validator, name, propType);
    }
  })(keysOf);
  return keysOf;
}
var mutuallyExclusiveProps = {};
var hasRequiredMutuallyExclusiveProps;
function requireMutuallyExclusiveProps() {
  if (hasRequiredMutuallyExclusiveProps) return mutuallyExclusiveProps;
  hasRequiredMutuallyExclusiveProps = 1;
  (function(exports$1) {
    Object.defineProperty(exports$1, "__esModule", {
      value: true
    });
    exports$1["default"] = mutuallyExclusiveOfType;
    var _wrapValidator = _interopRequireDefault(requireWrapValidator());
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : { "default": obj };
    }
    function ownKeys2(object2, enumerableOnly) {
      var keys3 = Object.keys(object2);
      if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object2);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
          return Object.getOwnPropertyDescriptor(object2, sym).enumerable;
        });
        keys3.push.apply(keys3, symbols);
      }
      return keys3;
    }
    function _objectSpread3(target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) {
          ownKeys2(Object(source), true).forEach(function(key) {
            _defineProperty2(target, key, source[key]);
          });
        } else if (Object.getOwnPropertyDescriptors) {
          Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        } else {
          ownKeys2(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
          });
        }
      }
      return target;
    }
    function _defineProperty2(obj, key, value) {
      if (key in obj) {
        Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
      } else {
        obj[key] = value;
      }
      return obj;
    }
    function mutuallyExclusiveOfType(propType) {
      if (typeof propType !== "function") {
        throw new TypeError("a propType is required");
      }
      for (var _len = arguments.length, exclusiveProps = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        exclusiveProps[_key - 1] = arguments[_key];
      }
      if (exclusiveProps.length < 1) {
        throw new TypeError("at least one prop that is mutually exclusive with this propType is required");
      }
      var propList = exclusiveProps.join(", or ");
      var map = exclusiveProps.reduce(function(acc, prop) {
        return _objectSpread3(_objectSpread3({}, acc), {}, _defineProperty2({}, prop, true));
      }, {});
      var countProps = function countProps2(count2, prop) {
        return count2 + (map[prop] ? 1 : 0);
      };
      var validator = function mutuallyExclusiveProps2(props, propName, componentName) {
        var exclusivePropCount = Object.keys(props).filter(function(prop) {
          return props[prop] != null;
        }).reduce(countProps, 0);
        if (exclusivePropCount > 1) {
          return new Error("A ".concat(componentName, " cannot have more than one of these props: ").concat(propList));
        }
        for (var _len2 = arguments.length, rest = new Array(_len2 > 3 ? _len2 - 3 : 0), _key2 = 3; _key2 < _len2; _key2++) {
          rest[_key2 - 3] = arguments[_key2];
        }
        return propType.apply(void 0, [props, propName, componentName].concat(rest));
      };
      validator.isRequired = function mutuallyExclusivePropsRequired(props, propName, componentName) {
        var exclusivePropCount = Object.keys(props).filter(function(prop) {
          return prop === propName || props[prop] != null;
        }).reduce(countProps, 0);
        if (exclusivePropCount > 1) {
          return new Error("A ".concat(componentName, " cannot have more than one of these props: ").concat(propList));
        }
        for (var _len3 = arguments.length, rest = new Array(_len3 > 3 ? _len3 - 3 : 0), _key3 = 3; _key3 < _len3; _key3++) {
          rest[_key3 - 3] = arguments[_key3];
        }
        return propType.apply(void 0, [props, propName, componentName].concat(rest));
      };
      return (0, _wrapValidator["default"])(validator, "mutuallyExclusiveProps:".concat(propList), exclusiveProps);
    }
  })(mutuallyExclusiveProps);
  return mutuallyExclusiveProps;
}
var mutuallyExclusiveTrueProps = {};
var hasRequiredMutuallyExclusiveTrueProps;
function requireMutuallyExclusiveTrueProps() {
  if (hasRequiredMutuallyExclusiveTrueProps) return mutuallyExclusiveTrueProps;
  hasRequiredMutuallyExclusiveTrueProps = 1;
  (function(exports$1) {
    Object.defineProperty(exports$1, "__esModule", {
      value: true
    });
    exports$1["default"] = mutuallyExclusiveTrue;
    var _propTypes = propTypesExports;
    var _wrapValidator = _interopRequireDefault(requireWrapValidator());
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : { "default": obj };
    }
    function mutuallyExclusiveTrue() {
      for (var _len = arguments.length, exclusiveProps = new Array(_len), _key = 0; _key < _len; _key++) {
        exclusiveProps[_key] = arguments[_key];
      }
      if (exclusiveProps.length < 1) {
        throw new TypeError("at least one prop that is mutually exclusive is required");
      }
      if (!exclusiveProps.every(function(x2) {
        return typeof x2 === "string";
      })) {
        throw new TypeError("all exclusive true props must be strings");
      }
      var propsList = exclusiveProps.join(", or ");
      var validator = function mutuallyExclusiveTrueProps2(props, propName, componentName) {
        var countProps = function countProps2(count2, prop) {
          return count2 + (props[prop] ? 1 : 0);
        };
        var exclusivePropCount = exclusiveProps.reduce(countProps, 0);
        if (exclusivePropCount > 1) {
          return new Error("A ".concat(componentName, " cannot have more than one of these boolean props be true: ").concat(propsList));
        }
        for (var _len2 = arguments.length, rest = new Array(_len2 > 3 ? _len2 - 3 : 0), _key2 = 3; _key2 < _len2; _key2++) {
          rest[_key2 - 3] = arguments[_key2];
        }
        return _propTypes.bool.apply(void 0, [props, propName, componentName].concat(rest));
      };
      validator.isRequired = function mutuallyExclusiveTruePropsRequired(props, propName, componentName) {
        var countProps = function countProps2(count2, prop) {
          return count2 + (props[prop] ? 1 : 0);
        };
        var exclusivePropCount = exclusiveProps.reduce(countProps, 0);
        if (exclusivePropCount > 1) {
          return new Error("A ".concat(componentName, " cannot have more than one of these boolean props be true: ").concat(propsList));
        }
        for (var _len3 = arguments.length, rest = new Array(_len3 > 3 ? _len3 - 3 : 0), _key3 = 3; _key3 < _len3; _key3++) {
          rest[_key3 - 3] = arguments[_key3];
        }
        return _propTypes.bool.isRequired.apply(_propTypes.bool, [props, propName, componentName].concat(rest));
      };
      return (0, _wrapValidator["default"])(validator, "mutuallyExclusiveTrueProps: ".concat(propsList), exclusiveProps);
    }
  })(mutuallyExclusiveTrueProps);
  return mutuallyExclusiveTrueProps;
}
var nChildren = {};
var hasRequiredNChildren;
function requireNChildren() {
  if (hasRequiredNChildren) return nChildren;
  hasRequiredNChildren = 1;
  (function(exports$1) {
    Object.defineProperty(exports$1, "__esModule", {
      value: true
    });
    exports$1["default"] = nChildren2;
    var _react = _interopRequireDefault(React__default);
    var _propTypes = propTypesExports;
    var _wrapValidator = _interopRequireDefault(requireWrapValidator());
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : { "default": obj };
    }
    function nChildren2(n2) {
      var propType = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : _propTypes.node;
      if (typeof n2 !== "number" || isNaN(n2) || n2 < 0) {
        throw new TypeError("a non-negative number is required");
      }
      var validator = function nChildrenValidator(props, propName, componentName) {
        if (propName !== "children") {
          return new TypeError("".concat(componentName, " is using the nChildren validator on a non-children prop"));
        }
        var children = props.children;
        var childrenCount = _react["default"].Children.count(children);
        if (childrenCount !== n2) {
          return new RangeError("".concat(componentName, " expects to receive ").concat(n2, " children, but received ").concat(childrenCount, " children."));
        }
        for (var _len = arguments.length, rest = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
          rest[_key - 3] = arguments[_key];
        }
        return propType.apply(void 0, [props, propName, componentName].concat(rest));
      };
      validator.isRequired = validator;
      return (0, _wrapValidator["default"])(validator, "nChildren:".concat(n2), n2);
    }
  })(nChildren);
  return nChildren;
}
var numericString = {};
var hasRequiredNumericString;
function requireNumericString() {
  if (hasRequiredNumericString) return numericString;
  hasRequiredNumericString = 1;
  (function(exports$1) {
    Object.defineProperty(exports$1, "__esModule", {
      value: true
    });
    exports$1["default"] = void 0;
    var _propTypes = propTypesExports;
    var _wrapValidator = _interopRequireDefault(requireWrapValidator());
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : { "default": obj };
    }
    var validNumericChars = /^[-+]?(?:[1-9][0-9]*(?:\.[0-9]+)?|0|0\.[0-9]+)$/;
    var validator = function numericString2(props, propName, componentName) {
      if (props[propName] == null) {
        return null;
      }
      for (var _len = arguments.length, rest = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
        rest[_key - 3] = arguments[_key];
      }
      var stringError = _propTypes.string.apply(void 0, [props, propName, componentName].concat(rest));
      if (stringError) {
        return stringError;
      }
      var value = props[propName];
      var passesRegex = validNumericChars.test(value);
      if (passesRegex) {
        return null;
      }
      return new TypeError("".concat(componentName, ': prop "').concat(propName, '" (value "').concat(value, '") must be a numeric string:\n    - starting with an optional + or -\n    - that does not have a leading zero\n    - with an optional decimal part (that contains only one decimal point, if present)\n    - that otherwise only contains digits (0-9)\n    - not +-NaN, or +-Infinity\n  '));
    };
    validator.isRequired = function numericStringRequired(props, propName, componentName) {
      if (props[propName] == null) {
        return new TypeError("".concat(componentName, ": ").concat(propName, " is required"));
      }
      for (var _len2 = arguments.length, rest = new Array(_len2 > 3 ? _len2 - 3 : 0), _key2 = 3; _key2 < _len2; _key2++) {
        rest[_key2 - 3] = arguments[_key2];
      }
      return validator.apply(void 0, [props, propName, componentName].concat(rest));
    };
    var _default2 = function _default3() {
      return (0, _wrapValidator["default"])(validator, "numericString");
    };
    exports$1["default"] = _default2;
  })(numericString);
  return numericString;
}
var predicate = {};
var hasRequiredPredicate;
function requirePredicate() {
  if (hasRequiredPredicate) return predicate;
  hasRequiredPredicate = 1;
  (function(exports$1) {
    Object.defineProperty(exports$1, "__esModule", {
      value: true
    });
    exports$1["default"] = predicate2;
    var _wrapValidator = _interopRequireDefault(requireWrapValidator());
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : { "default": obj };
    }
    function predicate2(fn2) {
      var message2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
      if (typeof fn2 !== "function") {
        throw new TypeError("`fn` must be a function");
      }
      if (typeof message2 !== "string") {
        throw new TypeError("`message`, if provided, must be a string");
      }
      function requiredValidator(props, propName, componentName) {
        var result = fn2(props[propName]);
        if (result) {
          return null;
        }
        return new TypeError("`".concat(componentName, "` requires that `").concat(propName, "` pass a predicate function").concat(message2 ? ": ".concat(message2) : "", "."));
      }
      function validator(props, propName) {
        if (props[propName] == null) {
          return null;
        }
        for (var _len = arguments.length, rest = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
          rest[_key - 2] = arguments[_key];
        }
        return requiredValidator.apply(void 0, [props, propName].concat(rest));
      }
      validator.isRequired = requiredValidator;
      return (0, _wrapValidator["default"])(validator, "predicate", fn2);
    }
  })(predicate);
  return predicate;
}
var range = {};
var hasRequiredRange;
function requireRange() {
  if (hasRequiredRange) return range;
  hasRequiredRange = 1;
  (function(exports$1) {
    Object.defineProperty(exports$1, "__esModule", {
      value: true
    });
    exports$1["default"] = range2;
    var _and = _interopRequireDefault(requireAnd());
    var _between = _interopRequireDefault(requireBetween());
    var _integer = _interopRequireDefault(requireInteger());
    var _isInteger = _interopRequireDefault(requireIsInteger());
    var _wrapValidator = _interopRequireDefault(requireWrapValidator());
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : { "default": obj };
    }
    var MAX_SAFE_INTEGER2 = Number.MAX_SAFE_INTEGER || /* istanbul ignore next */
    Math.pow(2, 53) - 1;
    function isValidLength(x2) {
      return (0, _isInteger["default"])(x2) && Math.abs(x2) < MAX_SAFE_INTEGER2;
    }
    function range2(min2, max2) {
      if (!isValidLength(min2) || !isValidLength(max2)) {
        throw new RangeError('"range" requires two integers: '.concat(min2, " and ").concat(max2, " given"));
      }
      if (min2 === max2) {
        throw new RangeError("min and max must not be the same");
      }
      return (0, _wrapValidator["default"])((0, _and["default"])([(0, _integer["default"])(), (0, _between["default"])({
        gte: min2,
        lt: max2
      })], "range"), "range", {
        min: min2,
        max: max2
      });
    }
  })(range);
  return range;
}
var ref = {};
var hasRequiredRef;
function requireRef() {
  if (hasRequiredRef) return ref;
  hasRequiredRef = 1;
  (function(exports$1) {
    Object.defineProperty(exports$1, "__esModule", {
      value: true
    });
    exports$1["default"] = void 0;
    var _react = React__default;
    var _isPlainObject = _interopRequireDefault(requireIsPlainObject());
    var _wrapValidator = _interopRequireDefault(requireWrapValidator());
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : { "default": obj };
    }
    var isPrototypeOf = Object.prototype.isPrototypeOf;
    function isNewRef(prop) {
      if (!(0, _isPlainObject["default"])(prop)) {
        return false;
      }
      var ownProperties = Object.keys(prop);
      return ownProperties.length === 1 && ownProperties[0] === "current";
    }
    function isCallbackRef(prop) {
      return typeof prop === "function" && !isPrototypeOf.call(_react.Component, prop) && (!_react.PureComponent || !isPrototypeOf.call(_react.PureComponent, prop));
    }
    function requiredRef(props, propName, componentName) {
      var propValue = props[propName];
      if (isCallbackRef(propValue) || isNewRef(propValue)) {
        return null;
      }
      return new TypeError("".concat(propName, " in ").concat(componentName, " must be a ref"));
    }
    function ref2(props, propName, componentName) {
      var propValue = props[propName];
      if (propValue == null) {
        return null;
      }
      for (var _len = arguments.length, rest = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
        rest[_key - 3] = arguments[_key];
      }
      return requiredRef.apply(void 0, [props, propName, componentName].concat(rest));
    }
    ref2.isRequired = requiredRef;
    var _default2 = function _default3() {
      return (0, _wrapValidator["default"])(ref2, "ref");
    };
    exports$1["default"] = _default2;
  })(ref);
  return ref;
}
var requiredBy = {};
var hasRequiredRequiredBy;
function requireRequiredBy() {
  if (hasRequiredRequiredBy) return requiredBy;
  hasRequiredRequiredBy = 1;
  (function(exports$1) {
    Object.defineProperty(exports$1, "__esModule", {
      value: true
    });
    exports$1["default"] = getRequiredBy;
    var _objectIs = _interopRequireDefault(requireObjectIs());
    var _wrapValidator = _interopRequireDefault(requireWrapValidator());
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : { "default": obj };
    }
    function getRequiredBy(requiredByPropName, propType) {
      var defaultValue = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
      function requiredBy2(props, propName, componentName) {
        if (props[requiredByPropName]) {
          var propValue = props[propName];
          if ((0, _objectIs["default"])(propValue, defaultValue) || typeof propValue === "undefined") {
            return new TypeError("".concat(componentName, ": when ").concat(requiredByPropName, " is true, prop “").concat(propName, "” must be present."));
          }
        }
        for (var _len = arguments.length, rest = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
          rest[_key - 3] = arguments[_key];
        }
        return propType.apply(void 0, [props, propName, componentName].concat(rest));
      }
      requiredBy2.isRequired = function requiredByRequired(props, propName, componentName) {
        var propValue = props[propName];
        if ((0, _objectIs["default"])(propValue, defaultValue)) {
          return new TypeError("".concat(componentName, ": prop “").concat(propName, "” must be present."));
        }
        for (var _len2 = arguments.length, rest = new Array(_len2 > 3 ? _len2 - 3 : 0), _key2 = 3; _key2 < _len2; _key2++) {
          rest[_key2 - 3] = arguments[_key2];
        }
        return propType.isRequired.apply(propType, [props, propName, componentName].concat(rest));
      };
      return (0, _wrapValidator["default"])(requiredBy2, "requiredBy “".concat(requiredByPropName, "”"), [requiredByPropName, defaultValue]);
    }
  })(requiredBy);
  return requiredBy;
}
var restrictedProp = {};
var hasRequiredRestrictedProp;
function requireRestrictedProp() {
  if (hasRequiredRestrictedProp) return restrictedProp;
  hasRequiredRestrictedProp = 1;
  (function(exports$1) {
    Object.defineProperty(exports$1, "__esModule", {
      value: true
    });
    exports$1["default"] = void 0;
    var _wrapValidator = _interopRequireDefault(requireWrapValidator());
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : { "default": obj };
    }
    function customMessageWrapper(messsageFunction) {
      function restrictedProp2(props, propName, componentName, location) {
        if (props[propName] == null) {
          return null;
        }
        if (messsageFunction && typeof messsageFunction === "function") {
          for (var _len = arguments.length, rest = new Array(_len > 4 ? _len - 4 : 0), _key = 4; _key < _len; _key++) {
            rest[_key - 4] = arguments[_key];
          }
          return new TypeError(messsageFunction.apply(void 0, [props, propName, componentName, location].concat(rest)));
        }
        return new TypeError("The ".concat(propName, " ").concat(location, " on ").concat(componentName, " is not allowed."));
      }
      restrictedProp2.isRequired = restrictedProp2;
      return restrictedProp2;
    }
    var _default2 = function _default3() {
      var messsageFunction = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
      return (0, _wrapValidator["default"])(customMessageWrapper(messsageFunction), "restrictedProp");
    };
    exports$1["default"] = _default2;
  })(restrictedProp);
  return restrictedProp;
}
var stringEndsWith = {};
var hasRequiredStringEndsWith;
function requireStringEndsWith() {
  if (hasRequiredStringEndsWith) return stringEndsWith;
  hasRequiredStringEndsWith = 1;
  (function(exports$1) {
    Object.defineProperty(exports$1, "__esModule", {
      value: true
    });
    exports$1["default"] = stringEndsWithValidator;
    var _propTypes = propTypesExports;
    var _wrapValidator = _interopRequireDefault(requireWrapValidator());
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : { "default": obj };
    }
    function stringEndsWithValidator(end2) {
      if (typeof end2 !== "string" || end2.length === 0) {
        throw new TypeError("a non-empty string is required");
      }
      var validator = function stringEndsWith2(props, propName, componentName) {
        var propValue = props[propName];
        if (propValue == null) {
          return null;
        }
        for (var _len = arguments.length, rest = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
          rest[_key - 3] = arguments[_key];
        }
        var stringError = _propTypes.string.apply(void 0, [props, propName, componentName].concat(rest));
        if (stringError) {
          return stringError;
        }
        if (!propValue.endsWith(end2) || propValue.length <= end2.length) {
          return new TypeError("".concat(componentName, ": ").concat(propName, ' does not end with "').concat(end2, '"'));
        }
        return null;
      };
      validator.isRequired = function requiredStringEndsWith() {
        var stringError = _propTypes.string.isRequired.apply(_propTypes.string, arguments);
        if (stringError) {
          return stringError;
        }
        return validator.apply(void 0, arguments);
      };
      return (0, _wrapValidator["default"])(validator, "stringEndsWith: ".concat(end2));
    }
  })(stringEndsWith);
  return stringEndsWith;
}
var stringStartsWith = {};
var hasRequiredStringStartsWith;
function requireStringStartsWith() {
  if (hasRequiredStringStartsWith) return stringStartsWith;
  hasRequiredStringStartsWith = 1;
  (function(exports$1) {
    Object.defineProperty(exports$1, "__esModule", {
      value: true
    });
    exports$1["default"] = stringStartsWithValidator;
    var _propTypes = propTypesExports;
    var _wrapValidator = _interopRequireDefault(requireWrapValidator());
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : { "default": obj };
    }
    function stringStartsWithValidator(start2) {
      if (typeof start2 !== "string" || start2.length === 0) {
        throw new TypeError("a non-empty string is required");
      }
      var validator = function stringStartsWith2(props, propName, componentName) {
        var propValue = props[propName];
        if (propValue == null) {
          return null;
        }
        for (var _len = arguments.length, rest = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
          rest[_key - 3] = arguments[_key];
        }
        var stringError = _propTypes.string.apply(void 0, [props, propName, componentName].concat(rest));
        if (stringError) {
          return stringError;
        }
        if (!propValue.startsWith(start2) || propValue.length <= start2.length) {
          return new TypeError("".concat(componentName, ": ").concat(propName, ' does not start with "').concat(start2, '"'));
        }
        return null;
      };
      validator.isRequired = function requiredStringStartsWith() {
        var stringError = _propTypes.string.isRequired.apply(_propTypes.string, arguments);
        if (stringError) {
          return stringError;
        }
        return validator.apply(void 0, arguments);
      };
      return (0, _wrapValidator["default"])(validator, "stringStartsWith: ".concat(start2));
    }
  })(stringStartsWith);
  return stringStartsWith;
}
var uniqueArray = {};
var hasRequiredUniqueArray;
function requireUniqueArray() {
  if (hasRequiredUniqueArray) return uniqueArray;
  hasRequiredUniqueArray = 1;
  (function(exports$1) {
    Object.defineProperty(exports$1, "__esModule", {
      value: true
    });
    exports$1["default"] = void 0;
    var _propTypes = propTypesExports;
    var _wrapValidator = _interopRequireDefault(requireWrapValidator());
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : { "default": obj };
    }
    function uniqueCountWithSet(arr) {
      return new Set(arr).size;
    }
    function uniqueCountLegacy(arr) {
      var seen = [];
      arr.forEach(function(item) {
        if (seen.indexOf(item) === -1) {
          seen.push(item);
        }
      });
      return seen.length;
    }
    var getUniqueCount = typeof Set === "function" ? uniqueCountWithSet : (
      /* istanbul ignore next */
      uniqueCountLegacy
    );
    function requiredUniqueArray(props, propName, componentName) {
      for (var _len = arguments.length, rest = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
        rest[_key - 3] = arguments[_key];
      }
      var result = _propTypes.array.isRequired.apply(_propTypes.array, [props, propName, componentName].concat(rest));
      if (result != null) {
        return result;
      }
      var propValue = props[propName];
      var uniqueCount = getUniqueCount(propValue);
      if (uniqueCount !== propValue.length) {
        return new RangeError("".concat(componentName, ": values must be unique. ").concat(propValue.length - uniqueCount, " duplicate values found."));
      }
      return null;
    }
    function uniqueArray2(props, propName) {
      var propValue = props[propName];
      if (propValue == null) {
        return null;
      }
      for (var _len2 = arguments.length, rest = new Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        rest[_key2 - 2] = arguments[_key2];
      }
      return requiredUniqueArray.apply(void 0, [props, propName].concat(rest));
    }
    uniqueArray2.isRequired = requiredUniqueArray;
    var _default2 = function _default3() {
      return (0, _wrapValidator["default"])(uniqueArray2, "uniqueArray");
    };
    exports$1["default"] = _default2;
  })(uniqueArray);
  return uniqueArray;
}
var uniqueArrayOf = {};
var hasRequiredUniqueArrayOf;
function requireUniqueArrayOf() {
  if (hasRequiredUniqueArrayOf) return uniqueArrayOf;
  hasRequiredUniqueArrayOf = 1;
  (function(exports$1) {
    Object.defineProperty(exports$1, "__esModule", {
      value: true
    });
    exports$1["default"] = uniqueArrayOfTypeValidator;
    var _propTypes = propTypesExports;
    var _and = _interopRequireDefault(requireAnd());
    var _uniqueArray = _interopRequireDefault(requireUniqueArray());
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : { "default": obj };
    }
    function ownKeys2(object2, enumerableOnly) {
      var keys3 = Object.keys(object2);
      if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object2);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
          return Object.getOwnPropertyDescriptor(object2, sym).enumerable;
        });
        keys3.push.apply(keys3, symbols);
      }
      return keys3;
    }
    function _objectSpread3(target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) {
          ownKeys2(Object(source), true).forEach(function(key) {
            _defineProperty2(target, key, source[key]);
          });
        } else if (Object.getOwnPropertyDescriptors) {
          Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        } else {
          ownKeys2(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
          });
        }
      }
      return target;
    }
    function _defineProperty2(obj, key, value) {
      if (key in obj) {
        Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
      } else {
        obj[key] = value;
      }
      return obj;
    }
    var unique = (0, _uniqueArray["default"])();
    function uniqueArrayOfTypeValidator(type2) {
      if (typeof type2 !== "function") {
        throw new TypeError("type must be a validator function");
      }
      var mapper = null;
      var name = "uniqueArrayOfType";
      for (var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        rest[_key - 1] = arguments[_key];
      }
      if (rest.length === 1) {
        if (typeof rest[0] === "function") {
          mapper = rest[0];
        } else if (typeof rest[0] === "string") {
          name = rest[0];
        } else {
          throw new TypeError("single input must either be string or function");
        }
      } else if (rest.length === 2) {
        if (typeof rest[0] === "function" && typeof rest[1] === "string") {
          mapper = rest[0];
          name = rest[1];
        } else {
          throw new TypeError("multiple inputs must be in [function, string] order");
        }
      } else if (rest.length > 2) {
        throw new TypeError("only [], [name], [mapper], and [mapper, name] are valid inputs");
      }
      function uniqueArrayOfMapped(props, propName) {
        var propValue = props[propName];
        if (propValue == null) {
          return null;
        }
        var values3 = propValue.map(mapper);
        for (var _len2 = arguments.length, args = new Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
          args[_key2 - 2] = arguments[_key2];
        }
        return unique.apply(void 0, [_objectSpread3(_objectSpread3({}, props), {}, _defineProperty2({}, propName, values3)), propName].concat(args));
      }
      uniqueArrayOfMapped.isRequired = function isRequired(props, propName) {
        var propValue = props[propName];
        for (var _len3 = arguments.length, args = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++) {
          args[_key3 - 2] = arguments[_key3];
        }
        if (propValue == null) {
          return _propTypes.array.isRequired.apply(_propTypes.array, [props, propName].concat(args));
        }
        return uniqueArrayOfMapped.apply(void 0, [props, propName].concat(args));
      };
      var arrayValidator = (0, _propTypes.arrayOf)(type2);
      var uniqueValidator = mapper ? uniqueArrayOfMapped : unique;
      var validator = (0, _and["default"])([arrayValidator, uniqueValidator], name);
      validator.isRequired = (0, _and["default"])([uniqueValidator.isRequired, arrayValidator.isRequired], "".concat(name, ".isRequired"));
      return validator;
    }
  })(uniqueArrayOf);
  return uniqueArrayOf;
}
var build;
var hasRequiredBuild;
function requireBuild() {
  if (hasRequiredBuild) return build;
  hasRequiredBuild = 1;
  var _propTypesExact = _interopRequireDefault(requireSrc());
  var _and = _interopRequireDefault(requireAnd());
  var _between = _interopRequireDefault(requireBetween());
  var _booleanSome = _interopRequireDefault(requireBooleanSome());
  var _childrenHavePropXorChildren = _interopRequireDefault(requireChildrenHavePropXorChildren());
  var _childrenOf = _interopRequireDefault(requireChildrenOf());
  var _childrenOfType = _interopRequireDefault(requireChildrenOfType());
  var _childrenSequenceOf = _interopRequireDefault(requireChildrenSequenceOf());
  var _componentWithName = _interopRequireDefault(requireComponentWithName());
  var _disallowedIf = _interopRequireDefault(requireDisallowedIf());
  var _elementType = _interopRequireDefault(requireElementType());
  var _empty = _interopRequireDefault(requireEmpty());
  var _explicitNull = _interopRequireDefault(requireExplicitNull());
  var _integer = _interopRequireDefault(requireInteger());
  var _keysOf = _interopRequireDefault(requireKeysOf());
  var _mutuallyExclusiveProps = _interopRequireDefault(requireMutuallyExclusiveProps());
  var _mutuallyExclusiveTrueProps = _interopRequireDefault(requireMutuallyExclusiveTrueProps());
  var _nChildren = _interopRequireDefault(requireNChildren());
  var _nonNegativeInteger = _interopRequireDefault(requireNonNegativeInteger());
  var _nonNegativeNumber = _interopRequireDefault(requireNonNegativeNumber());
  var _numericString = _interopRequireDefault(requireNumericString());
  var _object = _interopRequireDefault(requireObject());
  var _or = _interopRequireDefault(requireOr());
  var _predicate = _interopRequireDefault(requirePredicate());
  var _range = _interopRequireDefault(requireRange());
  var _ref3 = _interopRequireDefault(requireRef());
  var _requiredBy = _interopRequireDefault(requireRequiredBy());
  var _restrictedProp = _interopRequireDefault(requireRestrictedProp());
  var _sequenceOf = _interopRequireDefault(requireSequenceOf());
  var _shape = _interopRequireDefault(requireShape());
  var _stringEndsWith = _interopRequireDefault(requireStringEndsWith());
  var _stringStartsWith = _interopRequireDefault(requireStringStartsWith());
  var _uniqueArray = _interopRequireDefault(requireUniqueArray());
  var _uniqueArrayOf = _interopRequireDefault(requireUniqueArrayOf());
  var _valuesOf = _interopRequireDefault(requireValuesOf());
  var _withShape = _interopRequireDefault(requireWithShape());
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  build = {
    and: _and["default"],
    between: _between["default"],
    booleanSome: _booleanSome["default"],
    childrenHavePropXorChildren: _childrenHavePropXorChildren["default"],
    childrenOf: _childrenOf["default"],
    childrenOfType: _childrenOfType["default"],
    childrenSequenceOf: _childrenSequenceOf["default"],
    componentWithName: _componentWithName["default"],
    disallowedIf: _disallowedIf["default"],
    elementType: _elementType["default"],
    empty: _empty["default"],
    explicitNull: _explicitNull["default"],
    forbidExtraProps: _propTypesExact["default"],
    integer: _integer["default"],
    keysOf: _keysOf["default"],
    mutuallyExclusiveProps: _mutuallyExclusiveProps["default"],
    mutuallyExclusiveTrueProps: _mutuallyExclusiveTrueProps["default"],
    nChildren: _nChildren["default"],
    nonNegativeInteger: _nonNegativeInteger["default"],
    nonNegativeNumber: _nonNegativeNumber["default"],
    numericString: _numericString["default"],
    object: _object["default"],
    or: _or["default"],
    predicate: _predicate["default"],
    range: _range["default"],
    ref: _ref3["default"],
    requiredBy: _requiredBy["default"],
    restrictedProp: _restrictedProp["default"],
    sequenceOf: _sequenceOf["default"],
    shape: _shape["default"],
    stringEndsWith: _stringEndsWith["default"],
    stringStartsWith: _stringStartsWith["default"],
    uniqueArray: _uniqueArray["default"],
    uniqueArrayOf: _uniqueArrayOf["default"],
    valuesOf: _valuesOf["default"],
    withShape: _withShape["default"]
  };
  return build;
}
var airbnbPropTypes = process.env.NODE_ENV === "production" ? requireMocks() : requireBuild();
var CAN_USE_DOM = !!(typeof window !== "undefined" && window.document && window.document.createElement);
function testPassiveEventListeners() {
  if (!CAN_USE_DOM) {
    return false;
  }
  if (!window.addEventListener || !window.removeEventListener || !Object.defineProperty) {
    return false;
  }
  var supportsPassiveOption = false;
  try {
    var opts = Object.defineProperty({}, "passive", {
      // eslint-disable-next-line getter-return
      get: /* @__PURE__ */ function() {
        function get2() {
          supportsPassiveOption = true;
        }
        return get2;
      }()
    });
    var noop3 = function noop4() {
    };
    window.addEventListener("testPassiveEventSupport", noop3, opts);
    window.removeEventListener("testPassiveEventSupport", noop3, opts);
  } catch (e3) {
  }
  return supportsPassiveOption;
}
var memoized = void 0;
function canUsePassiveEventListeners() {
  if (memoized === void 0) {
    memoized = testPassiveEventListeners();
  }
  return memoized;
}
function normalizeEventOptions(eventOptions) {
  if (!eventOptions) {
    return void 0;
  }
  if (!canUsePassiveEventListeners()) {
    return !!eventOptions.capture;
  }
  return eventOptions;
}
function eventOptionsKey(normalizedEventOptions) {
  if (!normalizedEventOptions) {
    return 0;
  }
  if (normalizedEventOptions === true) {
    return 100;
  }
  var capture = normalizedEventOptions.capture << 0;
  var passive2 = normalizedEventOptions.passive << 1;
  var once = normalizedEventOptions.once << 2;
  return capture + passive2 + once;
}
function ensureCanMutateNextEventHandlers(eventHandlers) {
  if (eventHandlers.handlers === eventHandlers.nextHandlers) {
    eventHandlers.nextHandlers = eventHandlers.handlers.slice();
  }
}
function TargetEventHandlers(target) {
  this.target = target;
  this.events = {};
}
TargetEventHandlers.prototype.getEventHandlers = /* @__PURE__ */ function() {
  function getEventHandlers(eventName, options2) {
    var key = String(eventName) + " " + String(eventOptionsKey(options2));
    if (!this.events[key]) {
      this.events[key] = {
        handlers: [],
        handleEvent: void 0
      };
      this.events[key].nextHandlers = this.events[key].handlers;
    }
    return this.events[key];
  }
  return getEventHandlers;
}();
TargetEventHandlers.prototype.handleEvent = /* @__PURE__ */ function() {
  function handleEvent(eventName, options2, event) {
    var eventHandlers = this.getEventHandlers(eventName, options2);
    eventHandlers.handlers = eventHandlers.nextHandlers;
    eventHandlers.handlers.forEach(function(handler) {
      if (handler) {
        handler(event);
      }
    });
  }
  return handleEvent;
}();
TargetEventHandlers.prototype.add = /* @__PURE__ */ function() {
  function add(eventName, listener, options2) {
    var _this = this;
    var eventHandlers = this.getEventHandlers(eventName, options2);
    ensureCanMutateNextEventHandlers(eventHandlers);
    if (eventHandlers.nextHandlers.length === 0) {
      eventHandlers.handleEvent = this.handleEvent.bind(this, eventName, options2);
      this.target.addEventListener(eventName, eventHandlers.handleEvent, options2);
    }
    eventHandlers.nextHandlers.push(listener);
    var isSubscribed = true;
    var unsubscribe = /* @__PURE__ */ function() {
      function unsubscribe2() {
        if (!isSubscribed) {
          return;
        }
        isSubscribed = false;
        ensureCanMutateNextEventHandlers(eventHandlers);
        var index2 = eventHandlers.nextHandlers.indexOf(listener);
        eventHandlers.nextHandlers.splice(index2, 1);
        if (eventHandlers.nextHandlers.length === 0) {
          if (_this.target) {
            _this.target.removeEventListener(eventName, eventHandlers.handleEvent, options2);
          }
          eventHandlers.handleEvent = void 0;
        }
      }
      return unsubscribe2;
    }();
    return unsubscribe;
  }
  return add;
}();
var EVENT_HANDLERS_KEY = "__consolidated_events_handlers__";
function addEventListener(target, eventName, listener, options2) {
  if (!target[EVENT_HANDLERS_KEY]) {
    target[EVENT_HANDLERS_KEY] = new TargetEventHandlers(target);
  }
  var normalizedEventOptions = normalizeEventOptions(options2);
  return target[EVENT_HANDLERS_KEY].add(eventName, listener, normalizedEventOptions);
}
var index_esm = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  addEventListener
});
var require$$3 = /* @__PURE__ */ getAugmentedNamespace(index_esm);
var RequireObjectCoercible2 = RequireObjectCoercible$1;
var callBound = callBound$2;
var $isEnumerable = callBound("Object.prototype.propertyIsEnumerable");
var implementation$5 = function values2(O2) {
  var obj = RequireObjectCoercible2(O2);
  var vals = [];
  for (var key in obj) {
    if ($isEnumerable(obj, key)) {
      vals[vals.length] = obj[key];
    }
  }
  return vals;
};
var implementation$4 = implementation$5;
var polyfill$3 = function getPolyfill() {
  return typeof Object.values === "function" ? Object.values : implementation$4;
};
var getPolyfill$2 = polyfill$3;
var define$2 = defineProperties_1;
var shim$3 = function shimValues() {
  var polyfill2 = getPolyfill$2();
  define$2(Object, { values: polyfill2 }, {
    values: function testValues() {
      return Object.values !== polyfill2;
    }
  });
  return polyfill2;
};
var define$1 = defineProperties_1;
var callBind = callBindExports;
var implementation$3 = implementation$5;
var getPolyfill$1 = polyfill$3;
var shim$2 = shim$3;
var polyfill$2 = callBind(getPolyfill$1(), Object);
define$1(polyfill$2, {
  getPolyfill: getPolyfill$1,
  implementation: implementation$3,
  shim: shim$2
});
var object_values = polyfill$2;
var implementation$2 = function contains(other) {
  if (arguments.length < 1) {
    throw new TypeError("1 argument is required");
  }
  if (typeof other !== "object") {
    throw new TypeError("Argument 1 (”other“) to Node.contains must be an instance of Node");
  }
  var node2 = other;
  do {
    if (this === node2) {
      return true;
    }
    if (node2) {
      node2 = node2.parentNode;
    }
  } while (node2);
  return false;
};
var implementation$1 = implementation$2;
var polyfill$1 = function getPolyfill2() {
  if (typeof document !== "undefined") {
    if (document.contains) {
      return document.contains;
    }
    if (document.body && document.body.contains) {
      try {
        if (typeof document.body.contains.call(document, "") === "boolean") {
          return document.body.contains;
        }
      } catch (e3) {
      }
    }
  }
  return implementation$1;
};
var shim$1;
var hasRequiredShim;
function requireShim() {
  if (hasRequiredShim) return shim$1;
  hasRequiredShim = 1;
  var define2 = defineProperties_1;
  var getPolyfill4 = polyfill$1;
  shim$1 = function shimContains() {
    var polyfill2 = getPolyfill4();
    if (typeof document !== "undefined") {
      define2(
        document,
        { contains: polyfill2 },
        { contains: function() {
          return document.contains !== polyfill2;
        } }
      );
      if (typeof Element !== "undefined") {
        define2(
          Element.prototype,
          { contains: polyfill2 },
          { contains: function() {
            return Element.prototype.contains !== polyfill2;
          } }
        );
      }
    }
    return polyfill2;
  };
  return shim$1;
}
var define = defineProperties_1;
var implementation = implementation$2;
var getPolyfill3 = polyfill$1;
var polyfill = getPolyfill3();
var shim = requireShim();
var boundContains = function contains2(node2, other) {
  return polyfill.apply(node2, [other]);
};
define(boundContains, {
  getPolyfill: getPolyfill3,
  implementation,
  shim
});
var document_contains = boundContains;
(function(exports$1) {
  Object.defineProperty(exports$1, "__esModule", {
    value: true
  });
  var _createClass2 = /* @__PURE__ */ function() {
    function defineProperties2(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }
    return function(Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties2(Constructor.prototype, protoProps);
      if (staticProps) defineProperties2(Constructor, staticProps);
      return Constructor;
    };
  }();
  var _react = React__default;
  var _react2 = _interopRequireDefault(_react);
  var _propTypes = propTypesExports;
  var _propTypes2 = _interopRequireDefault(_propTypes);
  var _airbnbPropTypes = airbnbPropTypes;
  var _consolidatedEvents = require$$3;
  var _object = object_values;
  var _object2 = _interopRequireDefault(_object);
  var _document = document_contains;
  var _document2 = _interopRequireDefault(_document);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  function _classCallCheck2(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function _possibleConstructorReturn2(self2, call) {
    if (!self2) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return call && (typeof call === "object" || typeof call === "function") ? call : self2;
  }
  function _inherits2(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }
  var DISPLAY = {
    BLOCK: "block",
    FLEX: "flex",
    INLINE: "inline",
    INLINE_BLOCK: "inline-block",
    CONTENTS: "contents"
  };
  var propTypes = (0, _airbnbPropTypes.forbidExtraProps)({
    children: _propTypes2["default"].node.isRequired,
    onOutsideClick: _propTypes2["default"].func.isRequired,
    disabled: _propTypes2["default"].bool,
    useCapture: _propTypes2["default"].bool,
    display: _propTypes2["default"].oneOf((0, _object2["default"])(DISPLAY))
  });
  var defaultProps2 = {
    disabled: false,
    // `useCapture` is set to true by default so that a `stopPropagation` in the
    // children will not prevent all outside click handlers from firing - maja
    useCapture: true,
    display: DISPLAY.BLOCK
  };
  var OutsideClickHandler2 = function(_React$Component) {
    _inherits2(OutsideClickHandler3, _React$Component);
    function OutsideClickHandler3() {
      var _ref3;
      _classCallCheck2(this, OutsideClickHandler3);
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      var _this = _possibleConstructorReturn2(this, (_ref3 = OutsideClickHandler3.__proto__ || Object.getPrototypeOf(OutsideClickHandler3)).call.apply(_ref3, [this].concat(args)));
      _this.onMouseDown = _this.onMouseDown.bind(_this);
      _this.onMouseUp = _this.onMouseUp.bind(_this);
      _this.setChildNodeRef = _this.setChildNodeRef.bind(_this);
      return _this;
    }
    _createClass2(OutsideClickHandler3, [{
      key: "componentDidMount",
      value: /* @__PURE__ */ function() {
        function componentDidMount() {
          var _props = this.props, disabled = _props.disabled, useCapture = _props.useCapture;
          if (!disabled) this.addMouseDownEventListener(useCapture);
        }
        return componentDidMount;
      }()
    }, {
      key: "componentDidUpdate",
      value: /* @__PURE__ */ function() {
        function componentDidUpdate(_ref22) {
          var prevDisabled = _ref22.disabled;
          var _props2 = this.props, disabled = _props2.disabled, useCapture = _props2.useCapture;
          if (prevDisabled !== disabled) {
            if (disabled) {
              this.removeEventListeners();
            } else {
              this.addMouseDownEventListener(useCapture);
            }
          }
        }
        return componentDidUpdate;
      }()
    }, {
      key: "componentWillUnmount",
      value: /* @__PURE__ */ function() {
        function componentWillUnmount() {
          this.removeEventListeners();
        }
        return componentWillUnmount;
      }()
      // Use mousedown/mouseup to enforce that clicks remain outside the root's
      // descendant tree, even when dragged. This should also get triggered on
      // touch devices.
    }, {
      key: "onMouseDown",
      value: /* @__PURE__ */ function() {
        function onMouseDown(e3) {
          var useCapture = this.props.useCapture;
          var isDescendantOfRoot = this.childNode && (0, _document2["default"])(this.childNode, e3.target);
          if (!isDescendantOfRoot) {
            if (this.removeMouseUp) {
              this.removeMouseUp();
              this.removeMouseUp = null;
            }
            this.removeMouseUp = (0, _consolidatedEvents.addEventListener)(document, "mouseup", this.onMouseUp, { capture: useCapture });
          }
        }
        return onMouseDown;
      }()
      // Use mousedown/mouseup to enforce that clicks remain outside the root's
      // descendant tree, even when dragged. This should also get triggered on
      // touch devices.
    }, {
      key: "onMouseUp",
      value: /* @__PURE__ */ function() {
        function onMouseUp(e3) {
          var onOutsideClick = this.props.onOutsideClick;
          var isDescendantOfRoot = this.childNode && (0, _document2["default"])(this.childNode, e3.target);
          if (this.removeMouseUp) {
            this.removeMouseUp();
            this.removeMouseUp = null;
          }
          if (!isDescendantOfRoot) {
            onOutsideClick(e3);
          }
        }
        return onMouseUp;
      }()
    }, {
      key: "setChildNodeRef",
      value: /* @__PURE__ */ function() {
        function setChildNodeRef(ref2) {
          this.childNode = ref2;
        }
        return setChildNodeRef;
      }()
    }, {
      key: "addMouseDownEventListener",
      value: /* @__PURE__ */ function() {
        function addMouseDownEventListener(useCapture) {
          this.removeMouseDown = (0, _consolidatedEvents.addEventListener)(document, "mousedown", this.onMouseDown, { capture: useCapture });
        }
        return addMouseDownEventListener;
      }()
    }, {
      key: "removeEventListeners",
      value: /* @__PURE__ */ function() {
        function removeEventListeners() {
          if (this.removeMouseDown) this.removeMouseDown();
          if (this.removeMouseUp) this.removeMouseUp();
        }
        return removeEventListeners;
      }()
    }, {
      key: "render",
      value: /* @__PURE__ */ function() {
        function render() {
          var _props3 = this.props, children = _props3.children, display = _props3.display;
          return _react2["default"].createElement(
            "div",
            {
              ref: this.setChildNodeRef,
              style: display !== DISPLAY.BLOCK && (0, _object2["default"])(DISPLAY).includes(display) ? { display } : void 0
            },
            children
          );
        }
        return render;
      }()
    }]);
    return OutsideClickHandler3;
  }(_react2["default"].Component);
  exports$1["default"] = OutsideClickHandler2;
  OutsideClickHandler2.propTypes = propTypes;
  OutsideClickHandler2.defaultProps = defaultProps2;
})(OutsideClickHandler$1);
var reactOutsideClickHandler = OutsideClickHandler$1;
var OutsideClickHandler = /* @__PURE__ */ getDefaultExportFromCjs(reactOutsideClickHandler);
var fromEntries = function fromEntries2(entries) {
  return entries.reduce(function(acc, _ref3) {
    var key = _ref3[0], value = _ref3[1];
    acc[key] = value;
    return acc;
  }, {});
};
var useIsomorphicLayoutEffect$1 = typeof window !== "undefined" && window.document && window.document.createElement ? React.useLayoutEffect : React.useEffect;
var top = "top";
var bottom = "bottom";
var right = "right";
var left = "left";
var auto = "auto";
var basePlacements = [top, bottom, right, left];
var start = "start";
var end = "end";
var clippingParents = "clippingParents";
var viewport$2 = "viewport";
var popper = "popper";
var reference = "reference";
var variationPlacements = /* @__PURE__ */ basePlacements.reduce(function(acc, placement) {
  return acc.concat([placement + "-" + start, placement + "-" + end]);
}, []);
var placements = /* @__PURE__ */ [].concat(basePlacements, [auto]).reduce(function(acc, placement) {
  return acc.concat([placement, placement + "-" + start, placement + "-" + end]);
}, []);
var beforeRead = "beforeRead";
var read = "read";
var afterRead = "afterRead";
var beforeMain = "beforeMain";
var main = "main";
var afterMain = "afterMain";
var beforeWrite = "beforeWrite";
var write = "write";
var afterWrite = "afterWrite";
var modifierPhases = [beforeRead, read, afterRead, beforeMain, main, afterMain, beforeWrite, write, afterWrite];
function getNodeName$2(element) {
  return element ? (element.nodeName || "").toLowerCase() : null;
}
function getWindow$3(node2) {
  if (node2 == null) {
    return window;
  }
  if (node2.toString() !== "[object Window]") {
    var ownerDocument = node2.ownerDocument;
    return ownerDocument ? ownerDocument.defaultView || window : window;
  }
  return node2;
}
function isElement$3(node2) {
  var OwnElement = getWindow$3(node2).Element;
  return node2 instanceof OwnElement || node2 instanceof Element;
}
function isHTMLElement$2(node2) {
  var OwnElement = getWindow$3(node2).HTMLElement;
  return node2 instanceof OwnElement || node2 instanceof HTMLElement;
}
function isShadowRoot$2(node2) {
  if (typeof ShadowRoot === "undefined") {
    return false;
  }
  var OwnElement = getWindow$3(node2).ShadowRoot;
  return node2 instanceof OwnElement || node2 instanceof ShadowRoot;
}
function applyStyles(_ref3) {
  var state = _ref3.state;
  Object.keys(state.elements).forEach(function(name) {
    var style = state.styles[name] || {};
    var attributes = state.attributes[name] || {};
    var element = state.elements[name];
    if (!isHTMLElement$2(element) || !getNodeName$2(element)) {
      return;
    }
    Object.assign(element.style, style);
    Object.keys(attributes).forEach(function(name2) {
      var value = attributes[name2];
      if (value === false) {
        element.removeAttribute(name2);
      } else {
        element.setAttribute(name2, value === true ? "" : value);
      }
    });
  });
}
function effect$2(_ref22) {
  var state = _ref22.state;
  var initialStyles = {
    popper: {
      position: state.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  Object.assign(state.elements.popper.style, initialStyles.popper);
  state.styles = initialStyles;
  if (state.elements.arrow) {
    Object.assign(state.elements.arrow.style, initialStyles.arrow);
  }
  return function() {
    Object.keys(state.elements).forEach(function(name) {
      var element = state.elements[name];
      var attributes = state.attributes[name] || {};
      var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]);
      var style = styleProperties.reduce(function(style2, property2) {
        style2[property2] = "";
        return style2;
      }, {});
      if (!isHTMLElement$2(element) || !getNodeName$2(element)) {
        return;
      }
      Object.assign(element.style, style);
      Object.keys(attributes).forEach(function(attribute) {
        element.removeAttribute(attribute);
      });
    });
  };
}
var applyStyles$1 = {
  name: "applyStyles",
  enabled: true,
  phase: "write",
  fn: applyStyles,
  effect: effect$2,
  requires: ["computeStyles"]
};
function getBasePlacement(placement) {
  return placement.split("-")[0];
}
var max$5 = Math.max;
var min$5 = Math.min;
var round$2 = Math.round;
function getUAString() {
  var uaData = navigator.userAgentData;
  if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) {
    return uaData.brands.map(function(item) {
      return item.brand + "/" + item.version;
    }).join(" ");
  }
  return navigator.userAgent;
}
function isLayoutViewport() {
  return !/^((?!chrome|android).)*safari/i.test(getUAString());
}
function getBoundingClientRect$2(element, includeScale, isFixedStrategy) {
  if (includeScale === void 0) {
    includeScale = false;
  }
  if (isFixedStrategy === void 0) {
    isFixedStrategy = false;
  }
  var clientRect = element.getBoundingClientRect();
  var scaleX = 1;
  var scaleY = 1;
  if (includeScale && isHTMLElement$2(element)) {
    scaleX = element.offsetWidth > 0 ? round$2(clientRect.width) / element.offsetWidth || 1 : 1;
    scaleY = element.offsetHeight > 0 ? round$2(clientRect.height) / element.offsetHeight || 1 : 1;
  }
  var _ref3 = isElement$3(element) ? getWindow$3(element) : window, visualViewport = _ref3.visualViewport;
  var addVisualOffsets = !isLayoutViewport() && isFixedStrategy;
  var x2 = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
  var y2 = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
  var width2 = clientRect.width / scaleX;
  var height2 = clientRect.height / scaleY;
  return {
    width: width2,
    height: height2,
    top: y2,
    right: x2 + width2,
    bottom: y2 + height2,
    left: x2,
    x: x2,
    y: y2
  };
}
function getLayoutRect(element) {
  var clientRect = getBoundingClientRect$2(element);
  var width2 = element.offsetWidth;
  var height2 = element.offsetHeight;
  if (Math.abs(clientRect.width - width2) <= 1) {
    width2 = clientRect.width;
  }
  if (Math.abs(clientRect.height - height2) <= 1) {
    height2 = clientRect.height;
  }
  return {
    x: element.offsetLeft,
    y: element.offsetTop,
    width: width2,
    height: height2
  };
}
function contains3(parent, child) {
  var rootNode = child.getRootNode && child.getRootNode();
  if (parent.contains(child)) {
    return true;
  } else if (rootNode && isShadowRoot$2(rootNode)) {
    var next2 = child;
    do {
      if (next2 && parent.isSameNode(next2)) {
        return true;
      }
      next2 = next2.parentNode || next2.host;
    } while (next2);
  }
  return false;
}
function getComputedStyle$4(element) {
  return getWindow$3(element).getComputedStyle(element);
}
function isTableElement$1(element) {
  return ["table", "td", "th"].indexOf(getNodeName$2(element)) >= 0;
}
function getDocumentElement$2(element) {
  return ((isElement$3(element) ? element.ownerDocument : (
    // $FlowFixMe[prop-missing]
    element.document
  )) || window.document).documentElement;
}
function getParentNode$2(element) {
  if (getNodeName$2(element) === "html") {
    return element;
  }
  return (
    // this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || // DOM Element detected
    (isShadowRoot$2(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    getDocumentElement$2(element)
  );
}
function getTrueOffsetParent$1(element) {
  if (!isHTMLElement$2(element) || // https://github.com/popperjs/popper-core/issues/837
  getComputedStyle$4(element).position === "fixed") {
    return null;
  }
  return element.offsetParent;
}
function getContainingBlock$1(element) {
  var isFirefox = /firefox/i.test(getUAString());
  var isIE = /Trident/i.test(getUAString());
  if (isIE && isHTMLElement$2(element)) {
    var elementCss = getComputedStyle$4(element);
    if (elementCss.position === "fixed") {
      return null;
    }
  }
  var currentNode = getParentNode$2(element);
  if (isShadowRoot$2(currentNode)) {
    currentNode = currentNode.host;
  }
  while (isHTMLElement$2(currentNode) && ["html", "body"].indexOf(getNodeName$2(currentNode)) < 0) {
    var css4 = getComputedStyle$4(currentNode);
    if (css4.transform !== "none" || css4.perspective !== "none" || css4.contain === "paint" || ["transform", "perspective"].indexOf(css4.willChange) !== -1 || isFirefox && css4.willChange === "filter" || isFirefox && css4.filter && css4.filter !== "none") {
      return currentNode;
    } else {
      currentNode = currentNode.parentNode;
    }
  }
  return null;
}
function getOffsetParent$1(element) {
  var window2 = getWindow$3(element);
  var offsetParent = getTrueOffsetParent$1(element);
  while (offsetParent && isTableElement$1(offsetParent) && getComputedStyle$4(offsetParent).position === "static") {
    offsetParent = getTrueOffsetParent$1(offsetParent);
  }
  if (offsetParent && (getNodeName$2(offsetParent) === "html" || getNodeName$2(offsetParent) === "body" && getComputedStyle$4(offsetParent).position === "static")) {
    return window2;
  }
  return offsetParent || getContainingBlock$1(element) || window2;
}
function getMainAxisFromPlacement(placement) {
  return ["top", "bottom"].indexOf(placement) >= 0 ? "x" : "y";
}
function within(min2, value, max2) {
  return max$5(min2, min$5(value, max2));
}
function withinMaxClamp(min2, value, max2) {
  var v2 = within(min2, value, max2);
  return v2 > max2 ? max2 : v2;
}
function getFreshSideObject() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
function mergePaddingObject(paddingObject) {
  return Object.assign({}, getFreshSideObject(), paddingObject);
}
function expandToHashMap(value, keys3) {
  return keys3.reduce(function(hashMap, key) {
    hashMap[key] = value;
    return hashMap;
  }, {});
}
var toPaddingObject = function toPaddingObject2(padding2, state) {
  padding2 = typeof padding2 === "function" ? padding2(Object.assign({}, state.rects, {
    placement: state.placement
  })) : padding2;
  return mergePaddingObject(typeof padding2 !== "number" ? padding2 : expandToHashMap(padding2, basePlacements));
};
function arrow$4(_ref3) {
  var _state$modifiersData$;
  var state = _ref3.state, name = _ref3.name, options2 = _ref3.options;
  var arrowElement = state.elements.arrow;
  var popperOffsets2 = state.modifiersData.popperOffsets;
  var basePlacement = getBasePlacement(state.placement);
  var axis = getMainAxisFromPlacement(basePlacement);
  var isVertical = [left, right].indexOf(basePlacement) >= 0;
  var len = isVertical ? "height" : "width";
  if (!arrowElement || !popperOffsets2) {
    return;
  }
  var paddingObject = toPaddingObject(options2.padding, state);
  var arrowRect = getLayoutRect(arrowElement);
  var minProp = axis === "y" ? top : left;
  var maxProp = axis === "y" ? bottom : right;
  var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets2[axis] - state.rects.popper[len];
  var startDiff = popperOffsets2[axis] - state.rects.reference[axis];
  var arrowOffsetParent = getOffsetParent$1(arrowElement);
  var clientSize = arrowOffsetParent ? axis === "y" ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
  var centerToReference = endDiff / 2 - startDiff / 2;
  var min2 = paddingObject[minProp];
  var max2 = clientSize - arrowRect[len] - paddingObject[maxProp];
  var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
  var offset2 = within(min2, center, max2);
  var axisProp = axis;
  state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset2, _state$modifiersData$.centerOffset = offset2 - center, _state$modifiersData$);
}
function effect$1(_ref22) {
  var state = _ref22.state, options2 = _ref22.options;
  var _options$element = options2.element, arrowElement = _options$element === void 0 ? "[data-popper-arrow]" : _options$element;
  if (arrowElement == null) {
    return;
  }
  if (typeof arrowElement === "string") {
    arrowElement = state.elements.popper.querySelector(arrowElement);
    if (!arrowElement) {
      return;
    }
  }
  if (!contains3(state.elements.popper, arrowElement)) {
    return;
  }
  state.elements.arrow = arrowElement;
}
var arrow$5 = {
  name: "arrow",
  enabled: true,
  phase: "main",
  fn: arrow$4,
  effect: effect$1,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};
function getVariation(placement) {
  return placement.split("-")[1];
}
var unsetSides = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function roundOffsetsByDPR(_ref3, win) {
  var x2 = _ref3.x, y2 = _ref3.y;
  var dpr = win.devicePixelRatio || 1;
  return {
    x: round$2(x2 * dpr) / dpr || 0,
    y: round$2(y2 * dpr) / dpr || 0
  };
}
function mapToStyles(_ref22) {
  var _Object$assign2;
  var popper2 = _ref22.popper, popperRect = _ref22.popperRect, placement = _ref22.placement, variation = _ref22.variation, offsets = _ref22.offsets, position2 = _ref22.position, gpuAcceleration = _ref22.gpuAcceleration, adaptive = _ref22.adaptive, roundOffsets = _ref22.roundOffsets, isFixed = _ref22.isFixed;
  var _offsets$x = offsets.x, x2 = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y2 = _offsets$y === void 0 ? 0 : _offsets$y;
  var _ref3 = typeof roundOffsets === "function" ? roundOffsets({
    x: x2,
    y: y2
  }) : {
    x: x2,
    y: y2
  };
  x2 = _ref3.x;
  y2 = _ref3.y;
  var hasX = offsets.hasOwnProperty("x");
  var hasY = offsets.hasOwnProperty("y");
  var sideX = left;
  var sideY = top;
  var win = window;
  if (adaptive) {
    var offsetParent = getOffsetParent$1(popper2);
    var heightProp = "clientHeight";
    var widthProp = "clientWidth";
    if (offsetParent === getWindow$3(popper2)) {
      offsetParent = getDocumentElement$2(popper2);
      if (getComputedStyle$4(offsetParent).position !== "static" && position2 === "absolute") {
        heightProp = "scrollHeight";
        widthProp = "scrollWidth";
      }
    }
    offsetParent = offsetParent;
    if (placement === top || (placement === left || placement === right) && variation === end) {
      sideY = bottom;
      var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : (
        // $FlowFixMe[prop-missing]
        offsetParent[heightProp]
      );
      y2 -= offsetY - popperRect.height;
      y2 *= gpuAcceleration ? 1 : -1;
    }
    if (placement === left || (placement === top || placement === bottom) && variation === end) {
      sideX = right;
      var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : (
        // $FlowFixMe[prop-missing]
        offsetParent[widthProp]
      );
      x2 -= offsetX - popperRect.width;
      x2 *= gpuAcceleration ? 1 : -1;
    }
  }
  var commonStyles = Object.assign({
    position: position2
  }, adaptive && unsetSides);
  var _ref4 = roundOffsets === true ? roundOffsetsByDPR({
    x: x2,
    y: y2
  }, getWindow$3(popper2)) : {
    x: x2,
    y: y2
  };
  x2 = _ref4.x;
  y2 = _ref4.y;
  if (gpuAcceleration) {
    var _Object$assign;
    return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? "0" : "", _Object$assign[sideX] = hasX ? "0" : "", _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x2 + "px, " + y2 + "px)" : "translate3d(" + x2 + "px, " + y2 + "px, 0)", _Object$assign));
  }
  return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y2 + "px" : "", _Object$assign2[sideX] = hasX ? x2 + "px" : "", _Object$assign2.transform = "", _Object$assign2));
}
function computeStyles(_ref5) {
  var state = _ref5.state, options2 = _ref5.options;
  var _options$gpuAccelerat = options2.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options2.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options2.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
  var commonStyles = {
    placement: getBasePlacement(state.placement),
    variation: getVariation(state.placement),
    popper: state.elements.popper,
    popperRect: state.rects.popper,
    gpuAcceleration,
    isFixed: state.options.strategy === "fixed"
  };
  if (state.modifiersData.popperOffsets != null) {
    state.styles.popper = Object.assign({}, state.styles.popper, mapToStyles(Object.assign({}, commonStyles, {
      offsets: state.modifiersData.popperOffsets,
      position: state.options.strategy,
      adaptive,
      roundOffsets
    })));
  }
  if (state.modifiersData.arrow != null) {
    state.styles.arrow = Object.assign({}, state.styles.arrow, mapToStyles(Object.assign({}, commonStyles, {
      offsets: state.modifiersData.arrow,
      position: "absolute",
      adaptive: false,
      roundOffsets
    })));
  }
  state.attributes.popper = Object.assign({}, state.attributes.popper, {
    "data-popper-placement": state.placement
  });
}
var computeStyles$1 = {
  name: "computeStyles",
  enabled: true,
  phase: "beforeWrite",
  fn: computeStyles,
  data: {}
};
var passive = {
  passive: true
};
function effect(_ref3) {
  var state = _ref3.state, instance = _ref3.instance, options2 = _ref3.options;
  var _options$scroll = options2.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options2.resize, resize = _options$resize === void 0 ? true : _options$resize;
  var window2 = getWindow$3(state.elements.popper);
  var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
  if (scroll) {
    scrollParents.forEach(function(scrollParent) {
      scrollParent.addEventListener("scroll", instance.update, passive);
    });
  }
  if (resize) {
    window2.addEventListener("resize", instance.update, passive);
  }
  return function() {
    if (scroll) {
      scrollParents.forEach(function(scrollParent) {
        scrollParent.removeEventListener("scroll", instance.update, passive);
      });
    }
    if (resize) {
      window2.removeEventListener("resize", instance.update, passive);
    }
  };
}
var eventListeners = {
  name: "eventListeners",
  enabled: true,
  phase: "write",
  fn: function fn() {
  },
  effect,
  data: {}
};
var hash$2 = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function getOppositePlacement$1(placement) {
  return placement.replace(/left|right|bottom|top/g, function(matched) {
    return hash$2[matched];
  });
}
var hash$1 = {
  start: "end",
  end: "start"
};
function getOppositeVariationPlacement(placement) {
  return placement.replace(/start|end/g, function(matched) {
    return hash$1[matched];
  });
}
function getWindowScroll(node2) {
  var win = getWindow$3(node2);
  var scrollLeft = win.pageXOffset;
  var scrollTop = win.pageYOffset;
  return {
    scrollLeft,
    scrollTop
  };
}
function getWindowScrollBarX$1(element) {
  return getBoundingClientRect$2(getDocumentElement$2(element)).left + getWindowScroll(element).scrollLeft;
}
function getViewportRect$1(element, strategy) {
  var win = getWindow$3(element);
  var html = getDocumentElement$2(element);
  var visualViewport = win.visualViewport;
  var width2 = html.clientWidth;
  var height2 = html.clientHeight;
  var x2 = 0;
  var y2 = 0;
  if (visualViewport) {
    width2 = visualViewport.width;
    height2 = visualViewport.height;
    var layoutViewport = isLayoutViewport();
    if (layoutViewport || !layoutViewport && strategy === "fixed") {
      x2 = visualViewport.offsetLeft;
      y2 = visualViewport.offsetTop;
    }
  }
  return {
    width: width2,
    height: height2,
    x: x2 + getWindowScrollBarX$1(element),
    y: y2
  };
}
function getDocumentRect$1(element) {
  var _element$ownerDocumen;
  var html = getDocumentElement$2(element);
  var winScroll = getWindowScroll(element);
  var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
  var width2 = max$5(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
  var height2 = max$5(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
  var x2 = -winScroll.scrollLeft + getWindowScrollBarX$1(element);
  var y2 = -winScroll.scrollTop;
  if (getComputedStyle$4(body || html).direction === "rtl") {
    x2 += max$5(html.clientWidth, body ? body.clientWidth : 0) - width2;
  }
  return {
    width: width2,
    height: height2,
    x: x2,
    y: y2
  };
}
function isScrollParent(element) {
  var _getComputedStyle = getComputedStyle$4(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
  return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}
function getScrollParent$1(node2) {
  if (["html", "body", "#document"].indexOf(getNodeName$2(node2)) >= 0) {
    return node2.ownerDocument.body;
  }
  if (isHTMLElement$2(node2) && isScrollParent(node2)) {
    return node2;
  }
  return getScrollParent$1(getParentNode$2(node2));
}
function listScrollParents(element, list) {
  var _element$ownerDocumen;
  if (list === void 0) {
    list = [];
  }
  var scrollParent = getScrollParent$1(element);
  var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
  var win = getWindow$3(scrollParent);
  var target = isBody ? [win].concat(win.visualViewport || [], isScrollParent(scrollParent) ? scrollParent : []) : scrollParent;
  var updatedList = list.concat(target);
  return isBody ? updatedList : (
    // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
    updatedList.concat(listScrollParents(getParentNode$2(target)))
  );
}
function rectToClientRect$2(rect) {
  return Object.assign({}, rect, {
    left: rect.x,
    top: rect.y,
    right: rect.x + rect.width,
    bottom: rect.y + rect.height
  });
}
function getInnerBoundingClientRect$1(element, strategy) {
  var rect = getBoundingClientRect$2(element, false, strategy === "fixed");
  rect.top = rect.top + element.clientTop;
  rect.left = rect.left + element.clientLeft;
  rect.bottom = rect.top + element.clientHeight;
  rect.right = rect.left + element.clientWidth;
  rect.width = element.clientWidth;
  rect.height = element.clientHeight;
  rect.x = rect.left;
  rect.y = rect.top;
  return rect;
}
function getClientRectFromMixedType(element, clippingParent, strategy) {
  return clippingParent === viewport$2 ? rectToClientRect$2(getViewportRect$1(element, strategy)) : isElement$3(clippingParent) ? getInnerBoundingClientRect$1(clippingParent, strategy) : rectToClientRect$2(getDocumentRect$1(getDocumentElement$2(element)));
}
function getClippingParents(element) {
  var clippingParents2 = listScrollParents(getParentNode$2(element));
  var canEscapeClipping = ["absolute", "fixed"].indexOf(getComputedStyle$4(element).position) >= 0;
  var clipperElement = canEscapeClipping && isHTMLElement$2(element) ? getOffsetParent$1(element) : element;
  if (!isElement$3(clipperElement)) {
    return [];
  }
  return clippingParents2.filter(function(clippingParent) {
    return isElement$3(clippingParent) && contains3(clippingParent, clipperElement) && getNodeName$2(clippingParent) !== "body";
  });
}
function getClippingRect$1(element, boundary, rootBoundary, strategy) {
  var mainClippingParents = boundary === "clippingParents" ? getClippingParents(element) : [].concat(boundary);
  var clippingParents2 = [].concat(mainClippingParents, [rootBoundary]);
  var firstClippingParent = clippingParents2[0];
  var clippingRect = clippingParents2.reduce(function(accRect, clippingParent) {
    var rect = getClientRectFromMixedType(element, clippingParent, strategy);
    accRect.top = max$5(rect.top, accRect.top);
    accRect.right = min$5(rect.right, accRect.right);
    accRect.bottom = min$5(rect.bottom, accRect.bottom);
    accRect.left = max$5(rect.left, accRect.left);
    return accRect;
  }, getClientRectFromMixedType(element, firstClippingParent, strategy));
  clippingRect.width = clippingRect.right - clippingRect.left;
  clippingRect.height = clippingRect.bottom - clippingRect.top;
  clippingRect.x = clippingRect.left;
  clippingRect.y = clippingRect.top;
  return clippingRect;
}
function computeOffsets(_ref3) {
  var reference2 = _ref3.reference, element = _ref3.element, placement = _ref3.placement;
  var basePlacement = placement ? getBasePlacement(placement) : null;
  var variation = placement ? getVariation(placement) : null;
  var commonX = reference2.x + reference2.width / 2 - element.width / 2;
  var commonY = reference2.y + reference2.height / 2 - element.height / 2;
  var offsets;
  switch (basePlacement) {
    case top:
      offsets = {
        x: commonX,
        y: reference2.y - element.height
      };
      break;
    case bottom:
      offsets = {
        x: commonX,
        y: reference2.y + reference2.height
      };
      break;
    case right:
      offsets = {
        x: reference2.x + reference2.width,
        y: commonY
      };
      break;
    case left:
      offsets = {
        x: reference2.x - element.width,
        y: commonY
      };
      break;
    default:
      offsets = {
        x: reference2.x,
        y: reference2.y
      };
  }
  var mainAxis = basePlacement ? getMainAxisFromPlacement(basePlacement) : null;
  if (mainAxis != null) {
    var len = mainAxis === "y" ? "height" : "width";
    switch (variation) {
      case start:
        offsets[mainAxis] = offsets[mainAxis] - (reference2[len] / 2 - element[len] / 2);
        break;
      case end:
        offsets[mainAxis] = offsets[mainAxis] + (reference2[len] / 2 - element[len] / 2);
        break;
    }
  }
  return offsets;
}
function detectOverflow$2(state, options2) {
  if (options2 === void 0) {
    options2 = {};
  }
  var _options = options2, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? clippingParents : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? viewport$2 : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? popper : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding2 = _options$padding === void 0 ? 0 : _options$padding;
  var paddingObject = mergePaddingObject(typeof padding2 !== "number" ? padding2 : expandToHashMap(padding2, basePlacements));
  var altContext = elementContext === popper ? reference : popper;
  var popperRect = state.rects.popper;
  var element = state.elements[altBoundary ? altContext : elementContext];
  var clippingClientRect = getClippingRect$1(isElement$3(element) ? element : element.contextElement || getDocumentElement$2(state.elements.popper), boundary, rootBoundary, strategy);
  var referenceClientRect = getBoundingClientRect$2(state.elements.reference);
  var popperOffsets2 = computeOffsets({
    reference: referenceClientRect,
    element: popperRect,
    placement
  });
  var popperClientRect = rectToClientRect$2(Object.assign({}, popperRect, popperOffsets2));
  var elementClientRect = elementContext === popper ? popperClientRect : referenceClientRect;
  var overflowOffsets = {
    top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
    bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
    left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
    right: elementClientRect.right - clippingClientRect.right + paddingObject.right
  };
  var offsetData = state.modifiersData.offset;
  if (elementContext === popper && offsetData) {
    var offset2 = offsetData[placement];
    Object.keys(overflowOffsets).forEach(function(key) {
      var multiply = [right, bottom].indexOf(key) >= 0 ? 1 : -1;
      var axis = [top, bottom].indexOf(key) >= 0 ? "y" : "x";
      overflowOffsets[key] += offset2[axis] * multiply;
    });
  }
  return overflowOffsets;
}
function computeAutoPlacement(state, options2) {
  if (options2 === void 0) {
    options2 = {};
  }
  var _options = options2, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding2 = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? placements : _options$allowedAutoP;
  var variation = getVariation(placement);
  var placements$1 = variation ? flipVariations ? variationPlacements : variationPlacements.filter(function(placement2) {
    return getVariation(placement2) === variation;
  }) : basePlacements;
  var allowedPlacements = placements$1.filter(function(placement2) {
    return allowedAutoPlacements.indexOf(placement2) >= 0;
  });
  if (allowedPlacements.length === 0) {
    allowedPlacements = placements$1;
  }
  var overflows = allowedPlacements.reduce(function(acc, placement2) {
    acc[placement2] = detectOverflow$2(state, {
      placement: placement2,
      boundary,
      rootBoundary,
      padding: padding2
    })[getBasePlacement(placement2)];
    return acc;
  }, {});
  return Object.keys(overflows).sort(function(a2, b2) {
    return overflows[a2] - overflows[b2];
  });
}
function getExpandedFallbackPlacements(placement) {
  if (getBasePlacement(placement) === auto) {
    return [];
  }
  var oppositePlacement = getOppositePlacement$1(placement);
  return [getOppositeVariationPlacement(placement), oppositePlacement, getOppositeVariationPlacement(oppositePlacement)];
}
function flip$3(_ref3) {
  var state = _ref3.state, options2 = _ref3.options, name = _ref3.name;
  if (state.modifiersData[name]._skip) {
    return;
  }
  var _options$mainAxis = options2.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options2.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options2.fallbackPlacements, padding2 = options2.padding, boundary = options2.boundary, rootBoundary = options2.rootBoundary, altBoundary = options2.altBoundary, _options$flipVariatio = options2.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options2.allowedAutoPlacements;
  var preferredPlacement = state.options.placement;
  var basePlacement = getBasePlacement(preferredPlacement);
  var isBasePlacement = basePlacement === preferredPlacement;
  var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [getOppositePlacement$1(preferredPlacement)] : getExpandedFallbackPlacements(preferredPlacement));
  var placements2 = [preferredPlacement].concat(fallbackPlacements).reduce(function(acc, placement2) {
    return acc.concat(getBasePlacement(placement2) === auto ? computeAutoPlacement(state, {
      placement: placement2,
      boundary,
      rootBoundary,
      padding: padding2,
      flipVariations,
      allowedAutoPlacements
    }) : placement2);
  }, []);
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var checksMap = /* @__PURE__ */ new Map();
  var makeFallbackChecks = true;
  var firstFittingPlacement = placements2[0];
  for (var i = 0; i < placements2.length; i++) {
    var placement = placements2[i];
    var _basePlacement = getBasePlacement(placement);
    var isStartVariation = getVariation(placement) === start;
    var isVertical = [top, bottom].indexOf(_basePlacement) >= 0;
    var len = isVertical ? "width" : "height";
    var overflow = detectOverflow$2(state, {
      placement,
      boundary,
      rootBoundary,
      altBoundary,
      padding: padding2
    });
    var mainVariationSide = isVertical ? isStartVariation ? right : left : isStartVariation ? bottom : top;
    if (referenceRect[len] > popperRect[len]) {
      mainVariationSide = getOppositePlacement$1(mainVariationSide);
    }
    var altVariationSide = getOppositePlacement$1(mainVariationSide);
    var checks = [];
    if (checkMainAxis) {
      checks.push(overflow[_basePlacement] <= 0);
    }
    if (checkAltAxis) {
      checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
    }
    if (checks.every(function(check) {
      return check;
    })) {
      firstFittingPlacement = placement;
      makeFallbackChecks = false;
      break;
    }
    checksMap.set(placement, checks);
  }
  if (makeFallbackChecks) {
    var numberOfChecks = flipVariations ? 3 : 1;
    var _loop = function _loop2(_i2) {
      var fittingPlacement = placements2.find(function(placement2) {
        var checks2 = checksMap.get(placement2);
        if (checks2) {
          return checks2.slice(0, _i2).every(function(check) {
            return check;
          });
        }
      });
      if (fittingPlacement) {
        firstFittingPlacement = fittingPlacement;
        return "break";
      }
    };
    for (var _i = numberOfChecks; _i > 0; _i--) {
      var _ret = _loop(_i);
      if (_ret === "break") break;
    }
  }
  if (state.placement !== firstFittingPlacement) {
    state.modifiersData[name]._skip = true;
    state.placement = firstFittingPlacement;
    state.reset = true;
  }
}
var flip$4 = {
  name: "flip",
  enabled: true,
  phase: "main",
  fn: flip$3,
  requiresIfExists: ["offset"],
  data: {
    _skip: false
  }
};
function getSideOffsets(overflow, rect, preventedOffsets) {
  if (preventedOffsets === void 0) {
    preventedOffsets = {
      x: 0,
      y: 0
    };
  }
  return {
    top: overflow.top - rect.height - preventedOffsets.y,
    right: overflow.right - rect.width + preventedOffsets.x,
    bottom: overflow.bottom - rect.height + preventedOffsets.y,
    left: overflow.left - rect.width - preventedOffsets.x
  };
}
function isAnySideFullyClipped(overflow) {
  return [top, right, bottom, left].some(function(side) {
    return overflow[side] >= 0;
  });
}
function hide(_ref3) {
  var state = _ref3.state, name = _ref3.name;
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var preventedOffsets = state.modifiersData.preventOverflow;
  var referenceOverflow = detectOverflow$2(state, {
    elementContext: "reference"
  });
  var popperAltOverflow = detectOverflow$2(state, {
    altBoundary: true
  });
  var referenceClippingOffsets = getSideOffsets(referenceOverflow, referenceRect);
  var popperEscapeOffsets = getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
  var isReferenceHidden = isAnySideFullyClipped(referenceClippingOffsets);
  var hasPopperEscaped = isAnySideFullyClipped(popperEscapeOffsets);
  state.modifiersData[name] = {
    referenceClippingOffsets,
    popperEscapeOffsets,
    isReferenceHidden,
    hasPopperEscaped
  };
  state.attributes.popper = Object.assign({}, state.attributes.popper, {
    "data-popper-reference-hidden": isReferenceHidden,
    "data-popper-escaped": hasPopperEscaped
  });
}
var hide$1 = {
  name: "hide",
  enabled: true,
  phase: "main",
  requiresIfExists: ["preventOverflow"],
  fn: hide
};
function distanceAndSkiddingToXY(placement, rects, offset2) {
  var basePlacement = getBasePlacement(placement);
  var invertDistance = [left, top].indexOf(basePlacement) >= 0 ? -1 : 1;
  var _ref3 = typeof offset2 === "function" ? offset2(Object.assign({}, rects, {
    placement
  })) : offset2, skidding = _ref3[0], distance = _ref3[1];
  skidding = skidding || 0;
  distance = (distance || 0) * invertDistance;
  return [left, right].indexOf(basePlacement) >= 0 ? {
    x: distance,
    y: skidding
  } : {
    x: skidding,
    y: distance
  };
}
function offset$3(_ref22) {
  var state = _ref22.state, options2 = _ref22.options, name = _ref22.name;
  var _options$offset = options2.offset, offset2 = _options$offset === void 0 ? [0, 0] : _options$offset;
  var data = placements.reduce(function(acc, placement) {
    acc[placement] = distanceAndSkiddingToXY(placement, state.rects, offset2);
    return acc;
  }, {});
  var _data$state$placement = data[state.placement], x2 = _data$state$placement.x, y2 = _data$state$placement.y;
  if (state.modifiersData.popperOffsets != null) {
    state.modifiersData.popperOffsets.x += x2;
    state.modifiersData.popperOffsets.y += y2;
  }
  state.modifiersData[name] = data;
}
var offset$4 = {
  name: "offset",
  enabled: true,
  phase: "main",
  requires: ["popperOffsets"],
  fn: offset$3
};
function popperOffsets(_ref3) {
  var state = _ref3.state, name = _ref3.name;
  state.modifiersData[name] = computeOffsets({
    reference: state.rects.reference,
    element: state.rects.popper,
    placement: state.placement
  });
}
var popperOffsets$1 = {
  name: "popperOffsets",
  enabled: true,
  phase: "read",
  fn: popperOffsets,
  data: {}
};
function getAltAxis(axis) {
  return axis === "x" ? "y" : "x";
}
function preventOverflow(_ref3) {
  var state = _ref3.state, options2 = _ref3.options, name = _ref3.name;
  var _options$mainAxis = options2.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options2.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options2.boundary, rootBoundary = options2.rootBoundary, altBoundary = options2.altBoundary, padding2 = options2.padding, _options$tether = options2.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options2.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
  var overflow = detectOverflow$2(state, {
    boundary,
    rootBoundary,
    padding: padding2,
    altBoundary
  });
  var basePlacement = getBasePlacement(state.placement);
  var variation = getVariation(state.placement);
  var isBasePlacement = !variation;
  var mainAxis = getMainAxisFromPlacement(basePlacement);
  var altAxis = getAltAxis(mainAxis);
  var popperOffsets2 = state.modifiersData.popperOffsets;
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var tetherOffsetValue = typeof tetherOffset === "function" ? tetherOffset(Object.assign({}, state.rects, {
    placement: state.placement
  })) : tetherOffset;
  var normalizedTetherOffsetValue = typeof tetherOffsetValue === "number" ? {
    mainAxis: tetherOffsetValue,
    altAxis: tetherOffsetValue
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, tetherOffsetValue);
  var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
  var data = {
    x: 0,
    y: 0
  };
  if (!popperOffsets2) {
    return;
  }
  if (checkMainAxis) {
    var _offsetModifierState$;
    var mainSide = mainAxis === "y" ? top : left;
    var altSide = mainAxis === "y" ? bottom : right;
    var len = mainAxis === "y" ? "height" : "width";
    var offset2 = popperOffsets2[mainAxis];
    var min2 = offset2 + overflow[mainSide];
    var max2 = offset2 - overflow[altSide];
    var additive = tether ? -popperRect[len] / 2 : 0;
    var minLen = variation === start ? referenceRect[len] : popperRect[len];
    var maxLen = variation === start ? -popperRect[len] : -referenceRect[len];
    var arrowElement = state.elements.arrow;
    var arrowRect = tether && arrowElement ? getLayoutRect(arrowElement) : {
      width: 0,
      height: 0
    };
    var arrowPaddingObject = state.modifiersData["arrow#persistent"] ? state.modifiersData["arrow#persistent"].padding : getFreshSideObject();
    var arrowPaddingMin = arrowPaddingObject[mainSide];
    var arrowPaddingMax = arrowPaddingObject[altSide];
    var arrowLen = within(0, referenceRect[len], arrowRect[len]);
    var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
    var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
    var arrowOffsetParent = state.elements.arrow && getOffsetParent$1(state.elements.arrow);
    var clientOffset = arrowOffsetParent ? mainAxis === "y" ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
    var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
    var tetherMin = offset2 + minOffset - offsetModifierValue - clientOffset;
    var tetherMax = offset2 + maxOffset - offsetModifierValue;
    var preventedOffset = within(tether ? min$5(min2, tetherMin) : min2, offset2, tether ? max$5(max2, tetherMax) : max2);
    popperOffsets2[mainAxis] = preventedOffset;
    data[mainAxis] = preventedOffset - offset2;
  }
  if (checkAltAxis) {
    var _offsetModifierState$2;
    var _mainSide = mainAxis === "x" ? top : left;
    var _altSide = mainAxis === "x" ? bottom : right;
    var _offset = popperOffsets2[altAxis];
    var _len = altAxis === "y" ? "height" : "width";
    var _min = _offset + overflow[_mainSide];
    var _max = _offset - overflow[_altSide];
    var isOriginSide = [top, left].indexOf(basePlacement) !== -1;
    var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
    var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
    var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
    var _preventedOffset = tether && isOriginSide ? withinMaxClamp(_tetherMin, _offset, _tetherMax) : within(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
    popperOffsets2[altAxis] = _preventedOffset;
    data[altAxis] = _preventedOffset - _offset;
  }
  state.modifiersData[name] = data;
}
var preventOverflow$1 = {
  name: "preventOverflow",
  enabled: true,
  phase: "main",
  fn: preventOverflow,
  requiresIfExists: ["offset"]
};
function getHTMLElementScroll(element) {
  return {
    scrollLeft: element.scrollLeft,
    scrollTop: element.scrollTop
  };
}
function getNodeScroll$1(node2) {
  if (node2 === getWindow$3(node2) || !isHTMLElement$2(node2)) {
    return getWindowScroll(node2);
  } else {
    return getHTMLElementScroll(node2);
  }
}
function isElementScaled(element) {
  var rect = element.getBoundingClientRect();
  var scaleX = round$2(rect.width) / element.offsetWidth || 1;
  var scaleY = round$2(rect.height) / element.offsetHeight || 1;
  return scaleX !== 1 || scaleY !== 1;
}
function getCompositeRect(elementOrVirtualElement, offsetParent, isFixed) {
  if (isFixed === void 0) {
    isFixed = false;
  }
  var isOffsetParentAnElement = isHTMLElement$2(offsetParent);
  var offsetParentIsScaled = isHTMLElement$2(offsetParent) && isElementScaled(offsetParent);
  var documentElement = getDocumentElement$2(offsetParent);
  var rect = getBoundingClientRect$2(elementOrVirtualElement, offsetParentIsScaled, isFixed);
  var scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  var offsets = {
    x: 0,
    y: 0
  };
  if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
    if (getNodeName$2(offsetParent) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
    isScrollParent(documentElement)) {
      scroll = getNodeScroll$1(offsetParent);
    }
    if (isHTMLElement$2(offsetParent)) {
      offsets = getBoundingClientRect$2(offsetParent, true);
      offsets.x += offsetParent.clientLeft;
      offsets.y += offsetParent.clientTop;
    } else if (documentElement) {
      offsets.x = getWindowScrollBarX$1(documentElement);
    }
  }
  return {
    x: rect.left + scroll.scrollLeft - offsets.x,
    y: rect.top + scroll.scrollTop - offsets.y,
    width: rect.width,
    height: rect.height
  };
}
function order(modifiers) {
  var map = /* @__PURE__ */ new Map();
  var visited = /* @__PURE__ */ new Set();
  var result = [];
  modifiers.forEach(function(modifier) {
    map.set(modifier.name, modifier);
  });
  function sort(modifier) {
    visited.add(modifier.name);
    var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
    requires.forEach(function(dep) {
      if (!visited.has(dep)) {
        var depModifier = map.get(dep);
        if (depModifier) {
          sort(depModifier);
        }
      }
    });
    result.push(modifier);
  }
  modifiers.forEach(function(modifier) {
    if (!visited.has(modifier.name)) {
      sort(modifier);
    }
  });
  return result;
}
function orderModifiers(modifiers) {
  var orderedModifiers = order(modifiers);
  return modifierPhases.reduce(function(acc, phase) {
    return acc.concat(orderedModifiers.filter(function(modifier) {
      return modifier.phase === phase;
    }));
  }, []);
}
function debounce(fn2) {
  var pending;
  return function() {
    if (!pending) {
      pending = new Promise(function(resolve) {
        Promise.resolve().then(function() {
          pending = void 0;
          resolve(fn2());
        });
      });
    }
    return pending;
  };
}
function mergeByName(modifiers) {
  var merged = modifiers.reduce(function(merged2, current) {
    var existing = merged2[current.name];
    merged2[current.name] = existing ? Object.assign({}, existing, current, {
      options: Object.assign({}, existing.options, current.options),
      data: Object.assign({}, existing.data, current.data)
    }) : current;
    return merged2;
  }, {});
  return Object.keys(merged).map(function(key) {
    return merged[key];
  });
}
var DEFAULT_OPTIONS = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function areValidElements() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  return !args.some(function(element) {
    return !(element && typeof element.getBoundingClientRect === "function");
  });
}
function popperGenerator(generatorOptions) {
  if (generatorOptions === void 0) {
    generatorOptions = {};
  }
  var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers2 = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions2 = _generatorOptions$def2 === void 0 ? DEFAULT_OPTIONS : _generatorOptions$def2;
  return function createPopper2(reference2, popper2, options2) {
    if (options2 === void 0) {
      options2 = defaultOptions2;
    }
    var state = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, DEFAULT_OPTIONS, defaultOptions2),
      modifiersData: {},
      elements: {
        reference: reference2,
        popper: popper2
      },
      attributes: {},
      styles: {}
    };
    var effectCleanupFns = [];
    var isDestroyed = false;
    var instance = {
      state,
      setOptions: function setOptions(setOptionsAction) {
        var options3 = typeof setOptionsAction === "function" ? setOptionsAction(state.options) : setOptionsAction;
        cleanupModifierEffects();
        state.options = Object.assign({}, defaultOptions2, state.options, options3);
        state.scrollParents = {
          reference: isElement$3(reference2) ? listScrollParents(reference2) : reference2.contextElement ? listScrollParents(reference2.contextElement) : [],
          popper: listScrollParents(popper2)
        };
        var orderedModifiers = orderModifiers(mergeByName([].concat(defaultModifiers2, state.options.modifiers)));
        state.orderedModifiers = orderedModifiers.filter(function(m2) {
          return m2.enabled;
        });
        runModifierEffects();
        return instance.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function forceUpdate() {
        if (isDestroyed) {
          return;
        }
        var _state$elements = state.elements, reference3 = _state$elements.reference, popper3 = _state$elements.popper;
        if (!areValidElements(reference3, popper3)) {
          return;
        }
        state.rects = {
          reference: getCompositeRect(reference3, getOffsetParent$1(popper3), state.options.strategy === "fixed"),
          popper: getLayoutRect(popper3)
        };
        state.reset = false;
        state.placement = state.options.placement;
        state.orderedModifiers.forEach(function(modifier) {
          return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
        });
        for (var index2 = 0; index2 < state.orderedModifiers.length; index2++) {
          if (state.reset === true) {
            state.reset = false;
            index2 = -1;
            continue;
          }
          var _state$orderedModifie = state.orderedModifiers[index2], fn2 = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
          if (typeof fn2 === "function") {
            state = fn2({
              state,
              options: _options,
              name,
              instance
            }) || state;
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: debounce(function() {
        return new Promise(function(resolve) {
          instance.forceUpdate();
          resolve(state);
        });
      }),
      destroy: function destroy() {
        cleanupModifierEffects();
        isDestroyed = true;
      }
    };
    if (!areValidElements(reference2, popper2)) {
      return instance;
    }
    instance.setOptions(options2).then(function(state2) {
      if (!isDestroyed && options2.onFirstUpdate) {
        options2.onFirstUpdate(state2);
      }
    });
    function runModifierEffects() {
      state.orderedModifiers.forEach(function(_ref3) {
        var name = _ref3.name, _ref$options = _ref3.options, options3 = _ref$options === void 0 ? {} : _ref$options, effect2 = _ref3.effect;
        if (typeof effect2 === "function") {
          var cleanupFn = effect2({
            state,
            name,
            instance,
            options: options3
          });
          var noopFn = function noopFn2() {
          };
          effectCleanupFns.push(cleanupFn || noopFn);
        }
      });
    }
    function cleanupModifierEffects() {
      effectCleanupFns.forEach(function(fn2) {
        return fn2();
      });
      effectCleanupFns = [];
    }
    return instance;
  };
}
var defaultModifiers = [eventListeners, popperOffsets$1, computeStyles$1, applyStyles$1, offset$4, flip$4, preventOverflow$1, arrow$5, hide$1];
var createPopper = /* @__PURE__ */ popperGenerator({
  defaultModifiers
});
var EMPTY_MODIFIERS = [];
var usePopper = function usePopper2(referenceElement, popperElement, options2) {
  if (options2 === void 0) {
    options2 = {};
  }
  var prevOptions = React.useRef(null);
  var optionsWithDefaults = {
    onFirstUpdate: options2.onFirstUpdate,
    placement: options2.placement || "bottom",
    strategy: options2.strategy || "absolute",
    modifiers: options2.modifiers || EMPTY_MODIFIERS
  };
  var _React$useState = React.useState({
    styles: {
      popper: {
        position: optionsWithDefaults.strategy,
        left: "0",
        top: "0"
      },
      arrow: {
        position: "absolute"
      }
    },
    attributes: {}
  }), state = _React$useState[0], setState = _React$useState[1];
  var updateStateModifier = React.useMemo(function() {
    return {
      name: "updateState",
      enabled: true,
      phase: "write",
      fn: function fn2(_ref3) {
        var state2 = _ref3.state;
        var elements = Object.keys(state2.elements);
        ReactDOM.flushSync(function() {
          setState({
            styles: fromEntries(elements.map(function(element) {
              return [element, state2.styles[element] || {}];
            })),
            attributes: fromEntries(elements.map(function(element) {
              return [element, state2.attributes[element]];
            }))
          });
        });
      },
      requires: ["computeStyles"]
    };
  }, []);
  var popperOptions = React.useMemo(function() {
    var newOptions = {
      onFirstUpdate: optionsWithDefaults.onFirstUpdate,
      placement: optionsWithDefaults.placement,
      strategy: optionsWithDefaults.strategy,
      modifiers: [].concat(optionsWithDefaults.modifiers, [updateStateModifier, {
        name: "applyStyles",
        enabled: false
      }])
    };
    if (isEqual$3(prevOptions.current, newOptions)) {
      return prevOptions.current || newOptions;
    } else {
      prevOptions.current = newOptions;
      return newOptions;
    }
  }, [optionsWithDefaults.onFirstUpdate, optionsWithDefaults.placement, optionsWithDefaults.strategy, optionsWithDefaults.modifiers, updateStateModifier]);
  var popperInstanceRef = React.useRef();
  useIsomorphicLayoutEffect$1(function() {
    if (popperInstanceRef.current) {
      popperInstanceRef.current.setOptions(popperOptions);
    }
  }, [popperOptions]);
  useIsomorphicLayoutEffect$1(function() {
    if (referenceElement == null || popperElement == null) {
      return;
    }
    var createPopper$1 = options2.createPopper || createPopper;
    var popperInstance = createPopper$1(referenceElement, popperElement, popperOptions);
    popperInstanceRef.current = popperInstance;
    return function() {
      popperInstance.destroy();
      popperInstanceRef.current = null;
    };
  }, [referenceElement, popperElement, options2.createPopper]);
  return {
    state: popperInstanceRef.current ? popperInstanceRef.current.state : null,
    styles: state.styles,
    attributes: state.attributes,
    update: popperInstanceRef.current ? popperInstanceRef.current.update : null,
    forceUpdate: popperInstanceRef.current ? popperInstanceRef.current.forceUpdate : null
  };
};
function useMenu(opts) {
  const {
    closeOnSelect = true,
    initialValue
  } = opts || {};
  const [anchor, anchorRef] = useCallbackRef();
  const [visible, setVisible] = useState(false);
  const [selected, setSelected] = useState(initialValue);
  const closeMenu = useCallback(() => setVisible(false), []);
  const toggleMenu = useCallback(() => setVisible((old) => !old), []);
  const handleMenuItemClick = useCallback((value) => {
    setSelected(value);
    if (closeOnSelect) closeMenu();
  }, [closeMenu, closeOnSelect]);
  return {
    anchor,
    visible,
    selected,
    anchorRef,
    toggleMenu,
    closeMenu,
    handleMenuItemClick
  };
}
function useCallbackRef(initialValue) {
  const [ref2, setRef] = useState(initialValue);
  const callbackRef = useCallback((node2) => {
    if (node2 === null) return;
    setRef(node2);
  }, []);
  return [ref2, callbackRef];
}
var lodash_isequal = { exports: {} };
lodash_isequal.exports;
(function(module, exports$1) {
  var LARGE_ARRAY_SIZE2 = 200;
  var HASH_UNDEFINED2 = "__lodash_hash_undefined__";
  var COMPARE_PARTIAL_FLAG2 = 1, COMPARE_UNORDERED_FLAG2 = 2;
  var MAX_SAFE_INTEGER2 = 9007199254740991;
  var argsTag2 = "[object Arguments]", arrayTag2 = "[object Array]", asyncTag2 = "[object AsyncFunction]", boolTag2 = "[object Boolean]", dateTag2 = "[object Date]", errorTag2 = "[object Error]", funcTag2 = "[object Function]", genTag2 = "[object GeneratorFunction]", mapTag2 = "[object Map]", numberTag2 = "[object Number]", nullTag2 = "[object Null]", objectTag2 = "[object Object]", promiseTag2 = "[object Promise]", proxyTag2 = "[object Proxy]", regexpTag2 = "[object RegExp]", setTag2 = "[object Set]", stringTag2 = "[object String]", symbolTag2 = "[object Symbol]", undefinedTag2 = "[object Undefined]", weakMapTag2 = "[object WeakMap]";
  var arrayBufferTag2 = "[object ArrayBuffer]", dataViewTag2 = "[object DataView]", float32Tag2 = "[object Float32Array]", float64Tag2 = "[object Float64Array]", int8Tag2 = "[object Int8Array]", int16Tag2 = "[object Int16Array]", int32Tag2 = "[object Int32Array]", uint8Tag2 = "[object Uint8Array]", uint8ClampedTag2 = "[object Uint8ClampedArray]", uint16Tag2 = "[object Uint16Array]", uint32Tag2 = "[object Uint32Array]";
  var reRegExpChar2 = /[\\^$.*+?()[\]{}|]/g;
  var reIsHostCtor2 = /^\[object .+?Constructor\]$/;
  var reIsUint2 = /^(?:0|[1-9]\d*)$/;
  var typedArrayTags2 = {};
  typedArrayTags2[float32Tag2] = typedArrayTags2[float64Tag2] = typedArrayTags2[int8Tag2] = typedArrayTags2[int16Tag2] = typedArrayTags2[int32Tag2] = typedArrayTags2[uint8Tag2] = typedArrayTags2[uint8ClampedTag2] = typedArrayTags2[uint16Tag2] = typedArrayTags2[uint32Tag2] = true;
  typedArrayTags2[argsTag2] = typedArrayTags2[arrayTag2] = typedArrayTags2[arrayBufferTag2] = typedArrayTags2[boolTag2] = typedArrayTags2[dataViewTag2] = typedArrayTags2[dateTag2] = typedArrayTags2[errorTag2] = typedArrayTags2[funcTag2] = typedArrayTags2[mapTag2] = typedArrayTags2[numberTag2] = typedArrayTags2[objectTag2] = typedArrayTags2[regexpTag2] = typedArrayTags2[setTag2] = typedArrayTags2[stringTag2] = typedArrayTags2[weakMapTag2] = false;
  var freeGlobal2 = typeof commonjsGlobal == "object" && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;
  var freeSelf2 = typeof self == "object" && self && self.Object === Object && self;
  var root2 = freeGlobal2 || freeSelf2 || Function("return this")();
  var freeExports = exports$1 && !exports$1.nodeType && exports$1;
  var freeModule = freeExports && true && module && !module.nodeType && module;
  var moduleExports = freeModule && freeModule.exports === freeExports;
  var freeProcess = moduleExports && freeGlobal2.process;
  var nodeUtil2 = function() {
    try {
      return freeProcess && freeProcess.binding && freeProcess.binding("util");
    } catch (e3) {
    }
  }();
  var nodeIsTypedArray2 = nodeUtil2 && nodeUtil2.isTypedArray;
  function arrayFilter2(array, predicate2) {
    var index2 = -1, length2 = array == null ? 0 : array.length, resIndex = 0, result = [];
    while (++index2 < length2) {
      var value = array[index2];
      if (predicate2(value, index2, array)) {
        result[resIndex++] = value;
      }
    }
    return result;
  }
  function arrayPush2(array, values3) {
    var index2 = -1, length2 = values3.length, offset2 = array.length;
    while (++index2 < length2) {
      array[offset2 + index2] = values3[index2];
    }
    return array;
  }
  function arraySome2(array, predicate2) {
    var index2 = -1, length2 = array == null ? 0 : array.length;
    while (++index2 < length2) {
      if (predicate2(array[index2], index2, array)) {
        return true;
      }
    }
    return false;
  }
  function baseTimes2(n2, iteratee) {
    var index2 = -1, result = Array(n2);
    while (++index2 < n2) {
      result[index2] = iteratee(index2);
    }
    return result;
  }
  function baseUnary2(func) {
    return function(value) {
      return func(value);
    };
  }
  function cacheHas2(cache, key) {
    return cache.has(key);
  }
  function getValue2(object2, key) {
    return object2 == null ? void 0 : object2[key];
  }
  function mapToArray2(map) {
    var index2 = -1, result = Array(map.size);
    map.forEach(function(value, key) {
      result[++index2] = [key, value];
    });
    return result;
  }
  function overArg2(func, transform) {
    return function(arg) {
      return func(transform(arg));
    };
  }
  function setToArray2(set2) {
    var index2 = -1, result = Array(set2.size);
    set2.forEach(function(value) {
      result[++index2] = value;
    });
    return result;
  }
  var arrayProto2 = Array.prototype, funcProto2 = Function.prototype, objectProto2 = Object.prototype;
  var coreJsData2 = root2["__core-js_shared__"];
  var funcToString2 = funcProto2.toString;
  var hasOwnProperty2 = objectProto2.hasOwnProperty;
  var maskSrcKey2 = function() {
    var uid = /[^.]+$/.exec(coreJsData2 && coreJsData2.keys && coreJsData2.keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
  }();
  var nativeObjectToString2 = objectProto2.toString;
  var reIsNative2 = RegExp(
    "^" + funcToString2.call(hasOwnProperty2).replace(reRegExpChar2, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  );
  var Buffer2 = moduleExports ? root2.Buffer : void 0, Symbol2 = root2.Symbol, Uint8Array2 = root2.Uint8Array, propertyIsEnumerable2 = objectProto2.propertyIsEnumerable, splice2 = arrayProto2.splice, symToStringTag2 = Symbol2 ? Symbol2.toStringTag : void 0;
  var nativeGetSymbols2 = Object.getOwnPropertySymbols, nativeIsBuffer = Buffer2 ? Buffer2.isBuffer : void 0, nativeKeys2 = overArg2(Object.keys, Object);
  var DataView2 = getNative2(root2, "DataView"), Map2 = getNative2(root2, "Map"), Promise2 = getNative2(root2, "Promise"), Set2 = getNative2(root2, "Set"), WeakMap2 = getNative2(root2, "WeakMap"), nativeCreate2 = getNative2(Object, "create");
  var dataViewCtorString2 = toSource2(DataView2), mapCtorString2 = toSource2(Map2), promiseCtorString2 = toSource2(Promise2), setCtorString2 = toSource2(Set2), weakMapCtorString2 = toSource2(WeakMap2);
  var symbolProto2 = Symbol2 ? Symbol2.prototype : void 0, symbolValueOf2 = symbolProto2 ? symbolProto2.valueOf : void 0;
  function Hash2(entries) {
    var index2 = -1, length2 = entries == null ? 0 : entries.length;
    this.clear();
    while (++index2 < length2) {
      var entry = entries[index2];
      this.set(entry[0], entry[1]);
    }
  }
  function hashClear2() {
    this.__data__ = nativeCreate2 ? nativeCreate2(null) : {};
    this.size = 0;
  }
  function hashDelete2(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
  }
  function hashGet2(key) {
    var data = this.__data__;
    if (nativeCreate2) {
      var result = data[key];
      return result === HASH_UNDEFINED2 ? void 0 : result;
    }
    return hasOwnProperty2.call(data, key) ? data[key] : void 0;
  }
  function hashHas2(key) {
    var data = this.__data__;
    return nativeCreate2 ? data[key] !== void 0 : hasOwnProperty2.call(data, key);
  }
  function hashSet2(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = nativeCreate2 && value === void 0 ? HASH_UNDEFINED2 : value;
    return this;
  }
  Hash2.prototype.clear = hashClear2;
  Hash2.prototype["delete"] = hashDelete2;
  Hash2.prototype.get = hashGet2;
  Hash2.prototype.has = hashHas2;
  Hash2.prototype.set = hashSet2;
  function ListCache2(entries) {
    var index2 = -1, length2 = entries == null ? 0 : entries.length;
    this.clear();
    while (++index2 < length2) {
      var entry = entries[index2];
      this.set(entry[0], entry[1]);
    }
  }
  function listCacheClear2() {
    this.__data__ = [];
    this.size = 0;
  }
  function listCacheDelete2(key) {
    var data = this.__data__, index2 = assocIndexOf2(data, key);
    if (index2 < 0) {
      return false;
    }
    var lastIndex = data.length - 1;
    if (index2 == lastIndex) {
      data.pop();
    } else {
      splice2.call(data, index2, 1);
    }
    --this.size;
    return true;
  }
  function listCacheGet2(key) {
    var data = this.__data__, index2 = assocIndexOf2(data, key);
    return index2 < 0 ? void 0 : data[index2][1];
  }
  function listCacheHas2(key) {
    return assocIndexOf2(this.__data__, key) > -1;
  }
  function listCacheSet2(key, value) {
    var data = this.__data__, index2 = assocIndexOf2(data, key);
    if (index2 < 0) {
      ++this.size;
      data.push([key, value]);
    } else {
      data[index2][1] = value;
    }
    return this;
  }
  ListCache2.prototype.clear = listCacheClear2;
  ListCache2.prototype["delete"] = listCacheDelete2;
  ListCache2.prototype.get = listCacheGet2;
  ListCache2.prototype.has = listCacheHas2;
  ListCache2.prototype.set = listCacheSet2;
  function MapCache2(entries) {
    var index2 = -1, length2 = entries == null ? 0 : entries.length;
    this.clear();
    while (++index2 < length2) {
      var entry = entries[index2];
      this.set(entry[0], entry[1]);
    }
  }
  function mapCacheClear2() {
    this.size = 0;
    this.__data__ = {
      "hash": new Hash2(),
      "map": new (Map2 || ListCache2)(),
      "string": new Hash2()
    };
  }
  function mapCacheDelete2(key) {
    var result = getMapData2(this, key)["delete"](key);
    this.size -= result ? 1 : 0;
    return result;
  }
  function mapCacheGet2(key) {
    return getMapData2(this, key).get(key);
  }
  function mapCacheHas2(key) {
    return getMapData2(this, key).has(key);
  }
  function mapCacheSet2(key, value) {
    var data = getMapData2(this, key), size2 = data.size;
    data.set(key, value);
    this.size += data.size == size2 ? 0 : 1;
    return this;
  }
  MapCache2.prototype.clear = mapCacheClear2;
  MapCache2.prototype["delete"] = mapCacheDelete2;
  MapCache2.prototype.get = mapCacheGet2;
  MapCache2.prototype.has = mapCacheHas2;
  MapCache2.prototype.set = mapCacheSet2;
  function SetCache2(values3) {
    var index2 = -1, length2 = values3 == null ? 0 : values3.length;
    this.__data__ = new MapCache2();
    while (++index2 < length2) {
      this.add(values3[index2]);
    }
  }
  function setCacheAdd2(value) {
    this.__data__.set(value, HASH_UNDEFINED2);
    return this;
  }
  function setCacheHas2(value) {
    return this.__data__.has(value);
  }
  SetCache2.prototype.add = SetCache2.prototype.push = setCacheAdd2;
  SetCache2.prototype.has = setCacheHas2;
  function Stack2(entries) {
    var data = this.__data__ = new ListCache2(entries);
    this.size = data.size;
  }
  function stackClear2() {
    this.__data__ = new ListCache2();
    this.size = 0;
  }
  function stackDelete2(key) {
    var data = this.__data__, result = data["delete"](key);
    this.size = data.size;
    return result;
  }
  function stackGet2(key) {
    return this.__data__.get(key);
  }
  function stackHas2(key) {
    return this.__data__.has(key);
  }
  function stackSet2(key, value) {
    var data = this.__data__;
    if (data instanceof ListCache2) {
      var pairs = data.__data__;
      if (!Map2 || pairs.length < LARGE_ARRAY_SIZE2 - 1) {
        pairs.push([key, value]);
        this.size = ++data.size;
        return this;
      }
      data = this.__data__ = new MapCache2(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
  }
  Stack2.prototype.clear = stackClear2;
  Stack2.prototype["delete"] = stackDelete2;
  Stack2.prototype.get = stackGet2;
  Stack2.prototype.has = stackHas2;
  Stack2.prototype.set = stackSet2;
  function arrayLikeKeys2(value, inherited) {
    var isArr = isArray2(value), isArg = !isArr && isArguments3(value), isBuff = !isArr && !isArg && isBuffer2(value), isType = !isArr && !isArg && !isBuff && isTypedArray2(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes2(value.length, String) : [], length2 = result.length;
    for (var key in value) {
      if (hasOwnProperty2.call(value, key) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
      (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
      isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
      isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
      isIndex2(key, length2)))) {
        result.push(key);
      }
    }
    return result;
  }
  function assocIndexOf2(array, key) {
    var length2 = array.length;
    while (length2--) {
      if (eq2(array[length2][0], key)) {
        return length2;
      }
    }
    return -1;
  }
  function baseGetAllKeys2(object2, keysFunc, symbolsFunc) {
    var result = keysFunc(object2);
    return isArray2(object2) ? result : arrayPush2(result, symbolsFunc(object2));
  }
  function baseGetTag2(value) {
    if (value == null) {
      return value === void 0 ? undefinedTag2 : nullTag2;
    }
    return symToStringTag2 && symToStringTag2 in Object(value) ? getRawTag2(value) : objectToString2(value);
  }
  function baseIsArguments2(value) {
    return isObjectLike2(value) && baseGetTag2(value) == argsTag2;
  }
  function baseIsEqual2(value, other, bitmask, customizer, stack) {
    if (value === other) {
      return true;
    }
    if (value == null || other == null || !isObjectLike2(value) && !isObjectLike2(other)) {
      return value !== value && other !== other;
    }
    return baseIsEqualDeep2(value, other, bitmask, customizer, baseIsEqual2, stack);
  }
  function baseIsEqualDeep2(object2, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = isArray2(object2), othIsArr = isArray2(other), objTag = objIsArr ? arrayTag2 : getTag2(object2), othTag = othIsArr ? arrayTag2 : getTag2(other);
    objTag = objTag == argsTag2 ? objectTag2 : objTag;
    othTag = othTag == argsTag2 ? objectTag2 : othTag;
    var objIsObj = objTag == objectTag2, othIsObj = othTag == objectTag2, isSameTag = objTag == othTag;
    if (isSameTag && isBuffer2(object2)) {
      if (!isBuffer2(other)) {
        return false;
      }
      objIsArr = true;
      objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
      stack || (stack = new Stack2());
      return objIsArr || isTypedArray2(object2) ? equalArrays2(object2, other, bitmask, customizer, equalFunc, stack) : equalByTag2(object2, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & COMPARE_PARTIAL_FLAG2)) {
      var objIsWrapped = objIsObj && hasOwnProperty2.call(object2, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty2.call(other, "__wrapped__");
      if (objIsWrapped || othIsWrapped) {
        var objUnwrapped = objIsWrapped ? object2.value() : object2, othUnwrapped = othIsWrapped ? other.value() : other;
        stack || (stack = new Stack2());
        return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
      }
    }
    if (!isSameTag) {
      return false;
    }
    stack || (stack = new Stack2());
    return equalObjects2(object2, other, bitmask, customizer, equalFunc, stack);
  }
  function baseIsNative2(value) {
    if (!isObject2(value) || isMasked2(value)) {
      return false;
    }
    var pattern = isFunction2(value) ? reIsNative2 : reIsHostCtor2;
    return pattern.test(toSource2(value));
  }
  function baseIsTypedArray2(value) {
    return isObjectLike2(value) && isLength2(value.length) && !!typedArrayTags2[baseGetTag2(value)];
  }
  function baseKeys2(object2) {
    if (!isPrototype2(object2)) {
      return nativeKeys2(object2);
    }
    var result = [];
    for (var key in Object(object2)) {
      if (hasOwnProperty2.call(object2, key) && key != "constructor") {
        result.push(key);
      }
    }
    return result;
  }
  function equalArrays2(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG2, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
      return false;
    }
    var stacked = stack.get(array);
    if (stacked && stack.get(other)) {
      return stacked == other;
    }
    var index2 = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG2 ? new SetCache2() : void 0;
    stack.set(array, other);
    stack.set(other, array);
    while (++index2 < arrLength) {
      var arrValue = array[index2], othValue = other[index2];
      if (customizer) {
        var compared = isPartial ? customizer(othValue, arrValue, index2, other, array, stack) : customizer(arrValue, othValue, index2, array, other, stack);
      }
      if (compared !== void 0) {
        if (compared) {
          continue;
        }
        result = false;
        break;
      }
      if (seen) {
        if (!arraySome2(other, function(othValue2, othIndex) {
          if (!cacheHas2(seen, othIndex) && (arrValue === othValue2 || equalFunc(arrValue, othValue2, bitmask, customizer, stack))) {
            return seen.push(othIndex);
          }
        })) {
          result = false;
          break;
        }
      } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
        result = false;
        break;
      }
    }
    stack["delete"](array);
    stack["delete"](other);
    return result;
  }
  function equalByTag2(object2, other, tag, bitmask, customizer, equalFunc, stack) {
    switch (tag) {
      case dataViewTag2:
        if (object2.byteLength != other.byteLength || object2.byteOffset != other.byteOffset) {
          return false;
        }
        object2 = object2.buffer;
        other = other.buffer;
      case arrayBufferTag2:
        if (object2.byteLength != other.byteLength || !equalFunc(new Uint8Array2(object2), new Uint8Array2(other))) {
          return false;
        }
        return true;
      case boolTag2:
      case dateTag2:
      case numberTag2:
        return eq2(+object2, +other);
      case errorTag2:
        return object2.name == other.name && object2.message == other.message;
      case regexpTag2:
      case stringTag2:
        return object2 == other + "";
      case mapTag2:
        var convert = mapToArray2;
      case setTag2:
        var isPartial = bitmask & COMPARE_PARTIAL_FLAG2;
        convert || (convert = setToArray2);
        if (object2.size != other.size && !isPartial) {
          return false;
        }
        var stacked = stack.get(object2);
        if (stacked) {
          return stacked == other;
        }
        bitmask |= COMPARE_UNORDERED_FLAG2;
        stack.set(object2, other);
        var result = equalArrays2(convert(object2), convert(other), bitmask, customizer, equalFunc, stack);
        stack["delete"](object2);
        return result;
      case symbolTag2:
        if (symbolValueOf2) {
          return symbolValueOf2.call(object2) == symbolValueOf2.call(other);
        }
    }
    return false;
  }
  function equalObjects2(object2, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG2, objProps = getAllKeys2(object2), objLength = objProps.length, othProps = getAllKeys2(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) {
      return false;
    }
    var index2 = objLength;
    while (index2--) {
      var key = objProps[index2];
      if (!(isPartial ? key in other : hasOwnProperty2.call(other, key))) {
        return false;
      }
    }
    var stacked = stack.get(object2);
    if (stacked && stack.get(other)) {
      return stacked == other;
    }
    var result = true;
    stack.set(object2, other);
    stack.set(other, object2);
    var skipCtor = isPartial;
    while (++index2 < objLength) {
      key = objProps[index2];
      var objValue = object2[key], othValue = other[key];
      if (customizer) {
        var compared = isPartial ? customizer(othValue, objValue, key, other, object2, stack) : customizer(objValue, othValue, key, object2, other, stack);
      }
      if (!(compared === void 0 ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
        result = false;
        break;
      }
      skipCtor || (skipCtor = key == "constructor");
    }
    if (result && !skipCtor) {
      var objCtor = object2.constructor, othCtor = other.constructor;
      if (objCtor != othCtor && ("constructor" in object2 && "constructor" in other) && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) {
        result = false;
      }
    }
    stack["delete"](object2);
    stack["delete"](other);
    return result;
  }
  function getAllKeys2(object2) {
    return baseGetAllKeys2(object2, keys3, getSymbols2);
  }
  function getMapData2(map, key) {
    var data = map.__data__;
    return isKeyable2(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
  }
  function getNative2(object2, key) {
    var value = getValue2(object2, key);
    return baseIsNative2(value) ? value : void 0;
  }
  function getRawTag2(value) {
    var isOwn = hasOwnProperty2.call(value, symToStringTag2), tag = value[symToStringTag2];
    try {
      value[symToStringTag2] = void 0;
      var unmasked = true;
    } catch (e3) {
    }
    var result = nativeObjectToString2.call(value);
    if (unmasked) {
      if (isOwn) {
        value[symToStringTag2] = tag;
      } else {
        delete value[symToStringTag2];
      }
    }
    return result;
  }
  var getSymbols2 = !nativeGetSymbols2 ? stubArray2 : function(object2) {
    if (object2 == null) {
      return [];
    }
    object2 = Object(object2);
    return arrayFilter2(nativeGetSymbols2(object2), function(symbol) {
      return propertyIsEnumerable2.call(object2, symbol);
    });
  };
  var getTag2 = baseGetTag2;
  if (DataView2 && getTag2(new DataView2(new ArrayBuffer(1))) != dataViewTag2 || Map2 && getTag2(new Map2()) != mapTag2 || Promise2 && getTag2(Promise2.resolve()) != promiseTag2 || Set2 && getTag2(new Set2()) != setTag2 || WeakMap2 && getTag2(new WeakMap2()) != weakMapTag2) {
    getTag2 = function(value) {
      var result = baseGetTag2(value), Ctor = result == objectTag2 ? value.constructor : void 0, ctorString = Ctor ? toSource2(Ctor) : "";
      if (ctorString) {
        switch (ctorString) {
          case dataViewCtorString2:
            return dataViewTag2;
          case mapCtorString2:
            return mapTag2;
          case promiseCtorString2:
            return promiseTag2;
          case setCtorString2:
            return setTag2;
          case weakMapCtorString2:
            return weakMapTag2;
        }
      }
      return result;
    };
  }
  function isIndex2(value, length2) {
    length2 = length2 == null ? MAX_SAFE_INTEGER2 : length2;
    return !!length2 && (typeof value == "number" || reIsUint2.test(value)) && (value > -1 && value % 1 == 0 && value < length2);
  }
  function isKeyable2(value) {
    var type2 = typeof value;
    return type2 == "string" || type2 == "number" || type2 == "symbol" || type2 == "boolean" ? value !== "__proto__" : value === null;
  }
  function isMasked2(func) {
    return !!maskSrcKey2 && maskSrcKey2 in func;
  }
  function isPrototype2(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto2;
    return value === proto;
  }
  function objectToString2(value) {
    return nativeObjectToString2.call(value);
  }
  function toSource2(func) {
    if (func != null) {
      try {
        return funcToString2.call(func);
      } catch (e3) {
      }
      try {
        return func + "";
      } catch (e3) {
      }
    }
    return "";
  }
  function eq2(value, other) {
    return value === other || value !== value && other !== other;
  }
  var isArguments3 = baseIsArguments2(/* @__PURE__ */ function() {
    return arguments;
  }()) ? baseIsArguments2 : function(value) {
    return isObjectLike2(value) && hasOwnProperty2.call(value, "callee") && !propertyIsEnumerable2.call(value, "callee");
  };
  var isArray2 = Array.isArray;
  function isArrayLike2(value) {
    return value != null && isLength2(value.length) && !isFunction2(value);
  }
  var isBuffer2 = nativeIsBuffer || stubFalse2;
  function isEqual2(value, other) {
    return baseIsEqual2(value, other);
  }
  function isFunction2(value) {
    if (!isObject2(value)) {
      return false;
    }
    var tag = baseGetTag2(value);
    return tag == funcTag2 || tag == genTag2 || tag == asyncTag2 || tag == proxyTag2;
  }
  function isLength2(value) {
    return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER2;
  }
  function isObject2(value) {
    var type2 = typeof value;
    return value != null && (type2 == "object" || type2 == "function");
  }
  function isObjectLike2(value) {
    return value != null && typeof value == "object";
  }
  var isTypedArray2 = nodeIsTypedArray2 ? baseUnary2(nodeIsTypedArray2) : baseIsTypedArray2;
  function keys3(object2) {
    return isArrayLike2(object2) ? arrayLikeKeys2(object2) : baseKeys2(object2);
  }
  function stubArray2() {
    return [];
  }
  function stubFalse2() {
    return false;
  }
  module.exports = isEqual2;
})(lodash_isequal, lodash_isequal.exports);
var lodash_isequalExports = lodash_isequal.exports;
var equal = /* @__PURE__ */ getDefaultExportFromCjs(lodash_isequalExports);
function useControlledState$1(value, defaultValue, onChange2) {
  const [stateValue, setStateValue] = useState(value || defaultValue);
  const onChangeRef = useRef(onChange2);
  const isControlled = value !== void 0;
  let currentValue = isControlled ? value : stateValue;
  const setValue = useCallback((nextValue, ...args) => {
    const onChangeHandler = (changeValue, ...changeArgs) => {
      if (onChangeRef.current) {
        if (!equal(currentValue, changeValue)) {
          onChangeRef.current(changeValue, ...changeArgs);
        }
      }
      if (!isControlled) currentValue = changeValue;
    };
    if (!isControlled) setStateValue(nextValue);
    onChangeHandler(typeof nextValue === "function" ? nextValue(currentValue) : nextValue, ...args);
  }, [isControlled, currentValue]);
  useEffect(() => {
    onChangeRef.current = onChange2;
  });
  return [currentValue, setValue];
}
function useArrayRef(length2) {
  const [elRefs, setElRefs] = useState([]);
  useEffect(() => {
    setElRefs((old) => Array(length2).fill(void 0).map((_2, i) => old[i] || createRef()));
  }, [length2]);
  return [elRefs];
}
const useDrawer = () => {
  const [isOpen, setIsOpen] = useState(false);
  const open = useCallback(() => {
    setIsOpen(true);
  }, []);
  const close = useCallback(() => {
    setIsOpen(false);
  }, []);
  const toggle = useCallback(() => {
    setIsOpen((prev2) => !prev2);
  }, []);
  return {
    isOpen,
    open,
    close,
    toggle
  };
};
const menuPseudostates = [Pseudostate.hover, Pseudostate.active, Pseudostate["focus-visible"], Pseudostate.disabled];
const MENU_STYLE = {
  background: `var(${TOKENS.color.background.surface0})`,
  borderRadius: "3px"
};
const MenuContainer$1 = styled.div`
  display: block;
  padding-top: 8px;
  ${composeWrapper([space, color, typography, layout, flexbox, grid, background, border, position$1, shadow], menuPseudostates)}
  /* Declared after composeWrapper so it wins over any boxShadow prop; this is
     the authoritative menu shadow. The legacy theme's own menus.boxShadow only
     carried the 2px layer and was already overridden here, so it is not
     migrated. Shadows have no single token to read - the token system splits
     them into unitless component vars. */
  box-shadow: 0 3px 10px 0 rgba(0, 0, 0, 0.08), 0 0 2px 0 rgba(0, 0, 0, 0.2);
`;
const MenuList$1 = styled.ul`
  margin: 0;
  padding: 0;
  max-height: ${(props) => props.maxHeight};
  overflow-y: hidden;
  display: flex;
  flex-direction: column;
`;
const MenuContext = createContext$1(void 0);
const Menu$2 = forwardRef(({
  anchorElement,
  onClickAway,
  setWidthToAnchor = true,
  children,
  visible: isOpen,
  width: width2,
  menuPosition = "bottom-start",
  hasGroups = false,
  maxHeight,
  autoFocus = true,
  ...rest
}, ref2) => {
  const [popper2, popperRef] = useCallbackRef();
  useEffect(() => {
    if (anchorElement) {
      anchorElement.setAttribute("aria-haspopup", "menu");
    }
  }, [anchorElement]);
  const popperModifiers = useMemo(() => [{
    name: "sameWidth",
    enabled: setWidthToAnchor || width2 !== void 0,
    phase: "beforeWrite",
    requires: ["computeStyles"],
    fn({
      state
    }) {
      const widthToUse = width2 ?? `${state.rects.reference.width}px`;
      state.styles.popper.width = `calc(${widthToUse} + 2px)`;
    },
    effect({
      state
    }) {
      const widthToUse = width2 ?? `${state.elements.reference.offsetWidth}px`;
      state.elements.popper.style.width = `${widthToUse}px`;
    }
  }, {
    name: "offset",
    options: {
      offset: [0, 8]
    }
  }], []);
  const {
    styles,
    attributes,
    update
  } = usePopper(anchorElement, popper2, {
    placement: menuPosition,
    modifiers: popperModifiers,
    strategy: "fixed"
  });
  useEffect(() => {
    if (update) {
      update();
    }
  }, [isOpen, anchorElement]);
  const menuListRole = hasGroups ? "listbox" : "menu";
  return /* @__PURE__ */ jsxRuntimeExports.jsx(MenuContext.Provider, { value: {
    isOpen,
    onClickAway
  }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(OutsideClickHandler, { onOutsideClick: (e3) => {
    if (onClickAway && !(anchorElement == null ? void 0 : anchorElement.contains(e3.target))) onClickAway(e3);
  }, children: isOpen && /* @__PURE__ */ jsxRuntimeExports.jsx(MenuContainer$1, { ref: popperRef, style: styles.popper, ...attributes.popper, ...MENU_STYLE, ...rest, children: /* @__PURE__ */ jsxRuntimeExports.jsx(MenuList$1, { ref: ref2, role: menuListRole, maxHeight, children: /* @__PURE__ */ jsxRuntimeExports.jsx($9bf71ea28793e738$export$20e40289641fbbb6, { contain: true, autoFocus, restoreFocus: true, children }) }) }) }) });
});
Menu$2.displayName = "Menu";
const MENU_ITEM_VARIANT = ["default", "icon-before", "icon-after", "checkbox", "radio"];
const getFocusOptions = (variant) => ({
  wrap: true,
  accept: (node2) => variant === "checkbox" ? node2.getAttribute("role") === "menuitem" || node2.hasAttribute("data-expanded") : true
});
const menuItemPseudostates = [Pseudostate.hover, Pseudostate.active, Pseudostate["focus-visible"], Pseudostate.disabled];
const v$9 = (token2) => `var(${token2})`;
const MENU_ITEM_BASE_STYLE = {
  fontFamily: v$9(TOKENS.text.fontFamily.primary),
  fontWeight: v$9(TOKENS.text.fontWeight.default),
  fontSize: "0.875rem",
  lineHeight: "140%",
  letterSpacing: "0em",
  padding: "6px 16px",
  color: v$9(TOKENS.color.foreground.default),
  // Reserves space so the focus border does not shift the content.
  border: "solid 2px transparent",
  hoverStyle: {
    background: v$9(TOKENS.color.background.interaction.neutralHover)
  },
  activeStyle: {
    background: v$9(TOKENS.color.background.interaction.neutralActive)
  },
  focusStyle: {
    border: `solid 2px var(${TOKENS.color.border.focus})`,
    borderRadius: "6px"
  }
};
const MENU_ITEM_VARIANT_STYLE = {
  disabledStyle: {
    color: v$9(TOKENS.color.foreground.interaction.disabled),
    hoverStyle: {
      background: v$9(TOKENS.color.background.surface0)
    }
  },
  selected: {
    fontWeight: v$9(TOKENS.text.fontWeight.header)
  }
};
const MenuItemContainer = styled.li`
  display: flex;
  background: none;
  border: none;
  outline: none;
  cursor: pointer;
  align-items: center;
  column-gap: 4px;

  svg[data-variant="icon-after"] {
    margin-left: auto;
  }

  ${composeWrapper([space, color, typography, layout, flexbox, grid, background, border, position$1, shadow], menuItemPseudostates)}
  ${(props) => props.disabled && "cursor: not-allowed;"}
`;
const MenuItem = forwardRef(({
  children,
  disabled,
  selected,
  nodeAfter,
  variant = "default",
  name,
  indeterminate = false,
  onClickOrEnterPress,
  onClickCheckbox,
  ...rest
}, ref2) => {
  const getVariant = () => {
    if (disabled) {
      return "disabledStyle";
    }
    if (selected) {
      return "selected";
    }
    return void 0;
  };
  const variantStyle = getVariant();
  const themedProps = {
    ...MENU_ITEM_BASE_STYLE,
    ...variantStyle ? MENU_ITEM_VARIANT_STYLE[variantStyle] : {}
  };
  const menuContext = useContext(MenuContext);
  const iconNode = useMemo(() => {
    const VariantIcon = selected ? CheckmarkCircleIcon : PlusCircleIcon;
    return /* @__PURE__ */ jsxRuntimeExports.jsx(VariantIcon, { "data-variant": variant, fill: "currentColor", size: "md", "aria-hidden": "true" });
  }, [selected, variant]);
  const focusManager = $9bf71ea28793e738$export$10c5169755ce7bd7();
  const onKeyDown = (e3) => {
    if (!focusManager) return;
    const focusOptions = getFocusOptions(variant);
    e3.stopPropagation();
    e3.preventDefault();
    switch (e3.key) {
      case "ArrowRight":
        focusManager.focusNext(focusOptions);
        break;
      case "ArrowLeft":
        focusManager.focusPrevious(focusOptions);
        break;
      case "ArrowDown":
        focusManager.focusNext(focusOptions);
        break;
      case "ArrowUp":
        focusManager.focusPrevious(focusOptions);
        break;
      case "Home":
        focusManager.focusFirst(focusOptions);
        break;
      case "End":
        focusManager.focusLast(focusOptions);
        break;
      case "Enter":
      case " ":
        if (!disabled && onClickOrEnterPress) {
          onClickOrEnterPress(e3);
        }
        break;
      case "Escape":
        if (menuContext && menuContext.onClickAway) {
          menuContext.onClickAway(e3);
        }
        break;
    }
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(MenuItemContainer, { ref: ref2, "aria-disabled": disabled, disabled, onKeyDown, onClick: (e3) => {
    if (!disabled && onClickOrEnterPress) onClickOrEnterPress(e3);
  }, tabIndex: 0, role: "menuitem", ...themedProps, ...rest, children: [
    variant === "checkbox" && /* @__PURE__ */ jsxRuntimeExports.jsx(
      CheckboxInput,
      {
        name,
        tabIndex: -1,
        "aria-hidden": "true",
        id: `${rest.id}-checkbox`,
        checked: selected,
        interactiveParent: !onClickCheckbox,
        "aria-label": typeof children === "string" ? children : "",
        indeterminate,
        value: rest.value,
        onClick: onClickCheckbox
      }
    ),
    variant === "radio" && /* @__PURE__ */ jsxRuntimeExports.jsx(RadioInput, { name, tabIndex: -1, "aria-hidden": "true", id: `${rest.id}-checkbox`, checked: selected, interactiveParent: true, "aria-label": typeof children === "string" ? children : "", indeterminate, value: rest.value }),
    variant === "icon-before" && iconNode,
    children,
    variant === "icon-after" && iconNode,
    nodeAfter && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { style: {
      marginLeft: "auto"
    }, children: nodeAfter })
  ] });
});
MenuItem.displayName = "MenuItem";
const SelectInputCaretDownIcon = ({
  fill
}) => /* @__PURE__ */ jsxRuntimeExports.jsx("svg", { width: "20", height: "11", viewBox: "0 0 20 11", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M0.183038 0.650578C0.427104 0.406489 0.822832 0.40647 1.06692 0.650536L10 9.58278L18.9331 0.650536C19.1772 0.40647 19.5729 0.406489 19.817 0.650578C20.061 0.894667 20.061 1.29039 19.8169 1.53446L10.8839 10.4666C10.8838 10.4667 10.8837 10.4669 10.8836 10.467C10.7676 10.583 10.63 10.675 10.4784 10.7379C10.3268 10.8008 10.1642 10.8331 10 10.8331C9.83581 10.8331 9.67323 10.8008 9.52155 10.7379C9.37003 10.675 9.23236 10.583 9.11641 10.467C9.1163 10.4669 9.11619 10.4667 9.11608 10.4666L0.183079 1.53446C-0.0610102 1.29039 -0.0610287 0.894667 0.183038 0.650578Z", fill }) });
const StyledLabelContainer = styled.label`
  ${InputWrapperStyles};
  appearance: none;
  /* Trap z-index inside so that we don't cause side effects due to z-index conflicts with consumers */
  isolation: isolate;

  /* Hide the existing caret */
  &::-ms-expand {
    display: none;
  }
  /* for Firefox */
  -moz-appearance: none;
  /* for Chrome */
  -webkit-appearance: none;
  ${(props) => css$3`
      /*
       * Hide native menu if:
       * The useMenuDropdown prop has been passed
       * The device supports both hover and fine pointer devices
       */
      @media (hover: hover) and (pointer: fine) {
        option {
          display: ${props.useMenuDropdown ? `none` : `block`};
        }
      }
    `}
`;
const StyledSelect = styled.select`
  /* Remove the caret from the dropdown (since we're adding our own) */
  /* Chromium-based */
  -webkit-appearance: none;
  /* Firefox */
  -moz-appearance: none;
  /* IE10+ */
  &::-ms-expand {
    display: none;
  }
  /* Only hide scrollbar on Safari */
  @supports (-webkit-hyphens: none) {
    &::-webkit-scrollbar {
      -webkit-appearance: none;
      width: 0;
      height: 0;
    }
  }
  -webkit-font-smoothing: antialiased;
  ${InputElementStyles};
  padding: ${(props) => props.margin || props.m};
  ${(props) => css$3`
    padding-top: calc(${getEffectiveMarginTop(props)} * 1.5);
    padding-bottom: ${(props == null ? void 0 : props.selectPaddingBottom) || `calc(${getEffectiveMarginBottom(props)} * 0.5)`};
  `}
  width: 100%;
  height: 100%;
  margin: 0;
  cursor: pointer;
  z-index: 2;
  background: none !important;
  &:-webkit-autofill {
    z-index: 1;
  }
  text-overflow: ellipsis;
`;
const SelectLabelTextSpan = styled(LabelTextSpan)`
  -webkit-font-smoothing: antialiased;
  z-index: 1;
  ${(props) => props.disabled && css$3`
      color: ${props.disabledColor};
    `}
`;
const CaretIconContainer = styled.div`
  position: absolute;
  height: 100%;
  top: 1px;
  right: ${(props) => getEffectiveMarginRight(props)};
  display: flex;
  align-items: center;
  justify-content: center;
`;
const MenuContainer = styled.div`
  /* If device does not support hover or has a coarse pointer device, hide display menu */
  @media (hover: none), (pointer: coarse) {
    display: none;
  }
`;
const SelectInput = forwardRef((props, forwardedRef) => {
  var _a2, _b;
  const {
    invalid,
    className,
    children,
    labelStyles,
    label,
    assistiveTextStyles,
    assistiveTextPlacement,
    assistiveText,
    useMenuDropdown = false,
    value: controlledValue,
    disabled,
    name,
    id: id2,
    ...rest
  } = props;
  const themedProps = INPUT_STYLE_PROPS;
  const [value, onChange2] = useControlledInput({
    controlledValue,
    onChange: props.onChange,
    defaultValue: props.defaultValue
  });
  const [anchorElement, setAnchorElement] = useState();
  const [isMenuVisible, setIsMenuVisible] = useState(false);
  const {
    ref: ref2,
    refHandler
  } = useRefHandler(forwardedRef);
  const handleAnchorClick = () => {
    setIsMenuVisible(!isMenuVisible);
  };
  const onKeyDown = (e3) => {
    if (useMenuDropdown) {
      e3.stopPropagation();
      e3.preventDefault();
      switch (e3.key) {
        case " ":
        case "ArrowDown":
        case "ArrowUp":
          setIsMenuVisible(true);
          break;
      }
    }
  };
  const menuItemOnChange = (customOnChange, targetValue) => {
    customOnChange({
      /*
       * Mocking the target object here and expecting that consumers will only need
       * the name (required for Formik) and value if they pass in a custom onChange. But we can add more values if
       * needed later.
       */
      // @ts-ignore - mocking target here with just the name and value.
      target: {
        name: id2 || name || "",
        value: targetValue
      }
    });
  };
  const allProps = {
    ...themedProps,
    ...props
  };
  const spaceProps = selectStyledSystemProps(omit(allProps, "size"), ["space"]);
  const inputWrapperStyles = selectStyledSystemProps(allProps, ["layout", "background", "position", "shadow", "border", "outline", "color", "space"], true);
  const [hasValue, setHasValue] = useState(!!value);
  useEffect(() => {
    if (value === void 0 || value === "") {
      setHasValue(false);
    } else {
      setHasValue(true);
    }
  }, [value]);
  const caretIconColor = disabled ? (_a2 = themedProps == null ? void 0 : themedProps.labelStyles) == null ? void 0 : _a2.disabledColor : themedProps == null ? void 0 : themedProps.selectIconColor;
  const disabledLabelColor = (_b = themedProps == null ? void 0 : themedProps.labelStyles) == null ? void 0 : _b.disabledColor;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(AssistiveTextWrapper, { assistiveText, assistiveTextPlacement, id: id2, invalid, ...themedProps.assistiveTextStyles, ...assistiveTextStyles, children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledLabelContainer, { ...inputWrapperStyles, useMenuDropdown, className: `${className || ""} ${invalid ? "invalid" : ""} ${disabled ? "disabled" : ""}`, moveLabelOnFocus: false, htmlFor: id2, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { style: {
        width: "100%",
        height: "100%"
      }, ref: (el) => {
        if (el) {
          setAnchorElement(el);
        }
      }, children: [
        /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledSelect, { ...themedProps, ...rest, className: `${className || ""}`, ref: refHandler, id: id2, name, useMenuDropdown, onClick: handleAnchorClick, onChange: (e3) => {
          if (onChange2) {
            onChange2(e3);
          } else if (e3.target.value) {
            setHasValue(true);
          } else {
            setHasValue(false);
          }
        }, onKeyDown, value, disabled, hasValue, "data-isinvalid": !!invalid, "data-hasvalue": hasValue, placeholder: "", "aria-label": label, children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx("option", { value: "", "aria-label": "Nothing" }),
          children
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          SelectLabelTextSpan,
          {
            ...spaceProps,
            ...themedProps.labelStyles,
            ...labelStyles,
            disabled,
            disabledColor: disabledLabelColor,
            "aria-hidden": true,
            children: label
          }
        )
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(CaretIconContainer, { ...spaceProps, "aria-hidden": true, children: /* @__PURE__ */ jsxRuntimeExports.jsx(SelectInputCaretDownIcon, { fill: caretIconColor }) })
    ] }),
    useMenuDropdown && isMenuVisible && /* @__PURE__ */ jsxRuntimeExports.jsx(MenuContainer, { children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Menu$2, { zIndex: "2", onClickAway: handleAnchorClick, visible: isMenuVisible, anchorElement, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(MenuItem, { "aria-label": "Nothing", onClickOrEnterPress: () => {
        setIsMenuVisible(false);
        if (onChange2) {
          menuItemOnChange(onChange2, "");
        } else if (ref2.current) {
          ref2.current.value = "";
        }
        setHasValue(false);
      }, children: "--" }),
      _default(children).map((option) => {
        var _a3;
        if (React__default.isValidElement(option)) {
          return /* @__PURE__ */ jsxRuntimeExports.jsx(MenuItem, { onClickOrEnterPress: () => {
            setIsMenuVisible(false);
            if (onChange2) {
              menuItemOnChange(onChange2, option.props.value);
            } else {
              if (ref2.current) {
                ref2.current.value = option.props.value;
              }
              if (option.props.value) {
                setHasValue(true);
              } else {
                setHasValue(false);
              }
            }
          }, selected: value !== void 0 ? value === option.props.value : ((_a3 = ref2 == null ? void 0 : ref2.current) == null ? void 0 : _a3.value) === option.props.value, ...option.props }, option.props.value);
        }
        return void 0;
      })
    ] }) })
  ] }) });
});
SelectInput.displayName = "SelectInput";
const NumericInput = forwardRef(({
  numeral,
  cleaveOptions,
  ...props
}, ref2) => {
  const formatter = (value) => {
    if (numeral) {
      return M$1(value, {
        numeralThousandsGroupStyle: v$d.THOUSAND,
        ...cleaveOptions
      });
    }
    return value.replace(/\D/g, "");
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(TextInput, { inputMode: "numeric", ref: ref2, variant: "numeric", formatter, ...props });
});
NumericInput.displayName = "NumericInput";
const PercentInput = forwardRef((props, ref2) => {
  const {
    onChange: onChange2,
    max: max2 = 100,
    ...rest
  } = props;
  const formatter = (value) => {
    return M$1(value, {
      numeralPositiveOnly: true,
      numeralDecimalScale: 0,
      numeralIntegerScale: 3
    });
  };
  useEffect(() => {
    if (max2) console.warn("PercentInputs currently don't support uncontrolled values");
    if (max2 && (max2 <= 0 || max2 > 999)) console.error("Max values below 0 or above 3 digits aren't currently supported");
  }, []);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(TextInput, { onChange: (event) => {
    const parsedInput = parseInt(event.target.value, 10);
    const invalidInput = Number.isNaN(parsedInput);
    if (invalidInput) {
      event.target.value = "";
    }
    if (max2 && parsedInput > max2) {
      event.target.value = `${max2}`;
    }
    if (onChange2) {
      onChange2(event);
    }
  }, ref: ref2, iconRight: /* @__PURE__ */ jsxRuntimeExports.jsx(PercentIcon, {}), formatter, ...rest });
});
PercentInput.displayName = "PercentInput";
function _typeof$4(o) {
  "@babel/helpers - typeof";
  return _typeof$4 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof$4(o);
}
function toPrimitive(t2, r2) {
  if ("object" != _typeof$4(t2) || !t2) return t2;
  var e3 = t2[Symbol.toPrimitive];
  if (void 0 !== e3) {
    var i = e3.call(t2, r2);
    if ("object" != _typeof$4(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r2 ? String : Number)(t2);
}
function toPropertyKey(t2) {
  var i = toPrimitive(t2, "string");
  return "symbol" == _typeof$4(i) ? i : i + "";
}
function _defineProperty$4(e3, r2, t2) {
  return (r2 = toPropertyKey(r2)) in e3 ? Object.defineProperty(e3, r2, {
    value: t2,
    enumerable: true,
    configurable: true,
    writable: true
  }) : e3[r2] = t2, e3;
}
function ownKeys$3(e3, r2) {
  var t2 = Object.keys(e3);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e3);
    r2 && (o = o.filter(function(r3) {
      return Object.getOwnPropertyDescriptor(e3, r3).enumerable;
    })), t2.push.apply(t2, o);
  }
  return t2;
}
function _objectSpread2(e3) {
  for (var r2 = 1; r2 < arguments.length; r2++) {
    var t2 = null != arguments[r2] ? arguments[r2] : {};
    r2 % 2 ? ownKeys$3(Object(t2), true).forEach(function(r3) {
      _defineProperty$4(e3, r3, t2[r3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e3, Object.getOwnPropertyDescriptors(t2)) : ownKeys$3(Object(t2)).forEach(function(r3) {
      Object.defineProperty(e3, r3, Object.getOwnPropertyDescriptor(t2, r3));
    });
  }
  return e3;
}
function _classCallCheck$2(a2, n2) {
  if (!(a2 instanceof n2)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$2(e3, r2) {
  for (var t2 = 0; t2 < r2.length; t2++) {
    var o = r2[t2];
    o.enumerable = o.enumerable || false, o.configurable = true, "value" in o && (o.writable = true), Object.defineProperty(e3, toPropertyKey(o.key), o);
  }
}
function _createClass$2(e3, r2, t2) {
  return r2 && _defineProperties$2(e3.prototype, r2), t2 && _defineProperties$2(e3, t2), Object.defineProperty(e3, "prototype", {
    writable: false
  }), e3;
}
function _inherits$2(t2, e3) {
  if ("function" != typeof e3 && null !== e3) throw new TypeError("Super expression must either be null or a function");
  t2.prototype = Object.create(e3 && e3.prototype, {
    constructor: {
      value: t2,
      writable: true,
      configurable: true
    }
  }), Object.defineProperty(t2, "prototype", {
    writable: false
  }), e3 && _setPrototypeOf$2(t2, e3);
}
function _possibleConstructorReturn$2(t2, e3) {
  if (e3 && ("object" == _typeof$4(e3) || "function" == typeof e3)) return e3;
  if (void 0 !== e3) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized$2(t2);
}
function _createSuper(t2) {
  var r2 = _isNativeReflectConstruct$2();
  return function() {
    var e3, o = _getPrototypeOf$2(t2);
    if (r2) {
      var s2 = _getPrototypeOf$2(this).constructor;
      e3 = Reflect.construct(o, arguments, s2);
    } else e3 = o.apply(this, arguments);
    return _possibleConstructorReturn$2(this, e3);
  };
}
function _arrayLikeToArray(r2, a2) {
  (null == a2 || a2 > r2.length) && (a2 = r2.length);
  for (var e3 = 0, n2 = Array(a2); e3 < a2; e3++) n2[e3] = r2[e3];
  return n2;
}
function _arrayWithoutHoles(r2) {
  if (Array.isArray(r2)) return _arrayLikeToArray(r2);
}
function _iterableToArray(r2) {
  if ("undefined" != typeof Symbol && null != r2[Symbol.iterator] || null != r2["@@iterator"]) return Array.from(r2);
}
function _unsupportedIterableToArray(r2, a2) {
  if (r2) {
    if ("string" == typeof r2) return _arrayLikeToArray(r2, a2);
    var t2 = {}.toString.call(r2).slice(8, -1);
    return "Object" === t2 && r2.constructor && (t2 = r2.constructor.name), "Map" === t2 || "Set" === t2 ? Array.from(r2) : "Arguments" === t2 || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t2) ? _arrayLikeToArray(r2, a2) : void 0;
  }
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(r2) {
  return _arrayWithoutHoles(r2) || _iterableToArray(r2) || _unsupportedIterableToArray(r2) || _nonIterableSpread();
}
function sheetForTag(tag) {
  if (tag.sheet) {
    return tag.sheet;
  }
  for (var i = 0; i < document.styleSheets.length; i++) {
    if (document.styleSheets[i].ownerNode === tag) {
      return document.styleSheets[i];
    }
  }
  return void 0;
}
function createStyleElement(options2) {
  var tag = document.createElement("style");
  tag.setAttribute("data-emotion", options2.key);
  if (options2.nonce !== void 0) {
    tag.setAttribute("nonce", options2.nonce);
  }
  tag.appendChild(document.createTextNode(""));
  tag.setAttribute("data-s", "");
  return tag;
}
var StyleSheet = /* @__PURE__ */ function() {
  function StyleSheet2(options2) {
    var _this = this;
    this._insertTag = function(tag) {
      var before;
      if (_this.tags.length === 0) {
        if (_this.insertionPoint) {
          before = _this.insertionPoint.nextSibling;
        } else if (_this.prepend) {
          before = _this.container.firstChild;
        } else {
          before = _this.before;
        }
      } else {
        before = _this.tags[_this.tags.length - 1].nextSibling;
      }
      _this.container.insertBefore(tag, before);
      _this.tags.push(tag);
    };
    this.isSpeedy = options2.speedy === void 0 ? true : options2.speedy;
    this.tags = [];
    this.ctr = 0;
    this.nonce = options2.nonce;
    this.key = options2.key;
    this.container = options2.container;
    this.prepend = options2.prepend;
    this.insertionPoint = options2.insertionPoint;
    this.before = null;
  }
  var _proto = StyleSheet2.prototype;
  _proto.hydrate = function hydrate(nodes) {
    nodes.forEach(this._insertTag);
  };
  _proto.insert = function insert(rule) {
    if (this.ctr % (this.isSpeedy ? 65e3 : 1) === 0) {
      this._insertTag(createStyleElement(this));
    }
    var tag = this.tags[this.tags.length - 1];
    if (this.isSpeedy) {
      var sheet = sheetForTag(tag);
      try {
        sheet.insertRule(rule, sheet.cssRules.length);
      } catch (e3) {
      }
    } else {
      tag.appendChild(document.createTextNode(rule));
    }
    this.ctr++;
  };
  _proto.flush = function flush() {
    this.tags.forEach(function(tag) {
      var _tag$parentNode;
      return (_tag$parentNode = tag.parentNode) == null ? void 0 : _tag$parentNode.removeChild(tag);
    });
    this.tags = [];
    this.ctr = 0;
  };
  return StyleSheet2;
}();
var MS = "-ms-";
var MOZ = "-moz-";
var WEBKIT = "-webkit-";
var COMMENT = "comm";
var RULESET = "rule";
var DECLARATION = "decl";
var IMPORT = "@import";
var KEYFRAMES = "@keyframes";
var LAYER = "@layer";
var abs = Math.abs;
var from = String.fromCharCode;
var assign = Object.assign;
function hash(value, length2) {
  return charat(value, 0) ^ 45 ? (((length2 << 2 ^ charat(value, 0)) << 2 ^ charat(value, 1)) << 2 ^ charat(value, 2)) << 2 ^ charat(value, 3) : 0;
}
function trim(value) {
  return value.trim();
}
function match$1(value, pattern) {
  return (value = pattern.exec(value)) ? value[0] : value;
}
function replace(value, pattern, replacement) {
  return value.replace(pattern, replacement);
}
function indexof(value, search) {
  return value.indexOf(search);
}
function charat(value, index2) {
  return value.charCodeAt(index2) | 0;
}
function substr(value, begin, end2) {
  return value.slice(begin, end2);
}
function strlen(value) {
  return value.length;
}
function sizeof(value) {
  return value.length;
}
function append$1(value, array) {
  return array.push(value), value;
}
function combine(array, callback) {
  return array.map(callback).join("");
}
var line = 1;
var column = 1;
var length$1 = 0;
var position = 0;
var character = 0;
var characters = "";
function node(value, root2, parent, type2, props, children, length2) {
  return { value, root: root2, parent, type: type2, props, children, line, column, length: length2, return: "" };
}
function copy(root2, props) {
  return assign(node("", null, null, "", null, null, 0), root2, { length: -root2.length }, props);
}
function char() {
  return character;
}
function prev() {
  character = position > 0 ? charat(characters, --position) : 0;
  if (column--, character === 10)
    column = 1, line--;
  return character;
}
function next() {
  character = position < length$1 ? charat(characters, position++) : 0;
  if (column++, character === 10)
    column = 1, line++;
  return character;
}
function peek() {
  return charat(characters, position);
}
function caret() {
  return position;
}
function slice(begin, end2) {
  return substr(characters, begin, end2);
}
function token(type2) {
  switch (type2) {
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    case 59:
    case 123:
    case 125:
      return 4;
    case 58:
      return 3;
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function alloc(value) {
  return line = column = 1, length$1 = strlen(characters = value), position = 0, [];
}
function dealloc(value) {
  return characters = "", value;
}
function delimit(type2) {
  return trim(slice(position - 1, delimiter(type2 === 91 ? type2 + 2 : type2 === 40 ? type2 + 1 : type2)));
}
function whitespace(type2) {
  while (character = peek())
    if (character < 33)
      next();
    else
      break;
  return token(type2) > 2 || token(character) > 3 ? "" : " ";
}
function escaping(index2, count2) {
  while (--count2 && next())
    if (character < 48 || character > 102 || character > 57 && character < 65 || character > 70 && character < 97)
      break;
  return slice(index2, caret() + (count2 < 6 && peek() == 32 && next() == 32));
}
function delimiter(type2) {
  while (next())
    switch (character) {
      case type2:
        return position;
      case 34:
      case 39:
        if (type2 !== 34 && type2 !== 39)
          delimiter(character);
        break;
      case 40:
        if (type2 === 41)
          delimiter(type2);
        break;
      case 92:
        next();
        break;
    }
  return position;
}
function commenter(type2, index2) {
  while (next())
    if (type2 + character === 47 + 10)
      break;
    else if (type2 + character === 42 + 42 && peek() === 47)
      break;
  return "/*" + slice(index2, position - 1) + "*" + from(type2 === 47 ? type2 : next());
}
function identifier(index2) {
  while (!token(peek()))
    next();
  return slice(index2, position);
}
function compile(value) {
  return dealloc(parse$1("", null, null, null, [""], value = alloc(value), 0, [0], value));
}
function parse$1(value, root2, parent, rule, rules, rulesets, pseudo, points, declarations) {
  var index2 = 0;
  var offset2 = 0;
  var length2 = pseudo;
  var atrule = 0;
  var property2 = 0;
  var previous = 0;
  var variable = 1;
  var scanning = 1;
  var ampersand = 1;
  var character2 = 0;
  var type2 = "";
  var props = rules;
  var children = rulesets;
  var reference2 = rule;
  var characters2 = type2;
  while (scanning)
    switch (previous = character2, character2 = next()) {
      case 40:
        if (previous != 108 && charat(characters2, length2 - 1) == 58) {
          if (indexof(characters2 += replace(delimit(character2), "&", "&\f"), "&\f") != -1)
            ampersand = -1;
          break;
        }
      case 34:
      case 39:
      case 91:
        characters2 += delimit(character2);
        break;
      case 9:
      case 10:
      case 13:
      case 32:
        characters2 += whitespace(previous);
        break;
      case 92:
        characters2 += escaping(caret() - 1, 7);
        continue;
      case 47:
        switch (peek()) {
          case 42:
          case 47:
            append$1(comment(commenter(next(), caret()), root2, parent), declarations);
            break;
          default:
            characters2 += "/";
        }
        break;
      case 123 * variable:
        points[index2++] = strlen(characters2) * ampersand;
      case 125 * variable:
      case 59:
      case 0:
        switch (character2) {
          case 0:
          case 125:
            scanning = 0;
          case 59 + offset2:
            if (ampersand == -1) characters2 = replace(characters2, /\f/g, "");
            if (property2 > 0 && strlen(characters2) - length2)
              append$1(property2 > 32 ? declaration(characters2 + ";", rule, parent, length2 - 1) : declaration(replace(characters2, " ", "") + ";", rule, parent, length2 - 2), declarations);
            break;
          case 59:
            characters2 += ";";
          default:
            append$1(reference2 = ruleset(characters2, root2, parent, index2, offset2, rules, points, type2, props = [], children = [], length2), rulesets);
            if (character2 === 123)
              if (offset2 === 0)
                parse$1(characters2, root2, reference2, reference2, props, rulesets, length2, points, children);
              else
                switch (atrule === 99 && charat(characters2, 3) === 110 ? 100 : atrule) {
                  case 100:
                  case 108:
                  case 109:
                  case 115:
                    parse$1(value, reference2, reference2, rule && append$1(ruleset(value, reference2, reference2, 0, 0, rules, points, type2, rules, props = [], length2), children), rules, children, length2, points, rule ? props : children);
                    break;
                  default:
                    parse$1(characters2, reference2, reference2, reference2, [""], children, 0, points, children);
                }
        }
        index2 = offset2 = property2 = 0, variable = ampersand = 1, type2 = characters2 = "", length2 = pseudo;
        break;
      case 58:
        length2 = 1 + strlen(characters2), property2 = previous;
      default:
        if (variable < 1) {
          if (character2 == 123)
            --variable;
          else if (character2 == 125 && variable++ == 0 && prev() == 125)
            continue;
        }
        switch (characters2 += from(character2), character2 * variable) {
          case 38:
            ampersand = offset2 > 0 ? 1 : (characters2 += "\f", -1);
            break;
          case 44:
            points[index2++] = (strlen(characters2) - 1) * ampersand, ampersand = 1;
            break;
          case 64:
            if (peek() === 45)
              characters2 += delimit(next());
            atrule = peek(), offset2 = length2 = strlen(type2 = characters2 += identifier(caret())), character2++;
            break;
          case 45:
            if (previous === 45 && strlen(characters2) == 2)
              variable = 0;
        }
    }
  return rulesets;
}
function ruleset(value, root2, parent, index2, offset2, rules, points, type2, props, children, length2) {
  var post = offset2 - 1;
  var rule = offset2 === 0 ? rules : [""];
  var size2 = sizeof(rule);
  for (var i = 0, j = 0, k2 = 0; i < index2; ++i)
    for (var x2 = 0, y2 = substr(value, post + 1, post = abs(j = points[i])), z3 = value; x2 < size2; ++x2)
      if (z3 = trim(j > 0 ? rule[x2] + " " + y2 : replace(y2, /&\f/g, rule[x2])))
        props[k2++] = z3;
  return node(value, root2, parent, offset2 === 0 ? RULESET : type2, props, children, length2);
}
function comment(value, root2, parent) {
  return node(value, root2, parent, COMMENT, from(char()), substr(value, 2, -2), 0);
}
function declaration(value, root2, parent, length2) {
  return node(value, root2, parent, DECLARATION, substr(value, 0, length2), substr(value, length2 + 1, -1), length2);
}
function serialize(children, callback) {
  var output = "";
  var length2 = sizeof(children);
  for (var i = 0; i < length2; i++)
    output += callback(children[i], i, children, callback) || "";
  return output;
}
function stringify(element, index2, children, callback) {
  switch (element.type) {
    case LAYER:
      if (element.children.length) break;
    case IMPORT:
    case DECLARATION:
      return element.return = element.return || element.value;
    case COMMENT:
      return "";
    case KEYFRAMES:
      return element.return = element.value + "{" + serialize(element.children, callback) + "}";
    case RULESET:
      element.value = element.props.join(",");
  }
  return strlen(children = serialize(element.children, callback)) ? element.return = element.value + "{" + children + "}" : "";
}
function middleware(collection) {
  var length2 = sizeof(collection);
  return function(element, index2, children, callback) {
    var output = "";
    for (var i = 0; i < length2; i++)
      output += collection[i](element, index2, children, callback) || "";
    return output;
  };
}
function rulesheet(callback) {
  return function(element) {
    if (!element.root) {
      if (element = element.return)
        callback(element);
    }
  };
}
var identifierWithPointTracking = function identifierWithPointTracking2(begin, points, index2) {
  var previous = 0;
  var character2 = 0;
  while (true) {
    previous = character2;
    character2 = peek();
    if (previous === 38 && character2 === 12) {
      points[index2] = 1;
    }
    if (token(character2)) {
      break;
    }
    next();
  }
  return slice(begin, position);
};
var toRules = function toRules2(parsed, points) {
  var index2 = -1;
  var character2 = 44;
  do {
    switch (token(character2)) {
      case 0:
        if (character2 === 38 && peek() === 12) {
          points[index2] = 1;
        }
        parsed[index2] += identifierWithPointTracking(position - 1, points, index2);
        break;
      case 2:
        parsed[index2] += delimit(character2);
        break;
      case 4:
        if (character2 === 44) {
          parsed[++index2] = peek() === 58 ? "&\f" : "";
          points[index2] = parsed[index2].length;
          break;
        }
      default:
        parsed[index2] += from(character2);
    }
  } while (character2 = next());
  return parsed;
};
var getRules = function getRules2(value, points) {
  return dealloc(toRules(alloc(value), points));
};
var fixedElements = /* @__PURE__ */ new WeakMap();
var compat = function compat2(element) {
  if (element.type !== "rule" || !element.parent || // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  element.length < 1) {
    return;
  }
  var value = element.value;
  var parent = element.parent;
  var isImplicitRule = element.column === parent.column && element.line === parent.line;
  while (parent.type !== "rule") {
    parent = parent.parent;
    if (!parent) return;
  }
  if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !fixedElements.get(parent)) {
    return;
  }
  if (isImplicitRule) {
    return;
  }
  fixedElements.set(element, true);
  var points = [];
  var rules = getRules(value, points);
  var parentRules = parent.props;
  for (var i = 0, k2 = 0; i < rules.length; i++) {
    for (var j = 0; j < parentRules.length; j++, k2++) {
      element.props[k2] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
    }
  }
};
var removeLabel = function removeLabel2(element) {
  if (element.type === "decl") {
    var value = element.value;
    if (
      // charcode for l
      value.charCodeAt(0) === 108 && // charcode for b
      value.charCodeAt(2) === 98
    ) {
      element["return"] = "";
      element.value = "";
    }
  }
};
function prefix(value, length2) {
  switch (hash(value, length2)) {
    case 5103:
      return WEBKIT + "print-" + value + value;
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855:
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return WEBKIT + value + value;
    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return WEBKIT + value + MOZ + value + MS + value + value;
    case 6828:
    case 4268:
      return WEBKIT + value + MS + value + value;
    case 6165:
      return WEBKIT + value + MS + "flex-" + value + value;
    case 5187:
      return WEBKIT + value + replace(value, /(\w+).+(:[^]+)/, WEBKIT + "box-$1$2" + MS + "flex-$1$2") + value;
    case 5443:
      return WEBKIT + value + MS + "flex-item-" + replace(value, /flex-|-self/, "") + value;
    case 4675:
      return WEBKIT + value + MS + "flex-line-pack" + replace(value, /align-content|flex-|-self/, "") + value;
    case 5548:
      return WEBKIT + value + MS + replace(value, "shrink", "negative") + value;
    case 5292:
      return WEBKIT + value + MS + replace(value, "basis", "preferred-size") + value;
    case 6060:
      return WEBKIT + "box-" + replace(value, "-grow", "") + WEBKIT + value + MS + replace(value, "grow", "positive") + value;
    case 4554:
      return WEBKIT + replace(value, /([^-])(transform)/g, "$1" + WEBKIT + "$2") + value;
    case 6187:
      return replace(replace(replace(value, /(zoom-|grab)/, WEBKIT + "$1"), /(image-set)/, WEBKIT + "$1"), value, "") + value;
    case 5495:
    case 3959:
      return replace(value, /(image-set\([^]*)/, WEBKIT + "$1$`$1");
    case 4968:
      return replace(replace(value, /(.+:)(flex-)?(.*)/, WEBKIT + "box-pack:$3" + MS + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + WEBKIT + value + value;
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return replace(value, /(.+)-inline(.+)/, WEBKIT + "$1$2") + value;
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (strlen(value) - 1 - length2 > 6) switch (charat(value, length2 + 1)) {
        case 109:
          if (charat(value, length2 + 4) !== 45) break;
        case 102:
          return replace(value, /(.+:)(.+)-([^]+)/, "$1" + WEBKIT + "$2-$3$1" + MOZ + (charat(value, length2 + 3) == 108 ? "$3" : "$2-$3")) + value;
        case 115:
          return ~indexof(value, "stretch") ? prefix(replace(value, "stretch", "fill-available"), length2) + value : value;
      }
      break;
    case 4949:
      if (charat(value, length2 + 1) !== 115) break;
    case 6444:
      switch (charat(value, strlen(value) - 3 - (~indexof(value, "!important") && 10))) {
        case 107:
          return replace(value, ":", ":" + WEBKIT) + value;
        case 101:
          return replace(value, /(.+:)([^;!]+)(;|!.+)?/, "$1" + WEBKIT + (charat(value, 14) === 45 ? "inline-" : "") + "box$3$1" + WEBKIT + "$2$3$1" + MS + "$2box$3") + value;
      }
      break;
    case 5936:
      switch (charat(value, length2 + 11)) {
        case 114:
          return WEBKIT + value + MS + replace(value, /[svh]\w+-[tblr]{2}/, "tb") + value;
        case 108:
          return WEBKIT + value + MS + replace(value, /[svh]\w+-[tblr]{2}/, "tb-rl") + value;
        case 45:
          return WEBKIT + value + MS + replace(value, /[svh]\w+-[tblr]{2}/, "lr") + value;
      }
      return WEBKIT + value + MS + value + value;
  }
  return value;
}
var prefixer = function prefixer2(element, index2, children, callback) {
  if (element.length > -1) {
    if (!element["return"]) switch (element.type) {
      case DECLARATION:
        element["return"] = prefix(element.value, element.length);
        break;
      case KEYFRAMES:
        return serialize([copy(element, {
          value: replace(element.value, "@", "@" + WEBKIT)
        })], callback);
      case RULESET:
        if (element.length) return combine(element.props, function(value) {
          switch (match$1(value, /(::plac\w+|:read-\w+)/)) {
            case ":read-only":
            case ":read-write":
              return serialize([copy(element, {
                props: [replace(value, /:(read-\w+)/, ":" + MOZ + "$1")]
              })], callback);
            case "::placeholder":
              return serialize([copy(element, {
                props: [replace(value, /:(plac\w+)/, ":" + WEBKIT + "input-$1")]
              }), copy(element, {
                props: [replace(value, /:(plac\w+)/, ":" + MOZ + "$1")]
              }), copy(element, {
                props: [replace(value, /:(plac\w+)/, MS + "input-$1")]
              })], callback);
          }
          return "";
        });
    }
  }
};
var defaultStylisPlugins = [prefixer];
var createCache = function createCache2(options2) {
  var key = options2.key;
  if (key === "css") {
    var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])");
    Array.prototype.forEach.call(ssrStyles, function(node2) {
      var dataEmotionAttribute = node2.getAttribute("data-emotion");
      if (dataEmotionAttribute.indexOf(" ") === -1) {
        return;
      }
      document.head.appendChild(node2);
      node2.setAttribute("data-s", "");
    });
  }
  var stylisPlugins = options2.stylisPlugins || defaultStylisPlugins;
  var inserted = {};
  var container;
  var nodesToHydrate = [];
  {
    container = options2.container || document.head;
    Array.prototype.forEach.call(
      // this means we will ignore elements which don't have a space in them which
      // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
      document.querySelectorAll('style[data-emotion^="' + key + ' "]'),
      function(node2) {
        var attrib = node2.getAttribute("data-emotion").split(" ");
        for (var i = 1; i < attrib.length; i++) {
          inserted[attrib[i]] = true;
        }
        nodesToHydrate.push(node2);
      }
    );
  }
  var _insert;
  var omnipresentPlugins = [compat, removeLabel];
  {
    var currentSheet;
    var finalizingPlugins = [stringify, rulesheet(function(rule) {
      currentSheet.insert(rule);
    })];
    var serializer = middleware(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
    var stylis = function stylis2(styles) {
      return serialize(compile(styles), serializer);
    };
    _insert = function insert(selector, serialized, sheet, shouldCache) {
      currentSheet = sheet;
      stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
      if (shouldCache) {
        cache.inserted[serialized.name] = true;
      }
    };
  }
  var cache = {
    key,
    sheet: new StyleSheet({
      key,
      container,
      nonce: options2.nonce,
      speedy: options2.speedy,
      prepend: options2.prepend,
      insertionPoint: options2.insertionPoint
    }),
    nonce: options2.nonce,
    inserted,
    registered: {},
    insert: _insert
  };
  cache.sheet.hydrate(nodesToHydrate);
  return cache;
};
var reactIs$1 = { exports: {} };
var reactIs_production_min$1 = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactIs_production_min$1;
function requireReactIs_production_min$1() {
  if (hasRequiredReactIs_production_min$1) return reactIs_production_min$1;
  hasRequiredReactIs_production_min$1 = 1;
  var b2 = "function" === typeof Symbol && Symbol.for, c2 = b2 ? Symbol.for("react.element") : 60103, d2 = b2 ? Symbol.for("react.portal") : 60106, e3 = b2 ? Symbol.for("react.fragment") : 60107, f2 = b2 ? Symbol.for("react.strict_mode") : 60108, g3 = b2 ? Symbol.for("react.profiler") : 60114, h2 = b2 ? Symbol.for("react.provider") : 60109, k2 = b2 ? Symbol.for("react.context") : 60110, l2 = b2 ? Symbol.for("react.async_mode") : 60111, m2 = b2 ? Symbol.for("react.concurrent_mode") : 60111, n2 = b2 ? Symbol.for("react.forward_ref") : 60112, p2 = b2 ? Symbol.for("react.suspense") : 60113, q2 = b2 ? Symbol.for("react.suspense_list") : 60120, r2 = b2 ? Symbol.for("react.memo") : 60115, t2 = b2 ? Symbol.for("react.lazy") : 60116, v2 = b2 ? Symbol.for("react.block") : 60121, w3 = b2 ? Symbol.for("react.fundamental") : 60117, x2 = b2 ? Symbol.for("react.responder") : 60118, y2 = b2 ? Symbol.for("react.scope") : 60119;
  function z3(a2) {
    if ("object" === typeof a2 && null !== a2) {
      var u2 = a2.$$typeof;
      switch (u2) {
        case c2:
          switch (a2 = a2.type, a2) {
            case l2:
            case m2:
            case e3:
            case g3:
            case f2:
            case p2:
              return a2;
            default:
              switch (a2 = a2 && a2.$$typeof, a2) {
                case k2:
                case n2:
                case t2:
                case r2:
                case h2:
                  return a2;
                default:
                  return u2;
              }
          }
        case d2:
          return u2;
      }
    }
  }
  function A3(a2) {
    return z3(a2) === m2;
  }
  reactIs_production_min$1.AsyncMode = l2;
  reactIs_production_min$1.ConcurrentMode = m2;
  reactIs_production_min$1.ContextConsumer = k2;
  reactIs_production_min$1.ContextProvider = h2;
  reactIs_production_min$1.Element = c2;
  reactIs_production_min$1.ForwardRef = n2;
  reactIs_production_min$1.Fragment = e3;
  reactIs_production_min$1.Lazy = t2;
  reactIs_production_min$1.Memo = r2;
  reactIs_production_min$1.Portal = d2;
  reactIs_production_min$1.Profiler = g3;
  reactIs_production_min$1.StrictMode = f2;
  reactIs_production_min$1.Suspense = p2;
  reactIs_production_min$1.isAsyncMode = function(a2) {
    return A3(a2) || z3(a2) === l2;
  };
  reactIs_production_min$1.isConcurrentMode = A3;
  reactIs_production_min$1.isContextConsumer = function(a2) {
    return z3(a2) === k2;
  };
  reactIs_production_min$1.isContextProvider = function(a2) {
    return z3(a2) === h2;
  };
  reactIs_production_min$1.isElement = function(a2) {
    return "object" === typeof a2 && null !== a2 && a2.$$typeof === c2;
  };
  reactIs_production_min$1.isForwardRef = function(a2) {
    return z3(a2) === n2;
  };
  reactIs_production_min$1.isFragment = function(a2) {
    return z3(a2) === e3;
  };
  reactIs_production_min$1.isLazy = function(a2) {
    return z3(a2) === t2;
  };
  reactIs_production_min$1.isMemo = function(a2) {
    return z3(a2) === r2;
  };
  reactIs_production_min$1.isPortal = function(a2) {
    return z3(a2) === d2;
  };
  reactIs_production_min$1.isProfiler = function(a2) {
    return z3(a2) === g3;
  };
  reactIs_production_min$1.isStrictMode = function(a2) {
    return z3(a2) === f2;
  };
  reactIs_production_min$1.isSuspense = function(a2) {
    return z3(a2) === p2;
  };
  reactIs_production_min$1.isValidElementType = function(a2) {
    return "string" === typeof a2 || "function" === typeof a2 || a2 === e3 || a2 === m2 || a2 === g3 || a2 === f2 || a2 === p2 || a2 === q2 || "object" === typeof a2 && null !== a2 && (a2.$$typeof === t2 || a2.$$typeof === r2 || a2.$$typeof === h2 || a2.$$typeof === k2 || a2.$$typeof === n2 || a2.$$typeof === w3 || a2.$$typeof === x2 || a2.$$typeof === y2 || a2.$$typeof === v2);
  };
  reactIs_production_min$1.typeOf = z3;
  return reactIs_production_min$1;
}
var reactIs_development$1 = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactIs_development$1;
function requireReactIs_development$1() {
  if (hasRequiredReactIs_development$1) return reactIs_development$1;
  hasRequiredReactIs_development$1 = 1;
  if (process.env.NODE_ENV !== "production") {
    (function() {
      var hasSymbol = typeof Symbol === "function" && Symbol.for;
      var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for("react.element") : 60103;
      var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for("react.portal") : 60106;
      var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for("react.fragment") : 60107;
      var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for("react.strict_mode") : 60108;
      var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for("react.profiler") : 60114;
      var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for("react.provider") : 60109;
      var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for("react.context") : 60110;
      var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for("react.async_mode") : 60111;
      var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for("react.concurrent_mode") : 60111;
      var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for("react.forward_ref") : 60112;
      var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for("react.suspense") : 60113;
      var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for("react.suspense_list") : 60120;
      var REACT_MEMO_TYPE = hasSymbol ? Symbol.for("react.memo") : 60115;
      var REACT_LAZY_TYPE = hasSymbol ? Symbol.for("react.lazy") : 60116;
      var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for("react.block") : 60121;
      var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for("react.fundamental") : 60117;
      var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for("react.responder") : 60118;
      var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for("react.scope") : 60119;
      function isValidElementType(type2) {
        return typeof type2 === "string" || typeof type2 === "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
        type2 === REACT_FRAGMENT_TYPE || type2 === REACT_CONCURRENT_MODE_TYPE || type2 === REACT_PROFILER_TYPE || type2 === REACT_STRICT_MODE_TYPE || type2 === REACT_SUSPENSE_TYPE || type2 === REACT_SUSPENSE_LIST_TYPE || typeof type2 === "object" && type2 !== null && (type2.$$typeof === REACT_LAZY_TYPE || type2.$$typeof === REACT_MEMO_TYPE || type2.$$typeof === REACT_PROVIDER_TYPE || type2.$$typeof === REACT_CONTEXT_TYPE || type2.$$typeof === REACT_FORWARD_REF_TYPE || type2.$$typeof === REACT_FUNDAMENTAL_TYPE || type2.$$typeof === REACT_RESPONDER_TYPE || type2.$$typeof === REACT_SCOPE_TYPE || type2.$$typeof === REACT_BLOCK_TYPE);
      }
      function typeOf2(object2) {
        if (typeof object2 === "object" && object2 !== null) {
          var $$typeof = object2.$$typeof;
          switch ($$typeof) {
            case REACT_ELEMENT_TYPE:
              var type2 = object2.type;
              switch (type2) {
                case REACT_ASYNC_MODE_TYPE:
                case REACT_CONCURRENT_MODE_TYPE:
                case REACT_FRAGMENT_TYPE:
                case REACT_PROFILER_TYPE:
                case REACT_STRICT_MODE_TYPE:
                case REACT_SUSPENSE_TYPE:
                  return type2;
                default:
                  var $$typeofType = type2 && type2.$$typeof;
                  switch ($$typeofType) {
                    case REACT_CONTEXT_TYPE:
                    case REACT_FORWARD_REF_TYPE:
                    case REACT_LAZY_TYPE:
                    case REACT_MEMO_TYPE:
                    case REACT_PROVIDER_TYPE:
                      return $$typeofType;
                    default:
                      return $$typeof;
                  }
              }
            case REACT_PORTAL_TYPE:
              return $$typeof;
          }
        }
        return void 0;
      }
      var AsyncMode = REACT_ASYNC_MODE_TYPE;
      var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
      var ContextConsumer = REACT_CONTEXT_TYPE;
      var ContextProvider = REACT_PROVIDER_TYPE;
      var Element2 = REACT_ELEMENT_TYPE;
      var ForwardRef = REACT_FORWARD_REF_TYPE;
      var Fragment2 = REACT_FRAGMENT_TYPE;
      var Lazy = REACT_LAZY_TYPE;
      var Memo = REACT_MEMO_TYPE;
      var Portal2 = REACT_PORTAL_TYPE;
      var Profiler = REACT_PROFILER_TYPE;
      var StrictMode = REACT_STRICT_MODE_TYPE;
      var Suspense = REACT_SUSPENSE_TYPE;
      var hasWarnedAboutDeprecatedIsAsyncMode = false;
      function isAsyncMode(object2) {
        {
          if (!hasWarnedAboutDeprecatedIsAsyncMode) {
            hasWarnedAboutDeprecatedIsAsyncMode = true;
            console["warn"]("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.");
          }
        }
        return isConcurrentMode(object2) || typeOf2(object2) === REACT_ASYNC_MODE_TYPE;
      }
      function isConcurrentMode(object2) {
        return typeOf2(object2) === REACT_CONCURRENT_MODE_TYPE;
      }
      function isContextConsumer(object2) {
        return typeOf2(object2) === REACT_CONTEXT_TYPE;
      }
      function isContextProvider(object2) {
        return typeOf2(object2) === REACT_PROVIDER_TYPE;
      }
      function isElement2(object2) {
        return typeof object2 === "object" && object2 !== null && object2.$$typeof === REACT_ELEMENT_TYPE;
      }
      function isForwardRef(object2) {
        return typeOf2(object2) === REACT_FORWARD_REF_TYPE;
      }
      function isFragment(object2) {
        return typeOf2(object2) === REACT_FRAGMENT_TYPE;
      }
      function isLazy(object2) {
        return typeOf2(object2) === REACT_LAZY_TYPE;
      }
      function isMemo(object2) {
        return typeOf2(object2) === REACT_MEMO_TYPE;
      }
      function isPortal(object2) {
        return typeOf2(object2) === REACT_PORTAL_TYPE;
      }
      function isProfiler(object2) {
        return typeOf2(object2) === REACT_PROFILER_TYPE;
      }
      function isStrictMode(object2) {
        return typeOf2(object2) === REACT_STRICT_MODE_TYPE;
      }
      function isSuspense(object2) {
        return typeOf2(object2) === REACT_SUSPENSE_TYPE;
      }
      reactIs_development$1.AsyncMode = AsyncMode;
      reactIs_development$1.ConcurrentMode = ConcurrentMode;
      reactIs_development$1.ContextConsumer = ContextConsumer;
      reactIs_development$1.ContextProvider = ContextProvider;
      reactIs_development$1.Element = Element2;
      reactIs_development$1.ForwardRef = ForwardRef;
      reactIs_development$1.Fragment = Fragment2;
      reactIs_development$1.Lazy = Lazy;
      reactIs_development$1.Memo = Memo;
      reactIs_development$1.Portal = Portal2;
      reactIs_development$1.Profiler = Profiler;
      reactIs_development$1.StrictMode = StrictMode;
      reactIs_development$1.Suspense = Suspense;
      reactIs_development$1.isAsyncMode = isAsyncMode;
      reactIs_development$1.isConcurrentMode = isConcurrentMode;
      reactIs_development$1.isContextConsumer = isContextConsumer;
      reactIs_development$1.isContextProvider = isContextProvider;
      reactIs_development$1.isElement = isElement2;
      reactIs_development$1.isForwardRef = isForwardRef;
      reactIs_development$1.isFragment = isFragment;
      reactIs_development$1.isLazy = isLazy;
      reactIs_development$1.isMemo = isMemo;
      reactIs_development$1.isPortal = isPortal;
      reactIs_development$1.isProfiler = isProfiler;
      reactIs_development$1.isStrictMode = isStrictMode;
      reactIs_development$1.isSuspense = isSuspense;
      reactIs_development$1.isValidElementType = isValidElementType;
      reactIs_development$1.typeOf = typeOf2;
    })();
  }
  return reactIs_development$1;
}
if (process.env.NODE_ENV === "production") {
  reactIs$1.exports = requireReactIs_production_min$1();
} else {
  reactIs$1.exports = requireReactIs_development$1();
}
var reactIsExports = reactIs$1.exports;
var reactIs = reactIsExports;
var FORWARD_REF_STATICS = {
  "$$typeof": true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  "$$typeof": true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;
var isBrowser = true;
function getRegisteredStyles(registered, registeredStyles, classNames2) {
  var rawClassName = "";
  classNames2.split(" ").forEach(function(className) {
    if (registered[className] !== void 0) {
      registeredStyles.push(registered[className] + ";");
    } else if (className) {
      rawClassName += className + " ";
    }
  });
  return rawClassName;
}
var registerStyles = function registerStyles2(cache, serialized, isStringTag) {
  var className = cache.key + "-" + serialized.name;
  if (
    // we only need to add the styles to the registered cache if the
    // class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    isBrowser === false) && cache.registered[className] === void 0
  ) {
    cache.registered[className] = serialized.styles;
  }
};
var insertStyles = function insertStyles2(cache, serialized, isStringTag) {
  registerStyles(cache, serialized, isStringTag);
  var className = cache.key + "-" + serialized.name;
  if (cache.inserted[serialized.name] === void 0) {
    var current = serialized;
    do {
      cache.insert(serialized === current ? "." + className : "", current, cache.sheet, true);
      current = current.next;
    } while (current !== void 0);
  }
};
function murmur2(str) {
  var h2 = 0;
  var k2, i = 0, len = str.length;
  for (; len >= 4; ++i, len -= 4) {
    k2 = str.charCodeAt(i) & 255 | (str.charCodeAt(++i) & 255) << 8 | (str.charCodeAt(++i) & 255) << 16 | (str.charCodeAt(++i) & 255) << 24;
    k2 = /* Math.imul(k, m): */
    (k2 & 65535) * 1540483477 + ((k2 >>> 16) * 59797 << 16);
    k2 ^= /* k >>> r: */
    k2 >>> 24;
    h2 = /* Math.imul(k, m): */
    (k2 & 65535) * 1540483477 + ((k2 >>> 16) * 59797 << 16) ^ /* Math.imul(h, m): */
    (h2 & 65535) * 1540483477 + ((h2 >>> 16) * 59797 << 16);
  }
  switch (len) {
    case 3:
      h2 ^= (str.charCodeAt(i + 2) & 255) << 16;
    case 2:
      h2 ^= (str.charCodeAt(i + 1) & 255) << 8;
    case 1:
      h2 ^= str.charCodeAt(i) & 255;
      h2 = /* Math.imul(h, m): */
      (h2 & 65535) * 1540483477 + ((h2 >>> 16) * 59797 << 16);
  }
  h2 ^= h2 >>> 13;
  h2 = /* Math.imul(h, m): */
  (h2 & 65535) * 1540483477 + ((h2 >>> 16) * 59797 << 16);
  return ((h2 ^ h2 >>> 15) >>> 0).toString(36);
}
var unitlessKeys = {
  animationIterationCount: 1,
  aspectRatio: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  scale: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};
var hyphenateRegex = /[A-Z]|^ms/g;
var animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var isCustomProperty = function isCustomProperty2(property2) {
  return property2.charCodeAt(1) === 45;
};
var isProcessableValue = function isProcessableValue2(value) {
  return value != null && typeof value !== "boolean";
};
var processStyleName = /* @__PURE__ */ memoize$2(function(styleName) {
  return isCustomProperty(styleName) ? styleName : styleName.replace(hyphenateRegex, "-$&").toLowerCase();
});
var processStyleValue = function processStyleValue2(key, value) {
  switch (key) {
    case "animation":
    case "animationName": {
      if (typeof value === "string") {
        return value.replace(animationRegex, function(match2, p1, p2) {
          cursor = {
            name: p1,
            styles: p2,
            next: cursor
          };
          return p1;
        });
      }
    }
  }
  if (unitlessKeys[key] !== 1 && !isCustomProperty(key) && typeof value === "number" && value !== 0) {
    return value + "px";
  }
  return value;
};
function handleInterpolation(mergedProps, registered, interpolation) {
  if (interpolation == null) {
    return "";
  }
  var componentSelector = interpolation;
  if (componentSelector.__emotion_styles !== void 0) {
    return componentSelector;
  }
  switch (typeof interpolation) {
    case "boolean": {
      return "";
    }
    case "object": {
      var keyframes2 = interpolation;
      if (keyframes2.anim === 1) {
        cursor = {
          name: keyframes2.name,
          styles: keyframes2.styles,
          next: cursor
        };
        return keyframes2.name;
      }
      var serializedStyles = interpolation;
      if (serializedStyles.styles !== void 0) {
        var next2 = serializedStyles.next;
        if (next2 !== void 0) {
          while (next2 !== void 0) {
            cursor = {
              name: next2.name,
              styles: next2.styles,
              next: cursor
            };
            next2 = next2.next;
          }
        }
        var styles = serializedStyles.styles + ";";
        return styles;
      }
      return createStringFromObject(mergedProps, registered, interpolation);
    }
    case "function": {
      if (mergedProps !== void 0) {
        var previousCursor = cursor;
        var result = interpolation(mergedProps);
        cursor = previousCursor;
        return handleInterpolation(mergedProps, registered, result);
      }
      break;
    }
  }
  var asString = interpolation;
  {
    return asString;
  }
}
function createStringFromObject(mergedProps, registered, obj) {
  var string = "";
  if (Array.isArray(obj)) {
    for (var i = 0; i < obj.length; i++) {
      string += handleInterpolation(mergedProps, registered, obj[i]) + ";";
    }
  } else {
    for (var key in obj) {
      var value = obj[key];
      if (typeof value !== "object") {
        var asString = value;
        if (isProcessableValue(asString)) {
          string += processStyleName(key) + ":" + processStyleValue(key, asString) + ";";
        }
      } else {
        if (Array.isArray(value) && typeof value[0] === "string" && registered == null) {
          for (var _i = 0; _i < value.length; _i++) {
            if (isProcessableValue(value[_i])) {
              string += processStyleName(key) + ":" + processStyleValue(key, value[_i]) + ";";
            }
          }
        } else {
          var interpolated = handleInterpolation(mergedProps, registered, value);
          switch (key) {
            case "animation":
            case "animationName": {
              string += processStyleName(key) + ":" + interpolated + ";";
              break;
            }
            default: {
              string += key + "{" + interpolated + "}";
            }
          }
        }
      }
    }
  }
  return string;
}
var labelPattern = /label:\s*([^\s;{]+)\s*(;|$)/g;
var cursor;
function serializeStyles(args, registered, mergedProps) {
  if (args.length === 1 && typeof args[0] === "object" && args[0] !== null && args[0].styles !== void 0) {
    return args[0];
  }
  var stringMode = true;
  var styles = "";
  cursor = void 0;
  var strings = args[0];
  if (strings == null || strings.raw === void 0) {
    stringMode = false;
    styles += handleInterpolation(mergedProps, registered, strings);
  } else {
    var asTemplateStringsArr = strings;
    styles += asTemplateStringsArr[0];
  }
  for (var i = 1; i < args.length; i++) {
    styles += handleInterpolation(mergedProps, registered, args[i]);
    if (stringMode) {
      var templateStringsArr = strings;
      styles += templateStringsArr[i];
    }
  }
  labelPattern.lastIndex = 0;
  var identifierName = "";
  var match2;
  while ((match2 = labelPattern.exec(styles)) !== null) {
    identifierName += "-" + match2[1];
  }
  var name = murmur2(styles) + identifierName;
  return {
    name,
    styles,
    next: cursor
  };
}
var syncFallback = function syncFallback2(create) {
  return create();
};
var useInsertionEffect$1 = React["useInsertionEffect"] ? React["useInsertionEffect"] : false;
var useInsertionEffectAlwaysWithSyncFallback = useInsertionEffect$1 || syncFallback;
var EmotionCacheContext = /* @__PURE__ */ React.createContext(
  // we're doing this to avoid preconstruct's dead code elimination in this one case
  // because this module is primarily intended for the browser and node
  // but it's also required in react native and similar environments sometimes
  // and we could have a special build just for that
  // but this is much easier and the native packages
  // might use a different theme context in the future anyway
  typeof HTMLElement !== "undefined" ? /* @__PURE__ */ createCache({
    key: "css"
  }) : null
);
EmotionCacheContext.Provider;
var withEmotionCache = function withEmotionCache2(func) {
  return /* @__PURE__ */ forwardRef(function(props, ref2) {
    var cache = useContext(EmotionCacheContext);
    return func(props, cache, ref2);
  });
};
var ThemeContext = /* @__PURE__ */ React.createContext({});
var hasOwn = {}.hasOwnProperty;
var typePropName = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__";
var createEmotionProps = function createEmotionProps2(type2, props) {
  var newProps = {};
  for (var _key in props) {
    if (hasOwn.call(props, _key)) {
      newProps[_key] = props[_key];
    }
  }
  newProps[typePropName] = type2;
  return newProps;
};
var Insertion = function Insertion2(_ref3) {
  var cache = _ref3.cache, serialized = _ref3.serialized, isStringTag = _ref3.isStringTag;
  registerStyles(cache, serialized, isStringTag);
  useInsertionEffectAlwaysWithSyncFallback(function() {
    return insertStyles(cache, serialized, isStringTag);
  });
  return null;
};
var Emotion = /* @__PURE__ */ withEmotionCache(function(props, cache, ref2) {
  var cssProp = props.css;
  if (typeof cssProp === "string" && cache.registered[cssProp] !== void 0) {
    cssProp = cache.registered[cssProp];
  }
  var WrappedComponent = props[typePropName];
  var registeredStyles = [cssProp];
  var className = "";
  if (typeof props.className === "string") {
    className = getRegisteredStyles(cache.registered, registeredStyles, props.className);
  } else if (props.className != null) {
    className = props.className + " ";
  }
  var serialized = serializeStyles(registeredStyles, void 0, React.useContext(ThemeContext));
  className += cache.key + "-" + serialized.name;
  var newProps = {};
  for (var _key2 in props) {
    if (hasOwn.call(props, _key2) && _key2 !== "css" && _key2 !== typePropName && true) {
      newProps[_key2] = props[_key2];
    }
  }
  newProps.className = className;
  if (ref2) {
    newProps.ref = ref2;
  }
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Insertion, {
    cache,
    serialized,
    isStringTag: typeof WrappedComponent === "string"
  }), /* @__PURE__ */ React.createElement(WrappedComponent, newProps));
});
var Emotion$1 = Emotion;
var jsx = function jsx2(type2, props) {
  var args = arguments;
  if (props == null || !hasOwn.call(props, "css")) {
    return React.createElement.apply(void 0, args);
  }
  var argsLength = args.length;
  var createElementArgArray = new Array(argsLength);
  createElementArgArray[0] = Emotion$1;
  createElementArgArray[1] = createEmotionProps(type2, props);
  for (var i = 2; i < argsLength; i++) {
    createElementArgArray[i] = args[i];
  }
  return React.createElement.apply(null, createElementArgArray);
};
(function(_jsx) {
  var JSX;
  /* @__PURE__ */ (function(_JSX) {
  })(JSX || (JSX = _jsx.JSX || (_jsx.JSX = {})));
})(jsx || (jsx = {}));
function css$2() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  return serializeStyles(args);
}
function keyframes() {
  var insertable = css$2.apply(void 0, arguments);
  var name = "animation-" + insertable.name;
  return {
    name,
    styles: "@keyframes " + name + "{" + insertable.styles + "}",
    anim: 1,
    toString: function toString2() {
      return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
    }
  };
}
function _arrayWithHoles(r2) {
  if (Array.isArray(r2)) return r2;
}
function _iterableToArrayLimit(r2, l2) {
  var t2 = null == r2 ? null : "undefined" != typeof Symbol && r2[Symbol.iterator] || r2["@@iterator"];
  if (null != t2) {
    var e3, n2, i, u2, a2 = [], f2 = true, o = false;
    try {
      if (i = (t2 = t2.call(r2)).next, 0 === l2) {
        if (Object(t2) !== t2) return;
        f2 = false;
      } else for (; !(f2 = (e3 = i.call(t2)).done) && (a2.push(e3.value), a2.length !== l2); f2 = true) ;
    } catch (r3) {
      o = true, n2 = r3;
    } finally {
      try {
        if (!f2 && null != t2["return"] && (u2 = t2["return"](), Object(u2) !== u2)) return;
      } finally {
        if (o) throw n2;
      }
    }
    return a2;
  }
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(r2, e3) {
  return _arrayWithHoles(r2) || _iterableToArrayLimit(r2, e3) || _unsupportedIterableToArray(r2, e3) || _nonIterableRest();
}
function _objectWithoutProperties$3(e3, t2) {
  if (null == e3) return {};
  var o, r2, i = _objectWithoutPropertiesLoose$4(e3, t2);
  if (Object.getOwnPropertySymbols) {
    var n2 = Object.getOwnPropertySymbols(e3);
    for (r2 = 0; r2 < n2.length; r2++) o = n2[r2], -1 === t2.indexOf(o) && {}.propertyIsEnumerable.call(e3, o) && (i[o] = e3[o]);
  }
  return i;
}
function _taggedTemplateLiteral(e3, t2) {
  return t2 || (t2 = e3.slice(0)), Object.freeze(Object.defineProperties(e3, {
    raw: {
      value: Object.freeze(t2)
    }
  }));
}
const min$4 = Math.min;
const max$4 = Math.max;
const oppositeSideMap = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
const oppositeAlignmentMap = {
  start: "end",
  end: "start"
};
function clamp$1(start2, value, end2) {
  return max$4(start2, min$4(value, end2));
}
function evaluate$1(value, param) {
  return typeof value === "function" ? value(param) : value;
}
function getSide$1(placement) {
  return placement.split("-")[0];
}
function getAlignment$1(placement) {
  return placement.split("-")[1];
}
function getOppositeAxis(axis) {
  return axis === "x" ? "y" : "x";
}
function getAxisLength(axis) {
  return axis === "y" ? "height" : "width";
}
function getSideAxis$1(placement) {
  return ["top", "bottom"].includes(getSide$1(placement)) ? "y" : "x";
}
function getAlignmentAxis(placement) {
  return getOppositeAxis(getSideAxis$1(placement));
}
function getAlignmentSides(placement, rects, rtl) {
  if (rtl === void 0) {
    rtl = false;
  }
  const alignment = getAlignment$1(placement);
  const alignmentAxis = getAlignmentAxis(placement);
  const length2 = getAxisLength(alignmentAxis);
  let mainAlignmentSide = alignmentAxis === "x" ? alignment === (rtl ? "end" : "start") ? "right" : "left" : alignment === "start" ? "bottom" : "top";
  if (rects.reference[length2] > rects.floating[length2]) {
    mainAlignmentSide = getOppositePlacement(mainAlignmentSide);
  }
  return [mainAlignmentSide, getOppositePlacement(mainAlignmentSide)];
}
function getExpandedPlacements(placement) {
  const oppositePlacement = getOppositePlacement(placement);
  return [getOppositeAlignmentPlacement(placement), oppositePlacement, getOppositeAlignmentPlacement(oppositePlacement)];
}
function getOppositeAlignmentPlacement(placement) {
  return placement.replace(/start|end/g, (alignment) => oppositeAlignmentMap[alignment]);
}
function getSideList(side, isStart, rtl) {
  const lr = ["left", "right"];
  const rl = ["right", "left"];
  const tb = ["top", "bottom"];
  const bt = ["bottom", "top"];
  switch (side) {
    case "top":
    case "bottom":
      if (rtl) return isStart ? rl : lr;
      return isStart ? lr : rl;
    case "left":
    case "right":
      return isStart ? tb : bt;
    default:
      return [];
  }
}
function getOppositeAxisPlacements(placement, flipAlignment, direction, rtl) {
  const alignment = getAlignment$1(placement);
  let list = getSideList(getSide$1(placement), direction === "start", rtl);
  if (alignment) {
    list = list.map((side) => side + "-" + alignment);
    if (flipAlignment) {
      list = list.concat(list.map(getOppositeAlignmentPlacement));
    }
  }
  return list;
}
function getOppositePlacement(placement) {
  return placement.replace(/left|right|bottom|top/g, (side) => oppositeSideMap[side]);
}
function expandPaddingObject$1(padding2) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...padding2
  };
}
function getPaddingObject$1(padding2) {
  return typeof padding2 !== "number" ? expandPaddingObject$1(padding2) : {
    top: padding2,
    right: padding2,
    bottom: padding2,
    left: padding2
  };
}
function rectToClientRect$1(rect) {
  const {
    x: x2,
    y: y2,
    width: width2,
    height: height2
  } = rect;
  return {
    width: width2,
    height: height2,
    top: y2,
    left: x2,
    right: x2 + width2,
    bottom: y2 + height2,
    x: x2,
    y: y2
  };
}
function computeCoordsFromPlacement(_ref3, placement, rtl) {
  let {
    reference: reference2,
    floating
  } = _ref3;
  const sideAxis = getSideAxis$1(placement);
  const alignmentAxis = getAlignmentAxis(placement);
  const alignLength = getAxisLength(alignmentAxis);
  const side = getSide$1(placement);
  const isVertical = sideAxis === "y";
  const commonX = reference2.x + reference2.width / 2 - floating.width / 2;
  const commonY = reference2.y + reference2.height / 2 - floating.height / 2;
  const commonAlign = reference2[alignLength] / 2 - floating[alignLength] / 2;
  let coords;
  switch (side) {
    case "top":
      coords = {
        x: commonX,
        y: reference2.y - floating.height
      };
      break;
    case "bottom":
      coords = {
        x: commonX,
        y: reference2.y + reference2.height
      };
      break;
    case "right":
      coords = {
        x: reference2.x + reference2.width,
        y: commonY
      };
      break;
    case "left":
      coords = {
        x: reference2.x - floating.width,
        y: commonY
      };
      break;
    default:
      coords = {
        x: reference2.x,
        y: reference2.y
      };
  }
  switch (getAlignment$1(placement)) {
    case "start":
      coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
      break;
    case "end":
      coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
      break;
  }
  return coords;
}
const computePosition$1 = async (reference2, floating, config2) => {
  const {
    placement = "bottom",
    strategy = "absolute",
    middleware: middleware2 = [],
    platform: platform2
  } = config2;
  const validMiddleware = middleware2.filter(Boolean);
  const rtl = await (platform2.isRTL == null ? void 0 : platform2.isRTL(floating));
  let rects = await platform2.getElementRects({
    reference: reference2,
    floating,
    strategy
  });
  let {
    x: x2,
    y: y2
  } = computeCoordsFromPlacement(rects, placement, rtl);
  let statefulPlacement = placement;
  let middlewareData = {};
  let resetCount = 0;
  for (let i = 0; i < validMiddleware.length; i++) {
    const {
      name,
      fn: fn2
    } = validMiddleware[i];
    const {
      x: nextX,
      y: nextY,
      data,
      reset
    } = await fn2({
      x: x2,
      y: y2,
      initialPlacement: placement,
      placement: statefulPlacement,
      strategy,
      middlewareData,
      rects,
      platform: platform2,
      elements: {
        reference: reference2,
        floating
      }
    });
    x2 = nextX != null ? nextX : x2;
    y2 = nextY != null ? nextY : y2;
    middlewareData = {
      ...middlewareData,
      [name]: {
        ...middlewareData[name],
        ...data
      }
    };
    if (reset && resetCount <= 50) {
      resetCount++;
      if (typeof reset === "object") {
        if (reset.placement) {
          statefulPlacement = reset.placement;
        }
        if (reset.rects) {
          rects = reset.rects === true ? await platform2.getElementRects({
            reference: reference2,
            floating,
            strategy
          }) : reset.rects;
        }
        ({
          x: x2,
          y: y2
        } = computeCoordsFromPlacement(rects, statefulPlacement, rtl));
      }
      i = -1;
    }
  }
  return {
    x: x2,
    y: y2,
    placement: statefulPlacement,
    strategy,
    middlewareData
  };
};
async function detectOverflow$1(state, options2) {
  var _await$platform$isEle;
  if (options2 === void 0) {
    options2 = {};
  }
  const {
    x: x2,
    y: y2,
    platform: platform2,
    rects,
    elements,
    strategy
  } = state;
  const {
    boundary = "clippingAncestors",
    rootBoundary = "viewport",
    elementContext = "floating",
    altBoundary = false,
    padding: padding2 = 0
  } = evaluate$1(options2, state);
  const paddingObject = getPaddingObject$1(padding2);
  const altContext = elementContext === "floating" ? "reference" : "floating";
  const element = elements[altBoundary ? altContext : elementContext];
  const clippingClientRect = rectToClientRect$1(await platform2.getClippingRect({
    element: ((_await$platform$isEle = await (platform2.isElement == null ? void 0 : platform2.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || await (platform2.getDocumentElement == null ? void 0 : platform2.getDocumentElement(elements.floating)),
    boundary,
    rootBoundary,
    strategy
  }));
  const rect = elementContext === "floating" ? {
    x: x2,
    y: y2,
    width: rects.floating.width,
    height: rects.floating.height
  } : rects.reference;
  const offsetParent = await (platform2.getOffsetParent == null ? void 0 : platform2.getOffsetParent(elements.floating));
  const offsetScale = await (platform2.isElement == null ? void 0 : platform2.isElement(offsetParent)) ? await (platform2.getScale == null ? void 0 : platform2.getScale(offsetParent)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  };
  const elementClientRect = rectToClientRect$1(platform2.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform2.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements,
    rect,
    offsetParent,
    strategy
  }) : rect);
  return {
    top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
    bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
    left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
    right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
  };
}
const arrow$3 = (options2) => ({
  name: "arrow",
  options: options2,
  async fn(state) {
    const {
      x: x2,
      y: y2,
      placement,
      rects,
      platform: platform2,
      elements,
      middlewareData
    } = state;
    const {
      element,
      padding: padding2 = 0
    } = evaluate$1(options2, state) || {};
    if (element == null) {
      return {};
    }
    const paddingObject = getPaddingObject$1(padding2);
    const coords = {
      x: x2,
      y: y2
    };
    const axis = getAlignmentAxis(placement);
    const length2 = getAxisLength(axis);
    const arrowDimensions = await platform2.getDimensions(element);
    const isYAxis = axis === "y";
    const minProp = isYAxis ? "top" : "left";
    const maxProp = isYAxis ? "bottom" : "right";
    const clientProp = isYAxis ? "clientHeight" : "clientWidth";
    const endDiff = rects.reference[length2] + rects.reference[axis] - coords[axis] - rects.floating[length2];
    const startDiff = coords[axis] - rects.reference[axis];
    const arrowOffsetParent = await (platform2.getOffsetParent == null ? void 0 : platform2.getOffsetParent(element));
    let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;
    if (!clientSize || !await (platform2.isElement == null ? void 0 : platform2.isElement(arrowOffsetParent))) {
      clientSize = elements.floating[clientProp] || rects.floating[length2];
    }
    const centerToReference = endDiff / 2 - startDiff / 2;
    const largestPossiblePadding = clientSize / 2 - arrowDimensions[length2] / 2 - 1;
    const minPadding = min$4(paddingObject[minProp], largestPossiblePadding);
    const maxPadding = min$4(paddingObject[maxProp], largestPossiblePadding);
    const min$12 = minPadding;
    const max2 = clientSize - arrowDimensions[length2] - maxPadding;
    const center = clientSize / 2 - arrowDimensions[length2] / 2 + centerToReference;
    const offset2 = clamp$1(min$12, center, max2);
    const shouldAddOffset = !middlewareData.arrow && getAlignment$1(placement) != null && center !== offset2 && rects.reference[length2] / 2 - (center < min$12 ? minPadding : maxPadding) - arrowDimensions[length2] / 2 < 0;
    const alignmentOffset = shouldAddOffset ? center < min$12 ? center - min$12 : center - max2 : 0;
    return {
      [axis]: coords[axis] + alignmentOffset,
      data: {
        [axis]: offset2,
        centerOffset: center - offset2 - alignmentOffset,
        ...shouldAddOffset && {
          alignmentOffset
        }
      },
      reset: shouldAddOffset
    };
  }
});
const flip$2 = function(options2) {
  if (options2 === void 0) {
    options2 = {};
  }
  return {
    name: "flip",
    options: options2,
    async fn(state) {
      var _middlewareData$arrow, _middlewareData$flip;
      const {
        placement,
        middlewareData,
        rects,
        initialPlacement,
        platform: platform2,
        elements
      } = state;
      const {
        mainAxis: checkMainAxis = true,
        crossAxis: checkCrossAxis = true,
        fallbackPlacements: specifiedFallbackPlacements,
        fallbackStrategy = "bestFit",
        fallbackAxisSideDirection = "none",
        flipAlignment = true,
        ...detectOverflowOptions
      } = evaluate$1(options2, state);
      if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) {
        return {};
      }
      const side = getSide$1(placement);
      const initialSideAxis = getSideAxis$1(initialPlacement);
      const isBasePlacement = getSide$1(initialPlacement) === initialPlacement;
      const rtl = await (platform2.isRTL == null ? void 0 : platform2.isRTL(elements.floating));
      const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [getOppositePlacement(initialPlacement)] : getExpandedPlacements(initialPlacement));
      const hasFallbackAxisSideDirection = fallbackAxisSideDirection !== "none";
      if (!specifiedFallbackPlacements && hasFallbackAxisSideDirection) {
        fallbackPlacements.push(...getOppositeAxisPlacements(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
      }
      const placements2 = [initialPlacement, ...fallbackPlacements];
      const overflow = await detectOverflow$1(state, detectOverflowOptions);
      const overflows = [];
      let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
      if (checkMainAxis) {
        overflows.push(overflow[side]);
      }
      if (checkCrossAxis) {
        const sides = getAlignmentSides(placement, rects, rtl);
        overflows.push(overflow[sides[0]], overflow[sides[1]]);
      }
      overflowsData = [...overflowsData, {
        placement,
        overflows
      }];
      if (!overflows.every((side2) => side2 <= 0)) {
        var _middlewareData$flip2, _overflowsData$filter;
        const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
        const nextPlacement = placements2[nextIndex];
        if (nextPlacement) {
          return {
            data: {
              index: nextIndex,
              overflows: overflowsData
            },
            reset: {
              placement: nextPlacement
            }
          };
        }
        let resetPlacement = (_overflowsData$filter = overflowsData.filter((d2) => d2.overflows[0] <= 0).sort((a2, b2) => a2.overflows[1] - b2.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;
        if (!resetPlacement) {
          switch (fallbackStrategy) {
            case "bestFit": {
              var _overflowsData$filter2;
              const placement2 = (_overflowsData$filter2 = overflowsData.filter((d2) => {
                if (hasFallbackAxisSideDirection) {
                  const currentSideAxis = getSideAxis$1(d2.placement);
                  return currentSideAxis === initialSideAxis || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  currentSideAxis === "y";
                }
                return true;
              }).map((d2) => [d2.placement, d2.overflows.filter((overflow2) => overflow2 > 0).reduce((acc, overflow2) => acc + overflow2, 0)]).sort((a2, b2) => a2[1] - b2[1])[0]) == null ? void 0 : _overflowsData$filter2[0];
              if (placement2) {
                resetPlacement = placement2;
              }
              break;
            }
            case "initialPlacement":
              resetPlacement = initialPlacement;
              break;
          }
        }
        if (placement !== resetPlacement) {
          return {
            reset: {
              placement: resetPlacement
            }
          };
        }
      }
      return {};
    }
  };
};
async function convertValueToCoords(state, options2) {
  const {
    placement,
    platform: platform2,
    elements
  } = state;
  const rtl = await (platform2.isRTL == null ? void 0 : platform2.isRTL(elements.floating));
  const side = getSide$1(placement);
  const alignment = getAlignment$1(placement);
  const isVertical = getSideAxis$1(placement) === "y";
  const mainAxisMulti = ["left", "top"].includes(side) ? -1 : 1;
  const crossAxisMulti = rtl && isVertical ? -1 : 1;
  const rawValue = evaluate$1(options2, state);
  let {
    mainAxis,
    crossAxis,
    alignmentAxis
  } = typeof rawValue === "number" ? {
    mainAxis: rawValue,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: rawValue.mainAxis || 0,
    crossAxis: rawValue.crossAxis || 0,
    alignmentAxis: rawValue.alignmentAxis
  };
  if (alignment && typeof alignmentAxis === "number") {
    crossAxis = alignment === "end" ? alignmentAxis * -1 : alignmentAxis;
  }
  return isVertical ? {
    x: crossAxis * crossAxisMulti,
    y: mainAxis * mainAxisMulti
  } : {
    x: mainAxis * mainAxisMulti,
    y: crossAxis * crossAxisMulti
  };
}
const offset$2 = function(options2) {
  if (options2 === void 0) {
    options2 = 0;
  }
  return {
    name: "offset",
    options: options2,
    async fn(state) {
      var _middlewareData$offse, _middlewareData$arrow;
      const {
        x: x2,
        y: y2,
        placement,
        middlewareData
      } = state;
      const diffCoords = await convertValueToCoords(state, options2);
      if (placement === ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse.placement) && (_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) {
        return {};
      }
      return {
        x: x2 + diffCoords.x,
        y: y2 + diffCoords.y,
        data: {
          ...diffCoords,
          placement
        }
      };
    }
  };
};
const min$3 = Math.min;
const max$3 = Math.max;
const round$1 = Math.round;
const floor$1 = Math.floor;
const createCoords$1 = (v2) => ({
  x: v2,
  y: v2
});
function hasWindow$2() {
  return typeof window !== "undefined";
}
function getNodeName$1(node2) {
  if (isNode$1(node2)) {
    return (node2.nodeName || "").toLowerCase();
  }
  return "#document";
}
function getWindow$2(node2) {
  var _node$ownerDocument;
  return (node2 == null || (_node$ownerDocument = node2.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function getDocumentElement$1(node2) {
  var _ref3;
  return (_ref3 = (isNode$1(node2) ? node2.ownerDocument : node2.document) || window.document) == null ? void 0 : _ref3.documentElement;
}
function isNode$1(value) {
  if (!hasWindow$2()) {
    return false;
  }
  return value instanceof Node || value instanceof getWindow$2(value).Node;
}
function isElement$2(value) {
  if (!hasWindow$2()) {
    return false;
  }
  return value instanceof Element || value instanceof getWindow$2(value).Element;
}
function isHTMLElement$1(value) {
  if (!hasWindow$2()) {
    return false;
  }
  return value instanceof HTMLElement || value instanceof getWindow$2(value).HTMLElement;
}
function isShadowRoot$1(value) {
  if (!hasWindow$2() || typeof ShadowRoot === "undefined") {
    return false;
  }
  return value instanceof ShadowRoot || value instanceof getWindow$2(value).ShadowRoot;
}
function isOverflowElement$1(element) {
  const {
    overflow,
    overflowX,
    overflowY,
    display
  } = getComputedStyle$3(element);
  return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && !["inline", "contents"].includes(display);
}
function isWebKit$1() {
  if (typeof CSS === "undefined" || !CSS.supports) return false;
  return CSS.supports("-webkit-backdrop-filter", "none");
}
function isLastTraversableNode$1(node2) {
  return ["html", "body", "#document"].includes(getNodeName$1(node2));
}
function getComputedStyle$3(element) {
  return getWindow$2(element).getComputedStyle(element);
}
function getParentNode$1(node2) {
  if (getNodeName$1(node2) === "html") {
    return node2;
  }
  const result = (
    // Step into the shadow DOM of the parent of a slotted node.
    node2.assignedSlot || // DOM Element detected.
    node2.parentNode || // ShadowRoot detected.
    isShadowRoot$1(node2) && node2.host || // Fallback.
    getDocumentElement$1(node2)
  );
  return isShadowRoot$1(result) ? result.host : result;
}
function getNearestOverflowAncestor$1(node2) {
  const parentNode = getParentNode$1(node2);
  if (isLastTraversableNode$1(parentNode)) {
    return node2.ownerDocument ? node2.ownerDocument.body : node2.body;
  }
  if (isHTMLElement$1(parentNode) && isOverflowElement$1(parentNode)) {
    return parentNode;
  }
  return getNearestOverflowAncestor$1(parentNode);
}
function getOverflowAncestors$1(node2, list, traverseIframes) {
  var _node$ownerDocument2;
  if (list === void 0) {
    list = [];
  }
  if (traverseIframes === void 0) {
    traverseIframes = true;
  }
  const scrollableAncestor = getNearestOverflowAncestor$1(node2);
  const isBody = scrollableAncestor === ((_node$ownerDocument2 = node2.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
  const win = getWindow$2(scrollableAncestor);
  if (isBody) {
    const frameElement = getFrameElement$1(win);
    return list.concat(win, win.visualViewport || [], isOverflowElement$1(scrollableAncestor) ? scrollableAncestor : [], frameElement && traverseIframes ? getOverflowAncestors$1(frameElement) : []);
  }
  return list.concat(scrollableAncestor, getOverflowAncestors$1(scrollableAncestor, [], traverseIframes));
}
function getFrameElement$1(win) {
  return win.parent && Object.getPrototypeOf(win.parent) ? win.frameElement : null;
}
function getCssDimensions$1(element) {
  const css4 = getComputedStyle$3(element);
  let width2 = parseFloat(css4.width) || 0;
  let height2 = parseFloat(css4.height) || 0;
  const hasOffset = isHTMLElement$1(element);
  const offsetWidth = hasOffset ? element.offsetWidth : width2;
  const offsetHeight = hasOffset ? element.offsetHeight : height2;
  const shouldFallback = round$1(width2) !== offsetWidth || round$1(height2) !== offsetHeight;
  if (shouldFallback) {
    width2 = offsetWidth;
    height2 = offsetHeight;
  }
  return {
    width: width2,
    height: height2,
    $: shouldFallback
  };
}
function unwrapElement$1(element) {
  return !isElement$2(element) ? element.contextElement : element;
}
function getScale$1(element) {
  const domElement = unwrapElement$1(element);
  if (!isHTMLElement$1(domElement)) {
    return createCoords$1(1);
  }
  const rect = domElement.getBoundingClientRect();
  const {
    width: width2,
    height: height2,
    $: $2
  } = getCssDimensions$1(domElement);
  let x2 = ($2 ? round$1(rect.width) : rect.width) / width2;
  let y2 = ($2 ? round$1(rect.height) : rect.height) / height2;
  if (!x2 || !Number.isFinite(x2)) {
    x2 = 1;
  }
  if (!y2 || !Number.isFinite(y2)) {
    y2 = 1;
  }
  return {
    x: x2,
    y: y2
  };
}
const noOffsets$1 = /* @__PURE__ */ createCoords$1(0);
function getVisualOffsets$1(element) {
  const win = getWindow$2(element);
  if (!isWebKit$1() || !win.visualViewport) {
    return noOffsets$1;
  }
  return {
    x: win.visualViewport.offsetLeft,
    y: win.visualViewport.offsetTop
  };
}
function shouldAddVisualOffsets$1(element, isFixed, floatingOffsetParent) {
  {
    return false;
  }
}
function getBoundingClientRect$1(element, includeScale, isFixedStrategy, offsetParent) {
  if (includeScale === void 0) {
    includeScale = false;
  }
  const clientRect = element.getBoundingClientRect();
  const domElement = unwrapElement$1(element);
  let scale = createCoords$1(1);
  if (includeScale) {
    {
      scale = getScale$1(element);
    }
  }
  const visualOffsets = shouldAddVisualOffsets$1() ? getVisualOffsets$1(domElement) : createCoords$1(0);
  let x2 = (clientRect.left + visualOffsets.x) / scale.x;
  let y2 = (clientRect.top + visualOffsets.y) / scale.y;
  let width2 = clientRect.width / scale.x;
  let height2 = clientRect.height / scale.y;
  if (domElement) {
    const win = getWindow$2(domElement);
    const offsetWin = offsetParent;
    let currentWin = win;
    let currentIFrame = getFrameElement$1(currentWin);
    while (currentIFrame && offsetParent && offsetWin !== currentWin) {
      const iframeScale = getScale$1(currentIFrame);
      const iframeRect = currentIFrame.getBoundingClientRect();
      const css4 = getComputedStyle$3(currentIFrame);
      const left2 = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css4.paddingLeft)) * iframeScale.x;
      const top2 = iframeRect.top + (currentIFrame.clientTop + parseFloat(css4.paddingTop)) * iframeScale.y;
      x2 *= iframeScale.x;
      y2 *= iframeScale.y;
      width2 *= iframeScale.x;
      height2 *= iframeScale.y;
      x2 += left2;
      y2 += top2;
      currentWin = getWindow$2(currentIFrame);
      currentIFrame = getFrameElement$1(currentWin);
    }
  }
  return rectToClientRect$1({
    width: width2,
    height: height2,
    x: x2,
    y: y2
  });
}
function rectsAreEqual$1(a2, b2) {
  return a2.x === b2.x && a2.y === b2.y && a2.width === b2.width && a2.height === b2.height;
}
function observeMove$1(element, onMove) {
  let io = null;
  let timeoutId;
  const root2 = getDocumentElement$1(element);
  function cleanup() {
    var _io;
    clearTimeout(timeoutId);
    (_io = io) == null || _io.disconnect();
    io = null;
  }
  function refresh(skip, threshold) {
    if (skip === void 0) {
      skip = false;
    }
    if (threshold === void 0) {
      threshold = 1;
    }
    cleanup();
    const elementRectForRootMargin = element.getBoundingClientRect();
    const {
      left: left2,
      top: top2,
      width: width2,
      height: height2
    } = elementRectForRootMargin;
    if (!skip) {
      onMove();
    }
    if (!width2 || !height2) {
      return;
    }
    const insetTop = floor$1(top2);
    const insetRight = floor$1(root2.clientWidth - (left2 + width2));
    const insetBottom = floor$1(root2.clientHeight - (top2 + height2));
    const insetLeft = floor$1(left2);
    const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
    const options2 = {
      rootMargin,
      threshold: max$3(0, min$3(1, threshold)) || 1
    };
    let isFirstUpdate = true;
    function handleObserve(entries) {
      const ratio = entries[0].intersectionRatio;
      if (ratio !== threshold) {
        if (!isFirstUpdate) {
          return refresh();
        }
        if (!ratio) {
          timeoutId = setTimeout(() => {
            refresh(false, 1e-7);
          }, 1e3);
        } else {
          refresh(false, ratio);
        }
      }
      if (ratio === 1 && !rectsAreEqual$1(elementRectForRootMargin, element.getBoundingClientRect())) {
        refresh();
      }
      isFirstUpdate = false;
    }
    try {
      io = new IntersectionObserver(handleObserve, {
        ...options2,
        // Handle <iframe>s
        root: root2.ownerDocument
      });
    } catch (e3) {
      io = new IntersectionObserver(handleObserve, options2);
    }
    io.observe(element);
  }
  refresh(true);
  return cleanup;
}
function autoUpdate$1(reference2, floating, update, options2) {
  if (options2 === void 0) {
    options2 = {};
  }
  const {
    ancestorScroll = true,
    ancestorResize = true,
    elementResize = typeof ResizeObserver === "function",
    layoutShift = typeof IntersectionObserver === "function",
    animationFrame = false
  } = options2;
  const referenceEl = unwrapElement$1(reference2);
  const ancestors = ancestorScroll || ancestorResize ? [...referenceEl ? getOverflowAncestors$1(referenceEl) : [], ...getOverflowAncestors$1(floating)] : [];
  ancestors.forEach((ancestor) => {
    ancestorScroll && ancestor.addEventListener("scroll", update, {
      passive: true
    });
    ancestorResize && ancestor.addEventListener("resize", update);
  });
  const cleanupIo = referenceEl && layoutShift ? observeMove$1(referenceEl, update) : null;
  let reobserveFrame = -1;
  let resizeObserver = null;
  if (elementResize) {
    resizeObserver = new ResizeObserver((_ref3) => {
      let [firstEntry] = _ref3;
      if (firstEntry && firstEntry.target === referenceEl && resizeObserver) {
        resizeObserver.unobserve(floating);
        cancelAnimationFrame(reobserveFrame);
        reobserveFrame = requestAnimationFrame(() => {
          var _resizeObserver;
          (_resizeObserver = resizeObserver) == null || _resizeObserver.observe(floating);
        });
      }
      update();
    });
    if (referenceEl && !animationFrame) {
      resizeObserver.observe(referenceEl);
    }
    resizeObserver.observe(floating);
  }
  let frameId;
  let prevRefRect = animationFrame ? getBoundingClientRect$1(reference2) : null;
  if (animationFrame) {
    frameLoop();
  }
  function frameLoop() {
    const nextRefRect = getBoundingClientRect$1(reference2);
    if (prevRefRect && !rectsAreEqual$1(prevRefRect, nextRefRect)) {
      update();
    }
    prevRefRect = nextRefRect;
    frameId = requestAnimationFrame(frameLoop);
  }
  update();
  return () => {
    var _resizeObserver2;
    ancestors.forEach((ancestor) => {
      ancestorScroll && ancestor.removeEventListener("scroll", update);
      ancestorResize && ancestor.removeEventListener("resize", update);
    });
    cleanupIo == null || cleanupIo();
    (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.disconnect();
    resizeObserver = null;
    if (animationFrame) {
      cancelAnimationFrame(frameId);
    }
  };
}
var index$2 = useLayoutEffect;
var _excluded$4$1 = ["className", "clearValue", "cx", "getStyles", "getClassNames", "getValue", "hasValue", "isMulti", "isRtl", "options", "selectOption", "selectProps", "setValue", "theme"];
var noop$3 = function noop() {
};
function applyPrefixToName(prefix2, name) {
  if (!name) {
    return prefix2;
  } else if (name[0] === "-") {
    return prefix2 + name;
  } else {
    return prefix2 + "__" + name;
  }
}
function classNames(prefix2, state) {
  for (var _len = arguments.length, classNameList = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    classNameList[_key - 2] = arguments[_key];
  }
  var arr = [].concat(classNameList);
  if (state && prefix2) {
    for (var key in state) {
      if (state.hasOwnProperty(key) && state[key]) {
        arr.push("".concat(applyPrefixToName(prefix2, key)));
      }
    }
  }
  return arr.filter(function(i) {
    return i;
  }).map(function(i) {
    return String(i).trim();
  }).join(" ");
}
var cleanValue = function cleanValue2(value) {
  if (isArray$9(value)) return value.filter(Boolean);
  if (_typeof$4(value) === "object" && value !== null) return [value];
  return [];
};
var cleanCommonProps = function cleanCommonProps2(props) {
  props.className;
  props.clearValue;
  props.cx;
  props.getStyles;
  props.getClassNames;
  props.getValue;
  props.hasValue;
  props.isMulti;
  props.isRtl;
  props.options;
  props.selectOption;
  props.selectProps;
  props.setValue;
  props.theme;
  var innerProps = _objectWithoutProperties$3(props, _excluded$4$1);
  return _objectSpread2({}, innerProps);
};
var getStyleProps = function getStyleProps2(props, name, classNamesState) {
  var cx = props.cx, getStyles = props.getStyles, getClassNames = props.getClassNames, className = props.className;
  return {
    css: getStyles(name, props),
    className: cx(classNamesState !== null && classNamesState !== void 0 ? classNamesState : {}, getClassNames(name, props), className)
  };
};
function isDocumentElement(el) {
  return [document.documentElement, document.body, window].indexOf(el) > -1;
}
function normalizedHeight(el) {
  if (isDocumentElement(el)) {
    return window.innerHeight;
  }
  return el.clientHeight;
}
function getScrollTop(el) {
  if (isDocumentElement(el)) {
    return window.pageYOffset;
  }
  return el.scrollTop;
}
function scrollTo(el, top2) {
  if (isDocumentElement(el)) {
    window.scrollTo(0, top2);
    return;
  }
  el.scrollTop = top2;
}
function getScrollParent(element) {
  var style = getComputedStyle(element);
  var excludeStaticParent = style.position === "absolute";
  var overflowRx = /(auto|scroll)/;
  if (style.position === "fixed") return document.documentElement;
  for (var parent = element; parent = parent.parentElement; ) {
    style = getComputedStyle(parent);
    if (excludeStaticParent && style.position === "static") {
      continue;
    }
    if (overflowRx.test(style.overflow + style.overflowY + style.overflowX)) {
      return parent;
    }
  }
  return document.documentElement;
}
function easeOutCubic(t2, b2, c2, d2) {
  return c2 * ((t2 = t2 / d2 - 1) * t2 * t2 + 1) + b2;
}
function animatedScrollTo(element, to) {
  var duration = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 200;
  var callback = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : noop$3;
  var start2 = getScrollTop(element);
  var change = to - start2;
  var increment = 10;
  var currentTime = 0;
  function animateScroll() {
    currentTime += increment;
    var val = easeOutCubic(currentTime, start2, change, duration);
    scrollTo(element, val);
    if (currentTime < duration) {
      window.requestAnimationFrame(animateScroll);
    } else {
      callback(element);
    }
  }
  animateScroll();
}
function scrollIntoView(menuEl, focusedEl) {
  var menuRect = menuEl.getBoundingClientRect();
  var focusedRect = focusedEl.getBoundingClientRect();
  var overScroll = focusedEl.offsetHeight / 3;
  if (focusedRect.bottom + overScroll > menuRect.bottom) {
    scrollTo(menuEl, Math.min(focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + overScroll, menuEl.scrollHeight));
  } else if (focusedRect.top - overScroll < menuRect.top) {
    scrollTo(menuEl, Math.max(focusedEl.offsetTop - overScroll, 0));
  }
}
function getBoundingClientObj(element) {
  var rect = element.getBoundingClientRect();
  return {
    bottom: rect.bottom,
    height: rect.height,
    left: rect.left,
    right: rect.right,
    top: rect.top,
    width: rect.width
  };
}
function isTouchCapable() {
  try {
    document.createEvent("TouchEvent");
    return true;
  } catch (e3) {
    return false;
  }
}
function isMobileDevice() {
  try {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  } catch (e3) {
    return false;
  }
}
var passiveOptionAccessed = false;
var options = {
  get passive() {
    return passiveOptionAccessed = true;
  }
};
var w$1 = typeof window !== "undefined" ? window : {};
if (w$1.addEventListener && w$1.removeEventListener) {
  w$1.addEventListener("p", noop$3, options);
  w$1.removeEventListener("p", noop$3, false);
}
var supportsPassiveEvents = passiveOptionAccessed;
function notNullish(item) {
  return item != null;
}
function isArray$9(arg) {
  return Array.isArray(arg);
}
function valueTernary(isMulti, multiValue, singleValue) {
  return isMulti ? multiValue : singleValue;
}
function singleValueAsValue(singleValue) {
  return singleValue;
}
function multiValueAsValue(multiValue) {
  return multiValue;
}
var removeProps = function removeProps2(propsObj) {
  for (var _len2 = arguments.length, properties2 = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    properties2[_key2 - 1] = arguments[_key2];
  }
  var propsMap = Object.entries(propsObj).filter(function(_ref3) {
    var _ref22 = _slicedToArray(_ref3, 1), key = _ref22[0];
    return !properties2.includes(key);
  });
  return propsMap.reduce(function(newProps, _ref3) {
    var _ref4 = _slicedToArray(_ref3, 2), key = _ref4[0], val = _ref4[1];
    newProps[key] = val;
    return newProps;
  }, {});
};
var _excluded$3$1 = ["children", "innerProps"], _excluded2$1 = ["children", "innerProps"];
function getMenuPlacement(_ref3) {
  var preferredMaxHeight = _ref3.maxHeight, menuEl = _ref3.menuEl, minHeight = _ref3.minHeight, preferredPlacement = _ref3.placement, shouldScroll = _ref3.shouldScroll, isFixedPosition = _ref3.isFixedPosition, controlHeight2 = _ref3.controlHeight;
  var scrollParent = getScrollParent(menuEl);
  var defaultState = {
    placement: "bottom",
    maxHeight: preferredMaxHeight
  };
  if (!menuEl || !menuEl.offsetParent) return defaultState;
  var _scrollParent$getBoun = scrollParent.getBoundingClientRect(), scrollHeight = _scrollParent$getBoun.height;
  var _menuEl$getBoundingCl = menuEl.getBoundingClientRect(), menuBottom = _menuEl$getBoundingCl.bottom, menuHeight = _menuEl$getBoundingCl.height, menuTop = _menuEl$getBoundingCl.top;
  var _menuEl$offsetParent$ = menuEl.offsetParent.getBoundingClientRect(), containerTop = _menuEl$offsetParent$.top;
  var viewHeight = isFixedPosition ? window.innerHeight : normalizedHeight(scrollParent);
  var scrollTop = getScrollTop(scrollParent);
  var marginBottom = parseInt(getComputedStyle(menuEl).marginBottom, 10);
  var marginTop = parseInt(getComputedStyle(menuEl).marginTop, 10);
  var viewSpaceAbove = containerTop - marginTop;
  var viewSpaceBelow = viewHeight - menuTop;
  var scrollSpaceAbove = viewSpaceAbove + scrollTop;
  var scrollSpaceBelow = scrollHeight - scrollTop - menuTop;
  var scrollDown = menuBottom - viewHeight + scrollTop + marginBottom;
  var scrollUp = scrollTop + menuTop - marginTop;
  var scrollDuration = 160;
  switch (preferredPlacement) {
    case "auto":
    case "bottom":
      if (viewSpaceBelow >= menuHeight) {
        return {
          placement: "bottom",
          maxHeight: preferredMaxHeight
        };
      }
      if (scrollSpaceBelow >= menuHeight && !isFixedPosition) {
        if (shouldScroll) {
          animatedScrollTo(scrollParent, scrollDown, scrollDuration);
        }
        return {
          placement: "bottom",
          maxHeight: preferredMaxHeight
        };
      }
      if (!isFixedPosition && scrollSpaceBelow >= minHeight || isFixedPosition && viewSpaceBelow >= minHeight) {
        if (shouldScroll) {
          animatedScrollTo(scrollParent, scrollDown, scrollDuration);
        }
        var constrainedHeight = isFixedPosition ? viewSpaceBelow - marginBottom : scrollSpaceBelow - marginBottom;
        return {
          placement: "bottom",
          maxHeight: constrainedHeight
        };
      }
      if (preferredPlacement === "auto" || isFixedPosition) {
        var _constrainedHeight = preferredMaxHeight;
        var spaceAbove = isFixedPosition ? viewSpaceAbove : scrollSpaceAbove;
        if (spaceAbove >= minHeight) {
          _constrainedHeight = Math.min(spaceAbove - marginBottom - controlHeight2, preferredMaxHeight);
        }
        return {
          placement: "top",
          maxHeight: _constrainedHeight
        };
      }
      if (preferredPlacement === "bottom") {
        if (shouldScroll) {
          scrollTo(scrollParent, scrollDown);
        }
        return {
          placement: "bottom",
          maxHeight: preferredMaxHeight
        };
      }
      break;
    case "top":
      if (viewSpaceAbove >= menuHeight) {
        return {
          placement: "top",
          maxHeight: preferredMaxHeight
        };
      }
      if (scrollSpaceAbove >= menuHeight && !isFixedPosition) {
        if (shouldScroll) {
          animatedScrollTo(scrollParent, scrollUp, scrollDuration);
        }
        return {
          placement: "top",
          maxHeight: preferredMaxHeight
        };
      }
      if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
        var _constrainedHeight2 = preferredMaxHeight;
        if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
          _constrainedHeight2 = isFixedPosition ? viewSpaceAbove - marginTop : scrollSpaceAbove - marginTop;
        }
        if (shouldScroll) {
          animatedScrollTo(scrollParent, scrollUp, scrollDuration);
        }
        return {
          placement: "top",
          maxHeight: _constrainedHeight2
        };
      }
      return {
        placement: "bottom",
        maxHeight: preferredMaxHeight
      };
    default:
      throw new Error('Invalid placement provided "'.concat(preferredPlacement, '".'));
  }
  return defaultState;
}
function alignToControl(placement) {
  var placementToCSSProp = {
    bottom: "top",
    top: "bottom"
  };
  return placement ? placementToCSSProp[placement] : "bottom";
}
var coercePlacement = function coercePlacement2(p2) {
  return p2 === "auto" ? "bottom" : p2;
};
var menuCSS = function menuCSS2(_ref22, unstyled) {
  var _objectSpread2$1;
  var placement = _ref22.placement, _ref2$theme = _ref22.theme, borderRadius2 = _ref2$theme.borderRadius, spacing2 = _ref2$theme.spacing, colors2 = _ref2$theme.colors;
  return _objectSpread2((_objectSpread2$1 = {
    label: "menu"
  }, _defineProperty$4(_objectSpread2$1, alignToControl(placement), "100%"), _defineProperty$4(_objectSpread2$1, "position", "absolute"), _defineProperty$4(_objectSpread2$1, "width", "100%"), _defineProperty$4(_objectSpread2$1, "zIndex", 1), _objectSpread2$1), unstyled ? {} : {
    backgroundColor: colors2.neutral0,
    borderRadius: borderRadius2,
    boxShadow: "0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1)",
    marginBottom: spacing2.menuGutter,
    marginTop: spacing2.menuGutter
  });
};
var PortalPlacementContext = /* @__PURE__ */ createContext$1(null);
var MenuPlacer = function MenuPlacer2(props) {
  var children = props.children, minMenuHeight = props.minMenuHeight, maxMenuHeight = props.maxMenuHeight, menuPlacement = props.menuPlacement, menuPosition = props.menuPosition, menuShouldScrollIntoView = props.menuShouldScrollIntoView, theme = props.theme;
  var _ref3 = useContext(PortalPlacementContext) || {}, setPortalPlacement = _ref3.setPortalPlacement;
  var ref2 = useRef(null);
  var _useState = useState(maxMenuHeight), _useState2 = _slicedToArray(_useState, 2), maxHeight = _useState2[0], setMaxHeight = _useState2[1];
  var _useState3 = useState(null), _useState4 = _slicedToArray(_useState3, 2), placement = _useState4[0], setPlacement = _useState4[1];
  var controlHeight2 = theme.spacing.controlHeight;
  index$2(function() {
    var menuEl = ref2.current;
    if (!menuEl) return;
    var isFixedPosition = menuPosition === "fixed";
    var shouldScroll = menuShouldScrollIntoView && !isFixedPosition;
    var state = getMenuPlacement({
      maxHeight: maxMenuHeight,
      menuEl,
      minHeight: minMenuHeight,
      placement: menuPlacement,
      shouldScroll,
      isFixedPosition,
      controlHeight: controlHeight2
    });
    setMaxHeight(state.maxHeight);
    setPlacement(state.placement);
    setPortalPlacement === null || setPortalPlacement === void 0 ? void 0 : setPortalPlacement(state.placement);
  }, [maxMenuHeight, menuPlacement, menuPosition, menuShouldScrollIntoView, minMenuHeight, setPortalPlacement, controlHeight2]);
  return children({
    ref: ref2,
    placerProps: _objectSpread2(_objectSpread2({}, props), {}, {
      placement: placement || coercePlacement(menuPlacement),
      maxHeight
    })
  });
};
var Menu$1 = function Menu(props) {
  var children = props.children, innerRef = props.innerRef, innerProps = props.innerProps;
  return jsx("div", _extends$4({}, getStyleProps(props, "menu", {
    menu: true
  }), {
    ref: innerRef
  }, innerProps), children);
};
var Menu$1$1 = Menu$1;
var menuListCSS = function menuListCSS2(_ref4, unstyled) {
  var maxHeight = _ref4.maxHeight, baseUnit2 = _ref4.theme.spacing.baseUnit;
  return _objectSpread2({
    maxHeight,
    overflowY: "auto",
    position: "relative",
    // required for offset[Height, Top] > keyboard scroll
    WebkitOverflowScrolling: "touch"
  }, unstyled ? {} : {
    paddingBottom: baseUnit2,
    paddingTop: baseUnit2
  });
};
var MenuList = function MenuList2(props) {
  var children = props.children, innerProps = props.innerProps, innerRef = props.innerRef, isMulti = props.isMulti;
  return jsx("div", _extends$4({}, getStyleProps(props, "menuList", {
    "menu-list": true,
    "menu-list--is-multi": isMulti
  }), {
    ref: innerRef
  }, innerProps), children);
};
var noticeCSS = function noticeCSS2(_ref5, unstyled) {
  var _ref5$theme = _ref5.theme, baseUnit2 = _ref5$theme.spacing.baseUnit, colors2 = _ref5$theme.colors;
  return _objectSpread2({
    textAlign: "center"
  }, unstyled ? {} : {
    color: colors2.neutral40,
    padding: "".concat(baseUnit2 * 2, "px ").concat(baseUnit2 * 3, "px")
  });
};
var noOptionsMessageCSS = noticeCSS;
var loadingMessageCSS = noticeCSS;
var NoOptionsMessage = function NoOptionsMessage2(_ref6) {
  var _ref6$children = _ref6.children, children = _ref6$children === void 0 ? "No options" : _ref6$children, innerProps = _ref6.innerProps, restProps = _objectWithoutProperties$3(_ref6, _excluded$3$1);
  return jsx("div", _extends$4({}, getStyleProps(_objectSpread2(_objectSpread2({}, restProps), {}, {
    children,
    innerProps
  }), "noOptionsMessage", {
    "menu-notice": true,
    "menu-notice--no-options": true
  }), innerProps), children);
};
var LoadingMessage = function LoadingMessage2(_ref7) {
  var _ref7$children = _ref7.children, children = _ref7$children === void 0 ? "Loading..." : _ref7$children, innerProps = _ref7.innerProps, restProps = _objectWithoutProperties$3(_ref7, _excluded2$1);
  return jsx("div", _extends$4({}, getStyleProps(_objectSpread2(_objectSpread2({}, restProps), {}, {
    children,
    innerProps
  }), "loadingMessage", {
    "menu-notice": true,
    "menu-notice--loading": true
  }), innerProps), children);
};
var menuPortalCSS = function menuPortalCSS2(_ref8) {
  var rect = _ref8.rect, offset2 = _ref8.offset, position2 = _ref8.position;
  return {
    left: rect.left,
    position: position2,
    top: offset2,
    width: rect.width,
    zIndex: 1
  };
};
var MenuPortal = function MenuPortal2(props) {
  var appendTo = props.appendTo, children = props.children, controlElement = props.controlElement, innerProps = props.innerProps, menuPlacement = props.menuPlacement, menuPosition = props.menuPosition;
  var menuPortalRef = useRef(null);
  var cleanupRef = useRef(null);
  var _useState5 = useState(coercePlacement(menuPlacement)), _useState6 = _slicedToArray(_useState5, 2), placement = _useState6[0], setPortalPlacement = _useState6[1];
  var portalPlacementContext = useMemo(function() {
    return {
      setPortalPlacement
    };
  }, []);
  var _useState7 = useState(null), _useState8 = _slicedToArray(_useState7, 2), computedPosition = _useState8[0], setComputedPosition = _useState8[1];
  var updateComputedPosition = useCallback(function() {
    if (!controlElement) return;
    var rect = getBoundingClientObj(controlElement);
    var scrollDistance = menuPosition === "fixed" ? 0 : window.pageYOffset;
    var offset2 = rect[placement] + scrollDistance;
    if (offset2 !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset) || rect.left !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left) || rect.width !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width)) {
      setComputedPosition({
        offset: offset2,
        rect
      });
    }
  }, [controlElement, menuPosition, placement, computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset, computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left, computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width]);
  index$2(function() {
    updateComputedPosition();
  }, [updateComputedPosition]);
  var runAutoUpdate = useCallback(function() {
    if (typeof cleanupRef.current === "function") {
      cleanupRef.current();
      cleanupRef.current = null;
    }
    if (controlElement && menuPortalRef.current) {
      cleanupRef.current = autoUpdate$1(controlElement, menuPortalRef.current, updateComputedPosition, {
        elementResize: "ResizeObserver" in window
      });
    }
  }, [controlElement, updateComputedPosition]);
  index$2(function() {
    runAutoUpdate();
  }, [runAutoUpdate]);
  var setMenuPortalElement = useCallback(function(menuPortalElement) {
    menuPortalRef.current = menuPortalElement;
    runAutoUpdate();
  }, [runAutoUpdate]);
  if (!appendTo && menuPosition !== "fixed" || !computedPosition) return null;
  var menuWrapper = jsx("div", _extends$4({
    ref: setMenuPortalElement
  }, getStyleProps(_objectSpread2(_objectSpread2({}, props), {}, {
    offset: computedPosition.offset,
    position: menuPosition,
    rect: computedPosition.rect
  }), "menuPortal", {
    "menu-portal": true
  }), innerProps), children);
  return jsx(PortalPlacementContext.Provider, {
    value: portalPlacementContext
  }, appendTo ? /* @__PURE__ */ createPortal(menuWrapper, appendTo) : menuWrapper);
};
var containerCSS = function containerCSS2(_ref3) {
  var isDisabled = _ref3.isDisabled, isRtl = _ref3.isRtl;
  return {
    label: "container",
    direction: isRtl ? "rtl" : void 0,
    pointerEvents: isDisabled ? "none" : void 0,
    // cancel mouse events when disabled
    position: "relative"
  };
};
var SelectContainer = function SelectContainer2(props) {
  var children = props.children, innerProps = props.innerProps, isDisabled = props.isDisabled, isRtl = props.isRtl;
  return jsx("div", _extends$4({}, getStyleProps(props, "container", {
    "--is-disabled": isDisabled,
    "--is-rtl": isRtl
  }), innerProps), children);
};
var valueContainerCSS = function valueContainerCSS2(_ref22, unstyled) {
  var spacing2 = _ref22.theme.spacing, isMulti = _ref22.isMulti, hasValue = _ref22.hasValue, controlShouldRenderValue = _ref22.selectProps.controlShouldRenderValue;
  return _objectSpread2({
    alignItems: "center",
    display: isMulti && hasValue && controlShouldRenderValue ? "flex" : "grid",
    flex: 1,
    flexWrap: "wrap",
    WebkitOverflowScrolling: "touch",
    position: "relative",
    overflow: "hidden"
  }, unstyled ? {} : {
    padding: "".concat(spacing2.baseUnit / 2, "px ").concat(spacing2.baseUnit * 2, "px")
  });
};
var ValueContainer = function ValueContainer2(props) {
  var children = props.children, innerProps = props.innerProps, isMulti = props.isMulti, hasValue = props.hasValue;
  return jsx("div", _extends$4({}, getStyleProps(props, "valueContainer", {
    "value-container": true,
    "value-container--is-multi": isMulti,
    "value-container--has-value": hasValue
  }), innerProps), children);
};
var indicatorsContainerCSS = function indicatorsContainerCSS2() {
  return {
    alignItems: "center",
    alignSelf: "stretch",
    display: "flex",
    flexShrink: 0
  };
};
var IndicatorsContainer = function IndicatorsContainer2(props) {
  var children = props.children, innerProps = props.innerProps;
  return jsx("div", _extends$4({}, getStyleProps(props, "indicatorsContainer", {
    indicators: true
  }), innerProps), children);
};
var _templateObject;
var _excluded$2$1 = ["size"], _excluded2 = ["innerProps", "isRtl", "size"];
function _EMOTION_STRINGIFIED_CSS_ERROR__$3() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var _ref2$2 = process.env.NODE_ENV === "production" ? {
  name: "8mmkcg",
  styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0"
} : {
  name: "tj5bde-Svg",
  styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0;label:Svg;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$3
};
var Svg = function Svg2(_ref3) {
  var size2 = _ref3.size, props = _objectWithoutProperties$3(_ref3, _excluded$2$1);
  return jsx("svg", _extends$4({
    height: size2,
    width: size2,
    viewBox: "0 0 20 20",
    "aria-hidden": "true",
    focusable: "false",
    css: _ref2$2
  }, props));
};
var CrossIcon = function CrossIcon2(props) {
  return jsx(Svg, _extends$4({
    size: 20
  }, props), jsx("path", {
    d: "M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"
  }));
};
var DownChevron = function DownChevron2(props) {
  return jsx(Svg, _extends$4({
    size: 20
  }, props), jsx("path", {
    d: "M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
  }));
};
var baseCSS = function baseCSS2(_ref3, unstyled) {
  var isFocused = _ref3.isFocused, _ref3$theme = _ref3.theme, baseUnit2 = _ref3$theme.spacing.baseUnit, colors2 = _ref3$theme.colors;
  return _objectSpread2({
    label: "indicatorContainer",
    display: "flex",
    transition: "color 150ms"
  }, unstyled ? {} : {
    color: isFocused ? colors2.neutral60 : colors2.neutral20,
    padding: baseUnit2 * 2,
    ":hover": {
      color: isFocused ? colors2.neutral80 : colors2.neutral40
    }
  });
};
var dropdownIndicatorCSS = baseCSS;
var DropdownIndicator$1 = function DropdownIndicator(props) {
  var children = props.children, innerProps = props.innerProps;
  return jsx("div", _extends$4({}, getStyleProps(props, "dropdownIndicator", {
    indicator: true,
    "dropdown-indicator": true
  }), innerProps), children || jsx(DownChevron, null));
};
var clearIndicatorCSS = baseCSS;
var ClearIndicator$1 = function ClearIndicator(props) {
  var children = props.children, innerProps = props.innerProps;
  return jsx("div", _extends$4({}, getStyleProps(props, "clearIndicator", {
    indicator: true,
    "clear-indicator": true
  }), innerProps), children || jsx(CrossIcon, null));
};
var indicatorSeparatorCSS = function indicatorSeparatorCSS2(_ref4, unstyled) {
  var isDisabled = _ref4.isDisabled, _ref4$theme = _ref4.theme, baseUnit2 = _ref4$theme.spacing.baseUnit, colors2 = _ref4$theme.colors;
  return _objectSpread2({
    label: "indicatorSeparator",
    alignSelf: "stretch",
    width: 1
  }, unstyled ? {} : {
    backgroundColor: isDisabled ? colors2.neutral10 : colors2.neutral20,
    marginBottom: baseUnit2 * 2,
    marginTop: baseUnit2 * 2
  });
};
var IndicatorSeparator = function IndicatorSeparator2(props) {
  var innerProps = props.innerProps;
  return jsx("span", _extends$4({}, innerProps, getStyleProps(props, "indicatorSeparator", {
    "indicator-separator": true
  })));
};
var loadingDotAnimations = keyframes(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  0%, 80%, 100% { opacity: 0; }\n  40% { opacity: 1; }\n"])));
var loadingIndicatorCSS = function loadingIndicatorCSS2(_ref5, unstyled) {
  var isFocused = _ref5.isFocused, size2 = _ref5.size, _ref5$theme = _ref5.theme, colors2 = _ref5$theme.colors, baseUnit2 = _ref5$theme.spacing.baseUnit;
  return _objectSpread2({
    label: "loadingIndicator",
    display: "flex",
    transition: "color 150ms",
    alignSelf: "center",
    fontSize: size2,
    lineHeight: 1,
    marginRight: size2,
    textAlign: "center",
    verticalAlign: "middle"
  }, unstyled ? {} : {
    color: isFocused ? colors2.neutral60 : colors2.neutral20,
    padding: baseUnit2 * 2
  });
};
var LoadingDot = function LoadingDot2(_ref6) {
  var delay = _ref6.delay, offset2 = _ref6.offset;
  return jsx("span", {
    css: /* @__PURE__ */ css$2({
      animation: "".concat(loadingDotAnimations, " 1s ease-in-out ").concat(delay, "ms infinite;"),
      backgroundColor: "currentColor",
      borderRadius: "1em",
      display: "inline-block",
      marginLeft: offset2 ? "1em" : void 0,
      height: "1em",
      verticalAlign: "top",
      width: "1em"
    }, process.env.NODE_ENV === "production" ? "" : ";label:LoadingDot;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")
  });
};
var LoadingIndicator = function LoadingIndicator2(_ref7) {
  var innerProps = _ref7.innerProps, isRtl = _ref7.isRtl, _ref7$size = _ref7.size, size2 = _ref7$size === void 0 ? 4 : _ref7$size, restProps = _objectWithoutProperties$3(_ref7, _excluded2);
  return jsx("div", _extends$4({}, getStyleProps(_objectSpread2(_objectSpread2({}, restProps), {}, {
    innerProps,
    isRtl,
    size: size2
  }), "loadingIndicator", {
    indicator: true,
    "loading-indicator": true
  }), innerProps), jsx(LoadingDot, {
    delay: 0,
    offset: isRtl
  }), jsx(LoadingDot, {
    delay: 160,
    offset: true
  }), jsx(LoadingDot, {
    delay: 320,
    offset: !isRtl
  }));
};
var css$1 = function css(_ref3, unstyled) {
  var isDisabled = _ref3.isDisabled, isFocused = _ref3.isFocused, _ref$theme = _ref3.theme, colors2 = _ref$theme.colors, borderRadius2 = _ref$theme.borderRadius, spacing2 = _ref$theme.spacing;
  return _objectSpread2({
    label: "control",
    alignItems: "center",
    cursor: "default",
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-between",
    minHeight: spacing2.controlHeight,
    outline: "0 !important",
    position: "relative",
    transition: "all 100ms"
  }, unstyled ? {} : {
    backgroundColor: isDisabled ? colors2.neutral5 : colors2.neutral0,
    borderColor: isDisabled ? colors2.neutral10 : isFocused ? colors2.primary : colors2.neutral20,
    borderRadius: borderRadius2,
    borderStyle: "solid",
    borderWidth: 1,
    boxShadow: isFocused ? "0 0 0 1px ".concat(colors2.primary) : void 0,
    "&:hover": {
      borderColor: isFocused ? colors2.primary : colors2.neutral30
    }
  });
};
var Control$1 = function Control(props) {
  var children = props.children, isDisabled = props.isDisabled, isFocused = props.isFocused, innerRef = props.innerRef, innerProps = props.innerProps, menuIsOpen = props.menuIsOpen;
  return jsx("div", _extends$4({
    ref: innerRef
  }, getStyleProps(props, "control", {
    control: true,
    "control--is-disabled": isDisabled,
    "control--is-focused": isFocused,
    "control--menu-is-open": menuIsOpen
  }), innerProps, {
    "aria-disabled": isDisabled || void 0
  }), children);
};
var Control$1$1 = Control$1;
var _excluded$1$1 = ["data"];
var groupCSS = function groupCSS2(_ref3, unstyled) {
  var spacing2 = _ref3.theme.spacing;
  return unstyled ? {} : {
    paddingBottom: spacing2.baseUnit * 2,
    paddingTop: spacing2.baseUnit * 2
  };
};
var Group = function Group2(props) {
  var children = props.children, cx = props.cx, getStyles = props.getStyles, getClassNames = props.getClassNames, Heading = props.Heading, headingProps = props.headingProps, innerProps = props.innerProps, label = props.label, theme = props.theme, selectProps = props.selectProps;
  return jsx("div", _extends$4({}, getStyleProps(props, "group", {
    group: true
  }), innerProps), jsx(Heading, _extends$4({}, headingProps, {
    selectProps,
    theme,
    getStyles,
    getClassNames,
    cx
  }), label), jsx("div", null, children));
};
var groupHeadingCSS = function groupHeadingCSS2(_ref22, unstyled) {
  var _ref2$theme = _ref22.theme, colors2 = _ref2$theme.colors, spacing2 = _ref2$theme.spacing;
  return _objectSpread2({
    label: "group",
    cursor: "default",
    display: "block"
  }, unstyled ? {} : {
    color: colors2.neutral40,
    fontSize: "75%",
    fontWeight: 500,
    marginBottom: "0.25em",
    paddingLeft: spacing2.baseUnit * 3,
    paddingRight: spacing2.baseUnit * 3,
    textTransform: "uppercase"
  });
};
var GroupHeading = function GroupHeading2(props) {
  var _cleanCommonProps = cleanCommonProps(props);
  _cleanCommonProps.data;
  var innerProps = _objectWithoutProperties$3(_cleanCommonProps, _excluded$1$1);
  return jsx("div", _extends$4({}, getStyleProps(props, "groupHeading", {
    "group-heading": true
  }), innerProps));
};
var Group$1 = Group;
var _excluded$6 = ["innerRef", "isDisabled", "isHidden", "inputClassName"];
var inputCSS = function inputCSS2(_ref3, unstyled) {
  var isDisabled = _ref3.isDisabled, value = _ref3.value, _ref$theme = _ref3.theme, spacing2 = _ref$theme.spacing, colors2 = _ref$theme.colors;
  return _objectSpread2(_objectSpread2({
    visibility: isDisabled ? "hidden" : "visible",
    // force css to recompute when value change due to @emotion bug.
    // We can remove it whenever the bug is fixed.
    transform: value ? "translateZ(0)" : ""
  }, containerStyle), unstyled ? {} : {
    margin: spacing2.baseUnit / 2,
    paddingBottom: spacing2.baseUnit / 2,
    paddingTop: spacing2.baseUnit / 2,
    color: colors2.neutral80
  });
};
var spacingStyle = {
  gridArea: "1 / 2",
  font: "inherit",
  minWidth: "2px",
  border: 0,
  margin: 0,
  outline: 0,
  padding: 0
};
var containerStyle = {
  flex: "1 1 auto",
  display: "inline-grid",
  gridArea: "1 / 1 / 2 / 3",
  gridTemplateColumns: "0 min-content",
  "&:after": _objectSpread2({
    content: 'attr(data-value) " "',
    visibility: "hidden",
    whiteSpace: "pre"
  }, spacingStyle)
};
var inputStyle = function inputStyle2(isHidden) {
  return _objectSpread2({
    label: "input",
    color: "inherit",
    background: 0,
    opacity: isHidden ? 0 : 1,
    width: "100%"
  }, spacingStyle);
};
var Input$1 = function Input(props) {
  var cx = props.cx, value = props.value;
  var _cleanCommonProps = cleanCommonProps(props), innerRef = _cleanCommonProps.innerRef, isDisabled = _cleanCommonProps.isDisabled, isHidden = _cleanCommonProps.isHidden, inputClassName = _cleanCommonProps.inputClassName, innerProps = _objectWithoutProperties$3(_cleanCommonProps, _excluded$6);
  return jsx("div", _extends$4({}, getStyleProps(props, "input", {
    "input-container": true
  }), {
    "data-value": value || ""
  }), jsx("input", _extends$4({
    className: cx({
      input: true
    }, inputClassName),
    ref: innerRef,
    style: inputStyle(isHidden),
    disabled: isDisabled
  }, innerProps)));
};
var Input$1$1 = Input$1;
var multiValueCSS = function multiValueCSS2(_ref3, unstyled) {
  var _ref$theme = _ref3.theme, spacing2 = _ref$theme.spacing, borderRadius2 = _ref$theme.borderRadius, colors2 = _ref$theme.colors;
  return _objectSpread2({
    label: "multiValue",
    display: "flex",
    minWidth: 0
  }, unstyled ? {} : {
    backgroundColor: colors2.neutral10,
    borderRadius: borderRadius2 / 2,
    margin: spacing2.baseUnit / 2
  });
};
var multiValueLabelCSS = function multiValueLabelCSS2(_ref22, unstyled) {
  var _ref2$theme = _ref22.theme, borderRadius2 = _ref2$theme.borderRadius, colors2 = _ref2$theme.colors, cropWithEllipsis = _ref22.cropWithEllipsis;
  return _objectSpread2({
    overflow: "hidden",
    textOverflow: cropWithEllipsis || cropWithEllipsis === void 0 ? "ellipsis" : void 0,
    whiteSpace: "nowrap"
  }, unstyled ? {} : {
    borderRadius: borderRadius2 / 2,
    color: colors2.neutral80,
    fontSize: "85%",
    padding: 3,
    paddingLeft: 6
  });
};
var multiValueRemoveCSS = function multiValueRemoveCSS2(_ref3, unstyled) {
  var _ref3$theme = _ref3.theme, spacing2 = _ref3$theme.spacing, borderRadius2 = _ref3$theme.borderRadius, colors2 = _ref3$theme.colors, isFocused = _ref3.isFocused;
  return _objectSpread2({
    alignItems: "center",
    display: "flex"
  }, unstyled ? {} : {
    borderRadius: borderRadius2 / 2,
    backgroundColor: isFocused ? colors2.dangerLight : void 0,
    paddingLeft: spacing2.baseUnit,
    paddingRight: spacing2.baseUnit,
    ":hover": {
      backgroundColor: colors2.dangerLight,
      color: colors2.danger
    }
  });
};
var MultiValueGeneric = function MultiValueGeneric2(_ref4) {
  var children = _ref4.children, innerProps = _ref4.innerProps;
  return jsx("div", innerProps, children);
};
var MultiValueContainer = MultiValueGeneric;
var MultiValueLabel = MultiValueGeneric;
function MultiValueRemove(_ref5) {
  var children = _ref5.children, innerProps = _ref5.innerProps;
  return jsx("div", _extends$4({
    role: "button"
  }, innerProps), children || jsx(CrossIcon, {
    size: 14
  }));
}
var MultiValue$1 = function MultiValue(props) {
  var children = props.children, components2 = props.components, data = props.data, innerProps = props.innerProps, isDisabled = props.isDisabled, removeProps3 = props.removeProps, selectProps = props.selectProps;
  var Container2 = components2.Container, Label = components2.Label, Remove = components2.Remove;
  return jsx(Container2, {
    data,
    innerProps: _objectSpread2(_objectSpread2({}, getStyleProps(props, "multiValue", {
      "multi-value": true,
      "multi-value--is-disabled": isDisabled
    })), innerProps),
    selectProps
  }, jsx(Label, {
    data,
    innerProps: _objectSpread2({}, getStyleProps(props, "multiValueLabel", {
      "multi-value__label": true
    })),
    selectProps
  }, children), jsx(Remove, {
    data,
    innerProps: _objectSpread2(_objectSpread2({}, getStyleProps(props, "multiValueRemove", {
      "multi-value__remove": true
    })), {}, {
      "aria-label": "Remove ".concat(children || "option")
    }, removeProps3),
    selectProps
  }));
};
var MultiValue$1$1 = MultiValue$1;
var optionCSS = function optionCSS2(_ref3, unstyled) {
  var isDisabled = _ref3.isDisabled, isFocused = _ref3.isFocused, isSelected = _ref3.isSelected, _ref$theme = _ref3.theme, spacing2 = _ref$theme.spacing, colors2 = _ref$theme.colors;
  return _objectSpread2({
    label: "option",
    cursor: "default",
    display: "block",
    fontSize: "inherit",
    width: "100%",
    userSelect: "none",
    WebkitTapHighlightColor: "rgba(0, 0, 0, 0)"
  }, unstyled ? {} : {
    backgroundColor: isSelected ? colors2.primary : isFocused ? colors2.primary25 : "transparent",
    color: isDisabled ? colors2.neutral20 : isSelected ? colors2.neutral0 : "inherit",
    padding: "".concat(spacing2.baseUnit * 2, "px ").concat(spacing2.baseUnit * 3, "px"),
    // provide some affordance on touch devices
    ":active": {
      backgroundColor: !isDisabled ? isSelected ? colors2.primary : colors2.primary50 : void 0
    }
  });
};
var Option$1 = function Option(props) {
  var children = props.children, isDisabled = props.isDisabled, isFocused = props.isFocused, isSelected = props.isSelected, innerRef = props.innerRef, innerProps = props.innerProps;
  return jsx("div", _extends$4({}, getStyleProps(props, "option", {
    option: true,
    "option--is-disabled": isDisabled,
    "option--is-focused": isFocused,
    "option--is-selected": isSelected
  }), {
    ref: innerRef,
    "aria-disabled": isDisabled
  }, innerProps), children);
};
var Option$1$1 = Option$1;
var placeholderCSS = function placeholderCSS2(_ref3, unstyled) {
  var _ref$theme = _ref3.theme, spacing2 = _ref$theme.spacing, colors2 = _ref$theme.colors;
  return _objectSpread2({
    label: "placeholder",
    gridArea: "1 / 1 / 2 / 3"
  }, unstyled ? {} : {
    color: colors2.neutral50,
    marginLeft: spacing2.baseUnit / 2,
    marginRight: spacing2.baseUnit / 2
  });
};
var Placeholder$1 = function Placeholder(props) {
  var children = props.children, innerProps = props.innerProps;
  return jsx("div", _extends$4({}, getStyleProps(props, "placeholder", {
    placeholder: true
  }), innerProps), children);
};
var Placeholder$1$1 = Placeholder$1;
var css2 = function css3(_ref3, unstyled) {
  var isDisabled = _ref3.isDisabled, _ref$theme = _ref3.theme, spacing2 = _ref$theme.spacing, colors2 = _ref$theme.colors;
  return _objectSpread2({
    label: "singleValue",
    gridArea: "1 / 1 / 2 / 3",
    maxWidth: "100%",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
  }, unstyled ? {} : {
    color: isDisabled ? colors2.neutral40 : colors2.neutral80,
    marginLeft: spacing2.baseUnit / 2,
    marginRight: spacing2.baseUnit / 2
  });
};
var SingleValue = function SingleValue2(props) {
  var children = props.children, isDisabled = props.isDisabled, innerProps = props.innerProps;
  return jsx("div", _extends$4({}, getStyleProps(props, "singleValue", {
    "single-value": true,
    "single-value--is-disabled": isDisabled
  }), innerProps), children);
};
var SingleValue$1 = SingleValue;
var components = {
  ClearIndicator: ClearIndicator$1,
  Control: Control$1$1,
  DropdownIndicator: DropdownIndicator$1,
  DownChevron,
  CrossIcon,
  Group: Group$1,
  GroupHeading,
  IndicatorsContainer,
  IndicatorSeparator,
  Input: Input$1$1,
  LoadingIndicator,
  Menu: Menu$1$1,
  MenuList,
  MenuPortal,
  LoadingMessage,
  NoOptionsMessage,
  MultiValue: MultiValue$1$1,
  MultiValueContainer,
  MultiValueLabel,
  MultiValueRemove,
  Option: Option$1$1,
  Placeholder: Placeholder$1$1,
  SelectContainer,
  SingleValue: SingleValue$1,
  ValueContainer
};
var defaultComponents = function defaultComponents2(props) {
  return _objectSpread2(_objectSpread2({}, components), props.components);
};
var safeIsNaN = Number.isNaN || function ponyfill(value) {
  return typeof value === "number" && value !== value;
};
function isEqual$2(first, second) {
  if (first === second) {
    return true;
  }
  if (safeIsNaN(first) && safeIsNaN(second)) {
    return true;
  }
  return false;
}
function areInputsEqual(newInputs, lastInputs) {
  if (newInputs.length !== lastInputs.length) {
    return false;
  }
  for (var i = 0; i < newInputs.length; i++) {
    if (!isEqual$2(newInputs[i], lastInputs[i])) {
      return false;
    }
  }
  return true;
}
function memoizeOne(resultFn, isEqual2) {
  if (isEqual2 === void 0) {
    isEqual2 = areInputsEqual;
  }
  var cache = null;
  function memoized2() {
    var newArgs = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      newArgs[_i] = arguments[_i];
    }
    if (cache && cache.lastThis === this && isEqual2(newArgs, cache.lastArgs)) {
      return cache.lastResult;
    }
    var lastResult = resultFn.apply(this, newArgs);
    cache = {
      lastResult,
      lastArgs: newArgs,
      lastThis: this
    };
    return lastResult;
  }
  memoized2.clear = function clear() {
    cache = null;
  };
  return memoized2;
}
function _EMOTION_STRINGIFIED_CSS_ERROR__$2() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var _ref = process.env.NODE_ENV === "production" ? {
  name: "7pg0cj-a11yText",
  styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap"
} : {
  name: "1f43avz-a11yText-A11yText",
  styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap;label:A11yText;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkExMXlUZXh0LnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFPSSIsImZpbGUiOiJBMTF5VGV4dC50c3giLCJzb3VyY2VzQ29udGVudCI6WyIvKiogQGpzeCBqc3ggKi9cbmltcG9ydCB7IEpTWCB9IGZyb20gJ3JlYWN0JztcbmltcG9ydCB7IGpzeCB9IGZyb20gJ0BlbW90aW9uL3JlYWN0JztcblxuLy8gQXNzaXN0aXZlIHRleHQgdG8gZGVzY3JpYmUgdmlzdWFsIGVsZW1lbnRzLiBIaWRkZW4gZm9yIHNpZ2h0ZWQgdXNlcnMuXG5jb25zdCBBMTF5VGV4dCA9IChwcm9wczogSlNYLkludHJpbnNpY0VsZW1lbnRzWydzcGFuJ10pID0+IChcbiAgPHNwYW5cbiAgICBjc3M9e3tcbiAgICAgIGxhYmVsOiAnYTExeVRleHQnLFxuICAgICAgekluZGV4OiA5OTk5LFxuICAgICAgYm9yZGVyOiAwLFxuICAgICAgY2xpcDogJ3JlY3QoMXB4LCAxcHgsIDFweCwgMXB4KScsXG4gICAgICBoZWlnaHQ6IDEsXG4gICAgICB3aWR0aDogMSxcbiAgICAgIHBvc2l0aW9uOiAnYWJzb2x1dGUnLFxuICAgICAgb3ZlcmZsb3c6ICdoaWRkZW4nLFxuICAgICAgcGFkZGluZzogMCxcbiAgICAgIHdoaXRlU3BhY2U6ICdub3dyYXAnLFxuICAgIH19XG4gICAgey4uLnByb3BzfVxuICAvPlxuKTtcblxuZXhwb3J0IGRlZmF1bHQgQTExeVRleHQ7XG4iXX0= */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$2
};
var A11yText = function A11yText2(props) {
  return jsx("span", _extends$4({
    css: _ref
  }, props));
};
var A11yText$1 = A11yText;
var defaultAriaLiveMessages = {
  guidance: function guidance(props) {
    var isSearchable = props.isSearchable, isMulti = props.isMulti, tabSelectsValue = props.tabSelectsValue, context = props.context, isInitialFocus = props.isInitialFocus;
    switch (context) {
      case "menu":
        return "Use Up and Down to choose options, press Enter to select the currently focused option, press Escape to exit the menu".concat(tabSelectsValue ? ", press Tab to select the option and exit the menu" : "", ".");
      case "input":
        return isInitialFocus ? "".concat(props["aria-label"] || "Select", " is focused ").concat(isSearchable ? ",type to refine list" : "", ", press Down to open the menu, ").concat(isMulti ? " press left to focus selected values" : "") : "";
      case "value":
        return "Use left and right to toggle between focused values, press Backspace to remove the currently focused value";
      default:
        return "";
    }
  },
  onChange: function onChange(props) {
    var action = props.action, _props$label = props.label, label = _props$label === void 0 ? "" : _props$label, labels = props.labels, isDisabled = props.isDisabled;
    switch (action) {
      case "deselect-option":
      case "pop-value":
      case "remove-value":
        return "option ".concat(label, ", deselected.");
      case "clear":
        return "All selected options have been cleared.";
      case "initial-input-focus":
        return "option".concat(labels.length > 1 ? "s" : "", " ").concat(labels.join(","), ", selected.");
      case "select-option":
        return isDisabled ? "option ".concat(label, " is disabled. Select another option.") : "option ".concat(label, ", selected.");
      default:
        return "";
    }
  },
  onFocus: function onFocus(props) {
    var context = props.context, focused = props.focused, options2 = props.options, _props$label2 = props.label, label = _props$label2 === void 0 ? "" : _props$label2, selectValue = props.selectValue, isDisabled = props.isDisabled, isSelected = props.isSelected, isAppleDevice2 = props.isAppleDevice;
    var getArrayIndex = function getArrayIndex2(arr, item) {
      return arr && arr.length ? "".concat(arr.indexOf(item) + 1, " of ").concat(arr.length) : "";
    };
    if (context === "value" && selectValue) {
      return "value ".concat(label, " focused, ").concat(getArrayIndex(selectValue, focused), ".");
    }
    if (context === "menu" && isAppleDevice2) {
      var disabled = isDisabled ? " disabled" : "";
      var status = "".concat(isSelected ? " selected" : "").concat(disabled);
      return "".concat(label).concat(status, ", ").concat(getArrayIndex(options2, focused), ".");
    }
    return "";
  },
  onFilter: function onFilter(props) {
    var inputValue = props.inputValue, resultsMessage = props.resultsMessage;
    return "".concat(resultsMessage).concat(inputValue ? " for search term " + inputValue : "", ".");
  }
};
var LiveRegion = function LiveRegion2(props) {
  var ariaSelection = props.ariaSelection, focusedOption = props.focusedOption, focusedValue = props.focusedValue, focusableOptions = props.focusableOptions, isFocused = props.isFocused, selectValue = props.selectValue, selectProps = props.selectProps, id2 = props.id, isAppleDevice2 = props.isAppleDevice;
  var ariaLiveMessages = selectProps.ariaLiveMessages, getOptionLabel4 = selectProps.getOptionLabel, inputValue = selectProps.inputValue, isMulti = selectProps.isMulti, isOptionDisabled3 = selectProps.isOptionDisabled, isSearchable = selectProps.isSearchable, menuIsOpen = selectProps.menuIsOpen, options2 = selectProps.options, screenReaderStatus2 = selectProps.screenReaderStatus, tabSelectsValue = selectProps.tabSelectsValue, isLoading = selectProps.isLoading;
  var ariaLabel = selectProps["aria-label"];
  var ariaLive = selectProps["aria-live"];
  var messages = useMemo(function() {
    return _objectSpread2(_objectSpread2({}, defaultAriaLiveMessages), ariaLiveMessages || {});
  }, [ariaLiveMessages]);
  var ariaSelected = useMemo(function() {
    var message2 = "";
    if (ariaSelection && messages.onChange) {
      var option = ariaSelection.option, selectedOptions = ariaSelection.options, removedValue = ariaSelection.removedValue, removedValues = ariaSelection.removedValues, value = ariaSelection.value;
      var asOption = function asOption2(val) {
        return !Array.isArray(val) ? val : null;
      };
      var selected = removedValue || option || asOption(value);
      var label = selected ? getOptionLabel4(selected) : "";
      var multiSelected = selectedOptions || removedValues || void 0;
      var labels = multiSelected ? multiSelected.map(getOptionLabel4) : [];
      var onChangeProps = _objectSpread2({
        // multiSelected items are usually items that have already been selected
        // or set by the user as a default value so we assume they are not disabled
        isDisabled: selected && isOptionDisabled3(selected, selectValue),
        label,
        labels
      }, ariaSelection);
      message2 = messages.onChange(onChangeProps);
    }
    return message2;
  }, [ariaSelection, messages, isOptionDisabled3, selectValue, getOptionLabel4]);
  var ariaFocused = useMemo(function() {
    var focusMsg = "";
    var focused = focusedOption || focusedValue;
    var isSelected = !!(focusedOption && selectValue && selectValue.includes(focusedOption));
    if (focused && messages.onFocus) {
      var onFocusProps = {
        focused,
        label: getOptionLabel4(focused),
        isDisabled: isOptionDisabled3(focused, selectValue),
        isSelected,
        options: focusableOptions,
        context: focused === focusedOption ? "menu" : "value",
        selectValue,
        isAppleDevice: isAppleDevice2
      };
      focusMsg = messages.onFocus(onFocusProps);
    }
    return focusMsg;
  }, [focusedOption, focusedValue, getOptionLabel4, isOptionDisabled3, messages, focusableOptions, selectValue, isAppleDevice2]);
  var ariaResults = useMemo(function() {
    var resultsMsg = "";
    if (menuIsOpen && options2.length && !isLoading && messages.onFilter) {
      var resultsMessage = screenReaderStatus2({
        count: focusableOptions.length
      });
      resultsMsg = messages.onFilter({
        inputValue,
        resultsMessage
      });
    }
    return resultsMsg;
  }, [focusableOptions, inputValue, menuIsOpen, messages, options2, screenReaderStatus2, isLoading]);
  var isInitialFocus = (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === "initial-input-focus";
  var ariaGuidance = useMemo(function() {
    var guidanceMsg = "";
    if (messages.guidance) {
      var context = focusedValue ? "value" : menuIsOpen ? "menu" : "input";
      guidanceMsg = messages.guidance({
        "aria-label": ariaLabel,
        context,
        isDisabled: focusedOption && isOptionDisabled3(focusedOption, selectValue),
        isMulti,
        isSearchable,
        tabSelectsValue,
        isInitialFocus
      });
    }
    return guidanceMsg;
  }, [ariaLabel, focusedOption, focusedValue, isMulti, isOptionDisabled3, isSearchable, menuIsOpen, messages, selectValue, tabSelectsValue, isInitialFocus]);
  var ScreenReaderText = jsx(Fragment, null, jsx("span", {
    id: "aria-selection"
  }, ariaSelected), jsx("span", {
    id: "aria-focused"
  }, ariaFocused), jsx("span", {
    id: "aria-results"
  }, ariaResults), jsx("span", {
    id: "aria-guidance"
  }, ariaGuidance));
  return jsx(Fragment, null, jsx(A11yText$1, {
    id: id2
  }, isInitialFocus && ScreenReaderText), jsx(A11yText$1, {
    "aria-live": ariaLive,
    "aria-atomic": "false",
    "aria-relevant": "additions text",
    role: "log"
  }, isFocused && !isInitialFocus && ScreenReaderText));
};
var LiveRegion$1 = LiveRegion;
var diacritics = [{
  base: "A",
  letters: "AⒶＡÀÁÂẦẤẪẨÃĀĂẰẮẴẲȦǠÄǞẢÅǺǍȀȂẠẬẶḀĄȺⱯ"
}, {
  base: "AA",
  letters: "Ꜳ"
}, {
  base: "AE",
  letters: "ÆǼǢ"
}, {
  base: "AO",
  letters: "Ꜵ"
}, {
  base: "AU",
  letters: "Ꜷ"
}, {
  base: "AV",
  letters: "ꜸꜺ"
}, {
  base: "AY",
  letters: "Ꜽ"
}, {
  base: "B",
  letters: "BⒷＢḂḄḆɃƂƁ"
}, {
  base: "C",
  letters: "CⒸＣĆĈĊČÇḈƇȻꜾ"
}, {
  base: "D",
  letters: "DⒹＤḊĎḌḐḒḎĐƋƊƉꝹ"
}, {
  base: "DZ",
  letters: "ǱǄ"
}, {
  base: "Dz",
  letters: "ǲǅ"
}, {
  base: "E",
  letters: "EⒺＥÈÉÊỀẾỄỂẼĒḔḖĔĖËẺĚȄȆẸỆȨḜĘḘḚƐƎ"
}, {
  base: "F",
  letters: "FⒻＦḞƑꝻ"
}, {
  base: "G",
  letters: "GⒼＧǴĜḠĞĠǦĢǤƓꞠꝽꝾ"
}, {
  base: "H",
  letters: "HⒽＨĤḢḦȞḤḨḪĦⱧⱵꞍ"
}, {
  base: "I",
  letters: "IⒾＩÌÍÎĨĪĬİÏḮỈǏȈȊỊĮḬƗ"
}, {
  base: "J",
  letters: "JⒿＪĴɈ"
}, {
  base: "K",
  letters: "KⓀＫḰǨḲĶḴƘⱩꝀꝂꝄꞢ"
}, {
  base: "L",
  letters: "LⓁＬĿĹĽḶḸĻḼḺŁȽⱢⱠꝈꝆꞀ"
}, {
  base: "LJ",
  letters: "Ǉ"
}, {
  base: "Lj",
  letters: "ǈ"
}, {
  base: "M",
  letters: "MⓂＭḾṀṂⱮƜ"
}, {
  base: "N",
  letters: "NⓃＮǸŃÑṄŇṆŅṊṈȠƝꞐꞤ"
}, {
  base: "NJ",
  letters: "Ǌ"
}, {
  base: "Nj",
  letters: "ǋ"
}, {
  base: "O",
  letters: "OⓄＯÒÓÔỒỐỖỔÕṌȬṎŌṐṒŎȮȰÖȪỎŐǑȌȎƠỜỚỠỞỢỌỘǪǬØǾƆƟꝊꝌ"
}, {
  base: "OI",
  letters: "Ƣ"
}, {
  base: "OO",
  letters: "Ꝏ"
}, {
  base: "OU",
  letters: "Ȣ"
}, {
  base: "P",
  letters: "PⓅＰṔṖƤⱣꝐꝒꝔ"
}, {
  base: "Q",
  letters: "QⓆＱꝖꝘɊ"
}, {
  base: "R",
  letters: "RⓇＲŔṘŘȐȒṚṜŖṞɌⱤꝚꞦꞂ"
}, {
  base: "S",
  letters: "SⓈＳẞŚṤŜṠŠṦṢṨȘŞⱾꞨꞄ"
}, {
  base: "T",
  letters: "TⓉＴṪŤṬȚŢṰṮŦƬƮȾꞆ"
}, {
  base: "TZ",
  letters: "Ꜩ"
}, {
  base: "U",
  letters: "UⓊＵÙÚÛŨṸŪṺŬÜǛǗǕǙỦŮŰǓȔȖƯỪỨỮỬỰỤṲŲṶṴɄ"
}, {
  base: "V",
  letters: "VⓋＶṼṾƲꝞɅ"
}, {
  base: "VY",
  letters: "Ꝡ"
}, {
  base: "W",
  letters: "WⓌＷẀẂŴẆẄẈⱲ"
}, {
  base: "X",
  letters: "XⓍＸẊẌ"
}, {
  base: "Y",
  letters: "YⓎＹỲÝŶỸȲẎŸỶỴƳɎỾ"
}, {
  base: "Z",
  letters: "ZⓏＺŹẐŻŽẒẔƵȤⱿⱫꝢ"
}, {
  base: "a",
  letters: "aⓐａẚàáâầấẫẩãāăằắẵẳȧǡäǟảåǻǎȁȃạậặḁąⱥɐ"
}, {
  base: "aa",
  letters: "ꜳ"
}, {
  base: "ae",
  letters: "æǽǣ"
}, {
  base: "ao",
  letters: "ꜵ"
}, {
  base: "au",
  letters: "ꜷ"
}, {
  base: "av",
  letters: "ꜹꜻ"
}, {
  base: "ay",
  letters: "ꜽ"
}, {
  base: "b",
  letters: "bⓑｂḃḅḇƀƃɓ"
}, {
  base: "c",
  letters: "cⓒｃćĉċčçḉƈȼꜿↄ"
}, {
  base: "d",
  letters: "dⓓｄḋďḍḑḓḏđƌɖɗꝺ"
}, {
  base: "dz",
  letters: "ǳǆ"
}, {
  base: "e",
  letters: "eⓔｅèéêềếễểẽēḕḗĕėëẻěȅȇẹệȩḝęḙḛɇɛǝ"
}, {
  base: "f",
  letters: "fⓕｆḟƒꝼ"
}, {
  base: "g",
  letters: "gⓖｇǵĝḡğġǧģǥɠꞡᵹꝿ"
}, {
  base: "h",
  letters: "hⓗｈĥḣḧȟḥḩḫẖħⱨⱶɥ"
}, {
  base: "hv",
  letters: "ƕ"
}, {
  base: "i",
  letters: "iⓘｉìíîĩīĭïḯỉǐȉȋịįḭɨı"
}, {
  base: "j",
  letters: "jⓙｊĵǰɉ"
}, {
  base: "k",
  letters: "kⓚｋḱǩḳķḵƙⱪꝁꝃꝅꞣ"
}, {
  base: "l",
  letters: "lⓛｌŀĺľḷḹļḽḻſłƚɫⱡꝉꞁꝇ"
}, {
  base: "lj",
  letters: "ǉ"
}, {
  base: "m",
  letters: "mⓜｍḿṁṃɱɯ"
}, {
  base: "n",
  letters: "nⓝｎǹńñṅňṇņṋṉƞɲŉꞑꞥ"
}, {
  base: "nj",
  letters: "ǌ"
}, {
  base: "o",
  letters: "oⓞｏòóôồốỗổõṍȭṏōṑṓŏȯȱöȫỏőǒȍȏơờớỡởợọộǫǭøǿɔꝋꝍɵ"
}, {
  base: "oi",
  letters: "ƣ"
}, {
  base: "ou",
  letters: "ȣ"
}, {
  base: "oo",
  letters: "ꝏ"
}, {
  base: "p",
  letters: "pⓟｐṕṗƥᵽꝑꝓꝕ"
}, {
  base: "q",
  letters: "qⓠｑɋꝗꝙ"
}, {
  base: "r",
  letters: "rⓡｒŕṙřȑȓṛṝŗṟɍɽꝛꞧꞃ"
}, {
  base: "s",
  letters: "sⓢｓßśṥŝṡšṧṣṩșşȿꞩꞅẛ"
}, {
  base: "t",
  letters: "tⓣｔṫẗťṭțţṱṯŧƭʈⱦꞇ"
}, {
  base: "tz",
  letters: "ꜩ"
}, {
  base: "u",
  letters: "uⓤｕùúûũṹūṻŭüǜǘǖǚủůűǔȕȗưừứữửựụṳųṷṵʉ"
}, {
  base: "v",
  letters: "vⓥｖṽṿʋꝟʌ"
}, {
  base: "vy",
  letters: "ꝡ"
}, {
  base: "w",
  letters: "wⓦｗẁẃŵẇẅẘẉⱳ"
}, {
  base: "x",
  letters: "xⓧｘẋẍ"
}, {
  base: "y",
  letters: "yⓨｙỳýŷỹȳẏÿỷẙỵƴɏỿ"
}, {
  base: "z",
  letters: "zⓩｚźẑżžẓẕƶȥɀⱬꝣ"
}];
var anyDiacritic = new RegExp("[" + diacritics.map(function(d2) {
  return d2.letters;
}).join("") + "]", "g");
var diacriticToBase = {};
for (var i = 0; i < diacritics.length; i++) {
  var diacritic = diacritics[i];
  for (var j = 0; j < diacritic.letters.length; j++) {
    diacriticToBase[diacritic.letters[j]] = diacritic.base;
  }
}
var stripDiacritics = function stripDiacritics2(str) {
  return str.replace(anyDiacritic, function(match2) {
    return diacriticToBase[match2];
  });
};
var memoizedStripDiacriticsForInput = memoizeOne(stripDiacritics);
var trimString = function trimString2(str) {
  return str.replace(/^\s+|\s+$/g, "");
};
var defaultStringify = function defaultStringify2(option) {
  return "".concat(option.label, " ").concat(option.value);
};
var createFilter = function createFilter2(config2) {
  return function(option, rawInput) {
    if (option.data.__isNew__) return true;
    var _ignoreCase$ignoreAcc = _objectSpread2({
      ignoreCase: true,
      ignoreAccents: true,
      stringify: defaultStringify,
      trim: true,
      matchFrom: "any"
    }, config2), ignoreCase = _ignoreCase$ignoreAcc.ignoreCase, ignoreAccents = _ignoreCase$ignoreAcc.ignoreAccents, stringify2 = _ignoreCase$ignoreAcc.stringify, trim2 = _ignoreCase$ignoreAcc.trim, matchFrom = _ignoreCase$ignoreAcc.matchFrom;
    var input = trim2 ? trimString(rawInput) : rawInput;
    var candidate = trim2 ? trimString(stringify2(option)) : stringify2(option);
    if (ignoreCase) {
      input = input.toLowerCase();
      candidate = candidate.toLowerCase();
    }
    if (ignoreAccents) {
      input = memoizedStripDiacriticsForInput(input);
      candidate = stripDiacritics(candidate);
    }
    return matchFrom === "start" ? candidate.substr(0, input.length) === input : candidate.indexOf(input) > -1;
  };
};
var _excluded$5 = ["innerRef"];
function DummyInput(_ref3) {
  var innerRef = _ref3.innerRef, props = _objectWithoutProperties$3(_ref3, _excluded$5);
  var filteredProps = removeProps(props, "onExited", "in", "enter", "exit", "appear");
  return jsx("input", _extends$4({
    ref: innerRef
  }, filteredProps, {
    css: /* @__PURE__ */ css$2({
      label: "dummyInput",
      // get rid of any default styles
      background: 0,
      border: 0,
      // important! this hides the flashing cursor
      caretColor: "transparent",
      fontSize: "inherit",
      gridArea: "1 / 1 / 2 / 3",
      outline: 0,
      padding: 0,
      // important! without `width` browsers won't allow focus
      width: 1,
      // remove cursor on desktop
      color: "transparent",
      // remove cursor on mobile whilst maintaining "scroll into view" behaviour
      left: -100,
      opacity: 0,
      position: "relative",
      transform: "scale(.01)"
    }, process.env.NODE_ENV === "production" ? "" : ";label:DummyInput;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkR1bW15SW5wdXQudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQXlCTSIsImZpbGUiOiJEdW1teUlucHV0LnRzeCIsInNvdXJjZXNDb250ZW50IjpbIi8qKiBAanN4IGpzeCAqL1xuaW1wb3J0IHsgSlNYLCBSZWYgfSBmcm9tICdyZWFjdCc7XG5pbXBvcnQgeyBqc3ggfSBmcm9tICdAZW1vdGlvbi9yZWFjdCc7XG5pbXBvcnQgeyByZW1vdmVQcm9wcyB9IGZyb20gJy4uL3V0aWxzJztcblxuZXhwb3J0IGRlZmF1bHQgZnVuY3Rpb24gRHVtbXlJbnB1dCh7XG4gIGlubmVyUmVmLFxuICAuLi5wcm9wc1xufTogSlNYLkludHJpbnNpY0VsZW1lbnRzWydpbnB1dCddICYge1xuICByZWFkb25seSBpbm5lclJlZjogUmVmPEhUTUxJbnB1dEVsZW1lbnQ+O1xufSkge1xuICAvLyBSZW1vdmUgYW5pbWF0aW9uIHByb3BzIG5vdCBtZWFudCBmb3IgSFRNTCBlbGVtZW50c1xuICBjb25zdCBmaWx0ZXJlZFByb3BzID0gcmVtb3ZlUHJvcHMoXG4gICAgcHJvcHMsXG4gICAgJ29uRXhpdGVkJyxcbiAgICAnaW4nLFxuICAgICdlbnRlcicsXG4gICAgJ2V4aXQnLFxuICAgICdhcHBlYXInXG4gICk7XG5cbiAgcmV0dXJuIChcbiAgICA8aW5wdXRcbiAgICAgIHJlZj17aW5uZXJSZWZ9XG4gICAgICB7Li4uZmlsdGVyZWRQcm9wc31cbiAgICAgIGNzcz17e1xuICAgICAgICBsYWJlbDogJ2R1bW15SW5wdXQnLFxuICAgICAgICAvLyBnZXQgcmlkIG9mIGFueSBkZWZhdWx0IHN0eWxlc1xuICAgICAgICBiYWNrZ3JvdW5kOiAwLFxuICAgICAgICBib3JkZXI6IDAsXG4gICAgICAgIC8vIGltcG9ydGFudCEgdGhpcyBoaWRlcyB0aGUgZmxhc2hpbmcgY3Vyc29yXG4gICAgICAgIGNhcmV0Q29sb3I6ICd0cmFuc3BhcmVudCcsXG4gICAgICAgIGZvbnRTaXplOiAnaW5oZXJpdCcsXG4gICAgICAgIGdyaWRBcmVhOiAnMSAvIDEgLyAyIC8gMycsXG4gICAgICAgIG91dGxpbmU6IDAsXG4gICAgICAgIHBhZGRpbmc6IDAsXG4gICAgICAgIC8vIGltcG9ydGFudCEgd2l0aG91dCBgd2lkdGhgIGJyb3dzZXJzIHdvbid0IGFsbG93IGZvY3VzXG4gICAgICAgIHdpZHRoOiAxLFxuXG4gICAgICAgIC8vIHJlbW92ZSBjdXJzb3Igb24gZGVza3RvcFxuICAgICAgICBjb2xvcjogJ3RyYW5zcGFyZW50JyxcblxuICAgICAgICAvLyByZW1vdmUgY3Vyc29yIG9uIG1vYmlsZSB3aGlsc3QgbWFpbnRhaW5pbmcgXCJzY3JvbGwgaW50byB2aWV3XCIgYmVoYXZpb3VyXG4gICAgICAgIGxlZnQ6IC0xMDAsXG4gICAgICAgIG9wYWNpdHk6IDAsXG4gICAgICAgIHBvc2l0aW9uOiAncmVsYXRpdmUnLFxuICAgICAgICB0cmFuc2Zvcm06ICdzY2FsZSguMDEpJyxcbiAgICAgIH19XG4gICAgLz5cbiAgKTtcbn1cbiJdfQ== */")
  }));
}
var cancelScroll = function cancelScroll2(event) {
  if (event.cancelable) event.preventDefault();
  event.stopPropagation();
};
function useScrollCapture(_ref3) {
  var isEnabled = _ref3.isEnabled, onBottomArrive = _ref3.onBottomArrive, onBottomLeave = _ref3.onBottomLeave, onTopArrive = _ref3.onTopArrive, onTopLeave = _ref3.onTopLeave;
  var isBottom = useRef(false);
  var isTop = useRef(false);
  var touchStart = useRef(0);
  var scrollTarget = useRef(null);
  var handleEventDelta = useCallback(function(event, delta) {
    if (scrollTarget.current === null) return;
    var _scrollTarget$current = scrollTarget.current, scrollTop = _scrollTarget$current.scrollTop, scrollHeight = _scrollTarget$current.scrollHeight, clientHeight = _scrollTarget$current.clientHeight;
    var target = scrollTarget.current;
    var isDeltaPositive = delta > 0;
    var availableScroll = scrollHeight - clientHeight - scrollTop;
    var shouldCancelScroll = false;
    if (availableScroll > delta && isBottom.current) {
      if (onBottomLeave) onBottomLeave(event);
      isBottom.current = false;
    }
    if (isDeltaPositive && isTop.current) {
      if (onTopLeave) onTopLeave(event);
      isTop.current = false;
    }
    if (isDeltaPositive && delta > availableScroll) {
      if (onBottomArrive && !isBottom.current) {
        onBottomArrive(event);
      }
      target.scrollTop = scrollHeight;
      shouldCancelScroll = true;
      isBottom.current = true;
    } else if (!isDeltaPositive && -delta > scrollTop) {
      if (onTopArrive && !isTop.current) {
        onTopArrive(event);
      }
      target.scrollTop = 0;
      shouldCancelScroll = true;
      isTop.current = true;
    }
    if (shouldCancelScroll) {
      cancelScroll(event);
    }
  }, [onBottomArrive, onBottomLeave, onTopArrive, onTopLeave]);
  var onWheel = useCallback(function(event) {
    handleEventDelta(event, event.deltaY);
  }, [handleEventDelta]);
  var onTouchStart = useCallback(function(event) {
    touchStart.current = event.changedTouches[0].clientY;
  }, []);
  var onTouchMove = useCallback(function(event) {
    var deltaY = touchStart.current - event.changedTouches[0].clientY;
    handleEventDelta(event, deltaY);
  }, [handleEventDelta]);
  var startListening = useCallback(function(el) {
    if (!el) return;
    var notPassive = supportsPassiveEvents ? {
      passive: false
    } : false;
    el.addEventListener("wheel", onWheel, notPassive);
    el.addEventListener("touchstart", onTouchStart, notPassive);
    el.addEventListener("touchmove", onTouchMove, notPassive);
  }, [onTouchMove, onTouchStart, onWheel]);
  var stopListening = useCallback(function(el) {
    if (!el) return;
    el.removeEventListener("wheel", onWheel, false);
    el.removeEventListener("touchstart", onTouchStart, false);
    el.removeEventListener("touchmove", onTouchMove, false);
  }, [onTouchMove, onTouchStart, onWheel]);
  useEffect(function() {
    if (!isEnabled) return;
    var element = scrollTarget.current;
    startListening(element);
    return function() {
      stopListening(element);
    };
  }, [isEnabled, startListening, stopListening]);
  return function(element) {
    scrollTarget.current = element;
  };
}
var STYLE_KEYS = ["boxSizing", "height", "overflow", "paddingRight", "position"];
var LOCK_STYLES = {
  boxSizing: "border-box",
  // account for possible declaration `width: 100%;` on body
  overflow: "hidden",
  position: "relative",
  height: "100%"
};
function preventTouchMove(e3) {
  if (e3.cancelable) e3.preventDefault();
}
function allowTouchMove(e3) {
  e3.stopPropagation();
}
function preventInertiaScroll() {
  var top2 = this.scrollTop;
  var totalScroll = this.scrollHeight;
  var currentScroll = top2 + this.offsetHeight;
  if (top2 === 0) {
    this.scrollTop = 1;
  } else if (currentScroll === totalScroll) {
    this.scrollTop = top2 - 1;
  }
}
function isTouchDevice() {
  return "ontouchstart" in window || navigator.maxTouchPoints;
}
var canUseDOM$1 = !!(typeof window !== "undefined" && window.document && window.document.createElement);
var activeScrollLocks = 0;
var listenerOptions = {
  capture: false,
  passive: false
};
function useScrollLock(_ref3) {
  var isEnabled = _ref3.isEnabled, _ref$accountForScroll = _ref3.accountForScrollbars, accountForScrollbars = _ref$accountForScroll === void 0 ? true : _ref$accountForScroll;
  var originalStyles = useRef({});
  var scrollTarget = useRef(null);
  var addScrollLock = useCallback(function(touchScrollTarget) {
    if (!canUseDOM$1) return;
    var target = document.body;
    var targetStyle = target && target.style;
    if (accountForScrollbars) {
      STYLE_KEYS.forEach(function(key) {
        var val = targetStyle && targetStyle[key];
        originalStyles.current[key] = val;
      });
    }
    if (accountForScrollbars && activeScrollLocks < 1) {
      var currentPadding = parseInt(originalStyles.current.paddingRight, 10) || 0;
      var clientWidth = document.body ? document.body.clientWidth : 0;
      var adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;
      Object.keys(LOCK_STYLES).forEach(function(key) {
        var val = LOCK_STYLES[key];
        if (targetStyle) {
          targetStyle[key] = val;
        }
      });
      if (targetStyle) {
        targetStyle.paddingRight = "".concat(adjustedPadding, "px");
      }
    }
    if (target && isTouchDevice()) {
      target.addEventListener("touchmove", preventTouchMove, listenerOptions);
      if (touchScrollTarget) {
        touchScrollTarget.addEventListener("touchstart", preventInertiaScroll, listenerOptions);
        touchScrollTarget.addEventListener("touchmove", allowTouchMove, listenerOptions);
      }
    }
    activeScrollLocks += 1;
  }, [accountForScrollbars]);
  var removeScrollLock = useCallback(function(touchScrollTarget) {
    if (!canUseDOM$1) return;
    var target = document.body;
    var targetStyle = target && target.style;
    activeScrollLocks = Math.max(activeScrollLocks - 1, 0);
    if (accountForScrollbars && activeScrollLocks < 1) {
      STYLE_KEYS.forEach(function(key) {
        var val = originalStyles.current[key];
        if (targetStyle) {
          targetStyle[key] = val;
        }
      });
    }
    if (target && isTouchDevice()) {
      target.removeEventListener("touchmove", preventTouchMove, listenerOptions);
      if (touchScrollTarget) {
        touchScrollTarget.removeEventListener("touchstart", preventInertiaScroll, listenerOptions);
        touchScrollTarget.removeEventListener("touchmove", allowTouchMove, listenerOptions);
      }
    }
  }, [accountForScrollbars]);
  useEffect(function() {
    if (!isEnabled) return;
    var element = scrollTarget.current;
    addScrollLock(element);
    return function() {
      removeScrollLock(element);
    };
  }, [isEnabled, addScrollLock, removeScrollLock]);
  return function(element) {
    scrollTarget.current = element;
  };
}
function _EMOTION_STRINGIFIED_CSS_ERROR__$1() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var blurSelectInput = function blurSelectInput2(event) {
  var element = event.target;
  return element.ownerDocument.activeElement && element.ownerDocument.activeElement.blur();
};
var _ref2$1 = process.env.NODE_ENV === "production" ? {
  name: "1kfdb0e",
  styles: "position:fixed;left:0;bottom:0;right:0;top:0"
} : {
  name: "bp8cua-ScrollManager",
  styles: "position:fixed;left:0;bottom:0;right:0;top:0;label:ScrollManager;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$1
};
function ScrollManager(_ref3) {
  var children = _ref3.children, lockEnabled = _ref3.lockEnabled, _ref$captureEnabled = _ref3.captureEnabled, captureEnabled = _ref$captureEnabled === void 0 ? true : _ref$captureEnabled, onBottomArrive = _ref3.onBottomArrive, onBottomLeave = _ref3.onBottomLeave, onTopArrive = _ref3.onTopArrive, onTopLeave = _ref3.onTopLeave;
  var setScrollCaptureTarget = useScrollCapture({
    isEnabled: captureEnabled,
    onBottomArrive,
    onBottomLeave,
    onTopArrive,
    onTopLeave
  });
  var setScrollLockTarget = useScrollLock({
    isEnabled: lockEnabled
  });
  var targetRef = function targetRef2(element) {
    setScrollCaptureTarget(element);
    setScrollLockTarget(element);
  };
  return jsx(Fragment, null, lockEnabled && jsx("div", {
    onClick: blurSelectInput,
    css: _ref2$1
  }), children(targetRef));
}
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var _ref2 = process.env.NODE_ENV === "production" ? {
  name: "1a0ro4n-requiredInput",
  styles: "label:requiredInput;opacity:0;pointer-events:none;position:absolute;bottom:0;left:0;right:0;width:100%"
} : {
  name: "5kkxb2-requiredInput-RequiredInput",
  styles: "label:requiredInput;opacity:0;pointer-events:none;position:absolute;bottom:0;left:0;right:0;width:100%;label:RequiredInput;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlJlcXVpcmVkSW5wdXQudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQWNJIiwiZmlsZSI6IlJlcXVpcmVkSW5wdXQudHN4Iiwic291cmNlc0NvbnRlbnQiOlsiLyoqIEBqc3gganN4ICovXG5pbXBvcnQgeyBGb2N1c0V2ZW50SGFuZGxlciwgRnVuY3Rpb25Db21wb25lbnQgfSBmcm9tICdyZWFjdCc7XG5pbXBvcnQgeyBqc3ggfSBmcm9tICdAZW1vdGlvbi9yZWFjdCc7XG5cbmNvbnN0IFJlcXVpcmVkSW5wdXQ6IEZ1bmN0aW9uQ29tcG9uZW50PHtcbiAgcmVhZG9ubHkgbmFtZT86IHN0cmluZztcbiAgcmVhZG9ubHkgb25Gb2N1czogRm9jdXNFdmVudEhhbmRsZXI8SFRNTElucHV0RWxlbWVudD47XG59PiA9ICh7IG5hbWUsIG9uRm9jdXMgfSkgPT4gKFxuICA8aW5wdXRcbiAgICByZXF1aXJlZFxuICAgIG5hbWU9e25hbWV9XG4gICAgdGFiSW5kZXg9ey0xfVxuICAgIGFyaWEtaGlkZGVuPVwidHJ1ZVwiXG4gICAgb25Gb2N1cz17b25Gb2N1c31cbiAgICBjc3M9e3tcbiAgICAgIGxhYmVsOiAncmVxdWlyZWRJbnB1dCcsXG4gICAgICBvcGFjaXR5OiAwLFxuICAgICAgcG9pbnRlckV2ZW50czogJ25vbmUnLFxuICAgICAgcG9zaXRpb246ICdhYnNvbHV0ZScsXG4gICAgICBib3R0b206IDAsXG4gICAgICBsZWZ0OiAwLFxuICAgICAgcmlnaHQ6IDAsXG4gICAgICB3aWR0aDogJzEwMCUnLFxuICAgIH19XG4gICAgLy8gUHJldmVudCBgU3dpdGNoaW5nIGZyb20gdW5jb250cm9sbGVkIHRvIGNvbnRyb2xsZWRgIGVycm9yXG4gICAgdmFsdWU9XCJcIlxuICAgIG9uQ2hhbmdlPXsoKSA9PiB7fX1cbiAgLz5cbik7XG5cbmV4cG9ydCBkZWZhdWx0IFJlcXVpcmVkSW5wdXQ7XG4iXX0= */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
var RequiredInput = function RequiredInput2(_ref3) {
  var name = _ref3.name, onFocus2 = _ref3.onFocus;
  return jsx("input", {
    required: true,
    name,
    tabIndex: -1,
    "aria-hidden": "true",
    onFocus: onFocus2,
    css: _ref2,
    value: "",
    onChange: function onChange2() {
    }
  });
};
var RequiredInput$1 = RequiredInput;
function testPlatform(re) {
  var _window$navigator$use;
  return typeof window !== "undefined" && window.navigator != null ? re.test(((_window$navigator$use = window.navigator["userAgentData"]) === null || _window$navigator$use === void 0 ? void 0 : _window$navigator$use.platform) || window.navigator.platform) : false;
}
function isIPhone() {
  return testPlatform(/^iPhone/i);
}
function isMac() {
  return testPlatform(/^Mac/i);
}
function isIPad() {
  return testPlatform(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
  isMac() && navigator.maxTouchPoints > 1;
}
function isIOS() {
  return isIPhone() || isIPad();
}
function isAppleDevice() {
  return isMac() || isIOS();
}
var formatGroupLabel = function formatGroupLabel2(group) {
  return group.label;
};
var getOptionLabel$1 = function getOptionLabel(option) {
  return option.label;
};
var getOptionValue$1 = function getOptionValue(option) {
  return option.value;
};
var isOptionDisabled = function isOptionDisabled2(option) {
  return !!option.isDisabled;
};
var defaultStyles = {
  clearIndicator: clearIndicatorCSS,
  container: containerCSS,
  control: css$1,
  dropdownIndicator: dropdownIndicatorCSS,
  group: groupCSS,
  groupHeading: groupHeadingCSS,
  indicatorsContainer: indicatorsContainerCSS,
  indicatorSeparator: indicatorSeparatorCSS,
  input: inputCSS,
  loadingIndicator: loadingIndicatorCSS,
  loadingMessage: loadingMessageCSS,
  menu: menuCSS,
  menuList: menuListCSS,
  menuPortal: menuPortalCSS,
  multiValue: multiValueCSS,
  multiValueLabel: multiValueLabelCSS,
  multiValueRemove: multiValueRemoveCSS,
  noOptionsMessage: noOptionsMessageCSS,
  option: optionCSS,
  placeholder: placeholderCSS,
  singleValue: css2,
  valueContainer: valueContainerCSS
};
var colors = {
  primary: "#2684FF",
  primary75: "#4C9AFF",
  primary50: "#B2D4FF",
  primary25: "#DEEBFF",
  danger: "#DE350B",
  dangerLight: "#FFBDAD",
  neutral0: "hsl(0, 0%, 100%)",
  neutral5: "hsl(0, 0%, 95%)",
  neutral10: "hsl(0, 0%, 90%)",
  neutral20: "hsl(0, 0%, 80%)",
  neutral30: "hsl(0, 0%, 70%)",
  neutral40: "hsl(0, 0%, 60%)",
  neutral50: "hsl(0, 0%, 50%)",
  neutral60: "hsl(0, 0%, 40%)",
  neutral70: "hsl(0, 0%, 30%)",
  neutral80: "hsl(0, 0%, 20%)",
  neutral90: "hsl(0, 0%, 10%)"
};
var borderRadius = 4;
var baseUnit = 4;
var controlHeight = 38;
var menuGutter = baseUnit * 2;
var spacing = {
  baseUnit,
  controlHeight,
  menuGutter
};
var defaultTheme = {
  borderRadius,
  colors,
  spacing
};
var defaultProps = {
  "aria-live": "polite",
  backspaceRemovesValue: true,
  blurInputOnSelect: isTouchCapable(),
  captureMenuScroll: !isTouchCapable(),
  classNames: {},
  closeMenuOnSelect: true,
  closeMenuOnScroll: false,
  components: {},
  controlShouldRenderValue: true,
  escapeClearsValue: false,
  filterOption: createFilter(),
  formatGroupLabel,
  getOptionLabel: getOptionLabel$1,
  getOptionValue: getOptionValue$1,
  isDisabled: false,
  isLoading: false,
  isMulti: false,
  isRtl: false,
  isSearchable: true,
  isOptionDisabled,
  loadingMessage: function loadingMessage() {
    return "Loading...";
  },
  maxMenuHeight: 300,
  minMenuHeight: 140,
  menuIsOpen: false,
  menuPlacement: "bottom",
  menuPosition: "absolute",
  menuShouldBlockScroll: false,
  menuShouldScrollIntoView: !isMobileDevice(),
  noOptionsMessage: function noOptionsMessage() {
    return "No options";
  },
  openMenuOnFocus: false,
  openMenuOnClick: true,
  options: [],
  pageSize: 5,
  placeholder: "Select...",
  screenReaderStatus: function screenReaderStatus(_ref3) {
    var count2 = _ref3.count;
    return "".concat(count2, " result").concat(count2 !== 1 ? "s" : "", " available");
  },
  styles: {},
  tabIndex: 0,
  tabSelectsValue: true,
  unstyled: false
};
function toCategorizedOption(props, option, selectValue, index2) {
  var isDisabled = _isOptionDisabled(props, option, selectValue);
  var isSelected = _isOptionSelected(props, option, selectValue);
  var label = getOptionLabel2(props, option);
  var value = getOptionValue2(props, option);
  return {
    type: "option",
    data: option,
    isDisabled,
    isSelected,
    label,
    value,
    index: index2
  };
}
function buildCategorizedOptions(props, selectValue) {
  return props.options.map(function(groupOrOption, groupOrOptionIndex) {
    if ("options" in groupOrOption) {
      var categorizedOptions = groupOrOption.options.map(function(option, optionIndex) {
        return toCategorizedOption(props, option, selectValue, optionIndex);
      }).filter(function(categorizedOption2) {
        return isFocusable(props, categorizedOption2);
      });
      return categorizedOptions.length > 0 ? {
        type: "group",
        data: groupOrOption,
        options: categorizedOptions,
        index: groupOrOptionIndex
      } : void 0;
    }
    var categorizedOption = toCategorizedOption(props, groupOrOption, selectValue, groupOrOptionIndex);
    return isFocusable(props, categorizedOption) ? categorizedOption : void 0;
  }).filter(notNullish);
}
function buildFocusableOptionsFromCategorizedOptions(categorizedOptions) {
  return categorizedOptions.reduce(function(optionsAccumulator, categorizedOption) {
    if (categorizedOption.type === "group") {
      optionsAccumulator.push.apply(optionsAccumulator, _toConsumableArray(categorizedOption.options.map(function(option) {
        return option.data;
      })));
    } else {
      optionsAccumulator.push(categorizedOption.data);
    }
    return optionsAccumulator;
  }, []);
}
function buildFocusableOptionsWithIds(categorizedOptions, optionId) {
  return categorizedOptions.reduce(function(optionsAccumulator, categorizedOption) {
    if (categorizedOption.type === "group") {
      optionsAccumulator.push.apply(optionsAccumulator, _toConsumableArray(categorizedOption.options.map(function(option) {
        return {
          data: option.data,
          id: "".concat(optionId, "-").concat(categorizedOption.index, "-").concat(option.index)
        };
      })));
    } else {
      optionsAccumulator.push({
        data: categorizedOption.data,
        id: "".concat(optionId, "-").concat(categorizedOption.index)
      });
    }
    return optionsAccumulator;
  }, []);
}
function buildFocusableOptions(props, selectValue) {
  return buildFocusableOptionsFromCategorizedOptions(buildCategorizedOptions(props, selectValue));
}
function isFocusable(props, categorizedOption) {
  var _props$inputValue = props.inputValue, inputValue = _props$inputValue === void 0 ? "" : _props$inputValue;
  var data = categorizedOption.data, isSelected = categorizedOption.isSelected, label = categorizedOption.label, value = categorizedOption.value;
  return (!shouldHideSelectedOptions(props) || !isSelected) && _filterOption(props, {
    label,
    value,
    data
  }, inputValue);
}
function getNextFocusedValue(state, nextSelectValue) {
  var focusedValue = state.focusedValue, lastSelectValue = state.selectValue;
  var lastFocusedIndex = lastSelectValue.indexOf(focusedValue);
  if (lastFocusedIndex > -1) {
    var nextFocusedIndex = nextSelectValue.indexOf(focusedValue);
    if (nextFocusedIndex > -1) {
      return focusedValue;
    } else if (lastFocusedIndex < nextSelectValue.length) {
      return nextSelectValue[lastFocusedIndex];
    }
  }
  return null;
}
function getNextFocusedOption(state, options2) {
  var lastFocusedOption = state.focusedOption;
  return lastFocusedOption && options2.indexOf(lastFocusedOption) > -1 ? lastFocusedOption : options2[0];
}
var getFocusedOptionId = function getFocusedOptionId2(focusableOptionsWithIds, focusedOption) {
  var _focusableOptionsWith;
  var focusedOptionId = (_focusableOptionsWith = focusableOptionsWithIds.find(function(option) {
    return option.data === focusedOption;
  })) === null || _focusableOptionsWith === void 0 ? void 0 : _focusableOptionsWith.id;
  return focusedOptionId || null;
};
var getOptionLabel2 = function getOptionLabel3(props, data) {
  return props.getOptionLabel(data);
};
var getOptionValue2 = function getOptionValue3(props, data) {
  return props.getOptionValue(data);
};
function _isOptionDisabled(props, option, selectValue) {
  return typeof props.isOptionDisabled === "function" ? props.isOptionDisabled(option, selectValue) : false;
}
function _isOptionSelected(props, option, selectValue) {
  if (selectValue.indexOf(option) > -1) return true;
  if (typeof props.isOptionSelected === "function") {
    return props.isOptionSelected(option, selectValue);
  }
  var candidate = getOptionValue2(props, option);
  return selectValue.some(function(i) {
    return getOptionValue2(props, i) === candidate;
  });
}
function _filterOption(props, option, inputValue) {
  return props.filterOption ? props.filterOption(option, inputValue) : true;
}
var shouldHideSelectedOptions = function shouldHideSelectedOptions2(props) {
  var hideSelectedOptions = props.hideSelectedOptions, isMulti = props.isMulti;
  if (hideSelectedOptions === void 0) return isMulti;
  return hideSelectedOptions;
};
var instanceId = 1;
var Select = /* @__PURE__ */ function(_Component) {
  _inherits$2(Select2, _Component);
  var _super = _createSuper(Select2);
  function Select2(_props) {
    var _this;
    _classCallCheck$2(this, Select2);
    _this = _super.call(this, _props);
    _this.state = {
      ariaSelection: null,
      focusedOption: null,
      focusedOptionId: null,
      focusableOptionsWithIds: [],
      focusedValue: null,
      inputIsHidden: false,
      isFocused: false,
      selectValue: [],
      clearFocusValueOnUpdate: false,
      prevWasFocused: false,
      inputIsHiddenAfterUpdate: void 0,
      prevProps: void 0,
      instancePrefix: ""
    };
    _this.blockOptionHover = false;
    _this.isComposing = false;
    _this.commonProps = void 0;
    _this.initialTouchX = 0;
    _this.initialTouchY = 0;
    _this.openAfterFocus = false;
    _this.scrollToFocusedOptionOnUpdate = false;
    _this.userIsDragging = void 0;
    _this.isAppleDevice = isAppleDevice();
    _this.controlRef = null;
    _this.getControlRef = function(ref2) {
      _this.controlRef = ref2;
    };
    _this.focusedOptionRef = null;
    _this.getFocusedOptionRef = function(ref2) {
      _this.focusedOptionRef = ref2;
    };
    _this.menuListRef = null;
    _this.getMenuListRef = function(ref2) {
      _this.menuListRef = ref2;
    };
    _this.inputRef = null;
    _this.getInputRef = function(ref2) {
      _this.inputRef = ref2;
    };
    _this.focus = _this.focusInput;
    _this.blur = _this.blurInput;
    _this.onChange = function(newValue, actionMeta) {
      var _this$props = _this.props, onChange2 = _this$props.onChange, name = _this$props.name;
      actionMeta.name = name;
      _this.ariaOnChange(newValue, actionMeta);
      onChange2(newValue, actionMeta);
    };
    _this.setValue = function(newValue, action, option) {
      var _this$props2 = _this.props, closeMenuOnSelect = _this$props2.closeMenuOnSelect, isMulti = _this$props2.isMulti, inputValue = _this$props2.inputValue;
      _this.onInputChange("", {
        action: "set-value",
        prevInputValue: inputValue
      });
      if (closeMenuOnSelect) {
        _this.setState({
          inputIsHiddenAfterUpdate: !isMulti
        });
        _this.onMenuClose();
      }
      _this.setState({
        clearFocusValueOnUpdate: true
      });
      _this.onChange(newValue, {
        action,
        option
      });
    };
    _this.selectOption = function(newValue) {
      var _this$props3 = _this.props, blurInputOnSelect = _this$props3.blurInputOnSelect, isMulti = _this$props3.isMulti, name = _this$props3.name;
      var selectValue = _this.state.selectValue;
      var deselected = isMulti && _this.isOptionSelected(newValue, selectValue);
      var isDisabled = _this.isOptionDisabled(newValue, selectValue);
      if (deselected) {
        var candidate = _this.getOptionValue(newValue);
        _this.setValue(multiValueAsValue(selectValue.filter(function(i) {
          return _this.getOptionValue(i) !== candidate;
        })), "deselect-option", newValue);
      } else if (!isDisabled) {
        if (isMulti) {
          _this.setValue(multiValueAsValue([].concat(_toConsumableArray(selectValue), [newValue])), "select-option", newValue);
        } else {
          _this.setValue(singleValueAsValue(newValue), "select-option");
        }
      } else {
        _this.ariaOnChange(singleValueAsValue(newValue), {
          action: "select-option",
          option: newValue,
          name
        });
        return;
      }
      if (blurInputOnSelect) {
        _this.blurInput();
      }
    };
    _this.removeValue = function(removedValue) {
      var isMulti = _this.props.isMulti;
      var selectValue = _this.state.selectValue;
      var candidate = _this.getOptionValue(removedValue);
      var newValueArray = selectValue.filter(function(i) {
        return _this.getOptionValue(i) !== candidate;
      });
      var newValue = valueTernary(isMulti, newValueArray, newValueArray[0] || null);
      _this.onChange(newValue, {
        action: "remove-value",
        removedValue
      });
      _this.focusInput();
    };
    _this.clearValue = function() {
      var selectValue = _this.state.selectValue;
      _this.onChange(valueTernary(_this.props.isMulti, [], null), {
        action: "clear",
        removedValues: selectValue
      });
    };
    _this.popValue = function() {
      var isMulti = _this.props.isMulti;
      var selectValue = _this.state.selectValue;
      var lastSelectedValue = selectValue[selectValue.length - 1];
      var newValueArray = selectValue.slice(0, selectValue.length - 1);
      var newValue = valueTernary(isMulti, newValueArray, newValueArray[0] || null);
      if (lastSelectedValue) {
        _this.onChange(newValue, {
          action: "pop-value",
          removedValue: lastSelectedValue
        });
      }
    };
    _this.getFocusedOptionId = function(focusedOption) {
      return getFocusedOptionId(_this.state.focusableOptionsWithIds, focusedOption);
    };
    _this.getFocusableOptionsWithIds = function() {
      return buildFocusableOptionsWithIds(buildCategorizedOptions(_this.props, _this.state.selectValue), _this.getElementId("option"));
    };
    _this.getValue = function() {
      return _this.state.selectValue;
    };
    _this.cx = function() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      return classNames.apply(void 0, [_this.props.classNamePrefix].concat(args));
    };
    _this.getOptionLabel = function(data) {
      return getOptionLabel2(_this.props, data);
    };
    _this.getOptionValue = function(data) {
      return getOptionValue2(_this.props, data);
    };
    _this.getStyles = function(key, props) {
      var unstyled = _this.props.unstyled;
      var base = defaultStyles[key](props, unstyled);
      base.boxSizing = "border-box";
      var custom = _this.props.styles[key];
      return custom ? custom(base, props) : base;
    };
    _this.getClassNames = function(key, props) {
      var _this$props$className, _this$props$className2;
      return (_this$props$className = (_this$props$className2 = _this.props.classNames)[key]) === null || _this$props$className === void 0 ? void 0 : _this$props$className.call(_this$props$className2, props);
    };
    _this.getElementId = function(element) {
      return "".concat(_this.state.instancePrefix, "-").concat(element);
    };
    _this.getComponents = function() {
      return defaultComponents(_this.props);
    };
    _this.buildCategorizedOptions = function() {
      return buildCategorizedOptions(_this.props, _this.state.selectValue);
    };
    _this.getCategorizedOptions = function() {
      return _this.props.menuIsOpen ? _this.buildCategorizedOptions() : [];
    };
    _this.buildFocusableOptions = function() {
      return buildFocusableOptionsFromCategorizedOptions(_this.buildCategorizedOptions());
    };
    _this.getFocusableOptions = function() {
      return _this.props.menuIsOpen ? _this.buildFocusableOptions() : [];
    };
    _this.ariaOnChange = function(value, actionMeta) {
      _this.setState({
        ariaSelection: _objectSpread2({
          value
        }, actionMeta)
      });
    };
    _this.onMenuMouseDown = function(event) {
      if (event.button !== 0) {
        return;
      }
      event.stopPropagation();
      event.preventDefault();
      _this.focusInput();
    };
    _this.onMenuMouseMove = function(event) {
      _this.blockOptionHover = false;
    };
    _this.onControlMouseDown = function(event) {
      if (event.defaultPrevented) {
        return;
      }
      var openMenuOnClick = _this.props.openMenuOnClick;
      if (!_this.state.isFocused) {
        if (openMenuOnClick) {
          _this.openAfterFocus = true;
        }
        _this.focusInput();
      } else if (!_this.props.menuIsOpen) {
        if (openMenuOnClick) {
          _this.openMenu("first");
        }
      } else {
        if (event.target.tagName !== "INPUT" && event.target.tagName !== "TEXTAREA") {
          _this.onMenuClose();
        }
      }
      if (event.target.tagName !== "INPUT" && event.target.tagName !== "TEXTAREA") {
        event.preventDefault();
      }
    };
    _this.onDropdownIndicatorMouseDown = function(event) {
      if (event && event.type === "mousedown" && event.button !== 0) {
        return;
      }
      if (_this.props.isDisabled) return;
      var _this$props4 = _this.props, isMulti = _this$props4.isMulti, menuIsOpen = _this$props4.menuIsOpen;
      _this.focusInput();
      if (menuIsOpen) {
        _this.setState({
          inputIsHiddenAfterUpdate: !isMulti
        });
        _this.onMenuClose();
      } else {
        _this.openMenu("first");
      }
      event.preventDefault();
    };
    _this.onClearIndicatorMouseDown = function(event) {
      if (event && event.type === "mousedown" && event.button !== 0) {
        return;
      }
      _this.clearValue();
      event.preventDefault();
      _this.openAfterFocus = false;
      if (event.type === "touchend") {
        _this.focusInput();
      } else {
        setTimeout(function() {
          return _this.focusInput();
        });
      }
    };
    _this.onScroll = function(event) {
      if (typeof _this.props.closeMenuOnScroll === "boolean") {
        if (event.target instanceof HTMLElement && isDocumentElement(event.target)) {
          _this.props.onMenuClose();
        }
      } else if (typeof _this.props.closeMenuOnScroll === "function") {
        if (_this.props.closeMenuOnScroll(event)) {
          _this.props.onMenuClose();
        }
      }
    };
    _this.onCompositionStart = function() {
      _this.isComposing = true;
    };
    _this.onCompositionEnd = function() {
      _this.isComposing = false;
    };
    _this.onTouchStart = function(_ref22) {
      var touches = _ref22.touches;
      var touch = touches && touches.item(0);
      if (!touch) {
        return;
      }
      _this.initialTouchX = touch.clientX;
      _this.initialTouchY = touch.clientY;
      _this.userIsDragging = false;
    };
    _this.onTouchMove = function(_ref3) {
      var touches = _ref3.touches;
      var touch = touches && touches.item(0);
      if (!touch) {
        return;
      }
      var deltaX = Math.abs(touch.clientX - _this.initialTouchX);
      var deltaY = Math.abs(touch.clientY - _this.initialTouchY);
      var moveThreshold = 5;
      _this.userIsDragging = deltaX > moveThreshold || deltaY > moveThreshold;
    };
    _this.onTouchEnd = function(event) {
      if (_this.userIsDragging) return;
      if (_this.controlRef && !_this.controlRef.contains(event.target) && _this.menuListRef && !_this.menuListRef.contains(event.target)) {
        _this.blurInput();
      }
      _this.initialTouchX = 0;
      _this.initialTouchY = 0;
    };
    _this.onControlTouchEnd = function(event) {
      if (_this.userIsDragging) return;
      _this.onControlMouseDown(event);
    };
    _this.onClearIndicatorTouchEnd = function(event) {
      if (_this.userIsDragging) return;
      _this.onClearIndicatorMouseDown(event);
    };
    _this.onDropdownIndicatorTouchEnd = function(event) {
      if (_this.userIsDragging) return;
      _this.onDropdownIndicatorMouseDown(event);
    };
    _this.handleInputChange = function(event) {
      var prevInputValue = _this.props.inputValue;
      var inputValue = event.currentTarget.value;
      _this.setState({
        inputIsHiddenAfterUpdate: false
      });
      _this.onInputChange(inputValue, {
        action: "input-change",
        prevInputValue
      });
      if (!_this.props.menuIsOpen) {
        _this.onMenuOpen();
      }
    };
    _this.onInputFocus = function(event) {
      if (_this.props.onFocus) {
        _this.props.onFocus(event);
      }
      _this.setState({
        inputIsHiddenAfterUpdate: false,
        isFocused: true
      });
      if (_this.openAfterFocus || _this.props.openMenuOnFocus) {
        _this.openMenu("first");
      }
      _this.openAfterFocus = false;
    };
    _this.onInputBlur = function(event) {
      var prevInputValue = _this.props.inputValue;
      if (_this.menuListRef && _this.menuListRef.contains(document.activeElement)) {
        _this.inputRef.focus();
        return;
      }
      if (_this.props.onBlur) {
        _this.props.onBlur(event);
      }
      _this.onInputChange("", {
        action: "input-blur",
        prevInputValue
      });
      _this.onMenuClose();
      _this.setState({
        focusedValue: null,
        isFocused: false
      });
    };
    _this.onOptionHover = function(focusedOption) {
      if (_this.blockOptionHover || _this.state.focusedOption === focusedOption) {
        return;
      }
      var options2 = _this.getFocusableOptions();
      var focusedOptionIndex = options2.indexOf(focusedOption);
      _this.setState({
        focusedOption,
        focusedOptionId: focusedOptionIndex > -1 ? _this.getFocusedOptionId(focusedOption) : null
      });
    };
    _this.shouldHideSelectedOptions = function() {
      return shouldHideSelectedOptions(_this.props);
    };
    _this.onValueInputFocus = function(e3) {
      e3.preventDefault();
      e3.stopPropagation();
      _this.focus();
    };
    _this.onKeyDown = function(event) {
      var _this$props5 = _this.props, isMulti = _this$props5.isMulti, backspaceRemovesValue = _this$props5.backspaceRemovesValue, escapeClearsValue = _this$props5.escapeClearsValue, inputValue = _this$props5.inputValue, isClearable = _this$props5.isClearable, isDisabled = _this$props5.isDisabled, menuIsOpen = _this$props5.menuIsOpen, onKeyDown = _this$props5.onKeyDown, tabSelectsValue = _this$props5.tabSelectsValue, openMenuOnFocus = _this$props5.openMenuOnFocus;
      var _this$state = _this.state, focusedOption = _this$state.focusedOption, focusedValue = _this$state.focusedValue, selectValue = _this$state.selectValue;
      if (isDisabled) return;
      if (typeof onKeyDown === "function") {
        onKeyDown(event);
        if (event.defaultPrevented) {
          return;
        }
      }
      _this.blockOptionHover = true;
      switch (event.key) {
        case "ArrowLeft":
          if (!isMulti || inputValue) return;
          _this.focusValue("previous");
          break;
        case "ArrowRight":
          if (!isMulti || inputValue) return;
          _this.focusValue("next");
          break;
        case "Delete":
        case "Backspace":
          if (inputValue) return;
          if (focusedValue) {
            _this.removeValue(focusedValue);
          } else {
            if (!backspaceRemovesValue) return;
            if (isMulti) {
              _this.popValue();
            } else if (isClearable) {
              _this.clearValue();
            }
          }
          break;
        case "Tab":
          if (_this.isComposing) return;
          if (event.shiftKey || !menuIsOpen || !tabSelectsValue || !focusedOption || // don't capture the event if the menu opens on focus and the focused
          // option is already selected; it breaks the flow of navigation
          openMenuOnFocus && _this.isOptionSelected(focusedOption, selectValue)) {
            return;
          }
          _this.selectOption(focusedOption);
          break;
        case "Enter":
          if (event.keyCode === 229) {
            break;
          }
          if (menuIsOpen) {
            if (!focusedOption) return;
            if (_this.isComposing) return;
            _this.selectOption(focusedOption);
            break;
          }
          return;
        case "Escape":
          if (menuIsOpen) {
            _this.setState({
              inputIsHiddenAfterUpdate: false
            });
            _this.onInputChange("", {
              action: "menu-close",
              prevInputValue: inputValue
            });
            _this.onMenuClose();
          } else if (isClearable && escapeClearsValue) {
            _this.clearValue();
          }
          break;
        case " ":
          if (inputValue) {
            return;
          }
          if (!menuIsOpen) {
            _this.openMenu("first");
            break;
          }
          if (!focusedOption) return;
          _this.selectOption(focusedOption);
          break;
        case "ArrowUp":
          if (menuIsOpen) {
            _this.focusOption("up");
          } else {
            _this.openMenu("last");
          }
          break;
        case "ArrowDown":
          if (menuIsOpen) {
            _this.focusOption("down");
          } else {
            _this.openMenu("first");
          }
          break;
        case "PageUp":
          if (!menuIsOpen) return;
          _this.focusOption("pageup");
          break;
        case "PageDown":
          if (!menuIsOpen) return;
          _this.focusOption("pagedown");
          break;
        case "Home":
          if (!menuIsOpen) return;
          _this.focusOption("first");
          break;
        case "End":
          if (!menuIsOpen) return;
          _this.focusOption("last");
          break;
        default:
          return;
      }
      event.preventDefault();
    };
    _this.state.instancePrefix = "react-select-" + (_this.props.instanceId || ++instanceId);
    _this.state.selectValue = cleanValue(_props.value);
    if (_props.menuIsOpen && _this.state.selectValue.length) {
      var focusableOptionsWithIds = _this.getFocusableOptionsWithIds();
      var focusableOptions = _this.buildFocusableOptions();
      var optionIndex = focusableOptions.indexOf(_this.state.selectValue[0]);
      _this.state.focusableOptionsWithIds = focusableOptionsWithIds;
      _this.state.focusedOption = focusableOptions[optionIndex];
      _this.state.focusedOptionId = getFocusedOptionId(focusableOptionsWithIds, focusableOptions[optionIndex]);
    }
    return _this;
  }
  _createClass$2(Select2, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.startListeningComposition();
      this.startListeningToTouch();
      if (this.props.closeMenuOnScroll && document && document.addEventListener) {
        document.addEventListener("scroll", this.onScroll, true);
      }
      if (this.props.autoFocus) {
        this.focusInput();
      }
      if (this.props.menuIsOpen && this.state.focusedOption && this.menuListRef && this.focusedOptionRef) {
        scrollIntoView(this.menuListRef, this.focusedOptionRef);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props6 = this.props, isDisabled = _this$props6.isDisabled, menuIsOpen = _this$props6.menuIsOpen;
      var isFocused = this.state.isFocused;
      if (
        // ensure focus is restored correctly when the control becomes enabled
        isFocused && !isDisabled && prevProps.isDisabled || // ensure focus is on the Input when the menu opens
        isFocused && menuIsOpen && !prevProps.menuIsOpen
      ) {
        this.focusInput();
      }
      if (isFocused && isDisabled && !prevProps.isDisabled) {
        this.setState({
          isFocused: false
        }, this.onMenuClose);
      } else if (!isFocused && !isDisabled && prevProps.isDisabled && this.inputRef === document.activeElement) {
        this.setState({
          isFocused: true
        });
      }
      if (this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate) {
        scrollIntoView(this.menuListRef, this.focusedOptionRef);
        this.scrollToFocusedOptionOnUpdate = false;
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.stopListeningComposition();
      this.stopListeningToTouch();
      document.removeEventListener("scroll", this.onScroll, true);
    }
    // ==============================
    // Consumer Handlers
    // ==============================
  }, {
    key: "onMenuOpen",
    value: function onMenuOpen() {
      this.props.onMenuOpen();
    }
  }, {
    key: "onMenuClose",
    value: function onMenuClose() {
      this.onInputChange("", {
        action: "menu-close",
        prevInputValue: this.props.inputValue
      });
      this.props.onMenuClose();
    }
  }, {
    key: "onInputChange",
    value: function onInputChange(newValue, actionMeta) {
      this.props.onInputChange(newValue, actionMeta);
    }
    // ==============================
    // Methods
    // ==============================
  }, {
    key: "focusInput",
    value: function focusInput() {
      if (!this.inputRef) return;
      this.inputRef.focus();
    }
  }, {
    key: "blurInput",
    value: function blurInput() {
      if (!this.inputRef) return;
      this.inputRef.blur();
    }
    // aliased for consumers
  }, {
    key: "openMenu",
    value: function openMenu(focusOption) {
      var _this2 = this;
      var _this$state2 = this.state, selectValue = _this$state2.selectValue, isFocused = _this$state2.isFocused;
      var focusableOptions = this.buildFocusableOptions();
      var openAtIndex = focusOption === "first" ? 0 : focusableOptions.length - 1;
      if (!this.props.isMulti) {
        var selectedIndex = focusableOptions.indexOf(selectValue[0]);
        if (selectedIndex > -1) {
          openAtIndex = selectedIndex;
        }
      }
      this.scrollToFocusedOptionOnUpdate = !(isFocused && this.menuListRef);
      this.setState({
        inputIsHiddenAfterUpdate: false,
        focusedValue: null,
        focusedOption: focusableOptions[openAtIndex],
        focusedOptionId: this.getFocusedOptionId(focusableOptions[openAtIndex])
      }, function() {
        return _this2.onMenuOpen();
      });
    }
  }, {
    key: "focusValue",
    value: function focusValue(direction) {
      var _this$state3 = this.state, selectValue = _this$state3.selectValue, focusedValue = _this$state3.focusedValue;
      if (!this.props.isMulti) return;
      this.setState({
        focusedOption: null
      });
      var focusedIndex = selectValue.indexOf(focusedValue);
      if (!focusedValue) {
        focusedIndex = -1;
      }
      var lastIndex = selectValue.length - 1;
      var nextFocus = -1;
      if (!selectValue.length) return;
      switch (direction) {
        case "previous":
          if (focusedIndex === 0) {
            nextFocus = 0;
          } else if (focusedIndex === -1) {
            nextFocus = lastIndex;
          } else {
            nextFocus = focusedIndex - 1;
          }
          break;
        case "next":
          if (focusedIndex > -1 && focusedIndex < lastIndex) {
            nextFocus = focusedIndex + 1;
          }
          break;
      }
      this.setState({
        inputIsHidden: nextFocus !== -1,
        focusedValue: selectValue[nextFocus]
      });
    }
  }, {
    key: "focusOption",
    value: function focusOption() {
      var direction = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "first";
      var pageSize = this.props.pageSize;
      var focusedOption = this.state.focusedOption;
      var options2 = this.getFocusableOptions();
      if (!options2.length) return;
      var nextFocus = 0;
      var focusedIndex = options2.indexOf(focusedOption);
      if (!focusedOption) {
        focusedIndex = -1;
      }
      if (direction === "up") {
        nextFocus = focusedIndex > 0 ? focusedIndex - 1 : options2.length - 1;
      } else if (direction === "down") {
        nextFocus = (focusedIndex + 1) % options2.length;
      } else if (direction === "pageup") {
        nextFocus = focusedIndex - pageSize;
        if (nextFocus < 0) nextFocus = 0;
      } else if (direction === "pagedown") {
        nextFocus = focusedIndex + pageSize;
        if (nextFocus > options2.length - 1) nextFocus = options2.length - 1;
      } else if (direction === "last") {
        nextFocus = options2.length - 1;
      }
      this.scrollToFocusedOptionOnUpdate = true;
      this.setState({
        focusedOption: options2[nextFocus],
        focusedValue: null,
        focusedOptionId: this.getFocusedOptionId(options2[nextFocus])
      });
    }
  }, {
    key: "getTheme",
    value: (
      // ==============================
      // Getters
      // ==============================
      function getTheme() {
        if (!this.props.theme) {
          return defaultTheme;
        }
        if (typeof this.props.theme === "function") {
          return this.props.theme(defaultTheme);
        }
        return _objectSpread2(_objectSpread2({}, defaultTheme), this.props.theme);
      }
    )
  }, {
    key: "getCommonProps",
    value: function getCommonProps() {
      var clearValue = this.clearValue, cx = this.cx, getStyles = this.getStyles, getClassNames = this.getClassNames, getValue2 = this.getValue, selectOption = this.selectOption, setValue = this.setValue, props = this.props;
      var isMulti = props.isMulti, isRtl = props.isRtl, options2 = props.options;
      var hasValue = this.hasValue();
      return {
        clearValue,
        cx,
        getStyles,
        getClassNames,
        getValue: getValue2,
        hasValue,
        isMulti,
        isRtl,
        options: options2,
        selectOption,
        selectProps: props,
        setValue,
        theme: this.getTheme()
      };
    }
  }, {
    key: "hasValue",
    value: function hasValue() {
      var selectValue = this.state.selectValue;
      return selectValue.length > 0;
    }
  }, {
    key: "hasOptions",
    value: function hasOptions() {
      return !!this.getFocusableOptions().length;
    }
  }, {
    key: "isClearable",
    value: function isClearable() {
      var _this$props7 = this.props, isClearable2 = _this$props7.isClearable, isMulti = _this$props7.isMulti;
      if (isClearable2 === void 0) return isMulti;
      return isClearable2;
    }
  }, {
    key: "isOptionDisabled",
    value: function isOptionDisabled3(option, selectValue) {
      return _isOptionDisabled(this.props, option, selectValue);
    }
  }, {
    key: "isOptionSelected",
    value: function isOptionSelected(option, selectValue) {
      return _isOptionSelected(this.props, option, selectValue);
    }
  }, {
    key: "filterOption",
    value: function filterOption(option, inputValue) {
      return _filterOption(this.props, option, inputValue);
    }
  }, {
    key: "formatOptionLabel",
    value: function formatOptionLabel(data, context) {
      if (typeof this.props.formatOptionLabel === "function") {
        var _inputValue = this.props.inputValue;
        var _selectValue = this.state.selectValue;
        return this.props.formatOptionLabel(data, {
          context,
          inputValue: _inputValue,
          selectValue: _selectValue
        });
      } else {
        return this.getOptionLabel(data);
      }
    }
  }, {
    key: "formatGroupLabel",
    value: function formatGroupLabel3(data) {
      return this.props.formatGroupLabel(data);
    }
    // ==============================
    // Mouse Handlers
    // ==============================
  }, {
    key: "startListeningComposition",
    value: (
      // ==============================
      // Composition Handlers
      // ==============================
      function startListeningComposition() {
        if (document && document.addEventListener) {
          document.addEventListener("compositionstart", this.onCompositionStart, false);
          document.addEventListener("compositionend", this.onCompositionEnd, false);
        }
      }
    )
  }, {
    key: "stopListeningComposition",
    value: function stopListeningComposition() {
      if (document && document.removeEventListener) {
        document.removeEventListener("compositionstart", this.onCompositionStart);
        document.removeEventListener("compositionend", this.onCompositionEnd);
      }
    }
  }, {
    key: "startListeningToTouch",
    value: (
      // ==============================
      // Touch Handlers
      // ==============================
      function startListeningToTouch() {
        if (document && document.addEventListener) {
          document.addEventListener("touchstart", this.onTouchStart, false);
          document.addEventListener("touchmove", this.onTouchMove, false);
          document.addEventListener("touchend", this.onTouchEnd, false);
        }
      }
    )
  }, {
    key: "stopListeningToTouch",
    value: function stopListeningToTouch() {
      if (document && document.removeEventListener) {
        document.removeEventListener("touchstart", this.onTouchStart);
        document.removeEventListener("touchmove", this.onTouchMove);
        document.removeEventListener("touchend", this.onTouchEnd);
      }
    }
  }, {
    key: "renderInput",
    value: (
      // ==============================
      // Renderers
      // ==============================
      function renderInput() {
        var _this$props8 = this.props, isDisabled = _this$props8.isDisabled, isSearchable = _this$props8.isSearchable, inputId = _this$props8.inputId, inputValue = _this$props8.inputValue, tabIndex = _this$props8.tabIndex, form = _this$props8.form, menuIsOpen = _this$props8.menuIsOpen, required = _this$props8.required;
        var _this$getComponents = this.getComponents(), Input3 = _this$getComponents.Input;
        var _this$state4 = this.state, inputIsHidden = _this$state4.inputIsHidden, ariaSelection = _this$state4.ariaSelection;
        var commonProps = this.commonProps;
        var id2 = inputId || this.getElementId("input");
        var ariaAttributes = _objectSpread2(_objectSpread2(_objectSpread2({
          "aria-autocomplete": "list",
          "aria-expanded": menuIsOpen,
          "aria-haspopup": true,
          "aria-errormessage": this.props["aria-errormessage"],
          "aria-invalid": this.props["aria-invalid"],
          "aria-label": this.props["aria-label"],
          "aria-labelledby": this.props["aria-labelledby"],
          "aria-required": required,
          role: "combobox",
          "aria-activedescendant": this.isAppleDevice ? void 0 : this.state.focusedOptionId || ""
        }, menuIsOpen && {
          "aria-controls": this.getElementId("listbox")
        }), !isSearchable && {
          "aria-readonly": true
        }), this.hasValue() ? (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === "initial-input-focus" && {
          "aria-describedby": this.getElementId("live-region")
        } : {
          "aria-describedby": this.getElementId("placeholder")
        });
        if (!isSearchable) {
          return /* @__PURE__ */ React.createElement(DummyInput, _extends$4({
            id: id2,
            innerRef: this.getInputRef,
            onBlur: this.onInputBlur,
            onChange: noop$3,
            onFocus: this.onInputFocus,
            disabled: isDisabled,
            tabIndex,
            inputMode: "none",
            form,
            value: ""
          }, ariaAttributes));
        }
        return /* @__PURE__ */ React.createElement(Input3, _extends$4({}, commonProps, {
          autoCapitalize: "none",
          autoComplete: "off",
          autoCorrect: "off",
          id: id2,
          innerRef: this.getInputRef,
          isDisabled,
          isHidden: inputIsHidden,
          onBlur: this.onInputBlur,
          onChange: this.handleInputChange,
          onFocus: this.onInputFocus,
          spellCheck: "false",
          tabIndex,
          form,
          type: "text",
          value: inputValue
        }, ariaAttributes));
      }
    )
  }, {
    key: "renderPlaceholderOrValue",
    value: function renderPlaceholderOrValue() {
      var _this3 = this;
      var _this$getComponents2 = this.getComponents(), MultiValue3 = _this$getComponents2.MultiValue, MultiValueContainer2 = _this$getComponents2.MultiValueContainer, MultiValueLabel2 = _this$getComponents2.MultiValueLabel, MultiValueRemove2 = _this$getComponents2.MultiValueRemove, SingleValue3 = _this$getComponents2.SingleValue, Placeholder3 = _this$getComponents2.Placeholder;
      var commonProps = this.commonProps;
      var _this$props9 = this.props, controlShouldRenderValue = _this$props9.controlShouldRenderValue, isDisabled = _this$props9.isDisabled, isMulti = _this$props9.isMulti, inputValue = _this$props9.inputValue, placeholder = _this$props9.placeholder;
      var _this$state5 = this.state, selectValue = _this$state5.selectValue, focusedValue = _this$state5.focusedValue, isFocused = _this$state5.isFocused;
      if (!this.hasValue() || !controlShouldRenderValue) {
        return inputValue ? null : /* @__PURE__ */ React.createElement(Placeholder3, _extends$4({}, commonProps, {
          key: "placeholder",
          isDisabled,
          isFocused,
          innerProps: {
            id: this.getElementId("placeholder")
          }
        }), placeholder);
      }
      if (isMulti) {
        return selectValue.map(function(opt, index2) {
          var isOptionFocused = opt === focusedValue;
          var key = "".concat(_this3.getOptionLabel(opt), "-").concat(_this3.getOptionValue(opt));
          return /* @__PURE__ */ React.createElement(MultiValue3, _extends$4({}, commonProps, {
            components: {
              Container: MultiValueContainer2,
              Label: MultiValueLabel2,
              Remove: MultiValueRemove2
            },
            isFocused: isOptionFocused,
            isDisabled,
            key,
            index: index2,
            removeProps: {
              onClick: function onClick() {
                return _this3.removeValue(opt);
              },
              onTouchEnd: function onTouchEnd() {
                return _this3.removeValue(opt);
              },
              onMouseDown: function onMouseDown(e3) {
                e3.preventDefault();
              }
            },
            data: opt
          }), _this3.formatOptionLabel(opt, "value"));
        });
      }
      if (inputValue) {
        return null;
      }
      var singleValue = selectValue[0];
      return /* @__PURE__ */ React.createElement(SingleValue3, _extends$4({}, commonProps, {
        data: singleValue,
        isDisabled
      }), this.formatOptionLabel(singleValue, "value"));
    }
  }, {
    key: "renderClearIndicator",
    value: function renderClearIndicator() {
      var _this$getComponents3 = this.getComponents(), ClearIndicator3 = _this$getComponents3.ClearIndicator;
      var commonProps = this.commonProps;
      var _this$props10 = this.props, isDisabled = _this$props10.isDisabled, isLoading = _this$props10.isLoading;
      var isFocused = this.state.isFocused;
      if (!this.isClearable() || !ClearIndicator3 || isDisabled || !this.hasValue() || isLoading) {
        return null;
      }
      var innerProps = {
        onMouseDown: this.onClearIndicatorMouseDown,
        onTouchEnd: this.onClearIndicatorTouchEnd,
        "aria-hidden": "true"
      };
      return /* @__PURE__ */ React.createElement(ClearIndicator3, _extends$4({}, commonProps, {
        innerProps,
        isFocused
      }));
    }
  }, {
    key: "renderLoadingIndicator",
    value: function renderLoadingIndicator() {
      var _this$getComponents4 = this.getComponents(), LoadingIndicator3 = _this$getComponents4.LoadingIndicator;
      var commonProps = this.commonProps;
      var _this$props11 = this.props, isDisabled = _this$props11.isDisabled, isLoading = _this$props11.isLoading;
      var isFocused = this.state.isFocused;
      if (!LoadingIndicator3 || !isLoading) return null;
      var innerProps = {
        "aria-hidden": "true"
      };
      return /* @__PURE__ */ React.createElement(LoadingIndicator3, _extends$4({}, commonProps, {
        innerProps,
        isDisabled,
        isFocused
      }));
    }
  }, {
    key: "renderIndicatorSeparator",
    value: function renderIndicatorSeparator() {
      var _this$getComponents5 = this.getComponents(), DropdownIndicator3 = _this$getComponents5.DropdownIndicator, IndicatorSeparator3 = _this$getComponents5.IndicatorSeparator;
      if (!DropdownIndicator3 || !IndicatorSeparator3) return null;
      var commonProps = this.commonProps;
      var isDisabled = this.props.isDisabled;
      var isFocused = this.state.isFocused;
      return /* @__PURE__ */ React.createElement(IndicatorSeparator3, _extends$4({}, commonProps, {
        isDisabled,
        isFocused
      }));
    }
  }, {
    key: "renderDropdownIndicator",
    value: function renderDropdownIndicator() {
      var _this$getComponents6 = this.getComponents(), DropdownIndicator3 = _this$getComponents6.DropdownIndicator;
      if (!DropdownIndicator3) return null;
      var commonProps = this.commonProps;
      var isDisabled = this.props.isDisabled;
      var isFocused = this.state.isFocused;
      var innerProps = {
        onMouseDown: this.onDropdownIndicatorMouseDown,
        onTouchEnd: this.onDropdownIndicatorTouchEnd,
        "aria-hidden": "true"
      };
      return /* @__PURE__ */ React.createElement(DropdownIndicator3, _extends$4({}, commonProps, {
        innerProps,
        isDisabled,
        isFocused
      }));
    }
  }, {
    key: "renderMenu",
    value: function renderMenu() {
      var _this4 = this;
      var _this$getComponents7 = this.getComponents(), Group3 = _this$getComponents7.Group, GroupHeading3 = _this$getComponents7.GroupHeading, Menu3 = _this$getComponents7.Menu, MenuList3 = _this$getComponents7.MenuList, MenuPortal3 = _this$getComponents7.MenuPortal, LoadingMessage3 = _this$getComponents7.LoadingMessage, NoOptionsMessage3 = _this$getComponents7.NoOptionsMessage, Option3 = _this$getComponents7.Option;
      var commonProps = this.commonProps;
      var focusedOption = this.state.focusedOption;
      var _this$props12 = this.props, captureMenuScroll = _this$props12.captureMenuScroll, inputValue = _this$props12.inputValue, isLoading = _this$props12.isLoading, loadingMessage2 = _this$props12.loadingMessage, minMenuHeight = _this$props12.minMenuHeight, maxMenuHeight = _this$props12.maxMenuHeight, menuIsOpen = _this$props12.menuIsOpen, menuPlacement = _this$props12.menuPlacement, menuPosition = _this$props12.menuPosition, menuPortalTarget = _this$props12.menuPortalTarget, menuShouldBlockScroll = _this$props12.menuShouldBlockScroll, menuShouldScrollIntoView = _this$props12.menuShouldScrollIntoView, noOptionsMessage2 = _this$props12.noOptionsMessage, onMenuScrollToTop = _this$props12.onMenuScrollToTop, onMenuScrollToBottom = _this$props12.onMenuScrollToBottom;
      if (!menuIsOpen) return null;
      var render = function render2(props, id2) {
        var type2 = props.type, data = props.data, isDisabled = props.isDisabled, isSelected = props.isSelected, label = props.label, value = props.value;
        var isFocused = focusedOption === data;
        var onHover = isDisabled ? void 0 : function() {
          return _this4.onOptionHover(data);
        };
        var onSelect = isDisabled ? void 0 : function() {
          return _this4.selectOption(data);
        };
        var optionId = "".concat(_this4.getElementId("option"), "-").concat(id2);
        var innerProps = {
          id: optionId,
          onClick: onSelect,
          onMouseMove: onHover,
          onMouseOver: onHover,
          tabIndex: -1,
          role: "option",
          "aria-selected": _this4.isAppleDevice ? void 0 : isSelected
          // is not supported on Apple devices
        };
        return /* @__PURE__ */ React.createElement(Option3, _extends$4({}, commonProps, {
          innerProps,
          data,
          isDisabled,
          isSelected,
          key: optionId,
          label,
          type: type2,
          value,
          isFocused,
          innerRef: isFocused ? _this4.getFocusedOptionRef : void 0
        }), _this4.formatOptionLabel(props.data, "menu"));
      };
      var menuUI;
      if (this.hasOptions()) {
        menuUI = this.getCategorizedOptions().map(function(item) {
          if (item.type === "group") {
            var _data = item.data, options2 = item.options, groupIndex = item.index;
            var groupId = "".concat(_this4.getElementId("group"), "-").concat(groupIndex);
            var headingId = "".concat(groupId, "-heading");
            return /* @__PURE__ */ React.createElement(Group3, _extends$4({}, commonProps, {
              key: groupId,
              data: _data,
              options: options2,
              Heading: GroupHeading3,
              headingProps: {
                id: headingId,
                data: item.data
              },
              label: _this4.formatGroupLabel(item.data)
            }), item.options.map(function(option) {
              return render(option, "".concat(groupIndex, "-").concat(option.index));
            }));
          } else if (item.type === "option") {
            return render(item, "".concat(item.index));
          }
        });
      } else if (isLoading) {
        var message2 = loadingMessage2({
          inputValue
        });
        if (message2 === null) return null;
        menuUI = /* @__PURE__ */ React.createElement(LoadingMessage3, commonProps, message2);
      } else {
        var _message = noOptionsMessage2({
          inputValue
        });
        if (_message === null) return null;
        menuUI = /* @__PURE__ */ React.createElement(NoOptionsMessage3, commonProps, _message);
      }
      var menuPlacementProps = {
        minMenuHeight,
        maxMenuHeight,
        menuPlacement,
        menuPosition,
        menuShouldScrollIntoView
      };
      var menuElement = /* @__PURE__ */ React.createElement(MenuPlacer, _extends$4({}, commonProps, menuPlacementProps), function(_ref4) {
        var ref2 = _ref4.ref, _ref4$placerProps = _ref4.placerProps, placement = _ref4$placerProps.placement, maxHeight = _ref4$placerProps.maxHeight;
        return /* @__PURE__ */ React.createElement(Menu3, _extends$4({}, commonProps, menuPlacementProps, {
          innerRef: ref2,
          innerProps: {
            onMouseDown: _this4.onMenuMouseDown,
            onMouseMove: _this4.onMenuMouseMove
          },
          isLoading,
          placement
        }), /* @__PURE__ */ React.createElement(ScrollManager, {
          captureEnabled: captureMenuScroll,
          onTopArrive: onMenuScrollToTop,
          onBottomArrive: onMenuScrollToBottom,
          lockEnabled: menuShouldBlockScroll
        }, function(scrollTargetRef) {
          return /* @__PURE__ */ React.createElement(MenuList3, _extends$4({}, commonProps, {
            innerRef: function innerRef(instance) {
              _this4.getMenuListRef(instance);
              scrollTargetRef(instance);
            },
            innerProps: {
              role: "listbox",
              "aria-multiselectable": commonProps.isMulti,
              id: _this4.getElementId("listbox")
            },
            isLoading,
            maxHeight,
            focusedOption
          }), menuUI);
        }));
      });
      return menuPortalTarget || menuPosition === "fixed" ? /* @__PURE__ */ React.createElement(MenuPortal3, _extends$4({}, commonProps, {
        appendTo: menuPortalTarget,
        controlElement: this.controlRef,
        menuPlacement,
        menuPosition
      }), menuElement) : menuElement;
    }
  }, {
    key: "renderFormField",
    value: function renderFormField() {
      var _this5 = this;
      var _this$props13 = this.props, delimiter2 = _this$props13.delimiter, isDisabled = _this$props13.isDisabled, isMulti = _this$props13.isMulti, name = _this$props13.name, required = _this$props13.required;
      var selectValue = this.state.selectValue;
      if (required && !this.hasValue() && !isDisabled) {
        return /* @__PURE__ */ React.createElement(RequiredInput$1, {
          name,
          onFocus: this.onValueInputFocus
        });
      }
      if (!name || isDisabled) return;
      if (isMulti) {
        if (delimiter2) {
          var value = selectValue.map(function(opt) {
            return _this5.getOptionValue(opt);
          }).join(delimiter2);
          return /* @__PURE__ */ React.createElement("input", {
            name,
            type: "hidden",
            value
          });
        } else {
          var input = selectValue.length > 0 ? selectValue.map(function(opt, i) {
            return /* @__PURE__ */ React.createElement("input", {
              key: "i-".concat(i),
              name,
              type: "hidden",
              value: _this5.getOptionValue(opt)
            });
          }) : /* @__PURE__ */ React.createElement("input", {
            name,
            type: "hidden",
            value: ""
          });
          return /* @__PURE__ */ React.createElement("div", null, input);
        }
      } else {
        var _value = selectValue[0] ? this.getOptionValue(selectValue[0]) : "";
        return /* @__PURE__ */ React.createElement("input", {
          name,
          type: "hidden",
          value: _value
        });
      }
    }
  }, {
    key: "renderLiveRegion",
    value: function renderLiveRegion() {
      var commonProps = this.commonProps;
      var _this$state6 = this.state, ariaSelection = _this$state6.ariaSelection, focusedOption = _this$state6.focusedOption, focusedValue = _this$state6.focusedValue, isFocused = _this$state6.isFocused, selectValue = _this$state6.selectValue;
      var focusableOptions = this.getFocusableOptions();
      return /* @__PURE__ */ React.createElement(LiveRegion$1, _extends$4({}, commonProps, {
        id: this.getElementId("live-region"),
        ariaSelection,
        focusedOption,
        focusedValue,
        isFocused,
        selectValue,
        focusableOptions,
        isAppleDevice: this.isAppleDevice
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$getComponents8 = this.getComponents(), Control3 = _this$getComponents8.Control, IndicatorsContainer3 = _this$getComponents8.IndicatorsContainer, SelectContainer3 = _this$getComponents8.SelectContainer, ValueContainer3 = _this$getComponents8.ValueContainer;
      var _this$props14 = this.props, className = _this$props14.className, id2 = _this$props14.id, isDisabled = _this$props14.isDisabled, menuIsOpen = _this$props14.menuIsOpen;
      var isFocused = this.state.isFocused;
      var commonProps = this.commonProps = this.getCommonProps();
      return /* @__PURE__ */ React.createElement(SelectContainer3, _extends$4({}, commonProps, {
        className,
        innerProps: {
          id: id2,
          onKeyDown: this.onKeyDown
        },
        isDisabled,
        isFocused
      }), this.renderLiveRegion(), /* @__PURE__ */ React.createElement(Control3, _extends$4({}, commonProps, {
        innerRef: this.getControlRef,
        innerProps: {
          onMouseDown: this.onControlMouseDown,
          onTouchEnd: this.onControlTouchEnd
        },
        isDisabled,
        isFocused,
        menuIsOpen
      }), /* @__PURE__ */ React.createElement(ValueContainer3, _extends$4({}, commonProps, {
        isDisabled
      }), this.renderPlaceholderOrValue(), this.renderInput()), /* @__PURE__ */ React.createElement(IndicatorsContainer3, _extends$4({}, commonProps, {
        isDisabled
      }), this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderIndicatorSeparator(), this.renderDropdownIndicator())), this.renderMenu(), this.renderFormField());
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      var prevProps = state.prevProps, clearFocusValueOnUpdate = state.clearFocusValueOnUpdate, inputIsHiddenAfterUpdate = state.inputIsHiddenAfterUpdate, ariaSelection = state.ariaSelection, isFocused = state.isFocused, prevWasFocused = state.prevWasFocused, instancePrefix = state.instancePrefix;
      var options2 = props.options, value = props.value, menuIsOpen = props.menuIsOpen, inputValue = props.inputValue, isMulti = props.isMulti;
      var selectValue = cleanValue(value);
      var newMenuOptionsState = {};
      if (prevProps && (value !== prevProps.value || options2 !== prevProps.options || menuIsOpen !== prevProps.menuIsOpen || inputValue !== prevProps.inputValue)) {
        var focusableOptions = menuIsOpen ? buildFocusableOptions(props, selectValue) : [];
        var focusableOptionsWithIds = menuIsOpen ? buildFocusableOptionsWithIds(buildCategorizedOptions(props, selectValue), "".concat(instancePrefix, "-option")) : [];
        var focusedValue = clearFocusValueOnUpdate ? getNextFocusedValue(state, selectValue) : null;
        var focusedOption = getNextFocusedOption(state, focusableOptions);
        var focusedOptionId = getFocusedOptionId(focusableOptionsWithIds, focusedOption);
        newMenuOptionsState = {
          selectValue,
          focusedOption,
          focusedOptionId,
          focusableOptionsWithIds,
          focusedValue,
          clearFocusValueOnUpdate: false
        };
      }
      var newInputIsHiddenState = inputIsHiddenAfterUpdate != null && props !== prevProps ? {
        inputIsHidden: inputIsHiddenAfterUpdate,
        inputIsHiddenAfterUpdate: void 0
      } : {};
      var newAriaSelection = ariaSelection;
      var hasKeptFocus = isFocused && prevWasFocused;
      if (isFocused && !hasKeptFocus) {
        newAriaSelection = {
          value: valueTernary(isMulti, selectValue, selectValue[0] || null),
          options: selectValue,
          action: "initial-input-focus"
        };
        hasKeptFocus = !prevWasFocused;
      }
      if ((ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === "initial-input-focus") {
        newAriaSelection = null;
      }
      return _objectSpread2(_objectSpread2(_objectSpread2({}, newMenuOptionsState), newInputIsHiddenState), {}, {
        prevProps: props,
        ariaSelection: newAriaSelection,
        prevWasFocused: hasKeptFocus
      });
    }
  }]);
  return Select2;
}(Component);
Select.defaultProps = defaultProps;
var _excluded$4 = ["defaultInputValue", "defaultMenuIsOpen", "defaultValue", "inputValue", "menuIsOpen", "onChange", "onInputChange", "onMenuClose", "onMenuOpen", "value"];
function useStateManager(_ref3) {
  var _ref$defaultInputValu = _ref3.defaultInputValue, defaultInputValue = _ref$defaultInputValu === void 0 ? "" : _ref$defaultInputValu, _ref$defaultMenuIsOpe = _ref3.defaultMenuIsOpen, defaultMenuIsOpen = _ref$defaultMenuIsOpe === void 0 ? false : _ref$defaultMenuIsOpe, _ref$defaultValue = _ref3.defaultValue, defaultValue = _ref$defaultValue === void 0 ? null : _ref$defaultValue, propsInputValue = _ref3.inputValue, propsMenuIsOpen = _ref3.menuIsOpen, propsOnChange = _ref3.onChange, propsOnInputChange = _ref3.onInputChange, propsOnMenuClose = _ref3.onMenuClose, propsOnMenuOpen = _ref3.onMenuOpen, propsValue = _ref3.value, restSelectProps = _objectWithoutProperties$3(_ref3, _excluded$4);
  var _useState = useState(propsInputValue !== void 0 ? propsInputValue : defaultInputValue), _useState2 = _slicedToArray(_useState, 2), stateInputValue = _useState2[0], setStateInputValue = _useState2[1];
  var _useState3 = useState(propsMenuIsOpen !== void 0 ? propsMenuIsOpen : defaultMenuIsOpen), _useState4 = _slicedToArray(_useState3, 2), stateMenuIsOpen = _useState4[0], setStateMenuIsOpen = _useState4[1];
  var _useState5 = useState(propsValue !== void 0 ? propsValue : defaultValue), _useState6 = _slicedToArray(_useState5, 2), stateValue = _useState6[0], setStateValue = _useState6[1];
  var onChange2 = useCallback(function(value2, actionMeta) {
    if (typeof propsOnChange === "function") {
      propsOnChange(value2, actionMeta);
    }
    setStateValue(value2);
  }, [propsOnChange]);
  var onInputChange = useCallback(function(value2, actionMeta) {
    var newValue;
    if (typeof propsOnInputChange === "function") {
      newValue = propsOnInputChange(value2, actionMeta);
    }
    setStateInputValue(newValue !== void 0 ? newValue : value2);
  }, [propsOnInputChange]);
  var onMenuOpen = useCallback(function() {
    if (typeof propsOnMenuOpen === "function") {
      propsOnMenuOpen();
    }
    setStateMenuIsOpen(true);
  }, [propsOnMenuOpen]);
  var onMenuClose = useCallback(function() {
    if (typeof propsOnMenuClose === "function") {
      propsOnMenuClose();
    }
    setStateMenuIsOpen(false);
  }, [propsOnMenuClose]);
  var inputValue = propsInputValue !== void 0 ? propsInputValue : stateInputValue;
  var menuIsOpen = propsMenuIsOpen !== void 0 ? propsMenuIsOpen : stateMenuIsOpen;
  var value = propsValue !== void 0 ? propsValue : stateValue;
  return _objectSpread2(_objectSpread2({}, restSelectProps), {}, {
    inputValue,
    menuIsOpen,
    onChange: onChange2,
    onInputChange,
    onMenuClose,
    onMenuOpen,
    value
  });
}
var _excluded$3 = ["allowCreateWhileLoading", "createOptionPosition", "formatCreateLabel", "isValidNewOption", "getNewOptionData", "onCreateOption", "options", "onChange"];
var compareOption = function compareOption2() {
  var inputValue = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
  var option = arguments.length > 1 ? arguments[1] : void 0;
  var accessors = arguments.length > 2 ? arguments[2] : void 0;
  var candidate = String(inputValue).toLowerCase();
  var optionValue = String(accessors.getOptionValue(option)).toLowerCase();
  var optionLabel = String(accessors.getOptionLabel(option)).toLowerCase();
  return optionValue === candidate || optionLabel === candidate;
};
var builtins = {
  formatCreateLabel: function formatCreateLabel(inputValue) {
    return 'Create "'.concat(inputValue, '"');
  },
  isValidNewOption: function isValidNewOption(inputValue, selectValue, selectOptions, accessors) {
    return !(!inputValue || selectValue.some(function(option) {
      return compareOption(inputValue, option, accessors);
    }) || selectOptions.some(function(option) {
      return compareOption(inputValue, option, accessors);
    }));
  },
  getNewOptionData: function getNewOptionData(inputValue, optionLabel) {
    return {
      label: optionLabel,
      value: inputValue,
      __isNew__: true
    };
  }
};
function useCreatable(_ref3) {
  var _ref$allowCreateWhile = _ref3.allowCreateWhileLoading, allowCreateWhileLoading = _ref$allowCreateWhile === void 0 ? false : _ref$allowCreateWhile, _ref$createOptionPosi = _ref3.createOptionPosition, createOptionPosition = _ref$createOptionPosi === void 0 ? "last" : _ref$createOptionPosi, _ref$formatCreateLabe = _ref3.formatCreateLabel, formatCreateLabel2 = _ref$formatCreateLabe === void 0 ? builtins.formatCreateLabel : _ref$formatCreateLabe, _ref$isValidNewOption = _ref3.isValidNewOption, isValidNewOption2 = _ref$isValidNewOption === void 0 ? builtins.isValidNewOption : _ref$isValidNewOption, _ref$getNewOptionData = _ref3.getNewOptionData, getNewOptionData2 = _ref$getNewOptionData === void 0 ? builtins.getNewOptionData : _ref$getNewOptionData, onCreateOption = _ref3.onCreateOption, _ref$options = _ref3.options, propsOptions = _ref$options === void 0 ? [] : _ref$options, propsOnChange = _ref3.onChange, restSelectProps = _objectWithoutProperties$3(_ref3, _excluded$3);
  var _restSelectProps$getO = restSelectProps.getOptionValue, getOptionValue$1$1 = _restSelectProps$getO === void 0 ? getOptionValue$1 : _restSelectProps$getO, _restSelectProps$getO2 = restSelectProps.getOptionLabel, getOptionLabel$1$1 = _restSelectProps$getO2 === void 0 ? getOptionLabel$1 : _restSelectProps$getO2, inputValue = restSelectProps.inputValue, isLoading = restSelectProps.isLoading, isMulti = restSelectProps.isMulti, value = restSelectProps.value, name = restSelectProps.name;
  var newOption = useMemo(function() {
    return isValidNewOption2(inputValue, cleanValue(value), propsOptions, {
      getOptionValue: getOptionValue$1$1,
      getOptionLabel: getOptionLabel$1$1
    }) ? getNewOptionData2(inputValue, formatCreateLabel2(inputValue)) : void 0;
  }, [formatCreateLabel2, getNewOptionData2, getOptionLabel$1$1, getOptionValue$1$1, inputValue, isValidNewOption2, propsOptions, value]);
  var options2 = useMemo(function() {
    return (allowCreateWhileLoading || !isLoading) && newOption ? createOptionPosition === "first" ? [newOption].concat(_toConsumableArray(propsOptions)) : [].concat(_toConsumableArray(propsOptions), [newOption]) : propsOptions;
  }, [allowCreateWhileLoading, createOptionPosition, isLoading, newOption, propsOptions]);
  var onChange2 = useCallback(function(newValue, actionMeta) {
    if (actionMeta.action !== "select-option") {
      return propsOnChange(newValue, actionMeta);
    }
    var valueArray = Array.isArray(newValue) ? newValue : [newValue];
    if (valueArray[valueArray.length - 1] === newOption) {
      if (onCreateOption) onCreateOption(inputValue);
      else {
        var newOptionData = getNewOptionData2(inputValue, inputValue);
        var newActionMeta = {
          action: "create-option",
          name,
          option: newOptionData
        };
        propsOnChange(valueTernary(isMulti, [].concat(_toConsumableArray(cleanValue(value)), [newOptionData]), newOptionData), newActionMeta);
      }
      return;
    }
    propsOnChange(newValue, actionMeta);
  }, [getNewOptionData2, inputValue, isMulti, name, newOption, onCreateOption, propsOnChange, value]);
  return _objectSpread2(_objectSpread2({}, restSelectProps), {}, {
    options: options2,
    onChange: onChange2
  });
}
var CreatableSelect = /* @__PURE__ */ forwardRef(function(props, ref2) {
  var creatableProps = useStateManager(props);
  var selectProps = useCreatable(creatableProps);
  return /* @__PURE__ */ React.createElement(Select, _extends$4({
    ref: ref2
  }, selectProps));
});
var CreatableSelect$1 = CreatableSelect;
const TagCloseIcon = () => /* @__PURE__ */ jsxRuntimeExports.jsx("svg", { width: "9", height: "9", viewBox: "0 0 10 9", fill: "none", xmlns: "http://www.w3.org/2000/svg", focusable: "true", children: /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.41762 0.480124C9.52746 0.370289 9.52746 0.192211 9.41762 0.0823762C9.30779 -0.0274587 9.12971 -0.0274587 9.01988 0.0823762L5 4.10225L0.980124 0.0823762C0.870289 -0.0274587 0.692211 -0.0274587 0.582376 0.0823762C0.472541 0.192211 0.472541 0.370289 0.582376 0.480124L4.60225 4.5L0.582376 8.51988C0.472541 8.62971 0.472541 8.80779 0.582376 8.91762C0.692211 9.02746 0.870289 9.02746 0.980124 8.91762L5 4.89775L9.01988 8.91762C9.12971 9.02746 9.30779 9.02746 9.41762 8.91762C9.52746 8.80779 9.52746 8.62971 9.41762 8.51988L5.39775 4.5L9.41762 0.480124Z" }) });
const v$8 = (token2) => `var(${token2})`;
const TAG_BASE_STYLE = {
  fontFamily: v$8(TOKENS.text.fontFamily.primary),
  fontWeight: v$8(TOKENS.text.fontWeight.default),
  fontSize: "0.75rem",
  lineHeight: "140%",
  letterSpacing: "0em",
  borderRadius: "3px",
  paddingLeft: "8px",
  paddingTop: "5px",
  paddingBottom: "3px",
  paddingRight: "8px",
  focusRingStyle: {
    gap: "1px",
    width: "2px",
    borderRadius: "1px",
    color: v$8(TOKENS.color.border.focus)
  }
};
const TAG_GRAY_STYLE = {
  borderStyle: "solid",
  borderWidth: "1px",
  borderColor: v$8(TOKENS.color.border.interaction.neutral),
  fill: v$8(TOKENS.color.foreground.default),
  color: v$8(TOKENS.color.foreground.default),
  background: "transparent",
  hoverStyle: {
    background: v$8(TOKENS.color.background.interaction.neutralHover),
    borderColor: v$8(TOKENS.color.border.interaction.neutralHover)
  },
  activeStyle: {
    background: v$8(TOKENS.color.background.interaction.neutralActive),
    borderColor: v$8(TOKENS.color.border.interaction.neutralActive)
  },
  // borderColor is pinned to the resting value so the hover/active border does
  // not bleed through on a disabled tag: `disabled` is composed last, but only
  // overrides the properties it sets.
  disabledStyle: {
    background: v$8(TOKENS.color.background.interaction.neutralDisabled),
    color: v$8(TOKENS.color.foreground.interaction.disabled),
    fill: v$8(TOKENS.color.foreground.interaction.disabled),
    borderColor: v$8(TOKENS.color.border.interaction.neutral)
  }
};
const TAG_VARIANT_STYLE = {
  gray: TAG_GRAY_STYLE
};
const tagPseudostates = [Pseudostate.hover, Pseudostate.active, Pseudostate["focus-visible"], Pseudostate.disabled];
const StyledTag = styled.span`
  display: inline-flex;
  cursor: pointer;
  align-items: center;
  justify-content: center;
  gap: ${(props) => props.iconGap}px;
  ${(props) => props.disabled && `
      cursor: not-allowed;
      &.disabled * {
        cursor: not-allowed;
      }
    `}
  ${composeWrapper([svg, space, typography, layout, color, background, border, position$1], tagPseudostates)}
`;
const LabelContainer$1 = styled.span`
  position: relative;
`;
const IconContainer$1 = styled.button`
  display: flex;
  position: relative;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  height: 9px;
  ${(props) => {
  return FocusRing({
    ...props.focusRingStyle
  });
}}
`;
const Tag = forwardRef((props, ref2) => {
  const {
    className,
    children,
    disabled,
    onClose,
    onTouchClose,
    hideIcon,
    iconGap = "7.5",
    variant = "gray"
  } = props;
  const themedProps = {
    ...TAG_BASE_STYLE,
    ...TAG_VARIANT_STYLE[variant] ?? TAG_GRAY_STYLE
  };
  const onCloseWrapper = (e3) => {
    if (onClose && !disabled) {
      onClose(e3);
    }
  };
  const onTouchCloseWrapper = (e3) => {
    if (onTouchClose && !disabled) {
      onTouchClose(e3);
    }
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledTag, { className: `${disabled ? "disabled" : ""}`, iconGap, ...props, ...themedProps, ref: ref2, onClick: onCloseWrapper, onTouchEnd: onTouchCloseWrapper, "data-testid": "tag", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(LabelContainer$1, { children }),
    !hideIcon && /* @__PURE__ */ jsxRuntimeExports.jsx(IconContainer$1, { "aria-label": "Close Icon", className, disabled, ...themedProps, children: /* @__PURE__ */ jsxRuntimeExports.jsx(TagCloseIcon, {}) })
  ] });
});
Tag.displayName = "Tag";
const TypeaheadContext = React__default.createContext(null);
const useTypeaheadContext = () => {
  const ctx = React__default.useContext(TypeaheadContext);
  if (!ctx) {
    throw new Error("Typeahead subcomponents must render within TypeaheadInput");
  }
  return ctx;
};
const positionInputElement = (props) => css$3`
  margin-top: calc(${getEffectiveMarginTop(props)} * 1.5);
`;
const labelTransformationStyles = (marginTop) => css$3`
  transform: translateY(calc(${marginTop} / 2));
  font-size: 12px;
  line-height: 12px;
`;
const textInputStates = [Pseudostate.hover, Pseudostate.active, Pseudostate["focus-visible"], Pseudostate.invalid, Pseudostate["focus-within"], Pseudostate.disabled];
const withReactSelectTheme = (Component2) => function WithReactSelectTheme(props) {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Component2, { ...props, theme: defaultTheme$1 });
};
const StyledCloseIcon$1 = styled(CloseIcon)`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;
const StyledCaretDownIcon = styled(CaretDownIcon)`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;
const StyledCaretUpIcon = styled(CaretUpIcon)`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;
const StyledControl = styled(withReactSelectTheme(components$1.Control))`
  outline: solid 0px;
  display: flex;
  background-color: transparent;
  box-shadow: none;
  ${composeWrapper([typography, color, layout, border, outline, shadow], textInputStates)};
  min-height: ${(props) => props.height};
  border-style: solid;
  height: max-content;
`;
const ValueContainerWrapper = styled.div`
  width: 100%;
  position: relative;
  display: flex;
  height: 100%;
`;
const StyledValueContainer = styled(withReactSelectTheme(components$1.ValueContainer))`
  ${composeWrapper([color, typography], textInputStates)}
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  padding-top: 0px;
  padding-bottom: 0px;
  overflow: auto;
  max-width: 100%;
  background-color: transparent;
  & > div {
    padding: 0px;
    overflow: visible;
    gap: 4px;
    max-width: 100%;
  }
  &:invalid,
  &.invalid {
    background-color: transparent;
  }
  ${(props) => positionInputElement(props)}
`;
const StyledLabel$2 = styled.label`
  ${composeWrapper([color, typography], textInputStates)}
  align-self: flex-start;
  pointer-events: none;
  position: absolute;
  transition: 0.2s ease all;
  -moz-transition: 0.2s ease all;
  -webkit-transition: 0.2s ease all;
  top: 0;
  transform: translateY(${(props) => getEffectiveMarginTop(props)});
  background-color: transparent;
  padding-left: 8px;
  ${(props) => props.isFloating && labelTransformationStyles(getEffectiveMarginTop(props) || "0px")};
`;
const positionIcons = css$3`
  /* Place the top of the icons in the middle of the input */
  margin-top: calc(${(props) => props.height} / 2);

  /* Shift the icons up so they're centered correctly */
  & svg {
    transform: translateY(-50%);
  }
`;
const StyledDropdownIndicator = styled(withReactSelectTheme(components$1.DropdownIndicator))`
  ${positionIcons}
  padding: 0px 8px 0px 4px;
`;
const DropdownIndicator2 = (props) => {
  const {
    selectProps,
    innerProps
  } = props;
  const {
    menuIsOpen,
    onMenuOpen,
    onMenuClose
  } = selectProps;
  const {
    disabled,
    inputTheme
  } = useTypeaheadContext();
  const handleToggle = React__default.useCallback(() => {
    if (!menuIsOpen) {
      onMenuOpen();
    } else {
      onMenuClose();
    }
  }, [menuIsOpen, onMenuOpen, onMenuClose]);
  const touchStartRef = React__default.useRef(null);
  const isScrollingRef = React__default.useRef(false);
  const handleKeyDown = (e3, action) => {
    if (e3.key === "Enter" || e3.key === " ") {
      e3.stopPropagation();
      e3.preventDefault();
      action();
    }
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(StyledDropdownIndicator, { "data-role": "dropdown-indicator", ...inputTheme, ...{
    ...props,
    innerProps: {
      ...innerProps,
      onTouchEnd: (e3) => {
        var _a2;
        e3.stopPropagation();
        if (isScrollingRef.current) {
          return;
        }
        (_a2 = innerProps.onTouchEnd) == null ? void 0 : _a2.call(innerProps, e3);
        handleToggle();
      },
      onMouseDown: (e3) => {
        var _a2;
        e3.stopPropagation();
        (_a2 = innerProps.onMouseDown) == null ? void 0 : _a2.call(innerProps, e3);
        handleToggle();
      },
      onTouchStart: (e3) => {
        const touch = e3.touches[0];
        if (!touch) return;
        touchStartRef.current = {
          x: touch.clientX,
          y: touch.clientY
        };
        isScrollingRef.current = false;
      },
      onTouchMove: (e3) => {
        const touch = e3.touches[0];
        if (!touchStartRef.current || !touch) return;
        const dx = Math.abs(touch.clientX - touchStartRef.current.x);
        const dy = Math.abs(touch.clientY - touchStartRef.current.y);
        if (dx > 8 || dy > 8) {
          isScrollingRef.current = true;
        }
      }
    }
  }, children: menuIsOpen ? /* @__PURE__ */ jsxRuntimeExports.jsx(StyledCaretUpIcon, { "data-testid": "Caret-UpIcon", size: "sm", fill: disabled ? "#BBBBBB" : void 0, role: "button", tabIndex: disabled ? -1 : 0, "aria-label": "Close dropdown", onKeyDown: (e3) => handleKeyDown(e3, onMenuClose) }) : /* @__PURE__ */ jsxRuntimeExports.jsx(StyledCaretDownIcon, { "data-testid": "Caret-DownIcon", size: "sm", fill: disabled ? "#BBBBBB" : void 0, role: "button", tabIndex: disabled ? -1 : 0, "aria-label": "Open dropdown", onKeyDown: (e3) => handleKeyDown(e3, onMenuOpen) }) });
};
const StyledClearIndicator = styled(withReactSelectTheme(components$1.ClearIndicator))`
  display: flex;
  padding-right: 4px;
  ${positionIcons}
`;
const ClearIndicator2 = (props) => {
  const {
    clearValue,
    selectProps: {
      isClearable,
      isMulti,
      onChange: onChange2,
      onMenuOpen
    }
  } = props;
  const {
    disabled,
    inputTheme
  } = useTypeaheadContext();
  if (!isClearable) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(React__default.Fragment, {});
  }
  const handleClear = (e3) => {
    e3.stopPropagation();
    if (isMulti) {
      onChange2([], {
        action: "clear",
        removedValues: []
      });
    } else {
      clearValue();
    }
    onMenuOpen();
  };
  const handleKeyDown = (e3) => {
    if (e3.key === "Enter" || e3.key === " ") {
      e3.preventDefault();
      e3.stopPropagation();
      if (isMulti) {
        onChange2([], {
          action: "clear",
          removedValues: []
        });
      } else {
        clearValue();
      }
      onMenuOpen();
    }
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(StyledClearIndicator, { ...inputTheme, ...props, children: /* @__PURE__ */ jsxRuntimeExports.jsx(StyledCloseIcon$1, { size: "sm", fill: disabled ? "#BBBBBB" : void 0, role: "button", tabIndex: disabled ? -1 : 0, "aria-label": "Clear selection", onClick: handleClear, onTouchEnd: handleClear, onKeyDown: handleKeyDown }) });
};
const IconWrapper = styled.div`
  height: 16px;
  width: 16px;
  margin-left: 14px;
  ${positionIcons}
`;
const Control2 = ({
  children,
  ...props
}) => {
  const {
    isFocused,
    selectProps: {
      inputValue
    },
    selectProps
  } = props;
  const {
    inputTheme,
    disabled,
    label,
    hideDropdownIndicator
  } = useTypeaheadContext();
  return /* @__PURE__ */ jsxRuntimeExports.jsx(React__default.Fragment, { children: /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledControl, { ...inputTheme, ...selectProps, ...props, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(IconWrapper, { ...inputTheme, children: /* @__PURE__ */ jsxRuntimeExports.jsx(SearchIcon, { size: "sm", fill: disabled ? "#BBBBBB" : void 0 }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(ValueContainerWrapper, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(StyledLabel$2, { isFloating: isFocused || props.hasValue || !!inputValue, ...inputTheme, ...inputTheme.labelStyles, disabled, htmlFor: props.selectProps.inputId, children: label }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(StyledValueContainer, { ...inputTheme, ...selectProps, ...props, children })
    ] }),
    props.hasValue && /* @__PURE__ */ jsxRuntimeExports.jsx(ClearIndicator2, { ...props }),
    !hideDropdownIndicator && /* @__PURE__ */ jsxRuntimeExports.jsx(DropdownIndicator2, { ...props })
  ] }) });
};
const StyledPlaceholder = styled(withReactSelectTheme(components$1.Placeholder))`
  ${composeWrapper([typography, color], textInputStates)}
`;
const DEFAULT_PLACEHOLDER = "Type to search";
const Placeholder2 = (props) => {
  const {
    isFocused,
    hasValue,
    selectProps: {
      placeholder
    },
    selectProps
  } = props;
  const {
    inputTheme: {
      placeholderStyles
    }
  } = useTypeaheadContext();
  return /* @__PURE__ */ jsxRuntimeExports.jsx(StyledPlaceholder, { ...placeholderStyles, ...selectProps, ...props, children: isFocused && !hasValue ? placeholder || DEFAULT_PLACEHOLDER : "" });
};
const MultiValue2 = (props) => {
  const {
    removeProps: {
      onClick,
      onTouchEnd
    },
    children
  } = props;
  const {
    disabled
  } = useTypeaheadContext();
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Tag, { onClose: onClick, onTouchClose: onTouchEnd, disabled, children });
};
const StyledInput = styled(withReactSelectTheme(components$1.Input))`
  align-self: flex-end;
  display: flex;
  align-items: flex-end;
  margin: 0px;
  padding: 0px;
`;
const Input2 = (props) => {
  const {
    innerRef
  } = props;
  const {
    label,
    inputRef
  } = useTypeaheadContext();
  return /* @__PURE__ */ jsxRuntimeExports.jsx(StyledInput, { "aria-label": label, ...props, innerRef: (ref2) => {
    if (inputRef && ref2) {
      inputRef.current = ref2;
    }
    if (innerRef && ref2) {
      innerRef(ref2);
    }
  } });
};
const StyledMenu = styled(withReactSelectTheme(components$1.Menu))`
  ${composeWrapper([typography, color], textInputStates)};
`;
const Menu2 = (props) => {
  const {
    selectProps
  } = props;
  const {
    inputTheme
  } = useTypeaheadContext();
  return /* @__PURE__ */ jsxRuntimeExports.jsx(StyledMenu, { ...inputTheme, ...selectProps, ...props });
};
const StyledOption = styled(withReactSelectTheme(components$1.Option))`
  ${composeWrapper([background, color, space, border], textInputStates)};
  margin: 0px;
  cursor: pointer;
  padding-top: 8px;
  padding-bottom: 8px;
`;
const Option2 = (props) => {
  const {
    label,
    isFocused
  } = props;
  const {
    menuItemTheme,
    inputTheme,
    disabled = false
  } = useTypeaheadContext();
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { "data-cy": `typeahead-option-${label}`, children: /* @__PURE__ */ jsxRuntimeExports.jsx(StyledOption, { ...inputTheme, ...menuItemTheme, ...props, className: `${isFocused ? "focus-visible" : ""}`, isFocused, isDisabled: disabled, children: label }) });
};
const COMPONENTS = {
  IndicatorsContainer: () => null,
  Control: Control2,
  Placeholder: Placeholder2,
  MultiValue: MultiValue2,
  Input: Input2,
  Menu: Menu2,
  Option: Option2,
  ClearIndicator: ClearIndicator2
};
const MENU_ITEM_STYLE_PROPS = {
  // Typography — bodySmall.mobile (fontSize/lineHeight carrier-invariant)
  fontFamily: `var(${TOKENS.text.fontFamily.primary})`,
  fontSize: "0.875rem",
  lineHeight: "140%",
  padding: "6px 16px",
  color: `var(${TOKENS.color.foreground.default})`,
  // Account for the focus border ahead of time so focus doesn't "wiggle" content
  border: "solid 2px transparent",
  hoverStyle: {
    background: `var(${TOKENS.color.background.interaction.neutralHover})`
  },
  activeStyle: {
    background: `var(${TOKENS.color.background.interaction.neutralActive})`
  }
};
const TypeaheadInput = forwardRef((props, ref2) => {
  const {
    closeMenuOnSelect = true,
    openMenuOnClick = false,
    openMenuOnFocus = false,
    isClearable = true,
    backspaceRemovesValue = true,
    placeholder = DEFAULT_PLACEHOLDER,
    onChange: onChange2,
    isValidNewOption: isValidNewOption2,
    id: id2,
    disabled,
    creatable = false,
    invalid,
    className,
    styles: customStyles,
    truncateOptions = false
  } = props;
  const inputThemeProps = INPUT_STYLE_PROPS;
  const menuItemPropsWithoutFocus = MENU_ITEM_STYLE_PROPS;
  const onChangeWrapper = (option) => {
    if (onChange2) {
      return onChange2(option);
    }
    return null;
  };
  const isValidNewOptionWrapper = (option) => {
    if (isValidNewOption2) {
      return isValidNewOption2(option);
    }
    return true;
  };
  const defaultStyles2 = {
    control: () => ({}),
    dropdownIndicator: () => ({}),
    clearIndicator: () => ({}),
    option: () => ({
      ...truncateOptions && {
        textOverflow: "ellipsis",
        overflow: "hidden",
        whiteSpace: "nowrap"
      }
    }),
    menuList: (provided) => ({
      ...provided,
      paddingTop: "0px",
      fontSize: "14px"
    }),
    input: () => ({
      display: "inline-grid",
      gridArea: "1/1/2/3"
    })
  };
  const reactSelectProps = {
    ...props,
    id: void 0,
    // Omit id from spread so only the input gets it via inputId; otherwise react-select
    // would put id on both the root div and the input, producing duplicate IDs.
    components: COMPONENTS,
    styles: {
      ...defaultStyles2,
      ...customStyles ?? {}
    },
    isDisabled: disabled,
    openMenuOnClick,
    openMenuOnFocus,
    inputTheme: inputThemeProps,
    menuItemTheme: menuItemPropsWithoutFocus,
    closeMenuOnSelect,
    isClearable,
    backspaceRemovesValue,
    inputId: id2,
    inputRef: ref2,
    placeholder,
    className: `${className || ""} ${invalid ? "invalid" : ""}`,
    onChange: onChangeWrapper,
    theme: defaultTheme$1
  };
  const contextValue = React__default.useMemo(() => ({
    inputTheme: inputThemeProps,
    menuItemTheme: menuItemPropsWithoutFocus,
    label: props.label,
    inputRef: ref2,
    hideDropdownIndicator: props.hideDropdownIndicator,
    disabled
  }), [inputThemeProps, menuItemPropsWithoutFocus, props.label, ref2, props.hideDropdownIndicator, disabled]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(TypeaheadContext.Provider, { value: contextValue, children: !creatable ? /* @__PURE__ */ jsxRuntimeExports.jsx(Select$1, { ...reactSelectProps }) : /* @__PURE__ */ jsxRuntimeExports.jsx(
    CreatableSelect$1,
    {
      ...reactSelectProps,
      isValidNewOption: (option) => isValidNewOptionWrapper(option)
    }
  ) });
});
TypeaheadInput.displayName = "Typeahead";
const StyledTextInput = styled(TextInput)`
  font-weight: 300;
  color: var(${TOKENS.color.foreground.subdued});
  & > span > span {
    margin: 10px 16px 10px 0px;
    height: 26px;
    line-height: 26px;
  }
  min-width: 280px;
  align-self: center;
`;
const ClearSearchButton = styled(IconButton)`
  border: none;
  border-radius: 20px;
  height: 30px;
  width: 30px;
`;
const ClearSearchIcon = styled(CloseIcon)`
  height: 16px;
  width: 16px;
`;
const SearchInput = forwardRef(({
  clearSearchButton,
  onClear,
  ...rest
}, ref2) => {
  const [searchValue, setSearchValue] = useState("");
  const onChangeHandler = (e3) => {
    setSearchValue(e3.target.value);
  };
  const handleSearchClear = () => {
    setSearchValue("");
    onClear == null ? void 0 : onClear();
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(StyledTextInput, { iconLeft: /* @__PURE__ */ jsxRuntimeExports.jsx(SearchIcon, {}), iconRight: clearSearchButton && searchValue && searchValue.length > 0 ? /* @__PURE__ */ jsxRuntimeExports.jsx(ClearSearchButton, { variant: "secondary", onClick: handleSearchClear, children: /* @__PURE__ */ jsxRuntimeExports.jsx(ClearSearchIcon, {}) }) : void 0, onChange: onChangeHandler, value: searchValue, ...rest, ref: ref2 });
});
SearchInput.displayName = "SearchInput";
const FilterContainer = styled.div`
  display: flex;
  flex-direction: column;
`;
const FilterTriggerContainer = styled.button`
  width: fit-content;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  cursor: pointer;
  background: none;
  column-gap: 8px;

  svg[data-open="true"] {
    transform: rotate(180deg);
    transition: transform 200ms ease-in-out;
  }

  svg[data-open="false"] {
    transform: rotate(0deg);
    transition: transform 200ms ease-in-out;
  }

  ${(props) => FocusRing({
  ...props.focusStyle
})}

  ${composeWrapper([space, color, typography, layout, flexbox, grid, background, border, position$1, shadow], [Pseudostate.hover, Pseudostate.active])}

  ${(props) => props.open && `background: var(${TOKENS.color.background.interaction.accentSubduedActive});`}
`;
const FilterContentHeader = styled.div`
  display: flex;
  position: relative;
  align-items: center;
  justify-content: space-between;
  padding: 8px 16px;
`;
const FilterHeaderButton = styled(LinkButton)`
  display: flex;
  align-items: center;
  padding: 0;
  font-size: medium;
  gap: 4px;
  color: var(${TOKENS.color.foreground.interaction.accent});

  svg {
    fill: var(${TOKENS.color.foreground.interaction.accent});
  }
`;
const FilterListContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin: 8px;
  margin-top: 0;

  gap: ${(props) => props.hasSubItems ? "4px" : 0};
`;
const FilterScrollContainer = styled.div`
  overflow: auto;
`;
const FilterSearchWrapper = styled.div`
  padding: 4px 16px 8px;

  ${(props) => props.$hasCustomWidth && css$3`
      > [class] {
        min-width: unset;
        width: 100%;
      }
    `}
`;
const FilterItemMenu = styled(MenuItem)`
  position: relative;
`;
const FilterItemButton = styled(Button)`
  position: absolute;
  top: 50%;
  right: 8px;
  transform: translate3d(0, -50%, 0);

  &[data-expanded="true"] {
    & svg {
      transform: rotate(180deg);
      transition: transform 200ms ease-in-out;
    }
  }

  &[data-expanded="false"] {
    & svg {
      transform: rotate(0deg);
      transition: transform 200ms ease-in-out;
    }
  }
`;
const FilterItemContainer = styled.div`
  display: flex;
  flex-direction: column;
  overflow: hidden;

  ${composeWrapper([space, color, typography, layout, flexbox, grid, background, border, position$1], [Pseudostate.hover])}
`;
const FilterSlotContainer = styled.div`
  padding: 6px 16px;

  label[class],
  .react-datepicker-wrapper {
    min-width: unset;
    width: 100%;
  }
`;
const v$7 = (token2) => `var(${token2})`;
const FILTER_TRIGGER_STYLE = {
  color: v$7(TOKENS.color.foreground.default),
  borderRadius: "4px",
  background: v$7(TOKENS.color.background.surface1),
  padding: "8px 12px",
  focusStyle: {
    width: "2px",
    color: v$7(TOKENS.color.border.focus),
    borderRadius: "4px",
    background: v$7(TOKENS.color.background.surface2)
  },
  hoverStyle: {
    background: v$7(TOKENS.color.background.interaction.accentSubduedActive)
  },
  activeStyle: {
    background: v$7(TOKENS.color.background.interaction.accentSubduedActive)
  }
};
const FilterTrigger = forwardRef((props, ref2) => {
  const {
    open,
    checkedItems = 0,
    selectedLabel,
    emptyLabel = "All",
    icon: CustomIcon,
    title,
    ...rest
  } = props;
  const themeProps = FILTER_TRIGGER_STYLE;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(FilterTriggerContainer, { ref: ref2, open, "aria-label": `${title}: ${selectedLabel ?? (checkedItems ? `(${checkedItems})` : emptyLabel)}`, ...rest, ...themeProps, children: [
    CustomIcon && /* @__PURE__ */ jsxRuntimeExports.jsx(CustomIcon, { size: "sm" }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(Text, { element: "p", variant: "bodySmall.desktop", children: [
      `${title}: `,
      /* @__PURE__ */ jsxRuntimeExports.jsx(Text, { element: "span", variant: "bodySmall.desktop", fontWeight: "700", color: `var(${TOKENS.color.foreground.primary})`, children: !checkedItems ? emptyLabel : selectedLabel ?? `(${checkedItems})` })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(CaretDownIcon, { "data-open": open, fill: `var(${TOKENS.color.foreground.primary})`, size: "sm" })
  ] });
});
var FilterTrigger$1 = memo(FilterTrigger);
const FilterSlot = (props) => {
  const {
    item,
    itemValue
  } = props;
  const {
    value: filterValue,
    slotMap,
    setValue,
    type: type2
  } = useFilterContext();
  const slotValue = useMemo(() => {
    var _a2;
    if (type2 === "single") {
      const prefix2 = `${itemValue}~`;
      const str = filterValue;
      if (!str.startsWith(prefix2)) return void 0;
      try {
        return JSON.parse(str.slice(prefix2.length));
      } catch {
        return void 0;
      }
    }
    const slotComponentValue = (_a2 = filterValue.find((value) => {
      const [rootValue, subValue] = value.split("~");
      return `${rootValue}~${subValue}` === itemValue;
    })) == null ? void 0 : _a2.split("~")[2];
    if (!slotComponentValue) return void 0;
    return JSON.parse(slotComponentValue);
  }, [filterValue, type2, itemValue]);
  const slot = useMemo(() => {
    if (!item.slot) return null;
    const slotComponent = slotMap[item.slot];
    return cloneElement(slotComponent, {
      ...slotComponent.props,
      value: slotValue,
      onChange: (value) => {
        var _a2;
        const finalValue = "target" in value ? (_a2 = value.target) == null ? void 0 : _a2.value : value;
        if (type2 === "single") {
          setValue(`${itemValue}~${JSON.stringify(finalValue)}`);
        } else {
          setValue((old) => old.map((oldValue) => {
            const [rootValue, subValue] = oldValue.split("~");
            return `${rootValue}~${subValue}` === itemValue ? `${itemValue}~${JSON.stringify(finalValue)}` : oldValue;
          }));
        }
      }
    });
  }, [item.slot, slotMap, slotValue, type2, itemValue, setValue]);
  if (item.slot && !Object.keys(slotMap ?? {}).includes(item.slot)) {
    throw new Error(`Slot ${item.slot} not found in slotMap`);
  }
  if (!slot) return null;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(FilterSlotContainer, { children: slot });
};
var FilterSlot$1 = memo(FilterSlot);
function getNumOfChecked(value, type2) {
  if (type2 === "single") return value ? 1 : 0;
  return value.length;
}
function mapUpdatingValues(filter, value) {
  return filter.map((item) => {
    const [rootValue, subValue] = item.split("~");
    if (`${rootValue}~${subValue}` === value) return `${rootValue}~${subValue}`;
    return item;
  });
}
function filterSimplify(values3) {
  return values3.map((value) => {
    const [rootValue, subValue] = value.split("~");
    return `${rootValue}~${subValue}`;
  });
}
const checkSelected = (values3, itemValue) => {
  if (typeof values3 === "string") {
    if (!itemValue) return values3 === "";
    return values3 === itemValue || values3.startsWith(`${itemValue}~`);
  }
  if (!Array.isArray(values3)) return false;
  return values3 == null ? void 0 : values3.map((v2) => {
    const [value, subValue] = v2.split("~");
    return subValue ? `${value}~${subValue}` : value;
  }).includes(itemValue);
};
function checkAnySelected(values3, itemValue) {
  if (typeof values3 === "string") values3 = [values3];
  if (!Array.isArray(values3)) return false;
  const mappedValues = values3 == null ? void 0 : values3.map((v2) => {
    const value = v2.split("~")[0];
    return value;
  });
  const result = mappedValues.includes(itemValue);
  return result;
}
function checkAllSelected(value, itemValue, items) {
  if (!(items == null ? void 0 : items.length)) {
    return value.includes(itemValue);
  }
  return items.every((item) => filterSimplify(value).includes(`${itemValue}~${item.value}`));
}
function checkIndeterminate(value, itemValue, items) {
  return items == null ? void 0 : items.some((item) => filterSimplify(value).includes(`${itemValue}~${item.value}`));
}
const FILTER_ITEM_STYLE = {
  borderRadius: "6px"
};
const FILTER_ITEM_VARIANT_STYLE = {
  expanded: {
    background: `var(${TOKENS.color.background.surface1})`
  },
  collapsed: {
    background: "unset"
  }
};
const FilterItemComponent = (props, ref2) => {
  const {
    item,
    onUpdate,
    onExpand,
    ...menuItemProps
  } = props;
  const {
    value,
    subItems,
    type: itemType = "multiple",
    expandableRoot = false,
    hideSelectAll = false,
    variant: itemVariant = expandableRoot ? "default" : "checkbox"
  } = item;
  const {
    value: filterValue,
    type: type2
  } = useFilterContext();
  const expanding = useRef(false);
  const [expanded, setExpanded] = useState(false);
  const themeProps = {
    ...FILTER_ITEM_STYLE,
    ...(subItems == null ? void 0 : subItems.length) && expanded ? FILTER_ITEM_VARIANT_STYLE.expanded : FILTER_ITEM_VARIANT_STYLE.collapsed
  };
  const numOfChecked = useMemo(() => {
    if (type2 !== "nested") return 0;
    const checkedValues = filterValue;
    const filteredValues = checkedValues.filter((v2) => {
      const [itemValue, subItemValue] = v2.split("~");
      return itemValue === item.value || subItemValue === item.value;
    });
    return filteredValues.length;
  }, [type2, filterValue, item]);
  const selectedMap = useMemo(() => ({
    single: checkSelected(filterValue, value),
    multiple: checkSelected(filterValue, value),
    nested: checkAllSelected(filterValue, item.value, item.subItems)
  }), [value, item, filterValue]);
  const indeterminate = useMemo(() => !checkAllSelected(filterValue, item.value, item.subItems) && checkIndeterminate(filterValue, item.value, item.subItems), [filterValue, item]);
  const handleToggleExpand = useCallback(() => {
    setExpanded((old) => {
      const newExpanded = !old;
      if (newExpanded) onExpand == null ? void 0 : onExpand(value);
      return newExpanded;
    });
  }, [onExpand, value]);
  useImperativeHandle(ref2, () => ({
    collapse: (expandingValue) => {
      if (expandingValue === value) return;
      setExpanded(false);
    }
  }), [value]);
  const handleClickCheckbox = useCallback((e3) => {
    e3.stopPropagation();
    onUpdate(item.value, itemType, subItems);
  }, [onUpdate, item, itemType, subItems]);
  const onClickCheckbox = (subItems == null ? void 0 : subItems.length) ? handleClickCheckbox : void 0;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(FilterItemContainer, { ...themeProps, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(FilterItemMenu, { ...menuItemProps, id: `filter-item-${item.value}`, paddingLeft: "8px", paddingRight: "8px", ...type2 === "single" ? {
      variant: item.variant ?? "default"
    } : {
      variant: itemType === "single" ? "default" : itemVariant
    }, ...type2 === "nested" && {
      fontWeight: "bold"
    }, ...(subItems == null ? void 0 : subItems.length) && {
      nodeAfter: /* @__PURE__ */ jsxRuntimeExports.jsx(FilterItemButton, { type: "button", padding: "0px", variant: "ghost", "aria-expanded": expanded, "data-expanded": expanded, "aria-label": `${item.label} ${expanded ? "open" : "closed"}`, iconLeft: /* @__PURE__ */ jsxRuntimeExports.jsx(CaretDownIcon, { size: "sm" }), onClick: (e3) => {
        e3.stopPropagation();
        handleToggleExpand();
      }, onKeyDown: (e3) => {
        if (e3.key === "Enter") {
          expanding.current = true;
          handleToggleExpand();
        }
      } })
    }, selected: selectedMap[type2], indeterminate, onClickOrEnterPress: () => {
      if (expanding.current) {
        expanding.current = false;
        return;
      }
      if (itemType === "single" || expandableRoot || (subItems == null ? void 0 : subItems.length)) {
        handleToggleExpand();
        return;
      }
      onUpdate(item.value, itemType, subItems);
    }, onClickCheckbox, children: `${item.label} ${numOfChecked ? `(${numOfChecked})` : ""}` }),
    type2 === "single" && item.slot && checkSelected(filterValue, item.value) && /* @__PURE__ */ jsxRuntimeExports.jsx(FilterSlot$1, { item, itemValue: item.value }),
    expanded && /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
      expandableRoot && !hideSelectAll && /* @__PURE__ */ jsxRuntimeExports.jsx(FilterItemMenu, { id: `filter-item-${item.value}-select-all`, variant: "checkbox", paddingLeft: "16px", selected: selectedMap[type2], onClickOrEnterPress: () => {
        onUpdate(item.value, itemType, subItems);
      }, children: "Select all" }),
      item.type === "single" && !hideSelectAll && /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(FilterItemMenu, { id: `filter-item-${item.value}-all`, variant: "radio", paddingLeft: "16px", selected: !checkAnySelected(filterValue, item.value), onClickOrEnterPress: () => {
        onUpdate(item.value, itemType);
      }, children: item.allLabel ?? "Any" }) }),
      (subItems == null ? void 0 : subItems.length) && /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: subItems.map((subItem) => {
        const isSelected = checkSelected(filterValue, `${item.value}~${subItem.value}`);
        return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(FilterItemMenu, { id: `filter-item-${item.value}-${subItem.value}`, paddingLeft: "16px", variant: itemType === "single" ? "radio" : "checkbox", selected: isSelected, onClickOrEnterPress: () => {
            onUpdate(`${item.value}~${subItem.value}`, itemType, subItems);
          }, ...menuItemProps, children: subItem.label }, subItem.value),
          subItem.slot && isSelected && /* @__PURE__ */ jsxRuntimeExports.jsx(FilterSlot$1, { item: subItem, itemValue: `${item.value}~${subItem.value}` })
        ] });
      }) })
    ] })
  ] });
};
var FilterItemComponent$1 = memo(forwardRef(FilterItemComponent));
const [FilterProvider, useFilterContext] = createContext({
  name: "FilterContext",
  hookName: "useFilterContext",
  providerName: "<FilterProvider/>"
});
const Filter$1 = forwardRef((props, ref2) => {
  var _a2;
  const {
    type: type2 = "single",
    items,
    value: pValue,
    filterName,
    headerIcon: HeaderIcon,
    slotMap,
    onClear,
    onChange: onChange2,
    searchable,
    emptyLabel
  } = props;
  const [value, setValue] = useControlledState$1(pValue, type2 === "single" ? "" : [], onChange2);
  const [searchQuery, setSearchQuery] = useState("");
  const menu = useMenu();
  const visibleItems = useMemo(() => searchable && searchQuery ? items.filter((item) => item.label.toLowerCase().includes(searchQuery.toLowerCase())) : items, [items, searchable, searchQuery]);
  const [itemsRef] = useArrayRef(visibleItems.length);
  const filterContextValue = useMemo(() => ({
    type: type2,
    items,
    value,
    slotMap,
    setValue
  }), [type2, value, items, slotMap, setValue]);
  const handleUpdate = useCallback((val, filterType, subItems) => {
    if (type2 === "single") setValue(val);
    else if (type2 === "multiple") {
      setValue((old) => {
        const updatedValue = new Set(old);
        if (updatedValue.has(val)) updatedValue.delete(val);
        else updatedValue.add(val);
        return Array.from(updatedValue);
      });
    } else {
      setValue((old) => {
        const [status, subStatus] = val.split("~");
        if (filterType === "multiple") {
          const updatedValue2 = new Set(mapUpdatingValues(old, val));
          if (!subStatus && status === val) {
            const indeterminate = checkIndeterminate(old, status, subItems);
            const all = checkAllSelected(old, status, subItems);
            if (!subItems) {
              if (!indeterminate && !all) updatedValue2.add(status);
              else updatedValue2.delete(status);
            }
            subItems == null ? void 0 : subItems.forEach((subItem) => {
              const subItemValue = `${status}~${subItem.value}`;
              if (!indeterminate || !all) updatedValue2.add(subItemValue);
              else updatedValue2.delete(subItemValue);
            });
            return Array.from(updatedValue2);
          }
          if (updatedValue2.has(val)) updatedValue2.delete(val);
          else updatedValue2.add(val);
          return Array.from(updatedValue2);
        }
        const updatedValue = new Set(mapUpdatingValues(old, val));
        if (status) {
          updatedValue.forEach((item) => {
            if (item.startsWith(status)) {
              updatedValue.delete(item);
            }
          });
        }
        updatedValue.add(val);
        return Array.from(updatedValue);
      });
    }
  }, [type2, itemsRef, setValue]);
  const handleExpand = useCallback((expandingValue) => {
    itemsRef.forEach((itemRef) => {
      itemRef.current.collapse(expandingValue);
    });
  }, [itemsRef]);
  const handleClear = useCallback((e3) => {
    e3.stopPropagation();
    setValue(type2 === "single" ? "" : []);
    setSearchQuery("");
    onClear == null ? void 0 : onClear();
  }, [onClear, setValue, type2]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(FilterProvider, { value: filterContextValue, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(FilterContainer, { ref: ref2, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(FilterTrigger$1, { ref: menu.anchorRef, icon: HeaderIcon, open: menu.visible, title: filterName, checkedItems: getNumOfChecked(value, type2), emptyLabel, selectedLabel: type2 === "single" && value && typeof value === "string" ? (_a2 = items.find((item) => item.value === value)) == null ? void 0 : _a2.label : void 0, onClick: menu.toggleMenu }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(Menu$2, { zIndex: "5", hasGroups: false, visible: menu.visible, width: searchable ? "327px" : "280px", maxHeight: "60vh", anchorElement: menu.anchor, onClickAway: menu.closeMenu, autoFocus: false, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs(FilterContentHeader, { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(Text, { element: "p", variant: "headerSmall.desktop", color: `var(${TOKENS.color.foreground.primary})`, children: filterName }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs(FilterHeaderButton, { role: "menuitem", variant: "ghost", "aria-label": "Clear", onClick: handleClear, children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(CloseIcon, { size: "sm" }),
          "Clear"
        ] })
      ] }),
      searchable && /* @__PURE__ */ jsxRuntimeExports.jsx(FilterSearchWrapper, { $hasCustomWidth: !!searchable, children: /* @__PURE__ */ jsxRuntimeExports.jsx(SearchInput, { id: `${filterName}-search`, label: "Search", value: searchQuery, onChange: (e3) => setSearchQuery(e3.target.value) }) }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(FilterScrollContainer, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(FilterListContainer, { hasSubItems: visibleItems.some((item) => {
        var _a3;
        return (_a3 = item.subItems) == null ? void 0 : _a3.length;
      }), children: visibleItems.map((item, index2) => /* @__PURE__ */ jsxRuntimeExports.jsx(FilterItemComponent$1, { ref: itemsRef[index2], item, onUpdate: handleUpdate, onExpand: handleExpand }, item.value)) }) })
    ] })
  ] }) });
});
Filter$1.displayName = "Filter";
const LOGO_COLOR_TYPES = ["onLight", "onDark", "auto"];
const LogoComponent = styled.img`
  display: flex;
  align-items: center;
  justify-content: center;
  ${compose(space, color, typography, layout, background, border)};
`;
const Logo = ({
  src: src2,
  ...rest
}) => {
  const {
    height: height2,
    width: width2,
    alt
  } = rest;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(LogoComponent, { ...rest, src: src2, alt: alt ?? "Logo", height: height2 == null ? void 0 : height2.toString(), width: width2 == null ? void 0 : width2.toString(), role: "img" });
};
Logo.displayName = "Logo";
const MenuGroupContainer = styled.li`
  background: none;
  border: none;
  outline: none;
  cursor: pointer;
  ${composeWrapper([space, color, typography, layout, flexbox, grid, background, border, position$1, shadow])}
  margin: 0;
  padding: 0;
  list-style: none;
`;
const MenuGroupList = styled.ul`
  margin: 0;
  padding: 0;
`;
const MenuGroupTitle = styled.p`
  margin: 0;
  padding: 10px 18px;
  font-weight: bold;
`;
const MenuGroupDivider = styled.hr`
  margin: 8px;
`;
const MenuGroup = forwardRef(({
  children,
  title,
  removeDivider,
  ...rest
}, ref2) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(MenuGroupContainer, { ref: ref2, ...rest, role: "listitem", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(MenuGroupTitle, { children: title }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(MenuGroupList, { role: "group", children }),
    !removeDivider && /* @__PURE__ */ jsxRuntimeExports.jsx(MenuGroupDivider, {})
  ] });
});
MenuGroup.displayName = "MenuGroup";
const styledSystemFns = [color, border, space, typography, layout];
const StyledPercentageBar = styled.div`
  box-sizing: border-box;
  border-radius: 12px;
  border: 1px solid var(${TOKENS.color.border.interaction.neutral});
  background: var(${TOKENS.color.background.interaction.neutralUnactivated});
  color: var(${TOKENS.color.foreground.default});
  position: relative;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  height: ${(props) => props.height || "16px"};
  &:before {
    content: "";
    height: 100%;
    width: ${(props) => props.percent}%;
    border-top-right-radius: ${(props) => props.borderTopRightRadius || 0};
    border-bottom-right-radius: ${(props) => props.borderBottomRightRadius || 0};
    display: block;
    position: absolute;
    left: 0;
    top: 0;
    background: ${(props) => props.hasError ? props.errorBg || `var(${TOKENS.color.background.interaction.danger})` : props.activeBg || `var(${TOKENS.color.background.interaction.neutralActivated})`};
    z-index: 1;
  }
  ${composeWrapper(styledSystemFns, [])}
`;
const PercentageBar = forwardRef(({
  percent,
  hasError = false,
  max: max2 = 100,
  ...rest
}, ref2) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    StyledPercentageBar,
    {
      role: "progressbar",
      "aria-label": `Percentage Bar ${percent}%`,
      percent: !percent ? 1 : percent,
      ...rest,
      ref: ref2,
      hasError: hasError || percent > max2
    }
  );
});
PercentageBar.displayName = "PercentageBar";
var appleIphone = /iPhone/i;
var appleIpod = /iPod/i;
var appleTablet = /iPad/i;
var appleUniversal = /\biOS-universal(?:.+)Mac\b/i;
var androidPhone = /\bAndroid(?:.+)Mobile\b/i;
var androidTablet = /Android/i;
var amazonPhone = /(?:SD4930UR|\bSilk(?:.+)Mobile\b)/i;
var amazonTablet = /Silk/i;
var windowsPhone = /Windows Phone/i;
var windowsTablet = /\bWindows(?:.+)ARM\b/i;
var otherBlackBerry = /BlackBerry/i;
var otherBlackBerry10 = /BB10/i;
var otherOpera = /Opera Mini/i;
var otherChrome = /\b(CriOS|Chrome)(?:.+)Mobile/i;
var otherFirefox = /Mobile(?:.+)Firefox\b/i;
var isAppleTabletOnIos13 = function(navigator2) {
  return typeof navigator2 !== "undefined" && navigator2.platform === "MacIntel" && typeof navigator2.maxTouchPoints === "number" && navigator2.maxTouchPoints > 1 && typeof MSStream === "undefined";
};
function createMatch(userAgent) {
  return function(regex) {
    return regex.test(userAgent);
  };
}
function isMobile(param) {
  var nav = {
    userAgent: "",
    platform: "",
    maxTouchPoints: 0
  };
  if (typeof navigator !== "undefined") {
    nav = {
      userAgent: navigator.userAgent,
      platform: navigator.platform,
      maxTouchPoints: navigator.maxTouchPoints || 0
    };
  }
  var userAgent = nav.userAgent;
  var tmp = userAgent.split("[FBAN");
  if (typeof tmp[1] !== "undefined") {
    userAgent = tmp[0];
  }
  tmp = userAgent.split("Twitter");
  if (typeof tmp[1] !== "undefined") {
    userAgent = tmp[0];
  }
  var match2 = createMatch(userAgent);
  var result = {
    apple: {
      phone: match2(appleIphone) && !match2(windowsPhone),
      ipod: match2(appleIpod),
      tablet: !match2(appleIphone) && (match2(appleTablet) || isAppleTabletOnIos13(nav)) && !match2(windowsPhone),
      universal: match2(appleUniversal),
      device: (match2(appleIphone) || match2(appleIpod) || match2(appleTablet) || match2(appleUniversal) || isAppleTabletOnIos13(nav)) && !match2(windowsPhone)
    },
    amazon: {
      phone: match2(amazonPhone),
      tablet: !match2(amazonPhone) && match2(amazonTablet),
      device: match2(amazonPhone) || match2(amazonTablet)
    },
    android: {
      phone: !match2(windowsPhone) && match2(amazonPhone) || !match2(windowsPhone) && match2(androidPhone),
      tablet: !match2(windowsPhone) && !match2(amazonPhone) && !match2(androidPhone) && (match2(amazonTablet) || match2(androidTablet)),
      device: !match2(windowsPhone) && (match2(amazonPhone) || match2(amazonTablet) || match2(androidPhone) || match2(androidTablet)) || match2(/\bokhttp\b/i)
    },
    windows: {
      phone: match2(windowsPhone),
      tablet: match2(windowsTablet),
      device: match2(windowsPhone) || match2(windowsTablet)
    },
    other: {
      blackberry: match2(otherBlackBerry),
      blackberry10: match2(otherBlackBerry10),
      opera: match2(otherOpera),
      firefox: match2(otherFirefox),
      chrome: match2(otherChrome),
      device: match2(otherBlackBerry) || match2(otherBlackBerry10) || match2(otherOpera) || match2(otherFirefox) || match2(otherChrome)
    },
    any: false,
    phone: false,
    tablet: false
  };
  result.any = result.apple.device || result.android.device || result.windows.device || result.other.device;
  result.phone = result.apple.phone || result.android.phone || result.windows.phone;
  result.tablet = result.apple.tablet || result.android.tablet || result.windows.tablet;
  return result;
}
/**
  * @reach/utils v0.18.0
  *
  * Copyright (c) 2018-2022, React Training LLC
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE.md file in the root directory of this source tree.
  *
  * @license MIT
  */
function canUseDOM() {
  return !!(typeof window !== "undefined" && window.document && window.document.createElement);
}
function composeEventHandlers(theirHandler, ourHandler) {
  return (event) => {
    theirHandler && theirHandler(event);
    if (!event.defaultPrevented) {
      return ourHandler(event);
    }
  };
}
function isFunction$4(value) {
  return !!(value && {}.toString.call(value) == "[object Function]");
}
function assignRef(ref2, value) {
  if (ref2 == null)
    return;
  if (isFunction$4(ref2)) {
    ref2(value);
  } else {
    try {
      ref2.current = value;
    } catch (error2) {
      throw new Error(`Cannot assign value "${value}" to ref "${ref2}"`);
    }
  }
}
function useComposedRefs(...refs) {
  return useCallback((node2) => {
    for (let ref2 of refs) {
      assignRef(ref2, node2);
    }
  }, refs);
}
function getOwnerDocument(element) {
  return canUseDOM() ? element ? element.ownerDocument : document : null;
}
function createContext2(rootComponentName, defaultContext) {
  let Ctx = React.createContext(defaultContext);
  function Provider(props) {
    let { children, ...context } = props;
    let value = React.useMemo(() => context, Object.values(context));
    return /* @__PURE__ */ React.createElement(Ctx.Provider, {
      value
    }, children);
  }
  function useContext2(callerComponentName) {
    let context = React.useContext(Ctx);
    if (context) {
      return context;
    }
    throw Error(`${callerComponentName} must be rendered inside of a ${rootComponentName} component.`);
  }
  Ctx.displayName = `${rootComponentName}Context`;
  Provider.displayName = `${rootComponentName}Provider`;
  return [Provider, useContext2];
}
function isRightClick(nativeEvent) {
  return "which" in nativeEvent ? nativeEvent.which === 3 : "button" in nativeEvent ? nativeEvent.button === 2 : false;
}
function makeId(...args) {
  return args.filter((val) => val != null).join("--");
}
function noop$2() {
}
function useControlledState({
  controlledValue,
  defaultValue,
  calledFrom = "A component"
}) {
  let wasControlled = controlledValue !== void 0;
  let isControlledRef = useRef(wasControlled);
  {
    if (!isControlledRef.current && wasControlled) {
      console.warn(`${calledFrom} is changing from controlled to uncontrolled. Components should not switch from controlled to uncontrolled (or vice versa). Decide between using a controlled or uncontrolled value for the lifetime of the component.`);
    }
    if (isControlledRef.current && !wasControlled) {
      console.warn(`${calledFrom} is changing from uncontrolled to controlled. Components should not switch from uncontrolled to controlled (or vice versa). Decide between using a controlled or uncontrolled value for the lifetime of the component.`);
    }
  }
  let [valueState, setValue] = useState(isControlledRef.current ? controlledValue : defaultValue);
  let set2 = useCallback((n2) => {
    if (!isControlledRef.current) {
      setValue(n2);
    }
  }, []);
  return [isControlledRef.current ? controlledValue : valueState, set2];
}
var useIsomorphicLayoutEffect = canUseDOM() ? useLayoutEffect : useEffect;
function createStableCallbackHook(useEffectHook, callback) {
  let callbackRef = useRef(callback);
  useEffectHook(() => {
    callbackRef.current = callback;
  });
  return useCallback((...args) => {
    callbackRef.current && callbackRef.current(...args);
  }, []);
}
function useStableLayoutCallback(callback) {
  return createStableCallbackHook(useIsomorphicLayoutEffect, callback);
}
var serverHandoffComplete$1 = false;
var id = 0;
function genId$1() {
  return ++id;
}
var maybeReactUseId = React["useId".toString()];
function useId$1(providedId) {
  if (maybeReactUseId !== void 0) {
    let generatedId = maybeReactUseId();
    return providedId ?? generatedId;
  }
  let initialId = providedId ?? (serverHandoffComplete$1 ? genId$1() : null);
  let [id2, setId] = React.useState(initialId);
  useIsomorphicLayoutEffect(() => {
    if (id2 === null) {
      setId(genId$1());
    }
  }, []);
  React.useEffect(() => {
    if (serverHandoffComplete$1 === false) {
      serverHandoffComplete$1 = true;
    }
  }, []);
  return providedId ?? id2 ?? void 0;
}
var [SliderProvider, useSliderContext] = createContext2("Slider");
var Slider = React.forwardRef(function Slider2({ children, ...props }, forwardedRef) {
  return /* @__PURE__ */ React.createElement(SliderInput$1, {
    ...props,
    ref: forwardedRef,
    "data-reach-slider": "",
    __componentName: "Slider"
  }, /* @__PURE__ */ React.createElement(SliderTrack2, null, /* @__PURE__ */ React.createElement(SliderRange2, null), /* @__PURE__ */ React.createElement(SliderHandle2, null), children));
});
Slider.displayName = "Slider";
var SliderInput$1 = React.forwardRef(function SliderInput2({
  "aria-label": ariaLabel,
  "aria-labelledby": ariaLabelledBy,
  "aria-valuetext": ariaValueTextProp,
  as: Comp = "div",
  defaultValue,
  disabled = false,
  value: controlledValue,
  getAriaLabel,
  getAriaValueText,
  getValueText: DEPRECATED_getValueText,
  handleAlignment = "center",
  max: max2 = 100,
  min: min2 = 0,
  name,
  onChange: onChange2,
  onKeyDown,
  onMouseDown,
  onMouseMove,
  onMouseUp,
  onPointerDown,
  onPointerUp,
  onTouchEnd,
  onTouchMove,
  onTouchStart,
  orientation = "horizontal",
  step = 1,
  children,
  __componentName = "SliderInput",
  ...rest
}, forwardedRef) {
  {
    let depecratedPropIsSet = !!DEPRECATED_getValueText;
    React.useEffect(() => {
      if (depecratedPropIsSet) {
        console.warn("The `getValueText` prop in @reach/slider is deprecated. Please use `getAriaValueText` instead.");
      }
    }, [depecratedPropIsSet]);
  }
  let touchId = React.useRef();
  let id2 = useId$1(rest.id);
  let pointerDownRef = React.useRef(false);
  let trackRef = React.useRef(null);
  let handleRef = React.useRef(null);
  let sliderRef = React.useRef(null);
  let ref2 = useComposedRefs(sliderRef, forwardedRef);
  let [hasFocus, setHasFocus] = React.useState(false);
  let { ref: x2, ...handleDimensions } = useDimensions(handleRef);
  defaultValue = defaultValue || min2;
  let defaultValueRef = React.useRef(defaultValue);
  let isControlledRef = React.useRef(controlledValue !== void 0);
  let [_value, setValue] = useControlledState({
    controlledValue,
    defaultValue,
    calledFrom: "SliderInput"
  });
  let value = clamp(_value, min2, max2);
  let trackPercent = valueToPercent(value, min2, max2);
  let isVertical = orientation === "vertical";
  let handleSize = isVertical ? handleDimensions.height : handleDimensions.width;
  let handlePosition = `calc(${trackPercent}% - ${handleAlignment === "center" ? `${handleSize}px / 2` : `${handleSize}px * ${trackPercent * 0.01}`})`;
  let handlePositionRef = React.useRef(handlePosition);
  useIsomorphicLayoutEffect(() => {
    handlePositionRef.current = handlePosition;
  }, [handlePosition]);
  let onChangeRef = React.useRef(onChange2);
  useIsomorphicLayoutEffect(() => {
    onChangeRef.current = onChange2;
  }, [onChange2]);
  let updateValue = React.useCallback(function updateValue2(newValue) {
    setValue(newValue);
    if (onChangeRef.current) {
      onChangeRef.current(newValue, {
        min: min2,
        max: max2,
        handlePosition: handlePositionRef.current
      });
    }
  }, [max2, min2, setValue]);
  let getNewValueFromEvent = React.useCallback((event) => {
    return getNewValue(getPointerPosition(event, touchId), trackRef.current, {
      step,
      orientation,
      min: min2,
      max: max2
    });
  }, [max2, min2, orientation, step]);
  let handleKeyDown = useStableLayoutCallback((event) => {
    if (disabled) {
      return;
    }
    let newValue;
    let tenSteps = (max2 - min2) / 10;
    let keyStep = step || (max2 - min2) / 100;
    switch (event.key) {
      case "ArrowLeft":
      case "ArrowDown":
        newValue = value - keyStep;
        break;
      case "ArrowRight":
      case "ArrowUp":
        newValue = value + keyStep;
        break;
      case "PageDown":
        newValue = value - tenSteps;
        break;
      case "PageUp":
        newValue = value + tenSteps;
        break;
      case "Home":
        newValue = min2;
        break;
      case "End":
        newValue = max2;
        break;
      default:
        return;
    }
    event.preventDefault();
    newValue = clamp(step ? roundValueToStep(newValue, step, min2) : newValue, min2, max2);
    updateValue(newValue);
  });
  let ariaValueText = DEPRECATED_getValueText ? DEPRECATED_getValueText(value) : getAriaValueText ? getAriaValueText(value) : ariaValueTextProp;
  let rangeStyle = { [isVertical ? "height" : "width"]: `${trackPercent}%` };
  let removeMoveEvents = React.useRef(noop$2);
  let removeStartEvents = React.useRef(noop$2);
  let removeEndEvents = React.useRef(noop$2);
  let appEvents = React.useRef({
    onMouseMove,
    onMouseDown,
    onMouseUp,
    onTouchStart,
    onTouchEnd,
    onTouchMove,
    onPointerDown,
    onPointerUp
  });
  useIsomorphicLayoutEffect(() => {
    appEvents.current.onMouseMove = onMouseMove;
    appEvents.current.onMouseDown = onMouseDown;
    appEvents.current.onMouseUp = onMouseUp;
    appEvents.current.onTouchStart = onTouchStart;
    appEvents.current.onTouchEnd = onTouchEnd;
    appEvents.current.onTouchMove = onTouchMove;
    appEvents.current.onPointerDown = onPointerDown;
    appEvents.current.onPointerUp = onPointerUp;
  }, [onMouseMove, onMouseDown, onMouseUp, onTouchStart, onTouchEnd, onTouchMove, onPointerDown, onPointerUp]);
  let handleSlideStart = useStableLayoutCallback((event) => {
    var _a2;
    if (isRightClick(event))
      return;
    if (disabled) {
      pointerDownRef.current = false;
      return;
    }
    let ownerDocument = getOwnerDocument(sliderRef.current);
    let ownerWindow = ownerDocument.defaultView || window;
    pointerDownRef.current = true;
    if (event.changedTouches) {
      event.preventDefault();
      let touch = (_a2 = event.changedTouches) == null ? void 0 : _a2[0];
      if (touch != null) {
        touchId.current = touch.identifier;
      }
    }
    let newValue = getNewValueFromEvent(event);
    if (newValue == null) {
      return;
    }
    ownerWindow.requestAnimationFrame(() => {
      var _a3;
      return (_a3 = handleRef.current) == null ? void 0 : _a3.focus();
    });
    updateValue(newValue);
    removeMoveEvents.current = addMoveListener();
    removeEndEvents.current = addEndListener();
  });
  let setPointerCapture = useStableLayoutCallback((event) => {
    var _a2;
    if (isRightClick(event))
      return;
    if (disabled) {
      pointerDownRef.current = false;
      return;
    }
    pointerDownRef.current = true;
    (_a2 = sliderRef.current) == null ? void 0 : _a2.setPointerCapture(event.pointerId);
  });
  let releasePointerCapture = useStableLayoutCallback((event) => {
    var _a2;
    if (isRightClick(event))
      return;
    (_a2 = sliderRef.current) == null ? void 0 : _a2.releasePointerCapture(event.pointerId);
    pointerDownRef.current = false;
  });
  let handlePointerMove = useStableLayoutCallback((event) => {
    if (disabled || !pointerDownRef.current) {
      pointerDownRef.current = false;
      return;
    }
    let newValue = getNewValueFromEvent(event);
    if (newValue == null) {
      return;
    }
    updateValue(newValue);
  });
  let handleSlideStop = useStableLayoutCallback((event) => {
    if (isRightClick(event))
      return;
    pointerDownRef.current = false;
    let newValue = getNewValueFromEvent(event);
    if (newValue == null) {
      return;
    }
    touchId.current = void 0;
    removeMoveEvents.current();
    removeEndEvents.current();
  });
  let addMoveListener = React.useCallback(() => {
    let ownerDocument = getOwnerDocument(sliderRef.current);
    let touchListener = composeEventHandlers(appEvents.current.onTouchMove, handlePointerMove);
    let mouseListener = composeEventHandlers(appEvents.current.onMouseMove, handlePointerMove);
    ownerDocument.addEventListener("touchmove", touchListener);
    ownerDocument.addEventListener("mousemove", mouseListener);
    return () => {
      ownerDocument.removeEventListener("touchmove", touchListener);
      ownerDocument.removeEventListener("mousemove", mouseListener);
    };
  }, [handlePointerMove]);
  let addEndListener = React.useCallback(() => {
    let ownerDocument = getOwnerDocument(sliderRef.current);
    let ownerWindow = ownerDocument.defaultView || window;
    let pointerListener = composeEventHandlers(appEvents.current.onPointerUp, releasePointerCapture);
    let touchListener = composeEventHandlers(appEvents.current.onTouchEnd, handleSlideStop);
    let mouseListener = composeEventHandlers(appEvents.current.onMouseUp, handleSlideStop);
    if ("PointerEvent" in ownerWindow) {
      ownerDocument.addEventListener("pointerup", pointerListener);
    }
    ownerDocument.addEventListener("touchend", touchListener);
    ownerDocument.addEventListener("mouseup", mouseListener);
    return () => {
      if ("PointerEvent" in ownerWindow) {
        ownerDocument.removeEventListener("pointerup", pointerListener);
      }
      ownerDocument.removeEventListener("touchend", touchListener);
      ownerDocument.removeEventListener("mouseup", mouseListener);
    };
  }, [handleSlideStop, releasePointerCapture]);
  let addStartListener = React.useCallback(() => {
    let sliderElement = sliderRef.current;
    if (!sliderElement) {
      return noop$2;
    }
    let ownerDocument = getOwnerDocument(sliderElement);
    let ownerWindow = ownerDocument.defaultView || window;
    let touchListener = composeEventHandlers(appEvents.current.onTouchStart, handleSlideStart);
    let mouseListener = composeEventHandlers(appEvents.current.onMouseDown, handleSlideStart);
    let pointerListener = composeEventHandlers(appEvents.current.onPointerDown, setPointerCapture);
    sliderElement.addEventListener("touchstart", touchListener);
    sliderElement.addEventListener("mousedown", mouseListener);
    if ("PointerEvent" in ownerWindow) {
      sliderElement.addEventListener("pointerdown", pointerListener);
    }
    return () => {
      sliderElement.removeEventListener("touchstart", touchListener);
      sliderElement.removeEventListener("mousedown", mouseListener);
      if ("PointerEvent" in ownerWindow) {
        sliderElement.removeEventListener("pointerdown", pointerListener);
      }
    };
  }, [setPointerCapture, handleSlideStart]);
  React.useEffect(() => {
    removeStartEvents.current = addStartListener();
    return () => {
      removeStartEvents.current();
      removeEndEvents.current();
      removeMoveEvents.current();
    };
  }, [addStartListener]);
  let shouldRenderInput = name != null;
  let inputRef = React.useRef(null);
  React.useEffect(() => {
    let isControlled = isControlledRef.current;
    let defaultValue2 = defaultValueRef.current;
    let inputElement = inputRef.current;
    let form = inputElement == null ? void 0 : inputElement.form;
    if (!shouldRenderInput || !form || isControlled)
      return;
    function handleReset(event) {
      setValue(defaultValue2);
    }
    form.addEventListener("reset", handleReset);
    return () => {
      form == null ? void 0 : form.removeEventListener("reset", handleReset);
    };
  }, [setValue, shouldRenderInput]);
  return /* @__PURE__ */ React.createElement(SliderProvider, {
    ariaLabel: getAriaLabel ? getAriaLabel(value) : ariaLabel,
    ariaLabelledBy,
    ariaValueText,
    handleDimensions,
    handleKeyDown,
    handlePosition,
    handleRef,
    hasFocus,
    onKeyDown,
    setHasFocus,
    sliderId: id2,
    sliderMax: max2,
    sliderMin: min2,
    value,
    disabled: !!disabled,
    isVertical,
    orientation,
    trackPercent,
    trackRef,
    rangeStyle,
    updateValue
  }, /* @__PURE__ */ React.createElement(Comp, {
    ...rest,
    ref: ref2,
    "data-reach-slider-input": "",
    "data-disabled": disabled ? "" : void 0,
    "data-orientation": orientation,
    tabIndex: -1
  }, isFunction$4(children) ? children({
    hasFocus,
    id: id2,
    max: max2,
    min: min2,
    value,
    ariaValueText,
    valueText: ariaValueText
  }) : children, shouldRenderInput ? /* @__PURE__ */ React.createElement("input", {
    type: "hidden",
    value,
    name,
    id: id2 && makeId("input", id2),
    ref: inputRef
  }) : null));
});
SliderInput$1.displayName = "SliderInput";
var SliderTrackImpl = React.forwardRef(function SliderTrack({ as: Comp = "div", children, style = {}, ...props }, forwardedRef) {
  const { disabled, orientation, trackRef } = useSliderContext("SliderTrack");
  const ref2 = useComposedRefs(trackRef, forwardedRef);
  return /* @__PURE__ */ React.createElement(Comp, {
    ref: ref2,
    style: { ...style, position: "relative" },
    ...props,
    "data-reach-slider-track": "",
    "data-disabled": disabled ? "" : void 0,
    "data-orientation": orientation
  }, children);
});
SliderTrackImpl.displayName = "SliderTrack";
var SliderTrack2 = React.memo(SliderTrackImpl);
SliderTrack2.displayName = "SliderTrack";
var SliderRangeImpl = React.forwardRef(function SliderRange({ as: Comp = "div", children, style = {}, ...props }, forwardedRef) {
  let { disabled, orientation, rangeStyle } = useSliderContext("SliderRange");
  return /* @__PURE__ */ React.createElement(Comp, {
    ref: forwardedRef,
    style: { position: "absolute", ...rangeStyle, ...style },
    ...props,
    "data-reach-slider-range": "",
    "data-disabled": disabled ? "" : void 0,
    "data-orientation": orientation
  });
});
SliderRangeImpl.displayName = "SliderRange";
var SliderRange2 = React.memo(SliderRangeImpl);
var SliderTrackHighlightImpl = React.forwardRef(function SliderTrackHighlightImpl2(props, ref2) {
  {
    React.useEffect(() => {
      console.warn("`SliderTrackHighlight` has been deprecated in favor of `SliderRange` and will be dropped from a future version of Reach UI.");
    }, []);
  }
  return /* @__PURE__ */ React.createElement(SliderRangeImpl, {
    "data-reach-slider-track-highlight": "",
    ...props,
    ref: ref2
  });
});
SliderTrackHighlightImpl.displayName = "SliderTrackHighlight";
React.memo(SliderTrackHighlightImpl);
SliderRange2.displayName = "SliderRange";
var SliderHandleImpl = React.forwardRef(function SliderHandle({
  as: Comp = "div",
  onBlur,
  onFocus: onFocus2,
  style = {},
  onKeyDown,
  ...props
}, forwardedRef) {
  const {
    ariaLabel,
    ariaLabelledBy,
    ariaValueText,
    disabled,
    handlePosition,
    handleRef,
    isVertical,
    handleKeyDown,
    orientation,
    setHasFocus,
    sliderMin,
    sliderMax,
    value
  } = useSliderContext("SliderHandle");
  const ref2 = useComposedRefs(handleRef, forwardedRef);
  return /* @__PURE__ */ React.createElement(Comp, {
    "aria-disabled": disabled || void 0,
    "aria-label": ariaLabel,
    "aria-labelledby": ariaLabel ? void 0 : ariaLabelledBy,
    "aria-orientation": orientation,
    "aria-valuemax": sliderMax,
    "aria-valuemin": sliderMin,
    "aria-valuenow": value,
    "aria-valuetext": ariaValueText,
    role: "slider",
    tabIndex: disabled ? -1 : 0,
    ...props,
    "data-reach-slider-handle": "",
    ref: ref2,
    onBlur: composeEventHandlers(onBlur, () => {
      setHasFocus(false);
    }),
    onFocus: composeEventHandlers(onFocus2, () => {
      setHasFocus(true);
    }),
    onKeyDown: composeEventHandlers(onKeyDown, handleKeyDown),
    style: {
      position: "absolute",
      ...isVertical ? { bottom: handlePosition } : { left: handlePosition },
      ...style
    }
  });
});
SliderHandleImpl.displayName = "SliderHandle";
var SliderHandle2 = React.memo(SliderHandleImpl);
SliderHandle2.displayName = "SliderHandle";
var SliderMarkerImpl = React.forwardRef(function SliderMarker({ as: Comp = "div", children, style = {}, value, ...props }, forwardedRef) {
  const {
    disabled,
    isVertical,
    orientation,
    sliderMin,
    sliderMax,
    value: sliderValue
  } = useSliderContext("SliderMarker");
  let inRange = !(value < sliderMin || value > sliderMax);
  let absoluteStartPosition = `${valueToPercent(value, sliderMin, sliderMax)}%`;
  let state = value < sliderValue ? "under-value" : value === sliderValue ? "at-value" : "over-value";
  return inRange ? /* @__PURE__ */ React.createElement(Comp, {
    ref: forwardedRef,
    style: {
      position: "absolute",
      ...isVertical ? { bottom: absoluteStartPosition } : { left: absoluteStartPosition },
      ...style
    },
    ...props,
    "data-reach-slider-marker": "",
    "data-disabled": disabled ? "" : void 0,
    "data-orientation": orientation,
    "data-state": state,
    "data-value": value,
    children
  }) : null;
});
SliderMarkerImpl.displayName = "SliderMarker";
var SliderMarker2 = React.memo(SliderMarkerImpl);
SliderMarker2.displayName = "SliderMarker";
function clamp(val, min2, max2) {
  return val > max2 ? max2 : val < min2 ? min2 : val;
}
function getDecimalPrecision(num) {
  if (Math.abs(num) < 1) {
    const parts = num.toExponential().split("e-");
    const matissaDecimalPart = parts[0].split(".")[1];
    return (matissaDecimalPart ? matissaDecimalPart.length : 0) + parseInt(parts[1], 10);
  }
  const decimalPart = num.toString().split(".")[1];
  return decimalPart ? decimalPart.length : 0;
}
function percentToValue(percent, min2, max2) {
  return (max2 - min2) * percent + min2;
}
function roundValueToStep(value, step, min2) {
  let nearest = Math.round((value - min2) / step) * step + min2;
  return Number(nearest.toFixed(getDecimalPrecision(step)));
}
function getPointerPosition(event, touchId) {
  if (touchId.current !== void 0 && event.changedTouches) {
    for (let i = 0; i < event.changedTouches.length; i += 1) {
      const touch = event.changedTouches[i];
      if (touch.identifier === touchId.current) {
        return {
          x: touch.clientX,
          y: touch.clientY
        };
      }
    }
    return false;
  }
  return {
    x: event.clientX,
    y: event.clientY
  };
}
function getNewValue(handlePosition, track, props) {
  let { orientation, min: min2, max: max2, step } = props;
  if (!track || !handlePosition) {
    return null;
  }
  let { left: left2, width: width2, bottom: bottom2, height: height2 } = track.getBoundingClientRect();
  let isVertical = orientation === "vertical";
  let diff = isVertical ? bottom2 - handlePosition.y : handlePosition.x - left2;
  let percent = diff / (isVertical ? height2 : width2);
  let newValue = percentToValue(percent, min2, max2);
  return clamp(step ? roundValueToStep(newValue, step, min2) : newValue, min2, max2);
}
function useDimensions(ref2) {
  const [{ width: width2, height: height2 }, setDimensions] = React.useState({
    width: 0,
    height: 0
  });
  useIsomorphicLayoutEffect(() => {
    let ownerDocument = getOwnerDocument(ref2.current);
    let ownerWindow = ownerDocument.defaultView || window;
    if (ref2.current) {
      const { height: _newHeight, width: _newWidth } = ownerWindow.getComputedStyle(ref2.current);
      let newHeight = parseFloat(_newHeight);
      let newWidth = parseFloat(_newWidth);
      if (newHeight !== height2 || newWidth !== width2) {
        setDimensions({ height: newHeight, width: newWidth });
      }
    }
  }, [ref2, width2, height2]);
  return { ref: ref2, width: width2, height: height2 };
}
function valueToPercent(value, min2, max2) {
  return (value - min2) * 100 / (max2 - min2);
}
const SLIDER_CUSTOM_DOM_PROPS = /* @__PURE__ */ new Set(["activeColor", "inactiveColor", "disabledColor", "trackHeight", "feetHeight", "feetWidth", "hideFeet", "focusRingStyle", "thumbStyle", "labelStyle", "labelPosition", "labelSpacing", "sliderBound"]);
const SLIDER_REACH_API_PROPS = /* @__PURE__ */ new Set(["getAriaLabel", "getAriaValueText", "getValueText", "handleAlignment"]);
const sliderShouldForwardProp = (prop) => {
  if (SLIDER_CUSTOM_DOM_PROPS.has(prop)) {
    return false;
  }
  if (SLIDER_REACH_API_PROPS.has(prop)) {
    return true;
  }
  return kindredShouldForwardProp(prop, "div");
};
const sliderPsuedostates = [Pseudostate.hover, Pseudostate.active, Pseudostate.disabled];
const SliderContainer = styled.div`
  padding: 0;
  margin: 0;
  display: inline-flex;
  justify-content: center;
  flex-wrap: wrap;
  position: relative;
  gap: ${(props) => props.labelSpacing || "6px"};
  width: ${(props) => props.width || "100%"};
  ${({
  labelPosition
}) => labelPosition === "above" && css$3`
      flex-direction: column-reverse;
    `}
  ${composeWrapper([layout, space, position$1], sliderPsuedostates)}
  height: auto;
`;
const thumbStyledSystemFns = [border, color, layout, shadow];
const SliderThumb = styled(SliderHandle2).withConfig({
  shouldForwardProp: sliderShouldForwardProp
})`
  outline: none;
  transform-origin: center;
  top: 50%;
  left: ${(props) => {
  if (props.sliderBound === "atMinBound") {
    return "calc(0% - 3px) !important";
  }
  if (props.sliderBound === "atMaxBound") {
    return "calc(100% - 47px) !important";
  }
  return "0";
}};
  transform: translateY(-50%);
  padding: 0;
  margin: 0;
  box-sizing: border-box;
  z-index: 6;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px; /* Space in-between icons. This is technically hardcoded but I don't see this needing changing much */
  ${(props) => composeWrapper([border, color, layout, shadow], props.disabled ? [] : [Pseudostate.hover, Pseudostate.active])(props)};
  &:focus-visible,
  &.focus {
    ${(props) => RawFocusRing({
  ...props.focusRingStyle,
  elementBorderProps: props
})}
  }
`;
const getSliderInputHeight = (trackHeight, thumbHeight) => {
  if (trackHeight !== void 0 && thumbHeight !== void 0) {
    return css$3`max(${trackHeight}, ${thumbHeight})`;
  }
  return thumbHeight !== void 0 ? thumbHeight : trackHeight;
};
const StyledReachSliderInput = styled(SliderInput$1).withConfig({
  shouldForwardProp: sliderShouldForwardProp
})`
  z-index: 10;
  max-width: 100%;
  width: 100%;
  cursor: pointer;
  height: ${(props) => {
  var _a2;
  return getSliderInputHeight(props.trackHeight, (_a2 = props == null ? void 0 : props.thumbStyle) == null ? void 0 : _a2.height);
}};
  position: relative;
  ${(props) => props.disabled && css$3`
      cursor: not-allowed;
    `}

  /* Whenever you hover/click any part of the slider it should show the hover/active state on the Thumb button */
  ${(props) => {
  var _a2, _b;
  return !props.disabled && css$3`
      &:hover ${SliderThumb} {
        ${compose(...thumbStyledSystemFns)(((_a2 = props.thumbStyle) == null ? void 0 : _a2.hoverStyle) || {})}
      }
      &:active ${SliderThumb} {
        ${compose(...thumbStyledSystemFns)(((_b = props.thumbStyle) == null ? void 0 : _b.activeStyle) || {})}
      }
    `;
}}
`;
const SliderBackgroundTrack = styled(SliderTrack2).withConfig({
  shouldForwardProp: sliderShouldForwardProp
})`
  ${({
  inactiveColor,
  trackHeight,
  disabled,
  disabledColor
}) => css$3`
    position: relative;
    width: 100%;
    height: 100%;
    z-index: 1;
    &:before {
      content: "";
      width: 100%;
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      left: 0;
      background: ${inactiveColor || "gray"};
      height: ${trackHeight || "3px"};
      border-radius: inherit;
      ${disabled && css$3`
        background: ${disabledColor};
      `}
    }

    ${compose(border)};
  `}
`;
const SliderFeet = styled.div`
  ${({
  feetHeight,
  feetWidth,
  activeColor,
  inactiveColor,
  disabled,
  disabledColor
}) => css$3`
    width: 100%;
    &:before,
    &:after {
      content: "";
      position: absolute;
      /* Positions so that the foot is centered on the line */
      top: 50%;
      transform: translateY(-50%);
      height: ${feetHeight};
      width: ${feetWidth};
      z-index: 2;
    }
    &:before {
      left: 0;
      background-color: ${disabled ? disabledColor : activeColor};
    }
    &:after {
      right: 0;
      background-color: ${disabled ? disabledColor : inactiveColor};
    }
  `}
`;
const SliderFilledTrack = styled(SliderRange2).withConfig({
  shouldForwardProp: sliderShouldForwardProp
})`
  border-radius: inherit;
  left: 0;
  bottom: 0;
  height: ${(props) => props.trackHeight};
  background-color: ${(props) => props.activeColor};
  top: 50%;
  transform: translateY(-50%);
  ${(props) => props.disabled && css$3`
      background: ${props.disabledColor};
    `}
`;
const LabelContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  bottom: 0;
  left: 0;
  ${composeWrapper([color, typography, space], sliderPsuedostates)}
`;
const LeftArrow = styled.div`
  box-sizing: border-box;
  display: block;
  width: 0;
  height: 0;
  border-top: 6.5px solid transparent;
  border-bottom: 6.5px solid transparent;
  border-right: 10px solid ${(props) => props.color || "black"};
  ${({
  disabled,
  disabledColor
}) => disabled && css$3`
      border-right-color: ${disabledColor};
    `}
`;
const RightArrow = styled.div`
  box-sizing: border-box;
  display: block;
  width: 0;
  height: 0;
  border-top: 6.5px solid transparent;
  border-bottom: 6.5px solid transparent;
  border-left: 10px solid ${(props) => props.color || "black"};
  ${({
  disabled,
  disabledColor
}) => disabled && css$3`
      border-left-color: ${disabledColor};
    `}
`;
const v$6 = (token2) => `var(${token2})`;
const SLIDER_FOCUS_RING = {
  gap: "1px",
  width: "2px",
  borderRadius: "4px",
  color: v$6(TOKENS.color.border.focus)
};
const SLIDER_STYLE = {
  trackHeight: "6px",
  borderRadius: "3px",
  activeColor: v$6(TOKENS.color.background.interaction.neutralActivated),
  inactiveColor: v$6(TOKENS.color.background.interaction.neutralUnactivated),
  disabledColor: v$6(TOKENS.color.background.interaction.neutralUnactivated),
  height: "30px",
  hideFeet: true,
  focusRingStyle: SLIDER_FOCUS_RING,
  labelPosition: "above",
  labelStyle: {
    color: v$6(TOKENS.color.foreground.default),
    fontFamily: v$6(TOKENS.text.fontFamily.primary),
    fontWeight: v$6(TOKENS.text.fontWeight.label),
    fontSize: "0.75rem",
    lineHeight: "140%",
    letterSpacing: "0.12em"
  },
  thumbStyle: {
    width: "50px",
    height: "30px",
    borderRadius: "15px",
    border: "0px solid transparent",
    boxShadow: `0 2px 4px rgba(0, 0, 0, 0.15)`,
    backgroundColor: v$6(TOKENS.color.background.surface0),
    color: v$6(TOKENS.color.foreground.default),
    disabledColor: v$6(TOKENS.color.foreground.interaction.disabled),
    hoverStyle: {
      backgroundColor: v$6(TOKENS.color.background.interaction.neutralHover),
      borderWidth: "1px",
      borderColor: v$6(TOKENS.color.border.interaction.neutralHover)
    },
    activeStyle: {
      borderWidth: "2px",
      borderColor: v$6(TOKENS.color.border.focus),
      backgroundColor: v$6(TOKENS.color.background.interaction.neutralActive)
    },
    focusRingStyle: SLIDER_FOCUS_RING
  }
};
const SliderInput = forwardRef(({
  labelRight,
  labelLeft,
  labelStyle,
  disabled,
  onChange: onChange2,
  getAriaLabel,
  getAriaValueText,
  handleAlignment,
  min: min2 = 0,
  max: max2,
  step = 1,
  value: controlledValue,
  defaultValue: propsDefaultValue,
  name,
  onMouseUp,
  onTouchEnd,
  width: width2,
  id: propsId,
  "aria-label": ariaLabel,
  "aria-labelledby": ariaLabelledBy,
  ...props
}, forwardedRef) => {
  var _a2;
  const themedProps = SLIDER_STYLE;
  const isMobileDevice2 = ((_a2 = isMobile()) == null ? void 0 : _a2.any) || false;
  const backupId = useId$2();
  const id2 = propsId ?? backupId;
  const getStartingValue = useCallback(() => {
    const sliderMiddleValue = Math.ceil(max2 / 2);
    if (max2 <= min2) {
      const newValueInBounds = Math.max(Math.min(controlledValue ?? 0, max2), min2);
      console.error("Invalid min and max values provided to the slider input", {
        max: max2,
        min: min2
      }, "Max must be greater than min by at least 1. The input will be disabled as a result. The value will be set to ", newValueInBounds);
      if (max2 === min2) {
        return newValueInBounds;
      }
      return newValueInBounds;
    }
    if (controlledValue !== void 0) {
      if (typeof controlledValue !== "number") {
        return sliderMiddleValue;
      }
      if (controlledValue > max2) {
        return max2;
      }
      if (controlledValue < min2) {
        return min2;
      }
      return controlledValue;
    }
    return propsDefaultValue !== void 0 ? propsDefaultValue : sliderMiddleValue;
  }, [max2, min2, controlledValue]);
  const startingValue = getStartingValue();
  const emitOnChange = (newValue) => {
    if (onChange2) {
      onChange2({
        target: {
          value: newValue
        }
      });
    }
  };
  const handleArrowClick = (e3, direction) => {
    e3.preventDefault();
    e3.stopPropagation();
    if (!isDisabled) {
      const sliderElement = e3.currentTarget.closest('[role="slider"]');
      if (sliderElement) {
        sliderElement.focus();
        const keyEvent = new KeyboardEvent("keydown", {
          key: direction,
          code: direction,
          bubbles: true,
          cancelable: true
        });
        sliderElement.dispatchEvent(keyEvent);
      }
    }
  };
  useEffect(() => {
    if (controlledValue !== void 0) {
      if (controlledValue !== startingValue) {
        emitOnChange(startingValue);
      }
    } else {
      emitOnChange(startingValue);
    }
  }, []);
  useEffect(() => {
    if (controlledValue) {
      const newValueInBounds = Math.max(Math.min(controlledValue, max2), min2);
      if (controlledValue !== newValueInBounds) {
        emitOnChange(newValueInBounds);
      }
    }
  }, [min2, max2, controlledValue]);
  const [internalValue, setInternalValue] = useState(startingValue);
  const [sliderBound, setSliderBound] = useState(null);
  const isDisabled = max2 <= min2 || disabled;
  useEffect(() => {
    if (step > max2 - min2) {
      console.error("Invalid step provided to slider input", {
        max: max2,
        min: min2,
        step
      }, " The step param needs to be less than max-min. The behavior might be strange.");
    }
  }, [max2, min2, step, startingValue]);
  useEffect(() => {
    if (internalValue !== min2 && internalValue !== max2) {
      if (sliderBound !== null) {
        setSliderBound(null);
      }
      return;
    }
    const newBound = internalValue === min2 ? "atMinBound" : "atMaxBound";
    if (sliderBound !== newBound) {
      setSliderBound(newBound);
    }
  }, [internalValue, min2, max2]);
  const onChangeHandler = (newValue) => {
    if (Number.isNaN(newValue)) {
      return;
    }
    if (newValue === internalValue) {
      return;
    }
    setInternalValue(newValue);
    emitOnChange(newValue);
  };
  const combinedProps = merge({}, themedProps, {
    ...props,
    width: width2,
    id: id2
  });
  const containerProps = selectStyledSystemProps(combinedProps, ["layout", "space", "position"]);
  const internalGetAriaLabel = () => {
    if (ariaLabel !== void 0) {
      const labelLeftString = labelLeft !== void 0 ? labelLeft : min2;
      const labelRightString = labelRight !== void 0 ? labelRight : max2;
      return `${ariaLabel}, from ${labelLeftString} to ${labelRightString}`;
    }
    return void 0;
  };
  const defaultGetAriaValueText = (value) => {
    if ((labelRight == null ? void 0 : labelRight.toLowerCase().includes("%")) || (labelLeft == null ? void 0 : labelLeft.toLowerCase().includes("%"))) {
      return `${value} percent`;
    }
    return `${value}`;
  };
  const reachSliderProps = {
    defaultValue: startingValue,
    disabled: isDisabled,
    value: controlledValue,
    "aria-label": getAriaLabel ? getAriaLabel(internalValue) : internalGetAriaLabel(),
    "aria-labelledby": ariaLabelledBy,
    getAriaLabel,
    getAriaValueText: getAriaValueText || defaultGetAriaValueText,
    handleAlignment,
    max: max2,
    min: min2,
    step,
    onChange: onChangeHandler,
    trackHeight: combinedProps.trackHeight,
    name,
    thumbStyle: combinedProps.thumbStyle
  };
  const trackProps = {
    disabled: isDisabled,
    inactiveColor: combinedProps.inactiveColor,
    activeColor: combinedProps.activeColor,
    trackHeight: combinedProps.trackHeight,
    disabledColor: combinedProps.disabledColor,
    ...selectStyledSystemProps(combinedProps, ["border"])
  };
  const feetProps = {
    disabled: isDisabled,
    feetHeight: combinedProps.feetHeight,
    feetWidth: combinedProps.feetWidth,
    activeColor: combinedProps.activeColor,
    inactiveColor: combinedProps.inactiveColor,
    disabledColor: combinedProps.disabledColor
  };
  const handleOnMouseUp = (e3) => {
    var _a3, _b;
    if (onMouseUp && !isMobileDevice2) {
      const newValue = Number((_b = (_a3 = e3 == null ? void 0 : e3.target) == null ? void 0 : _a3.attributes["data-value"]) == null ? void 0 : _b.value);
      if (newValue !== void 0 && newValue !== null && !Number.isNaN(newValue)) {
        onMouseUp({
          target: {
            value: newValue
          }
        });
      }
    }
  };
  const handleOnTouchEnd = (e3) => {
    var _a3, _b, _c;
    if (!onTouchEnd) {
      return;
    }
    const lookForCorrectElement = () => {
      var _a4, _b2, _c2;
      const {
        className
      } = e3.target;
      if (className.includes("slider-base")) {
        return e3.target;
      }
      if (className.includes("slider-track")) {
        return e3.target.parentElement;
      }
      if (className.includes("slider-filled-track") || className.includes("slider-thumb") || className.includes("slider-feet")) {
        return (_a4 = e3.target.parentElement) == null ? void 0 : _a4.parentElement;
      }
      if (className.includes("left-arrow") || className.includes("right-arrow")) {
        return (_c2 = (_b2 = e3.target.parentElement) == null ? void 0 : _b2.parentElement) == null ? void 0 : _c2.parentElement;
      }
      return e3.target;
    };
    const elementValue = (_c = (_b = (_a3 = lookForCorrectElement()) == null ? void 0 : _a3.attributes) == null ? void 0 : _b["data-value"]) == null ? void 0 : _c.value;
    const newValue = Number(elementValue);
    onTouchEnd({
      target: {
        value: newValue
      }
    });
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: /* @__PURE__ */ jsxRuntimeExports.jsxs(SliderContainer, { ...containerProps, labelPosition: combinedProps.labelPosition, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(StyledReachSliderInput, { ...reachSliderProps, className: "slider-base", "data-value": internalValue, onMouseUp: handleOnMouseUp, onTouchEnd: handleOnTouchEnd, "data-cy": "slider-track-container", handleAlignment: "contain", children: /* @__PURE__ */ jsxRuntimeExports.jsxs(SliderBackgroundTrack, { ...trackProps, className: "slider-track", children: [
      !combinedProps.hideFeet && /* @__PURE__ */ jsxRuntimeExports.jsx(SliderFeet, { ...feetProps, className: "slider-feet" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(SliderFilledTrack, { ...trackProps, className: "reach-slider-filled-track" }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs(SliderThumb, { ...combinedProps.thumbStyle, disabled: isDisabled, className: "reach-slider-thumb", "data-testid": name, "data-value": controlledValue, ref: forwardedRef, id: id2, sliderBound, ...props, children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(LeftArrow, { className: "slider-left-arrow", ...combinedProps.thumbStyle, disabled: isDisabled, onMouseDown: (e3) => handleArrowClick(e3, "ArrowLeft") }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(RightArrow, { className: "slider-right-arrow", ...combinedProps.thumbStyle, disabled: isDisabled, onMouseDown: (e3) => handleArrowClick(e3, "ArrowRight") })
      ] })
    ] }) }),
    (labelRight || labelLeft) && /* @__PURE__ */ jsxRuntimeExports.jsxs(LabelContainer, { ...themedProps == null ? void 0 : themedProps.labelStyle, ...labelStyle, "aria-hidden": true, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: labelLeft }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: labelRight })
    ] })
  ] }) });
});
SliderInput.displayName = "SliderInput";
const $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c = typeof document !== "undefined" ? React__default.useLayoutEffect : () => {
};
function $1dbecbe27a04f9af$export$14d238f342723f25(defaultValue) {
  let [value, setValue] = useState(defaultValue);
  let currValue = useRef(value);
  let effect2 = useRef(null);
  let nextRef = useRef(() => {
    if (!effect2.current) return;
    let newValue = effect2.current.next();
    if (newValue.done) {
      effect2.current = null;
      return;
    }
    if (currValue.current === newValue.value) nextRef.current();
    else setValue(newValue.value);
  });
  $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c(() => {
    currValue.current = value;
    if (effect2.current) nextRef.current();
  });
  let queue = useCallback((fn2) => {
    effect2.current = fn2(currValue.current);
    nextRef.current();
  }, [
    nextRef
  ]);
  return [
    value,
    queue
  ];
}
const $b5e257d569688ac6$var$defaultContext = {
  prefix: String(Math.round(Math.random() * 1e10)),
  current: 0
};
const $b5e257d569688ac6$var$SSRContext = /* @__PURE__ */ React__default.createContext($b5e257d569688ac6$var$defaultContext);
const $b5e257d569688ac6$var$IsSSRContext = /* @__PURE__ */ React__default.createContext(false);
let $b5e257d569688ac6$var$canUseDOM = Boolean(typeof window !== "undefined" && window.document && window.document.createElement);
let $b5e257d569688ac6$var$componentIds = /* @__PURE__ */ new WeakMap();
function $b5e257d569688ac6$var$useCounter(isDisabled = false) {
  let ctx = useContext($b5e257d569688ac6$var$SSRContext);
  let ref2 = useRef(null);
  if (ref2.current === null && !isDisabled) {
    var _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner, _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    let currentOwner = (_React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = React__default.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED) === null || _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED === void 0 ? void 0 : (_React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner = _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner) === null || _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner === void 0 ? void 0 : _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner.current;
    if (currentOwner) {
      let prevComponentValue = $b5e257d569688ac6$var$componentIds.get(currentOwner);
      if (prevComponentValue == null)
        $b5e257d569688ac6$var$componentIds.set(currentOwner, {
          id: ctx.current,
          state: currentOwner.memoizedState
        });
      else if (currentOwner.memoizedState !== prevComponentValue.state) {
        ctx.current = prevComponentValue.id;
        $b5e257d569688ac6$var$componentIds.delete(currentOwner);
      }
    }
    ref2.current = ++ctx.current;
  }
  return ref2.current;
}
function $b5e257d569688ac6$var$useLegacySSRSafeId(defaultId) {
  let ctx = useContext($b5e257d569688ac6$var$SSRContext);
  if (ctx === $b5e257d569688ac6$var$defaultContext && !$b5e257d569688ac6$var$canUseDOM && process.env.NODE_ENV !== "production") console.warn("When server rendering, you must wrap your application in an <SSRProvider> to ensure consistent ids are generated between the client and server.");
  let counter = $b5e257d569688ac6$var$useCounter(!!defaultId);
  let prefix2 = ctx === $b5e257d569688ac6$var$defaultContext && process.env.NODE_ENV === "test" ? "react-aria" : `react-aria${ctx.prefix}`;
  return defaultId || `${prefix2}-${counter}`;
}
function $b5e257d569688ac6$var$useModernSSRSafeId(defaultId) {
  let id2 = React__default.useId();
  let [didSSR] = useState($b5e257d569688ac6$export$535bd6ca7f90a273());
  let prefix2 = didSSR || process.env.NODE_ENV === "test" ? "react-aria" : `react-aria${$b5e257d569688ac6$var$defaultContext.prefix}`;
  return defaultId || `${prefix2}-${id2}`;
}
const $b5e257d569688ac6$export$619500959fc48b26 = typeof React__default["useId"] === "function" ? $b5e257d569688ac6$var$useModernSSRSafeId : $b5e257d569688ac6$var$useLegacySSRSafeId;
function $b5e257d569688ac6$var$getSnapshot() {
  return false;
}
function $b5e257d569688ac6$var$getServerSnapshot() {
  return true;
}
function $b5e257d569688ac6$var$subscribe(onStoreChange) {
  return () => {
  };
}
function $b5e257d569688ac6$export$535bd6ca7f90a273() {
  if (typeof React__default["useSyncExternalStore"] === "function") return React__default["useSyncExternalStore"]($b5e257d569688ac6$var$subscribe, $b5e257d569688ac6$var$getSnapshot, $b5e257d569688ac6$var$getServerSnapshot);
  return useContext($b5e257d569688ac6$var$IsSSRContext);
}
let $bdb11010cef70236$var$canUseDOM = Boolean(typeof window !== "undefined" && window.document && window.document.createElement);
let $bdb11010cef70236$export$d41a04c74483c6ef = /* @__PURE__ */ new Map();
let $bdb11010cef70236$var$registry;
if (typeof FinalizationRegistry !== "undefined") $bdb11010cef70236$var$registry = new FinalizationRegistry((heldValue) => {
  $bdb11010cef70236$export$d41a04c74483c6ef.delete(heldValue);
});
function $bdb11010cef70236$export$f680877a34711e37(defaultId) {
  let [value, setValue] = useState(defaultId);
  let nextId = useRef(null);
  let res = $b5e257d569688ac6$export$619500959fc48b26(value);
  let cleanupRef = useRef(null);
  if ($bdb11010cef70236$var$registry) $bdb11010cef70236$var$registry.register(cleanupRef, res);
  if ($bdb11010cef70236$var$canUseDOM) {
    const cacheIdRef = $bdb11010cef70236$export$d41a04c74483c6ef.get(res);
    if (cacheIdRef && !cacheIdRef.includes(nextId)) cacheIdRef.push(nextId);
    else $bdb11010cef70236$export$d41a04c74483c6ef.set(res, [
      nextId
    ]);
  }
  $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c(() => {
    let r2 = res;
    return () => {
      if ($bdb11010cef70236$var$registry) $bdb11010cef70236$var$registry.unregister(cleanupRef);
      $bdb11010cef70236$export$d41a04c74483c6ef.delete(r2);
    };
  }, [
    res
  ]);
  useEffect(() => {
    let newId = nextId.current;
    if (newId) setValue(newId);
    return () => {
      if (newId) nextId.current = null;
    };
  });
  return res;
}
function $bdb11010cef70236$export$b4cc09c592e8fdb8(depArray = []) {
  let id2 = $bdb11010cef70236$export$f680877a34711e37();
  let [resolvedId, setResolvedId] = $1dbecbe27a04f9af$export$14d238f342723f25(id2);
  let updateId = useCallback(() => {
    setResolvedId(function* () {
      yield id2;
      yield document.getElementById(id2) ? id2 : void 0;
    });
  }, [
    id2,
    setResolvedId
  ]);
  $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c(updateId, [
    id2,
    updateId,
    ...depArray
  ]);
  return resolvedId;
}
const $431fbd86ca7dc216$export$b204af158042fbac = (el) => {
  var _el_ownerDocument;
  return (_el_ownerDocument = el === null || el === void 0 ? void 0 : el.ownerDocument) !== null && _el_ownerDocument !== void 0 ? _el_ownerDocument : document;
};
const $431fbd86ca7dc216$export$f21a1ffae260145a = (el) => {
  if (el && "window" in el && el.window === el) return el;
  const doc = $431fbd86ca7dc216$export$b204af158042fbac(el);
  return doc.defaultView || window;
};
function $431fbd86ca7dc216$var$isNode(value) {
  return value !== null && typeof value === "object" && "nodeType" in value && typeof value.nodeType === "number";
}
function $431fbd86ca7dc216$export$af51f0f06c0f328a(node2) {
  return $431fbd86ca7dc216$var$isNode(node2) && node2.nodeType === Node.DOCUMENT_FRAGMENT_NODE && "host" in node2;
}
let $f4e2df6bd15f8569$var$_shadowDOM = false;
function $f4e2df6bd15f8569$export$98658e8c59125e6a() {
  return $f4e2df6bd15f8569$var$_shadowDOM;
}
function $d4ee10de306f2510$export$4282f70798064fe0(node2, otherNode) {
  if (!$f4e2df6bd15f8569$export$98658e8c59125e6a()) return otherNode && node2 ? node2.contains(otherNode) : false;
  if (!node2 || !otherNode) return false;
  let currentNode = otherNode;
  while (currentNode !== null) {
    if (currentNode === node2) return true;
    if (currentNode.tagName === "SLOT" && currentNode.assignedSlot)
      currentNode = currentNode.assignedSlot.parentNode;
    else if ($431fbd86ca7dc216$export$af51f0f06c0f328a(currentNode))
      currentNode = currentNode.host;
    else currentNode = currentNode.parentNode;
  }
  return false;
}
const $d4ee10de306f2510$export$cd4e5573fbe2b576 = (doc = document) => {
  var _activeElement_shadowRoot;
  if (!$f4e2df6bd15f8569$export$98658e8c59125e6a()) return doc.activeElement;
  let activeElement = doc.activeElement;
  while (activeElement && "shadowRoot" in activeElement && ((_activeElement_shadowRoot = activeElement.shadowRoot) === null || _activeElement_shadowRoot === void 0 ? void 0 : _activeElement_shadowRoot.activeElement)) activeElement = activeElement.shadowRoot.activeElement;
  return activeElement;
};
const $65484d02dcb7eb3e$var$DOMPropNames = /* @__PURE__ */ new Set([
  "id"
]);
const $65484d02dcb7eb3e$var$labelablePropNames = /* @__PURE__ */ new Set([
  "aria-label",
  "aria-labelledby",
  "aria-describedby",
  "aria-details"
]);
const $65484d02dcb7eb3e$var$linkPropNames = /* @__PURE__ */ new Set([
  "href",
  "hrefLang",
  "target",
  "rel",
  "download",
  "ping",
  "referrerPolicy"
]);
const $65484d02dcb7eb3e$var$globalAttrs = /* @__PURE__ */ new Set([
  "dir",
  "lang",
  "hidden",
  "inert",
  "translate"
]);
const $65484d02dcb7eb3e$var$globalEvents = /* @__PURE__ */ new Set([
  "onClick",
  "onAuxClick",
  "onContextMenu",
  "onDoubleClick",
  "onMouseDown",
  "onMouseEnter",
  "onMouseLeave",
  "onMouseMove",
  "onMouseOut",
  "onMouseOver",
  "onMouseUp",
  "onTouchCancel",
  "onTouchEnd",
  "onTouchMove",
  "onTouchStart",
  "onPointerDown",
  "onPointerMove",
  "onPointerUp",
  "onPointerCancel",
  "onPointerEnter",
  "onPointerLeave",
  "onPointerOver",
  "onPointerOut",
  "onGotPointerCapture",
  "onLostPointerCapture",
  "onScroll",
  "onWheel",
  "onAnimationStart",
  "onAnimationEnd",
  "onAnimationIteration",
  "onTransitionCancel",
  "onTransitionEnd",
  "onTransitionRun",
  "onTransitionStart"
]);
const $65484d02dcb7eb3e$var$propRe = /^(data-.*)$/;
function $65484d02dcb7eb3e$export$457c3d6518dd4c6f(props, opts = {}) {
  let { labelable, isLink, global: global2, events = global2, propNames } = opts;
  let filteredProps = {};
  for (const prop in props) if (Object.prototype.hasOwnProperty.call(props, prop) && ($65484d02dcb7eb3e$var$DOMPropNames.has(prop) || labelable && $65484d02dcb7eb3e$var$labelablePropNames.has(prop) || isLink && $65484d02dcb7eb3e$var$linkPropNames.has(prop) || global2 && $65484d02dcb7eb3e$var$globalAttrs.has(prop) || events && ($65484d02dcb7eb3e$var$globalEvents.has(prop) || prop.endsWith("Capture") && $65484d02dcb7eb3e$var$globalEvents.has(prop.slice(0, -7))) || (propNames === null || propNames === void 0 ? void 0 : propNames.has(prop)) || $65484d02dcb7eb3e$var$propRe.test(prop))) filteredProps[prop] = props[prop];
  return filteredProps;
}
function $7215afc6de606d6b$export$de79e2c695e052f3(element) {
  if ($7215afc6de606d6b$var$supportsPreventScroll()) element.focus({
    preventScroll: true
  });
  else {
    let scrollableElements = $7215afc6de606d6b$var$getScrollableElements(element);
    element.focus();
    $7215afc6de606d6b$var$restoreScrollPosition(scrollableElements);
  }
}
let $7215afc6de606d6b$var$supportsPreventScrollCached = null;
function $7215afc6de606d6b$var$supportsPreventScroll() {
  if ($7215afc6de606d6b$var$supportsPreventScrollCached == null) {
    $7215afc6de606d6b$var$supportsPreventScrollCached = false;
    try {
      let focusElem = document.createElement("div");
      focusElem.focus({
        get preventScroll() {
          $7215afc6de606d6b$var$supportsPreventScrollCached = true;
          return true;
        }
      });
    } catch {
    }
  }
  return $7215afc6de606d6b$var$supportsPreventScrollCached;
}
function $7215afc6de606d6b$var$getScrollableElements(element) {
  let parent = element.parentNode;
  let scrollableElements = [];
  let rootScrollingElement = document.scrollingElement || document.documentElement;
  while (parent instanceof HTMLElement && parent !== rootScrollingElement) {
    if (parent.offsetHeight < parent.scrollHeight || parent.offsetWidth < parent.scrollWidth) scrollableElements.push({
      element: parent,
      scrollTop: parent.scrollTop,
      scrollLeft: parent.scrollLeft
    });
    parent = parent.parentNode;
  }
  if (rootScrollingElement instanceof HTMLElement) scrollableElements.push({
    element: rootScrollingElement,
    scrollTop: rootScrollingElement.scrollTop,
    scrollLeft: rootScrollingElement.scrollLeft
  });
  return scrollableElements;
}
function $7215afc6de606d6b$var$restoreScrollPosition(scrollableElements) {
  for (let { element, scrollTop, scrollLeft } of scrollableElements) {
    element.scrollTop = scrollTop;
    element.scrollLeft = scrollLeft;
  }
}
function $c87311424ea30a05$var$testUserAgent(re) {
  var _window_navigator_userAgentData;
  if (typeof window === "undefined" || window.navigator == null) return false;
  let brands = (_window_navigator_userAgentData = window.navigator["userAgentData"]) === null || _window_navigator_userAgentData === void 0 ? void 0 : _window_navigator_userAgentData.brands;
  return Array.isArray(brands) && brands.some((brand) => re.test(brand.brand)) || re.test(window.navigator.userAgent);
}
function $c87311424ea30a05$var$testPlatform(re) {
  var _window_navigator_userAgentData;
  return typeof window !== "undefined" && window.navigator != null ? re.test(((_window_navigator_userAgentData = window.navigator["userAgentData"]) === null || _window_navigator_userAgentData === void 0 ? void 0 : _window_navigator_userAgentData.platform) || window.navigator.platform) : false;
}
function $c87311424ea30a05$var$cached(fn2) {
  if (process.env.NODE_ENV === "test") return fn2;
  let res = null;
  return () => {
    if (res == null) res = fn2();
    return res;
  };
}
const $c87311424ea30a05$export$9ac100e40613ea10 = $c87311424ea30a05$var$cached(function() {
  return $c87311424ea30a05$var$testPlatform(/^Mac/i);
});
const $c87311424ea30a05$export$186c6964ca17d99 = $c87311424ea30a05$var$cached(function() {
  return $c87311424ea30a05$var$testPlatform(/^iPhone/i);
});
const $c87311424ea30a05$export$7bef049ce92e4224 = $c87311424ea30a05$var$cached(function() {
  return $c87311424ea30a05$var$testPlatform(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
  $c87311424ea30a05$export$9ac100e40613ea10() && navigator.maxTouchPoints > 1;
});
const $c87311424ea30a05$export$fedb369cb70207f1 = $c87311424ea30a05$var$cached(function() {
  return $c87311424ea30a05$export$186c6964ca17d99() || $c87311424ea30a05$export$7bef049ce92e4224();
});
$c87311424ea30a05$var$cached(function() {
  return $c87311424ea30a05$export$9ac100e40613ea10() || $c87311424ea30a05$export$fedb369cb70207f1();
});
const $c87311424ea30a05$export$78551043582a6a98 = $c87311424ea30a05$var$cached(function() {
  return $c87311424ea30a05$var$testUserAgent(/AppleWebKit/i) && !$c87311424ea30a05$export$6446a186d09e379e();
});
const $c87311424ea30a05$export$6446a186d09e379e = $c87311424ea30a05$var$cached(function() {
  return $c87311424ea30a05$var$testUserAgent(/Chrome/i);
});
const $c87311424ea30a05$export$a11b0059900ceec8 = $c87311424ea30a05$var$cached(function() {
  return $c87311424ea30a05$var$testUserAgent(/Android/i);
});
const $c87311424ea30a05$export$b7d78993b74f766d = $c87311424ea30a05$var$cached(function() {
  return $c87311424ea30a05$var$testUserAgent(/Firefox/i);
});
function $ea8dcbcb9ea1b556$export$95185d699e05d4d7(target, modifiers, setOpening = true) {
  var _window_event_type, _window_event;
  let { metaKey, ctrlKey, altKey, shiftKey } = modifiers;
  if ($c87311424ea30a05$export$b7d78993b74f766d() && ((_window_event = window.event) === null || _window_event === void 0 ? void 0 : (_window_event_type = _window_event.type) === null || _window_event_type === void 0 ? void 0 : _window_event_type.startsWith("key")) && target.target === "_blank") {
    if ($c87311424ea30a05$export$9ac100e40613ea10()) metaKey = true;
    else ctrlKey = true;
  }
  let event = $c87311424ea30a05$export$78551043582a6a98() && $c87311424ea30a05$export$9ac100e40613ea10() && !$c87311424ea30a05$export$7bef049ce92e4224() && process.env.NODE_ENV !== "test" ? new KeyboardEvent("keydown", {
    keyIdentifier: "Enter",
    metaKey,
    ctrlKey,
    altKey,
    shiftKey
  }) : new MouseEvent("click", {
    metaKey,
    ctrlKey,
    altKey,
    shiftKey,
    detail: 1,
    bubbles: true,
    cancelable: true
  });
  $ea8dcbcb9ea1b556$export$95185d699e05d4d7.isOpening = setOpening;
  $7215afc6de606d6b$export$de79e2c695e052f3(target);
  target.dispatchEvent(event);
  $ea8dcbcb9ea1b556$export$95185d699e05d4d7.isOpening = false;
}
$ea8dcbcb9ea1b556$export$95185d699e05d4d7.isOpening = false;
let $bbed8b41f857bcc0$var$transitionsByElement = /* @__PURE__ */ new Map();
let $bbed8b41f857bcc0$var$transitionCallbacks = /* @__PURE__ */ new Set();
function $bbed8b41f857bcc0$var$setupGlobalEvents() {
  if (typeof window === "undefined") return;
  function isTransitionEvent(event) {
    return "propertyName" in event;
  }
  let onTransitionStart = (e3) => {
    if (!isTransitionEvent(e3) || !e3.target) return;
    let transitions2 = $bbed8b41f857bcc0$var$transitionsByElement.get(e3.target);
    if (!transitions2) {
      transitions2 = /* @__PURE__ */ new Set();
      $bbed8b41f857bcc0$var$transitionsByElement.set(e3.target, transitions2);
      e3.target.addEventListener("transitioncancel", onTransitionEnd, {
        once: true
      });
    }
    transitions2.add(e3.propertyName);
  };
  let onTransitionEnd = (e3) => {
    if (!isTransitionEvent(e3) || !e3.target) return;
    let properties2 = $bbed8b41f857bcc0$var$transitionsByElement.get(e3.target);
    if (!properties2) return;
    properties2.delete(e3.propertyName);
    if (properties2.size === 0) {
      e3.target.removeEventListener("transitioncancel", onTransitionEnd);
      $bbed8b41f857bcc0$var$transitionsByElement.delete(e3.target);
    }
    if ($bbed8b41f857bcc0$var$transitionsByElement.size === 0) {
      for (let cb of $bbed8b41f857bcc0$var$transitionCallbacks) cb();
      $bbed8b41f857bcc0$var$transitionCallbacks.clear();
    }
  };
  document.body.addEventListener("transitionrun", onTransitionStart);
  document.body.addEventListener("transitionend", onTransitionEnd);
}
if (typeof document !== "undefined") {
  if (document.readyState !== "loading") $bbed8b41f857bcc0$var$setupGlobalEvents();
  else document.addEventListener("DOMContentLoaded", $bbed8b41f857bcc0$var$setupGlobalEvents);
}
function $bbed8b41f857bcc0$var$cleanupDetachedElements() {
  for (const [eventTarget] of $bbed8b41f857bcc0$var$transitionsByElement)
    if ("isConnected" in eventTarget && !eventTarget.isConnected) $bbed8b41f857bcc0$var$transitionsByElement.delete(eventTarget);
}
function $bbed8b41f857bcc0$export$24490316f764c430(fn2) {
  requestAnimationFrame(() => {
    $bbed8b41f857bcc0$var$cleanupDetachedElements();
    if ($bbed8b41f857bcc0$var$transitionsByElement.size === 0) fn2();
    else $bbed8b41f857bcc0$var$transitionCallbacks.add(fn2);
  });
}
function $6a7db85432448f7f$export$60278871457622de(event) {
  if (event.pointerType === "" && event.isTrusted) return true;
  if ($c87311424ea30a05$export$a11b0059900ceec8() && event.pointerType) return event.type === "click" && event.buttons === 1;
  return event.detail === 0 && !event.pointerType;
}
let $8a9cb279dc87e130$export$fda7da73ab5d4c48 = false;
let $507fabe10e71c6fb$var$currentModality = null;
const $507fabe10e71c6fb$export$901e90a13c50a14e = /* @__PURE__ */ new Set();
let $507fabe10e71c6fb$export$d90243b58daecda7 = /* @__PURE__ */ new Map();
let $507fabe10e71c6fb$var$hasEventBeforeFocus = false;
let $507fabe10e71c6fb$var$hasBlurredWindowRecently = false;
function $507fabe10e71c6fb$var$triggerChangeHandlers(modality, e3) {
  for (let handler of $507fabe10e71c6fb$export$901e90a13c50a14e) handler(modality, e3);
}
function $507fabe10e71c6fb$var$isValidKey(e3) {
  return !(e3.metaKey || !$c87311424ea30a05$export$9ac100e40613ea10() && e3.altKey || e3.ctrlKey || e3.key === "Control" || e3.key === "Shift" || e3.key === "Meta");
}
function $507fabe10e71c6fb$var$handleKeyboardEvent(e3) {
  $507fabe10e71c6fb$var$hasEventBeforeFocus = true;
  if (!$ea8dcbcb9ea1b556$export$95185d699e05d4d7.isOpening && $507fabe10e71c6fb$var$isValidKey(e3)) {
    $507fabe10e71c6fb$var$currentModality = "keyboard";
    $507fabe10e71c6fb$var$triggerChangeHandlers("keyboard", e3);
  }
}
function $507fabe10e71c6fb$var$handlePointerEvent(e3) {
  $507fabe10e71c6fb$var$currentModality = "pointer";
  "pointerType" in e3 ? e3.pointerType : "mouse";
  if (e3.type === "mousedown" || e3.type === "pointerdown") {
    $507fabe10e71c6fb$var$hasEventBeforeFocus = true;
    $507fabe10e71c6fb$var$triggerChangeHandlers("pointer", e3);
  }
}
function $507fabe10e71c6fb$var$handleClickEvent(e3) {
  if (!$ea8dcbcb9ea1b556$export$95185d699e05d4d7.isOpening && $6a7db85432448f7f$export$60278871457622de(e3)) {
    $507fabe10e71c6fb$var$hasEventBeforeFocus = true;
    $507fabe10e71c6fb$var$currentModality = "virtual";
  }
}
function $507fabe10e71c6fb$var$handleFocusEvent(e3) {
  if (e3.target === window || e3.target === document || $8a9cb279dc87e130$export$fda7da73ab5d4c48 || !e3.isTrusted) return;
  if (!$507fabe10e71c6fb$var$hasEventBeforeFocus && !$507fabe10e71c6fb$var$hasBlurredWindowRecently) {
    $507fabe10e71c6fb$var$currentModality = "virtual";
    $507fabe10e71c6fb$var$triggerChangeHandlers("virtual", e3);
  }
  $507fabe10e71c6fb$var$hasEventBeforeFocus = false;
  $507fabe10e71c6fb$var$hasBlurredWindowRecently = false;
}
function $507fabe10e71c6fb$var$handleWindowBlur() {
  $507fabe10e71c6fb$var$hasEventBeforeFocus = false;
  $507fabe10e71c6fb$var$hasBlurredWindowRecently = true;
}
function $507fabe10e71c6fb$var$setupGlobalFocusEvents(element) {
  if (typeof window === "undefined" || typeof document === "undefined" || $507fabe10e71c6fb$export$d90243b58daecda7.get($431fbd86ca7dc216$export$f21a1ffae260145a(element))) return;
  const windowObject = $431fbd86ca7dc216$export$f21a1ffae260145a(element);
  const documentObject = $431fbd86ca7dc216$export$b204af158042fbac(element);
  let focus = windowObject.HTMLElement.prototype.focus;
  windowObject.HTMLElement.prototype.focus = function() {
    $507fabe10e71c6fb$var$hasEventBeforeFocus = true;
    focus.apply(this, arguments);
  };
  documentObject.addEventListener("keydown", $507fabe10e71c6fb$var$handleKeyboardEvent, true);
  documentObject.addEventListener("keyup", $507fabe10e71c6fb$var$handleKeyboardEvent, true);
  documentObject.addEventListener("click", $507fabe10e71c6fb$var$handleClickEvent, true);
  windowObject.addEventListener("focus", $507fabe10e71c6fb$var$handleFocusEvent, true);
  windowObject.addEventListener("blur", $507fabe10e71c6fb$var$handleWindowBlur, false);
  if (typeof PointerEvent !== "undefined") {
    documentObject.addEventListener("pointerdown", $507fabe10e71c6fb$var$handlePointerEvent, true);
    documentObject.addEventListener("pointermove", $507fabe10e71c6fb$var$handlePointerEvent, true);
    documentObject.addEventListener("pointerup", $507fabe10e71c6fb$var$handlePointerEvent, true);
  } else if (process.env.NODE_ENV === "test") {
    documentObject.addEventListener("mousedown", $507fabe10e71c6fb$var$handlePointerEvent, true);
    documentObject.addEventListener("mousemove", $507fabe10e71c6fb$var$handlePointerEvent, true);
    documentObject.addEventListener("mouseup", $507fabe10e71c6fb$var$handlePointerEvent, true);
  }
  windowObject.addEventListener("beforeunload", () => {
    $507fabe10e71c6fb$var$tearDownWindowFocusTracking(element);
  }, {
    once: true
  });
  $507fabe10e71c6fb$export$d90243b58daecda7.set(windowObject, {
    focus
  });
}
const $507fabe10e71c6fb$var$tearDownWindowFocusTracking = (element, loadListener) => {
  const windowObject = $431fbd86ca7dc216$export$f21a1ffae260145a(element);
  const documentObject = $431fbd86ca7dc216$export$b204af158042fbac(element);
  if (loadListener) documentObject.removeEventListener("DOMContentLoaded", loadListener);
  if (!$507fabe10e71c6fb$export$d90243b58daecda7.has(windowObject)) return;
  windowObject.HTMLElement.prototype.focus = $507fabe10e71c6fb$export$d90243b58daecda7.get(windowObject).focus;
  documentObject.removeEventListener("keydown", $507fabe10e71c6fb$var$handleKeyboardEvent, true);
  documentObject.removeEventListener("keyup", $507fabe10e71c6fb$var$handleKeyboardEvent, true);
  documentObject.removeEventListener("click", $507fabe10e71c6fb$var$handleClickEvent, true);
  windowObject.removeEventListener("focus", $507fabe10e71c6fb$var$handleFocusEvent, true);
  windowObject.removeEventListener("blur", $507fabe10e71c6fb$var$handleWindowBlur, false);
  if (typeof PointerEvent !== "undefined") {
    documentObject.removeEventListener("pointerdown", $507fabe10e71c6fb$var$handlePointerEvent, true);
    documentObject.removeEventListener("pointermove", $507fabe10e71c6fb$var$handlePointerEvent, true);
    documentObject.removeEventListener("pointerup", $507fabe10e71c6fb$var$handlePointerEvent, true);
  } else if (process.env.NODE_ENV === "test") {
    documentObject.removeEventListener("mousedown", $507fabe10e71c6fb$var$handlePointerEvent, true);
    documentObject.removeEventListener("mousemove", $507fabe10e71c6fb$var$handlePointerEvent, true);
    documentObject.removeEventListener("mouseup", $507fabe10e71c6fb$var$handlePointerEvent, true);
  }
  $507fabe10e71c6fb$export$d90243b58daecda7.delete(windowObject);
};
function $507fabe10e71c6fb$export$2f1888112f558a7d(element) {
  const documentObject = $431fbd86ca7dc216$export$b204af158042fbac(element);
  let loadListener;
  if (documentObject.readyState !== "loading") $507fabe10e71c6fb$var$setupGlobalFocusEvents(element);
  else {
    loadListener = () => {
      $507fabe10e71c6fb$var$setupGlobalFocusEvents(element);
    };
    documentObject.addEventListener("DOMContentLoaded", loadListener);
  }
  return () => $507fabe10e71c6fb$var$tearDownWindowFocusTracking(element, loadListener);
}
if (typeof document !== "undefined") $507fabe10e71c6fb$export$2f1888112f558a7d();
function $507fabe10e71c6fb$export$630ff653c5ada6a9() {
  return $507fabe10e71c6fb$var$currentModality;
}
function $3ad3f6e1647bc98d$export$80f3e147d781571c(element) {
  const ownerDocument = $431fbd86ca7dc216$export$b204af158042fbac(element);
  if ($507fabe10e71c6fb$export$630ff653c5ada6a9() === "virtual") {
    let lastFocusedElement = $d4ee10de306f2510$export$cd4e5573fbe2b576(ownerDocument);
    $bbed8b41f857bcc0$export$24490316f764c430(() => {
      const activeElement = $d4ee10de306f2510$export$cd4e5573fbe2b576(ownerDocument);
      if ((activeElement === lastFocusedElement || activeElement === ownerDocument.body) && element.isConnected) $7215afc6de606d6b$export$de79e2c695e052f3(element);
    });
  } else $7215afc6de606d6b$export$de79e2c695e052f3(element);
}
function $40df3f8667284809$export$d55e7ee900f34e93(props, ref2) {
  let { role = "dialog" } = props;
  let titleId = $bdb11010cef70236$export$b4cc09c592e8fdb8();
  titleId = props["aria-label"] ? void 0 : titleId;
  let isRefocusing = useRef(false);
  useEffect(() => {
    if (ref2.current && !$d4ee10de306f2510$export$4282f70798064fe0(ref2.current, document.activeElement)) {
      $3ad3f6e1647bc98d$export$80f3e147d781571c(ref2.current);
      let timeout2 = setTimeout(() => {
        if (document.activeElement === ref2.current || document.activeElement === document.body) {
          isRefocusing.current = true;
          if (ref2.current) {
            ref2.current.blur();
            $3ad3f6e1647bc98d$export$80f3e147d781571c(ref2.current);
          }
          isRefocusing.current = false;
        }
      }, 500);
      return () => {
        clearTimeout(timeout2);
      };
    }
  }, [
    ref2
  ]);
  $337b884510726a0d$export$14c98a7594375490();
  return {
    dialogProps: {
      ...$65484d02dcb7eb3e$export$457c3d6518dd4c6f(props, {
        labelable: true
      }),
      role,
      tabIndex: -1,
      "aria-labelledby": props["aria-labelledby"] || titleId,
      // Prevent blur events from reaching useOverlay, which may cause
      // popovers to close. Since focus is contained within the dialog,
      // we don't want this to occur due to the above useEffect.
      onBlur: (e3) => {
        if (isRefocusing.current) e3.stopPropagation();
      }
    },
    titleProps: {
      id: titleId
    }
  };
}
var getDefaultParent = function(originalTarget) {
  if (typeof document === "undefined") {
    return null;
  }
  var sampleTarget = Array.isArray(originalTarget) ? originalTarget[0] : originalTarget;
  return sampleTarget.ownerDocument.body;
};
var counterMap = /* @__PURE__ */ new WeakMap();
var uncontrolledNodes = /* @__PURE__ */ new WeakMap();
var markerMap = {};
var lockCount = 0;
var unwrapHost = function(node2) {
  return node2 && (node2.host || unwrapHost(node2.parentNode));
};
var correctTargets = function(parent, targets) {
  return targets.map(function(target) {
    if (parent.contains(target)) {
      return target;
    }
    var correctedTarget = unwrapHost(target);
    if (correctedTarget && parent.contains(correctedTarget)) {
      return correctedTarget;
    }
    console.error("aria-hidden", target, "in not contained inside", parent, ". Doing nothing");
    return null;
  }).filter(function(x2) {
    return Boolean(x2);
  });
};
var applyAttributeToOthers = function(originalTarget, parentNode, markerName, controlAttribute) {
  var targets = correctTargets(parentNode, Array.isArray(originalTarget) ? originalTarget : [originalTarget]);
  if (!markerMap[markerName]) {
    markerMap[markerName] = /* @__PURE__ */ new WeakMap();
  }
  var markerCounter = markerMap[markerName];
  var hiddenNodes = [];
  var elementsToKeep = /* @__PURE__ */ new Set();
  var elementsToStop = new Set(targets);
  var keep = function(el) {
    if (!el || elementsToKeep.has(el)) {
      return;
    }
    elementsToKeep.add(el);
    keep(el.parentNode);
  };
  targets.forEach(keep);
  var deep = function(parent) {
    if (!parent || elementsToStop.has(parent)) {
      return;
    }
    Array.prototype.forEach.call(parent.children, function(node2) {
      if (elementsToKeep.has(node2)) {
        deep(node2);
      } else {
        try {
          var attr = node2.getAttribute(controlAttribute);
          var alreadyHidden = attr !== null && attr !== "false";
          var counterValue = (counterMap.get(node2) || 0) + 1;
          var markerValue = (markerCounter.get(node2) || 0) + 1;
          counterMap.set(node2, counterValue);
          markerCounter.set(node2, markerValue);
          hiddenNodes.push(node2);
          if (counterValue === 1 && alreadyHidden) {
            uncontrolledNodes.set(node2, true);
          }
          if (markerValue === 1) {
            node2.setAttribute(markerName, "true");
          }
          if (!alreadyHidden) {
            node2.setAttribute(controlAttribute, "true");
          }
        } catch (e3) {
          console.error("aria-hidden: cannot operate on ", node2, e3);
        }
      }
    });
  };
  deep(parentNode);
  elementsToKeep.clear();
  lockCount++;
  return function() {
    hiddenNodes.forEach(function(node2) {
      var counterValue = counterMap.get(node2) - 1;
      var markerValue = markerCounter.get(node2) - 1;
      counterMap.set(node2, counterValue);
      markerCounter.set(node2, markerValue);
      if (!counterValue) {
        if (!uncontrolledNodes.has(node2)) {
          node2.removeAttribute(controlAttribute);
        }
        uncontrolledNodes.delete(node2);
      }
      if (!markerValue) {
        node2.removeAttribute(markerName);
      }
    });
    lockCount--;
    if (!lockCount) {
      counterMap = /* @__PURE__ */ new WeakMap();
      counterMap = /* @__PURE__ */ new WeakMap();
      uncontrolledNodes = /* @__PURE__ */ new WeakMap();
      markerMap = {};
    }
  };
};
var hideOthers = function(originalTarget, parentNode, markerName) {
  if (markerName === void 0) {
    markerName = "data-aria-hidden";
  }
  var targets = Array.from(Array.isArray(originalTarget) ? originalTarget : [originalTarget]);
  var activeParentNode = parentNode || getDefaultParent(originalTarget);
  if (!activeParentNode) {
    return function() {
      return null;
    };
  }
  targets.push.apply(targets, Array.from(activeParentNode.querySelectorAll("[aria-live]")));
  return applyAttributeToOthers(targets, activeParentNode, markerName, "aria-hidden");
};
const $0ba7c906f8d7a5d9$var$currentDocument = typeof document !== "undefined" ? document : void 0;
function $0ba7c906f8d7a5d9$export$11dddb85aae73809(selector = "body", { document: document1 = $0ba7c906f8d7a5d9$var$currentDocument } = {}) {
  if (!document1) return () => {
  };
  let target = document1.querySelector(selector);
  if (!target) return () => {
  };
  let config2 = {
    childList: true
  };
  let modalContainers = [];
  let undo;
  let observer = new MutationObserver((mutationRecord) => {
    const liveAnnouncer = document1.querySelector('[data-live-announcer="true"]');
    for (let mutation of mutationRecord) {
      if (mutation.type === "childList" && mutation.addedNodes.length > 0) {
        let addNode = Array.from(mutation.addedNodes).find((node2) => {
          var _node_querySelector;
          return (_node_querySelector = node2.querySelector) === null || _node_querySelector === void 0 ? void 0 : _node_querySelector.call(node2, '[aria-modal="true"], [data-ismodal="true"]');
        });
        if (addNode) {
          modalContainers.push(addNode);
          let modal = addNode.querySelector('[aria-modal="true"], [data-ismodal="true"]');
          undo === null || undo === void 0 ? void 0 : undo();
          let others = [
            modal,
            ...liveAnnouncer ? [
              liveAnnouncer
            ] : []
          ];
          undo = hideOthers(others);
        }
      } else if (mutation.type === "childList" && mutation.removedNodes.length > 0) {
        let removedNodes = Array.from(mutation.removedNodes);
        let nodeIndexRemove = modalContainers.findIndex((container) => removedNodes.includes(container));
        if (nodeIndexRemove >= 0) {
          undo === null || undo === void 0 ? void 0 : undo();
          modalContainers = modalContainers.filter((val, i) => i !== nodeIndexRemove);
          if (modalContainers.length > 0) {
            let modal = modalContainers[modalContainers.length - 1].querySelector('[aria-modal="true"], [data-ismodal="true"]');
            let others = [
              modal,
              ...liveAnnouncer ? [
                liveAnnouncer
              ] : []
            ];
            undo = hideOthers(others);
          } else undo = void 0;
        }
      }
    }
  });
  observer.observe(target, config2);
  return () => {
    undo === null || undo === void 0 ? void 0 : undo();
    observer.disconnect();
  };
}
if (typeof window !== "undefined") {
  $0ba7c906f8d7a5d9$export$11dddb85aae73809();
}
let savedScrollPosition = 0;
const applyIOSBodyFix = () => {
  if (typeof window === "undefined") return;
  savedScrollPosition = window.pageYOffset || document.documentElement.scrollTop;
  window.scrollTo(0, 0);
  document.body.style.position = "fixed";
  document.body.style.width = "100%";
  document.body.style.top = "0px";
};
const removeIOSBodyFix = () => {
  if (typeof window === "undefined") return;
  document.body.style.position = "";
  document.body.style.width = "";
  document.body.style.top = "";
  window.scrollTo(0, savedScrollPosition);
};
const ModalBackdrop = styled.div`
  position: fixed;
  z-index: 100;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  /* allow scrolling when it's too big */
  overflow: auto;
  background-color: ${(props) => curriedTransparentize$1(1 - (props.backdropOpacity || 0), props.backdropColor || "gray")};
`;
const ModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  overflow: auto;
  background: white;
  /* This number is a bit arbitrary but can always be overridden by consumers. */
  z-index: 101;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  max-height: 85vh;
  max-width: 100vw;
  border-radius: 10px;
  /* Center content */
  margin: auto;

  /* Our mobile version of the modal comes built in with the concept of sticking
     to the bottom instead of the center of the screen. Here we add some styles for that.
     This is something that currently lives outside of a "themed" mindset
     and is considered standard behavior for all modals across all themes */
  @media (max-width: ${BREAKPOINTS.sm}) {
    width: 100%;
    max-height: calc(100vh - ${(props) => props.bottomOffset ?? 0}px - 20px);
    top: auto;
    /* props.bottomOffset means the keyboard is pushing the modal up, so we need to set the bottom to auto, otherwise set it to 0px */
    bottom: ${(props) => props.bottomOffset ? "auto" : "0px"};
    transform: translateX(-50%);
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
  }
  ${composeWrapper([space, color, typography, layout, flexbox, grid, background, border, position$1, shadow], [])};

  @media (max-width: ${BREAKPOINTS.sm}) {
    max-height: 90vh;
  }
`;
const ModalCloseButton = styled(Button)`
  position: absolute;
  top: ${(props) => props.closeButtonMargin};
  right: ${(props) => props.closeButtonMargin};
  height: ${(props) => props.closeButtonSize};
  width: ${(props) => props.closeButtonSize};
  background-color: white;
  box-sizing: border-box;
  padding: 0;
  border: none;
  margin: 0;
  border-radius: 50%;
  display: ${(props) => props.showCloseButton ? "flex" : "none"};
  align-items: center;
  justify-content: center;
`;
const ModalTitleElement = styled.div`
  padding: 28px 48px 8px 20px;
  ${compose(space, color, typography, layout, flexbox, grid, background, border, position$1, shadow)}
`;
const ModalTitle = forwardRef(({
  size: size2,
  ...rest
}, ref2) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(ModalTitleElement, { ...rest, ref: ref2 });
});
ModalTitle.displayName = "ModalTitle";
const ScrollShadowTop = styled.div`
  position: sticky;
  top: -1px;
  left: 0;
  right: 0;
  height: 8px;
  background: linear-gradient(to bottom, rgba(0, 0, 0, 0.1), transparent);
  opacity: ${(props) => props.show ? 1 : 0};
  transition: opacity 0.2s;
  pointer-events: none;
  z-index: 1;
`;
const ScrollShadowBottom = styled.div`
  position: sticky;
  bottom: -1px;
  left: 0;
  right: 0;
  height: ${(props) => props.show ? "8px" : "0px"};
  background: linear-gradient(to top, rgba(0, 0, 0, 0.1), transparent);
  opacity: ${(props) => props.show ? 1 : 0};
  transition: opacity 0.2s;
  pointer-events: none;
  z-index: 1;
`;
const ModalBodyWrapper = styled.div`
  position: relative;
  max-height: 100%;
  overflow: auto;

  &:focus-visible {
    outline: 2px solid var(${TOKENS.color.border.focus});
    outline-offset: 2px;
  }
`;
const ModalBodyElement = styled.div`
  position: relative;
  padding: 8px 20px 16px 20px;
  ${compose(space, color, typography, layout, flexbox, grid, background, border, position$1, shadow)}
`;
const ModalBody = forwardRef((props, ref2) => {
  const [showTopShadow, setShowTopShadow] = useState(false);
  const [showBottomShadow, setShowBottomShadow] = useState(false);
  const wrapperRef = useRef(null);
  const updateShadows = () => {
    if (wrapperRef.current) {
      const target = wrapperRef.current;
      const hasTopShadow = target.scrollTop > 0;
      const hasBottomShadow = target.scrollTop < target.scrollHeight - target.clientHeight - 1;
      setShowTopShadow(hasTopShadow);
      setShowBottomShadow(hasBottomShadow);
    }
  };
  const handleScroll = () => {
    updateShadows();
  };
  useEffect(() => {
    if (wrapperRef.current) {
      const resizeObserver = new index$3(() => {
        updateShadows();
      });
      resizeObserver.observe(wrapperRef.current);
      return () => {
        resizeObserver.disconnect();
      };
    }
    return void 0;
  }, []);
  useEffect(() => {
    updateShadows();
  }, []);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(ModalBodyWrapper, { ref: wrapperRef, onScroll: handleScroll, tabIndex: 0, role: "region", "aria-label": "Modal content", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(ScrollShadowTop, { id: "ScrollShadowTop", show: showTopShadow }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(ModalBodyElement, { id: "ModalBody", ...props, ref: ref2, children: props.children }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(ScrollShadowBottom, { id: "ScrollShadowBottom", show: showBottomShadow })
  ] });
});
ModalBody.displayName = "ModalBody";
const ModalFooterElement = styled.div`
  padding: 16px 20px 24px 20px;
  ${compose(space, color, typography, layout, flexbox, grid, background, border, position$1, shadow)}
`;
const ModalFooter = forwardRef((props, ref2) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(ModalFooterElement, { ...props, ref: ref2 });
});
ModalFooter.displayName = "ModalFooter";
const Modal = forwardRef(({
  children,
  isDismissable = true,
  isKeyboardDismissDisabled = false,
  onClose,
  isUnderlayClickDismissDisabled = false,
  closeButtonMargin,
  closeButtonVariant,
  closeButtonSize,
  showCloseButton = true,
  ...rest
}, forwardedRef) => {
  const [bottomViewportOffset, setBottomViewportOffset] = useState(0);
  const backupModalRef = useRef(null);
  const modalRef = forwardedRef && typeof forwardedRef !== "function" ? forwardedRef : backupModalRef;
  const {
    overlayProps,
    underlayProps
  } = $a11501f3d1d39e6c$export$ea8f71083e90600f({
    isOpen: true,
    // Modal "open" status is managed higher up. If the modal is rendering, it's assumed to be open.
    isDismissable,
    isKeyboardDismissDisabled,
    onClose: () => {
      if (onClose && isDismissable) {
        onClose();
      }
    },
    // This is a function that allows you to check for which element is clicked outside the modal
    // We don't have any use cases where we care what they click on outside, just so long as they click outside
    shouldCloseOnInteractOutside: () => !isUnderlayClickDismissDisabled
  }, modalRef);
  $49c51c25361d4cd2$export$ee0f7cc6afcd1c18();
  const {
    modalProps: modalAriaProps
  } = $f57aed4a881a3485$export$33ffd74ebf07f060();
  const {
    dialogProps: dialogAriaProps
  } = $40df3f8667284809$export$d55e7ee900f34e93({
    role: "dialog"
  }, modalRef);
  useEffect(() => {
    var _a2, _b;
    function handleViewportChange() {
      const {
        visualViewport
      } = window;
      if (window.innerHeight !== (visualViewport == null ? void 0 : visualViewport.height) && window.innerWidth) {
        setBottomViewportOffset(window.innerHeight - ((visualViewport == null ? void 0 : visualViewport.height) ?? 0));
      } else {
        setBottomViewportOffset(0);
      }
    }
    const isIos = ((_a2 = detect(navigator.userAgent)) == null ? void 0 : _a2.os) === "iOS";
    const shouldAddListener = isIos && window.visualViewport;
    if (shouldAddListener) {
      (_b = window.visualViewport) == null ? void 0 : _b.addEventListener("resize", handleViewportChange);
    }
    return () => {
      var _a3;
      if (shouldAddListener) {
        (_a3 = window.visualViewport) == null ? void 0 : _a3.removeEventListener("resize", handleViewportChange);
      }
    };
  }, []);
  useEffect(() => {
    var _a2;
    const isIos = ((_a2 = detect(navigator.userAgent)) == null ? void 0 : _a2.os) === "iOS";
    if (isIos) {
      applyIOSBodyFix();
      return removeIOSBodyFix;
    }
    return void 0;
  }, []);
  return /* @__PURE__ */ jsxRuntimeExports.jsx($f57aed4a881a3485$export$b47c3594eab58386, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(ModalBackdrop, { ...underlayProps, backdropColor: "#000000", backdropOpacity: 0.6, "data-testid": "modalBackdrop", children: /* @__PURE__ */ jsxRuntimeExports.jsx($9bf71ea28793e738$export$20e40289641fbbb6, { contain: true, restoreFocus: true, autoFocus: true, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(ModalContainer, { ...overlayProps, ...dialogAriaProps, ...modalAriaProps, "aria-modal": "true", width: "640px", ...rest, ref: (modalElementRef) => {
    if (typeof forwardedRef === "function") {
      forwardedRef(modalElementRef);
      backupModalRef.current = modalElementRef;
    } else {
      modalRef.current = modalElementRef;
    }
  }, bottomOffset: bottomViewportOffset, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      ModalCloseButton,
      {
        showCloseButton,
        variant: closeButtonVariant || "outline",
        onClick: () => {
          if (isDismissable && onClose) {
            onClose();
          }
        },
        onTouchEnd: () => {
          if (isDismissable && onClose) {
            onClose();
          }
        },
        "aria-label": "Dismiss the modal dialog",
        disabled: !isDismissable,
        closeButtonSize: "36px",
        closeButtonMargin: "12px",
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(CloseIcon, { size: "sm" })
      }
    ),
    children
  ] }) }) }) });
});
Modal.displayName = "Modal";
const TableColumnEditorWrapper = styled.div`
  position: fixed;
  z-index: 2;
  border-radius: 3px;
  box-shadow: 0 3px 10px 0 rgba(0, 0, 0, 0.08), 0 0 2px 0 rgba(0, 0, 0, 0.2);
  width: 304px;
  height: 46vh;
  display: flex;
  flex-direction: column;
  background: #fff;
  /* CSS handles positioning calculations */
  top: calc(var(--trigger-top, 0px) + 40px);
  left: calc(var(--trigger-left, 0px) - 268px);
`;
const EditorHeader = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 16px 16px 12px;
  align-items: flex-start;
  border-bottom: 1px solid var(${TOKENS.color.background.surface2});
`;
const EditorHeaderLeftSide = styled.div`
  display: flex;
  flex-direction: column;
`;
const EditorBody = styled.div`
  overflow-y: auto;
  height: 100%;
  overscroll-behavior: contain;
`;
const EditorFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 16px;
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.1), 0 0 1px 0 rgba(0, 0, 0, 0.25);
  height: 64px;
`;
const BodyHeader = styled.div`
  padding: 8px 16px;
`;
const CheckboxContainer = styled.div`
  flex-grow: 1;
`;
const TableColumnEditor = forwardRef(({
  columns,
  defaultColumnState,
  triggerRef,
  onClose,
  onConfirm,
  lockedColumns = []
}, ref2) => {
  const [columnDisplayState, setColumnDisplayState] = useState(columns);
  const internalRef = useRef(null);
  useImperativeHandle(ref2, () => internalRef.current, []);
  const numHiddenColumns = Object.entries(columnDisplayState).reduce((acc, [_columnName, isDisplayed]) => {
    if (!isDisplayed) {
      return acc + 1;
    }
    return acc;
  }, 0);
  useEffect(() => {
    const updateTriggerPosition = () => {
      if ((triggerRef == null ? void 0 : triggerRef.current) && internalRef.current) {
        const rect = triggerRef.current.getBoundingClientRect();
        internalRef.current.style.setProperty("--trigger-top", `${rect.top}px`);
        internalRef.current.style.setProperty("--trigger-left", `${rect.left}px`);
      }
    };
    updateTriggerPosition();
    window.addEventListener("scroll", updateTriggerPosition, true);
    window.addEventListener("resize", updateTriggerPosition);
    return () => {
      window.removeEventListener("scroll", updateTriggerPosition, true);
      window.removeEventListener("resize", updateTriggerPosition);
    };
  }, [triggerRef]);
  const onColumnSelectHandler = (e3, columnName) => {
    if (lockedColumns.includes(columnName)) return;
    const newColumnState = {
      ...columnDisplayState
    };
    newColumnState[columnName] = e3.target.checked;
    setColumnDisplayState(newColumnState);
  };
  const onReset = () => {
    const lockedOverrides = Object.fromEntries(lockedColumns.map((col) => [col, true]));
    const resetState = {
      ...defaultColumnState,
      ...lockedOverrides
    };
    setColumnDisplayState(resetState);
    onConfirm(resetState);
    onClose();
  };
  const handleConfirm = () => {
    onConfirm(columnDisplayState);
    onClose();
  };
  const editorContent = /* @__PURE__ */ jsxRuntimeExports.jsxs(TableColumnEditorWrapper, { ref: internalRef, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs(EditorHeader, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs(EditorHeaderLeftSide, { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(Text, { element: "h2", variant: "headerSmall.responsive", color: `var(${TOKENS.color.foreground.primary})`, children: "Table editor" }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs(Text, { element: "h2", variant: "disclaimerSmall.responsive", color: `var(${TOKENS.color.foreground.subdued})`, style: {
          display: "flex",
          alignItems: "center",
          gap: "4px"
        }, children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(EyeClosedIcon, { size: "sm", fill: `var(${TOKENS.color.foreground.subdued})` }),
          `${numHiddenColumns} hidden columns`
        ] })
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs(LinkButton, { style: {
        gap: "4px"
      }, onClick: onReset, children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(LoadingIcon, { size: "md" }),
        "Reset"
      ] })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(EditorBody, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(BodyHeader, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(Text, { element: "h2", variant: "headerXSmall.responsive", children: "Displayed columns" }) }),
      Object.entries(columnDisplayState).map(([columnName, isDisplayed]) => {
        const isLocked = lockedColumns.includes(columnName);
        return /* @__PURE__ */ jsxRuntimeExports.jsx(MenuItem, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(CheckboxContainer, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(CheckboxInput, { id: columnName, value: columnName, checked: isDisplayed, disabled: isLocked, onChange: (e3) => {
          onColumnSelectHandler(e3, columnName);
        }, children: columnName }) }) }, columnName);
      })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(EditorFooter, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(Button, { width: "100%", onClick: handleConfirm, children: "Done" }) })
  ] });
  return createPortal(editorContent, document.body);
});
TableColumnEditor.displayName = "TableColumnEditor";
const ColumnMenuWrapper = styled.div`
  position: relative;
`;
const TableColumnEditorDropdown = forwardRef(function TableColumnEditorDropdownInner({
  columns,
  defaultColumnState,
  onConfirm,
  lockedColumns
}, fwdRef) {
  const [isColumnMenuOpen, toggleColumnMenu] = useState(false);
  const menuRef = useRef(null);
  const triggerRef = useRef(null);
  const editorRef = useRef(null);
  useEffect(() => {
    const handleClickOutside = (event) => {
      var _a2, _b;
      const clickedInsideMenu = (_a2 = menuRef.current) == null ? void 0 : _a2.contains(event.target);
      const clickedInsideEditor = (_b = editorRef.current) == null ? void 0 : _b.contains(event.target);
      if (!clickedInsideMenu && !clickedInsideEditor) {
        toggleColumnMenu(false);
      }
    };
    if (isColumnMenuOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isColumnMenuOpen]);
  const onClickHandler = () => {
    toggleColumnMenu(!isColumnMenuOpen);
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(ColumnMenuWrapper, { ref: fwdRef ?? menuRef, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { ref: triggerRef, children: /* @__PURE__ */ jsxRuntimeExports.jsx(IconButton, { onClick: onClickHandler, variant: "ghost", height: "32px", width: "32px", children: /* @__PURE__ */ jsxRuntimeExports.jsx(GearIcon, { size: "sm" }) }) }),
    isColumnMenuOpen && /* @__PURE__ */ jsxRuntimeExports.jsx(TableColumnEditor, { onClose: () => toggleColumnMenu(false), columns, defaultColumnState, onConfirm, lockedColumns, triggerRef, ref: editorRef })
  ] });
});
TableColumnEditorDropdown.displayName = "TableColumnEditorDropdown";
const TAB_GAP = 24;
function useTabOverflow({
  containerRef,
  tabRefs,
  moreButtonRef,
  enabled
}) {
  const [visibleCount, setVisibleCount] = useState(tabRefs.length);
  const calculate = useCallback(() => {
    var _a2, _b;
    const container = containerRef.current;
    if (!container || !enabled || tabRefs.length === 0) {
      setVisibleCount(tabRefs.length);
      return;
    }
    const containerWidth = container.offsetWidth;
    const moreButtonWidth = ((_a2 = moreButtonRef.current) == null ? void 0 : _a2.offsetWidth) ?? 0;
    let usedWidth = 0;
    let fitCount = 0;
    for (let i = 0; i < tabRefs.length; i++) {
      const tab = (_b = tabRefs[i]) == null ? void 0 : _b.current;
      if (tab) {
        const tabWidth = tab.offsetWidth;
        const widthWithGap = i === 0 ? tabWidth : tabWidth + TAB_GAP;
        const projectedWidth = usedWidth + widthWithGap + TAB_GAP + moreButtonWidth;
        if (projectedWidth > containerWidth && i < tabRefs.length - 1) {
          break;
        }
        usedWidth += widthWithGap;
        fitCount++;
      }
    }
    if (fitCount < tabRefs.length) {
      setVisibleCount(fitCount);
    } else {
      setVisibleCount(tabRefs.length);
    }
  }, [containerRef, tabRefs, moreButtonRef, enabled]);
  useEffect(() => {
    if (!enabled) {
      setVisibleCount(tabRefs.length);
      return void 0;
    }
    const container = containerRef.current;
    if (!container) return void 0;
    calculate();
    const observer = new ResizeObserver(() => {
      calculate();
    });
    observer.observe(container);
    return () => {
      observer.disconnect();
    };
  }, [containerRef, enabled, calculate, tabRefs.length]);
  return {
    visibleCount
  };
}
const StyledDashboardTabs = styled.div`
  ${({
  dividerFullWidth
}) => css$3`
    margin-top: 32px;
    display: flex;
    height: 56px;
    box-sizing: border-box;
    flex-direction: row;
    gap: 24px;
    width: ${dividerFullWidth ? "100%" : "fit-content"};
    position: relative;

    /* This pseudo-element is used to create a bottom border that spans the entire width of the tab navigation */
    &::after {
      content: "";
      position: absolute;
      bottom: 0px;
      left: 0px;
      right: 0px; /* this matches the padding of the tabs so the border is flush with the end of the last tab (if dividerFullWidth is false) */
      height: 1px;
      background-color: var(${TOKENS.color.border.default});
      z-index: 0; /* Ensure tab's ::after border is above this one */
    }
  `}
`;
const StyledTab = styled.button`
  background: none;
  cursor: pointer;
  box-sizing: border-box;
  position: relative;
  border: none;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
  height: 56px;
  padding: 1px 0px;

  /* Default styles (inactive state) */
  color: var(${TOKENS.color.foreground.default});
  fill: var(${TOKENS.color.foreground.default});

  /* Default pseudo-element style (inactive) */
  &::after {
    content: "";
    position: absolute;
    bottom: 0;
    left: 0px; /* this matches the padding of the tab so the border is flush with the tab */
    right: 0px; /* this matches the padding of the tab so the border is flush with the tab */
    height: 3px;
    background-color: transparent; /* Default inactive border is transparent */
    z-index: 1;
  }

  // Hover styles (apply regardless of active state, but not when disabled)
  &:hover:not(:disabled) {
    color: var(${TOKENS.color.foreground.interaction.accentHover});
    fill: var(${TOKENS.color.foreground.interaction.accentHover});
  }

  &:active:not(:disabled) {
    color: var(${TOKENS.color.foreground.interaction.accentActive});
    fill: var(${TOKENS.color.foreground.interaction.accentActive});
    &::after {
      background-color: var(
        ${TOKENS.color.foreground.interaction.accentActive}
      );
    }
  }

  &:disabled {
    cursor: not-allowed;
    color: var(${TOKENS.color.foreground.interaction.disabled});
    fill: var(${TOKENS.color.foreground.interaction.disabled});
    &::after {
      background-color: transparent; /* Ensure border is hidden when disabled */
    }
  }

  ${(_props) => composeWrapper([color, layout, flexbox, space, typography, border, position$1, shadow, svg], [Pseudostate.hover, Pseudostate.active, Pseudostate.disabled])}

  ${(props) => FocusRing({
  ...props.focusRingStyle
})}

  /* --- Apply isActive styles LAST to override defaults/props --- */
  ${({
  isActive
}) => isActive && css$3`
      /* Override color/fill for the active state */
      color: var(${TOKENS.color.foreground.interaction.accent});
      fill: var(${TOKENS.color.foreground.interaction.accent});
      /* Set the border color for the active state */
      &::after {
        background-color: var(${TOKENS.color.foreground.interaction.accent});
      }
      // Re-apply active:not(:disabled) styles specific to an already active tab
      // to ensure the ::after color persists correctly during press
      &:active:not(:disabled) {
        &::after {
          background-color: var(
            ${TOKENS.color.foreground.interaction.accentActive}
          );
        }
      }
    `}
`;
const Tab$1 = forwardRef(({
  isActive,
  type: type2 = "button",
  children,
  ...rest
  // Default HTML button props & styled system props
}, ref2) => /* @__PURE__ */ jsxRuntimeExports.jsx(StyledTab, { role: "tab", "aria-selected": Boolean(isActive), ref: ref2, type: type2, isActive, ...rest, children }));
Tab$1.displayName = "Tab";
const MoreButtonWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  flex-shrink: 0;
`;
const HiddenMeasure = styled.div`
  position: absolute;
  visibility: hidden;
  pointer-events: none;
  height: 0;
  overflow: hidden;
`;
const v$5 = (token2) => `var(${token2})`;
const TAB_NAVIGATION_STYLE = {
  fontFamily: v$5(TOKENS.text.fontFamily.primary),
  fontWeight: v$5(TOKENS.text.fontWeight.header),
  fontSize: "0.875rem",
  lineHeight: "140%",
  letterSpacing: "0em",
  color: v$5(TOKENS.color.foreground.default),
  fill: v$5(TOKENS.color.foreground.interaction.accent),
  hoverStyle: {
    color: v$5(TOKENS.color.foreground.interaction.accentHover),
    fill: v$5(TOKENS.color.foreground.interaction.accentHover)
  },
  activeStyle: {
    color: v$5(TOKENS.color.foreground.interaction.accentActive),
    fill: v$5(TOKENS.color.foreground.interaction.accentActive)
  },
  disabledStyle: {
    color: v$5(TOKENS.color.foreground.interaction.disabled),
    fill: v$5(TOKENS.color.foreground.interaction.disabled)
  },
  focusRingStyle: {
    gap: "1px",
    width: "2px",
    borderRadius: "4px",
    color: v$5(TOKENS.color.border.focus)
  }
};
const TabNavigation = ({
  tabs,
  dividerFullWidth = true,
  overflow = false
}) => {
  var _a2;
  const themedProps = TAB_NAVIGATION_STYLE;
  const containerRef = useRef(null);
  const moreButtonRef = useRef(null);
  const [moreAnchor, moreAnchorRef] = useCallbackRef();
  const tabRefs = useMemo(() => Array.from({
    length: tabs.length
  }, () => createRef()), [tabs.length]);
  const visibleTabRefs = useMemo(() => Array.from({
    length: tabs.length
  }, () => createRef()), [tabs.length]);
  const {
    visibleCount
  } = useTabOverflow({
    containerRef,
    tabRefs,
    moreButtonRef,
    enabled: overflow
  });
  const [menuVisible, setMenuVisible] = React__default.useState(false);
  const toggleMenu = useCallback(() => setMenuVisible((visible) => !visible), []);
  const closeMenu = useCallback(() => setMenuVisible(false), []);
  const hasOverflow = overflow && visibleCount < tabs.length;
  const visibleTabs = hasOverflow ? tabs.slice(0, visibleCount) : tabs;
  const overflowTabs = hasOverflow ? tabs.slice(visibleCount) : [];
  const hasActiveOverflowTab = overflowTabs.some((t2) => t2.isActive);
  const activeOverflowLabel = (_a2 = overflowTabs.find((t2) => t2.isActive)) == null ? void 0 : _a2.label;
  const moreButtonLabel = activeOverflowLabel ?? "More";
  const moreButtonAriaLabel = typeof activeOverflowLabel === "string" && activeOverflowLabel.length > 0 ? `More tabs, ${activeOverflowLabel} selected` : "More tabs";
  const handleKeyDown = useCallback((e3) => {
    const renderedTabButtons = visibleTabRefs.slice(0, visibleCount).map((r2) => r2.current).filter((el) => el !== null);
    const focusableElements = hasOverflow && moreAnchor ? [...renderedTabButtons, moreAnchor] : renderedTabButtons;
    const activeIndex = focusableElements.indexOf(document.activeElement);
    if (activeIndex === -1) return;
    const focusPrev = () => {
      var _a3;
      return (_a3 = focusableElements[(activeIndex - 1 + focusableElements.length) % focusableElements.length]) == null ? void 0 : _a3.focus();
    };
    const focusNext = () => {
      var _a3;
      return (_a3 = focusableElements[(activeIndex + 1) % focusableElements.length]) == null ? void 0 : _a3.focus();
    };
    const isMoreButtonFocused = hasOverflow && document.activeElement === moreAnchor;
    if (e3.key === "ArrowLeft") {
      e3.preventDefault();
      focusPrev();
    }
    if (e3.key === "ArrowRight") {
      e3.preventDefault();
      focusNext();
    }
    if (e3.key === "ArrowDown" && isMoreButtonFocused && !menuVisible) {
      e3.preventDefault();
      setMenuVisible(true);
    }
  }, [visibleTabRefs, visibleCount, hasOverflow, moreAnchor, menuVisible]);
  const renderTab = ({
    label,
    isActive,
    onClick,
    key,
    quantity,
    badgeType = "errorStrong",
    disabled,
    ...restTabProps
  }, _2, ref2) => /* @__PURE__ */ jsxRuntimeExports.jsxs(Tab$1, { ref: ref2, isActive, onClick, disabled, ...restTabProps, ...themedProps, children: [
    label,
    quantity && quantity > 0 ? /* @__PURE__ */ jsxRuntimeExports.jsx(Badge, { badgeType, size: "subcompact", children: quantity }) : null
  ] }, key ?? (label == null ? void 0 : label.toString()));
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledDashboardTabs, { ref: containerRef, role: "tablist", "aria-orientation": "horizontal", dividerFullWidth, onKeyDown: handleKeyDown, children: [
      overflow && /* @__PURE__ */ jsxRuntimeExports.jsxs(HiddenMeasure, { "aria-hidden": "true", children: [
        tabs.map((tab, i) => renderTab(tab, i, tabRefs[i])),
        /* @__PURE__ */ jsxRuntimeExports.jsx(MoreButtonWrapper, { ref: moreButtonRef, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Tab$1, { tabIndex: -1, children: [
          "More ",
          /* @__PURE__ */ jsxRuntimeExports.jsx(CaretDownIcon, { size: "sm", fill: "currentColor" })
        ] }) })
      ] }),
      visibleTabs.map((tab, i) => renderTab(tab, i, visibleTabRefs[i])),
      hasOverflow && /* @__PURE__ */ jsxRuntimeExports.jsx(MoreButtonWrapper, { role: "none", children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Tab$1, { ref: moreAnchorRef, isActive: hasActiveOverflowTab, onClick: toggleMenu, "aria-haspopup": "menu", "aria-expanded": menuVisible, "aria-label": moreButtonAriaLabel, ...themedProps, children: [
        moreButtonLabel,
        " ",
        /* @__PURE__ */ jsxRuntimeExports.jsx(CaretDownIcon, { size: "sm", fill: "currentColor" })
      ] }) })
    ] }),
    hasOverflow && /* @__PURE__ */ jsxRuntimeExports.jsx(Menu$2, { visible: menuVisible, anchorElement: moreAnchor, onClickAway: closeMenu, setWidthToAnchor: false, menuPosition: "bottom-start", zIndex: "2", children: overflowTabs.map(({
      label,
      isActive,
      onClick,
      key,
      disabled
    }) => /* @__PURE__ */ jsxRuntimeExports.jsx(MenuItem, { selected: isActive, disabled, "aria-label": isActive ? `${typeof label === "string" ? label : ""} (current)` : void 0, onClickOrEnterPress: () => {
      onClick();
      closeMenu();
    }, children: label }, key ?? (label == null ? void 0 : label.toString()))) })
  ] });
};
TabNavigation.displayName = "TabNavigation";
const c$1 = (e3) => "number" == typeof e3 && !isNaN(e3), d = (e3) => "string" == typeof e3, u = (e3) => "function" == typeof e3, p = (e3) => d(e3) || u(e3) ? e3 : null, m = (e3) => isValidElement(e3) || d(e3) || u(e3) || c$1(e3);
function f(e3, t2, n2) {
  void 0 === n2 && (n2 = 300);
  const { scrollHeight: o, style: s2 } = e3;
  requestAnimationFrame(() => {
    s2.minHeight = "initial", s2.height = o + "px", s2.transition = `all ${n2}ms`, requestAnimationFrame(() => {
      s2.height = "0", s2.padding = "0", s2.margin = "0", setTimeout(t2, n2);
    });
  });
}
function g2(t2) {
  let { enter: a2, exit: r2, appendPosition: i = false, collapse: l2 = true, collapseDuration: c2 = 300 } = t2;
  return function(t3) {
    let { children: d2, position: u2, preventExitTransition: p2, done: m2, nodeRef: g3, isIn: y2, playToast: v2 } = t3;
    const h2 = i ? `${a2}--${u2}` : a2, T2 = i ? `${r2}--${u2}` : r2, E2 = useRef(0);
    return useLayoutEffect(() => {
      const e3 = g3.current, t4 = h2.split(" "), n2 = (o) => {
        o.target === g3.current && (v2(), e3.removeEventListener("animationend", n2), e3.removeEventListener("animationcancel", n2), 0 === E2.current && "animationcancel" !== o.type && e3.classList.remove(...t4));
      };
      e3.classList.add(...t4), e3.addEventListener("animationend", n2), e3.addEventListener("animationcancel", n2);
    }, []), useEffect(() => {
      const e3 = g3.current, t4 = () => {
        e3.removeEventListener("animationend", t4), l2 ? f(e3, m2, c2) : m2();
      };
      y2 || (p2 ? t4() : (E2.current = 1, e3.className += ` ${T2}`, e3.addEventListener("animationend", t4)));
    }, [y2]), React__default.createElement(React__default.Fragment, null, d2);
  };
}
function y(e3, t2) {
  return null != e3 ? { content: e3.content, containerId: e3.props.containerId, id: e3.props.toastId, theme: e3.props.theme, type: e3.props.type, data: e3.props.data || {}, isLoading: e3.props.isLoading, icon: e3.props.icon, status: t2 } : {};
}
const v$4 = /* @__PURE__ */ new Map();
let h = [];
const T = /* @__PURE__ */ new Set(), E = (e3) => T.forEach((t2) => t2(e3)), b = () => v$4.size > 0;
function I(e3, t2) {
  var n2;
  if (t2) return !(null == (n2 = v$4.get(t2)) || !n2.isToastActive(e3));
  let o = false;
  return v$4.forEach((t3) => {
    t3.isToastActive(e3) && (o = true);
  }), o;
}
function _(e3, t2) {
  m(e3) && (b() || h.push({ content: e3, options: t2 }), v$4.forEach((n2) => {
    n2.buildToast(e3, t2);
  }));
}
function C2(e3, t2) {
  v$4.forEach((n2) => {
    null != t2 && null != t2 && t2.containerId ? (null == t2 ? void 0 : t2.containerId) === n2.id && n2.toggle(e3, null == t2 ? void 0 : t2.id) : n2.toggle(e3, null == t2 ? void 0 : t2.id);
  });
}
function L(e3) {
  const { subscribe: o, getSnapshot: s2, setProps: i } = useRef(function(e4) {
    const n2 = e4.containerId || 1;
    return { subscribe(o2) {
      const s3 = /* @__PURE__ */ function(e5, n3, o3) {
        let s4 = 1, r3 = 0, i2 = [], l3 = [], f2 = [], g3 = n3;
        const v2 = /* @__PURE__ */ new Map(), h2 = /* @__PURE__ */ new Set(), T2 = () => {
          f2 = Array.from(v2.values()), h2.forEach((e6) => e6());
        }, E2 = (e6) => {
          l3 = null == e6 ? [] : l3.filter((t2) => t2 !== e6), T2();
        }, b2 = (e6) => {
          const { toastId: n4, onOpen: s5, updateId: a2, children: r4 } = e6.props, i3 = null == a2;
          e6.staleId && v2.delete(e6.staleId), v2.set(n4, e6), l3 = [...l3, e6.props.toastId].filter((t2) => t2 !== e6.staleId), T2(), o3(y(e6, i3 ? "added" : "updated")), i3 && u(s5) && s5(isValidElement(r4) && r4.props);
        };
        return { id: e5, props: g3, observe: (e6) => (h2.add(e6), () => h2.delete(e6)), toggle: (e6, t2) => {
          v2.forEach((n4) => {
            null != t2 && t2 !== n4.props.toastId || u(n4.toggle) && n4.toggle(e6);
          });
        }, removeToast: E2, toasts: v2, clearQueue: () => {
          r3 -= i2.length, i2 = [];
        }, buildToast: (n4, l4) => {
          if (((t2) => {
            let { containerId: n5, toastId: o4, updateId: s5 } = t2;
            const a2 = n5 ? n5 !== e5 : 1 !== e5, r4 = v2.has(o4) && null == s5;
            return a2 || r4;
          })(l4)) return;
          const { toastId: f3, updateId: h3, data: I2, staleId: _2, delay: C3 } = l4, L2 = () => {
            E2(f3);
          }, N2 = null == h3;
          N2 && r3++;
          const $2 = { ...g3, style: g3.toastStyle, key: s4++, ...Object.fromEntries(Object.entries(l4).filter((e6) => {
            let [t2, n5] = e6;
            return null != n5;
          })), toastId: f3, updateId: h3, data: I2, closeToast: L2, isIn: false, className: p(l4.className || g3.toastClassName), bodyClassName: p(l4.bodyClassName || g3.bodyClassName), progressClassName: p(l4.progressClassName || g3.progressClassName), autoClose: !l4.isLoading && (w3 = l4.autoClose, k2 = g3.autoClose, false === w3 || c$1(w3) && w3 > 0 ? w3 : k2), deleteToast() {
            const e6 = v2.get(f3), { onClose: n5, children: s5 } = e6.props;
            u(n5) && n5(isValidElement(s5) && s5.props), o3(y(e6, "removed")), v2.delete(f3), r3--, r3 < 0 && (r3 = 0), i2.length > 0 ? b2(i2.shift()) : T2();
          } };
          var w3, k2;
          $2.closeButton = g3.closeButton, false === l4.closeButton || m(l4.closeButton) ? $2.closeButton = l4.closeButton : true === l4.closeButton && ($2.closeButton = !m(g3.closeButton) || g3.closeButton);
          let P2 = n4;
          isValidElement(n4) && !d(n4.type) ? P2 = cloneElement(n4, { closeToast: L2, toastProps: $2, data: I2 }) : u(n4) && (P2 = n4({ closeToast: L2, toastProps: $2, data: I2 }));
          const M2 = { content: P2, props: $2, staleId: _2 };
          g3.limit && g3.limit > 0 && r3 > g3.limit && N2 ? i2.push(M2) : c$1(C3) ? setTimeout(() => {
            b2(M2);
          }, C3) : b2(M2);
        }, setProps(e6) {
          g3 = e6;
        }, setToggle: (e6, t2) => {
          v2.get(e6).toggle = t2;
        }, isToastActive: (e6) => l3.some((t2) => t2 === e6), getSnapshot: () => f2 };
      }(n2, e4, E);
      v$4.set(n2, s3);
      const r2 = s3.observe(o2);
      return h.forEach((e5) => _(e5.content, e5.options)), h = [], () => {
        r2(), v$4.delete(n2);
      };
    }, setProps(e5) {
      var t2;
      null == (t2 = v$4.get(n2)) || t2.setProps(e5);
    }, getSnapshot() {
      var e5;
      return null == (e5 = v$4.get(n2)) ? void 0 : e5.getSnapshot();
    } };
  }(e3)).current;
  i(e3);
  const l2 = useSyncExternalStore(o, s2, s2);
  return { getToastToRender: function(t2) {
    if (!l2) return [];
    const n2 = /* @__PURE__ */ new Map();
    return e3.newestOnTop && l2.reverse(), l2.forEach((e4) => {
      const { position: t3 } = e4.props;
      n2.has(t3) || n2.set(t3, []), n2.get(t3).push(e4);
    }), Array.from(n2, (e4) => t2(e4[0], e4[1]));
  }, isToastActive: I, count: null == l2 ? void 0 : l2.length };
}
function N(e3) {
  const [t2, o] = useState(false), [a2, r2] = useState(false), l2 = useRef(null), c2 = useRef({ start: 0, delta: 0, removalDistance: 0, canCloseOnClick: true, canDrag: false, didMove: false }).current, { autoClose: d2, pauseOnHover: u2, closeToast: p2, onClick: m2, closeOnClick: f2 } = e3;
  var g3, y2;
  function h2() {
    o(true);
  }
  function T2() {
    o(false);
  }
  function E2(n2) {
    const o2 = l2.current;
    c2.canDrag && o2 && (c2.didMove = true, t2 && T2(), c2.delta = "x" === e3.draggableDirection ? n2.clientX - c2.start : n2.clientY - c2.start, c2.start !== n2.clientX && (c2.canCloseOnClick = false), o2.style.transform = `translate3d(${"x" === e3.draggableDirection ? `${c2.delta}px, var(--y)` : `0, calc(${c2.delta}px + var(--y))`},0)`, o2.style.opacity = "" + (1 - Math.abs(c2.delta / c2.removalDistance)));
  }
  function b2() {
    document.removeEventListener("pointermove", E2), document.removeEventListener("pointerup", b2);
    const t3 = l2.current;
    if (c2.canDrag && c2.didMove && t3) {
      if (c2.canDrag = false, Math.abs(c2.delta) > c2.removalDistance) return r2(true), e3.closeToast(), void e3.collapseAll();
      t3.style.transition = "transform 0.2s, opacity 0.2s", t3.style.removeProperty("transform"), t3.style.removeProperty("opacity");
    }
  }
  null == (y2 = v$4.get((g3 = { id: e3.toastId, containerId: e3.containerId, fn: o }).containerId || 1)) || y2.setToggle(g3.id, g3.fn), useEffect(() => {
    if (e3.pauseOnFocusLoss) return document.hasFocus() || T2(), window.addEventListener("focus", h2), window.addEventListener("blur", T2), () => {
      window.removeEventListener("focus", h2), window.removeEventListener("blur", T2);
    };
  }, [e3.pauseOnFocusLoss]);
  const I2 = { onPointerDown: function(t3) {
    if (true === e3.draggable || e3.draggable === t3.pointerType) {
      c2.didMove = false, document.addEventListener("pointermove", E2), document.addEventListener("pointerup", b2);
      const n2 = l2.current;
      c2.canCloseOnClick = true, c2.canDrag = true, n2.style.transition = "none", "x" === e3.draggableDirection ? (c2.start = t3.clientX, c2.removalDistance = n2.offsetWidth * (e3.draggablePercent / 100)) : (c2.start = t3.clientY, c2.removalDistance = n2.offsetHeight * (80 === e3.draggablePercent ? 1.5 * e3.draggablePercent : e3.draggablePercent) / 100);
    }
  }, onPointerUp: function(t3) {
    const { top: n2, bottom: o2, left: s2, right: a3 } = l2.current.getBoundingClientRect();
    "touchend" !== t3.nativeEvent.type && e3.pauseOnHover && t3.clientX >= s2 && t3.clientX <= a3 && t3.clientY >= n2 && t3.clientY <= o2 ? T2() : h2();
  } };
  return d2 && u2 && (I2.onMouseEnter = T2, e3.stacked || (I2.onMouseLeave = h2)), f2 && (I2.onClick = (e4) => {
    m2 && m2(e4), c2.canCloseOnClick && p2();
  }), { playToast: h2, pauseToast: T2, isRunning: t2, preventExitTransition: a2, toastRef: l2, eventHandlers: I2 };
}
function $(t2) {
  let { delay: n2, isRunning: o, closeToast: s2, type: a2 = "default", hide: r2, className: i, style: c2, controlledProgress: d2, progress: p2, rtl: m2, isIn: f2, theme: g3 } = t2;
  const y2 = r2 || d2 && 0 === p2, v2 = { ...c2, animationDuration: `${n2}ms`, animationPlayState: o ? "running" : "paused" };
  d2 && (v2.transform = `scaleX(${p2})`);
  const h2 = clsx("Toastify__progress-bar", d2 ? "Toastify__progress-bar--controlled" : "Toastify__progress-bar--animated", `Toastify__progress-bar-theme--${g3}`, `Toastify__progress-bar--${a2}`, { "Toastify__progress-bar--rtl": m2 }), T2 = u(i) ? i({ rtl: m2, type: a2, defaultClassName: h2 }) : clsx(h2, i), E2 = { [d2 && p2 >= 1 ? "onTransitionEnd" : "onAnimationEnd"]: d2 && p2 < 1 ? null : () => {
    f2 && s2();
  } };
  return React__default.createElement("div", { className: "Toastify__progress-bar--wrp", "data-hidden": y2 }, React__default.createElement("div", { className: `Toastify__progress-bar--bg Toastify__progress-bar-theme--${g3} Toastify__progress-bar--${a2}` }), React__default.createElement("div", { role: "progressbar", "aria-hidden": y2 ? "true" : "false", "aria-label": "notification timer", className: T2, style: v2, ...E2 }));
}
let w2 = 1;
const k$1 = () => "" + w2++;
function P(e3) {
  return e3 && (d(e3.toastId) || c$1(e3.toastId)) ? e3.toastId : k$1();
}
function M(e3, t2) {
  return _(e3, t2), t2.toastId;
}
function x(e3, t2) {
  return { ...t2, type: t2 && t2.type || e3, toastId: P(t2) };
}
function A2(e3) {
  return (t2, n2) => M(t2, x(e3, n2));
}
function B2(e3, t2) {
  return M(e3, x("default", t2));
}
B2.loading = (e3, t2) => M(e3, x("default", { isLoading: true, autoClose: false, closeOnClick: false, closeButton: false, draggable: false, ...t2 })), B2.promise = function(e3, t2, n2) {
  let o, { pending: s2, error: a2, success: r2 } = t2;
  s2 && (o = d(s2) ? B2.loading(s2, n2) : B2.loading(s2.render, { ...n2, ...s2 }));
  const i = { isLoading: null, autoClose: null, closeOnClick: null, closeButton: null, draggable: null }, l2 = (e4, t3, s3) => {
    if (null == t3) return void B2.dismiss(o);
    const a3 = { type: e4, ...i, ...n2, data: s3 }, r3 = d(t3) ? { render: t3 } : t3;
    return o ? B2.update(o, { ...a3, ...r3 }) : B2(r3.render, { ...a3, ...r3 }), s3;
  }, c2 = u(e3) ? e3() : e3;
  return c2.then((e4) => l2("success", r2, e4)).catch((e4) => l2("error", a2, e4)), c2;
}, B2.success = A2("success"), B2.info = A2("info"), B2.error = A2("error"), B2.warning = A2("warning"), B2.warn = B2.warning, B2.dark = (e3, t2) => M(e3, x("default", { theme: "dark", ...t2 })), B2.dismiss = function(e3) {
  !function(e4) {
    var t2;
    if (b()) {
      if (null == e4 || d(t2 = e4) || c$1(t2)) v$4.forEach((t3) => {
        t3.removeToast(e4);
      });
      else if (e4 && ("containerId" in e4 || "id" in e4)) {
        const t3 = v$4.get(e4.containerId);
        t3 ? t3.removeToast(e4.id) : v$4.forEach((t4) => {
          t4.removeToast(e4.id);
        });
      }
    } else h = h.filter((t3) => null != e4 && t3.options.toastId !== e4);
  }(e3);
}, B2.clearWaitingQueue = function(e3) {
  void 0 === e3 && (e3 = {}), v$4.forEach((t2) => {
    !t2.props.limit || e3.containerId && t2.id !== e3.containerId || t2.clearQueue();
  });
}, B2.isActive = I, B2.update = function(e3, t2) {
  void 0 === t2 && (t2 = {});
  const n2 = ((e4, t3) => {
    var n3;
    let { containerId: o } = t3;
    return null == (n3 = v$4.get(o || 1)) ? void 0 : n3.toasts.get(e4);
  })(e3, t2);
  if (n2) {
    const { props: o, content: s2 } = n2, a2 = { delay: 100, ...o, ...t2, toastId: t2.toastId || e3, updateId: k$1() };
    a2.toastId !== e3 && (a2.staleId = e3);
    const r2 = a2.render || s2;
    delete a2.render, M(r2, a2);
  }
}, B2.done = (e3) => {
  B2.update(e3, { progress: 1 });
}, B2.onChange = function(e3) {
  return T.add(e3), () => {
    T.delete(e3);
  };
}, B2.play = (e3) => C2(true, e3), B2.pause = (e3) => C2(false, e3);
const O = "undefined" != typeof window ? useLayoutEffect : useEffect, D = (t2) => {
  let { theme: n2, type: o, isLoading: s2, ...a2 } = t2;
  return React__default.createElement("svg", { viewBox: "0 0 24 24", width: "100%", height: "100%", fill: "colored" === n2 ? "currentColor" : `var(--toastify-icon-color-${o})`, ...a2 });
}, z2 = { info: function(t2) {
  return React__default.createElement(D, { ...t2 }, React__default.createElement("path", { d: "M12 0a12 12 0 1012 12A12.013 12.013 0 0012 0zm.25 5a1.5 1.5 0 11-1.5 1.5 1.5 1.5 0 011.5-1.5zm2.25 13.5h-4a1 1 0 010-2h.75a.25.25 0 00.25-.25v-4.5a.25.25 0 00-.25-.25h-.75a1 1 0 010-2h1a2 2 0 012 2v4.75a.25.25 0 00.25.25h.75a1 1 0 110 2z" }));
}, warning: function(t2) {
  return React__default.createElement(D, { ...t2 }, React__default.createElement("path", { d: "M23.32 17.191L15.438 2.184C14.728.833 13.416 0 11.996 0c-1.42 0-2.733.833-3.443 2.184L.533 17.448a4.744 4.744 0 000 4.368C1.243 23.167 2.555 24 3.975 24h16.05C22.22 24 24 22.044 24 19.632c0-.904-.251-1.746-.68-2.44zm-9.622 1.46c0 1.033-.724 1.823-1.698 1.823s-1.698-.79-1.698-1.822v-.043c0-1.028.724-1.822 1.698-1.822s1.698.79 1.698 1.822v.043zm.039-12.285l-.84 8.06c-.057.581-.408.943-.897.943-.49 0-.84-.367-.896-.942l-.84-8.065c-.057-.624.25-1.095.779-1.095h1.91c.528.005.84.476.784 1.1z" }));
}, success: function(t2) {
  return React__default.createElement(D, { ...t2 }, React__default.createElement("path", { d: "M12 0a12 12 0 1012 12A12.014 12.014 0 0012 0zm6.927 8.2l-6.845 9.289a1.011 1.011 0 01-1.43.188l-4.888-3.908a1 1 0 111.25-1.562l4.076 3.261 6.227-8.451a1 1 0 111.61 1.183z" }));
}, error: function(t2) {
  return React__default.createElement(D, { ...t2 }, React__default.createElement("path", { d: "M11.983 0a12.206 12.206 0 00-8.51 3.653A11.8 11.8 0 000 12.207 11.779 11.779 0 0011.8 24h.214A12.111 12.111 0 0024 11.791 11.766 11.766 0 0011.983 0zM10.5 16.542a1.476 1.476 0 011.449-1.53h.027a1.527 1.527 0 011.523 1.47 1.475 1.475 0 01-1.449 1.53h-.027a1.529 1.529 0 01-1.523-1.47zM11 12.5v-6a1 1 0 012 0v6a1 1 0 11-2 0z" }));
}, spinner: function() {
  return React__default.createElement("div", { className: "Toastify__spinner" });
} }, R = (n2) => {
  const { isRunning: o, preventExitTransition: s2, toastRef: r2, eventHandlers: i, playToast: c2 } = N(n2), { closeButton: d2, children: p2, autoClose: m2, onClick: f2, type: g3, hideProgressBar: y2, closeToast: v2, transition: h2, position: T2, className: E2, style: b2, bodyClassName: I2, bodyStyle: _2, progressClassName: C3, progressStyle: L2, updateId: w3, role: k2, progress: P2, rtl: M2, toastId: x2, deleteToast: A3, isIn: B3, isLoading: O2, closeOnClick: D2, theme: R2 } = n2, S2 = clsx("Toastify__toast", `Toastify__toast-theme--${R2}`, `Toastify__toast--${g3}`, { "Toastify__toast--rtl": M2 }, { "Toastify__toast--close-on-click": D2 }), H2 = u(E2) ? E2({ rtl: M2, position: T2, type: g3, defaultClassName: S2 }) : clsx(S2, E2), F2 = function(e3) {
    let { theme: n3, type: o2, isLoading: s3, icon: r3 } = e3, i2 = null;
    const l2 = { theme: n3, type: o2 };
    return false === r3 || (u(r3) ? i2 = r3({ ...l2, isLoading: s3 }) : isValidElement(r3) ? i2 = cloneElement(r3, l2) : s3 ? i2 = z2.spinner() : ((e4) => e4 in z2)(o2) && (i2 = z2[o2](l2))), i2;
  }(n2), X = !!P2 || !m2, Y = { closeToast: v2, type: g3, theme: R2 };
  let q2 = null;
  return false === d2 || (q2 = u(d2) ? d2(Y) : isValidElement(d2) ? cloneElement(d2, Y) : function(t2) {
    let { closeToast: n3, theme: o2, ariaLabel: s3 = "close" } = t2;
    return React__default.createElement("button", { className: `Toastify__close-button Toastify__close-button--${o2}`, type: "button", onClick: (e3) => {
      e3.stopPropagation(), n3(e3);
    }, "aria-label": s3 }, React__default.createElement("svg", { "aria-hidden": "true", viewBox: "0 0 14 16" }, React__default.createElement("path", { fillRule: "evenodd", d: "M7.71 8.23l3.75 3.75-1.48 1.48-3.75-3.75-3.75 3.75L1 11.98l3.75-3.75L1 4.48 2.48 3l3.75 3.75L9.98 3l1.48 1.48-3.75 3.75z" })));
  }(Y)), React__default.createElement(h2, { isIn: B3, done: A3, position: T2, preventExitTransition: s2, nodeRef: r2, playToast: c2 }, React__default.createElement("div", { id: x2, onClick: f2, "data-in": B3, className: H2, ...i, style: b2, ref: r2 }, React__default.createElement("div", { ...B3 && { role: k2 }, className: u(I2) ? I2({ type: g3 }) : clsx("Toastify__toast-body", I2), style: _2 }, null != F2 && React__default.createElement("div", { className: clsx("Toastify__toast-icon", { "Toastify--animate-icon Toastify__zoom-enter": !O2 }) }, F2), React__default.createElement("div", null, p2)), q2, React__default.createElement($, { ...w3 && !X ? { key: `pb-${w3}` } : {}, rtl: M2, theme: R2, delay: m2, isRunning: o, isIn: B3, closeToast: v2, hide: y2, type: g3, style: L2, className: C3, controlledProgress: X, progress: P2 || 0 })));
}, S = function(e3, t2) {
  return void 0 === t2 && (t2 = false), { enter: `Toastify--animate Toastify__${e3}-enter`, exit: `Toastify--animate Toastify__${e3}-exit`, appendPosition: t2 };
}, H = g2(S("bounce", true));
g2(S("slide", true));
g2(S("zoom"));
g2(S("flip"));
const q = { position: "top-right", transition: H, autoClose: 5e3, closeButton: true, pauseOnHover: true, pauseOnFocusLoss: true, draggable: "touch", draggablePercent: 80, draggableDirection: "x", role: "alert", theme: "light" };
function Q(t2) {
  let o = { ...q, ...t2 };
  const s2 = t2.stacked, [a2, r2] = useState(true), c2 = useRef(null), { getToastToRender: d2, isToastActive: m2, count: f2 } = L(o), { className: g3, style: y2, rtl: v2, containerId: h2 } = o;
  function T2(e3) {
    const t3 = clsx("Toastify__toast-container", `Toastify__toast-container--${e3}`, { "Toastify__toast-container--rtl": v2 });
    return u(g3) ? g3({ position: e3, rtl: v2, defaultClassName: t3 }) : clsx(t3, p(g3));
  }
  function E2() {
    s2 && (r2(true), B2.play());
  }
  return O(() => {
    if (s2) {
      var e3;
      const t3 = c2.current.querySelectorAll('[data-in="true"]'), n2 = 12, s3 = null == (e3 = o.position) ? void 0 : e3.includes("top");
      let r3 = 0, i = 0;
      Array.from(t3).reverse().forEach((e4, t4) => {
        const o2 = e4;
        o2.classList.add("Toastify__toast--stacked"), t4 > 0 && (o2.dataset.collapsed = `${a2}`), o2.dataset.pos || (o2.dataset.pos = s3 ? "top" : "bot");
        const l2 = r3 * (a2 ? 0.2 : 1) + (a2 ? 0 : n2 * t4);
        o2.style.setProperty("--y", `${s3 ? l2 : -1 * l2}px`), o2.style.setProperty("--g", `${n2}`), o2.style.setProperty("--s", "" + (1 - (a2 ? i : 0))), r3 += o2.offsetHeight, i += 0.025;
      });
    }
  }, [a2, f2, s2]), React__default.createElement("div", { ref: c2, className: "Toastify", id: h2, onMouseEnter: () => {
    s2 && (r2(false), B2.pause());
  }, onMouseLeave: E2 }, d2((t3, n2) => {
    const o2 = n2.length ? { ...y2 } : { ...y2, pointerEvents: "none" };
    return React__default.createElement("div", { className: T2(t3), style: o2, key: `container-${t3}` }, n2.map((t4) => {
      let { content: n3, props: o3 } = t4;
      return React__default.createElement(R, { ...o3, stacked: s2, collapseAll: E2, isIn: m2(o3.toastId, o3.containerId), style: o3.style, key: `toast-${o3.key}` }, n3);
    }));
  }));
}
const MOBILE_BREAKPOINT = "800px";
const TOAST_TYPES = ["info", "warning", "danger", "success"];
const v$3 = (token2) => `var(${token2})`;
const TOAST_VARIANT_STYLE = {
  info: {
    backgroundColor: v$3(TOKENS.color.background.feedback.info),
    color: v$3(TOKENS.color.foreground.interaction.onFeedback),
    fill: v$3(TOKENS.color.foreground.interaction.onFeedback)
  },
  warning: {
    backgroundColor: v$3(TOKENS.color.background.feedback.warningStrong),
    color: v$3(TOKENS.color.foreground.interaction.onFeedback),
    fill: v$3(TOKENS.color.foreground.interaction.onFeedback)
  },
  success: {
    backgroundColor: v$3(TOKENS.color.background.feedback.successStrong),
    color: v$3(TOKENS.color.foreground.interaction.onReverse),
    fill: v$3(TOKENS.color.foreground.interaction.onReverse)
  },
  danger: {
    backgroundColor: v$3(TOKENS.color.background.feedback.dangerStrong),
    color: v$3(TOKENS.color.foreground.interaction.onReverse),
    fill: v$3(TOKENS.color.foreground.interaction.onReverse)
  }
};
const TOAST_WIDTH_BY_SIZE = {
  desktop: "480px",
  mobile: "335px"
};
const TOAST_BASE_STYLE = {
  fontFamily: v$3(TOKENS.text.fontFamily.primary),
  // Only Lantern set a toast font weight (300); elsewhere toasts inherited the
  // ambient body weight. `text.fontWeight.default` reproduces both.
  fontWeight: v$3(TOKENS.text.fontWeight.default),
  fontSize: "1rem",
  lineHeight: "24px",
  borderRadius: "6px",
  p: "12px",
  leftIconSpacing: "14px",
  iconSize: "24px"
};
const TOAST_POSITIONS = ["top-right", "top-center", "top-left", "bottom-right", "bottom-center", "bottom-left"];
const ToastDiv = styled.div`
  display: flex;
  justify-content: space-between;
  box-sizing: border-box;
  ${compose(space, color, typography, layout, flexbox, grid, background, border, position$1, shadow, svg)};

  /* At super small devices we just full-width the toasts */
  @media (max-width: 400px) {
    width: 100%;
  }
`;
const getDefaultIconType = (toastType) => {
  switch (toastType) {
    case "danger":
      return InfoCircleIcon;
    case "info":
      return InfoCircleIcon;
    case "warning":
      return WarningIcon;
    case "success":
      return CheckmarkCircleIcon;
    default:
      return null;
  }
};
const IconContainer = styled.div`
  /* Spacing between left icon and text */
  margin-right: ${(props) => props.leftIconSpacing};
  display: flex;
  align-items: flex-start;
  justify-content: center;
  height: 100%;
`;
const LeftToastContainer = styled.div`
  display: flex;
  align-items: flex-start;
  background: none;
  width: 100%;
`;
const TextContainer$1 = styled.div`
  /* Don't let the width of the text get too close to the close icon */
  max-width: calc(100% - 48px); /* 48px is per the design spec */
`;
const CloseIconButton = styled(Button)`
  display: flex;
  justify-content: center;
  padding: 0;
  /* Don't allow the other content to shrink this button */
  flex-shrink: 0;
  width: ${(props) => props.size};
  height: ${(props) => props.size};
`;
const Toast = forwardRef(({
  children,
  type: type2 = "info",
  closeToast,
  closeIcon,
  leftIcon,
  leftIconSpacing,
  forceMobileView,
  ...rest
}, ref2) => {
  const isMobile2 = forceMobileView || reactResponsiveExports.useMediaQuery({
    query: `(max-width: ${MOBILE_BREAKPOINT})`
  });
  const currentSize = isMobile2 ? "mobile" : "desktop";
  const themedProps = {
    ...TOAST_BASE_STYLE,
    width: TOAST_WIDTH_BY_SIZE[currentSize],
    ...TOAST_VARIANT_STYLE[type2]
  };
  const allProps = {
    ...themedProps,
    ...rest
  };
  const iconSize = allProps.iconSize || "2px";
  const DefaultIcon = getDefaultIconType(type2);
  const iconSpacing = leftIconSpacing || themedProps.leftIconSpacing;
  const hasIcon = leftIcon !== void 0 || DefaultIcon !== null;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(ToastDiv, { ...themedProps, ...rest, type: type2, color: allProps.color, ref: ref2, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs(LeftToastContainer, { children: [
      hasIcon && /* @__PURE__ */ jsxRuntimeExports.jsx(IconContainer, { leftIconSpacing: iconSpacing, children: leftIcon || // Otherwise, if the user didnt provide an icon we show our default icon (if it's not null)
      DefaultIcon !== null && /* @__PURE__ */ jsxRuntimeExports.jsx(DefaultIcon, { width: iconSize, height: iconSize, fill: allProps.fill }) }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(TextContainer$1, { children })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(CloseIconButton, { unstyled: true, focusRingStyle: {
      color: allProps.color
    }, width: iconSize, height: iconSize, "aria-label": "Close toast", onClick: () => {
      if (closeToast) {
        closeToast();
      }
    }, children: closeIcon || /* @__PURE__ */ jsxRuntimeExports.jsx(CloseIcon, { size: "sm", fill: allProps.color }) })
  ] });
});
const flyUpAnimation = keyframes$1`
  0% {
    opacity: 0;
    transform: translateY(25px);
  }

  70% {
    transform: translateY(-15px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
`;
const flyDownAnimation = keyframes$1`
  0% {
    opacity: 0;
    transform: translateY(-25px);
  }

  70% {
    transform: translateY(15px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
`;
const fadeUpAnimation = keyframes$1`
  0% {
    opacity: 1;
    height: 100%;
  }
  10% {
    transform: translateY(10px);
  }
  70% {
    transform: translateY(-15px);
  }
  100% {
    opacity: 0;
    height: 100%;
    transform: translateY(-15px);
  }
`;
const fadeDownAnimation = keyframes$1`
  0% {
    opacity: 1;
    height: 100%;
  }
  10% {
    transform: translateY(-10px);
  }
  70% {
    transform: translateY(15px);
  }
  100% {
    opacity: 0;
    height: 100%;
    transform: translateY(15px);
  }
`;
const StyledToastContainer = styled(Q)`
  /* Entry animation */
  --toastify-toast-width: ${(props) => props.width || "480px"};

  /* react-toastify allows you to customize animations through a class name that they put on the toast for you.*/
  & .flyUp {
    animation: ${(props) => css$3`
        ${props.entryAnimationSpeed}ms ${flyUpAnimation} ease
      `};
  }
  & .flyDown {
    animation: ${(props) => css$3`
        ${props.entryAnimationSpeed}ms ${flyDownAnimation} ease
      `};
  }
  & .fadeUp {
    opacity: 0;
    animation: ${(props) => css$3`
        ${props.exitAnimationSpeed}ms ${fadeDownAnimation} ease
      `};
  }
  & .fadeDown {
    opacity: 0;
    animation: ${(props) => css$3`
        ${props.exitAnimationSpeed}ms ${fadeUpAnimation} ease
      `};
  }

  /* Default size is the desktop size (480px by default) */
  width: ${(props) => props.width || "480px"};
  padding: 0;
  min-height: 0;
  cursor: auto;
  & .Toastify__toast {
    padding: 0;
    cursor: default;
    min-height: 0;
    background: transparent;
  }
  & .Toastify__toast-body {
    padding: 0;
    margin: 0;
  }
  /* Change the toast size to mobile size (335px by default) */
  @media (max-width: ${MOBILE_BREAKPOINT}) {
    --toastify-toast-width: ${(props) => props.width || "335px"};
  }

  /* Adjust the bottom margin for top toasts */
  &.Toastify__toast-container--top-center,
  &.Toastify__toast-container--top-right,
  &.Toastify__toast-container--top-left {
    top: 1rem;
    & .Toastify__toast {
      margin-top: 0.5rem;
    }
  }
  /* Adjust the bottom margin for bottom toasts */
  &.Toastify__toast-container--bottom-center,
  &.Toastify__toast-container--bottom-right,
  &.Toastify__toast-container--bottom-left {
    bottom: 1rem;
    & .Toastify__toast {
      margin-bottom: 0.5rem;
    }
  }

  /* Undo progress bar styles */
  --toastify-color-progress-light: transparent;
  --toastify-color-progress-dark: transparent;
  --toastify-color-progress-info: transparent;
  --toastify-color-progress-success: transparent;
  --toastify-color-progress-warning: transparent;
  --toastify-color-progress-error: transparent;
  --toastify-color-progress-bgo: transparent;

  /* Undo some react-toastify styles */
  @media (max-width: 480px) {
    padding-right: 1em;
    padding-left: 1em;
    width: 100%;
    .Toastify__toast {
      width: ${(props) => props.width || "335px"};
      margin-bottom: 0.5rem;
    }
    /* By default react-toastify makes toasts full width at <480px devices */
    /* We chose not to do that which means we have to adjust the positioning ourselves */
    &.Toastify__toast-container--bottom-center .Toastify__toast,
    &.Toastify__toast-container--top-center .Toastify__toast {
      margin-left: auto;
      margin-right: auto;
    }
    &.Toastify__toast-container--bottom-right .Toastify__toast,
    &.Toastify__toast-container--top-right .Toastify__toast {
      margin-left: auto;
      margin-right: 0;
    }
    &.Toastify__toast-container--bottom-left .Toastify__toast,
    &.Toastify__toast-container--top-left .Toastify__toast {
      margin-left: 0;
      margin-right: auto;
    }
  }
  /* When on a very tiny screen, we go down to full width toasts */
  @media (max-width: 400px) {
    --toastify-toast-width: 100%;
    width: 100%;
    margin-bottom: 0.25rem;

    .Toastify__toast {
      width: 100%;
      margin-bottom: 0.5rem;
    }
  }
`;
const transitions = {
  bottom: g2({
    enter: "flyUp",
    exit: "fadeUp",
    collapse: false
  }),
  top: g2({
    enter: "flyDown",
    exit: "fadeDown",
    collapse: false
  })
};
const DEFAULT_TOAST_PROPS = {
  hideProgressBar: true,
  autoClose: 1e4,
  // 10 secs default
  closeOnClick: false,
  position: "bottom-right",
  closeButton: false,
  draggable: false,
  entryAnimationSpeed: 250,
  // milliseconds
  exitAnimationSpeed: 400,
  // milliseconds
  newestOnTop: false,
  stacked: true
};
const ToastContainer = ({
  duration,
  ...rest
}) => {
  const isMobile2 = reactResponsiveExports.useMediaQuery({
    query: `(max-width: ${MOBILE_BREAKPOINT})`
  });
  const currentSize = isMobile2 ? "mobile" : "desktop";
  const width2 = TOAST_WIDTH_BY_SIZE[currentSize];
  const toastPosition = rest.position || DEFAULT_TOAST_PROPS.position;
  const toastTransition = toastPosition.includes("top") ? transitions.top : transitions.bottom;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(StyledToastContainer, { ...DEFAULT_TOAST_PROPS, width: width2, ...duration && {
    autoClose: duration
  }, transition: toastTransition, ...rest, position: toastPosition });
};
Toast.displayName = "Toast";
const dismissToast = B2.dismiss;
const updateToast = B2.update;
const isToastActive = B2.isActive;
const clearToastWaitingQueue = B2.clearWaitingQueue;
var angle = { "_default": "deg" };
angle.deg = {
  "grad": function(value) {
    return value / 0.9;
  },
  "rad": function(value) {
    return value * (Math.PI / 180);
  },
  "turn": function(value) {
    return value / 360;
  }
};
angle.grad = {
  "deg": function(value) {
    return value * 0.9;
  }
};
angle.rad = {
  "deg": function(value) {
    return value / (Math.PI / 180);
  }
};
angle.turn = {
  "deg": function(value) {
    return value * 360;
  }
};
var angle_1 = angle;
var utilities$2 = {};
utilities$2.getElementFontSize = function(element) {
  return typeof getComputedStyle !== "undefined" ? parseFloat(getComputedStyle(element, "").fontSize) : 16;
};
utilities$2.getCreatedElementDimensions = function(parent, properties2, content) {
  var element = document.createElement("div");
  var style = element.style;
  var dimensions;
  var property2;
  style.position = "absolute";
  style.zIndex = -2147483648;
  style.left = 0;
  style.top = 0;
  style.visibility = "hidden";
  if (properties2) {
    for (property2 in properties2) {
      if (properties2.hasOwnProperty(property2)) {
        style[property2] = properties2[property2];
      }
    }
  }
  if (content) {
    element.innerHTML = content;
  }
  parent.appendChild(element);
  dimensions = [
    element.offsetWidth,
    element.offsetHeight
  ];
  parent.removeChild(element);
  return dimensions;
};
utilities$2.getCreatedElementWidth = function(parent, properties2, content) {
  return utilities$2.getCreatedElementDimensions(parent, properties2, content)[0];
};
utilities$2.getCreatedElementHeight = function(parent, properties2, content) {
  return utilities$2.getCreatedElementDimensions(parent, properties2, content)[1];
};
var selfReferenceTriggers = [
  "perspective",
  "translate",
  "translate3d",
  "translateX",
  "translateY",
  "translateZ",
  "transformOrigin"
];
var layoutYTriggers = [
  "height",
  "top",
  "translateY"
];
var positionTriggers = ["absolute", "fixed"];
utilities$2.getRelativeElementDimension = function(element, property2) {
  var reference2;
  var dimension;
  var referenceComputed;
  var useY = layoutYTriggers.indexOf(property2) > -1;
  var useSelf = selfReferenceTriggers.indexOf(property2) > -1;
  var positioned = positionTriggers.indexOf(getComputedStyle(element, "").position) > -1;
  if (useSelf) {
    reference2 = element;
  } else {
    reference2 = positioned ? element.offsetParent : element.parentNode;
  }
  dimension = useY ? reference2.offsetHeight : reference2.offsetWidth;
  if (!useSelf && positioned) {
    referenceComputed = getComputedStyle(reference2, "");
    dimension -= useY ? parseFloat(referenceComputed.paddingTop) + parseFloat(referenceComputed.paddingBottom) : parseFloat(referenceComputed.paddingRight) + parseFloat(referenceComputed.paddingLeft);
  }
  return dimension;
};
utilities$2.DPI = function() {
  if (typeof window === "undefined") {
    return 96;
  }
  return utilities$2.getCreatedElementWidth(document.body, {
    "width": "1in"
  });
}();
utilities$2.ifZeroThenOne = function(value) {
  return value === 0 ? 1 : value;
};
var utilities_1 = utilities$2;
var viewport$1 = {};
var width = -1;
var height = -1;
viewport$1.width = function() {
  return width;
};
viewport$1.height = function() {
  return height;
};
viewport$1.max = function() {
  return Math.max(width, height);
};
viewport$1.min = function() {
  return Math.min(width, height);
};
viewport$1.setDimensions = function() {
  if (typeof document !== "undefined") {
    width = document.documentElement.clientWidth;
    height = document.documentElement.clientHeight;
  }
};
viewport$1.onWindowResize = function() {
  viewport$1.setDimensions();
};
if (typeof window !== "undefined") {
  window.addEventListener("resize", viewport$1.onWindowResize, false);
  window.addEventListener("orientationchange", viewport$1.onWindowResize, false);
  viewport$1.setDimensions();
}
var viewportDimensions = viewport$1;
var utilities$1 = utilities_1;
var viewport = viewportDimensions;
var length = { "_default": "px" };
length[""] = {
  "px": function(value, element) {
    return parseFloat(getComputedStyle(element, "").fontSize) * value;
  }
};
length["%"] = {
  "px": function(value, element, property2) {
    return value * utilities$1.getRelativeElementDimension(element, property2) / 100;
  }
};
length.ch = {
  "px": function(value, element) {
    return value * utilities$1.ifZeroThenOne(utilities$1.getCreatedElementWidth(element, null, "0"));
  }
};
length.cm = {
  "px": function(value) {
    return value / 2.54 * utilities$1.ifZeroThenOne(utilities$1.DPI);
  }
};
length.em = {
  "px": function(value, element) {
    return value * utilities$1.getElementFontSize(element);
  }
};
length.ex = {
  "px": function(value, element) {
    return value * utilities$1.getCreatedElementHeight(element, null, "x");
  }
};
length["in"] = {
  "px": function(value) {
    return value * utilities$1.DPI;
  }
};
length.mm = {
  "px": function(value) {
    return value / 2.54 * utilities$1.ifZeroThenOne(utilities$1.DPI) / 10;
  }
};
length.pc = {
  "px": function(value) {
    return value * (utilities$1.DPI / 72 * 12);
  }
};
length.pt = {
  "px": function(value) {
    return value * utilities$1.DPI / 72;
  }
};
length.px = {
  "": function(value, element) {
    return value / parseFloat(getComputedStyle(element, "").fontSize);
  },
  "%": function(value, element, property2) {
    return value / utilities$1.ifZeroThenOne(utilities$1.getRelativeElementDimension(element, property2)) * 100;
  },
  "ch": function(value, element) {
    return value / utilities$1.ifZeroThenOne(utilities$1.getCreatedElementWidth(element, null, "0"));
  },
  "cm": function(value) {
    return value / utilities$1.ifZeroThenOne(utilities$1.DPI) * 2.54;
  },
  "em": function(value, element) {
    return value / utilities$1.ifZeroThenOne(utilities$1.getElementFontSize(element));
  },
  "ex": function(value, element) {
    return value / utilities$1.ifZeroThenOne(utilities$1.getCreatedElementHeight(element, null, "x"));
  },
  "in": function(value) {
    return value / utilities$1.ifZeroThenOne(utilities$1.DPI);
  },
  "mm": function(value) {
    return value * 2.54 / utilities$1.ifZeroThenOne(utilities$1.DPI) * 10;
  },
  "pc": function(value) {
    return value / (utilities$1.DPI / 72 * 12);
  },
  "pt": function(value) {
    return value * 72 / utilities$1.DPI;
  },
  "rem": function(value) {
    return value / utilities$1.ifZeroThenOne(utilities$1.getElementFontSize(document.documentElement));
  },
  "vh": function(value) {
    return value / utilities$1.ifZeroThenOne(viewport.height() / 100);
  },
  "vmax": function(value) {
    return value / utilities$1.ifZeroThenOne(viewport.max() / 100);
  },
  "vmin": function(value) {
    return value / utilities$1.ifZeroThenOne(viewport.min() / 100);
  },
  "vw": function(value) {
    return value / utilities$1.ifZeroThenOne(viewport.width() / 100);
  }
};
length.rem = {
  "px": function(value) {
    return value * utilities$1.getElementFontSize(document.documentElement);
  }
};
length.vh = {
  "px": function(value) {
    return value * (viewport.height() / 100);
  }
};
length.vmax = {
  "px": function(value) {
    return value * (viewport.max() / 100);
  }
};
length.vmin = {
  "px": function(value) {
    return value * (viewport.min() / 100);
  }
};
length.vw = {
  "px": function(value) {
    return value * (viewport.width() / 100);
  }
};
var length_1 = length;
var utilities = utilities_1;
var resolution = { "_default": "dpi" };
resolution.dpi = {
  "dpcm": function(value) {
    return value / 2.54;
  },
  "dppx": function(value) {
    return value / utilities.DPI;
  }
};
resolution.dpcm = {
  "dpi": function(value) {
    return value * 2.54;
  }
};
resolution.dppx = {
  "dpi": function(value) {
    return value * utilities.DPI;
  }
};
var resolution_1 = resolution;
var conversions$1 = {
  "angle": angle_1,
  "length": length_1,
  "resolution": resolution_1
};
var isNumeric$1 = { exports: {} };
(function(module, exports$1) {
  var isNumeric2 = function(obj) {
    obj = typeof obj === "string" ? obj.replace(/,/g, "") : obj;
    return !isNaN(parseFloat(obj)) && isFinite(obj) && Object.prototype.toString.call(obj).toLowerCase() !== "[object array]";
  };
  {
    if (module.exports) {
      exports$1 = module.exports = isNumeric2;
    }
    exports$1.isNumeric = isNumeric2;
  }
})(isNumeric$1, isNumeric$1.exports);
var isNumericExports = isNumeric$1.exports;
var conversions = conversions$1;
var isNumeric = isNumericExports;
var units = {};
units.conversions = conversions;
var properties = units.properties = {};
properties.lineHeight = properties.opacity = properties.scale = properties.scale3d = properties.scaleX = properties.scaleY = properties.scaleZ = {
  "defaultUnit": "",
  "defaultValue": 1
};
properties.rotate = properties.rotate3d = properties.rotateX = properties.rotateY = properties.rotateZ = properties.skew = properties.skewX = properties.skewY = {
  "defaultUnit": "deg"
};
properties.resolution = {
  "defaultUnit": "dpi",
  "defaultValue": 96
};
units.convert = function(to, value, element, property2) {
  var parts = units.parse(value, property2);
  if (to === "_default") {
    to = units.getDefaultUnit(property2);
  }
  return to === parts.unit ? parts.value : units.processConversion(parts.unit, to, parts.value, element, property2);
};
units.parse = function(value, property2) {
  var parts = {};
  var matches;
  if (isNumeric(value)) {
    parts.value = value;
    parts.unit = property2 ? units.getDefaultUnit(property2) : "";
  } else {
    matches = value.toString().trim().match(/^(-?[\d+\.\-]+)([a-z]+|%)$/i);
    if (matches !== null) {
      parts.value = matches[1];
      parts.unit = matches[2];
    } else {
      parts.unit = value;
      parts.value = property2 ? units.getDefaultValue(property2) : 0;
    }
  }
  parts.value = parseFloat(parts.value);
  return parts;
};
units.getDefaultValue = function(property2) {
  return typeof properties[property2] !== "undefined" && typeof properties[property2].defaultValue !== "undefined" ? properties[property2].defaultValue : 0;
};
units.getDefaultUnit = function(property2) {
  return typeof properties[property2] !== "undefined" && typeof properties[property2].defaultUnit !== "undefined" ? properties[property2].defaultUnit : "px";
};
units.processConversion = function(fromUnits, toUnits, value, element, property2) {
  var type2 = units.getConversionType(fromUnits);
  var method;
  if (typeof type2[fromUnits][toUnits] === "function") {
    method = type2[fromUnits][toUnits];
  } else {
    method = type2[type2._default][toUnits];
    value = type2[fromUnits][type2._default](value, element, property2);
  }
  return method(value, element, property2);
};
units.getConversionType = function(fromUnits) {
  var property2;
  var type2 = null;
  for (property2 in conversions) {
    if (conversions.hasOwnProperty(property2) && typeof conversions[property2][fromUnits] !== "undefined") {
      type2 = conversions[property2];
      break;
    }
  }
  return type2;
};
var lib = units;
var unitsCss = lib;
var CSSunits = /* @__PURE__ */ getDefaultExportFromCjs(unitsCss);
const PopoverContainer = styled.div.withConfig({
  shouldForwardProp: kindredShouldForwardProp
})`
  display: ${(props) => props.$visible ? "flex" : "none"};
  max-width: 200px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-wrap: wrap;
  text-transform: initial;

  /* Default values. These will be replaced by the variant style props */
  background: var(${TOKENS.color.background.reverse});
  color: var(${TOKENS.color.foreground.interaction.onReverse});
  ${compose(space, color, typography, layout, flexbox, grid, background, border, position$1, shadow)}
`;
const PopoverArrow = styled.div.withConfig({
  shouldForwardProp: kindredShouldForwardProp
})`
  display: flex;

  &::before {
    content: "";
    display: block;
    background: ${(props) => props.background || `var(${TOKENS.color.background.reverse})`};
    height: 8px;
    width: 8px;
    visibility: ${(props) => props.$visible ? "visible" : "hidden"};
    transform: rotate(45deg);
  }

  [data-popper-placement^="top"] & {
    bottom: -4px;
  }

  [data-popper-placement^="bottom"] & {
    top: -4px;
  }

  [data-popper-placement="left"] & {
    right: -4px;
  }

  [data-popper-placement="right"] & {
    left: -4px;
  }
`;
const POPOVER_POSITIONS = ["top", "top-start", "top-end", "bottom", "bottom", "bottom-start", "bottom-end", "right", "left"];
const v$2 = (token2) => `var(${token2})`;
const POPOVER_TRIGGER_FOCUS_RING = {
  gap: "1px",
  width: "2px",
  borderRadius: "4px",
  color: v$2(TOKENS.color.border.focus)
};
const POPOVER_CARD_SHADOW = "0px 0px 2px 0px rgba(0, 0, 0, 0.2), 0px 3px 10px 0px rgba(0, 0, 0, 0.08)";
const POPOVER_BASE_STYLE = {
  borderRadius: "8px",
  color: v$2(TOKENS.color.foreground.default),
  padding: "16px",
  maxWidth: "220px",
  zIndex: "3"
};
const POPOVER_VARIANT_STYLE = {
  card: {
    hideArrow: true,
    background: v$2(TOKENS.color.background.surface0),
    borderRadius: v$2(TOKENS.dimension.radius.surface1),
    color: v$2(TOKENS.color.foreground.default),
    padding: "16px",
    boxShadow: POPOVER_CARD_SHADOW,
    maxWidth: "220px"
  },
  tooltip: {
    hideArrow: false,
    background: v$2(TOKENS.color.background.reverse),
    color: v$2(TOKENS.color.foreground.interaction.onReverse),
    fontFamily: v$2(TOKENS.text.fontFamily.primary),
    fontWeight: v$2(TOKENS.text.fontWeight.default),
    fontSize: "0.875rem",
    lineHeight: "140%",
    letterSpacing: "0em",
    borderRadius: v$2(TOKENS.dimension.radius.surface1),
    padding: "8px 12px",
    maxWidth: "200px"
  }
};
const DEFAULT_POPOVER_VARIANT = "card";
const popoverStyleForVariant = (variant) => {
  const resolved = variant ?? DEFAULT_POPOVER_VARIANT;
  const variantStyle = POPOVER_VARIANT_STYLE[resolved];
  if (!variantStyle) {
    console.warn(`No variant ${resolved} found for popovers.`);
  }
  return {
    ...POPOVER_BASE_STYLE,
    ...variantStyle
  };
};
const TriggerStyles = createGlobalStyle`
  .tooltipTrigger {
    cursor: pointer;
    /* Doesnt have focus-visible behavior by default so we add this */
    &:focus {
      outline: none;
    }
    &:focus-visible, &.focus-visible {
      /* Apply a default themed focus ring */
      ${FocusRing(POPOVER_TRIGGER_FOCUS_RING)}
    }
  }
`;
const SERVER_TRIGGER_STYLES_OWNER = "server";
const triggerStylesOwners = [];
const triggerStylesListeners = /* @__PURE__ */ new Set();
const subscribeToTriggerStylesOwner = (listener) => {
  triggerStylesListeners.add(listener);
  return () => {
    triggerStylesListeners.delete(listener);
  };
};
const getTriggerStylesOwner = () => triggerStylesOwners[0];
const getServerTriggerStylesOwner = () => typeof window === "undefined" ? SERVER_TRIGGER_STYLES_OWNER : void 0;
const TriggerStylesMount = ({
  instanceId: instanceId2
}) => {
  useEffect(() => {
    triggerStylesOwners.push(instanceId2);
    triggerStylesListeners.forEach((listener) => listener());
    return () => {
      const index2 = triggerStylesOwners.indexOf(instanceId2);
      if (index2 !== -1) {
        triggerStylesOwners.splice(index2, 1);
      }
      triggerStylesListeners.forEach((listener) => listener());
    };
  }, [instanceId2]);
  const owner = useSyncExternalStore(subscribeToTriggerStylesOwner, getTriggerStylesOwner, getServerTriggerStylesOwner);
  return owner === instanceId2 || owner === SERVER_TRIGGER_STYLES_OWNER ? /* @__PURE__ */ jsxRuntimeExports.jsx(TriggerStyles, {}) : null;
};
const usePopover = (props) => {
  var _a2;
  const {
    defaultIsVisible = void 0,
    isVisible: controlledVisibility = void 0,
    id: id2 = void 0,
    triggerMode: propsTriggerMode = "onClickAndPress",
    hideOnOutsideClick = true,
    includeRole = true,
    elementRef = void 0
  } = props || {};
  const [isPopoverVisible, setIsVisible] = useState(defaultIsVisible ?? false);
  const randomId = useId$2();
  const popoverId = id2 ?? randomId;
  const currentVisibility = controlledVisibility ?? isPopoverVisible;
  const [triggerRef, setTriggerRef] = useState(null);
  const isMobile$1 = ((_a2 = isMobile()) == null ? void 0 : _a2.any) || false;
  useEffect(() => {
    if (elementRef) {
      setTriggerRef(elementRef.current);
    }
  }, [elementRef]);
  const triggerMode = isMobile$1 && propsTriggerMode === "onHoverAndFocus" ? "onClickAndPress" : propsTriggerMode;
  const isHoverMode = triggerMode === "onHoverAndFocus";
  function handlePopoverChange(newVisibility) {
    setIsVisible(newVisibility);
  }
  const onMouseDown = useCallback(() => {
    handlePopoverChange(!currentVisibility);
  }, [currentVisibility]);
  const onKeyDown = useCallback((e3) => {
    if (e3.code === "Space") {
      e3.preventDefault();
      handlePopoverChange(!currentVisibility);
    }
  }, [currentVisibility]);
  const onMouseOver = useCallback(() => {
    handlePopoverChange(true);
  }, []);
  const onMouseLeave = useCallback(() => {
    handlePopoverChange(false);
  }, []);
  const onFocus2 = useCallback(() => {
    handlePopoverChange(true);
  }, []);
  const onBlur = useCallback(() => {
    handlePopoverChange(false);
  }, []);
  const getTriggerCallbacks = () => {
    switch (triggerMode) {
      case "onClickAndPress":
        return {
          onMouseDown,
          onKeyDown
        };
      case "onHoverAndFocus":
        return {
          onMouseOver,
          onMouseLeave,
          onFocus: onFocus2,
          onBlur
        };
      case "onFocus":
        return {
          onMouseDown,
          onKeyDown,
          onFocus: onFocus2,
          onBlur
        };
      default:
        return {};
    }
  };
  const hoverModeProps = {
    ...includeRole ? {
      role: "button"
    } : {},
    tabIndex: 0
  };
  const nonHoverModeProps = {
    ...includeRole ? {
      role: "button"
    } : {},
    tabIndex: 0,
    "aria-expanded": isPopoverVisible,
    "aria-controls": popoverId
  };
  const triggerProps = {
    ...isHoverMode ? hoverModeProps : nonHoverModeProps,
    ...getTriggerCallbacks(),
    ...elementRef ? {} : {
      ref: (el) => setTriggerRef(el)
    },
    // If elementRef is provided, we don't need to set the ref
    className: "tooltipTrigger"
  };
  const Popover = forwardRef(({
    zIndex,
    position: position2 = "top",
    yOffset = 8,
    xOffset = 0,
    handleOutsideClick,
    variant,
    children,
    ...rest
  }, ref2) => {
    const themedProps = popoverStyleForVariant(variant);
    const [popperRef, setPopperRef] = useState(null);
    const [arrowElement, setArrowElement] = useState(null);
    const hideArrow = rest.hideArrow ?? themedProps.hideArrow ?? false;
    const distanceFromEdgeToArrow = 24;
    const positionModifier = React__default.useMemo(() => ({
      name: "offset",
      options: {
        offset: ({
          popper: popper2
        }) => {
          var _a3, _b;
          const elementWidth = (triggerRef == null ? void 0 : triggerRef.offsetWidth) ?? 0;
          const elementPaddingRight = CSSunits.parse(((_a3 = triggerRef == null ? void 0 : triggerRef.style) == null ? void 0 : _a3.paddingRight) ?? "").value;
          const elementPaddingLeft = CSSunits.parse(((_b = triggerRef == null ? void 0 : triggerRef.style) == null ? void 0 : _b.paddingLeft) ?? "").value;
          if (position2.includes("end")) {
            return [Math.max(elementWidth - popper2.width - elementPaddingRight - distanceFromEdgeToArrow, popper2.width / 2 - distanceFromEdgeToArrow) + xOffset, yOffset];
          }
          if (position2.includes("start")) {
            return [xOffset - Math.max(elementWidth - popper2.width - distanceFromEdgeToArrow - elementPaddingLeft, popper2.width / 2 - distanceFromEdgeToArrow), yOffset];
          }
          return [xOffset, yOffset];
        }
      }
    }), [position2]);
    const determinePosition = (pos) => {
      if (pos.includes("top")) return "top";
      if (pos.includes("bottom")) return "bottom";
      return pos;
    };
    const {
      styles,
      attributes,
      update
    } = usePopper(triggerRef, popperRef, {
      placement: determinePosition(position2),
      modifiers: [
        positionModifier,
        // Offset the arrow
        {
          name: "arrow",
          options: {
            element: arrowElement,
            padding: 7
          }
        },
        {
          name: "preventOverflow",
          options: {
            padding: 10
          }
        }
      ]
    });
    useEffect(() => {
      if (update !== null) {
        update();
      }
    }, [currentVisibility]);
    return /* @__PURE__ */ jsxRuntimeExports.jsxs(OutsideClickHandler, { onOutsideClick: (event) => {
      if (handleOutsideClick) {
        handleOutsideClick({
          currentVisibility
        });
      }
      const clickedOnTrigger = triggerRef && (triggerRef.contains(event.target) || triggerRef === event.target);
      if (hideOnOutsideClick && !clickedOnTrigger && !isHoverMode) {
        handlePopoverChange(false);
      }
    }, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(TriggerStylesMount, { instanceId: popoverId }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { ref: setPopperRef, style: {
        ...styles.popper,
        zIndex: zIndex || themedProps.zIndex || 3,
        // In hover mode we leave the content visible for screen readers all the time but just hide it visually
        ...isHoverMode && {
          opacity: currentVisibility ? void 0 : 0,
          pointerEvents: "none"
        }
      }, ...attributes.popper, id: popoverId, "aria-hidden": isHoverMode ? false : !currentVisibility, role: "tooltip", children: [
        !hideArrow && /* @__PURE__ */ jsxRuntimeExports.jsx(PopoverArrow, { ref: setArrowElement, style: styles.arrow, background: themedProps.background || rest.background, $visible: currentVisibility }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(PopoverContainer, { ...themedProps, ...rest, $visible: isHoverMode || currentVisibility, ref: ref2, children })
      ] })
    ] });
  });
  Popover.displayName = "Popover";
  return {
    Popover,
    triggerProps
  };
};
const DEFAULT_CIRCLE_SPACING = "4px";
const toggleStyleFns = [color, border, space, layout, background];
const togglePseudostates = [Pseudostate.hover, Pseudostate.active, Pseudostate["focus-visible"], Pseudostate.checked, Pseudostate.disabled];
const v$1 = (token2) => `var(${token2})`;
const TOGGLE_BASE_STYLE = {
  fontFamily: v$1(TOKENS.text.fontFamily.primary),
  fontWeight: v$1(TOKENS.text.fontWeight.default),
  fontSize: "0.875rem",
  lineHeight: "140%",
  letterSpacing: "0em",
  color: v$1(TOKENS.color.foreground.default),
  borderRadius: "40px",
  width: "40px",
  height: "24px",
  circleSpacing: "4px",
  circleColor: v$1(TOKENS.color.background.interaction.neutral),
  borderStyle: "solid",
  borderWidth: "1px",
  borderColor: v$1(TOKENS.color.border.interaction.neutral),
  transition: "all 100ms ease-in-out",
  disabledStyle: {
    background: v$1(TOKENS.color.background.interaction.neutralDisabled),
    borderColor: v$1(TOKENS.color.border.interaction.neutral),
    circleColor: v$1(TOKENS.color.background.interaction.disabled)
  },
  focusRingStyle: {
    gap: "1px",
    width: "2px",
    borderRadius: "4px",
    color: v$1(TOKENS.color.border.focus)
  }
};
const TOGGLE_VARIANT_STYLE = {
  unselected: {
    background: v$1(TOKENS.color.background.interaction.neutralUnactivated),
    hoverStyle: {
      background: v$1(TOKENS.color.background.interaction.neutralUnactivated),
      borderColor: v$1(TOKENS.color.border.interaction.neutralHover)
    }
  },
  selected: {
    background: v$1(TOKENS.color.background.interaction.neutralSelected),
    borderColor: v$1(TOKENS.color.border.interaction.neutralSelected),
    hoverStyle: {
      background: v$1(TOKENS.color.background.interaction.neutralSelectedHover),
      borderColor: v$1(TOKENS.color.border.interaction.neutralSelected)
    }
  }
};
const StyledToggle = styled.input`
  border: none;
  margin: 0;
  padding: 0;
  /* remove default checkbox appearance */
  -webkit-appearance: none;
  appearance: none;
  box-sizing: border-box;
  position: relative;
  cursor: pointer;
  /* The transition prop is not one of toggleStyleFns, so it has to be applied
     here. Without it the track snapped while the circle animated. */
  transition: ${({
  transition: transition2
}) => transition2};

  &:disabled {
    cursor: not-allowed;
  }

  ${composeWrapper(toggleStyleFns, togglePseudostates)}
  ${(props) => FocusRing({
  ...props.focusRingStyle,
  elementBorderProps: props
})}
  ${({
  height: height2,
  width: width2,
  circleSpacing,
  transition: transition2,
  circleColor,
  borderColor: borderColor2,
  borderWidth: borderWidth2,
  hoverStyle,
  disabledStyle
}) => {
  const circleSize = `calc(${height2} - (${circleSpacing} * 2))`;
  const inset = `calc(${circleSpacing} - ${borderWidth2})`;
  return css$3`
      &:before {
        transition: ${transition2};
        content: "";
        border-radius: 50%; /* This doesnt seem worth theming? */
        background-color: ${circleColor || "white"};
        border: ${borderWidth2} solid ${borderColor2};
        width: ${circleSize};
        height: ${circleSize};
        transform: translate(${inset}, ${inset});
        position: absolute;
      }

      &:hover:not(:disabled):before,
      &.hover:not(:disabled):before {
        border-color: ${(hoverStyle == null ? void 0 : hoverStyle.borderColor) || borderColor2};
      }

      &:disabled:before,
      &.disabled:before {
        background-color: ${(disabledStyle == null ? void 0 : disabledStyle.circleColor) || circleColor};
        border-color: ${(disabledStyle == null ? void 0 : disabledStyle.borderColor) || borderColor2};
      }

      &:checked {
        &:before {
          transform: translate(
            /* Translation = width of toggle - size of circle - space on the
               right - the track border on the left */
              calc(
                ${width2} - ${circleSize} - ${circleSpacing} - ${borderWidth2}
              ),
            ${inset}
          );
        }
      }
    `;
}}
`;
const StyledLabel$1 = styled.label`
  display: inline-flex;
  align-items: center;
  gap: 12px;
  ${({
  labelPosition
}) => labelPosition === "left" && "flex-direction: row-reverse;"}
  ${composeWrapper([typography, color], [])}
`;
const Toggle = forwardRef((props, ref2) => {
  const {
    toggled,
    circleSpacing = DEFAULT_CIRCLE_SPACING,
    labelPosition = "right",
    ...rest
  } = props;
  const currentVariant = toggled ? "selected" : "unselected";
  const themedProps = {
    ...TOGGLE_BASE_STYLE,
    ...TOGGLE_VARIANT_STYLE[currentVariant]
  };
  const typographyProps = selectStyledSystemProps({
    ...themedProps,
    ...props
  }, ["typography"]);
  const {
    color: textColor
  } = {
    ...themedProps,
    ...props
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledLabel$1, { labelPosition, ...typographyProps, color: textColor, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(StyledToggle, { ...themedProps, ...rest, checked: toggled, circleSpacing, type: "checkbox", ref: ref2 }),
    "label" in props && props.label
  ] });
});
Toggle.displayName = "Toggle";
const bestowPurpleThemeMappings = {
  headlineLarge: "headerXLarge.desktop",
  headlineMedium: "headerMedium.desktop",
  paragraph: "bodyMedium.desktop"
};
const getThemeAgnosticTypography = (themeName, variant) => {
  switch (themeName) {
    case "PURPLE_THEME":
    case "NATIONWIDE_THEME":
    case "USAA_THEME":
    default:
      return bestowPurpleThemeMappings[variant];
  }
};
const APIGearIllustration = forwardRef((props, ref2) => /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { width: "56", height: "56", viewBox: "0 0 56 56", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img", "aria-label": "API Gear Illustration ", ...props, ref: ref2, children: [
  /* @__PURE__ */ jsxRuntimeExports.jsx("title", { children: "API Gear Illustration " }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M29.9636 55H26.0364C25.6492 54.9992 25.2743 54.8638 24.976 54.6171C24.676 54.3675 24.4742 54.0196 24.4065 53.6353L24.2789 52.9774C23.8469 50.7978 23.5425 49.5509 22.3153 49.2171C21.088 48.8833 19.6742 50.4149 18.4862 51.7502L18.2505 52.0153C18.002 52.3028 17.6603 52.4937 17.2852 52.5547C16.91 52.6158 16.5254 52.543 16.1985 52.3491L12.8015 50.3854C12.4766 50.1945 12.2244 49.9009 12.0847 49.5509C11.9671 49.1938 11.9671 48.8084 12.0847 48.4513L12.2909 47.6363C12.988 45.5353 13.2727 44.3963 12.448 43.5323C11.6233 42.6684 9.50255 43.2182 7.82364 43.7974L7.51927 43.8956C7.15788 44.0277 6.76139 44.0277 6.4 43.8956C6.04177 43.7656 5.74214 43.5112 5.55564 43.1789L3.61164 39.7818C3.42579 39.4535 3.35664 39.0719 3.41548 38.6993C3.47432 38.3266 3.65767 37.9849 3.93564 37.7298L4.43636 37.2782C6.20364 35.7465 7.03818 34.9611 6.70436 33.7142C6.37055 32.4673 4.43636 31.9862 2.62 31.6327L2.31564 31.5738C1.94485 31.4972 1.61171 31.2953 1.37215 31.0021C1.13258 30.7089 1.00118 30.3422 1 29.9636V26.0363C1.00186 25.654 1.13339 25.2837 1.37309 24.9858C1.61937 24.6801 1.96826 24.4743 2.35491 24.4065L3.03236 24.2691C5.20218 23.8469 6.44909 23.5425 6.78291 22.3054C7.11673 21.0683 5.58509 19.6643 4.24982 18.4763L3.98473 18.2407C3.69697 17.9854 3.50621 17.6386 3.44473 17.2589C3.38953 16.9009 3.45517 16.5347 3.63127 16.2182L5.59491 12.8309C5.77084 12.498 6.05475 12.2349 6.4 12.0847C6.75799 11.9524 7.15147 11.9524 7.50945 12.0847L8.36364 12.2909C10.4353 12.9683 11.5545 13.2727 12.4087 12.4283C13.2629 11.584 12.7229 9.48289 12.1436 7.80398L12.0455 7.49962C11.9132 7.14163 11.9132 6.74815 12.0455 6.39017C12.182 6.03574 12.4346 5.73808 12.7622 5.5458L16.1593 3.58217C16.5076 3.41579 16.9017 3.37085 17.2785 3.45453C17.6551 3.51226 18.0012 3.69565 18.2604 3.97489L18.7316 4.51489C20.2633 6.28217 21.0585 7.11671 22.2956 6.78289C23.5327 6.44908 24.004 4.43635 24.3476 2.64944L24.4164 2.31562C24.4858 1.9296 24.6913 1.58126 24.9956 1.3338C25.293 1.10459 25.6611 0.986516 26.0364 0.999984H29.9636C30.3462 1.00027 30.7171 1.13198 31.0142 1.37308C31.3176 1.61978 31.5201 1.96904 31.5836 2.35489L31.7211 3.03235C32.1531 5.20217 32.4575 6.43926 33.6847 6.77308C34.912 7.10689 36.316 5.58507 37.4942 4.25962L37.7495 3.97489C37.9957 3.69061 38.3331 3.50085 38.7039 3.43816C39.0748 3.37546 39.4558 3.44373 39.7818 3.63126L43.1789 5.59489C43.5038 5.78586 43.7559 6.07945 43.8956 6.42944C44.0133 6.78655 44.0133 7.17197 43.8956 7.52908C43.7975 7.82362 43.7091 8.10835 43.6109 8.38326C42.9335 10.4549 42.6291 11.5742 43.4735 12.4283C44.3178 13.2825 46.4189 12.7523 48.0684 12.1829L48.4022 12.0749C48.7626 11.9375 49.161 11.9375 49.5215 12.0749C49.8856 12.2093 50.189 12.4709 50.3756 12.8113L52.3393 16.1985C52.5246 16.5261 52.5938 16.9067 52.5356 17.2785C52.4818 17.6564 52.2977 18.0036 52.0153 18.2603L51.4556 18.7414C49.6982 20.2731 48.8735 21.0585 49.2073 22.2956C49.5411 23.5327 51.5636 24.0138 53.3211 24.3673L53.6353 24.4262C54.0151 24.4927 54.3596 24.6902 54.6089 24.9844C54.8582 25.2785 54.9966 25.6508 55 26.0363V29.9636C54.9975 30.3428 54.8659 30.7099 54.6269 31.0043C54.3913 31.2983 54.0621 31.5027 53.6942 31.5836L53.0167 31.7211C50.8371 32.1433 49.5902 32.4476 49.2564 33.6847L49.1876 33.94C49.0993 35.1673 50.5033 36.4142 51.76 37.5138L52.0251 37.7593C52.3054 38.0062 52.4917 38.3424 52.5526 38.711C52.6134 39.0796 52.545 39.4579 52.3589 39.7818L50.3953 43.1789C50.2043 43.5038 49.9107 43.7559 49.5607 43.8956C49.2036 44.0132 48.8182 44.0132 48.4611 43.8956L47.6364 43.7091C45.5451 43.012 44.416 42.7273 43.5618 43.552C42.7076 44.3767 43.2378 46.4974 43.8171 48.1862L43.9153 48.4807C44.0474 48.8421 44.0474 49.2386 43.9153 49.6C43.7852 49.9582 43.5309 50.2579 43.1985 50.4444L39.8015 52.408C39.4731 52.5938 39.0916 52.663 38.7189 52.6041C38.3463 52.5453 38.0045 52.3619 37.7495 52.084L37.1702 51.4262C35.6876 49.7473 34.9218 48.952 33.7142 49.276C32.5065 49.6 31.9862 51.6323 31.6327 53.3996L31.5738 53.704C31.5078 54.0889 31.3057 54.4373 31.0044 54.6858C30.7044 54.908 30.3365 55.0191 29.9636 55ZM21.9422 48.2058C22.1471 48.2049 22.3514 48.228 22.5509 48.2745C24.4458 48.7851 24.8091 50.6505 25.2411 52.8007L25.3687 53.4585C25.3971 53.6164 25.4806 53.759 25.6044 53.8611C25.7261 53.9615 25.8786 54.0169 26.0364 54.0182H29.9636C30.1174 54.0207 30.267 53.9685 30.3858 53.8709C30.5026 53.7728 30.5823 53.6377 30.6116 53.488L30.6705 53.1934C31.0535 51.2298 31.5345 48.8145 33.4589 48.2843C35.3833 47.7542 36.4044 49.0894 37.9065 50.7291L38.476 51.3673C38.5805 51.4822 38.7208 51.5584 38.8742 51.5834C39.0275 51.6083 39.1848 51.5806 39.3204 51.5047L42.7273 49.6C42.8626 49.5189 42.9665 49.3943 43.0218 49.2465C43.0712 49.1 43.0712 48.9414 43.0218 48.7949L42.9236 48.5102C42.2756 46.6251 41.4804 44.2883 42.9236 42.8647C44.3669 41.4411 45.9967 42.0989 48.0193 42.7763L48.8047 43.0316C48.9522 43.0777 49.1109 43.0727 49.2552 43.0174C49.3995 42.9622 49.5209 42.86 49.6 42.7273L51.5636 39.3302C51.6433 39.1976 51.6713 39.0403 51.6422 38.8883C51.6204 38.7383 51.5434 38.6017 51.4262 38.5054L51.1611 38.26C49.6884 36.964 47.8622 35.3145 48.3236 33.4589L48.4415 33.1742C49.0502 31.5149 50.8273 31.2105 52.8793 30.7589L53.5371 30.6313C53.6875 30.5979 53.8224 30.5149 53.92 30.3956C53.9982 30.2659 54.0326 30.1144 54.0182 29.9636V26.0363C54.0207 25.8826 53.9685 25.733 53.8709 25.6142C53.7728 25.4974 53.6377 25.4177 53.488 25.3883L53.1836 25.3294C51.22 24.9465 48.8145 24.4654 48.2745 22.5509C47.7345 20.6363 49.1091 19.4876 50.8273 18.0051L51.3673 17.524C51.4801 17.4255 51.5533 17.2895 51.5735 17.1411C51.6016 16.9892 51.5737 16.8322 51.4949 16.6993L49.6 13.2727C49.5226 13.1321 49.3971 13.024 49.2465 12.9683C49.1009 12.9142 48.9406 12.9142 48.7949 12.9683L48.4611 13.0862C46.5956 13.7145 44.2687 14.4902 42.8647 13.0862C41.4607 11.6822 42.0793 10.072 42.7273 8.07889C42.8255 7.80398 42.9138 7.52908 43.0022 7.23453C43.061 7.08521 43.0657 6.92002 43.0155 6.76759C42.9653 6.61516 42.8633 6.48511 42.7273 6.39998L39.3204 4.43635C39.1779 4.38287 39.021 4.38287 38.8785 4.43635C38.7285 4.45813 38.5919 4.53516 38.4956 4.65235L38.2404 4.93708C36.9542 6.39998 35.2949 8.22617 33.4491 7.74508C31.6033 7.26398 31.1909 5.39853 30.7589 3.25817L30.6215 2.57089C30.5948 2.41469 30.5151 2.27249 30.3956 2.16835C30.2801 2.05423 30.1259 1.98766 29.9636 1.9818H26.0364C25.8826 1.97925 25.733 2.03145 25.6142 2.12908C25.4949 2.22668 25.4119 2.36154 25.3785 2.51198L25.3098 2.8458C24.9269 4.80944 24.4556 7.18544 22.5411 7.68617C20.6265 8.18689 19.468 6.8418 17.9756 5.12362L17.5142 4.59344C17.4064 4.50184 17.2723 4.44683 17.1313 4.43635C16.9794 4.41658 16.8252 4.444 16.6895 4.51489L13.2727 6.39998C13.1426 6.4827 13.04 6.60234 12.9782 6.74362C12.934 6.89092 12.934 7.04796 12.9782 7.19526L13.0862 7.49962C13.7244 9.37489 14.5196 11.7116 13.0862 13.1254C11.6527 14.5393 10.0425 13.8913 8.03964 13.2334L7.19527 12.9683C7.0478 12.9223 6.88911 12.9273 6.74482 12.9825C6.60053 13.0377 6.47906 13.14 6.4 13.2727L4.43636 16.6796C4.35669 16.8122 4.32873 16.9695 4.35782 17.1214C4.3796 17.2715 4.45663 17.4081 4.57382 17.5043L4.83891 17.74C6.31164 19.0458 8.13782 20.6854 7.67636 22.5509C7.21491 24.4163 5.31018 24.8091 3.16 25.2313L2.49236 25.3687C2.33807 25.3993 2.19922 25.4826 2.09964 25.6043C2.01324 25.7312 1.97176 25.8832 1.98182 26.0363V29.9636C1.97926 30.1174 2.03146 30.267 2.12909 30.3858C2.22718 30.5026 2.36232 30.5823 2.512 30.6116L2.80655 30.6705C4.77018 31.0534 7.18545 31.5345 7.71564 33.4589C8.24582 35.3833 6.87127 36.532 5.15309 38.0243L4.62291 38.476C4.51326 38.581 4.44086 38.7188 4.41673 38.8687C4.38791 39.0238 4.41579 39.1841 4.49527 39.3203L6.4 42.7273C6.48109 42.8626 6.6057 42.9665 6.75345 43.0218C6.89995 43.0712 7.0586 43.0712 7.20509 43.0218L7.50945 42.9138C9.38473 42.2756 11.7215 41.4902 13.1353 42.9138C14.5491 44.3374 13.8913 45.9869 13.2138 48.0193L12.9684 48.7851C12.9173 48.9352 12.9197 49.0983 12.9752 49.2468C13.0307 49.3953 13.1358 49.5201 13.2727 49.6L16.6698 51.5636C16.8027 51.6424 16.9597 51.6703 17.1116 51.6422C17.2617 51.6204 17.3983 51.5434 17.4945 51.4262L17.7302 51.1611C18.8985 49.7963 20.3025 48.2058 21.9422 48.2058Z", fill: "#0B3541" }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M20.4498 14.2546C23.9327 12.345 28.0112 11.8302 31.8594 12.8146C35.7075 13.799 39.0378 16.2089 41.176 19.5564C41.215 19.6105 41.2425 19.6719 41.2569 19.737C41.2714 19.802 41.2724 19.8694 41.26 19.9349C41.2475 20.0003 41.2219 20.0626 41.1846 20.1179C41.1474 20.1731 41.0992 20.2202 41.0431 20.2563C40.9871 20.2923 40.9243 20.3165 40.8585 20.3275C40.7928 20.3385 40.7255 20.336 40.6607 20.3201C40.596 20.3042 40.5352 20.2753 40.482 20.2352C40.4288 20.195 40.3843 20.1444 40.3513 20.0866C39.0166 18.0175 37.1845 16.3161 35.0225 15.138C32.8605 13.9598 30.4376 13.3425 27.9755 13.3425C25.5133 13.3425 23.0904 13.9598 20.9284 15.138C18.7664 16.3161 16.9343 18.0175 15.5996 20.0866C15.5262 20.1885 15.4164 20.2585 15.2929 20.2819C15.1694 20.3053 15.0416 20.2805 14.9359 20.2126C14.8301 20.1446 14.7545 20.0386 14.7245 19.9166C14.6946 19.7945 14.7126 19.6656 14.7749 19.5564C16.193 17.342 18.1443 15.519 20.4498 14.2546ZM14.9713 35.7662C15.0807 35.6961 15.2134 35.6722 15.3404 35.6998C15.4674 35.7274 15.5783 35.8042 15.6487 35.9135C16.9834 37.9825 18.8155 39.6839 20.9775 40.8621C23.1395 42.0402 25.5624 42.6575 28.0245 42.6575C30.4867 42.6575 32.9096 42.0402 35.0716 40.8621C37.2336 39.6839 39.0657 37.9825 40.4004 35.9135C40.4738 35.8115 40.5836 35.7415 40.7071 35.7181C40.8306 35.6947 40.9584 35.7195 41.0641 35.7875C41.1699 35.8554 41.2455 35.9614 41.2755 36.0835C41.3054 36.2055 41.2874 36.3345 41.2251 36.4436C39.8097 38.6614 37.8583 40.4868 35.5511 41.7513C33.244 43.0158 30.6555 43.6786 28.0245 43.6786C25.3936 43.6786 22.8051 43.0158 20.4979 41.7513C18.1908 40.4868 16.2394 38.6614 14.824 36.4436C14.7539 36.3342 14.73 36.2015 14.7576 36.0745C14.7852 35.9475 14.8621 35.8366 14.9713 35.7662ZM31.6622 20.7051C31.7208 20.7315 31.7735 20.7694 31.8172 20.8165C31.861 20.8636 31.8948 20.919 31.9168 20.9794C31.9387 21.0398 31.9484 21.104 31.9451 21.1681C31.9419 21.2323 31.9258 21.2952 31.8978 21.3531L25.0545 36.1982C25.0328 36.264 24.9973 36.3244 24.9505 36.3755C24.9037 36.4266 24.8466 36.4672 24.7829 36.4947C24.7193 36.5221 24.6506 36.5358 24.5813 36.5347C24.512 36.5337 24.4437 36.518 24.3809 36.4887C24.3181 36.4594 24.2622 36.4172 24.217 36.3647C24.1717 36.3123 24.138 36.2508 24.1182 36.1844C24.0983 36.118 24.0928 36.0482 24.1019 35.9795C24.1109 35.9108 24.1345 35.8448 24.1709 35.7858L31.0436 20.9407C31.096 20.841 31.1816 20.7628 31.2857 20.7198C31.3897 20.6767 31.5056 20.6715 31.6131 20.7051H31.6622ZM20.44 25.0546C20.5058 25.0328 20.5662 24.9973 20.6173 24.9505C20.6684 24.9037 20.709 24.8466 20.7365 24.7829C20.7639 24.7193 20.7776 24.6506 20.7766 24.5813C20.7755 24.512 20.7599 24.4437 20.7305 24.3809C20.7012 24.3181 20.659 24.2622 20.6065 24.217C20.5541 24.1717 20.4926 24.138 20.4262 24.1182C20.3598 24.0983 20.29 24.0928 20.2213 24.1019C20.1526 24.111 20.0866 24.1345 20.0276 24.1709L14.5982 26.6451C14.3385 26.7614 14.1196 26.953 13.9698 27.1949C13.8551 27.3741 13.7803 27.5759 13.7506 27.7866C13.7208 27.9973 13.7367 28.2119 13.7973 28.4159C13.8578 28.6199 13.9615 28.8085 14.1014 28.9688C14.2413 29.1291 14.4141 29.2575 14.608 29.3451L20.0276 31.7113C20.1474 31.7634 20.283 31.7657 20.4045 31.7178C20.526 31.67 20.6236 31.5758 20.6756 31.456C20.7277 31.3362 20.7301 31.2007 20.6822 31.0791C20.6343 30.9576 20.5401 30.8601 20.4204 30.808L15.0007 28.4418C14.9145 28.4029 14.84 28.3419 14.7847 28.2651C14.7351 28.1854 14.708 28.0938 14.7062 28C14.7067 27.9029 14.7339 27.8078 14.7847 27.7251C14.84 27.6483 14.9145 27.5873 15.0007 27.5484L20.44 25.0546ZM35.9429 24.1709C35.8287 24.1331 35.7046 24.1385 35.5942 24.1862C35.4837 24.2338 35.3946 24.3203 35.3438 24.4293C35.2929 24.5383 35.2838 24.6622 35.3182 24.7775C35.3527 24.8927 35.4282 24.9913 35.5305 25.0546L40.96 27.5386C41.0462 27.5775 41.1207 27.6385 41.176 27.7153C41.2269 27.798 41.254 27.8931 41.2545 27.9902C41.2527 28.084 41.2256 28.1756 41.176 28.2553C41.1207 28.3321 41.0462 28.393 40.96 28.432L35.5404 30.7982C35.4811 30.824 35.4274 30.8612 35.3825 30.9077C35.3375 30.9542 35.3022 31.0091 35.2785 31.0693C35.2548 31.1295 35.2432 31.1937 35.2443 31.2584C35.2455 31.3231 35.2593 31.3869 35.2851 31.4462C35.3109 31.5055 35.3481 31.5591 35.3946 31.6041C35.4411 31.649 35.496 31.6843 35.5562 31.708C35.6164 31.7317 35.6806 31.7434 35.7453 31.7422C35.81 31.7411 35.8738 31.7272 35.9331 31.7015L41.3527 29.3353C41.5489 29.2503 41.7241 29.1233 41.866 28.9633C42.0078 28.8033 42.1129 28.6141 42.1737 28.4091C42.2345 28.2042 42.2497 27.9883 42.2181 27.7768C42.1865 27.5654 42.109 27.3634 41.9909 27.1851C41.8389 26.945 41.6207 26.7541 41.3625 26.6353L35.9429 24.1709Z", fill: "#0B3541" })
] }));
APIGearIllustration.displayName = "APIGearIllustration";
const APlusRatingBadge = forwardRef((props, ref2) => /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { width: "64", height: "56", viewBox: "0 0 64 56", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img", "aria-label": "A Plus Rating Badge ", ...props, ref: ref2, children: [
  /* @__PURE__ */ jsxRuntimeExports.jsx("title", { children: "A Plus Rating Badge " }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M61.0157 38.6626L51.878 40.8315L52.966 30.371L61.0157 33.9053V38.6626ZM3.14551 38.7479L12.2904 40.8884L11.1953 30.4208L3.14551 33.955V38.7479Z", fill: "#0B3541" }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M32.0097 2.61636L30.6515 1.38614C30.3763 1.12738 30.0095 0.988713 29.632 1.00072C29.2545 1.01273 28.8972 1.17442 28.6391 1.45014L28.5182 1.59947L27.4515 3.07147C27.0352 3.64233 26.2629 3.82101 25.6382 3.49103L24.0168 2.63769C23.6849 2.45852 23.2954 2.41855 22.934 2.52657C22.5726 2.63459 22.2689 2.88176 22.0897 3.21369L22.0257 3.3488L21.3573 5.03414C21.0973 5.6908 20.3948 6.05718 19.7075 5.89458L17.9226 5.46791C17.5539 5.38763 17.1684 5.45717 16.851 5.66123C16.5335 5.86529 16.3102 6.18714 16.2302 6.55591V6.70525L16.0026 8.51147C15.911 9.21064 15.321 9.73715 14.6159 9.7488H12.7671C11.9816 9.7488 11.3448 10.3856 11.3448 11.171C11.3413 11.235 11.3413 11.2991 11.3448 11.363L11.5724 13.1692C11.6617 13.8704 11.2225 14.5308 10.5413 14.7195L8.82039 15.2386C8.06271 15.4432 7.614 16.2229 7.81772 16.9808C7.83109 17.0316 7.84772 17.0815 7.8675 17.1301L8.52172 18.7941C8.78076 19.452 8.5172 20.2003 7.90306 20.5506L6.31728 21.4466C5.98884 21.633 5.74805 21.9425 5.648 22.3066C5.54795 22.6708 5.59686 23.0598 5.78395 23.3879L5.86928 23.5159L6.93595 24.995C7.35067 25.5683 7.28098 26.3592 6.77239 26.851L5.46395 28.1168C5.18921 28.3759 5.02882 28.7337 5.01815 29.1112C5.00747 29.4887 5.1474 29.855 5.40706 30.1292C5.44868 30.1732 5.49387 30.2136 5.54217 30.2501L6.96439 31.4164C7.5075 31.8673 7.63768 32.6483 7.27017 33.251L6.29595 34.787C5.88436 35.4548 6.09116 36.3297 6.75817 36.7426L6.90039 36.8208L8.55017 37.603C9.18884 37.9071 9.50699 38.6343 9.29683 39.3097L8.75639 41.0448C8.64283 41.405 8.67722 41.7956 8.85198 42.1305C9.02673 42.4653 9.3275 42.7169 9.68795 42.8297L9.84439 42.8652L11.6435 43.2137C12.3356 43.3504 12.8229 43.9739 12.7884 44.6786L12.7031 46.5275C12.6627 47.3107 13.264 47.9787 14.0471 48.0208H14.2035L16.0311 47.9497C16.7366 47.9067 17.3666 48.3883 17.5102 49.0804L17.8728 50.8581C18.046 51.6237 18.8066 52.1043 19.5724 51.9319H19.7004L21.4497 51.3701C22.1161 51.1546 22.8402 51.4563 23.1564 52.0812L23.9528 53.6386C24.1196 53.9773 24.4141 54.2358 24.7716 54.3572C25.1291 54.4786 25.5201 54.4529 25.8586 54.2857L25.9866 54.2146L27.5439 53.2404C28.1416 52.8679 28.9218 52.9888 29.3786 53.5248L30.5591 54.947C30.8012 55.2368 31.1487 55.4184 31.5249 55.4518C31.901 55.4851 32.275 55.3675 32.5644 55.1248L32.6924 55.0039L33.9368 53.6386C34.4221 53.1272 35.2088 53.0486 35.7857 53.4537L37.2648 54.5275C37.5731 54.7456 37.9554 54.8323 38.3276 54.7682C38.6998 54.7042 39.0312 54.4948 39.2488 54.1861C39.2775 54.1451 39.3036 54.1023 39.3271 54.0581L40.2159 52.4581C40.5588 51.8395 41.3041 51.5668 41.9653 51.8181L43.6648 52.4581C44.0175 52.5947 44.4099 52.5852 44.7556 52.4317C45.1012 52.2783 45.3714 51.9935 45.5066 51.6404L45.5493 51.5052L46.0186 49.7346C46.1887 49.0452 46.8413 48.5869 47.5475 48.6608L49.3537 48.8599C49.7291 48.9018 50.1058 48.7927 50.4006 48.5565C50.6954 48.3204 50.8842 47.9767 50.9253 47.6012C50.929 47.5468 50.929 47.4921 50.9253 47.4377V45.603C50.9183 44.8892 51.4415 44.2807 52.1484 44.1808L53.9475 43.9248C54.7251 43.8147 55.2662 43.0953 55.1564 42.3177C55.1598 42.268 55.1598 42.2181 55.1564 42.1684L54.7084 40.3906C54.5193 39.7051 54.8655 38.9854 55.5191 38.7052L57.1759 37.9941C57.5249 37.8508 57.8025 37.5747 57.9479 37.2267C58.0933 36.8786 58.0944 36.487 57.9511 36.1381L57.8871 36.0315L57.0479 34.4386C56.7119 33.8206 56.8782 33.0498 57.4391 32.6252L58.9039 31.5941C59.209 31.371 59.4127 31.0356 59.4701 30.6621C59.5275 30.2885 59.4338 29.9074 59.2097 29.603C59.1733 29.5524 59.1329 29.5049 59.0888 29.4608L57.8444 28.1239C57.3642 27.6083 57.334 26.8188 57.7733 26.2679L58.9182 24.8457C59.412 24.2367 59.3198 23.3428 58.7119 22.8475L58.5982 22.7621L57.0337 21.7808C56.4394 21.3991 56.2153 20.639 56.5075 19.9959L57.2186 18.3319C57.539 17.6171 57.2211 16.7777 56.5075 16.4546L56.3653 16.3977L54.6373 15.8288C53.9664 15.6096 53.5577 14.9315 53.6773 14.2359L53.9902 12.4297C54.054 12.0571 53.9669 11.6745 53.748 11.3663C53.5292 11.0581 53.1967 10.8496 52.8239 10.787H52.6817L50.8613 10.6661C50.1567 10.6188 49.5935 10.0617 49.5386 9.35769L49.4248 7.51591C49.3941 7.13953 49.2148 6.79084 48.9267 6.54672C48.6386 6.30261 48.2652 6.18311 47.8888 6.21458H47.7466L45.9617 6.5488C45.2823 6.6704 44.6136 6.28659 44.3759 5.63858L43.7786 3.90347C43.6544 3.54679 43.3935 3.25415 43.0533 3.09007C42.7132 2.92599 42.3217 2.90395 41.9653 3.0288L41.8302 3.08569L40.1591 3.8608C39.5211 4.15703 38.7624 3.94242 38.3742 3.35591L37.3644 1.81991C37.1626 1.50115 36.8425 1.2756 36.4744 1.19292C36.1063 1.11023 35.7204 1.17718 35.4017 1.37903C35.3415 1.41708 35.2844 1.45988 35.2311 1.50703L33.8088 2.65903C33.2752 3.07427 32.523 3.05643 32.0097 2.61636Z", fill: "#EDF1F2" }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("circle", { cx: "32.1874", cy: "28.1666", r: "22.848", fill: "#EDF1F2" }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("circle", { cx: "32.3083", cy: "28.1666", r: "20.4587", stroke: "#0B3541", strokeWidth: "0.533333" }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M32.4576 23.4875C32.7634 24.3053 32.9127 24.7106 33.2114 25.5284L37.2789 25.5426C35.238 20.4155 34.1785 17.8555 31.974 12.7426C30.3456 12.7781 29.5349 12.7781 27.9136 12.7781C25.7234 17.9266 24.6709 20.5079 22.6514 25.6919C23.0664 25.6786 23.4265 25.6654 23.7609 25.6531C24.6812 25.6191 25.4079 25.5924 26.5554 25.5924C26.7786 24.9026 27.0157 24.2174 27.2665 23.5373C29.3429 23.4875 30.3811 23.4875 32.4575 23.4875H32.4576ZM31.4336 20.7141C30.175 20.7497 29.5492 20.7497 28.2905 20.7497C28.9021 19.0644 29.215 18.2252 29.8407 16.547C30.4879 18.2181 30.8079 19.0501 31.4336 20.7141ZM43.5301 17.2226C43.5301 17.7174 43.5145 18.0613 43.4974 18.4368C43.4863 18.6819 43.4745 18.9405 43.4661 19.2635L40.7639 19.1924C40.7639 19.919 40.7474 20.3982 40.7279 20.9648V20.965C40.7187 21.23 40.7089 21.5143 40.6999 21.8519L38.6305 21.8092C38.6305 20.7497 38.6305 20.2164 38.6803 19.1497C37.5923 19.1497 37.0519 19.1497 35.9639 19.1141V17.0661L38.6945 17.1017L38.7372 14.4421L40.8705 14.4848C40.8705 15.13 40.8549 15.5774 40.8379 16.0663V16.0664V16.0665C40.8267 16.3858 40.815 16.7229 40.8065 17.1444L43.5301 17.2226ZM3.88529 38.7693C22.6895 37.1337 41.6002 37.1337 60.4044 38.7693C61.1353 38.8731 61.8241 38.4005 61.9902 37.6813C62.4951 35.363 62.7511 34.211 63.2702 31.8928C63.2736 31.8265 63.2736 31.76 63.2702 31.6937C63.2976 31.3174 63.1744 30.9457 62.9276 30.6603C62.6809 30.3749 62.3309 30.1992 61.9546 30.1719C42.0709 28.3515 22.0624 28.3515 2.17863 30.1719H2.12885C1.75724 30.2503 1.4324 30.474 1.2267 30.7932C1.02099 31.1125 0.951515 31.5007 1.03374 31.8715C1.41123 33.7082 1.66373 34.8129 2.01406 36.3455C2.10589 36.7473 2.20445 37.1784 2.31374 37.6599C2.47015 38.3816 3.15289 38.8635 3.88529 38.7693Z", fill: "#0B3541" }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M30.1043 31.139C30.3952 31.2902 30.6406 31.516 30.8154 31.7932C31.187 32.3796 31.2061 33.1228 30.8652 33.7275C30.6949 34.012 30.4486 34.2435 30.1541 34.3959C29.8408 34.5621 29.4919 34.6499 29.1372 34.6519C28.7858 34.6657 28.4365 34.5924 28.1203 34.4386C27.8295 34.2874 27.5841 34.0616 27.4092 33.7844C27.23 33.4987 27.1339 33.1687 27.1319 32.8315C27.0931 32.4894 27.1549 32.1434 27.3097 31.8359C27.4743 31.5361 27.721 31.2894 28.0208 31.1248C28.6756 30.7928 29.4495 30.7928 30.1043 31.1248V31.139ZM26.2284 31.0466H25.1333L25.2186 34.6021H26.3066C26.2955 34.1585 26.2838 33.7841 26.2728 33.4357V33.4356V33.4356C26.2486 32.6671 26.2284 32.0252 26.2284 31.0466ZM22.6591 33.7275L23.1782 34.6875L24.4013 34.6235L23.6262 33.4786C23.8146 33.3648 23.9692 33.2028 24.0742 33.0093C24.1798 32.7878 24.2263 32.5429 24.2093 32.2981C24.2235 31.9378 24.0618 31.593 23.7755 31.3737C23.4343 31.1453 23.0255 31.0399 22.6164 31.075L20.8955 31.139L21.0377 34.6946H22.1186L22.0831 33.7275H22.6591ZM16.7993 31.3666L19.8784 31.2244L19.9139 32.0421L17.9655 32.1275L18.001 32.6892L19.7646 32.611L19.8002 33.4288L18.065 33.507L18.1006 34.0759L20.0704 33.9835L20.113 34.8012C18.8899 34.851 18.2784 34.8795 17.0553 34.9506C16.9415 33.5141 16.8917 32.803 16.7993 31.3666ZM15.5546 31.7719C15.8458 31.9875 16.0195 32.3269 16.0239 32.6892C16.083 33.0661 15.9649 33.4492 15.7039 33.7275C15.4062 33.998 15.0182 34.1476 14.6159 34.147L14.0328 34.1897C14.0436 34.511 14.0721 34.8315 14.1181 35.1497L13.023 35.2208L12.6675 31.6652C13.3786 31.6155 13.6986 31.5941 14.3884 31.5586C14.7901 31.4887 15.2036 31.5643 15.5546 31.7719ZM10.2573 34.5879C10.087 34.6044 9.91738 34.5504 9.78793 34.4386C9.66008 34.3219 9.57918 34.1626 9.56037 33.9906C9.45372 33.116 9.40394 32.6965 9.30441 31.8576L9.30439 31.8574L9.30437 31.8573L8.20215 31.9497C8.2785 32.5932 8.32975 32.9899 8.39761 33.5152L8.39761 33.5152L8.39761 33.5152L8.39761 33.5153L8.39763 33.5154L8.39767 33.5157C8.41828 33.6752 8.44042 33.8466 8.46526 34.0404C8.4989 34.3318 8.60933 34.6091 8.78526 34.8439C8.95888 35.0657 9.19012 35.2354 9.4537 35.3346C10.041 35.544 10.6895 35.4949 11.2386 35.1995C11.4736 35.0632 11.6601 34.8568 11.7719 34.6093C11.8871 34.3481 11.9266 34.0598 11.8857 33.7773C11.8413 33.3403 11.8065 33.0171 11.7713 32.6902C11.7389 32.3893 11.7062 32.0853 11.6653 31.6866L10.5417 31.7435C10.6341 32.6181 10.6839 33.0377 10.7835 33.8768C10.8085 34.0511 10.7679 34.2285 10.6697 34.3746C10.57 34.5026 10.4193 34.5805 10.2573 34.5879ZM5.92638 32.9097C6.12283 32.9024 6.31929 32.924 6.50949 32.9737C6.7294 33.0233 6.9438 33.0948 7.14949 33.187L7.44816 32.3337C7.22177 32.2246 6.98299 32.1435 6.73705 32.0919C6.46086 32.0563 6.18124 32.0563 5.90505 32.0919C5.63761 32.1124 5.37674 32.1849 5.13705 32.3052C4.93946 32.3966 4.7718 32.5421 4.65349 32.7248C4.55354 32.9171 4.51861 33.1367 4.55394 33.3506C4.58852 33.5653 4.69661 33.7614 4.85971 33.9052C4.99259 34.0344 5.15308 34.1317 5.32905 34.1897C5.54221 34.248 5.75819 34.2955 5.97616 34.3319C6.15262 34.352 6.32657 34.3902 6.49527 34.4457C6.59487 34.4741 6.66944 34.557 6.68727 34.659C6.70044 34.7333 6.6734 34.809 6.61616 34.8581C6.5387 34.9127 6.44762 34.9447 6.35305 34.9506C6.11179 34.964 5.87023 34.9302 5.64194 34.851C5.38857 34.7817 5.14833 34.6712 4.93083 34.5239C4.82607 34.8135 4.76938 34.9803 4.68208 35.2372L4.63927 35.363C4.90208 35.5314 5.19383 35.6495 5.49971 35.7115C5.80927 35.7848 6.12846 35.8088 6.44549 35.7826C6.69204 35.7567 6.93245 35.6894 7.1566 35.5835C7.35629 35.4886 7.52424 35.3379 7.64016 35.1497C7.75131 34.9535 7.79149 34.7249 7.75394 34.5026C7.73696 34.2876 7.64363 34.0858 7.49083 33.9337C7.35786 33.7979 7.19458 33.6955 7.01438 33.635C6.79868 33.5646 6.57746 33.5122 6.35305 33.4786C6.17912 33.4502 6.00786 33.4074 5.84105 33.3506C5.7462 33.3211 5.6752 33.2419 5.65616 33.1444C5.64806 33.0839 5.66918 33.0232 5.71305 32.9808C5.77547 32.9363 5.84977 32.9116 5.92638 32.9097ZM14.9502 32.7746C14.9732 32.9099 14.9341 33.0484 14.8435 33.1515H14.8648C14.7602 33.2577 14.6155 33.3145 14.4666 33.3079H13.9333C13.9166 33.1248 13.9031 32.9853 13.8898 32.8478L13.8897 32.8477C13.8746 32.6917 13.8597 32.5383 13.8408 32.3266H14.3813C14.522 32.3045 14.6657 32.3404 14.7795 32.4261C14.884 32.5122 14.9462 32.6393 14.9502 32.7746ZM22.0543 32.9381H22.68C22.8174 32.9423 22.9506 32.891 23.0498 32.7959C23.2277 32.5923 23.2277 32.2885 23.0498 32.0848C22.9415 31.9984 22.8037 31.9576 22.6658 31.971H22.04L22.0543 32.9381ZM28.3618 32.2768C28.4389 32.1347 28.5486 32.0128 28.6818 31.9212H28.6462C28.7932 31.8303 28.9642 31.7857 29.1369 31.7932C29.2932 31.7839 29.4482 31.8264 29.5778 31.9141C29.714 31.9992 29.8246 32.1197 29.8978 32.2626C30.0538 32.5736 30.0538 32.94 29.8978 33.251C29.8295 33.3969 29.7209 33.5203 29.5849 33.6066C29.459 33.6978 29.3066 33.7453 29.1511 33.7417C28.993 33.7481 28.8366 33.7059 28.7031 33.6208C28.564 33.5318 28.4491 33.4097 28.3689 33.2652C28.2908 33.1131 28.2471 32.9455 28.2409 32.7746C28.2343 32.6007 28.2761 32.4283 28.3618 32.2768ZM34.0579 34.5452L33.5744 33.5781H32.9984V34.5452H31.9175V30.9897H33.6384C34.0488 30.9605 34.4558 31.0819 34.7833 31.331C35.0693 31.5697 35.2185 31.9346 35.1815 32.3052C35.1882 32.541 35.1317 32.7742 35.0179 32.9808C34.9091 33.1725 34.749 33.33 34.5557 33.4359L35.2668 34.6164L34.0579 34.5452ZM33.6243 32.7604H32.9985V31.7933H33.6172C33.757 31.7838 33.895 31.8298 34.0012 31.9213C34.1676 32.1291 34.1676 32.4245 34.0012 32.6324C33.8968 32.7221 33.7618 32.7679 33.6243 32.7604ZM39.7541 34.6448L39.2919 33.6635H38.723V34.6306H37.6421L37.7132 31.075L39.4341 31.1177C39.847 31.0965 40.2536 31.2253 40.579 31.4804C40.8506 31.7189 40.9908 32.0735 40.9559 32.4332C40.9598 32.6817 40.8985 32.9269 40.7781 33.1444C40.6655 33.3345 40.4999 33.4877 40.3016 33.5852L41.0128 34.7799L39.7541 34.6448ZM39.3982 32.8315H38.7368L38.8008 31.8501H39.4195C39.5611 31.8461 39.6987 31.8971 39.8035 31.9924C39.8951 32.0896 39.9393 32.2223 39.9244 32.355C39.9282 32.4902 39.8769 32.6211 39.7822 32.7177C39.6738 32.8041 39.5361 32.8449 39.3982 32.8315ZM44.4682 34.8155L44.2762 34.2324L42.8042 34.1684C42.7118 34.3959 42.662 34.5097 42.5625 34.7372L41.4531 34.6946C42.1216 33.2724 42.4629 32.5612 43.1456 31.139L44.2691 31.1817C44.6876 32.2686 44.9441 32.9734 45.2798 33.8959L45.28 33.8965L45.28 33.8965C45.3835 34.181 45.4946 34.4862 45.6202 34.8297L44.4682 34.8155ZM44.0276 33.3932H43.1387L43.6649 32.2555L44.0276 33.3932ZM45.7984 31.2884L49.041 31.459C49.0493 31.7444 49.0326 32.0299 48.9913 32.3124L47.9317 32.2484C47.9039 32.7806 47.8812 33.1835 47.8586 33.5844L47.8585 33.5858L47.8584 33.5863L47.8584 33.5871C47.8348 34.0049 47.8114 34.4208 47.7824 34.979L46.6944 34.9221L46.8366 32.1915L45.7984 32.1346V31.2884ZM50.8898 31.5799L49.7947 31.5088C49.7487 32.2787 49.7131 32.8423 49.6766 33.4185C49.6454 33.912 49.6136 34.4148 49.5742 35.0644L50.648 35.1355C50.7476 33.7132 50.7973 33.0021 50.8898 31.5799ZM54.4242 31.8359L55.4268 31.9141C55.3664 32.6255 55.3219 33.159 55.2774 33.6926C55.233 34.2257 55.1886 34.7589 55.1282 35.4697L54.2108 35.3915C54.1049 35.2311 54.009 35.0859 53.9192 34.9497C53.5388 34.3732 53.2661 33.9599 52.7886 33.2581C52.7317 34.0546 52.7033 34.4528 52.6393 35.2492L51.6508 35.1497L51.8997 31.5941L52.8384 31.6581L54.2606 33.7915C54.2897 33.4748 54.3068 33.2235 54.3233 32.9826C54.3471 32.6338 54.3695 32.307 54.4242 31.8359ZM59.6365 34.0332L58.7049 33.9408C58.7003 33.9876 58.6959 34.0314 58.6919 34.0729C58.6649 34.3472 58.6477 34.5224 58.5983 34.7941C58.4195 34.8639 58.2281 34.8954 58.0365 34.8866C57.8695 34.874 57.7094 34.8149 57.5743 34.7159C57.4403 34.6171 57.3348 34.4846 57.2685 34.3319C57.2035 34.172 57.1767 33.9991 57.1903 33.827C57.2046 33.6549 57.2607 33.4889 57.3538 33.3435C57.4425 33.2051 57.5681 33.0942 57.7165 33.0235C57.8699 32.953 58.039 32.9236 58.2072 32.9381C58.5553 32.9832 58.8744 33.1555 59.1032 33.4217L59.8143 32.7604C59.6235 32.5594 59.3936 32.3996 59.1387 32.291C58.5436 32.0062 57.8583 31.9754 57.24 32.2057C56.9246 32.3276 56.6489 32.5343 56.4436 32.803C56.2436 33.0721 56.1251 33.393 56.1023 33.7275C56.068 34.071 56.1269 34.4173 56.2729 34.7301C56.4216 35.0205 56.645 35.266 56.92 35.4412C57.2116 35.6327 57.5466 35.7476 57.8943 35.7755C58.1753 35.7958 58.4577 35.7767 58.7334 35.7186C58.9988 35.6696 59.2553 35.5809 59.4943 35.4555L59.6365 34.0332Z", fill: "white" }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M23.1493 42.6448L23.0427 42.3177H22.1964L22.0684 42.6448H21.4355L22.3315 40.5755H22.9644L23.8178 42.6448H23.1493ZM22.8647 41.8697L22.6158 41.1586L22.3669 41.8697H22.8647ZM25.1262 42.019H24.4649V44.0884H25.0124V42.8581L25.4818 43.8821H25.8871L26.3493 42.8581V44.0884H26.8898V42.019H26.2284L25.6809 43.1639L25.1262 42.019ZM31.0425 40.8386C31.2207 40.8948 31.3803 40.9979 31.5048 41.1373C31.6082 41.2662 31.6635 41.4271 31.6612 41.5924C31.6652 41.7601 31.6098 41.9238 31.5048 42.0546C31.3965 42.1878 31.2501 42.2845 31.0852 42.3319C31.2823 42.3666 31.4596 42.473 31.583 42.6306C31.7107 42.7892 31.7765 42.9889 31.7679 43.1924C31.765 43.3737 31.6968 43.5479 31.5759 43.683C31.4529 43.8336 31.2903 43.9469 31.1065 44.0101C30.8796 44.0962 30.6381 44.1373 30.3954 44.131H28.6816V40.7177H30.3528C30.5882 40.7147 30.8221 40.7557 31.0425 40.8386ZM30.6305 41.7772C30.6305 41.8582 30.5968 41.9354 30.5376 41.9906V42.0119C30.4709 42.0631 30.3857 42.0837 30.303 42.0688H29.6914V41.4928H30.303C30.3873 41.4866 30.4709 41.512 30.5376 41.5639C30.5968 41.6191 30.6305 41.6963 30.6305 41.7772ZM30.6087 43.299C30.6855 43.2464 30.7288 43.1572 30.7225 43.0644C30.7251 42.9762 30.6821 42.8929 30.6087 42.8439C30.5174 42.7867 30.4105 42.7594 30.303 42.7657H29.6914V43.3844H30.303C30.4093 43.4024 30.5186 43.3796 30.6087 43.3204V43.299ZM35.3376 40.7533H32.5501L32.543 44.1808H35.3874V43.3986H33.5599V42.8581H35.1741V42.083H33.5599V41.5497H35.3376V40.7533ZM37.976 41.5497C37.8051 41.4856 37.625 41.4496 37.4427 41.443C37.3741 41.4601 37.3122 41.4973 37.2649 41.5497C37.2163 41.584 37.1872 41.6396 37.1867 41.699C37.1923 41.7926 37.25 41.875 37.336 41.9124C37.4838 41.9814 37.6388 42.0339 37.7982 42.0688C37.9997 42.1261 38.1969 42.1974 38.3884 42.2821C38.5464 42.3529 38.6853 42.4602 38.7938 42.595C38.9219 42.7559 38.9853 42.9588 38.9715 43.1639C38.9768 43.379 38.9091 43.5895 38.7795 43.7612C38.6511 43.9313 38.4755 44.0599 38.2747 44.131C38.0468 44.2137 37.8059 44.2546 37.5635 44.2519C37.2633 44.252 36.9652 44.2015 36.6818 44.1026C36.3932 44.0117 36.1234 43.8696 35.8853 43.683L36.2693 42.915C36.4532 43.0778 36.6653 43.2055 36.8951 43.2919C37.097 43.383 37.314 43.4361 37.5351 43.4484C37.6274 43.4562 37.7198 43.4337 37.7982 43.3844C37.856 43.3404 37.8901 43.2721 37.8907 43.1995C37.8837 43.1042 37.823 43.0214 37.7342 42.9861C37.5841 42.9166 37.4267 42.8641 37.2649 42.8297C37.0639 42.7797 36.8666 42.7155 36.6747 42.6377C36.5167 42.5669 36.3778 42.4597 36.2693 42.3248C36.1499 42.168 36.0895 41.9741 36.0987 41.7772C36.093 41.5709 36.1555 41.3685 36.2764 41.2012C36.3976 41.0284 36.5688 40.8968 36.7671 40.8244C36.9932 40.7338 37.2347 40.6879 37.4782 40.6892C37.7362 40.6882 37.9928 40.7266 38.2391 40.803C38.4733 40.862 38.6965 40.9581 38.9004 41.0875L38.5235 41.8697C38.3517 41.7457 38.1683 41.6386 37.976 41.5497ZM42.3922 40.7533H39.3984V41.5497H40.4011V44.1524H41.418V41.5497H42.3922V40.7533Z", fill: "#0B3541" })
] }));
APlusRatingBadge.displayName = "APlusRatingBadge";
const AffordableIllustration = forwardRef((props, ref2) => /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { width: "56", height: "56", viewBox: "0 0 56 56", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img", "aria-label": "Affordable Illustration ", ...props, ref: ref2, children: [
  /* @__PURE__ */ jsxRuntimeExports.jsx("title", { children: "Affordable Illustration " }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M54.898 9.22422C54.9951 9.48273 54.8642 9.771 54.6057 9.86808C52.9134 10.5036 51.9024 11.787 51.4852 13.1119C51.9713 12.9646 52.5095 12.922 53.0979 13.0397C53.9472 13.2096 54.5763 13.5963 54.9825 14.1182C55.3862 14.6371 55.5423 15.2548 55.5078 15.8395C55.441 16.9697 54.6183 18.14 53.2899 18.14C52.2409 18.14 51.4286 17.6449 50.9145 16.8823C50.568 16.3683 50.3621 15.7431 50.2904 15.0763C50.1771 15.199 50.0685 15.3282 49.9646 15.4619C49.6019 15.9284 49.3235 16.4169 49.1351 16.792C49.0414 16.9786 48.971 17.1349 48.9245 17.2433C48.9013 17.2975 48.8841 17.3396 48.873 17.3674L48.861 17.3979L48.8584 17.4046L48.8581 17.4053L48.8581 17.4056C48.858 17.4056 48.858 17.4056 48.858 17.4056C48.7611 17.664 48.4731 17.795 48.2146 17.6982C47.956 17.6014 47.8248 17.3133 47.9216 17.0547L48.3899 17.23C47.9216 17.0547 47.9217 17.0545 47.9218 17.0543L47.9219 17.0539L47.9224 17.0527L47.9237 17.0491L47.9282 17.0374L47.9444 16.9963C47.9583 16.9614 47.9787 16.9117 48.0053 16.8495C48.0586 16.7251 48.1375 16.5502 48.2415 16.343C48.4488 15.9306 48.7604 15.3816 49.1752 14.8481C49.4848 14.4498 49.8687 14.0405 50.3242 13.7061C50.6087 11.8195 51.8698 9.82728 54.2541 8.93191C54.5126 8.83483 54.8009 8.9657 54.898 9.22422ZM51.2684 14.2856C51.2231 15.0951 51.4018 15.8161 51.7437 16.3233C52.0836 16.8276 52.5939 17.14 53.2899 17.14C53.9315 17.14 54.4638 16.5553 54.5095 15.7805C54.5312 15.4127 54.433 15.0404 54.1933 14.7324C53.956 14.4274 53.5526 14.1504 52.9018 14.0203C52.3003 13.9 51.7554 14.0187 51.2684 14.2856Z", fill: "#0B3541" }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15.3266 8.0373C16.7514 8.24202 18.1221 8.72156 19.3628 9.44849C22.4052 8.35344 25.6162 7.79871 28.8509 7.81C41.7078 7.81039 52.3 16.3447 52.3 27.07C52.3 33.1838 48.8468 38.59 43.5366 42.1449L44.0068 45.7132L44.0077 45.7218C44.0203 45.8525 44.021 45.9842 44.0098 46.115C44.0053 46.4553 43.9353 46.7916 43.8036 47.1055C43.6689 47.4264 43.4723 47.7176 43.2251 47.9625C42.9779 48.2075 42.6849 48.4013 42.3627 48.533C42.041 48.6645 41.6965 48.7314 41.349 48.73C40.1341 48.7304 38.9408 48.4082 37.8913 47.7963C36.9525 47.249 36.1588 46.4874 35.5737 45.576C33.3612 46.1231 31.0901 46.3999 28.81 46.4C26.5296 46.3981 24.2577 46.1211 22.0445 45.5753C21.4561 46.4813 20.6604 47.2368 19.721 47.7777C18.6765 48.3791 17.4917 48.6938 16.2866 48.6901C16.1355 48.7004 15.9839 48.6999 15.8328 48.6886L15.8047 48.6865L15.7771 48.6813C15.0823 48.5499 14.4677 48.1492 14.067 47.5667C13.6681 46.9866 13.5135 46.2729 13.6364 45.5799L14.1522 42.0338C11.0299 39.7133 8.03161 37.2305 5.16973 34.5955C3.94989 34.5429 2.79116 34.0345 1.92538 33.1667C1.01261 32.2519 0.499997 31.0123 0.5 29.72V26.3111C0.497221 25.6701 0.621018 25.0348 0.864295 24.4418C1.10772 23.8483 1.46598 23.3088 1.91849 22.8543C2.371 22.3997 2.90886 22.039 3.50117 21.7928C4.09349 21.5467 4.72859 21.42 5.37001 21.42H6.42412C7.69994 18.126 9.86013 15.2486 12.6657 13.1043L9.76794 8.05427L10.4784 7.93671C12.0868 7.67055 13.7307 7.70467 15.3266 8.0373ZM41.349 48.73C41.3485 48.73 41.3481 48.73 41.3477 48.73L41.35 48.23L41.3503 48.73C41.3498 48.73 41.3494 48.73 41.349 48.73ZM11.3636 8.82587L13.9769 13.3803L13.6142 13.6443C10.699 15.7661 8.48015 18.7065 7.23947 22.092L7.11928 22.42H5.36999C4.86028 22.42 4.3556 22.5207 3.88491 22.7163C3.41422 22.9119 2.98681 23.1985 2.62721 23.5598C2.26762 23.921 1.98292 24.3497 1.78948 24.8213C1.59604 25.2929 1.49766 25.798 1.49999 26.3077L1.50001 26.31L1.5 29.72C1.5 30.7475 1.90757 31.7331 2.63329 32.4604C3.35902 33.1878 4.34364 33.5977 5.37114 33.6L5.5661 33.6004L5.7093 33.7327C8.6596 36.4584 11.7569 39.0207 14.9872 41.4079L15.2279 41.5858L14.6236 45.7405L14.622 45.749C14.5431 46.1851 14.6398 46.6348 14.891 47C15.1369 47.3575 15.5114 47.6058 15.9357 47.6933C16.0346 47.6994 16.1339 47.6988 16.2328 47.6914L16.2529 47.6899L16.273 47.69C17.3076 47.6962 18.3254 47.4274 19.222 46.9111C20.1186 46.3948 20.862 45.6495 21.3761 44.7516L21.5661 44.4197L21.9361 44.5162C24.1808 45.1011 26.4908 45.3981 28.8104 45.4C31.1298 45.3999 33.4396 45.1029 35.6835 44.5163L36.0559 44.4189L36.2453 44.7539C36.7562 45.6577 37.4981 46.4095 38.3949 46.9324C39.2918 47.4553 40.3115 47.7306 41.3497 47.73L41.3523 47.73C41.569 47.731 41.7838 47.6893 41.9843 47.6073C42.1849 47.5254 42.3674 47.4047 42.5213 47.2522C42.6752 47.0997 42.7976 46.9183 42.8815 46.7185C42.9653 46.5187 43.009 46.3044 43.01 46.0877L43.0101 46.0647L43.0123 46.0418C43.0193 45.97 43.0195 45.8978 43.0131 45.8259L42.4631 41.6528L42.7274 41.4809C47.9679 38.0721 51.3 32.8755 51.3 27.07C51.3 17.0756 41.3527 8.81 28.85 8.81L28.8482 8.81C25.6526 8.79874 22.4808 9.36062 19.4834 10.469L19.2551 10.5534L19.0478 10.4257C17.865 9.69737 16.5449 9.22055 15.1696 9.02502L15.1534 9.02272L15.1374 9.01936C13.8957 8.75896 12.6225 8.69414 11.3636 8.82587Z", fill: "#0B3541" }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M36.85 14.09C34.3226 13.0044 31.6007 12.4445 28.85 12.4445C26.0993 12.4445 23.3774 13.0044 20.85 14.09", stroke: "#90AFAA", strokeMiterlimit: "10", strokeLinecap: "round" })
] }));
AffordableIllustration.displayName = "AffordableIllustration";
const AmexLogoLarge = forwardRef((props, ref2) => /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { width: "68", height: "46", viewBox: "0 0 68 46", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img", "aria-label": "Amex Logo Large ", ...props, ref: ref2, children: [
  /* @__PURE__ */ jsxRuntimeExports.jsxs("g", { filter: "url(#filter0_dd_1_1152)", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("title", { children: "Amex Logo Large " }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2 4C2 2.34315 3.34315 1 5 1H63C64.6569 1 66 2.34315 66 4V40C66 41.6569 64.6569 43 63 43H5C3.34315 43 2 41.6569 2 40V4Z", fill: "url(#paint0_radial_1_1152)" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2 4C2 2.34315 3.34315 1 5 1H63C64.6569 1 66 2.34315 66 4V40C66 41.6569 64.6569 43 63 43H5C3.34315 43 2 41.6569 2 40V4Z", fill: "#E5E5E5", fillOpacity: "0.01" }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("mask", { id: "path4-outside1_1_1152", maskUnits: "userSpaceOnUse", x: "9", y: "16", width: "51", height: "12", fill: "black", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("rect", { fill: "white", x: "9", y: "16", width: "51", height: "12" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16.6572 22.9076L17.9909 19.972H18.0196L19.3103 22.9076H16.6572ZM16.872 18L13 26H15.2658L16.0689 24.2185H19.8979L20.6723 26H23.0098L19.1808 18H16.872ZM23.8989 18V26H26.007V20.3866H26.0357L28.5453 26H30.2805L32.7901 20.3305H32.8188V26H34.9269V18H31.7576L29.4918 23.5014H29.4631L27.0682 18H23.8989ZM36.9062 18V26H44.6789V24.521H39.1577V22.5602H44.1196V21.1933H39.1577V19.479H44.5642V18H36.9062ZM48.708 21.8095L45.1372 26H47.6612L49.9413 23.2325L52.1785 26H54.8602L51.2894 21.8207L54.5734 18H52.1068L50.0274 20.5546L48.0197 18H45.4097L48.708 21.8095Z" })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16.6572 22.9076L17.9909 19.972H18.0196L19.3103 22.9076H16.6572ZM16.872 18L13 26H15.2658L16.0689 24.2185H19.8979L20.6723 26H23.0098L19.1808 18H16.872ZM23.8989 18V26H26.007V20.3866H26.0357L28.5453 26H30.2805L32.7901 20.3305H32.8188V26H34.9269V18H31.7576L29.4918 23.5014H29.4631L27.0682 18H23.8989ZM36.9062 18V26H44.6789V24.521H39.1577V22.5602H44.1196V21.1933H39.1577V19.479H44.5642V18H36.9062ZM48.708 21.8095L45.1372 26H47.6612L49.9413 23.2325L52.1785 26H54.8602L51.2894 21.8207L54.5734 18H52.1068L50.0274 20.5546L48.0197 18H45.4097L48.708 21.8095Z", fill: "#1793C0", fillOpacity: "0.01" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M16.6572 22.9076L14.8363 22.0803L13.5519 24.9076H16.6572V22.9076ZM17.9909 19.972V17.972H16.7028L16.17 19.1447L17.9909 19.972ZM18.0196 19.972L19.8504 19.167L19.325 17.972H18.0196V19.972ZM19.3103 22.9076V24.9076H22.3743L21.1411 22.1026L19.3103 22.9076ZM16.872 18V16H15.618L15.0718 17.1287L16.872 18ZM13 26L11.1998 25.1287L9.81007 28H13V26ZM15.2658 26V28H16.5581L17.0891 26.8219L15.2658 26ZM16.0689 24.2185V22.2185H14.7767L14.2456 23.3966L16.0689 24.2185ZM19.8979 24.2185L21.7321 23.4212L21.2093 22.2185H19.8979V24.2185ZM20.6723 26L18.8381 26.7973L19.3608 28H20.6723V26ZM23.0098 26V28H26.1843L24.8138 25.1366L23.0098 26ZM19.1808 18L20.9848 17.1366L20.4409 16H19.1808V18ZM23.8989 18V16H21.8989V18H23.8989ZM23.8989 26H21.8989V28H23.8989V26ZM26.007 26V28H28.007V26H26.007ZM26.007 20.3866V18.3866H24.007V20.3866H26.007ZM26.0357 20.3866L27.8615 19.5703L27.3323 18.3866H26.0357V20.3866ZM28.5453 26L26.7194 26.8163L27.2487 28H28.5453V26ZM30.2805 26V28H31.5824L32.1093 26.8095L30.2805 26ZM32.7901 20.3305V18.3305H31.4882L30.9613 19.521L32.7901 20.3305ZM32.8188 20.3305H34.8188V18.3305H32.8188V20.3305ZM32.8188 26H30.8188V28H32.8188V26ZM34.9269 26V28H36.9269V26H34.9269ZM34.9269 18H36.9269V16H34.9269V18ZM31.7576 18V16H30.4183L29.9083 17.2383L31.7576 18ZM29.4918 23.5014V25.5014H30.831L31.3411 24.2631L29.4918 23.5014ZM29.4631 23.5014L27.6293 24.2997L28.1524 25.5014H29.4631V23.5014ZM27.0682 18L28.902 17.2017L28.3788 16H27.0682V18ZM36.9062 18V16H34.9062V18H36.9062ZM36.9062 26H34.9062V28H36.9062V26ZM44.6789 26V28H46.6789V26H44.6789ZM44.6789 24.521H46.6789V22.521H44.6789V24.521ZM39.1577 24.521H37.1577V26.521H39.1577V24.521ZM39.1577 22.5602V20.5602H37.1577V22.5602H39.1577ZM44.1196 22.5602V24.5602H46.1196V22.5602H44.1196ZM44.1196 21.1933H46.1196V19.1933H44.1196V21.1933ZM39.1577 21.1933H37.1577V23.1933H39.1577V21.1933ZM39.1577 19.479V17.479H37.1577V19.479H39.1577ZM44.5642 19.479V21.479H46.5642V19.479H44.5642ZM44.5642 18H46.5642V16H44.5642V18ZM48.708 21.8095L50.2303 23.1067L51.3445 21.7991L50.22 20.5004L48.708 21.8095ZM45.1372 26L43.6149 24.7028L40.8053 28H45.1372V26ZM47.6612 26V28H48.6047L49.2047 27.2718L47.6612 26ZM49.9413 23.2325L51.4967 21.9752L49.9561 20.0693L48.3978 21.9607L49.9413 23.2325ZM52.1785 26L50.6231 27.2573L51.2235 28H52.1785V26ZM54.8602 26V28H59.1996L56.3807 24.7008L54.8602 26ZM51.2894 21.8207L49.7726 20.5171L48.6554 21.8168L49.7688 23.1199L51.2894 21.8207ZM54.5734 18L56.0901 19.3037L58.9297 16H54.5734V18ZM52.1068 18V16H51.1559L50.5557 16.7374L52.1068 18ZM50.0274 20.5546L48.4549 21.7905L50 23.7564L51.5785 21.8172L50.0274 20.5546ZM48.0197 18L49.5922 16.7642L48.9916 16H48.0197V18ZM45.4097 18V16H41.0326L43.8977 19.3091L45.4097 18ZM18.4781 23.7348L19.8118 20.7992L16.17 19.1447L14.8363 22.0803L18.4781 23.7348ZM17.9909 21.972H18.0196V17.972H17.9909V21.972ZM16.1887 20.7769L17.4794 23.7125L21.1411 22.1026L19.8504 19.167L16.1887 20.7769ZM19.3103 20.9076H16.6572V24.9076H19.3103V20.9076ZM15.0718 17.1287L11.1998 25.1287L14.8002 26.8713L18.6722 18.8713L15.0718 17.1287ZM13 28H15.2658V24H13V28ZM17.0891 26.8219L17.8922 25.0404L14.2456 23.3966L13.4425 25.1781L17.0891 26.8219ZM16.0689 26.2185H19.8979V22.2185H16.0689V26.2185ZM18.0637 25.0158L18.8381 26.7973L22.5065 25.2027L21.7321 23.4212L18.0637 25.0158ZM20.6723 28H23.0098V24H20.6723V28ZM24.8138 25.1366L20.9848 17.1366L17.3768 18.8634L21.2058 26.8634L24.8138 25.1366ZM19.1808 16H16.872V20H19.1808V16ZM21.8989 18V26H25.8989V18H21.8989ZM23.8989 28H26.007V24H23.8989V28ZM28.007 26V20.3866H24.007V26H28.007ZM26.007 22.3866H26.0357V18.3866H26.007V22.3866ZM24.2098 21.2028L26.7194 26.8163L30.3711 25.1837L27.8615 19.5703L24.2098 21.2028ZM28.5453 28H30.2805V24H28.5453V28ZM32.1093 26.8095L34.619 21.1401L30.9613 19.521L28.4517 25.1905L32.1093 26.8095ZM32.7901 22.3305H32.8188V18.3305H32.7901V22.3305ZM30.8188 20.3305V26H34.8188V20.3305H30.8188ZM32.8188 28H34.9269V24H32.8188V28ZM36.9269 26V18H32.9269V26H36.9269ZM34.9269 16H31.7576V20H34.9269V16ZM29.9083 17.2383L27.6425 22.7397L31.3411 24.2631L33.6069 18.7617L29.9083 17.2383ZM29.4918 21.5014H29.4631V25.5014H29.4918V21.5014ZM31.2969 22.7031L28.902 17.2017L25.2344 18.7983L27.6293 24.2997L31.2969 22.7031ZM27.0682 16H23.8989V20H27.0682V16ZM34.9062 18V26H38.9062V18H34.9062ZM36.9062 28H44.6789V24H36.9062V28ZM46.6789 26V24.521H42.6789V26H46.6789ZM44.6789 22.521H39.1577V26.521H44.6789V22.521ZM41.1577 24.521V22.5602H37.1577V24.521H41.1577ZM39.1577 24.5602H44.1196V20.5602H39.1577V24.5602ZM46.1196 22.5602V21.1933H42.1196V22.5602H46.1196ZM44.1196 19.1933H39.1577V23.1933H44.1196V19.1933ZM41.1577 21.1933V19.479H37.1577V21.1933H41.1577ZM39.1577 21.479H44.5642V17.479H39.1577V21.479ZM46.5642 19.479V18H42.5642V19.479H46.5642ZM44.5642 16H36.9062V20H44.5642V16ZM47.1858 20.5123L43.6149 24.7028L46.6595 27.2972L50.2303 23.1067L47.1858 20.5123ZM45.1372 28H47.6612V24H45.1372V28ZM49.2047 27.2718L51.4849 24.5043L48.3978 21.9607L46.1176 24.7282L49.2047 27.2718ZM48.386 24.4898L50.6231 27.2573L53.7338 24.7427L51.4967 21.9752L48.386 24.4898ZM52.1785 28H54.8602V24H52.1785V28ZM56.3807 24.7008L52.8099 20.5215L49.7688 23.1199L53.3396 27.2992L56.3807 24.7008ZM52.8061 23.1244L56.0901 19.3037L53.0566 16.6963L49.7726 20.5171L52.8061 23.1244ZM54.5734 16H52.1068V20H54.5734V16ZM50.5557 16.7374L48.4763 19.2921L51.5785 21.8172L53.6579 19.2626L50.5557 16.7374ZM51.5999 19.3188L49.5922 16.7642L46.4472 19.2358L48.4549 21.7905L51.5999 19.3188ZM48.0197 16H45.4097V20H48.0197V16ZM43.8977 19.3091L47.196 23.1187L50.22 20.5004L46.9217 16.6909L43.8977 19.3091Z", fill: "white", mask: "url(#path4-outside1_1_1152)" })
  ] }),
  /* @__PURE__ */ jsxRuntimeExports.jsxs("defs", { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs("filter", { id: "filter0_dd_1_1152", x: "0", y: "0", width: "68", height: "46", filterUnits: "userSpaceOnUse", colorInterpolationFilters: "sRGB", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("feFlood", { floodOpacity: "0", result: "BackgroundImageFix" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("feColorMatrix", { in: "SourceAlpha", type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0", result: "hardAlpha" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("feOffset", { dy: "1" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("feGaussianBlur", { stdDeviation: "1" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("feComposite", { in2: "hardAlpha", operator: "out" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("feColorMatrix", { type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("feBlend", { mode: "normal", in2: "BackgroundImageFix", result: "effect1_dropShadow_1_1152" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("feColorMatrix", { in: "SourceAlpha", type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0", result: "hardAlpha" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("feOffset", {}),
      /* @__PURE__ */ jsxRuntimeExports.jsx("feGaussianBlur", { stdDeviation: "0.5" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("feColorMatrix", { type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("feBlend", { mode: "normal", in2: "effect1_dropShadow_1_1152", result: "effect2_dropShadow_1_1152" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("feBlend", { mode: "normal", in: "SourceGraphic", in2: "effect2_dropShadow_1_1152", result: "shape" })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("radialGradient", { id: "paint0_radial_1_1152", cx: "0", cy: "0", r: "1", gradientUnits: "userSpaceOnUse", gradientTransform: "translate(23.4922 8.96094) rotate(90) scale(42 64)", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { stopColor: "#71C8F2" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { offset: "1", stopColor: "#0071BD" })
    ] })
  ] })
] }));
AmexLogoLarge.displayName = "AmexLogoLarge";
const AmexLogoSmall = forwardRef((props, ref2) => /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { width: "36", height: "25", viewBox: "0 0 36 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img", "aria-label": "Amex Logo Small ", ...props, ref: ref2, children: [
  /* @__PURE__ */ jsxRuntimeExports.jsxs("g", { filter: "url(#filter0_dd_1_1067)", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("title", { children: "Amex Logo Small " }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2 2.5C2 1.67157 2.67157 1 3.5 1H32.5C33.3284 1 34 1.67157 34 2.5V20.5C34 21.3284 33.3284 22 32.5 22H3.5C2.67157 22 2 21.3284 2 20.5V2.5Z", fill: "url(#paint0_radial_1_1067)" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2 2.5C2 1.67157 2.67157 1 3.5 1H32.5C33.3284 1 34 1.67157 34 2.5V20.5C34 21.3284 33.3284 22 32.5 22H3.5C2.67157 22 2 21.3284 2 20.5V2.5Z", fill: "#E5E5E5", fillOpacity: "0.01" }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("mask", { id: "path4-outside1_1_1067", maskUnits: "userSpaceOnUse", x: "5.56794", y: "8", width: "25", height: "7", fill: "black", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("rect", { fill: "white", x: "5.56794", y: "8", width: "25", height: "7" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.39655 12.0672L10.0634 10.2325H10.0777L10.7231 12.0672H9.39655ZM9.50393 9L7.56794 14H8.70085L9.10239 12.8866H11.0169L11.4041 14H12.5728L10.6584 9H9.50393ZM13.0172 9V14H14.0712V10.4916H14.0855L15.3403 14H16.208L17.4628 10.4566H17.4771V14H18.5311V9H16.9465L15.8136 12.4384H15.7992L14.6018 9H13.0172ZM19.5211 9V14H23.4074V13.0756H20.6468V11.8501H23.1277V10.9958H20.6468V9.92437H23.35V9H19.5211ZM25.4222 11.381L23.6368 14H24.8988L26.0388 12.2703L27.1574 14H28.4983L26.7129 11.388L28.3549 9H27.1216L26.0819 10.5966L25.078 9H23.773L25.4222 11.381Z" })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.39655 12.0672L10.0634 10.2325H10.0777L10.7231 12.0672H9.39655ZM9.50393 9L7.56794 14H8.70085L9.10239 12.8866H11.0169L11.4041 14H12.5728L10.6584 9H9.50393ZM13.0172 9V14H14.0712V10.4916H14.0855L15.3403 14H16.208L17.4628 10.4566H17.4771V14H18.5311V9H16.9465L15.8136 12.4384H15.7992L14.6018 9H13.0172ZM19.5211 9V14H23.4074V13.0756H20.6468V11.8501H23.1277V10.9958H20.6468V9.92437H23.35V9H19.5211ZM25.4222 11.381L23.6368 14H24.8988L26.0388 12.2703L27.1574 14H28.4983L26.7129 11.388L28.3549 9H27.1216L26.0819 10.5966L25.078 9H23.773L25.4222 11.381Z", fill: "#1793C0", fillOpacity: "0.01" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M9.39655 12.0672L8.4567 11.7256L7.9691 13.0672H9.39655V12.0672ZM10.0634 10.2325V9.23249H9.36285L9.12355 9.8909L10.0634 10.2325ZM10.0777 10.2325L11.0211 9.90069L10.7861 9.23249H10.0777V10.2325ZM10.7231 12.0672V13.0672H12.1348L11.6664 11.7354L10.7231 12.0672ZM9.50393 9V8H8.81878L8.57139 8.63892L9.50393 9ZM7.56794 14L6.6354 13.6389L6.1084 15H7.56794V14ZM8.70085 14V15H9.40326L9.64155 14.3392L8.70085 14ZM9.10239 12.8866V11.8866H8.39998L8.16169 12.5473L9.10239 12.8866ZM11.0169 12.8866L11.9614 12.5581L11.7279 11.8866H11.0169V12.8866ZM11.4041 14L10.4595 14.3285L10.6931 15H11.4041V14ZM12.5728 14V15H14.0265L13.5067 13.6424L12.5728 14ZM10.6584 9L11.5922 8.64242L11.3463 8H10.6584V9ZM13.0172 9V8H12.0172V9H13.0172ZM13.0172 14H12.0172V15H13.0172V14ZM14.0712 14V15H15.0712V14H14.0712ZM14.0712 10.4916V9.4916H13.0712V10.4916H14.0712ZM14.0855 10.4916L15.0271 10.1548L14.7899 9.4916H14.0855V10.4916ZM15.3403 14L14.3988 14.3368L14.636 15H15.3403V14ZM16.208 14V15H16.9147L17.1506 14.3338L16.208 14ZM17.4628 10.4566V9.45658H16.756L16.5201 10.1228L17.4628 10.4566ZM17.4771 10.4566H18.4771V9.45658H17.4771V10.4566ZM17.4771 14H16.4771V15H17.4771V14ZM18.5311 14V15H19.5311V14H18.5311ZM18.5311 9H19.5311V8H18.5311V9ZM16.9465 9V8H16.2231L15.9967 8.68706L16.9465 9ZM15.8136 12.4384V13.4384H16.537L16.7634 12.7513L15.8136 12.4384ZM15.7992 12.4384L14.8549 12.7673L15.0886 13.4384H15.7992V12.4384ZM14.6018 9L15.5462 8.67111L15.3125 8H14.6018V9ZM19.5211 9V8H18.5211V9H19.5211ZM19.5211 14H18.5211V15H19.5211V14ZM23.4074 14V15H24.4074V14H23.4074ZM23.4074 13.0756H24.4074V12.0756H23.4074V13.0756ZM20.6468 13.0756H19.6468V14.0756H20.6468V13.0756ZM20.6468 11.8501V10.8501H19.6468V11.8501H20.6468ZM23.1277 11.8501V12.8501H24.1277V11.8501H23.1277ZM23.1277 10.9958H24.1277V9.9958H23.1277V10.9958ZM20.6468 10.9958H19.6468V11.9958H20.6468V10.9958ZM20.6468 9.92437V8.92437H19.6468V9.92437H20.6468ZM23.35 9.92437V10.9244H24.35V9.92437H23.35ZM23.35 9H24.35V8H23.35V9ZM25.4222 11.381L26.2485 11.9442L26.6355 11.3764L26.2443 10.8115L25.4222 11.381ZM23.6368 14L22.8105 13.4367L21.7448 15H23.6368V14ZM24.8988 14V15H25.4373L25.7337 14.5503L24.8988 14ZM26.0388 12.2703L26.8786 11.7273L26.0468 10.4411L25.2039 11.72L26.0388 12.2703ZM27.1574 14L26.3177 14.543L26.6132 15H27.1574V14ZM28.4983 14V15H30.3931L29.3238 13.4357L28.4983 14ZM26.7129 11.388L25.8889 10.8214L25.5004 11.3863L25.8873 11.9523L26.7129 11.388ZM28.3549 9L29.1789 9.5666L30.2561 8H28.3549V9ZM27.1216 9V8H26.5794L26.2836 8.45432L27.1216 9ZM26.0819 10.5966L25.2353 11.1289L26.0671 12.4519L26.9199 11.1423L26.0819 10.5966ZM25.078 9L25.9246 8.46774L25.6305 8H25.078V9ZM23.773 9V8H21.8639L22.951 9.5694L23.773 9ZM10.3364 12.4088L11.0032 10.5741L9.12355 9.8909L8.4567 11.7256L10.3364 12.4088ZM10.0634 11.2325H10.0777V9.23249H10.0634V11.2325ZM9.13439 10.5643L9.77972 12.399L11.6664 11.7354L11.0211 9.90069L9.13439 10.5643ZM10.7231 11.0672H9.39655V13.0672H10.7231V11.0672ZM8.57139 8.63892L6.6354 13.6389L8.50048 14.3611L10.4365 9.36108L8.57139 8.63892ZM7.56794 15H8.70085V13H7.56794V15ZM9.64155 14.3392L10.0431 13.2258L8.16169 12.5473L7.76015 13.6608L9.64155 14.3392ZM9.10239 13.8866H11.0169V11.8866H9.10239V13.8866ZM10.0724 13.215L10.4595 14.3285L12.3486 13.6715L11.9614 12.5581L10.0724 13.215ZM11.4041 15H12.5728V13H11.4041V15ZM13.5067 13.6424L11.5922 8.64242L9.72447 9.35758L11.6389 14.3576L13.5067 13.6424ZM10.6584 8H9.50393V10H10.6584V8ZM12.0172 9V14H14.0172V9H12.0172ZM13.0172 15H14.0712V13H13.0172V15ZM15.0712 14V10.4916H13.0712V14H15.0712ZM14.0712 11.4916H14.0855V9.4916H14.0712V11.4916ZM13.1439 10.8284L14.3988 14.3368L16.2819 13.6632L15.0271 10.1548L13.1439 10.8284ZM15.3403 15H16.208V13H15.3403V15ZM17.1506 14.3338L18.4054 10.7904L16.5201 10.1228L15.2653 13.6662L17.1506 14.3338ZM17.4628 11.4566H17.4771V9.45658H17.4628V11.4566ZM16.4771 10.4566V14H18.4771V10.4566H16.4771ZM17.4771 15H18.5311V13H17.4771V15ZM19.5311 14V9H17.5311V14H19.5311ZM18.5311 8H16.9465V10H18.5311V8ZM15.9967 8.68706L14.8638 12.1254L16.7634 12.7513L17.8963 9.31294L15.9967 8.68706ZM15.8136 11.4384H15.7992V13.4384H15.8136V11.4384ZM16.7436 12.1095L15.5462 8.67111L13.6574 9.32889L14.8549 12.7673L16.7436 12.1095ZM14.6018 8H13.0172V10H14.6018V8ZM18.5211 9V14H20.5211V9H18.5211ZM19.5211 15H23.4074V13H19.5211V15ZM24.4074 14V13.0756H22.4074V14H24.4074ZM23.4074 12.0756H20.6468V14.0756H23.4074V12.0756ZM21.6468 13.0756V11.8501H19.6468V13.0756H21.6468ZM20.6468 12.8501H23.1277V10.8501H20.6468V12.8501ZM24.1277 11.8501V10.9958H22.1277V11.8501H24.1277ZM23.1277 9.9958H20.6468V11.9958H23.1277V9.9958ZM21.6468 10.9958V9.92437H19.6468V10.9958H21.6468ZM20.6468 10.9244H23.35V8.92437H20.6468V10.9244ZM24.35 9.92437V9H22.35V9.92437H24.35ZM23.35 8H19.5211V10H23.35V8ZM24.5959 10.8177L22.8105 13.4367L24.4631 14.5633L26.2485 11.9442L24.5959 10.8177ZM23.6368 15H24.8988V13H23.6368V15ZM25.7337 14.5503L26.8738 12.8206L25.2039 11.72L24.0638 13.4497L25.7337 14.5503ZM25.1991 12.8133L26.3177 14.543L27.9971 13.457L26.8786 11.7273L25.1991 12.8133ZM27.1574 15H28.4983V13H27.1574V15ZM29.3238 13.4357L27.5384 10.8237L25.8873 11.9523L27.6727 14.5643L29.3238 13.4357ZM27.5369 11.9546L29.1789 9.5666L27.5309 8.4334L25.8889 10.8214L27.5369 11.9546ZM28.3549 8H27.1216V10H28.3549V8ZM26.2836 8.45432L25.2439 10.051L26.9199 11.1423L27.9596 9.54568L26.2836 8.45432ZM26.9284 10.0644L25.9246 8.46774L24.2314 9.53226L25.2353 11.1289L26.9284 10.0644ZM25.078 8H23.773V10H25.078V8ZM22.951 9.5694L24.6001 11.9504L26.2443 10.8115L24.5951 8.4306L22.951 9.5694Z", fill: "white", mask: "url(#path4-outside1_1_1067)" })
  ] }),
  /* @__PURE__ */ jsxRuntimeExports.jsxs("defs", { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs("filter", { id: "filter0_dd_1_1067", x: "0", y: "0", width: "36", height: "25", filterUnits: "userSpaceOnUse", colorInterpolationFilters: "sRGB", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("feFlood", { floodOpacity: "0", result: "BackgroundImageFix" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("feColorMatrix", { in: "SourceAlpha", type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0", result: "hardAlpha" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("feOffset", { dy: "1" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("feGaussianBlur", { stdDeviation: "1" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("feComposite", { in2: "hardAlpha", operator: "out" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("feColorMatrix", { type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("feBlend", { mode: "normal", in2: "BackgroundImageFix", result: "effect1_dropShadow_1_1067" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("feColorMatrix", { in: "SourceAlpha", type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0", result: "hardAlpha" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("feOffset", {}),
      /* @__PURE__ */ jsxRuntimeExports.jsx("feGaussianBlur", { stdDeviation: "0.5" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("feColorMatrix", { type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("feBlend", { mode: "normal", in2: "effect1_dropShadow_1_1067", result: "effect2_dropShadow_1_1067" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("feBlend", { mode: "normal", in: "SourceGraphic", in2: "effect2_dropShadow_1_1067", result: "shape" })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("radialGradient", { id: "paint0_radial_1_1067", cx: "0", cy: "0", r: "1", gradientUnits: "userSpaceOnUse", gradientTransform: "translate(12.7461 4.98047) rotate(90) scale(21 32)", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { stopColor: "#71C8F2" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { offset: "1", stopColor: "#0071BD" })
    ] })
  ] })
] }));
AmexLogoSmall.displayName = "AmexLogoSmall";
const ApplyOnlineStamp = forwardRef((props, ref2) => /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { width: "80", height: "80", viewBox: "0 0 80 80", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img", "aria-label": "Apply Online Stamp ", ...props, ref: ref2, children: [
  /* @__PURE__ */ jsxRuntimeExports.jsx("title", { children: "Apply Online Stamp " }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M44.8058 3.44238C44.6948 5.21913 43.2515 6.55166 41.4751 6.44061C39.6988 6.32955 38.3665 4.88597 38.4775 3.10928C38.5886 1.22148 40.0319 0 41.8082 0C43.5846 0.111054 44.9168 1.55464 44.8058 3.44238ZM39.0326 3.10928C38.9216 4.55287 40.0319 5.77434 41.4751 5.8854C42.9184 5.8854 44.1397 4.88597 44.1397 3.33133C44.2507 1.88774 43.1405 0.666266 41.6972 0.555212C40.3649 0.555212 39.1437 1.66569 39.0326 3.10928ZM29.0407 4.44175L26.4872 2.3319L25.71 2.44295L28.8186 4.99702L29.7068 7.77314L30.3729 7.66209L29.4848 4.88597L30.595 1.11042L29.9289 1.33253L29.0407 4.44175ZM20.6029 4.99708L21.158 4.77503L23.7115 9.77206L26.265 8.43952L26.4871 8.99474L23.3785 10.5494L20.6029 4.99708ZM15.4958 8.21736L13.8305 9.54989L17.7163 14.4359L18.1604 14.1028L16.7171 12.215L17.8273 11.2156C18.6045 10.5493 18.8265 9.43889 18.1604 8.55052C17.4942 7.66215 16.273 7.55109 15.4958 8.21736ZM17.7163 8.99468C18.1604 9.66094 18.0494 10.4383 17.4942 10.8825L16.384 11.7708L14.7187 9.66094L15.8289 8.77257C16.384 8.32841 17.2722 8.43947 17.7163 8.99468ZM8.27944 15.5462L9.6117 13.8805C10.2778 13.1032 11.4991 12.9922 12.2762 13.6584C13.0534 14.3247 13.1644 15.5462 12.4983 16.3235L11.4991 17.545L13.3865 19.0997L12.9424 19.5438L8.27944 15.5462ZM12.0542 15.9904C12.4983 15.4352 12.4983 14.5468 11.9432 14.1026C11.3881 13.6584 10.4999 13.7695 10.0558 14.3247L9.16761 15.4352L11.166 17.1008L12.0542 15.9904ZM44.9676 38.5887C40.6639 35.1041 34.311 35.8215 30.827 40.126L26.9333 38.5887L28.8802 20.8582H51.628L51.0131 26.1876H33.7986L32.9789 33.1568C35.0282 32.0294 37.2825 31.4145 39.6393 31.517C46.0947 31.517 51.1156 34.8991 53.165 40.331H46.6071C46.1972 39.716 45.5824 39.1011 44.9676 38.5887ZM44.8653 52.6289C45.7875 51.9115 46.6072 51.0916 47.1196 50.0667H53.4726C51.7306 56.216 46.2998 60.3155 38.8197 60.3155C32.6717 60.3155 27.7532 57.5484 24.8841 52.5264L30.6223 50.3741L30.9297 50.7841C32.3643 52.6289 34.4136 53.9613 36.6679 54.3712H36.8728L37.5901 54.4737C37.8975 54.5762 38.3074 54.5762 38.6148 54.5762H38.7172C40.6641 54.5762 42.611 54.0638 44.2505 53.0388L44.5579 52.8339L44.8653 52.6289ZM21.4002 42.5854H22.8348L24.3718 44.9426L25.9088 42.5854H27.3433V47.8123H25.8063V45.1476L24.6792 46.7874H24.0644L23.0397 45.1476V47.8123H21.4002V42.5854ZM30.6222 42.5854H28.9827V47.8123H30.6222V42.5854ZM33.5937 42.5854L35.6431 45.2501V42.5854H37.2825V47.8123H35.9505L33.9011 45.1476V47.8123H32.3641V42.5854H33.5937ZM38.8195 42.4833V45.6604C38.8195 45.7629 38.8196 45.8654 39.0245 45.7629C39.127 46.9927 40.1516 47.9152 41.3812 47.8127H41.4837C42.7133 47.8127 43.738 46.8902 43.738 45.6604V42.4833H42.0985V45.5579C42.0985 46.0704 41.6886 46.3778 41.2788 46.3778C40.7664 46.3778 40.459 45.9679 40.459 45.5579V42.4833H38.8195ZM44.6601 42.5854H49.0662V43.9177H47.6316V47.8123H45.9922V43.9177H44.5576V42.5854H44.6601ZM53.9847 43.9177V42.5854L50.1934 42.6879V47.9148H54.0872V46.5825H51.7304V45.865H53.5748V44.6352H51.7304V43.9177H53.9847ZM57.8784 44.3278C57.6735 44.0204 57.3661 43.8154 57.0587 43.8154C56.8538 43.8154 56.6488 43.9179 56.6488 44.1229C56.6488 44.2729 56.8684 44.368 57.1469 44.4886L57.1479 44.489L57.1557 44.4924C57.2551 44.5355 57.3618 44.582 57.4686 44.6353C58.3908 44.9428 59.108 45.3528 59.108 46.2751C59.108 47.1975 58.2883 47.9149 57.0587 47.9149C56.2389 47.9149 55.4192 47.6075 54.9069 46.8901L55.9315 45.9676C56.2389 46.3776 56.6488 46.5826 57.0587 46.5826C57.3661 46.5826 57.571 46.4801 57.571 46.2751C57.571 46.118 57.33 46.021 56.8942 45.8457C56.7616 45.7924 56.6111 45.7319 56.4439 45.6602C55.5217 45.2502 55.1118 44.8403 55.1118 44.1229C55.2143 43.098 56.034 42.3806 57.0587 42.483H57.1611C57.9809 42.483 58.6982 42.893 59.108 43.5079L57.8784 44.3278ZM4.3936 21.4317L8.72348 26.5398L8.94552 25.9846L7.61325 24.43L8.94552 21.9869L11.0549 22.2091L11.277 21.6538L4.72667 20.8765L4.3936 21.4317ZM8.39041 21.876L7.28018 23.8748L5.17076 21.4317L8.39041 21.876ZM49.9127 1.33241L49.4686 1.22142L47.4702 7.10676L48.0253 7.32886L49.5797 2.44289L51.6891 8.43929L52.1332 8.55034L54.0205 2.66494L53.5765 2.44289L52.0221 7.32886L49.9127 1.33241ZM58.4615 4.66404L59.0166 4.9972L56.241 9.88317L58.6835 11.3268L58.3505 11.7709L55.3529 10.1053L58.4615 4.66404ZM64.9009 8.99474L64.4568 8.66163L60.571 13.4365L61.0151 13.7697L64.9009 8.99474ZM68.4536 12.2149L68.7866 12.5481L67.3433 18.6555L71.2291 15.3242L71.6732 15.7683L67.0103 19.766L66.6772 19.4328L68.1205 13.3254L64.2347 16.6567L63.7906 16.2125L68.4536 12.2149ZM75.5591 23.4306L76.0032 23.2085L74.3378 19.7661L68.8977 22.6533L70.6741 26.0957L71.1182 25.8735L69.5639 22.9864L71.5623 21.876L72.7835 24.2079L73.2276 23.9858L72.0063 21.6538L74.0048 20.6545L75.5591 23.4306ZM7.83542 50.9697L8.05747 51.5249L2.17327 53.6348L1.95123 53.0796L7.83542 50.9697ZM9.50068 55.1895L9.27864 54.7454L3.94956 57.8546L4.28263 58.4099L8.72352 55.8558L6.17001 61.6301L6.39205 62.0744L11.7211 58.9651L11.3881 58.4099L6.94716 60.9639L9.50068 55.1895ZM11.6102 68.5147L17.4944 65.4055L17.9385 65.8497L15.718 72.1792L15.2739 71.7351L15.9401 69.7363L13.8306 67.9595L11.9432 68.959L11.6102 68.5147ZM14.4968 67.6264L16.2731 69.181L17.3833 66.1828L14.4968 67.6264ZM23.1565 69.8472C23.6006 70.1804 23.9337 70.6245 23.9337 71.1797H24.4888C24.4888 70.4024 24.0447 69.7362 23.3786 69.403C22.3794 68.7368 21.3802 69.0699 20.9361 69.8472C20.3882 70.8337 21.0301 71.6038 21.5806 72.2643L21.6022 72.2902C22.1573 72.9565 22.6014 73.5117 22.2684 74.178C21.9353 74.6221 21.2692 74.8442 20.603 74.4001C20.0479 74.0669 19.7148 73.5117 19.7148 72.8454H19.0487C19.0487 73.6227 19.4928 74.4001 20.27 74.8442C21.3802 75.5105 22.3794 75.1774 22.8235 74.4001C23.3786 73.5117 22.8235 72.7344 22.1573 71.9571L22.0972 71.8851L22.0379 71.8146C21.5416 71.2248 21.1824 70.798 21.4912 70.1804C21.8243 69.6251 22.4904 69.5141 23.1565 69.8472ZM31.5942 72.7343L32.1493 72.8454L31.0391 78.3976L33.8146 78.9529L33.7036 79.5081L30.373 78.8418L31.5942 72.7343ZM38.2555 73.734H37.7004L37.4784 79.9525H38.0335L38.2555 73.734ZM41.0313 73.8452L45.4722 73.401L45.5832 73.9563L43.5848 74.1783L44.1399 79.7306L43.5848 79.8417L43.0297 74.2894L41.1423 74.4004L41.0313 73.8452ZM51.8003 71.6239L47.4704 72.9564L47.6925 73.5116L49.5799 72.9564L51.1342 78.3977L51.6893 78.1756L50.0239 72.7343L51.9113 72.1791L51.8003 71.6239ZM54.2428 70.5135L54.798 70.1804L57.4625 75.1774L60.016 73.8449L60.238 74.289L57.1294 75.8437L54.2428 70.5135ZM62.7914 65.5166L62.4583 65.0724L59.5718 67.4043L63.4575 72.1793L66.4551 69.9584L66.1221 69.5142L63.5686 71.513L62.1253 69.7363L64.1237 68.0706L63.7906 67.6264L61.7922 69.2921L60.3489 67.5154L62.7914 65.5166ZM71.7844 64.073L67.8986 58.6319L68.2317 58.0766L74.782 59.4092L74.4489 59.9644L72.4505 59.5202L71.0072 61.8522L72.2285 63.5178L71.7844 64.073ZM70.5631 61.408L71.7844 59.5202L68.6758 58.854L70.5631 61.408ZM71.6733 52.5244C71.8954 51.9691 72.3395 51.636 72.8946 51.5249L72.7836 50.9697C72.0064 51.0808 71.4513 51.636 71.2292 52.3022C70.7851 53.3017 71.2292 54.3011 72.0064 54.6342C73.0056 54.9674 73.6717 54.301 74.3379 53.6348C74.893 52.9685 75.4481 52.5244 76.1142 52.7465C76.6693 52.9685 76.8914 53.6348 76.5583 54.4121C76.2253 55.0784 75.7812 55.4115 75.115 55.5226L75.2261 56.0778C76.0032 55.9667 76.6693 55.5226 77.0024 54.6342C77.4465 53.4127 77.0024 52.5244 76.2253 52.1912C75.2261 51.8581 74.5599 52.4133 73.8938 53.1906C73.2276 53.8569 72.7836 54.3011 72.1174 54.079C71.5623 53.8569 71.3403 53.1906 71.6733 52.5244Z", fill: "#282624" })
] }));
ApplyOnlineStamp.displayName = "ApplyOnlineStamp";
const BankLogoLarge = forwardRef((props, ref2) => /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { width: "68", height: "46", viewBox: "0 0 68 46", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-label": "Bank Logo Large", ...props, ref: ref2, children: [
  /* @__PURE__ */ jsxRuntimeExports.jsxs("g", { filter: "url(#filter0_dd_807_4667)", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("rect", { x: "2", y: "1", width: "64", height: "42", rx: "3", fill: "black", shapeRendering: "crispEdges" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M33.3773 12.1641C33.76 11.9453 34.2326 11.9453 34.6193 12.1641L41.3295 15.9961L41.4974 16.0625V16.0977L43.3683 17.168C43.8604 17.4492 44.1026 18.0273 43.958 18.5742C43.8135 19.1211 43.3175 19.5039 42.7512 19.5039H25.2493C24.683 19.5039 24.1869 19.1211 24.0424 18.5742C23.8979 18.0273 24.1401 17.4492 24.6322 17.168L26.4992 16.0977V16.0625L26.671 16L33.3773 12.1641ZM26.4992 20.75H28.9989V28.25H30.5612V20.75H33.0609V28.25H34.9357V20.75H37.4354V28.25H38.9977V20.75H41.4974V28.418C41.5208 28.4297 41.5443 28.4453 41.5677 28.4609L43.4425 29.7109C43.8995 30.0156 44.1065 30.5859 43.9463 31.1133C43.7862 31.6406 43.298 32 42.7473 32H25.2493C24.6986 32 24.2143 31.6406 24.0541 31.1133C23.894 30.5859 24.0971 30.0156 24.558 29.7109L26.4328 28.4609C26.4562 28.4453 26.4796 28.4336 26.5031 28.418V20.75H26.4992Z", fill: "white" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M33.3773 12.1641C33.76 11.9453 34.2326 11.9453 34.6193 12.1641L41.3295 15.9961L41.4974 16.0625V16.0977L43.3683 17.168C43.8604 17.4492 44.1026 18.0273 43.958 18.5742C43.8135 19.1211 43.3175 19.5039 42.7512 19.5039H25.2493C24.683 19.5039 24.1869 19.1211 24.0424 18.5742C23.8979 18.0273 24.1401 17.4492 24.6322 17.168L26.4992 16.0977V16.0625L26.671 16L33.3773 12.1641ZM26.4992 20.75H28.9989V28.25H30.5612V20.75H33.0609V28.25H34.9357V20.75H37.4354V28.25H38.9977V20.75H41.4974V28.418C41.5208 28.4297 41.5443 28.4453 41.5677 28.4609L43.4425 29.7109C43.8995 30.0156 44.1065 30.5859 43.9463 31.1133C43.7862 31.6406 43.298 32 42.7473 32H25.2493C24.6986 32 24.2143 31.6406 24.0541 31.1133C23.894 30.5859 24.0971 30.0156 24.558 29.7109L26.4328 28.4609C26.4562 28.4453 26.4796 28.4336 26.5031 28.418V20.75H26.4992Z", fill: "white" })
  ] }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("defs", { children: /* @__PURE__ */ jsxRuntimeExports.jsxs("filter", { id: "filter0_dd_807_4667", x: "0", y: "0", width: "68", height: "46", filterUnits: "userSpaceOnUse", colorInterpolationFilters: "sRGB", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("feFlood", { floodOpacity: "0", result: "BackgroundImageFix" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("feColorMatrix", { in: "SourceAlpha", type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0", result: "hardAlpha" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("feOffset", { dy: "1" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("feGaussianBlur", { stdDeviation: "1" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("feComposite", { in2: "hardAlpha", operator: "out" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("feColorMatrix", { type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("feBlend", { mode: "normal", in2: "BackgroundImageFix", result: "effect1_dropShadow_807_4667" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("feColorMatrix", { in: "SourceAlpha", type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0", result: "hardAlpha" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("feOffset", {}),
    /* @__PURE__ */ jsxRuntimeExports.jsx("feGaussianBlur", { stdDeviation: "0.5" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("feColorMatrix", { type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("feBlend", { mode: "normal", in2: "effect1_dropShadow_807_4667", result: "effect2_dropShadow_807_4667" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("feBlend", { mode: "normal", in: "SourceGraphic", in2: "effect2_dropShadow_807_4667", result: "shape" })
  ] }) })
] }));
BankLogoLarge.displayName = "BankLogoLarge";
const BankLogoSmall = forwardRef((props, ref2) => /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { width: "36", height: "24", viewBox: "0 0 36 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-label": "Bank Logo Small", ...props, ref: ref2, children: [
  /* @__PURE__ */ jsxRuntimeExports.jsxs("g", { filter: "url(#filter0_dd_916_98)", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("rect", { x: "2", y: "1", width: "32", height: "21", rx: "1.54688", fill: "#282624", shapeRendering: "crispEdges" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M17.6628 6.42834C17.8701 6.31555 18.1259 6.31555 18.3353 6.42834L21.9682 8.40424L22.0591 8.43848V8.4566L23.072 9.00848C23.3385 9.1535 23.4696 9.4516 23.3913 9.73358C23.3131 10.0156 23.0446 10.213 22.7379 10.213H13.2623C12.9557 10.213 12.6871 10.0156 12.6089 9.73358C12.5307 9.4516 12.6618 9.1535 12.9282 9.00848L13.939 8.4566V8.43848L14.032 8.40625L17.6628 6.42834ZM13.939 10.8555H15.2924V14.7227H16.1382V10.8555H17.4916V14.7227H18.5066V10.8555H19.8599V14.7227H20.7058V10.8555H22.0591V14.8093C22.0718 14.8153 22.0845 14.8234 22.0972 14.8314L23.1122 15.476C23.3596 15.6331 23.4717 15.9271 23.385 16.199C23.2983 16.4709 23.034 16.6562 22.7358 16.6562H13.2623C12.9642 16.6562 12.7019 16.4709 12.6152 16.199C12.5285 15.9271 12.6385 15.6331 12.888 15.476L13.9031 14.8314C13.9157 14.8234 13.9284 14.8173 13.9411 14.8093V10.8555H13.939Z", fill: "white" })
  ] }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("defs", { children: /* @__PURE__ */ jsxRuntimeExports.jsxs("filter", { id: "filter0_dd_916_98", x: "0.96875", y: "0.484375", width: "34.0625", height: "23.0625", filterUnits: "userSpaceOnUse", colorInterpolationFilters: "sRGB", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("feFlood", { floodOpacity: "0", result: "BackgroundImageFix" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("feColorMatrix", { in: "SourceAlpha", type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0", result: "hardAlpha" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("feOffset", { dy: "0.515625" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("feGaussianBlur", { stdDeviation: "0.515625" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("feComposite", { in2: "hardAlpha", operator: "out" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("feColorMatrix", { type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("feBlend", { mode: "normal", in2: "BackgroundImageFix", result: "effect1_dropShadow_916_98" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("feColorMatrix", { in: "SourceAlpha", type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0", result: "hardAlpha" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("feOffset", {}),
    /* @__PURE__ */ jsxRuntimeExports.jsx("feGaussianBlur", { stdDeviation: "0.257812" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("feColorMatrix", { type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("feBlend", { mode: "normal", in2: "effect1_dropShadow_916_98", result: "effect2_dropShadow_916_98" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("feBlend", { mode: "normal", in: "SourceGraphic", in2: "effect2_dropShadow_916_98", result: "shape" })
  ] }) })
] }));
BankLogoSmall.displayName = "BankLogoSmall";
const BestowFoundationLogo = forwardRef((props, ref2) => /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { width: "197", height: "59", viewBox: "0 0 197 59", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img", "aria-label": "Bestow Foundation Logo ", ...props, ref: ref2, children: [
  /* @__PURE__ */ jsxRuntimeExports.jsx("title", { children: "Bestow Foundation Logo " }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M73.3035 13.7771L78.01 15.7473C83.1564 17.9198 85.431 20.6283 85.4203 24.9591C85.4203 30.9335 80.2023 35.1081 72.7348 35.1081C68.0257 35.1316 63.4868 33.3618 60.053 30.1632L59.9492 30.0638C59.6175 29.7652 59.3179 29.4333 59.0551 29.0734L63.7044 25.701C63.7044 25.701 67.0126 29.368 73.0925 29.368C76.7082 29.368 78.9542 27.8913 78.9542 25.6975C78.9542 22.9935 77.0118 22.1724 74.0446 20.9179L73.9472 20.8768L68.293 18.4877C63.4684 16.4501 60.99 13.5038 60.99 9.43921C60.99 3.86597 66.4797 0.000195281 73.375 0.000195281C76.6619 -0.0154686 79.8834 0.911505 82.6522 2.66967C85.1842 4.34519 85.8029 5.3143 85.8029 5.3143L81.0607 8.75409C78.8947 6.78621 76.0536 5.7133 73.1175 5.75448C69.8988 5.75448 67.3953 7.10697 67.3953 9.10553C67.3953 10.9372 70.353 12.5347 73.3035 13.7771ZM115.887 17.6463C115.887 7.79196 122.958 0.00362158 133.276 0.00362158C143.501 0.00362158 150.568 7.83811 150.568 17.6463C150.568 27.4545 143.497 35.0973 133.276 35.0973C122.958 35.0973 115.887 27.5007 115.887 17.6463ZM121.942 17.6463C121.942 24.3591 126.542 29.3288 133.226 29.3288C139.813 29.3288 144.513 24.4726 144.513 17.6463C144.513 10.82 139.813 5.77211 133.226 5.77211C126.638 5.77211 121.942 10.82 121.942 17.6463ZM24.6234 9.54576C24.6234 12.6945 23.2787 15.2645 20.9755 16.6454C22.4882 17.4014 23.7542 18.5671 24.627 20.0076C25.4998 21.4482 25.9437 23.1046 25.9074 24.7852C25.9074 30.1668 22.0699 34.2136 16.0222 34.2136H0V0.880608H15.171C21.1186 0.880608 24.6234 4.73928 24.6234 9.54576ZM14.3449 6.60294H5.9976V14.3025H14.3914C17.3669 14.3025 18.8547 12.7797 18.8547 10.3977C18.8547 8.29267 17.3205 6.60294 14.3449 6.60294ZM5.9976 20.0284V28.5019H14.8241C17.9892 28.5019 19.6701 26.7128 19.6701 24.2882C19.6701 21.8637 17.9892 20.0284 14.8241 20.0284H5.9976ZM31.7529 34.2173H48.9124L56.7983 28.502H37.7469V20.0286H53.5331V14.3133H37.7469V6.59955H55.5001V0.884309H31.7529V34.2173ZM98.6869 6.59955H86.9957L94.878 0.884309H114.859V6.59955H104.684V34.2173H98.6869V6.59955ZM190.258 0.884309L184.038 24.9061L177.74 0.884309H171.267L164.948 24.8386L158.746 0.884309H152.555L161.192 34.2173H168.388L174.479 10.9481L180.573 34.2173H187.815L196.452 0.884309H190.258ZM24.7346 49.2753V53.0878H29.788V53.9753H24.7346V58.0895H23.701V48.3985H30.4032V49.2753H24.7346ZM38.2437 55.7646C38.683 56.5132 39.3214 57.1273 40.0891 57.5395V57.5537C40.8988 57.9757 41.7996 58.1962 42.7142 58.1962C43.6287 58.1962 44.5295 57.9757 45.3392 57.5537C46.1024 57.1392 46.7368 56.5254 47.1739 55.7788C47.6147 55.0077 47.8463 54.1362 47.8463 53.2496C47.8463 52.3629 47.6147 51.4915 47.1739 50.7203C46.7368 49.9737 46.1024 49.3599 45.3392 48.9454C44.5288 48.5258 43.6282 48.3066 42.7142 48.3066C41.8001 48.3066 40.8995 48.5258 40.0891 48.9454C39.3214 49.3576 38.683 49.9717 38.2437 50.7203C37.8099 51.4912 37.5821 52.3595 37.5821 53.2425C37.5821 54.1255 37.8099 54.9937 38.2437 55.7646ZM46.2798 55.3102C45.9349 55.9161 45.4272 56.415 44.8135 56.7515C44.173 57.101 43.4521 57.2796 42.7213 57.2698C41.9872 57.2784 41.2632 57.0999 40.6184 56.7515C40.0006 56.4155 39.4883 55.9168 39.1378 55.3102C38.7871 54.6798 38.6032 53.9715 38.6032 53.2513C38.6032 52.5312 38.7871 51.8229 39.1378 51.1924C39.4872 50.5851 39.9998 50.0861 40.6184 49.7512C41.2621 49.3997 41.9867 49.2199 42.7213 49.2294C43.4526 49.219 44.174 49.3989 44.8135 49.7512C45.4279 50.0867 45.9358 50.5859 46.2798 51.1924C46.6305 51.8229 46.8144 52.5312 46.8144 53.2513C46.8144 53.9715 46.6305 54.6798 46.2798 55.3102ZM57.1726 57.1027C56.4573 56.3927 56.0996 55.3443 56.0996 53.9575V48.3985H57.1332V53.9149C57.1332 55.0438 57.3907 55.8815 57.9021 56.4389C58.5183 56.9743 59.3095 57.2695 60.1284 57.2695C60.9474 57.2695 61.7386 56.9743 62.3547 56.4389C62.8662 55.8815 63.1237 55.0438 63.1237 53.9149V48.3985H64.1286V53.9575C64.1286 55.3349 63.777 56.3833 63.0736 57.1027C62.3702 57.8221 61.3867 58.1771 60.1231 58.1676C58.8642 58.1795 57.8807 57.8245 57.1726 57.1027ZM81.4571 58.1002V48.3985H80.4379V56.272L74.1398 48.3985H73.2887V58.1002H74.3223V50.2267L80.606 58.1002H81.4571ZM90.6739 48.3988H94.6508C95.6 48.3794 96.5395 48.5915 97.3868 49.0165C98.1526 49.404 98.7914 49.9999 99.2286 50.7346C99.6602 51.5036 99.8867 52.3693 99.8867 53.2496C99.8867 54.1299 99.6602 54.9956 99.2286 55.7647C98.7924 56.5001 98.1533 57.0962 97.3868 57.4828C96.5395 57.9078 95.6 58.1199 94.6508 58.1005H90.6739V48.3988ZM94.6079 57.213C95.3881 57.2309 96.1607 57.0577 96.8575 56.709C97.4765 56.3903 97.9932 55.9057 98.3488 55.3103C98.6995 54.6799 98.8834 53.9715 98.8834 53.2514C98.8834 52.5313 98.6995 51.8229 98.3488 51.1925C97.996 50.5895 97.4792 50.0973 96.8575 49.7726C96.1607 49.4238 95.3881 49.2507 94.6079 49.2685H91.7182V57.1953L94.6079 57.213ZM108.785 55.5088H114.232L115.423 58.1002H116.496L112.029 48.3985H111.01L106.539 58.1002H107.612L108.785 55.5088ZM111.507 49.467L113.853 54.6782H109.161L111.507 49.467ZM125.555 49.2755H122.121V48.388H130.025V49.2755H126.588V58.0897H125.555V49.2755ZM138.737 48.3985H137.703V58.1002H138.737V48.3985ZM149.593 57.5395C148.826 57.1283 148.188 56.5139 147.752 55.7646C147.316 54.9945 147.086 54.1259 147.086 53.2425C147.086 52.359 147.316 51.4904 147.752 50.7203C148.188 49.9711 148.826 49.3567 149.593 48.9454C150.404 48.5258 151.304 48.3066 152.219 48.3066C153.133 48.3066 154.033 48.5258 154.844 48.9454C155.608 49.3599 156.243 49.9736 156.682 50.7203C157.12 51.4923 157.351 52.3634 157.351 53.2496C157.351 54.1357 157.12 55.0069 156.682 55.7788C156.243 56.5256 155.608 57.1393 154.844 57.5537C154.034 57.9757 153.133 58.1962 152.219 58.1962C151.304 58.1962 150.403 57.9757 149.593 57.5537V57.5395ZM154.321 56.7515C154.941 56.4166 155.455 55.9177 155.806 55.3102C156.153 54.6788 156.335 53.9708 156.335 53.2513C156.335 52.5318 156.153 51.8239 155.806 51.1924C155.461 50.5866 154.953 50.0876 154.339 49.7512C153.693 49.4088 152.972 49.2296 152.24 49.2296C151.508 49.2296 150.787 49.4088 150.141 49.7512C149.52 50.0857 149.005 50.5846 148.653 51.1924C148.299 51.8217 148.113 52.5305 148.113 53.2513C148.113 53.9722 148.299 54.681 148.653 55.3102C149.003 55.9158 149.514 56.4144 150.13 56.7515C150.777 57.0918 151.497 57.2698 152.229 57.2698C152.961 57.2698 153.682 57.0918 154.329 56.7515H154.321ZM172.755 58.1002V48.3985H171.736V56.272L165.435 48.3985H164.583V58.1002H165.617V50.2267L171.901 58.1002H172.755Z", fill: "black" })
] }));
BestowFoundationLogo.displayName = "BestowFoundationLogo";
const CareerDevIllustration = forwardRef((props, ref2) => /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { width: "56", height: "56", viewBox: "0 0 56 56", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img", "aria-label": "Career Dev Illustration ", ...props, ref: ref2, children: [
  /* @__PURE__ */ jsxRuntimeExports.jsx("title", { children: "Career Dev Illustration " }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M27.82 54.6C23.8991 54.5993 20.0256 53.7426 16.47 52.09C16.4102 52.0624 16.3565 52.0233 16.3119 51.975C16.2672 51.9267 16.2325 51.87 16.2098 51.8082C16.187 51.7465 16.1767 51.6809 16.1793 51.6151C16.1819 51.5493 16.1974 51.4847 16.225 51.425C16.2526 51.3652 16.2917 51.3115 16.34 51.2669C16.3883 51.2222 16.445 51.1875 16.5068 51.1648C16.5685 51.142 16.6341 51.1317 16.6999 51.1343C16.7656 51.1369 16.8302 51.1524 16.89 51.18C22.3477 53.7173 28.5209 54.2659 34.3405 52.7307C40.1601 51.1955 45.2595 47.6733 48.7555 42.7741C52.2515 37.8749 53.9239 31.9073 53.483 25.9048C53.0422 19.9023 50.5159 14.243 46.3417 9.90712C42.1674 5.57122 36.6082 2.8318 30.6268 2.16331C24.6454 1.49482 18.6185 2.93938 13.5901 6.24678C8.56161 9.55418 4.84827 14.5161 3.09319 20.2732C1.33811 26.0303 1.65182 32.2199 3.98 37.77C4.00602 37.8303 4.01966 37.8952 4.02011 37.9608C4.02057 38.0265 4.00782 38.0915 3.98264 38.1522C3.95745 38.2128 3.92034 38.2677 3.87351 38.3138C3.82667 38.3598 3.77107 38.3959 3.71 38.42C3.58794 38.4698 3.45117 38.4693 3.32944 38.4187C3.20771 38.3682 3.11088 38.2716 3.06 38.15C0.831424 32.8382 0.371589 26.9502 1.7485 21.3568C3.12541 15.7634 6.26596 10.7617 10.7056 7.09136C15.1453 3.42106 20.6484 1.27709 26.4009 0.976544C32.1534 0.676 37.8499 2.23484 42.6479 5.42251C47.4459 8.61019 51.0906 13.2574 53.0428 18.6769C54.9951 24.0963 55.1514 30.0002 53.4885 35.5153C51.8255 41.0304 48.4318 45.8639 43.8091 49.3009C39.1865 52.7379 33.5804 54.5959 27.82 54.6Z", fill: "#0B3541" }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M27.82 45.77C25.0968 45.769 22.4094 45.1501 19.96 43.96C19.8933 43.9365 19.8324 43.8991 19.7812 43.8502C19.7301 43.8014 19.6899 43.7423 19.6632 43.6768C19.6366 43.6113 19.6242 43.5409 19.6267 43.4703C19.6293 43.3996 19.6469 43.3303 19.6782 43.2669C19.7095 43.2035 19.7539 43.1475 19.8085 43.1026C19.8631 43.0576 19.9266 43.0247 19.9948 43.0061C20.063 42.9875 20.1344 42.9836 20.2043 42.9946C20.2741 43.0056 20.3408 43.0313 20.4 43.07C24.0213 44.8341 28.1514 45.255 32.0542 44.2576C35.9569 43.2603 39.3787 40.9095 41.7096 37.6243C44.0406 34.339 45.1293 30.3328 44.7816 26.3197C44.4339 22.3066 42.6725 18.5473 39.8113 15.7119C36.9501 12.8764 33.1751 11.1491 29.159 10.8378C25.1428 10.5265 21.1467 11.6513 17.8827 14.0119C14.6187 16.3725 12.2989 19.8155 11.3369 23.7271C10.375 27.6387 10.8332 31.7648 12.63 35.37C12.6655 35.4289 12.6884 35.4945 12.6973 35.5627C12.7063 35.6308 12.7011 35.7001 12.682 35.7662C12.663 35.8323 12.6306 35.8937 12.5867 35.9467C12.5429 35.9996 12.4886 36.043 12.4272 36.074C12.3658 36.105 12.2987 36.1231 12.2301 36.127C12.1614 36.1309 12.0927 36.1206 12.0282 36.0968C11.9637 36.0729 11.9049 36.0361 11.8553 35.9884C11.8057 35.9408 11.7664 35.8835 11.74 35.82C10.0736 32.4889 9.48154 28.7229 10.0455 25.0412C10.6095 21.3595 12.3017 17.9434 14.8888 15.2639C17.476 12.5844 20.8306 10.7735 24.4903 10.0808C28.1499 9.38803 31.9344 9.84765 35.3218 11.3963C38.7093 12.9448 41.5329 15.5062 43.4035 18.727C45.274 21.9479 46.0993 25.6698 45.7656 29.3794C45.4319 33.0891 43.9556 36.6039 41.5402 39.4392C39.1249 42.2746 35.8895 44.2908 32.28 45.21C30.8231 45.5848 29.3244 45.773 27.82 45.77Z", fill: "#0B3541" }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M27.82 37.6C27.1852 37.6017 26.5518 37.538 25.93 37.41C25.7993 37.3812 25.6851 37.3021 25.6121 37.1899C25.5391 37.0776 25.5132 36.9412 25.54 36.81C25.553 36.7459 25.5787 36.6851 25.6156 36.6311C25.6525 36.5771 25.6999 36.531 25.7549 36.4956C25.8099 36.4602 25.8714 36.4361 25.9358 36.4249C26.0002 36.4136 26.0663 36.4153 26.13 36.43C26.6936 36.5607 27.2717 36.6178 27.85 36.6C29.5951 36.5941 31.2993 36.0712 32.7475 35.0973C34.1956 34.1235 35.3227 32.7423 35.9864 31.1284C36.6502 29.5144 36.8208 27.7399 36.4767 26.029C36.1326 24.3182 35.2892 22.7476 34.0532 21.5157C32.8171 20.2838 31.2437 19.4458 29.5316 19.1075C27.8196 18.7693 26.0457 18.9459 24.434 19.6151C22.8223 20.2842 21.445 21.416 20.4761 22.8674C19.5071 24.3189 18.99 26.0249 18.99 27.77C18.9712 28.4131 19.0181 29.0564 19.13 29.69C19.1539 29.8226 19.1241 29.9593 19.0472 30.0699C18.9703 30.1806 18.8526 30.2561 18.72 30.28C18.5874 30.3039 18.4507 30.2741 18.3401 30.1972C18.2294 30.1203 18.1539 30.0026 18.13 29.87C18.0096 29.1769 17.9627 28.473 17.99 27.77C17.9885 25.8267 18.5648 23.9268 19.6456 22.3118C20.7264 20.6968 22.263 19.4396 24.06 18.7C25.8542 17.9473 27.8334 17.7522 29.74 18.14C31.645 18.523 33.3939 19.4615 34.7663 20.8371C36.1387 22.2127 37.0731 23.9638 37.4518 25.8696C37.8304 27.7755 37.6362 29.7508 36.8938 31.5465C36.1514 33.3422 34.8939 34.8779 33.28 35.96C31.6531 37.015 29.759 37.584 27.82 37.6Z", fill: "#0B3541" }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M27.82 25.77C27.2896 25.77 26.7809 25.9807 26.4058 26.3558C26.0307 26.7309 25.82 27.2396 25.82 27.77C25.8237 28.1222 25.9203 28.4671 26.1 28.77L14.54 40.15H8.06C7.99461 40.1504 7.92995 40.1639 7.86984 40.1896C7.80973 40.2154 7.75538 40.2529 7.71 40.3L2.08 45.91C2.00992 45.9809 1.96216 46.0708 1.94261 46.1685C1.92306 46.2663 1.93258 46.3676 1.97 46.46C2.00859 46.5506 2.07255 46.628 2.15417 46.683C2.2358 46.738 2.33159 46.7682 2.43 46.77H7.82L5.16 49.39C5.11314 49.4365 5.07594 49.4918 5.05056 49.5527C5.02517 49.6136 5.0121 49.679 5.0121 49.745C5.0121 49.811 5.02517 49.8764 5.05056 49.9373C5.07594 49.9982 5.11314 50.0535 5.16 50.1C5.20538 50.1471 5.25973 50.1846 5.31984 50.2104C5.37995 50.2362 5.44461 50.2496 5.51 50.25C5.62652 50.241 5.73621 50.1915 5.82 50.11L8.44 47.53V52.77C8.4385 52.8704 8.46727 52.969 8.52256 53.0528C8.57785 53.1366 8.65711 53.2019 8.75 53.24C8.81297 53.2496 8.87703 53.2496 8.94 53.24C9.07316 53.2393 9.20137 53.1895 9.3 53.1L14.93 47.48C15.0205 47.3861 15.0708 47.2605 15.07 47.13V40.99L26.82 29.48C27.1219 29.6633 27.4669 29.7633 27.82 29.77C28.3504 29.77 28.8591 29.5593 29.2342 29.1842C29.6093 28.8091 29.82 28.3004 29.82 27.77C29.82 27.2396 29.6093 26.7309 29.2342 26.3558C28.8591 25.9807 28.3504 25.77 27.82 25.77ZM3.64 45.77L8.27 41.15H13.53L8.82 45.77H3.64ZM14.11 46.99L9.48 51.61V46.54L14.11 41.98V46.99Z", fill: "#0B3541" })
] }));
CareerDevIllustration.displayName = "CareerDevIllustration";
const CertifiedSSLBadge = forwardRef((props, ref2) => /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { width: "77", height: "20", viewBox: "0 0 77 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img", "aria-label": "CertifiedSSL Badge", ...props, ref: ref2, children: [
  /* @__PURE__ */ jsxRuntimeExports.jsx("title", { children: "CertifiedSSL Badge" }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("rect", { y: "7.03571", width: "12.7526", height: "12.9016", rx: "0.908452", fill: "#6E6E6E" }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.37981 2.98239C4.98829 2.98239 3.83325 4.17083 3.83325 5.67151V7.03571H1.87891V5.67151C1.87891 3.08733 3.87913 0.964355 6.37981 0.964355C8.8805 0.964355 10.8807 3.08733 10.8807 5.67151V7.03571H8.92637V5.67151C8.92637 4.17083 7.77134 2.98239 6.37981 2.98239Z", fill: "#6E6E6E" }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.9879 10.6731C10.2809 10.9695 10.2809 11.45 9.9879 11.7464L5.64605 16.139C5.29784 16.4913 4.73327 16.4913 4.38505 16.139L2.84862 14.5846C2.55567 14.2882 2.55567 13.8077 2.84862 13.5113C3.14157 13.2149 3.61654 13.2149 3.90949 13.5113L5.01555 14.6303L8.92703 10.6731C9.21998 10.3767 9.69495 10.3767 9.9879 10.6731Z", fill: "white" }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M16.8789 10.4323C17.6979 11.9147 19.32 12.7276 20.9894 12.7276C23.5251 12.7276 25.0212 11.1496 25.0212 9.3644C25.0212 7.35604 23.6038 6.65471 21.7769 5.85774C20.5957 5.33174 19.6193 5.04483 19.6193 4.27974C19.6193 3.57841 20.2807 3.17993 21.0682 3.17993C21.8557 3.17993 22.5329 3.59435 23.0211 4.39132L24.8008 3.03647C24.0448 1.69757 22.6746 0.964355 21.0997 0.964355C18.8791 0.964355 17.2096 2.38296 17.2096 4.3435C17.2096 6.27216 18.5956 6.98943 20.1547 7.69076C21.7139 8.3921 22.5959 8.56743 22.5959 9.44409C22.5959 10.0498 21.9501 10.4961 21.0052 10.4961C19.9657 10.4961 19.1153 9.85852 18.6271 9.01373L16.8789 10.4323Z", fill: "#6E6E6E" }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M26.8208 12.5044H34.3804V10.3686H29.2462V7.8661H33.3095V5.73022H29.2462V3.2915H34.1915V1.15563H26.8208V12.5044Z", fill: "#6E6E6E" }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M35.108 6.83004C35.108 10.1135 37.5649 12.7117 40.9194 12.7117C43.0298 12.7117 44.7937 11.58 45.7544 9.97009L43.9118 8.53555C43.2031 9.69912 42.1794 10.3686 40.8879 10.3686C38.998 10.3686 37.6121 8.82246 37.6121 6.83004C37.6121 4.83762 38.935 3.30744 40.9194 3.30744C42.1636 3.30744 43.3133 4.04065 43.8803 5.10859L45.7072 3.64217C44.7937 1.96853 43.0771 0.964355 40.9509 0.964355C37.5176 0.964355 35.108 3.54653 35.108 6.83004Z", fill: "#6E6E6E" }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M51.7337 12.7117C54.4741 12.7117 56.3482 10.7192 56.3482 8.21676V1.15563H53.9229V8.02549C53.9229 9.39627 53.0567 10.4005 51.7337 10.4005C50.4265 10.4005 49.5446 9.39627 49.5446 8.02549V1.15563H47.1192V8.21676C47.1192 10.7192 49.0091 12.7117 51.7337 12.7117Z", fill: "#6E6E6E" }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M61.2521 12.5044V8.40803H63.0318L64.8115 12.5044H67.4416L65.2997 7.97767C66.5281 7.40385 67.3628 6.24028 67.3628 4.77386C67.3628 2.63799 65.8037 1.15563 63.5988 1.15563H58.8268V12.5044H61.2521ZM61.2521 3.27556H63.2208C64.213 3.27556 64.8587 3.88126 64.8587 4.7898C64.8587 5.71428 64.1972 6.38374 63.1893 6.38374H61.2521V3.27556Z", fill: "#6E6E6E" }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M69.3314 12.5044H76.891V10.3686H71.7567V7.8661H75.82V5.73022H71.7567V3.2915H76.702V1.15563H69.3314V12.5044Z", fill: "#6E6E6E" }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M16.8789 18.9008C17.2539 19.5702 17.9965 19.9373 18.7608 19.9373C19.9217 19.9373 20.6067 19.2247 20.6067 18.4185C20.6067 17.5115 19.9578 17.1947 19.1214 16.8348C18.5806 16.5973 18.1335 16.4677 18.1335 16.1222C18.1335 15.8054 18.4364 15.6255 18.7969 15.6255C19.1574 15.6255 19.4675 15.8126 19.691 16.1726L20.5058 15.5607C20.1597 14.956 19.5324 14.6249 18.8113 14.6249C17.7946 14.6249 17.0303 15.2656 17.0303 16.151C17.0303 17.022 17.6648 17.3459 18.3787 17.6626C19.0925 17.9794 19.4963 18.0585 19.4963 18.4545C19.4963 18.728 19.2007 18.9296 18.768 18.9296C18.2922 18.9296 17.9028 18.6416 17.6793 18.2601L16.8789 18.9008Z", fill: "#6E6E6E" }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M21.0413 18.9008C21.4162 19.5702 22.1589 19.9373 22.9232 19.9373C24.0841 19.9373 24.7691 19.2247 24.7691 18.4185C24.7691 17.5115 24.1201 17.1947 23.2837 16.8348C22.7429 16.5973 22.2959 16.4677 22.2959 16.1222C22.2959 15.8054 22.5987 15.6255 22.9592 15.6255C23.3198 15.6255 23.6298 15.8126 23.8533 16.1726L24.6681 15.5607C24.322 14.956 23.6947 14.6249 22.9737 14.6249C21.957 14.6249 21.1927 15.2656 21.1927 16.151C21.1927 17.022 21.8272 17.3459 22.541 17.6626C23.2549 17.9794 23.6587 18.0585 23.6587 18.4545C23.6587 18.728 23.363 18.9296 22.9304 18.9296C22.4545 18.9296 22.0651 18.6416 21.8416 18.2601L21.0413 18.9008Z", fill: "#6E6E6E" }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M25.629 19.8438H28.8161V18.872H26.7394V14.7113H25.629V19.8438Z", fill: "#6E6E6E" }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M31.0456 19.8366H34.5066V18.872H32.156V17.7418H34.0163V16.7772H32.156V15.6759H34.4201V14.7113H31.0456V19.8366Z", fill: "#6E6E6E" }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M35.3699 19.8438H36.4803V16.5901L38.8454 19.8438H39.7827V14.7113H38.6723V17.929L36.3073 14.7113H35.3699V19.8438Z", fill: "#6E6E6E" }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M40.6647 17.2739C40.6647 18.7568 41.7895 19.9301 43.3254 19.9301C44.2916 19.9301 45.0991 19.419 45.539 18.692L44.6954 18.0442C44.3709 18.5696 43.9022 18.872 43.3109 18.872C42.4457 18.872 41.8112 18.1737 41.8112 17.2739C41.8112 16.3741 42.4168 15.6831 43.3254 15.6831C43.895 15.6831 44.4214 16.0142 44.6809 16.4965L45.5173 15.8342C45.0991 15.0784 44.3132 14.6249 43.3398 14.6249C41.7679 14.6249 40.6647 15.791 40.6647 17.2739Z", fill: "#6E6E6E" }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M47.3752 19.8366V17.9866H48.1899L49.0047 19.8366H50.2089L49.2283 17.7922C49.7907 17.5331 50.1728 17.0076 50.1728 16.3453C50.1728 15.3807 49.459 14.7113 48.4495 14.7113H46.2648V19.8366H47.3752ZM47.3752 15.6687H48.2765C48.7307 15.6687 49.0264 15.9422 49.0264 16.3525C49.0264 16.77 48.7235 17.0724 48.2621 17.0724H47.3752V15.6687Z", fill: "#6E6E6E" }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M52.2081 17.5763V19.8438H53.3258V17.5763L55.1644 14.7113H53.9387L52.7633 16.6261L51.588 14.7113H50.3623L52.2081 17.5763Z", fill: "#6E6E6E" }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M55.7372 19.8438H56.8404V18.1737H57.684C58.6575 18.1737 59.4434 17.4323 59.4434 16.4245C59.4434 15.4527 58.6719 14.7113 57.6768 14.7113H55.7372V19.8438ZM56.8404 17.2163V15.6687H57.5254C57.958 15.6687 58.2969 15.9854 58.2969 16.4245C58.2969 16.8708 57.958 17.2163 57.5254 17.2163H56.8404Z", fill: "#6E6E6E" }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M61.0394 15.6831V19.8438H62.1498V15.6831H63.5775V14.7113H59.6118V15.6831H61.0394Z", fill: "#6E6E6E" }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M64.252 19.8438H65.3625V14.7113H64.252V19.8438Z", fill: "#6E6E6E" }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M68.9267 19.9301C70.4769 19.9301 71.6018 18.7568 71.6018 17.2739C71.6018 15.791 70.4769 14.6249 68.9267 14.6249C67.3692 14.6249 66.2444 15.791 66.2444 17.2739C66.2444 18.7568 67.3692 19.9301 68.9267 19.9301ZM67.3909 17.2739C67.3909 16.3669 68.0398 15.6759 68.9267 15.6759C69.8136 15.6759 70.4553 16.3669 70.4553 17.2739C70.4553 18.1809 69.8136 18.8792 68.9267 18.8792C68.0398 18.8792 67.3909 18.1809 67.3909 17.2739Z", fill: "#6E6E6E" }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M72.4782 19.8438H73.5886V16.5901L75.9536 19.8438H76.891V14.7113H75.7806V17.929L73.4155 14.7113H72.4782V19.8438Z", fill: "#6E6E6E" })
] }));
CertifiedSSLBadge.displayName = "CertifiedSSLBadge";
const ClockIllustration = forwardRef((props, ref2) => /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { width: "56", height: "56", viewBox: "0 0 56 56", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img", "aria-label": "Clock Illustration ", ...props, ref: ref2, children: [
  /* @__PURE__ */ jsxRuntimeExports.jsx("title", { children: "Clock Illustration " }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M30.9785 13.1182C31.0291 12.8468 31.2903 12.6678 31.5617 12.7184C36.4724 13.635 40.844 16.4013 43.7749 20.4466C43.9369 20.6702 43.8869 20.9828 43.6633 21.1449C43.4397 21.3069 43.1271 21.2569 42.9651 21.0333C40.1845 17.1954 36.0371 14.5711 31.3782 13.7015C31.1068 13.6508 30.9278 13.3897 30.9785 13.1182Z", fill: "#90AFAA" }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M32.8409 1.32875C32.7115 1.27588 32.573 1.24913 32.4332 1.25002L32.43 1.25003H23.56C23.2789 1.25003 23.0093 1.36171 22.8105 1.5605C22.6117 1.75929 22.5 2.0289 22.5 2.31003V4.25003H25.41V4.25H25.91H29.91H30.41V4.25003H33.5V2.31002C33.5 2.17025 33.4724 2.03185 33.4187 1.9028C33.365 1.77375 33.2863 1.65659 33.1871 1.55808C33.088 1.45956 32.9703 1.38162 32.8409 1.32875ZM30.41 5.25003H34H34.5V4.75003V2.31004C34.5 2.0384 34.4463 1.76945 34.3419 1.51865C34.2376 1.26786 34.0847 1.04018 33.892 0.848714C33.6993 0.657249 33.4706 0.505788 33.2192 0.403044C32.9682 0.300515 32.6996 0.248519 32.4285 0.250032H23.56C23.0137 0.250032 22.4897 0.467067 22.1034 0.853392C21.717 1.23972 21.5 1.76369 21.5 2.31003V4.75003V5.25003H22H25.41V8.22939C21.1846 8.68707 17.2912 10.2516 14.0257 12.6271L12.8615 11.3353L12.8615 11.3353L12.8596 11.3332C12.3724 10.7989 11.6929 10.48 10.9707 10.4467C10.2484 10.4134 9.54249 10.6684 9.00822 11.1556C8.47395 11.6428 8.15509 12.3222 8.12179 13.0445C8.08849 13.7668 8.34348 14.4727 8.83065 15.007L8.83064 15.007L8.83323 15.0098L10.0267 16.2987C6.40916 20.4706 4.22 25.9146 4.22 31.87C4.22 45.0033 14.8667 55.65 28 55.65C41.1333 55.65 51.78 45.0033 51.78 31.87C51.78 25.9132 49.5898 20.4679 45.9707 16.2956L47.1694 14.9769L47.1697 14.9767C47.6567 14.4424 47.9116 13.7366 47.8783 13.0145C47.845 12.2922 47.5261 11.6127 46.9919 11.1256C46.4576 10.6384 45.7517 10.3834 45.0294 10.4167C44.3072 10.45 43.6277 10.7689 43.1405 11.3031L43.1405 11.3031L43.1345 11.3098L41.9753 12.6278C38.6633 10.2182 34.7053 8.64288 30.41 8.21058V5.25003ZM44.525 16.1902C44.051 15.6924 43.5557 15.2155 43.0406 14.7608C39.5949 11.7293 35.226 9.72233 30.41 9.21593V9.23751L29.847 9.16602L29.7959 9.15972C29.2167 9.11455 28.6314 9.09104 28.0409 9.09L28 9.09C27.9226 9.09 27.8452 9.09038 27.7678 9.09112C15.2937 9.21567 5.22 19.3664 5.22 31.87C5.22 44.451 15.419 54.65 28 54.65C40.581 54.65 50.78 44.451 50.78 31.87C50.78 25.7944 48.4016 20.2744 44.525 16.1902ZM45.2966 15.5505L45.2512 15.5027C44.7556 14.9805 44.2366 14.4809 43.6958 14.0054C43.3954 13.7404 43.0885 13.4826 42.7753 13.2324L43.8823 11.9738C44.1906 11.6374 44.6196 11.4367 45.0755 11.4157C45.5328 11.3946 45.9798 11.556 46.3181 11.8645C46.6564 12.173 46.8583 12.6032 46.8794 13.0605C46.9005 13.5179 46.739 13.9648 46.4305 14.3031L46.43 14.3037L45.2966 15.5505ZM26.41 5.25003H29.41V8.12088C28.9455 8.09058 28.4843 8.09001 28.0408 8.09L28 8.08997C27.9197 8.08997 27.8395 8.09036 27.7594 8.09116C27.3084 8.0955 26.8578 8.11205 26.41 8.14083V5.25003ZM28 29.36C26.5254 29.36 25.33 30.5554 25.33 32.03C25.33 33.5046 26.5254 34.7 28 34.7C29.4746 34.7 30.67 33.5046 30.67 32.03C30.67 31.7783 30.6352 31.5348 30.5701 31.304L28.2236 32.4772C27.9766 32.6007 27.6763 32.5006 27.5528 32.2536C27.4293 32.0066 27.5294 31.7063 27.7764 31.5828L30.1224 30.4098C29.6345 29.7716 28.8653 29.36 28 29.36ZM31.0287 29.9567C30.3673 28.9925 29.2575 28.36 28 28.36C25.9731 28.36 24.33 30.0031 24.33 32.03C24.33 34.0569 25.9731 35.7 28 35.7C30.0269 35.7 31.67 34.0569 31.67 32.03C31.67 31.6175 31.602 31.2209 31.4765 30.8508L45.2636 23.9572C45.5106 23.8337 45.6107 23.5334 45.4872 23.2864C45.3637 23.0394 45.0634 22.9393 44.8164 23.0628L31.0287 29.9567ZM28 12.39C28.2761 12.39 28.5 12.6139 28.5 12.89V14.89C28.5 15.1662 28.2761 15.39 28 15.39C27.7239 15.39 27.5 15.1662 27.5 14.89V12.89C27.5 12.6139 27.7239 12.39 28 12.39ZM28.5 49.17C28.5 48.8939 28.2761 48.67 28 48.67C27.7239 48.67 27.5 48.8939 27.5 49.17V51.17C27.5 51.4462 27.7239 51.67 28 51.67C28.2761 51.67 28.5 51.4462 28.5 51.17V49.17ZM44.6399 32.03C44.6399 31.7539 44.8638 31.53 45.1399 31.53H47.1399C47.416 31.53 47.6399 31.7539 47.6399 32.03C47.6399 32.3062 47.416 32.53 47.1399 32.53H45.1399C44.8638 32.53 44.6399 32.3062 44.6399 32.03ZM8.86011 31.53C8.58396 31.53 8.36011 31.7539 8.36011 32.03C8.36011 32.3062 8.58396 32.53 8.86011 32.53H10.8601C11.1362 32.53 11.3601 32.3062 11.3601 32.03C11.3601 31.7539 11.1362 31.53 10.8601 31.53H8.86011ZM9.68201 11.8945C10.0203 11.5861 10.4673 11.4246 10.9246 11.4457C11.3815 11.4667 11.8113 11.6683 12.1197 12.0059L13.2202 13.2271C12.3272 13.9433 11.4849 14.7206 10.6995 15.5534L9.56838 14.3319C9.26068 13.9937 9.09967 13.5473 9.12073 13.0906C9.14182 12.6332 9.34371 12.203 9.68201 11.8945Z", fill: "#0B3541" })
] }));
ClockIllustration.displayName = "ClockIllustration";
const DinersClubLogoLarge = forwardRef((props, ref2) => /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { width: "68", height: "46", viewBox: "0 0 68 46", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img", "aria-label": "Diners Club Logo Large ", ...props, ref: ref2, children: [
  /* @__PURE__ */ jsxRuntimeExports.jsxs("g", { filter: "url(#filter0_dd_1_1161)", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("title", { children: "Diners Club Logo Large " }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2 4C2 2.34315 3.34315 1 5 1H63C64.6569 1 66 2.34315 66 4V40C66 41.6569 64.6569 43 63 43H5C3.34315 43 2 41.6569 2 40V4Z", fill: "#F4F6F7" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2 4C2 2.34315 3.34315 1 5 1H63C64.6569 1 66 2.34315 66 4V40C66 41.6569 64.6569 43 63 43H5C3.34315 43 2 41.6569 2 40V4Z", fill: "#E5E5E5", fillOpacity: "0.01" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M36.6268 31.9604C42.033 31.9865 46.9674 27.5112 46.9674 22.0669C46.9674 16.1133 42.033 11.998 36.6268 12H31.9741C26.5031 11.998 22 16.1145 22 22.0669C22 27.5124 26.5031 31.9865 31.9741 31.9604H36.6268Z", fill: "url(#paint0_linear_1_1161)" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M31.9933 12.8317C26.9941 12.8333 22.9431 16.9224 22.9419 21.9691C22.9431 27.015 26.9941 31.1038 31.9933 31.1053C36.9937 31.1038 41.0456 27.015 41.0463 21.9691C41.0455 16.9224 36.9937 12.8333 31.9933 12.8317ZM26.2559 21.9691C26.2606 19.503 27.7869 17.4 29.9392 16.5644V27.3727C27.7869 26.5375 26.2606 24.4356 26.2559 21.9691ZM34.0469 27.375V16.564C36.2 17.3977 37.7286 19.5018 37.7325 21.9691C37.7286 24.4372 36.2 26.5398 34.0469 27.375Z", fill: "#F4F6F7" })
  ] }),
  /* @__PURE__ */ jsxRuntimeExports.jsxs("defs", { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs("filter", { id: "filter0_dd_1_1161", x: "0", y: "0", width: "68", height: "46", filterUnits: "userSpaceOnUse", colorInterpolationFilters: "sRGB", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("feFlood", { floodOpacity: "0", result: "BackgroundImageFix" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("feColorMatrix", { in: "SourceAlpha", type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0", result: "hardAlpha" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("feOffset", { dy: "1" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("feGaussianBlur", { stdDeviation: "1" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("feComposite", { in2: "hardAlpha", operator: "out" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("feColorMatrix", { type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("feBlend", { mode: "normal", in2: "BackgroundImageFix", result: "effect1_dropShadow_1_1161" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("feColorMatrix", { in: "SourceAlpha", type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0", result: "hardAlpha" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("feOffset", {}),
      /* @__PURE__ */ jsxRuntimeExports.jsx("feGaussianBlur", { stdDeviation: "0.5" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("feColorMatrix", { type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("feBlend", { mode: "normal", in2: "effect1_dropShadow_1_1161", result: "effect2_dropShadow_1_1161" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("feBlend", { mode: "normal", in: "SourceGraphic", in2: "effect2_dropShadow_1_1161", result: "shape" })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("linearGradient", { id: "paint0_linear_1_1161", x1: "52.1487", y1: "28.1405", x2: "45.7455", y2: "7.2151", gradientUnits: "userSpaceOnUse", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { stopColor: "#009BE0" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { offset: "1", stopColor: "#006BA8" })
    ] })
  ] })
] }));
DinersClubLogoLarge.displayName = "DinersClubLogoLarge";
const DinersClubLogoSmall = forwardRef((props, ref2) => /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { width: "36", height: "25", viewBox: "0 0 36 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img", "aria-label": "Diners Club Logo Small ", ...props, ref: ref2, children: [
  /* @__PURE__ */ jsxRuntimeExports.jsxs("g", { filter: "url(#filter0_dd_1_1173)", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("title", { children: "Diners Club Logo Small " }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2 2.5C2 1.67157 2.67157 1 3.5 1H32.5C33.3284 1 34 1.67157 34 2.5V20.5C34 21.3284 33.3284 22 32.5 22H3.5C2.67157 22 2 21.3284 2 20.5V2.5Z", fill: "#F4F6F7" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2 2.5C2 1.67157 2.67157 1 3.5 1H32.5C33.3284 1 34 1.67157 34 2.5V20.5C34 21.3284 33.3284 22 32.5 22H3.5C2.67157 22 2 21.3284 2 20.5V2.5Z", fill: "#E5E5E5", fillOpacity: "0.01" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M19.3134 16.4802C22.0165 16.4932 24.4837 14.2556 24.4837 11.5335C24.4837 8.55663 22.0165 6.49901 19.3134 6.5H16.987C14.2516 6.49901 12 8.55725 12 11.5335C12 14.2562 14.2516 16.4933 16.987 16.4802H19.3134Z", fill: "url(#paint0_linear_1_1173)" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16.9969 6.91584C14.4973 6.91663 12.4718 8.96119 12.4712 11.4846C12.4718 14.0075 14.4973 16.0519 16.9969 16.0527C19.4971 16.0519 21.523 14.0075 21.5234 11.4846C21.523 8.96119 19.4971 6.91663 16.9969 6.91584ZM14.1284 11.4846C14.1308 10.2515 14.8939 9.20002 15.9701 8.78218V14.1863C14.8939 13.7687 14.1308 12.7178 14.1284 11.4846ZM18.0234 14.1875V8.782C19.1 9.19883 19.8643 10.2509 19.8663 11.4846C19.8643 12.7186 19.1 13.7699 18.0234 14.1875Z", fill: "#F4F6F7" })
  ] }),
  /* @__PURE__ */ jsxRuntimeExports.jsxs("defs", { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs("filter", { id: "filter0_dd_1_1173", x: "0", y: "0", width: "36", height: "25", filterUnits: "userSpaceOnUse", colorInterpolationFilters: "sRGB", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("feFlood", { floodOpacity: "0", result: "BackgroundImageFix" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("feColorMatrix", { in: "SourceAlpha", type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0", result: "hardAlpha" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("feOffset", { dy: "1" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("feGaussianBlur", { stdDeviation: "1" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("feComposite", { in2: "hardAlpha", operator: "out" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("feColorMatrix", { type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("feBlend", { mode: "normal", in2: "BackgroundImageFix", result: "effect1_dropShadow_1_1173" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("feColorMatrix", { in: "SourceAlpha", type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0", result: "hardAlpha" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("feOffset", {}),
      /* @__PURE__ */ jsxRuntimeExports.jsx("feGaussianBlur", { stdDeviation: "0.5" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("feColorMatrix", { type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("feBlend", { mode: "normal", in2: "effect1_dropShadow_1_1173", result: "effect2_dropShadow_1_1173" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("feBlend", { mode: "normal", in: "SourceGraphic", in2: "effect2_dropShadow_1_1173", result: "shape" })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("linearGradient", { id: "paint0_linear_1_1173", x1: "27.0743", y1: "14.5703", x2: "23.8728", y2: "4.10755", gradientUnits: "userSpaceOnUse", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { stopColor: "#009BE0" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { offset: "1", stopColor: "#006BA8" })
    ] })
  ] })
] }));
DinersClubLogoSmall.displayName = "DinersClubLogoSmall";
const DiscoverLogoLarge = forwardRef((props, ref2) => /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { width: "68", height: "46", viewBox: "0 0 68 46", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img", "aria-label": "Discover Logo Large ", ...props, ref: ref2, children: [
  /* @__PURE__ */ jsxRuntimeExports.jsxs("g", { filter: "url(#filter0_dd_1_1109)", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("title", { children: "Discover Logo Large " }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2 4C2 2.34315 3.34315 1 5 1H63C64.6569 1 66 2.34315 66 4V40C66 41.6569 64.6569 43 63 43H5C3.34315 43 2 41.6569 2 40V4Z", fill: "url(#paint0_linear_1_1109)" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2 4C2 2.34315 3.34315 1 5 1H63C64.6569 1 66 2.34315 66 4V40C66 41.6569 64.6569 43 63 43H5C3.34315 43 2 41.6569 2 40V4Z", fill: "#E5E5E5", fillOpacity: "0.01" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14.7791 23.7824C14.3288 24.1918 13.7436 24.3704 12.8173 24.3704H12.4326V19.4798H12.8173C13.7436 19.4798 14.3058 19.6467 14.7791 20.0781C15.2749 20.5221 15.5731 21.2107 15.5731 21.9189C15.5731 22.6289 15.2749 23.3384 14.7791 23.7824ZM13.1044 18.2269H11V25.6221H13.0933C14.2064 25.6221 15.0103 25.3581 15.7156 24.7684C16.5541 24.0704 17.0499 23.0181 17.0499 21.9298C17.0499 19.7472 15.4294 18.2269 13.1044 18.2269Z", fill: "#212D34" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M17.7095 25.6223H19.1431V18.2269H17.7095V25.6223Z", fill: "#212D34" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M22.6486 21.0647C21.7883 20.7445 21.5358 20.5333 21.5358 20.1336C21.5358 19.6679 21.9859 19.3139 22.6038 19.3139C23.0331 19.3139 23.3863 19.4916 23.7597 19.9127L24.5099 18.9245C23.8935 18.3819 23.156 18.1047 22.3502 18.1047C21.0497 18.1047 20.0579 19.0133 20.0579 20.2236C20.0579 21.2425 20.5196 21.7642 21.8661 22.2516C22.4274 22.451 22.7131 22.5836 22.857 22.6727C23.1435 22.861 23.2869 23.1276 23.2869 23.4382C23.2869 24.0373 22.8136 24.4813 22.1739 24.4813C21.4901 24.4813 20.9392 24.137 20.6093 23.4947L19.683 24.3922C20.3435 25.3679 21.1369 25.8002 22.2278 25.8002C23.7174 25.8002 24.7626 24.8033 24.7626 23.3719C24.7626 22.1967 24.2793 21.665 22.6486 21.0647Z", fill: "#212D34" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M25.2149 21.9297C25.2149 24.1034 26.9112 25.7888 29.0942 25.7888C29.7112 25.7888 30.2399 25.6668 30.8916 25.358V23.66C30.3186 24.2371 29.8109 24.47 29.1609 24.47C27.717 24.47 26.6922 23.4165 26.6922 21.9188C26.6922 20.4991 27.7494 19.3791 29.0942 19.3791C29.7779 19.3791 30.2956 19.6245 30.8916 20.2111V18.514C30.2624 18.1928 29.745 18.0597 29.128 18.0597C26.956 18.0597 25.2149 19.7794 25.2149 21.9297Z", fill: "#212D34" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M42.2586 23.1943L40.2987 18.2269H38.7325L41.8514 25.8121H42.6229L45.798 18.2269H44.2439L42.2586 23.1943Z", fill: "#212D34" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M46.4463 25.6222H50.5119V24.3702H47.8788V22.3739H50.4151V21.1213H47.8788V19.4799H50.5119V18.2268H46.4463V25.6222Z", fill: "#212D34" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M53.3119 21.6316H52.8931V19.3919H53.3346C54.2277 19.3919 54.7129 19.7682 54.7129 20.4879C54.7129 21.2313 54.2277 21.6316 53.3119 21.6316ZM56.1879 20.4102C56.1879 19.0256 55.2401 18.2267 53.5869 18.2267H51.461V25.6222H52.8929V22.6513H53.0801L55.0643 25.6222H56.8274L54.5134 22.5067C55.5933 22.2856 56.1879 21.5424 56.1879 20.4102Z", fill: "#212D34" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("g", { filter: "url(#filter1_i_1_1109)", children: /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M39.1796 21.9501C39.1796 24.1229 37.4291 25.8843 35.2696 25.8843C33.1102 25.8843 31.3599 24.1229 31.3599 21.9501C31.3599 19.7772 33.1102 18.0161 35.2696 18.0161C37.4291 18.0161 39.1796 19.7772 39.1796 21.9501Z", fill: "url(#paint1_linear_1_1109)" }) })
  ] }),
  /* @__PURE__ */ jsxRuntimeExports.jsxs("defs", { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs("filter", { id: "filter0_dd_1_1109", x: "0", y: "0", width: "68", height: "46", filterUnits: "userSpaceOnUse", colorInterpolationFilters: "sRGB", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("feFlood", { floodOpacity: "0", result: "BackgroundImageFix" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("feColorMatrix", { in: "SourceAlpha", type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0", result: "hardAlpha" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("feOffset", { dy: "1" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("feGaussianBlur", { stdDeviation: "1" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("feComposite", { in2: "hardAlpha", operator: "out" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("feColorMatrix", { type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("feBlend", { mode: "normal", in2: "BackgroundImageFix", result: "effect1_dropShadow_1_1109" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("feColorMatrix", { in: "SourceAlpha", type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0", result: "hardAlpha" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("feOffset", {}),
      /* @__PURE__ */ jsxRuntimeExports.jsx("feGaussianBlur", { stdDeviation: "0.5" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("feColorMatrix", { type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("feBlend", { mode: "normal", in2: "effect1_dropShadow_1_1109", result: "effect2_dropShadow_1_1109" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("feBlend", { mode: "normal", in: "SourceGraphic", in2: "effect2_dropShadow_1_1109", result: "shape" })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("filter", { id: "filter1_i_1_1109", x: "31.3599", y: "18.0161", width: "7.81972", height: "7.86829", filterUnits: "userSpaceOnUse", colorInterpolationFilters: "sRGB", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("feFlood", { floodOpacity: "0", result: "BackgroundImageFix" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("feBlend", { mode: "normal", in: "SourceGraphic", in2: "BackgroundImageFix", result: "shape" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("feColorMatrix", { in: "SourceAlpha", type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0", result: "hardAlpha" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("feOffset", { dx: "1", dy: "1" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("feComposite", { in2: "hardAlpha", operator: "arithmetic", k2: "-1", k3: "1" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("feColorMatrix", { type: "matrix", values: "0 0 0 0 0.314068 0 0 0 0 0.00146228 0 0 0 0 0.00146228 0 0 0 0.5 0" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("feBlend", { mode: "normal", in2: "shape", result: "effect1_innerShadow_1_1109" })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("linearGradient", { id: "paint0_linear_1_1109", x1: "-30", y1: "22", x2: "8.53106", y2: "80.714", gradientUnits: "userSpaceOnUse", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { stopColor: "#EDF1F3" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { offset: "1", stopColor: "#D3DADF" })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("linearGradient", { id: "paint1_linear_1_1109", x1: "40.0593", y1: "22.7021", x2: "35.4196", y2: "17.2148", gradientUnits: "userSpaceOnUse", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { stopColor: "#FFA700" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { offset: "1", stopColor: "#E75A10" })
    ] })
  ] })
] }));
DiscoverLogoLarge.displayName = "DiscoverLogoLarge";
const DiscoverLogoSmall = forwardRef((props, ref2) => /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { width: "36", height: "25", viewBox: "0 0 36 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img", "aria-label": "Discover Logo Small ", ...props, ref: ref2, children: [
  /* @__PURE__ */ jsxRuntimeExports.jsxs("g", { filter: "url(#filter0_dd_1_1076)", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("title", { children: "Discover Logo Small " }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2 2.5C2 1.67157 2.67157 1 3.5 1H32.5C33.3284 1 34 1.67157 34 2.5V20.5C34 21.3284 33.3284 22 32.5 22H3.5C2.67157 22 2 21.3284 2 20.5V2.5Z", fill: "url(#paint0_linear_1_1076)" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2 2.5C2 1.67157 2.67157 1 3.5 1H32.5C33.3284 1 34 1.67157 34 2.5V20.5C34 21.3284 33.3284 22 32.5 22H3.5C2.67157 22 2 21.3284 2 20.5V2.5Z", fill: "#E5E5E5", fillOpacity: "0.01" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.01621 12.3331C8.80573 12.5244 8.5322 12.6079 8.09928 12.6079H7.91945V10.3221H8.09928C8.5322 10.3221 8.79498 10.4001 9.01621 10.6017C9.24794 10.8092 9.38729 11.1311 9.38729 11.4621C9.38729 11.794 9.24794 12.1255 9.01621 12.3331ZM8.23357 9.7365H7.25002V13.1929H8.2284C8.74864 13.1929 9.12436 13.0695 9.45403 12.7939C9.84594 12.4677 10.0777 11.9758 10.0777 11.4672C10.0777 10.4471 9.32025 9.7365 8.23357 9.7365Z", fill: "#212D34" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.3858 13.193H11.0558V9.73647H10.3858V13.193Z", fill: "#212D34" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.6947 11.0629C12.2926 10.9132 12.1746 10.8145 12.1746 10.6277C12.1746 10.41 12.3849 10.2445 12.6737 10.2445C12.8744 10.2445 13.0395 10.3276 13.214 10.5244L13.5646 10.0625C13.2765 9.80892 12.9319 9.67939 12.5552 9.67939C11.9474 9.67939 11.4838 10.104 11.4838 10.6697C11.4838 11.1459 11.6996 11.3898 12.3289 11.6176C12.5913 11.7108 12.7248 11.7728 12.7921 11.8144C12.926 11.9024 12.993 12.027 12.993 12.1722C12.993 12.4522 12.7718 12.6597 12.4728 12.6597C12.1532 12.6597 11.8957 12.4988 11.7415 12.1986L11.3086 12.6181C11.6173 13.0741 11.9881 13.2762 12.498 13.2762C13.1942 13.2762 13.6828 12.8102 13.6828 12.1412C13.6828 11.592 13.4569 11.3434 12.6947 11.0629Z", fill: "#212D34" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13.8941 11.4671C13.8941 12.4831 14.6869 13.2709 15.7072 13.2709C15.9956 13.2709 16.2427 13.2138 16.5473 13.0695V12.2759C16.2795 12.5456 16.0422 12.6544 15.7384 12.6544C15.0636 12.6544 14.5846 12.1621 14.5846 11.4621C14.5846 10.7985 15.0787 10.275 15.7072 10.275C16.0268 10.275 16.2687 10.3897 16.5473 10.6639V9.87066C16.2532 9.72056 16.0114 9.65833 15.723 9.65833C14.7079 9.65833 13.8941 10.4621 13.8941 11.4671Z", fill: "#212D34" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M21.86 12.0582L20.944 9.7365H20.2119L21.6697 13.2817H22.0303L23.5143 9.7365H22.7879L21.86 12.0582Z", fill: "#212D34" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M23.8174 13.193H25.7176V12.6078H24.487V11.6748H25.6724V11.0893H24.487V10.3221H25.7176V9.73642H23.8174V13.193Z", fill: "#212D34" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M27.0263 11.3278H26.8306V10.281H27.037C27.4543 10.281 27.6812 10.4568 27.6812 10.7932C27.6812 11.1407 27.4543 11.3278 27.0263 11.3278ZM28.3705 10.7569C28.3705 10.1098 27.9275 9.73639 27.1548 9.73639H26.1611V13.1929H26.8304V11.8044H26.9179L27.8453 13.1929H28.6693L27.5878 11.7368C28.0926 11.6335 28.3705 11.2861 28.3705 10.7569Z", fill: "#212D34" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("g", { filter: "url(#filter1_i_1_1076)", children: /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M20.421 11.4767C20.421 12.4922 19.6028 13.3155 18.5935 13.3155C17.5842 13.3155 16.7661 12.4922 16.7661 11.4767C16.7661 10.4611 17.5842 9.63794 18.5935 9.63794C19.6028 9.63794 20.421 10.4611 20.421 11.4767Z", fill: "url(#paint1_linear_1_1076)" }) })
  ] }),
  /* @__PURE__ */ jsxRuntimeExports.jsxs("defs", { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs("filter", { id: "filter0_dd_1_1076", x: "0", y: "0", width: "36", height: "25", filterUnits: "userSpaceOnUse", colorInterpolationFilters: "sRGB", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("feFlood", { floodOpacity: "0", result: "BackgroundImageFix" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("feColorMatrix", { in: "SourceAlpha", type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0", result: "hardAlpha" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("feOffset", { dy: "1" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("feGaussianBlur", { stdDeviation: "1" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("feComposite", { in2: "hardAlpha", operator: "out" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("feColorMatrix", { type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("feBlend", { mode: "normal", in2: "BackgroundImageFix", result: "effect1_dropShadow_1_1076" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("feColorMatrix", { in: "SourceAlpha", type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0", result: "hardAlpha" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("feOffset", {}),
      /* @__PURE__ */ jsxRuntimeExports.jsx("feGaussianBlur", { stdDeviation: "0.5" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("feColorMatrix", { type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("feBlend", { mode: "normal", in2: "effect1_dropShadow_1_1076", result: "effect2_dropShadow_1_1076" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("feBlend", { mode: "normal", in: "SourceGraphic", in2: "effect2_dropShadow_1_1076", result: "shape" })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("filter", { id: "filter1_i_1_1076", x: "16.7661", y: "9.63794", width: "3.65487", height: "3.67757", filterUnits: "userSpaceOnUse", colorInterpolationFilters: "sRGB", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("feFlood", { floodOpacity: "0", result: "BackgroundImageFix" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("feBlend", { mode: "normal", in: "SourceGraphic", in2: "BackgroundImageFix", result: "shape" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("feColorMatrix", { in: "SourceAlpha", type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0", result: "hardAlpha" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("feOffset", { dx: "1", dy: "1" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("feComposite", { in2: "hardAlpha", operator: "arithmetic", k2: "-1", k3: "1" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("feColorMatrix", { type: "matrix", values: "0 0 0 0 0.314068 0 0 0 0 0.00146228 0 0 0 0 0.00146228 0 0 0 0.5 0" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("feBlend", { mode: "normal", in2: "shape", result: "effect1_innerShadow_1_1076" })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("linearGradient", { id: "paint0_linear_1_1076", x1: "-14", y1: "11.5", x2: "5.26553", y2: "40.857", gradientUnits: "userSpaceOnUse", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { stopColor: "#EDF1F3" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { offset: "1", stopColor: "#D3DADF" })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("linearGradient", { id: "paint1_linear_1_1076", x1: "20.8321", y1: "11.8282", x2: "18.6636", y2: "9.26346", gradientUnits: "userSpaceOnUse", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { stopColor: "#FFA700" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { offset: "1", stopColor: "#E75A10" })
    ] })
  ] })
] }));
DiscoverLogoSmall.displayName = "DiscoverLogoSmall";
const EmailMarketingIllustration = forwardRef((props, ref2) => /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { width: "56", height: "56", viewBox: "0 0 56 56", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img", "aria-label": "Email Marketing Illustration ", ...props, ref: ref2, children: [
  /* @__PURE__ */ jsxRuntimeExports.jsx("title", { children: "Email Marketing Illustration " }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M51.68 0H4.37C3.87405 0 3.3984 0.197017 3.04771 0.54771C2.69702 0.898403 2.5 1.37405 2.5 1.87V34.44C2.5 34.936 2.69702 35.4116 3.04771 35.7623C3.3984 36.113 3.87405 36.31 4.37 36.31H25.3L24 39.81C23.893 40.2055 23.6616 40.5561 23.34 40.81C23.0172 41.0621 22.6196 41.1994 22.21 41.2H18.21C17.8705 41.1755 17.5297 41.2232 17.21 41.34C16.8877 41.4571 16.5919 41.6373 16.34 41.87C16.0869 42.1022 15.8857 42.3853 15.7496 42.7007C15.6135 43.016 15.5455 43.3565 15.55 43.7V45.28H40.78V43.71C40.7858 43.3673 40.7194 43.0272 40.585 42.7119C40.4506 42.3966 40.2513 42.1131 40 41.88C39.7481 41.6473 39.4523 41.4671 39.13 41.35C38.8094 41.2369 38.4693 41.1893 38.13 41.21H33.53C33.1196 41.1965 32.7226 41.0607 32.39 40.82C32.0604 40.5735 31.8271 40.2199 31.73 39.82L30.36 36.32H51.66C52.156 36.32 52.6316 36.123 52.9823 35.7723C53.333 35.4216 53.53 34.946 53.53 34.45V1.87C53.53 1.37749 53.3358 0.904855 52.9894 0.554731C52.643 0.204608 52.1725 0.00526747 51.68 0ZM30.78 40.08C30.937 40.6857 31.2883 41.2231 31.78 41.61C32.2932 41.982 32.9064 42.191 33.54 42.21H38.17C38.3766 42.1964 38.5839 42.2236 38.78 42.29C38.9727 42.3614 39.1494 42.4701 39.3 42.61C39.4506 42.7501 39.5699 42.9205 39.65 43.11C39.73 43.2999 39.7708 43.504 39.77 43.71V44.29H16.53V43.71C16.5292 43.504 16.57 43.2999 16.65 43.11C16.7301 42.9205 16.8494 42.7501 17 42.61C17.1506 42.4701 17.3273 42.3614 17.52 42.29C17.7261 42.2217 17.9435 42.1946 18.16 42.21H22.16C22.7831 42.2063 23.388 41.9991 23.8826 41.62C24.3772 41.241 24.7344 40.7107 24.9 40.11L26.37 36.31H29.31L30.78 40.08ZM52.2952 35.0552C52.132 35.2183 51.9107 35.31 51.68 35.31H4.37C4.25575 35.31 4.14262 35.2875 4.03707 35.2438C3.93151 35.2001 3.8356 35.136 3.75482 35.0552C3.67403 34.9744 3.60995 34.8785 3.56622 34.7729C3.5225 34.6674 3.5 34.5542 3.5 34.44V1.87C3.5 1.75575 3.5225 1.64262 3.56622 1.53707C3.60995 1.43151 3.67403 1.3356 3.75482 1.25482C3.8356 1.17403 3.93151 1.10995 4.03707 1.06622C4.14262 1.0225 4.25575 1 4.37 1H51.68C51.9107 1 52.132 1.09166 52.2952 1.25482C52.4583 1.41797 52.55 1.63926 52.55 1.87V34.44C52.55 34.6707 52.4583 34.892 52.2952 35.0552ZM49.8 53.08L46.25 48.42C46.0852 48.2112 45.8771 48.0406 45.64 47.92C45.3989 47.8064 45.1365 47.745 44.87 47.74H10.54C10.2766 47.744 10.0172 47.8054 9.77999 47.92C9.53999 48.0405 9.32858 48.211 9.15999 48.42L5.62999 53.07C5.45963 53.3199 5.36261 53.6124 5.34992 53.9146C5.33723 54.2168 5.40937 54.5164 5.55818 54.7797C5.70699 55.043 5.92653 55.2594 6.19194 55.4043C6.45736 55.5493 6.75805 55.6171 7.05999 55.6H48.37C48.6704 55.6166 48.9696 55.5497 49.2343 55.4067C49.4991 55.2638 49.7191 55.0503 49.87 54.79C50.02 54.5253 50.0929 54.224 50.0806 53.92C50.0682 53.616 49.971 53.3216 49.8 53.07V53.08ZM49 54.31C48.9439 54.4108 48.8608 54.4939 48.76 54.55C48.6551 54.6037 48.5376 54.6279 48.42 54.62H6.99999C6.88241 54.6279 6.76489 54.6037 6.65999 54.55C6.55923 54.4939 6.47611 54.4108 6.41999 54.31C6.36152 54.2098 6.33047 54.096 6.32999 53.98C6.33463 53.8649 6.37287 53.7536 6.43999 53.66L9.93999 49.02C10.0167 48.9277 10.1122 48.8527 10.22 48.8C10.3226 48.7488 10.4354 48.7214 10.55 48.72H44.84C44.9577 48.7226 45.0735 48.7498 45.18 48.8C45.283 48.8557 45.3746 48.9303 45.45 49.02L49 53.66C49.0656 53.7544 49.1037 53.8652 49.11 53.98C49.1035 54.0979 49.0655 54.2118 49 54.31ZM38.877 4.94615C39.9608 4.4138 41.1525 4.13796 42.36 4.14C43.9393 4.14744 45.4802 4.62809 46.7837 5.51991C48.0871 6.41172 49.0934 7.67375 49.6725 9.14309C50.2516 10.6124 50.377 12.2216 50.0326 13.763C49.6881 15.3043 48.8896 16.707 47.74 17.79V28.17C47.74 28.4077 47.6933 28.6431 47.6023 28.8627C47.5114 29.0823 47.3781 29.2819 47.21 29.45L47.15 29.5C46.8249 29.7643 46.419 29.909 46 29.91H9.82C9.387 29.9076 8.96889 29.7516 8.64 29.47L8.58 29.41C8.41194 29.2419 8.27863 29.0423 8.18769 28.8227C8.09675 28.6031 8.04997 28.3677 8.05 28.13V9.04C8.04762 8.80369 8.0918 8.56923 8.18 8.35C8.26677 8.125 8.39961 7.92063 8.57 7.75C8.73821 7.57887 8.93877 7.4429 9.16 7.35C9.38211 7.25857 9.61982 7.21103 9.86 7.21H36.11C36.8465 6.25311 37.7932 5.47851 38.877 4.94615ZM9.86 8.21C9.75373 8.20947 9.6484 8.22985 9.55 8.27L9.51 8.29L22.38 19.91L24.24 21.59C25.3545 22.3292 26.6627 22.7224 28 22.72C29.322 22.7129 30.6138 22.324 31.72 21.6L33.57 19.81L36.33 17.15C35.294 15.9249 34.6549 14.4138 34.4978 12.817C34.3406 11.2203 34.6727 9.61356 35.45 8.21H9.86ZM9.1 28.13C9.08484 28.2261 9.08484 28.3239 9.1 28.42L21.1 20.09L9.1 9.22V28.13ZM21.8 20.77L10.1 28.94L45.59 28.95L33.94 20.72L32.24 22.36C30.952 23.2144 29.4407 23.6701 27.895 23.6701C26.3494 23.6701 24.838 23.2144 23.55 22.36L21.8 20.77ZM46.72 28.42C46.752 28.3266 46.7688 28.2287 46.77 28.13L46.75 18.59C45.2799 19.5817 43.5188 20.05 41.7503 19.9194C39.9817 19.7888 38.3085 19.0669 37 17.87L34.81 20L46.72 28.42ZM38.5166 17.7771C39.6513 18.5353 40.9853 18.94 42.35 18.94H42.36C44.1883 18.9373 45.9407 18.2092 47.2326 16.9155C48.5244 15.6218 49.25 13.8683 49.25 12.04C49.25 10.6753 48.8453 9.34126 48.0871 8.20656C47.329 7.07186 46.2513 6.18747 44.9905 5.66523C43.7297 5.14298 42.3424 5.00634 41.0039 5.27258C39.6654 5.53882 38.4359 6.19598 37.471 7.16096C36.506 8.12594 35.8488 9.3554 35.5826 10.6939C35.3163 12.0323 35.453 13.4197 35.9752 14.6805C36.4975 15.9413 37.3819 17.019 38.5166 17.7771ZM44.76 9.5H44C43.8294 9.71766 43.6102 9.89233 43.36 10.01C43.1096 10.1263 42.8361 10.1844 42.56 10.18V11.18C42.9738 11.2136 43.3858 11.0964 43.72 10.85V13.5H42.59V14.5H45.83V13.5H44.76V9.5ZM39.36 10.42H40.29V11.71H41.61V12.71H40.3V14.03H39.37V12.71H38.03V11.71H39.36V10.42Z", fill: "#0B3541" })
] }));
EmailMarketingIllustration.displayName = "EmailMarketingIllustration";
const EveryPolicyBackedStamp = forwardRef((props, ref2) => /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { width: "80", height: "80", viewBox: "0 0 80 80", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img", "aria-label": "Every Policy Backed Stamp ", ...props, ref: ref2, children: [
  /* @__PURE__ */ jsxRuntimeExports.jsx("title", { children: "Every Policy Backed Stamp " }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M40.0655 4L42.0424 4.10405C42.9788 4.20809 43.7071 4.93641 43.603 5.97687C43.499 6.91329 42.6666 7.64161 41.7302 7.53756L40.3776 7.43352L40.2736 9.61848H39.7533L40.0655 4ZM41.7302 7.12138C42.3545 7.12138 42.9788 6.70519 43.0828 5.97687C43.0828 5.3526 42.5626 4.72832 41.9383 4.72832L40.5857 4.62428L40.3776 7.01733L41.7302 7.12138ZM31.2215 7.53756L29.0365 5.45664H28.3082L31.0134 7.95374L31.6377 10.5549L32.262 10.6589L31.6377 8.05779L32.8862 4.62427L32.262 4.72832L31.2215 7.53756ZM24.4585 13.3641L22.0654 8.16184L24.0423 7.22542C24.8747 6.80924 25.9151 7.12138 26.3313 7.95374C26.6435 8.68207 26.4354 9.41039 25.9151 9.93062L27.9961 11.5954L27.3718 11.9075L25.2909 10.2428L23.9383 10.867L24.9787 12.948L24.4585 13.3641ZM23.7302 10.5549L25.1868 9.93062C25.7071 9.61848 26.0192 8.9942 25.7071 8.36993C25.3949 7.74565 24.6666 7.53756 24.1464 7.8497L22.6897 8.47397L23.7302 10.5549ZM19.0482 10.5549L18.736 10.1387L16.0308 12.2196L19.4643 16.7977L22.2736 14.7167L21.9614 14.3005L19.5684 16.0693L18.3198 14.4046L20.1927 12.948L19.8805 12.5318L18.0077 13.9884L16.7592 12.3237L19.0482 10.5549ZM10.5164 17.734L15.4066 19.6069L13.0135 15.0289L13.4297 14.6127L16.2389 19.919L15.8228 20.4392L10.2043 18.2543L10.5164 17.734ZM8.33142 20.7514L8.74761 20.9595L7.29096 23.4566L9.05974 24.497L10.2042 22.4161L10.8285 22.7283L9.68402 24.8092L11.4528 25.8496L12.9094 23.2485L13.3256 23.4566L11.5568 26.4739L6.66669 23.7687L8.33142 20.7514ZM48.181 11.1792C49.7417 11.5954 51.3024 10.763 51.8226 9.2023C52.3428 7.53757 51.4064 5.97688 49.9498 5.5607C48.3891 5.14451 46.8284 5.97688 46.3082 7.53757C45.7879 9.09826 46.6203 10.6589 48.181 11.1792ZM48.285 10.6589C47.1405 10.2428 46.4122 8.89017 46.8284 7.64161C47.2446 6.39306 48.4931 5.66474 49.7417 6.08093C50.9902 6.39306 51.6145 7.84971 51.1983 9.09826C50.7821 10.3468 49.5336 11.0751 48.285 10.6589ZM56.0885 8.16183L56.6087 8.47396L54.0075 12.9479L56.2966 14.1965L56.0885 14.6127L53.3833 13.052L56.0885 8.16183ZM61.9151 12.0115L61.4989 11.6994L58.0654 16.1734L58.4816 16.4855L61.9151 12.0115ZM64.8284 21.3757C63.892 21.4797 63.0596 21.1676 62.4354 20.4392C61.3949 19.1907 61.4989 17.4219 62.7475 16.3815C63.996 15.2369 65.7648 15.341 66.8053 16.5895C67.4296 17.3179 67.6377 18.1502 67.5336 18.9826H67.0134C67.1174 18.3583 67.0134 17.63 66.4931 17.0057C65.6608 16.0693 64.2041 15.9653 63.1637 16.9017C62.1232 17.8381 62.0192 19.1907 62.9556 20.2312C63.4758 20.8554 64.2041 21.0635 64.9325 20.9595L64.8284 21.3757ZM68.7821 23.9768L70.1347 21.2716L69.8226 20.6474L68.1578 23.8728L65.8688 25.1213L66.1809 25.6416L68.47 24.393L72.1116 24.7051L71.7994 24.1849L68.7821 23.9768ZM12.0771 55.6068L13.1176 57.1675C13.6378 57.9998 13.5337 58.9362 12.8054 59.4565C12.2852 59.7686 11.6609 59.7686 11.2447 59.4565C11.3488 59.9767 11.3488 60.601 10.6204 61.0172C9.78808 61.5374 8.95571 61.2253 8.33144 60.2888L7.29098 58.6241L12.0771 55.6068ZM8.0193 58.8322L8.85167 60.0807C9.26785 60.705 9.89213 60.8091 10.4124 60.4969C10.9326 60.1848 11.0366 59.4565 10.6204 58.9362L9.78808 57.6877L8.0193 58.8322ZM11.973 56.3351L10.2043 57.4796L10.9326 58.6241C11.3488 59.2484 11.869 59.2484 12.3892 58.9362C12.9095 58.7281 13.0135 58.1039 12.7014 57.4796L11.973 56.3351ZM16.7591 61.8495L11.1407 64.2426L11.4528 64.6588L13.2216 63.9305L14.9904 65.6992L14.262 67.468L14.6782 67.7802L17.1753 62.2657L16.7591 61.8495ZM15.3025 65.2831L13.8459 63.7224L16.551 62.5779L15.3025 65.2831ZM21.8574 71.6298C21.025 71.942 20.0886 71.942 19.2562 71.3177C17.9036 70.3813 17.5915 68.7165 18.4239 67.2599C19.3603 65.9073 21.1291 65.4911 22.4817 66.4275C23.314 66.9478 23.7302 67.7801 23.7302 68.5084L23.21 68.6125C23.21 67.8842 22.8979 67.3639 22.1695 66.8437C21.025 66.1154 19.6724 66.4275 18.9441 67.572C18.2158 68.7165 18.4239 70.0691 19.5684 70.7974C20.2967 71.2136 21.025 71.3177 21.6493 71.0055L21.8574 71.6298ZM26.9556 69.0287L26.4354 68.8206L24.4585 74.0229L24.9788 74.231L25.603 72.6703L26.9556 71.942L27.788 75.3755L28.4123 75.5836L27.4759 71.6299L30.077 70.1732L29.4527 69.9651L25.8111 71.942L26.9556 69.0287ZM35.9037 71.3177L35.7996 71.8379L32.9904 71.3177L32.6782 73.3986L35.0713 73.8148L34.9673 74.335L32.5742 73.9188L32.2621 75.9997L35.1753 76.52L35.0713 77.0402L31.5337 76.4159L32.4701 70.7975L35.9037 71.3177ZM40.3776 71.4217L38.5048 71.5258L38.8169 77.2483L40.6898 77.1443C42.2505 77.0402 43.499 75.6876 43.395 74.1269C43.2909 72.5662 41.9383 71.3177 40.3776 71.4217ZM42.7707 74.1269C42.8747 75.4795 41.8343 76.4159 40.5857 76.52L39.3372 76.624L39.1291 72.046L40.3776 71.942C41.6262 71.8379 42.6666 72.7743 42.7707 74.1269ZM50.366 70.1732C50.1579 70.5894 49.7417 71.0056 49.2215 71.1096L49.0134 70.5894C49.5336 70.3813 50.0538 69.9651 50.1579 69.2368L50.5741 69.0287L52.4469 73.8148L53.6954 73.2946L53.9035 73.7108L50.8862 74.8553L50.5741 74.7512L51.8226 74.231L50.366 70.1732ZM55.2562 66.7397C53.9036 67.572 54.2157 69.1327 54.944 70.3813C55.6724 71.6298 56.9209 72.5663 58.2735 71.7339C59.6261 70.9015 59.314 69.3408 58.5856 68.0923C57.8573 66.8437 56.6088 65.9073 55.2562 66.7397ZM55.5683 67.2599C56.5047 66.7397 57.5452 67.468 58.1695 68.5085C58.7937 69.5489 59.0018 70.6934 58.0654 71.3177C57.0249 71.942 56.0885 71.2137 55.4643 70.0692C54.84 69.0287 54.6319 67.8842 55.5683 67.2599ZM60.8747 66.4275C59.8342 65.3871 59.314 63.9304 60.4585 62.7859C61.603 61.6414 63.0596 62.3697 63.996 63.4102C65.0365 64.4507 65.5567 65.9073 64.4122 67.0518C63.2677 68.0923 61.9151 67.468 60.8747 66.4275ZM64.1001 66.6356C64.9324 65.9073 64.5163 64.7628 63.5799 63.8264C62.6434 62.89 61.603 62.3697 60.7706 63.2021C59.9382 64.0345 60.3544 65.0749 61.2908 66.0114C62.2273 66.9478 63.2677 67.468 64.1001 66.6356ZM64.4122 60.601C65.0365 61.0172 65.7648 60.8091 66.181 60.1848C66.5971 59.5605 66.3891 58.8322 65.8688 58.416C65.2445 58.1039 64.5162 58.2079 64.1 58.8322C63.6839 59.3524 63.7879 60.1848 64.4122 60.601ZM64.6203 60.1848C64.2041 59.8727 64.2041 59.4565 64.4122 59.0403C64.6203 58.6241 65.1405 58.5201 65.5567 58.8322C65.9729 59.1443 65.9729 59.5605 65.7648 59.9767C65.5567 60.2888 65.0365 60.4969 64.6203 60.1848ZM66.285 55.6068L65.9729 56.023L68.3659 62.5778L68.6781 62.1617L66.285 55.6068ZM68.7821 59.8727C69.4064 60.2888 70.1347 60.0807 70.5509 59.4565C70.9671 58.8322 70.863 58.1039 70.2388 57.6877C69.6145 57.2715 68.8862 57.4796 68.47 58.1039C68.0538 58.6241 68.1578 59.4565 68.7821 59.8727ZM68.9902 59.3524C68.574 59.0403 68.574 58.6241 68.7821 58.2079C69.0943 57.8958 69.5104 57.7917 69.9266 57.9998C70.3428 58.312 70.3428 58.7281 70.1347 59.1443C69.9266 59.4565 69.4064 59.6646 68.9902 59.3524ZM38.805 24.3217L38.9966 24.3753L44.1931 25.8303C46.4937 26.4296 48.8714 26.5232 51.1341 25.9329L51.969 25.7151V26.578V29.4913C51.969 29.8595 51.6705 30.1579 51.3024 30.1579C50.9342 30.1579 50.6357 29.8595 50.6357 29.4913V27.4124C48.3757 27.8493 46.0614 27.6957 43.8509 27.119L43.8394 27.116L43.8394 27.1159L38.8287 25.7129L34.7531 27.0052L34.7526 27.0053C32.3737 27.7622 29.8719 27.9835 27.4655 27.5469L26.998 27.469V46.6741C27.6417 48.9966 29.4035 51.143 31.6568 52.8956C33.879 54.624 36.5145 55.9178 38.8377 56.5848C44.9002 55.2429 49.4449 51.3852 50.6357 46.6811V36.7745C50.6357 36.4063 50.9342 36.1078 51.3024 36.1078C51.6705 36.1078 51.969 36.4063 51.969 36.7745V46.7629V46.8433L51.9499 46.9215C50.6234 52.3378 45.474 56.5344 38.9558 57.9235L38.7963 57.9575L38.6391 57.9141C36.1098 57.2145 33.2479 55.8223 30.8382 53.9481C28.436 52.0797 26.415 49.6781 25.687 46.9338L25.6647 46.8498V46.7629V26.682V25.8951L26.4409 26.0244L27.6895 26.2325L27.6992 26.2341L27.6991 26.2342C29.8691 26.6287 32.1515 26.4337 34.3488 25.7346L34.3495 25.7344L38.6153 24.3818L38.805 24.3217ZM56.768 28.6101C57.0284 28.3497 57.0284 27.9276 56.768 27.6673C56.5077 27.4069 56.0855 27.4069 55.8252 27.6673L38.9239 44.5686L31.0716 36.6181C30.8128 36.3562 30.3907 36.3536 30.1288 36.6123C29.8668 36.871 29.8642 37.2931 30.1229 37.5551L38.4466 45.9828L38.918 46.4601L39.3923 45.9857L56.768 28.6101Z", fill: "#282624" })
] }));
EveryPolicyBackedStamp.displayName = "EveryPolicyBackedStamp";
const FlexPTOIllustration = forwardRef((props, ref2) => /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { width: "56", height: "56", viewBox: "0 0 56 56", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img", "aria-label": "FlexPTO Illustration ", ...props, ref: ref2, children: [
  /* @__PURE__ */ jsxRuntimeExports.jsx("title", { children: "FlexPTO Illustration " }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M27.6423 1.33551C27.9185 1.33551 28.1423 1.55937 28.1423 1.83551V5.77107C28.1423 6.04721 27.9185 6.27107 27.6423 6.27107C27.3662 6.27107 27.1423 6.04721 27.1423 5.77107V1.83551C27.1423 1.55937 27.3662 1.33551 27.6423 1.33551ZM27.6423 49.7289C27.9185 49.7289 28.1423 49.9528 28.1423 50.2289V54.1645C28.1423 54.4406 27.9185 54.6645 27.6423 54.6645C27.3662 54.6645 27.1423 54.4406 27.1423 54.1645V50.2289C27.1423 49.9528 27.3662 49.7289 27.6423 49.7289ZM50.229 27.5C49.9529 27.5 49.729 27.7239 49.729 28C49.729 28.2761 49.9529 28.5 50.229 28.5H54.1646C54.4407 28.5 54.6646 28.2761 54.6646 28C54.6646 27.7239 54.4407 27.5 54.1646 27.5H50.229ZM1.33569 28C1.33569 27.7239 1.55955 27.5 1.83569 27.5H5.77125C6.04739 27.5 6.27125 27.7239 6.27125 28C6.27125 28.2761 6.04739 28.5 5.77125 28.5H1.83569C1.55955 28.5 1.33569 28.2761 1.33569 28ZM12.6229 9.59908C12.4684 9.46036 12.2443 9.43151 12.0598 9.5266C11.8752 9.62168 11.7687 9.82092 11.792 10.0272C12.0489 12.3009 11.7759 14.6031 10.9944 16.7536C10.9001 17.0132 11.0341 17.3 11.2936 17.3943C11.5531 17.4886 11.84 17.3547 11.9343 17.0952C12.515 15.4972 12.8326 13.8207 12.8796 12.1307C12.9101 12.188 12.9413 12.2466 12.9734 12.3062C13.5588 13.3966 14.3998 14.8644 15.483 16.4484C17.642 19.6055 20.796 23.2731 24.8515 25.3049C32.8495 29.3118 41.6006 28.9155 46.4416 22.4858C46.8979 21.8978 47.2276 21.2219 47.4102 20.5003C47.5932 19.7775 47.6244 19.0246 47.502 18.2891L47.5017 18.2873C47.3274 17.2625 46.9267 16.4819 46.3819 15.8998C45.8402 15.321 45.1787 14.9626 44.5159 14.7427C43.2192 14.3125 41.8521 14.394 41.1967 14.4331L41.1768 14.4343L41.1768 14.4342L41.1696 14.4347C39.0849 14.5893 37.0664 15.2354 35.2793 16.32C33.4923 17.4046 31.9874 18.8969 30.888 20.6748C30.7427 20.9097 30.8154 21.2178 31.0502 21.3631C31.2851 21.5083 31.5932 21.4357 31.7385 21.2008C32.7549 19.5571 34.1461 18.1775 35.7982 17.1748C37.4492 16.1728 39.314 15.5757 41.2399 15.4323C41.9 15.393 43.0981 15.326 44.2011 15.6918C44.7458 15.8725 45.25 16.1538 45.6518 16.5832C46.0505 17.0092 46.3712 17.6051 46.5158 18.4544C46.6153 19.0533 46.5897 19.6664 46.4408 20.255C46.2917 20.844 46.0223 21.3957 45.6495 21.8755L45.6495 21.8754L45.6448 21.8816C41.2143 27.7691 33.0735 28.3055 25.2994 24.4108C21.4682 22.4914 18.4311 18.9879 16.3084 15.8839C15.2509 14.3374 14.4283 12.9021 13.8544 11.8332C13.8134 11.7567 13.7736 11.6821 13.7351 11.6095C15.2737 12.4597 17.0285 12.8802 18.8124 12.8039C19.0883 12.7922 19.3024 12.5589 19.2906 12.2831C19.2788 12.0072 19.0456 11.7931 18.7697 11.8049C16.5112 11.9014 14.3047 11.1096 12.6229 9.59908ZM30.5373 34.1047C30.2662 34.0521 30.0038 34.2293 29.9513 34.5004C29.8987 34.7715 30.0759 35.0339 30.347 35.0864C33.5727 35.7117 38.5097 38.1791 43.3344 44.6228C41.8292 44.226 40.2684 44.0638 38.7074 44.1451C38.4316 44.1595 38.2197 44.3947 38.2341 44.6705C38.2484 44.9463 38.4836 45.1582 38.7594 45.1438C40.7141 45.042 42.6685 45.349 44.4978 46.0451C44.6659 46.1091 44.8553 46.0779 44.994 45.9633C45.1327 45.8488 45.1991 45.6687 45.1681 45.4916C44.8389 43.6115 44.7725 41.6948 44.9707 39.7964C44.9994 39.5218 44.8 39.2759 44.5253 39.2472C44.2507 39.2185 44.0048 39.4179 43.9761 39.6925C43.8348 41.0457 43.8218 42.4077 43.9363 43.7605C39.0507 37.3467 34.0011 34.7761 30.5373 34.1047ZM25.5751 31.1368C25.8272 31.2494 25.9403 31.5451 25.8277 31.7973C24.3504 35.1053 21.346 38.3665 18.0748 40.5236C16.4358 41.6043 14.7097 42.4214 13.0511 42.8242C11.3969 43.226 9.77519 43.2234 8.37765 42.6167C7.65294 42.3226 7.03313 41.8177 6.59851 41.1674C6.16261 40.5151 5.93319 39.7468 5.94009 38.9623L5.94029 38.9404L5.94239 38.9186C6.04593 37.8472 6.40526 36.8162 6.99016 35.9126C7.57319 35.0118 8.36336 34.2637 9.29456 33.7308C12.0406 32.0156 15.2817 31.2688 18.5016 31.6095C18.7762 31.6385 18.9752 31.8847 18.9462 32.1593C18.9171 32.4339 18.671 32.633 18.3964 32.6039C15.3954 32.2864 12.3747 32.9835 9.81636 34.5839L9.80772 34.5893L9.79887 34.5944C9.00288 35.0483 8.32754 35.6867 7.82966 36.4559C7.33581 37.2189 7.03087 38.0885 6.93994 38.9926C6.93913 39.5688 7.1096 40.1324 7.42993 40.6117C7.75424 41.097 8.21715 41.4734 8.75838 41.692L8.77093 41.697L8.77086 41.6972C9.90748 42.1923 11.2935 42.2221 12.815 41.8525C14.3346 41.4834 15.9549 40.7236 17.5243 39.6887C20.6697 37.6147 23.5298 34.4904 24.9146 31.3895C25.0273 31.1373 25.3229 31.0242 25.5751 31.1368Z", fill: "#0B3541" })
] }));
FlexPTOIllustration.displayName = "FlexPTOIllustration";
const InAppTileIllustration = forwardRef((props, ref2) => /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { width: "56", height: "56", viewBox: "0 0 56 56", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img", "aria-label": "In App Tile Illustration ", ...props, ref: ref2, children: [
  /* @__PURE__ */ jsxRuntimeExports.jsx("title", { children: "In App Tile Illustration " }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 0C11.7239 0 11.5 0.223858 11.5 0.5C11.5 0.776142 11.7239 1 12 1H42.4C42.6761 1 42.9 0.776142 42.9 0.5C42.9 0.223858 42.6761 0 42.4 0H12ZM7.8999 18.4C7.8999 18.2136 7.95985 18.0972 8.02846 18.0285C8.09707 17.9599 8.21353 17.9 8.3999 17.9H47.5999C47.7863 17.9 47.9027 17.9599 47.9713 18.0285C48.04 18.0972 48.0999 18.2136 48.0999 18.4V21.9523C46.2133 20.5976 43.8997 19.8 41.3999 19.8C35.0486 19.8 29.8999 24.9487 29.8999 31.3C29.8999 33.8442 30.7261 36.1954 32.1248 38.1H8.3999C8.21353 38.1 8.09707 38.0401 8.02846 37.9714C7.95985 37.9028 7.8999 37.7864 7.8999 37.6V18.4ZM49.0999 18.4V22.7582C51.4333 24.8629 52.8999 27.9102 52.8999 31.3C52.8999 37.6513 47.7512 42.8 41.3999 42.8C38.0577 42.8 35.0485 41.3743 32.9473 39.0978C32.9317 39.0992 32.9159 39.1 32.8999 39.1H8.3999C7.98628 39.1 7.60274 38.9599 7.32135 38.6785C7.03996 38.3972 6.8999 38.0136 6.8999 37.6V18.4C6.8999 17.9864 7.03996 17.6028 7.32135 17.3214C7.60274 17.0401 7.98628 16.9 8.3999 16.9H47.5999C48.0135 16.9 48.3971 17.0401 48.6785 17.3214C48.9598 17.6028 49.0999 17.9864 49.0999 18.4ZM11.5 6.2C11.5 5.92385 11.7239 5.7 12 5.7H38.5C38.7761 5.7 39 5.92385 39 6.2C39 6.47614 38.7761 6.7 38.5 6.7H12C11.7239 6.7 11.5 6.47614 11.5 6.2ZM12 11.5C11.7239 11.5 11.5 11.7239 11.5 12C11.5 12.2761 11.7239 12.5 12 12.5H42.7C42.9761 12.5 43.2 12.2761 43.2 12C43.2 11.7239 42.9761 11.5 42.7 11.5H12ZM11.5 43.9C11.5 43.6239 11.7239 43.4 12 43.4H34.7C34.9761 43.4 35.2 43.6239 35.2 43.9C35.2 44.1761 34.9761 44.4 34.7 44.4H12C11.7239 44.4 11.5 44.1761 11.5 43.9ZM12 49.2C11.7239 49.2 11.5 49.4239 11.5 49.7C11.5 49.9761 11.7239 50.2 12 50.2H43C43.2761 50.2 43.5 49.9761 43.5 49.7C43.5 49.4239 43.2761 49.2 43 49.2H12ZM11.5 55.4C11.5 55.1239 11.7239 54.9 12 54.9H40C40.2761 54.9 40.5 55.1239 40.5 55.4C40.5 55.6761 40.2761 55.9 40 55.9H12C11.7239 55.9 11.5 55.6761 11.5 55.4ZM34.1999 31.3C34.1999 27.3236 37.4235 24.1 41.3999 24.1C45.3764 24.1 48.5999 27.3236 48.5999 31.3C48.5999 35.2765 45.3764 38.5 41.3999 38.5C37.4235 38.5 34.1999 35.2765 34.1999 31.3ZM41.3999 23.1C36.8712 23.1 33.1999 26.7713 33.1999 31.3C33.1999 35.8287 36.8712 39.5 41.3999 39.5C45.9286 39.5 49.5999 35.8287 49.5999 31.3C49.5999 26.7713 45.9286 23.1 41.3999 23.1ZM41.3999 20.8C35.6009 20.8 30.8999 25.501 30.8999 31.3C30.8999 37.099 35.6009 41.8 41.3999 41.8C47.1989 41.8 51.8999 37.099 51.8999 31.3C51.8999 25.501 47.1989 20.8 41.3999 20.8ZM38.0999 31.3C38.0999 29.4775 39.5774 28 41.3999 28C43.2224 28 44.6999 29.4775 44.6999 31.3C44.6999 33.1225 43.2224 34.6 41.3999 34.6C39.5774 34.6 38.0999 33.1225 38.0999 31.3ZM41.3999 27C39.0251 27 37.0999 28.9252 37.0999 31.3C37.0999 33.6748 39.0251 35.6 41.3999 35.6C43.7747 35.6 45.6999 33.6748 45.6999 31.3C45.6999 28.9252 43.7747 27 41.3999 27Z", fill: "#0B3541" })
] }));
InAppTileIllustration.displayName = "InAppTileIllustration";
const InstantHandIllustration = forwardRef((props, ref2) => /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { width: "56", height: "56", viewBox: "0 0 56 56", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img", "aria-label": "Instant Hand Illustration ", ...props, ref: ref2, children: [
  /* @__PURE__ */ jsxRuntimeExports.jsxs("g", { clipPath: "url(#clip0_1_987)", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("title", { children: "Instant Hand Illustration " }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M26.3683 5.28288C26.46 5.36364 26.5778 5.40875 26.7 5.40999H26.76C26.8255 5.40266 26.8889 5.38218 26.9463 5.34978C27.0037 5.31739 27.054 5.27374 27.0941 5.22146C27.1343 5.16917 27.1634 5.10933 27.1799 5.0455C27.1964 4.98167 27.1998 4.91518 27.19 4.84999L26.77 1.43999C26.7638 1.37457 26.7446 1.31106 26.7133 1.25323C26.6821 1.19541 26.6396 1.14446 26.5883 1.10341C26.537 1.06236 26.4779 1.03205 26.4146 1.01428C26.3514 0.996514 26.2852 0.991655 26.22 0.999992C26.0881 1.01749 25.9683 1.08585 25.8861 1.19047C25.8039 1.29509 25.7658 1.4277 25.78 1.55999L26.2 4.96999C26.2168 5.09108 26.2765 5.20212 26.3683 5.28288ZM36.1767 54.0544C36.2679 54.1291 36.3821 54.17 36.5 54.17L36.6 54.16C36.7303 54.1356 36.846 54.0614 36.9226 53.9531C36.9991 53.8448 37.0305 53.711 37.01 53.58L36.68 51.68C36.6575 51.5474 36.5832 51.4292 36.4734 51.3513C36.3637 51.2735 36.2276 51.2424 36.095 51.265C35.9624 51.2875 35.8442 51.3618 35.7663 51.4715C35.6885 51.5812 35.6575 51.7174 35.68 51.85L36 53.76C36.0231 53.8756 36.0856 53.9796 36.1767 54.0544ZM5.43 19.85H5.3L2.3 19.01C2.22668 18.9984 2.15686 18.9707 2.0956 18.9288C2.03434 18.8868 1.98318 18.8318 1.94584 18.7677C1.90849 18.7035 1.8859 18.6318 1.87971 18.5579C1.87351 18.4839 1.88386 18.4095 1.91 18.34C1.92733 18.2761 1.95718 18.2162 1.99783 18.1639C2.03848 18.1116 2.08912 18.0679 2.14681 18.0354C2.20449 18.0028 2.26807 17.982 2.33386 17.9742C2.39964 17.9664 2.46631 17.9718 2.53 17.99L5.57 18.85C5.63266 18.8673 5.69125 18.8969 5.74236 18.937C5.79348 18.9771 5.83609 19.0271 5.86774 19.0838C5.89938 19.1406 5.91941 19.2031 5.92667 19.2677C5.93392 19.3323 5.92826 19.3976 5.91 19.46C5.88534 19.5694 5.82459 19.6674 5.73754 19.7381C5.65048 19.8089 5.54216 19.8483 5.43 19.85ZM47.7569 21.313C47.8416 21.3761 47.9444 21.4101 48.05 21.41L48.2 21.43L53.83 19.69C53.8957 19.671 53.9569 19.6392 54.0103 19.5965C54.0637 19.5537 54.1081 19.5009 54.1411 19.441C54.174 19.3811 54.1949 19.3153 54.2024 19.2474C54.21 19.1794 54.204 19.1107 54.185 19.045C54.166 18.9793 54.1342 18.9181 54.0914 18.8647C54.0487 18.8113 53.9959 18.7669 53.936 18.7339C53.8761 18.701 53.8103 18.6801 53.7424 18.6726C53.6744 18.665 53.6057 18.671 53.54 18.69L47.91 20.43C47.8467 20.4494 47.788 20.4811 47.7371 20.5233C47.6862 20.5656 47.6441 20.6175 47.6135 20.6761C47.5828 20.7347 47.564 20.7988 47.5583 20.8647C47.5525 20.9306 47.5599 20.997 47.58 21.06C47.6102 21.1612 47.6722 21.2499 47.7569 21.313ZM1.5 34.85C1.36739 34.8712 1.23178 34.8389 1.12301 34.7601C1.01424 34.6814 0.941214 34.5626 0.919997 34.43C0.89878 34.2974 0.93111 34.1618 1.00988 34.053C1.08864 33.9442 1.20739 33.8712 1.34 33.85L6.25 32.18C6.31566 32.159 6.38481 32.1511 6.45352 32.1568C6.52222 32.1626 6.58913 32.1817 6.65041 32.2133C6.7117 32.2449 6.76617 32.2882 6.81071 32.3408C6.85525 32.3935 6.88899 32.4543 6.91 32.52C6.93101 32.5857 6.93888 32.6548 6.93317 32.7235C6.92745 32.7922 6.90826 32.8591 6.87669 32.9204C6.84512 32.9817 6.80178 33.0362 6.74916 33.0807C6.69654 33.1253 6.63566 33.159 6.57 33.18L1.66 34.79L1.5 34.85ZM45.1028 10.2486C45.1649 10.2762 45.2321 10.2903 45.3 10.29C45.4297 10.2869 45.5539 10.2372 45.65 10.15L47.17 8.69C47.2668 8.5985 47.3233 8.47229 47.327 8.33914C47.3308 8.20599 47.2815 8.0768 47.19 7.98C47.0985 7.88319 46.9723 7.8267 46.8391 7.82295C46.706 7.8192 46.5768 7.8685 46.48 7.96L44.94 9.43C44.8934 9.47562 44.8564 9.53008 44.8312 9.59018C44.8059 9.65028 44.7929 9.71481 44.7929 9.78C44.7929 9.84519 44.8059 9.90972 44.8312 9.96982C44.8564 10.0299 44.8934 10.0844 44.94 10.13C44.9853 10.1806 45.0408 10.2211 45.1028 10.2486ZM47.35 47.9C47.2867 47.9019 47.2236 47.8904 47.165 47.8663C47.1065 47.8422 47.0536 47.806 47.01 47.76L43.75 44.6C43.6974 44.5556 43.6545 44.5007 43.6241 44.4389C43.5936 44.3771 43.5763 44.3096 43.5732 44.2408C43.57 44.172 43.5812 44.1033 43.6058 44.0389C43.6305 43.9746 43.6682 43.9161 43.7166 43.867C43.765 43.8179 43.823 43.7794 43.8869 43.7538C43.9509 43.7282 44.0195 43.7161 44.0883 43.7183C44.1572 43.7205 44.2249 43.7368 44.2871 43.7664C44.3493 43.7959 44.4048 43.838 44.45 43.89L47.7 47.05C47.7478 47.0949 47.7859 47.1491 47.812 47.2093C47.8381 47.2695 47.8515 47.3344 47.8515 47.4C47.8515 47.4656 47.8381 47.5305 47.812 47.5907C47.7859 47.6509 47.7478 47.7051 47.7 47.75C47.6546 47.7971 47.6003 47.8346 47.5402 47.8604C47.4801 47.8862 47.4154 47.8996 47.35 47.9ZM53.98 34.85H54.12C54.226 34.8529 54.3301 34.8213 54.4167 34.76C54.5033 34.6987 54.5676 34.611 54.6 34.51C54.6371 34.3827 54.6222 34.2458 54.5584 34.1296C54.4946 34.0133 54.3873 33.9271 54.26 33.89L51.56 33.1C51.497 33.0802 51.4306 33.0733 51.3649 33.0798C51.2992 33.0863 51.2354 33.1061 51.1775 33.1378C51.1196 33.1696 51.0687 33.2127 51.0279 33.2646C50.9871 33.3166 50.9572 33.3762 50.94 33.44C50.9025 33.566 50.916 33.7016 50.9778 33.8177C51.0396 33.9337 51.1445 34.0208 51.27 34.06L53.98 34.85ZM14.91 11.67C14.7749 11.6697 14.6454 11.6157 14.55 11.52L10.24 7.07C10.1931 7.02351 10.1559 6.96821 10.1306 6.90728C10.1052 6.84635 10.0921 6.781 10.0921 6.715C10.0921 6.64899 10.1052 6.58364 10.1306 6.52271C10.1559 6.46178 10.1931 6.40648 10.24 6.36C10.2865 6.31313 10.3418 6.27594 10.4027 6.25055C10.4636 6.22517 10.529 6.2121 10.595 6.2121C10.661 6.2121 10.7264 6.22517 10.7873 6.25055C10.8482 6.27594 10.9035 6.31313 10.95 6.36L15.22 10.85C15.2669 10.8965 15.3041 10.9518 15.3294 11.0127C15.3548 11.0736 15.3679 11.139 15.3679 11.205C15.3679 11.271 15.3548 11.3364 15.3294 11.3973C15.3041 11.4582 15.2669 11.5135 15.22 11.56C15.1328 11.632 15.0231 11.671 14.91 11.67ZM43.2922 29.7425C43.5545 30.0851 43.7071 30.4991 43.73 30.93V35.23C43.7448 36.0004 43.5789 36.7636 43.2454 37.4582C42.912 38.1529 42.4204 38.7597 41.81 39.23L22.07 54.69C21.9838 54.7556 21.8783 54.7907 21.77 54.79C21.6667 54.7894 21.5661 54.7568 21.4821 54.6968C21.398 54.6367 21.3347 54.552 21.3007 54.4545C21.2667 54.3569 21.2638 54.2512 21.2923 54.152C21.3208 54.0527 21.3794 53.9646 21.46 53.9L41.2 38.44C41.6837 38.069 42.074 37.5901 42.3396 37.0414C42.6053 36.4927 42.739 35.8895 42.73 35.28V30.96C42.7197 30.8121 42.6799 30.6678 42.6129 30.5355C42.5459 30.4033 42.4531 30.2858 42.34 30.19C42.2293 30.0845 42.0959 30.0058 41.95 29.96C41.8055 29.91 41.6525 29.8896 41.5 29.9L33.61 30.46C33.4167 30.4771 33.2325 30.5501 33.08 30.67C32.9359 30.7978 32.8317 30.9645 32.78 31.15L31.91 34.43C31.8136 34.7105 31.7788 35.0085 31.8082 35.3036C31.8375 35.5987 31.9302 35.884 32.08 36.14C32.1819 36.2635 32.3082 36.3646 32.4511 36.4369C32.5939 36.5091 32.7502 36.5511 32.91 36.56C33.3189 36.4985 33.703 36.3255 34.02 36.06L36.93 33.77C37.0365 33.6888 37.1706 33.6527 37.3034 33.6696C37.4363 33.6864 37.5572 33.7548 37.64 33.86C37.7206 33.9649 37.7565 34.0974 37.7396 34.2286C37.7227 34.3598 37.6545 34.479 37.55 34.56L34.64 36.85C34.2249 37.1743 33.7379 37.3938 33.22 37.49C33.1333 37.5447 33.0324 37.5725 32.93 37.57H32.79H32.42L24.91 37.29C24.4985 37.2741 24.0905 37.3709 23.73 37.57C23.378 37.7609 23.0816 38.04 22.87 38.38L19.75 43.38C19.7083 43.4543 19.6472 43.5159 19.5732 43.5582C19.4993 43.6005 19.4152 43.6218 19.33 43.62C19.2347 43.6168 19.1417 43.5892 19.06 43.54C18.9488 43.4683 18.8705 43.3554 18.8424 43.226C18.8143 43.0967 18.8386 42.9614 18.91 42.85L22.06 37.85C22.3603 37.3579 22.7864 36.9548 23.2944 36.6824C23.8024 36.4099 24.374 36.2779 24.95 36.3L31.13 36.53C30.7544 35.8085 30.6755 34.9689 30.91 34.19C30.2068 34.6333 29.3913 34.8658 28.56 34.86C28.3419 34.8613 28.1242 34.8412 27.91 34.8C26.9 34.59 26.62 33.97 26.69 33.5L27.56 28.91L23.45 32.22C23.2087 32.3109 22.9483 32.3393 22.693 32.3026C22.4378 32.2659 22.1959 32.1652 21.99 32.01C21.8019 31.7772 21.6834 31.496 21.648 31.1988C21.6126 30.9016 21.6618 30.6005 21.79 30.33C22.37 28.55 22.79 27.33 22.79 27.33C23.3451 25.508 23.3451 23.562 22.79 21.74C22.6382 20.9196 22.2726 20.1538 21.73 19.52C21.1949 18.896 20.5052 18.4235 19.73 18.15C19.368 18.0117 18.9927 17.9112 18.61 17.85L18.09 24.27C17.9116 25.0914 17.5937 25.8761 17.15 26.59L13.64 32.08C12.8565 33.3235 12.541 34.8052 12.75 36.26L13.75 43.1L8.88 47.49C8.83633 47.5324 8.78468 47.5658 8.72803 47.5881C8.67138 47.6104 8.61087 47.6213 8.55 47.62C8.47901 47.6213 8.40854 47.6077 8.34311 47.5801C8.27767 47.5526 8.21871 47.5117 8.17 47.46C8.07775 47.3649 8.02616 47.2375 8.02616 47.105C8.02616 46.9725 8.07775 46.8452 8.17 46.75L12.64 42.75L11.71 36.44C11.4585 34.7559 11.8129 33.0373 12.71 31.59L16.21 26.1C16.5837 25.4981 16.8572 24.8395 17.02 24.15L17.71 16.85H18.2C18.837 16.8961 19.4655 17.0238 20.07 17.23C20.9971 17.5717 21.8203 18.1469 22.46 18.9C22.5943 19.0513 22.7179 19.2116 22.83 19.38C22.5619 18.5033 22.4635 17.5836 22.54 16.67L22.6 16.21L32.71 16.65L33.21 9.65001C33.2816 8.583 33.7412 7.57906 34.502 6.82749C35.2627 6.07592 36.2722 5.62864 37.34 5.57001H39.34V19.77L39.91 20.47C40.2528 20.847 40.4388 21.3406 40.43 21.85V24.35C40.7164 24.4372 40.9795 24.5876 41.2 24.79C41.4112 24.9768 41.5829 25.2039 41.7048 25.4581C41.8268 25.7123 41.8965 25.9884 41.91 26.27L42.03 28.96C42.1086 28.9661 42.186 28.9829 42.26 29.01C42.67 29.1445 43.0298 29.3998 43.2922 29.7425ZM35.2145 7.53311C34.6249 8.11163 34.2676 8.88601 34.21 9.71001L33.74 16.74L36.07 16.84C36.3726 16.8488 36.6696 16.9239 36.94 17.06C37.2207 17.1967 37.4643 17.3991 37.65 17.65L38.41 18.57V6.57001H37.41C36.5851 6.61199 35.8041 6.95459 35.2145 7.53311ZM36.47 17.96C36.3255 17.8932 36.1691 17.8558 36.01 17.85L23.51 17.26C23.4594 18.3565 23.7878 19.437 24.44 20.32C24.7902 20.7003 25.2176 21.0014 25.6936 21.2032C26.1696 21.405 26.6832 21.5028 27.2 21.49H32.51L32.43 24.61L39.43 24.25V21.86C39.4397 21.6032 39.3502 21.3526 39.18 21.16L36.84 18.28C36.7415 18.1476 36.6152 18.0384 36.47 17.96ZM22.69 31.36C22.8131 31.4027 22.9469 31.4027 23.07 31.36L27.84 27.43L28.04 26.43C28.1206 25.981 28.3479 25.5715 28.6864 25.2656C29.0248 24.9598 29.4552 24.7749 29.91 24.74L31.51 24.68L31.56 22.51H27.21C26.5496 22.5207 25.8945 22.3897 25.289 22.1257C24.6835 21.8618 24.1417 21.4711 23.7 20.98C23.6829 20.9571 23.6624 20.9343 23.642 20.9114C23.6142 20.8803 23.5864 20.8491 23.5668 20.8179C23.6474 21.0574 23.7119 21.3019 23.76 21.55C24.3748 23.5505 24.3748 25.6895 23.76 27.69C23.71 27.69 23.3 28.9 22.76 30.69C22.62 31.15 22.69 31.36 22.69 31.36ZM32.45 29.9C32.7571 29.6424 33.1397 29.4915 33.54 29.47L41.05 28.93L40.93 26.32C40.923 26.1695 40.8858 26.022 40.8205 25.8863C40.7552 25.7505 40.6632 25.6294 40.55 25.53C40.3252 25.3297 40.0308 25.2256 39.73 25.24L30.01 25.74C29.7782 25.7553 29.559 25.8507 29.39 26.01C29.2184 26.1694 29.1027 26.3798 29.06 26.61L27.71 33.73C28.076 33.9304 28.5013 33.9942 28.91 33.91C29.5557 33.8514 30.167 33.5923 30.6583 33.1692C31.1495 32.746 31.4963 32.1799 31.65 31.55L31.82 30.9C31.9196 30.5087 32.1401 30.1588 32.45 29.9Z", fill: "#0B3541" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M33.91 4.33001C34.0524 4.33001 34.1916 4.28779 34.31 4.20867C34.4284 4.12956 34.5207 4.01711 34.5752 3.88555C34.6297 3.75398 34.6439 3.60922 34.6162 3.46955C34.5884 3.32988 34.5198 3.20159 34.4191 3.1009C34.3184 3.0002 34.1901 2.93163 34.0505 2.90385C33.9108 2.87607 33.766 2.89033 33.6345 2.94482C33.5029 2.99932 33.3905 3.0916 33.3113 3.21C33.2322 3.32841 33.19 3.46761 33.19 3.61001C33.1887 3.70494 33.2064 3.79917 33.2421 3.88713C33.2778 3.9751 33.3308 4.055 33.3979 4.12213C33.465 4.18926 33.5449 4.24224 33.6329 4.27795C33.7208 4.31366 33.8151 4.33136 33.91 4.33001ZM20.6 5.85001C20.5979 5.99322 20.5531 6.13255 20.4714 6.25018C20.3897 6.3678 20.2747 6.45839 20.1413 6.51034C20.0078 6.5623 19.8619 6.57327 19.7221 6.54186C19.5824 6.51044 19.4552 6.43806 19.3568 6.33397C19.2584 6.22989 19.1933 6.09882 19.1698 5.95754C19.1463 5.81625 19.1655 5.67117 19.2249 5.54084C19.2843 5.41051 19.3812 5.30085 19.5032 5.22589C19.6253 5.15092 19.7669 5.11406 19.91 5.12001C20.0033 5.1226 20.0951 5.14355 20.1802 5.18164C20.2654 5.21973 20.3422 5.27424 20.4063 5.34203C20.4704 5.40983 20.5204 5.48958 20.5537 5.57675C20.5869 5.66391 20.6027 5.75677 20.6 5.85001ZM10.02 13.73C10.02 13.8728 9.9775 14.0124 9.89793 14.131C9.81837 14.2497 9.70532 14.3419 9.57317 14.3961C9.44103 14.4503 9.29575 14.464 9.15582 14.4354C9.01589 14.4068 8.88762 14.3372 8.78734 14.2355C8.68705 14.1338 8.61928 14.0046 8.59264 13.8642C8.566 13.7239 8.58169 13.5789 8.63772 13.4475C8.69375 13.3161 8.78759 13.2044 8.9073 13.1265C9.02702 13.0486 9.16719 13.008 9.31 13.01C9.40409 13.01 9.49724 13.0287 9.58404 13.065C9.67084 13.1013 9.74955 13.1545 9.81562 13.2215C9.88168 13.2885 9.93377 13.3679 9.96885 13.4552C10.0039 13.5425 10.0213 13.6359 10.02 13.73ZM49.63 40.19C49.63 40.3324 49.5878 40.4716 49.5087 40.59C49.4296 40.7084 49.3171 40.8007 49.1855 40.8552C49.054 40.9097 48.9092 40.924 48.7695 40.8962C48.6299 40.8684 48.5016 40.7998 48.4009 40.6991C48.3002 40.5984 48.2316 40.4701 48.2038 40.3305C48.1761 40.1908 48.1903 40.046 48.2448 39.9145C48.2993 39.7829 48.3916 39.6705 48.51 39.5914C48.6284 39.5122 48.7676 39.47 48.91 39.47C49.0049 39.4687 49.0992 39.4864 49.1871 39.5221C49.2751 39.5578 49.355 39.6108 49.4221 39.6779C49.4892 39.745 49.5422 39.8249 49.5779 39.9129C49.6136 40.0009 49.6314 40.0951 49.63 40.19ZM51.03 26.98C51.1724 26.98 51.3116 26.9378 51.43 26.8587C51.5484 26.7796 51.6407 26.6671 51.6952 26.5355C51.7497 26.404 51.764 26.2592 51.7362 26.1196C51.7084 25.9799 51.6398 25.8516 51.5391 25.7509C51.4384 25.6502 51.3101 25.5816 51.1705 25.5539C51.0308 25.5261 50.886 25.5403 50.7545 25.5948C50.6229 25.6493 50.5105 25.7416 50.4313 25.86C50.3522 25.9784 50.31 26.1176 50.31 26.26C50.3087 26.3549 50.3264 26.4492 50.3621 26.5371C50.3978 26.6251 50.4508 26.705 50.5179 26.7721C50.585 26.8393 50.6649 26.8922 50.7529 26.928C50.8409 26.9637 50.9351 26.9814 51.03 26.98ZM31.03 53.08C31.032 53.2232 30.9912 53.3638 30.9128 53.4837C30.8345 53.6037 30.7221 53.6975 30.5902 53.7532C30.4582 53.809 30.3126 53.8241 30.172 53.7966C30.0315 53.7691 29.9022 53.7004 29.801 53.5991C29.6997 53.4978 29.6309 53.3686 29.6034 53.228C29.576 53.0874 29.5911 52.9418 29.6468 52.8098C29.7025 52.6779 29.7964 52.5655 29.9163 52.4872C30.0362 52.4088 30.1768 52.368 30.32 52.37C30.5066 52.3726 30.6846 52.4486 30.8156 52.5815C30.9466 52.7143 31.02 52.8934 31.02 53.08H31.03ZM42.26 51.77C42.4032 51.772 42.5438 51.7312 42.6637 51.6528C42.7837 51.5745 42.8775 51.4622 42.9332 51.3302C42.9889 51.1982 43.004 51.0526 42.9766 50.9121C42.9491 50.7715 42.8803 50.6423 42.7791 50.541C42.6778 50.4397 42.5486 50.3709 42.408 50.3434C42.2674 50.316 42.1218 50.3311 41.9898 50.3868C41.8579 50.4425 41.7455 50.5364 41.6672 50.6563C41.5888 50.7762 41.548 50.9168 41.55 51.06C41.55 51.2466 41.6234 51.4257 41.7544 51.5586C41.8854 51.6914 42.0634 51.7674 42.25 51.77H42.26ZM7.13 25.56C7.13199 25.7028 7.09145 25.843 7.01355 25.9627C6.93565 26.0824 6.82391 26.1763 6.69253 26.2323C6.56116 26.2883 6.41609 26.304 6.27577 26.2774C6.13545 26.2507 6.00622 26.183 5.90453 26.0827C5.80283 25.9824 5.73326 25.8541 5.70466 25.7142C5.67605 25.5743 5.68972 25.429 5.74391 25.2968C5.79809 25.1647 5.89036 25.0517 6.00897 24.9721C6.12758 24.8925 6.26718 24.85 6.41 24.85C6.59924 24.85 6.78087 24.9245 6.91562 25.0574C7.05036 25.1902 7.12737 25.3708 7.13 25.56ZM6.75 40.9C6.89324 40.902 7.03381 40.8612 7.15373 40.7828C7.27365 40.7045 7.36748 40.5922 7.42321 40.4602C7.47894 40.3282 7.49404 40.1826 7.46658 40.0421C7.43912 39.9015 7.37034 39.7723 7.26905 39.671C7.16776 39.5697 7.03855 39.5009 6.89796 39.4734C6.75737 39.446 6.61178 39.4611 6.47982 39.5168C6.34786 39.5725 6.23552 39.6664 6.15717 39.7863C6.07882 39.9062 6.03803 40.0468 6.04 40.19C6.04 40.3783 6.11481 40.5589 6.24796 40.6921C6.38111 40.8252 6.5617 40.9 6.75 40.9ZM48.07 14.9C48.07 15.0424 48.0278 15.1816 47.9487 15.3C47.8695 15.4184 47.7571 15.5107 47.6255 15.5652C47.494 15.6197 47.3492 15.634 47.2095 15.6062C47.0699 15.5784 46.9416 15.5098 46.8409 15.4091C46.7402 15.3084 46.6716 15.1801 46.6438 15.0405C46.6161 14.9008 46.6303 14.756 46.6848 14.6245C46.7393 14.4929 46.8316 14.3805 46.95 14.3014C47.0684 14.2222 47.2076 14.18 47.35 14.18C47.4484 14.1784 47.5461 14.1972 47.6369 14.2354C47.7277 14.2735 47.8095 14.3301 47.8772 14.4016C47.9449 14.4731 47.997 14.5579 48.0302 14.6505C48.0634 14.7432 48.077 14.8418 48.07 14.94V14.9Z", fill: "#90AFAA" })
  ] }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("defs", { children: /* @__PURE__ */ jsxRuntimeExports.jsx("clipPath", { id: "clip0_1_987", children: /* @__PURE__ */ jsxRuntimeExports.jsx("rect", { width: "53.62", height: "53.8", fill: "white", transform: "translate(1 1)" }) }) })
] }));
InstantHandIllustration.displayName = "InstantHandIllustration";
const LandersIllustration = forwardRef((props, ref2) => /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { width: "56", height: "56", viewBox: "0 0 56 56", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img", "aria-label": "Landers Illustration ", ...props, ref: ref2, children: [
  /* @__PURE__ */ jsxRuntimeExports.jsx("title", { children: "Landers Illustration " }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3 1H53C54.1046 1 55 1.89543 55 3V10.91H1V3C1 1.89543 1.89543 1 3 1ZM1 12V30H55V12H1ZM55 31H1V53C1 54.1046 1.89543 55 3 55H53C54.1046 55 55 54.1046 55 53V31ZM0 31V30.91V30V12V11V10.91V3C0 1.34314 1.34315 0 3 0H53C54.6569 0 56 1.34315 56 3V10.91V11V12V30V30.91V31V53C56 54.6569 54.6569 56 53 56H3C1.34314 56 0 54.6569 0 53V31ZM4.95996 5C4.68382 5 4.45996 5.22386 4.45996 5.5V6.5C4.45996 6.77614 4.68382 7 4.95996 7H30.94C31.2161 7 31.44 6.77614 31.44 6.5V5.5C31.44 5.22386 31.2161 5 30.94 5H4.95996ZM3.45996 5.5C3.45996 4.67157 4.13153 4 4.95996 4H30.94C31.7684 4 32.44 4.67157 32.44 5.5V6.5C32.44 7.32843 31.7684 8 30.94 8H4.95996C4.13153 8 3.45996 7.32843 3.45996 6.5V5.5ZM11.53 18.03C11.53 17.7539 11.7539 17.53 12.03 17.53H43.97C44.2462 17.53 44.47 17.7539 44.47 18.03C44.47 18.3061 44.2462 18.53 43.97 18.53H12.03C11.7539 18.53 11.53 18.3061 11.53 18.03ZM17.55 23.29C17.2739 23.29 17.05 23.5139 17.05 23.79C17.05 24.0662 17.2739 24.29 17.55 24.29H38.4501C38.7262 24.29 38.9501 24.0662 38.9501 23.79C38.9501 23.5139 38.7262 23.29 38.4501 23.29H17.55ZM37.48 6C37.48 5.44772 37.9277 5 38.48 5C39.0323 5 39.48 5.44772 39.48 6C39.48 6.55228 39.0323 7 38.48 7C37.9277 7 37.48 6.55228 37.48 6ZM38.48 4C37.3754 4 36.48 4.89543 36.48 6C36.48 7.10457 37.3754 8 38.48 8C39.5845 8 40.48 7.10457 40.48 6C40.48 4.89543 39.5845 4 38.48 4ZM44.53 5C43.9777 5 43.53 5.44772 43.53 6C43.53 6.55228 43.9777 7 44.53 7C45.0823 7 45.53 6.55228 45.53 6C45.53 5.44772 45.0823 5 44.53 5ZM42.53 6C42.53 4.89543 43.4255 4 44.53 4C45.6346 4 46.53 4.89543 46.53 6C46.53 7.10457 45.6346 8 44.53 8C43.4255 8 42.53 7.10457 42.53 6ZM49.5801 6C49.5801 5.44772 50.0278 5 50.5801 5C51.1324 5 51.5801 5.44772 51.5801 6C51.5801 6.55228 51.1324 7 50.5801 7C50.0278 7 49.5801 6.55228 49.5801 6ZM50.5801 4C49.4755 4 48.5801 4.89543 48.5801 6C48.5801 7.10457 49.4755 8 50.5801 8C51.6846 8 52.5801 7.10457 52.5801 6C52.5801 4.89543 51.6846 4 50.5801 4ZM7.96997 35.6C7.69383 35.6 7.46997 35.8239 7.46997 36.1V49.95C7.46997 50.2262 7.69383 50.45 7.96997 50.45H24.79C25.0661 50.45 25.29 50.2262 25.29 49.95V36.1C25.29 35.8239 25.0661 35.6 24.79 35.6H7.96997ZM6.46997 36.1C6.46997 35.2716 7.14154 34.6 7.96997 34.6H24.79C25.6184 34.6 26.29 35.2716 26.29 36.1V49.95C26.29 50.7784 25.6184 51.45 24.79 51.45H7.96997C7.14154 51.45 6.46997 50.7784 6.46997 49.95V36.1ZM47.54 46.45V49.04C47.54 49.3161 47.3162 49.54 47.04 49.54H33.02C32.7439 49.54 32.52 49.3161 32.52 49.04V46.45C32.52 46.1739 32.7439 45.95 33.02 45.95H47.04C47.3162 45.95 47.54 46.1739 47.54 46.45ZM33.02 44.95C32.1916 44.95 31.52 45.6216 31.52 46.45V49.04C31.52 49.8684 32.1916 50.54 33.02 50.54H47.04C47.8684 50.54 48.54 49.8684 48.54 49.04V46.45C48.54 45.6216 47.8684 44.95 47.04 44.95H33.02ZM30.53 36.43C30.53 36.1539 30.7539 35.93 31.03 35.93H49.03C49.3062 35.93 49.53 36.1539 49.53 36.43C49.53 36.7061 49.3062 36.93 49.03 36.93H31.03C30.7539 36.93 30.53 36.7061 30.53 36.43ZM33.96 40.23C33.6838 40.23 33.46 40.4539 33.46 40.73C33.46 41.0061 33.6838 41.23 33.96 41.23H46.11C46.3861 41.23 46.61 41.0061 46.61 40.73C46.61 40.4539 46.3861 40.23 46.11 40.23H33.96Z", fill: "#0B3541" })
] }));
LandersIllustration.displayName = "LandersIllustration";
const MastercardLogoLarge = forwardRef((props, ref2) => /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { width: "68", height: "46", viewBox: "0 0 68 46", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img", "aria-label": "Mastercard Logo Large ", ...props, ref: ref2, children: [
  /* @__PURE__ */ jsxRuntimeExports.jsxs("g", { filter: "url(#filter0_dd_1_1127)", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("title", { children: "Mastercard Logo Large " }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2 4C2 2.34315 3.34315 1 5 1H63C64.6569 1 66 2.34315 66 4V40C66 41.6569 64.6569 43 63 43H5C3.34315 43 2 41.6569 2 40V4Z", fill: "#F4F6F7" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M27 33C33.0751 33 38 28.0751 38 22C38 15.9249 33.0751 11 27 11C20.9249 11 16 15.9249 16 22C16 28.0751 20.9249 33 27 33Z", fill: "#D8232A" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M34 30.4857C35.9019 32.0564 38.3407 33 41 33C47.0751 33 52 28.0751 52 22C52 15.9249 47.0751 11 41 11C38.3407 11 35.9019 11.9436 34 13.5143C36.443 15.5319 38 18.5841 38 22C38 25.4159 36.443 28.4681 34 30.4857Z", fill: "#ED9F2D" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M34 13.5143C31.557 15.5319 30 18.5841 30 22C30 25.4159 31.557 28.4681 34 30.4857C36.443 28.4681 38 25.4159 38 22C38 18.5841 36.443 15.5319 34 13.5143Z", fill: "#D8232A" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("mask", { id: "mask0_1_1127", maskUnits: "userSpaceOnUse", x: "30", y: "13", width: "8", height: "18", children: /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M34 13.5143C31.557 15.5319 30 18.5841 30 22C30 25.4159 31.557 28.4681 34 30.4857C36.443 28.4681 38 25.4159 38 22C38 18.5841 36.443 15.5319 34 13.5143Z", fill: "white" }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("g", { mask: "url(#mask0_1_1127)", children: /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M29 14H39V15H29V14ZM29 16H39V17H29V16ZM39 18H29V19H39V18ZM29 20H39V21H29V20ZM39 22H29V23H39V22ZM29 24H39V25H29V24ZM39 26H29V27H39V26ZM29 28H39V29H29V28ZM39 30H29V31H39V30Z", fill: "#ED9F2D" }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2 4C2 2.34315 3.34315 1 5 1H63C64.6569 1 66 2.34315 66 4V40C66 41.6569 64.6569 43 63 43H5C3.34315 43 2 41.6569 2 40V4Z", fill: "#E5E5E5", fillOpacity: "0.01" })
  ] }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("defs", { children: /* @__PURE__ */ jsxRuntimeExports.jsxs("filter", { id: "filter0_dd_1_1127", x: "0", y: "0", width: "68", height: "46", filterUnits: "userSpaceOnUse", colorInterpolationFilters: "sRGB", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("feFlood", { floodOpacity: "0", result: "BackgroundImageFix" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("feColorMatrix", { in: "SourceAlpha", type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0", result: "hardAlpha" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("feOffset", { dy: "1" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("feGaussianBlur", { stdDeviation: "1" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("feComposite", { in2: "hardAlpha", operator: "out" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("feColorMatrix", { type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("feBlend", { mode: "normal", in2: "BackgroundImageFix", result: "effect1_dropShadow_1_1127" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("feColorMatrix", { in: "SourceAlpha", type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0", result: "hardAlpha" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("feOffset", {}),
    /* @__PURE__ */ jsxRuntimeExports.jsx("feGaussianBlur", { stdDeviation: "0.5" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("feColorMatrix", { type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("feBlend", { mode: "normal", in2: "effect1_dropShadow_1_1127", result: "effect2_dropShadow_1_1127" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("feBlend", { mode: "normal", in: "SourceGraphic", in2: "effect2_dropShadow_1_1127", result: "shape" })
  ] }) })
] }));
MastercardLogoLarge.displayName = "MastercardLogoLarge";
const MastercardLogoSmall = forwardRef((props, ref2) => /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { width: "36", height: "25", viewBox: "0 0 36 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img", "aria-label": "Mastercard Logo Small ", ...props, ref: ref2, children: [
  /* @__PURE__ */ jsxRuntimeExports.jsxs("g", { filter: "url(#filter0_dd_1_1046)", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("title", { children: "Mastercard Logo Small " }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2 2.5C2 1.67157 2.67157 1 3.5 1H32.5C33.3284 1 34 1.67157 34 2.5V20.5C34 21.3284 33.3284 22 32.5 22H3.5C2.67157 22 2 21.3284 2 20.5V2.5Z", fill: "#F4F6F7" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14.5 17C17.5376 17 20 14.5376 20 11.5C20 8.46243 17.5376 6 14.5 6C11.4624 6 9 8.46243 9 11.5C9 14.5376 11.4624 17 14.5 17Z", fill: "#D8232A" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M18 15.7428C18.9509 16.5282 20.1704 17 21.5 17C24.5376 17 27 14.5376 27 11.5C27 8.46243 24.5376 6 21.5 6C20.1704 6 18.9509 6.47182 18 7.25716C19.2215 8.26595 20 9.79206 20 11.5C20 13.2079 19.2215 14.734 18 15.7428Z", fill: "#ED9F2D" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M18 7.25716C16.7785 8.26596 16 9.79206 16 11.5C16 13.2079 16.7785 14.734 18 15.7428C19.2215 14.734 20 13.2079 20 11.5C20 9.79206 19.2215 8.26596 18 7.25716Z", fill: "#D8232A" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("mask", { id: "mask0_1_1046", maskUnits: "userSpaceOnUse", x: "16", y: "7", width: "4", height: "9", children: /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M18 7.25716C16.7785 8.26596 16 9.79206 16 11.5C16 13.2079 16.7785 14.734 18 15.7428C19.2215 14.734 20 13.2079 20 11.5C20 9.79206 19.2215 8.26596 18 7.25716Z", fill: "white" }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("g", { mask: "url(#mask0_1_1046)", children: /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15 8H21V9H15V8ZM15 10H21V11H15V10ZM21 12H15V13H21V12ZM15 14H21V15H15V14ZM21 16H15V17H21V16Z", fill: "#ED9F2D" }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2 2.5C2 1.67157 2.67157 1 3.5 1H32.5C33.3284 1 34 1.67157 34 2.5V20.5C34 21.3284 33.3284 22 32.5 22H3.5C2.67157 22 2 21.3284 2 20.5V2.5Z", fill: "#E5E5E5", fillOpacity: "0.01" })
  ] }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("defs", { children: /* @__PURE__ */ jsxRuntimeExports.jsxs("filter", { id: "filter0_dd_1_1046", x: "0", y: "0", width: "36", height: "25", filterUnits: "userSpaceOnUse", colorInterpolationFilters: "sRGB", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("feFlood", { floodOpacity: "0", result: "BackgroundImageFix" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("feColorMatrix", { in: "SourceAlpha", type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0", result: "hardAlpha" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("feOffset", { dy: "1" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("feGaussianBlur", { stdDeviation: "1" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("feComposite", { in2: "hardAlpha", operator: "out" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("feColorMatrix", { type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("feBlend", { mode: "normal", in2: "BackgroundImageFix", result: "effect1_dropShadow_1_1046" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("feColorMatrix", { in: "SourceAlpha", type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0", result: "hardAlpha" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("feOffset", {}),
    /* @__PURE__ */ jsxRuntimeExports.jsx("feGaussianBlur", { stdDeviation: "0.5" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("feColorMatrix", { type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("feBlend", { mode: "normal", in2: "effect1_dropShadow_1_1046", result: "effect2_dropShadow_1_1046" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("feBlend", { mode: "normal", in: "SourceGraphic", in2: "effect2_dropShadow_1_1046", result: "shape" })
  ] }) })
] }));
MastercardLogoSmall.displayName = "MastercardLogoSmall";
const MedBenefitsIllustration = forwardRef((props, ref2) => /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { width: "56", height: "56", viewBox: "0 0 56 56", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img", "aria-label": "Med Benefits Illustration ", ...props, ref: ref2, children: [
  /* @__PURE__ */ jsxRuntimeExports.jsx("title", { children: "Med Benefits Illustration " }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M24.372 2.60644C25.9322 2.07354 27.5922 1.89828 29.2292 2.09365C30.8663 2.28902 32.4384 2.85001 33.8293 3.73511C34.0623 3.88336 34.3713 3.81468 34.5196 3.58171C34.6678 3.34874 34.5992 3.03969 34.3662 2.89144C32.8488 1.92585 31.1336 1.31384 29.3477 1.1007C27.5618 0.887562 25.7508 1.07875 24.0488 1.66013C22.3468 2.2415 20.7972 3.19817 19.5149 4.45934C18.2326 5.72052 17.2503 7.2539 16.6407 8.94603C16.5471 9.20583 16.6818 9.49231 16.9416 9.58591C17.2014 9.6795 17.4879 9.54477 17.5815 9.28497C18.1403 7.7339 19.0407 6.32834 20.2161 5.17231C21.3915 4.01627 22.8119 3.13935 24.372 2.60644ZM41.7469 3.19314C41.9421 3.3884 41.9421 3.70498 41.7469 3.90025L28.2757 17.3714L27.9222 17.7249L27.5686 17.3714L22.2797 12.0825C22.0845 11.8872 22.0845 11.5706 22.2797 11.3754C22.475 11.1801 22.7916 11.1801 22.9869 11.3754L27.9222 16.3107L41.0397 3.19314C41.235 2.99788 41.5516 2.99788 41.7469 3.19314ZM28 29.0711C28.2761 29.0711 28.5 29.295 28.5 29.5711V39.6562C30.6933 38.6292 32.2553 37.8882 33.31 36.9864C33.8728 36.5051 34.2754 35.9888 34.5416 35.3703C34.809 34.7491 34.9507 33.9968 34.951 33.0277C34.936 31.8969 34.6421 30.7873 34.0956 29.7972C33.9621 29.5555 34.0499 29.2513 34.2916 29.1178C34.5334 28.9844 34.8375 29.0721 34.971 29.3139C35.5977 30.4491 35.9343 31.7214 35.951 33.018L35.9511 33.0244C35.951 34.0915 35.7953 34.9871 35.4602 35.7657C35.1236 36.5477 34.6182 37.1834 33.9599 37.7464C32.7706 38.7633 31.0318 39.5764 28.8234 40.6091L28.5 40.7603V54.3667C28.5 54.6428 28.2761 54.8667 28 54.8667C27.7239 54.8667 27.5 54.6428 27.5 54.3667V41.2174C26.2575 41.7872 25.1112 42.3588 24.223 43.0835C23.1809 43.9337 22.5266 44.9682 22.5266 46.4489V46.4533C22.5143 47.8486 23.0236 49.1981 23.9546 50.2375C24.1388 50.4432 24.1215 50.7593 23.9158 50.9435C23.7101 51.1278 23.394 51.1104 23.2097 50.9047C22.1129 49.6802 21.5127 48.0904 21.5266 46.4467C21.5273 44.5997 22.3739 43.3015 23.5908 42.3087C24.6875 41.414 26.1106 40.747 27.5 40.1185V29.5711C27.5 29.295 27.7239 29.0711 28 29.0711ZM39.3795 14.4874C39.41 14.4927 39.4393 14.5007 39.4674 14.511H54.4446H54.9445L54.9446 15.011C54.9446 15.9519 54.758 16.8835 54.3954 17.7518C54.0328 18.62 53.5015 19.4077 52.8323 20.0691C52.1631 20.7306 51.3692 21.2526 50.4968 21.605C49.7951 21.8884 49.0539 22.0576 48.3011 22.1072C48.2487 22.873 48.0722 23.6264 47.7776 24.3375C47.421 25.1984 46.8984 25.9806 46.2395 26.6395C45.5806 27.2984 44.7984 27.821 43.9375 28.1776C43.0767 28.5342 42.154 28.7177 41.2222 28.7177H39.2C38.9238 28.7177 38.7 28.4939 38.7 28.2177C38.7 27.9416 38.9238 27.7177 39.2 27.7177H41.2222C42.0227 27.7177 42.8153 27.5601 43.5548 27.2537C44.2944 26.9474 44.9664 26.4984 45.5324 25.9324C46.0984 25.3663 46.5474 24.6944 46.8537 23.9548C47.0961 23.3697 47.2454 22.7513 47.2972 22.1222H43.5555L43.5535 22.1222H42.0001C41.724 22.1222 41.5001 21.8983 41.5001 21.6222C41.5001 21.346 41.724 21.1222 42.0001 21.1222H47.7557H47.7616L47.8177 21.1222H47.9079C48.6668 21.1129 49.4178 20.9624 50.1223 20.6778C50.872 20.375 51.5542 19.9263 52.1293 19.3579C52.7044 18.7895 53.161 18.1126 53.4726 17.3664C53.7198 16.7745 53.8718 16.1483 53.9241 15.511H39.6995C39.1436 18.1083 37.7377 20.4515 35.6978 22.1659C33.542 23.9777 30.8162 24.971 28.0001 24.971C25.1841 24.971 22.4583 23.9777 20.3025 22.1659C18.2625 20.4515 16.8567 18.1083 16.3007 15.511H2.15377C2.27174 16.9487 2.89559 18.3046 3.9232 19.3323C5.06926 20.4783 6.62364 21.1222 8.24441 21.1222H14C14.2761 21.1222 14.5 21.346 14.5 21.6222C14.5 21.8983 14.2761 22.1222 14 22.1222H12.5242L12.5222 22.1222H8.78054C8.89847 23.5557 9.52066 24.9077 10.5454 25.9324C11.6885 27.0755 13.2389 27.7177 14.8556 27.7177H16.8778C17.1539 27.7177 17.3778 27.9416 17.3778 28.2177C17.3778 28.4939 17.1539 28.7177 16.8778 28.7177H14.8556C12.9737 28.7177 11.1689 27.9702 9.83825 26.6395C8.62226 25.4235 7.8932 23.8116 7.77656 22.1068C6.06141 21.9937 4.43899 21.2623 3.2161 20.0394C1.88251 18.7058 1.1333 16.897 1.1333 15.011V14.511H1.6333H16.5329C16.5609 14.5007 16.5902 14.4927 16.6207 14.4874C16.8927 14.4398 17.1518 14.6218 17.1993 14.8939C17.6435 17.436 18.9702 19.74 20.9458 21.4004C22.9215 23.0607 25.4194 23.971 28.0001 23.971C30.5808 23.971 33.0788 23.0607 35.0544 21.4004C37.03 19.74 38.3567 17.436 38.8009 14.8939C38.8484 14.6218 39.1075 14.4398 39.3795 14.4874ZM21.9379 29.7929C22.069 29.5499 21.9782 29.2466 21.7352 29.1155C21.4921 28.9844 21.1888 29.0751 21.0577 29.3182C20.2339 30.8454 19.9355 32.6013 20.2086 34.3149C20.4817 36.0285 21.3111 37.6047 22.5689 38.8002C22.769 38.9904 23.0855 38.9824 23.2758 38.7822C23.466 38.5821 23.458 38.2656 23.2578 38.0753C22.1592 37.0311 21.4347 35.6544 21.1962 34.1575C20.9576 32.6607 21.2182 31.1269 21.9379 29.7929ZM33.3396 42.6606C33.1804 42.435 32.8684 42.3812 32.6428 42.5404C32.4172 42.6997 32.3634 43.0117 32.5226 43.2373C33.1853 44.1762 33.5393 45.2981 33.5355 46.4473L33.5355 46.4533C33.5478 47.8486 33.0386 49.1982 32.1075 50.2375C31.9233 50.4432 31.9407 50.7593 32.1464 50.9436C32.3521 51.1278 32.6682 51.1105 32.8524 50.9048C33.9491 49.6805 34.5492 48.091 34.5355 46.4476C34.5393 45.0918 34.1214 43.7684 33.3396 42.6606Z", fill: "#0B3541" })
] }));
MedBenefitsIllustration.displayName = "MedBenefitsIllustration";
const MobileIllustration = forwardRef((props, ref2) => /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { width: "56", height: "56", viewBox: "0 0 56 56", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img", "aria-label": "Mobile Illustration ", ...props, ref: ref2, children: [
  /* @__PURE__ */ jsxRuntimeExports.jsx("title", { children: "Mobile Illustration " }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15.9574 2.50002C15.1324 2.50002 14.4998 3.13263 14.4998 3.95766V8.10707H42.4974V3.95766C42.4974 3.13263 41.8648 2.50002 41.0398 2.50002H15.9574ZM14.4998 47.1377V9.10707H42.4974V47.1377H14.4998ZM14.4998 48.1377V52.0424C14.4998 52.8674 15.1324 53.5 15.9574 53.5H41.0398C41.8648 53.5 42.4974 52.8674 42.4974 52.0424V48.1377H14.4998ZM13.4998 3.95766C13.4998 2.58034 14.5801 1.50002 15.9574 1.50002H41.0398C42.4171 1.50002 43.4974 2.58034 43.4974 3.95766V52.0424C43.4974 53.4197 42.4171 54.5 41.0398 54.5H15.9574C14.5801 54.5 13.4998 53.4197 13.4998 52.0424V3.95766ZM22.7989 5.3036C22.7989 5.02746 23.0227 4.8036 23.2989 4.8036H28.9271C29.2032 4.8036 29.4271 5.02746 29.4271 5.3036C29.4271 5.57975 29.2032 5.8036 28.9271 5.8036H23.2989C23.0227 5.8036 22.7989 5.57975 22.7989 5.3036ZM33.8635 5.32472C33.8635 5.87701 33.4158 6.32472 32.8635 6.32472C32.3112 6.32472 31.8635 5.87701 31.8635 5.32472C31.8635 4.77244 32.3112 4.32472 32.8635 4.32472C33.4158 4.32472 33.8635 4.77244 33.8635 5.32472ZM27.6927 27.8164C27.6927 27.5403 27.9166 27.3164 28.1927 27.3164H37.6139C37.89 27.3164 38.1139 27.5403 38.1139 27.8164C38.1139 28.0926 37.89 28.3164 37.6139 28.3164H28.1927C27.9166 28.3164 27.6927 28.0926 27.6927 27.8164ZM20.006 18.273C20.006 17.0625 20.9872 16.0812 22.1977 16.0812C23.4082 16.0812 24.3895 17.0625 24.3895 18.273C24.3895 19.4834 23.4082 20.4647 22.1977 20.4647C20.9872 20.4647 20.006 19.4834 20.006 18.273ZM22.1977 15.0812C20.435 15.0812 19.006 16.5102 19.006 18.273C19.006 20.0357 20.435 21.4647 22.1977 21.4647C23.9605 21.4647 25.3895 20.0357 25.3895 18.273C25.3895 16.5102 23.9605 15.0812 22.1977 15.0812ZM22.1977 25.6248C20.9872 25.6248 20.006 26.6061 20.006 27.8165C20.006 29.027 20.9872 30.0083 22.1977 30.0083C23.4082 30.0083 24.3895 29.027 24.3895 27.8165C24.3895 26.6061 23.4082 25.6248 22.1977 25.6248ZM19.006 27.8165C19.006 26.0538 20.435 24.6248 22.1977 24.6248C23.9605 24.6248 25.3895 26.0538 25.3895 27.8165C25.3895 29.5793 23.9605 31.0083 22.1977 31.0083C20.435 31.0083 19.006 29.5793 19.006 27.8165ZM28.1927 17.773C27.9166 17.773 27.6927 17.9968 27.6927 18.273C27.6927 18.5491 27.9166 18.773 28.1927 18.773H37.6139C37.89 18.773 38.1139 18.5491 38.1139 18.273C38.1139 17.9968 37.89 17.773 37.6139 17.773H28.1927Z", fill: "#0B3541" }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M23.0541 18.273C23.0541 18.746 22.6706 19.1295 22.1976 19.1295C21.7246 19.1295 21.3412 18.746 21.3412 18.273C21.3412 17.8 21.7246 17.4165 22.1976 17.4165C22.6706 17.4165 23.0541 17.8 23.0541 18.273ZM20.8615 37.1153C20.8615 37.0332 20.9076 36.9093 21.021 36.7959C21.1343 36.6826 21.2583 36.6365 21.3404 36.6365H35.9004C35.9825 36.6365 36.1064 36.6826 36.2197 36.7959C36.3331 36.9093 36.3792 37.0332 36.3792 37.1153V40.6635C36.3792 40.7456 36.3331 40.8696 36.2197 40.9829C36.1064 41.0963 35.9825 41.1424 35.9004 41.1424H21.3404C21.2583 41.1424 21.1343 41.0963 21.021 40.9829C20.9076 40.8696 20.8615 40.7456 20.8615 40.6635V37.1153ZM21.3404 35.6365C20.933 35.6365 20.5676 35.8351 20.3139 36.0888C20.0602 36.3425 19.8615 36.708 19.8615 37.1153V40.6635C19.8615 41.0709 20.0602 41.4363 20.3139 41.69C20.5676 41.9437 20.933 42.1424 21.3404 42.1424H35.9004C36.3077 42.1424 36.6732 41.9437 36.9269 41.69C37.1806 41.4363 37.3792 41.0709 37.3792 40.6635V37.1153C37.3792 36.708 37.1806 36.3425 36.9269 36.0888C36.6732 35.8351 36.3077 35.6365 35.9004 35.6365H21.3404Z", fill: "#90AFAA" })
] }));
MobileIllustration.displayName = "MobileIllustration";
const NoMedExamIllustration = forwardRef((props, ref2) => /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { width: "56", height: "56", viewBox: "0 0 56 56", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img", "aria-label": "No Med Exam Illustration ", ...props, ref: ref2, children: [
  /* @__PURE__ */ jsxRuntimeExports.jsx("title", { children: "No Med Exam Illustration " }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M17.9235 18.6865C18.1188 18.8817 18.1188 19.1983 17.9235 19.3936L15.0635 22.2536C14.8683 22.4489 14.5517 22.4489 14.3564 22.2536C14.1612 22.0583 14.1612 21.7417 14.3564 21.5465L17.2164 18.6865C17.4117 18.4912 17.7283 18.4912 17.9235 18.6865ZM20.8836 21.6464C21.0788 21.8417 21.0788 22.1583 20.8836 22.3536L18.0236 25.2136C17.8283 25.4088 17.5117 25.4088 17.3165 25.2136C17.1212 25.0183 17.1212 24.7017 17.3165 24.5064L20.1765 21.6464C20.3717 21.4512 20.6883 21.4512 20.8836 21.6464ZM23.8431 25.3141C24.0387 25.1192 24.0392 24.8026 23.8443 24.607C23.6494 24.4114 23.3328 24.4109 23.1372 24.6058L20.2672 27.4658C20.0716 27.6607 20.071 27.9773 20.2659 28.1729C20.4609 28.3685 20.7775 28.3691 20.9731 28.1741L23.8431 25.3141ZM29.5048 30.2477C29.6994 30.4436 29.6983 30.7602 29.5023 30.9548L26.6223 33.8148C26.4264 34.0093 26.1098 34.0082 25.9152 33.8123C25.7207 33.6164 25.7218 33.2998 25.9177 33.1052L28.7977 30.2452C28.9936 30.0506 29.3102 30.0517 29.5048 30.2477ZM32.4442 33.903C32.6391 33.7074 32.6385 33.3908 32.4429 33.1959C32.2473 33.001 31.9307 33.0015 31.7358 33.1971L28.8758 36.0671C28.6809 36.2627 28.6814 36.5793 28.877 36.7742C29.0726 36.9691 29.3892 36.9686 29.5842 36.773L32.4442 33.903Z", fill: "#90AFAA" }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11.206 7.66696C16.0118 3.63814 22.1152 1.47352 28.397 1.58188C34.2514 1.68287 39.8828 3.75149 44.3973 7.42581L30.1905 22.6988L18.0429 10.5459L19.9337 8.65345C20.1289 8.4581 20.1287 8.14152 19.9334 7.94634C19.7381 7.75116 19.4215 7.7513 19.2263 7.94665L15.3577 11.8186L11.206 7.66696ZM10.4962 6.95723C15.4967 2.73747 21.862 0.469003 28.4143 0.582032C35.1183 0.697678 41.5406 3.29812 46.4364 7.87933C51.3323 12.4605 54.353 18.6962 54.913 25.3778C55.4731 32.0594 53.5326 38.7109 49.4676 44.0432C49.3002 44.2628 48.9865 44.3051 48.7669 44.1377C48.5473 43.9703 48.505 43.6565 48.6724 43.4369C52.5871 38.3017 54.4558 31.896 53.9165 25.4613C53.3772 19.0267 50.4681 13.0214 45.7532 8.60952C45.5584 8.42726 45.3611 8.24826 45.1614 8.07254L30.8979 23.4065L41.0836 33.5966L41.2288 33.7418L41.23 33.9472L41.2689 40.7617L51.0436 50.5364C51.2388 50.7317 51.2388 51.0483 51.0436 51.2435C50.8483 51.4388 50.5317 51.4388 50.3365 51.2435L40.5524 41.4594L33.7486 41.44L33.5422 41.4395L33.3963 41.2934L23.486 31.3747L9.77484 46.1148C13.9885 50.2595 19.496 52.857 25.3978 53.4605C31.6714 54.102 37.9648 52.4469 43.111 48.8019C43.3364 48.6423 43.6484 48.6956 43.808 48.921C43.9676 49.1463 43.9143 49.4584 43.689 49.618C38.3453 53.4028 31.8104 55.1214 25.2961 54.4553C18.7817 53.7891 12.73 50.7834 8.2629 45.9953C3.79581 41.2073 1.21649 34.9619 1.0032 28.4171C0.794867 22.0245 2.85761 15.7699 6.81697 10.7592L3.96132 7.90351L2.3438 9.52335C2.14867 9.71876 1.83209 9.71898 1.63669 9.52386C1.44129 9.32874 1.44106 9.01216 1.63618 8.81675L8.61618 1.82675C8.81131 1.63135 9.12789 1.63113 9.32329 1.82625C9.51869 2.02137 9.51892 2.33795 9.3238 2.53335L7.69924 4.16024L10.4962 6.95723ZM22.7787 30.6668L9.07474 45.3992L8.99408 45.3132C4.69208 40.7021 2.20808 34.6874 2.00267 28.3845C1.80331 22.2672 3.76339 16.2812 7.5291 11.4713L11.6127 15.5549L9.99696 17.166L9.64254 17.5194L9.6522 17.5291L7.70629 19.4766C7.51111 19.672 7.51125 19.9886 7.7066 20.1838C7.90194 20.3789 8.21853 20.3788 8.4137 20.1834L10.359 18.2365L22.7787 30.6668ZM12.3208 14.8488L7.88403 10.412C7.86166 10.3834 7.83582 10.3569 7.80656 10.3329L7.79859 10.3266L4.69884 7.22681L7.02522 4.90042L14.6478 12.523L12.7641 14.4068L12.3208 14.8488ZM24.1675 30.642L33.7501 40.2327L40.0279 33.9549L30.2164 24.1392L24.1675 30.642ZM29.509 23.4315L23.4603 29.9341L11.0658 17.529L15.531 13.06L17.3394 11.2567L29.509 23.4315ZM34.9536 40.4435L40.2671 40.4586L40.2369 35.1602L34.9536 40.4435Z", fill: "#0B3541" })
] }));
NoMedExamIllustration.displayName = "NoMedExamIllustration";
const PaymentCards = forwardRef((props, ref2) => /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { width: "159", height: "20", viewBox: "0 0 159 20", version: "1.1", xmlns: "http://www.w3.org/2000/svg", role: "img", "aria-label": "Visa, Mastercard, American Express, Discover, Diners Club", ...props, ref: ref2, children: [
  /* @__PURE__ */ jsxRuntimeExports.jsx("title", { children: "039EC250FB3D-4C9BA335-238B0DCCA453@1x" }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("defs", { children: /* @__PURE__ */ jsxRuntimeExports.jsxs("filter", { x: "-1.6%", y: "-13.7%", width: "103.2%", height: "127.3%", filterUnits: "objectBoundingBox", id: "filter1", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("feOffset", { dx: "1", dy: "1", in: "SourceAlpha", result: "shadowOffsetOuter1" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("feColorMatrix", { values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.12 0", type: "matrix", in: "shadowOffsetOuter1", result: "shadowMatrixOuter1" }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("feMerge", { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("feMergeNode", { in: "shadowMatrixOuter1" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("feMergeNode", { in: "SourceGraphic" })
    ] })
  ] }) }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("g", { id: "Symbols", stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd", children: /* @__PURE__ */ jsxRuntimeExports.jsx("g", { id: "Group3", filter: "url(#filter1)", children: /* @__PURE__ */ jsxRuntimeExports.jsx("image", { id: "IMG_16482", x: "0", y: "0", width: "158", height: "18.304878", xlinkHref: "data:image/png;base64,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" }) }) })
] }));
PaymentCards.displayName = "PaymentCards";
const ScholarshipsIllustration = forwardRef((props, ref2) => /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { width: "56", height: "56", viewBox: "0 0 56 56", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img", "aria-label": "Scholarships Illustration ", ...props, ref: ref2, children: [
  /* @__PURE__ */ jsxRuntimeExports.jsxs("g", { clipPath: "url(#clip0_1_960)", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("title", { children: "Scholarships Illustration " }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M41.34 12.7C40.5987 10.9492 39.514 9.36462 38.15 8.04C36.7817 6.71837 35.163 5.68367 33.389 4.99674C31.615 4.30981 29.7215 3.98452 27.82 4.04C25.2206 4.10629 22.6895 4.88603 20.5035 6.29396C18.3174 7.70189 16.5606 9.68379 15.4251 12.023C14.2896 14.3621 13.8191 16.9685 14.0651 19.557C14.3111 22.1456 15.2642 24.6166 16.82 26.7C18.8446 29.5455 19.8968 32.9685 19.82 36.46C19.8203 36.903 19.9086 37.3415 20.08 37.75C20.2494 38.1607 20.4973 38.5344 20.81 38.85C21.0464 39.089 21.32 39.2883 21.62 39.44V46.27C21.6222 46.6859 21.7874 47.0844 22.08 47.38C22.2251 47.5267 22.398 47.6429 22.5886 47.7219C22.7792 47.8009 22.9837 47.8411 23.19 47.84H23.72C23.8472 48.9363 24.3729 49.9476 25.197 50.6816C26.0212 51.4157 27.0863 51.8212 28.19 51.8212C29.2936 51.8212 30.3588 51.4157 31.183 50.6816C32.0071 49.9476 32.5328 48.9363 32.66 47.84H33.23C33.4408 47.8419 33.6504 47.808 33.85 47.74C34.0481 47.6641 34.2285 47.5484 34.38 47.4C34.5332 47.2522 34.6556 47.0754 34.74 46.88C34.82 46.6866 34.8608 46.4793 34.86 46.27V39.46C35.5931 39.1022 36.172 38.4912 36.49 37.74C36.6615 37.321 36.7498 36.8727 36.75 36.42C36.7026 32.9003 37.7779 29.4571 39.82 26.59C41.2374 24.5971 42.1228 22.2755 42.3922 19.8448C42.6617 17.4142 42.3064 14.955 41.36 12.7H41.34ZM30.7 49.78C30.0349 50.4198 29.1479 50.7772 28.225 50.7772C27.3021 50.7772 26.4151 50.4198 25.75 49.78C25.2057 49.2415 24.8542 48.5385 24.75 47.78H31.68C31.5902 48.5387 31.2445 49.2441 30.7 49.78ZM33.84 46.24C33.8504 46.313 33.8504 46.387 33.84 46.46C33.8085 46.5307 33.7645 46.595 33.71 46.65C33.6539 46.7004 33.5896 46.741 33.52 46.77C33.4374 46.7859 33.3526 46.7859 33.27 46.77H23.23C23.1552 46.7709 23.081 46.7563 23.0121 46.727C22.9433 46.6978 22.8813 46.6545 22.83 46.6C22.7893 46.5693 22.7581 46.5277 22.74 46.48L33.84 44.48V46.24ZM33.84 43.47L22.66 45.52V43.11L33.86 41.11L33.84 43.47ZM33.84 40.04L22.64 42.14V39.85H33.84V40.04ZM23.51 25.31C23.4495 24.9313 23.2709 24.5814 22.9997 24.3103C22.7286 24.0391 22.3787 23.8605 22 23.8L21.23 23.63L20.84 23.54C20.4957 23.4711 20.1603 23.3638 19.84 23.22C19.6373 23.1408 19.4726 22.9869 19.38 22.79C19.3057 22.59 19.3057 22.37 19.38 22.17C19.4902 21.8408 19.6378 21.5254 19.82 21.23L20.01 20.92C20.15 20.68 20.3 20.43 20.42 20.2C20.618 19.8578 20.7343 19.4745 20.76 19.08C20.7343 18.6855 20.618 18.3022 20.42 17.96C20.3 17.73 20.15 17.48 20.01 17.25L19.82 16.92C19.6341 16.6266 19.4863 16.3107 19.38 15.98C19.3 15.7707 19.3 15.5393 19.38 15.33C19.478 15.137 19.6409 14.9848 19.84 14.9C20.16 14.7554 20.4955 14.6481 20.84 14.58L21.23 14.49L21.97 14.32C22.3395 14.2329 22.6825 14.058 22.97 13.81C23.219 13.5232 23.394 13.1799 23.48 12.81C23.54 12.58 23.6 12.31 23.66 12.06L23.75 11.68C23.8151 11.336 23.9191 11.0005 24.06 10.68C24.1392 10.4773 24.2931 10.3126 24.49 10.22C24.6906 10.1491 24.9094 10.1491 25.11 10.22C25.4342 10.3386 25.7458 10.4893 26.04 10.67L26.34 10.84C26.58 10.99 26.83 11.14 27.07 11.26C27.4212 11.4766 27.8187 11.6068 28.23 11.64C28.6279 11.6158 29.0148 11.4994 29.36 11.3C29.6 11.18 29.85 11.02 30.1 10.88L30.4 10.7C30.6877 10.5165 30.9966 10.3688 31.32 10.26C31.52 10.1857 31.74 10.1857 31.94 10.26C32.1369 10.3526 32.2908 10.5173 32.37 10.72C32.5146 11.04 32.6219 11.3755 32.69 11.72C32.69 11.84 32.75 11.98 32.78 12.11C32.81 12.24 32.89 12.63 32.95 12.85C33.0336 13.2208 33.209 13.5646 33.46 13.85C33.7454 14.101 34.0892 14.2764 34.46 14.36L35.2 14.53L35.59 14.62C35.936 14.6872 36.272 14.7981 36.59 14.95C36.7841 15.0375 36.9453 15.1846 37.05 15.37C37.1249 15.5768 37.1249 15.8032 37.05 16.01C36.9398 16.3392 36.7922 16.6546 36.61 16.95L36.43 17.26C36.28 17.5 36.13 17.76 36.01 18C35.8105 18.3452 35.6941 18.7321 35.67 19.13C35.6956 19.5277 35.8119 19.9142 36.01 20.26C36.13 20.5 36.28 20.75 36.43 20.99C36.49 21.09 36.55 21.2 36.61 21.29C36.7938 21.581 36.9415 21.8933 37.05 22.22C37.1241 22.4235 37.1241 22.6465 37.05 22.85C36.9453 23.0354 36.7841 23.1825 36.59 23.27C36.27 23.4146 35.9345 23.5219 35.59 23.59L35.19 23.68L34.46 23.85C34.0927 23.9377 33.7505 24.1088 33.46 24.35C33.212 24.6375 33.0371 24.9805 32.95 25.35C32.89 25.58 32.83 25.84 32.77 26.1L32.68 26.48C32.6149 26.824 32.5109 27.1595 32.37 27.48C32.2908 27.6827 32.1369 27.8474 31.94 27.94C31.74 28.0143 31.52 28.0143 31.32 27.94C30.9966 27.8312 30.6877 27.6835 30.4 27.5L30.1 27.32C29.86 27.18 29.61 27.02 29.37 26.9C29.1698 26.7912 28.9586 26.7041 28.74 26.64V23.64C29.8857 23.5122 30.9389 22.9505 31.6834 22.0704C32.4279 21.1902 32.807 20.0584 32.743 18.9074C32.679 17.7564 32.1767 16.6736 31.3393 15.8814C30.5018 15.0892 29.3928 14.6478 28.24 14.6478C27.0872 14.6478 25.9782 15.0892 25.1407 15.8814C24.3033 16.6736 23.801 17.7564 23.737 18.9074C23.673 20.0584 24.0521 21.1902 24.7966 22.0704C25.5411 22.9505 26.5943 23.5122 27.74 23.64V26.64C27.5214 26.7041 27.3102 26.7912 27.11 26.9C26.87 27.02 26.62 27.18 26.37 27.32L26.07 27.5C25.7823 27.6835 25.4734 27.8312 25.15 27.94C24.95 28.0143 24.73 28.0143 24.53 27.94C24.3331 27.8474 24.1792 27.6827 24.1 27.48C23.9554 27.16 23.8481 26.8245 23.78 26.48L23.69 26.09C23.63 25.8 23.57 25.53 23.51 25.31ZM28.23 22.59C27.5358 22.59 26.8572 22.3841 26.2799 21.9985C25.7027 21.6128 25.2528 21.0646 24.9872 20.4232C24.7215 19.7818 24.652 19.0761 24.7874 18.3952C24.9229 17.7144 25.2572 17.0889 25.7481 16.5981C26.2389 16.1072 26.8644 15.7729 27.5452 15.6374C28.2261 15.502 28.9318 15.5715 29.5732 15.8372C30.2146 16.1028 30.7628 16.5527 31.1485 17.1299C31.5341 17.7072 31.74 18.3858 31.74 19.08C31.74 20.0109 31.3702 20.9037 30.7119 21.5619C30.0537 22.2202 29.1609 22.59 28.23 22.59ZM38.98 26.01C36.8204 29.0515 35.6824 32.7001 35.73 36.43C35.7366 36.7487 35.6769 37.0652 35.5547 37.3596C35.4324 37.654 35.2504 37.9197 35.02 38.14C34.7975 38.3662 34.5277 38.5404 34.23 38.65C33.9661 38.7571 33.6847 38.8148 33.4 38.82H28.73V27.61L28.9 27.7L29.55 28.07L29.89 28.27C30.2466 28.4958 30.6294 28.6771 31.03 28.81C31.4584 28.9726 31.9337 28.9586 32.3518 28.7711C32.7699 28.5837 33.0965 28.238 33.26 27.81C33.4364 27.4291 33.5705 27.0301 33.66 26.62C33.66 26.47 33.72 26.32 33.76 26.18C33.8 26.04 33.85 25.73 33.91 25.53C33.9503 25.3269 34.0357 25.1356 34.16 24.97C34.3287 24.8447 34.5235 24.7592 34.73 24.72C34.94 24.66 35.14 24.62 35.37 24.57L35.83 24.46C36.2413 24.3751 36.6409 24.2408 37.02 24.06C37.4463 23.8943 37.7903 23.5675 37.9774 23.1501C38.1646 22.7328 38.1799 22.2585 38.02 21.83C37.8871 21.4294 37.7058 21.0466 37.48 20.69L37.28 20.34C37.14 20.11 37.02 19.91 36.91 19.7C36.7851 19.4962 36.7066 19.2675 36.68 19.03C36.7074 18.7895 36.7858 18.5577 36.91 18.35C37.02 18.14 37.14 17.93 37.28 17.7L37.48 17.35C37.7058 16.9899 37.8871 16.6037 38.02 16.2C38.1744 15.777 38.1744 15.313 38.02 14.89C37.8328 14.4776 37.5024 14.1472 37.09 13.96C36.7094 13.7804 36.3104 13.6429 35.9 13.55L35.44 13.45L34.8 13.29C34.5962 13.2478 34.4026 13.1663 34.23 13.05C34.1137 12.8774 34.0322 12.6838 33.99 12.48C33.93 12.28 33.88 12.07 33.83 11.84C33.83 11.7 33.77 11.55 33.73 11.39C33.6451 10.9787 33.5108 10.5791 33.33 10.2C33.1569 9.78107 32.8262 9.44682 32.4092 9.26916C31.9922 9.0915 31.5221 9.08462 31.1 9.25C30.6994 9.38289 30.3166 9.56423 29.96 9.79L29.62 9.99L28.97 10.36C28.7662 10.4849 28.5375 10.5634 28.3 10.59C28.0625 10.5634 27.8338 10.4849 27.63 10.36C27.42 10.26 27.21 10.13 26.98 10L26.64 9.79C26.2809 9.5714 25.8986 9.39363 25.5 9.26C25.0779 9.09462 24.6078 9.1015 24.1908 9.27916C23.7738 9.45682 23.4431 9.79107 23.27 10.21C23.0922 10.5903 22.958 10.9895 22.87 11.4C22.87 11.55 22.8 11.7 22.77 11.83C22.74 11.96 22.68 12.28 22.62 12.49C22.5763 12.695 22.4913 12.889 22.37 13.06C22.1998 13.1806 22.0052 13.2625 21.8 13.3L21.16 13.46L20.7 13.56C20.2887 13.6449 19.8891 13.7792 19.51 13.96C19.0948 14.1481 18.7636 14.4828 18.58 14.9C18.4249 15.3263 18.4249 15.7937 18.58 16.22C18.7129 16.6237 18.8942 17.0099 19.12 17.37C19.19 17.51 19.27 17.63 19.34 17.75C19.41 17.87 19.59 18.17 19.69 18.37C19.8132 18.5709 19.8916 18.796 19.92 19.03C19.8916 19.264 19.8132 19.4891 19.69 19.69C19.59 19.89 19.46 20.1 19.33 20.32C19.2 20.54 19.19 20.55 19.12 20.68C18.8942 21.0401 18.7129 21.4263 18.58 21.83C18.483 22.0379 18.4284 22.2629 18.4192 22.4921C18.41 22.7213 18.4465 22.95 18.5265 23.165C18.6065 23.38 18.7285 23.5769 18.8853 23.7442C19.0422 23.9116 19.2307 24.0462 19.44 24.14C19.8191 24.3208 20.2187 24.4551 20.63 24.54L21.08 24.64C21.31 24.69 21.53 24.74 21.73 24.8C21.9338 24.8422 22.1274 24.9237 22.3 25.04C22.4163 25.2126 22.4978 25.4062 22.54 25.61C22.6 25.81 22.65 26.02 22.7 26.25C22.75 26.48 22.76 26.54 22.8 26.7C22.8849 27.1113 23.0192 27.5109 23.2 27.89C23.3635 28.318 23.6901 28.6637 24.1082 28.8511C24.5263 29.0386 25.0016 29.0526 25.43 28.89C25.8306 28.7571 26.2134 28.5758 26.57 28.35L26.91 28.15L27.56 27.78L27.73 27.69V38.8H23.23C22.9209 38.8011 22.6149 38.7399 22.33 38.62C22.0421 38.5026 21.7804 38.3293 21.56 38.11C21.3382 37.8921 21.1621 37.6322 21.0419 37.3455C20.9217 37.0587 20.8599 36.7509 20.86 36.44C20.9266 32.729 19.7938 29.0956 17.63 26.08C15.8887 23.7491 14.9644 20.9093 15 18C15.0961 14.6082 16.4763 11.3794 18.8617 8.96626C21.247 6.55308 24.4596 5.13548 27.85 5C29.6188 4.95135 31.3794 5.25719 33.0281 5.89951C34.6768 6.54182 36.1803 7.50762 37.45 8.74C38.7187 9.97305 39.7265 11.4485 40.4137 13.0788C41.1008 14.7091 41.4532 16.4608 41.45 18.23C41.4798 21.0207 40.6141 23.7475 38.98 26.01Z", fill: "#0B3541" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M28.23 18C28.0164 18 27.8076 18.0633 27.63 18.182C27.4524 18.3007 27.3139 18.4694 27.2322 18.6667C27.1505 18.864 27.1291 19.0812 27.1707 19.2907C27.2124 19.5002 27.3153 19.6926 27.4663 19.8437C27.6174 19.9947 27.8098 20.0976 28.0193 20.1392C28.2288 20.1809 28.4459 20.1595 28.6433 20.0778C28.8406 19.996 29.0093 19.8576 29.128 19.68C29.2467 19.5024 29.31 19.2936 29.31 19.08C29.31 18.7936 29.1962 18.5189 28.9937 18.3163C28.7911 18.1138 28.5164 18 28.23 18Z", fill: "#0B3541" })
  ] }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("defs", { children: /* @__PURE__ */ jsxRuntimeExports.jsx("clipPath", { id: "clip0_1_960", children: /* @__PURE__ */ jsxRuntimeExports.jsx("rect", { width: "28.46", height: "47.81", fill: "white", transform: "translate(14 4)" }) }) })
] }));
ScholarshipsIllustration.displayName = "ScholarshipsIllustration";
const SnackIllustration = forwardRef((props, ref2) => /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { width: "56", height: "56", viewBox: "0 0 56 56", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img", "aria-label": "Snack Illustration ", ...props, ref: ref2, children: [
  /* @__PURE__ */ jsxRuntimeExports.jsx("title", { children: "Snack Illustration " }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M36.85 16.26L37.2 15.91L41.2 11.91C41.7646 11.3363 42.143 10.6057 42.2857 9.81354C42.4284 9.02141 42.3288 8.20464 42 7.46999C41.7901 6.9641 41.4767 6.50767 41.08 6.12999L40.48 5.63999C39.3995 4.56244 38.1744 3.64029 36.84 2.89999C36.7822 2.86848 36.7188 2.84865 36.6534 2.84164C36.5879 2.83464 36.5217 2.84059 36.4586 2.85916C36.3954 2.87773 36.3366 2.90856 36.2853 2.94988C36.2341 2.99121 36.1915 3.04221 36.16 3.09999C36.1285 3.15778 36.1087 3.2212 36.1017 3.28664C36.0946 3.35209 36.1006 3.41827 36.1192 3.48142C36.1377 3.54456 36.1686 3.60343 36.2099 3.65466C36.2512 3.70589 36.3022 3.74848 36.36 3.77999C37.6414 4.47982 38.8165 5.35865 39.85 6.38999L40.46 6.87999C40.745 7.16556 40.9695 7.50567 41.12 7.87999C41.2785 8.24618 41.3603 8.64097 41.3603 9.04C41.3603 9.43902 41.2785 9.83381 41.12 10.2C40.9665 10.5752 40.7386 10.9153 40.45 11.2L36.45 15.2L33.68 12.47C32.1628 10.9561 30.3617 9.75654 28.38 8.93999C26.3956 8.1197 24.2672 7.70489 22.12 7.71999C19.977 7.72743 17.8567 8.15892 15.8813 8.9896C13.9058 9.82029 12.1143 11.0337 10.61 12.56C10.35 12.81 10.1 13.08 9.86 13.36C7.16284 16.5946 5.80032 20.7358 6.05 24.94C6.05 25.32 6.11 25.7 6.16 26.08C5.64574 25.9993 5.15292 25.8161 4.71073 25.5414C4.26855 25.2668 3.88599 24.9061 3.58572 24.4809C3.28545 24.0557 3.07358 23.5745 2.96266 23.0659C2.85175 22.5573 2.84404 22.0316 2.94 21.52C3.08784 20.7632 3.45672 20.0672 4 19.52L4.34 19.23L4.1 18.86C3.72626 18.3073 3.50545 17.6656 3.46 17C3.41827 16.31 3.55608 15.6209 3.86 15C4.16422 14.3903 4.62212 13.8704 5.18853 13.4916C5.75495 13.1128 6.41031 12.8883 7.09 12.84L7.82 12.79L7.51 12.13C7.18058 11.411 7.07937 10.6083 7.22 9.83C7.34564 9.03948 7.71642 8.3084 8.28 7.73999C8.84054 7.18197 9.55393 6.80266 10.33 6.64999C11.1095 6.50297 11.9154 6.59716 12.64 6.91999L13.3 7.20999V6.48999C13.3568 5.45872 13.8204 4.49209 14.589 3.80219C15.3577 3.11229 16.3686 2.75546 17.4 2.80999C18.1155 2.8459 18.8073 3.07767 19.4 3.47999L19.83 3.77999L20.11 3.32999C20.4724 2.76695 20.9757 2.30846 21.57 1.99999C22.1634 1.68412 22.8279 1.52574 23.5 1.53999C24.1723 1.55872 24.8279 1.75322 25.4016 2.10411C25.9753 2.45501 26.4471 2.95007 26.77 3.53999L26.99 3.93999L27.41 3.75999C28.3557 3.34675 29.4267 3.3252 30.3882 3.70008C31.3498 4.07496 32.1236 4.81569 32.54 5.75999C32.7688 6.27943 32.8814 6.84253 32.87 7.40999V8.08999L33.52 7.89999C34.1704 7.70595 34.8607 7.68869 35.52 7.84999C36.1909 8.02114 36.8048 8.36605 37.3 8.85C37.3449 8.89783 37.3991 8.93595 37.4593 8.96201C37.5195 8.98807 37.5844 9.00151 37.65 9.00151C37.7156 9.00151 37.7805 8.98807 37.8407 8.96201C37.9009 8.93595 37.9551 8.89783 38 8.85C38.0469 8.80351 38.0841 8.74821 38.1094 8.68728C38.1348 8.62635 38.1479 8.561 38.1479 8.49499C38.1479 8.42899 38.1348 8.36364 38.1094 8.30271C38.0841 8.24178 38.0469 8.18648 38 8.14C37.3799 7.5266 36.6062 7.09138 35.76 6.87999C35.1225 6.71864 34.4585 6.6914 33.81 6.79999C33.7293 6.07347 33.4873 5.37414 33.1019 4.75304C32.7164 4.13195 32.1971 3.60476 31.5819 3.20995C30.9667 2.81514 30.2711 2.56269 29.5459 2.471C28.8206 2.37931 28.0841 2.45072 27.39 2.67999C26.9954 2.1038 26.4844 1.61667 25.89 1.24999C25.1655 0.809643 24.3376 0.568187 23.49 0.549995C22.6435 0.530124 21.8063 0.729952 21.06 1.12999C20.4782 1.44605 19.9677 1.87833 19.56 2.39999C18.9266 2.05061 18.2224 1.84892 17.5 1.80999C16.3115 1.7442 15.1398 2.11418 14.2045 2.85057C13.2693 3.58697 12.6348 4.6392 12.42 5.80999C11.6803 5.58815 10.8976 5.55038 10.14 5.69999C9.158 5.88817 8.25708 6.37225 7.55816 7.08726C6.85924 7.80226 6.39578 8.71397 6.23 9.7C6.10167 10.4574 6.14958 11.2341 6.37 11.97C5.6508 12.1129 4.97358 12.4177 4.38969 12.8612C3.80579 13.3048 3.33055 13.8755 3 14.53C2.61137 15.2935 2.42542 16.144 2.46 17C2.51539 17.7004 2.71634 18.3816 3.05 19C2.50009 19.6739 2.13788 20.4812 2 21.34C1.87465 22.0055 1.8892 22.6898 2.04271 23.3494C2.19623 24.009 2.48535 24.6295 2.89168 25.1712C3.29801 25.713 3.81267 26.1643 4.40289 26.4963C4.99312 26.8284 5.646 27.034 6.32 27.1C6.95104 30.4952 8.62961 33.6076 11.12 36C11.5226 36.4061 12.0015 36.7284 12.5293 36.9483C13.0571 37.1683 13.6232 37.2815 14.195 37.2815C14.7668 37.2815 15.3329 37.1683 15.8607 36.9483C16.3885 36.7284 16.8674 36.4061 17.27 36L36.85 16.26ZM16.56 35.33C15.9206 35.9378 15.0722 36.2767 14.19 36.2767C13.3078 36.2767 12.4594 35.9378 11.82 35.33C8.95901 32.5844 7.24695 28.855 7.02977 24.8957C6.81259 20.9363 8.10649 17.0421 10.65 14C10.88 13.75 11.11 13.5 11.36 13.25C14.2229 10.3705 18.1095 8.74179 22.17 8.72H22.23C24.2098 8.72491 26.1696 9.11552 28 9.87C29.8665 10.6323 31.5653 11.7535 33 13.17L35.76 15.91L16.56 35.33Z", fill: "#0B3541" }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M14.17 29.14C14.039 29.2701 13.9496 29.4362 13.9133 29.6173C13.877 29.7983 13.8955 29.986 13.9663 30.1566C14.037 30.3271 14.157 30.4727 14.3108 30.5748C14.4646 30.6769 14.6454 30.731 14.83 30.73C15.0757 30.7242 15.3107 30.628 15.49 30.46C15.6634 30.2841 15.7607 30.047 15.7607 29.8C15.7607 29.553 15.6634 29.3159 15.49 29.14C15.3075 28.9797 15.0729 28.8913 14.83 28.8913C14.5871 28.8913 14.3525 28.9797 14.17 29.14Z", fill: "#0B3541" }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M52.55 35.59C50.847 32.4273 47.9675 30.0619 44.5342 29.0055C41.1009 27.9491 37.3898 28.2866 34.2034 29.9448C31.0169 31.6031 28.6112 34.4489 27.5065 37.867C26.4018 41.285 26.6868 45.0005 28.3 48.21C28.4262 48.4521 28.6358 48.6404 28.89 48.74C29.1498 48.8451 29.4402 48.8451 29.7 48.74C30.2058 48.4977 30.7592 48.3713 31.32 48.37C32.0686 48.3676 32.8029 48.5753 33.4393 48.9695C34.0757 49.3637 34.5887 49.9287 34.92 50.6C35.0383 50.8444 35.2459 51.0342 35.5 51.13C35.6374 51.1892 35.7854 51.2197 35.935 51.2197C36.0846 51.2197 36.2326 51.1892 36.37 51.13C36.9872 50.8123 37.6764 50.6606 38.37 50.69C39.404 50.7359 40.3812 51.176 41.101 51.9199C41.8207 52.6638 42.2282 53.655 42.24 54.69C42.237 54.8104 42.2609 54.93 42.31 55.04C42.364 55.1414 42.435 55.2327 42.52 55.31C42.6163 55.39 42.7289 55.448 42.85 55.48H43.03H43.19C45.2865 55.0618 47.2557 54.1577 48.9394 52.8403C50.623 51.523 51.9743 49.8291 52.8846 47.8948C53.7948 45.9605 54.2387 43.8396 54.1806 41.7026C54.1225 39.5656 53.564 37.472 52.55 35.59ZM53.08 43.7C52.7447 46.3247 51.5859 48.7754 49.77 50.7C48.0237 52.5829 45.7464 53.8907 43.24 54.45C43.1861 53.1863 42.6599 51.9889 41.7655 51.0945C40.8711 50.2001 39.6737 49.674 38.41 49.62H38.21C37.4197 49.6221 36.6402 49.8033 35.93 50.15L35.83 50.1C35.4163 49.2604 34.7752 48.5537 33.9796 48.0605C33.1841 47.5672 32.266 47.3072 31.33 47.31C30.6023 47.3249 29.8835 47.474 29.21 47.75C28.3156 45.9792 27.8496 44.023 27.8495 42.0391C27.8493 40.0553 28.315 38.0991 29.2091 36.3281C30.1032 34.5571 31.4007 33.0208 32.9971 31.8429C34.5934 30.6651 36.4441 29.8786 38.4 29.5467C40.356 29.2148 42.3625 29.3469 44.258 29.9323C46.1536 30.5177 47.8852 31.54 49.3134 32.917C50.7416 34.294 51.8265 35.9871 52.4807 37.86C53.1349 39.7329 53.3402 41.7333 53.08 43.7Z", fill: "#0B3541" }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M41.82 40.85C41.2706 40.8554 40.735 41.0223 40.2798 41.3299C39.8246 41.6375 39.4699 42.0723 39.26 42.58C39.0516 43.084 38.9983 43.6387 39.1069 44.1731C39.2156 44.7076 39.4813 45.1974 39.87 45.58C40.258 45.9679 40.752 46.2323 41.29 46.34C41.4697 46.3548 41.6503 46.3548 41.83 46.34C42.1969 46.34 42.5603 46.2687 42.9 46.13C43.4048 45.9153 43.8356 45.5575 44.1395 45.1008C44.4434 44.6442 44.6069 44.1085 44.61 43.56C44.61 43.1941 44.5378 42.9018 44.3974 42.5638C44.2571 42.2259 44.0514 41.919 43.7922 41.6607C43.533 41.4024 43.2254 41.1979 42.8869 41.0587C42.5485 40.9196 42.1859 40.8487 41.82 40.85ZM43.31 44.62C43.1165 44.9138 42.8372 45.1408 42.51 45.27C42.1858 45.4082 41.8275 45.4459 41.4816 45.3781C41.1357 45.3104 40.8181 45.1403 40.57 44.89C40.3231 44.6397 40.153 44.3239 40.08 43.98C40.0235 43.6437 40.058 43.2984 40.18 42.98C40.3179 42.658 40.543 42.3809 40.83 42.18C41.1276 41.9861 41.4748 41.8819 41.83 41.88C42.1534 41.8781 42.4711 41.9642 42.7492 42.1293C43.0273 42.2943 43.2552 42.532 43.4083 42.8167C43.5615 43.1015 43.6342 43.4226 43.6187 43.7456C43.6031 44.0686 43.4999 44.3813 43.32 44.65L43.31 44.62Z", fill: "#0B3541" }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M40.09 35.84C40.09 35.5156 39.9938 35.1986 39.8136 34.9289C39.6334 34.6592 39.3773 34.449 39.0776 34.3248C38.7779 34.2007 38.4482 34.1682 38.1301 34.2315C37.8119 34.2948 37.5197 34.451 37.2903 34.6803C37.061 34.9097 36.9048 35.2019 36.8415 35.52C36.7782 35.8382 36.8107 36.1679 36.9348 36.4676C37.059 36.7673 37.2692 37.0234 37.5389 37.2036C37.8086 37.3838 38.1256 37.48 38.45 37.48C38.8841 37.4774 39.2998 37.3037 39.6068 36.9968C39.9138 36.6898 40.0874 36.2741 40.09 35.84ZM38.45 36.48C38.3234 36.48 38.1997 36.4425 38.0944 36.3721C37.9892 36.3018 37.9072 36.2019 37.8587 36.0849C37.8103 35.968 37.7976 35.8393 37.8223 35.7151C37.847 35.591 37.9079 35.477 37.9975 35.3874C38.087 35.2979 38.201 35.237 38.3251 35.2123C38.4493 35.1876 38.578 35.2003 38.6949 35.2487C38.8119 35.2972 38.9118 35.3792 38.9821 35.4844C39.0525 35.5897 39.09 35.7134 39.09 35.84C39.09 36.0097 39.0226 36.1725 38.9025 36.2925C38.7825 36.4126 38.6197 36.48 38.45 36.48Z", fill: "#0B3541" }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M28.55 15C28.3504 14.99 28.1524 15.0401 27.9815 15.1437C27.8106 15.2473 27.6747 15.3998 27.5913 15.5814C27.5078 15.763 27.4808 15.9655 27.5135 16.1626C27.5463 16.3598 27.6373 16.5426 27.775 16.6875C27.9127 16.8324 28.0906 16.9327 28.2858 16.9755C28.481 17.0183 28.6846 17.0017 28.8702 16.9277C29.0559 16.8537 29.2151 16.7258 29.3274 16.5604C29.4396 16.3951 29.4998 16.1999 29.5 16C29.5003 15.7432 29.4019 15.4962 29.225 15.31C29.0481 15.1238 28.8065 15.0128 28.55 15Z", fill: "#0B3541" }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M25.11 18.51C24.9261 18.51 24.7463 18.5645 24.5933 18.6667C24.4404 18.7689 24.3212 18.9142 24.2508 19.0841C24.1804 19.254 24.162 19.441 24.1979 19.6214C24.2338 19.8018 24.3223 19.9675 24.4524 20.0976C24.5825 20.2277 24.7482 20.3162 24.9286 20.3521C25.109 20.388 25.296 20.3696 25.4659 20.2992C25.6358 20.2288 25.7811 20.1096 25.8833 19.9567C25.9855 19.8037 26.04 19.6239 26.04 19.44C26.04 19.1933 25.942 18.9568 25.7676 18.7824C25.5932 18.608 25.3567 18.51 25.11 18.51Z", fill: "#0B3541" }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M21.65 16.93C21.8339 16.93 22.0137 16.8755 22.1667 16.7733C22.3196 16.6711 22.4388 16.5258 22.5092 16.3559C22.5796 16.186 22.598 15.999 22.5621 15.8186C22.5262 15.6382 22.4377 15.4725 22.3076 15.3424C22.1775 15.2123 22.0118 15.1238 21.8314 15.0879C21.651 15.052 21.464 15.0704 21.2941 15.1408C21.1242 15.2112 20.9789 15.3304 20.8767 15.4833C20.7745 15.6363 20.72 15.8161 20.72 16C20.72 16.2467 20.818 16.4832 20.9924 16.6576C21.1668 16.832 21.4034 16.93 21.65 16.93Z", fill: "#0B3541" }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M18.23 20.42C18.4139 20.42 18.5937 20.3655 18.7467 20.2633C18.8996 20.1611 19.0188 20.0158 19.0892 19.8459C19.1596 19.676 19.178 19.489 19.1421 19.3086C19.1062 19.1282 19.0177 18.9625 18.8876 18.8324C18.7576 18.7023 18.5918 18.6138 18.4114 18.5779C18.231 18.542 18.044 18.5604 17.8741 18.6308C17.7042 18.7012 17.5589 18.8204 17.4567 18.9733C17.3545 19.1263 17.3 19.3061 17.3 19.49C17.3 19.7366 17.398 19.9732 17.5724 20.1476C17.7468 20.322 17.9834 20.42 18.23 20.42Z", fill: "#0B3541" }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M14.81 23.85C14.9939 23.85 15.1737 23.7955 15.3267 23.6933C15.4796 23.5911 15.5988 23.4458 15.6692 23.2759C15.7396 23.106 15.758 22.919 15.7221 22.7386C15.6862 22.5582 15.5977 22.3925 15.4676 22.2624C15.3375 22.1323 15.1718 22.0438 14.9914 22.0079C14.811 21.972 14.624 21.9904 14.4541 22.0608C14.2842 22.1312 14.1389 22.2504 14.0367 22.4033C13.9345 22.5563 13.88 22.7361 13.88 22.92C13.88 23.1667 13.978 23.4032 14.1524 23.5776C14.3268 23.752 14.5634 23.85 14.81 23.85Z", fill: "#0B3541" }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M18.26 25.41C18.0761 25.41 17.8963 25.4645 17.7433 25.5667C17.5904 25.6689 17.4712 25.8142 17.4008 25.9841C17.3304 26.154 17.312 26.341 17.3479 26.5214C17.3838 26.7018 17.4723 26.8676 17.6024 26.9976C17.7325 27.1277 17.8982 27.2163 18.0786 27.2521C18.259 27.288 18.446 27.2696 18.6159 27.1992C18.7858 27.1288 18.9311 27.0096 19.0333 26.8567C19.1355 26.7037 19.19 26.5239 19.19 26.34C19.19 26.0934 19.092 25.8568 18.9176 25.6824C18.7432 25.508 18.5067 25.41 18.26 25.41Z", fill: "#0B3541" }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M21.68 22C21.4961 22 21.3163 22.0545 21.1633 22.1567C21.0104 22.2589 20.8912 22.4042 20.8208 22.5741C20.7504 22.744 20.732 22.931 20.7679 23.1114C20.8038 23.2918 20.8923 23.4575 21.0224 23.5876C21.1525 23.7177 21.3182 23.8062 21.4986 23.8421C21.679 23.878 21.866 23.8596 22.0359 23.7892C22.2058 23.7188 22.3511 23.5996 22.4533 23.4467C22.5555 23.2937 22.61 23.1139 22.61 22.93C22.61 22.6833 22.512 22.4468 22.3376 22.2724C22.1632 22.098 21.9267 22 21.68 22Z", fill: "#0B3541" }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M15 17C15.5523 17 16 16.5523 16 16C16 15.4477 15.5523 15 15 15C14.4477 15 14 15.4477 14 16C14 16.5523 14.4477 17 15 17Z", fill: "#0B3541" }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M30.74 54.04C31.1763 54.04 31.53 53.6863 31.53 53.25C31.53 52.8137 31.1763 52.46 30.74 52.46C30.3037 52.46 29.95 52.8137 29.95 53.25C29.95 53.6863 30.3037 54.04 30.74 54.04Z", fill: "#0B3541" }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M49.56 40.21C49.4057 40.21 49.2549 40.2557 49.1267 40.3415C48.9984 40.4272 48.8984 40.549 48.8394 40.6915C48.7803 40.834 48.7649 40.9909 48.795 41.1422C48.8251 41.2935 48.8994 41.4325 49.0085 41.5415C49.1175 41.6506 49.2565 41.7249 49.4078 41.755C49.5591 41.7851 49.716 41.7697 49.8585 41.7106C50.001 41.6516 50.1228 41.5516 50.2085 41.4233C50.2943 41.2951 50.34 41.1443 50.34 40.99C50.34 40.7831 50.2578 40.5847 50.1115 40.4385C49.9653 40.2922 49.7669 40.21 49.56 40.21Z", fill: "#0B3541" })
] }));
SnackIllustration.displayName = "SnackIllustration";
const SwagIllustration = forwardRef((props, ref2) => /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { width: "56", height: "56", viewBox: "0 0 56 56", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img", "aria-label": "Swag Illustration ", ...props, ref: ref2, children: [
  /* @__PURE__ */ jsxRuntimeExports.jsx("title", { children: "Swag Illustration " }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M38.5298 1.97212C39.501 1.04469 40.7922 0.527191 42.135 0.527191C43.4778 0.527191 44.769 1.04469 45.7402 1.97212C46.7113 2.89955 47.2877 4.16556 47.3495 5.50698L47.35 5.51848V5.52999V37.741V37.75C47.35 41.584 45.4212 46.016 42.0629 49.4829C38.6951 52.9595 33.8576 55.5 28 55.5H27.9997C22.8687 55.4973 17.9486 53.4578 14.3204 49.8296C10.6922 46.2014 8.65272 41.2813 8.65 36.1503V36.15V10.25V10.2385L8.65053 10.227C8.71232 8.88556 9.28869 7.61955 10.2598 6.69212C11.231 5.76469 12.5222 5.24719 13.865 5.24719C15.2078 5.24719 16.499 5.76469 17.4702 6.69212C18.4413 7.61955 19.0177 8.88556 19.0795 10.227L19.08 10.2385V10.25V18.9308C19.2381 18.7138 19.4138 18.5082 19.606 18.316C20.583 17.3389 21.9082 16.79 23.29 16.79C24.6718 16.79 25.997 17.3389 26.974 18.316C27.4012 18.7432 27.7466 19.2369 28 19.7729C28.2534 19.2369 28.5988 18.7432 29.026 18.316C30.003 17.3389 31.3282 16.79 32.71 16.79C34.0918 16.79 35.417 17.3389 36.394 18.316C36.5862 18.5082 36.7619 18.7138 36.92 18.9307V5.52999V5.51848L36.9205 5.50698C36.9823 4.16556 37.5587 2.89955 38.5298 1.97212ZM18.08 22V10.2618C18.0274 9.18153 17.5619 8.1625 16.7795 7.41532C15.9944 6.66556 14.9506 6.24719 13.865 6.24719C12.7794 6.24719 11.7356 6.66556 10.9505 7.41532C10.1681 8.1625 9.70263 9.18153 9.65 10.2618L9.65 36.1497L9.65 36.15C9.65265 41.0159 11.5868 45.6818 15.0275 49.1225C18.4683 52.5633 23.1343 54.4974 28.0003 54.5C33.5526 54.4999 38.1399 52.0954 41.3446 48.7871C44.5561 45.4718 46.347 41.2831 46.35 37.7589C46.3027 36.4832 45.9576 35.2361 45.3419 34.1175C44.7249 32.9964 43.8534 32.0356 42.7975 31.3125L42.7869 31.3053L42.787 31.3051C41.2457 30.1904 39.3921 29.5902 37.49 29.59H37.49H29.18C28.0634 29.59 26.9926 30.0335 26.2031 30.8231C25.4136 31.6126 24.97 32.6834 24.97 33.8C24.97 34.0993 25.0019 34.3953 25.0637 34.6834C25.0672 34.6966 25.0701 34.7098 25.0724 34.723C25.2459 35.4948 25.6349 36.2087 26.2031 36.7769C26.9926 37.5664 28.0634 38.01 29.18 38.01H37.4195H37.42L37.4205 39.01C35.0538 39.0125 32.7848 39.9544 31.1122 41.6289C29.4395 43.3033 28.5 45.5732 28.5 47.94C28.5 48.2161 28.2761 48.44 28 48.44C27.7239 48.44 27.5 48.2161 27.5 47.94C27.5 45.3082 28.5447 42.7841 30.4047 40.9221C31.1937 40.1324 32.1019 39.4891 33.0872 39.01H29.18C27.7982 39.01 26.473 38.4611 25.496 37.484C24.9077 36.8958 24.4747 36.1814 24.2232 35.4044C23.0383 35.6168 21.8104 35.4138 20.7511 34.8205C19.5445 34.1446 18.6555 33.0176 18.2791 31.6869C18.1471 31.2262 18.0801 30.7493 18.08 30.2701V30.27V22ZM24.0078 34.4269C23.062 34.5873 22.0845 34.4212 21.2398 33.948C20.2641 33.4015 19.5453 32.4901 19.2412 31.414L19.2406 31.4122C19.1342 31.0408 19.0801 30.6564 19.08 30.27V30.2699V22C19.08 20.8834 19.5236 19.8126 20.3131 19.0231C21.1026 18.2335 22.1734 17.79 23.29 17.79C24.4066 17.79 25.4774 18.2335 26.2669 19.0231C27.0564 19.8126 27.5 20.8834 27.5 22V28.8683C26.7523 29.123 26.0651 29.5469 25.496 30.116C24.5189 31.093 23.97 32.4182 23.97 33.8C23.97 34.0106 23.9828 34.2199 24.0078 34.4269ZM28.5 28.6345C28.7242 28.605 28.9513 28.59 29.18 28.59H36.92V22C36.92 20.8834 36.4764 19.8126 35.6869 19.0231C34.8974 18.2335 33.8266 17.79 32.71 17.79C31.5934 17.79 30.5226 18.2335 29.7331 19.0231C28.9436 19.8126 28.5 20.8834 28.5 22V28.6345ZM37.92 28.5992C39.8787 28.6834 41.7735 29.3395 43.3678 30.4911C44.5504 31.3022 45.5266 32.379 46.218 33.6354C46.2633 33.7177 46.3073 33.8006 46.35 33.8841V5.54183C46.2974 4.46153 45.8319 3.4425 45.0495 2.69532C44.2644 1.94556 43.2206 1.52719 42.135 1.52719C41.0494 1.52719 40.0056 1.94555 39.2205 2.69532C38.4381 3.4425 37.9726 4.46153 37.92 5.54183V22V28.5992Z", fill: "#0B3541" })
] }));
SwagIllustration.displayName = "SwagIllustration";
const ThirtyDayBadge = forwardRef((props, ref2) => /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { width: "58", height: "58", viewBox: "0 0 58 58", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img", "aria-label": "Thirty Day Badge ", ...props, ref: ref2, children: [
  /* @__PURE__ */ jsxRuntimeExports.jsx("title", { children: "Thirty Day Badge " }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M31.1685 2.07839L32.3266 3.00632C33.253 3.81825 34.527 4.05024 35.6851 3.70226L37.0748 3.2383C38.6961 2.77434 40.5491 3.47028 41.3597 4.97816L42.0546 6.25406C42.6336 7.29798 43.6759 8.10991 44.9498 8.2259L46.3396 8.34189C47.9609 8.57387 49.3506 9.96576 49.5822 11.5896L49.698 12.9815C49.8139 14.1414 50.5087 15.3013 51.6668 15.8813L52.9407 16.5772C54.4463 17.3892 55.2569 19.129 54.6779 20.8689L54.2146 22.2608C53.8672 23.4207 54.0988 24.6966 54.9095 25.6245L55.836 26.7844C56.9941 28.1763 56.9941 30.0322 55.836 31.424L54.9095 32.584C54.0988 33.5119 53.8672 34.7878 54.2146 35.9477L54.6779 37.3396C55.1411 38.9634 54.4463 40.8193 52.9407 41.6312L51.6668 42.3272C50.6245 42.9071 49.8139 43.951 49.698 45.2269L49.5822 46.6188C49.4664 48.3587 48.0767 49.7506 46.3396 49.8666L44.9498 49.9826C43.7917 50.0986 42.6336 50.7945 42.0546 51.9544L41.3597 53.2303C40.5491 54.7382 38.8119 55.5501 37.0748 54.9702L35.6851 54.5062C34.527 54.1582 33.253 54.3902 32.3266 55.2021L31.1685 56.1301C29.7788 57.29 27.9258 57.29 26.5361 56.1301L25.378 55.2021C24.4515 54.3902 23.1776 54.1582 22.0195 54.5062L20.6298 54.9702C19.0084 55.4341 17.1555 54.7382 16.3448 53.2303L15.6499 51.9544C15.0709 50.9105 14.0286 50.0986 12.7547 49.9826L11.365 49.8666C9.74364 49.6346 8.35393 48.2427 8.12231 46.6188L8.0065 45.2269C7.89069 44.067 7.19583 42.9071 6.03773 42.3272L4.76382 41.6312C3.25829 40.8193 2.44762 39.0794 3.02667 37.3396L3.48991 35.9477C3.83734 34.7878 3.60572 33.5119 2.79505 32.584L1.86857 31.424C0.710475 30.0322 0.710475 28.1763 1.86857 26.7844L2.79505 25.6245C3.60572 24.6966 3.83734 23.4207 3.48991 22.2608L3.02667 20.8689C2.56343 19.245 3.25829 17.3892 4.76382 16.5772L6.03773 15.8813C7.08002 15.3013 7.89069 14.2574 8.0065 12.9815L8.12231 11.5896C8.35393 9.96576 9.74364 8.57387 11.365 8.34189L12.7547 8.2259C13.9128 8.10991 15.0709 7.41397 15.6499 6.25406L16.3448 4.97816C17.1555 3.47028 18.8926 2.65835 20.6298 3.2383L22.0195 3.70226C23.1776 4.05024 24.4515 3.81825 25.378 3.00632L26.5361 2.07839C27.9258 1.03448 29.7788 1.03448 31.1685 2.07839Z", fill: "white", stroke: "#D1D3D4" }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M29.4998 55.8367C28.8019 55.8367 28.1039 55.6041 27.5223 55.1388L26.359 54.2082C25.661 53.6265 24.6141 53.2776 23.6835 53.2776C23.2182 53.2776 22.8692 53.3939 22.4039 53.5102L21.008 53.9755C20.659 54.0918 20.4264 54.0918 20.0774 54.0918C18.9141 54.0918 17.8672 53.5102 17.4019 52.4633L16.7039 51.1837C16.1223 49.7878 14.959 48.9735 13.4468 48.8571L12.0508 48.7408C10.5386 48.6245 9.49166 47.4612 9.259 45.949L9.14268 44.5531C9.02635 43.0408 8.21207 41.8776 6.93247 41.1796L5.65288 40.4816C4.37329 39.7837 3.67533 38.2714 4.14064 36.8755L4.60594 35.4796C5.07125 34.0837 4.72227 32.6878 3.79166 31.5245L2.86105 30.3612C1.93043 29.198 1.93043 27.5694 2.86105 26.5225L3.79166 25.3592C4.72227 24.3123 4.95492 22.8 4.60594 21.4041L4.14064 20.0082C3.67533 18.6122 4.37329 17.1 5.65288 16.402L6.93247 15.7041C8.21207 15.1225 9.02635 13.9592 9.14268 12.4469L9.259 11.051C9.37533 9.53878 10.5386 8.49184 12.0508 8.25919L13.4468 8.14286C14.959 8.02653 16.1223 7.21225 16.8202 5.93266L17.5182 4.65306C18.0998 3.60613 19.0304 3.02449 20.1937 3.02449C20.5427 3.02449 20.7753 3.02449 21.1243 3.14082L22.5202 3.60613C22.8692 3.72245 23.3345 3.83878 23.7998 3.83878C24.7304 3.83878 25.7774 3.4898 26.4753 2.90817L27.6386 1.97755C28.1039 1.39592 28.8019 1.16327 29.4998 1.16327C30.1978 1.16327 30.8957 1.39592 31.4774 1.86123L32.6406 2.79184C33.3386 3.37347 34.3855 3.72245 35.3161 3.72245C35.7815 3.72245 36.1304 3.60613 36.5957 3.4898L37.9917 3.02449C38.3406 2.90817 38.5733 2.90817 38.9223 2.90817C40.0855 2.90817 41.1325 3.4898 41.5978 4.53674L42.2957 5.81633C42.8774 7.21225 44.0406 8.02653 45.5529 8.14286L46.9488 8.25919C48.461 8.37551 49.508 9.53878 49.7406 11.051L49.857 12.4469C49.9733 13.8429 50.7876 15.1225 52.0672 15.8204L53.3468 16.5184C54.6264 17.2163 55.3243 18.7286 54.859 20.1245L54.3937 21.5204C53.9284 22.9163 54.2774 24.3122 55.208 25.4755L56.1386 26.6388C57.0692 27.802 57.0692 29.4306 56.1386 30.4776L55.208 31.6408C54.2774 32.6878 54.0447 34.2 54.3937 35.5959L54.859 36.9918C55.3243 38.3878 54.6264 39.9 53.3468 40.598L52.0672 41.2959C50.7876 41.8776 49.9733 43.0408 49.857 44.5531L49.7406 45.949C49.6243 47.4612 48.461 48.5082 46.9488 48.7408L45.5529 48.8571C44.157 48.9735 42.8774 49.7878 42.1794 51.0674L41.4815 52.3469C40.8998 53.3939 39.9692 53.9755 38.8059 53.9755C38.457 53.9755 38.2243 53.9755 37.8753 53.8592L36.4794 53.3939C36.1304 53.2776 35.6651 53.1612 35.1998 53.1612C34.2692 53.1612 33.2223 53.5102 32.5243 54.0918L31.361 55.0225C30.8957 55.6041 30.1978 55.8367 29.4998 55.8367Z", fill: "url(#paint0_linear_1_1185)" }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M27.1734 1.39592C27.8714 0.814288 28.6857 0.581635 29.5 0.581635C30.3143 0.581635 31.1285 0.814288 31.8265 1.27959L32.9898 2.21021C33.6877 2.79184 34.502 3.02449 35.3163 3.02449C35.6653 3.02449 36.0143 3.02449 36.3632 2.90817L37.7592 2.44286C38.1081 2.32653 38.4571 2.32653 38.8061 2.32653C40.202 2.32653 41.3653 3.14082 42.0632 4.30408L42.7612 5.58368C43.3428 6.74694 44.5061 7.4449 45.6694 7.56123L47.0653 7.67755C48.6938 7.91021 50.0898 9.30612 50.3224 10.9347L50.4387 12.3306C50.5551 13.6102 51.3694 14.6571 52.4163 15.2388L53.6959 15.9367C55.2081 16.751 55.9061 18.6122 55.4408 20.2408L54.9755 21.6367C54.6265 22.8 54.8592 24.0796 55.6734 25.0102L56.604 26.1735C57.7673 27.5694 57.7673 29.4306 56.604 30.8265L55.6734 31.9898C54.8592 32.9204 54.6265 34.2 54.9755 35.3633L55.4408 36.7592C56.0224 38.5041 55.2081 40.249 53.6959 41.0633L52.4163 41.7612C51.253 42.3429 50.5551 43.5061 50.4387 44.6694L50.3224 46.0653C50.2061 47.8102 48.8102 49.2061 47.0653 49.3225L45.6694 49.4388C44.3898 49.5551 43.3428 50.3694 42.7612 51.4163L42.0632 52.6959C41.3653 53.9755 40.0857 54.6735 38.8061 54.6735C38.4571 54.6735 38.1081 54.6735 37.7592 54.5571L36.3632 54.0918C36.0143 53.9755 35.6653 53.9755 35.3163 53.9755C34.502 53.9755 33.6877 54.2082 32.9898 54.7898L31.8265 55.7204C31.1285 56.302 30.3143 56.5347 29.5 56.5347C28.6857 56.5347 27.8714 56.302 27.1734 55.7204L26.0102 54.7898C25.3122 54.2082 24.4979 53.9755 23.6836 53.9755C23.3347 53.9755 22.9857 53.9755 22.6367 54.0918L21.2408 54.5571C20.8918 54.6735 20.5428 54.6735 20.1938 54.6735C18.7979 54.6735 17.6347 53.8592 16.9367 52.6959L16.2387 51.4163C15.6571 50.2531 14.4938 49.5551 13.3306 49.4388L11.9347 49.3225C10.3061 49.0898 8.91017 47.6939 8.67752 46.0653L8.56119 44.6694C8.44487 43.3898 7.63058 42.3429 6.58364 41.7612L5.30405 41.0633C3.7918 40.249 3.09385 38.3878 3.55915 36.7592L4.02446 35.3633C4.37344 34.2 4.14078 32.9204 3.3265 31.9898L2.39589 30.8265C1.23262 29.4306 1.23262 27.5694 2.39589 26.1735L3.3265 25.0102C4.14078 24.0796 4.37344 22.8 4.02446 21.6367L3.55915 20.2408C2.97752 18.4959 3.7918 16.751 5.30405 15.9367L6.58364 15.2388C7.74691 14.6571 8.44487 13.4939 8.56119 12.3306L8.67752 10.9347C8.91017 9.30612 10.3061 7.91021 11.9347 7.67755H13.3306C14.6102 7.56123 15.6571 6.74694 16.2387 5.7L16.9367 4.42041C17.6347 3.14082 18.9143 2.44286 20.1938 2.44286C20.5428 2.44286 20.8918 2.44286 21.2408 2.55919L22.6367 3.02449C22.9857 3.14082 23.3347 3.14082 23.6836 3.14082C24.4979 3.14082 25.3122 2.90817 26.0102 2.32653L27.1734 1.39592ZM31.1285 2.32653C30.6632 1.97755 30.0816 1.7449 29.5 1.7449C28.9183 1.7449 28.3367 1.97755 27.8714 2.32653L26.7081 3.25714C25.8938 4.07143 24.8469 4.42041 23.6836 4.42041C23.2183 4.42041 22.753 4.30408 22.2877 4.18776L20.8918 3.72245C20.6592 3.60612 20.4265 3.60612 20.1938 3.60612C19.2632 3.60612 18.4489 4.07143 17.9836 4.88572L17.2857 6.16531C16.4714 7.67755 15.0755 8.60816 13.4469 8.72449L12.051 8.84082C10.8877 8.95714 9.95711 9.88776 9.84078 11.051L9.72446 12.4469C9.60813 14.0755 8.56119 15.4714 7.16527 16.2857L5.88568 16.9837C4.83874 17.5653 4.37344 18.7286 4.72242 19.8918L5.18772 21.2878C5.65303 22.8 5.30405 24.4286 4.25711 25.7082L3.3265 26.8714C2.51221 27.802 2.51221 29.0816 3.3265 30.0122L4.25711 31.1755C5.30405 32.3388 5.65303 34.0837 5.18772 35.5959L4.72242 36.9918C4.37344 38.1551 4.83874 39.3184 5.88568 39.9L7.16527 40.598C8.67752 41.4122 9.60813 42.8082 9.72446 44.4367L9.84078 45.8327C9.95711 46.9959 10.8877 47.9265 12.051 48.0429L13.4469 48.1592C15.0755 48.2755 16.4714 49.3224 17.2857 50.7184L17.9836 51.998C18.4489 52.8122 19.2632 53.2776 20.1938 53.2776C20.4265 53.2776 20.6592 53.2776 20.8918 53.1612L22.2877 52.6959C22.753 52.5796 23.2183 52.4633 23.6836 52.4633C24.7306 52.4633 25.8938 52.9286 26.7081 53.6265L27.8714 54.5571C28.3367 54.9061 28.9183 55.1388 29.5 55.1388C30.0816 55.1388 30.6632 54.9061 31.1285 54.5571L32.2918 53.6265C33.1061 52.8122 34.153 52.4633 35.3163 52.4633C35.7816 52.4633 36.2469 52.5796 36.7122 52.6959L38.1081 53.1612C38.3408 53.2776 38.5734 53.2776 38.8061 53.2776C39.7367 53.2776 40.551 52.8122 41.0163 51.998L41.7143 50.7184C42.5285 49.2061 43.9245 48.2755 45.553 48.1592L46.9489 48.0429C48.1122 47.9265 49.0428 46.9959 49.1592 45.8327L49.2755 44.4367C49.3918 42.8082 50.4387 41.4122 51.8347 40.598L53.1143 39.9C54.1612 39.3184 54.6265 38.1551 54.2775 36.9918L53.8122 35.5959C53.3469 34.0837 53.6959 32.4551 54.7428 31.1755L55.6734 30.0122C56.4877 29.0816 56.4877 27.802 55.6734 26.8714L54.7428 25.7082C53.6959 24.5449 53.3469 22.8 53.8122 21.2878L54.2775 19.8918C54.6265 18.7286 54.1612 17.5653 53.1143 16.9837L51.8347 16.2857C50.3224 15.4714 49.3918 14.0755 49.2755 12.4469L49.1592 11.051C49.0428 9.88776 48.1122 8.95714 46.9489 8.84082L45.553 8.72449C43.9245 8.60816 42.5285 7.56123 41.7143 6.16531L41.0163 4.88572C40.551 4.07143 39.7367 3.60612 38.8061 3.60612C38.5734 3.60612 38.3408 3.60612 38.1081 3.72245L36.7122 4.18776C36.2469 4.30408 35.7816 4.42041 35.3163 4.42041C34.2694 4.42041 33.1061 3.9551 32.2918 3.25714L31.1285 2.32653Z", fill: "white" }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("ellipse", { cx: "10.4896", cy: "30.0778", rx: "1.71711", ry: "1.74388", fill: "#514E4D" }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("ellipse", { cx: "49.4105", cy: "30.0778", rx: "1.71711", ry: "1.74388", fill: "#514E4D" }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M30.408 10.3138L32.1251 6.82605H30.8659L29.7211 9.03497L28.4619 6.82605H27.2027L29.1488 10.3138V11.9414H30.408V10.3138ZM22.395 8.10489L26.1727 7.05856L26.4016 8.10489L23.8832 8.80244L24.1121 9.73251L26.4016 9.15122L26.6305 10.1975L24.3411 10.8951L24.57 11.8252L27.2029 11.1276L27.4319 12.1739L23.6542 12.9878L22.395 8.10489ZM20.7922 8.80245L19.7619 9.38374L21.3646 12.0577L17.8159 10.5463L16.7856 11.1276L19.304 15.6617L20.3343 15.0804L18.8461 12.4065L22.2804 13.8016L23.3106 13.2203L20.7922 8.80245ZM16.3277 12.9878C15.8698 12.8715 15.4119 12.9878 14.954 13.104C14.4961 13.3365 14.1527 13.5691 13.8093 13.9178C13.4659 14.2666 13.2369 14.7316 13.1225 15.1967C13.008 15.6617 13.008 16.1267 13.1225 16.5918C13.2369 17.0568 13.4659 17.4056 13.8093 17.7544C14.1527 18.1031 14.6106 18.3357 15.0685 18.4519C15.5264 18.5682 15.9843 18.4519 16.4422 18.3357C16.9001 18.2194 17.2435 17.8706 17.5869 17.5219L17.5869 17.5219C17.9304 17.1731 18.1593 16.708 18.2738 16.243C18.3883 15.778 18.3883 15.3129 18.2738 14.8479C18.1593 14.3829 17.9304 14.0341 17.5869 13.6853C17.129 13.3365 16.7856 13.104 16.3277 12.9878ZM8.77246 22.6372L9.34483 21.3584L12.6646 21.2421L10.604 18.6844L11.1764 17.4056L15.7554 19.4983L15.183 20.4283L12.3211 19.1495L14.2672 21.4747L13.9238 22.2885L10.9475 22.4047L13.8093 23.6836L13.3514 24.7299L8.77246 22.6372ZM45.9766 35.0769L44.145 38.6809L48.6095 41.0061L50.4411 37.4021L49.5253 36.9371L48.2661 39.3785L47.4648 38.9135L48.495 36.7045L47.5792 36.2395L46.4345 38.4484L45.6332 37.9834L46.8924 35.542L45.9766 35.0769ZM13.9236 40.4248L13.3513 39.3785L12.092 39.9598C11.8631 39.7273 11.6342 39.4948 11.5197 39.2622C11.4052 39.0297 11.4052 38.7972 11.4052 38.5647C11.4052 38.3322 11.5197 38.0996 11.6342 37.8671C11.7486 37.6346 11.9776 37.4021 12.2065 37.2858C12.5499 37.0533 12.7789 37.0533 13.0078 37.0533C13.2368 37.0533 13.4657 37.1696 13.6947 37.2858C13.8092 37.4021 14.0381 37.6346 14.1526 37.8671C14.267 38.0996 14.3815 38.3322 14.3815 38.5647C14.3815 38.9135 14.3815 39.146 14.267 39.3785L15.4118 39.611V38.4484C15.4118 38.0996 15.2973 37.7509 15.0684 37.4021C14.8394 36.9371 14.496 36.472 14.1526 36.2395C13.8092 36.007 13.3513 35.7745 12.8934 35.7745C12.4355 35.7745 11.9776 35.8907 11.5197 36.1233C11.0618 36.3558 10.7184 36.7045 10.4894 37.0533C10.2605 37.4021 10.146 37.8671 10.146 38.3322C10.146 38.7972 10.2605 39.2622 10.4894 39.7273C10.6039 40.076 10.8328 40.3086 11.1763 40.6573C11.5197 41.0061 11.7486 41.2386 12.092 41.3549L13.9236 40.4248ZM15.0684 44.1451C14.8394 43.9126 14.7249 43.6801 14.7249 43.4476C14.7249 43.0988 14.8394 42.8663 14.9539 42.6338L17.0144 40.5411L16.0986 39.611L14.0381 41.7037C13.8092 42.0525 13.5802 42.4012 13.4657 42.75C13.3513 43.215 13.3513 43.5638 13.4657 43.9126C13.5802 44.2614 13.8092 44.6101 14.1526 44.9589C14.496 45.3077 14.7249 45.5402 15.1828 45.6565C15.6407 45.7727 15.9842 45.7727 16.3276 45.6565C16.671 45.5402 17.0144 45.424 17.3578 45.0752L19.4184 42.9825L18.5026 42.0525L16.4421 44.1451C16.2131 44.3776 15.9842 44.4939 15.7552 44.4939C15.5263 44.4939 15.2973 44.3776 15.0684 44.1451ZM20.1055 49.1442L20.22 48.2142L18.3884 47.0516L17.5871 47.6329L16.4424 46.9353L20.7924 43.6801L21.9371 44.3776L21.2503 49.8418L20.1055 49.1442ZM20.3342 47.0516L19.1895 46.354L20.6776 45.0752L20.3342 47.0516ZM24.7988 50.8881L24.4554 49.3768L23.5396 49.1442L23.1961 50.5393L21.9369 50.1906L23.3106 45.3077L25.4856 45.889C26.1725 46.1215 26.6304 46.354 26.8593 46.8191C27.0883 47.1678 27.2027 47.7491 27.0882 48.2142C26.9738 48.5629 26.8593 48.9117 26.6304 49.1442C26.4014 49.3768 26.1725 49.493 25.829 49.6093L26.4014 51.4694L24.7988 50.8881ZM25.4854 48.3304C25.2565 48.4467 25.0275 48.4467 24.7986 48.3304L23.8828 47.9816L24.3407 46.7028L25.2565 46.9353C25.5999 47.0516 25.8289 47.1678 25.8289 47.2841C25.8289 47.3167 25.8379 47.3585 25.8483 47.4069C25.8751 47.5309 25.9112 47.6981 25.8289 47.8654C25.8289 48.0979 25.7144 48.2142 25.4854 48.3304ZM31.4383 51.4694L31.0948 50.5393H28.9198L28.5764 51.4694H27.2027L29.2633 46.354H30.6369L32.8119 51.4694H31.4383ZM29.9501 47.7491L30.6369 49.6093H29.2633L29.9501 47.7491ZM35.7885 45.3077L36.9332 44.9589L38.3069 49.8418L37.1622 50.1906L34.1859 47.8654L34.9872 50.7719L33.8424 51.1206L32.4688 46.2378L33.6135 45.889L36.7043 48.2142L35.7885 45.3077ZM37.8488 45.7727L39.108 44.9589L41.283 48.3304L42.4277 47.6329L40.2527 44.2614L41.5119 43.4476L40.9396 42.5175L37.2764 44.8427L37.8488 45.7727ZM41.1685 42.1687L43.8014 39.146L44.6027 39.8435L42.7711 41.8199L43.458 42.5175L45.0606 40.7736L45.8619 41.4712L44.2593 43.3313L44.9461 44.0288L46.7777 41.9362L47.579 42.6337L44.8317 45.6565L41.1685 42.1687ZM14.2671 15.3129V16.0105C14.3816 16.243 14.496 16.4755 14.725 16.708C14.9539 16.9406 15.1829 17.0568 15.4118 17.0568C15.6408 17.1731 15.8697 17.1731 16.0987 17.0568C16.3276 16.9406 16.5566 16.8243 16.671 16.708C16.7092 16.6305 16.7474 16.566 16.7855 16.5014C16.8618 16.3722 16.9381 16.243 17.0145 16.0105C17.0145 15.778 17.0145 15.5455 16.9 15.3129C16.7855 15.0804 16.671 14.8479 16.4421 14.6154C16.2131 14.3829 15.9842 14.2666 15.7552 14.2666C15.5263 14.1504 15.2974 14.1504 15.0684 14.2666C14.8395 14.3829 14.6105 14.4991 14.496 14.6154C14.3816 14.8479 14.2671 15.0804 14.2671 15.3129ZM32.5832 9.38374L34.4148 9.73252L34.3003 10.5463L32.4688 10.1976L32.5832 9.38374ZM39.6804 9.73252C39.6804 9.5 39.4514 9.26748 39.2225 9.03497C39.108 8.91871 38.7646 8.68619 38.4211 8.56993L36.2461 7.63986L34.4146 12.4065L36.704 13.3365C37.0475 13.4528 37.3909 13.5691 37.7343 13.5691C38.0777 13.5691 38.3067 13.4528 38.5356 13.3365C38.7646 13.2203 38.879 12.9878 38.9935 12.7552C39.108 12.4065 39.108 12.0577 38.9935 11.8252C38.879 11.5927 38.6501 11.3601 38.4211 11.1276C38.7646 11.1276 38.9935 11.1276 39.2225 11.0114C39.4514 10.8951 39.5659 10.6626 39.6804 10.4301C39.7948 10.1976 39.7948 9.96504 39.6804 9.73252ZM37.3908 12.4065C37.5052 12.4065 37.6197 12.2902 37.7342 12.0577C37.814 11.9766 37.7825 11.8391 37.7561 11.7238C37.7447 11.6737 37.7342 11.6279 37.7342 11.5927C37.6197 11.4764 37.5052 11.3601 37.2763 11.2439L36.3605 10.8951L36.0171 11.9414L36.9329 12.2902C37.0474 12.4065 37.2763 12.4065 37.3908 12.4065ZM38.3067 10.1976C38.3067 10.3138 38.1922 10.4301 38.0777 10.4301C37.9633 10.4301 37.7343 10.4301 37.6198 10.5463L36.704 10.1976L37.0475 9.26748L37.9633 9.61626C38.0777 9.61626 38.1922 9.73252 38.3067 9.84878V10.1976ZM41.3975 16.3593L41.6264 15.4292L39.9093 14.0341L39.108 14.6154L38.0777 13.8016L42.8856 11.1276L43.9159 11.9414L42.5422 17.2893L41.3975 16.3593ZM41.9699 14.3829L40.8252 13.5691L42.5423 12.5227L41.9699 14.3829ZM46.8924 16.4755C46.7779 16.243 46.549 16.1267 46.32 16.0105C46.0911 15.8942 45.8621 15.8942 45.6332 15.8942C45.4042 15.8942 45.1753 16.0105 44.9463 16.243C44.7174 16.4755 44.6029 16.5918 44.4884 16.8243C44.2595 17.1731 44.2595 17.4056 44.2595 17.6381C44.2595 17.8706 44.374 18.1031 44.4884 18.3357C44.6029 18.4519 44.8318 18.6844 45.0608 18.8007C45.2897 18.917 45.5187 19.0332 45.7476 19.0332L45.5309 20.134L45.3953 20.1911C45.0709 20.1674 44.6776 20.0526 44.374 19.847C44.0305 19.6145 43.6871 19.382 43.4582 19.1495C43.1147 18.8007 43.0003 18.3357 42.8858 17.8706C42.7713 17.4056 42.8858 16.9406 43.0003 16.4755C43.2292 16.0105 43.4582 15.6617 43.8016 15.4292C44.145 15.0804 44.6029 14.9642 45.0608 14.8479C45.5187 14.8479 45.9766 14.8479 46.4345 15.0804C46.8924 15.3129 47.2358 15.5455 47.5792 16.0105C47.8082 16.3593 47.9226 16.708 48.0371 17.0568C48.1516 17.4056 48.1516 17.8706 48.1516 18.2194H47.0068C47.1213 17.7544 47.1213 17.4056 47.1213 17.1731C47.1213 16.9406 47.0068 16.708 46.8924 16.4755ZM45.3953 20.1911L44.832 20.4283L45.2899 21.7072L46.4347 21.2421L47.3505 21.5909L46.0912 23.5673L46.6636 25.0787L48.6097 21.9397L51.2426 22.8698L50.6702 21.4746L47.9228 20.5446L49.9833 19.7308L49.5255 18.4519L45.5309 20.134L45.5187 20.1958C45.479 20.1958 45.4377 20.1942 45.3953 20.1911Z", fill: "#514E4D" }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M34.6438 19.6145C36.8188 19.6145 38.4214 20.3121 39.5661 21.5909C40.7109 22.986 41.2832 24.7299 41.2832 27.1713C41.2832 29.6128 40.7109 31.4729 39.5661 32.7518C38.4214 34.0306 36.8188 34.7282 34.6438 34.7282C32.9267 34.7282 31.553 34.2631 30.4082 33.333C30.479 33.333 30.506 33.2886 30.5434 33.2273C30.5664 33.1893 30.5935 33.1449 30.6372 33.1005C31.2096 32.0542 31.553 31.0079 31.553 29.8453C31.553 28.4502 31.0951 27.2876 30.2938 26.3575C29.8359 25.8925 29.2635 25.4275 28.5767 25.0787L30.5227 23.4511C30.7517 23.2185 30.8661 22.8698 30.8661 22.521V20.6608C31.8964 19.9633 33.1556 19.6145 34.6438 19.6145ZM37.2193 36.2395L37.2766 36.1233V36.2395H37.2193ZM37.2193 36.2395L35.6739 39.3785V40.8899H34.1858V39.4948L32.4687 36.2395H33.9568L34.8726 38.0997L35.7884 36.2395H37.2193ZM28.4623 37.1696C28.2334 36.8208 27.8899 36.5883 27.5465 36.3558C27.2031 36.2395 26.7452 36.1233 26.1728 36.2395H24.1123V40.8899H26.1728C26.7452 40.8899 27.2031 40.7736 27.5465 40.5411C28.0044 40.3086 28.2334 40.0761 28.4623 39.7273C28.6913 39.3785 28.8057 38.9135 28.8057 38.4484C28.8057 37.9834 28.6913 37.5184 28.4623 37.1696ZM26.9739 39.2622C27.0884 39.0297 27.2029 38.7972 27.2029 38.4484C27.2029 38.0997 27.0884 37.8671 26.9739 37.6346C26.745 37.4021 26.516 37.2858 26.2871 37.2858H25.8292V39.611H26.4016C26.516 39.611 26.745 39.4948 26.9739 39.2622ZM31.7816 40.0761L32.0105 40.7736H33.6132L31.7816 36.1233H30.179L28.2329 40.7736H29.8355L30.0645 40.0761H31.7816ZM30.4081 39.0297H31.3239L30.866 37.6346L30.4081 39.0297ZM36.2465 29.6128C36.132 30.1941 35.9031 30.6591 35.6741 30.8916C35.4452 31.1241 35.1018 31.2404 34.6439 31.2404C34.186 31.2404 33.8425 31.1241 33.6136 30.8916C33.3847 30.6591 33.1557 30.1941 33.0412 29.6128C32.9268 29.0315 32.9268 28.2177 32.9268 27.2876C32.9268 26.2413 32.9268 25.5437 33.0412 24.9624C33.1557 24.3811 33.3847 24.0323 33.6136 23.6836C33.8425 23.3348 34.186 23.3348 34.6439 23.3348C35.1018 23.3348 35.4452 23.4511 35.6741 23.6836C35.9031 23.9161 36.132 24.3811 36.2465 24.9624C36.361 25.5437 36.361 26.3575 36.361 27.2876C36.361 28.2177 36.361 29.0315 36.2465 29.6128ZM30.4081 29.8453C30.4081 28.799 30.0647 27.8689 29.4923 27.1713C28.8055 26.4738 28.0042 26.0087 26.9739 25.7762L26.2871 25.66L29.7213 22.6372V19.847H19.0752V23.3348H24.1121L21.2502 26.0087V28.5664H23.9976C24.57 28.5664 24.9134 28.6827 25.2568 28.9152C25.6002 29.1477 25.7147 29.3803 25.7147 29.8453C25.7147 30.6591 25.1423 31.1241 23.9976 31.1241C22.6239 31.1241 21.2502 30.5428 19.991 29.4965L18.2739 32.7518C18.9608 33.333 19.8766 33.7981 21.0213 34.1469C22.166 34.4956 23.1963 34.7282 24.341 34.7282C25.6002 34.7282 26.6305 34.6119 27.5463 34.1469C28.3476 33.6818 29.1489 33.1005 29.6068 32.403C30.1792 31.7054 30.4081 30.7754 30.4081 29.8453Z", fill: "#514E4D" }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("defs", { children: /* @__PURE__ */ jsxRuntimeExports.jsxs("linearGradient", { id: "paint0_linear_1_1185", x1: "30.5905", y1: "64.9699", x2: "70.4187", y2: "27.5482", gradientUnits: "userSpaceOnUse", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { stopColor: "#C08C20" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { offset: "0.0448277", stopColor: "#C99A2F" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { offset: "0.1203", stopColor: "#D5AB42" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { offset: "0.1981", stopColor: "#DCB64D" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { offset: "0.2809", stopColor: "#DEB951" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { offset: "0.5177", stopColor: "#FEF3A4" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { offset: "0.8572", stopColor: "#E4C35C" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { offset: "0.9407", stopColor: "#B78115" })
  ] }) })
] }));
ThirtyDayBadge.displayName = "ThirtyDayBadge";
const ThirtyDayStamp = forwardRef((props, ref2) => /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { width: "80", height: "80", viewBox: "0 0 80 80", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img", "aria-label": "Thirty Day Stamp ", ...props, ref: ref2, children: [
  /* @__PURE__ */ jsxRuntimeExports.jsx("title", { children: "Thirty Day Stamp " }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M39.1555 7.04888H38.5511L38.4711 4.19553L36.2044 1.01334L36.8888 0.995548L38.7467 3.66221L40.4622 0.888885H41.1466L39.0666 4.19553L39.1555 7.04888ZM33.3333 7.59999L33.1911 7.06667L30.08 7.88444L29.5022 5.70665L31.9911 5.04888L31.8489 4.51557L29.3955 5.17334L28.8266 3.03998L31.8222 2.24886L31.68 1.72444L28.1066 2.66666L29.6355 8.5778L33.3333 7.59999ZM19.5466 7.79557L22 12.16L21.4844 12.4533L18.5155 7.12001L18.96 6.87999L24.6489 9.4222L22.1688 5.05778L22.6844 4.77333L25.68 10.1067L25.2444 10.3556L19.5466 7.79557ZM16.2222 12.5244L16.1689 12.4711C15.8772 12.1859 15.5322 11.961 15.1536 11.8094C14.7749 11.6577 14.3701 11.5821 13.9623 11.5871C13.5544 11.5921 13.1515 11.6774 12.7767 11.8382C12.4018 11.9991 12.0624 12.2323 11.7778 12.5244C11.3369 12.9642 11.0364 13.5248 10.9143 14.1355C10.7923 14.7461 10.8542 15.3792 11.0921 15.9546C11.33 16.5301 11.7333 17.022 12.251 17.3681C12.7686 17.7142 13.3773 17.8989 14 17.8989C14.6227 17.8989 15.2314 17.7142 15.749 17.3681C16.2666 17.022 16.6699 16.5301 16.9079 15.9546C17.1458 15.3792 17.2077 14.7461 17.0856 14.1355C16.9635 13.5248 16.6631 12.9642 16.2222 12.5244ZM12.24 16.5511C11.7617 16.0865 11.4874 15.4511 11.4774 14.7843C11.4674 14.1177 11.7225 13.4743 12.1866 12.9955C12.5389 12.6405 12.9886 12.398 13.4789 12.2989C13.9691 12.1998 14.4778 12.2486 14.9403 12.4391C15.4027 12.6296 15.7982 12.9531 16.0765 13.3687C16.3548 13.7843 16.5034 14.2732 16.5034 14.7733C16.5034 15.2735 16.3548 15.7624 16.0765 16.1779C15.7982 16.5935 15.4027 16.9171 14.9403 17.1076C14.4778 17.298 13.9691 17.3468 13.4789 17.2478C12.9886 17.1487 12.5389 16.9062 12.1866 16.5511H12.24ZM4.89775 24.7289L9.24443 26.9955L8.96887 27.5289L3.55554 24.6756L3.79553 24.2133L8.41777 23.84L6.07109 19.8222L6.31108 19.36L11.7333 22.2044L11.4489 22.7378L7.12887 20.4533L9.11997 24.0089L8.93331 24.3644L4.89775 24.7289ZM25.04 24.1955C26.2789 23.4202 27.7215 23.0333 29.1822 23.0844C30.6001 23.0227 32.0053 23.3748 33.2266 24.0978C33.7097 24.3734 34.1097 24.7737 34.3849 25.2569C34.6601 25.7401 34.8004 26.2884 34.7911 26.8445C34.7692 27.499 34.5976 28.1398 34.2894 28.7176C33.9812 29.2955 33.5447 29.795 33.0133 30.1778C31.5969 31.253 29.9351 31.9587 28.1777 32.2311C30.1266 32.0688 32.0802 32.483 33.7955 33.4222C34.4745 33.7879 35.039 34.3344 35.4266 35.0012C35.8141 35.668 36.0095 36.429 35.9911 37.2C35.9772 38.0182 35.7855 38.8235 35.4294 39.5602C35.0733 40.297 34.5613 40.9475 33.9289 41.4667C32.4031 42.8067 30.6001 43.7932 28.6489 44.3556C26.5417 45.025 24.3442 45.3667 22.1333 45.3689V44.72C23.5933 44.6756 25.0306 44.3465 26.3644 43.7511C27.6879 43.1996 28.8543 42.3293 29.76 41.2178C30.6565 40.1038 31.1317 38.7096 31.1022 37.28C31.1651 36.153 30.8524 35.037 30.2133 34.1067C29.9308 33.708 29.5635 33.3768 29.1378 33.137C28.712 32.8973 28.2385 32.7548 27.7511 32.72C27.4627 32.8626 27.1659 32.9873 26.8622 33.0933C26.6134 33.1807 26.3525 33.2287 26.0889 33.2356C25.68 33.2356 25.4844 33.0044 25.4755 32.7822C25.4666 32.56 25.6889 32.0178 26.5155 32.0622C26.8885 32.0998 27.2593 32.1561 27.6266 32.2311C28.3797 31.7606 28.9996 31.1051 29.4275 30.3271C29.8554 29.5492 30.077 28.6745 30.0711 27.7867C30.1033 27.391 30.051 26.993 29.9177 26.619C29.7844 26.2451 29.573 25.9038 29.2978 25.6178C28.6996 25.1123 27.9278 24.8603 27.1466 24.9155C26.2993 24.906 25.4657 25.1306 24.7378 25.5644C23.9982 26.0394 23.3875 26.6898 22.96 27.4578L22.3733 27.1644C23.0131 25.9766 23.9273 24.9587 25.04 24.1955ZM55.6 27.2C56.3722 28.5747 56.7649 30.1301 56.7378 31.7066C56.7655 33.3515 56.3642 34.9753 55.5733 36.4177C54.808 37.7961 53.6717 38.9325 52.2933 39.6978C50.8499 40.4649 49.244 40.8756 47.6096 40.8957C45.9751 40.9158 44.3596 40.5447 42.8977 39.8133C41.5748 39.1223 40.4768 38.0675 39.7333 36.7733C38.9493 35.39 38.5532 33.8208 38.5866 32.2311C38.5603 30.5988 38.9585 28.9876 39.7422 27.5556C40.4999 26.1805 41.6267 25.0445 42.9955 24.2756C44.4499 23.5129 46.064 23.1049 47.7061 23.0848C49.3482 23.0647 50.9718 23.4332 52.4444 24.16C53.7647 24.8516 54.8596 25.9064 55.6 27.2ZM49.8489 39.3066C50.5327 38.4431 51.0155 37.438 51.2622 36.3644C51.6361 34.8831 51.8125 33.3587 51.7866 31.8311C51.7866 29.0667 51.3955 27.0222 50.5955 25.6889C50.3133 25.1117 49.88 24.6217 49.3415 24.2712C48.8031 23.9206 48.1798 23.7224 47.5377 23.6978C47.1388 23.7007 46.7453 23.7904 46.3845 23.9608C46.0238 24.1312 45.7045 24.3781 45.4489 24.6845C44.7458 25.5303 44.2579 26.5336 44.0267 27.6089C43.6634 29.0889 43.4931 30.6096 43.52 32.1333C43.52 34.9007 43.917 36.954 44.7111 38.2933C44.9872 38.8788 45.4179 39.3779 45.9567 39.7365C46.4956 40.0953 47.1222 40.3001 47.7689 40.3289C48.1701 40.326 48.5656 40.2325 48.9257 40.0556C49.2858 39.8786 49.6014 39.6226 49.8489 39.3066ZM33.2444 53.9645C33.2444 52.7857 32.7762 51.6552 31.9427 50.8217C31.1092 49.9882 29.9787 49.52 28.8 49.52H25.5289V58.4089H28.8089C29.9861 58.4065 31.1142 57.9372 31.9458 57.104C32.7774 56.2708 33.2444 55.1417 33.2444 53.9645ZM28.6311 56.7555H27.4489V51.1822H28.6311C29.343 51.2224 30.0124 51.5336 30.5022 52.0518C30.9919 52.5699 31.2647 53.2559 31.2647 53.9689C31.2647 54.6819 30.9919 55.3678 30.5022 55.886C30.0124 56.4042 29.343 56.7153 28.6311 56.7555ZM35.7244 58.4177L39.1378 49.5289H41.0133L44.4178 58.4177H42.5155L41.7422 56.3822H38.4444L37.6711 58.4177H35.7244ZM40.08 51.68L39.0311 54.7466H41.1289L40.08 51.68ZM49.8222 52.8356L47.7866 49.52H45.6711L48.8622 54.4889V58.4177H50.8V54.4889L53.9822 49.52H51.8578L49.8222 52.8356ZM46.9955 5.10221L44.3289 4.66666L44.24 5.19998L46.96 5.66221L46.9955 5.10221ZM53.2745 9.76112C53.0397 9.75276 52.809 9.69802 52.5955 9.59999L52.5244 9.56445L50.5155 8.72889L52.7911 3.05778L54.7111 3.82221C55.1276 3.93723 55.4837 4.20833 55.7056 4.57915C55.9274 4.94992 55.9978 5.39192 55.9022 5.81331C55.8988 5.8361 55.8944 5.85872 55.889 5.88107C55.887 5.88905 55.8849 5.89697 55.8827 5.90484C55.8802 5.91368 55.8776 5.92252 55.8748 5.93131L55.8699 5.94607C55.8636 5.9643 55.8566 5.98231 55.8489 6C55.7395 6.27056 55.5532 6.50314 55.3131 6.66905C55.073 6.8349 54.7895 6.92681 54.4978 6.93332C54.7697 7.12945 54.9647 7.41438 55.0491 7.73893C55.1335 8.06347 55.102 8.40733 54.96 8.7111C54.864 8.92545 54.7264 9.11865 54.5553 9.27956C54.3842 9.44048 54.1829 9.56586 53.9631 9.64854C53.7432 9.73117 53.5092 9.76942 53.2745 9.76112ZM54.6311 4.40891L53.1822 3.79557L52.2933 5.82221L53.7155 6.39111C53.9647 6.51394 54.2514 6.53727 54.5172 6.45638C54.7831 6.37548 55.0081 6.19639 55.1466 5.95556C55.1726 5.90749 55.1935 5.85688 55.2089 5.80441C55.2358 5.74262 55.2567 5.67849 55.2713 5.61301C55.2872 5.54161 55.2956 5.46853 55.2963 5.39496C55.2976 5.25396 55.2705 5.11415 55.2166 4.98388C55.1626 4.85362 55.083 4.73551 54.9824 4.63672C54.8818 4.53797 54.7623 4.46045 54.6311 4.40891ZM53.6 6.89778L52.1155 6.31109L51.2889 8.46224L52.7733 9.05778C53.0654 9.18348 53.3947 9.19173 53.6927 9.08078C53.9907 8.96983 54.2345 8.74831 54.3733 8.46224C54.3781 8.43874 54.3781 8.41455 54.3733 8.39111C54.4634 8.09049 54.4332 7.7666 54.2889 7.48795C54.1445 7.20925 53.8975 6.99761 53.6 6.89778ZM61.4844 14.88L63.12 8.52441L62.6044 8.15109L57.0755 11.7066L57.6266 12.0711L59.3067 10.9955L61.4844 12.5333L60.9866 14.5511L61.4844 14.88ZM59.7955 10.64L62.4622 8.91552L61.6711 11.9733L59.7955 10.64ZM68.1422 19.8844V20.4266C67.6549 20.4747 67.1633 20.4007 66.7118 20.2114C66.2602 20.0221 65.8629 19.7234 65.5555 19.3422C65.2876 19.0241 65.085 18.6564 64.9592 18.26C64.8335 17.8636 64.787 17.4463 64.8225 17.032C64.858 16.6176 64.9747 16.2143 65.1661 15.845C65.3575 15.4758 65.6197 15.1479 65.9378 14.88C66.2558 14.6121 66.6236 14.4095 67.02 14.2837C67.4164 14.1579 67.8337 14.1114 68.248 14.147C68.6624 14.1825 69.0657 14.2992 69.4349 14.4906C69.8042 14.6819 70.1321 14.9441 70.4 15.2622C70.7034 15.609 70.9216 16.0218 71.0373 16.4678C71.1531 16.9137 71.1631 17.3806 71.0666 17.8311L70.4622 17.76C70.5572 17.3957 70.5606 17.0135 70.4722 16.6475C70.3838 16.2815 70.2063 15.943 69.9555 15.6622C69.5135 15.14 68.8821 14.8148 68.2003 14.7581C67.8628 14.7301 67.5229 14.7688 67.2003 14.8721C66.8777 14.9753 66.5785 15.1411 66.32 15.36C66.0614 15.5789 65.8485 15.8465 65.6934 16.1477C65.5383 16.4488 65.444 16.7776 65.4159 17.1152C65.3878 17.4528 65.4266 17.7926 65.5298 18.1152C65.6331 18.4379 65.7989 18.737 66.0178 18.9955C66.2679 19.3112 66.5939 19.5583 66.9654 19.7138C67.337 19.8692 67.7418 19.9279 68.1422 19.8844ZM69.3689 24.8622L71.0044 24.08L72.6755 24.5156L70.7733 27.8133L71.0844 28.4622L73.2533 24.6845L76.48 25.5733L76.1422 24.88L71.7955 23.7244L74.8888 22.2489L74.6311 21.7066L69.1111 24.3289L69.3689 24.8622ZM18.1244 69.8933L20.1689 67.3778L20.6311 67.7867L18.16 70.7911C17.9453 71.0061 17.6904 71.1767 17.4097 71.2931C17.1291 71.4094 16.8282 71.4693 16.5244 71.4693C16.2206 71.4693 15.9197 71.4094 15.6391 71.2931C15.3585 71.1767 15.1035 71.0061 14.8889 70.7911C14.5032 70.4198 14.2627 69.923 14.2106 69.3902C14.1585 68.8574 14.2981 68.3235 14.6044 67.8844L17.0311 64.8445L17.4933 65.2178L15.2178 68.0267C14.9326 68.382 14.7997 68.8357 14.848 69.2887C14.8963 69.7417 15.1219 70.1572 15.4755 70.4444C15.6472 70.5875 15.8455 70.6951 16.059 70.761C16.2725 70.8268 16.4969 70.8497 16.7193 70.8282C16.9417 70.8067 17.1577 70.7413 17.3546 70.6357C17.5516 70.5302 17.7256 70.3866 17.8666 70.2133L18.1244 69.8933ZM20.5333 74.8978L21.1022 75.1644L22.5955 73.7689L25.0311 74.9156L24.8977 76.96L25.4578 77.2267L25.9022 70.6667L25.3244 70.4L20.5333 74.8978ZM25.0844 74.3289L23.0133 73.3511L25.3067 71.1733L25.0844 74.3289ZM31.1733 72.6311L33.4666 73.1111C33.9272 73.2099 34.3324 73.4816 34.5986 73.8702C34.8649 74.2588 34.972 74.7348 34.8977 75.2C34.8363 75.5925 34.6406 75.9515 34.3439 76.2158C34.0472 76.48 33.6681 76.6331 33.2711 76.6489L34.0267 79.44L33.3511 79.3066L32.6222 76.56L31.04 76.2311L30.5244 78.72L29.9378 78.6222L31.1733 72.6311ZM33.7425 75.9077C34.0175 75.726 34.2092 75.4428 34.2755 75.12C34.3093 74.9595 34.311 74.7938 34.2806 74.6326C34.2501 74.4714 34.188 74.3178 34.098 74.1807C34.0079 74.0436 33.8917 73.9256 33.7559 73.8335C33.6201 73.7415 33.4674 73.6772 33.3067 73.6444L31.6533 73.2977L31.1466 75.7422L32.8089 76.0889C33.1318 76.1545 33.4676 76.0893 33.7425 75.9077ZM40.5333 73.6711L38.3022 79.8933H38.96L39.6533 77.9289L42.32 77.8489L43.1289 79.7333H43.7511L41.1644 73.6889L40.5333 73.6711ZM39.8489 77.3867L40.9066 74.4L42.1422 77.3155L39.8489 77.3867ZM52.1777 76.7733L50.8089 71.9556L51.3778 71.7956L53.0489 77.6622L52.5689 77.7956L47.6177 74L48.9955 78.8178L48.4266 78.9778L46.7467 73.0844L47.2266 72.9511L52.1777 76.7733ZM58.5778 68.7111L58.3111 68.24L54.4355 70.4533L54.7022 70.9244L56.3822 69.9733L59.1466 74.8L59.6622 74.4978L56.9066 69.6622L58.5778 68.7111ZM63.6889 68.2933L65.2089 69.9556L67.5911 67.7956L67.9644 68.2044L65.1378 70.7733L61.0311 66.1955L63.7689 63.7066L64.1333 64.1156L61.84 66.1955L63.3155 67.8222L65.2266 66.1067L65.6 66.5156L63.6889 68.2933ZM71.12 63.5733L69.2711 62.2756L70.7555 60.2044L70.3022 59.8844L68.8 61.9556L67.0222 60.6845L68.8 58.1511L68.3466 57.84L66.2222 60.8267L71.2266 64.3822L73.4222 61.2267L72.9689 60.9067L71.12 63.5733ZM8.37398 64.2556C7.80006 63.6601 7.48371 62.8626 7.49331 62.0355C7.50905 61.5278 7.64251 61.0307 7.88315 60.5834C8.12379 60.1361 8.46502 59.7507 8.87998 59.4578C9.39726 59.0994 10.0108 58.9059 10.6401 58.9025C11.2694 58.8991 11.885 59.0862 12.406 59.439C12.9271 59.7918 13.3293 60.2939 13.5599 60.8795C13.7904 61.4651 13.8384 62.1066 13.6977 62.72L13.0933 62.6311C13.1931 62.2743 13.2089 61.8992 13.1395 61.5353C13.0701 61.1713 12.9174 60.8284 12.6933 60.5333C12.4956 60.2639 12.2466 60.0362 11.9605 59.8634C11.6745 59.6906 11.357 59.5762 11.0265 59.5266C10.6961 59.477 10.359 59.4933 10.0348 59.5745C9.71068 59.6558 9.4058 59.8004 9.13776 60C8.60111 60.3838 8.23016 60.957 8.09981 61.6038C7.96947 62.2505 8.08945 62.9227 8.43553 63.4844L8.50663 63.5822C8.71667 63.889 8.99581 64.1421 9.32157 64.3212C9.64737 64.5003 10.0106 64.6004 10.3822 64.6133L11.3422 63.92L10.3466 62.5511L10.7822 62.2311L12.1244 64.0622L10.56 65.2178C9.73317 65.1968 8.94788 64.8512 8.37398 64.2556Z", fill: "#282624" })
] }));
ThirtyDayStamp.displayName = "ThirtyDayStamp";
const TrustIllustration = forwardRef((props, ref2) => /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { width: "56", height: "56", viewBox: "0 0 56 56", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img", "aria-label": "Trust Illustration ", ...props, ref: ref2, children: [
  /* @__PURE__ */ jsxRuntimeExports.jsx("title", { children: "Trust Illustration " }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M28.1895 6.95783L36.3385 9.23955C39.8875 10.2627 43.6399 10.3569 47.2358 9.51322L47.8517 9.36871L47.7898 32.9624L47.775 33.0217C45.7669 41.0232 38.1587 47.4608 28.2527 49.5393L28.1351 49.564L28.0191 49.5326C24.1735 48.4898 19.8258 46.3641 16.1815 43.5072C12.543 40.655 9.55344 37.0319 8.51559 32.9739L8.5 32.9129V9.40421L11.0167 9.84758L11.0185 9.84788C14.496 10.4729 18.074 10.2313 21.436 9.1443C21.4361 9.14428 21.4359 9.14432 21.436 9.1443L28.1895 6.95783ZM28.2105 8.00216L21.744 10.0957C18.2259 11.2332 14.4815 11.4862 10.8424 10.8323C10.8421 10.8322 10.8427 10.8323 10.8424 10.8323L9.5 10.5958V32.7864C10.4766 36.525 13.2709 39.9549 16.7985 42.7202C20.3025 45.4671 24.4789 47.5173 28.165 48.5357C37.7152 46.4938 44.8833 40.3184 46.7902 32.8371L46.8484 10.6222C43.2753 11.3559 39.5743 11.2128 36.0634 10.201C36.0627 10.2008 36.0621 10.2006 36.0615 10.2004L28.2105 8.00216Z", fill: "#0B3541" }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M55.4033 8.64638C55.5986 8.84161 55.5986 9.15819 55.4034 9.35349L28.3498 36.4172L15.1562 23.2236C14.961 23.0283 14.961 22.7117 15.1562 22.5164C15.3515 22.3212 15.6681 22.3212 15.8633 22.5164L28.3497 35.0028L54.6961 8.64651C54.8914 8.45121 55.208 8.45115 55.4033 8.64638Z", fill: "#90AFAA" })
] }));
TrustIllustration.displayName = "TrustIllustration";
const VisaLogoLarge = forwardRef((props, ref2) => /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { width: "68", height: "46", viewBox: "0 0 68 46", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img", "aria-label": "Visa Logo Large ", ...props, ref: ref2, children: [
  /* @__PURE__ */ jsxRuntimeExports.jsxs("g", { filter: "url(#filter0_dd_1_1094)", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("title", { children: "Visa Logo Large " }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2 4C2 2.34315 3.34315 1 5 1H63C64.6569 1 66 2.34315 66 4V40C66 41.6569 64.6569 43 63 43H5C3.34315 43 2 41.6569 2 40V4Z", fill: "#F4F6F7" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2 4C2 2.34315 3.34315 1 5 1H63C64.6569 1 66 2.34315 66 4V11H2V4Z", fill: "#4095DB" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2 33H66V40C66 41.6569 64.6569 43 63 43H5C3.34315 43 2 41.6569 2 40V33Z", fill: "#F4B662" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M41.2295 16.4879C40.657 16.2546 39.7567 16 38.635 16C35.7724 16 33.7574 17.5778 33.7407 19.8367C33.7225 21.5075 35.1786 22.4396 36.2764 22.995C37.4046 23.5643 37.7837 23.9286 37.7792 24.4376C37.7714 25.2162 36.8787 25.5729 36.0462 25.5729C34.887 25.5729 34.2711 25.3973 33.3189 24.9633L32.9464 24.7782L32.5415 27.3804C33.2167 27.7042 34.4683 27.9852 35.7673 28C38.8096 28 40.7864 26.4415 40.8096 24.0292C40.82 22.7042 40.0485 21.6996 38.3775 20.8704C37.3657 20.3315 36.7447 19.9744 36.7518 19.4288C36.7525 18.9455 37.2764 18.4284 38.4105 18.4284C39.3576 18.4126 40.0432 18.6387 40.5774 18.875L40.8374 19.008L41.2295 16.4879ZM27.8315 27.8276L29.6428 16.2026H32.5382L30.727 27.8276H27.8315ZM46.2383 20.4568C46.2383 20.4568 45.3249 23.0379 45.0849 23.7061H47.4886C47.3742 23.1249 46.8186 20.3502 46.8186 20.3502L46.6232 19.3476C46.546 19.5776 46.4384 19.8823 46.3565 20.1143L46.3561 20.1152L46.356 20.1156C46.2829 20.3225 46.2304 20.4712 46.2383 20.4568ZM48.657 16.2144H46.4193C45.7253 16.2144 45.2058 16.4201 44.9018 17.1781L40.6019 27.8318H43.643C43.643 27.8318 44.1392 26.3986 44.2518 26.084C44.4077 26.084 45.1431 26.0854 45.9226 26.0868H45.9226L45.923 26.0868C46.8019 26.0884 47.7368 26.09 47.9603 26.09C48.047 26.4957 48.3128 27.8318 48.3128 27.8318H51.0002L48.657 16.2144ZM25.4023 16.2124L22.5683 24.1379L22.2648 22.5268C22.2646 22.5262 22.2644 22.5255 22.2643 22.5249C22.2645 22.5255 22.2647 22.5262 22.2649 22.5268L21.2503 17.1853C21.0752 16.4486 20.5665 16.2302 19.9377 16.2045H15.2686L15.23 16.4453C16.3659 16.7464 17.3816 17.1805 18.2717 17.7204L20.8466 27.8175L23.9109 27.8156L28.4706 16.2124H25.4023Z", fill: "#0071CE" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2 4C2 2.34315 3.34315 1 5 1H63C64.6569 1 66 2.34315 66 4V40C66 41.6569 64.6569 43 63 43H5C3.34315 43 2 41.6569 2 40V4Z", fill: "#E5E5E5", fillOpacity: "0.01" })
  ] }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("defs", { children: /* @__PURE__ */ jsxRuntimeExports.jsxs("filter", { id: "filter0_dd_1_1094", x: "0", y: "0", width: "68", height: "46", filterUnits: "userSpaceOnUse", colorInterpolationFilters: "sRGB", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("feFlood", { floodOpacity: "0", result: "BackgroundImageFix" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("feColorMatrix", { in: "SourceAlpha", type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0", result: "hardAlpha" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("feOffset", { dy: "1" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("feGaussianBlur", { stdDeviation: "1" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("feComposite", { in2: "hardAlpha", operator: "out" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("feColorMatrix", { type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("feBlend", { mode: "normal", in2: "BackgroundImageFix", result: "effect1_dropShadow_1_1094" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("feColorMatrix", { in: "SourceAlpha", type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0", result: "hardAlpha" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("feOffset", {}),
    /* @__PURE__ */ jsxRuntimeExports.jsx("feGaussianBlur", { stdDeviation: "0.5" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("feColorMatrix", { type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("feBlend", { mode: "normal", in2: "effect1_dropShadow_1_1094", result: "effect2_dropShadow_1_1094" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("feBlend", { mode: "normal", in: "SourceGraphic", in2: "effect2_dropShadow_1_1094", result: "shape" })
  ] }) })
] }));
VisaLogoLarge.displayName = "VisaLogoLarge";
const VisaLogoSmall = forwardRef((props, ref2) => /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { width: "36", height: "25", viewBox: "0 0 36 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img", "aria-label": "Visa Logo Small ", ...props, ref: ref2, children: [
  /* @__PURE__ */ jsxRuntimeExports.jsxs("g", { filter: "url(#filter0_dd_1_1031)", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("title", { children: "Visa Logo Small " }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2 2.5C2 1.67157 2.67157 1 3.5 1H32.5C33.3284 1 34 1.67157 34 2.5V20.5C34 21.3284 33.3284 22 32.5 22H3.5C2.67157 22 2 21.3284 2 20.5V2.5Z", fill: "#F4F6F7" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2 2.5C2 1.67157 2.67157 1 3.5 1H32.5C33.3284 1 34 1.67157 34 2.5V6H2V2.5Z", fill: "#4095DB" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2 17H34V20.5C34 21.3284 33.3284 22 32.5 22H3.5C2.67157 22 2 21.3284 2 20.5V17Z", fill: "#F4B662" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M22.1402 8.28462C21.8288 8.14852 21.3392 8 20.7291 8C19.1722 8 18.0763 8.92035 18.0672 10.2381C18.0573 11.2127 18.8493 11.7564 19.4463 12.0804C20.0599 12.4125 20.2661 12.625 20.2637 12.9219C20.2594 13.3761 19.7739 13.5842 19.3211 13.5842C18.6907 13.5842 18.3557 13.4818 17.8378 13.2286L17.6353 13.1206L17.415 14.6386C17.7822 14.8274 18.463 14.9914 19.1694 15C20.8241 15 21.8992 14.0909 21.9118 12.6837C21.9175 11.9108 21.4979 11.3248 20.5891 10.8411C20.0388 10.5267 19.701 10.3184 19.7049 10.0001C19.7053 9.71823 19.9902 9.41658 20.607 9.41658C21.1221 9.40737 21.495 9.53927 21.7855 9.67707L21.9269 9.75468L22.1402 8.28462ZM14.8535 14.8995L15.8387 8.11817H17.4134L16.4283 14.8995H14.8535ZM24.8646 10.5998C24.8646 10.5998 24.3678 12.1054 24.2373 12.4952H25.5446C25.4824 12.1562 25.1802 10.5376 25.1802 10.5376L25.0739 9.95277C25.032 10.0868 24.9735 10.2643 24.929 10.3996L24.9288 10.4002L24.9286 10.4008L24.9285 10.401C24.8888 10.5216 24.8603 10.6082 24.8646 10.5998ZM26.1798 8.12508H24.9628C24.5853 8.12508 24.3028 8.24506 24.1374 8.68721L21.7988 14.9019H23.4528C23.4528 14.9019 23.7227 14.0658 23.7839 13.8824C23.8687 13.8824 24.2687 13.8831 24.6926 13.884C25.1707 13.8849 25.6793 13.8859 25.8009 13.8859C25.848 14.1225 25.9926 14.9019 25.9926 14.9019H27.4542L26.1798 8.12508ZM13.5324 8.12388L11.991 12.7471L11.8259 11.8073C11.8257 11.8064 11.8255 11.8056 11.8253 11.8047C11.8255 11.8056 11.8258 11.8064 11.8261 11.8073L11.2743 8.69142C11.1791 8.26169 10.9024 8.1343 10.5604 8.11928H8.02099L8 8.25978C8.61772 8.43538 9.1701 8.68858 9.6542 9.0035L11.0546 14.8935L12.7212 14.8924L15.2011 8.12388H13.5324Z", fill: "#0071CE" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2 2.5C2 1.67157 2.67157 1 3.5 1H32.5C33.3284 1 34 1.67157 34 2.5V20.5C34 21.3284 33.3284 22 32.5 22H3.5C2.67157 22 2 21.3284 2 20.5V2.5Z", fill: "#E5E5E5", fillOpacity: "0.01" })
  ] }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("defs", { children: /* @__PURE__ */ jsxRuntimeExports.jsxs("filter", { id: "filter0_dd_1_1031", x: "0", y: "0", width: "36", height: "25", filterUnits: "userSpaceOnUse", colorInterpolationFilters: "sRGB", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("feFlood", { floodOpacity: "0", result: "BackgroundImageFix" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("feColorMatrix", { in: "SourceAlpha", type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0", result: "hardAlpha" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("feOffset", { dy: "1" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("feGaussianBlur", { stdDeviation: "1" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("feComposite", { in2: "hardAlpha", operator: "out" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("feColorMatrix", { type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("feBlend", { mode: "normal", in2: "BackgroundImageFix", result: "effect1_dropShadow_1_1031" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("feColorMatrix", { in: "SourceAlpha", type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0", result: "hardAlpha" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("feOffset", {}),
    /* @__PURE__ */ jsxRuntimeExports.jsx("feGaussianBlur", { stdDeviation: "0.5" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("feColorMatrix", { type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("feBlend", { mode: "normal", in2: "effect1_dropShadow_1_1031", result: "effect2_dropShadow_1_1031" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("feBlend", { mode: "normal", in: "SourceGraphic", in2: "effect2_dropShadow_1_1031", result: "shape" })
  ] }) })
] }));
VisaLogoSmall.displayName = "VisaLogoSmall";
var brandAssets = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  APIGearIllustration,
  APlusRatingBadge,
  AffordableIllustration,
  AmexLogoLarge,
  AmexLogoSmall,
  ApplyOnlineStamp,
  BankLogoLarge,
  BankLogoSmall,
  BestowFoundationLogo,
  CareerDevIllustration,
  CertifiedSSLBadge,
  ClockIllustration,
  DinersClubLogoLarge,
  DinersClubLogoSmall,
  DiscoverLogoLarge,
  DiscoverLogoSmall,
  EmailMarketingIllustration,
  EveryPolicyBackedStamp,
  FlexPTOIllustration,
  InAppTileIllustration,
  InstantHandIllustration,
  LandersIllustration,
  MastercardLogoLarge,
  MastercardLogoSmall,
  MedBenefitsIllustration,
  MobileIllustration,
  NoMedExamIllustration,
  PaymentCards,
  ScholarshipsIllustration,
  SnackIllustration,
  SwagIllustration,
  ThirtyDayBadge,
  ThirtyDayStamp,
  TrustIllustration,
  VisaLogoLarge,
  VisaLogoSmall
});
const flexboxGap = system({
  gap: {
    property: "gap"
  }
});
const CARD_VARIANTS = ["default", "shadow"];
const CARD_BOX_SHADOW = "0px 2px 2px 0px rgba(0, 0, 0, 0.1)";
const CARD_STYLE = {
  borderStyle: "solid",
  borderWidth: "1px",
  borderColor: `var(${TOKENS.color.border.default})`,
  background: `var(${TOKENS.color.background.surface0})`,
  boxShadow: CARD_BOX_SHADOW,
  borderRadius: `var(${TOKENS.dimension.radius.surface1})`
};
const CARD_GUTTERS_STYLE = {
  px: "24px"
};
const CARD_HEADER_STYLE = {
  paddingTop: "24px",
  paddingBottom: "12px"
};
const CARD_BODY_STYLE = {
  gap: "4px",
  py: "12px"
};
const CARD_FOOTER_STYLE = {
  py: "24px"
};
const CARD_ACTION_FOOTER_STYLE = {
  color: `var(${TOKENS.color.foreground.interaction.accent})`,
  fontWeight: "500",
  fontSize: "0.875rem",
  textAlign: "center",
  py: "16px",
  borderTopWidth: "1px",
  borderTopStyle: "solid",
  borderTopColor: `var(${TOKENS.color.border.default})`,
  hoverStyle: {
    backgroundColor: `var(${TOKENS.color.background.surface2})`,
    color: `var(${TOKENS.color.foreground.interaction.accentHover})`,
    borderBottomLeftRadius: "inherit",
    borderBottomRightRadius: "inherit"
  },
  disabledStyle: {
    backgroundColor: "transparent",
    color: `var(${TOKENS.color.foreground.interaction.disabled})`
  },
  activeStyle: {
    backgroundColor: `var(${TOKENS.color.background.surface0})`,
    color: `var(${TOKENS.color.foreground.interaction.accentActive})`
  },
  focusRingStyle: {
    gap: "1px",
    width: "2px",
    borderRadius: "4px",
    color: `var(${TOKENS.color.border.focus})`
  }
};
const StyledCardGutters = styled.div`
  ${composeWrapper([space], [])}
`;
const CardGutters = forwardRef((props, ref2) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(StyledCardGutters, { ...CARD_GUTTERS_STYLE, ...props, ref: ref2 });
});
CardGutters.displayName = "CardGutters";
const StyledCardHeader = styled.div`
  ${composeWrapper([space, border], [])}
`;
const CardHeader = forwardRef(({
  noGutters,
  ...props
}, ref2) => {
  return noGutters ? /* @__PURE__ */ jsxRuntimeExports.jsx(StyledCardHeader, { ...CARD_HEADER_STYLE, ...props, ref: ref2 }) : /* @__PURE__ */ jsxRuntimeExports.jsx(CardGutters, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(StyledCardHeader, { ...CARD_HEADER_STYLE, ...props, ref: ref2 }) });
});
CardHeader.displayName = "CardHeader";
const StyledCardBody = styled.div`
  display: flex;
  flex-direction: column;
  ${composeWrapper([space, flexbox, flexboxGap], [])}
`;
const CardBody = forwardRef(({
  noGutters,
  ...props
}, ref2) => {
  return noGutters ? /* @__PURE__ */ jsxRuntimeExports.jsx(StyledCardBody, { ...CARD_BODY_STYLE, ...props, ref: ref2 }) : /* @__PURE__ */ jsxRuntimeExports.jsx(CardGutters, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(StyledCardBody, { ...CARD_BODY_STYLE, ...props, ref: ref2 }) });
});
CardBody.displayName = "CardBody";
const StyledCardFooter = styled.div`
  ${composeWrapper([space], [])}
`;
const CardFooter = forwardRef(({
  noGutters,
  ...props
}, ref2) => {
  return noGutters ? /* @__PURE__ */ jsxRuntimeExports.jsx(StyledCardFooter, { ...CARD_FOOTER_STYLE, ...props, ref: ref2 }) : /* @__PURE__ */ jsxRuntimeExports.jsx(CardGutters, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(StyledCardFooter, { ...CARD_FOOTER_STYLE, ...props, ref: ref2 }) });
});
CardFooter.displayName = "CardFooter";
const StyledCardActionFooter = styled.button`
  /* button reset */
  border: none;
  background: none;
  /* button reset */
  cursor: pointer;
  width: 100%;
  ${composeWrapper([space, border, typography, color, svg], [Pseudostate.hover, Pseudostate.active, Pseudostate.disabled])}
  position: relative; /* required for focus ring */
  ${(props) => FocusRing(props.focusRingStyle || {})}
`;
const CardActionFooter = forwardRef((props, ref2) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(StyledCardActionFooter, { type: "button", ...CARD_ACTION_FOOTER_STYLE, ...CARD_GUTTERS_STYLE, ...props, ref: ref2 });
});
CardActionFooter.displayName = "CardActionFooter";
const StyledCard = styled.div`
  ${composeWrapper([layout, space, color, border, shadow, background], [])}

  ${({
  variant
}) => variant === "shadow" && `
      border-radius: 4px;
      box-shadow: ${CARD_BOX_SHADOW};
      border: none;
    `}
`;
const Card = forwardRef((props, ref2) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(StyledCard, { ...CARD_STYLE, ...props, ref: ref2 });
});
Card.displayName = "Card";
const KitchenSinkContainer = styled.div`
  h2 {
    margin-bottom: 10px;
  }
`;
const SpacedDiv = styled.div`
  & > * {
    margin: 10px;
  }
  margin-bottom: 20px;
  margin-top: 10px;
`;
const ShadowBoxDiv = styled.div`
  width: 100px;
  height: 100px;
  box-shadow: ${(props) => props.shadow};
  display: inline-block;
  margin: 10px;
`;
const KitchenSink = () => {
  const theme = useTheme();
  const typographyVariantArray = Object.entries(theme.typography.variants).map(([variantName, variantValues]) => {
    if ("mobile" in variantValues || "desktop" in variantValues) {
      return Object.keys(variantValues).map((responsiveKey) => `${variantName}.${responsiveKey}`);
    }
    return [variantName];
  }).flat();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [menuAnchor, setMenuAnchor] = React__default.useState();
  const [isMenuVisible, setIsMenuVisible] = React__default.useState(false);
  const renderComponentVariantsAndSizes = ({
    Component: Component2,
    themeComponentName,
    miscComponentProps,
    noChildren,
    customVariants,
    customSizes
  }) => {
    const variants = customVariants || Object.keys(omit(get$3(theme, `${themeComponentName}.variants`), "defaultVariant") || {});
    const sizes = customSizes || Object.keys(omit(get$3(theme, `${themeComponentName}.sizes`), "defaultSize") || {});
    return /* @__PURE__ */ jsxRuntimeExports.jsxs(React__default.Fragment, { children: [
      variants.length > 0 && /* @__PURE__ */ jsxRuntimeExports.jsx(Text, { element: "h2", variant: getThemeAgnosticTypography(theme.key, "headlineMedium"), children: "Variants" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(SpacedDiv, { children: variants.map((variant) => /* @__PURE__ */ jsxRuntimeExports.jsxs(React__default.Fragment, { children: [
        noChildren && variant,
        /* @__PURE__ */ jsxRuntimeExports.jsx(Component2, { variant, type: variant, ...miscComponentProps, ...!noChildren && {
          children: `${variant} variant ${Component2.displayName}`
        } })
      ] })) }),
      sizes.length > 0 && /* @__PURE__ */ jsxRuntimeExports.jsx(Text, { element: "h2", variant: getThemeAgnosticTypography(theme.key, "headlineMedium"), children: "Sizes" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(SpacedDiv, { children: sizes.map((size2) => /* @__PURE__ */ jsxRuntimeExports.jsxs(React__default.Fragment, { children: [
        noChildren && size2,
        /* @__PURE__ */ jsxRuntimeExports.jsx(Component2, { size: size2, ...miscComponentProps, ...!noChildren && {
          children: `${size2} size ${Component2.displayName}`
        } })
      ] })) })
    ] });
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(KitchenSinkContainer, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs(Text, { element: "h2", variant: getThemeAgnosticTypography(theme.key, "headlineLarge"), children: [
      " ",
      "Buttons"
    ] }),
    renderComponentVariantsAndSizes({
      Component: Button,
      themeComponentName: "buttons"
    }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Text, { element: "h2", variant: getThemeAgnosticTypography(theme.key, "headlineLarge"), children: "Inputs" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(CheckboxInput, { id: "checkity-boxity", value: "checkbox", children: "Checkbox" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(CheckboxInput, { id: "checkity-boxity", value: "checkbox", checked: true, children: "Checkbox Checked" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(RadioInput, { id: "radio", value: "radio", children: "Radio" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(RadioInput, { id: "radio", value: "radio", checked: true, children: "Radio Checked" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(CurrencyInput, { id: "currency", label: "Currency", assistiveText: "Assistive Text" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(NumericInput, { id: "numeric", label: "Numeric", assistiveText: "Assistive Text" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(PasswordInput, { id: "pword", label: "Password", assistiveText: "Assistive Text" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(PercentInput, { id: "percent", label: "Percent", assistiveText: "Assistive Text" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(PhoneInput, { id: "phone", label: "Phone", assistiveText: "Assistive Text", onChange: () => null }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(TypeaheadInput, { id: "typeaheadSingle", options: [{
      label: "Option 1",
      value: "1"
    }, {
      label: "Option 2",
      value: "2"
    }], label: "Single TypeaheadInput" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(TypeaheadInput, { id: "typeaheadMulti", options: [{
      label: "Option 1",
      value: "1"
    }, {
      label: "Option 2",
      value: "2"
    }], label: "Multi TypeaheadInput", isMulti: true }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(SSNInput, { id: "ssn", label: "SSN", assistiveText: "Assistive Text", onChange: () => null }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(TextInput, { id: "text", label: "Text", assistiveText: "Assistive Text" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(TextInput, { id: "maskedInput", label: "Custom Mask Input", mask: "dd ⚡ ddd  ⚡ dddd️", assistiveText: "Assistive Text", onChange: () => null }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(SelectInput, { id: "select", label: "Select", assistiveText: "Assistive Text", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("option", { value: "option1", children: " Option 1" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("option", { value: "option2", children: " Option 2" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("option", { value: "option3", children: " Option 3" })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(SliderInput, { max: 5, "aria-label": "slider" }),
    renderComponentVariantsAndSizes({
      Component: ButtonGroup,
      themeComponentName: "buttonGroup",
      miscComponentProps: {
        options: [{
          label: "1",
          value: 1
        }, {
          label: "2",
          value: 2
        }, {
          label: "3",
          value: 3
        }],
        name: "bgroup"
      },
      noChildren: true
    }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Text, { element: "h2", variant: getThemeAgnosticTypography(theme.key, "headlineLarge"), children: "Links" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Link, { href: "/", children: " Anchor Link " }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(Link, { href: "/", underlined: true, children: [
      " ",
      "Anchor Link (underlined)",
      " "
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(LinkButton, { children: " Link Button " }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(LinkButton, { underlined: true, children: " Link Button (underlined) " }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Text, { element: "h2", variant: getThemeAgnosticTypography(theme.key, "headlineLarge"), children: "Shadows" }),
    Object.values(theme.shadows).map((shadowValue, level) => /* @__PURE__ */ jsxRuntimeExports.jsxs(React__default.Fragment, { children: [
      shadowValue.dim && /* @__PURE__ */ jsxRuntimeExports.jsxs(ShadowBoxDiv, { shadow: shadowValue.dim, children: [
        " ",
        level,
        " - Dim",
        " "
      ] }),
      "bright" in shadowValue && shadowValue.bright && /* @__PURE__ */ jsxRuntimeExports.jsxs(ShadowBoxDiv, { shadow: shadowValue.bright, children: [
        " ",
        level,
        " - Bright",
        " "
      ] })
    ] })),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Text, { element: "h2", variant: getThemeAgnosticTypography(theme.key, "headlineLarge"), children: "Tags & Toggles" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Tag, { children: "Tag" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Toggle, { label: "Toggle" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Toggle, { toggled: true, label: "Toggle (on)" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Text, { element: "h2", variant: getThemeAgnosticTypography(theme.key, "headlineLarge"), children: "Typography" }),
    typographyVariantArray.map((variantName) => /* @__PURE__ */ jsxRuntimeExports.jsxs(Text, { element: "p", variant: variantName, children: [
      variantName,
      " text"
    ] })),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Text, { element: "h2", variant: getThemeAgnosticTypography(theme.key, "headlineLarge"), children: "Toasts & Modals" }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs($f57aed4a881a3485$export$bf688221f59024e5, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(Button, { onClick: () => {
        setIsModalOpen(true);
      }, children: "Open Modal" }),
      isModalOpen && /* @__PURE__ */ jsxRuntimeExports.jsxs(Modal, { "aria-labelledby": "modal-title", ariaDescribedBy: "modal-body", onClose: () => {
        setIsModalOpen(false);
      }, children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(ModalTitle, { id: "modal-title", children: "Title" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(ModalBody, { id: "modal-body", children: "Body" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(ModalFooter, { children: "Footer" })
      ] })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Button, { onClick: () => {
      B2(/* @__PURE__ */ jsxRuntimeExports.jsx(Toast, { type: "success", children: " Here is my Toast " }));
    }, children: "Add Toast" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Button, { ref: (element) => {
      if (element) {
        setMenuAnchor(element);
      }
    }, onClick: () => setIsMenuVisible(true), children: "Show Menu" }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(Menu$2, { zIndex: "2", onClickAway: () => setIsMenuVisible(false), visible: isMenuVisible, anchorElement: menuAnchor, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(MenuItem, { children: "1" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(MenuItem, { children: "2" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(MenuItem, { children: "3" })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(ToastContainer, {}),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(Text, { element: "h2", variant: getThemeAgnosticTypography(theme.key, "headlineLarge"), children: [
      " ",
      "Brand Assets & Icons"
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(SpacedDiv, { children: Object.values(icons).map((IconComponent) => /* @__PURE__ */ jsxRuntimeExports.jsx(IconComponent, { direction: "default" })) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(SpacedDiv, { children: Object.values(brandAssets).map((AssetComponent) => /* @__PURE__ */ jsxRuntimeExports.jsx(AssetComponent, {})) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Text, { element: "h2", variant: getThemeAgnosticTypography(theme.key, "headlineLarge"), children: "Banners" }),
    renderComponentVariantsAndSizes({
      Component: Banner,
      themeComponentName: "banners"
    }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Text, { element: "h2", variant: getThemeAgnosticTypography(theme.key, "headlineLarge"), children: "Banners" }),
    renderComponentVariantsAndSizes({
      Component: Toast,
      themeComponentName: "toasts"
    }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Text, { element: "h2", variant: getThemeAgnosticTypography(theme.key, "headlineLarge"), children: "Percentage Bar" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(PercentageBar, { percent: 25 }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Text, { element: "h2", variant: getThemeAgnosticTypography(theme.key, "headlineLarge"), children: "Divider" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Divider, { style: {
      width: "200px",
      margin: "5px"
    } }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Divider, { vertical: true, style: {
      height: "200px",
      margin: "5px"
    } }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Text, { element: "h2", variant: getThemeAgnosticTypography(theme.key, "headlineLarge"), children: "Spinner" }),
    renderComponentVariantsAndSizes({
      Component: Spinner,
      themeComponentName: "spinners"
    }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Text, { element: "h2", variant: getThemeAgnosticTypography(theme.key, "headlineLarge"), children: "Cards" }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(Card, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(CardHeader, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(Text, { variant: "headerLarge.mobile", element: "h1", children: "Card Title" }) }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(CardGutters, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(Divider, {}) }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs(CardBody, { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(Text, { variant: "labelSmall.mobile", element: "h2", children: "Optional Subheading" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Text, { variant: "headerSmall.mobile", element: "h2", children: "Heading" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Text, { variant: "bodySmall.mobile", element: "p", children: "This is where description text can live, and it’s optional" })
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(CardActionFooter, { children: "Action" })
    ] })
  ] });
};
const pulse = keyframes$1`
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.4;
  }
  100% {
    opacity: 1;
  }
`;
const wave = keyframes$1`
  0% {
    transform: translateX(-100%);
  }
  50% {
    transform: translateX(100%);
  }
  100% {
    transform: translateX(100%);
  }
`;
const StyledSkeleton = styled.div`
  display: block;
  background-color: var(${TOKENS.color.background.surface2});
  border-radius: ${({
  variant
}) => {
  switch (variant) {
    case "circular":
      return "50%";
    case "rounded":
      return `var(${TOKENS.dimension.radius.surface1})`;
    case "text":
      return "4px";
    case "rectangular":
    default:
      return "0";
  }
}};
  min-width: 1px;
  min-height: 1px;

  ${compose(layout, space)};

  ${({
  variant
}) => variant === "text" && css$3`
      height: 1em;
      margin-top: 0;
      margin-bottom: 0;
      &:empty:before {
        content: "\\00a0";
      }
    `}

  ${({
  animation
}) => {
  if (animation === false) return "";
  if (animation === "pulse") {
    return css$3`
        animation: ${pulse} 1.5s ease-in-out 0.5s infinite;
      `;
  }
  return css$3`
      position: relative;
      overflow: hidden;
      &::after {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        transform: translateX(-100%);
        background: linear-gradient(
          90deg,
          transparent,
          var(${TOKENS.color.background.surface1}),
          transparent
        );
        animation: ${wave} 2s ease-in-out 0.5s infinite;
        content: "";
      }
    `;
}}
`;
const Skeleton = forwardRef(({
  variant = "text",
  animation = "wave",
  width: width2,
  height: height2,
  ...rest
}, ref2) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(StyledSkeleton, { ...rest, variant, animation, width: width2, height: height2, "data-testid": "skeleton", ref: ref2 });
});
Skeleton.displayName = "Skeleton";
const remToPx = (remValueString) => {
  if (remValueString === void 0) {
    return "0px";
  }
  const integerValue = +remValueString.replace("rem", "");
  if (Number.isNaN(integerValue)) {
    return "0px";
  }
  return `${integerValue * 16}px`;
};
const isSupportedFont = (name) => name in FONT_FILE_MAPPINGS;
const getStripeFontProps = (env, fontFamily) => {
  if (!isSupportedFont(fontFamily)) {
    console.error("Can't find font ", fontFamily, " to load into stripe. Check FontLoader.tsx in Kindred to see supported fonts");
    return void 0;
  }
  const font = FONT_FILE_MAPPINGS[fontFamily];
  if (font.type === "systemFont") {
    return [];
  }
  if (font.type === "linkFont") {
    return [{
      cssSrc: font.linkFunction(env)
    }];
  }
  return [{
    cssSrc: `https://fonts.googleapis.com/css?${font.fontQueryString}`
  }];
};
const useResolvedStripeInputStyles = () => {
  var _a2, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _A, _B, _C, _D, _E, _F, _G, _H, _I, _J, _K, _L, _M, _N, _O, _P, _Q, _R, _S, _T, _U, _V, _W, _X, _Y, _Z, __, _$, _aa, _ba, _ca, _da, _ea, _fa, _ga, _ha, _ia, _ja, _ka, _la, _ma, _na, _oa, _pa, _qa, _ra, _sa, _ta, _ua, _va, _wa, _xa, _ya;
  const t2 = (_a2 = useKindredConfigOptional()) == null ? void 0 : _a2.tokens;
  const b2 = BESTOW_ENTERPRISE_TOKENS;
  return {
    fontFamily: ((_c = (_b = t2 == null ? void 0 : t2.text) == null ? void 0 : _b.fontFamily) == null ? void 0 : _c.primary) ?? ((_e = (_d = b2.text) == null ? void 0 : _d.fontFamily) == null ? void 0 : _e.primary) ?? "",
    fontWeight: ((_g = (_f = t2 == null ? void 0 : t2.text) == null ? void 0 : _f.fontWeight) == null ? void 0 : _g.default) ?? ((_i = (_h = b2.text) == null ? void 0 : _h.fontWeight) == null ? void 0 : _i.default) ?? "",
    borderRadius: ((_l = (_k = (_j = t2 == null ? void 0 : t2.dimension) == null ? void 0 : _j.radius) == null ? void 0 : _k.interaction) == null ? void 0 : _l.inputLarge) ?? ((_o = (_n = (_m = b2.dimension) == null ? void 0 : _m.radius) == null ? void 0 : _n.interaction) == null ? void 0 : _o.inputLarge) ?? "",
    color: ((_q = (_p = t2 == null ? void 0 : t2.color) == null ? void 0 : _p.foreground) == null ? void 0 : _q.default) ?? ((_s = (_r = b2.color) == null ? void 0 : _r.foreground) == null ? void 0 : _s.default) ?? "",
    subdued: ((_u = (_t = t2 == null ? void 0 : t2.color) == null ? void 0 : _t.foreground) == null ? void 0 : _u.subdued) ?? ((_w = (_v = b2.color) == null ? void 0 : _v.foreground) == null ? void 0 : _w.subdued) ?? "",
    onAccent: ((_z = (_y = (_x = t2 == null ? void 0 : t2.color) == null ? void 0 : _x.foreground) == null ? void 0 : _y.interaction) == null ? void 0 : _z.onAccent) ?? ((_C = (_B = (_A = b2.color) == null ? void 0 : _A.foreground) == null ? void 0 : _B.interaction) == null ? void 0 : _C.onAccent) ?? "",
    borderDefault: ((_F = (_E = (_D = t2 == null ? void 0 : t2.color) == null ? void 0 : _D.border) == null ? void 0 : _E.interaction) == null ? void 0 : _F.neutral) ?? ((_I = (_H = (_G = b2.color) == null ? void 0 : _G.border) == null ? void 0 : _H.interaction) == null ? void 0 : _I.neutral) ?? "",
    borderHover: ((_L = (_K = (_J = t2 == null ? void 0 : t2.color) == null ? void 0 : _J.border) == null ? void 0 : _K.interaction) == null ? void 0 : _L.neutralHover) ?? ((_O = (_N = (_M = b2.color) == null ? void 0 : _M.border) == null ? void 0 : _N.interaction) == null ? void 0 : _O.neutralHover) ?? "",
    borderSelected: ((_R = (_Q = (_P = t2 == null ? void 0 : t2.color) == null ? void 0 : _P.border) == null ? void 0 : _Q.interaction) == null ? void 0 : _R.neutralSelected) ?? ((_U = (_T = (_S = b2.color) == null ? void 0 : _S.border) == null ? void 0 : _T.interaction) == null ? void 0 : _U.neutralSelected) ?? "",
    fillSelected: ((_X = (_W = (_V = t2 == null ? void 0 : t2.color) == null ? void 0 : _V.background) == null ? void 0 : _W.interaction) == null ? void 0 : _X.neutralSelected) ?? ((__ = (_Z = (_Y = b2.color) == null ? void 0 : _Y.background) == null ? void 0 : _Z.interaction) == null ? void 0 : __.neutralSelected) ?? "",
    fillSelectedHover: ((_ba = (_aa = (_$ = t2 == null ? void 0 : t2.color) == null ? void 0 : _$.background) == null ? void 0 : _aa.interaction) == null ? void 0 : _ba.neutralSelectedHover) ?? ((_ea = (_da = (_ca = b2.color) == null ? void 0 : _ca.background) == null ? void 0 : _da.interaction) == null ? void 0 : _ea.neutralSelectedHover) ?? "",
    fillPressed: ((_ha = (_ga = (_fa = t2 == null ? void 0 : t2.color) == null ? void 0 : _fa.background) == null ? void 0 : _ga.interaction) == null ? void 0 : _ha.neutralActive) ?? ((_ka = (_ja = (_ia = b2.color) == null ? void 0 : _ia.background) == null ? void 0 : _ja.interaction) == null ? void 0 : _ka.neutralActive) ?? "",
    hoverFill: ((_ma = (_la = t2 == null ? void 0 : t2.color) == null ? void 0 : _la.background) == null ? void 0 : _ma.surface2) ?? ((_oa = (_na = b2.color) == null ? void 0 : _na.background) == null ? void 0 : _oa.surface2) ?? "",
    focus: ((_qa = (_pa = t2 == null ? void 0 : t2.color) == null ? void 0 : _pa.border) == null ? void 0 : _qa.focus) ?? ((_sa = (_ra = b2.color) == null ? void 0 : _ra.border) == null ? void 0 : _sa.focus) ?? "",
    danger: ((_va = (_ua = (_ta = t2 == null ? void 0 : t2.color) == null ? void 0 : _ta.border) == null ? void 0 : _ua.feedback) == null ? void 0 : _va.danger) ?? ((_ya = (_xa = (_wa = b2.color) == null ? void 0 : _wa.border) == null ? void 0 : _xa.feedback) == null ? void 0 : _ya.danger) ?? ""
  };
};
const getStripePaymentElementsStyles = ({
  env = "production",
  options: options2
}) => {
  const resolved = useResolvedStripeInputStyles();
  const inputs = {
    fontFamily: resolved.fontFamily,
    fontSize: INPUT_STYLE_PROPS.fontSize,
    fontWeight: resolved.fontWeight,
    color: resolved.color,
    borderWidth: INPUT_STYLE_PROPS.borderWidth,
    borderColor: resolved.borderDefault,
    borderRadius: resolved.borderRadius,
    margin: INPUT_STYLE_PROPS.margin,
    marginTop: INPUT_STYLE_PROPS.marginTop,
    marginBottom: INPUT_STYLE_PROPS.marginBottom,
    labelStyles: {
      color: resolved.subdued,
      fontSize: INPUT_STYLE_PROPS.labelStyles.fontSize
    },
    hoverStyle: {
      outlineWidth: "1px",
      outlineColor: void 0,
      borderColor: resolved.borderHover
    },
    focusStyle: {
      outlineWidth: void 0,
      outlineColor: resolved.focus,
      borderColor: resolved.focus
    },
    invalidStyle: {
      outlineWidth: void 0,
      borderColor: resolved.danger
    },
    assistiveTextStyles: {
      fontSize: INPUT_STYLE_PROPS.assistiveTextStyles.fontSize,
      marginTop: INPUT_STYLE_PROPS.assistiveTextStyles.marginTop
    }
  };
  const fontFamilyToLoad = (inputs.fontFamily || "").split(",")[0] ?? "";
  const stripeFonts = getStripeFontProps(env, fontFamilyToLoad);
  return {
    fonts: stripeFonts,
    appearance: {
      theme: "none",
      labels: "floating",
      variables: {
        fontFamily: inputs.fontFamily,
        fontSizeBase: inputs.fontSize,
        colorText: inputs.color,
        spacingGridColumn: "8px",
        spacingGridRow: "8px",
        // This is a weird thing stripe does that multiplies the rest of the scaled values.
        // Dont really understand why but it's important to leave this at 1 or everything gets multiplied
        spacingUnit: "1px"
      },
      /**
       * Stripe is VERY particular about which types of styles are allowed to be added to each class.
       * e.g. `Tab` can take marginRight, but `TabIcon` cannot.
       *
       * See https://stripe.com/docs/elements/appearance-api?platform=web#rules for a full list.
       */
      rules: {
        ".Label": {
          color: inputs.labelStyles.color,
          fontSize: inputs.labelStyles.fontSize,
          fontWeight: inputs.fontWeight
        },
        ".Label--floating": {
          // TODO: This is a hardcoded value in the TextInput, should probably be connected to a themed value at some point
          fontSize: "0.75rem"
        },
        ".Input": {
          border: `${inputs.borderWidth} solid ${inputs.borderColor}`,
          borderRadius: inputs.borderRadius,
          paddingBottom: `${CSSunits.convert("px", getEffectiveMarginBottom(inputs) ?? 0) / 2}px`,
          paddingLeft: getEffectiveMarginLeft(inputs) ?? "0px",
          paddingTop: `${CSSunits.convert("px", getEffectiveMarginTop(inputs) ?? 0) / 2}px`
        },
        ".Input:hover": {
          outline: `${inputs.hoverStyle.outlineWidth || "1px"} solid ${inputs.hoverStyle.outlineColor}`,
          border: `${inputs.borderWidth} solid ${inputs.hoverStyle.borderColor}`
        },
        ".Input:focus": {
          outline: `${inputs.focusStyle.outlineWidth || "1px"} solid ${inputs.focusStyle.outlineColor}`,
          border: `${inputs.borderWidth} solid ${inputs.focusStyle.borderColor}`
        },
        ".Input--invalid": {
          boxShadow: "none",
          border: `${inputs.borderWidth} solid ${inputs.invalidStyle.borderColor}`,
          outline: `${inputs.invalidStyle.outlineWidth || "1px"} solid ${inputs.invalidStyle.borderColor}`,
          color: inputs.color
        },
        ".Input--invalid:hover": {
          boxShadow: "none",
          border: `${inputs.borderWidth} solid ${inputs.invalidStyle.borderColor}`,
          outline: `${inputs.invalidStyle.outlineWidth || "1px"} solid ${inputs.invalidStyle.borderColor}`,
          color: inputs.color
        },
        ".Input--invalid:focus": {
          boxShadow: "none",
          border: `${inputs.borderWidth} solid ${inputs.invalidStyle.borderColor}`,
          outline: `${inputs.invalidStyle.outlineWidth || "1px"} solid ${inputs.invalidStyle.borderColor}`,
          color: inputs.color
        },
        ".Error": {
          fontSize: inputs.assistiveTextStyles.fontSize,
          marginTop: inputs.assistiveTextStyles.marginTop
        },
        ".Tab": {
          border: `1px solid ${resolved.borderDefault}`,
          marginRight: "8px",
          marginBottom: "16px",
          padding: "12px"
        },
        ".Tab--selected": {
          backgroundColor: resolved.fillSelected,
          borderColor: resolved.borderSelected,
          color: options2.invertColor ? resolved.onAccent : resolved.color
        },
        ".Tab:hover, .Tab--selected:hover": {
          backgroundColor: resolved.fillSelectedHover,
          borderColor: resolved.borderSelected
        },
        ".Tab:hover": {
          border: `1px solid ${resolved.borderHover}`,
          backgroundColor: resolved.hoverFill
        },
        ".Tab:focus": {
          outline: `1px solid ${resolved.focus}`
        },
        ".Tab:active, .Tab--selected:active": {
          backgroundColor: resolved.fillPressed,
          borderColor: resolved.borderHover
        },
        ".Tab:active": {
          backgroundColor: resolved.fillPressed,
          border: `1px solid ${resolved.borderHover}`
        },
        ".TabLabel": {
          paddingTop: "8px"
        },
        ".TermsText": {
          paddingBottom: "12px"
        },
        ".TabIcon--selected": {
          fill: options2.invertColor ? resolved.onAccent : resolved.color
        },
        ".PickerItem": {
          border: `1px solid ${resolved.borderDefault}`
        },
        ".RedirectText": {
          paddingTop: "12px"
        }
      }
    }
  };
};
const getStripeInputOptions = () => {
  const resolved = useResolvedStripeInputStyles();
  return {
    style: {
      base: {
        fontWeight: resolved.fontWeight,
        fontSize: remToPx(INPUT_STYLE_PROPS.fontSize),
        fontFamily: resolved.fontFamily,
        "::placeholder": {
          color: resolved.subdued,
          fontWeight: resolved.fontWeight,
          fontSize: remToPx(INPUT_STYLE_PROPS.labelStyles.fontSize),
          fontFamily: resolved.fontFamily
        }
      }
    }
  };
};
const StripeStyledWrapper = styled.div`
  & .StripeElement {
    outline-style: solid;
    outline-width: 0;
    box-sizing: border-box;
    border-style: solid;
    font-size: ${(props) => remToPx(props.fontSize)};
    cursor: text;
    ${composeWrapper([border, background, layout, outline, color, shadow], textInputStates$1)};
    ${(props) => css$3`
      padding: ${props.margin || props.m};
      padding-top: ${props.my || props.marginTop || props.mt};
      padding-bottom: ${props.mb || props.marginBottom || props.mb};
      padding-left: ${props.mx || props.marginLeft || props.ml};
    `}
  }
  & .StripeElement--focus {
    ${(props) => compose(border, background, layout, outline, color, shadow)(props.focusStyle)};
    &:hover {
      ${(props) => compose(border, background, layout, outline, color, shadow)(props.focusStyle)};
    }
  }
  & .StripeElement--invalid {
    ${(props) => composeWrapper([border, background, layout, outline, color, shadow], [Pseudostate.hover])(props.invalidStyle)};
  }
  iframe .InputElement {
    /* Set the base rem size inside the iframe (they had a different default size for some reason) */
    font-size: 16px;
  }
  .InputElement {
    font-size: ${(props) => remToPx(props.fontSize)};
  }
`;
const StripeStyleWrapper = forwardRef(({
  variant = "numeric",
  children
}, ref2) => {
  const themedProps = {
    ...INPUT_STYLE_PROPS,
    ...variant === "numeric" ? INPUT_NUMERIC_VARIANT_STYLE_PROPS : {}
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(StripeStyledWrapper, { ...themedProps, ref: ref2, children });
});
StripeStyledWrapper.displayName = "StripeStyleWrapper";
const v = (token2) => `var(${token2})`;
const STEPPER_BACKGROUND_BY_STAGE = {
  complete: v(TOKENS.color.background.feedback.successStrong),
  active: v(TOKENS.color.background.interaction.neutral),
  incomplete: v(TOKENS.color.background.interaction.neutral),
  stalled: v(TOKENS.color.background.interaction.neutral),
  failed: v(TOKENS.color.background.feedback.dangerStrong)
};
const STEPPER_BORDER_BY_STAGE = {
  complete: v(TOKENS.color.border.feedback.success),
  active: v(TOKENS.color.border.feedback.success),
  incomplete: v(TOKENS.color.border.default),
  stalled: v(TOKENS.color.border.feedback.warning),
  failed: v(TOKENS.color.border.feedback.danger)
};
const STEPPER_ICON_BY_STAGE = {
  complete: v(TOKENS.color.foreground.interaction.onReverse),
  failed: v(TOKENS.color.foreground.interaction.onReverse),
  active: v(TOKENS.color.border.feedback.success),
  stalled: v(TOKENS.color.border.feedback.warning),
  incomplete: v(TOKENS.color.border.default)
};
const STEPPER_SIZES$1 = {
  small: {
    circleSize: "18px",
    iconSize: "10px",
    circleBorderWidth: "1px",
    lineWidth: "1px",
    bodyMarginLeft: "24px",
    bodyMarginTop: "0px",
    dateTop: "0px",
    titleVariant: "headerSmall",
    titleFontWeight: "600",
    descriptionVariant: "bodySmall"
  },
  large: {
    circleSize: "40px",
    iconSize: "24px",
    circleBorderWidth: "2px",
    lineWidth: "2px",
    bodyMarginLeft: "16px",
    bodyMarginTop: "4px",
    dateTop: "8px",
    titleVariant: "labelXSmall",
    titleFontWeight: "600",
    descriptionVariant: "bodyMedium"
  }
};
const STEPPER_DEFAULT_SIZE = "large";
const isStepperSize = (size2) => size2 !== void 0 && size2 in STEPPER_SIZES$1;
const stepperSizeProps = (size2) => isStepperSize(size2) ? STEPPER_SIZES$1[size2] : void 0;
const StepperCircleWrapper = styled.div`
  box-sizing: border-box;
  background-color: ${({
  stage
}) => STEPPER_BACKGROUND_BY_STAGE[stage] ?? STEPPER_BACKGROUND_BY_STAGE.incomplete};
  border: ${({
  stage,
  size: size2
}) => {
  var _a2;
  const borderWidth2 = ((_a2 = stepperSizeProps(size2)) == null ? void 0 : _a2.circleBorderWidth) || "2px";
  const borderColor2 = STEPPER_BORDER_BY_STAGE[stage] ?? STEPPER_BORDER_BY_STAGE.incomplete;
  return `${borderWidth2} solid ${borderColor2}`;
}};
  width: ${({
  size: size2
}) => {
  var _a2;
  return ((_a2 = stepperSizeProps(size2)) == null ? void 0 : _a2.circleSize) || "40px";
}};
  height: ${({
  size: size2
}) => {
  var _a2;
  return ((_a2 = stepperSizeProps(size2)) == null ? void 0 : _a2.circleSize) || "40px";
}};
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  line-height: 0;

  /* Override path fill for icons that have hardcoded fill (e.g., CheckmarkShorterIcon) */
  ${({
  $customFill
}) => $customFill ? `
    svg path {
      fill: ${$customFill} !important;
    }
  ` : ""}
`;
const StepperSectionWrapper = styled.div`
  display: flex;
  flex-direction: row;
  position: relative;
`;
const StepperSectionBody = styled.div`
  margin-left: ${({
  $size
}) => {
  var _a2;
  return ((_a2 = stepperSizeProps($size)) == null ? void 0 : _a2.bodyMarginLeft) || "20px";
}};
  margin-top: ${({
  $size
}) => {
  var _a2;
  return ((_a2 = stepperSizeProps($size)) == null ? void 0 : _a2.bodyMarginTop) || "8px";
}};
  margin-bottom: 32px;
  flex: 1;
`;
const StepperTitleRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  width: 100%;
`;
const StepperDate = styled.div`
  /* Date is now in flex container, no absolute positioning needed */
`;
const StepperAdditionalContent = styled.div`
  margin-top: 16px;
`;
const StepperCircleLineWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;
const StyledStepperLine = styled.div`
  flex-grow: ${({
  $isFailed
}) => $isFailed ? 0 : 1};
  width: ${({
  $size
}) => {
  var _a2;
  return ((_a2 = stepperSizeProps($size)) == null ? void 0 : _a2.lineWidth) || "2px";
}};
  background-color: ${({
  $isComplete
}) => $isComplete ? STEPPER_BORDER_BY_STAGE.complete : STEPPER_BORDER_BY_STAGE.incomplete};
  min-height: 32px;
`;
const StyledCloseIcon = styled(CloseIcon)`
  fill: ${STEPPER_BORDER_BY_STAGE.failed};
`;
const STEPPER_STAGES = ["complete", "active", "stalled", "incomplete", "failed"];
const STEPPER_SIZES = ["small", "large"];
const StepperCircle = ({
  stage,
  icon: Icon,
  size: size2,
  resolvedSize,
  iconSize = "24px",
  iconProps
}) => {
  const iconSizeValue = iconSize ?? "24px";
  const match2 = iconSizeValue.match(/^(\d+)px$/);
  const iconSizeNum = match2 && match2[1] ? parseInt(match2[1], 10) : 24;
  const sizeForStyled = resolvedSize || size2 || STEPPER_DEFAULT_SIZE;
  const getIconColor = () => {
    return STEPPER_ICON_BY_STAGE[stage] ?? STEPPER_ICON_BY_STAGE.incomplete;
  };
  const customFill = iconProps == null ? void 0 : iconProps.fill;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(StepperCircleWrapper, { stage, size: sizeForStyled, $customFill: customFill, children: Icon ? (() => {
    const defaultIconProps = {
      width: iconSizeNum,
      height: iconSizeNum,
      fill: getIconColor()
    };
    return /* @__PURE__ */ jsxRuntimeExports.jsx(Icon, { ...defaultIconProps, ...iconProps });
  })() : null });
};
const StepperLine = ({
  isComplete,
  isActive,
  isStalled,
  isFailed,
  size: size2
}) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: isFailed ? /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(StyledStepperLine, { $isFailed: isFailed, $size: size2 }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(StyledCloseIcon, { size: "sm" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(StyledStepperLine, { $size: size2 })
  ] }) : /* @__PURE__ */ jsxRuntimeExports.jsx(StyledStepperLine, { $isComplete: isComplete, $isActive: isActive, $isStalled: isStalled, $isFailed: isFailed, $size: size2 }) });
};
const StepperSection = React__default.forwardRef(({
  stage,
  icon,
  hideLine,
  children,
  size: size2,
  statusText,
  resolvedSize,
  descriptionVariant = "bodyMedium",
  iconSize,
  iconProps,
  title,
  headerLevel = "h2",
  titleVariant,
  titleFontWeight
}, ref2) => {
  const sizeForStyled = resolvedSize || size2 || STEPPER_DEFAULT_SIZE;
  const hasContent = title !== void 0 || children !== void 0 || Boolean(statusText);
  let headerContent = null;
  if (title !== void 0) {
    headerContent = /* @__PURE__ */ jsxRuntimeExports.jsxs(StepperTitleRow, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(Text, { variant: `${titleVariant || "labelXSmall"}.responsive`, element: headerLevel, mb: "4px", ...titleFontWeight && {
        fontWeight: titleFontWeight
      }, children: title }),
      statusText && /* @__PURE__ */ jsxRuntimeExports.jsx(StepperDate, { $size: sizeForStyled, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Text, { variant: `${descriptionVariant}.responsive`, element: "p", children: statusText }) })
    ] });
  } else if (statusText) {
    headerContent = /* @__PURE__ */ jsxRuntimeExports.jsx(StepperDate, { $size: sizeForStyled, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Text, { variant: `${descriptionVariant}.responsive`, element: "p", children: statusText }) });
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(StepperSectionWrapper, { ref: ref2, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs(StepperCircleLineWrapper, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(StepperCircle, { stage, icon, size: size2, resolvedSize: sizeForStyled, iconSize, iconProps }),
      !hideLine && /* @__PURE__ */ jsxRuntimeExports.jsx(StepperLine, { isComplete: stage === "complete", isActive: stage === "active", isStalled: stage === "stalled", isFailed: stage === "failed", size: sizeForStyled })
    ] }),
    hasContent ? /* @__PURE__ */ jsxRuntimeExports.jsxs(StepperSectionBody, { $size: sizeForStyled, children: [
      headerContent,
      children
    ] }) : null
  ] });
});
StepperSection.displayName = "StepperSection";
const Stepper = React__default.forwardRef(({
  steps,
  headerLevel = "h2",
  hideLines,
  size: size2
}, ref2) => {
  const resolvedSize = size2 || STEPPER_DEFAULT_SIZE;
  const themedProps = stepperSizeProps(resolvedSize) ?? {};
  const {
    iconSize = "24px",
    titleVariant = "labelXSmall",
    titleFontWeight,
    descriptionVariant = "bodyMedium"
  } = themedProps;
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { ref: ref2, children: steps.map(({
    id: id2,
    icon,
    stage,
    title,
    description,
    statusText,
    iconProps,
    additionalContent
  }, index2) => {
    const stepKey = id2 ?? `${stage}-${String(title ?? "")}-${index2}`;
    return /* @__PURE__ */ jsxRuntimeExports.jsxs(StepperSection, { icon, stage, hideLine: hideLines || index2 === steps.length - 1, size: size2, resolvedSize, descriptionVariant, iconSize, statusText, iconProps, title, headerLevel, titleVariant, titleFontWeight, children: [
      description !== void 0 ? /* @__PURE__ */ jsxRuntimeExports.jsx(Text, { variant: `${descriptionVariant}.responsive`, element: "p", children: description }) : null,
      additionalContent && /* @__PURE__ */ jsxRuntimeExports.jsx(StepperAdditionalContent, { children: additionalContent })
    ] }, stepKey);
  }) });
});
Stepper.displayName = "Stepper";
const DASHED_BORDER_MASK = `url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' stroke='%23000' stroke-width='2' stroke-dasharray='6%2c 10' stroke-dashoffset='0' stroke-linecap='square'/%3e%3c/svg%3e")`;
const dashedBorder = (color2) => css$3`
  &::before {
    content: "";
    position: absolute;
    inset: 0;
    pointer-events: none;
    background-color: ${color2};
    -webkit-mask-image: ${DASHED_BORDER_MASK};
    mask-image: ${DASHED_BORDER_MASK};
  }
`;
const BlankSignature = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  min-height: 20px;
`;
const SignatureContainer = styled.button`
  appearance: none;
  border: none;
  text-align: inherit;
  font: inherit;
  color: inherit;
  width: 100%;
  margin: 0;
  padding: 0;
  line-height: inherit;
  letter-spacing: inherit;
  position: relative;

  &:disabled {
    pointer-events: none;
  }

  ${({
  isSigned
}) => css$3`
      background: ${isSigned ? "transparent" : `var(${TOKENS.color.background.interaction.neutralEmphasized})`};
      ${isSigned ? "" : dashedBorder(`var(${TOKENS.color.border.interaction.neutralEmphasized})`)}
      cursor: ${isSigned ? "default" : "pointer"};
      padding-bottom: ${isSigned ? "0px" : "11px"};
      padding-top: ${isSigned ? `21px` : "11px"};
      margin-top: 16px;

      ${!isSigned ? css$3`
            &:hover,
            &:focus,
            &:focus-visible {
              background: var(
                ${TOKENS.color.background.interaction.neutralEmphasizedHover}
              );
            }
            &:focus-visible {
              outline-offset: 4px;
            }
            &.disabled {
              cursor: not-allowed;
              color: var(${TOKENS.color.foreground.interaction.disabled});
              background: var(
                ${TOKENS.color.background.interaction.neutralDisabled}
              );
              &::before {
                background-color: var(
                  ${TOKENS.color.border.interaction.neutral}
                );
              }

              & svg {
                fill: var(${TOKENS.color.foreground.interaction.disabled});
              }
            }
          ` : ""}

      svg {
        margin-right: 8px;
      }
    `}
`;
const SignatureText = styled(Text)`
  overflow-wrap: anywhere;
`;
const CursiveContainer = styled.div`
  min-height: 20px;
`;
const HorizontalRuleName = styled(Text)`
  color: var(${TOKENS.color.foreground.subdued});
  overflow-wrap: anywhere;
`;
const Signature = forwardRef((props, ref2) => {
  const {
    isSigned,
    onClick,
    name,
    placeholder = "Click to add signature",
    baselineText = name,
    disabled
  } = props;
  const [internalIsSigned, setInternalIsSigned] = useState(isSigned ?? false);
  const handleOnClick = () => {
    if (disabled) {
      return;
    }
    setInternalIsSigned(true);
    onClick == null ? void 0 : onClick();
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(SignatureContainer, { ...props, isSigned: internalIsSigned, onClick: handleOnClick, "data-testid": "signature_container", type: "button", ref: ref2, className: disabled ? "disabled" : "", disabled: disabled || internalIsSigned, children: !internalIsSigned ? /* @__PURE__ */ jsxRuntimeExports.jsxs(BlankSignature, { "data-testid": "signature_placeholder", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(PenIcon, { size: "md", "aria-hidden": "true" }),
      " ",
      /* @__PURE__ */ jsxRuntimeExports.jsx(Text, { variant: "headerXSmall.responsive", element: "p", children: placeholder })
    ] }) : /* @__PURE__ */ jsxRuntimeExports.jsx(CursiveContainer, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(SignatureText, { variant: "signature.responsive", element: "span", "data-testid": "signed_name", children: name }) }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Divider, { margin: "16px 0 8px" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(HorizontalRuleName, { variant: "bodyXSmall.responsive", element: "p", children: baselineText })
  ] });
});
Signature.displayName = "Signature";
const min$2 = Math.min;
const max$2 = Math.max;
function evaluate(value, param) {
  return typeof value === "function" ? value(param) : value;
}
function getSide(placement) {
  return placement.split("-")[0];
}
function getAlignment(placement) {
  return placement.split("-")[1];
}
const yAxisSides = /* @__PURE__ */ new Set(["top", "bottom"]);
function getSideAxis(placement) {
  return yAxisSides.has(getSide(placement)) ? "y" : "x";
}
function expandPaddingObject(padding2) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...padding2
  };
}
function getPaddingObject(padding2) {
  return typeof padding2 !== "number" ? expandPaddingObject(padding2) : {
    top: padding2,
    right: padding2,
    bottom: padding2,
    left: padding2
  };
}
function rectToClientRect(rect) {
  const {
    x: x2,
    y: y2,
    width: width2,
    height: height2
  } = rect;
  return {
    width: width2,
    height: height2,
    top: y2,
    left: x2,
    right: x2 + width2,
    bottom: y2 + height2,
    x: x2,
    y: y2
  };
}
async function detectOverflow(state, options2) {
  var _await$platform$isEle;
  if (options2 === void 0) {
    options2 = {};
  }
  const {
    x: x2,
    y: y2,
    platform: platform2,
    rects,
    elements,
    strategy
  } = state;
  const {
    boundary = "clippingAncestors",
    rootBoundary = "viewport",
    elementContext = "floating",
    altBoundary = false,
    padding: padding2 = 0
  } = evaluate(options2, state);
  const paddingObject = getPaddingObject(padding2);
  const altContext = elementContext === "floating" ? "reference" : "floating";
  const element = elements[altBoundary ? altContext : elementContext];
  const clippingClientRect = rectToClientRect(await platform2.getClippingRect({
    element: ((_await$platform$isEle = await (platform2.isElement == null ? void 0 : platform2.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || await (platform2.getDocumentElement == null ? void 0 : platform2.getDocumentElement(elements.floating)),
    boundary,
    rootBoundary,
    strategy
  }));
  const rect = elementContext === "floating" ? {
    x: x2,
    y: y2,
    width: rects.floating.width,
    height: rects.floating.height
  } : rects.reference;
  const offsetParent = await (platform2.getOffsetParent == null ? void 0 : platform2.getOffsetParent(elements.floating));
  const offsetScale = await (platform2.isElement == null ? void 0 : platform2.isElement(offsetParent)) ? await (platform2.getScale == null ? void 0 : platform2.getScale(offsetParent)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  };
  const elementClientRect = rectToClientRect(platform2.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform2.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements,
    rect,
    offsetParent,
    strategy
  }) : rect);
  return {
    top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
    bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
    left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
    right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
  };
}
const size$1 = function(options2) {
  if (options2 === void 0) {
    options2 = {};
  }
  return {
    name: "size",
    options: options2,
    async fn(state) {
      var _state$middlewareData, _state$middlewareData2;
      const {
        placement,
        rects,
        platform: platform2,
        elements
      } = state;
      const {
        apply: apply2 = () => {
        },
        ...detectOverflowOptions
      } = evaluate(options2, state);
      const overflow = await detectOverflow(state, detectOverflowOptions);
      const side = getSide(placement);
      const alignment = getAlignment(placement);
      const isYAxis = getSideAxis(placement) === "y";
      const {
        width: width2,
        height: height2
      } = rects.floating;
      let heightSide;
      let widthSide;
      if (side === "top" || side === "bottom") {
        heightSide = side;
        widthSide = alignment === (await (platform2.isRTL == null ? void 0 : platform2.isRTL(elements.floating)) ? "start" : "end") ? "left" : "right";
      } else {
        widthSide = side;
        heightSide = alignment === "end" ? "top" : "bottom";
      }
      const maximumClippingHeight = height2 - overflow.top - overflow.bottom;
      const maximumClippingWidth = width2 - overflow.left - overflow.right;
      const overflowAvailableHeight = min$2(height2 - overflow[heightSide], maximumClippingHeight);
      const overflowAvailableWidth = min$2(width2 - overflow[widthSide], maximumClippingWidth);
      const noShift = !state.middlewareData.shift;
      let availableHeight = overflowAvailableHeight;
      let availableWidth = overflowAvailableWidth;
      if ((_state$middlewareData = state.middlewareData.shift) != null && _state$middlewareData.enabled.x) {
        availableWidth = maximumClippingWidth;
      }
      if ((_state$middlewareData2 = state.middlewareData.shift) != null && _state$middlewareData2.enabled.y) {
        availableHeight = maximumClippingHeight;
      }
      if (noShift && !alignment) {
        const xMin = max$2(overflow.left, 0);
        const xMax = max$2(overflow.right, 0);
        const yMin = max$2(overflow.top, 0);
        const yMax = max$2(overflow.bottom, 0);
        if (isYAxis) {
          availableWidth = width2 - 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : max$2(overflow.left, overflow.right));
        } else {
          availableHeight = height2 - 2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : max$2(overflow.top, overflow.bottom));
        }
      }
      await apply2({
        ...state,
        availableWidth,
        availableHeight
      });
      const nextDimensions = await platform2.getDimensions(elements.floating);
      if (width2 !== nextDimensions.width || height2 !== nextDimensions.height) {
        return {
          reset: {
            rects: true
          }
        };
      }
      return {};
    }
  };
};
const size = size$1;
function toDate(argument) {
  const argStr = Object.prototype.toString.call(argument);
  if (argument instanceof Date || typeof argument === "object" && argStr === "[object Date]") {
    return new argument.constructor(+argument);
  } else if (typeof argument === "number" || argStr === "[object Number]" || typeof argument === "string" || argStr === "[object String]") {
    return new Date(argument);
  } else {
    return /* @__PURE__ */ new Date(NaN);
  }
}
function constructFrom(date, value) {
  if (date instanceof Date) {
    return new date.constructor(value);
  } else {
    return new Date(value);
  }
}
function addDays(date, amount) {
  const _date = toDate(date);
  if (isNaN(amount)) return constructFrom(date, NaN);
  if (!amount) {
    return _date;
  }
  _date.setDate(_date.getDate() + amount);
  return _date;
}
function addMonths(date, amount) {
  const _date = toDate(date);
  if (isNaN(amount)) return constructFrom(date, NaN);
  if (!amount) {
    return _date;
  }
  const dayOfMonth = _date.getDate();
  const endOfDesiredMonth = constructFrom(date, _date.getTime());
  endOfDesiredMonth.setMonth(_date.getMonth() + amount + 1, 0);
  const daysInMonth = endOfDesiredMonth.getDate();
  if (dayOfMonth >= daysInMonth) {
    return endOfDesiredMonth;
  } else {
    _date.setFullYear(
      endOfDesiredMonth.getFullYear(),
      endOfDesiredMonth.getMonth(),
      dayOfMonth
    );
    return _date;
  }
}
function addMilliseconds(date, amount) {
  const timestamp = +toDate(date);
  return constructFrom(date, timestamp + amount);
}
const millisecondsInWeek = 6048e5;
const millisecondsInDay = 864e5;
const millisecondsInMinute = 6e4;
const millisecondsInHour = 36e5;
const millisecondsInSecond = 1e3;
function addHours(date, amount) {
  return addMilliseconds(date, amount * millisecondsInHour);
}
let defaultOptions = {};
function getDefaultOptions$1() {
  return defaultOptions;
}
function startOfWeek(date, options2) {
  var _a2, _b, _c, _d;
  const defaultOptions2 = getDefaultOptions$1();
  const weekStartsOn = (options2 == null ? void 0 : options2.weekStartsOn) ?? ((_b = (_a2 = options2 == null ? void 0 : options2.locale) == null ? void 0 : _a2.options) == null ? void 0 : _b.weekStartsOn) ?? defaultOptions2.weekStartsOn ?? ((_d = (_c = defaultOptions2.locale) == null ? void 0 : _c.options) == null ? void 0 : _d.weekStartsOn) ?? 0;
  const _date = toDate(date);
  const day = _date.getDay();
  const diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  _date.setDate(_date.getDate() - diff);
  _date.setHours(0, 0, 0, 0);
  return _date;
}
function startOfISOWeek(date) {
  return startOfWeek(date, { weekStartsOn: 1 });
}
function getISOWeekYear(date) {
  const _date = toDate(date);
  const year = _date.getFullYear();
  const fourthOfJanuaryOfNextYear = constructFrom(date, 0);
  fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4);
  fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0);
  const startOfNextYear = startOfISOWeek(fourthOfJanuaryOfNextYear);
  const fourthOfJanuaryOfThisYear = constructFrom(date, 0);
  fourthOfJanuaryOfThisYear.setFullYear(year, 0, 4);
  fourthOfJanuaryOfThisYear.setHours(0, 0, 0, 0);
  const startOfThisYear = startOfISOWeek(fourthOfJanuaryOfThisYear);
  if (_date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (_date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}
function startOfDay(date) {
  const _date = toDate(date);
  _date.setHours(0, 0, 0, 0);
  return _date;
}
function getTimezoneOffsetInMilliseconds(date) {
  const _date = toDate(date);
  const utcDate = new Date(
    Date.UTC(
      _date.getFullYear(),
      _date.getMonth(),
      _date.getDate(),
      _date.getHours(),
      _date.getMinutes(),
      _date.getSeconds(),
      _date.getMilliseconds()
    )
  );
  utcDate.setUTCFullYear(_date.getFullYear());
  return +date - +utcDate;
}
function differenceInCalendarDays(dateLeft, dateRight) {
  const startOfDayLeft = startOfDay(dateLeft);
  const startOfDayRight = startOfDay(dateRight);
  const timestampLeft = +startOfDayLeft - getTimezoneOffsetInMilliseconds(startOfDayLeft);
  const timestampRight = +startOfDayRight - getTimezoneOffsetInMilliseconds(startOfDayRight);
  return Math.round((timestampLeft - timestampRight) / millisecondsInDay);
}
function startOfISOWeekYear(date) {
  const year = getISOWeekYear(date);
  const fourthOfJanuary = constructFrom(date, 0);
  fourthOfJanuary.setFullYear(year, 0, 4);
  fourthOfJanuary.setHours(0, 0, 0, 0);
  return startOfISOWeek(fourthOfJanuary);
}
function addMinutes(date, amount) {
  return addMilliseconds(date, amount * millisecondsInMinute);
}
function addQuarters(date, amount) {
  const months = amount * 3;
  return addMonths(date, months);
}
function addSeconds(date, amount) {
  return addMilliseconds(date, amount * 1e3);
}
function addWeeks(date, amount) {
  const days = amount * 7;
  return addDays(date, days);
}
function addYears(date, amount) {
  return addMonths(date, amount * 12);
}
function max$1(dates) {
  let result;
  dates.forEach(function(dirtyDate) {
    const currentDate = toDate(dirtyDate);
    if (result === void 0 || result < currentDate || isNaN(Number(currentDate))) {
      result = currentDate;
    }
  });
  return result || /* @__PURE__ */ new Date(NaN);
}
function min$1(dates) {
  let result;
  dates.forEach((dirtyDate) => {
    const date = toDate(dirtyDate);
    if (!result || result > date || isNaN(+date)) {
      result = date;
    }
  });
  return result || /* @__PURE__ */ new Date(NaN);
}
function isSameDay$1(dateLeft, dateRight) {
  const dateLeftStartOfDay = startOfDay(dateLeft);
  const dateRightStartOfDay = startOfDay(dateRight);
  return +dateLeftStartOfDay === +dateRightStartOfDay;
}
function isDate(value) {
  return value instanceof Date || typeof value === "object" && Object.prototype.toString.call(value) === "[object Date]";
}
function isValid$1(date) {
  if (!isDate(date) && typeof date !== "number") {
    return false;
  }
  const _date = toDate(date);
  return !isNaN(Number(_date));
}
function differenceInCalendarMonths(dateLeft, dateRight) {
  const _dateLeft = toDate(dateLeft);
  const _dateRight = toDate(dateRight);
  const yearDiff = _dateLeft.getFullYear() - _dateRight.getFullYear();
  const monthDiff = _dateLeft.getMonth() - _dateRight.getMonth();
  return yearDiff * 12 + monthDiff;
}
function getQuarter(date) {
  const _date = toDate(date);
  const quarter = Math.trunc(_date.getMonth() / 3) + 1;
  return quarter;
}
function differenceInCalendarQuarters(dateLeft, dateRight) {
  const _dateLeft = toDate(dateLeft);
  const _dateRight = toDate(dateRight);
  const yearDiff = _dateLeft.getFullYear() - _dateRight.getFullYear();
  const quarterDiff = getQuarter(_dateLeft) - getQuarter(_dateRight);
  return yearDiff * 4 + quarterDiff;
}
function differenceInCalendarYears(dateLeft, dateRight) {
  const _dateLeft = toDate(dateLeft);
  const _dateRight = toDate(dateRight);
  return _dateLeft.getFullYear() - _dateRight.getFullYear();
}
function differenceInDays(dateLeft, dateRight) {
  const _dateLeft = toDate(dateLeft);
  const _dateRight = toDate(dateRight);
  const sign3 = compareLocalAsc(_dateLeft, _dateRight);
  const difference = Math.abs(differenceInCalendarDays(_dateLeft, _dateRight));
  _dateLeft.setDate(_dateLeft.getDate() - sign3 * difference);
  const isLastDayNotFull = Number(
    compareLocalAsc(_dateLeft, _dateRight) === -sign3
  );
  const result = sign3 * (difference - isLastDayNotFull);
  return result === 0 ? 0 : result;
}
function compareLocalAsc(dateLeft, dateRight) {
  const diff = dateLeft.getFullYear() - dateRight.getFullYear() || dateLeft.getMonth() - dateRight.getMonth() || dateLeft.getDate() - dateRight.getDate() || dateLeft.getHours() - dateRight.getHours() || dateLeft.getMinutes() - dateRight.getMinutes() || dateLeft.getSeconds() - dateRight.getSeconds() || dateLeft.getMilliseconds() - dateRight.getMilliseconds();
  if (diff < 0) {
    return -1;
  } else if (diff > 0) {
    return 1;
  } else {
    return diff;
  }
}
function endOfDay(date) {
  const _date = toDate(date);
  _date.setHours(23, 59, 59, 999);
  return _date;
}
function endOfMonth(date) {
  const _date = toDate(date);
  const month = _date.getMonth();
  _date.setFullYear(_date.getFullYear(), month + 1, 0);
  _date.setHours(23, 59, 59, 999);
  return _date;
}
function startOfQuarter(date) {
  const _date = toDate(date);
  const currentMonth = _date.getMonth();
  const month = currentMonth - currentMonth % 3;
  _date.setMonth(month, 1);
  _date.setHours(0, 0, 0, 0);
  return _date;
}
function startOfMonth(date) {
  const _date = toDate(date);
  _date.setDate(1);
  _date.setHours(0, 0, 0, 0);
  return _date;
}
function endOfYear(date) {
  const _date = toDate(date);
  const year = _date.getFullYear();
  _date.setFullYear(year + 1, 0, 0);
  _date.setHours(23, 59, 59, 999);
  return _date;
}
function startOfYear(date) {
  const cleanDate = toDate(date);
  const _date = constructFrom(date, 0);
  _date.setFullYear(cleanDate.getFullYear(), 0, 1);
  _date.setHours(0, 0, 0, 0);
  return _date;
}
function endOfWeek(date, options2) {
  var _a2, _b;
  const defaultOptions2 = getDefaultOptions$1();
  const weekStartsOn = defaultOptions2.weekStartsOn ?? ((_b = (_a2 = defaultOptions2.locale) == null ? void 0 : _a2.options) == null ? void 0 : _b.weekStartsOn) ?? 0;
  const _date = toDate(date);
  const day = _date.getDay();
  const diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn);
  _date.setDate(_date.getDate() + diff);
  _date.setHours(23, 59, 59, 999);
  return _date;
}
const formatDistanceLocale = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
};
const formatDistance = (token2, count2, options2) => {
  let result;
  const tokenValue = formatDistanceLocale[token2];
  if (typeof tokenValue === "string") {
    result = tokenValue;
  } else if (count2 === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace("{{count}}", count2.toString());
  }
  if (options2 == null ? void 0 : options2.addSuffix) {
    if (options2.comparison && options2.comparison > 0) {
      return "in " + result;
    } else {
      return result + " ago";
    }
  }
  return result;
};
function buildFormatLongFn(args) {
  return (options2 = {}) => {
    const width2 = options2.width ? String(options2.width) : args.defaultWidth;
    const format2 = args.formats[width2] || args.formats[args.defaultWidth];
    return format2;
  };
}
const dateFormats = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
};
const timeFormats = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
};
const dateTimeFormats = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
};
const formatLong = {
  date: buildFormatLongFn({
    formats: dateFormats,
    defaultWidth: "full"
  }),
  time: buildFormatLongFn({
    formats: timeFormats,
    defaultWidth: "full"
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats,
    defaultWidth: "full"
  })
};
const formatRelativeLocale = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
};
const formatRelative = (token2, _date, _baseDate, _options) => formatRelativeLocale[token2];
function buildLocalizeFn(args) {
  return (value, options2) => {
    const context = (options2 == null ? void 0 : options2.context) ? String(options2.context) : "standalone";
    let valuesArray;
    if (context === "formatting" && args.formattingValues) {
      const defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
      const width2 = (options2 == null ? void 0 : options2.width) ? String(options2.width) : defaultWidth;
      valuesArray = args.formattingValues[width2] || args.formattingValues[defaultWidth];
    } else {
      const defaultWidth = args.defaultWidth;
      const width2 = (options2 == null ? void 0 : options2.width) ? String(options2.width) : args.defaultWidth;
      valuesArray = args.values[width2] || args.values[defaultWidth];
    }
    const index2 = args.argumentCallback ? args.argumentCallback(value) : value;
    return valuesArray[index2];
  };
}
const eraValues = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
};
const quarterValues = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
};
const monthValues = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ],
  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]
};
const dayValues = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ]
};
const dayPeriodValues = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
};
const formattingDayPeriodValues = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
};
const ordinalNumber = (dirtyNumber, _options) => {
  const number = Number(dirtyNumber);
  const rem100 = number % 100;
  if (rem100 > 20 || rem100 < 10) {
    switch (rem100 % 10) {
      case 1:
        return number + "st";
      case 2:
        return number + "nd";
      case 3:
        return number + "rd";
    }
  }
  return number + "th";
};
const localize = {
  ordinalNumber,
  era: buildLocalizeFn({
    values: eraValues,
    defaultWidth: "wide"
  }),
  quarter: buildLocalizeFn({
    values: quarterValues,
    defaultWidth: "wide",
    argumentCallback: (quarter) => quarter - 1
  }),
  month: buildLocalizeFn({
    values: monthValues,
    defaultWidth: "wide"
  }),
  day: buildLocalizeFn({
    values: dayValues,
    defaultWidth: "wide"
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues,
    defaultWidth: "wide",
    formattingValues: formattingDayPeriodValues,
    defaultFormattingWidth: "wide"
  })
};
function buildMatchFn(args) {
  return (string, options2 = {}) => {
    const width2 = options2.width;
    const matchPattern = width2 && args.matchPatterns[width2] || args.matchPatterns[args.defaultMatchWidth];
    const matchResult = string.match(matchPattern);
    if (!matchResult) {
      return null;
    }
    const matchedString = matchResult[0];
    const parsePatterns = width2 && args.parsePatterns[width2] || args.parsePatterns[args.defaultParseWidth];
    const key = Array.isArray(parsePatterns) ? findIndex(parsePatterns, (pattern) => pattern.test(matchedString)) : (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
      findKey(parsePatterns, (pattern) => pattern.test(matchedString))
    );
    let value;
    value = args.valueCallback ? args.valueCallback(key) : key;
    value = options2.valueCallback ? (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
      options2.valueCallback(value)
    ) : value;
    const rest = string.slice(matchedString.length);
    return { value, rest };
  };
}
function findKey(object2, predicate2) {
  for (const key in object2) {
    if (Object.prototype.hasOwnProperty.call(object2, key) && predicate2(object2[key])) {
      return key;
    }
  }
  return void 0;
}
function findIndex(array, predicate2) {
  for (let key = 0; key < array.length; key++) {
    if (predicate2(array[key])) {
      return key;
    }
  }
  return void 0;
}
function buildMatchPatternFn(args) {
  return (string, options2 = {}) => {
    const matchResult = string.match(args.matchPattern);
    if (!matchResult) return null;
    const matchedString = matchResult[0];
    const parseResult = string.match(args.parsePattern);
    if (!parseResult) return null;
    let value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
    value = options2.valueCallback ? options2.valueCallback(value) : value;
    const rest = string.slice(matchedString.length);
    return { value, rest };
  };
}
const matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
const parseOrdinalNumberPattern = /\d+/i;
const matchEraPatterns = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
};
const parseEraPatterns = {
  any: [/^b/i, /^(a|c)/i]
};
const matchQuarterPatterns = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
};
const parseQuarterPatterns = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
const matchMonthPatterns = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
const parseMonthPatterns = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
};
const matchDayPatterns = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
const parseDayPatterns = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
};
const matchDayPeriodPatterns = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
const parseDayPeriodPatterns = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
};
const match = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern,
    parsePattern: parseOrdinalNumberPattern,
    valueCallback: (value) => parseInt(value, 10)
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseEraPatterns,
    defaultParseWidth: "any"
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseQuarterPatterns,
    defaultParseWidth: "any",
    valueCallback: (index2) => index2 + 1
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseMonthPatterns,
    defaultParseWidth: "any"
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPatterns,
    defaultParseWidth: "any"
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns,
    defaultMatchWidth: "any",
    parsePatterns: parseDayPeriodPatterns,
    defaultParseWidth: "any"
  })
};
const enUS = {
  code: "en-US",
  formatDistance,
  formatLong,
  formatRelative,
  localize,
  match,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
function getDayOfYear(date) {
  const _date = toDate(date);
  const diff = differenceInCalendarDays(_date, startOfYear(_date));
  const dayOfYear = diff + 1;
  return dayOfYear;
}
function getISOWeek(date) {
  const _date = toDate(date);
  const diff = +startOfISOWeek(_date) - +startOfISOWeekYear(_date);
  return Math.round(diff / millisecondsInWeek) + 1;
}
function getWeekYear(date, options2) {
  var _a2, _b, _c, _d;
  const _date = toDate(date);
  const year = _date.getFullYear();
  const defaultOptions2 = getDefaultOptions$1();
  const firstWeekContainsDate = (options2 == null ? void 0 : options2.firstWeekContainsDate) ?? ((_b = (_a2 = options2 == null ? void 0 : options2.locale) == null ? void 0 : _a2.options) == null ? void 0 : _b.firstWeekContainsDate) ?? defaultOptions2.firstWeekContainsDate ?? ((_d = (_c = defaultOptions2.locale) == null ? void 0 : _c.options) == null ? void 0 : _d.firstWeekContainsDate) ?? 1;
  const firstWeekOfNextYear = constructFrom(date, 0);
  firstWeekOfNextYear.setFullYear(year + 1, 0, firstWeekContainsDate);
  firstWeekOfNextYear.setHours(0, 0, 0, 0);
  const startOfNextYear = startOfWeek(firstWeekOfNextYear, options2);
  const firstWeekOfThisYear = constructFrom(date, 0);
  firstWeekOfThisYear.setFullYear(year, 0, firstWeekContainsDate);
  firstWeekOfThisYear.setHours(0, 0, 0, 0);
  const startOfThisYear = startOfWeek(firstWeekOfThisYear, options2);
  if (_date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (_date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}
function startOfWeekYear(date, options2) {
  var _a2, _b, _c, _d;
  const defaultOptions2 = getDefaultOptions$1();
  const firstWeekContainsDate = (options2 == null ? void 0 : options2.firstWeekContainsDate) ?? ((_b = (_a2 = options2 == null ? void 0 : options2.locale) == null ? void 0 : _a2.options) == null ? void 0 : _b.firstWeekContainsDate) ?? defaultOptions2.firstWeekContainsDate ?? ((_d = (_c = defaultOptions2.locale) == null ? void 0 : _c.options) == null ? void 0 : _d.firstWeekContainsDate) ?? 1;
  const year = getWeekYear(date, options2);
  const firstWeek = constructFrom(date, 0);
  firstWeek.setFullYear(year, 0, firstWeekContainsDate);
  firstWeek.setHours(0, 0, 0, 0);
  const _date = startOfWeek(firstWeek, options2);
  return _date;
}
function getWeek$1(date, options2) {
  const _date = toDate(date);
  const diff = +startOfWeek(_date, options2) - +startOfWeekYear(_date, options2);
  return Math.round(diff / millisecondsInWeek) + 1;
}
function addLeadingZeros(number, targetLength) {
  const sign3 = number < 0 ? "-" : "";
  const output = Math.abs(number).toString().padStart(targetLength, "0");
  return sign3 + output;
}
const lightFormatters = {
  // Year
  y(date, token2) {
    const signedYear = date.getFullYear();
    const year = signedYear > 0 ? signedYear : 1 - signedYear;
    return addLeadingZeros(token2 === "yy" ? year % 100 : year, token2.length);
  },
  // Month
  M(date, token2) {
    const month = date.getMonth();
    return token2 === "M" ? String(month + 1) : addLeadingZeros(month + 1, 2);
  },
  // Day of the month
  d(date, token2) {
    return addLeadingZeros(date.getDate(), token2.length);
  },
  // AM or PM
  a(date, token2) {
    const dayPeriodEnumValue = date.getHours() / 12 >= 1 ? "pm" : "am";
    switch (token2) {
      case "a":
      case "aa":
        return dayPeriodEnumValue.toUpperCase();
      case "aaa":
        return dayPeriodEnumValue;
      case "aaaaa":
        return dayPeriodEnumValue[0];
      case "aaaa":
      default:
        return dayPeriodEnumValue === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h(date, token2) {
    return addLeadingZeros(date.getHours() % 12 || 12, token2.length);
  },
  // Hour [0-23]
  H(date, token2) {
    return addLeadingZeros(date.getHours(), token2.length);
  },
  // Minute
  m(date, token2) {
    return addLeadingZeros(date.getMinutes(), token2.length);
  },
  // Second
  s(date, token2) {
    return addLeadingZeros(date.getSeconds(), token2.length);
  },
  // Fraction of second
  S(date, token2) {
    const numberOfDigits = token2.length;
    const milliseconds = date.getMilliseconds();
    const fractionalSeconds = Math.trunc(
      milliseconds * Math.pow(10, numberOfDigits - 3)
    );
    return addLeadingZeros(fractionalSeconds, token2.length);
  }
};
const dayPeriodEnum = {
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
};
const formatters = {
  // Era
  G: function(date, token2, localize2) {
    const era = date.getFullYear() > 0 ? 1 : 0;
    switch (token2) {
      case "G":
      case "GG":
      case "GGG":
        return localize2.era(era, { width: "abbreviated" });
      case "GGGGG":
        return localize2.era(era, { width: "narrow" });
      case "GGGG":
      default:
        return localize2.era(era, { width: "wide" });
    }
  },
  // Year
  y: function(date, token2, localize2) {
    if (token2 === "yo") {
      const signedYear = date.getFullYear();
      const year = signedYear > 0 ? signedYear : 1 - signedYear;
      return localize2.ordinalNumber(year, { unit: "year" });
    }
    return lightFormatters.y(date, token2);
  },
  // Local week-numbering year
  Y: function(date, token2, localize2, options2) {
    const signedWeekYear = getWeekYear(date, options2);
    const weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;
    if (token2 === "YY") {
      const twoDigitYear = weekYear % 100;
      return addLeadingZeros(twoDigitYear, 2);
    }
    if (token2 === "Yo") {
      return localize2.ordinalNumber(weekYear, { unit: "year" });
    }
    return addLeadingZeros(weekYear, token2.length);
  },
  // ISO week-numbering year
  R: function(date, token2) {
    const isoWeekYear = getISOWeekYear(date);
    return addLeadingZeros(isoWeekYear, token2.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(date, token2) {
    const year = date.getFullYear();
    return addLeadingZeros(year, token2.length);
  },
  // Quarter
  Q: function(date, token2, localize2) {
    const quarter = Math.ceil((date.getMonth() + 1) / 3);
    switch (token2) {
      case "Q":
        return String(quarter);
      case "QQ":
        return addLeadingZeros(quarter, 2);
      case "Qo":
        return localize2.ordinalNumber(quarter, { unit: "quarter" });
      case "QQQ":
        return localize2.quarter(quarter, {
          width: "abbreviated",
          context: "formatting"
        });
      case "QQQQQ":
        return localize2.quarter(quarter, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return localize2.quarter(quarter, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(date, token2, localize2) {
    const quarter = Math.ceil((date.getMonth() + 1) / 3);
    switch (token2) {
      case "q":
        return String(quarter);
      case "qq":
        return addLeadingZeros(quarter, 2);
      case "qo":
        return localize2.ordinalNumber(quarter, { unit: "quarter" });
      case "qqq":
        return localize2.quarter(quarter, {
          width: "abbreviated",
          context: "standalone"
        });
      case "qqqqq":
        return localize2.quarter(quarter, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return localize2.quarter(quarter, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(date, token2, localize2) {
    const month = date.getMonth();
    switch (token2) {
      case "M":
      case "MM":
        return lightFormatters.M(date, token2);
      case "Mo":
        return localize2.ordinalNumber(month + 1, { unit: "month" });
      case "MMM":
        return localize2.month(month, {
          width: "abbreviated",
          context: "formatting"
        });
      case "MMMMM":
        return localize2.month(month, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return localize2.month(month, { width: "wide", context: "formatting" });
    }
  },
  // Stand-alone month
  L: function(date, token2, localize2) {
    const month = date.getMonth();
    switch (token2) {
      case "L":
        return String(month + 1);
      case "LL":
        return addLeadingZeros(month + 1, 2);
      case "Lo":
        return localize2.ordinalNumber(month + 1, { unit: "month" });
      case "LLL":
        return localize2.month(month, {
          width: "abbreviated",
          context: "standalone"
        });
      case "LLLLL":
        return localize2.month(month, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return localize2.month(month, { width: "wide", context: "standalone" });
    }
  },
  // Local week of year
  w: function(date, token2, localize2, options2) {
    const week = getWeek$1(date, options2);
    if (token2 === "wo") {
      return localize2.ordinalNumber(week, { unit: "week" });
    }
    return addLeadingZeros(week, token2.length);
  },
  // ISO week of year
  I: function(date, token2, localize2) {
    const isoWeek = getISOWeek(date);
    if (token2 === "Io") {
      return localize2.ordinalNumber(isoWeek, { unit: "week" });
    }
    return addLeadingZeros(isoWeek, token2.length);
  },
  // Day of the month
  d: function(date, token2, localize2) {
    if (token2 === "do") {
      return localize2.ordinalNumber(date.getDate(), { unit: "date" });
    }
    return lightFormatters.d(date, token2);
  },
  // Day of year
  D: function(date, token2, localize2) {
    const dayOfYear = getDayOfYear(date);
    if (token2 === "Do") {
      return localize2.ordinalNumber(dayOfYear, { unit: "dayOfYear" });
    }
    return addLeadingZeros(dayOfYear, token2.length);
  },
  // Day of week
  E: function(date, token2, localize2) {
    const dayOfWeek = date.getDay();
    switch (token2) {
      case "E":
      case "EE":
      case "EEE":
        return localize2.day(dayOfWeek, {
          width: "abbreviated",
          context: "formatting"
        });
      case "EEEEE":
        return localize2.day(dayOfWeek, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return localize2.day(dayOfWeek, {
          width: "short",
          context: "formatting"
        });
      case "EEEE":
      default:
        return localize2.day(dayOfWeek, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(date, token2, localize2, options2) {
    const dayOfWeek = date.getDay();
    const localDayOfWeek = (dayOfWeek - options2.weekStartsOn + 8) % 7 || 7;
    switch (token2) {
      case "e":
        return String(localDayOfWeek);
      case "ee":
        return addLeadingZeros(localDayOfWeek, 2);
      case "eo":
        return localize2.ordinalNumber(localDayOfWeek, { unit: "day" });
      case "eee":
        return localize2.day(dayOfWeek, {
          width: "abbreviated",
          context: "formatting"
        });
      case "eeeee":
        return localize2.day(dayOfWeek, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return localize2.day(dayOfWeek, {
          width: "short",
          context: "formatting"
        });
      case "eeee":
      default:
        return localize2.day(dayOfWeek, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(date, token2, localize2, options2) {
    const dayOfWeek = date.getDay();
    const localDayOfWeek = (dayOfWeek - options2.weekStartsOn + 8) % 7 || 7;
    switch (token2) {
      case "c":
        return String(localDayOfWeek);
      case "cc":
        return addLeadingZeros(localDayOfWeek, token2.length);
      case "co":
        return localize2.ordinalNumber(localDayOfWeek, { unit: "day" });
      case "ccc":
        return localize2.day(dayOfWeek, {
          width: "abbreviated",
          context: "standalone"
        });
      case "ccccc":
        return localize2.day(dayOfWeek, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return localize2.day(dayOfWeek, {
          width: "short",
          context: "standalone"
        });
      case "cccc":
      default:
        return localize2.day(dayOfWeek, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(date, token2, localize2) {
    const dayOfWeek = date.getDay();
    const isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
    switch (token2) {
      case "i":
        return String(isoDayOfWeek);
      case "ii":
        return addLeadingZeros(isoDayOfWeek, token2.length);
      case "io":
        return localize2.ordinalNumber(isoDayOfWeek, { unit: "day" });
      case "iii":
        return localize2.day(dayOfWeek, {
          width: "abbreviated",
          context: "formatting"
        });
      case "iiiii":
        return localize2.day(dayOfWeek, {
          width: "narrow",
          context: "formatting"
        });
      case "iiiiii":
        return localize2.day(dayOfWeek, {
          width: "short",
          context: "formatting"
        });
      case "iiii":
      default:
        return localize2.day(dayOfWeek, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(date, token2, localize2) {
    const hours = date.getHours();
    const dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
    switch (token2) {
      case "a":
      case "aa":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(date, token2, localize2) {
    const hours = date.getHours();
    let dayPeriodEnumValue;
    if (hours === 12) {
      dayPeriodEnumValue = dayPeriodEnum.noon;
    } else if (hours === 0) {
      dayPeriodEnumValue = dayPeriodEnum.midnight;
    } else {
      dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
    }
    switch (token2) {
      case "b":
      case "bb":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(date, token2, localize2) {
    const hours = date.getHours();
    let dayPeriodEnumValue;
    if (hours >= 17) {
      dayPeriodEnumValue = dayPeriodEnum.evening;
    } else if (hours >= 12) {
      dayPeriodEnumValue = dayPeriodEnum.afternoon;
    } else if (hours >= 4) {
      dayPeriodEnumValue = dayPeriodEnum.morning;
    } else {
      dayPeriodEnumValue = dayPeriodEnum.night;
    }
    switch (token2) {
      case "B":
      case "BB":
      case "BBB":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(date, token2, localize2) {
    if (token2 === "ho") {
      let hours = date.getHours() % 12;
      if (hours === 0) hours = 12;
      return localize2.ordinalNumber(hours, { unit: "hour" });
    }
    return lightFormatters.h(date, token2);
  },
  // Hour [0-23]
  H: function(date, token2, localize2) {
    if (token2 === "Ho") {
      return localize2.ordinalNumber(date.getHours(), { unit: "hour" });
    }
    return lightFormatters.H(date, token2);
  },
  // Hour [0-11]
  K: function(date, token2, localize2) {
    const hours = date.getHours() % 12;
    if (token2 === "Ko") {
      return localize2.ordinalNumber(hours, { unit: "hour" });
    }
    return addLeadingZeros(hours, token2.length);
  },
  // Hour [1-24]
  k: function(date, token2, localize2) {
    let hours = date.getHours();
    if (hours === 0) hours = 24;
    if (token2 === "ko") {
      return localize2.ordinalNumber(hours, { unit: "hour" });
    }
    return addLeadingZeros(hours, token2.length);
  },
  // Minute
  m: function(date, token2, localize2) {
    if (token2 === "mo") {
      return localize2.ordinalNumber(date.getMinutes(), { unit: "minute" });
    }
    return lightFormatters.m(date, token2);
  },
  // Second
  s: function(date, token2, localize2) {
    if (token2 === "so") {
      return localize2.ordinalNumber(date.getSeconds(), { unit: "second" });
    }
    return lightFormatters.s(date, token2);
  },
  // Fraction of second
  S: function(date, token2) {
    return lightFormatters.S(date, token2);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(date, token2, _localize) {
    const timezoneOffset = date.getTimezoneOffset();
    if (timezoneOffset === 0) {
      return "Z";
    }
    switch (token2) {
      case "X":
        return formatTimezoneWithOptionalMinutes(timezoneOffset);
      case "XXXX":
      case "XX":
        return formatTimezone(timezoneOffset);
      case "XXXXX":
      case "XXX":
      default:
        return formatTimezone(timezoneOffset, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(date, token2, _localize) {
    const timezoneOffset = date.getTimezoneOffset();
    switch (token2) {
      case "x":
        return formatTimezoneWithOptionalMinutes(timezoneOffset);
      case "xxxx":
      case "xx":
        return formatTimezone(timezoneOffset);
      case "xxxxx":
      case "xxx":
      default:
        return formatTimezone(timezoneOffset, ":");
    }
  },
  // Timezone (GMT)
  O: function(date, token2, _localize) {
    const timezoneOffset = date.getTimezoneOffset();
    switch (token2) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + formatTimezoneShort(timezoneOffset, ":");
      case "OOOO":
      default:
        return "GMT" + formatTimezone(timezoneOffset, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(date, token2, _localize) {
    const timezoneOffset = date.getTimezoneOffset();
    switch (token2) {
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + formatTimezoneShort(timezoneOffset, ":");
      case "zzzz":
      default:
        return "GMT" + formatTimezone(timezoneOffset, ":");
    }
  },
  // Seconds timestamp
  t: function(date, token2, _localize) {
    const timestamp = Math.trunc(date.getTime() / 1e3);
    return addLeadingZeros(timestamp, token2.length);
  },
  // Milliseconds timestamp
  T: function(date, token2, _localize) {
    const timestamp = date.getTime();
    return addLeadingZeros(timestamp, token2.length);
  }
};
function formatTimezoneShort(offset2, delimiter2 = "") {
  const sign3 = offset2 > 0 ? "-" : "+";
  const absOffset = Math.abs(offset2);
  const hours = Math.trunc(absOffset / 60);
  const minutes = absOffset % 60;
  if (minutes === 0) {
    return sign3 + String(hours);
  }
  return sign3 + String(hours) + delimiter2 + addLeadingZeros(minutes, 2);
}
function formatTimezoneWithOptionalMinutes(offset2, delimiter2) {
  if (offset2 % 60 === 0) {
    const sign3 = offset2 > 0 ? "-" : "+";
    return sign3 + addLeadingZeros(Math.abs(offset2) / 60, 2);
  }
  return formatTimezone(offset2, delimiter2);
}
function formatTimezone(offset2, delimiter2 = "") {
  const sign3 = offset2 > 0 ? "-" : "+";
  const absOffset = Math.abs(offset2);
  const hours = addLeadingZeros(Math.trunc(absOffset / 60), 2);
  const minutes = addLeadingZeros(absOffset % 60, 2);
  return sign3 + hours + delimiter2 + minutes;
}
const dateLongFormatter = (pattern, formatLong2) => {
  switch (pattern) {
    case "P":
      return formatLong2.date({ width: "short" });
    case "PP":
      return formatLong2.date({ width: "medium" });
    case "PPP":
      return formatLong2.date({ width: "long" });
    case "PPPP":
    default:
      return formatLong2.date({ width: "full" });
  }
};
const timeLongFormatter = (pattern, formatLong2) => {
  switch (pattern) {
    case "p":
      return formatLong2.time({ width: "short" });
    case "pp":
      return formatLong2.time({ width: "medium" });
    case "ppp":
      return formatLong2.time({ width: "long" });
    case "pppp":
    default:
      return formatLong2.time({ width: "full" });
  }
};
const dateTimeLongFormatter = (pattern, formatLong2) => {
  const matchResult = pattern.match(/(P+)(p+)?/) || [];
  const datePattern = matchResult[1];
  const timePattern = matchResult[2];
  if (!timePattern) {
    return dateLongFormatter(pattern, formatLong2);
  }
  let dateTimeFormat;
  switch (datePattern) {
    case "P":
      dateTimeFormat = formatLong2.dateTime({ width: "short" });
      break;
    case "PP":
      dateTimeFormat = formatLong2.dateTime({ width: "medium" });
      break;
    case "PPP":
      dateTimeFormat = formatLong2.dateTime({ width: "long" });
      break;
    case "PPPP":
    default:
      dateTimeFormat = formatLong2.dateTime({ width: "full" });
      break;
  }
  return dateTimeFormat.replace("{{date}}", dateLongFormatter(datePattern, formatLong2)).replace("{{time}}", timeLongFormatter(timePattern, formatLong2));
};
const longFormatters = {
  p: timeLongFormatter,
  P: dateTimeLongFormatter
};
const dayOfYearTokenRE = /^D+$/;
const weekYearTokenRE = /^Y+$/;
const throwTokens = ["D", "DD", "YY", "YYYY"];
function isProtectedDayOfYearToken(token2) {
  return dayOfYearTokenRE.test(token2);
}
function isProtectedWeekYearToken(token2) {
  return weekYearTokenRE.test(token2);
}
function warnOrThrowProtectedError(token2, format2, input) {
  const _message = message(token2, format2, input);
  console.warn(_message);
  if (throwTokens.includes(token2)) throw new RangeError(_message);
}
function message(token2, format2, input) {
  const subject = token2[0] === "Y" ? "years" : "days of the month";
  return `Use \`${token2.toLowerCase()}\` instead of \`${token2}\` (in \`${format2}\`) for formatting ${subject} to the input \`${input}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}
const formattingTokensRegExp$1 = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
const longFormattingTokensRegExp$2 = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
const escapedStringRegExp$1 = /^'([^]*?)'?$/;
const doubleQuoteRegExp$1 = /''/g;
const unescapedLatinCharacterRegExp$1 = /[a-zA-Z]/;
function format(date, formatStr, options2) {
  var _a2, _b, _c, _d, _e, _f, _g, _h;
  const defaultOptions2 = getDefaultOptions$1();
  const locale = (options2 == null ? void 0 : options2.locale) ?? defaultOptions2.locale ?? enUS;
  const firstWeekContainsDate = (options2 == null ? void 0 : options2.firstWeekContainsDate) ?? ((_b = (_a2 = options2 == null ? void 0 : options2.locale) == null ? void 0 : _a2.options) == null ? void 0 : _b.firstWeekContainsDate) ?? defaultOptions2.firstWeekContainsDate ?? ((_d = (_c = defaultOptions2.locale) == null ? void 0 : _c.options) == null ? void 0 : _d.firstWeekContainsDate) ?? 1;
  const weekStartsOn = (options2 == null ? void 0 : options2.weekStartsOn) ?? ((_f = (_e = options2 == null ? void 0 : options2.locale) == null ? void 0 : _e.options) == null ? void 0 : _f.weekStartsOn) ?? defaultOptions2.weekStartsOn ?? ((_h = (_g = defaultOptions2.locale) == null ? void 0 : _g.options) == null ? void 0 : _h.weekStartsOn) ?? 0;
  const originalDate = toDate(date);
  if (!isValid$1(originalDate)) {
    throw new RangeError("Invalid time value");
  }
  let parts = formatStr.match(longFormattingTokensRegExp$2).map((substring) => {
    const firstCharacter = substring[0];
    if (firstCharacter === "p" || firstCharacter === "P") {
      const longFormatter = longFormatters[firstCharacter];
      return longFormatter(substring, locale.formatLong);
    }
    return substring;
  }).join("").match(formattingTokensRegExp$1).map((substring) => {
    if (substring === "''") {
      return { isToken: false, value: "'" };
    }
    const firstCharacter = substring[0];
    if (firstCharacter === "'") {
      return { isToken: false, value: cleanEscapedString$1(substring) };
    }
    if (formatters[firstCharacter]) {
      return { isToken: true, value: substring };
    }
    if (firstCharacter.match(unescapedLatinCharacterRegExp$1)) {
      throw new RangeError(
        "Format string contains an unescaped latin alphabet character `" + firstCharacter + "`"
      );
    }
    return { isToken: false, value: substring };
  });
  if (locale.localize.preprocessor) {
    parts = locale.localize.preprocessor(originalDate, parts);
  }
  const formatterOptions = {
    firstWeekContainsDate,
    weekStartsOn,
    locale
  };
  return parts.map((part) => {
    if (!part.isToken) return part.value;
    const token2 = part.value;
    if (!(options2 == null ? void 0 : options2.useAdditionalWeekYearTokens) && isProtectedWeekYearToken(token2) || !(options2 == null ? void 0 : options2.useAdditionalDayOfYearTokens) && isProtectedDayOfYearToken(token2)) {
      warnOrThrowProtectedError(token2, formatStr, String(date));
    }
    const formatter = formatters[token2[0]];
    return formatter(originalDate, token2, locale.localize, formatterOptions);
  }).join("");
}
function cleanEscapedString$1(input) {
  const matched = input.match(escapedStringRegExp$1);
  if (!matched) {
    return input;
  }
  return matched[1].replace(doubleQuoteRegExp$1, "'");
}
function getDate(date) {
  const _date = toDate(date);
  const dayOfMonth = _date.getDate();
  return dayOfMonth;
}
function getDay(date) {
  const _date = toDate(date);
  const day = _date.getDay();
  return day;
}
function getDaysInMonth(date) {
  const _date = toDate(date);
  const year = _date.getFullYear();
  const monthIndex = _date.getMonth();
  const lastDayOfMonth = constructFrom(date, 0);
  lastDayOfMonth.setFullYear(year, monthIndex + 1, 0);
  lastDayOfMonth.setHours(0, 0, 0, 0);
  return lastDayOfMonth.getDate();
}
function getDefaultOptions() {
  return Object.assign({}, getDefaultOptions$1());
}
function getHours(date) {
  const _date = toDate(date);
  const hours = _date.getHours();
  return hours;
}
function getISODay(date) {
  const _date = toDate(date);
  let day = _date.getDay();
  if (day === 0) {
    day = 7;
  }
  return day;
}
function getMinutes(date) {
  const _date = toDate(date);
  const minutes = _date.getMinutes();
  return minutes;
}
function getMonth(date) {
  const _date = toDate(date);
  const month = _date.getMonth();
  return month;
}
function getSeconds(date) {
  const _date = toDate(date);
  const seconds = _date.getSeconds();
  return seconds;
}
function getTime(date) {
  const _date = toDate(date);
  const timestamp = _date.getTime();
  return timestamp;
}
function getYear(date) {
  return toDate(date).getFullYear();
}
function isAfter(date, dateToCompare) {
  const _date = toDate(date);
  const _dateToCompare = toDate(dateToCompare);
  return _date.getTime() > _dateToCompare.getTime();
}
function isBefore(date, dateToCompare) {
  const _date = toDate(date);
  const _dateToCompare = toDate(dateToCompare);
  return +_date < +_dateToCompare;
}
function isEqual$1(leftDate, rightDate) {
  const _dateLeft = toDate(leftDate);
  const _dateRight = toDate(rightDate);
  return +_dateLeft === +_dateRight;
}
function transpose(fromDate, constructor) {
  const date = constructor instanceof Date ? constructFrom(constructor, 0) : new constructor(0);
  date.setFullYear(
    fromDate.getFullYear(),
    fromDate.getMonth(),
    fromDate.getDate()
  );
  date.setHours(
    fromDate.getHours(),
    fromDate.getMinutes(),
    fromDate.getSeconds(),
    fromDate.getMilliseconds()
  );
  return date;
}
const TIMEZONE_UNIT_PRIORITY = 10;
class Setter {
  constructor() {
    __publicField(this, "subPriority", 0);
  }
  validate(_utcDate, _options) {
    return true;
  }
}
class ValueSetter extends Setter {
  constructor(value, validateValue, setValue, priority, subPriority) {
    super();
    this.value = value;
    this.validateValue = validateValue;
    this.setValue = setValue;
    this.priority = priority;
    if (subPriority) {
      this.subPriority = subPriority;
    }
  }
  validate(date, options2) {
    return this.validateValue(date, this.value, options2);
  }
  set(date, flags, options2) {
    return this.setValue(date, flags, this.value, options2);
  }
}
class DateToSystemTimezoneSetter extends Setter {
  constructor() {
    super(...arguments);
    __publicField(this, "priority", TIMEZONE_UNIT_PRIORITY);
    __publicField(this, "subPriority", -1);
  }
  set(date, flags) {
    if (flags.timestampIsSet) return date;
    return constructFrom(date, transpose(date, Date));
  }
}
let Parser$1 = class Parser {
  run(dateString, token2, match2, options2) {
    const result = this.parse(dateString, token2, match2, options2);
    if (!result) {
      return null;
    }
    return {
      setter: new ValueSetter(
        result.value,
        this.validate,
        this.set,
        this.priority,
        this.subPriority
      ),
      rest: result.rest
    };
  }
  validate(_utcDate, _value, _options) {
    return true;
  }
};
class EraParser extends Parser$1 {
  constructor() {
    super(...arguments);
    __publicField(this, "priority", 140);
    __publicField(this, "incompatibleTokens", ["R", "u", "t", "T"]);
  }
  parse(dateString, token2, match2) {
    switch (token2) {
      case "G":
      case "GG":
      case "GGG":
        return match2.era(dateString, { width: "abbreviated" }) || match2.era(dateString, { width: "narrow" });
      case "GGGGG":
        return match2.era(dateString, { width: "narrow" });
      case "GGGG":
      default:
        return match2.era(dateString, { width: "wide" }) || match2.era(dateString, { width: "abbreviated" }) || match2.era(dateString, { width: "narrow" });
    }
  }
  set(date, flags, value) {
    flags.era = value;
    date.setFullYear(value, 0, 1);
    date.setHours(0, 0, 0, 0);
    return date;
  }
}
const numericPatterns = {
  month: /^(1[0-2]|0?\d)/,
  // 0 to 12
  date: /^(3[0-1]|[0-2]?\d)/,
  // 0 to 31
  dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
  // 0 to 366
  week: /^(5[0-3]|[0-4]?\d)/,
  // 0 to 53
  hour23h: /^(2[0-3]|[0-1]?\d)/,
  // 0 to 23
  hour24h: /^(2[0-4]|[0-1]?\d)/,
  // 0 to 24
  hour11h: /^(1[0-1]|0?\d)/,
  // 0 to 11
  hour12h: /^(1[0-2]|0?\d)/,
  // 0 to 12
  minute: /^[0-5]?\d/,
  // 0 to 59
  second: /^[0-5]?\d/,
  // 0 to 59
  singleDigit: /^\d/,
  // 0 to 9
  twoDigits: /^\d{1,2}/,
  // 0 to 99
  threeDigits: /^\d{1,3}/,
  // 0 to 999
  fourDigits: /^\d{1,4}/,
  // 0 to 9999
  anyDigitsSigned: /^-?\d+/,
  singleDigitSigned: /^-?\d/,
  // 0 to 9, -0 to -9
  twoDigitsSigned: /^-?\d{1,2}/,
  // 0 to 99, -0 to -99
  threeDigitsSigned: /^-?\d{1,3}/,
  // 0 to 999, -0 to -999
  fourDigitsSigned: /^-?\d{1,4}/
  // 0 to 9999, -0 to -9999
};
const timezonePatterns = {
  basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
  basic: /^([+-])(\d{2})(\d{2})|Z/,
  basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
  extended: /^([+-])(\d{2}):(\d{2})|Z/,
  extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};
function mapValue(parseFnResult, mapFn) {
  if (!parseFnResult) {
    return parseFnResult;
  }
  return {
    value: mapFn(parseFnResult.value),
    rest: parseFnResult.rest
  };
}
function parseNumericPattern(pattern, dateString) {
  const matchResult = dateString.match(pattern);
  if (!matchResult) {
    return null;
  }
  return {
    value: parseInt(matchResult[0], 10),
    rest: dateString.slice(matchResult[0].length)
  };
}
function parseTimezonePattern(pattern, dateString) {
  const matchResult = dateString.match(pattern);
  if (!matchResult) {
    return null;
  }
  if (matchResult[0] === "Z") {
    return {
      value: 0,
      rest: dateString.slice(1)
    };
  }
  const sign3 = matchResult[1] === "+" ? 1 : -1;
  const hours = matchResult[2] ? parseInt(matchResult[2], 10) : 0;
  const minutes = matchResult[3] ? parseInt(matchResult[3], 10) : 0;
  const seconds = matchResult[5] ? parseInt(matchResult[5], 10) : 0;
  return {
    value: sign3 * (hours * millisecondsInHour + minutes * millisecondsInMinute + seconds * millisecondsInSecond),
    rest: dateString.slice(matchResult[0].length)
  };
}
function parseAnyDigitsSigned(dateString) {
  return parseNumericPattern(numericPatterns.anyDigitsSigned, dateString);
}
function parseNDigits(n2, dateString) {
  switch (n2) {
    case 1:
      return parseNumericPattern(numericPatterns.singleDigit, dateString);
    case 2:
      return parseNumericPattern(numericPatterns.twoDigits, dateString);
    case 3:
      return parseNumericPattern(numericPatterns.threeDigits, dateString);
    case 4:
      return parseNumericPattern(numericPatterns.fourDigits, dateString);
    default:
      return parseNumericPattern(new RegExp("^\\d{1," + n2 + "}"), dateString);
  }
}
function parseNDigitsSigned(n2, dateString) {
  switch (n2) {
    case 1:
      return parseNumericPattern(numericPatterns.singleDigitSigned, dateString);
    case 2:
      return parseNumericPattern(numericPatterns.twoDigitsSigned, dateString);
    case 3:
      return parseNumericPattern(numericPatterns.threeDigitsSigned, dateString);
    case 4:
      return parseNumericPattern(numericPatterns.fourDigitsSigned, dateString);
    default:
      return parseNumericPattern(new RegExp("^-?\\d{1," + n2 + "}"), dateString);
  }
}
function dayPeriodEnumToHours(dayPeriod) {
  switch (dayPeriod) {
    case "morning":
      return 4;
    case "evening":
      return 17;
    case "pm":
    case "noon":
    case "afternoon":
      return 12;
    case "am":
    case "midnight":
    case "night":
    default:
      return 0;
  }
}
function normalizeTwoDigitYear(twoDigitYear, currentYear) {
  const isCommonEra = currentYear > 0;
  const absCurrentYear = isCommonEra ? currentYear : 1 - currentYear;
  let result;
  if (absCurrentYear <= 50) {
    result = twoDigitYear || 100;
  } else {
    const rangeEnd = absCurrentYear + 50;
    const rangeEndCentury = Math.trunc(rangeEnd / 100) * 100;
    const isPreviousCentury = twoDigitYear >= rangeEnd % 100;
    result = twoDigitYear + rangeEndCentury - (isPreviousCentury ? 100 : 0);
  }
  return isCommonEra ? result : 1 - result;
}
function isLeapYearIndex$1(year) {
  return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
class YearParser extends Parser$1 {
  constructor() {
    super(...arguments);
    __publicField(this, "priority", 130);
    __publicField(this, "incompatibleTokens", ["Y", "R", "u", "w", "I", "i", "e", "c", "t", "T"]);
  }
  parse(dateString, token2, match2) {
    const valueCallback = (year) => ({
      year,
      isTwoDigitYear: token2 === "yy"
    });
    switch (token2) {
      case "y":
        return mapValue(parseNDigits(4, dateString), valueCallback);
      case "yo":
        return mapValue(
          match2.ordinalNumber(dateString, {
            unit: "year"
          }),
          valueCallback
        );
      default:
        return mapValue(parseNDigits(token2.length, dateString), valueCallback);
    }
  }
  validate(_date, value) {
    return value.isTwoDigitYear || value.year > 0;
  }
  set(date, flags, value) {
    const currentYear = date.getFullYear();
    if (value.isTwoDigitYear) {
      const normalizedTwoDigitYear = normalizeTwoDigitYear(
        value.year,
        currentYear
      );
      date.setFullYear(normalizedTwoDigitYear, 0, 1);
      date.setHours(0, 0, 0, 0);
      return date;
    }
    const year = !("era" in flags) || flags.era === 1 ? value.year : 1 - value.year;
    date.setFullYear(year, 0, 1);
    date.setHours(0, 0, 0, 0);
    return date;
  }
}
class LocalWeekYearParser extends Parser$1 {
  constructor() {
    super(...arguments);
    __publicField(this, "priority", 130);
    __publicField(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "Q",
      "q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "i",
      "t",
      "T"
    ]);
  }
  parse(dateString, token2, match2) {
    const valueCallback = (year) => ({
      year,
      isTwoDigitYear: token2 === "YY"
    });
    switch (token2) {
      case "Y":
        return mapValue(parseNDigits(4, dateString), valueCallback);
      case "Yo":
        return mapValue(
          match2.ordinalNumber(dateString, {
            unit: "year"
          }),
          valueCallback
        );
      default:
        return mapValue(parseNDigits(token2.length, dateString), valueCallback);
    }
  }
  validate(_date, value) {
    return value.isTwoDigitYear || value.year > 0;
  }
  set(date, flags, value, options2) {
    const currentYear = getWeekYear(date, options2);
    if (value.isTwoDigitYear) {
      const normalizedTwoDigitYear = normalizeTwoDigitYear(
        value.year,
        currentYear
      );
      date.setFullYear(
        normalizedTwoDigitYear,
        0,
        options2.firstWeekContainsDate
      );
      date.setHours(0, 0, 0, 0);
      return startOfWeek(date, options2);
    }
    const year = !("era" in flags) || flags.era === 1 ? value.year : 1 - value.year;
    date.setFullYear(year, 0, options2.firstWeekContainsDate);
    date.setHours(0, 0, 0, 0);
    return startOfWeek(date, options2);
  }
}
class ISOWeekYearParser extends Parser$1 {
  constructor() {
    super(...arguments);
    __publicField(this, "priority", 130);
    __publicField(this, "incompatibleTokens", [
      "G",
      "y",
      "Y",
      "u",
      "Q",
      "q",
      "M",
      "L",
      "w",
      "d",
      "D",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(dateString, token2) {
    if (token2 === "R") {
      return parseNDigitsSigned(4, dateString);
    }
    return parseNDigitsSigned(token2.length, dateString);
  }
  set(date, _flags, value) {
    const firstWeekOfYear = constructFrom(date, 0);
    firstWeekOfYear.setFullYear(value, 0, 4);
    firstWeekOfYear.setHours(0, 0, 0, 0);
    return startOfISOWeek(firstWeekOfYear);
  }
}
class ExtendedYearParser extends Parser$1 {
  constructor() {
    super(...arguments);
    __publicField(this, "priority", 130);
    __publicField(this, "incompatibleTokens", ["G", "y", "Y", "R", "w", "I", "i", "e", "c", "t", "T"]);
  }
  parse(dateString, token2) {
    if (token2 === "u") {
      return parseNDigitsSigned(4, dateString);
    }
    return parseNDigitsSigned(token2.length, dateString);
  }
  set(date, _flags, value) {
    date.setFullYear(value, 0, 1);
    date.setHours(0, 0, 0, 0);
    return date;
  }
}
class QuarterParser extends Parser$1 {
  constructor() {
    super(...arguments);
    __publicField(this, "priority", 120);
    __publicField(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "M",
      "L",
      "w",
      "I",
      "d",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(dateString, token2, match2) {
    switch (token2) {
      case "Q":
      case "QQ":
        return parseNDigits(token2.length, dateString);
      case "Qo":
        return match2.ordinalNumber(dateString, { unit: "quarter" });
      case "QQQ":
        return match2.quarter(dateString, {
          width: "abbreviated",
          context: "formatting"
        }) || match2.quarter(dateString, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQQ":
        return match2.quarter(dateString, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return match2.quarter(dateString, {
          width: "wide",
          context: "formatting"
        }) || match2.quarter(dateString, {
          width: "abbreviated",
          context: "formatting"
        }) || match2.quarter(dateString, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  validate(_date, value) {
    return value >= 1 && value <= 4;
  }
  set(date, _flags, value) {
    date.setMonth((value - 1) * 3, 1);
    date.setHours(0, 0, 0, 0);
    return date;
  }
}
class StandAloneQuarterParser extends Parser$1 {
  constructor() {
    super(...arguments);
    __publicField(this, "priority", 120);
    __publicField(this, "incompatibleTokens", [
      "Y",
      "R",
      "Q",
      "M",
      "L",
      "w",
      "I",
      "d",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(dateString, token2, match2) {
    switch (token2) {
      case "q":
      case "qq":
        return parseNDigits(token2.length, dateString);
      case "qo":
        return match2.ordinalNumber(dateString, { unit: "quarter" });
      case "qqq":
        return match2.quarter(dateString, {
          width: "abbreviated",
          context: "standalone"
        }) || match2.quarter(dateString, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqqq":
        return match2.quarter(dateString, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return match2.quarter(dateString, {
          width: "wide",
          context: "standalone"
        }) || match2.quarter(dateString, {
          width: "abbreviated",
          context: "standalone"
        }) || match2.quarter(dateString, {
          width: "narrow",
          context: "standalone"
        });
    }
  }
  validate(_date, value) {
    return value >= 1 && value <= 4;
  }
  set(date, _flags, value) {
    date.setMonth((value - 1) * 3, 1);
    date.setHours(0, 0, 0, 0);
    return date;
  }
}
class MonthParser extends Parser$1 {
  constructor() {
    super(...arguments);
    __publicField(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "L",
      "w",
      "I",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
    __publicField(this, "priority", 110);
  }
  parse(dateString, token2, match2) {
    const valueCallback = (value) => value - 1;
    switch (token2) {
      case "M":
        return mapValue(
          parseNumericPattern(numericPatterns.month, dateString),
          valueCallback
        );
      case "MM":
        return mapValue(parseNDigits(2, dateString), valueCallback);
      case "Mo":
        return mapValue(
          match2.ordinalNumber(dateString, {
            unit: "month"
          }),
          valueCallback
        );
      case "MMM":
        return match2.month(dateString, {
          width: "abbreviated",
          context: "formatting"
        }) || match2.month(dateString, { width: "narrow", context: "formatting" });
      case "MMMMM":
        return match2.month(dateString, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return match2.month(dateString, { width: "wide", context: "formatting" }) || match2.month(dateString, {
          width: "abbreviated",
          context: "formatting"
        }) || match2.month(dateString, { width: "narrow", context: "formatting" });
    }
  }
  validate(_date, value) {
    return value >= 0 && value <= 11;
  }
  set(date, _flags, value) {
    date.setMonth(value, 1);
    date.setHours(0, 0, 0, 0);
    return date;
  }
}
class StandAloneMonthParser extends Parser$1 {
  constructor() {
    super(...arguments);
    __publicField(this, "priority", 110);
    __publicField(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "M",
      "w",
      "I",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(dateString, token2, match2) {
    const valueCallback = (value) => value - 1;
    switch (token2) {
      case "L":
        return mapValue(
          parseNumericPattern(numericPatterns.month, dateString),
          valueCallback
        );
      case "LL":
        return mapValue(parseNDigits(2, dateString), valueCallback);
      case "Lo":
        return mapValue(
          match2.ordinalNumber(dateString, {
            unit: "month"
          }),
          valueCallback
        );
      case "LLL":
        return match2.month(dateString, {
          width: "abbreviated",
          context: "standalone"
        }) || match2.month(dateString, { width: "narrow", context: "standalone" });
      case "LLLLL":
        return match2.month(dateString, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return match2.month(dateString, { width: "wide", context: "standalone" }) || match2.month(dateString, {
          width: "abbreviated",
          context: "standalone"
        }) || match2.month(dateString, { width: "narrow", context: "standalone" });
    }
  }
  validate(_date, value) {
    return value >= 0 && value <= 11;
  }
  set(date, _flags, value) {
    date.setMonth(value, 1);
    date.setHours(0, 0, 0, 0);
    return date;
  }
}
function setWeek(date, week, options2) {
  const _date = toDate(date);
  const diff = getWeek$1(_date, options2) - week;
  _date.setDate(_date.getDate() - diff * 7);
  return _date;
}
class LocalWeekParser extends Parser$1 {
  constructor() {
    super(...arguments);
    __publicField(this, "priority", 100);
    __publicField(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "i",
      "t",
      "T"
    ]);
  }
  parse(dateString, token2, match2) {
    switch (token2) {
      case "w":
        return parseNumericPattern(numericPatterns.week, dateString);
      case "wo":
        return match2.ordinalNumber(dateString, { unit: "week" });
      default:
        return parseNDigits(token2.length, dateString);
    }
  }
  validate(_date, value) {
    return value >= 1 && value <= 53;
  }
  set(date, _flags, value, options2) {
    return startOfWeek(setWeek(date, value, options2), options2);
  }
}
function setISOWeek(date, week) {
  const _date = toDate(date);
  const diff = getISOWeek(_date) - week;
  _date.setDate(_date.getDate() - diff * 7);
  return _date;
}
class ISOWeekParser extends Parser$1 {
  constructor() {
    super(...arguments);
    __publicField(this, "priority", 100);
    __publicField(this, "incompatibleTokens", [
      "y",
      "Y",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "w",
      "d",
      "D",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(dateString, token2, match2) {
    switch (token2) {
      case "I":
        return parseNumericPattern(numericPatterns.week, dateString);
      case "Io":
        return match2.ordinalNumber(dateString, { unit: "week" });
      default:
        return parseNDigits(token2.length, dateString);
    }
  }
  validate(_date, value) {
    return value >= 1 && value <= 53;
  }
  set(date, _flags, value) {
    return startOfISOWeek(setISOWeek(date, value));
  }
}
const DAYS_IN_MONTH = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
const DAYS_IN_MONTH_LEAP_YEAR = [
  31,
  29,
  31,
  30,
  31,
  30,
  31,
  31,
  30,
  31,
  30,
  31
];
class DateParser extends Parser$1 {
  constructor() {
    super(...arguments);
    __publicField(this, "priority", 90);
    __publicField(this, "subPriority", 1);
    __publicField(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "w",
      "I",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(dateString, token2, match2) {
    switch (token2) {
      case "d":
        return parseNumericPattern(numericPatterns.date, dateString);
      case "do":
        return match2.ordinalNumber(dateString, { unit: "date" });
      default:
        return parseNDigits(token2.length, dateString);
    }
  }
  validate(date, value) {
    const year = date.getFullYear();
    const isLeapYear = isLeapYearIndex$1(year);
    const month = date.getMonth();
    if (isLeapYear) {
      return value >= 1 && value <= DAYS_IN_MONTH_LEAP_YEAR[month];
    } else {
      return value >= 1 && value <= DAYS_IN_MONTH[month];
    }
  }
  set(date, _flags, value) {
    date.setDate(value);
    date.setHours(0, 0, 0, 0);
    return date;
  }
}
class DayOfYearParser extends Parser$1 {
  constructor() {
    super(...arguments);
    __publicField(this, "priority", 90);
    __publicField(this, "subpriority", 1);
    __publicField(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "M",
      "L",
      "w",
      "I",
      "d",
      "E",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(dateString, token2, match2) {
    switch (token2) {
      case "D":
      case "DD":
        return parseNumericPattern(numericPatterns.dayOfYear, dateString);
      case "Do":
        return match2.ordinalNumber(dateString, { unit: "date" });
      default:
        return parseNDigits(token2.length, dateString);
    }
  }
  validate(date, value) {
    const year = date.getFullYear();
    const isLeapYear = isLeapYearIndex$1(year);
    if (isLeapYear) {
      return value >= 1 && value <= 366;
    } else {
      return value >= 1 && value <= 365;
    }
  }
  set(date, _flags, value) {
    date.setMonth(0, value);
    date.setHours(0, 0, 0, 0);
    return date;
  }
}
function setDay(date, day, options2) {
  var _a2, _b, _c, _d;
  const defaultOptions2 = getDefaultOptions$1();
  const weekStartsOn = (options2 == null ? void 0 : options2.weekStartsOn) ?? ((_b = (_a2 = options2 == null ? void 0 : options2.locale) == null ? void 0 : _a2.options) == null ? void 0 : _b.weekStartsOn) ?? defaultOptions2.weekStartsOn ?? ((_d = (_c = defaultOptions2.locale) == null ? void 0 : _c.options) == null ? void 0 : _d.weekStartsOn) ?? 0;
  const _date = toDate(date);
  const currentDay = _date.getDay();
  const remainder = day % 7;
  const dayIndex = (remainder + 7) % 7;
  const delta = 7 - weekStartsOn;
  const diff = day < 0 || day > 6 ? day - (currentDay + delta) % 7 : (dayIndex + delta) % 7 - (currentDay + delta) % 7;
  return addDays(_date, diff);
}
class DayParser extends Parser$1 {
  constructor() {
    super(...arguments);
    __publicField(this, "priority", 90);
    __publicField(this, "incompatibleTokens", ["D", "i", "e", "c", "t", "T"]);
  }
  parse(dateString, token2, match2) {
    switch (token2) {
      case "E":
      case "EE":
      case "EEE":
        return match2.day(dateString, {
          width: "abbreviated",
          context: "formatting"
        }) || match2.day(dateString, { width: "short", context: "formatting" }) || match2.day(dateString, { width: "narrow", context: "formatting" });
      case "EEEEE":
        return match2.day(dateString, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return match2.day(dateString, { width: "short", context: "formatting" }) || match2.day(dateString, { width: "narrow", context: "formatting" });
      case "EEEE":
      default:
        return match2.day(dateString, { width: "wide", context: "formatting" }) || match2.day(dateString, {
          width: "abbreviated",
          context: "formatting"
        }) || match2.day(dateString, { width: "short", context: "formatting" }) || match2.day(dateString, { width: "narrow", context: "formatting" });
    }
  }
  validate(_date, value) {
    return value >= 0 && value <= 6;
  }
  set(date, _flags, value, options2) {
    date = setDay(date, value, options2);
    date.setHours(0, 0, 0, 0);
    return date;
  }
}
class LocalDayParser extends Parser$1 {
  constructor() {
    super(...arguments);
    __publicField(this, "priority", 90);
    __publicField(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "E",
      "i",
      "c",
      "t",
      "T"
    ]);
  }
  parse(dateString, token2, match2, options2) {
    const valueCallback = (value) => {
      const wholeWeekDays = Math.floor((value - 1) / 7) * 7;
      return (value + options2.weekStartsOn + 6) % 7 + wholeWeekDays;
    };
    switch (token2) {
      case "e":
      case "ee":
        return mapValue(parseNDigits(token2.length, dateString), valueCallback);
      case "eo":
        return mapValue(
          match2.ordinalNumber(dateString, {
            unit: "day"
          }),
          valueCallback
        );
      case "eee":
        return match2.day(dateString, {
          width: "abbreviated",
          context: "formatting"
        }) || match2.day(dateString, { width: "short", context: "formatting" }) || match2.day(dateString, { width: "narrow", context: "formatting" });
      case "eeeee":
        return match2.day(dateString, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return match2.day(dateString, { width: "short", context: "formatting" }) || match2.day(dateString, { width: "narrow", context: "formatting" });
      case "eeee":
      default:
        return match2.day(dateString, { width: "wide", context: "formatting" }) || match2.day(dateString, {
          width: "abbreviated",
          context: "formatting"
        }) || match2.day(dateString, { width: "short", context: "formatting" }) || match2.day(dateString, { width: "narrow", context: "formatting" });
    }
  }
  validate(_date, value) {
    return value >= 0 && value <= 6;
  }
  set(date, _flags, value, options2) {
    date = setDay(date, value, options2);
    date.setHours(0, 0, 0, 0);
    return date;
  }
}
class StandAloneLocalDayParser extends Parser$1 {
  constructor() {
    super(...arguments);
    __publicField(this, "priority", 90);
    __publicField(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "E",
      "i",
      "e",
      "t",
      "T"
    ]);
  }
  parse(dateString, token2, match2, options2) {
    const valueCallback = (value) => {
      const wholeWeekDays = Math.floor((value - 1) / 7) * 7;
      return (value + options2.weekStartsOn + 6) % 7 + wholeWeekDays;
    };
    switch (token2) {
      case "c":
      case "cc":
        return mapValue(parseNDigits(token2.length, dateString), valueCallback);
      case "co":
        return mapValue(
          match2.ordinalNumber(dateString, {
            unit: "day"
          }),
          valueCallback
        );
      case "ccc":
        return match2.day(dateString, {
          width: "abbreviated",
          context: "standalone"
        }) || match2.day(dateString, { width: "short", context: "standalone" }) || match2.day(dateString, { width: "narrow", context: "standalone" });
      case "ccccc":
        return match2.day(dateString, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return match2.day(dateString, { width: "short", context: "standalone" }) || match2.day(dateString, { width: "narrow", context: "standalone" });
      case "cccc":
      default:
        return match2.day(dateString, { width: "wide", context: "standalone" }) || match2.day(dateString, {
          width: "abbreviated",
          context: "standalone"
        }) || match2.day(dateString, { width: "short", context: "standalone" }) || match2.day(dateString, { width: "narrow", context: "standalone" });
    }
  }
  validate(_date, value) {
    return value >= 0 && value <= 6;
  }
  set(date, _flags, value, options2) {
    date = setDay(date, value, options2);
    date.setHours(0, 0, 0, 0);
    return date;
  }
}
function setISODay(date, day) {
  const _date = toDate(date);
  const currentDay = getISODay(_date);
  const diff = day - currentDay;
  return addDays(_date, diff);
}
class ISODayParser extends Parser$1 {
  constructor() {
    super(...arguments);
    __publicField(this, "priority", 90);
    __publicField(this, "incompatibleTokens", [
      "y",
      "Y",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "w",
      "d",
      "D",
      "E",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(dateString, token2, match2) {
    const valueCallback = (value) => {
      if (value === 0) {
        return 7;
      }
      return value;
    };
    switch (token2) {
      case "i":
      case "ii":
        return parseNDigits(token2.length, dateString);
      case "io":
        return match2.ordinalNumber(dateString, { unit: "day" });
      case "iii":
        return mapValue(
          match2.day(dateString, {
            width: "abbreviated",
            context: "formatting"
          }) || match2.day(dateString, {
            width: "short",
            context: "formatting"
          }) || match2.day(dateString, {
            width: "narrow",
            context: "formatting"
          }),
          valueCallback
        );
      case "iiiii":
        return mapValue(
          match2.day(dateString, {
            width: "narrow",
            context: "formatting"
          }),
          valueCallback
        );
      case "iiiiii":
        return mapValue(
          match2.day(dateString, {
            width: "short",
            context: "formatting"
          }) || match2.day(dateString, {
            width: "narrow",
            context: "formatting"
          }),
          valueCallback
        );
      case "iiii":
      default:
        return mapValue(
          match2.day(dateString, {
            width: "wide",
            context: "formatting"
          }) || match2.day(dateString, {
            width: "abbreviated",
            context: "formatting"
          }) || match2.day(dateString, {
            width: "short",
            context: "formatting"
          }) || match2.day(dateString, {
            width: "narrow",
            context: "formatting"
          }),
          valueCallback
        );
    }
  }
  validate(_date, value) {
    return value >= 1 && value <= 7;
  }
  set(date, _flags, value) {
    date = setISODay(date, value);
    date.setHours(0, 0, 0, 0);
    return date;
  }
}
class AMPMParser extends Parser$1 {
  constructor() {
    super(...arguments);
    __publicField(this, "priority", 80);
    __publicField(this, "incompatibleTokens", ["b", "B", "H", "k", "t", "T"]);
  }
  parse(dateString, token2, match2) {
    switch (token2) {
      case "a":
      case "aa":
      case "aaa":
        return match2.dayPeriod(dateString, {
          width: "abbreviated",
          context: "formatting"
        }) || match2.dayPeriod(dateString, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaaa":
        return match2.dayPeriod(dateString, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return match2.dayPeriod(dateString, {
          width: "wide",
          context: "formatting"
        }) || match2.dayPeriod(dateString, {
          width: "abbreviated",
          context: "formatting"
        }) || match2.dayPeriod(dateString, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(date, _flags, value) {
    date.setHours(dayPeriodEnumToHours(value), 0, 0, 0);
    return date;
  }
}
class AMPMMidnightParser extends Parser$1 {
  constructor() {
    super(...arguments);
    __publicField(this, "priority", 80);
    __publicField(this, "incompatibleTokens", ["a", "B", "H", "k", "t", "T"]);
  }
  parse(dateString, token2, match2) {
    switch (token2) {
      case "b":
      case "bb":
      case "bbb":
        return match2.dayPeriod(dateString, {
          width: "abbreviated",
          context: "formatting"
        }) || match2.dayPeriod(dateString, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbbb":
        return match2.dayPeriod(dateString, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return match2.dayPeriod(dateString, {
          width: "wide",
          context: "formatting"
        }) || match2.dayPeriod(dateString, {
          width: "abbreviated",
          context: "formatting"
        }) || match2.dayPeriod(dateString, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(date, _flags, value) {
    date.setHours(dayPeriodEnumToHours(value), 0, 0, 0);
    return date;
  }
}
class DayPeriodParser extends Parser$1 {
  constructor() {
    super(...arguments);
    __publicField(this, "priority", 80);
    __publicField(this, "incompatibleTokens", ["a", "b", "t", "T"]);
  }
  parse(dateString, token2, match2) {
    switch (token2) {
      case "B":
      case "BB":
      case "BBB":
        return match2.dayPeriod(dateString, {
          width: "abbreviated",
          context: "formatting"
        }) || match2.dayPeriod(dateString, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBBB":
        return match2.dayPeriod(dateString, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return match2.dayPeriod(dateString, {
          width: "wide",
          context: "formatting"
        }) || match2.dayPeriod(dateString, {
          width: "abbreviated",
          context: "formatting"
        }) || match2.dayPeriod(dateString, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(date, _flags, value) {
    date.setHours(dayPeriodEnumToHours(value), 0, 0, 0);
    return date;
  }
}
class Hour1to12Parser extends Parser$1 {
  constructor() {
    super(...arguments);
    __publicField(this, "priority", 70);
    __publicField(this, "incompatibleTokens", ["H", "K", "k", "t", "T"]);
  }
  parse(dateString, token2, match2) {
    switch (token2) {
      case "h":
        return parseNumericPattern(numericPatterns.hour12h, dateString);
      case "ho":
        return match2.ordinalNumber(dateString, { unit: "hour" });
      default:
        return parseNDigits(token2.length, dateString);
    }
  }
  validate(_date, value) {
    return value >= 1 && value <= 12;
  }
  set(date, _flags, value) {
    const isPM = date.getHours() >= 12;
    if (isPM && value < 12) {
      date.setHours(value + 12, 0, 0, 0);
    } else if (!isPM && value === 12) {
      date.setHours(0, 0, 0, 0);
    } else {
      date.setHours(value, 0, 0, 0);
    }
    return date;
  }
}
class Hour0to23Parser extends Parser$1 {
  constructor() {
    super(...arguments);
    __publicField(this, "priority", 70);
    __publicField(this, "incompatibleTokens", ["a", "b", "h", "K", "k", "t", "T"]);
  }
  parse(dateString, token2, match2) {
    switch (token2) {
      case "H":
        return parseNumericPattern(numericPatterns.hour23h, dateString);
      case "Ho":
        return match2.ordinalNumber(dateString, { unit: "hour" });
      default:
        return parseNDigits(token2.length, dateString);
    }
  }
  validate(_date, value) {
    return value >= 0 && value <= 23;
  }
  set(date, _flags, value) {
    date.setHours(value, 0, 0, 0);
    return date;
  }
}
class Hour0To11Parser extends Parser$1 {
  constructor() {
    super(...arguments);
    __publicField(this, "priority", 70);
    __publicField(this, "incompatibleTokens", ["h", "H", "k", "t", "T"]);
  }
  parse(dateString, token2, match2) {
    switch (token2) {
      case "K":
        return parseNumericPattern(numericPatterns.hour11h, dateString);
      case "Ko":
        return match2.ordinalNumber(dateString, { unit: "hour" });
      default:
        return parseNDigits(token2.length, dateString);
    }
  }
  validate(_date, value) {
    return value >= 0 && value <= 11;
  }
  set(date, _flags, value) {
    const isPM = date.getHours() >= 12;
    if (isPM && value < 12) {
      date.setHours(value + 12, 0, 0, 0);
    } else {
      date.setHours(value, 0, 0, 0);
    }
    return date;
  }
}
class Hour1To24Parser extends Parser$1 {
  constructor() {
    super(...arguments);
    __publicField(this, "priority", 70);
    __publicField(this, "incompatibleTokens", ["a", "b", "h", "H", "K", "t", "T"]);
  }
  parse(dateString, token2, match2) {
    switch (token2) {
      case "k":
        return parseNumericPattern(numericPatterns.hour24h, dateString);
      case "ko":
        return match2.ordinalNumber(dateString, { unit: "hour" });
      default:
        return parseNDigits(token2.length, dateString);
    }
  }
  validate(_date, value) {
    return value >= 1 && value <= 24;
  }
  set(date, _flags, value) {
    const hours = value <= 24 ? value % 24 : value;
    date.setHours(hours, 0, 0, 0);
    return date;
  }
}
class MinuteParser extends Parser$1 {
  constructor() {
    super(...arguments);
    __publicField(this, "priority", 60);
    __publicField(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(dateString, token2, match2) {
    switch (token2) {
      case "m":
        return parseNumericPattern(numericPatterns.minute, dateString);
      case "mo":
        return match2.ordinalNumber(dateString, { unit: "minute" });
      default:
        return parseNDigits(token2.length, dateString);
    }
  }
  validate(_date, value) {
    return value >= 0 && value <= 59;
  }
  set(date, _flags, value) {
    date.setMinutes(value, 0, 0);
    return date;
  }
}
class SecondParser extends Parser$1 {
  constructor() {
    super(...arguments);
    __publicField(this, "priority", 50);
    __publicField(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(dateString, token2, match2) {
    switch (token2) {
      case "s":
        return parseNumericPattern(numericPatterns.second, dateString);
      case "so":
        return match2.ordinalNumber(dateString, { unit: "second" });
      default:
        return parseNDigits(token2.length, dateString);
    }
  }
  validate(_date, value) {
    return value >= 0 && value <= 59;
  }
  set(date, _flags, value) {
    date.setSeconds(value, 0);
    return date;
  }
}
class FractionOfSecondParser extends Parser$1 {
  constructor() {
    super(...arguments);
    __publicField(this, "priority", 30);
    __publicField(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(dateString, token2) {
    const valueCallback = (value) => Math.trunc(value * Math.pow(10, -token2.length + 3));
    return mapValue(parseNDigits(token2.length, dateString), valueCallback);
  }
  set(date, _flags, value) {
    date.setMilliseconds(value);
    return date;
  }
}
class ISOTimezoneWithZParser extends Parser$1 {
  constructor() {
    super(...arguments);
    __publicField(this, "priority", 10);
    __publicField(this, "incompatibleTokens", ["t", "T", "x"]);
  }
  parse(dateString, token2) {
    switch (token2) {
      case "X":
        return parseTimezonePattern(
          timezonePatterns.basicOptionalMinutes,
          dateString
        );
      case "XX":
        return parseTimezonePattern(timezonePatterns.basic, dateString);
      case "XXXX":
        return parseTimezonePattern(
          timezonePatterns.basicOptionalSeconds,
          dateString
        );
      case "XXXXX":
        return parseTimezonePattern(
          timezonePatterns.extendedOptionalSeconds,
          dateString
        );
      case "XXX":
      default:
        return parseTimezonePattern(timezonePatterns.extended, dateString);
    }
  }
  set(date, flags, value) {
    if (flags.timestampIsSet) return date;
    return constructFrom(
      date,
      date.getTime() - getTimezoneOffsetInMilliseconds(date) - value
    );
  }
}
class ISOTimezoneParser extends Parser$1 {
  constructor() {
    super(...arguments);
    __publicField(this, "priority", 10);
    __publicField(this, "incompatibleTokens", ["t", "T", "X"]);
  }
  parse(dateString, token2) {
    switch (token2) {
      case "x":
        return parseTimezonePattern(
          timezonePatterns.basicOptionalMinutes,
          dateString
        );
      case "xx":
        return parseTimezonePattern(timezonePatterns.basic, dateString);
      case "xxxx":
        return parseTimezonePattern(
          timezonePatterns.basicOptionalSeconds,
          dateString
        );
      case "xxxxx":
        return parseTimezonePattern(
          timezonePatterns.extendedOptionalSeconds,
          dateString
        );
      case "xxx":
      default:
        return parseTimezonePattern(timezonePatterns.extended, dateString);
    }
  }
  set(date, flags, value) {
    if (flags.timestampIsSet) return date;
    return constructFrom(
      date,
      date.getTime() - getTimezoneOffsetInMilliseconds(date) - value
    );
  }
}
class TimestampSecondsParser extends Parser$1 {
  constructor() {
    super(...arguments);
    __publicField(this, "priority", 40);
    __publicField(this, "incompatibleTokens", "*");
  }
  parse(dateString) {
    return parseAnyDigitsSigned(dateString);
  }
  set(date, _flags, value) {
    return [constructFrom(date, value * 1e3), { timestampIsSet: true }];
  }
}
class TimestampMillisecondsParser extends Parser$1 {
  constructor() {
    super(...arguments);
    __publicField(this, "priority", 20);
    __publicField(this, "incompatibleTokens", "*");
  }
  parse(dateString) {
    return parseAnyDigitsSigned(dateString);
  }
  set(date, _flags, value) {
    return [constructFrom(date, value), { timestampIsSet: true }];
  }
}
const parsers = {
  G: new EraParser(),
  y: new YearParser(),
  Y: new LocalWeekYearParser(),
  R: new ISOWeekYearParser(),
  u: new ExtendedYearParser(),
  Q: new QuarterParser(),
  q: new StandAloneQuarterParser(),
  M: new MonthParser(),
  L: new StandAloneMonthParser(),
  w: new LocalWeekParser(),
  I: new ISOWeekParser(),
  d: new DateParser(),
  D: new DayOfYearParser(),
  E: new DayParser(),
  e: new LocalDayParser(),
  c: new StandAloneLocalDayParser(),
  i: new ISODayParser(),
  a: new AMPMParser(),
  b: new AMPMMidnightParser(),
  B: new DayPeriodParser(),
  h: new Hour1to12Parser(),
  H: new Hour0to23Parser(),
  K: new Hour0To11Parser(),
  k: new Hour1To24Parser(),
  m: new MinuteParser(),
  s: new SecondParser(),
  S: new FractionOfSecondParser(),
  X: new ISOTimezoneWithZParser(),
  x: new ISOTimezoneParser(),
  t: new TimestampSecondsParser(),
  T: new TimestampMillisecondsParser()
};
const formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
const longFormattingTokensRegExp$1 = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
const escapedStringRegExp = /^'([^]*?)'?$/;
const doubleQuoteRegExp = /''/g;
const notWhitespaceRegExp = /\S/;
const unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function parse(dateStr, formatStr, referenceDate, options2) {
  var _a2, _b, _c, _d, _e, _f, _g, _h;
  const defaultOptions2 = getDefaultOptions();
  const locale = (options2 == null ? void 0 : options2.locale) ?? defaultOptions2.locale ?? enUS;
  const firstWeekContainsDate = (options2 == null ? void 0 : options2.firstWeekContainsDate) ?? ((_b = (_a2 = options2 == null ? void 0 : options2.locale) == null ? void 0 : _a2.options) == null ? void 0 : _b.firstWeekContainsDate) ?? defaultOptions2.firstWeekContainsDate ?? ((_d = (_c = defaultOptions2.locale) == null ? void 0 : _c.options) == null ? void 0 : _d.firstWeekContainsDate) ?? 1;
  const weekStartsOn = (options2 == null ? void 0 : options2.weekStartsOn) ?? ((_f = (_e = options2 == null ? void 0 : options2.locale) == null ? void 0 : _e.options) == null ? void 0 : _f.weekStartsOn) ?? defaultOptions2.weekStartsOn ?? ((_h = (_g = defaultOptions2.locale) == null ? void 0 : _g.options) == null ? void 0 : _h.weekStartsOn) ?? 0;
  if (formatStr === "") {
    if (dateStr === "") {
      return toDate(referenceDate);
    } else {
      return constructFrom(referenceDate, NaN);
    }
  }
  const subFnOptions = {
    firstWeekContainsDate,
    weekStartsOn,
    locale
  };
  const setters = [new DateToSystemTimezoneSetter()];
  const tokens = formatStr.match(longFormattingTokensRegExp$1).map((substring) => {
    const firstCharacter = substring[0];
    if (firstCharacter in longFormatters) {
      const longFormatter = longFormatters[firstCharacter];
      return longFormatter(substring, locale.formatLong);
    }
    return substring;
  }).join("").match(formattingTokensRegExp);
  const usedTokens = [];
  for (let token2 of tokens) {
    if (!(options2 == null ? void 0 : options2.useAdditionalWeekYearTokens) && isProtectedWeekYearToken(token2)) {
      warnOrThrowProtectedError(token2, formatStr, dateStr);
    }
    if (!(options2 == null ? void 0 : options2.useAdditionalDayOfYearTokens) && isProtectedDayOfYearToken(token2)) {
      warnOrThrowProtectedError(token2, formatStr, dateStr);
    }
    const firstCharacter = token2[0];
    const parser = parsers[firstCharacter];
    if (parser) {
      const { incompatibleTokens } = parser;
      if (Array.isArray(incompatibleTokens)) {
        const incompatibleToken = usedTokens.find(
          (usedToken) => incompatibleTokens.includes(usedToken.token) || usedToken.token === firstCharacter
        );
        if (incompatibleToken) {
          throw new RangeError(
            `The format string mustn't contain \`${incompatibleToken.fullToken}\` and \`${token2}\` at the same time`
          );
        }
      } else if (parser.incompatibleTokens === "*" && usedTokens.length > 0) {
        throw new RangeError(
          `The format string mustn't contain \`${token2}\` and any other token at the same time`
        );
      }
      usedTokens.push({ token: firstCharacter, fullToken: token2 });
      const parseResult = parser.run(
        dateStr,
        token2,
        locale.match,
        subFnOptions
      );
      if (!parseResult) {
        return constructFrom(referenceDate, NaN);
      }
      setters.push(parseResult.setter);
      dateStr = parseResult.rest;
    } else {
      if (firstCharacter.match(unescapedLatinCharacterRegExp)) {
        throw new RangeError(
          "Format string contains an unescaped latin alphabet character `" + firstCharacter + "`"
        );
      }
      if (token2 === "''") {
        token2 = "'";
      } else if (firstCharacter === "'") {
        token2 = cleanEscapedString(token2);
      }
      if (dateStr.indexOf(token2) === 0) {
        dateStr = dateStr.slice(token2.length);
      } else {
        return constructFrom(referenceDate, NaN);
      }
    }
  }
  if (dateStr.length > 0 && notWhitespaceRegExp.test(dateStr)) {
    return constructFrom(referenceDate, NaN);
  }
  const uniquePrioritySetters = setters.map((setter) => setter.priority).sort((a2, b2) => b2 - a2).filter((priority, index2, array) => array.indexOf(priority) === index2).map(
    (priority) => setters.filter((setter) => setter.priority === priority).sort((a2, b2) => b2.subPriority - a2.subPriority)
  ).map((setterArray) => setterArray[0]);
  let date = toDate(referenceDate);
  if (isNaN(date.getTime())) {
    return constructFrom(referenceDate, NaN);
  }
  const flags = {};
  for (const setter of uniquePrioritySetters) {
    if (!setter.validate(date, subFnOptions)) {
      return constructFrom(referenceDate, NaN);
    }
    const result = setter.set(date, flags, subFnOptions);
    if (Array.isArray(result)) {
      date = result[0];
      Object.assign(flags, result[1]);
    } else {
      date = result;
    }
  }
  return constructFrom(referenceDate, date);
}
function cleanEscapedString(input) {
  return input.match(escapedStringRegExp)[1].replace(doubleQuoteRegExp, "'");
}
function isSameMonth$1(dateLeft, dateRight) {
  const _dateLeft = toDate(dateLeft);
  const _dateRight = toDate(dateRight);
  return _dateLeft.getFullYear() === _dateRight.getFullYear() && _dateLeft.getMonth() === _dateRight.getMonth();
}
function isSameQuarter$1(dateLeft, dateRight) {
  const dateLeftStartOfQuarter = startOfQuarter(dateLeft);
  const dateRightStartOfQuarter = startOfQuarter(dateRight);
  return +dateLeftStartOfQuarter === +dateRightStartOfQuarter;
}
function isSameYear$1(dateLeft, dateRight) {
  const _dateLeft = toDate(dateLeft);
  const _dateRight = toDate(dateRight);
  return _dateLeft.getFullYear() === _dateRight.getFullYear();
}
function isWithinInterval(date, interval) {
  const time = +toDate(date);
  const [startTime, endTime] = [
    +toDate(interval.start),
    +toDate(interval.end)
  ].sort((a2, b2) => a2 - b2);
  return time >= startTime && time <= endTime;
}
function subDays(date, amount) {
  return addDays(date, -1);
}
function parseISO(argument, options2) {
  const additionalDigits = 2;
  const dateStrings = splitDateString(argument);
  let date;
  if (dateStrings.date) {
    const parseYearResult = parseYear(dateStrings.date, additionalDigits);
    date = parseDate$1(parseYearResult.restDateString, parseYearResult.year);
  }
  if (!date || isNaN(date.getTime())) {
    return /* @__PURE__ */ new Date(NaN);
  }
  const timestamp = date.getTime();
  let time = 0;
  let offset2;
  if (dateStrings.time) {
    time = parseTime(dateStrings.time);
    if (isNaN(time)) {
      return /* @__PURE__ */ new Date(NaN);
    }
  }
  if (dateStrings.timezone) {
    offset2 = parseTimezone(dateStrings.timezone);
    if (isNaN(offset2)) {
      return /* @__PURE__ */ new Date(NaN);
    }
  } else {
    const dirtyDate = new Date(timestamp + time);
    const result = /* @__PURE__ */ new Date(0);
    result.setFullYear(
      dirtyDate.getUTCFullYear(),
      dirtyDate.getUTCMonth(),
      dirtyDate.getUTCDate()
    );
    result.setHours(
      dirtyDate.getUTCHours(),
      dirtyDate.getUTCMinutes(),
      dirtyDate.getUTCSeconds(),
      dirtyDate.getUTCMilliseconds()
    );
    return result;
  }
  return new Date(timestamp + time + offset2);
}
const patterns = {
  dateTimeDelimiter: /[T ]/,
  timeZoneDelimiter: /[Z ]/i,
  timezone: /([Z+-].*)$/
};
const dateRegex = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/;
const timeRegex = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/;
const timezoneRegex = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function splitDateString(dateString) {
  const dateStrings = {};
  const array = dateString.split(patterns.dateTimeDelimiter);
  let timeString;
  if (array.length > 2) {
    return dateStrings;
  }
  if (/:/.test(array[0])) {
    timeString = array[0];
  } else {
    dateStrings.date = array[0];
    timeString = array[1];
    if (patterns.timeZoneDelimiter.test(dateStrings.date)) {
      dateStrings.date = dateString.split(patterns.timeZoneDelimiter)[0];
      timeString = dateString.substr(
        dateStrings.date.length,
        dateString.length
      );
    }
  }
  if (timeString) {
    const token2 = patterns.timezone.exec(timeString);
    if (token2) {
      dateStrings.time = timeString.replace(token2[1], "");
      dateStrings.timezone = token2[1];
    } else {
      dateStrings.time = timeString;
    }
  }
  return dateStrings;
}
function parseYear(dateString, additionalDigits) {
  const regex = new RegExp(
    "^(?:(\\d{4}|[+-]\\d{" + (4 + additionalDigits) + "})|(\\d{2}|[+-]\\d{" + (2 + additionalDigits) + "})$)"
  );
  const captures = dateString.match(regex);
  if (!captures) return { year: NaN, restDateString: "" };
  const year = captures[1] ? parseInt(captures[1]) : null;
  const century = captures[2] ? parseInt(captures[2]) : null;
  return {
    year: century === null ? year : century * 100,
    restDateString: dateString.slice((captures[1] || captures[2]).length)
  };
}
function parseDate$1(dateString, year) {
  if (year === null) return /* @__PURE__ */ new Date(NaN);
  const captures = dateString.match(dateRegex);
  if (!captures) return /* @__PURE__ */ new Date(NaN);
  const isWeekDate = !!captures[4];
  const dayOfYear = parseDateUnit(captures[1]);
  const month = parseDateUnit(captures[2]) - 1;
  const day = parseDateUnit(captures[3]);
  const week = parseDateUnit(captures[4]);
  const dayOfWeek = parseDateUnit(captures[5]) - 1;
  if (isWeekDate) {
    if (!validateWeekDate(year, week, dayOfWeek)) {
      return /* @__PURE__ */ new Date(NaN);
    }
    return dayOfISOWeekYear(year, week, dayOfWeek);
  } else {
    const date = /* @__PURE__ */ new Date(0);
    if (!validateDate(year, month, day) || !validateDayOfYearDate(year, dayOfYear)) {
      return /* @__PURE__ */ new Date(NaN);
    }
    date.setUTCFullYear(year, month, Math.max(dayOfYear, day));
    return date;
  }
}
function parseDateUnit(value) {
  return value ? parseInt(value) : 1;
}
function parseTime(timeString) {
  const captures = timeString.match(timeRegex);
  if (!captures) return NaN;
  const hours = parseTimeUnit(captures[1]);
  const minutes = parseTimeUnit(captures[2]);
  const seconds = parseTimeUnit(captures[3]);
  if (!validateTime(hours, minutes, seconds)) {
    return NaN;
  }
  return hours * millisecondsInHour + minutes * millisecondsInMinute + seconds * 1e3;
}
function parseTimeUnit(value) {
  return value && parseFloat(value.replace(",", ".")) || 0;
}
function parseTimezone(timezoneString) {
  if (timezoneString === "Z") return 0;
  const captures = timezoneString.match(timezoneRegex);
  if (!captures) return 0;
  const sign3 = captures[1] === "+" ? -1 : 1;
  const hours = parseInt(captures[2]);
  const minutes = captures[3] && parseInt(captures[3]) || 0;
  if (!validateTimezone(hours, minutes)) {
    return NaN;
  }
  return sign3 * (hours * millisecondsInHour + minutes * millisecondsInMinute);
}
function dayOfISOWeekYear(isoWeekYear, week, day) {
  const date = /* @__PURE__ */ new Date(0);
  date.setUTCFullYear(isoWeekYear, 0, 4);
  const fourthOfJanuaryDay = date.getUTCDay() || 7;
  const diff = (week - 1) * 7 + day + 1 - fourthOfJanuaryDay;
  date.setUTCDate(date.getUTCDate() + diff);
  return date;
}
const daysInMonths = [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
function isLeapYearIndex(year) {
  return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function validateDate(year, month, date) {
  return month >= 0 && month <= 11 && date >= 1 && date <= (daysInMonths[month] || (isLeapYearIndex(year) ? 29 : 28));
}
function validateDayOfYearDate(year, dayOfYear) {
  return dayOfYear >= 1 && dayOfYear <= (isLeapYearIndex(year) ? 366 : 365);
}
function validateWeekDate(_year, week, day) {
  return week >= 1 && week <= 53 && day >= 0 && day <= 6;
}
function validateTime(hours, minutes, seconds) {
  if (hours === 24) {
    return minutes === 0 && seconds === 0;
  }
  return seconds >= 0 && seconds < 60 && minutes >= 0 && minutes < 60 && hours >= 0 && hours < 25;
}
function validateTimezone(_hours, minutes) {
  return minutes >= 0 && minutes <= 59;
}
function setMonth(date, month) {
  const _date = toDate(date);
  const year = _date.getFullYear();
  const day = _date.getDate();
  const dateWithDesiredMonth = constructFrom(date, 0);
  dateWithDesiredMonth.setFullYear(year, month, 15);
  dateWithDesiredMonth.setHours(0, 0, 0, 0);
  const daysInMonth = getDaysInMonth(dateWithDesiredMonth);
  _date.setMonth(month, Math.min(day, daysInMonth));
  return _date;
}
function set(date, values3) {
  let _date = toDate(date);
  if (isNaN(+_date)) {
    return constructFrom(date, NaN);
  }
  if (values3.year != null) {
    _date.setFullYear(values3.year);
  }
  if (values3.month != null) {
    _date = setMonth(_date, values3.month);
  }
  if (values3.date != null) {
    _date.setDate(values3.date);
  }
  if (values3.hours != null) {
    _date.setHours(values3.hours);
  }
  if (values3.minutes != null) {
    _date.setMinutes(values3.minutes);
  }
  if (values3.seconds != null) {
    _date.setSeconds(values3.seconds);
  }
  if (values3.milliseconds != null) {
    _date.setMilliseconds(values3.milliseconds);
  }
  return _date;
}
function setHours(date, hours) {
  const _date = toDate(date);
  _date.setHours(hours);
  return _date;
}
function setMinutes(date, minutes) {
  const _date = toDate(date);
  _date.setMinutes(minutes);
  return _date;
}
function setQuarter(date, quarter) {
  const _date = toDate(date);
  const oldQuarter = Math.trunc(_date.getMonth() / 3) + 1;
  const diff = quarter - oldQuarter;
  return setMonth(_date, _date.getMonth() + diff * 3);
}
function setSeconds(date, seconds) {
  const _date = toDate(date);
  _date.setSeconds(seconds);
  return _date;
}
function setYear(date, year) {
  const _date = toDate(date);
  if (isNaN(+_date)) {
    return constructFrom(date, NaN);
  }
  _date.setFullYear(year);
  return _date;
}
function subMonths(date, amount) {
  return addMonths(date, -amount);
}
function subQuarters(date, amount) {
  return addQuarters(date, -1);
}
function subWeeks(date, amount) {
  return addWeeks(date, -1);
}
function subYears(date, amount) {
  return addYears(date, -amount);
}
function hasWindow$1() {
  return typeof window !== "undefined";
}
function getWindow$1(node2) {
  var _node$ownerDocument;
  return (node2 == null || (_node$ownerDocument = node2.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function isElement$1(value) {
  if (!hasWindow$1()) {
    return false;
  }
  return value instanceof Element || value instanceof getWindow$1(value).Element;
}
function getComputedStyle$2(element) {
  return getWindow$1(element).getComputedStyle(element);
}
const min = Math.min;
const max = Math.max;
const round = Math.round;
const floor = Math.floor;
const createCoords = (v2) => ({
  x: v2,
  y: v2
});
function hasWindow() {
  return typeof window !== "undefined";
}
function getNodeName(node2) {
  if (isNode(node2)) {
    return (node2.nodeName || "").toLowerCase();
  }
  return "#document";
}
function getWindow(node2) {
  var _node$ownerDocument;
  return (node2 == null || (_node$ownerDocument = node2.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function getDocumentElement(node2) {
  var _ref3;
  return (_ref3 = (isNode(node2) ? node2.ownerDocument : node2.document) || window.document) == null ? void 0 : _ref3.documentElement;
}
function isNode(value) {
  if (!hasWindow()) {
    return false;
  }
  return value instanceof Node || value instanceof getWindow(value).Node;
}
function isElement(value) {
  if (!hasWindow()) {
    return false;
  }
  return value instanceof Element || value instanceof getWindow(value).Element;
}
function isHTMLElement(value) {
  if (!hasWindow()) {
    return false;
  }
  return value instanceof HTMLElement || value instanceof getWindow(value).HTMLElement;
}
function isShadowRoot(value) {
  if (!hasWindow() || typeof ShadowRoot === "undefined") {
    return false;
  }
  return value instanceof ShadowRoot || value instanceof getWindow(value).ShadowRoot;
}
function isOverflowElement(element) {
  const {
    overflow,
    overflowX,
    overflowY,
    display
  } = getComputedStyle$1(element);
  return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && !["inline", "contents"].includes(display);
}
function isTableElement(element) {
  return ["table", "td", "th"].includes(getNodeName(element));
}
function isTopLayer(element) {
  return [":popover-open", ":modal"].some((selector) => {
    try {
      return element.matches(selector);
    } catch (e3) {
      return false;
    }
  });
}
function isContainingBlock(elementOrCss) {
  const webkit = isWebKit();
  const css4 = isElement(elementOrCss) ? getComputedStyle$1(elementOrCss) : elementOrCss;
  return ["transform", "translate", "scale", "rotate", "perspective"].some((value) => css4[value] ? css4[value] !== "none" : false) || (css4.containerType ? css4.containerType !== "normal" : false) || !webkit && (css4.backdropFilter ? css4.backdropFilter !== "none" : false) || !webkit && (css4.filter ? css4.filter !== "none" : false) || ["transform", "translate", "scale", "rotate", "perspective", "filter"].some((value) => (css4.willChange || "").includes(value)) || ["paint", "layout", "strict", "content"].some((value) => (css4.contain || "").includes(value));
}
function getContainingBlock(element) {
  let currentNode = getParentNode(element);
  while (isHTMLElement(currentNode) && !isLastTraversableNode(currentNode)) {
    if (isContainingBlock(currentNode)) {
      return currentNode;
    } else if (isTopLayer(currentNode)) {
      return null;
    }
    currentNode = getParentNode(currentNode);
  }
  return null;
}
function isWebKit() {
  if (typeof CSS === "undefined" || !CSS.supports) return false;
  return CSS.supports("-webkit-backdrop-filter", "none");
}
function isLastTraversableNode(node2) {
  return ["html", "body", "#document"].includes(getNodeName(node2));
}
function getComputedStyle$1(element) {
  return getWindow(element).getComputedStyle(element);
}
function getNodeScroll(element) {
  if (isElement(element)) {
    return {
      scrollLeft: element.scrollLeft,
      scrollTop: element.scrollTop
    };
  }
  return {
    scrollLeft: element.scrollX,
    scrollTop: element.scrollY
  };
}
function getParentNode(node2) {
  if (getNodeName(node2) === "html") {
    return node2;
  }
  const result = (
    // Step into the shadow DOM of the parent of a slotted node.
    node2.assignedSlot || // DOM Element detected.
    node2.parentNode || // ShadowRoot detected.
    isShadowRoot(node2) && node2.host || // Fallback.
    getDocumentElement(node2)
  );
  return isShadowRoot(result) ? result.host : result;
}
function getNearestOverflowAncestor(node2) {
  const parentNode = getParentNode(node2);
  if (isLastTraversableNode(parentNode)) {
    return node2.ownerDocument ? node2.ownerDocument.body : node2.body;
  }
  if (isHTMLElement(parentNode) && isOverflowElement(parentNode)) {
    return parentNode;
  }
  return getNearestOverflowAncestor(parentNode);
}
function getOverflowAncestors(node2, list, traverseIframes) {
  var _node$ownerDocument2;
  if (list === void 0) {
    list = [];
  }
  if (traverseIframes === void 0) {
    traverseIframes = true;
  }
  const scrollableAncestor = getNearestOverflowAncestor(node2);
  const isBody = scrollableAncestor === ((_node$ownerDocument2 = node2.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
  const win = getWindow(scrollableAncestor);
  if (isBody) {
    const frameElement = getFrameElement(win);
    return list.concat(win, win.visualViewport || [], isOverflowElement(scrollableAncestor) ? scrollableAncestor : [], frameElement && traverseIframes ? getOverflowAncestors(frameElement) : []);
  }
  return list.concat(scrollableAncestor, getOverflowAncestors(scrollableAncestor, [], traverseIframes));
}
function getFrameElement(win) {
  return win.parent && Object.getPrototypeOf(win.parent) ? win.frameElement : null;
}
function getCssDimensions(element) {
  const css4 = getComputedStyle$1(element);
  let width2 = parseFloat(css4.width) || 0;
  let height2 = parseFloat(css4.height) || 0;
  const hasOffset = isHTMLElement(element);
  const offsetWidth = hasOffset ? element.offsetWidth : width2;
  const offsetHeight = hasOffset ? element.offsetHeight : height2;
  const shouldFallback = round(width2) !== offsetWidth || round(height2) !== offsetHeight;
  if (shouldFallback) {
    width2 = offsetWidth;
    height2 = offsetHeight;
  }
  return {
    width: width2,
    height: height2,
    $: shouldFallback
  };
}
function unwrapElement(element) {
  return !isElement(element) ? element.contextElement : element;
}
function getScale(element) {
  const domElement = unwrapElement(element);
  if (!isHTMLElement(domElement)) {
    return createCoords(1);
  }
  const rect = domElement.getBoundingClientRect();
  const {
    width: width2,
    height: height2,
    $: $2
  } = getCssDimensions(domElement);
  let x2 = ($2 ? round(rect.width) : rect.width) / width2;
  let y2 = ($2 ? round(rect.height) : rect.height) / height2;
  if (!x2 || !Number.isFinite(x2)) {
    x2 = 1;
  }
  if (!y2 || !Number.isFinite(y2)) {
    y2 = 1;
  }
  return {
    x: x2,
    y: y2
  };
}
const noOffsets = /* @__PURE__ */ createCoords(0);
function getVisualOffsets(element) {
  const win = getWindow(element);
  if (!isWebKit() || !win.visualViewport) {
    return noOffsets;
  }
  return {
    x: win.visualViewport.offsetLeft,
    y: win.visualViewport.offsetTop
  };
}
function shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
  if (isFixed === void 0) {
    isFixed = false;
  }
  if (!floatingOffsetParent || isFixed && floatingOffsetParent !== getWindow(element)) {
    return false;
  }
  return isFixed;
}
function getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
  if (includeScale === void 0) {
    includeScale = false;
  }
  if (isFixedStrategy === void 0) {
    isFixedStrategy = false;
  }
  const clientRect = element.getBoundingClientRect();
  const domElement = unwrapElement(element);
  let scale = createCoords(1);
  if (includeScale) {
    if (offsetParent) {
      if (isElement(offsetParent)) {
        scale = getScale(offsetParent);
      }
    } else {
      scale = getScale(element);
    }
  }
  const visualOffsets = shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? getVisualOffsets(domElement) : createCoords(0);
  let x2 = (clientRect.left + visualOffsets.x) / scale.x;
  let y2 = (clientRect.top + visualOffsets.y) / scale.y;
  let width2 = clientRect.width / scale.x;
  let height2 = clientRect.height / scale.y;
  if (domElement) {
    const win = getWindow(domElement);
    const offsetWin = offsetParent && isElement(offsetParent) ? getWindow(offsetParent) : offsetParent;
    let currentWin = win;
    let currentIFrame = getFrameElement(currentWin);
    while (currentIFrame && offsetParent && offsetWin !== currentWin) {
      const iframeScale = getScale(currentIFrame);
      const iframeRect = currentIFrame.getBoundingClientRect();
      const css4 = getComputedStyle$1(currentIFrame);
      const left2 = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css4.paddingLeft)) * iframeScale.x;
      const top2 = iframeRect.top + (currentIFrame.clientTop + parseFloat(css4.paddingTop)) * iframeScale.y;
      x2 *= iframeScale.x;
      y2 *= iframeScale.y;
      width2 *= iframeScale.x;
      height2 *= iframeScale.y;
      x2 += left2;
      y2 += top2;
      currentWin = getWindow(currentIFrame);
      currentIFrame = getFrameElement(currentWin);
    }
  }
  return rectToClientRect$1({
    width: width2,
    height: height2,
    x: x2,
    y: y2
  });
}
function getWindowScrollBarX(element, rect) {
  const leftScroll = getNodeScroll(element).scrollLeft;
  if (!rect) {
    return getBoundingClientRect(getDocumentElement(element)).left + leftScroll;
  }
  return rect.left + leftScroll;
}
function getHTMLOffset(documentElement, scroll, ignoreScrollbarX) {
  if (ignoreScrollbarX === void 0) {
    ignoreScrollbarX = false;
  }
  const htmlRect = documentElement.getBoundingClientRect();
  const x2 = htmlRect.left + scroll.scrollLeft - (ignoreScrollbarX ? 0 : (
    // RTL <body> scrollbar.
    getWindowScrollBarX(documentElement, htmlRect)
  ));
  const y2 = htmlRect.top + scroll.scrollTop;
  return {
    x: x2,
    y: y2
  };
}
function convertOffsetParentRelativeRectToViewportRelativeRect(_ref3) {
  let {
    elements,
    rect,
    offsetParent,
    strategy
  } = _ref3;
  const isFixed = strategy === "fixed";
  const documentElement = getDocumentElement(offsetParent);
  const topLayer = elements ? isTopLayer(elements.floating) : false;
  if (offsetParent === documentElement || topLayer && isFixed) {
    return rect;
  }
  let scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  let scale = createCoords(1);
  const offsets = createCoords(0);
  const isOffsetParentAnElement = isHTMLElement(offsetParent);
  if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
    if (getNodeName(offsetParent) !== "body" || isOverflowElement(documentElement)) {
      scroll = getNodeScroll(offsetParent);
    }
    if (isHTMLElement(offsetParent)) {
      const offsetRect = getBoundingClientRect(offsetParent);
      scale = getScale(offsetParent);
      offsets.x = offsetRect.x + offsetParent.clientLeft;
      offsets.y = offsetRect.y + offsetParent.clientTop;
    }
  }
  const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? getHTMLOffset(documentElement, scroll, true) : createCoords(0);
  return {
    width: rect.width * scale.x,
    height: rect.height * scale.y,
    x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x + htmlOffset.x,
    y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y + htmlOffset.y
  };
}
function getClientRects(element) {
  return Array.from(element.getClientRects());
}
function getDocumentRect(element) {
  const html = getDocumentElement(element);
  const scroll = getNodeScroll(element);
  const body = element.ownerDocument.body;
  const width2 = max(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
  const height2 = max(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
  let x2 = -scroll.scrollLeft + getWindowScrollBarX(element);
  const y2 = -scroll.scrollTop;
  if (getComputedStyle$1(body).direction === "rtl") {
    x2 += max(html.clientWidth, body.clientWidth) - width2;
  }
  return {
    width: width2,
    height: height2,
    x: x2,
    y: y2
  };
}
function getViewportRect(element, strategy) {
  const win = getWindow(element);
  const html = getDocumentElement(element);
  const visualViewport = win.visualViewport;
  let width2 = html.clientWidth;
  let height2 = html.clientHeight;
  let x2 = 0;
  let y2 = 0;
  if (visualViewport) {
    width2 = visualViewport.width;
    height2 = visualViewport.height;
    const visualViewportBased = isWebKit();
    if (!visualViewportBased || visualViewportBased && strategy === "fixed") {
      x2 = visualViewport.offsetLeft;
      y2 = visualViewport.offsetTop;
    }
  }
  return {
    width: width2,
    height: height2,
    x: x2,
    y: y2
  };
}
function getInnerBoundingClientRect(element, strategy) {
  const clientRect = getBoundingClientRect(element, true, strategy === "fixed");
  const top2 = clientRect.top + element.clientTop;
  const left2 = clientRect.left + element.clientLeft;
  const scale = isHTMLElement(element) ? getScale(element) : createCoords(1);
  const width2 = element.clientWidth * scale.x;
  const height2 = element.clientHeight * scale.y;
  const x2 = left2 * scale.x;
  const y2 = top2 * scale.y;
  return {
    width: width2,
    height: height2,
    x: x2,
    y: y2
  };
}
function getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
  let rect;
  if (clippingAncestor === "viewport") {
    rect = getViewportRect(element, strategy);
  } else if (clippingAncestor === "document") {
    rect = getDocumentRect(getDocumentElement(element));
  } else if (isElement(clippingAncestor)) {
    rect = getInnerBoundingClientRect(clippingAncestor, strategy);
  } else {
    const visualOffsets = getVisualOffsets(element);
    rect = {
      x: clippingAncestor.x - visualOffsets.x,
      y: clippingAncestor.y - visualOffsets.y,
      width: clippingAncestor.width,
      height: clippingAncestor.height
    };
  }
  return rectToClientRect$1(rect);
}
function hasFixedPositionAncestor(element, stopNode) {
  const parentNode = getParentNode(element);
  if (parentNode === stopNode || !isElement(parentNode) || isLastTraversableNode(parentNode)) {
    return false;
  }
  return getComputedStyle$1(parentNode).position === "fixed" || hasFixedPositionAncestor(parentNode, stopNode);
}
function getClippingElementAncestors(element, cache) {
  const cachedResult = cache.get(element);
  if (cachedResult) {
    return cachedResult;
  }
  let result = getOverflowAncestors(element, [], false).filter((el) => isElement(el) && getNodeName(el) !== "body");
  let currentContainingBlockComputedStyle = null;
  const elementIsFixed = getComputedStyle$1(element).position === "fixed";
  let currentNode = elementIsFixed ? getParentNode(element) : element;
  while (isElement(currentNode) && !isLastTraversableNode(currentNode)) {
    const computedStyle = getComputedStyle$1(currentNode);
    const currentNodeIsContaining = isContainingBlock(currentNode);
    if (!currentNodeIsContaining && computedStyle.position === "fixed") {
      currentContainingBlockComputedStyle = null;
    }
    const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === "static" && !!currentContainingBlockComputedStyle && ["absolute", "fixed"].includes(currentContainingBlockComputedStyle.position) || isOverflowElement(currentNode) && !currentNodeIsContaining && hasFixedPositionAncestor(element, currentNode);
    if (shouldDropCurrentNode) {
      result = result.filter((ancestor) => ancestor !== currentNode);
    } else {
      currentContainingBlockComputedStyle = computedStyle;
    }
    currentNode = getParentNode(currentNode);
  }
  cache.set(element, result);
  return result;
}
function getClippingRect(_ref3) {
  let {
    element,
    boundary,
    rootBoundary,
    strategy
  } = _ref3;
  const elementClippingAncestors = boundary === "clippingAncestors" ? isTopLayer(element) ? [] : getClippingElementAncestors(element, this._c) : [].concat(boundary);
  const clippingAncestors = [...elementClippingAncestors, rootBoundary];
  const firstClippingAncestor = clippingAncestors[0];
  const clippingRect = clippingAncestors.reduce((accRect, clippingAncestor) => {
    const rect = getClientRectFromClippingAncestor(element, clippingAncestor, strategy);
    accRect.top = max(rect.top, accRect.top);
    accRect.right = min(rect.right, accRect.right);
    accRect.bottom = min(rect.bottom, accRect.bottom);
    accRect.left = max(rect.left, accRect.left);
    return accRect;
  }, getClientRectFromClippingAncestor(element, firstClippingAncestor, strategy));
  return {
    width: clippingRect.right - clippingRect.left,
    height: clippingRect.bottom - clippingRect.top,
    x: clippingRect.left,
    y: clippingRect.top
  };
}
function getDimensions(element) {
  const {
    width: width2,
    height: height2
  } = getCssDimensions(element);
  return {
    width: width2,
    height: height2
  };
}
function getRectRelativeToOffsetParent(element, offsetParent, strategy) {
  const isOffsetParentAnElement = isHTMLElement(offsetParent);
  const documentElement = getDocumentElement(offsetParent);
  const isFixed = strategy === "fixed";
  const rect = getBoundingClientRect(element, true, isFixed, offsetParent);
  let scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const offsets = createCoords(0);
  if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
    if (getNodeName(offsetParent) !== "body" || isOverflowElement(documentElement)) {
      scroll = getNodeScroll(offsetParent);
    }
    if (isOffsetParentAnElement) {
      const offsetRect = getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
      offsets.x = offsetRect.x + offsetParent.clientLeft;
      offsets.y = offsetRect.y + offsetParent.clientTop;
    } else if (documentElement) {
      offsets.x = getWindowScrollBarX(documentElement);
    }
  }
  const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? getHTMLOffset(documentElement, scroll) : createCoords(0);
  const x2 = rect.left + scroll.scrollLeft - offsets.x - htmlOffset.x;
  const y2 = rect.top + scroll.scrollTop - offsets.y - htmlOffset.y;
  return {
    x: x2,
    y: y2,
    width: rect.width,
    height: rect.height
  };
}
function isStaticPositioned(element) {
  return getComputedStyle$1(element).position === "static";
}
function getTrueOffsetParent(element, polyfill2) {
  if (!isHTMLElement(element) || getComputedStyle$1(element).position === "fixed") {
    return null;
  }
  if (polyfill2) {
    return polyfill2(element);
  }
  let rawOffsetParent = element.offsetParent;
  if (getDocumentElement(element) === rawOffsetParent) {
    rawOffsetParent = rawOffsetParent.ownerDocument.body;
  }
  return rawOffsetParent;
}
function getOffsetParent(element, polyfill2) {
  const win = getWindow(element);
  if (isTopLayer(element)) {
    return win;
  }
  if (!isHTMLElement(element)) {
    let svgOffsetParent = getParentNode(element);
    while (svgOffsetParent && !isLastTraversableNode(svgOffsetParent)) {
      if (isElement(svgOffsetParent) && !isStaticPositioned(svgOffsetParent)) {
        return svgOffsetParent;
      }
      svgOffsetParent = getParentNode(svgOffsetParent);
    }
    return win;
  }
  let offsetParent = getTrueOffsetParent(element, polyfill2);
  while (offsetParent && isTableElement(offsetParent) && isStaticPositioned(offsetParent)) {
    offsetParent = getTrueOffsetParent(offsetParent, polyfill2);
  }
  if (offsetParent && isLastTraversableNode(offsetParent) && isStaticPositioned(offsetParent) && !isContainingBlock(offsetParent)) {
    return win;
  }
  return offsetParent || getContainingBlock(element) || win;
}
const getElementRects = async function(data) {
  const getOffsetParentFn = this.getOffsetParent || getOffsetParent;
  const getDimensionsFn = this.getDimensions;
  const floatingDimensions = await getDimensionsFn(data.floating);
  return {
    reference: getRectRelativeToOffsetParent(data.reference, await getOffsetParentFn(data.floating), data.strategy),
    floating: {
      x: 0,
      y: 0,
      width: floatingDimensions.width,
      height: floatingDimensions.height
    }
  };
};
function isRTL(element) {
  return getComputedStyle$1(element).direction === "rtl";
}
const platform = {
  convertOffsetParentRelativeRectToViewportRelativeRect,
  getDocumentElement,
  getClippingRect,
  getOffsetParent,
  getElementRects,
  getClientRects,
  getDimensions,
  getScale,
  isElement,
  isRTL
};
function rectsAreEqual(a2, b2) {
  return a2.x === b2.x && a2.y === b2.y && a2.width === b2.width && a2.height === b2.height;
}
function observeMove(element, onMove) {
  let io = null;
  let timeoutId;
  const root2 = getDocumentElement(element);
  function cleanup() {
    var _io;
    clearTimeout(timeoutId);
    (_io = io) == null || _io.disconnect();
    io = null;
  }
  function refresh(skip, threshold) {
    if (skip === void 0) {
      skip = false;
    }
    if (threshold === void 0) {
      threshold = 1;
    }
    cleanup();
    const elementRectForRootMargin = element.getBoundingClientRect();
    const {
      left: left2,
      top: top2,
      width: width2,
      height: height2
    } = elementRectForRootMargin;
    if (!skip) {
      onMove();
    }
    if (!width2 || !height2) {
      return;
    }
    const insetTop = floor(top2);
    const insetRight = floor(root2.clientWidth - (left2 + width2));
    const insetBottom = floor(root2.clientHeight - (top2 + height2));
    const insetLeft = floor(left2);
    const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
    const options2 = {
      rootMargin,
      threshold: max(0, min(1, threshold)) || 1
    };
    let isFirstUpdate = true;
    function handleObserve(entries) {
      const ratio = entries[0].intersectionRatio;
      if (ratio !== threshold) {
        if (!isFirstUpdate) {
          return refresh();
        }
        if (!ratio) {
          timeoutId = setTimeout(() => {
            refresh(false, 1e-7);
          }, 1e3);
        } else {
          refresh(false, ratio);
        }
      }
      if (ratio === 1 && !rectsAreEqual(elementRectForRootMargin, element.getBoundingClientRect())) {
        refresh();
      }
      isFirstUpdate = false;
    }
    try {
      io = new IntersectionObserver(handleObserve, {
        ...options2,
        // Handle <iframe>s
        root: root2.ownerDocument
      });
    } catch (e3) {
      io = new IntersectionObserver(handleObserve, options2);
    }
    io.observe(element);
  }
  refresh(true);
  return cleanup;
}
function autoUpdate(reference2, floating, update, options2) {
  if (options2 === void 0) {
    options2 = {};
  }
  const {
    ancestorScroll = true,
    ancestorResize = true,
    elementResize = typeof ResizeObserver === "function",
    layoutShift = typeof IntersectionObserver === "function",
    animationFrame = false
  } = options2;
  const referenceEl = unwrapElement(reference2);
  const ancestors = ancestorScroll || ancestorResize ? [...referenceEl ? getOverflowAncestors(referenceEl) : [], ...getOverflowAncestors(floating)] : [];
  ancestors.forEach((ancestor) => {
    ancestorScroll && ancestor.addEventListener("scroll", update, {
      passive: true
    });
    ancestorResize && ancestor.addEventListener("resize", update);
  });
  const cleanupIo = referenceEl && layoutShift ? observeMove(referenceEl, update) : null;
  let reobserveFrame = -1;
  let resizeObserver = null;
  if (elementResize) {
    resizeObserver = new ResizeObserver((_ref3) => {
      let [firstEntry] = _ref3;
      if (firstEntry && firstEntry.target === referenceEl && resizeObserver) {
        resizeObserver.unobserve(floating);
        cancelAnimationFrame(reobserveFrame);
        reobserveFrame = requestAnimationFrame(() => {
          var _resizeObserver;
          (_resizeObserver = resizeObserver) == null || _resizeObserver.observe(floating);
        });
      }
      update();
    });
    if (referenceEl && !animationFrame) {
      resizeObserver.observe(referenceEl);
    }
    resizeObserver.observe(floating);
  }
  let frameId;
  let prevRefRect = animationFrame ? getBoundingClientRect(reference2) : null;
  if (animationFrame) {
    frameLoop();
  }
  function frameLoop() {
    const nextRefRect = getBoundingClientRect(reference2);
    if (prevRefRect && !rectsAreEqual(prevRefRect, nextRefRect)) {
      update();
    }
    prevRefRect = nextRefRect;
    frameId = requestAnimationFrame(frameLoop);
  }
  update();
  return () => {
    var _resizeObserver2;
    ancestors.forEach((ancestor) => {
      ancestorScroll && ancestor.removeEventListener("scroll", update);
      ancestorResize && ancestor.removeEventListener("resize", update);
    });
    cleanupIo == null || cleanupIo();
    (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.disconnect();
    resizeObserver = null;
    if (animationFrame) {
      cancelAnimationFrame(frameId);
    }
  };
}
const offset$1 = offset$2;
const flip$1 = flip$2;
const arrow$2 = arrow$3;
const computePosition = (reference2, floating, options2) => {
  const cache = /* @__PURE__ */ new Map();
  const mergedOptions = {
    platform,
    ...options2
  };
  const platformWithCache = {
    ...mergedOptions.platform,
    _c: cache
  };
  return computePosition$1(reference2, floating, {
    ...mergedOptions,
    platform: platformWithCache
  });
};
var index$1 = typeof document !== "undefined" ? useLayoutEffect : useEffect;
function deepEqual(a2, b2) {
  if (a2 === b2) {
    return true;
  }
  if (typeof a2 !== typeof b2) {
    return false;
  }
  if (typeof a2 === "function" && a2.toString() === b2.toString()) {
    return true;
  }
  let length2;
  let i;
  let keys3;
  if (a2 && b2 && typeof a2 === "object") {
    if (Array.isArray(a2)) {
      length2 = a2.length;
      if (length2 !== b2.length) return false;
      for (i = length2; i-- !== 0; ) {
        if (!deepEqual(a2[i], b2[i])) {
          return false;
        }
      }
      return true;
    }
    keys3 = Object.keys(a2);
    length2 = keys3.length;
    if (length2 !== Object.keys(b2).length) {
      return false;
    }
    for (i = length2; i-- !== 0; ) {
      if (!{}.hasOwnProperty.call(b2, keys3[i])) {
        return false;
      }
    }
    for (i = length2; i-- !== 0; ) {
      const key = keys3[i];
      if (key === "_owner" && a2.$$typeof) {
        continue;
      }
      if (!deepEqual(a2[key], b2[key])) {
        return false;
      }
    }
    return true;
  }
  return a2 !== a2 && b2 !== b2;
}
function getDPR(element) {
  if (typeof window === "undefined") {
    return 1;
  }
  const win = element.ownerDocument.defaultView || window;
  return win.devicePixelRatio || 1;
}
function roundByDPR(element, value) {
  const dpr = getDPR(element);
  return Math.round(value * dpr) / dpr;
}
function useLatestRef(value) {
  const ref2 = React.useRef(value);
  index$1(() => {
    ref2.current = value;
  });
  return ref2;
}
function useFloating$1(options2) {
  if (options2 === void 0) {
    options2 = {};
  }
  const {
    placement = "bottom",
    strategy = "absolute",
    middleware: middleware2 = [],
    platform: platform2,
    elements: {
      reference: externalReference,
      floating: externalFloating
    } = {},
    transform = true,
    whileElementsMounted,
    open
  } = options2;
  const [data, setData] = React.useState({
    x: 0,
    y: 0,
    strategy,
    placement,
    middlewareData: {},
    isPositioned: false
  });
  const [latestMiddleware, setLatestMiddleware] = React.useState(middleware2);
  if (!deepEqual(latestMiddleware, middleware2)) {
    setLatestMiddleware(middleware2);
  }
  const [_reference, _setReference] = React.useState(null);
  const [_floating, _setFloating] = React.useState(null);
  const setReference = React.useCallback((node2) => {
    if (node2 !== referenceRef.current) {
      referenceRef.current = node2;
      _setReference(node2);
    }
  }, []);
  const setFloating = React.useCallback((node2) => {
    if (node2 !== floatingRef.current) {
      floatingRef.current = node2;
      _setFloating(node2);
    }
  }, []);
  const referenceEl = externalReference || _reference;
  const floatingEl = externalFloating || _floating;
  const referenceRef = React.useRef(null);
  const floatingRef = React.useRef(null);
  const dataRef = React.useRef(data);
  const hasWhileElementsMounted = whileElementsMounted != null;
  const whileElementsMountedRef = useLatestRef(whileElementsMounted);
  const platformRef = useLatestRef(platform2);
  const openRef = useLatestRef(open);
  const update = React.useCallback(() => {
    if (!referenceRef.current || !floatingRef.current) {
      return;
    }
    const config2 = {
      placement,
      strategy,
      middleware: latestMiddleware
    };
    if (platformRef.current) {
      config2.platform = platformRef.current;
    }
    computePosition(referenceRef.current, floatingRef.current, config2).then((data2) => {
      const fullData = {
        ...data2,
        // The floating element's position may be recomputed while it's closed
        // but still mounted (such as when transitioning out). To ensure
        // `isPositioned` will be `false` initially on the next open, avoid
        // setting it to `true` when `open === false` (must be specified).
        isPositioned: openRef.current !== false
      };
      if (isMountedRef.current && !deepEqual(dataRef.current, fullData)) {
        dataRef.current = fullData;
        ReactDOM.flushSync(() => {
          setData(fullData);
        });
      }
    });
  }, [latestMiddleware, placement, strategy, platformRef, openRef]);
  index$1(() => {
    if (open === false && dataRef.current.isPositioned) {
      dataRef.current.isPositioned = false;
      setData((data2) => ({
        ...data2,
        isPositioned: false
      }));
    }
  }, [open]);
  const isMountedRef = React.useRef(false);
  index$1(() => {
    isMountedRef.current = true;
    return () => {
      isMountedRef.current = false;
    };
  }, []);
  index$1(() => {
    if (referenceEl) referenceRef.current = referenceEl;
    if (floatingEl) floatingRef.current = floatingEl;
    if (referenceEl && floatingEl) {
      if (whileElementsMountedRef.current) {
        return whileElementsMountedRef.current(referenceEl, floatingEl, update);
      }
      update();
    }
  }, [referenceEl, floatingEl, update, whileElementsMountedRef, hasWhileElementsMounted]);
  const refs = React.useMemo(() => ({
    reference: referenceRef,
    floating: floatingRef,
    setReference,
    setFloating
  }), [setReference, setFloating]);
  const elements = React.useMemo(() => ({
    reference: referenceEl,
    floating: floatingEl
  }), [referenceEl, floatingEl]);
  const floatingStyles = React.useMemo(() => {
    const initialStyles = {
      position: strategy,
      left: 0,
      top: 0
    };
    if (!elements.floating) {
      return initialStyles;
    }
    const x2 = roundByDPR(elements.floating, data.x);
    const y2 = roundByDPR(elements.floating, data.y);
    if (transform) {
      return {
        ...initialStyles,
        transform: "translate(" + x2 + "px, " + y2 + "px)",
        ...getDPR(elements.floating) >= 1.5 && {
          willChange: "transform"
        }
      };
    }
    return {
      position: strategy,
      left: x2,
      top: y2
    };
  }, [strategy, transform, elements.floating, data.x, data.y]);
  return React.useMemo(() => ({
    ...data,
    update,
    refs,
    elements,
    floatingStyles
  }), [data, update, refs, elements, floatingStyles]);
}
const arrow$1 = (options2) => {
  function isRef(value) {
    return {}.hasOwnProperty.call(value, "current");
  }
  return {
    name: "arrow",
    options: options2,
    fn(state) {
      const {
        element,
        padding: padding2
      } = typeof options2 === "function" ? options2(state) : options2;
      if (element && isRef(element)) {
        if (element.current != null) {
          return arrow$2({
            element: element.current,
            padding: padding2
          }).fn(state);
        }
        return {};
      }
      if (element) {
        return arrow$2({
          element,
          padding: padding2
        }).fn(state);
      }
      return {};
    }
  };
};
const offset = (options2, deps) => ({
  ...offset$1(options2),
  options: [options2, deps]
});
const flip = (options2, deps) => ({
  ...flip$1(options2),
  options: [options2, deps]
});
const arrow = (options2, deps) => ({
  ...arrow$1(options2),
  options: [options2, deps]
});
const SafeReact = {
  ...React
};
const useInsertionEffect = SafeReact.useInsertionEffect;
const useSafeInsertionEffect = useInsertionEffect || ((fn2) => fn2());
function useEffectEvent(callback) {
  const ref2 = React.useRef(() => {
    if (process.env.NODE_ENV !== "production") {
      throw new Error("Cannot call an event handler while rendering.");
    }
  });
  useSafeInsertionEffect(() => {
    ref2.current = callback;
  });
  return React.useCallback(function() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return ref2.current == null ? void 0 : ref2.current(...args);
  }, []);
}
var index = typeof document !== "undefined" ? useLayoutEffect : useEffect;
let serverHandoffComplete = false;
let count = 0;
const genId = () => (
  // Ensure the id is unique with multiple independent versions of Floating UI
  // on <React 18
  "floating-ui-" + Math.random().toString(36).slice(2, 6) + count++
);
function useFloatingId() {
  const [id2, setId] = React.useState(() => serverHandoffComplete ? genId() : void 0);
  index(() => {
    if (id2 == null) {
      setId(genId());
    }
  }, []);
  React.useEffect(() => {
    serverHandoffComplete = true;
  }, []);
  return id2;
}
const useReactId = SafeReact.useId;
const useId = useReactId || useFloatingId;
let devMessageSet;
if (process.env.NODE_ENV !== "production") {
  devMessageSet = /* @__PURE__ */ new Set();
}
function warn$1() {
  var _devMessageSet;
  for (var _len = arguments.length, messages = new Array(_len), _key = 0; _key < _len; _key++) {
    messages[_key] = arguments[_key];
  }
  const message2 = "Floating UI: " + messages.join(" ");
  if (!((_devMessageSet = devMessageSet) != null && _devMessageSet.has(message2))) {
    var _devMessageSet2;
    (_devMessageSet2 = devMessageSet) == null || _devMessageSet2.add(message2);
    console.warn(message2);
  }
}
function error() {
  var _devMessageSet3;
  for (var _len2 = arguments.length, messages = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    messages[_key2] = arguments[_key2];
  }
  const message2 = "Floating UI: " + messages.join(" ");
  if (!((_devMessageSet3 = devMessageSet) != null && _devMessageSet3.has(message2))) {
    var _devMessageSet4;
    (_devMessageSet4 = devMessageSet) == null || _devMessageSet4.add(message2);
    console.error(message2);
  }
}
const FloatingArrow = /* @__PURE__ */ React.forwardRef(function FloatingArrow2(props, ref2) {
  const {
    context: {
      placement,
      elements: {
        floating
      },
      middlewareData: {
        arrow: arrow2,
        shift
      }
    },
    width: width2 = 14,
    height: height2 = 7,
    tipRadius = 0,
    strokeWidth = 0,
    staticOffset,
    stroke,
    d: d2,
    style: {
      transform,
      ...restStyle
    } = {},
    ...rest
  } = props;
  if (process.env.NODE_ENV !== "production") {
    if (!ref2) {
      warn$1("The `ref` prop is required for `FloatingArrow`.");
    }
  }
  const clipPathId = useId();
  const [isRTL2, setIsRTL] = React.useState(false);
  index(() => {
    if (!floating) return;
    const isRTL3 = getComputedStyle$2(floating).direction === "rtl";
    if (isRTL3) {
      setIsRTL(true);
    }
  }, [floating]);
  if (!floating) {
    return null;
  }
  const [side, alignment] = placement.split("-");
  const isVerticalSide = side === "top" || side === "bottom";
  let computedStaticOffset = staticOffset;
  if (isVerticalSide && shift != null && shift.x || !isVerticalSide && shift != null && shift.y) {
    computedStaticOffset = null;
  }
  const computedStrokeWidth = strokeWidth * 2;
  const halfStrokeWidth = computedStrokeWidth / 2;
  const svgX = width2 / 2 * (tipRadius / -8 + 1);
  const svgY = height2 / 2 * tipRadius / 4;
  const isCustomShape = !!d2;
  const yOffsetProp = computedStaticOffset && alignment === "end" ? "bottom" : "top";
  let xOffsetProp = computedStaticOffset && alignment === "end" ? "right" : "left";
  if (computedStaticOffset && isRTL2) {
    xOffsetProp = alignment === "end" ? "left" : "right";
  }
  const arrowX = (arrow2 == null ? void 0 : arrow2.x) != null ? computedStaticOffset || arrow2.x : "";
  const arrowY = (arrow2 == null ? void 0 : arrow2.y) != null ? computedStaticOffset || arrow2.y : "";
  const dValue = d2 || "M0,0" + (" H" + width2) + (" L" + (width2 - svgX) + "," + (height2 - svgY)) + (" Q" + width2 / 2 + "," + height2 + " " + svgX + "," + (height2 - svgY)) + " Z";
  const rotation = {
    top: isCustomShape ? "rotate(180deg)" : "",
    left: isCustomShape ? "rotate(90deg)" : "rotate(-90deg)",
    bottom: isCustomShape ? "" : "rotate(180deg)",
    right: isCustomShape ? "rotate(-90deg)" : "rotate(90deg)"
  }[side];
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", {
    ...rest,
    "aria-hidden": true,
    ref: ref2,
    width: isCustomShape ? width2 : width2 + computedStrokeWidth,
    height: width2,
    viewBox: "0 0 " + width2 + " " + (height2 > width2 ? height2 : width2),
    style: {
      position: "absolute",
      pointerEvents: "none",
      [xOffsetProp]: arrowX,
      [yOffsetProp]: arrowY,
      [side]: isVerticalSide || isCustomShape ? "100%" : "calc(100% - " + computedStrokeWidth / 2 + "px)",
      transform: [rotation, transform].filter((t2) => !!t2).join(" "),
      ...restStyle
    },
    children: [computedStrokeWidth > 0 && /* @__PURE__ */ jsxRuntimeExports.jsx("path", {
      clipPath: "url(#" + clipPathId + ")",
      fill: "none",
      stroke,
      strokeWidth: computedStrokeWidth + (d2 ? 0 : 1),
      d: dValue
    }), /* @__PURE__ */ jsxRuntimeExports.jsx("path", {
      stroke: computedStrokeWidth && !d2 ? rest.fill : "none",
      d: dValue
    }), /* @__PURE__ */ jsxRuntimeExports.jsx("clipPath", {
      id: clipPathId,
      children: /* @__PURE__ */ jsxRuntimeExports.jsx("rect", {
        x: -halfStrokeWidth,
        y: halfStrokeWidth * (isCustomShape ? -1 : 1),
        width: width2 + computedStrokeWidth,
        height: width2
      })
    })]
  });
});
function createPubSub() {
  const map = /* @__PURE__ */ new Map();
  return {
    emit(event, data) {
      var _map$get;
      (_map$get = map.get(event)) == null || _map$get.forEach((handler) => handler(data));
    },
    on(event, listener) {
      map.set(event, [...map.get(event) || [], listener]);
    },
    off(event, listener) {
      var _map$get2;
      map.set(event, ((_map$get2 = map.get(event)) == null ? void 0 : _map$get2.filter((l2) => l2 !== listener)) || []);
    }
  };
}
const FloatingNodeContext = /* @__PURE__ */ React.createContext(null);
const FloatingTreeContext = /* @__PURE__ */ React.createContext(null);
const useFloatingParentNodeId = () => {
  var _React$useContext;
  return ((_React$useContext = React.useContext(FloatingNodeContext)) == null ? void 0 : _React$useContext.id) || null;
};
const useFloatingTree = () => React.useContext(FloatingTreeContext);
function useFloatingRootContext(options2) {
  const {
    open = false,
    onOpenChange: onOpenChangeProp,
    elements: elementsProp
  } = options2;
  const floatingId = useId();
  const dataRef = React.useRef({});
  const [events] = React.useState(() => createPubSub());
  const nested = useFloatingParentNodeId() != null;
  if (process.env.NODE_ENV !== "production") {
    const optionDomReference = elementsProp.reference;
    if (optionDomReference && !isElement$1(optionDomReference)) {
      error("Cannot pass a virtual element to the `elements.reference` option,", "as it must be a real DOM element. Use `refs.setPositionReference()`", "instead.");
    }
  }
  const [positionReference, setPositionReference] = React.useState(elementsProp.reference);
  const onOpenChange = useEffectEvent((open2, event, reason) => {
    dataRef.current.openEvent = open2 ? event : void 0;
    events.emit("openchange", {
      open: open2,
      event,
      reason,
      nested
    });
    onOpenChangeProp == null || onOpenChangeProp(open2, event, reason);
  });
  const refs = React.useMemo(() => ({
    setPositionReference
  }), []);
  const elements = React.useMemo(() => ({
    reference: positionReference || elementsProp.reference || null,
    floating: elementsProp.floating || null,
    domReference: elementsProp.reference
  }), [positionReference, elementsProp.reference, elementsProp.floating]);
  return React.useMemo(() => ({
    dataRef,
    open,
    onOpenChange,
    elements,
    events,
    floatingId,
    refs
  }), [open, onOpenChange, elements, events, floatingId, refs]);
}
function useFloating(options2) {
  if (options2 === void 0) {
    options2 = {};
  }
  const {
    nodeId
  } = options2;
  const internalRootContext = useFloatingRootContext({
    ...options2,
    elements: {
      reference: null,
      floating: null,
      ...options2.elements
    }
  });
  const rootContext = options2.rootContext || internalRootContext;
  const computedElements = rootContext.elements;
  const [_domReference, setDomReference] = React.useState(null);
  const [positionReference, _setPositionReference] = React.useState(null);
  const optionDomReference = computedElements == null ? void 0 : computedElements.domReference;
  const domReference = optionDomReference || _domReference;
  const domReferenceRef = React.useRef(null);
  const tree = useFloatingTree();
  index(() => {
    if (domReference) {
      domReferenceRef.current = domReference;
    }
  }, [domReference]);
  const position2 = useFloating$1({
    ...options2,
    elements: {
      ...computedElements,
      ...positionReference && {
        reference: positionReference
      }
    }
  });
  const setPositionReference = React.useCallback((node2) => {
    const computedPositionReference = isElement$1(node2) ? {
      getBoundingClientRect: () => node2.getBoundingClientRect(),
      contextElement: node2
    } : node2;
    _setPositionReference(computedPositionReference);
    position2.refs.setReference(computedPositionReference);
  }, [position2.refs]);
  const setReference = React.useCallback((node2) => {
    if (isElement$1(node2) || node2 === null) {
      domReferenceRef.current = node2;
      setDomReference(node2);
    }
    if (isElement$1(position2.refs.reference.current) || position2.refs.reference.current === null || // Don't allow setting virtual elements using the old technique back to
    // `null` to support `positionReference` + an unstable `reference`
    // callback ref.
    node2 !== null && !isElement$1(node2)) {
      position2.refs.setReference(node2);
    }
  }, [position2.refs]);
  const refs = React.useMemo(() => ({
    ...position2.refs,
    setReference,
    setPositionReference,
    domReference: domReferenceRef
  }), [position2.refs, setReference, setPositionReference]);
  const elements = React.useMemo(() => ({
    ...position2.elements,
    domReference
  }), [position2.elements, domReference]);
  const context = React.useMemo(() => ({
    ...position2,
    ...rootContext,
    refs,
    elements,
    nodeId
  }), [position2, refs, elements, nodeId, rootContext]);
  index(() => {
    rootContext.dataRef.current.floatingContext = context;
    const node2 = tree == null ? void 0 : tree.nodesRef.current.find((node3) => node3.id === nodeId);
    if (node2) {
      node2.context = context;
    }
  });
  return React.useMemo(() => ({
    ...position2,
    context,
    refs,
    elements
  }), [position2, refs, elements, context]);
}
/*!
  react-datepicker v7.6.0
  https://github.com/Hacker0x01/react-datepicker
  Released under the MIT License.
*/
var _extendStatics = function extendStatics(d2, b2) {
  _extendStatics = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function(d3, b3) {
    d3.__proto__ = b3;
  } || function(d3, b3) {
    for (var p2 in b3) if (Object.prototype.hasOwnProperty.call(b3, p2)) d3[p2] = b3[p2];
  };
  return _extendStatics(d2, b2);
};
function __extends(d2, b2) {
  if (typeof b2 !== "function" && b2 !== null) throw new TypeError("Class extends value " + String(b2) + " is not a constructor or null");
  _extendStatics(d2, b2);
  function __() {
    this.constructor = d2;
  }
  d2.prototype = b2 === null ? Object.create(b2) : (__.prototype = b2.prototype, new __());
}
var _assign = function __assign() {
  _assign = Object.assign || function __assign2(t2) {
    for (var s2, i = 1, n2 = arguments.length; i < n2; i++) {
      s2 = arguments[i];
      for (var p2 in s2) if (Object.prototype.hasOwnProperty.call(s2, p2)) t2[p2] = s2[p2];
    }
    return t2;
  };
  return _assign.apply(this, arguments);
};
function __spreadArray(to, from2, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l2 = from2.length, ar; i < l2; i++) {
    if (ar || !(i in from2)) {
      if (!ar) ar = Array.prototype.slice.call(from2, 0, i);
      ar[i] = from2[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from2));
}
typeof SuppressedError === "function" ? SuppressedError : function(error2, suppressed, message2) {
  var e3 = new Error(message2);
  return e3.name = "SuppressedError", e3.error = error2, e3.suppressed = suppressed, e3;
};
var CalendarContainer = function(_a2) {
  var _b = _a2.showTimeSelectOnly, showTimeSelectOnly = _b === void 0 ? false : _b, _c = _a2.showTime, showTime = _c === void 0 ? false : _c, className = _a2.className, children = _a2.children;
  var ariaLabel = showTimeSelectOnly ? "Choose Time" : "Choose Date".concat(showTime ? " and Time" : "");
  return React__default.createElement("div", { className, role: "dialog", "aria-label": ariaLabel, "aria-modal": "true" }, children);
};
var useDetectClickOutside = function(onClickOutside, ignoreClass) {
  var ref2 = useRef(null);
  var onClickOutsideRef = useRef(onClickOutside);
  onClickOutsideRef.current = onClickOutside;
  var handleClickOutside = useCallback(function(event) {
    var _a2;
    if (ref2.current && !ref2.current.contains(event.target)) {
      if (!(ignoreClass && event.target instanceof HTMLElement && event.target.classList.contains(ignoreClass))) {
        (_a2 = onClickOutsideRef.current) === null || _a2 === void 0 ? void 0 : _a2.call(onClickOutsideRef, event);
      }
    }
  }, [ignoreClass]);
  useEffect(function() {
    document.addEventListener("mousedown", handleClickOutside);
    return function() {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [handleClickOutside]);
  return ref2;
};
var ClickOutsideWrapper = function(_a2) {
  var children = _a2.children, onClickOutside = _a2.onClickOutside, className = _a2.className, containerRef = _a2.containerRef, style = _a2.style, ignoreClass = _a2.ignoreClass;
  var detectRef = useDetectClickOutside(onClickOutside, ignoreClass);
  return React__default.createElement("div", { className, style, ref: function(node2) {
    detectRef.current = node2;
    if (containerRef) {
      containerRef.current = node2;
    }
  } }, children);
};
var KeyType;
(function(KeyType2) {
  KeyType2["ArrowUp"] = "ArrowUp";
  KeyType2["ArrowDown"] = "ArrowDown";
  KeyType2["ArrowLeft"] = "ArrowLeft";
  KeyType2["ArrowRight"] = "ArrowRight";
  KeyType2["PageUp"] = "PageUp";
  KeyType2["PageDown"] = "PageDown";
  KeyType2["Home"] = "Home";
  KeyType2["End"] = "End";
  KeyType2["Enter"] = "Enter";
  KeyType2["Space"] = " ";
  KeyType2["Tab"] = "Tab";
  KeyType2["Escape"] = "Escape";
  KeyType2["Backspace"] = "Backspace";
  KeyType2["X"] = "x";
})(KeyType || (KeyType = {}));
function getLocaleScope() {
  var scope = typeof window !== "undefined" ? window : globalThis;
  return scope;
}
var DEFAULT_YEAR_ITEM_NUMBER = 12;
var longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
function newDate(value) {
  if (value == null) {
    return /* @__PURE__ */ new Date();
  }
  var d2 = typeof value === "string" ? parseISO(value) : toDate(value);
  return isValid(d2) ? d2 : /* @__PURE__ */ new Date();
}
function parseDate(value, dateFormat, locale, strictParsing, minDate) {
  var _a2;
  var parsedDate = null;
  var localeObject = getLocaleObject(locale) || getLocaleObject(getDefaultLocale());
  var strictParsingValueMatch = true;
  if (Array.isArray(dateFormat)) {
    dateFormat.forEach(function(df) {
      var tryParseDate = parse(value, df, /* @__PURE__ */ new Date(), {
        locale: localeObject,
        useAdditionalWeekYearTokens: true,
        useAdditionalDayOfYearTokens: true
      });
      if (strictParsing) {
        strictParsingValueMatch = isValid(tryParseDate, minDate) && value === formatDate(tryParseDate, df, locale);
      }
      if (isValid(tryParseDate, minDate) && strictParsingValueMatch) {
        parsedDate = tryParseDate;
      }
    });
    return parsedDate;
  }
  parsedDate = parse(value, dateFormat, /* @__PURE__ */ new Date(), {
    locale: localeObject,
    useAdditionalWeekYearTokens: true,
    useAdditionalDayOfYearTokens: true
  });
  if (strictParsing) {
    strictParsingValueMatch = isValid(parsedDate) && value === formatDate(parsedDate, dateFormat, locale);
  } else if (!isValid(parsedDate)) {
    var format_1 = ((_a2 = dateFormat.match(longFormattingTokensRegExp)) !== null && _a2 !== void 0 ? _a2 : []).map(function(substring) {
      var firstCharacter = substring[0];
      if (firstCharacter === "p" || firstCharacter === "P") {
        var longFormatter = longFormatters[firstCharacter];
        return localeObject ? longFormatter(substring, localeObject.formatLong) : firstCharacter;
      }
      return substring;
    }).join("");
    if (value.length > 0) {
      parsedDate = parse(value, format_1.slice(0, value.length), /* @__PURE__ */ new Date(), {
        useAdditionalWeekYearTokens: true,
        useAdditionalDayOfYearTokens: true
      });
    }
    if (!isValid(parsedDate)) {
      parsedDate = new Date(value);
    }
  }
  return isValid(parsedDate) && strictParsingValueMatch ? parsedDate : null;
}
function isValid(date, minDate) {
  return isValid$1(date) && !isBefore(date, minDate !== null && minDate !== void 0 ? minDate : /* @__PURE__ */ new Date("1/1/1800"));
}
function formatDate(date, formatStr, locale) {
  if (locale === "en") {
    return format(date, formatStr, {
      useAdditionalWeekYearTokens: true,
      useAdditionalDayOfYearTokens: true
    });
  }
  var localeObj = locale ? getLocaleObject(locale) : void 0;
  if (locale && !localeObj) {
    console.warn('A locale object was not found for the provided string ["'.concat(locale, '"].'));
  }
  if (!localeObj && !!getDefaultLocale() && !!getLocaleObject(getDefaultLocale())) {
    localeObj = getLocaleObject(getDefaultLocale());
  }
  return format(date, formatStr, {
    locale: localeObj,
    useAdditionalWeekYearTokens: true,
    useAdditionalDayOfYearTokens: true
  });
}
function safeDateFormat(date, _a2) {
  var dateFormat = _a2.dateFormat, locale = _a2.locale;
  var formatStr = Array.isArray(dateFormat) && dateFormat.length > 0 ? dateFormat[0] : dateFormat;
  return date && formatDate(date, formatStr, locale) || "";
}
function safeDateRangeFormat(startDate, endDate, props) {
  if (!startDate) {
    return "";
  }
  var formattedStartDate = safeDateFormat(startDate, props);
  var formattedEndDate = endDate ? safeDateFormat(endDate, props) : "";
  return "".concat(formattedStartDate, " - ").concat(formattedEndDate);
}
function safeMultipleDatesFormat(dates, props) {
  if (!(dates === null || dates === void 0 ? void 0 : dates.length)) {
    return "";
  }
  var formattedFirstDate = dates[0] ? safeDateFormat(dates[0], props) : "";
  if (dates.length === 1) {
    return formattedFirstDate;
  }
  if (dates.length === 2 && dates[1]) {
    var formattedSecondDate = safeDateFormat(dates[1], props);
    return "".concat(formattedFirstDate, ", ").concat(formattedSecondDate);
  }
  var extraDatesCount = dates.length - 1;
  return "".concat(formattedFirstDate, " (+").concat(extraDatesCount, ")");
}
function setTime(date, _a2) {
  var _b = _a2.hour, hour = _b === void 0 ? 0 : _b, _c = _a2.minute, minute = _c === void 0 ? 0 : _c, _d = _a2.second, second = _d === void 0 ? 0 : _d;
  return setHours(setMinutes(setSeconds(date, second), minute), hour);
}
function getWeek(date) {
  return getISOWeek(date);
}
function getDayOfWeekCode(day, locale) {
  return formatDate(day, "ddd", locale);
}
function getStartOfDay(date) {
  return startOfDay(date);
}
function getStartOfWeek(date, locale, calendarStartDay) {
  var localeObj = locale ? getLocaleObject(locale) : getLocaleObject(getDefaultLocale());
  return startOfWeek(date, {
    locale: localeObj,
    weekStartsOn: calendarStartDay
  });
}
function getStartOfMonth(date) {
  return startOfMonth(date);
}
function getStartOfYear(date) {
  return startOfYear(date);
}
function getStartOfQuarter(date) {
  return startOfQuarter(date);
}
function getStartOfToday() {
  return startOfDay(newDate());
}
function getEndOfDay(date) {
  return endOfDay(date);
}
function getEndOfWeek(date) {
  return endOfWeek(date);
}
function getEndOfMonth(date) {
  return endOfMonth(date);
}
function isSameYear(date1, date2) {
  if (date1 && date2) {
    return isSameYear$1(date1, date2);
  } else {
    return !date1 && !date2;
  }
}
function isSameMonth(date1, date2) {
  if (date1 && date2) {
    return isSameMonth$1(date1, date2);
  } else {
    return !date1 && !date2;
  }
}
function isSameQuarter(date1, date2) {
  if (date1 && date2) {
    return isSameQuarter$1(date1, date2);
  } else {
    return !date1 && !date2;
  }
}
function isSameDay(date1, date2) {
  if (date1 && date2) {
    return isSameDay$1(date1, date2);
  } else {
    return !date1 && !date2;
  }
}
function isEqual(date1, date2) {
  if (date1 && date2) {
    return isEqual$1(date1, date2);
  } else {
    return !date1 && !date2;
  }
}
function isDayInRange(day, startDate, endDate) {
  var valid;
  var start2 = startOfDay(startDate);
  var end2 = endOfDay(endDate);
  try {
    valid = isWithinInterval(day, { start: start2, end: end2 });
  } catch (err) {
    valid = false;
  }
  return valid;
}
function getDefaultLocale() {
  var scope = getLocaleScope();
  return scope.__localeId__;
}
function getLocaleObject(localeSpec) {
  if (typeof localeSpec === "string") {
    var scope = getLocaleScope();
    return scope.__localeData__ ? scope.__localeData__[localeSpec] : void 0;
  } else {
    return localeSpec;
  }
}
function getFormattedWeekdayInLocale(date, formatFunc, locale) {
  return formatFunc(formatDate(date, "EEEE", locale));
}
function getWeekdayMinInLocale(date, locale) {
  return formatDate(date, "EEEEEE", locale);
}
function getWeekdayShortInLocale(date, locale) {
  return formatDate(date, "EEE", locale);
}
function getMonthInLocale(month, locale) {
  return formatDate(setMonth(newDate(), month), "LLLL", locale);
}
function getMonthShortInLocale(month, locale) {
  return formatDate(setMonth(newDate(), month), "LLL", locale);
}
function getQuarterShortInLocale(quarter, locale) {
  return formatDate(setQuarter(newDate(), quarter), "QQQ", locale);
}
function isDayDisabled(day, _a2) {
  var _b = _a2 === void 0 ? {} : _a2, minDate = _b.minDate, maxDate = _b.maxDate, excludeDates = _b.excludeDates, excludeDateIntervals = _b.excludeDateIntervals, includeDates = _b.includeDates, includeDateIntervals = _b.includeDateIntervals, filterDate = _b.filterDate;
  return isOutOfBounds(day, { minDate, maxDate }) || excludeDates && excludeDates.some(function(excludeDate) {
    if (excludeDate instanceof Date) {
      return isSameDay(day, excludeDate);
    } else {
      return isSameDay(day, excludeDate.date);
    }
  }) || excludeDateIntervals && excludeDateIntervals.some(function(_a3) {
    var start2 = _a3.start, end2 = _a3.end;
    return isWithinInterval(day, { start: start2, end: end2 });
  }) || includeDates && !includeDates.some(function(includeDate) {
    return isSameDay(day, includeDate);
  }) || includeDateIntervals && !includeDateIntervals.some(function(_a3) {
    var start2 = _a3.start, end2 = _a3.end;
    return isWithinInterval(day, { start: start2, end: end2 });
  }) || filterDate && !filterDate(newDate(day)) || false;
}
function isDayExcluded(day, _a2) {
  var _b = _a2 === void 0 ? {} : _a2, excludeDates = _b.excludeDates, excludeDateIntervals = _b.excludeDateIntervals;
  if (excludeDateIntervals && excludeDateIntervals.length > 0) {
    return excludeDateIntervals.some(function(_a3) {
      var start2 = _a3.start, end2 = _a3.end;
      return isWithinInterval(day, { start: start2, end: end2 });
    });
  }
  return excludeDates && excludeDates.some(function(excludeDate) {
    var _a3;
    if (excludeDate instanceof Date) {
      return isSameDay(day, excludeDate);
    } else {
      return isSameDay(day, (_a3 = excludeDate.date) !== null && _a3 !== void 0 ? _a3 : /* @__PURE__ */ new Date());
    }
  }) || false;
}
function isMonthDisabled(month, _a2) {
  var _b = _a2 === void 0 ? {} : _a2, minDate = _b.minDate, maxDate = _b.maxDate, excludeDates = _b.excludeDates, includeDates = _b.includeDates, filterDate = _b.filterDate;
  return isOutOfBounds(month, {
    minDate: minDate ? startOfMonth(minDate) : void 0,
    maxDate: maxDate ? endOfMonth(maxDate) : void 0
  }) || (excludeDates === null || excludeDates === void 0 ? void 0 : excludeDates.some(function(excludeDate) {
    return isSameMonth(month, excludeDate instanceof Date ? excludeDate : excludeDate.date);
  })) || includeDates && !includeDates.some(function(includeDate) {
    return isSameMonth(month, includeDate);
  }) || filterDate && !filterDate(newDate(month)) || false;
}
function isMonthInRange(startDate, endDate, m2, day) {
  var startDateYear = getYear(startDate);
  var startDateMonth = getMonth(startDate);
  var endDateYear = getYear(endDate);
  var endDateMonth = getMonth(endDate);
  var dayYear = getYear(day);
  if (startDateYear === endDateYear && startDateYear === dayYear) {
    return startDateMonth <= m2 && m2 <= endDateMonth;
  } else if (startDateYear < endDateYear) {
    return dayYear === startDateYear && startDateMonth <= m2 || dayYear === endDateYear && endDateMonth >= m2 || dayYear < endDateYear && dayYear > startDateYear;
  }
  return false;
}
function isMonthYearDisabled(date, _a2) {
  var _b = _a2 === void 0 ? {} : _a2, minDate = _b.minDate, maxDate = _b.maxDate, excludeDates = _b.excludeDates, includeDates = _b.includeDates;
  return isOutOfBounds(date, { minDate, maxDate }) || excludeDates && excludeDates.some(function(excludedDate) {
    return isSameMonth(excludedDate instanceof Date ? excludedDate : excludedDate.date, date);
  }) || includeDates && !includeDates.some(function(includedDate) {
    return isSameMonth(includedDate, date);
  }) || false;
}
function isQuarterDisabled(quarter, _a2) {
  var _b = _a2 === void 0 ? {} : _a2, minDate = _b.minDate, maxDate = _b.maxDate, excludeDates = _b.excludeDates, includeDates = _b.includeDates, filterDate = _b.filterDate;
  return isOutOfBounds(quarter, { minDate, maxDate }) || (excludeDates === null || excludeDates === void 0 ? void 0 : excludeDates.some(function(excludeDate) {
    return isSameQuarter(quarter, excludeDate instanceof Date ? excludeDate : excludeDate.date);
  })) || includeDates && !includeDates.some(function(includeDate) {
    return isSameQuarter(quarter, includeDate);
  }) || filterDate && !filterDate(newDate(quarter)) || false;
}
function isYearInRange(year, start2, end2) {
  if (!start2 || !end2)
    return false;
  if (!isValid$1(start2) || !isValid$1(end2))
    return false;
  var startYear = getYear(start2);
  var endYear = getYear(end2);
  return startYear <= year && endYear >= year;
}
function isYearDisabled(year, _a2) {
  var _b = _a2 === void 0 ? {} : _a2, minDate = _b.minDate, maxDate = _b.maxDate, excludeDates = _b.excludeDates, includeDates = _b.includeDates, filterDate = _b.filterDate;
  var date = new Date(year, 0, 1);
  return isOutOfBounds(date, {
    minDate: minDate ? startOfYear(minDate) : void 0,
    maxDate: maxDate ? endOfYear(maxDate) : void 0
  }) || (excludeDates === null || excludeDates === void 0 ? void 0 : excludeDates.some(function(excludeDate) {
    return isSameYear(date, excludeDate instanceof Date ? excludeDate : excludeDate.date);
  })) || includeDates && !includeDates.some(function(includeDate) {
    return isSameYear(date, includeDate);
  }) || filterDate && !filterDate(newDate(date)) || false;
}
function isQuarterInRange(startDate, endDate, q2, day) {
  var startDateYear = getYear(startDate);
  var startDateQuarter = getQuarter(startDate);
  var endDateYear = getYear(endDate);
  var endDateQuarter = getQuarter(endDate);
  var dayYear = getYear(day);
  if (startDateYear === endDateYear && startDateYear === dayYear) {
    return startDateQuarter <= q2 && q2 <= endDateQuarter;
  } else if (startDateYear < endDateYear) {
    return dayYear === startDateYear && startDateQuarter <= q2 || dayYear === endDateYear && endDateQuarter >= q2 || dayYear < endDateYear && dayYear > startDateYear;
  }
  return false;
}
function isOutOfBounds(day, _a2) {
  var _b;
  var _c = _a2 === void 0 ? {} : _a2, minDate = _c.minDate, maxDate = _c.maxDate;
  return (_b = minDate && differenceInCalendarDays(day, minDate) < 0 || maxDate && differenceInCalendarDays(day, maxDate) > 0) !== null && _b !== void 0 ? _b : false;
}
function isTimeInList(time, times) {
  return times.some(function(listTime) {
    return getHours(listTime) === getHours(time) && getMinutes(listTime) === getMinutes(time) && getSeconds(listTime) === getSeconds(time);
  });
}
function isTimeDisabled(time, _a2) {
  var _b = _a2 === void 0 ? {} : _a2, excludeTimes = _b.excludeTimes, includeTimes = _b.includeTimes, filterTime = _b.filterTime;
  return excludeTimes && isTimeInList(time, excludeTimes) || includeTimes && !isTimeInList(time, includeTimes) || filterTime && !filterTime(time) || false;
}
function isTimeInDisabledRange(time, _a2) {
  var minTime = _a2.minTime, maxTime = _a2.maxTime;
  if (!minTime || !maxTime) {
    throw new Error("Both minTime and maxTime props required");
  }
  var baseTime = newDate();
  baseTime = setHours(baseTime, getHours(time));
  baseTime = setMinutes(baseTime, getMinutes(time));
  baseTime = setSeconds(baseTime, getSeconds(time));
  var min2 = newDate();
  min2 = setHours(min2, getHours(minTime));
  min2 = setMinutes(min2, getMinutes(minTime));
  min2 = setSeconds(min2, getSeconds(minTime));
  var max2 = newDate();
  max2 = setHours(max2, getHours(maxTime));
  max2 = setMinutes(max2, getMinutes(maxTime));
  max2 = setSeconds(max2, getSeconds(maxTime));
  var valid;
  try {
    valid = !isWithinInterval(baseTime, { start: min2, end: max2 });
  } catch (err) {
    valid = false;
  }
  return valid;
}
function monthDisabledBefore(day, _a2) {
  var _b = _a2 === void 0 ? {} : _a2, minDate = _b.minDate, includeDates = _b.includeDates;
  var previousMonth = subMonths(day, 1);
  return minDate && differenceInCalendarMonths(minDate, previousMonth) > 0 || includeDates && includeDates.every(function(includeDate) {
    return differenceInCalendarMonths(includeDate, previousMonth) > 0;
  }) || false;
}
function monthDisabledAfter(day, _a2) {
  var _b = _a2 === void 0 ? {} : _a2, maxDate = _b.maxDate, includeDates = _b.includeDates;
  var nextMonth = addMonths(day, 1);
  return maxDate && differenceInCalendarMonths(nextMonth, maxDate) > 0 || includeDates && includeDates.every(function(includeDate) {
    return differenceInCalendarMonths(nextMonth, includeDate) > 0;
  }) || false;
}
function quarterDisabledBefore(date, _a2) {
  var _b = _a2 === void 0 ? {} : _a2, minDate = _b.minDate, includeDates = _b.includeDates;
  var firstDateOfYear = startOfYear(date);
  var previousQuarter = subQuarters(firstDateOfYear);
  return minDate && differenceInCalendarQuarters(minDate, previousQuarter) > 0 || includeDates && includeDates.every(function(includeDate) {
    return differenceInCalendarQuarters(includeDate, previousQuarter) > 0;
  }) || false;
}
function quarterDisabledAfter(date, _a2) {
  var _b = _a2 === void 0 ? {} : _a2, maxDate = _b.maxDate, includeDates = _b.includeDates;
  var lastDateOfYear = endOfYear(date);
  var nextQuarter = addQuarters(lastDateOfYear, 1);
  return maxDate && differenceInCalendarQuarters(nextQuarter, maxDate) > 0 || includeDates && includeDates.every(function(includeDate) {
    return differenceInCalendarQuarters(nextQuarter, includeDate) > 0;
  }) || false;
}
function yearDisabledBefore(day, _a2) {
  var _b = _a2 === void 0 ? {} : _a2, minDate = _b.minDate, includeDates = _b.includeDates;
  var previousYear = subYears(day, 1);
  return minDate && differenceInCalendarYears(minDate, previousYear) > 0 || includeDates && includeDates.every(function(includeDate) {
    return differenceInCalendarYears(includeDate, previousYear) > 0;
  }) || false;
}
function yearsDisabledBefore(day, _a2) {
  var _b = _a2 === void 0 ? {} : _a2, minDate = _b.minDate, _c = _b.yearItemNumber, yearItemNumber = _c === void 0 ? DEFAULT_YEAR_ITEM_NUMBER : _c;
  var previousYear = getStartOfYear(subYears(day, yearItemNumber));
  var endPeriod = getYearsPeriod(previousYear, yearItemNumber).endPeriod;
  var minDateYear = minDate && getYear(minDate);
  return minDateYear && minDateYear > endPeriod || false;
}
function yearDisabledAfter(day, _a2) {
  var _b = _a2 === void 0 ? {} : _a2, maxDate = _b.maxDate, includeDates = _b.includeDates;
  var nextYear = addYears(day, 1);
  return maxDate && differenceInCalendarYears(nextYear, maxDate) > 0 || includeDates && includeDates.every(function(includeDate) {
    return differenceInCalendarYears(nextYear, includeDate) > 0;
  }) || false;
}
function yearsDisabledAfter(day, _a2) {
  var _b = _a2 === void 0 ? {} : _a2, maxDate = _b.maxDate, _c = _b.yearItemNumber, yearItemNumber = _c === void 0 ? DEFAULT_YEAR_ITEM_NUMBER : _c;
  var nextYear = addYears(day, yearItemNumber);
  var startPeriod = getYearsPeriod(nextYear, yearItemNumber).startPeriod;
  var maxDateYear = maxDate && getYear(maxDate);
  return maxDateYear && maxDateYear < startPeriod || false;
}
function getEffectiveMinDate(_a2) {
  var minDate = _a2.minDate, includeDates = _a2.includeDates;
  if (includeDates && minDate) {
    var minDates = includeDates.filter(function(includeDate) {
      return differenceInCalendarDays(includeDate, minDate) >= 0;
    });
    return min$1(minDates);
  } else if (includeDates) {
    return min$1(includeDates);
  } else {
    return minDate;
  }
}
function getEffectiveMaxDate(_a2) {
  var maxDate = _a2.maxDate, includeDates = _a2.includeDates;
  if (includeDates && maxDate) {
    var maxDates = includeDates.filter(function(includeDate) {
      return differenceInCalendarDays(includeDate, maxDate) <= 0;
    });
    return max$1(maxDates);
  } else if (includeDates) {
    return max$1(includeDates);
  } else {
    return maxDate;
  }
}
function getHighLightDaysMap(highlightDates, defaultClassName) {
  var _a2;
  if (highlightDates === void 0) {
    highlightDates = [];
  }
  if (defaultClassName === void 0) {
    defaultClassName = "react-datepicker__day--highlighted";
  }
  var dateClasses = /* @__PURE__ */ new Map();
  for (var i = 0, len = highlightDates.length; i < len; i++) {
    var obj = highlightDates[i];
    if (isDate(obj)) {
      var key = formatDate(obj, "MM.dd.yyyy");
      var classNamesArr = dateClasses.get(key) || [];
      if (!classNamesArr.includes(defaultClassName)) {
        classNamesArr.push(defaultClassName);
        dateClasses.set(key, classNamesArr);
      }
    } else if (typeof obj === "object") {
      var keys3 = Object.keys(obj);
      var className = (_a2 = keys3[0]) !== null && _a2 !== void 0 ? _a2 : "";
      var arrOfDates = obj[className];
      if (typeof className === "string" && Array.isArray(arrOfDates)) {
        for (var k2 = 0, len_1 = arrOfDates.length; k2 < len_1; k2++) {
          var dateK = arrOfDates[k2];
          if (dateK) {
            var key = formatDate(dateK, "MM.dd.yyyy");
            var classNamesArr = dateClasses.get(key) || [];
            if (!classNamesArr.includes(className)) {
              classNamesArr.push(className);
              dateClasses.set(key, classNamesArr);
            }
          }
        }
      }
    }
  }
  return dateClasses;
}
function arraysAreEqual(array1, array2) {
  if (array1.length !== array2.length) {
    return false;
  }
  return array1.every(function(value, index2) {
    return value === array2[index2];
  });
}
function getHolidaysMap(holidayDates, defaultClassName) {
  if (holidayDates === void 0) {
    holidayDates = [];
  }
  if (defaultClassName === void 0) {
    defaultClassName = "react-datepicker__day--holidays";
  }
  var dateClasses = /* @__PURE__ */ new Map();
  holidayDates.forEach(function(holiday) {
    var dateObj = holiday.date, holidayName = holiday.holidayName;
    if (!isDate(dateObj)) {
      return;
    }
    var key = formatDate(dateObj, "MM.dd.yyyy");
    var classNamesObj = dateClasses.get(key) || {
      className: "",
      holidayNames: []
    };
    if ("className" in classNamesObj && classNamesObj["className"] === defaultClassName && arraysAreEqual(classNamesObj["holidayNames"], [holidayName])) {
      return;
    }
    classNamesObj["className"] = defaultClassName;
    var holidayNameArr = classNamesObj["holidayNames"];
    classNamesObj["holidayNames"] = holidayNameArr ? __spreadArray(__spreadArray([], holidayNameArr, true), [holidayName], false) : [holidayName];
    dateClasses.set(key, classNamesObj);
  });
  return dateClasses;
}
function timesToInjectAfter(startOfDay2, currentTime, currentMultiplier, intervals, injectedTimes) {
  var l2 = injectedTimes.length;
  var times = [];
  for (var i = 0; i < l2; i++) {
    var injectedTime = startOfDay2;
    var injectedTimeValue = injectedTimes[i];
    if (injectedTimeValue) {
      injectedTime = addHours(injectedTime, getHours(injectedTimeValue));
      injectedTime = addMinutes(injectedTime, getMinutes(injectedTimeValue));
      injectedTime = addSeconds(injectedTime, getSeconds(injectedTimeValue));
    }
    var nextTime = addMinutes(startOfDay2, (currentMultiplier + 1) * intervals);
    if (isAfter(injectedTime, currentTime) && isBefore(injectedTime, nextTime) && injectedTimeValue != void 0) {
      times.push(injectedTimeValue);
    }
  }
  return times;
}
function addZero(i) {
  return i < 10 ? "0".concat(i) : "".concat(i);
}
function getYearsPeriod(date, yearItemNumber) {
  if (yearItemNumber === void 0) {
    yearItemNumber = DEFAULT_YEAR_ITEM_NUMBER;
  }
  var endPeriod = Math.ceil(getYear(date) / yearItemNumber) * yearItemNumber;
  var startPeriod = endPeriod - (yearItemNumber - 1);
  return { startPeriod, endPeriod };
}
function getHoursInDay(d2) {
  var startOfDay2 = new Date(d2.getFullYear(), d2.getMonth(), d2.getDate());
  var startOfTheNextDay = new Date(d2.getFullYear(), d2.getMonth(), d2.getDate(), 24);
  return Math.round((+startOfTheNextDay - +startOfDay2) / 36e5);
}
function startOfMinute(d2) {
  var seconds = d2.getSeconds();
  var milliseconds = d2.getMilliseconds();
  return toDate(d2.getTime() - seconds * 1e3 - milliseconds);
}
function isSameMinute(d1, d2) {
  return startOfMinute(d1).getTime() === startOfMinute(d2).getTime();
}
function getMidnightDate(date) {
  if (!isDate(date)) {
    throw new Error("Invalid date");
  }
  var dateWithoutTime = new Date(date);
  dateWithoutTime.setHours(0, 0, 0, 0);
  return dateWithoutTime;
}
function isDateBefore(date, dateToCompare) {
  if (!isDate(date) || !isDate(dateToCompare)) {
    throw new Error("Invalid date received");
  }
  var midnightDate = getMidnightDate(date);
  var midnightDateToCompare = getMidnightDate(dateToCompare);
  return isBefore(midnightDate, midnightDateToCompare);
}
function isSpaceKeyDown(event) {
  return event.key === KeyType.Space;
}
var InputTime = (
  /** @class */
  function(_super) {
    __extends(InputTime2, _super);
    function InputTime2(props) {
      var _this = _super.call(this, props) || this;
      _this.inputRef = React__default.createRef();
      _this.onTimeChange = function(time) {
        var _a2, _b;
        _this.setState({ time });
        var propDate = _this.props.date;
        var isPropDateValid = propDate instanceof Date && !isNaN(+propDate);
        var date = isPropDateValid ? propDate : /* @__PURE__ */ new Date();
        if (time === null || time === void 0 ? void 0 : time.includes(":")) {
          var _c = time.split(":"), hours = _c[0], minutes = _c[1];
          date.setHours(Number(hours));
          date.setMinutes(Number(minutes));
        }
        (_b = (_a2 = _this.props).onChange) === null || _b === void 0 ? void 0 : _b.call(_a2, date);
      };
      _this.renderTimeInput = function() {
        var time = _this.state.time;
        var _a2 = _this.props, date = _a2.date, timeString = _a2.timeString, customTimeInput = _a2.customTimeInput;
        if (customTimeInput) {
          return cloneElement(customTimeInput, {
            date,
            value: time,
            onChange: _this.onTimeChange
          });
        }
        return React__default.createElement("input", { type: "time", className: "react-datepicker-time__input", placeholder: "Time", name: "time-input", ref: _this.inputRef, onClick: function() {
          var _a3;
          (_a3 = _this.inputRef.current) === null || _a3 === void 0 ? void 0 : _a3.focus();
        }, required: true, value: time, onChange: function(event) {
          _this.onTimeChange(event.target.value || timeString);
        } });
      };
      _this.state = {
        time: _this.props.timeString
      };
      return _this;
    }
    InputTime2.getDerivedStateFromProps = function(props, state) {
      if (props.timeString !== state.time) {
        return {
          time: props.timeString
        };
      }
      return null;
    };
    InputTime2.prototype.render = function() {
      return React__default.createElement(
        "div",
        { className: "react-datepicker__input-time-container" },
        React__default.createElement("div", { className: "react-datepicker-time__caption" }, this.props.timeInputLabel),
        React__default.createElement(
          "div",
          { className: "react-datepicker-time__input-container" },
          React__default.createElement("div", { className: "react-datepicker-time__input" }, this.renderTimeInput())
        )
      );
    };
    return InputTime2;
  }(Component)
);
var Day = (
  /** @class */
  function(_super) {
    __extends(Day2, _super);
    function Day2() {
      var _this = _super !== null && _super.apply(this, arguments) || this;
      _this.dayEl = createRef();
      _this.handleClick = function(event) {
        if (!_this.isDisabled() && _this.props.onClick) {
          _this.props.onClick(event);
        }
      };
      _this.handleMouseEnter = function(event) {
        if (!_this.isDisabled() && _this.props.onMouseEnter) {
          _this.props.onMouseEnter(event);
        }
      };
      _this.handleOnKeyDown = function(event) {
        var _a2, _b;
        var eventKey = event.key;
        if (eventKey === KeyType.Space) {
          event.preventDefault();
          event.key = KeyType.Enter;
        }
        (_b = (_a2 = _this.props).handleOnKeyDown) === null || _b === void 0 ? void 0 : _b.call(_a2, event);
      };
      _this.isSameDay = function(other) {
        return isSameDay(_this.props.day, other);
      };
      _this.isKeyboardSelected = function() {
        var _a2;
        if (_this.props.disabledKeyboardNavigation) {
          return false;
        }
        var isSelectedDate = _this.props.selectsMultiple ? (_a2 = _this.props.selectedDates) === null || _a2 === void 0 ? void 0 : _a2.some(function(date) {
          return _this.isSameDayOrWeek(date);
        }) : _this.isSameDayOrWeek(_this.props.selected);
        var isDisabled = _this.props.preSelection && _this.isDisabled(_this.props.preSelection);
        return !isSelectedDate && _this.isSameDayOrWeek(_this.props.preSelection) && !isDisabled;
      };
      _this.isDisabled = function(day) {
        if (day === void 0) {
          day = _this.props.day;
        }
        return isDayDisabled(day, {
          minDate: _this.props.minDate,
          maxDate: _this.props.maxDate,
          excludeDates: _this.props.excludeDates,
          excludeDateIntervals: _this.props.excludeDateIntervals,
          includeDateIntervals: _this.props.includeDateIntervals,
          includeDates: _this.props.includeDates,
          filterDate: _this.props.filterDate
        });
      };
      _this.isExcluded = function() {
        return isDayExcluded(_this.props.day, {
          excludeDates: _this.props.excludeDates,
          excludeDateIntervals: _this.props.excludeDateIntervals
        });
      };
      _this.isStartOfWeek = function() {
        return isSameDay(_this.props.day, getStartOfWeek(_this.props.day, _this.props.locale, _this.props.calendarStartDay));
      };
      _this.isSameWeek = function(other) {
        return _this.props.showWeekPicker && isSameDay(other, getStartOfWeek(_this.props.day, _this.props.locale, _this.props.calendarStartDay));
      };
      _this.isSameDayOrWeek = function(other) {
        return _this.isSameDay(other) || _this.isSameWeek(other);
      };
      _this.getHighLightedClass = function() {
        var _a2 = _this.props, day = _a2.day, highlightDates = _a2.highlightDates;
        if (!highlightDates) {
          return false;
        }
        var dayStr = formatDate(day, "MM.dd.yyyy");
        return highlightDates.get(dayStr);
      };
      _this.getHolidaysClass = function() {
        var _a2;
        var _b = _this.props, day = _b.day, holidays = _b.holidays;
        if (!holidays) {
          return [void 0];
        }
        var dayStr = formatDate(day, "MM.dd.yyyy");
        if (holidays.has(dayStr)) {
          return [(_a2 = holidays.get(dayStr)) === null || _a2 === void 0 ? void 0 : _a2.className];
        }
        return [void 0];
      };
      _this.isInRange = function() {
        var _a2 = _this.props, day = _a2.day, startDate = _a2.startDate, endDate = _a2.endDate;
        if (!startDate || !endDate) {
          return false;
        }
        return isDayInRange(day, startDate, endDate);
      };
      _this.isInSelectingRange = function() {
        var _a2;
        var _b = _this.props, day = _b.day, selectsStart = _b.selectsStart, selectsEnd = _b.selectsEnd, selectsRange = _b.selectsRange, selectsDisabledDaysInRange = _b.selectsDisabledDaysInRange, startDate = _b.startDate, endDate = _b.endDate;
        var selectingDate = (_a2 = _this.props.selectingDate) !== null && _a2 !== void 0 ? _a2 : _this.props.preSelection;
        if (!(selectsStart || selectsEnd || selectsRange) || !selectingDate || !selectsDisabledDaysInRange && _this.isDisabled()) {
          return false;
        }
        if (selectsStart && endDate && (isBefore(selectingDate, endDate) || isEqual(selectingDate, endDate))) {
          return isDayInRange(day, selectingDate, endDate);
        }
        if (selectsEnd && startDate && (isAfter(selectingDate, startDate) || isEqual(selectingDate, startDate))) {
          return isDayInRange(day, startDate, selectingDate);
        }
        if (selectsRange && startDate && !endDate && (isAfter(selectingDate, startDate) || isEqual(selectingDate, startDate))) {
          return isDayInRange(day, startDate, selectingDate);
        }
        return false;
      };
      _this.isSelectingRangeStart = function() {
        var _a2;
        if (!_this.isInSelectingRange()) {
          return false;
        }
        var _b = _this.props, day = _b.day, startDate = _b.startDate, selectsStart = _b.selectsStart;
        var selectingDate = (_a2 = _this.props.selectingDate) !== null && _a2 !== void 0 ? _a2 : _this.props.preSelection;
        if (selectsStart) {
          return isSameDay(day, selectingDate);
        } else {
          return isSameDay(day, startDate);
        }
      };
      _this.isSelectingRangeEnd = function() {
        var _a2;
        if (!_this.isInSelectingRange()) {
          return false;
        }
        var _b = _this.props, day = _b.day, endDate = _b.endDate, selectsEnd = _b.selectsEnd, selectsRange = _b.selectsRange;
        var selectingDate = (_a2 = _this.props.selectingDate) !== null && _a2 !== void 0 ? _a2 : _this.props.preSelection;
        if (selectsEnd || selectsRange) {
          return isSameDay(day, selectingDate);
        } else {
          return isSameDay(day, endDate);
        }
      };
      _this.isRangeStart = function() {
        var _a2 = _this.props, day = _a2.day, startDate = _a2.startDate, endDate = _a2.endDate;
        if (!startDate || !endDate) {
          return false;
        }
        return isSameDay(startDate, day);
      };
      _this.isRangeEnd = function() {
        var _a2 = _this.props, day = _a2.day, startDate = _a2.startDate, endDate = _a2.endDate;
        if (!startDate || !endDate) {
          return false;
        }
        return isSameDay(endDate, day);
      };
      _this.isWeekend = function() {
        var weekday = getDay(_this.props.day);
        return weekday === 0 || weekday === 6;
      };
      _this.isAfterMonth = function() {
        return _this.props.month !== void 0 && (_this.props.month + 1) % 12 === getMonth(_this.props.day);
      };
      _this.isBeforeMonth = function() {
        return _this.props.month !== void 0 && (getMonth(_this.props.day) + 1) % 12 === _this.props.month;
      };
      _this.isCurrentDay = function() {
        return _this.isSameDay(newDate());
      };
      _this.isSelected = function() {
        var _a2;
        if (_this.props.selectsMultiple) {
          return (_a2 = _this.props.selectedDates) === null || _a2 === void 0 ? void 0 : _a2.some(function(date) {
            return _this.isSameDayOrWeek(date);
          });
        }
        return _this.isSameDayOrWeek(_this.props.selected);
      };
      _this.getClassNames = function(date) {
        var dayClassName = _this.props.dayClassName ? _this.props.dayClassName(date) : void 0;
        return clsx("react-datepicker__day", dayClassName, "react-datepicker__day--" + getDayOfWeekCode(_this.props.day), {
          "react-datepicker__day--disabled": _this.isDisabled(),
          "react-datepicker__day--excluded": _this.isExcluded(),
          "react-datepicker__day--selected": _this.isSelected(),
          "react-datepicker__day--keyboard-selected": _this.isKeyboardSelected(),
          "react-datepicker__day--range-start": _this.isRangeStart(),
          "react-datepicker__day--range-end": _this.isRangeEnd(),
          "react-datepicker__day--in-range": _this.isInRange(),
          "react-datepicker__day--in-selecting-range": _this.isInSelectingRange(),
          "react-datepicker__day--selecting-range-start": _this.isSelectingRangeStart(),
          "react-datepicker__day--selecting-range-end": _this.isSelectingRangeEnd(),
          "react-datepicker__day--today": _this.isCurrentDay(),
          "react-datepicker__day--weekend": _this.isWeekend(),
          "react-datepicker__day--outside-month": _this.isAfterMonth() || _this.isBeforeMonth()
        }, _this.getHighLightedClass(), _this.getHolidaysClass());
      };
      _this.getAriaLabel = function() {
        var _a2 = _this.props, day = _a2.day, _b = _a2.ariaLabelPrefixWhenEnabled, ariaLabelPrefixWhenEnabled = _b === void 0 ? "Choose" : _b, _c = _a2.ariaLabelPrefixWhenDisabled, ariaLabelPrefixWhenDisabled = _c === void 0 ? "Not available" : _c;
        var prefix2 = _this.isDisabled() || _this.isExcluded() ? ariaLabelPrefixWhenDisabled : ariaLabelPrefixWhenEnabled;
        return "".concat(prefix2, " ").concat(formatDate(day, "PPPP", _this.props.locale));
      };
      _this.getTitle = function() {
        var _a2 = _this.props, day = _a2.day, _b = _a2.holidays, holidays = _b === void 0 ? /* @__PURE__ */ new Map() : _b, excludeDates = _a2.excludeDates;
        var compareDt = formatDate(day, "MM.dd.yyyy");
        var titles = [];
        if (holidays.has(compareDt)) {
          titles.push.apply(titles, holidays.get(compareDt).holidayNames);
        }
        if (_this.isExcluded()) {
          titles.push(excludeDates === null || excludeDates === void 0 ? void 0 : excludeDates.filter(function(excludeDate) {
            if (excludeDate instanceof Date) {
              return isSameDay(excludeDate, day);
            }
            return isSameDay(excludeDate === null || excludeDate === void 0 ? void 0 : excludeDate.date, day);
          }).map(function(excludeDate) {
            if (excludeDate instanceof Date) {
              return void 0;
            }
            return excludeDate === null || excludeDate === void 0 ? void 0 : excludeDate.message;
          }));
        }
        return titles.join(", ");
      };
      _this.getTabIndex = function() {
        var selectedDay = _this.props.selected;
        var preSelectionDay = _this.props.preSelection;
        var tabIndex = !(_this.props.showWeekPicker && (_this.props.showWeekNumber || !_this.isStartOfWeek())) && (_this.isKeyboardSelected() || _this.isSameDay(selectedDay) && isSameDay(preSelectionDay, selectedDay)) ? 0 : -1;
        return tabIndex;
      };
      _this.handleFocusDay = function() {
        var _a2;
        _this.shouldFocusDay() && ((_a2 = _this.dayEl.current) === null || _a2 === void 0 ? void 0 : _a2.focus({ preventScroll: true }));
      };
      _this.renderDayContents = function() {
        if (_this.props.monthShowsDuplicateDaysEnd && _this.isAfterMonth())
          return null;
        if (_this.props.monthShowsDuplicateDaysStart && _this.isBeforeMonth())
          return null;
        return _this.props.renderDayContents ? _this.props.renderDayContents(getDate(_this.props.day), _this.props.day) : getDate(_this.props.day);
      };
      _this.render = function() {
        return (
          // TODO: Use <option> instead of the "option" role to ensure accessibility across all devices.
          React__default.createElement(
            "div",
            { ref: _this.dayEl, className: _this.getClassNames(_this.props.day), onKeyDown: _this.handleOnKeyDown, onClick: _this.handleClick, onMouseEnter: !_this.props.usePointerEvent ? _this.handleMouseEnter : void 0, onPointerEnter: _this.props.usePointerEvent ? _this.handleMouseEnter : void 0, tabIndex: _this.getTabIndex(), "aria-label": _this.getAriaLabel(), role: "option", title: _this.getTitle(), "aria-disabled": _this.isDisabled(), "aria-current": _this.isCurrentDay() ? "date" : void 0, "aria-selected": _this.isSelected() || _this.isInRange() },
            _this.renderDayContents(),
            _this.getTitle() !== "" && React__default.createElement("span", { className: "overlay" }, _this.getTitle())
          )
        );
      };
      return _this;
    }
    Day2.prototype.componentDidMount = function() {
      this.handleFocusDay();
    };
    Day2.prototype.componentDidUpdate = function() {
      this.handleFocusDay();
    };
    Day2.prototype.shouldFocusDay = function() {
      var shouldFocusDay = false;
      if (this.getTabIndex() === 0 && this.isSameDay(this.props.preSelection)) {
        if (!document.activeElement || document.activeElement === document.body) {
          shouldFocusDay = true;
        }
        if (this.props.inline && !this.props.shouldFocusDayInline) {
          shouldFocusDay = false;
        }
        if (this.isDayActiveElement()) {
          shouldFocusDay = true;
        }
        if (this.isDuplicateDay()) {
          shouldFocusDay = false;
        }
      }
      return shouldFocusDay;
    };
    Day2.prototype.isDayActiveElement = function() {
      var _a2, _b, _c;
      return ((_b = (_a2 = this.props.containerRef) === null || _a2 === void 0 ? void 0 : _a2.current) === null || _b === void 0 ? void 0 : _b.contains(document.activeElement)) && ((_c = document.activeElement) === null || _c === void 0 ? void 0 : _c.classList.contains("react-datepicker__day"));
    };
    Day2.prototype.isDuplicateDay = function() {
      return (
        //day is one of the non rendered duplicate days
        this.props.monthShowsDuplicateDaysEnd && this.isAfterMonth() || this.props.monthShowsDuplicateDaysStart && this.isBeforeMonth()
      );
    };
    return Day2;
  }(Component)
);
var WeekNumber = (
  /** @class */
  function(_super) {
    __extends(WeekNumber2, _super);
    function WeekNumber2() {
      var _this = _super !== null && _super.apply(this, arguments) || this;
      _this.weekNumberEl = createRef();
      _this.handleClick = function(event) {
        if (_this.props.onClick) {
          _this.props.onClick(event);
        }
      };
      _this.handleOnKeyDown = function(event) {
        var _a2, _b;
        var eventKey = event.key;
        if (eventKey === KeyType.Space) {
          event.preventDefault();
          event.key = KeyType.Enter;
        }
        (_b = (_a2 = _this.props).handleOnKeyDown) === null || _b === void 0 ? void 0 : _b.call(_a2, event);
      };
      _this.isKeyboardSelected = function() {
        return !_this.props.disabledKeyboardNavigation && !isSameDay(_this.props.date, _this.props.selected) && isSameDay(_this.props.date, _this.props.preSelection);
      };
      _this.getTabIndex = function() {
        return _this.props.showWeekPicker && _this.props.showWeekNumber && (_this.isKeyboardSelected() || isSameDay(_this.props.date, _this.props.selected) && isSameDay(_this.props.preSelection, _this.props.selected)) ? 0 : -1;
      };
      _this.handleFocusWeekNumber = function(prevProps) {
        var shouldFocusWeekNumber = false;
        if (_this.getTabIndex() === 0 && !(prevProps === null || prevProps === void 0 ? void 0 : prevProps.isInputFocused) && isSameDay(_this.props.date, _this.props.preSelection)) {
          if (!document.activeElement || document.activeElement === document.body) {
            shouldFocusWeekNumber = true;
          }
          if (_this.props.inline && !_this.props.shouldFocusDayInline) {
            shouldFocusWeekNumber = false;
          }
          if (_this.props.containerRef && _this.props.containerRef.current && _this.props.containerRef.current.contains(document.activeElement) && document.activeElement && document.activeElement.classList.contains("react-datepicker__week-number")) {
            shouldFocusWeekNumber = true;
          }
        }
        shouldFocusWeekNumber && _this.weekNumberEl.current && _this.weekNumberEl.current.focus({ preventScroll: true });
      };
      return _this;
    }
    Object.defineProperty(WeekNumber2, "defaultProps", {
      get: function() {
        return {
          ariaLabelPrefix: "week "
        };
      },
      enumerable: false,
      configurable: true
    });
    WeekNumber2.prototype.componentDidMount = function() {
      this.handleFocusWeekNumber();
    };
    WeekNumber2.prototype.componentDidUpdate = function(prevProps) {
      this.handleFocusWeekNumber(prevProps);
    };
    WeekNumber2.prototype.render = function() {
      var _a2 = this.props, weekNumber = _a2.weekNumber, isWeekDisabled = _a2.isWeekDisabled, _b = _a2.ariaLabelPrefix, ariaLabelPrefix = _b === void 0 ? WeekNumber2.defaultProps.ariaLabelPrefix : _b, onClick = _a2.onClick;
      var weekNumberClasses = {
        "react-datepicker__week-number": true,
        "react-datepicker__week-number--clickable": !!onClick && !isWeekDisabled,
        "react-datepicker__week-number--selected": !!onClick && isSameDay(this.props.date, this.props.selected)
      };
      return React__default.createElement("div", { ref: this.weekNumberEl, className: clsx(weekNumberClasses), "aria-label": "".concat(ariaLabelPrefix, " ").concat(this.props.weekNumber), onClick: this.handleClick, onKeyDown: this.handleOnKeyDown, tabIndex: this.getTabIndex() }, weekNumber);
    };
    return WeekNumber2;
  }(Component)
);
var Week = (
  /** @class */
  function(_super) {
    __extends(Week2, _super);
    function Week2() {
      var _this = _super !== null && _super.apply(this, arguments) || this;
      _this.isDisabled = function(day) {
        return isDayDisabled(day, {
          minDate: _this.props.minDate,
          maxDate: _this.props.maxDate,
          excludeDates: _this.props.excludeDates,
          excludeDateIntervals: _this.props.excludeDateIntervals,
          includeDateIntervals: _this.props.includeDateIntervals,
          includeDates: _this.props.includeDates,
          filterDate: _this.props.filterDate
        });
      };
      _this.handleDayClick = function(day, event) {
        if (_this.props.onDayClick) {
          _this.props.onDayClick(day, event);
        }
      };
      _this.handleDayMouseEnter = function(day) {
        if (_this.props.onDayMouseEnter) {
          _this.props.onDayMouseEnter(day);
        }
      };
      _this.handleWeekClick = function(day, weekNumber, event) {
        var _a2, _b, _c;
        var enabledWeekDay = new Date(day);
        for (var i = 0; i < 7; i++) {
          var processingDay = new Date(day);
          processingDay.setDate(processingDay.getDate() + i);
          var isEnabled = !_this.isDisabled(processingDay);
          if (isEnabled) {
            enabledWeekDay = processingDay;
            break;
          }
        }
        if (typeof _this.props.onWeekSelect === "function") {
          _this.props.onWeekSelect(enabledWeekDay, weekNumber, event);
        }
        if (_this.props.showWeekPicker) {
          _this.handleDayClick(enabledWeekDay, event);
        }
        if ((_a2 = _this.props.shouldCloseOnSelect) !== null && _a2 !== void 0 ? _a2 : Week2.defaultProps.shouldCloseOnSelect) {
          (_c = (_b = _this.props).setOpen) === null || _c === void 0 ? void 0 : _c.call(_b, false);
        }
      };
      _this.formatWeekNumber = function(date) {
        if (_this.props.formatWeekNumber) {
          return _this.props.formatWeekNumber(date);
        }
        return getWeek(date);
      };
      _this.isWeekDisabled = function() {
        var startOfWeek2 = _this.startOfWeek();
        var endOfWeek2 = addDays(startOfWeek2, 6);
        var processingDate = new Date(startOfWeek2);
        while (processingDate <= endOfWeek2) {
          if (!_this.isDisabled(processingDate))
            return false;
          processingDate = addDays(processingDate, 1);
        }
        return true;
      };
      _this.renderDays = function() {
        var startOfWeek2 = _this.startOfWeek();
        var days = [];
        var weekNumber = _this.formatWeekNumber(startOfWeek2);
        if (_this.props.showWeekNumber) {
          var onClickAction = _this.props.onWeekSelect || _this.props.showWeekPicker ? _this.handleWeekClick.bind(_this, startOfWeek2, weekNumber) : void 0;
          days.push(React__default.createElement(WeekNumber, _assign({ key: "W" }, Week2.defaultProps, _this.props, { weekNumber, isWeekDisabled: _this.isWeekDisabled(), date: startOfWeek2, onClick: onClickAction })));
        }
        return days.concat([0, 1, 2, 3, 4, 5, 6].map(function(offset2) {
          var day = addDays(startOfWeek2, offset2);
          return React__default.createElement(Day, _assign({}, Week2.defaultProps, _this.props, { ariaLabelPrefixWhenEnabled: _this.props.chooseDayAriaLabelPrefix, ariaLabelPrefixWhenDisabled: _this.props.disabledDayAriaLabelPrefix, key: day.valueOf(), day, onClick: _this.handleDayClick.bind(_this, day), onMouseEnter: _this.handleDayMouseEnter.bind(_this, day) }));
        }));
      };
      _this.startOfWeek = function() {
        return getStartOfWeek(_this.props.day, _this.props.locale, _this.props.calendarStartDay);
      };
      _this.isKeyboardSelected = function() {
        return !_this.props.disabledKeyboardNavigation && !isSameDay(_this.startOfWeek(), _this.props.selected) && isSameDay(_this.startOfWeek(), _this.props.preSelection);
      };
      return _this;
    }
    Object.defineProperty(Week2, "defaultProps", {
      get: function() {
        return {
          shouldCloseOnSelect: true
        };
      },
      enumerable: false,
      configurable: true
    });
    Week2.prototype.render = function() {
      var weekNumberClasses = {
        "react-datepicker__week": true,
        "react-datepicker__week--selected": isSameDay(this.startOfWeek(), this.props.selected),
        "react-datepicker__week--keyboard-selected": this.isKeyboardSelected()
      };
      return React__default.createElement("div", { className: clsx(weekNumberClasses) }, this.renderDays());
    };
    return Week2;
  }(Component)
);
var _a;
var FIXED_HEIGHT_STANDARD_WEEK_COUNT = 6;
var MONTH_COLUMNS_LAYOUT = {
  TWO_COLUMNS: "two_columns",
  THREE_COLUMNS: "three_columns",
  FOUR_COLUMNS: "four_columns"
};
var MONTH_COLUMNS = (_a = {}, _a[MONTH_COLUMNS_LAYOUT.TWO_COLUMNS] = {
  grid: [
    [0, 1],
    [2, 3],
    [4, 5],
    [6, 7],
    [8, 9],
    [10, 11]
  ],
  verticalNavigationOffset: 2
}, _a[MONTH_COLUMNS_LAYOUT.THREE_COLUMNS] = {
  grid: [
    [0, 1, 2],
    [3, 4, 5],
    [6, 7, 8],
    [9, 10, 11]
  ],
  verticalNavigationOffset: 3
}, _a[MONTH_COLUMNS_LAYOUT.FOUR_COLUMNS] = {
  grid: [
    [0, 1, 2, 3],
    [4, 5, 6, 7],
    [8, 9, 10, 11]
  ],
  verticalNavigationOffset: 4
}, _a);
var MONTH_NAVIGATION_HORIZONTAL_OFFSET = 1;
function getMonthColumnsLayout(showFourColumnMonthYearPicker, showTwoColumnMonthYearPicker) {
  if (showFourColumnMonthYearPicker) {
    return MONTH_COLUMNS_LAYOUT.FOUR_COLUMNS;
  }
  if (showTwoColumnMonthYearPicker) {
    return MONTH_COLUMNS_LAYOUT.TWO_COLUMNS;
  }
  return MONTH_COLUMNS_LAYOUT.THREE_COLUMNS;
}
var Month = (
  /** @class */
  function(_super) {
    __extends(Month2, _super);
    function Month2() {
      var _this = _super !== null && _super.apply(this, arguments) || this;
      _this.MONTH_REFS = __spreadArray([], Array(12), true).map(function() {
        return createRef();
      });
      _this.QUARTER_REFS = __spreadArray([], Array(4), true).map(function() {
        return createRef();
      });
      _this.isDisabled = function(day) {
        return isDayDisabled(day, {
          minDate: _this.props.minDate,
          maxDate: _this.props.maxDate,
          excludeDates: _this.props.excludeDates,
          excludeDateIntervals: _this.props.excludeDateIntervals,
          includeDateIntervals: _this.props.includeDateIntervals,
          includeDates: _this.props.includeDates,
          filterDate: _this.props.filterDate
        });
      };
      _this.isExcluded = function(day) {
        return isDayExcluded(day, {
          excludeDates: _this.props.excludeDates,
          excludeDateIntervals: _this.props.excludeDateIntervals
        });
      };
      _this.handleDayClick = function(day, event) {
        var _a2, _b;
        (_b = (_a2 = _this.props).onDayClick) === null || _b === void 0 ? void 0 : _b.call(_a2, day, event, _this.props.orderInDisplay);
      };
      _this.handleDayMouseEnter = function(day) {
        var _a2, _b;
        (_b = (_a2 = _this.props).onDayMouseEnter) === null || _b === void 0 ? void 0 : _b.call(_a2, day);
      };
      _this.handleMouseLeave = function() {
        var _a2, _b;
        (_b = (_a2 = _this.props).onMouseLeave) === null || _b === void 0 ? void 0 : _b.call(_a2);
      };
      _this.isRangeStartMonth = function(m2) {
        var _a2 = _this.props, day = _a2.day, startDate = _a2.startDate, endDate = _a2.endDate;
        if (!startDate || !endDate) {
          return false;
        }
        return isSameMonth(setMonth(day, m2), startDate);
      };
      _this.isRangeStartQuarter = function(q2) {
        var _a2 = _this.props, day = _a2.day, startDate = _a2.startDate, endDate = _a2.endDate;
        if (!startDate || !endDate) {
          return false;
        }
        return isSameQuarter(setQuarter(day, q2), startDate);
      };
      _this.isRangeEndMonth = function(m2) {
        var _a2 = _this.props, day = _a2.day, startDate = _a2.startDate, endDate = _a2.endDate;
        if (!startDate || !endDate) {
          return false;
        }
        return isSameMonth(setMonth(day, m2), endDate);
      };
      _this.isRangeEndQuarter = function(q2) {
        var _a2 = _this.props, day = _a2.day, startDate = _a2.startDate, endDate = _a2.endDate;
        if (!startDate || !endDate) {
          return false;
        }
        return isSameQuarter(setQuarter(day, q2), endDate);
      };
      _this.isInSelectingRangeMonth = function(m2) {
        var _a2;
        var _b = _this.props, day = _b.day, selectsStart = _b.selectsStart, selectsEnd = _b.selectsEnd, selectsRange = _b.selectsRange, startDate = _b.startDate, endDate = _b.endDate;
        var selectingDate = (_a2 = _this.props.selectingDate) !== null && _a2 !== void 0 ? _a2 : _this.props.preSelection;
        if (!(selectsStart || selectsEnd || selectsRange) || !selectingDate) {
          return false;
        }
        if (selectsStart && endDate) {
          return isMonthInRange(selectingDate, endDate, m2, day);
        }
        if (selectsEnd && startDate) {
          return isMonthInRange(startDate, selectingDate, m2, day);
        }
        if (selectsRange && startDate && !endDate) {
          return isMonthInRange(startDate, selectingDate, m2, day);
        }
        return false;
      };
      _this.isSelectingMonthRangeStart = function(m2) {
        var _a2;
        if (!_this.isInSelectingRangeMonth(m2)) {
          return false;
        }
        var _b = _this.props, day = _b.day, startDate = _b.startDate, selectsStart = _b.selectsStart;
        var _month = setMonth(day, m2);
        var selectingDate = (_a2 = _this.props.selectingDate) !== null && _a2 !== void 0 ? _a2 : _this.props.preSelection;
        if (selectsStart) {
          return isSameMonth(_month, selectingDate);
        } else {
          return isSameMonth(_month, startDate);
        }
      };
      _this.isSelectingMonthRangeEnd = function(m2) {
        var _a2;
        if (!_this.isInSelectingRangeMonth(m2)) {
          return false;
        }
        var _b = _this.props, day = _b.day, endDate = _b.endDate, selectsEnd = _b.selectsEnd, selectsRange = _b.selectsRange;
        var _month = setMonth(day, m2);
        var selectingDate = (_a2 = _this.props.selectingDate) !== null && _a2 !== void 0 ? _a2 : _this.props.preSelection;
        if (selectsEnd || selectsRange) {
          return isSameMonth(_month, selectingDate);
        } else {
          return isSameMonth(_month, endDate);
        }
      };
      _this.isInSelectingRangeQuarter = function(q2) {
        var _a2;
        var _b = _this.props, day = _b.day, selectsStart = _b.selectsStart, selectsEnd = _b.selectsEnd, selectsRange = _b.selectsRange, startDate = _b.startDate, endDate = _b.endDate;
        var selectingDate = (_a2 = _this.props.selectingDate) !== null && _a2 !== void 0 ? _a2 : _this.props.preSelection;
        if (!(selectsStart || selectsEnd || selectsRange) || !selectingDate) {
          return false;
        }
        if (selectsStart && endDate) {
          return isQuarterInRange(selectingDate, endDate, q2, day);
        }
        if (selectsEnd && startDate) {
          return isQuarterInRange(startDate, selectingDate, q2, day);
        }
        if (selectsRange && startDate && !endDate) {
          return isQuarterInRange(startDate, selectingDate, q2, day);
        }
        return false;
      };
      _this.isWeekInMonth = function(startOfWeek2) {
        var day = _this.props.day;
        var endOfWeek2 = addDays(startOfWeek2, 6);
        return isSameMonth(startOfWeek2, day) || isSameMonth(endOfWeek2, day);
      };
      _this.isCurrentMonth = function(day, m2) {
        return getYear(day) === getYear(newDate()) && m2 === getMonth(newDate());
      };
      _this.isCurrentQuarter = function(day, q2) {
        return getYear(day) === getYear(newDate()) && q2 === getQuarter(newDate());
      };
      _this.isSelectedMonth = function(day, m2, selected) {
        return getMonth(selected) === m2 && getYear(day) === getYear(selected);
      };
      _this.isSelectMonthInList = function(day, m2, selectedDates) {
        return selectedDates.some(function(selectedDate) {
          return _this.isSelectedMonth(day, m2, selectedDate);
        });
      };
      _this.isSelectedQuarter = function(day, q2, selected) {
        return getQuarter(day) === q2 && getYear(day) === getYear(selected);
      };
      _this.renderWeeks = function() {
        var weeks = [];
        var isFixedHeight = _this.props.fixedHeight;
        var i = 0;
        var breakAfterNextPush = false;
        var currentWeekStart = getStartOfWeek(getStartOfMonth(_this.props.day), _this.props.locale, _this.props.calendarStartDay);
        var isPreSelected = function(preSelection2) {
          return _this.props.showWeekPicker ? getStartOfWeek(preSelection2, _this.props.locale, _this.props.calendarStartDay) : _this.props.preSelection;
        };
        var isSelected = function(selected2) {
          return _this.props.showWeekPicker ? getStartOfWeek(selected2, _this.props.locale, _this.props.calendarStartDay) : _this.props.selected;
        };
        var selected = _this.props.selected ? isSelected(_this.props.selected) : void 0;
        var preSelection = _this.props.preSelection ? isPreSelected(_this.props.preSelection) : void 0;
        while (true) {
          weeks.push(React__default.createElement(Week, _assign({}, _this.props, { ariaLabelPrefix: _this.props.weekAriaLabelPrefix, key: i, day: currentWeekStart, month: getMonth(_this.props.day), onDayClick: _this.handleDayClick, onDayMouseEnter: _this.handleDayMouseEnter, selected, preSelection, showWeekNumber: _this.props.showWeekNumbers })));
          if (breakAfterNextPush)
            break;
          i++;
          currentWeekStart = addWeeks(currentWeekStart, 1);
          var isFixedAndFinalWeek = isFixedHeight && i >= FIXED_HEIGHT_STANDARD_WEEK_COUNT;
          var isNonFixedAndOutOfMonth = !isFixedHeight && !_this.isWeekInMonth(currentWeekStart);
          if (isFixedAndFinalWeek || isNonFixedAndOutOfMonth) {
            if (_this.props.peekNextMonth) {
              breakAfterNextPush = true;
            } else {
              break;
            }
          }
        }
        return weeks;
      };
      _this.onMonthClick = function(event, m2) {
        var _a2 = _this.isMonthDisabledForLabelDate(m2), isDisabled = _a2.isDisabled, labelDate = _a2.labelDate;
        if (isDisabled) {
          return;
        }
        _this.handleDayClick(getStartOfMonth(labelDate), event);
      };
      _this.onMonthMouseEnter = function(m2) {
        var _a2 = _this.isMonthDisabledForLabelDate(m2), isDisabled = _a2.isDisabled, labelDate = _a2.labelDate;
        if (isDisabled) {
          return;
        }
        _this.handleDayMouseEnter(getStartOfMonth(labelDate));
      };
      _this.handleMonthNavigation = function(newMonth, newDate2) {
        var _a2, _b, _c, _d;
        (_b = (_a2 = _this.props).setPreSelection) === null || _b === void 0 ? void 0 : _b.call(_a2, newDate2);
        (_d = (_c = _this.MONTH_REFS[newMonth]) === null || _c === void 0 ? void 0 : _c.current) === null || _d === void 0 ? void 0 : _d.focus();
      };
      _this.handleKeyboardNavigation = function(event, eventKey, month) {
        var _a2;
        var _b = _this.props, selected = _b.selected, preSelection = _b.preSelection, setPreSelection = _b.setPreSelection, minDate = _b.minDate, maxDate = _b.maxDate, showFourColumnMonthYearPicker = _b.showFourColumnMonthYearPicker, showTwoColumnMonthYearPicker = _b.showTwoColumnMonthYearPicker;
        if (!preSelection)
          return;
        var monthColumnsLayout = getMonthColumnsLayout(showFourColumnMonthYearPicker, showTwoColumnMonthYearPicker);
        var verticalOffset = _this.getVerticalOffset(monthColumnsLayout);
        var monthsGrid = (_a2 = MONTH_COLUMNS[monthColumnsLayout]) === null || _a2 === void 0 ? void 0 : _a2.grid;
        var calculateNewDateAndMonth = function(eventKey2, date, month2) {
          var _a3, _b2;
          var newCalculatedDate2 = date;
          var newCalculatedMonth2 = month2;
          switch (eventKey2) {
            case KeyType.ArrowRight:
              newCalculatedDate2 = addMonths(date, MONTH_NAVIGATION_HORIZONTAL_OFFSET);
              newCalculatedMonth2 = month2 === 11 ? 0 : month2 + MONTH_NAVIGATION_HORIZONTAL_OFFSET;
              break;
            case KeyType.ArrowLeft:
              newCalculatedDate2 = subMonths(date, MONTH_NAVIGATION_HORIZONTAL_OFFSET);
              newCalculatedMonth2 = month2 === 0 ? 11 : month2 - MONTH_NAVIGATION_HORIZONTAL_OFFSET;
              break;
            case KeyType.ArrowUp:
              newCalculatedDate2 = subMonths(date, verticalOffset);
              newCalculatedMonth2 = ((_a3 = monthsGrid === null || monthsGrid === void 0 ? void 0 : monthsGrid[0]) === null || _a3 === void 0 ? void 0 : _a3.includes(month2)) ? month2 + 12 - verticalOffset : month2 - verticalOffset;
              break;
            case KeyType.ArrowDown:
              newCalculatedDate2 = addMonths(date, verticalOffset);
              newCalculatedMonth2 = ((_b2 = monthsGrid === null || monthsGrid === void 0 ? void 0 : monthsGrid[monthsGrid.length - 1]) === null || _b2 === void 0 ? void 0 : _b2.includes(month2)) ? month2 - 12 + verticalOffset : month2 + verticalOffset;
              break;
          }
          return { newCalculatedDate: newCalculatedDate2, newCalculatedMonth: newCalculatedMonth2 };
        };
        var getNewDateAndMonth = function(eventKey2, selectedDate, month2) {
          var MAX_ITERATIONS = 40;
          var eventKeyCopy = eventKey2;
          var validDateFound = false;
          var iterations = 0;
          var _a3 = calculateNewDateAndMonth(eventKeyCopy, selectedDate, month2), newCalculatedDate2 = _a3.newCalculatedDate, newCalculatedMonth2 = _a3.newCalculatedMonth;
          while (!validDateFound) {
            if (iterations >= MAX_ITERATIONS) {
              newCalculatedDate2 = selectedDate;
              newCalculatedMonth2 = month2;
              break;
            }
            if (minDate && newCalculatedDate2 < minDate) {
              eventKeyCopy = KeyType.ArrowRight;
              var obj = calculateNewDateAndMonth(eventKeyCopy, newCalculatedDate2, newCalculatedMonth2);
              newCalculatedDate2 = obj.newCalculatedDate;
              newCalculatedMonth2 = obj.newCalculatedMonth;
            }
            if (maxDate && newCalculatedDate2 > maxDate) {
              eventKeyCopy = KeyType.ArrowLeft;
              var obj = calculateNewDateAndMonth(eventKeyCopy, newCalculatedDate2, newCalculatedMonth2);
              newCalculatedDate2 = obj.newCalculatedDate;
              newCalculatedMonth2 = obj.newCalculatedMonth;
            }
            if (isMonthYearDisabled(newCalculatedDate2, _this.props)) {
              var obj = calculateNewDateAndMonth(eventKeyCopy, newCalculatedDate2, newCalculatedMonth2);
              newCalculatedDate2 = obj.newCalculatedDate;
              newCalculatedMonth2 = obj.newCalculatedMonth;
            } else {
              validDateFound = true;
            }
            iterations++;
          }
          return { newCalculatedDate: newCalculatedDate2, newCalculatedMonth: newCalculatedMonth2 };
        };
        if (eventKey === KeyType.Enter) {
          if (!_this.isMonthDisabled(month)) {
            _this.onMonthClick(event, month);
            setPreSelection === null || setPreSelection === void 0 ? void 0 : setPreSelection(selected);
          }
          return;
        }
        var _c = getNewDateAndMonth(eventKey, preSelection, month), newCalculatedDate = _c.newCalculatedDate, newCalculatedMonth = _c.newCalculatedMonth;
        switch (eventKey) {
          case KeyType.ArrowRight:
          case KeyType.ArrowLeft:
          case KeyType.ArrowUp:
          case KeyType.ArrowDown:
            _this.handleMonthNavigation(newCalculatedMonth, newCalculatedDate);
            break;
        }
      };
      _this.getVerticalOffset = function(monthColumnsLayout) {
        var _a2, _b;
        return (_b = (_a2 = MONTH_COLUMNS[monthColumnsLayout]) === null || _a2 === void 0 ? void 0 : _a2.verticalNavigationOffset) !== null && _b !== void 0 ? _b : 0;
      };
      _this.onMonthKeyDown = function(event, month) {
        var _a2 = _this.props, disabledKeyboardNavigation = _a2.disabledKeyboardNavigation, handleOnMonthKeyDown = _a2.handleOnMonthKeyDown;
        var eventKey = event.key;
        if (eventKey !== KeyType.Tab) {
          event.preventDefault();
        }
        if (!disabledKeyboardNavigation) {
          _this.handleKeyboardNavigation(event, eventKey, month);
        }
        handleOnMonthKeyDown && handleOnMonthKeyDown(event);
      };
      _this.onQuarterClick = function(event, q2) {
        var labelDate = setQuarter(_this.props.day, q2);
        if (isQuarterDisabled(labelDate, _this.props)) {
          return;
        }
        _this.handleDayClick(getStartOfQuarter(labelDate), event);
      };
      _this.onQuarterMouseEnter = function(q2) {
        var labelDate = setQuarter(_this.props.day, q2);
        if (isQuarterDisabled(labelDate, _this.props)) {
          return;
        }
        _this.handleDayMouseEnter(getStartOfQuarter(labelDate));
      };
      _this.handleQuarterNavigation = function(newQuarter, newDate2) {
        var _a2, _b, _c, _d;
        if (_this.isDisabled(newDate2) || _this.isExcluded(newDate2)) {
          return;
        }
        (_b = (_a2 = _this.props).setPreSelection) === null || _b === void 0 ? void 0 : _b.call(_a2, newDate2);
        (_d = (_c = _this.QUARTER_REFS[newQuarter - 1]) === null || _c === void 0 ? void 0 : _c.current) === null || _d === void 0 ? void 0 : _d.focus();
      };
      _this.onQuarterKeyDown = function(event, quarter) {
        var _a2, _b;
        var eventKey = event.key;
        if (!_this.props.disabledKeyboardNavigation) {
          switch (eventKey) {
            case KeyType.Enter:
              _this.onQuarterClick(event, quarter);
              (_b = (_a2 = _this.props).setPreSelection) === null || _b === void 0 ? void 0 : _b.call(_a2, _this.props.selected);
              break;
            case KeyType.ArrowRight:
              if (!_this.props.preSelection) {
                break;
              }
              _this.handleQuarterNavigation(quarter === 4 ? 1 : quarter + 1, addQuarters(_this.props.preSelection, 1));
              break;
            case KeyType.ArrowLeft:
              if (!_this.props.preSelection) {
                break;
              }
              _this.handleQuarterNavigation(quarter === 1 ? 4 : quarter - 1, subQuarters(_this.props.preSelection));
              break;
          }
        }
      };
      _this.isMonthDisabledForLabelDate = function(month) {
        var _a2;
        var _b = _this.props, day = _b.day, minDate = _b.minDate, maxDate = _b.maxDate, excludeDates = _b.excludeDates, includeDates = _b.includeDates;
        var labelDate = setMonth(day, month);
        return {
          isDisabled: (_a2 = (minDate || maxDate || excludeDates || includeDates) && isMonthDisabled(labelDate, _this.props)) !== null && _a2 !== void 0 ? _a2 : false,
          labelDate
        };
      };
      _this.isMonthDisabled = function(month) {
        var isDisabled = _this.isMonthDisabledForLabelDate(month).isDisabled;
        return isDisabled;
      };
      _this.getMonthClassNames = function(m2) {
        var _a2 = _this.props, day = _a2.day, startDate = _a2.startDate, endDate = _a2.endDate, preSelection = _a2.preSelection, monthClassName = _a2.monthClassName;
        var _monthClassName = monthClassName ? monthClassName(setMonth(day, m2)) : void 0;
        var selection = _this.getSelection();
        return clsx("react-datepicker__month-text", "react-datepicker__month-".concat(m2), _monthClassName, {
          "react-datepicker__month-text--disabled": _this.isMonthDisabled(m2),
          "react-datepicker__month-text--selected": selection ? _this.isSelectMonthInList(day, m2, selection) : void 0,
          "react-datepicker__month-text--keyboard-selected": !_this.props.disabledKeyboardNavigation && preSelection && _this.isSelectedMonth(day, m2, preSelection) && !_this.isMonthDisabled(m2),
          "react-datepicker__month-text--in-selecting-range": _this.isInSelectingRangeMonth(m2),
          "react-datepicker__month-text--in-range": startDate && endDate ? isMonthInRange(startDate, endDate, m2, day) : void 0,
          "react-datepicker__month-text--range-start": _this.isRangeStartMonth(m2),
          "react-datepicker__month-text--range-end": _this.isRangeEndMonth(m2),
          "react-datepicker__month-text--selecting-range-start": _this.isSelectingMonthRangeStart(m2),
          "react-datepicker__month-text--selecting-range-end": _this.isSelectingMonthRangeEnd(m2),
          "react-datepicker__month-text--today": _this.isCurrentMonth(day, m2)
        });
      };
      _this.getTabIndex = function(m2) {
        if (_this.props.preSelection == null) {
          return "-1";
        }
        var preSelectedMonth = getMonth(_this.props.preSelection);
        var isPreSelectedMonthDisabled = _this.isMonthDisabledForLabelDate(preSelectedMonth).isDisabled;
        var tabIndex = m2 === preSelectedMonth && !(isPreSelectedMonthDisabled || _this.props.disabledKeyboardNavigation) ? "0" : "-1";
        return tabIndex;
      };
      _this.getQuarterTabIndex = function(q2) {
        if (_this.props.preSelection == null) {
          return "-1";
        }
        var preSelectedQuarter = getQuarter(_this.props.preSelection);
        var isCurrentQuarterDisabled = isQuarterDisabled(_this.props.day, _this.props);
        var tabIndex = q2 === preSelectedQuarter && !(isCurrentQuarterDisabled || _this.props.disabledKeyboardNavigation) ? "0" : "-1";
        return tabIndex;
      };
      _this.getAriaLabel = function(month) {
        var _a2 = _this.props, _b = _a2.chooseDayAriaLabelPrefix, chooseDayAriaLabelPrefix = _b === void 0 ? "Choose" : _b, _c = _a2.disabledDayAriaLabelPrefix, disabledDayAriaLabelPrefix = _c === void 0 ? "Not available" : _c, day = _a2.day, locale = _a2.locale;
        var labelDate = setMonth(day, month);
        var prefix2 = _this.isDisabled(labelDate) || _this.isExcluded(labelDate) ? disabledDayAriaLabelPrefix : chooseDayAriaLabelPrefix;
        return "".concat(prefix2, " ").concat(formatDate(labelDate, "MMMM yyyy", locale));
      };
      _this.getQuarterClassNames = function(q2) {
        var _a2 = _this.props, day = _a2.day, startDate = _a2.startDate, endDate = _a2.endDate, selected = _a2.selected, minDate = _a2.minDate, maxDate = _a2.maxDate, excludeDates = _a2.excludeDates, includeDates = _a2.includeDates, filterDate = _a2.filterDate, preSelection = _a2.preSelection, disabledKeyboardNavigation = _a2.disabledKeyboardNavigation;
        var isDisabled = (minDate || maxDate || excludeDates || includeDates || filterDate) && isQuarterDisabled(setQuarter(day, q2), _this.props);
        return clsx("react-datepicker__quarter-text", "react-datepicker__quarter-".concat(q2), {
          "react-datepicker__quarter-text--disabled": isDisabled,
          "react-datepicker__quarter-text--selected": selected ? _this.isSelectedQuarter(day, q2, selected) : void 0,
          "react-datepicker__quarter-text--keyboard-selected": !disabledKeyboardNavigation && preSelection && _this.isSelectedQuarter(day, q2, preSelection) && !isDisabled,
          "react-datepicker__quarter-text--in-selecting-range": _this.isInSelectingRangeQuarter(q2),
          "react-datepicker__quarter-text--in-range": startDate && endDate ? isQuarterInRange(startDate, endDate, q2, day) : void 0,
          "react-datepicker__quarter-text--range-start": _this.isRangeStartQuarter(q2),
          "react-datepicker__quarter-text--range-end": _this.isRangeEndQuarter(q2)
        });
      };
      _this.getMonthContent = function(m2) {
        var _a2 = _this.props, showFullMonthYearPicker = _a2.showFullMonthYearPicker, renderMonthContent = _a2.renderMonthContent, locale = _a2.locale, day = _a2.day;
        var shortMonthText = getMonthShortInLocale(m2, locale);
        var fullMonthText = getMonthInLocale(m2, locale);
        if (renderMonthContent) {
          return renderMonthContent(m2, shortMonthText, fullMonthText, day);
        }
        return showFullMonthYearPicker ? fullMonthText : shortMonthText;
      };
      _this.getQuarterContent = function(q2) {
        var _a2;
        var _b = _this.props, renderQuarterContent = _b.renderQuarterContent, locale = _b.locale;
        var shortQuarter = getQuarterShortInLocale(q2, locale);
        return (_a2 = renderQuarterContent === null || renderQuarterContent === void 0 ? void 0 : renderQuarterContent(q2, shortQuarter)) !== null && _a2 !== void 0 ? _a2 : shortQuarter;
      };
      _this.renderMonths = function() {
        var _a2;
        var _b = _this.props, showTwoColumnMonthYearPicker = _b.showTwoColumnMonthYearPicker, showFourColumnMonthYearPicker = _b.showFourColumnMonthYearPicker, day = _b.day, selected = _b.selected;
        var monthColumns = (_a2 = MONTH_COLUMNS[getMonthColumnsLayout(showFourColumnMonthYearPicker, showTwoColumnMonthYearPicker)]) === null || _a2 === void 0 ? void 0 : _a2.grid;
        return monthColumns === null || monthColumns === void 0 ? void 0 : monthColumns.map(function(month, i) {
          return React__default.createElement("div", { className: "react-datepicker__month-wrapper", key: i }, month.map(function(m2, j) {
            return React__default.createElement("div", { ref: _this.MONTH_REFS[m2], key: j, onClick: function(event) {
              _this.onMonthClick(event, m2);
            }, onKeyDown: function(event) {
              if (isSpaceKeyDown(event)) {
                event.preventDefault();
                event.key = KeyType.Enter;
              }
              _this.onMonthKeyDown(event, m2);
            }, onMouseEnter: !_this.props.usePointerEvent ? function() {
              return _this.onMonthMouseEnter(m2);
            } : void 0, onPointerEnter: _this.props.usePointerEvent ? function() {
              return _this.onMonthMouseEnter(m2);
            } : void 0, tabIndex: Number(_this.getTabIndex(m2)), className: _this.getMonthClassNames(m2), "aria-disabled": _this.isMonthDisabled(m2), role: "option", "aria-label": _this.getAriaLabel(m2), "aria-current": _this.isCurrentMonth(day, m2) ? "date" : void 0, "aria-selected": selected ? _this.isSelectedMonth(day, m2, selected) : void 0 }, _this.getMonthContent(m2));
          }));
        });
      };
      _this.renderQuarters = function() {
        var _a2 = _this.props, day = _a2.day, selected = _a2.selected;
        var quarters = [1, 2, 3, 4];
        return React__default.createElement("div", { className: "react-datepicker__quarter-wrapper" }, quarters.map(function(q2, j) {
          return React__default.createElement("div", { key: j, ref: _this.QUARTER_REFS[j], role: "option", onClick: function(event) {
            _this.onQuarterClick(event, q2);
          }, onKeyDown: function(event) {
            _this.onQuarterKeyDown(event, q2);
          }, onMouseEnter: !_this.props.usePointerEvent ? function() {
            return _this.onQuarterMouseEnter(q2);
          } : void 0, onPointerEnter: _this.props.usePointerEvent ? function() {
            return _this.onQuarterMouseEnter(q2);
          } : void 0, className: _this.getQuarterClassNames(q2), "aria-selected": selected ? _this.isSelectedQuarter(day, q2, selected) : void 0, tabIndex: Number(_this.getQuarterTabIndex(q2)), "aria-current": _this.isCurrentQuarter(day, q2) ? "date" : void 0 }, _this.getQuarterContent(q2));
        }));
      };
      _this.getClassNames = function() {
        var _a2 = _this.props, selectingDate = _a2.selectingDate, selectsStart = _a2.selectsStart, selectsEnd = _a2.selectsEnd, showMonthYearPicker = _a2.showMonthYearPicker, showQuarterYearPicker = _a2.showQuarterYearPicker, showWeekPicker = _a2.showWeekPicker;
        return clsx("react-datepicker__month", {
          "react-datepicker__month--selecting-range": selectingDate && (selectsStart || selectsEnd)
        }, { "react-datepicker__monthPicker": showMonthYearPicker }, { "react-datepicker__quarterPicker": showQuarterYearPicker }, { "react-datepicker__weekPicker": showWeekPicker });
      };
      return _this;
    }
    Month2.prototype.getSelection = function() {
      var _a2 = this.props, selected = _a2.selected, selectedDates = _a2.selectedDates, selectsMultiple = _a2.selectsMultiple;
      if (selectsMultiple) {
        return selectedDates;
      }
      if (selected) {
        return [selected];
      }
      return void 0;
    };
    Month2.prototype.render = function() {
      var _a2 = this.props, showMonthYearPicker = _a2.showMonthYearPicker, showQuarterYearPicker = _a2.showQuarterYearPicker, day = _a2.day, _b = _a2.ariaLabelPrefix, ariaLabelPrefix = _b === void 0 ? "Month " : _b;
      var formattedAriaLabelPrefix = ariaLabelPrefix ? ariaLabelPrefix.trim() + " " : "";
      return React__default.createElement("div", { className: this.getClassNames(), onMouseLeave: !this.props.usePointerEvent ? this.handleMouseLeave : void 0, onPointerLeave: this.props.usePointerEvent ? this.handleMouseLeave : void 0, "aria-label": "".concat(formattedAriaLabelPrefix).concat(formatDate(day, "MMMM, yyyy", this.props.locale)), role: "listbox" }, showMonthYearPicker ? this.renderMonths() : showQuarterYearPicker ? this.renderQuarters() : this.renderWeeks());
    };
    return Month2;
  }(Component)
);
var MonthDropdownOptions = (
  /** @class */
  function(_super) {
    __extends(MonthDropdownOptions2, _super);
    function MonthDropdownOptions2() {
      var _this = _super !== null && _super.apply(this, arguments) || this;
      _this.isSelectedMonth = function(i) {
        return _this.props.month === i;
      };
      _this.renderOptions = function() {
        return _this.props.monthNames.map(function(month, i) {
          return React__default.createElement(
            "div",
            { className: _this.isSelectedMonth(i) ? "react-datepicker__month-option react-datepicker__month-option--selected_month" : "react-datepicker__month-option", key: month, onClick: _this.onChange.bind(_this, i), "aria-selected": _this.isSelectedMonth(i) ? "true" : void 0 },
            _this.isSelectedMonth(i) ? React__default.createElement("span", { className: "react-datepicker__month-option--selected" }, "✓") : "",
            month
          );
        });
      };
      _this.onChange = function(month) {
        return _this.props.onChange(month);
      };
      _this.handleClickOutside = function() {
        return _this.props.onCancel();
      };
      return _this;
    }
    MonthDropdownOptions2.prototype.render = function() {
      return React__default.createElement(ClickOutsideWrapper, { className: "react-datepicker__month-dropdown", onClickOutside: this.handleClickOutside }, this.renderOptions());
    };
    return MonthDropdownOptions2;
  }(Component)
);
var MonthDropdown = (
  /** @class */
  function(_super) {
    __extends(MonthDropdown2, _super);
    function MonthDropdown2() {
      var _this = _super !== null && _super.apply(this, arguments) || this;
      _this.state = {
        dropdownVisible: false
      };
      _this.renderSelectOptions = function(monthNames) {
        return monthNames.map(function(m2, i) {
          return React__default.createElement("option", { key: m2, value: i }, m2);
        });
      };
      _this.renderSelectMode = function(monthNames) {
        return React__default.createElement("select", { value: _this.props.month, className: "react-datepicker__month-select", onChange: function(e3) {
          return _this.onChange(parseInt(e3.target.value));
        } }, _this.renderSelectOptions(monthNames));
      };
      _this.renderReadView = function(visible, monthNames) {
        return React__default.createElement(
          "div",
          { key: "read", style: { visibility: visible ? "visible" : "hidden" }, className: "react-datepicker__month-read-view", onClick: _this.toggleDropdown },
          React__default.createElement("span", { className: "react-datepicker__month-read-view--down-arrow" }),
          React__default.createElement("span", { className: "react-datepicker__month-read-view--selected-month" }, monthNames[_this.props.month])
        );
      };
      _this.renderDropdown = function(monthNames) {
        return React__default.createElement(MonthDropdownOptions, _assign({ key: "dropdown" }, _this.props, { monthNames, onChange: _this.onChange, onCancel: _this.toggleDropdown }));
      };
      _this.renderScrollMode = function(monthNames) {
        var dropdownVisible = _this.state.dropdownVisible;
        var result = [_this.renderReadView(!dropdownVisible, monthNames)];
        if (dropdownVisible) {
          result.unshift(_this.renderDropdown(monthNames));
        }
        return result;
      };
      _this.onChange = function(month) {
        _this.toggleDropdown();
        if (month !== _this.props.month) {
          _this.props.onChange(month);
        }
      };
      _this.toggleDropdown = function() {
        return _this.setState({
          dropdownVisible: !_this.state.dropdownVisible
        });
      };
      return _this;
    }
    MonthDropdown2.prototype.render = function() {
      var _this = this;
      var monthNames = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11].map(this.props.useShortMonthInDropdown ? function(m2) {
        return getMonthShortInLocale(m2, _this.props.locale);
      } : function(m2) {
        return getMonthInLocale(m2, _this.props.locale);
      });
      var renderedDropdown;
      switch (this.props.dropdownMode) {
        case "scroll":
          renderedDropdown = this.renderScrollMode(monthNames);
          break;
        case "select":
          renderedDropdown = this.renderSelectMode(monthNames);
          break;
      }
      return React__default.createElement("div", { className: "react-datepicker__month-dropdown-container react-datepicker__month-dropdown-container--".concat(this.props.dropdownMode) }, renderedDropdown);
    };
    return MonthDropdown2;
  }(Component)
);
function generateMonthYears(minDate, maxDate) {
  var list = [];
  var currDate = getStartOfMonth(minDate);
  var lastDate = getStartOfMonth(maxDate);
  while (!isAfter(currDate, lastDate)) {
    list.push(newDate(currDate));
    currDate = addMonths(currDate, 1);
  }
  return list;
}
var MonthYearDropdownOptions = (
  /** @class */
  function(_super) {
    __extends(MonthYearDropdownOptions2, _super);
    function MonthYearDropdownOptions2(props) {
      var _this = _super.call(this, props) || this;
      _this.renderOptions = function() {
        return _this.state.monthYearsList.map(function(monthYear) {
          var monthYearPoint = getTime(monthYear);
          var isSameMonthYear = isSameYear(_this.props.date, monthYear) && isSameMonth(_this.props.date, monthYear);
          return React__default.createElement(
            "div",
            { className: isSameMonthYear ? "react-datepicker__month-year-option--selected_month-year" : "react-datepicker__month-year-option", key: monthYearPoint, onClick: _this.onChange.bind(_this, monthYearPoint), "aria-selected": isSameMonthYear ? "true" : void 0 },
            isSameMonthYear ? React__default.createElement("span", { className: "react-datepicker__month-year-option--selected" }, "✓") : "",
            formatDate(monthYear, _this.props.dateFormat, _this.props.locale)
          );
        });
      };
      _this.onChange = function(monthYear) {
        return _this.props.onChange(monthYear);
      };
      _this.handleClickOutside = function() {
        _this.props.onCancel();
      };
      _this.state = {
        monthYearsList: generateMonthYears(_this.props.minDate, _this.props.maxDate)
      };
      return _this;
    }
    MonthYearDropdownOptions2.prototype.render = function() {
      var dropdownClass = clsx({
        "react-datepicker__month-year-dropdown": true,
        "react-datepicker__month-year-dropdown--scrollable": this.props.scrollableMonthYearDropdown
      });
      return React__default.createElement(ClickOutsideWrapper, { className: dropdownClass, onClickOutside: this.handleClickOutside }, this.renderOptions());
    };
    return MonthYearDropdownOptions2;
  }(Component)
);
var MonthYearDropdown = (
  /** @class */
  function(_super) {
    __extends(MonthYearDropdown2, _super);
    function MonthYearDropdown2() {
      var _this = _super !== null && _super.apply(this, arguments) || this;
      _this.state = {
        dropdownVisible: false
      };
      _this.renderSelectOptions = function() {
        var currDate = getStartOfMonth(_this.props.minDate);
        var lastDate = getStartOfMonth(_this.props.maxDate);
        var options2 = [];
        while (!isAfter(currDate, lastDate)) {
          var timePoint = getTime(currDate);
          options2.push(React__default.createElement("option", { key: timePoint, value: timePoint }, formatDate(currDate, _this.props.dateFormat, _this.props.locale)));
          currDate = addMonths(currDate, 1);
        }
        return options2;
      };
      _this.onSelectChange = function(event) {
        _this.onChange(parseInt(event.target.value));
      };
      _this.renderSelectMode = function() {
        return React__default.createElement("select", { value: getTime(getStartOfMonth(_this.props.date)), className: "react-datepicker__month-year-select", onChange: _this.onSelectChange }, _this.renderSelectOptions());
      };
      _this.renderReadView = function(visible) {
        var yearMonth = formatDate(_this.props.date, _this.props.dateFormat, _this.props.locale);
        return React__default.createElement(
          "div",
          { key: "read", style: { visibility: visible ? "visible" : "hidden" }, className: "react-datepicker__month-year-read-view", onClick: _this.toggleDropdown },
          React__default.createElement("span", { className: "react-datepicker__month-year-read-view--down-arrow" }),
          React__default.createElement("span", { className: "react-datepicker__month-year-read-view--selected-month-year" }, yearMonth)
        );
      };
      _this.renderDropdown = function() {
        return React__default.createElement(MonthYearDropdownOptions, _assign({ key: "dropdown" }, _this.props, { onChange: _this.onChange, onCancel: _this.toggleDropdown }));
      };
      _this.renderScrollMode = function() {
        var dropdownVisible = _this.state.dropdownVisible;
        var result = [_this.renderReadView(!dropdownVisible)];
        if (dropdownVisible) {
          result.unshift(_this.renderDropdown());
        }
        return result;
      };
      _this.onChange = function(monthYearPoint) {
        _this.toggleDropdown();
        var changedDate = newDate(monthYearPoint);
        if (isSameYear(_this.props.date, changedDate) && isSameMonth(_this.props.date, changedDate)) {
          return;
        }
        _this.props.onChange(changedDate);
      };
      _this.toggleDropdown = function() {
        return _this.setState({
          dropdownVisible: !_this.state.dropdownVisible
        });
      };
      return _this;
    }
    MonthYearDropdown2.prototype.render = function() {
      var renderedDropdown;
      switch (this.props.dropdownMode) {
        case "scroll":
          renderedDropdown = this.renderScrollMode();
          break;
        case "select":
          renderedDropdown = this.renderSelectMode();
          break;
      }
      return React__default.createElement("div", { className: "react-datepicker__month-year-dropdown-container react-datepicker__month-year-dropdown-container--".concat(this.props.dropdownMode) }, renderedDropdown);
    };
    return MonthYearDropdown2;
  }(Component)
);
var Time = (
  /** @class */
  function(_super) {
    __extends(Time2, _super);
    function Time2() {
      var _this = _super !== null && _super.apply(this, arguments) || this;
      _this.state = {
        height: null
      };
      _this.scrollToTheSelectedTime = function() {
        requestAnimationFrame(function() {
          var _a2, _b, _c;
          if (!_this.list)
            return;
          _this.list.scrollTop = (_c = _this.centerLi && Time2.calcCenterPosition(_this.props.monthRef ? _this.props.monthRef.clientHeight - ((_b = (_a2 = _this.header) === null || _a2 === void 0 ? void 0 : _a2.clientHeight) !== null && _b !== void 0 ? _b : 0) : _this.list.clientHeight, _this.centerLi)) !== null && _c !== void 0 ? _c : 0;
        });
      };
      _this.handleClick = function(time) {
        var _a2, _b;
        if ((_this.props.minTime || _this.props.maxTime) && isTimeInDisabledRange(time, _this.props) || (_this.props.excludeTimes || _this.props.includeTimes || _this.props.filterTime) && isTimeDisabled(time, _this.props)) {
          return;
        }
        (_b = (_a2 = _this.props).onChange) === null || _b === void 0 ? void 0 : _b.call(_a2, time);
      };
      _this.isSelectedTime = function(time) {
        return _this.props.selected && isSameMinute(_this.props.selected, time);
      };
      _this.isDisabledTime = function(time) {
        return (_this.props.minTime || _this.props.maxTime) && isTimeInDisabledRange(time, _this.props) || (_this.props.excludeTimes || _this.props.includeTimes || _this.props.filterTime) && isTimeDisabled(time, _this.props);
      };
      _this.liClasses = function(time) {
        var _a2;
        var classes = [
          "react-datepicker__time-list-item",
          _this.props.timeClassName ? _this.props.timeClassName(time) : void 0
        ];
        if (_this.isSelectedTime(time)) {
          classes.push("react-datepicker__time-list-item--selected");
        }
        if (_this.isDisabledTime(time)) {
          classes.push("react-datepicker__time-list-item--disabled");
        }
        if (_this.props.injectTimes && (getHours(time) * 3600 + getMinutes(time) * 60 + getSeconds(time)) % (((_a2 = _this.props.intervals) !== null && _a2 !== void 0 ? _a2 : Time2.defaultProps.intervals) * 60) !== 0) {
          classes.push("react-datepicker__time-list-item--injected");
        }
        return classes.join(" ");
      };
      _this.handleOnKeyDown = function(event, time) {
        var _a2, _b;
        if (event.key === KeyType.Space) {
          event.preventDefault();
          event.key = KeyType.Enter;
        }
        if ((event.key === KeyType.ArrowUp || event.key === KeyType.ArrowLeft) && event.target instanceof HTMLElement && event.target.previousSibling) {
          event.preventDefault();
          event.target.previousSibling instanceof HTMLElement && event.target.previousSibling.focus();
        }
        if ((event.key === KeyType.ArrowDown || event.key === KeyType.ArrowRight) && event.target instanceof HTMLElement && event.target.nextSibling) {
          event.preventDefault();
          event.target.nextSibling instanceof HTMLElement && event.target.nextSibling.focus();
        }
        if (event.key === KeyType.Enter) {
          _this.handleClick(time);
        }
        (_b = (_a2 = _this.props).handleOnKeyDown) === null || _b === void 0 ? void 0 : _b.call(_a2, event);
      };
      _this.renderTimes = function() {
        var _a2;
        var times = [];
        var format2 = typeof _this.props.format === "string" ? _this.props.format : "p";
        var intervals = (_a2 = _this.props.intervals) !== null && _a2 !== void 0 ? _a2 : Time2.defaultProps.intervals;
        var activeDate = _this.props.selected || _this.props.openToDate || newDate();
        var base = getStartOfDay(activeDate);
        var sortedInjectTimes = _this.props.injectTimes && _this.props.injectTimes.sort(function(a2, b2) {
          return a2.getTime() - b2.getTime();
        });
        var minutesInDay = 60 * getHoursInDay(activeDate);
        var multiplier = minutesInDay / intervals;
        for (var i = 0; i < multiplier; i++) {
          var currentTime = addMinutes(base, i * intervals);
          times.push(currentTime);
          if (sortedInjectTimes) {
            var timesToInject = timesToInjectAfter(base, currentTime, i, intervals, sortedInjectTimes);
            times = times.concat(timesToInject);
          }
        }
        var timeToFocus = times.reduce(function(prev2, time) {
          if (time.getTime() <= activeDate.getTime()) {
            return time;
          }
          return prev2;
        }, times[0]);
        return times.map(function(time) {
          return React__default.createElement("li", { key: time.valueOf(), onClick: _this.handleClick.bind(_this, time), className: _this.liClasses(time), ref: function(li) {
            if (time === timeToFocus) {
              _this.centerLi = li;
            }
          }, onKeyDown: function(event) {
            _this.handleOnKeyDown(event, time);
          }, tabIndex: time === timeToFocus ? 0 : -1, role: "option", "aria-selected": _this.isSelectedTime(time) ? "true" : void 0, "aria-disabled": _this.isDisabledTime(time) ? "true" : void 0 }, formatDate(time, format2, _this.props.locale));
        });
      };
      _this.renderTimeCaption = function() {
        if (_this.props.showTimeCaption === false) {
          return React__default.createElement(React__default.Fragment, null);
        }
        return React__default.createElement(
          "div",
          { className: "react-datepicker__header react-datepicker__header--time ".concat(_this.props.showTimeSelectOnly ? "react-datepicker__header--time--only" : ""), ref: function(header) {
            _this.header = header;
          } },
          React__default.createElement("div", { className: "react-datepicker-time__header" }, _this.props.timeCaption)
        );
      };
      return _this;
    }
    Object.defineProperty(Time2, "defaultProps", {
      get: function() {
        return {
          intervals: 30,
          todayButton: null,
          timeCaption: "Time",
          showTimeCaption: true
        };
      },
      enumerable: false,
      configurable: true
    });
    Time2.prototype.componentDidMount = function() {
      this.scrollToTheSelectedTime();
      if (this.props.monthRef && this.header) {
        this.setState({
          height: this.props.monthRef.clientHeight - this.header.clientHeight
        });
      }
    };
    Time2.prototype.render = function() {
      var _this = this;
      var _a2;
      var height2 = this.state.height;
      return React__default.createElement(
        "div",
        { className: "react-datepicker__time-container ".concat(((_a2 = this.props.todayButton) !== null && _a2 !== void 0 ? _a2 : Time2.defaultProps.todayButton) ? "react-datepicker__time-container--with-today-button" : "") },
        this.renderTimeCaption(),
        React__default.createElement(
          "div",
          { className: "react-datepicker__time" },
          React__default.createElement(
            "div",
            { className: "react-datepicker__time-box" },
            React__default.createElement("ul", { className: "react-datepicker__time-list", ref: function(list) {
              _this.list = list;
            }, style: height2 ? { height: height2 } : {}, role: "listbox", "aria-label": this.props.timeCaption }, this.renderTimes())
          )
        )
      );
    };
    Time2.calcCenterPosition = function(listHeight, centerLiRef) {
      return centerLiRef.offsetTop - (listHeight / 2 - centerLiRef.clientHeight / 2);
    };
    return Time2;
  }(Component)
);
var VERTICAL_NAVIGATION_OFFSET = 3;
var Year = (
  /** @class */
  function(_super) {
    __extends(Year2, _super);
    function Year2(props) {
      var _this = _super.call(this, props) || this;
      _this.YEAR_REFS = __spreadArray([], Array(_this.props.yearItemNumber), true).map(function() {
        return createRef();
      });
      _this.isDisabled = function(date) {
        return isDayDisabled(date, {
          minDate: _this.props.minDate,
          maxDate: _this.props.maxDate,
          excludeDates: _this.props.excludeDates,
          includeDates: _this.props.includeDates,
          filterDate: _this.props.filterDate
        });
      };
      _this.isExcluded = function(date) {
        return isDayExcluded(date, {
          excludeDates: _this.props.excludeDates
        });
      };
      _this.selectingDate = function() {
        var _a2;
        return (_a2 = _this.props.selectingDate) !== null && _a2 !== void 0 ? _a2 : _this.props.preSelection;
      };
      _this.updateFocusOnPaginate = function(refIndex) {
        var waitForReRender = function() {
          var _a2, _b;
          (_b = (_a2 = _this.YEAR_REFS[refIndex]) === null || _a2 === void 0 ? void 0 : _a2.current) === null || _b === void 0 ? void 0 : _b.focus();
        };
        window.requestAnimationFrame(waitForReRender);
      };
      _this.handleYearClick = function(day, event) {
        if (_this.props.onDayClick) {
          _this.props.onDayClick(day, event);
        }
      };
      _this.handleYearNavigation = function(newYear, newDate2) {
        var _a2, _b, _c, _d;
        var _e = _this.props, date = _e.date, yearItemNumber = _e.yearItemNumber;
        if (date === void 0 || yearItemNumber === void 0) {
          return;
        }
        var startPeriod = getYearsPeriod(date, yearItemNumber).startPeriod;
        if (_this.isDisabled(newDate2) || _this.isExcluded(newDate2)) {
          return;
        }
        (_b = (_a2 = _this.props).setPreSelection) === null || _b === void 0 ? void 0 : _b.call(_a2, newDate2);
        if (newYear - startPeriod < 0) {
          _this.updateFocusOnPaginate(yearItemNumber - (startPeriod - newYear));
        } else if (newYear - startPeriod >= yearItemNumber) {
          _this.updateFocusOnPaginate(Math.abs(yearItemNumber - (newYear - startPeriod)));
        } else
          (_d = (_c = _this.YEAR_REFS[newYear - startPeriod]) === null || _c === void 0 ? void 0 : _c.current) === null || _d === void 0 ? void 0 : _d.focus();
      };
      _this.isSameDay = function(y2, other) {
        return isSameDay(y2, other);
      };
      _this.isCurrentYear = function(y2) {
        return y2 === getYear(newDate());
      };
      _this.isRangeStart = function(y2) {
        return _this.props.startDate && _this.props.endDate && isSameYear(setYear(newDate(), y2), _this.props.startDate);
      };
      _this.isRangeEnd = function(y2) {
        return _this.props.startDate && _this.props.endDate && isSameYear(setYear(newDate(), y2), _this.props.endDate);
      };
      _this.isInRange = function(y2) {
        return isYearInRange(y2, _this.props.startDate, _this.props.endDate);
      };
      _this.isInSelectingRange = function(y2) {
        var _a2 = _this.props, selectsStart = _a2.selectsStart, selectsEnd = _a2.selectsEnd, selectsRange = _a2.selectsRange, startDate = _a2.startDate, endDate = _a2.endDate;
        if (!(selectsStart || selectsEnd || selectsRange) || !_this.selectingDate()) {
          return false;
        }
        if (selectsStart && endDate) {
          return isYearInRange(y2, _this.selectingDate(), endDate);
        }
        if (selectsEnd && startDate) {
          return isYearInRange(y2, startDate, _this.selectingDate());
        }
        if (selectsRange && startDate && !endDate) {
          return isYearInRange(y2, startDate, _this.selectingDate());
        }
        return false;
      };
      _this.isSelectingRangeStart = function(y2) {
        var _a2;
        if (!_this.isInSelectingRange(y2)) {
          return false;
        }
        var _b = _this.props, startDate = _b.startDate, selectsStart = _b.selectsStart;
        var _year = setYear(newDate(), y2);
        if (selectsStart) {
          return isSameYear(_year, (_a2 = _this.selectingDate()) !== null && _a2 !== void 0 ? _a2 : null);
        }
        return isSameYear(_year, startDate !== null && startDate !== void 0 ? startDate : null);
      };
      _this.isSelectingRangeEnd = function(y2) {
        var _a2;
        if (!_this.isInSelectingRange(y2)) {
          return false;
        }
        var _b = _this.props, endDate = _b.endDate, selectsEnd = _b.selectsEnd, selectsRange = _b.selectsRange;
        var _year = setYear(newDate(), y2);
        if (selectsEnd || selectsRange) {
          return isSameYear(_year, (_a2 = _this.selectingDate()) !== null && _a2 !== void 0 ? _a2 : null);
        }
        return isSameYear(_year, endDate !== null && endDate !== void 0 ? endDate : null);
      };
      _this.isKeyboardSelected = function(y2) {
        if (_this.props.date === void 0 || _this.props.selected == null || _this.props.preSelection == null) {
          return;
        }
        var _a2 = _this.props, minDate = _a2.minDate, maxDate = _a2.maxDate, excludeDates = _a2.excludeDates, includeDates = _a2.includeDates, filterDate = _a2.filterDate;
        var date = getStartOfYear(setYear(_this.props.date, y2));
        var isDisabled = (minDate || maxDate || excludeDates || includeDates || filterDate) && isYearDisabled(y2, _this.props);
        return !_this.props.disabledKeyboardNavigation && !_this.props.inline && !isSameDay(date, getStartOfYear(_this.props.selected)) && isSameDay(date, getStartOfYear(_this.props.preSelection)) && !isDisabled;
      };
      _this.onYearClick = function(event, y2) {
        var date = _this.props.date;
        if (date === void 0) {
          return;
        }
        _this.handleYearClick(getStartOfYear(setYear(date, y2)), event);
      };
      _this.onYearKeyDown = function(event, y2) {
        var _a2, _b;
        var key = event.key;
        var _c = _this.props, date = _c.date, yearItemNumber = _c.yearItemNumber, handleOnKeyDown = _c.handleOnKeyDown;
        if (key !== KeyType.Tab) {
          event.preventDefault();
        }
        if (!_this.props.disabledKeyboardNavigation) {
          switch (key) {
            case KeyType.Enter:
              if (_this.props.selected == null) {
                break;
              }
              _this.onYearClick(event, y2);
              (_b = (_a2 = _this.props).setPreSelection) === null || _b === void 0 ? void 0 : _b.call(_a2, _this.props.selected);
              break;
            case KeyType.ArrowRight:
              if (_this.props.preSelection == null) {
                break;
              }
              _this.handleYearNavigation(y2 + 1, addYears(_this.props.preSelection, 1));
              break;
            case KeyType.ArrowLeft:
              if (_this.props.preSelection == null) {
                break;
              }
              _this.handleYearNavigation(y2 - 1, subYears(_this.props.preSelection, 1));
              break;
            case KeyType.ArrowUp: {
              if (date === void 0 || yearItemNumber === void 0 || _this.props.preSelection == null) {
                break;
              }
              var startPeriod = getYearsPeriod(date, yearItemNumber).startPeriod;
              var offset2 = VERTICAL_NAVIGATION_OFFSET;
              var newYear = y2 - offset2;
              if (newYear < startPeriod) {
                var leftOverOffset = yearItemNumber % offset2;
                if (y2 >= startPeriod && y2 < startPeriod + leftOverOffset) {
                  offset2 = leftOverOffset;
                } else {
                  offset2 += leftOverOffset;
                }
                newYear = y2 - offset2;
              }
              _this.handleYearNavigation(newYear, subYears(_this.props.preSelection, offset2));
              break;
            }
            case KeyType.ArrowDown: {
              if (date === void 0 || yearItemNumber === void 0 || _this.props.preSelection == null) {
                break;
              }
              var endPeriod = getYearsPeriod(date, yearItemNumber).endPeriod;
              var offset2 = VERTICAL_NAVIGATION_OFFSET;
              var newYear = y2 + offset2;
              if (newYear > endPeriod) {
                var leftOverOffset = yearItemNumber % offset2;
                if (y2 <= endPeriod && y2 > endPeriod - leftOverOffset) {
                  offset2 = leftOverOffset;
                } else {
                  offset2 += leftOverOffset;
                }
                newYear = y2 + offset2;
              }
              _this.handleYearNavigation(newYear, addYears(_this.props.preSelection, offset2));
              break;
            }
          }
        }
        handleOnKeyDown && handleOnKeyDown(event);
      };
      _this.getYearClassNames = function(y2) {
        var _a2 = _this.props, date = _a2.date, minDate = _a2.minDate, maxDate = _a2.maxDate, selected = _a2.selected, excludeDates = _a2.excludeDates, includeDates = _a2.includeDates, filterDate = _a2.filterDate, yearClassName = _a2.yearClassName;
        return clsx("react-datepicker__year-text", "react-datepicker__year-".concat(y2), date ? yearClassName === null || yearClassName === void 0 ? void 0 : yearClassName(setYear(date, y2)) : void 0, {
          "react-datepicker__year-text--selected": selected ? y2 === getYear(selected) : void 0,
          "react-datepicker__year-text--disabled": (minDate || maxDate || excludeDates || includeDates || filterDate) && isYearDisabled(y2, _this.props),
          "react-datepicker__year-text--keyboard-selected": _this.isKeyboardSelected(y2),
          "react-datepicker__year-text--range-start": _this.isRangeStart(y2),
          "react-datepicker__year-text--range-end": _this.isRangeEnd(y2),
          "react-datepicker__year-text--in-range": _this.isInRange(y2),
          "react-datepicker__year-text--in-selecting-range": _this.isInSelectingRange(y2),
          "react-datepicker__year-text--selecting-range-start": _this.isSelectingRangeStart(y2),
          "react-datepicker__year-text--selecting-range-end": _this.isSelectingRangeEnd(y2),
          "react-datepicker__year-text--today": _this.isCurrentYear(y2)
        });
      };
      _this.getYearTabIndex = function(y2) {
        if (_this.props.disabledKeyboardNavigation || _this.props.preSelection == null) {
          return "-1";
        }
        var preSelected = getYear(_this.props.preSelection);
        var isPreSelectedYearDisabled = isYearDisabled(y2, _this.props);
        return y2 === preSelected && !isPreSelectedYearDisabled ? "0" : "-1";
      };
      _this.getYearContent = function(y2) {
        return _this.props.renderYearContent ? _this.props.renderYearContent(y2) : y2;
      };
      return _this;
    }
    Year2.prototype.render = function() {
      var _this = this;
      var yearsList = [];
      var _a2 = this.props, date = _a2.date, yearItemNumber = _a2.yearItemNumber, onYearMouseEnter = _a2.onYearMouseEnter, onYearMouseLeave = _a2.onYearMouseLeave;
      if (date === void 0) {
        return null;
      }
      var _b = getYearsPeriod(date, yearItemNumber), startPeriod = _b.startPeriod, endPeriod = _b.endPeriod;
      var _loop_1 = function(y3) {
        yearsList.push(React__default.createElement("div", { ref: this_1.YEAR_REFS[y3 - startPeriod], onClick: function(event) {
          _this.onYearClick(event, y3);
        }, onKeyDown: function(event) {
          if (isSpaceKeyDown(event)) {
            event.preventDefault();
            event.key = KeyType.Enter;
          }
          _this.onYearKeyDown(event, y3);
        }, tabIndex: Number(this_1.getYearTabIndex(y3)), className: this_1.getYearClassNames(y3), onMouseEnter: !this_1.props.usePointerEvent ? function(event) {
          return onYearMouseEnter(event, y3);
        } : void 0, onPointerEnter: this_1.props.usePointerEvent ? function(event) {
          return onYearMouseEnter(event, y3);
        } : void 0, onMouseLeave: !this_1.props.usePointerEvent ? function(event) {
          return onYearMouseLeave(event, y3);
        } : void 0, onPointerLeave: this_1.props.usePointerEvent ? function(event) {
          return onYearMouseLeave(event, y3);
        } : void 0, key: y3, "aria-current": this_1.isCurrentYear(y3) ? "date" : void 0 }, this_1.getYearContent(y3)));
      };
      var this_1 = this;
      for (var y2 = startPeriod; y2 <= endPeriod; y2++) {
        _loop_1(y2);
      }
      return React__default.createElement(
        "div",
        { className: "react-datepicker__year" },
        React__default.createElement("div", { className: "react-datepicker__year-wrapper", onMouseLeave: !this.props.usePointerEvent ? this.props.clearSelectingDate : void 0, onPointerLeave: this.props.usePointerEvent ? this.props.clearSelectingDate : void 0 }, yearsList)
      );
    };
    return Year2;
  }(Component)
);
function generateYears(year, noOfYear, minDate, maxDate) {
  var list = [];
  for (var i = 0; i < 2 * noOfYear + 1; i++) {
    var newYear = year + noOfYear - i;
    var isInRange = true;
    if (minDate) {
      isInRange = getYear(minDate) <= newYear;
    }
    if (maxDate && isInRange) {
      isInRange = getYear(maxDate) >= newYear;
    }
    if (isInRange) {
      list.push(newYear);
    }
  }
  return list;
}
var YearDropdownOptions = (
  /** @class */
  function(_super) {
    __extends(YearDropdownOptions2, _super);
    function YearDropdownOptions2(props) {
      var _this = _super.call(this, props) || this;
      _this.renderOptions = function() {
        var selectedYear = _this.props.year;
        var options2 = _this.state.yearsList.map(function(year) {
          return React__default.createElement(
            "div",
            { className: selectedYear === year ? "react-datepicker__year-option react-datepicker__year-option--selected_year" : "react-datepicker__year-option", key: year, onClick: _this.onChange.bind(_this, year), "aria-selected": selectedYear === year ? "true" : void 0 },
            selectedYear === year ? React__default.createElement("span", { className: "react-datepicker__year-option--selected" }, "✓") : "",
            year
          );
        });
        var minYear = _this.props.minDate ? getYear(_this.props.minDate) : null;
        var maxYear = _this.props.maxDate ? getYear(_this.props.maxDate) : null;
        if (!maxYear || !_this.state.yearsList.find(function(year) {
          return year === maxYear;
        })) {
          options2.unshift(React__default.createElement(
            "div",
            { className: "react-datepicker__year-option", key: "upcoming", onClick: _this.incrementYears },
            React__default.createElement("a", { className: "react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-upcoming" })
          ));
        }
        if (!minYear || !_this.state.yearsList.find(function(year) {
          return year === minYear;
        })) {
          options2.push(React__default.createElement(
            "div",
            { className: "react-datepicker__year-option", key: "previous", onClick: _this.decrementYears },
            React__default.createElement("a", { className: "react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-previous" })
          ));
        }
        return options2;
      };
      _this.onChange = function(year) {
        _this.props.onChange(year);
      };
      _this.handleClickOutside = function() {
        _this.props.onCancel();
      };
      _this.shiftYears = function(amount) {
        var years = _this.state.yearsList.map(function(year) {
          return year + amount;
        });
        _this.setState({
          yearsList: years
        });
      };
      _this.incrementYears = function() {
        return _this.shiftYears(1);
      };
      _this.decrementYears = function() {
        return _this.shiftYears(-1);
      };
      var yearDropdownItemNumber = props.yearDropdownItemNumber, scrollableYearDropdown = props.scrollableYearDropdown;
      var noOfYear = yearDropdownItemNumber || (scrollableYearDropdown ? 10 : 5);
      _this.state = {
        yearsList: generateYears(_this.props.year, noOfYear, _this.props.minDate, _this.props.maxDate)
      };
      _this.dropdownRef = createRef();
      return _this;
    }
    YearDropdownOptions2.prototype.componentDidMount = function() {
      var dropdownCurrent = this.dropdownRef.current;
      if (dropdownCurrent) {
        var dropdownCurrentChildren = dropdownCurrent.children ? Array.from(dropdownCurrent.children) : null;
        var selectedYearOptionEl = dropdownCurrentChildren ? dropdownCurrentChildren.find(function(childEl) {
          return childEl.ariaSelected;
        }) : null;
        dropdownCurrent.scrollTop = selectedYearOptionEl && selectedYearOptionEl instanceof HTMLElement ? selectedYearOptionEl.offsetTop + (selectedYearOptionEl.clientHeight - dropdownCurrent.clientHeight) / 2 : (dropdownCurrent.scrollHeight - dropdownCurrent.clientHeight) / 2;
      }
    };
    YearDropdownOptions2.prototype.render = function() {
      var dropdownClass = clsx({
        "react-datepicker__year-dropdown": true,
        "react-datepicker__year-dropdown--scrollable": this.props.scrollableYearDropdown
      });
      return React__default.createElement(ClickOutsideWrapper, { className: dropdownClass, containerRef: this.dropdownRef, onClickOutside: this.handleClickOutside }, this.renderOptions());
    };
    return YearDropdownOptions2;
  }(Component)
);
var YearDropdown = (
  /** @class */
  function(_super) {
    __extends(YearDropdown2, _super);
    function YearDropdown2() {
      var _this = _super !== null && _super.apply(this, arguments) || this;
      _this.state = {
        dropdownVisible: false
      };
      _this.renderSelectOptions = function() {
        var minYear = _this.props.minDate ? getYear(_this.props.minDate) : 1900;
        var maxYear = _this.props.maxDate ? getYear(_this.props.maxDate) : 2100;
        var options2 = [];
        for (var i = minYear; i <= maxYear; i++) {
          options2.push(React__default.createElement("option", { key: i, value: i }, i));
        }
        return options2;
      };
      _this.onSelectChange = function(event) {
        _this.onChange(parseInt(event.target.value));
      };
      _this.renderSelectMode = function() {
        return React__default.createElement("select", { value: _this.props.year, className: "react-datepicker__year-select", onChange: _this.onSelectChange }, _this.renderSelectOptions());
      };
      _this.renderReadView = function(visible) {
        return React__default.createElement(
          "div",
          { key: "read", style: { visibility: visible ? "visible" : "hidden" }, className: "react-datepicker__year-read-view", onClick: function(event) {
            return _this.toggleDropdown(event);
          } },
          React__default.createElement("span", { className: "react-datepicker__year-read-view--down-arrow" }),
          React__default.createElement("span", { className: "react-datepicker__year-read-view--selected-year" }, _this.props.year)
        );
      };
      _this.renderDropdown = function() {
        return React__default.createElement(YearDropdownOptions, _assign({ key: "dropdown" }, _this.props, { onChange: _this.onChange, onCancel: _this.toggleDropdown }));
      };
      _this.renderScrollMode = function() {
        var dropdownVisible = _this.state.dropdownVisible;
        var result = [_this.renderReadView(!dropdownVisible)];
        if (dropdownVisible) {
          result.unshift(_this.renderDropdown());
        }
        return result;
      };
      _this.onChange = function(year) {
        _this.toggleDropdown();
        if (year === _this.props.year)
          return;
        _this.props.onChange(year);
      };
      _this.toggleDropdown = function(event) {
        _this.setState({
          dropdownVisible: !_this.state.dropdownVisible
        }, function() {
          if (_this.props.adjustDateOnChange) {
            _this.handleYearChange(_this.props.date, event);
          }
        });
      };
      _this.handleYearChange = function(date, event) {
        var _a2;
        (_a2 = _this.onSelect) === null || _a2 === void 0 ? void 0 : _a2.call(_this, date, event);
        _this.setOpen();
      };
      _this.onSelect = function(date, event) {
        var _a2, _b;
        (_b = (_a2 = _this.props).onSelect) === null || _b === void 0 ? void 0 : _b.call(_a2, date, event);
      };
      _this.setOpen = function() {
        var _a2, _b;
        (_b = (_a2 = _this.props).setOpen) === null || _b === void 0 ? void 0 : _b.call(_a2, true);
      };
      return _this;
    }
    YearDropdown2.prototype.render = function() {
      var renderedDropdown;
      switch (this.props.dropdownMode) {
        case "scroll":
          renderedDropdown = this.renderScrollMode();
          break;
        case "select":
          renderedDropdown = this.renderSelectMode();
          break;
      }
      return React__default.createElement("div", { className: "react-datepicker__year-dropdown-container react-datepicker__year-dropdown-container--".concat(this.props.dropdownMode) }, renderedDropdown);
    };
    return YearDropdown2;
  }(Component)
);
var DROPDOWN_FOCUS_CLASSNAMES = [
  "react-datepicker__year-select",
  "react-datepicker__month-select",
  "react-datepicker__month-year-select"
];
var isDropdownSelect = function(element) {
  var classNames2 = (element.className || "").split(/\s+/);
  return DROPDOWN_FOCUS_CLASSNAMES.some(function(testClassname) {
    return classNames2.indexOf(testClassname) >= 0;
  });
};
var Calendar = (
  /** @class */
  function(_super) {
    __extends(Calendar2, _super);
    function Calendar2(props) {
      var _this = _super.call(this, props) || this;
      _this.monthContainer = void 0;
      _this.handleClickOutside = function(event) {
        _this.props.onClickOutside(event);
      };
      _this.setClickOutsideRef = function() {
        return _this.containerRef.current;
      };
      _this.handleDropdownFocus = function(event) {
        var _a2, _b;
        if (isDropdownSelect(event.target)) {
          (_b = (_a2 = _this.props).onDropdownFocus) === null || _b === void 0 ? void 0 : _b.call(_a2, event);
        }
      };
      _this.getDateInView = function() {
        var _a2 = _this.props, preSelection = _a2.preSelection, selected = _a2.selected, openToDate = _a2.openToDate;
        var minDate = getEffectiveMinDate(_this.props);
        var maxDate = getEffectiveMaxDate(_this.props);
        var current = newDate();
        var initialDate = openToDate || selected || preSelection;
        if (initialDate) {
          return initialDate;
        } else {
          if (minDate && isBefore(current, minDate)) {
            return minDate;
          } else if (maxDate && isAfter(current, maxDate)) {
            return maxDate;
          }
        }
        return current;
      };
      _this.increaseMonth = function() {
        _this.setState(function(_a2) {
          var date = _a2.date;
          return {
            date: addMonths(date, 1)
          };
        }, function() {
          return _this.handleMonthChange(_this.state.date);
        });
      };
      _this.decreaseMonth = function() {
        _this.setState(function(_a2) {
          var date = _a2.date;
          return {
            date: subMonths(date, 1)
          };
        }, function() {
          return _this.handleMonthChange(_this.state.date);
        });
      };
      _this.handleDayClick = function(day, event, monthSelectedIn) {
        _this.props.onSelect(day, event, monthSelectedIn);
        _this.props.setPreSelection && _this.props.setPreSelection(day);
      };
      _this.handleDayMouseEnter = function(day) {
        _this.setState({ selectingDate: day });
        _this.props.onDayMouseEnter && _this.props.onDayMouseEnter(day);
      };
      _this.handleMonthMouseLeave = function() {
        _this.setState({ selectingDate: void 0 });
        _this.props.onMonthMouseLeave && _this.props.onMonthMouseLeave();
      };
      _this.handleYearMouseEnter = function(event, year) {
        _this.setState({ selectingDate: setYear(newDate(), year) });
        !!_this.props.onYearMouseEnter && _this.props.onYearMouseEnter(event, year);
      };
      _this.handleYearMouseLeave = function(event, year) {
        !!_this.props.onYearMouseLeave && _this.props.onYearMouseLeave(event, year);
      };
      _this.handleYearChange = function(date) {
        var _a2, _b, _c, _d;
        (_b = (_a2 = _this.props).onYearChange) === null || _b === void 0 ? void 0 : _b.call(_a2, date);
        _this.setState({ isRenderAriaLiveMessage: true });
        if (_this.props.adjustDateOnChange) {
          _this.props.onSelect(date);
          (_d = (_c = _this.props).setOpen) === null || _d === void 0 ? void 0 : _d.call(_c, true);
        }
        _this.props.setPreSelection && _this.props.setPreSelection(date);
      };
      _this.getEnabledPreSelectionDateForMonth = function(date) {
        if (!isDayDisabled(date, _this.props)) {
          return date;
        }
        var startOfMonth2 = getStartOfMonth(date);
        var endOfMonth2 = getEndOfMonth(date);
        var totalDays = differenceInDays(endOfMonth2, startOfMonth2);
        var preSelectedDate = null;
        for (var dayIdx = 0; dayIdx <= totalDays; dayIdx++) {
          var processingDate = addDays(startOfMonth2, dayIdx);
          if (!isDayDisabled(processingDate, _this.props)) {
            preSelectedDate = processingDate;
            break;
          }
        }
        return preSelectedDate;
      };
      _this.handleMonthChange = function(date) {
        var _a2, _b, _c;
        var enabledPreSelectionDate = (_a2 = _this.getEnabledPreSelectionDateForMonth(date)) !== null && _a2 !== void 0 ? _a2 : date;
        _this.handleCustomMonthChange(enabledPreSelectionDate);
        if (_this.props.adjustDateOnChange) {
          _this.props.onSelect(enabledPreSelectionDate);
          (_c = (_b = _this.props).setOpen) === null || _c === void 0 ? void 0 : _c.call(_b, true);
        }
        _this.props.setPreSelection && _this.props.setPreSelection(enabledPreSelectionDate);
      };
      _this.handleCustomMonthChange = function(date) {
        var _a2, _b;
        (_b = (_a2 = _this.props).onMonthChange) === null || _b === void 0 ? void 0 : _b.call(_a2, date);
        _this.setState({ isRenderAriaLiveMessage: true });
      };
      _this.handleMonthYearChange = function(date) {
        _this.handleYearChange(date);
        _this.handleMonthChange(date);
      };
      _this.changeYear = function(year) {
        _this.setState(function(_a2) {
          var date = _a2.date;
          return {
            date: setYear(date, Number(year))
          };
        }, function() {
          return _this.handleYearChange(_this.state.date);
        });
      };
      _this.changeMonth = function(month) {
        _this.setState(function(_a2) {
          var date = _a2.date;
          return {
            date: setMonth(date, Number(month))
          };
        }, function() {
          return _this.handleMonthChange(_this.state.date);
        });
      };
      _this.changeMonthYear = function(monthYear) {
        _this.setState(function(_a2) {
          var date = _a2.date;
          return {
            date: setYear(setMonth(date, getMonth(monthYear)), getYear(monthYear))
          };
        }, function() {
          return _this.handleMonthYearChange(_this.state.date);
        });
      };
      _this.header = function(date) {
        if (date === void 0) {
          date = _this.state.date;
        }
        var startOfWeek2 = getStartOfWeek(date, _this.props.locale, _this.props.calendarStartDay);
        var dayNames = [];
        if (_this.props.showWeekNumbers) {
          dayNames.push(React__default.createElement("div", { key: "W", className: "react-datepicker__day-name" }, _this.props.weekLabel || "#"));
        }
        return dayNames.concat([0, 1, 2, 3, 4, 5, 6].map(function(offset2) {
          var day = addDays(startOfWeek2, offset2);
          var weekDayName = _this.formatWeekday(day, _this.props.locale);
          var weekDayClassName = _this.props.weekDayClassName ? _this.props.weekDayClassName(day) : void 0;
          return React__default.createElement("div", { key: offset2, "aria-label": formatDate(day, "EEEE", _this.props.locale), className: clsx("react-datepicker__day-name", weekDayClassName) }, weekDayName);
        }));
      };
      _this.formatWeekday = function(day, locale) {
        if (_this.props.formatWeekDay) {
          return getFormattedWeekdayInLocale(day, _this.props.formatWeekDay, locale);
        }
        return _this.props.useWeekdaysShort ? getWeekdayShortInLocale(day, locale) : getWeekdayMinInLocale(day, locale);
      };
      _this.decreaseYear = function() {
        _this.setState(function(_a2) {
          var _b;
          var date = _a2.date;
          return {
            date: subYears(date, _this.props.showYearPicker ? (_b = _this.props.yearItemNumber) !== null && _b !== void 0 ? _b : Calendar2.defaultProps.yearItemNumber : 1)
          };
        }, function() {
          return _this.handleYearChange(_this.state.date);
        });
      };
      _this.clearSelectingDate = function() {
        _this.setState({ selectingDate: void 0 });
      };
      _this.renderPreviousButton = function() {
        var _a2, _b, _c;
        if (_this.props.renderCustomHeader) {
          return;
        }
        var monthsShown = (_a2 = _this.props.monthsShown) !== null && _a2 !== void 0 ? _a2 : Calendar2.defaultProps.monthsShown;
        var monthsToSubtract = _this.props.showPreviousMonths ? monthsShown - 1 : 0;
        var monthSelectedIn = (_b = _this.props.monthSelectedIn) !== null && _b !== void 0 ? _b : monthsToSubtract;
        var fromMonthDate = subMonths(_this.state.date, monthSelectedIn);
        var allPrevDaysDisabled;
        switch (true) {
          case _this.props.showMonthYearPicker:
            allPrevDaysDisabled = yearDisabledBefore(_this.state.date, _this.props);
            break;
          case _this.props.showYearPicker:
            allPrevDaysDisabled = yearsDisabledBefore(_this.state.date, _this.props);
            break;
          case _this.props.showQuarterYearPicker:
            allPrevDaysDisabled = quarterDisabledBefore(_this.state.date, _this.props);
            break;
          default:
            allPrevDaysDisabled = monthDisabledBefore(fromMonthDate, _this.props);
            break;
        }
        if (!((_c = _this.props.forceShowMonthNavigation) !== null && _c !== void 0 ? _c : Calendar2.defaultProps.forceShowMonthNavigation) && !_this.props.showDisabledMonthNavigation && allPrevDaysDisabled || _this.props.showTimeSelectOnly) {
          return;
        }
        var iconClasses = [
          "react-datepicker__navigation-icon",
          "react-datepicker__navigation-icon--previous"
        ];
        var classes = [
          "react-datepicker__navigation",
          "react-datepicker__navigation--previous"
        ];
        var clickHandler = _this.decreaseMonth;
        if (_this.props.showMonthYearPicker || _this.props.showQuarterYearPicker || _this.props.showYearPicker) {
          clickHandler = _this.decreaseYear;
        }
        if (allPrevDaysDisabled && _this.props.showDisabledMonthNavigation) {
          classes.push("react-datepicker__navigation--previous--disabled");
          clickHandler = void 0;
        }
        var isForYear = _this.props.showMonthYearPicker || _this.props.showQuarterYearPicker || _this.props.showYearPicker;
        var _d = _this.props, _e = _d.previousMonthButtonLabel, previousMonthButtonLabel = _e === void 0 ? Calendar2.defaultProps.previousMonthButtonLabel : _e, _f = _d.previousYearButtonLabel, previousYearButtonLabel = _f === void 0 ? Calendar2.defaultProps.previousYearButtonLabel : _f;
        var _g = _this.props, _h = _g.previousMonthAriaLabel, previousMonthAriaLabel = _h === void 0 ? typeof previousMonthButtonLabel === "string" ? previousMonthButtonLabel : "Previous Month" : _h, _j = _g.previousYearAriaLabel, previousYearAriaLabel = _j === void 0 ? typeof previousYearButtonLabel === "string" ? previousYearButtonLabel : "Previous Year" : _j;
        return React__default.createElement(
          "button",
          { type: "button", className: classes.join(" "), onClick: clickHandler, onKeyDown: _this.props.handleOnKeyDown, "aria-label": isForYear ? previousYearAriaLabel : previousMonthAriaLabel },
          React__default.createElement("span", { className: iconClasses.join(" ") }, isForYear ? previousYearButtonLabel : previousMonthButtonLabel)
        );
      };
      _this.increaseYear = function() {
        _this.setState(function(_a2) {
          var _b;
          var date = _a2.date;
          return {
            date: addYears(date, _this.props.showYearPicker ? (_b = _this.props.yearItemNumber) !== null && _b !== void 0 ? _b : Calendar2.defaultProps.yearItemNumber : 1)
          };
        }, function() {
          return _this.handleYearChange(_this.state.date);
        });
      };
      _this.renderNextButton = function() {
        var _a2;
        if (_this.props.renderCustomHeader) {
          return;
        }
        var allNextDaysDisabled;
        switch (true) {
          case _this.props.showMonthYearPicker:
            allNextDaysDisabled = yearDisabledAfter(_this.state.date, _this.props);
            break;
          case _this.props.showYearPicker:
            allNextDaysDisabled = yearsDisabledAfter(_this.state.date, _this.props);
            break;
          case _this.props.showQuarterYearPicker:
            allNextDaysDisabled = quarterDisabledAfter(_this.state.date, _this.props);
            break;
          default:
            allNextDaysDisabled = monthDisabledAfter(_this.state.date, _this.props);
            break;
        }
        if (!((_a2 = _this.props.forceShowMonthNavigation) !== null && _a2 !== void 0 ? _a2 : Calendar2.defaultProps.forceShowMonthNavigation) && !_this.props.showDisabledMonthNavigation && allNextDaysDisabled || _this.props.showTimeSelectOnly) {
          return;
        }
        var classes = [
          "react-datepicker__navigation",
          "react-datepicker__navigation--next"
        ];
        var iconClasses = [
          "react-datepicker__navigation-icon",
          "react-datepicker__navigation-icon--next"
        ];
        if (_this.props.showTimeSelect) {
          classes.push("react-datepicker__navigation--next--with-time");
        }
        if (_this.props.todayButton) {
          classes.push("react-datepicker__navigation--next--with-today-button");
        }
        var clickHandler = _this.increaseMonth;
        if (_this.props.showMonthYearPicker || _this.props.showQuarterYearPicker || _this.props.showYearPicker) {
          clickHandler = _this.increaseYear;
        }
        if (allNextDaysDisabled && _this.props.showDisabledMonthNavigation) {
          classes.push("react-datepicker__navigation--next--disabled");
          clickHandler = void 0;
        }
        var isForYear = _this.props.showMonthYearPicker || _this.props.showQuarterYearPicker || _this.props.showYearPicker;
        var _b = _this.props, _c = _b.nextMonthButtonLabel, nextMonthButtonLabel = _c === void 0 ? Calendar2.defaultProps.nextMonthButtonLabel : _c, _d = _b.nextYearButtonLabel, nextYearButtonLabel = _d === void 0 ? Calendar2.defaultProps.nextYearButtonLabel : _d;
        var _e = _this.props, _f = _e.nextMonthAriaLabel, nextMonthAriaLabel = _f === void 0 ? typeof nextMonthButtonLabel === "string" ? nextMonthButtonLabel : "Next Month" : _f, _g = _e.nextYearAriaLabel, nextYearAriaLabel = _g === void 0 ? typeof nextYearButtonLabel === "string" ? nextYearButtonLabel : "Next Year" : _g;
        return React__default.createElement(
          "button",
          { type: "button", className: classes.join(" "), onClick: clickHandler, onKeyDown: _this.props.handleOnKeyDown, "aria-label": isForYear ? nextYearAriaLabel : nextMonthAriaLabel },
          React__default.createElement("span", { className: iconClasses.join(" ") }, isForYear ? nextYearButtonLabel : nextMonthButtonLabel)
        );
      };
      _this.renderCurrentMonth = function(date) {
        if (date === void 0) {
          date = _this.state.date;
        }
        var classes = ["react-datepicker__current-month"];
        if (_this.props.showYearDropdown) {
          classes.push("react-datepicker__current-month--hasYearDropdown");
        }
        if (_this.props.showMonthDropdown) {
          classes.push("react-datepicker__current-month--hasMonthDropdown");
        }
        if (_this.props.showMonthYearDropdown) {
          classes.push("react-datepicker__current-month--hasMonthYearDropdown");
        }
        return React__default.createElement("h2", { className: classes.join(" ") }, formatDate(date, _this.props.dateFormat, _this.props.locale));
      };
      _this.renderYearDropdown = function(overrideHide) {
        if (overrideHide === void 0) {
          overrideHide = false;
        }
        if (!_this.props.showYearDropdown || overrideHide) {
          return;
        }
        return React__default.createElement(YearDropdown, _assign({}, Calendar2.defaultProps, _this.props, { date: _this.state.date, onChange: _this.changeYear, year: getYear(_this.state.date) }));
      };
      _this.renderMonthDropdown = function(overrideHide) {
        if (overrideHide === void 0) {
          overrideHide = false;
        }
        if (!_this.props.showMonthDropdown || overrideHide) {
          return;
        }
        return React__default.createElement(MonthDropdown, _assign({}, Calendar2.defaultProps, _this.props, { month: getMonth(_this.state.date), onChange: _this.changeMonth }));
      };
      _this.renderMonthYearDropdown = function(overrideHide) {
        if (overrideHide === void 0) {
          overrideHide = false;
        }
        if (!_this.props.showMonthYearDropdown || overrideHide) {
          return;
        }
        return React__default.createElement(MonthYearDropdown, _assign({}, Calendar2.defaultProps, _this.props, { date: _this.state.date, onChange: _this.changeMonthYear }));
      };
      _this.handleTodayButtonClick = function(event) {
        _this.props.onSelect(getStartOfToday(), event);
        _this.props.setPreSelection && _this.props.setPreSelection(getStartOfToday());
      };
      _this.renderTodayButton = function() {
        if (!_this.props.todayButton || _this.props.showTimeSelectOnly) {
          return;
        }
        return React__default.createElement("div", { className: "react-datepicker__today-button", onClick: _this.handleTodayButtonClick }, _this.props.todayButton);
      };
      _this.renderDefaultHeader = function(_a2) {
        var monthDate = _a2.monthDate, i = _a2.i;
        return React__default.createElement(
          "div",
          { className: "react-datepicker__header ".concat(_this.props.showTimeSelect ? "react-datepicker__header--has-time-select" : "") },
          _this.renderCurrentMonth(monthDate),
          React__default.createElement(
            "div",
            { className: "react-datepicker__header__dropdown react-datepicker__header__dropdown--".concat(_this.props.dropdownMode), onFocus: _this.handleDropdownFocus },
            _this.renderMonthDropdown(i !== 0),
            _this.renderMonthYearDropdown(i !== 0),
            _this.renderYearDropdown(i !== 0)
          ),
          React__default.createElement("div", { className: "react-datepicker__day-names" }, _this.header(monthDate))
        );
      };
      _this.renderCustomHeader = function(headerArgs) {
        var _a2, _b;
        var monthDate = headerArgs.monthDate, i = headerArgs.i;
        if (_this.props.showTimeSelect && !_this.state.monthContainer || _this.props.showTimeSelectOnly) {
          return null;
        }
        var prevMonthButtonDisabled = monthDisabledBefore(_this.state.date, _this.props);
        var nextMonthButtonDisabled = monthDisabledAfter(_this.state.date, _this.props);
        var prevYearButtonDisabled = yearDisabledBefore(_this.state.date, _this.props);
        var nextYearButtonDisabled = yearDisabledAfter(_this.state.date, _this.props);
        var showDayNames = !_this.props.showMonthYearPicker && !_this.props.showQuarterYearPicker && !_this.props.showYearPicker;
        return React__default.createElement(
          "div",
          { className: "react-datepicker__header react-datepicker__header--custom", onFocus: _this.props.onDropdownFocus },
          (_b = (_a2 = _this.props).renderCustomHeader) === null || _b === void 0 ? void 0 : _b.call(_a2, _assign(_assign({}, _this.state), { customHeaderCount: i, monthDate, changeMonth: _this.changeMonth, changeYear: _this.changeYear, decreaseMonth: _this.decreaseMonth, increaseMonth: _this.increaseMonth, decreaseYear: _this.decreaseYear, increaseYear: _this.increaseYear, prevMonthButtonDisabled, nextMonthButtonDisabled, prevYearButtonDisabled, nextYearButtonDisabled })),
          showDayNames && React__default.createElement("div", { className: "react-datepicker__day-names" }, _this.header(monthDate))
        );
      };
      _this.renderYearHeader = function(_a2) {
        var monthDate = _a2.monthDate;
        var _b = _this.props, showYearPicker = _b.showYearPicker, _c = _b.yearItemNumber, yearItemNumber = _c === void 0 ? Calendar2.defaultProps.yearItemNumber : _c;
        var _d = getYearsPeriod(monthDate, yearItemNumber), startPeriod = _d.startPeriod, endPeriod = _d.endPeriod;
        return React__default.createElement("div", { className: "react-datepicker__header react-datepicker-year-header" }, showYearPicker ? "".concat(startPeriod, " - ").concat(endPeriod) : getYear(monthDate));
      };
      _this.renderHeader = function(_a2) {
        var monthDate = _a2.monthDate, _b = _a2.i, i = _b === void 0 ? 0 : _b;
        var headerArgs = { monthDate, i };
        switch (true) {
          case _this.props.renderCustomHeader !== void 0:
            return _this.renderCustomHeader(headerArgs);
          case (_this.props.showMonthYearPicker || _this.props.showQuarterYearPicker || _this.props.showYearPicker):
            return _this.renderYearHeader(headerArgs);
          default:
            return _this.renderDefaultHeader(headerArgs);
        }
      };
      _this.renderMonths = function() {
        var _a2, _b;
        if (_this.props.showTimeSelectOnly || _this.props.showYearPicker) {
          return;
        }
        var monthList = [];
        var monthsShown = (_a2 = _this.props.monthsShown) !== null && _a2 !== void 0 ? _a2 : Calendar2.defaultProps.monthsShown;
        var monthsToSubtract = _this.props.showPreviousMonths ? monthsShown - 1 : 0;
        var fromMonthDate = _this.props.showMonthYearPicker || _this.props.showQuarterYearPicker ? addYears(_this.state.date, monthsToSubtract) : subMonths(_this.state.date, monthsToSubtract);
        var monthSelectedIn = (_b = _this.props.monthSelectedIn) !== null && _b !== void 0 ? _b : monthsToSubtract;
        for (var i = 0; i < monthsShown; ++i) {
          var monthsToAdd = i - monthSelectedIn + monthsToSubtract;
          var monthDate = _this.props.showMonthYearPicker || _this.props.showQuarterYearPicker ? addYears(fromMonthDate, monthsToAdd) : addMonths(fromMonthDate, monthsToAdd);
          var monthKey = "month-".concat(i);
          var monthShowsDuplicateDaysEnd = i < monthsShown - 1;
          var monthShowsDuplicateDaysStart = i > 0;
          monthList.push(React__default.createElement(
            "div",
            { key: monthKey, ref: function(div) {
              _this.monthContainer = div !== null && div !== void 0 ? div : void 0;
            }, className: "react-datepicker__month-container" },
            _this.renderHeader({ monthDate, i }),
            React__default.createElement(Month, _assign({}, Calendar2.defaultProps, _this.props, { ariaLabelPrefix: _this.props.monthAriaLabelPrefix, day: monthDate, onDayClick: _this.handleDayClick, handleOnKeyDown: _this.props.handleOnDayKeyDown, handleOnMonthKeyDown: _this.props.handleOnKeyDown, onDayMouseEnter: _this.handleDayMouseEnter, onMouseLeave: _this.handleMonthMouseLeave, orderInDisplay: i, selectingDate: _this.state.selectingDate, monthShowsDuplicateDaysEnd, monthShowsDuplicateDaysStart }))
          ));
        }
        return monthList;
      };
      _this.renderYears = function() {
        if (_this.props.showTimeSelectOnly) {
          return;
        }
        if (_this.props.showYearPicker) {
          return React__default.createElement(
            "div",
            { className: "react-datepicker__year--container" },
            _this.renderHeader({ monthDate: _this.state.date }),
            React__default.createElement(Year, _assign({}, Calendar2.defaultProps, _this.props, { selectingDate: _this.state.selectingDate, date: _this.state.date, onDayClick: _this.handleDayClick, clearSelectingDate: _this.clearSelectingDate, onYearMouseEnter: _this.handleYearMouseEnter, onYearMouseLeave: _this.handleYearMouseLeave }))
          );
        }
        return;
      };
      _this.renderTimeSection = function() {
        if (_this.props.showTimeSelect && (_this.state.monthContainer || _this.props.showTimeSelectOnly)) {
          return React__default.createElement(Time, _assign({}, Calendar2.defaultProps, _this.props, { onChange: _this.props.onTimeChange, format: _this.props.timeFormat, intervals: _this.props.timeIntervals, monthRef: _this.state.monthContainer }));
        }
        return;
      };
      _this.renderInputTimeSection = function() {
        var time = _this.props.selected ? new Date(_this.props.selected) : void 0;
        var timeValid = time && isValid(time) && Boolean(_this.props.selected);
        var timeString = timeValid ? "".concat(addZero(time.getHours()), ":").concat(addZero(time.getMinutes())) : "";
        if (_this.props.showTimeInput) {
          return React__default.createElement(InputTime, _assign({}, Calendar2.defaultProps, _this.props, { date: time, timeString, onChange: _this.props.onTimeChange }));
        }
        return;
      };
      _this.renderAriaLiveRegion = function() {
        var _a2;
        var _b = getYearsPeriod(_this.state.date, (_a2 = _this.props.yearItemNumber) !== null && _a2 !== void 0 ? _a2 : Calendar2.defaultProps.yearItemNumber), startPeriod = _b.startPeriod, endPeriod = _b.endPeriod;
        var ariaLiveMessage;
        if (_this.props.showYearPicker) {
          ariaLiveMessage = "".concat(startPeriod, " - ").concat(endPeriod);
        } else if (_this.props.showMonthYearPicker || _this.props.showQuarterYearPicker) {
          ariaLiveMessage = getYear(_this.state.date);
        } else {
          ariaLiveMessage = "".concat(getMonthInLocale(getMonth(_this.state.date), _this.props.locale), " ").concat(getYear(_this.state.date));
        }
        return React__default.createElement("span", { role: "alert", "aria-live": "polite", className: "react-datepicker__aria-live" }, _this.state.isRenderAriaLiveMessage && ariaLiveMessage);
      };
      _this.renderChildren = function() {
        if (_this.props.children) {
          return React__default.createElement("div", { className: "react-datepicker__children-container" }, _this.props.children);
        }
        return;
      };
      _this.containerRef = createRef();
      _this.state = {
        date: _this.getDateInView(),
        selectingDate: void 0,
        monthContainer: void 0,
        isRenderAriaLiveMessage: false
      };
      return _this;
    }
    Object.defineProperty(Calendar2, "defaultProps", {
      get: function() {
        return {
          monthsShown: 1,
          forceShowMonthNavigation: false,
          timeCaption: "Time",
          previousYearButtonLabel: "Previous Year",
          nextYearButtonLabel: "Next Year",
          previousMonthButtonLabel: "Previous Month",
          nextMonthButtonLabel: "Next Month",
          yearItemNumber: DEFAULT_YEAR_ITEM_NUMBER
        };
      },
      enumerable: false,
      configurable: true
    });
    Calendar2.prototype.componentDidMount = function() {
      var _this = this;
      if (this.props.showTimeSelect) {
        this.assignMonthContainer = function() {
          _this.setState({ monthContainer: _this.monthContainer });
        }();
      }
    };
    Calendar2.prototype.componentDidUpdate = function(prevProps) {
      var _this = this;
      if (this.props.preSelection && (!isSameDay(this.props.preSelection, prevProps.preSelection) || this.props.monthSelectedIn !== prevProps.monthSelectedIn)) {
        var hasMonthChanged_1 = !isSameMonth(this.state.date, this.props.preSelection);
        this.setState({
          date: this.props.preSelection
        }, function() {
          return hasMonthChanged_1 && _this.handleCustomMonthChange(_this.state.date);
        });
      } else if (this.props.openToDate && !isSameDay(this.props.openToDate, prevProps.openToDate)) {
        this.setState({
          date: this.props.openToDate
        });
      }
    };
    Calendar2.prototype.render = function() {
      var Container2 = this.props.container || CalendarContainer;
      return React__default.createElement(
        ClickOutsideWrapper,
        { onClickOutside: this.handleClickOutside, style: { display: "contents" }, containerRef: this.containerRef, ignoreClass: this.props.outsideClickIgnoreClass },
        React__default.createElement(
          Container2,
          { className: clsx("react-datepicker", this.props.className, {
            "react-datepicker--time-only": this.props.showTimeSelectOnly
          }), showTime: this.props.showTimeSelect || this.props.showTimeInput, showTimeSelectOnly: this.props.showTimeSelectOnly },
          this.renderAriaLiveRegion(),
          this.renderPreviousButton(),
          this.renderNextButton(),
          this.renderMonths(),
          this.renderYears(),
          this.renderTodayButton(),
          this.renderTimeSection(),
          this.renderInputTimeSection(),
          this.renderChildren()
        )
      );
    };
    return Calendar2;
  }(Component)
);
var CalendarIcon = function(_a2) {
  var icon = _a2.icon, _b = _a2.className, className = _b === void 0 ? "" : _b, onClick = _a2.onClick;
  var defaultClass = "react-datepicker__calendar-icon";
  if (typeof icon === "string") {
    return React__default.createElement("i", { className: "".concat(defaultClass, " ").concat(icon, " ").concat(className), "aria-hidden": "true", onClick });
  }
  if (React__default.isValidElement(icon)) {
    return React__default.cloneElement(icon, {
      className: "".concat(icon.props.className || "", " ").concat(defaultClass, " ").concat(className),
      onClick: function(event) {
        if (typeof icon.props.onClick === "function") {
          icon.props.onClick(event);
        }
        if (typeof onClick === "function") {
          onClick(event);
        }
      }
    });
  }
  return React__default.createElement(
    "svg",
    { className: "".concat(defaultClass, " ").concat(className), xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 448 512", onClick },
    React__default.createElement("path", { d: "M96 32V64H48C21.5 64 0 85.5 0 112v48H448V112c0-26.5-21.5-48-48-48H352V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V64H160V32c0-17.7-14.3-32-32-32S96 14.3 96 32zM448 192H0V464c0 26.5 21.5 48 48 48H400c26.5 0 48-21.5 48-48V192z" })
  );
};
var Portal = (
  /** @class */
  function(_super) {
    __extends(Portal2, _super);
    function Portal2(props) {
      var _this = _super.call(this, props) || this;
      _this.portalRoot = null;
      _this.el = document.createElement("div");
      return _this;
    }
    Portal2.prototype.componentDidMount = function() {
      this.portalRoot = (this.props.portalHost || document).getElementById(this.props.portalId);
      if (!this.portalRoot) {
        this.portalRoot = document.createElement("div");
        this.portalRoot.setAttribute("id", this.props.portalId);
        (this.props.portalHost || document.body).appendChild(this.portalRoot);
      }
      this.portalRoot.appendChild(this.el);
    };
    Portal2.prototype.componentWillUnmount = function() {
      if (this.portalRoot) {
        this.portalRoot.removeChild(this.el);
      }
    };
    Portal2.prototype.render = function() {
      return ReactDOM__default.createPortal(this.props.children, this.el);
    };
    return Portal2;
  }(Component)
);
var focusableElementsSelector = "[tabindex], a, button, input, select, textarea";
var focusableFilter = function(node2) {
  if (node2 instanceof HTMLAnchorElement) {
    return node2.tabIndex !== -1;
  }
  return !node2.disabled && node2.tabIndex !== -1;
};
var TabLoop = (
  /** @class */
  function(_super) {
    __extends(TabLoop2, _super);
    function TabLoop2(props) {
      var _this = _super.call(this, props) || this;
      _this.getTabChildren = function() {
        var _a2;
        return Array.prototype.slice.call((_a2 = _this.tabLoopRef.current) === null || _a2 === void 0 ? void 0 : _a2.querySelectorAll(focusableElementsSelector), 1, -1).filter(focusableFilter);
      };
      _this.handleFocusStart = function() {
        var tabChildren = _this.getTabChildren();
        tabChildren && tabChildren.length > 1 && tabChildren[tabChildren.length - 1].focus();
      };
      _this.handleFocusEnd = function() {
        var tabChildren = _this.getTabChildren();
        tabChildren && tabChildren.length > 1 && tabChildren[0].focus();
      };
      _this.tabLoopRef = createRef();
      return _this;
    }
    TabLoop2.prototype.render = function() {
      var _a2;
      if (!((_a2 = this.props.enableTabLoop) !== null && _a2 !== void 0 ? _a2 : TabLoop2.defaultProps.enableTabLoop)) {
        return this.props.children;
      }
      return React__default.createElement(
        "div",
        { className: "react-datepicker__tab-loop", ref: this.tabLoopRef },
        React__default.createElement("div", { className: "react-datepicker__tab-loop__start", tabIndex: 0, onFocus: this.handleFocusStart }),
        this.props.children,
        React__default.createElement("div", { className: "react-datepicker__tab-loop__end", tabIndex: 0, onFocus: this.handleFocusEnd })
      );
    };
    TabLoop2.defaultProps = {
      enableTabLoop: true
    };
    return TabLoop2;
  }(Component)
);
function withFloating(Component2) {
  var WithFloating = function(props) {
    var _a2;
    var hidePopper = typeof props.hidePopper === "boolean" ? props.hidePopper : true;
    var arrowRef = useRef(null);
    var floatingProps = useFloating(_assign({ open: !hidePopper, whileElementsMounted: autoUpdate, placement: props.popperPlacement, middleware: __spreadArray([
      flip({ padding: 15 }),
      offset(10),
      arrow({ element: arrowRef })
    ], (_a2 = props.popperModifiers) !== null && _a2 !== void 0 ? _a2 : [], true) }, props.popperProps));
    var componentProps = _assign(_assign({}, props), { hidePopper, popperProps: _assign(_assign({}, floatingProps), { arrowRef }) });
    return React__default.createElement(Component2, _assign({}, componentProps));
  };
  return WithFloating;
}
var PopperComponent = (
  /** @class */
  function(_super) {
    __extends(PopperComponent2, _super);
    function PopperComponent2() {
      return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(PopperComponent2, "defaultProps", {
      get: function() {
        return {
          hidePopper: true
        };
      },
      enumerable: false,
      configurable: true
    });
    PopperComponent2.prototype.render = function() {
      var _a2 = this.props, className = _a2.className, wrapperClassName = _a2.wrapperClassName, _b = _a2.hidePopper, hidePopper = _b === void 0 ? PopperComponent2.defaultProps.hidePopper : _b, popperComponent = _a2.popperComponent, targetComponent = _a2.targetComponent, enableTabLoop = _a2.enableTabLoop, popperOnKeyDown = _a2.popperOnKeyDown, portalId = _a2.portalId, portalHost = _a2.portalHost, popperProps = _a2.popperProps, showArrow = _a2.showArrow;
      var popper2 = void 0;
      if (!hidePopper) {
        var classes = clsx("react-datepicker-popper", className);
        popper2 = React__default.createElement(
          TabLoop,
          { enableTabLoop },
          React__default.createElement(
            "div",
            { ref: popperProps.refs.setFloating, style: popperProps.floatingStyles, className: classes, "data-placement": popperProps.placement, onKeyDown: popperOnKeyDown },
            popperComponent,
            showArrow && React__default.createElement(FloatingArrow, { ref: popperProps.arrowRef, context: popperProps.context, fill: "currentColor", strokeWidth: 1, height: 8, width: 16, style: { transform: "translateY(-1px)" }, className: "react-datepicker__triangle" })
          )
        );
      }
      if (this.props.popperContainer) {
        popper2 = createElement(this.props.popperContainer, {}, popper2);
      }
      if (portalId && !hidePopper) {
        popper2 = React__default.createElement(Portal, { portalId, portalHost }, popper2);
      }
      var wrapperClasses = clsx("react-datepicker-wrapper", wrapperClassName);
      return React__default.createElement(
        React__default.Fragment,
        null,
        React__default.createElement("div", { ref: popperProps.refs.setReference, className: wrapperClasses }, targetComponent),
        popper2
      );
    };
    return PopperComponent2;
  }(Component)
);
var PopperComponent$1 = withFloating(PopperComponent);
var outsideClickIgnoreClass = "react-datepicker-ignore-onclickoutside";
function hasPreSelectionChanged(date1, date2) {
  if (date1 && date2) {
    return getMonth(date1) !== getMonth(date2) || getYear(date1) !== getYear(date2);
  }
  return date1 !== date2;
}
var INPUT_ERR_1 = "Date input not valid.";
var DatePicker$1 = (
  /** @class */
  function(_super) {
    __extends(DatePicker2, _super);
    function DatePicker2(props) {
      var _this = _super.call(this, props) || this;
      _this.calendar = null;
      _this.input = null;
      _this.getPreSelection = function() {
        return _this.props.openToDate ? _this.props.openToDate : _this.props.selectsEnd && _this.props.startDate ? _this.props.startDate : _this.props.selectsStart && _this.props.endDate ? _this.props.endDate : newDate();
      };
      _this.modifyHolidays = function() {
        var _a2;
        return (_a2 = _this.props.holidays) === null || _a2 === void 0 ? void 0 : _a2.reduce(function(accumulator, holiday) {
          var date = new Date(holiday.date);
          if (!isValid(date)) {
            return accumulator;
          }
          return __spreadArray(__spreadArray([], accumulator, true), [_assign(_assign({}, holiday), { date })], false);
        }, []);
      };
      _this.calcInitialState = function() {
        var _a2;
        var defaultPreSelection = _this.getPreSelection();
        var minDate = getEffectiveMinDate(_this.props);
        var maxDate = getEffectiveMaxDate(_this.props);
        var boundedPreSelection = minDate && isBefore(defaultPreSelection, getStartOfDay(minDate)) ? minDate : maxDate && isAfter(defaultPreSelection, getEndOfDay(maxDate)) ? maxDate : defaultPreSelection;
        return {
          open: _this.props.startOpen || false,
          preventFocus: false,
          inputValue: null,
          preSelection: (_a2 = _this.props.selectsRange ? _this.props.startDate : _this.props.selected) !== null && _a2 !== void 0 ? _a2 : boundedPreSelection,
          // transforming highlighted days (perhaps nested array)
          // to flat Map for faster access in day.jsx
          highlightDates: getHighLightDaysMap(_this.props.highlightDates),
          focused: false,
          // used to focus day in inline version after month has changed, but not on
          // initial render
          shouldFocusDayInline: false,
          isRenderAriaLiveMessage: false,
          wasHidden: false
        };
      };
      _this.resetHiddenStatus = function() {
        _this.setState(_assign(_assign({}, _this.state), { wasHidden: false }));
      };
      _this.setHiddenStatus = function() {
        _this.setState(_assign(_assign({}, _this.state), { wasHidden: true }));
      };
      _this.setHiddenStateOnVisibilityHidden = function() {
        if (document.visibilityState !== "hidden") {
          return;
        }
        _this.setHiddenStatus();
      };
      _this.clearPreventFocusTimeout = function() {
        if (_this.preventFocusTimeout) {
          clearTimeout(_this.preventFocusTimeout);
        }
      };
      _this.safeFocus = function() {
        setTimeout(function() {
          var _a2, _b;
          (_b = (_a2 = _this.input) === null || _a2 === void 0 ? void 0 : _a2.focus) === null || _b === void 0 ? void 0 : _b.call(_a2, { preventScroll: true });
        }, 0);
      };
      _this.safeBlur = function() {
        setTimeout(function() {
          var _a2, _b;
          (_b = (_a2 = _this.input) === null || _a2 === void 0 ? void 0 : _a2.blur) === null || _b === void 0 ? void 0 : _b.call(_a2);
        }, 0);
      };
      _this.setFocus = function() {
        _this.safeFocus();
      };
      _this.setBlur = function() {
        _this.safeBlur();
        _this.cancelFocusInput();
      };
      _this.setOpen = function(open, skipSetBlur) {
        if (skipSetBlur === void 0) {
          skipSetBlur = false;
        }
        _this.setState({
          open,
          preSelection: open && _this.state.open ? _this.state.preSelection : _this.calcInitialState().preSelection,
          lastPreSelectChange: PRESELECT_CHANGE_VIA_NAVIGATE
        }, function() {
          if (!open) {
            _this.setState(function(prev2) {
              return {
                focused: skipSetBlur ? prev2.focused : false
              };
            }, function() {
              !skipSetBlur && _this.setBlur();
              _this.setState({ inputValue: null });
            });
          }
        });
      };
      _this.inputOk = function() {
        return isDate(_this.state.preSelection);
      };
      _this.isCalendarOpen = function() {
        return _this.props.open === void 0 ? _this.state.open && !_this.props.disabled && !_this.props.readOnly : _this.props.open;
      };
      _this.handleFocus = function(event) {
        var _a2, _b;
        var isAutoReFocus = _this.state.wasHidden;
        var isOpenAllowed = isAutoReFocus ? _this.state.open : true;
        if (isAutoReFocus) {
          _this.resetHiddenStatus();
        }
        if (!_this.state.preventFocus && isOpenAllowed) {
          (_b = (_a2 = _this.props).onFocus) === null || _b === void 0 ? void 0 : _b.call(_a2, event);
          if (!_this.props.preventOpenOnFocus && !_this.props.readOnly) {
            _this.setOpen(true);
          }
        }
        _this.setState({ focused: true });
      };
      _this.sendFocusBackToInput = function() {
        if (_this.preventFocusTimeout) {
          _this.clearPreventFocusTimeout();
        }
        _this.setState({ preventFocus: true }, function() {
          _this.preventFocusTimeout = setTimeout(function() {
            _this.setFocus();
            _this.setState({ preventFocus: false });
          });
        });
      };
      _this.cancelFocusInput = function() {
        clearTimeout(_this.inputFocusTimeout);
        _this.inputFocusTimeout = void 0;
      };
      _this.deferFocusInput = function() {
        _this.cancelFocusInput();
        _this.inputFocusTimeout = setTimeout(function() {
          return _this.setFocus();
        }, 1);
      };
      _this.handleDropdownFocus = function() {
        _this.cancelFocusInput();
      };
      _this.handleBlur = function(event) {
        var _a2, _b;
        if (!_this.state.open || _this.props.withPortal || _this.props.showTimeInput) {
          (_b = (_a2 = _this.props).onBlur) === null || _b === void 0 ? void 0 : _b.call(_a2, event);
        }
        _this.setState({ focused: false });
      };
      _this.handleCalendarClickOutside = function(event) {
        var _a2, _b;
        if (!_this.props.inline) {
          _this.setOpen(false);
        }
        (_b = (_a2 = _this.props).onClickOutside) === null || _b === void 0 ? void 0 : _b.call(_a2, event);
        if (_this.props.withPortal) {
          event.preventDefault();
        }
      };
      _this.handleChange = function() {
        var _a2, _b;
        var allArgs = [];
        for (var _i = 0; _i < arguments.length; _i++) {
          allArgs[_i] = arguments[_i];
        }
        var event = allArgs[0];
        if (_this.props.onChangeRaw) {
          _this.props.onChangeRaw.apply(_this, allArgs);
          if (!event || typeof event.isDefaultPrevented !== "function" || event.isDefaultPrevented()) {
            return;
          }
        }
        _this.setState({
          inputValue: (event === null || event === void 0 ? void 0 : event.target) instanceof HTMLInputElement ? event.target.value : null,
          lastPreSelectChange: PRESELECT_CHANGE_VIA_INPUT
        });
        var _c = _this.props, _d = _c.dateFormat, dateFormat = _d === void 0 ? DatePicker2.defaultProps.dateFormat : _d, _e = _c.strictParsing, strictParsing = _e === void 0 ? DatePicker2.defaultProps.strictParsing : _e, selectsRange = _c.selectsRange, startDate = _c.startDate, endDate = _c.endDate;
        var value = (event === null || event === void 0 ? void 0 : event.target) instanceof HTMLInputElement ? event.target.value : "";
        if (selectsRange) {
          var _f = value.split("-", 2).map(function(val) {
            return val.trim();
          }), valueStart = _f[0], valueEnd = _f[1];
          var startDateNew = parseDate(valueStart !== null && valueStart !== void 0 ? valueStart : "", dateFormat, _this.props.locale, strictParsing);
          var endDateNew = parseDate(valueEnd !== null && valueEnd !== void 0 ? valueEnd : "", dateFormat, _this.props.locale, strictParsing);
          var startChanged = (startDate === null || startDate === void 0 ? void 0 : startDate.getTime()) !== (startDateNew === null || startDateNew === void 0 ? void 0 : startDateNew.getTime());
          var endChanged = (endDate === null || endDate === void 0 ? void 0 : endDate.getTime()) !== (endDateNew === null || endDateNew === void 0 ? void 0 : endDateNew.getTime());
          if (!startChanged && !endChanged) {
            return;
          }
          if (startDateNew && isDayDisabled(startDateNew, _this.props)) {
            return;
          }
          if (endDateNew && isDayDisabled(endDateNew, _this.props)) {
            return;
          }
          (_b = (_a2 = _this.props).onChange) === null || _b === void 0 ? void 0 : _b.call(_a2, [startDateNew, endDateNew], event);
        } else {
          var date = parseDate(value, dateFormat, _this.props.locale, strictParsing, _this.props.minDate);
          if (_this.props.showTimeSelectOnly && _this.props.selected && date && !isSameDay(date, _this.props.selected)) {
            date = set(_this.props.selected, {
              hours: getHours(date),
              minutes: getMinutes(date),
              seconds: getSeconds(date)
            });
          }
          if (date || !value) {
            _this.setSelected(date, event, true);
          }
        }
      };
      _this.handleSelect = function(date, event, monthSelectedIn) {
        if (_this.props.shouldCloseOnSelect && !_this.props.showTimeSelect) {
          _this.sendFocusBackToInput();
        }
        if (_this.props.onChangeRaw) {
          _this.props.onChangeRaw(event);
        }
        _this.setSelected(date, event, false, monthSelectedIn);
        if (_this.props.showDateSelect) {
          _this.setState({ isRenderAriaLiveMessage: true });
        }
        if (!_this.props.shouldCloseOnSelect || _this.props.showTimeSelect) {
          _this.setPreSelection(date);
        } else if (!_this.props.inline) {
          if (!_this.props.selectsRange) {
            _this.setOpen(false);
          }
          var _a2 = _this.props, startDate = _a2.startDate, endDate = _a2.endDate;
          if (startDate && !endDate && (_this.props.swapRange || !isDateBefore(date, startDate))) {
            _this.setOpen(false);
          }
        }
      };
      _this.setSelected = function(date, event, keepInput, monthSelectedIn) {
        var _a2, _b;
        var changedDate = date;
        if (_this.props.showYearPicker) {
          if (changedDate !== null && isYearDisabled(getYear(changedDate), _this.props)) {
            return;
          }
        } else if (_this.props.showMonthYearPicker) {
          if (changedDate !== null && isMonthDisabled(changedDate, _this.props)) {
            return;
          }
        } else {
          if (changedDate !== null && isDayDisabled(changedDate, _this.props)) {
            return;
          }
        }
        var _c = _this.props, onChange2 = _c.onChange, selectsRange = _c.selectsRange, startDate = _c.startDate, endDate = _c.endDate, selectsMultiple = _c.selectsMultiple, selectedDates = _c.selectedDates, minTime = _c.minTime, swapRange = _c.swapRange;
        if (!isEqual(_this.props.selected, changedDate) || _this.props.allowSameDay || selectsRange || selectsMultiple) {
          if (changedDate !== null) {
            if (_this.props.selected && (!keepInput || !_this.props.showTimeSelect && !_this.props.showTimeSelectOnly && !_this.props.showTimeInput)) {
              changedDate = setTime(changedDate, {
                hour: getHours(_this.props.selected),
                minute: getMinutes(_this.props.selected),
                second: getSeconds(_this.props.selected)
              });
            }
            if (!keepInput && (_this.props.showTimeSelect || _this.props.showTimeSelectOnly)) {
              if (minTime) {
                changedDate = setTime(changedDate, {
                  hour: minTime.getHours(),
                  minute: minTime.getMinutes(),
                  second: minTime.getSeconds()
                });
              }
            }
            if (!_this.props.inline) {
              _this.setState({
                preSelection: changedDate
              });
            }
            if (!_this.props.focusSelectedMonth) {
              _this.setState({ monthSelectedIn });
            }
          }
          if (selectsRange) {
            var noRanges = !startDate && !endDate;
            var hasStartRange = startDate && !endDate;
            var isRangeFilled = startDate && endDate;
            if (noRanges) {
              onChange2 === null || onChange2 === void 0 ? void 0 : onChange2([changedDate, null], event);
            } else if (hasStartRange) {
              if (changedDate === null) {
                onChange2 === null || onChange2 === void 0 ? void 0 : onChange2([null, null], event);
              } else if (isDateBefore(changedDate, startDate)) {
                if (swapRange) {
                  onChange2 === null || onChange2 === void 0 ? void 0 : onChange2([changedDate, startDate], event);
                } else {
                  onChange2 === null || onChange2 === void 0 ? void 0 : onChange2([changedDate, null], event);
                }
              } else {
                onChange2 === null || onChange2 === void 0 ? void 0 : onChange2([startDate, changedDate], event);
              }
            }
            if (isRangeFilled) {
              onChange2 === null || onChange2 === void 0 ? void 0 : onChange2([changedDate, null], event);
            }
          } else if (selectsMultiple) {
            if (changedDate !== null) {
              if (!(selectedDates === null || selectedDates === void 0 ? void 0 : selectedDates.length)) {
                onChange2 === null || onChange2 === void 0 ? void 0 : onChange2([changedDate], event);
              } else {
                var isChangedDateAlreadySelected = selectedDates.some(function(selectedDate) {
                  return isSameDay(selectedDate, changedDate);
                });
                if (isChangedDateAlreadySelected) {
                  var nextDates = selectedDates.filter(function(selectedDate) {
                    return !isSameDay(selectedDate, changedDate);
                  });
                  onChange2 === null || onChange2 === void 0 ? void 0 : onChange2(nextDates, event);
                } else {
                  onChange2 === null || onChange2 === void 0 ? void 0 : onChange2(__spreadArray(__spreadArray([], selectedDates, true), [changedDate], false), event);
                }
              }
            }
          } else {
            onChange2 === null || onChange2 === void 0 ? void 0 : onChange2(changedDate, event);
          }
        }
        if (!keepInput) {
          (_b = (_a2 = _this.props).onSelect) === null || _b === void 0 ? void 0 : _b.call(_a2, changedDate, event);
          _this.setState({ inputValue: null });
        }
      };
      _this.setPreSelection = function(date) {
        var hasMinDate = isDate(_this.props.minDate);
        var hasMaxDate = isDate(_this.props.maxDate);
        var isValidDateSelection = true;
        if (date) {
          var dateStartOfDay = getStartOfDay(date);
          if (hasMinDate && hasMaxDate) {
            isValidDateSelection = isDayInRange(date, _this.props.minDate, _this.props.maxDate);
          } else if (hasMinDate) {
            var minDateStartOfDay = getStartOfDay(_this.props.minDate);
            isValidDateSelection = isAfter(date, minDateStartOfDay) || isEqual(dateStartOfDay, minDateStartOfDay);
          } else if (hasMaxDate) {
            var maxDateEndOfDay = getEndOfDay(_this.props.maxDate);
            isValidDateSelection = isBefore(date, maxDateEndOfDay) || isEqual(dateStartOfDay, maxDateEndOfDay);
          }
        }
        if (isValidDateSelection) {
          _this.setState({
            preSelection: date
          });
        }
      };
      _this.toggleCalendar = function() {
        _this.setOpen(!_this.state.open);
      };
      _this.handleTimeChange = function(time) {
        var _a2, _b;
        if (_this.props.selectsRange || _this.props.selectsMultiple) {
          return;
        }
        var selected = _this.props.selected ? _this.props.selected : _this.getPreSelection();
        var changedDate = _this.props.selected ? time : setTime(selected, {
          hour: getHours(time),
          minute: getMinutes(time)
        });
        _this.setState({
          preSelection: changedDate
        });
        (_b = (_a2 = _this.props).onChange) === null || _b === void 0 ? void 0 : _b.call(_a2, changedDate);
        if (_this.props.shouldCloseOnSelect && !_this.props.showTimeInput) {
          _this.sendFocusBackToInput();
          _this.setOpen(false);
        }
        if (_this.props.showTimeInput) {
          _this.setOpen(true);
        }
        if (_this.props.showTimeSelectOnly || _this.props.showTimeSelect) {
          _this.setState({ isRenderAriaLiveMessage: true });
        }
        _this.setState({ inputValue: null });
      };
      _this.onInputClick = function() {
        var _a2, _b;
        if (!_this.props.disabled && !_this.props.readOnly) {
          _this.setOpen(true);
        }
        (_b = (_a2 = _this.props).onInputClick) === null || _b === void 0 ? void 0 : _b.call(_a2);
      };
      _this.onInputKeyDown = function(event) {
        var _a2, _b, _c, _d, _e, _f;
        (_b = (_a2 = _this.props).onKeyDown) === null || _b === void 0 ? void 0 : _b.call(_a2, event);
        var eventKey = event.key;
        if (!_this.state.open && !_this.props.inline && !_this.props.preventOpenOnFocus) {
          if (eventKey === KeyType.ArrowDown || eventKey === KeyType.ArrowUp || eventKey === KeyType.Enter) {
            (_c = _this.onInputClick) === null || _c === void 0 ? void 0 : _c.call(_this);
          }
          return;
        }
        if (_this.state.open) {
          if (eventKey === KeyType.ArrowDown || eventKey === KeyType.ArrowUp) {
            event.preventDefault();
            var selectorString = _this.props.showTimeSelectOnly ? ".react-datepicker__time-list-item[tabindex='0']" : _this.props.showWeekPicker && _this.props.showWeekNumbers ? '.react-datepicker__week-number[tabindex="0"]' : _this.props.showFullMonthYearPicker || _this.props.showMonthYearPicker ? '.react-datepicker__month-text[tabindex="0"]' : '.react-datepicker__day[tabindex="0"]';
            var selectedItem = ((_d = _this.calendar) === null || _d === void 0 ? void 0 : _d.containerRef.current) instanceof Element && _this.calendar.containerRef.current.querySelector(selectorString);
            selectedItem instanceof HTMLElement && selectedItem.focus({ preventScroll: true });
            return;
          }
          var copy2 = newDate(_this.state.preSelection);
          if (eventKey === KeyType.Enter) {
            event.preventDefault();
            event.target.blur();
            if (_this.inputOk() && _this.state.lastPreSelectChange === PRESELECT_CHANGE_VIA_NAVIGATE) {
              _this.handleSelect(copy2, event);
              !_this.props.shouldCloseOnSelect && _this.setPreSelection(copy2);
            } else {
              _this.setOpen(false);
            }
          } else if (eventKey === KeyType.Escape) {
            event.preventDefault();
            event.target.blur();
            _this.sendFocusBackToInput();
            _this.setOpen(false);
          } else if (eventKey === KeyType.Tab) {
            _this.setOpen(false);
          }
          if (!_this.inputOk()) {
            (_f = (_e = _this.props).onInputError) === null || _f === void 0 ? void 0 : _f.call(_e, { code: 1, msg: INPUT_ERR_1 });
          }
        }
      };
      _this.onPortalKeyDown = function(event) {
        var eventKey = event.key;
        if (eventKey === KeyType.Escape) {
          event.preventDefault();
          _this.setState({
            preventFocus: true
          }, function() {
            _this.setOpen(false);
            setTimeout(function() {
              _this.setFocus();
              _this.setState({ preventFocus: false });
            });
          });
        }
      };
      _this.onDayKeyDown = function(event) {
        var _a2, _b, _c, _d, _e, _f;
        var _g = _this.props, minDate = _g.minDate, maxDate = _g.maxDate, disabledKeyboardNavigation = _g.disabledKeyboardNavigation, showWeekPicker = _g.showWeekPicker, shouldCloseOnSelect = _g.shouldCloseOnSelect, locale = _g.locale, calendarStartDay = _g.calendarStartDay, adjustDateOnChange = _g.adjustDateOnChange, inline = _g.inline;
        (_b = (_a2 = _this.props).onKeyDown) === null || _b === void 0 ? void 0 : _b.call(_a2, event);
        if (disabledKeyboardNavigation)
          return;
        var eventKey = event.key;
        var isShiftKeyActive = event.shiftKey;
        var copy2 = newDate(_this.state.preSelection);
        var calculateNewDate = function(eventKey2, date) {
          var newCalculatedDate = date;
          switch (eventKey2) {
            case KeyType.ArrowRight:
              newCalculatedDate = showWeekPicker ? addWeeks(date, 1) : addDays(date, 1);
              break;
            case KeyType.ArrowLeft:
              newCalculatedDate = showWeekPicker ? subWeeks(date) : subDays(date);
              break;
            case KeyType.ArrowUp:
              newCalculatedDate = subWeeks(date);
              break;
            case KeyType.ArrowDown:
              newCalculatedDate = addWeeks(date, 1);
              break;
            case KeyType.PageUp:
              newCalculatedDate = isShiftKeyActive ? subYears(date, 1) : subMonths(date, 1);
              break;
            case KeyType.PageDown:
              newCalculatedDate = isShiftKeyActive ? addYears(date, 1) : addMonths(date, 1);
              break;
            case KeyType.Home:
              newCalculatedDate = getStartOfWeek(date, locale, calendarStartDay);
              break;
            case KeyType.End:
              newCalculatedDate = getEndOfWeek(date);
              break;
          }
          return newCalculatedDate;
        };
        var getNewDate = function(eventKey2, date) {
          var MAX_ITERATIONS = 40;
          var eventKeyCopy = eventKey2;
          var validDateFound = false;
          var iterations = 0;
          var newSelection2 = calculateNewDate(eventKey2, date);
          while (!validDateFound) {
            if (iterations >= MAX_ITERATIONS) {
              newSelection2 = date;
              break;
            }
            if (minDate && newSelection2 < minDate) {
              eventKeyCopy = KeyType.ArrowRight;
              newSelection2 = isDayDisabled(minDate, _this.props) ? calculateNewDate(eventKeyCopy, newSelection2) : minDate;
            }
            if (maxDate && newSelection2 > maxDate) {
              eventKeyCopy = KeyType.ArrowLeft;
              newSelection2 = isDayDisabled(maxDate, _this.props) ? calculateNewDate(eventKeyCopy, newSelection2) : maxDate;
            }
            if (isDayDisabled(newSelection2, _this.props)) {
              if (eventKeyCopy === KeyType.PageUp || eventKeyCopy === KeyType.Home) {
                eventKeyCopy = KeyType.ArrowRight;
              }
              if (eventKeyCopy === KeyType.PageDown || eventKeyCopy === KeyType.End) {
                eventKeyCopy = KeyType.ArrowLeft;
              }
              newSelection2 = calculateNewDate(eventKeyCopy, newSelection2);
            } else {
              validDateFound = true;
            }
            iterations++;
          }
          return newSelection2;
        };
        if (eventKey === KeyType.Enter) {
          event.preventDefault();
          _this.handleSelect(copy2, event);
          !shouldCloseOnSelect && _this.setPreSelection(copy2);
          return;
        } else if (eventKey === KeyType.Escape) {
          event.preventDefault();
          _this.setOpen(false);
          if (!_this.inputOk()) {
            (_d = (_c = _this.props).onInputError) === null || _d === void 0 ? void 0 : _d.call(_c, { code: 1, msg: INPUT_ERR_1 });
          }
          return;
        }
        var newSelection = null;
        switch (eventKey) {
          case KeyType.ArrowLeft:
          case KeyType.ArrowRight:
          case KeyType.ArrowUp:
          case KeyType.ArrowDown:
          case KeyType.PageUp:
          case KeyType.PageDown:
          case KeyType.Home:
          case KeyType.End:
            newSelection = getNewDate(eventKey, copy2);
            break;
        }
        if (!newSelection) {
          (_f = (_e = _this.props).onInputError) === null || _f === void 0 ? void 0 : _f.call(_e, { code: 1, msg: INPUT_ERR_1 });
          return;
        }
        event.preventDefault();
        _this.setState({ lastPreSelectChange: PRESELECT_CHANGE_VIA_NAVIGATE });
        if (adjustDateOnChange) {
          _this.setSelected(newSelection);
        }
        _this.setPreSelection(newSelection);
        if (inline) {
          var prevMonth = getMonth(copy2);
          var newMonth = getMonth(newSelection);
          var prevYear = getYear(copy2);
          var newYear = getYear(newSelection);
          if (prevMonth !== newMonth || prevYear !== newYear) {
            _this.setState({ shouldFocusDayInline: true });
          } else {
            _this.setState({ shouldFocusDayInline: false });
          }
        }
      };
      _this.onPopperKeyDown = function(event) {
        var eventKey = event.key;
        if (eventKey === KeyType.Escape) {
          event.preventDefault();
          _this.sendFocusBackToInput();
        }
      };
      _this.onClearClick = function(event) {
        if (event) {
          if (event.preventDefault) {
            event.preventDefault();
          }
        }
        _this.sendFocusBackToInput();
        var _a2 = _this.props, selectsRange = _a2.selectsRange, onChange2 = _a2.onChange;
        if (selectsRange) {
          onChange2 === null || onChange2 === void 0 ? void 0 : onChange2([null, null], event);
        } else {
          onChange2 === null || onChange2 === void 0 ? void 0 : onChange2(null, event);
        }
        _this.setState({ inputValue: null });
      };
      _this.clear = function() {
        _this.onClearClick();
      };
      _this.onScroll = function(event) {
        if (typeof _this.props.closeOnScroll === "boolean" && _this.props.closeOnScroll) {
          if (event.target === document || event.target === document.documentElement || event.target === document.body) {
            _this.setOpen(false);
          }
        } else if (typeof _this.props.closeOnScroll === "function") {
          if (_this.props.closeOnScroll(event)) {
            _this.setOpen(false);
          }
        }
      };
      _this.renderCalendar = function() {
        var _a2, _b;
        if (!_this.props.inline && !_this.isCalendarOpen()) {
          return null;
        }
        return React__default.createElement(Calendar, _assign({ showMonthYearDropdown: void 0, ref: function(elem) {
          _this.calendar = elem;
        } }, _this.props, _this.state, { setOpen: _this.setOpen, dateFormat: (_a2 = _this.props.dateFormatCalendar) !== null && _a2 !== void 0 ? _a2 : DatePicker2.defaultProps.dateFormatCalendar, onSelect: _this.handleSelect, onClickOutside: _this.handleCalendarClickOutside, holidays: getHolidaysMap(_this.modifyHolidays()), outsideClickIgnoreClass, onDropdownFocus: _this.handleDropdownFocus, onTimeChange: _this.handleTimeChange, className: _this.props.calendarClassName, container: _this.props.calendarContainer, handleOnKeyDown: _this.props.onKeyDown, handleOnDayKeyDown: _this.onDayKeyDown, setPreSelection: _this.setPreSelection, dropdownMode: (_b = _this.props.dropdownMode) !== null && _b !== void 0 ? _b : DatePicker2.defaultProps.dropdownMode }), _this.props.children);
      };
      _this.renderAriaLiveRegion = function() {
        var _a2 = _this.props, _b = _a2.dateFormat, dateFormat = _b === void 0 ? DatePicker2.defaultProps.dateFormat : _b, locale = _a2.locale;
        var isContainsTime = _this.props.showTimeInput || _this.props.showTimeSelect;
        var longDateFormat = isContainsTime ? "PPPPp" : "PPPP";
        var ariaLiveMessage;
        if (_this.props.selectsRange) {
          ariaLiveMessage = "Selected start date: ".concat(safeDateFormat(_this.props.startDate, {
            dateFormat: longDateFormat,
            locale
          }), ". ").concat(_this.props.endDate ? "End date: " + safeDateFormat(_this.props.endDate, {
            dateFormat: longDateFormat,
            locale
          }) : "");
        } else {
          if (_this.props.showTimeSelectOnly) {
            ariaLiveMessage = "Selected time: ".concat(safeDateFormat(_this.props.selected, { dateFormat, locale }));
          } else if (_this.props.showYearPicker) {
            ariaLiveMessage = "Selected year: ".concat(safeDateFormat(_this.props.selected, { dateFormat: "yyyy", locale }));
          } else if (_this.props.showMonthYearPicker) {
            ariaLiveMessage = "Selected month: ".concat(safeDateFormat(_this.props.selected, { dateFormat: "MMMM yyyy", locale }));
          } else if (_this.props.showQuarterYearPicker) {
            ariaLiveMessage = "Selected quarter: ".concat(safeDateFormat(_this.props.selected, {
              dateFormat: "yyyy, QQQ",
              locale
            }));
          } else {
            ariaLiveMessage = "Selected date: ".concat(safeDateFormat(_this.props.selected, {
              dateFormat: longDateFormat,
              locale
            }));
          }
        }
        return React__default.createElement("span", { role: "alert", "aria-live": "polite", className: "react-datepicker__aria-live" }, ariaLiveMessage);
      };
      _this.renderDateInput = function() {
        var _a2, _b;
        var _c;
        var className = clsx(_this.props.className, (_a2 = {}, _a2[outsideClickIgnoreClass] = _this.state.open, _a2));
        var customInput = _this.props.customInput || React__default.createElement("input", { type: "text" });
        var customInputRef = _this.props.customInputRef || "ref";
        var _d = _this.props, _e = _d.dateFormat, dateFormat = _e === void 0 ? DatePicker2.defaultProps.dateFormat : _e, locale = _d.locale;
        var inputValue = typeof _this.props.value === "string" ? _this.props.value : typeof _this.state.inputValue === "string" ? _this.state.inputValue : _this.props.selectsRange ? safeDateRangeFormat(_this.props.startDate, _this.props.endDate, {
          dateFormat,
          locale
        }) : _this.props.selectsMultiple ? safeMultipleDatesFormat((_c = _this.props.selectedDates) !== null && _c !== void 0 ? _c : [], {
          dateFormat,
          locale
        }) : safeDateFormat(_this.props.selected, {
          dateFormat,
          locale
        });
        return cloneElement(customInput, (_b = {}, _b[customInputRef] = function(input) {
          _this.input = input;
        }, _b.value = inputValue, _b.onBlur = _this.handleBlur, _b.onChange = _this.handleChange, _b.onClick = _this.onInputClick, _b.onFocus = _this.handleFocus, _b.onKeyDown = _this.onInputKeyDown, _b.id = _this.props.id, _b.name = _this.props.name, _b.form = _this.props.form, _b.autoFocus = _this.props.autoFocus, _b.placeholder = _this.props.placeholderText, _b.disabled = _this.props.disabled, _b.autoComplete = _this.props.autoComplete, _b.className = clsx(customInput.props.className, className), _b.title = _this.props.title, _b.readOnly = _this.props.readOnly, _b.required = _this.props.required, _b.tabIndex = _this.props.tabIndex, _b["aria-describedby"] = _this.props.ariaDescribedBy, _b["aria-invalid"] = _this.props.ariaInvalid, _b["aria-labelledby"] = _this.props.ariaLabelledBy, _b["aria-required"] = _this.props.ariaRequired, _b));
      };
      _this.renderClearButton = function() {
        var _a2 = _this.props, isClearable = _a2.isClearable, disabled = _a2.disabled, selected = _a2.selected, startDate = _a2.startDate, endDate = _a2.endDate, clearButtonTitle = _a2.clearButtonTitle, _b = _a2.clearButtonClassName, clearButtonClassName = _b === void 0 ? "" : _b, _c = _a2.ariaLabelClose, ariaLabelClose = _c === void 0 ? "Close" : _c, selectedDates = _a2.selectedDates;
        if (isClearable && (selected != null || startDate != null || endDate != null || (selectedDates === null || selectedDates === void 0 ? void 0 : selectedDates.length))) {
          return React__default.createElement("button", { type: "button", className: clsx("react-datepicker__close-icon", clearButtonClassName, { "react-datepicker__close-icon--disabled": disabled }), disabled, "aria-label": ariaLabelClose, onClick: _this.onClearClick, title: clearButtonTitle, tabIndex: -1 });
        } else {
          return null;
        }
      };
      _this.state = _this.calcInitialState();
      _this.preventFocusTimeout = void 0;
      return _this;
    }
    Object.defineProperty(DatePicker2, "defaultProps", {
      get: function() {
        return {
          allowSameDay: false,
          dateFormat: "MM/dd/yyyy",
          dateFormatCalendar: "LLLL yyyy",
          disabled: false,
          disabledKeyboardNavigation: false,
          dropdownMode: "scroll",
          preventOpenOnFocus: false,
          monthsShown: 1,
          readOnly: false,
          withPortal: false,
          selectsDisabledDaysInRange: false,
          shouldCloseOnSelect: true,
          showTimeSelect: false,
          showTimeInput: false,
          showPreviousMonths: false,
          showMonthYearPicker: false,
          showFullMonthYearPicker: false,
          showTwoColumnMonthYearPicker: false,
          showFourColumnMonthYearPicker: false,
          showYearPicker: false,
          showQuarterYearPicker: false,
          showWeekPicker: false,
          strictParsing: false,
          swapRange: false,
          timeIntervals: 30,
          timeCaption: "Time",
          previousMonthAriaLabel: "Previous Month",
          previousMonthButtonLabel: "Previous Month",
          nextMonthAriaLabel: "Next Month",
          nextMonthButtonLabel: "Next Month",
          previousYearAriaLabel: "Previous Year",
          previousYearButtonLabel: "Previous Year",
          nextYearAriaLabel: "Next Year",
          nextYearButtonLabel: "Next Year",
          timeInputLabel: "Time",
          enableTabLoop: true,
          yearItemNumber: DEFAULT_YEAR_ITEM_NUMBER,
          focusSelectedMonth: false,
          showPopperArrow: true,
          excludeScrollbar: true,
          customTimeInput: null,
          calendarStartDay: void 0,
          toggleCalendarOnIconClick: false,
          usePointerEvent: false
        };
      },
      enumerable: false,
      configurable: true
    });
    DatePicker2.prototype.componentDidMount = function() {
      window.addEventListener("scroll", this.onScroll, true);
      document.addEventListener("visibilitychange", this.setHiddenStateOnVisibilityHidden);
    };
    DatePicker2.prototype.componentDidUpdate = function(prevProps, prevState) {
      var _a2, _b, _c, _d;
      if (prevProps.inline && hasPreSelectionChanged(prevProps.selected, this.props.selected)) {
        this.setPreSelection(this.props.selected);
      }
      if (this.state.monthSelectedIn !== void 0 && prevProps.monthsShown !== this.props.monthsShown) {
        this.setState({ monthSelectedIn: 0 });
      }
      if (prevProps.highlightDates !== this.props.highlightDates) {
        this.setState({
          highlightDates: getHighLightDaysMap(this.props.highlightDates)
        });
      }
      if (!prevState.focused && !isEqual(prevProps.selected, this.props.selected)) {
        this.setState({ inputValue: null });
      }
      if (prevState.open !== this.state.open) {
        if (prevState.open === false && this.state.open === true) {
          (_b = (_a2 = this.props).onCalendarOpen) === null || _b === void 0 ? void 0 : _b.call(_a2);
        }
        if (prevState.open === true && this.state.open === false) {
          (_d = (_c = this.props).onCalendarClose) === null || _d === void 0 ? void 0 : _d.call(_c);
        }
      }
    };
    DatePicker2.prototype.componentWillUnmount = function() {
      this.clearPreventFocusTimeout();
      window.removeEventListener("scroll", this.onScroll, true);
      document.removeEventListener("visibilitychange", this.setHiddenStateOnVisibilityHidden);
    };
    DatePicker2.prototype.renderInputContainer = function() {
      var _a2 = this.props, showIcon = _a2.showIcon, icon = _a2.icon, calendarIconClassname = _a2.calendarIconClassname, calendarIconClassName = _a2.calendarIconClassName, toggleCalendarOnIconClick = _a2.toggleCalendarOnIconClick;
      var open = this.state.open;
      if (calendarIconClassname) {
        console.warn("calendarIconClassname props is deprecated. should use calendarIconClassName props.");
      }
      return React__default.createElement(
        "div",
        { className: "react-datepicker__input-container".concat(showIcon ? " react-datepicker__view-calendar-icon" : "") },
        showIcon && React__default.createElement(CalendarIcon, _assign({ icon, className: clsx(calendarIconClassName, !calendarIconClassName && calendarIconClassname, open && "react-datepicker-ignore-onclickoutside") }, toggleCalendarOnIconClick ? {
          onClick: this.toggleCalendar
        } : null)),
        this.state.isRenderAriaLiveMessage && this.renderAriaLiveRegion(),
        this.renderDateInput(),
        this.renderClearButton()
      );
    };
    DatePicker2.prototype.render = function() {
      var calendar = this.renderCalendar();
      if (this.props.inline)
        return calendar;
      if (this.props.withPortal) {
        var portalContainer = this.state.open ? React__default.createElement(
          TabLoop,
          { enableTabLoop: this.props.enableTabLoop },
          React__default.createElement("div", { className: "react-datepicker__portal", tabIndex: -1, onKeyDown: this.onPortalKeyDown }, calendar)
        ) : null;
        if (this.state.open && this.props.portalId) {
          portalContainer = React__default.createElement(Portal, _assign({ portalId: this.props.portalId }, this.props), portalContainer);
        }
        return React__default.createElement(
          "div",
          null,
          this.renderInputContainer(),
          portalContainer
        );
      }
      return React__default.createElement(PopperComponent$1, _assign({}, this.props, { className: this.props.popperClassName, hidePopper: !this.isCalendarOpen(), targetComponent: this.renderInputContainer(), popperComponent: calendar, popperOnKeyDown: this.onPopperKeyDown, showArrow: this.props.showPopperArrow }));
    };
    return DatePicker2;
  }(Component)
);
var PRESELECT_CHANGE_VIA_INPUT = "input";
var PRESELECT_CHANGE_VIA_NAVIGATE = "navigate";
const ReactDatePicker = React__default.forwardRef((props, ref2) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(DatePicker$1, { ref: ref2, ...props });
});
ReactDatePicker.displayName = "ReactDatePicker";
const DatePickerStyles = css$3`
  .react-datepicker__year-read-view--down-arrow,
  .react-datepicker__month-read-view--down-arrow,
  .react-datepicker__month-year-read-view--down-arrow,
  .react-datepicker__navigation-icon::before {
    border-color: #ccc;
    border-style: solid;
    border-width: 3px 3px 0 0;
    content: "";
    display: block;
    height: 9px;
    position: absolute;
    top: 6px;
    width: 9px;
  }
  .react-datepicker-wrapper {
    display: inline-block;
    padding: 0;
    border: 0;
  }

  .react-datepicker {
    font-family: "Helvetica Neue", helvetica, arial, sans-serif;
    font-size: 0.8rem;
    background-color: #fff;
    color: #000;
    border: 1px solid #aeaeae;
    border-radius: 0.3rem;
    display: inline-block;
    position: relative;
    line-height: initial;
  }

  .react-datepicker--time-only .react-datepicker__time-container {
    border-left: 0;
  }
  .react-datepicker--time-only .react-datepicker__time,
  .react-datepicker--time-only .react-datepicker__time-box {
    border-bottom-left-radius: 0.3rem;
    border-bottom-right-radius: 0.3rem;
  }

  .react-datepicker-popper {
    z-index: 1;
    line-height: 0;
  }
  .react-datepicker-popper .react-datepicker__triangle {
    stroke: #aeaeae;
  }
  .react-datepicker-popper[data-placement^="bottom"]
    .react-datepicker__triangle {
    fill: #f0f0f0;
    color: #f0f0f0;
  }
  .react-datepicker-popper[data-placement^="top"] .react-datepicker__triangle {
    fill: #fff;
    color: #fff;
  }

  .react-datepicker__header {
    text-align: center;
    background-color: #f0f0f0;
    border-bottom: 1px solid #aeaeae;
    border-top-left-radius: 0.3rem;
    padding: 8px 0;
    position: relative;
  }
  .react-datepicker__header--time {
    padding-bottom: 8px;
    padding-left: 5px;
    padding-right: 5px;
  }
  .react-datepicker__header--time:not(.react-datepicker__header--time--only) {
    border-top-left-radius: 0;
  }
  .react-datepicker__header:not(.react-datepicker__header--has-time-select) {
    border-top-right-radius: 0.3rem;
  }

  .react-datepicker__year-dropdown-container--select,
  .react-datepicker__month-dropdown-container--select,
  .react-datepicker__month-year-dropdown-container--select,
  .react-datepicker__year-dropdown-container--scroll,
  .react-datepicker__month-dropdown-container--scroll,
  .react-datepicker__month-year-dropdown-container--scroll {
    display: inline-block;
    margin: 0 15px;
  }

  .react-datepicker__current-month,
  .react-datepicker-time__header,
  .react-datepicker-year-header {
    margin-top: 0;
    color: #000;
    font-weight: bold;
    font-size: 0.944rem;
  }

  h2.react-datepicker__current-month {
    padding: 0;
    margin: 0;
  }

  .react-datepicker-time__header {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }

  .react-datepicker__navigation {
    align-items: center;
    background: none;
    display: flex;
    justify-content: center;
    text-align: center;
    cursor: pointer;
    position: absolute;
    top: 2px;
    padding: 0;
    border: none;
    z-index: 1;
    height: 32px;
    width: 32px;
    text-indent: -999em;
    overflow: hidden;
  }
  .react-datepicker__navigation--previous {
    left: 2px;
  }
  .react-datepicker__navigation--next {
    right: 2px;
  }
  .react-datepicker__navigation--next--with-time:not(
      .react-datepicker__navigation--next--with-today-button
    ) {
    right: 85px;
  }
  .react-datepicker__navigation--years {
    position: relative;
    top: 0;
    display: block;
    margin-left: auto;
    margin-right: auto;
  }
  .react-datepicker__navigation--years-previous {
    top: 4px;
  }
  .react-datepicker__navigation--years-upcoming {
    top: -4px;
  }
  .react-datepicker__navigation:hover *::before {
    border-color: rgb(165.75, 165.75, 165.75);
  }

  .react-datepicker__navigation-icon {
    position: relative;
    top: -1px;
    font-size: 20px;
    width: 0;
  }
  .react-datepicker__navigation-icon--next {
    left: -2px;
  }
  .react-datepicker__navigation-icon--next::before {
    transform: rotate(45deg);
    left: -7px;
  }
  .react-datepicker__navigation-icon--previous {
    right: -2px;
  }
  .react-datepicker__navigation-icon--previous::before {
    transform: rotate(225deg);
    right: -7px;
  }

  .react-datepicker__month-container {
    float: left;
  }

  .react-datepicker__year {
    margin: 0.4rem;
    text-align: center;
  }
  .react-datepicker__year-wrapper {
    display: flex;
    flex-wrap: wrap;
    max-width: 180px;
  }
  .react-datepicker__year .react-datepicker__year-text {
    display: inline-block;
    width: 4rem;
    margin: 2px;
  }

  .react-datepicker__month {
    margin: 0.4rem;
    text-align: center;
  }
  .react-datepicker__month .react-datepicker__month-text,
  .react-datepicker__month .react-datepicker__quarter-text {
    display: inline-block;
    width: 4rem;
    margin: 2px;
  }

  .react-datepicker__input-time-container {
    clear: both;
    width: 100%;
    float: left;
    margin: 5px 0 10px 15px;
    text-align: left;
  }
  .react-datepicker__input-time-container .react-datepicker-time__caption {
    display: inline-block;
  }
  .react-datepicker__input-time-container
    .react-datepicker-time__input-container {
    display: inline-block;
  }
  .react-datepicker__input-time-container
    .react-datepicker-time__input-container
    .react-datepicker-time__input {
    display: inline-block;
    margin-left: 10px;
  }
  .react-datepicker__input-time-container
    .react-datepicker-time__input-container
    .react-datepicker-time__input
    input {
    width: auto;
  }
  .react-datepicker__input-time-container
    .react-datepicker-time__input-container
    .react-datepicker-time__input
    input[type="time"]::-webkit-inner-spin-button,
  .react-datepicker__input-time-container
    .react-datepicker-time__input-container
    .react-datepicker-time__input
    input[type="time"]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  .react-datepicker__input-time-container
    .react-datepicker-time__input-container
    .react-datepicker-time__input
    input[type="time"] {
    -moz-appearance: textfield;
  }
  .react-datepicker__input-time-container
    .react-datepicker-time__input-container
    .react-datepicker-time__input
    input[type="time"] {
    -moz-appearance: textfield;
  }
  .react-datepicker__input-time-container
    .react-datepicker-time__input-container
    .react-datepicker-time__delimiter {
    margin-left: 5px;
    display: inline-block;
  }

  .react-datepicker__time-container {
    float: right;
    border-left: 1px solid #aeaeae;
    width: 85px;
  }
  .react-datepicker__time-container--with-today-button {
    display: inline;
    border: 1px solid #aeaeae;
    border-radius: 0.3rem;
    position: absolute;
    right: -87px;
    top: 0;
  }
  .react-datepicker__time-container .react-datepicker__time {
    position: relative;
    background: white;
    border-bottom-right-radius: 0.3rem;
  }
  .react-datepicker__time-container
    .react-datepicker__time
    .react-datepicker__time-box {
    width: 85px;
    overflow-x: hidden;
    margin: 0 auto;
    text-align: center;
    border-bottom-right-radius: 0.3rem;
  }
  .react-datepicker__time-container
    .react-datepicker__time
    .react-datepicker__time-box
    ul.react-datepicker__time-list {
    list-style: none;
    margin: 0;
    height: calc(195px + 1.7rem / 2);
    overflow-y: scroll;
    padding-right: 0;
    padding-left: 0;
    width: 100%;
    box-sizing: content-box;
  }
  .react-datepicker__time-container
    .react-datepicker__time
    .react-datepicker__time-box
    ul.react-datepicker__time-list
    li.react-datepicker__time-list-item {
    height: 30px;
    padding: 5px 10px;
    white-space: nowrap;
  }
  .react-datepicker__time-container
    .react-datepicker__time
    .react-datepicker__time-box
    ul.react-datepicker__time-list
    li.react-datepicker__time-list-item:hover {
    cursor: pointer;
    background-color: #f0f0f0;
  }
  .react-datepicker__time-container
    .react-datepicker__time
    .react-datepicker__time-box
    ul.react-datepicker__time-list
    li.react-datepicker__time-list-item--selected {
    background-color: #216ba5;
    color: white;
    font-weight: bold;
  }
  .react-datepicker__time-container
    .react-datepicker__time
    .react-datepicker__time-box
    ul.react-datepicker__time-list
    li.react-datepicker__time-list-item--selected:hover {
    background-color: #216ba5;
  }
  .react-datepicker__time-container
    .react-datepicker__time
    .react-datepicker__time-box
    ul.react-datepicker__time-list
    li.react-datepicker__time-list-item--disabled {
    color: #ccc;
  }
  .react-datepicker__time-container
    .react-datepicker__time
    .react-datepicker__time-box
    ul.react-datepicker__time-list
    li.react-datepicker__time-list-item--disabled:hover {
    cursor: default;
    background-color: transparent;
  }

  .react-datepicker__week-number {
    color: #ccc;
    display: inline-block;
    width: 1.7rem;
    line-height: 1.7rem;
    text-align: center;
    margin: 0.166rem;
  }
  .react-datepicker__week-number.react-datepicker__week-number--clickable {
    cursor: pointer;
  }
  .react-datepicker__week-number.react-datepicker__week-number--clickable:not(
      .react-datepicker__week-number--selected,
      .react-datepicker__week-number--keyboard-selected
    ):hover {
    border-radius: 0.3rem;
    background-color: #f0f0f0;
  }
  .react-datepicker__week-number--selected {
    border-radius: 0.3rem;
    background-color: #216ba5;
    color: #fff;
  }
  .react-datepicker__week-number--selected:hover {
    background-color: rgb(28.75, 93.2196969697, 143.75);
  }
  .react-datepicker__week-number--keyboard-selected {
    border-radius: 0.3rem;
    background-color: rgb(41.5, 134.5606060606, 207.5);
    color: #fff;
  }
  .react-datepicker__week-number--keyboard-selected:hover {
    background-color: rgb(28.75, 93.2196969697, 143.75);
  }

  .react-datepicker__day-names {
    white-space: nowrap;
    margin-bottom: -8px;
  }

  .react-datepicker__week {
    white-space: nowrap;
  }

  .react-datepicker__day-name,
  .react-datepicker__day,
  .react-datepicker__time-name {
    color: #000;
    display: inline-block;
    width: 1.7rem;
    line-height: 1.7rem;
    text-align: center;
    margin: 0.166rem;
  }

  .react-datepicker__day,
  .react-datepicker__month-text,
  .react-datepicker__quarter-text,
  .react-datepicker__year-text {
    cursor: pointer;
  }
  .react-datepicker__day:not([aria-disabled="true"]):hover,
  .react-datepicker__month-text:not([aria-disabled="true"]):hover,
  .react-datepicker__quarter-text:not([aria-disabled="true"]):hover,
  .react-datepicker__year-text:not([aria-disabled="true"]):hover {
    border-radius: 0.3rem;
    background-color: #f0f0f0;
  }
  .react-datepicker__day--today,
  .react-datepicker__month-text--today,
  .react-datepicker__quarter-text--today,
  .react-datepicker__year-text--today {
    font-weight: bold;
  }
  .react-datepicker__day--highlighted,
  .react-datepicker__month-text--highlighted,
  .react-datepicker__quarter-text--highlighted,
  .react-datepicker__year-text--highlighted {
    border-radius: 0.3rem;
    background-color: #3dcc4a;
    color: #fff;
  }
  .react-datepicker__day--highlighted:not([aria-disabled="true"]):hover,
  .react-datepicker__month-text--highlighted:not([aria-disabled="true"]):hover,
  .react-datepicker__quarter-text--highlighted:not(
      [aria-disabled="true"]
    ):hover,
  .react-datepicker__year-text--highlighted:not([aria-disabled="true"]):hover {
    background-color: rgb(49.8551020408, 189.6448979592, 62.5632653061);
  }
  .react-datepicker__day--highlighted-custom-1,
  .react-datepicker__month-text--highlighted-custom-1,
  .react-datepicker__quarter-text--highlighted-custom-1,
  .react-datepicker__year-text--highlighted-custom-1 {
    color: magenta;
  }
  .react-datepicker__day--highlighted-custom-2,
  .react-datepicker__month-text--highlighted-custom-2,
  .react-datepicker__quarter-text--highlighted-custom-2,
  .react-datepicker__year-text--highlighted-custom-2 {
    color: green;
  }
  .react-datepicker__day--holidays,
  .react-datepicker__month-text--holidays,
  .react-datepicker__quarter-text--holidays,
  .react-datepicker__year-text--holidays {
    position: relative;
    border-radius: 0.3rem;
    background-color: #ff6803;
    color: #fff;
  }
  .react-datepicker__day--holidays .overlay,
  .react-datepicker__month-text--holidays .overlay,
  .react-datepicker__quarter-text--holidays .overlay,
  .react-datepicker__year-text--holidays .overlay {
    position: absolute;
    bottom: 100%;
    left: 50%;
    transform: translateX(-50%);
    background-color: #333;
    color: #fff;
    padding: 4px;
    border-radius: 4px;
    white-space: nowrap;
    visibility: hidden;
    opacity: 0;
    transition: visibility 0s, opacity 0.3s ease-in-out;
  }
  .react-datepicker__day--holidays:not([aria-disabled="true"]):hover,
  .react-datepicker__month-text--holidays:not([aria-disabled="true"]):hover,
  .react-datepicker__quarter-text--holidays:not([aria-disabled="true"]):hover,
  .react-datepicker__year-text--holidays:not([aria-disabled="true"]):hover {
    background-color: rgb(207, 82.9642857143, 0);
  }
  .react-datepicker__day--holidays:hover .overlay,
  .react-datepicker__month-text--holidays:hover .overlay,
  .react-datepicker__quarter-text--holidays:hover .overlay,
  .react-datepicker__year-text--holidays:hover .overlay {
    visibility: visible;
    opacity: 1;
  }
  .react-datepicker__day--selected,
  .react-datepicker__day--in-selecting-range,
  .react-datepicker__day--in-range,
  .react-datepicker__month-text--selected,
  .react-datepicker__month-text--in-selecting-range,
  .react-datepicker__month-text--in-range,
  .react-datepicker__quarter-text--selected,
  .react-datepicker__quarter-text--in-selecting-range,
  .react-datepicker__quarter-text--in-range,
  .react-datepicker__year-text--selected,
  .react-datepicker__year-text--in-selecting-range,
  .react-datepicker__year-text--in-range {
    border-radius: 0.3rem;
    background-color: #216ba5;
    color: #fff;
  }
  .react-datepicker__day--selected:not([aria-disabled="true"]):hover,
  .react-datepicker__day--in-selecting-range:not([aria-disabled="true"]):hover,
  .react-datepicker__day--in-range:not([aria-disabled="true"]):hover,
  .react-datepicker__month-text--selected:not([aria-disabled="true"]):hover,
  .react-datepicker__month-text--in-selecting-range:not(
      [aria-disabled="true"]
    ):hover,
  .react-datepicker__month-text--in-range:not([aria-disabled="true"]):hover,
  .react-datepicker__quarter-text--selected:not([aria-disabled="true"]):hover,
  .react-datepicker__quarter-text--in-selecting-range:not(
      [aria-disabled="true"]
    ):hover,
  .react-datepicker__quarter-text--in-range:not([aria-disabled="true"]):hover,
  .react-datepicker__year-text--selected:not([aria-disabled="true"]):hover,
  .react-datepicker__year-text--in-selecting-range:not(
      [aria-disabled="true"]
    ):hover,
  .react-datepicker__year-text--in-range:not([aria-disabled="true"]):hover {
    background-color: rgb(28.75, 93.2196969697, 143.75);
  }
  .react-datepicker__day--keyboard-selected,
  .react-datepicker__month-text--keyboard-selected,
  .react-datepicker__quarter-text--keyboard-selected,
  .react-datepicker__year-text--keyboard-selected {
    border-radius: 0.3rem;
    background-color: rgb(186.25, 217.0833333333, 241.25);
    color: rgb(0, 0, 0);
  }
  .react-datepicker__day--keyboard-selected:not([aria-disabled="true"]):hover,
  .react-datepicker__month-text--keyboard-selected:not(
      [aria-disabled="true"]
    ):hover,
  .react-datepicker__quarter-text--keyboard-selected:not(
      [aria-disabled="true"]
    ):hover,
  .react-datepicker__year-text--keyboard-selected:not(
      [aria-disabled="true"]
    ):hover {
    background-color: rgb(28.75, 93.2196969697, 143.75);
  }
  .react-datepicker__day--in-selecting-range:not(
      .react-datepicker__day--in-range,
      .react-datepicker__month-text--in-range,
      .react-datepicker__quarter-text--in-range,
      .react-datepicker__year-text--in-range
    ),
  .react-datepicker__month-text--in-selecting-range:not(
      .react-datepicker__day--in-range,
      .react-datepicker__month-text--in-range,
      .react-datepicker__quarter-text--in-range,
      .react-datepicker__year-text--in-range
    ),
  .react-datepicker__quarter-text--in-selecting-range:not(
      .react-datepicker__day--in-range,
      .react-datepicker__month-text--in-range,
      .react-datepicker__quarter-text--in-range,
      .react-datepicker__year-text--in-range
    ),
  .react-datepicker__year-text--in-selecting-range:not(
      .react-datepicker__day--in-range,
      .react-datepicker__month-text--in-range,
      .react-datepicker__quarter-text--in-range,
      .react-datepicker__year-text--in-range
    ) {
    background-color: rgba(33, 107, 165, 0.5);
  }
  .react-datepicker__month--selecting-range
    .react-datepicker__day--in-range:not(
      .react-datepicker__day--in-selecting-range,
      .react-datepicker__month-text--in-selecting-range,
      .react-datepicker__quarter-text--in-selecting-range,
      .react-datepicker__year-text--in-selecting-range
    ),
  .react-datepicker__year--selecting-range
    .react-datepicker__day--in-range:not(
      .react-datepicker__day--in-selecting-range,
      .react-datepicker__month-text--in-selecting-range,
      .react-datepicker__quarter-text--in-selecting-range,
      .react-datepicker__year-text--in-selecting-range
    ),
  .react-datepicker__month--selecting-range
    .react-datepicker__month-text--in-range:not(
      .react-datepicker__day--in-selecting-range,
      .react-datepicker__month-text--in-selecting-range,
      .react-datepicker__quarter-text--in-selecting-range,
      .react-datepicker__year-text--in-selecting-range
    ),
  .react-datepicker__year--selecting-range
    .react-datepicker__month-text--in-range:not(
      .react-datepicker__day--in-selecting-range,
      .react-datepicker__month-text--in-selecting-range,
      .react-datepicker__quarter-text--in-selecting-range,
      .react-datepicker__year-text--in-selecting-range
    ),
  .react-datepicker__month--selecting-range
    .react-datepicker__quarter-text--in-range:not(
      .react-datepicker__day--in-selecting-range,
      .react-datepicker__month-text--in-selecting-range,
      .react-datepicker__quarter-text--in-selecting-range,
      .react-datepicker__year-text--in-selecting-range
    ),
  .react-datepicker__year--selecting-range
    .react-datepicker__quarter-text--in-range:not(
      .react-datepicker__day--in-selecting-range,
      .react-datepicker__month-text--in-selecting-range,
      .react-datepicker__quarter-text--in-selecting-range,
      .react-datepicker__year-text--in-selecting-range
    ),
  .react-datepicker__month--selecting-range
    .react-datepicker__year-text--in-range:not(
      .react-datepicker__day--in-selecting-range,
      .react-datepicker__month-text--in-selecting-range,
      .react-datepicker__quarter-text--in-selecting-range,
      .react-datepicker__year-text--in-selecting-range
    ),
  .react-datepicker__year--selecting-range
    .react-datepicker__year-text--in-range:not(
      .react-datepicker__day--in-selecting-range,
      .react-datepicker__month-text--in-selecting-range,
      .react-datepicker__quarter-text--in-selecting-range,
      .react-datepicker__year-text--in-selecting-range
    ) {
    background-color: #f0f0f0;
    color: #000;
  }
  .react-datepicker__day--disabled,
  .react-datepicker__month-text--disabled,
  .react-datepicker__quarter-text--disabled,
  .react-datepicker__year-text--disabled {
    cursor: default;
    color: #ccc;
  }
  .react-datepicker__day--disabled .overlay,
  .react-datepicker__month-text--disabled .overlay,
  .react-datepicker__quarter-text--disabled .overlay,
  .react-datepicker__year-text--disabled .overlay {
    position: absolute;
    bottom: 70%;
    left: 50%;
    transform: translateX(-50%);
    background-color: #333;
    color: #fff;
    padding: 4px;
    border-radius: 4px;
    white-space: nowrap;
    visibility: hidden;
    opacity: 0;
    transition: visibility 0s, opacity 0.3s ease-in-out;
  }

  .react-datepicker__input-container {
    position: relative;
    display: inline-block;
    width: 100%;
  }
  .react-datepicker__input-container .react-datepicker__calendar-icon {
    position: absolute;
    padding: 0.5rem;
    box-sizing: content-box;
  }

  .react-datepicker__view-calendar-icon input {
    padding: 6px 10px 5px 25px;
  }

  .react-datepicker__year-read-view,
  .react-datepicker__month-read-view,
  .react-datepicker__month-year-read-view {
    border: 1px solid transparent;
    border-radius: 0.3rem;
    position: relative;
  }
  .react-datepicker__year-read-view:hover,
  .react-datepicker__month-read-view:hover,
  .react-datepicker__month-year-read-view:hover {
    cursor: pointer;
  }
  .react-datepicker__year-read-view:hover
    .react-datepicker__year-read-view--down-arrow,
  .react-datepicker__year-read-view:hover
    .react-datepicker__month-read-view--down-arrow,
  .react-datepicker__month-read-view:hover
    .react-datepicker__year-read-view--down-arrow,
  .react-datepicker__month-read-view:hover
    .react-datepicker__month-read-view--down-arrow,
  .react-datepicker__month-year-read-view:hover
    .react-datepicker__year-read-view--down-arrow,
  .react-datepicker__month-year-read-view:hover
    .react-datepicker__month-read-view--down-arrow {
    border-top-color: rgb(178.5, 178.5, 178.5);
  }
  .react-datepicker__year-read-view--down-arrow,
  .react-datepicker__month-read-view--down-arrow,
  .react-datepicker__month-year-read-view--down-arrow {
    transform: rotate(135deg);
    right: -16px;
    top: 0;
  }

  .react-datepicker__year-dropdown,
  .react-datepicker__month-dropdown,
  .react-datepicker__month-year-dropdown {
    background-color: #f0f0f0;
    position: absolute;
    width: 50%;
    left: 25%;
    top: 30px;
    z-index: 1;
    text-align: center;
    border-radius: 0.3rem;
    border: 1px solid #aeaeae;
  }
  .react-datepicker__year-dropdown:hover,
  .react-datepicker__month-dropdown:hover,
  .react-datepicker__month-year-dropdown:hover {
    cursor: pointer;
  }
  .react-datepicker__year-dropdown--scrollable,
  .react-datepicker__month-dropdown--scrollable,
  .react-datepicker__month-year-dropdown--scrollable {
    height: 150px;
    overflow-y: scroll;
  }

  .react-datepicker__year-option,
  .react-datepicker__month-option,
  .react-datepicker__month-year-option {
    line-height: 20px;
    width: 100%;
    display: block;
    margin-left: auto;
    margin-right: auto;
  }
  .react-datepicker__year-option:first-of-type,
  .react-datepicker__month-option:first-of-type,
  .react-datepicker__month-year-option:first-of-type {
    border-top-left-radius: 0.3rem;
    border-top-right-radius: 0.3rem;
  }
  .react-datepicker__year-option:last-of-type,
  .react-datepicker__month-option:last-of-type,
  .react-datepicker__month-year-option:last-of-type {
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    border-bottom-left-radius: 0.3rem;
    border-bottom-right-radius: 0.3rem;
  }
  .react-datepicker__year-option:hover,
  .react-datepicker__month-option:hover,
  .react-datepicker__month-year-option:hover {
    background-color: #ccc;
  }
  .react-datepicker__year-option:hover
    .react-datepicker__navigation--years-upcoming,
  .react-datepicker__month-option:hover
    .react-datepicker__navigation--years-upcoming,
  .react-datepicker__month-year-option:hover
    .react-datepicker__navigation--years-upcoming {
    border-bottom-color: rgb(178.5, 178.5, 178.5);
  }
  .react-datepicker__year-option:hover
    .react-datepicker__navigation--years-previous,
  .react-datepicker__month-option:hover
    .react-datepicker__navigation--years-previous,
  .react-datepicker__month-year-option:hover
    .react-datepicker__navigation--years-previous {
    border-top-color: rgb(178.5, 178.5, 178.5);
  }
  .react-datepicker__year-option--selected,
  .react-datepicker__month-option--selected,
  .react-datepicker__month-year-option--selected {
    position: absolute;
    left: 15px;
  }

  .react-datepicker__close-icon {
    cursor: pointer;
    background-color: transparent;
    border: 0;
    outline: 0;
    padding: 0 6px 0 0;
    position: absolute;
    top: 0;
    right: 0;
    height: 100%;
    display: table-cell;
    vertical-align: middle;
  }
  .react-datepicker__close-icon::after {
    cursor: pointer;
    background-color: #216ba5;
    color: #fff;
    border-radius: 50%;
    height: 16px;
    width: 16px;
    padding: 2px;
    font-size: 12px;
    line-height: 1;
    text-align: center;
    display: table-cell;
    vertical-align: middle;
    content: "×";
  }
  .react-datepicker__close-icon--disabled {
    cursor: default;
  }
  .react-datepicker__close-icon--disabled::after {
    cursor: default;
    background-color: #ccc;
  }

  .react-datepicker__today-button {
    background: #f0f0f0;
    border-top: 1px solid #aeaeae;
    cursor: pointer;
    text-align: center;
    font-weight: bold;
    padding: 5px 0;
    clear: left;
  }

  .react-datepicker__portal {
    position: fixed;
    width: 100vw;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.8);
    left: 0;
    top: 0;
    justify-content: center;
    align-items: center;
    display: flex;
    z-index: 2147483647;
  }
  .react-datepicker__portal .react-datepicker__day-name,
  .react-datepicker__portal .react-datepicker__day,
  .react-datepicker__portal .react-datepicker__time-name {
    width: 3rem;
    line-height: 3rem;
  }
  @media (max-width: 400px), (max-height: 550px) {
    .react-datepicker__portal .react-datepicker__day-name,
    .react-datepicker__portal .react-datepicker__day,
    .react-datepicker__portal .react-datepicker__time-name {
      width: 2rem;
      line-height: 2rem;
    }
  }
  .react-datepicker__portal .react-datepicker__current-month,
  .react-datepicker__portal .react-datepicker-time__header {
    font-size: 1.44rem;
  }

  .react-datepicker__children-container {
    width: 13.8rem;
    margin: 0.4rem;
    padding-right: 0.2rem;
    padding-left: 0.2rem;
    height: auto;
  }

  .react-datepicker__aria-live {
    position: absolute;
    clip-path: circle(0);
    border: 0;
    height: 1px;
    margin: -1px;
    overflow: hidden;
    padding: 0;
    width: 1px;
    white-space: nowrap;
  }

  .react-datepicker__calendar-icon {
    width: 1em;
    height: 1em;
    vertical-align: -0.125em;
  }
`;
const StyledWrapper$1 = styled.div`
  ${css$3`
    ${DatePickerStyles}
    fill: var(${TOKENS.color.border.interaction.neutralSelected});
    .react-datepicker__day.react-datepicker__day--keyboard-selected {
      border: none;
      border-radius: 7px;
      background-color: var(${TOKENS.color.border.interaction.neutralSelected});
      color: var(${TOKENS.color.foreground.interaction.onSelected});
    }

    .react-datepicker-popper .react-datepicker__navigation {
      padding-top: var(${TOKENS.dimension.space["4"]});
      color: var(${TOKENS.color.foreground.interaction.accent});
    }

    .react-datepicker {
      box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.189);
      border: none !important;
      font-family: var(${TOKENS.text.fontFamily.primary});
      min-width: 368px;
      min-height: 402px;
    }

    .react-datepicker__month-container {
      width: 368px;
    }

    .react-datepicker__header {
      border-bottom: solid 5px var(--light) !important;
      background: var(${TOKENS.color.background.surface0});
    }

    .react-datepicker__current-month {
      color: var(--dark) !important;
    }

    .react-datepicker__day.react-datepicker__day--today {
      border-radius: 7px;
      border: solid 2px var(--brand) !important;
      background-color: var(${TOKENS.color.background.surface0});
      //color: var(--dark) !important;
      width: 30px;
    }

    .react-datepicker__day.react-datepicker__day--selected {
      border: none;
      border-radius: 7px;
      background-color: var(
        ${TOKENS.color.background.interaction.neutralSelected}
      );
      box-sizing: unset;
      color: var(${TOKENS.color.foreground.interaction.onSelected});
    }

    .react-datepicker__day.react-datepicker__day--selected:hover {
      border-radius: 7px;
      background-color: var(
        ${TOKENS.color.background.interaction.neutralSelectedHover}
      );
    }

    .react-datepicker__day {
      width: 2.5rem !important;
      height: 2.5rem;
      font-size: 16px;
      line-height: 2.5rem;
    }

    .react-datepicker__day-names {
      font-size: 16px;
    }

    .react-datepicker__day-name {
      width: 2.5rem !important;
      color: #6e6e6e;
    }

    .react-datepicker__day.react-datepicker__day--today:hover {
      background-color: var(
        ${TOKENS.color.background.interaction.neutralHover}
      );
      color: var(${TOKENS.color.foreground.default});
    }

    .react-datepicker__year-text--in-range:hover {
      border: none;
      border-radius: 7px !important;
      color: var(--dark) !important;
    }
    .react-datepicker-wrapper {
      width: 100%;
    }
  `}
`;
const StyledCalendarHeader$1 = styled.div`
  display: flex;
  justify-content: center;
  align-content: space-between;
  gap: 4px;
  padding: 32px 24px 24px 24px;
`;
const StyledCustomInput = styled(DateInput)`
  min-width: 368px;
  padding-top: 1px;
`;
const StyledHeader$1 = styled.div`
  display: flex;
  gap: 4px;
  width: 272px;
  height: 30px;
  justify-content: center;
  align-items: baseline;
`;
const StyledHeaderWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;
const StyledCaretLeftIcon$1 = styled(CaretLeftIcon)`
  ${css$3`
    fill: var(${TOKENS.color.foreground.interaction.accent});
  `};
`;
const StyledCaretRightIcon$1 = styled(CaretRightIcon)`
  ${css$3`
    fill: var(${TOKENS.color.foreground.interaction.accent});
  `};
`;
const CustomInput = React__default.forwardRef((props, _ref3) => {
  const [value, setValue] = useState("");
  useEffect(() => {
    if (props.date) {
      setValue(props.date.toLocaleDateString("en-US", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit"
      }));
    }
  }, [props.date]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(StyledCustomInput, { id: props.id ?? "date-picker", label: props.label ?? "Date", type: "text", iconRight: /* @__PURE__ */ jsxRuntimeExports.jsx(CalendarIcon$1, {}), onClick: () => {
    var _a2;
    (_a2 = props.onClick) == null ? void 0 : _a2.call(props, props.date);
    if (props.date) {
      setValue(props.date.toLocaleDateString("en-US", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit"
      }));
    }
  }, onChange: (e3) => {
    setValue(e3.target.value);
    if (e3.target.value.length === 10) {
      props.handleDateChange(new Date(e3.target.value));
    }
  }, defaultValue: "", value, disabled: props.disabled });
});
const DatePicker = React__default.forwardRef(({
  label,
  selected,
  subHeaderItem,
  selectsRange: _2,
  selectsMultiple: __,
  ...props
}, ref2) => {
  const selectedDate = selected ? new Date(selected) : void 0;
  const customInput = /* @__PURE__ */ jsxRuntimeExports.jsx(CustomInput, { handleDateChange: (date) => {
    var _a2;
    return (_a2 = props.onChange) == null ? void 0 : _a2.call(props, date);
  }, date: selectedDate, ref: ref2, label, disabled: props.disabled });
  const stayWithinWindowBoundsModifier = useMemo(() => size({
    apply({
      availableHeight,
      availableWidth,
      elements
    }) {
      Object.assign(elements.floating.style, {
        maxHeight: `${availableHeight}px`,
        maxWidth: `${availableWidth}px`
      });
    }
  }), []);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(StyledWrapper$1, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(ReactDatePicker, { ...props, popperModifiers: [stayWithinWindowBoundsModifier, ...props.popperModifiers ?? []], showPopperArrow: false, formatWeekDay: (nameOfDay) => nameOfDay.substr(0, 1), renderCustomHeader: ({
    date,
    decreaseMonth,
    increaseMonth
  }) => {
    return /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledHeaderWrapper, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledCalendarHeader$1, { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(StyledCaretLeftIcon$1, { onClick: decreaseMonth, fill: "" }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledHeader$1, { children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(Text, { element: "h2", variant: "headerMedium.desktop", children: date.toLocaleString("default", {
            month: "long"
          }) }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(Text, { element: "h2", variant: "bodyLarge.desktop", children: date.getFullYear() })
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(StyledCaretRightIcon$1, { onClick: increaseMonth })
      ] }),
      subHeaderItem
    ] });
  }, selected: selectedDate, onChange: (date) => {
    var _a2;
    if (date) {
      (_a2 = props.onChange) == null ? void 0 : _a2.call(props, date);
    }
  }, openToDate: props.openToDate ?? selectedDate ?? /* @__PURE__ */ new Date(), customInput, disabledKeyboardNavigation: true }) });
});
DatePicker.displayName = "DatePicker";
const ReactDateRangePicker = (props) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(DatePicker$1, { ...props });
};
const StyledWrapper = styled.div`
  ${css$3`
    ${DatePickerStyles}
    fill: var(${TOKENS.color.border.interaction.neutralSelected});

    .react-datepicker-popper .react-datepicker__navigation {
      padding-top: var(${TOKENS.dimension.space["4"]});
      color: var(${TOKENS.color.foreground.interaction.accent});
    }

    .react-datepicker {
      box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.189);
      border: none !important;
      font-family: var(${TOKENS.text.fontFamily.primary});
      min-width: 368px;
      min-height: 402px;
    }

    .react-datepicker__month-container {
      width: 368px;
    }

    .react-datepicker__header {
      border-bottom: solid 5px var(--light) !important;
      background: var(${TOKENS.color.background.surface0});
    }

    .react-datepicker__current-month {
      color: var(--dark) !important;
    }

    .react-datepicker__day {
      width: 2.5rem !important;
      height: 2.5rem;
      font-size: 16px;
      line-height: 2.5rem;
    }

    .react-datepicker__day-names {
      font-size: 16px;
    }

    .react-datepicker__day-name {
      width: 2.5rem !important;
      color: #6e6e6e;
    }

    // Range picker styles
    .react-datepicker__day:not([aria-disabled="true"]):hover {
      background-color: var(${TOKENS.color.background.interaction.neutralHover});
    }

    .react-datepicker__day--in-selecting-range:not(
        [aria-disabled="true"]
      ):hover {
      background-color: var(
        ${TOKENS.color.background.interaction.neutralSelectedHover}
      );
    }

    .react-datepicker__day--in-selecting-range:not(
        .react-datepicker__day--in-range,
        .react-datepicker__month-text--in-range,
        .react-datepicker__quarter-text--in-range,
        .react-datepicker__year-text--in-range
      ) {
      background-color: var(
        ${TOKENS.color.background.interaction.neutralSelected}
      );
      color: var(${TOKENS.color.foreground.interaction.onSelected});
    }

    .react-datepicker__day--in-range {
      background-color: var(
        ${TOKENS.color.background.interaction.neutralSelected}
      );
      color: var(${TOKENS.color.foreground.interaction.onSelected});
    }

    .react-datepicker__day--in-range:not([aria-disabled="true"]):hover {
      background-color: var(
        ${TOKENS.color.background.interaction.neutralSelectedHover}
      );
    }

    .react-datepicker__day--range-start {
      background-color: var(
        ${TOKENS.color.background.interaction.neutralSelectedHover}
      );
    }

    .react-datepicker__day--range-end {
      background-color: var(
        ${TOKENS.color.background.interaction.neutralSelectedHover}
      );
    }
  `}
`;
const StyledCalendarHeader = styled.div`
  display: flex;
  justifycontent: center;
  aligncontent: space-between;
  gap: 4px;
  padding: 32px 24px 24px 24px;
`;
const StyledCustomRangeInput = styled(TextInput)`
  min-width: 300px;
  padding-top: 1px;
`;
const StyledHeader = styled.div`
  display: flex;
  gap: 4px;
  width: 272px;
  height: 30px;
  justify-content: center;
  align-items: baseline;
`;
const StyledCaretLeftIcon = styled(CaretLeftIcon)`
  ${css$3`
    fill: var(${TOKENS.color.foreground.interaction.accent});
  `};
`;
const StyledCaretRightIcon = styled(CaretRightIcon)`
  ${css$3`
    fill: var(${TOKENS.color.foreground.interaction.accent});
  `};
`;
const dateRangeCleaveOptions = {
  blocks: [2, 2, 4, 2, 2, 4],
  delimiters: ["/", "/", " - ", "/", "/"],
  delimiterLazyShow: true
};
const CustomRangeInput = React__default.forwardRef(({
  id: id2,
  label,
  value,
  onClick,
  onChange: onChange2,
  onClear,
  forwardedRef,
  className
}, ref2) => {
  const formatter = (internalValue) => {
    return s$1(internalValue, dateRangeCleaveOptions);
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(StyledCustomRangeInput, { mask: value ? void 0 : "mm/dd/yyyy - mm/dd/yyyy", id: id2, label: label || "Date Range", type: "text", defaultValue: "", value, onClick, onChange: onChange2, formatter, iconRight: onClear ? /* @__PURE__ */ jsxRuntimeExports.jsx(CloseIcon, { size: "sm", cursor: "pointer", onClick: onClear }) : /* @__PURE__ */ jsxRuntimeExports.jsx(CalendarIcon$1, {}), ref: forwardedRef || ref2, className });
});
const DateRangePicker = React__default.forwardRef((props, forwardRef2) => {
  const {
    onChange: onChange2,
    value,
    defaultValue,
    clearable,
    maxDate,
    minDate,
    id: id2,
    label,
    className,
    popperPlacement
  } = props;
  const [valueStartDate, valueEndDate] = value || [];
  const externalStartDate = valueStartDate ? new Date(valueStartDate) : null;
  const externalEndDate = valueEndDate ? new Date(valueEndDate) : null;
  const ref2 = useRef(null);
  const [dateRange, setDateRange] = useState([null, null]);
  const [startDate, endDate] = dateRange;
  useEffect(() => {
    if ((defaultValue == null ? void 0 : defaultValue[0]) || (defaultValue == null ? void 0 : defaultValue[1])) {
      setDateRange(defaultValue);
    }
  }, [defaultValue]);
  const handleDateRangeChange = (update) => {
    setDateRange(update);
    if (onChange2) {
      const dateStrings = [update[0] ? `${update[0].getFullYear()}-${String(update[0].getMonth() + 1).padStart(2, "0")}-${String(update[0].getDate()).padStart(2, "0")}` : null, update[1] ? `${update[1].getFullYear()}-${String(update[1].getMonth() + 1).padStart(2, "0")}-${String(update[1].getDate()).padStart(2, "0")}` : null];
      const safeDates = [dateStrings[0] ? /* @__PURE__ */ new Date(`${dateStrings[0]}T12:00:00.000Z`) : null, dateStrings[1] ? /* @__PURE__ */ new Date(`${dateStrings[1]}T12:00:00.000Z`) : null];
      onChange2(safeDates);
    }
  };
  const handleClearDateRange = () => {
    setDateRange([null, null]);
    if (onChange2) {
      onChange2([null, null]);
    }
  };
  const isClearable = clearable && (startDate || endDate);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(StyledWrapper, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(ReactDateRangePicker, { popperProps: {
    strategy: "fixed"
  }, id: id2, selectsRange: true, popperPlacement, strictParsing: true, startDate: externalStartDate || (startDate ?? void 0), endDate: externalEndDate || (endDate ?? void 0), maxDate, minDate, onChange: handleDateRangeChange, showPopperArrow: false, formatWeekDay: (nameOfDay) => nameOfDay.substr(0, 1), renderCustomHeader: ({
    date,
    decreaseMonth,
    increaseMonth
  }) => {
    return /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledCalendarHeader, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(StyledCaretLeftIcon, { onClick: decreaseMonth, fill: "" }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledHeader, { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(Text, { element: "h2", variant: "headerMedium.desktop", children: new Date(date).toLocaleString("default", {
          month: "long"
        }) }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Text, { element: "h2", variant: "bodyLarge.desktop", children: new Date(date).getFullYear() })
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(StyledCaretRightIcon, { onClick: increaseMonth })
    ] });
  }, disabledKeyboardNavigation: true, customInput: (
    // eslint-disable-next-line react/jsx-wrap-multilines
    /* @__PURE__ */ jsxRuntimeExports.jsx(CustomRangeInput, { id: `${id2}-input`, label, ref: ref2, forwardedRef: forwardRef2, onClear: isClearable ? handleClearDateRange : void 0, className })
  ) }) });
});
DateRangePicker.displayName = "DateRangePicker";
const GhostChartContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;
const GhostYAxis = styled.div`
  width: 15%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: flex-end;
  padding-right: 15px;
`;
const GhostXAxis = styled.div`
  width: 100%;
  height: 15%;
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  align-items: flex-start;
  padding-top: 20px;
  padding-left: 100px;
`;
const GhostRow = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 100%;
`;
const shimmer = keyframes$1`
  0% {
    background-position: -200% 0;
  }
  100% {
    background-position: 200% 0;
  }
`;
const GhostBox = styled.div`
  width: 60px;
  height: 20px;
  background: linear-gradient(90deg, #cccccc 25%, #e0e0e0 50%, #cccccc 75%);
  background-size: 200% 100%;
  animation: ${shimmer} 1.5s infinite;
  border-radius: 4px;

  @media (max-width: ${BREAKPOINTS.sm}) {
    width: 40px;
  }
`;
const GhostChart = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  border-left: 1px solid #e4e7ec;
  border-bottom: 1px solid #e4e7ec;
  width: 85%;
  height: 100%;
`;
const LoadingChart = forwardRef((_2, ref2) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(GhostChartContainer, { ...ref2, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs(GhostRow, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs(GhostYAxis, { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(GhostBox, {}),
        /* @__PURE__ */ jsxRuntimeExports.jsx(GhostBox, {}),
        /* @__PURE__ */ jsxRuntimeExports.jsx(GhostBox, {}),
        /* @__PURE__ */ jsxRuntimeExports.jsx(GhostBox, {})
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(GhostChart, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(Spinner, { size: "large" }) })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(GhostXAxis, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(GhostBox, {}),
      /* @__PURE__ */ jsxRuntimeExports.jsx(GhostBox, {}),
      /* @__PURE__ */ jsxRuntimeExports.jsx(GhostBox, {}),
      /* @__PURE__ */ jsxRuntimeExports.jsx(GhostBox, {})
    ] })
  ] });
});
LoadingChart.displayName = "LoadingChart";
const TooltipContainer = styled.div`
  background-color: white;
  padding: 20px;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-shadow: rgba(0, 0, 0, 0.2) 0px 0px 2px 0px,
    rgba(0, 0, 0, 0.08) 0px 3px 10px 0px;
  z-index: 99999;
`;
const TooltipContentContainer = styled.div`
  margin-top: 6px;
`;
const TooltipRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 4px;
`;
const TooltipSublabel = styled(Text)`
  color: var(${TOKENS.color.foreground.subdued});
  margin-left: 15px;
`;
const ColorBox = styled.div`
  width: 10px;
  height: 10px;
  background-color: ${({
  color: color2
}) => color2};
  margin-bottom: 3px;
`;
const LabelText = styled(Text)`
  color: var(${TOKENS.color.foreground.subdued});
  text-align: center;
`;
const SublabelText = styled(Text)`
  color: var(${TOKENS.color.foreground.default});
  text-align: center;
  font-weight: 400;
`;
const LabelGroup = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
`;
const currencyFormatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  minimumFractionDigits: 0,
  maximumFractionDigits: 0
});
const numberFormatter = new Intl.NumberFormat("en-US", {
  minimumFractionDigits: 0,
  maximumFractionDigits: 0
});
const ChartTooltip = forwardRef(({
  xAxis,
  tooltipItems,
  data
}, ref2) => {
  function formatValue(value, isCurrency, isPercentage) {
    if (isCurrency) {
      return currencyFormatter.format(value);
    }
    if (isPercentage) {
      return `${(value * 100).toFixed(2)}%`;
    }
    return numberFormatter.format(value);
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(TooltipContainer, { ...ref2, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(LabelText, { variant: "labelXSmall.responsive", element: "p", children: `${xAxis.label} ${data[xAxis.labelKey]}` }),
    xAxis.sublabelKey && xAxis.sublabel && /* @__PURE__ */ jsxRuntimeExports.jsx(SublabelText, { variant: "headerSmall.responsive", element: "p", children: `${xAxis.sublabel}: ${data[xAxis.sublabelKey]}` }),
    tooltipItems.map((item) => /* @__PURE__ */ jsxRuntimeExports.jsxs(TooltipContentContainer, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs(TooltipRow, { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsxs(LabelGroup, { children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(ColorBox, { color: item.color }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(Text, { variant: "bodySmall.responsive", element: "p", children: `${item.label}:` })
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Text, { variant: "headerXSmall.responsive", element: "p", children: `${formatValue(data[item.key], item.isCurrency, item.isPercentage)}` })
      ] }),
      item.sublabel && /* @__PURE__ */ jsxRuntimeExports.jsx(TooltipRow, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(TooltipSublabel, { variant: "bodyXSmall.responsive", element: "p", children: item.sublabel }) })
    ] }, item.key))
  ] });
});
ChartTooltip.displayName = "ChartTooltip";
var isArray$8 = Array.isArray;
var isArray_1 = isArray$8;
var freeGlobal$1 = typeof commonjsGlobal == "object" && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;
var _freeGlobal = freeGlobal$1;
var freeGlobal = _freeGlobal;
var freeSelf = typeof self == "object" && self && self.Object === Object && self;
var root$8 = freeGlobal || freeSelf || Function("return this")();
var _root = root$8;
var root$7 = _root;
var Symbol$6 = root$7.Symbol;
var _Symbol = Symbol$6;
var Symbol$5 = _Symbol;
var objectProto$b = Object.prototype;
var hasOwnProperty$8 = objectProto$b.hasOwnProperty;
var nativeObjectToString$1 = objectProto$b.toString;
var symToStringTag$1 = Symbol$5 ? Symbol$5.toStringTag : void 0;
function getRawTag$1(value) {
  var isOwn = hasOwnProperty$8.call(value, symToStringTag$1), tag = value[symToStringTag$1];
  try {
    value[symToStringTag$1] = void 0;
    var unmasked = true;
  } catch (e3) {
  }
  var result = nativeObjectToString$1.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag$1] = tag;
    } else {
      delete value[symToStringTag$1];
    }
  }
  return result;
}
var _getRawTag = getRawTag$1;
var objectProto$a = Object.prototype;
var nativeObjectToString = objectProto$a.toString;
function objectToString$1(value) {
  return nativeObjectToString.call(value);
}
var _objectToString = objectToString$1;
var Symbol$4 = _Symbol, getRawTag = _getRawTag, objectToString = _objectToString;
var nullTag = "[object Null]", undefinedTag = "[object Undefined]";
var symToStringTag = Symbol$4 ? Symbol$4.toStringTag : void 0;
function baseGetTag$6(value) {
  if (value == null) {
    return value === void 0 ? undefinedTag : nullTag;
  }
  return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
}
var _baseGetTag = baseGetTag$6;
function isObjectLike$6(value) {
  return value != null && typeof value == "object";
}
var isObjectLike_1 = isObjectLike$6;
var baseGetTag$5 = _baseGetTag, isObjectLike$5 = isObjectLike_1;
var symbolTag$1 = "[object Symbol]";
function isSymbol$3(value) {
  return typeof value == "symbol" || isObjectLike$5(value) && baseGetTag$5(value) == symbolTag$1;
}
var isSymbol_1 = isSymbol$3;
var isArray$7 = isArray_1, isSymbol$2 = isSymbol_1;
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/;
function isKey$3(value, object2) {
  if (isArray$7(value)) {
    return false;
  }
  var type2 = typeof value;
  if (type2 == "number" || type2 == "symbol" || type2 == "boolean" || value == null || isSymbol$2(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object2 != null && value in Object(object2);
}
var _isKey = isKey$3;
function isObject$3(value) {
  var type2 = typeof value;
  return value != null && (type2 == "object" || type2 == "function");
}
var isObject_1 = isObject$3;
var isObject$4 = /* @__PURE__ */ getDefaultExportFromCjs(isObject_1);
var baseGetTag$4 = _baseGetTag, isObject$2 = isObject_1;
var asyncTag = "[object AsyncFunction]", funcTag$1 = "[object Function]", genTag = "[object GeneratorFunction]", proxyTag = "[object Proxy]";
function isFunction$2(value) {
  if (!isObject$2(value)) {
    return false;
  }
  var tag = baseGetTag$4(value);
  return tag == funcTag$1 || tag == genTag || tag == asyncTag || tag == proxyTag;
}
var isFunction_1 = isFunction$2;
var isFunction$3 = /* @__PURE__ */ getDefaultExportFromCjs(isFunction_1);
var root$6 = _root;
var coreJsData$1 = root$6["__core-js_shared__"];
var _coreJsData = coreJsData$1;
var coreJsData = _coreJsData;
var maskSrcKey = function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
  return uid ? "Symbol(src)_1." + uid : "";
}();
function isMasked$1(func) {
  return !!maskSrcKey && maskSrcKey in func;
}
var _isMasked = isMasked$1;
var funcProto$1 = Function.prototype;
var funcToString$1 = funcProto$1.toString;
function toSource$2(func) {
  if (func != null) {
    try {
      return funcToString$1.call(func);
    } catch (e3) {
    }
    try {
      return func + "";
    } catch (e3) {
    }
  }
  return "";
}
var _toSource = toSource$2;
var isFunction$1 = isFunction_1, isMasked = _isMasked, isObject$1 = isObject_1, toSource$1 = _toSource;
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
var reIsHostCtor = /^\[object .+?Constructor\]$/;
var funcProto = Function.prototype, objectProto$9 = Object.prototype;
var funcToString = funcProto.toString;
var hasOwnProperty$7 = objectProto$9.hasOwnProperty;
var reIsNative = RegExp(
  "^" + funcToString.call(hasOwnProperty$7).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function baseIsNative$1(value) {
  if (!isObject$1(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction$1(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource$1(value));
}
var _baseIsNative = baseIsNative$1;
function getValue$1(object2, key) {
  return object2 == null ? void 0 : object2[key];
}
var _getValue = getValue$1;
var baseIsNative = _baseIsNative, getValue = _getValue;
function getNative$6(object2, key) {
  var value = getValue(object2, key);
  return baseIsNative(value) ? value : void 0;
}
var _getNative = getNative$6;
var getNative$5 = _getNative;
var nativeCreate$4 = getNative$5(Object, "create");
var _nativeCreate = nativeCreate$4;
var nativeCreate$3 = _nativeCreate;
function hashClear$1() {
  this.__data__ = nativeCreate$3 ? nativeCreate$3(null) : {};
  this.size = 0;
}
var _hashClear = hashClear$1;
function hashDelete$1(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}
var _hashDelete = hashDelete$1;
var nativeCreate$2 = _nativeCreate;
var HASH_UNDEFINED$2 = "__lodash_hash_undefined__";
var objectProto$8 = Object.prototype;
var hasOwnProperty$6 = objectProto$8.hasOwnProperty;
function hashGet$1(key) {
  var data = this.__data__;
  if (nativeCreate$2) {
    var result = data[key];
    return result === HASH_UNDEFINED$2 ? void 0 : result;
  }
  return hasOwnProperty$6.call(data, key) ? data[key] : void 0;
}
var _hashGet = hashGet$1;
var nativeCreate$1 = _nativeCreate;
var objectProto$7 = Object.prototype;
var hasOwnProperty$5 = objectProto$7.hasOwnProperty;
function hashHas$1(key) {
  var data = this.__data__;
  return nativeCreate$1 ? data[key] !== void 0 : hasOwnProperty$5.call(data, key);
}
var _hashHas = hashHas$1;
var nativeCreate = _nativeCreate;
var HASH_UNDEFINED$1 = "__lodash_hash_undefined__";
function hashSet$1(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = nativeCreate && value === void 0 ? HASH_UNDEFINED$1 : value;
  return this;
}
var _hashSet = hashSet$1;
var hashClear = _hashClear, hashDelete = _hashDelete, hashGet = _hashGet, hashHas = _hashHas, hashSet = _hashSet;
function Hash$1(entries) {
  var index2 = -1, length2 = entries == null ? 0 : entries.length;
  this.clear();
  while (++index2 < length2) {
    var entry = entries[index2];
    this.set(entry[0], entry[1]);
  }
}
Hash$1.prototype.clear = hashClear;
Hash$1.prototype["delete"] = hashDelete;
Hash$1.prototype.get = hashGet;
Hash$1.prototype.has = hashHas;
Hash$1.prototype.set = hashSet;
var _Hash = Hash$1;
function listCacheClear$1() {
  this.__data__ = [];
  this.size = 0;
}
var _listCacheClear = listCacheClear$1;
function eq$2(value, other) {
  return value === other || value !== value && other !== other;
}
var eq_1 = eq$2;
var eq$1 = eq_1;
function assocIndexOf$4(array, key) {
  var length2 = array.length;
  while (length2--) {
    if (eq$1(array[length2][0], key)) {
      return length2;
    }
  }
  return -1;
}
var _assocIndexOf = assocIndexOf$4;
var assocIndexOf$3 = _assocIndexOf;
var arrayProto = Array.prototype;
var splice = arrayProto.splice;
function listCacheDelete$1(key) {
  var data = this.__data__, index2 = assocIndexOf$3(data, key);
  if (index2 < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index2 == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index2, 1);
  }
  --this.size;
  return true;
}
var _listCacheDelete = listCacheDelete$1;
var assocIndexOf$2 = _assocIndexOf;
function listCacheGet$1(key) {
  var data = this.__data__, index2 = assocIndexOf$2(data, key);
  return index2 < 0 ? void 0 : data[index2][1];
}
var _listCacheGet = listCacheGet$1;
var assocIndexOf$1 = _assocIndexOf;
function listCacheHas$1(key) {
  return assocIndexOf$1(this.__data__, key) > -1;
}
var _listCacheHas = listCacheHas$1;
var assocIndexOf = _assocIndexOf;
function listCacheSet$1(key, value) {
  var data = this.__data__, index2 = assocIndexOf(data, key);
  if (index2 < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index2][1] = value;
  }
  return this;
}
var _listCacheSet = listCacheSet$1;
var listCacheClear = _listCacheClear, listCacheDelete = _listCacheDelete, listCacheGet = _listCacheGet, listCacheHas = _listCacheHas, listCacheSet = _listCacheSet;
function ListCache$4(entries) {
  var index2 = -1, length2 = entries == null ? 0 : entries.length;
  this.clear();
  while (++index2 < length2) {
    var entry = entries[index2];
    this.set(entry[0], entry[1]);
  }
}
ListCache$4.prototype.clear = listCacheClear;
ListCache$4.prototype["delete"] = listCacheDelete;
ListCache$4.prototype.get = listCacheGet;
ListCache$4.prototype.has = listCacheHas;
ListCache$4.prototype.set = listCacheSet;
var _ListCache = ListCache$4;
var getNative$4 = _getNative, root$5 = _root;
var Map$4 = getNative$4(root$5, "Map");
var _Map = Map$4;
var Hash = _Hash, ListCache$3 = _ListCache, Map$3 = _Map;
function mapCacheClear$1() {
  this.size = 0;
  this.__data__ = {
    "hash": new Hash(),
    "map": new (Map$3 || ListCache$3)(),
    "string": new Hash()
  };
}
var _mapCacheClear = mapCacheClear$1;
function isKeyable$1(value) {
  var type2 = typeof value;
  return type2 == "string" || type2 == "number" || type2 == "symbol" || type2 == "boolean" ? value !== "__proto__" : value === null;
}
var _isKeyable = isKeyable$1;
var isKeyable = _isKeyable;
function getMapData$4(map, key) {
  var data = map.__data__;
  return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
var _getMapData = getMapData$4;
var getMapData$3 = _getMapData;
function mapCacheDelete$1(key) {
  var result = getMapData$3(this, key)["delete"](key);
  this.size -= result ? 1 : 0;
  return result;
}
var _mapCacheDelete = mapCacheDelete$1;
var getMapData$2 = _getMapData;
function mapCacheGet$1(key) {
  return getMapData$2(this, key).get(key);
}
var _mapCacheGet = mapCacheGet$1;
var getMapData$1 = _getMapData;
function mapCacheHas$1(key) {
  return getMapData$1(this, key).has(key);
}
var _mapCacheHas = mapCacheHas$1;
var getMapData = _getMapData;
function mapCacheSet$1(key, value) {
  var data = getMapData(this, key), size2 = data.size;
  data.set(key, value);
  this.size += data.size == size2 ? 0 : 1;
  return this;
}
var _mapCacheSet = mapCacheSet$1;
var mapCacheClear = _mapCacheClear, mapCacheDelete = _mapCacheDelete, mapCacheGet = _mapCacheGet, mapCacheHas = _mapCacheHas, mapCacheSet = _mapCacheSet;
function MapCache$3(entries) {
  var index2 = -1, length2 = entries == null ? 0 : entries.length;
  this.clear();
  while (++index2 < length2) {
    var entry = entries[index2];
    this.set(entry[0], entry[1]);
  }
}
MapCache$3.prototype.clear = mapCacheClear;
MapCache$3.prototype["delete"] = mapCacheDelete;
MapCache$3.prototype.get = mapCacheGet;
MapCache$3.prototype.has = mapCacheHas;
MapCache$3.prototype.set = mapCacheSet;
var _MapCache = MapCache$3;
var MapCache$2 = _MapCache;
var FUNC_ERROR_TEXT = "Expected a function";
function memoize$1(func, resolver) {
  if (typeof func != "function" || resolver != null && typeof resolver != "function") {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized2 = function() {
    var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized2.cache;
    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized2.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized2.cache = new (memoize$1.Cache || MapCache$2)();
  return memoized2;
}
memoize$1.Cache = MapCache$2;
var memoize_1 = memoize$1;
var memoize = memoize_1;
var MAX_MEMOIZE_SIZE = 500;
function memoizeCapped$1(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });
  var cache = result.cache;
  return result;
}
var _memoizeCapped = memoizeCapped$1;
var memoizeCapped = _memoizeCapped;
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
var reEscapeChar = /\\(\\)?/g;
var stringToPath$1 = memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46) {
    result.push("");
  }
  string.replace(rePropName, function(match2, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, "$1") : number || match2);
  });
  return result;
});
var _stringToPath = stringToPath$1;
function arrayMap$1(array, iteratee) {
  var index2 = -1, length2 = array == null ? 0 : array.length, result = Array(length2);
  while (++index2 < length2) {
    result[index2] = iteratee(array[index2], index2, array);
  }
  return result;
}
var _arrayMap = arrayMap$1;
var Symbol$3 = _Symbol, arrayMap = _arrayMap, isArray$6 = isArray_1, isSymbol$1 = isSymbol_1;
var symbolProto$1 = Symbol$3 ? Symbol$3.prototype : void 0, symbolToString = symbolProto$1 ? symbolProto$1.toString : void 0;
function baseToString$1(value) {
  if (typeof value == "string") {
    return value;
  }
  if (isArray$6(value)) {
    return arrayMap(value, baseToString$1) + "";
  }
  if (isSymbol$1(value)) {
    return symbolToString ? symbolToString.call(value) : "";
  }
  var result = value + "";
  return result == "0" && 1 / value == -Infinity ? "-0" : result;
}
var _baseToString = baseToString$1;
var baseToString = _baseToString;
function toString$2(value) {
  return value == null ? "" : baseToString(value);
}
var toString_1 = toString$2;
var isArray$5 = isArray_1, isKey$2 = _isKey, stringToPath2 = _stringToPath, toString$1 = toString_1;
function castPath$2(value, object2) {
  if (isArray$5(value)) {
    return value;
  }
  return isKey$2(value, object2) ? [value] : stringToPath2(toString$1(value));
}
var _castPath = castPath$2;
var isSymbol = isSymbol_1;
function toKey$4(value) {
  if (typeof value == "string" || isSymbol(value)) {
    return value;
  }
  var result = value + "";
  return result == "0" && 1 / value == -Infinity ? "-0" : result;
}
var _toKey = toKey$4;
var castPath$1 = _castPath, toKey$3 = _toKey;
function baseGet$2(object2, path) {
  path = castPath$1(path, object2);
  var index2 = 0, length2 = path.length;
  while (object2 != null && index2 < length2) {
    object2 = object2[toKey$3(path[index2++])];
  }
  return index2 && index2 == length2 ? object2 : void 0;
}
var _baseGet = baseGet$2;
var baseGet$1 = _baseGet;
function get$1(object2, path, defaultValue) {
  var result = object2 == null ? void 0 : baseGet$1(object2, path);
  return result === void 0 ? defaultValue : result;
}
var get_1 = get$1;
var reactIs_production_min = {};
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactIs_production_min;
function requireReactIs_production_min() {
  if (hasRequiredReactIs_production_min) return reactIs_production_min;
  hasRequiredReactIs_production_min = 1;
  var b2 = Symbol.for("react.element"), c2 = Symbol.for("react.portal"), d2 = Symbol.for("react.fragment"), e3 = Symbol.for("react.strict_mode"), f2 = Symbol.for("react.profiler"), g3 = Symbol.for("react.provider"), h2 = Symbol.for("react.context"), k2 = Symbol.for("react.server_context"), l2 = Symbol.for("react.forward_ref"), m2 = Symbol.for("react.suspense"), n2 = Symbol.for("react.suspense_list"), p2 = Symbol.for("react.memo"), q2 = Symbol.for("react.lazy"), t2 = Symbol.for("react.offscreen"), u2;
  u2 = Symbol.for("react.module.reference");
  function v2(a2) {
    if ("object" === typeof a2 && null !== a2) {
      var r2 = a2.$$typeof;
      switch (r2) {
        case b2:
          switch (a2 = a2.type, a2) {
            case d2:
            case f2:
            case e3:
            case m2:
            case n2:
              return a2;
            default:
              switch (a2 = a2 && a2.$$typeof, a2) {
                case k2:
                case h2:
                case l2:
                case q2:
                case p2:
                case g3:
                  return a2;
                default:
                  return r2;
              }
          }
        case c2:
          return r2;
      }
    }
  }
  reactIs_production_min.ContextConsumer = h2;
  reactIs_production_min.ContextProvider = g3;
  reactIs_production_min.Element = b2;
  reactIs_production_min.ForwardRef = l2;
  reactIs_production_min.Fragment = d2;
  reactIs_production_min.Lazy = q2;
  reactIs_production_min.Memo = p2;
  reactIs_production_min.Portal = c2;
  reactIs_production_min.Profiler = f2;
  reactIs_production_min.StrictMode = e3;
  reactIs_production_min.Suspense = m2;
  reactIs_production_min.SuspenseList = n2;
  reactIs_production_min.isAsyncMode = function() {
    return false;
  };
  reactIs_production_min.isConcurrentMode = function() {
    return false;
  };
  reactIs_production_min.isContextConsumer = function(a2) {
    return v2(a2) === h2;
  };
  reactIs_production_min.isContextProvider = function(a2) {
    return v2(a2) === g3;
  };
  reactIs_production_min.isElement = function(a2) {
    return "object" === typeof a2 && null !== a2 && a2.$$typeof === b2;
  };
  reactIs_production_min.isForwardRef = function(a2) {
    return v2(a2) === l2;
  };
  reactIs_production_min.isFragment = function(a2) {
    return v2(a2) === d2;
  };
  reactIs_production_min.isLazy = function(a2) {
    return v2(a2) === q2;
  };
  reactIs_production_min.isMemo = function(a2) {
    return v2(a2) === p2;
  };
  reactIs_production_min.isPortal = function(a2) {
    return v2(a2) === c2;
  };
  reactIs_production_min.isProfiler = function(a2) {
    return v2(a2) === f2;
  };
  reactIs_production_min.isStrictMode = function(a2) {
    return v2(a2) === e3;
  };
  reactIs_production_min.isSuspense = function(a2) {
    return v2(a2) === m2;
  };
  reactIs_production_min.isSuspenseList = function(a2) {
    return v2(a2) === n2;
  };
  reactIs_production_min.isValidElementType = function(a2) {
    return "string" === typeof a2 || "function" === typeof a2 || a2 === d2 || a2 === f2 || a2 === e3 || a2 === m2 || a2 === n2 || a2 === t2 || "object" === typeof a2 && null !== a2 && (a2.$$typeof === q2 || a2.$$typeof === p2 || a2.$$typeof === g3 || a2.$$typeof === h2 || a2.$$typeof === l2 || a2.$$typeof === u2 || void 0 !== a2.getModuleId) ? true : false;
  };
  reactIs_production_min.typeOf = v2;
  return reactIs_production_min;
}
var reactIs_development = {};
/**
 * @license React
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactIs_development;
function requireReactIs_development() {
  if (hasRequiredReactIs_development) return reactIs_development;
  hasRequiredReactIs_development = 1;
  if (process.env.NODE_ENV !== "production") {
    (function() {
      var REACT_ELEMENT_TYPE = Symbol.for("react.element");
      var REACT_PORTAL_TYPE = Symbol.for("react.portal");
      var REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
      var REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode");
      var REACT_PROFILER_TYPE = Symbol.for("react.profiler");
      var REACT_PROVIDER_TYPE = Symbol.for("react.provider");
      var REACT_CONTEXT_TYPE = Symbol.for("react.context");
      var REACT_SERVER_CONTEXT_TYPE = Symbol.for("react.server_context");
      var REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref");
      var REACT_SUSPENSE_TYPE = Symbol.for("react.suspense");
      var REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list");
      var REACT_MEMO_TYPE = Symbol.for("react.memo");
      var REACT_LAZY_TYPE = Symbol.for("react.lazy");
      var REACT_OFFSCREEN_TYPE = Symbol.for("react.offscreen");
      var enableScopeAPI = false;
      var enableCacheElement = false;
      var enableTransitionTracing = false;
      var enableLegacyHidden = false;
      var enableDebugTracing = false;
      var REACT_MODULE_REFERENCE;
      {
        REACT_MODULE_REFERENCE = Symbol.for("react.module.reference");
      }
      function isValidElementType(type2) {
        if (typeof type2 === "string" || typeof type2 === "function") {
          return true;
        }
        if (type2 === REACT_FRAGMENT_TYPE || type2 === REACT_PROFILER_TYPE || enableDebugTracing || type2 === REACT_STRICT_MODE_TYPE || type2 === REACT_SUSPENSE_TYPE || type2 === REACT_SUSPENSE_LIST_TYPE || enableLegacyHidden || type2 === REACT_OFFSCREEN_TYPE || enableScopeAPI || enableCacheElement || enableTransitionTracing) {
          return true;
        }
        if (typeof type2 === "object" && type2 !== null) {
          if (type2.$$typeof === REACT_LAZY_TYPE || type2.$$typeof === REACT_MEMO_TYPE || type2.$$typeof === REACT_PROVIDER_TYPE || type2.$$typeof === REACT_CONTEXT_TYPE || type2.$$typeof === REACT_FORWARD_REF_TYPE || // This needs to include all possible module reference object
          // types supported by any Flight configuration anywhere since
          // we don't know which Flight build this will end up being used
          // with.
          type2.$$typeof === REACT_MODULE_REFERENCE || type2.getModuleId !== void 0) {
            return true;
          }
        }
        return false;
      }
      function typeOf2(object2) {
        if (typeof object2 === "object" && object2 !== null) {
          var $$typeof = object2.$$typeof;
          switch ($$typeof) {
            case REACT_ELEMENT_TYPE:
              var type2 = object2.type;
              switch (type2) {
                case REACT_FRAGMENT_TYPE:
                case REACT_PROFILER_TYPE:
                case REACT_STRICT_MODE_TYPE:
                case REACT_SUSPENSE_TYPE:
                case REACT_SUSPENSE_LIST_TYPE:
                  return type2;
                default:
                  var $$typeofType = type2 && type2.$$typeof;
                  switch ($$typeofType) {
                    case REACT_SERVER_CONTEXT_TYPE:
                    case REACT_CONTEXT_TYPE:
                    case REACT_FORWARD_REF_TYPE:
                    case REACT_LAZY_TYPE:
                    case REACT_MEMO_TYPE:
                    case REACT_PROVIDER_TYPE:
                      return $$typeofType;
                    default:
                      return $$typeof;
                  }
              }
            case REACT_PORTAL_TYPE:
              return $$typeof;
          }
        }
        return void 0;
      }
      var ContextConsumer = REACT_CONTEXT_TYPE;
      var ContextProvider = REACT_PROVIDER_TYPE;
      var Element2 = REACT_ELEMENT_TYPE;
      var ForwardRef = REACT_FORWARD_REF_TYPE;
      var Fragment2 = REACT_FRAGMENT_TYPE;
      var Lazy = REACT_LAZY_TYPE;
      var Memo = REACT_MEMO_TYPE;
      var Portal2 = REACT_PORTAL_TYPE;
      var Profiler = REACT_PROFILER_TYPE;
      var StrictMode = REACT_STRICT_MODE_TYPE;
      var Suspense = REACT_SUSPENSE_TYPE;
      var SuspenseList = REACT_SUSPENSE_LIST_TYPE;
      var hasWarnedAboutDeprecatedIsAsyncMode = false;
      var hasWarnedAboutDeprecatedIsConcurrentMode = false;
      function isAsyncMode(object2) {
        {
          if (!hasWarnedAboutDeprecatedIsAsyncMode) {
            hasWarnedAboutDeprecatedIsAsyncMode = true;
            console["warn"]("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.");
          }
        }
        return false;
      }
      function isConcurrentMode(object2) {
        {
          if (!hasWarnedAboutDeprecatedIsConcurrentMode) {
            hasWarnedAboutDeprecatedIsConcurrentMode = true;
            console["warn"]("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.");
          }
        }
        return false;
      }
      function isContextConsumer(object2) {
        return typeOf2(object2) === REACT_CONTEXT_TYPE;
      }
      function isContextProvider(object2) {
        return typeOf2(object2) === REACT_PROVIDER_TYPE;
      }
      function isElement2(object2) {
        return typeof object2 === "object" && object2 !== null && object2.$$typeof === REACT_ELEMENT_TYPE;
      }
      function isForwardRef(object2) {
        return typeOf2(object2) === REACT_FORWARD_REF_TYPE;
      }
      function isFragment(object2) {
        return typeOf2(object2) === REACT_FRAGMENT_TYPE;
      }
      function isLazy(object2) {
        return typeOf2(object2) === REACT_LAZY_TYPE;
      }
      function isMemo(object2) {
        return typeOf2(object2) === REACT_MEMO_TYPE;
      }
      function isPortal(object2) {
        return typeOf2(object2) === REACT_PORTAL_TYPE;
      }
      function isProfiler(object2) {
        return typeOf2(object2) === REACT_PROFILER_TYPE;
      }
      function isStrictMode(object2) {
        return typeOf2(object2) === REACT_STRICT_MODE_TYPE;
      }
      function isSuspense(object2) {
        return typeOf2(object2) === REACT_SUSPENSE_TYPE;
      }
      function isSuspenseList(object2) {
        return typeOf2(object2) === REACT_SUSPENSE_LIST_TYPE;
      }
      reactIs_development.ContextConsumer = ContextConsumer;
      reactIs_development.ContextProvider = ContextProvider;
      reactIs_development.Element = Element2;
      reactIs_development.ForwardRef = ForwardRef;
      reactIs_development.Fragment = Fragment2;
      reactIs_development.Lazy = Lazy;
      reactIs_development.Memo = Memo;
      reactIs_development.Portal = Portal2;
      reactIs_development.Profiler = Profiler;
      reactIs_development.StrictMode = StrictMode;
      reactIs_development.Suspense = Suspense;
      reactIs_development.SuspenseList = SuspenseList;
      reactIs_development.isAsyncMode = isAsyncMode;
      reactIs_development.isConcurrentMode = isConcurrentMode;
      reactIs_development.isContextConsumer = isContextConsumer;
      reactIs_development.isContextProvider = isContextProvider;
      reactIs_development.isElement = isElement2;
      reactIs_development.isForwardRef = isForwardRef;
      reactIs_development.isFragment = isFragment;
      reactIs_development.isLazy = isLazy;
      reactIs_development.isMemo = isMemo;
      reactIs_development.isPortal = isPortal;
      reactIs_development.isProfiler = isProfiler;
      reactIs_development.isStrictMode = isStrictMode;
      reactIs_development.isSuspense = isSuspense;
      reactIs_development.isSuspenseList = isSuspenseList;
      reactIs_development.isValidElementType = isValidElementType;
      reactIs_development.typeOf = typeOf2;
    })();
  }
  return reactIs_development;
}
if (process.env.NODE_ENV === "production") {
  requireReactIs_production_min();
} else {
  requireReactIs_development();
}
var baseGetTag$3 = _baseGetTag, isObjectLike$4 = isObjectLike_1;
var numberTag$2 = "[object Number]";
function isNumber$2(value) {
  return typeof value == "number" || isObjectLike$4(value) && baseGetTag$3(value) == numberTag$2;
}
var isNumber_1 = isNumber$2;
var isNumber$3 = /* @__PURE__ */ getDefaultExportFromCjs(isNumber_1);
var isNumber$1 = isNumber_1;
function isNaN$1(value) {
  return isNumber$1(value) && value != +value;
}
var _isNaN = isNaN$1;
var isNan = /* @__PURE__ */ getDefaultExportFromCjs(_isNaN);
var isNumber = function isNumber2(value) {
  return isNumber$3(value) && !isNan(value);
};
function _typeof$3(o) {
  "@babel/helpers - typeof";
  return _typeof$3 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof$3(o);
}
var SVGContainerPropKeys = ["viewBox", "children"];
var SVGElementPropKeys = [
  "aria-activedescendant",
  "aria-atomic",
  "aria-autocomplete",
  "aria-busy",
  "aria-checked",
  "aria-colcount",
  "aria-colindex",
  "aria-colspan",
  "aria-controls",
  "aria-current",
  "aria-describedby",
  "aria-details",
  "aria-disabled",
  "aria-errormessage",
  "aria-expanded",
  "aria-flowto",
  "aria-haspopup",
  "aria-hidden",
  "aria-invalid",
  "aria-keyshortcuts",
  "aria-label",
  "aria-labelledby",
  "aria-level",
  "aria-live",
  "aria-modal",
  "aria-multiline",
  "aria-multiselectable",
  "aria-orientation",
  "aria-owns",
  "aria-placeholder",
  "aria-posinset",
  "aria-pressed",
  "aria-readonly",
  "aria-relevant",
  "aria-required",
  "aria-roledescription",
  "aria-rowcount",
  "aria-rowindex",
  "aria-rowspan",
  "aria-selected",
  "aria-setsize",
  "aria-sort",
  "aria-valuemax",
  "aria-valuemin",
  "aria-valuenow",
  "aria-valuetext",
  "className",
  "color",
  "height",
  "id",
  "lang",
  "max",
  "media",
  "method",
  "min",
  "name",
  "style",
  /*
   * removed 'type' SVGElementPropKey because we do not currently use any SVG elements
   * that can use it and it conflicts with the recharts prop 'type'
   * https://github.com/recharts/recharts/pull/3327
   * https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/type
   */
  // 'type',
  "target",
  "width",
  "role",
  "tabIndex",
  "accentHeight",
  "accumulate",
  "additive",
  "alignmentBaseline",
  "allowReorder",
  "alphabetic",
  "amplitude",
  "arabicForm",
  "ascent",
  "attributeName",
  "attributeType",
  "autoReverse",
  "azimuth",
  "baseFrequency",
  "baselineShift",
  "baseProfile",
  "bbox",
  "begin",
  "bias",
  "by",
  "calcMode",
  "capHeight",
  "clip",
  "clipPath",
  "clipPathUnits",
  "clipRule",
  "colorInterpolation",
  "colorInterpolationFilters",
  "colorProfile",
  "colorRendering",
  "contentScriptType",
  "contentStyleType",
  "cursor",
  "cx",
  "cy",
  "d",
  "decelerate",
  "descent",
  "diffuseConstant",
  "direction",
  "display",
  "divisor",
  "dominantBaseline",
  "dur",
  "dx",
  "dy",
  "edgeMode",
  "elevation",
  "enableBackground",
  "end",
  "exponent",
  "externalResourcesRequired",
  "fill",
  "fillOpacity",
  "fillRule",
  "filter",
  "filterRes",
  "filterUnits",
  "floodColor",
  "floodOpacity",
  "focusable",
  "fontFamily",
  "fontSize",
  "fontSizeAdjust",
  "fontStretch",
  "fontStyle",
  "fontVariant",
  "fontWeight",
  "format",
  "from",
  "fx",
  "fy",
  "g1",
  "g2",
  "glyphName",
  "glyphOrientationHorizontal",
  "glyphOrientationVertical",
  "glyphRef",
  "gradientTransform",
  "gradientUnits",
  "hanging",
  "horizAdvX",
  "horizOriginX",
  "href",
  "ideographic",
  "imageRendering",
  "in2",
  "in",
  "intercept",
  "k1",
  "k2",
  "k3",
  "k4",
  "k",
  "kernelMatrix",
  "kernelUnitLength",
  "kerning",
  "keyPoints",
  "keySplines",
  "keyTimes",
  "lengthAdjust",
  "letterSpacing",
  "lightingColor",
  "limitingConeAngle",
  "local",
  "markerEnd",
  "markerHeight",
  "markerMid",
  "markerStart",
  "markerUnits",
  "markerWidth",
  "mask",
  "maskContentUnits",
  "maskUnits",
  "mathematical",
  "mode",
  "numOctaves",
  "offset",
  "opacity",
  "operator",
  "order",
  "orient",
  "orientation",
  "origin",
  "overflow",
  "overlinePosition",
  "overlineThickness",
  "paintOrder",
  "panose1",
  "pathLength",
  "patternContentUnits",
  "patternTransform",
  "patternUnits",
  "pointerEvents",
  "pointsAtX",
  "pointsAtY",
  "pointsAtZ",
  "preserveAlpha",
  "preserveAspectRatio",
  "primitiveUnits",
  "r",
  "radius",
  "refX",
  "refY",
  "renderingIntent",
  "repeatCount",
  "repeatDur",
  "requiredExtensions",
  "requiredFeatures",
  "restart",
  "result",
  "rotate",
  "rx",
  "ry",
  "seed",
  "shapeRendering",
  "slope",
  "spacing",
  "specularConstant",
  "specularExponent",
  "speed",
  "spreadMethod",
  "startOffset",
  "stdDeviation",
  "stemh",
  "stemv",
  "stitchTiles",
  "stopColor",
  "stopOpacity",
  "strikethroughPosition",
  "strikethroughThickness",
  "string",
  "stroke",
  "strokeDasharray",
  "strokeDashoffset",
  "strokeLinecap",
  "strokeLinejoin",
  "strokeMiterlimit",
  "strokeOpacity",
  "strokeWidth",
  "surfaceScale",
  "systemLanguage",
  "tableValues",
  "targetX",
  "targetY",
  "textAnchor",
  "textDecoration",
  "textLength",
  "textRendering",
  "to",
  "transform",
  "u1",
  "u2",
  "underlinePosition",
  "underlineThickness",
  "unicode",
  "unicodeBidi",
  "unicodeRange",
  "unitsPerEm",
  "vAlphabetic",
  "values",
  "vectorEffect",
  "version",
  "vertAdvY",
  "vertOriginX",
  "vertOriginY",
  "vHanging",
  "vIdeographic",
  "viewTarget",
  "visibility",
  "vMathematical",
  "widths",
  "wordSpacing",
  "writingMode",
  "x1",
  "x2",
  "x",
  "xChannelSelector",
  "xHeight",
  "xlinkActuate",
  "xlinkArcrole",
  "xlinkHref",
  "xlinkRole",
  "xlinkShow",
  "xlinkTitle",
  "xlinkType",
  "xmlBase",
  "xmlLang",
  "xmlns",
  "xmlnsXlink",
  "xmlSpace",
  "y1",
  "y2",
  "y",
  "yChannelSelector",
  "z",
  "zoomAndPan",
  "ref",
  "key",
  "angle"
];
var PolyElementKeys = ["points", "pathLength"];
var FilteredElementKeyMap = {
  svg: SVGContainerPropKeys,
  polygon: PolyElementKeys,
  polyline: PolyElementKeys
};
var EventKeys = ["dangerouslySetInnerHTML", "onCopy", "onCopyCapture", "onCut", "onCutCapture", "onPaste", "onPasteCapture", "onCompositionEnd", "onCompositionEndCapture", "onCompositionStart", "onCompositionStartCapture", "onCompositionUpdate", "onCompositionUpdateCapture", "onFocus", "onFocusCapture", "onBlur", "onBlurCapture", "onChange", "onChangeCapture", "onBeforeInput", "onBeforeInputCapture", "onInput", "onInputCapture", "onReset", "onResetCapture", "onSubmit", "onSubmitCapture", "onInvalid", "onInvalidCapture", "onLoad", "onLoadCapture", "onError", "onErrorCapture", "onKeyDown", "onKeyDownCapture", "onKeyPress", "onKeyPressCapture", "onKeyUp", "onKeyUpCapture", "onAbort", "onAbortCapture", "onCanPlay", "onCanPlayCapture", "onCanPlayThrough", "onCanPlayThroughCapture", "onDurationChange", "onDurationChangeCapture", "onEmptied", "onEmptiedCapture", "onEncrypted", "onEncryptedCapture", "onEnded", "onEndedCapture", "onLoadedData", "onLoadedDataCapture", "onLoadedMetadata", "onLoadedMetadataCapture", "onLoadStart", "onLoadStartCapture", "onPause", "onPauseCapture", "onPlay", "onPlayCapture", "onPlaying", "onPlayingCapture", "onProgress", "onProgressCapture", "onRateChange", "onRateChangeCapture", "onSeeked", "onSeekedCapture", "onSeeking", "onSeekingCapture", "onStalled", "onStalledCapture", "onSuspend", "onSuspendCapture", "onTimeUpdate", "onTimeUpdateCapture", "onVolumeChange", "onVolumeChangeCapture", "onWaiting", "onWaitingCapture", "onAuxClick", "onAuxClickCapture", "onClick", "onClickCapture", "onContextMenu", "onContextMenuCapture", "onDoubleClick", "onDoubleClickCapture", "onDrag", "onDragCapture", "onDragEnd", "onDragEndCapture", "onDragEnter", "onDragEnterCapture", "onDragExit", "onDragExitCapture", "onDragLeave", "onDragLeaveCapture", "onDragOver", "onDragOverCapture", "onDragStart", "onDragStartCapture", "onDrop", "onDropCapture", "onMouseDown", "onMouseDownCapture", "onMouseEnter", "onMouseLeave", "onMouseMove", "onMouseMoveCapture", "onMouseOut", "onMouseOutCapture", "onMouseOver", "onMouseOverCapture", "onMouseUp", "onMouseUpCapture", "onSelect", "onSelectCapture", "onTouchCancel", "onTouchCancelCapture", "onTouchEnd", "onTouchEndCapture", "onTouchMove", "onTouchMoveCapture", "onTouchStart", "onTouchStartCapture", "onPointerDown", "onPointerDownCapture", "onPointerMove", "onPointerMoveCapture", "onPointerUp", "onPointerUpCapture", "onPointerCancel", "onPointerCancelCapture", "onPointerEnter", "onPointerEnterCapture", "onPointerLeave", "onPointerLeaveCapture", "onPointerOver", "onPointerOverCapture", "onPointerOut", "onPointerOutCapture", "onGotPointerCapture", "onGotPointerCaptureCapture", "onLostPointerCapture", "onLostPointerCaptureCapture", "onScroll", "onScrollCapture", "onWheel", "onWheelCapture", "onAnimationStart", "onAnimationStartCapture", "onAnimationEnd", "onAnimationEndCapture", "onAnimationIteration", "onAnimationIterationCapture", "onTransitionEnd", "onTransitionEndCapture"];
var getEventHandlerOfChild = function getEventHandlerOfChild2(originalHandler, data, index2) {
  return function(e3) {
    originalHandler(data, index2, e3);
    return null;
  };
};
var adaptEventsOfChild = function adaptEventsOfChild2(props, data, index2) {
  if (!isObject$4(props) || _typeof$3(props) !== "object") {
    return null;
  }
  var out = null;
  Object.keys(props).forEach(function(key) {
    var item = props[key];
    if (EventKeys.includes(key) && typeof item === "function") {
      if (!out) out = {};
      out[key] = getEventHandlerOfChild(item, data, index2);
    }
  });
  return out;
};
var isValidSpreadableProp = function isValidSpreadableProp2(property2, key, includeEvents, svgElementType) {
  var _FilteredElementKeyMa;
  var matchingElementTypeKeys = (_FilteredElementKeyMa = FilteredElementKeyMap === null || FilteredElementKeyMap === void 0 ? void 0 : FilteredElementKeyMap[svgElementType]) !== null && _FilteredElementKeyMa !== void 0 ? _FilteredElementKeyMa : [];
  return key.startsWith("data-") || !isFunction$3(property2) && (svgElementType && matchingElementTypeKeys.includes(key) || SVGElementPropKeys.includes(key)) || EventKeys.includes(key);
};
var filterProps = function filterProps2(props, includeEvents, svgElementType) {
  if (!props || typeof props === "function" || typeof props === "boolean") {
    return null;
  }
  var inputProps = props;
  if (/* @__PURE__ */ isValidElement(props)) {
    inputProps = props.props;
  }
  if (!isObject$4(inputProps)) {
    return null;
  }
  var out = {};
  Object.keys(inputProps).forEach(function(key) {
    var _inputProps;
    if (isValidSpreadableProp((_inputProps = inputProps) === null || _inputProps === void 0 ? void 0 : _inputProps[key], key, includeEvents, svgElementType)) {
      out[key] = inputProps[key];
    }
  });
  return out;
};
var _excluded$2 = ["children", "width", "height", "viewBox", "className", "style", "title", "desc"];
function _extends$3() {
  _extends$3 = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$3.apply(this, arguments);
}
function _objectWithoutProperties$2(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose$2(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose$2(source, excluded) {
  if (source == null) return {};
  var target = {};
  for (var key in source) {
    if (Object.prototype.hasOwnProperty.call(source, key)) {
      if (excluded.indexOf(key) >= 0) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function Surface(props) {
  var children = props.children, width2 = props.width, height2 = props.height, viewBox = props.viewBox, className = props.className, style = props.style, title = props.title, desc = props.desc, others = _objectWithoutProperties$2(props, _excluded$2);
  var svgView = viewBox || {
    width: width2,
    height: height2,
    x: 0,
    y: 0
  };
  var layerClass = clsx("recharts-surface", className);
  return /* @__PURE__ */ React__default.createElement("svg", _extends$3({}, filterProps(others, true, "svg"), {
    className: layerClass,
    width: width2,
    height: height2,
    style,
    viewBox: "".concat(svgView.x, " ").concat(svgView.y, " ").concat(svgView.width, " ").concat(svgView.height)
  }), /* @__PURE__ */ React__default.createElement("title", null, title), /* @__PURE__ */ React__default.createElement("desc", null, desc), children);
}
var isDev = process.env.NODE_ENV !== "production";
var warn = function warn2(condition, format2) {
  for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }
  if (isDev && typeof console !== "undefined" && console.warn) {
    if (!condition) {
      {
        var argIndex = 0;
        console.warn(format2.replace(/%s/g, function() {
          return args[argIndex++];
        }));
      }
    }
  }
};
function baseSlice$1(array, start2, end2) {
  var index2 = -1, length2 = array.length;
  if (start2 < 0) {
    start2 = -start2 > length2 ? 0 : length2 + start2;
  }
  end2 = end2 > length2 ? length2 : end2;
  if (end2 < 0) {
    end2 += length2;
  }
  length2 = start2 > end2 ? 0 : end2 - start2 >>> 0;
  start2 >>>= 0;
  var result = Array(length2);
  while (++index2 < length2) {
    result[index2] = array[index2 + start2];
  }
  return result;
}
var _baseSlice = baseSlice$1;
var baseSlice = _baseSlice;
function castSlice$1(array, start2, end2) {
  var length2 = array.length;
  end2 = end2 === void 0 ? length2 : end2;
  return !start2 && end2 >= length2 ? array : baseSlice(array, start2, end2);
}
var _castSlice = castSlice$1;
var rsAstralRange$1 = "\\ud800-\\udfff", rsComboMarksRange$1 = "\\u0300-\\u036f", reComboHalfMarksRange$1 = "\\ufe20-\\ufe2f", rsComboSymbolsRange$1 = "\\u20d0-\\u20ff", rsComboRange$1 = rsComboMarksRange$1 + reComboHalfMarksRange$1 + rsComboSymbolsRange$1, rsVarRange$1 = "\\ufe0e\\ufe0f";
var rsZWJ$1 = "\\u200d";
var reHasUnicode = RegExp("[" + rsZWJ$1 + rsAstralRange$1 + rsComboRange$1 + rsVarRange$1 + "]");
function hasUnicode$2(string) {
  return reHasUnicode.test(string);
}
var _hasUnicode = hasUnicode$2;
function asciiToArray$1(string) {
  return string.split("");
}
var _asciiToArray = asciiToArray$1;
var rsAstralRange = "\\ud800-\\udfff", rsComboMarksRange = "\\u0300-\\u036f", reComboHalfMarksRange = "\\ufe20-\\ufe2f", rsComboSymbolsRange = "\\u20d0-\\u20ff", rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsVarRange = "\\ufe0e\\ufe0f";
var rsAstral = "[" + rsAstralRange + "]", rsCombo = "[" + rsComboRange + "]", rsFitz = "\\ud83c[\\udffb-\\udfff]", rsModifier = "(?:" + rsCombo + "|" + rsFitz + ")", rsNonAstral = "[^" + rsAstralRange + "]", rsRegional = "(?:\\ud83c[\\udde6-\\uddff]){2}", rsSurrPair = "[\\ud800-\\udbff][\\udc00-\\udfff]", rsZWJ = "\\u200d";
var reOptMod = rsModifier + "?", rsOptVar = "[" + rsVarRange + "]?", rsOptJoin = "(?:" + rsZWJ + "(?:" + [rsNonAstral, rsRegional, rsSurrPair].join("|") + ")" + rsOptVar + reOptMod + ")*", rsSeq = rsOptVar + reOptMod + rsOptJoin, rsSymbol = "(?:" + [rsNonAstral + rsCombo + "?", rsCombo, rsRegional, rsSurrPair, rsAstral].join("|") + ")";
var reUnicode = RegExp(rsFitz + "(?=" + rsFitz + ")|" + rsSymbol + rsSeq, "g");
function unicodeToArray$1(string) {
  return string.match(reUnicode) || [];
}
var _unicodeToArray = unicodeToArray$1;
var asciiToArray = _asciiToArray, hasUnicode$1 = _hasUnicode, unicodeToArray = _unicodeToArray;
function stringToArray$1(string) {
  return hasUnicode$1(string) ? unicodeToArray(string) : asciiToArray(string);
}
var _stringToArray = stringToArray$1;
var castSlice = _castSlice, hasUnicode = _hasUnicode, stringToArray = _stringToArray, toString = toString_1;
function createCaseFirst$1(methodName) {
  return function(string) {
    string = toString(string);
    var strSymbols = hasUnicode(string) ? stringToArray(string) : void 0;
    var chr = strSymbols ? strSymbols[0] : string.charAt(0);
    var trailing = strSymbols ? castSlice(strSymbols, 1).join("") : string.slice(1);
    return chr[methodName]() + trailing;
  };
}
var _createCaseFirst = createCaseFirst$1;
var createCaseFirst = _createCaseFirst;
var upperFirst = createCaseFirst("toUpperCase");
var upperFirst_1 = upperFirst;
var upperFirst$1 = /* @__PURE__ */ getDefaultExportFromCjs(upperFirst_1);
function constant(x2) {
  return function constant2() {
    return x2;
  };
}
const cos = Math.cos;
const sin = Math.sin;
const sqrt = Math.sqrt;
const pi$1 = Math.PI;
const tau$1 = 2 * pi$1;
const pi = Math.PI, tau = 2 * pi, epsilon = 1e-6, tauEpsilon = tau - epsilon;
function append(strings) {
  this._ += strings[0];
  for (let i = 1, n2 = strings.length; i < n2; ++i) {
    this._ += arguments[i] + strings[i];
  }
}
function appendRound(digits) {
  let d2 = Math.floor(digits);
  if (!(d2 >= 0)) throw new Error(`invalid digits: ${digits}`);
  if (d2 > 15) return append;
  const k2 = 10 ** d2;
  return function(strings) {
    this._ += strings[0];
    for (let i = 1, n2 = strings.length; i < n2; ++i) {
      this._ += Math.round(arguments[i] * k2) / k2 + strings[i];
    }
  };
}
class Path {
  constructor(digits) {
    this._x0 = this._y0 = // start of current subpath
    this._x1 = this._y1 = null;
    this._ = "";
    this._append = digits == null ? append : appendRound(digits);
  }
  moveTo(x2, y2) {
    this._append`M${this._x0 = this._x1 = +x2},${this._y0 = this._y1 = +y2}`;
  }
  closePath() {
    if (this._x1 !== null) {
      this._x1 = this._x0, this._y1 = this._y0;
      this._append`Z`;
    }
  }
  lineTo(x2, y2) {
    this._append`L${this._x1 = +x2},${this._y1 = +y2}`;
  }
  quadraticCurveTo(x1, y1, x2, y2) {
    this._append`Q${+x1},${+y1},${this._x1 = +x2},${this._y1 = +y2}`;
  }
  bezierCurveTo(x1, y1, x2, y2, x3, y3) {
    this._append`C${+x1},${+y1},${+x2},${+y2},${this._x1 = +x3},${this._y1 = +y3}`;
  }
  arcTo(x1, y1, x2, y2, r2) {
    x1 = +x1, y1 = +y1, x2 = +x2, y2 = +y2, r2 = +r2;
    if (r2 < 0) throw new Error(`negative radius: ${r2}`);
    let x0 = this._x1, y0 = this._y1, x21 = x2 - x1, y21 = y2 - y1, x01 = x0 - x1, y01 = y0 - y1, l01_2 = x01 * x01 + y01 * y01;
    if (this._x1 === null) {
      this._append`M${this._x1 = x1},${this._y1 = y1}`;
    } else if (!(l01_2 > epsilon)) ;
    else if (!(Math.abs(y01 * x21 - y21 * x01) > epsilon) || !r2) {
      this._append`L${this._x1 = x1},${this._y1 = y1}`;
    } else {
      let x20 = x2 - x0, y20 = y2 - y0, l21_2 = x21 * x21 + y21 * y21, l20_2 = x20 * x20 + y20 * y20, l21 = Math.sqrt(l21_2), l01 = Math.sqrt(l01_2), l2 = r2 * Math.tan((pi - Math.acos((l21_2 + l01_2 - l20_2) / (2 * l21 * l01))) / 2), t01 = l2 / l01, t21 = l2 / l21;
      if (Math.abs(t01 - 1) > epsilon) {
        this._append`L${x1 + t01 * x01},${y1 + t01 * y01}`;
      }
      this._append`A${r2},${r2},0,0,${+(y01 * x20 > x01 * y20)},${this._x1 = x1 + t21 * x21},${this._y1 = y1 + t21 * y21}`;
    }
  }
  arc(x2, y2, r2, a0, a1, ccw) {
    x2 = +x2, y2 = +y2, r2 = +r2, ccw = !!ccw;
    if (r2 < 0) throw new Error(`negative radius: ${r2}`);
    let dx = r2 * Math.cos(a0), dy = r2 * Math.sin(a0), x0 = x2 + dx, y0 = y2 + dy, cw = 1 ^ ccw, da = ccw ? a0 - a1 : a1 - a0;
    if (this._x1 === null) {
      this._append`M${x0},${y0}`;
    } else if (Math.abs(this._x1 - x0) > epsilon || Math.abs(this._y1 - y0) > epsilon) {
      this._append`L${x0},${y0}`;
    }
    if (!r2) return;
    if (da < 0) da = da % tau + tau;
    if (da > tauEpsilon) {
      this._append`A${r2},${r2},0,1,${cw},${x2 - dx},${y2 - dy}A${r2},${r2},0,1,${cw},${this._x1 = x0},${this._y1 = y0}`;
    } else if (da > epsilon) {
      this._append`A${r2},${r2},0,${+(da >= pi)},${cw},${this._x1 = x2 + r2 * Math.cos(a1)},${this._y1 = y2 + r2 * Math.sin(a1)}`;
    }
  }
  rect(x2, y2, w3, h2) {
    this._append`M${this._x0 = this._x1 = +x2},${this._y0 = this._y1 = +y2}h${w3 = +w3}v${+h2}h${-w3}Z`;
  }
  toString() {
    return this._;
  }
}
function withPath(shape2) {
  let digits = 3;
  shape2.digits = function(_2) {
    if (!arguments.length) return digits;
    if (_2 == null) {
      digits = null;
    } else {
      const d2 = Math.floor(_2);
      if (!(d2 >= 0)) throw new RangeError(`invalid digits: ${_2}`);
      digits = d2;
    }
    return shape2;
  };
  return () => new Path(digits);
}
var symbolCircle = {
  draw(context, size2) {
    const r2 = sqrt(size2 / pi$1);
    context.moveTo(r2, 0);
    context.arc(0, 0, r2, 0, tau$1);
  }
};
var symbolCross = {
  draw(context, size2) {
    const r2 = sqrt(size2 / 5) / 2;
    context.moveTo(-3 * r2, -r2);
    context.lineTo(-r2, -r2);
    context.lineTo(-r2, -3 * r2);
    context.lineTo(r2, -3 * r2);
    context.lineTo(r2, -r2);
    context.lineTo(3 * r2, -r2);
    context.lineTo(3 * r2, r2);
    context.lineTo(r2, r2);
    context.lineTo(r2, 3 * r2);
    context.lineTo(-r2, 3 * r2);
    context.lineTo(-r2, r2);
    context.lineTo(-3 * r2, r2);
    context.closePath();
  }
};
const tan30 = sqrt(1 / 3);
const tan30_2 = tan30 * 2;
var symbolDiamond = {
  draw(context, size2) {
    const y2 = sqrt(size2 / tan30_2);
    const x2 = y2 * tan30;
    context.moveTo(0, -y2);
    context.lineTo(x2, 0);
    context.lineTo(0, y2);
    context.lineTo(-x2, 0);
    context.closePath();
  }
};
var symbolSquare = {
  draw(context, size2) {
    const w3 = sqrt(size2);
    const x2 = -w3 / 2;
    context.rect(x2, x2, w3, w3);
  }
};
const ka = 0.8908130915292852;
const kr = sin(pi$1 / 10) / sin(7 * pi$1 / 10);
const kx = sin(tau$1 / 10) * kr;
const ky = -cos(tau$1 / 10) * kr;
var symbolStar = {
  draw(context, size2) {
    const r2 = sqrt(size2 * ka);
    const x2 = kx * r2;
    const y2 = ky * r2;
    context.moveTo(0, -r2);
    context.lineTo(x2, y2);
    for (let i = 1; i < 5; ++i) {
      const a2 = tau$1 * i / 5;
      const c2 = cos(a2);
      const s2 = sin(a2);
      context.lineTo(s2 * r2, -c2 * r2);
      context.lineTo(c2 * x2 - s2 * y2, s2 * x2 + c2 * y2);
    }
    context.closePath();
  }
};
const sqrt3 = sqrt(3);
var symbolTriangle = {
  draw(context, size2) {
    const y2 = -sqrt(size2 / (sqrt3 * 3));
    context.moveTo(0, y2 * 2);
    context.lineTo(-sqrt3 * y2, -y2);
    context.lineTo(sqrt3 * y2, -y2);
    context.closePath();
  }
};
const c = -0.5;
const s = sqrt(3) / 2;
const k = 1 / sqrt(12);
const a = (k / 2 + 1) * 3;
var symbolWye = {
  draw(context, size2) {
    const r2 = sqrt(size2 / a);
    const x0 = r2 / 2, y0 = r2 * k;
    const x1 = x0, y1 = r2 * k + r2;
    const x2 = -x1, y2 = y1;
    context.moveTo(x0, y0);
    context.lineTo(x1, y1);
    context.lineTo(x2, y2);
    context.lineTo(c * x0 - s * y0, s * x0 + c * y0);
    context.lineTo(c * x1 - s * y1, s * x1 + c * y1);
    context.lineTo(c * x2 - s * y2, s * x2 + c * y2);
    context.lineTo(c * x0 + s * y0, c * y0 - s * x0);
    context.lineTo(c * x1 + s * y1, c * y1 - s * x1);
    context.lineTo(c * x2 + s * y2, c * y2 - s * x2);
    context.closePath();
  }
};
function Symbol$2(type2, size2) {
  let context = null, path = withPath(symbol);
  type2 = typeof type2 === "function" ? type2 : constant(type2 || symbolCircle);
  size2 = typeof size2 === "function" ? size2 : constant(size2 === void 0 ? 64 : +size2);
  function symbol() {
    let buffer;
    if (!context) context = buffer = path();
    type2.apply(this, arguments).draw(context, +size2.apply(this, arguments));
    if (buffer) return context = null, buffer + "" || null;
  }
  symbol.type = function(_2) {
    return arguments.length ? (type2 = typeof _2 === "function" ? _2 : constant(_2), symbol) : type2;
  };
  symbol.size = function(_2) {
    return arguments.length ? (size2 = typeof _2 === "function" ? _2 : constant(+_2), symbol) : size2;
  };
  symbol.context = function(_2) {
    return arguments.length ? (context = _2 == null ? null : _2, symbol) : context;
  };
  return symbol;
}
function _typeof$2(o) {
  "@babel/helpers - typeof";
  return _typeof$2 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof$2(o);
}
var _excluded$1 = ["type", "size", "sizeType"];
function _extends$2() {
  _extends$2 = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$2.apply(this, arguments);
}
function ownKeys$2(e3, r2) {
  var t2 = Object.keys(e3);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e3);
    r2 && (o = o.filter(function(r3) {
      return Object.getOwnPropertyDescriptor(e3, r3).enumerable;
    })), t2.push.apply(t2, o);
  }
  return t2;
}
function _objectSpread$2(e3) {
  for (var r2 = 1; r2 < arguments.length; r2++) {
    var t2 = null != arguments[r2] ? arguments[r2] : {};
    r2 % 2 ? ownKeys$2(Object(t2), true).forEach(function(r3) {
      _defineProperty$3(e3, r3, t2[r3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e3, Object.getOwnPropertyDescriptors(t2)) : ownKeys$2(Object(t2)).forEach(function(r3) {
      Object.defineProperty(e3, r3, Object.getOwnPropertyDescriptor(t2, r3));
    });
  }
  return e3;
}
function _defineProperty$3(obj, key, value) {
  key = _toPropertyKey$2(key);
  if (key in obj) {
    Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey$2(t2) {
  var i = _toPrimitive$2(t2, "string");
  return "symbol" == _typeof$2(i) ? i : i + "";
}
function _toPrimitive$2(t2, r2) {
  if ("object" != _typeof$2(t2) || !t2) return t2;
  var e3 = t2[Symbol.toPrimitive];
  if (void 0 !== e3) {
    var i = e3.call(t2, r2);
    if ("object" != _typeof$2(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r2 ? String : Number)(t2);
}
function _objectWithoutProperties$1(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose$1(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose$1(source, excluded) {
  if (source == null) return {};
  var target = {};
  for (var key in source) {
    if (Object.prototype.hasOwnProperty.call(source, key)) {
      if (excluded.indexOf(key) >= 0) continue;
      target[key] = source[key];
    }
  }
  return target;
}
var symbolFactories = {
  symbolCircle,
  symbolCross,
  symbolDiamond,
  symbolSquare,
  symbolStar,
  symbolTriangle,
  symbolWye
};
var RADIAN = Math.PI / 180;
var getSymbolFactory = function getSymbolFactory2(type2) {
  var name = "symbol".concat(upperFirst$1(type2));
  return symbolFactories[name] || symbolCircle;
};
var calculateAreaSize = function calculateAreaSize2(size2, sizeType, type2) {
  if (sizeType === "area") {
    return size2;
  }
  switch (type2) {
    case "cross":
      return 5 * size2 * size2 / 9;
    case "diamond":
      return 0.5 * size2 * size2 / Math.sqrt(3);
    case "square":
      return size2 * size2;
    case "star": {
      var angle2 = 18 * RADIAN;
      return 1.25 * size2 * size2 * (Math.tan(angle2) - Math.tan(angle2 * 2) * Math.pow(Math.tan(angle2), 2));
    }
    case "triangle":
      return Math.sqrt(3) * size2 * size2 / 4;
    case "wye":
      return (21 - 10 * Math.sqrt(3)) * size2 * size2 / 8;
    default:
      return Math.PI * size2 * size2 / 4;
  }
};
var registerSymbol = function registerSymbol2(key, factory) {
  symbolFactories["symbol".concat(upperFirst$1(key))] = factory;
};
var Symbols = function Symbols2(_ref3) {
  var _ref$type = _ref3.type, type2 = _ref$type === void 0 ? "circle" : _ref$type, _ref$size = _ref3.size, size2 = _ref$size === void 0 ? 64 : _ref$size, _ref$sizeType = _ref3.sizeType, sizeType = _ref$sizeType === void 0 ? "area" : _ref$sizeType, rest = _objectWithoutProperties$1(_ref3, _excluded$1);
  var props = _objectSpread$2(_objectSpread$2({}, rest), {}, {
    type: type2,
    size: size2,
    sizeType
  });
  var getPath = function getPath2() {
    var symbolFactory = getSymbolFactory(type2);
    var symbol = Symbol$2().type(symbolFactory).size(calculateAreaSize(size2, sizeType, type2));
    return symbol();
  };
  var className = props.className, cx = props.cx, cy = props.cy;
  var filteredProps = filterProps(props, true);
  if (cx === +cx && cy === +cy && size2 === +size2) {
    return /* @__PURE__ */ React__default.createElement("path", _extends$2({}, filteredProps, {
      className: clsx("recharts-symbols", className),
      transform: "translate(".concat(cx, ", ").concat(cy, ")"),
      d: getPath()
    }));
  }
  return null;
};
Symbols.registerSymbol = registerSymbol;
function _typeof$1(o) {
  "@babel/helpers - typeof";
  return _typeof$1 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof$1(o);
}
function _extends$1() {
  _extends$1 = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$1.apply(this, arguments);
}
function ownKeys$1(e3, r2) {
  var t2 = Object.keys(e3);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e3);
    r2 && (o = o.filter(function(r3) {
      return Object.getOwnPropertyDescriptor(e3, r3).enumerable;
    })), t2.push.apply(t2, o);
  }
  return t2;
}
function _objectSpread$1(e3) {
  for (var r2 = 1; r2 < arguments.length; r2++) {
    var t2 = null != arguments[r2] ? arguments[r2] : {};
    r2 % 2 ? ownKeys$1(Object(t2), true).forEach(function(r3) {
      _defineProperty$2(e3, r3, t2[r3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e3, Object.getOwnPropertyDescriptors(t2)) : ownKeys$1(Object(t2)).forEach(function(r3) {
      Object.defineProperty(e3, r3, Object.getOwnPropertyDescriptor(t2, r3));
    });
  }
  return e3;
}
function _classCallCheck$1(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties$1(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey$1(descriptor.key), descriptor);
  }
}
function _createClass$1(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$1(Constructor.prototype, protoProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
function _callSuper$1(t2, o, e3) {
  return o = _getPrototypeOf$1(o), _possibleConstructorReturn$1(t2, _isNativeReflectConstruct$1() ? Reflect.construct(o, e3 || [], _getPrototypeOf$1(t2).constructor) : o.apply(t2, e3));
}
function _possibleConstructorReturn$1(self2, call) {
  if (call && (_typeof$1(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized$1(self2);
}
function _assertThisInitialized$1(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
function _isNativeReflectConstruct$1() {
  try {
    var t2 = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t3) {
  }
  return (_isNativeReflectConstruct$1 = function _isNativeReflectConstruct2() {
    return !!t2;
  })();
}
function _getPrototypeOf$1(o) {
  _getPrototypeOf$1 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf2(o2) {
    return o2.__proto__ || Object.getPrototypeOf(o2);
  };
  return _getPrototypeOf$1(o);
}
function _inherits$1(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });
  Object.defineProperty(subClass, "prototype", { writable: false });
  if (superClass) _setPrototypeOf$1(subClass, superClass);
}
function _setPrototypeOf$1(o, p2) {
  _setPrototypeOf$1 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf2(o2, p3) {
    o2.__proto__ = p3;
    return o2;
  };
  return _setPrototypeOf$1(o, p2);
}
function _defineProperty$2(obj, key, value) {
  key = _toPropertyKey$1(key);
  if (key in obj) {
    Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey$1(t2) {
  var i = _toPrimitive$1(t2, "string");
  return "symbol" == _typeof$1(i) ? i : i + "";
}
function _toPrimitive$1(t2, r2) {
  if ("object" != _typeof$1(t2) || !t2) return t2;
  var e3 = t2[Symbol.toPrimitive];
  if (void 0 !== e3) {
    var i = e3.call(t2, r2);
    if ("object" != _typeof$1(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(t2);
}
var SIZE = 32;
var DefaultLegendContent = /* @__PURE__ */ function(_PureComponent) {
  function DefaultLegendContent2() {
    _classCallCheck$1(this, DefaultLegendContent2);
    return _callSuper$1(this, DefaultLegendContent2, arguments);
  }
  _inherits$1(DefaultLegendContent2, _PureComponent);
  return _createClass$1(DefaultLegendContent2, [{
    key: "renderIcon",
    value: (
      /**
       * Render the path of icon
       * @param {Object} data Data of each legend item
       * @return {String} Path element
       */
      function renderIcon(data) {
        var inactiveColor = this.props.inactiveColor;
        var halfSize = SIZE / 2;
        var sixthSize = SIZE / 6;
        var thirdSize = SIZE / 3;
        var color2 = data.inactive ? inactiveColor : data.color;
        if (data.type === "plainline") {
          return /* @__PURE__ */ React__default.createElement("line", {
            strokeWidth: 4,
            fill: "none",
            stroke: color2,
            strokeDasharray: data.payload.strokeDasharray,
            x1: 0,
            y1: halfSize,
            x2: SIZE,
            y2: halfSize,
            className: "recharts-legend-icon"
          });
        }
        if (data.type === "line") {
          return /* @__PURE__ */ React__default.createElement("path", {
            strokeWidth: 4,
            fill: "none",
            stroke: color2,
            d: "M0,".concat(halfSize, "h").concat(thirdSize, "\n            A").concat(sixthSize, ",").concat(sixthSize, ",0,1,1,").concat(2 * thirdSize, ",").concat(halfSize, "\n            H").concat(SIZE, "M").concat(2 * thirdSize, ",").concat(halfSize, "\n            A").concat(sixthSize, ",").concat(sixthSize, ",0,1,1,").concat(thirdSize, ",").concat(halfSize),
            className: "recharts-legend-icon"
          });
        }
        if (data.type === "rect") {
          return /* @__PURE__ */ React__default.createElement("path", {
            stroke: "none",
            fill: color2,
            d: "M0,".concat(SIZE / 8, "h").concat(SIZE, "v").concat(SIZE * 3 / 4, "h").concat(-SIZE, "z"),
            className: "recharts-legend-icon"
          });
        }
        if (/* @__PURE__ */ React__default.isValidElement(data.legendIcon)) {
          var iconProps = _objectSpread$1({}, data);
          delete iconProps.legendIcon;
          return /* @__PURE__ */ React__default.cloneElement(data.legendIcon, iconProps);
        }
        return /* @__PURE__ */ React__default.createElement(Symbols, {
          fill: color2,
          cx: halfSize,
          cy: halfSize,
          size: SIZE,
          sizeType: "diameter",
          type: data.type
        });
      }
    )
    /**
     * Draw items of legend
     * @return {ReactElement} Items
     */
  }, {
    key: "renderItems",
    value: function renderItems() {
      var _this = this;
      var _this$props = this.props, payload = _this$props.payload, iconSize = _this$props.iconSize, layout2 = _this$props.layout, formatter = _this$props.formatter, inactiveColor = _this$props.inactiveColor;
      var viewBox = {
        x: 0,
        y: 0,
        width: SIZE,
        height: SIZE
      };
      var itemStyle = {
        display: layout2 === "horizontal" ? "inline-block" : "block",
        marginRight: 10
      };
      var svgStyle = {
        display: "inline-block",
        verticalAlign: "middle",
        marginRight: 4
      };
      return payload.map(function(entry, i) {
        var finalFormatter = entry.formatter || formatter;
        var className = clsx(_defineProperty$2(_defineProperty$2({
          "recharts-legend-item": true
        }, "legend-item-".concat(i), true), "inactive", entry.inactive));
        if (entry.type === "none") {
          return null;
        }
        var entryValue = !isFunction$3(entry.value) ? entry.value : null;
        warn(
          !isFunction$3(entry.value),
          `The name property is also required when using a function for the dataKey of a chart's cartesian components. Ex: <Bar name="Name of my Data"/>`
          // eslint-disable-line max-len
        );
        var color2 = entry.inactive ? inactiveColor : entry.color;
        return /* @__PURE__ */ React__default.createElement("li", _extends$1({
          className,
          style: itemStyle,
          key: "legend-item-".concat(i)
        }, adaptEventsOfChild(_this.props, entry, i)), /* @__PURE__ */ React__default.createElement(Surface, {
          width: iconSize,
          height: iconSize,
          viewBox,
          style: svgStyle
        }, _this.renderIcon(entry)), /* @__PURE__ */ React__default.createElement("span", {
          className: "recharts-legend-item-text",
          style: {
            color: color2
          }
        }, finalFormatter ? finalFormatter(entryValue, entry, i) : entryValue));
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props, payload = _this$props2.payload, layout2 = _this$props2.layout, align = _this$props2.align;
      if (!payload || !payload.length) {
        return null;
      }
      var finalStyle = {
        padding: 0,
        margin: 0,
        textAlign: layout2 === "horizontal" ? align : "left"
      };
      return /* @__PURE__ */ React__default.createElement("ul", {
        className: "recharts-default-legend",
        style: finalStyle
      }, this.renderItems());
    }
  }]);
}(PureComponent);
_defineProperty$2(DefaultLegendContent, "displayName", "Legend");
_defineProperty$2(DefaultLegendContent, "defaultProps", {
  iconSize: 14,
  layout: "horizontal",
  align: "center",
  verticalAlign: "middle",
  inactiveColor: "#ccc"
});
var ListCache$2 = _ListCache;
function stackClear$1() {
  this.__data__ = new ListCache$2();
  this.size = 0;
}
var _stackClear = stackClear$1;
function stackDelete$1(key) {
  var data = this.__data__, result = data["delete"](key);
  this.size = data.size;
  return result;
}
var _stackDelete = stackDelete$1;
function stackGet$1(key) {
  return this.__data__.get(key);
}
var _stackGet = stackGet$1;
function stackHas$1(key) {
  return this.__data__.has(key);
}
var _stackHas = stackHas$1;
var ListCache$1 = _ListCache, Map$2 = _Map, MapCache$1 = _MapCache;
var LARGE_ARRAY_SIZE$1 = 200;
function stackSet$1(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache$1) {
    var pairs = data.__data__;
    if (!Map$2 || pairs.length < LARGE_ARRAY_SIZE$1 - 1) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache$1(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}
var _stackSet = stackSet$1;
var ListCache = _ListCache, stackClear = _stackClear, stackDelete = _stackDelete, stackGet = _stackGet, stackHas = _stackHas, stackSet = _stackSet;
function Stack$2(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}
Stack$2.prototype.clear = stackClear;
Stack$2.prototype["delete"] = stackDelete;
Stack$2.prototype.get = stackGet;
Stack$2.prototype.has = stackHas;
Stack$2.prototype.set = stackSet;
var _Stack = Stack$2;
var HASH_UNDEFINED = "__lodash_hash_undefined__";
function setCacheAdd$1(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}
var _setCacheAdd = setCacheAdd$1;
function setCacheHas$1(value) {
  return this.__data__.has(value);
}
var _setCacheHas = setCacheHas$1;
var MapCache = _MapCache, setCacheAdd = _setCacheAdd, setCacheHas = _setCacheHas;
function SetCache$2(values3) {
  var index2 = -1, length2 = values3 == null ? 0 : values3.length;
  this.__data__ = new MapCache();
  while (++index2 < length2) {
    this.add(values3[index2]);
  }
}
SetCache$2.prototype.add = SetCache$2.prototype.push = setCacheAdd;
SetCache$2.prototype.has = setCacheHas;
var _SetCache = SetCache$2;
function arraySome$1(array, predicate2) {
  var index2 = -1, length2 = array == null ? 0 : array.length;
  while (++index2 < length2) {
    if (predicate2(array[index2], index2, array)) {
      return true;
    }
  }
  return false;
}
var _arraySome = arraySome$1;
function cacheHas$2(cache, key) {
  return cache.has(key);
}
var _cacheHas = cacheHas$2;
var SetCache$1 = _SetCache, arraySome = _arraySome, cacheHas$1 = _cacheHas;
var COMPARE_PARTIAL_FLAG$5 = 1, COMPARE_UNORDERED_FLAG$3 = 2;
function equalArrays$2(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG$5, arrLength = array.length, othLength = other.length;
  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  var arrStacked = stack.get(array);
  var othStacked = stack.get(other);
  if (arrStacked && othStacked) {
    return arrStacked == other && othStacked == array;
  }
  var index2 = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG$3 ? new SetCache$1() : void 0;
  stack.set(array, other);
  stack.set(other, array);
  while (++index2 < arrLength) {
    var arrValue = array[index2], othValue = other[index2];
    if (customizer) {
      var compared = isPartial ? customizer(othValue, arrValue, index2, other, array, stack) : customizer(arrValue, othValue, index2, array, other, stack);
    }
    if (compared !== void 0) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    if (seen) {
      if (!arraySome(other, function(othValue2, othIndex) {
        if (!cacheHas$1(seen, othIndex) && (arrValue === othValue2 || equalFunc(arrValue, othValue2, bitmask, customizer, stack))) {
          return seen.push(othIndex);
        }
      })) {
        result = false;
        break;
      }
    } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
      result = false;
      break;
    }
  }
  stack["delete"](array);
  stack["delete"](other);
  return result;
}
var _equalArrays = equalArrays$2;
var root$4 = _root;
var Uint8Array$2 = root$4.Uint8Array;
var _Uint8Array = Uint8Array$2;
function mapToArray$1(map) {
  var index2 = -1, result = Array(map.size);
  map.forEach(function(value, key) {
    result[++index2] = [key, value];
  });
  return result;
}
var _mapToArray = mapToArray$1;
function setToArray$3(set2) {
  var index2 = -1, result = Array(set2.size);
  set2.forEach(function(value) {
    result[++index2] = value;
  });
  return result;
}
var _setToArray = setToArray$3;
var Symbol$1 = _Symbol, Uint8Array$1 = _Uint8Array, eq = eq_1, equalArrays$1 = _equalArrays, mapToArray = _mapToArray, setToArray$2 = _setToArray;
var COMPARE_PARTIAL_FLAG$4 = 1, COMPARE_UNORDERED_FLAG$2 = 2;
var boolTag$1 = "[object Boolean]", dateTag$1 = "[object Date]", errorTag$1 = "[object Error]", mapTag$2 = "[object Map]", numberTag$1 = "[object Number]", regexpTag$1 = "[object RegExp]", setTag$2 = "[object Set]", stringTag$1 = "[object String]", symbolTag = "[object Symbol]";
var arrayBufferTag$1 = "[object ArrayBuffer]", dataViewTag$2 = "[object DataView]";
var symbolProto = Symbol$1 ? Symbol$1.prototype : void 0, symbolValueOf = symbolProto ? symbolProto.valueOf : void 0;
function equalByTag$1(object2, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag$2:
      if (object2.byteLength != other.byteLength || object2.byteOffset != other.byteOffset) {
        return false;
      }
      object2 = object2.buffer;
      other = other.buffer;
    case arrayBufferTag$1:
      if (object2.byteLength != other.byteLength || !equalFunc(new Uint8Array$1(object2), new Uint8Array$1(other))) {
        return false;
      }
      return true;
    case boolTag$1:
    case dateTag$1:
    case numberTag$1:
      return eq(+object2, +other);
    case errorTag$1:
      return object2.name == other.name && object2.message == other.message;
    case regexpTag$1:
    case stringTag$1:
      return object2 == other + "";
    case mapTag$2:
      var convert = mapToArray;
    case setTag$2:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG$4;
      convert || (convert = setToArray$2);
      if (object2.size != other.size && !isPartial) {
        return false;
      }
      var stacked = stack.get(object2);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG$2;
      stack.set(object2, other);
      var result = equalArrays$1(convert(object2), convert(other), bitmask, customizer, equalFunc, stack);
      stack["delete"](object2);
      return result;
    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object2) == symbolValueOf.call(other);
      }
  }
  return false;
}
var _equalByTag = equalByTag$1;
function arrayPush$1(array, values3) {
  var index2 = -1, length2 = values3.length, offset2 = array.length;
  while (++index2 < length2) {
    array[offset2 + index2] = values3[index2];
  }
  return array;
}
var _arrayPush = arrayPush$1;
var arrayPush = _arrayPush, isArray$4 = isArray_1;
function baseGetAllKeys$1(object2, keysFunc, symbolsFunc) {
  var result = keysFunc(object2);
  return isArray$4(object2) ? result : arrayPush(result, symbolsFunc(object2));
}
var _baseGetAllKeys = baseGetAllKeys$1;
function arrayFilter$1(array, predicate2) {
  var index2 = -1, length2 = array == null ? 0 : array.length, resIndex = 0, result = [];
  while (++index2 < length2) {
    var value = array[index2];
    if (predicate2(value, index2, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}
var _arrayFilter = arrayFilter$1;
function stubArray$1() {
  return [];
}
var stubArray_1 = stubArray$1;
var arrayFilter = _arrayFilter, stubArray = stubArray_1;
var objectProto$6 = Object.prototype;
var propertyIsEnumerable$1 = objectProto$6.propertyIsEnumerable;
var nativeGetSymbols = Object.getOwnPropertySymbols;
var getSymbols$1 = !nativeGetSymbols ? stubArray : function(object2) {
  if (object2 == null) {
    return [];
  }
  object2 = Object(object2);
  return arrayFilter(nativeGetSymbols(object2), function(symbol) {
    return propertyIsEnumerable$1.call(object2, symbol);
  });
};
var _getSymbols = getSymbols$1;
function baseTimes$1(n2, iteratee) {
  var index2 = -1, result = Array(n2);
  while (++index2 < n2) {
    result[index2] = iteratee(index2);
  }
  return result;
}
var _baseTimes = baseTimes$1;
var baseGetTag$2 = _baseGetTag, isObjectLike$3 = isObjectLike_1;
var argsTag$2 = "[object Arguments]";
function baseIsArguments$1(value) {
  return isObjectLike$3(value) && baseGetTag$2(value) == argsTag$2;
}
var _baseIsArguments = baseIsArguments$1;
var baseIsArguments = _baseIsArguments, isObjectLike$2 = isObjectLike_1;
var objectProto$5 = Object.prototype;
var hasOwnProperty$4 = objectProto$5.hasOwnProperty;
var propertyIsEnumerable = objectProto$5.propertyIsEnumerable;
var isArguments$2 = baseIsArguments(/* @__PURE__ */ function() {
  return arguments;
}()) ? baseIsArguments : function(value) {
  return isObjectLike$2(value) && hasOwnProperty$4.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
};
var isArguments_1 = isArguments$2;
var isBuffer$2 = { exports: {} };
function stubFalse() {
  return false;
}
var stubFalse_1 = stubFalse;
isBuffer$2.exports;
(function(module, exports$1) {
  var root2 = _root, stubFalse2 = stubFalse_1;
  var freeExports = exports$1 && !exports$1.nodeType && exports$1;
  var freeModule = freeExports && true && module && !module.nodeType && module;
  var moduleExports = freeModule && freeModule.exports === freeExports;
  var Buffer2 = moduleExports ? root2.Buffer : void 0;
  var nativeIsBuffer = Buffer2 ? Buffer2.isBuffer : void 0;
  var isBuffer2 = nativeIsBuffer || stubFalse2;
  module.exports = isBuffer2;
})(isBuffer$2, isBuffer$2.exports);
var isBufferExports = isBuffer$2.exports;
var MAX_SAFE_INTEGER$1 = 9007199254740991;
var reIsUint = /^(?:0|[1-9]\d*)$/;
function isIndex$2(value, length2) {
  var type2 = typeof value;
  length2 = length2 == null ? MAX_SAFE_INTEGER$1 : length2;
  return !!length2 && (type2 == "number" || type2 != "symbol" && reIsUint.test(value)) && (value > -1 && value % 1 == 0 && value < length2);
}
var _isIndex = isIndex$2;
var MAX_SAFE_INTEGER = 9007199254740991;
function isLength$3(value) {
  return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}
var isLength_1 = isLength$3;
var baseGetTag$1 = _baseGetTag, isLength$2 = isLength_1, isObjectLike$1 = isObjectLike_1;
var argsTag$1 = "[object Arguments]", arrayTag$1 = "[object Array]", boolTag = "[object Boolean]", dateTag = "[object Date]", errorTag = "[object Error]", funcTag = "[object Function]", mapTag$1 = "[object Map]", numberTag = "[object Number]", objectTag$2 = "[object Object]", regexpTag = "[object RegExp]", setTag$1 = "[object Set]", stringTag = "[object String]", weakMapTag$1 = "[object WeakMap]";
var arrayBufferTag = "[object ArrayBuffer]", dataViewTag$1 = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag$1] = typedArrayTags[arrayTag$1] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag$1] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag$1] = typedArrayTags[numberTag] = typedArrayTags[objectTag$2] = typedArrayTags[regexpTag] = typedArrayTags[setTag$1] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag$1] = false;
function baseIsTypedArray$1(value) {
  return isObjectLike$1(value) && isLength$2(value.length) && !!typedArrayTags[baseGetTag$1(value)];
}
var _baseIsTypedArray = baseIsTypedArray$1;
function baseUnary$1(func) {
  return function(value) {
    return func(value);
  };
}
var _baseUnary = baseUnary$1;
var _nodeUtil = { exports: {} };
_nodeUtil.exports;
(function(module, exports$1) {
  var freeGlobal2 = _freeGlobal;
  var freeExports = exports$1 && !exports$1.nodeType && exports$1;
  var freeModule = freeExports && true && module && !module.nodeType && module;
  var moduleExports = freeModule && freeModule.exports === freeExports;
  var freeProcess = moduleExports && freeGlobal2.process;
  var nodeUtil2 = function() {
    try {
      var types = freeModule && freeModule.require && freeModule.require("util").types;
      if (types) {
        return types;
      }
      return freeProcess && freeProcess.binding && freeProcess.binding("util");
    } catch (e3) {
    }
  }();
  module.exports = nodeUtil2;
})(_nodeUtil, _nodeUtil.exports);
var _nodeUtilExports = _nodeUtil.exports;
var baseIsTypedArray = _baseIsTypedArray, baseUnary = _baseUnary, nodeUtil = _nodeUtilExports;
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
var isTypedArray$2 = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
var isTypedArray_1 = isTypedArray$2;
var baseTimes = _baseTimes, isArguments$1 = isArguments_1, isArray$3 = isArray_1, isBuffer$1 = isBufferExports, isIndex$1 = _isIndex, isTypedArray$1 = isTypedArray_1;
var objectProto$4 = Object.prototype;
var hasOwnProperty$3 = objectProto$4.hasOwnProperty;
function arrayLikeKeys$1(value, inherited) {
  var isArr = isArray$3(value), isArg = !isArr && isArguments$1(value), isBuff = !isArr && !isArg && isBuffer$1(value), isType = !isArr && !isArg && !isBuff && isTypedArray$1(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length2 = result.length;
  for (var key in value) {
    if ((inherited || hasOwnProperty$3.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
    isIndex$1(key, length2)))) {
      result.push(key);
    }
  }
  return result;
}
var _arrayLikeKeys = arrayLikeKeys$1;
var objectProto$3 = Object.prototype;
function isPrototype$1(value) {
  var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto$3;
  return value === proto;
}
var _isPrototype = isPrototype$1;
function overArg$1(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}
var _overArg = overArg$1;
var overArg = _overArg;
var nativeKeys$1 = overArg(Object.keys, Object);
var _nativeKeys = nativeKeys$1;
var isPrototype = _isPrototype, nativeKeys = _nativeKeys;
var objectProto$2 = Object.prototype;
var hasOwnProperty$2 = objectProto$2.hasOwnProperty;
function baseKeys$1(object2) {
  if (!isPrototype(object2)) {
    return nativeKeys(object2);
  }
  var result = [];
  for (var key in Object(object2)) {
    if (hasOwnProperty$2.call(object2, key) && key != "constructor") {
      result.push(key);
    }
  }
  return result;
}
var _baseKeys = baseKeys$1;
var isFunction = isFunction_1, isLength$1 = isLength_1;
function isArrayLike$1(value) {
  return value != null && isLength$1(value.length) && !isFunction(value);
}
var isArrayLike_1 = isArrayLike$1;
var arrayLikeKeys = _arrayLikeKeys, baseKeys = _baseKeys, isArrayLike = isArrayLike_1;
function keys$2(object2) {
  return isArrayLike(object2) ? arrayLikeKeys(object2) : baseKeys(object2);
}
var keys_1 = keys$2;
var baseGetAllKeys = _baseGetAllKeys, getSymbols = _getSymbols, keys$1 = keys_1;
function getAllKeys$1(object2) {
  return baseGetAllKeys(object2, keys$1, getSymbols);
}
var _getAllKeys = getAllKeys$1;
var getAllKeys = _getAllKeys;
var COMPARE_PARTIAL_FLAG$3 = 1;
var objectProto$1 = Object.prototype;
var hasOwnProperty$1 = objectProto$1.hasOwnProperty;
function equalObjects$1(object2, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG$3, objProps = getAllKeys(object2), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index2 = objLength;
  while (index2--) {
    var key = objProps[index2];
    if (!(isPartial ? key in other : hasOwnProperty$1.call(other, key))) {
      return false;
    }
  }
  var objStacked = stack.get(object2);
  var othStacked = stack.get(other);
  if (objStacked && othStacked) {
    return objStacked == other && othStacked == object2;
  }
  var result = true;
  stack.set(object2, other);
  stack.set(other, object2);
  var skipCtor = isPartial;
  while (++index2 < objLength) {
    key = objProps[index2];
    var objValue = object2[key], othValue = other[key];
    if (customizer) {
      var compared = isPartial ? customizer(othValue, objValue, key, other, object2, stack) : customizer(objValue, othValue, key, object2, other, stack);
    }
    if (!(compared === void 0 ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == "constructor");
  }
  if (result && !skipCtor) {
    var objCtor = object2.constructor, othCtor = other.constructor;
    if (objCtor != othCtor && ("constructor" in object2 && "constructor" in other) && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack["delete"](object2);
  stack["delete"](other);
  return result;
}
var _equalObjects = equalObjects$1;
var getNative$3 = _getNative, root$3 = _root;
var DataView$2 = getNative$3(root$3, "DataView");
var _DataView = DataView$2;
var getNative$2 = _getNative, root$2 = _root;
var Promise$2 = getNative$2(root$2, "Promise");
var _Promise = Promise$2;
var getNative$1 = _getNative, root$1 = _root;
var Set$3 = getNative$1(root$1, "Set");
var _Set = Set$3;
var getNative = _getNative, root = _root;
var WeakMap$2 = getNative(root, "WeakMap");
var _WeakMap = WeakMap$2;
var DataView$1 = _DataView, Map$1 = _Map, Promise$1 = _Promise, Set$2 = _Set, WeakMap$1 = _WeakMap, baseGetTag = _baseGetTag, toSource = _toSource;
var mapTag = "[object Map]", objectTag$1 = "[object Object]", promiseTag = "[object Promise]", setTag = "[object Set]", weakMapTag = "[object WeakMap]";
var dataViewTag = "[object DataView]";
var dataViewCtorString = toSource(DataView$1), mapCtorString = toSource(Map$1), promiseCtorString = toSource(Promise$1), setCtorString = toSource(Set$2), weakMapCtorString = toSource(WeakMap$1);
var getTag$1 = baseGetTag;
if (DataView$1 && getTag$1(new DataView$1(new ArrayBuffer(1))) != dataViewTag || Map$1 && getTag$1(new Map$1()) != mapTag || Promise$1 && getTag$1(Promise$1.resolve()) != promiseTag || Set$2 && getTag$1(new Set$2()) != setTag || WeakMap$1 && getTag$1(new WeakMap$1()) != weakMapTag) {
  getTag$1 = function(value) {
    var result = baseGetTag(value), Ctor = result == objectTag$1 ? value.constructor : void 0, ctorString = Ctor ? toSource(Ctor) : "";
    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString:
          return dataViewTag;
        case mapCtorString:
          return mapTag;
        case promiseCtorString:
          return promiseTag;
        case setCtorString:
          return setTag;
        case weakMapCtorString:
          return weakMapTag;
      }
    }
    return result;
  };
}
var _getTag = getTag$1;
var Stack$1 = _Stack, equalArrays = _equalArrays, equalByTag = _equalByTag, equalObjects = _equalObjects, getTag = _getTag, isArray$2 = isArray_1, isBuffer = isBufferExports, isTypedArray = isTypedArray_1;
var COMPARE_PARTIAL_FLAG$2 = 1;
var argsTag = "[object Arguments]", arrayTag = "[object Array]", objectTag = "[object Object]";
var objectProto = Object.prototype;
var hasOwnProperty = objectProto.hasOwnProperty;
function baseIsEqualDeep$1(object2, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray$2(object2), othIsArr = isArray$2(other), objTag = objIsArr ? arrayTag : getTag(object2), othTag = othIsArr ? arrayTag : getTag(other);
  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;
  var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
  if (isSameTag && isBuffer(object2)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack$1());
    return objIsArr || isTypedArray(object2) ? equalArrays(object2, other, bitmask, customizer, equalFunc, stack) : equalByTag(object2, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG$2)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object2, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty.call(other, "__wrapped__");
    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object2.value() : object2, othUnwrapped = othIsWrapped ? other.value() : other;
      stack || (stack = new Stack$1());
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack$1());
  return equalObjects(object2, other, bitmask, customizer, equalFunc, stack);
}
var _baseIsEqualDeep = baseIsEqualDeep$1;
var baseIsEqualDeep = _baseIsEqualDeep, isObjectLike = isObjectLike_1;
function baseIsEqual$2(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual$2, stack);
}
var _baseIsEqual = baseIsEqual$2;
var Stack = _Stack, baseIsEqual$1 = _baseIsEqual;
var COMPARE_PARTIAL_FLAG$1 = 1, COMPARE_UNORDERED_FLAG$1 = 2;
function baseIsMatch$1(object2, source, matchData, customizer) {
  var index2 = matchData.length, length2 = index2, noCustomizer = !customizer;
  if (object2 == null) {
    return !length2;
  }
  object2 = Object(object2);
  while (index2--) {
    var data = matchData[index2];
    if (noCustomizer && data[2] ? data[1] !== object2[data[0]] : !(data[0] in object2)) {
      return false;
    }
  }
  while (++index2 < length2) {
    data = matchData[index2];
    var key = data[0], objValue = object2[key], srcValue = data[1];
    if (noCustomizer && data[2]) {
      if (objValue === void 0 && !(key in object2)) {
        return false;
      }
    } else {
      var stack = new Stack();
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object2, source, stack);
      }
      if (!(result === void 0 ? baseIsEqual$1(srcValue, objValue, COMPARE_PARTIAL_FLAG$1 | COMPARE_UNORDERED_FLAG$1, customizer, stack) : result)) {
        return false;
      }
    }
  }
  return true;
}
var _baseIsMatch = baseIsMatch$1;
var isObject = isObject_1;
function isStrictComparable$2(value) {
  return value === value && !isObject(value);
}
var _isStrictComparable = isStrictComparable$2;
var isStrictComparable$1 = _isStrictComparable, keys2 = keys_1;
function getMatchData$1(object2) {
  var result = keys2(object2), length2 = result.length;
  while (length2--) {
    var key = result[length2], value = object2[key];
    result[length2] = [key, value, isStrictComparable$1(value)];
  }
  return result;
}
var _getMatchData = getMatchData$1;
function matchesStrictComparable$2(key, srcValue) {
  return function(object2) {
    if (object2 == null) {
      return false;
    }
    return object2[key] === srcValue && (srcValue !== void 0 || key in Object(object2));
  };
}
var _matchesStrictComparable = matchesStrictComparable$2;
var baseIsMatch = _baseIsMatch, getMatchData = _getMatchData, matchesStrictComparable$1 = _matchesStrictComparable;
function baseMatches$1(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable$1(matchData[0][0], matchData[0][1]);
  }
  return function(object2) {
    return object2 === source || baseIsMatch(object2, source, matchData);
  };
}
var _baseMatches = baseMatches$1;
function baseHasIn$1(object2, key) {
  return object2 != null && key in Object(object2);
}
var _baseHasIn = baseHasIn$1;
var castPath = _castPath, isArguments2 = isArguments_1, isArray$1 = isArray_1, isIndex = _isIndex, isLength = isLength_1, toKey$2 = _toKey;
function hasPath$1(object2, path, hasFunc) {
  path = castPath(path, object2);
  var index2 = -1, length2 = path.length, result = false;
  while (++index2 < length2) {
    var key = toKey$2(path[index2]);
    if (!(result = object2 != null && hasFunc(object2, key))) {
      break;
    }
    object2 = object2[key];
  }
  if (result || ++index2 != length2) {
    return result;
  }
  length2 = object2 == null ? 0 : object2.length;
  return !!length2 && isLength(length2) && isIndex(key, length2) && (isArray$1(object2) || isArguments2(object2));
}
var _hasPath = hasPath$1;
var baseHasIn = _baseHasIn, hasPath = _hasPath;
function hasIn$1(object2, path) {
  return object2 != null && hasPath(object2, path, baseHasIn);
}
var hasIn_1 = hasIn$1;
var baseIsEqual = _baseIsEqual, get = get_1, hasIn = hasIn_1, isKey$1 = _isKey, isStrictComparable = _isStrictComparable, matchesStrictComparable = _matchesStrictComparable, toKey$1 = _toKey;
var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
function baseMatchesProperty$1(path, srcValue) {
  if (isKey$1(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey$1(path), srcValue);
  }
  return function(object2) {
    var objValue = get(object2, path);
    return objValue === void 0 && objValue === srcValue ? hasIn(object2, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}
var _baseMatchesProperty = baseMatchesProperty$1;
function identity$1(value) {
  return value;
}
var identity_1 = identity$1;
function baseProperty$1(key) {
  return function(object2) {
    return object2 == null ? void 0 : object2[key];
  };
}
var _baseProperty = baseProperty$1;
var baseGet = _baseGet;
function basePropertyDeep$1(path) {
  return function(object2) {
    return baseGet(object2, path);
  };
}
var _basePropertyDeep = basePropertyDeep$1;
var baseProperty = _baseProperty, basePropertyDeep = _basePropertyDeep, isKey = _isKey, toKey = _toKey;
function property$1(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}
var property_1 = property$1;
var baseMatches = _baseMatches, baseMatchesProperty = _baseMatchesProperty, identity = identity_1, isArray = isArray_1, property = property_1;
function baseIteratee$1(value) {
  if (typeof value == "function") {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if (typeof value == "object") {
    return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
  }
  return property(value);
}
var _baseIteratee = baseIteratee$1;
function baseFindIndex$1(array, predicate2, fromIndex, fromRight) {
  var length2 = array.length, index2 = fromIndex + (fromRight ? 1 : -1);
  while (fromRight ? index2-- : ++index2 < length2) {
    if (predicate2(array[index2], index2, array)) {
      return index2;
    }
  }
  return -1;
}
var _baseFindIndex = baseFindIndex$1;
function baseIsNaN$1(value) {
  return value !== value;
}
var _baseIsNaN = baseIsNaN$1;
function strictIndexOf$1(array, value, fromIndex) {
  var index2 = fromIndex - 1, length2 = array.length;
  while (++index2 < length2) {
    if (array[index2] === value) {
      return index2;
    }
  }
  return -1;
}
var _strictIndexOf = strictIndexOf$1;
var baseFindIndex = _baseFindIndex, baseIsNaN = _baseIsNaN, strictIndexOf = _strictIndexOf;
function baseIndexOf$1(array, value, fromIndex) {
  return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
}
var _baseIndexOf = baseIndexOf$1;
var baseIndexOf = _baseIndexOf;
function arrayIncludes$1(array, value) {
  var length2 = array == null ? 0 : array.length;
  return !!length2 && baseIndexOf(array, value, 0) > -1;
}
var _arrayIncludes = arrayIncludes$1;
function arrayIncludesWith$1(array, value, comparator) {
  var index2 = -1, length2 = array == null ? 0 : array.length;
  while (++index2 < length2) {
    if (comparator(value, array[index2])) {
      return true;
    }
  }
  return false;
}
var _arrayIncludesWith = arrayIncludesWith$1;
function noop$1() {
}
var noop_1 = noop$1;
var Set$1 = _Set, noop2 = noop_1, setToArray$1 = _setToArray;
var INFINITY = 1 / 0;
var createSet$1 = !(Set$1 && 1 / setToArray$1(new Set$1([, -0]))[1] == INFINITY) ? noop2 : function(values3) {
  return new Set$1(values3);
};
var _createSet = createSet$1;
var SetCache = _SetCache, arrayIncludes = _arrayIncludes, arrayIncludesWith = _arrayIncludesWith, cacheHas = _cacheHas, createSet = _createSet, setToArray = _setToArray;
var LARGE_ARRAY_SIZE = 200;
function baseUniq$1(array, iteratee, comparator) {
  var index2 = -1, includes = arrayIncludes, length2 = array.length, isCommon = true, result = [], seen = result;
  if (comparator) {
    isCommon = false;
    includes = arrayIncludesWith;
  } else if (length2 >= LARGE_ARRAY_SIZE) {
    var set2 = iteratee ? null : createSet(array);
    if (set2) {
      return setToArray(set2);
    }
    isCommon = false;
    includes = cacheHas;
    seen = new SetCache();
  } else {
    seen = iteratee ? [] : result;
  }
  outer:
    while (++index2 < length2) {
      var value = array[index2], computed = iteratee ? iteratee(value) : value;
      value = comparator || value !== 0 ? value : 0;
      if (isCommon && computed === computed) {
        var seenIndex = seen.length;
        while (seenIndex--) {
          if (seen[seenIndex] === computed) {
            continue outer;
          }
        }
        if (iteratee) {
          seen.push(computed);
        }
        result.push(value);
      } else if (!includes(seen, computed, comparator)) {
        if (seen !== result) {
          seen.push(computed);
        }
        result.push(value);
      }
    }
  return result;
}
var _baseUniq = baseUniq$1;
var baseIteratee = _baseIteratee, baseUniq = _baseUniq;
function uniqBy(array, iteratee) {
  return array && array.length ? baseUniq(array, baseIteratee(iteratee)) : [];
}
var uniqBy_1 = uniqBy;
var uniqBy$1 = /* @__PURE__ */ getDefaultExportFromCjs(uniqBy_1);
function getUniqPayload(payload, option, defaultUniqBy2) {
  if (option === true) {
    return uniqBy$1(payload, defaultUniqBy2);
  }
  if (isFunction$3(option)) {
    return uniqBy$1(payload, option);
  }
  return payload;
}
function _typeof(o) {
  "@babel/helpers - typeof";
  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof(o);
}
var _excluded = ["ref"];
function ownKeys(e3, r2) {
  var t2 = Object.keys(e3);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e3);
    r2 && (o = o.filter(function(r3) {
      return Object.getOwnPropertyDescriptor(e3, r3).enumerable;
    })), t2.push.apply(t2, o);
  }
  return t2;
}
function _objectSpread(e3) {
  for (var r2 = 1; r2 < arguments.length; r2++) {
    var t2 = null != arguments[r2] ? arguments[r2] : {};
    r2 % 2 ? ownKeys(Object(t2), true).forEach(function(r3) {
      _defineProperty$1(e3, r3, t2[r3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e3, Object.getOwnPropertyDescriptors(t2)) : ownKeys(Object(t2)).forEach(function(r3) {
      Object.defineProperty(e3, r3, Object.getOwnPropertyDescriptor(t2, r3));
    });
  }
  return e3;
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
function _callSuper(t2, o, e3) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t2, _isNativeReflectConstruct() ? Reflect.construct(o, e3 || [], _getPrototypeOf(t2).constructor) : o.apply(t2, e3));
}
function _possibleConstructorReturn(self2, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized(self2);
}
function _assertThisInitialized(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
function _isNativeReflectConstruct() {
  try {
    var t2 = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t3) {
  }
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct2() {
    return !!t2;
  })();
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf2(o2) {
    return o2.__proto__ || Object.getPrototypeOf(o2);
  };
  return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });
  Object.defineProperty(subClass, "prototype", { writable: false });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p2) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf2(o2, p3) {
    o2.__proto__ = p3;
    return o2;
  };
  return _setPrototypeOf(o, p2);
}
function _defineProperty$1(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey(t2) {
  var i = _toPrimitive(t2, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t2, r2) {
  if ("object" != _typeof(t2) || !t2) return t2;
  var e3 = t2[Symbol.toPrimitive];
  if (void 0 !== e3) {
    var i = e3.call(t2, r2);
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(t2);
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  for (var key in source) {
    if (Object.prototype.hasOwnProperty.call(source, key)) {
      if (excluded.indexOf(key) >= 0) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function defaultUniqBy(entry) {
  return entry.value;
}
function renderContent(content, props) {
  if (/* @__PURE__ */ React__default.isValidElement(content)) {
    return /* @__PURE__ */ React__default.cloneElement(content, props);
  }
  if (typeof content === "function") {
    return /* @__PURE__ */ React__default.createElement(content, props);
  }
  props.ref;
  var otherProps = _objectWithoutProperties(props, _excluded);
  return /* @__PURE__ */ React__default.createElement(DefaultLegendContent, otherProps);
}
var EPS = 1;
var Legend = /* @__PURE__ */ function(_PureComponent) {
  function Legend2() {
    var _this;
    _classCallCheck(this, Legend2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, Legend2, [].concat(args));
    _defineProperty$1(_this, "lastBoundingBox", {
      width: -1,
      height: -1
    });
    return _this;
  }
  _inherits(Legend2, _PureComponent);
  return _createClass(Legend2, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.updateBBox();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.updateBBox();
    }
  }, {
    key: "getBBox",
    value: function getBBox() {
      if (this.wrapperNode && this.wrapperNode.getBoundingClientRect) {
        var box = this.wrapperNode.getBoundingClientRect();
        box.height = this.wrapperNode.offsetHeight;
        box.width = this.wrapperNode.offsetWidth;
        return box;
      }
      return null;
    }
  }, {
    key: "updateBBox",
    value: function updateBBox() {
      var onBBoxUpdate = this.props.onBBoxUpdate;
      var box = this.getBBox();
      if (box) {
        if (Math.abs(box.width - this.lastBoundingBox.width) > EPS || Math.abs(box.height - this.lastBoundingBox.height) > EPS) {
          this.lastBoundingBox.width = box.width;
          this.lastBoundingBox.height = box.height;
          if (onBBoxUpdate) {
            onBBoxUpdate(box);
          }
        }
      } else if (this.lastBoundingBox.width !== -1 || this.lastBoundingBox.height !== -1) {
        this.lastBoundingBox.width = -1;
        this.lastBoundingBox.height = -1;
        if (onBBoxUpdate) {
          onBBoxUpdate(null);
        }
      }
    }
  }, {
    key: "getBBoxSnapshot",
    value: function getBBoxSnapshot() {
      if (this.lastBoundingBox.width >= 0 && this.lastBoundingBox.height >= 0) {
        return _objectSpread({}, this.lastBoundingBox);
      }
      return {
        width: 0,
        height: 0
      };
    }
  }, {
    key: "getDefaultPosition",
    value: function getDefaultPosition(style) {
      var _this$props = this.props, layout2 = _this$props.layout, align = _this$props.align, verticalAlign = _this$props.verticalAlign, margin2 = _this$props.margin, chartWidth = _this$props.chartWidth, chartHeight = _this$props.chartHeight;
      var hPos, vPos;
      if (!style || (style.left === void 0 || style.left === null) && (style.right === void 0 || style.right === null)) {
        if (align === "center" && layout2 === "vertical") {
          var box = this.getBBoxSnapshot();
          hPos = {
            left: ((chartWidth || 0) - box.width) / 2
          };
        } else {
          hPos = align === "right" ? {
            right: margin2 && margin2.right || 0
          } : {
            left: margin2 && margin2.left || 0
          };
        }
      }
      if (!style || (style.top === void 0 || style.top === null) && (style.bottom === void 0 || style.bottom === null)) {
        if (verticalAlign === "middle") {
          var _box = this.getBBoxSnapshot();
          vPos = {
            top: ((chartHeight || 0) - _box.height) / 2
          };
        } else {
          vPos = verticalAlign === "bottom" ? {
            bottom: margin2 && margin2.bottom || 0
          } : {
            top: margin2 && margin2.top || 0
          };
        }
      }
      return _objectSpread(_objectSpread({}, hPos), vPos);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props2 = this.props, content = _this$props2.content, width2 = _this$props2.width, height2 = _this$props2.height, wrapperStyle = _this$props2.wrapperStyle, payloadUniqBy = _this$props2.payloadUniqBy, payload = _this$props2.payload;
      var outerStyle = _objectSpread(_objectSpread({
        position: "absolute",
        width: width2 || "auto",
        height: height2 || "auto"
      }, this.getDefaultPosition(wrapperStyle)), wrapperStyle);
      return /* @__PURE__ */ React__default.createElement("div", {
        className: "recharts-legend-wrapper",
        style: outerStyle,
        ref: function ref2(node2) {
          _this2.wrapperNode = node2;
        }
      }, renderContent(content, _objectSpread(_objectSpread({}, this.props), {}, {
        payload: getUniqPayload(payload, payloadUniqBy, defaultUniqBy)
      })));
    }
  }], [{
    key: "getWithHeight",
    value: function getWithHeight(item, chartWidth) {
      var _this$defaultProps$it = _objectSpread(_objectSpread({}, this.defaultProps), item.props), layout2 = _this$defaultProps$it.layout;
      if (layout2 === "vertical" && isNumber(item.props.height)) {
        return {
          height: item.props.height
        };
      }
      if (layout2 === "horizontal") {
        return {
          width: item.props.width || chartWidth
        };
      }
      return null;
    }
  }]);
}(PureComponent);
_defineProperty$1(Legend, "displayName", "Legend");
_defineProperty$1(Legend, "defaultProps", {
  iconSize: 14,
  layout: "horizontal",
  align: "center",
  verticalAlign: "bottom"
});
const ChartLegend = forwardRef(({
  legendItems,
  position: position2,
  onClick
}, ref2) => {
  function getLegendPayload() {
    return legendItems.map((item) => ({
      key: item.key,
      value: item.label,
      type: "square",
      color: item.hidden ? `${item.color}80` : item.color
    }));
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Legend, { ...ref2, verticalAlign: position2, onClick, align: "center", wrapperStyle: {
    position: "relative",
    zIndex: 1,
    top: "25px",
    left: "15px"
  }, payload: getLegendPayload(), formatter: (value) => {
    var _a2;
    return /* @__PURE__ */ jsxRuntimeExports.jsx(Text, { variant: "disclaimerSmall.responsive", style: {
      color: "black",
      opacity: ((_a2 = legendItems.find((item) => item.label === value)) == null ? void 0 : _a2.hidden) ? 0.5 : 1,
      marginRight: "6px",
      marginLeft: "3px"
    }, element: "span", children: value });
  } });
});
ChartLegend.displayName = "ChartLegend";
const StyledCaretIcon = styled(CaretDownIcon)`
  transition: transform 0.3s ease-in-out;
  transform: ${(props) => props.$trigger ? "rotate(180deg)" : "rotate(0deg)"};
`;
const StyledLinkButton$2 = styled(LinkButton)`
  display: flex;
  gap: 5px;
  position: relative;
`;
const TextContainer = styled.div`
  min-width: 40px;
`;
const TextSpan = styled.span`
  position: absolute;
  left: 0;
  top: 0;

  &.fade-enter {
    opacity: 0;
  }
  &.fade-enter-active {
    opacity: 1;
    transition: opacity 200ms ease-in;
  }
  &.fade-exit {
    opacity: 1;
  }
  &.fade-exit-active {
    opacity: 0;
    transition: opacity 200ms ease-out;
  }
`;
const OpenCloseCaret = forwardRef(({
  trigger,
  stateUpdate,
  openedText = "Hide",
  closedText = "Show",
  ...rest
}, ref2) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledLinkButton$2, { width: "100%", size: "small", onClick: () => stateUpdate(!trigger), ref: ref2, ...rest, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(TextContainer, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(TransitionGroup, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(CSSTransition, { timeout: 200, classNames: "fade", children: /* @__PURE__ */ jsxRuntimeExports.jsx(TextSpan, { children: trigger ? openedText : closedText }) }, trigger ? "opened" : "closed") }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(StyledCaretIcon, { $trigger: trigger, size: "sm" })
  ] });
});
OpenCloseCaret.displayName = "OpenCloseCaret";
const PopoverAnimationStyles = createGlobalStyle`
  div[role="tooltip"] {
    transition: opacity 200ms ease !important;
    transform-origin: center;
  }
`;
const SortButton = styled.button`
  background: transparent;
  border: none;
  border-radius: 4px;
  padding: 2px;
  width: 20px;
  height: 20px;
  cursor: pointer;
  color: var(${TOKENS.color.foreground.interaction.accent});
  transition: background-color 150ms ease-in-out, color 150ms ease-in-out;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    background-color: var(
      ${TOKENS.color.background.interaction.accentSubduedHover}
    );
    color: var(${TOKENS.color.foreground.interaction.accentHover});
  }

  &:focus-visible {
    outline: 2px solid var(${TOKENS.color.border.brand});
    outline-offset: 1px;
  }

  &:active {
    background-color: var(
      ${TOKENS.color.background.interaction.accentSubduedActive}
    );
    color: var(${TOKENS.color.foreground.interaction.accentActive});
  }

  &:disabled {
    cursor: not-allowed;
    background-color: var(${TOKENS.color.background.interaction.disabled});
    color: var(${TOKENS.color.foreground.interaction.onDisabled});
  }
`;
const TableSortControl = forwardRef(({
  sortDirection,
  onSortChange,
  popoverTexts,
  isDisabled,
  columnName,
  ...popoverProps
}, ref2) => {
  const [isVisible, setIsVisible] = useState(false);
  const showTimer = useRef();
  const hideTimer = useRef();
  const buttonRef = useRef(null);
  const {
    Popover,
    triggerProps
  } = usePopover({
    isVisible,
    triggerMode: "onHoverAndFocus",
    elementRef: buttonRef
  });
  const setRefs = useCallback((node2) => {
    buttonRef.current = node2;
    if (typeof ref2 === "function") {
      ref2(node2);
    } else if (ref2) {
      ref2.current = node2;
    }
  }, [ref2]);
  const handleMouseEnter = () => {
    clearTimeout(hideTimer.current);
    showTimer.current = setTimeout(() => setIsVisible(true), 400);
  };
  const handleMouseLeave = () => {
    clearTimeout(showTimer.current);
    hideTimer.current = setTimeout(() => setIsVisible(false), 400);
  };
  const handleClick = () => {
    if (isDisabled) return;
    let newDirection;
    if (sortDirection === "default") {
      newDirection = "desc";
    } else if (sortDirection === "desc") {
      newDirection = "asc";
    } else {
      newDirection = "default";
    }
    onSortChange(newDirection);
  };
  const getAriaLabel = () => {
    switch (sortDirection) {
      case "asc":
        return `Column ${columnName} is sorted ascending. Click to remove sort.`;
      case "desc":
        return `Column ${columnName} is sorted descending. Click to sort ascending.`;
      case "default":
      default:
        return `Column ${columnName} is not sorted. Click to sort descending.`;
    }
  };
  useEffect(() => {
    return () => {
      clearTimeout(showTimer.current);
      clearTimeout(hideTimer.current);
    };
  }, []);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(PopoverAnimationStyles, {}),
    /* @__PURE__ */ jsxRuntimeExports.jsx(SortButton, { ...triggerProps, ref: setRefs, onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave, onClick: handleClick, disabled: isDisabled, "aria-label": getAriaLabel(), children: /* @__PURE__ */ jsxRuntimeExports.jsx(TableSortIcon, { direction: sortDirection, width: 16, height: 16 }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Popover, { position: "top", variant: "tooltip", ...popoverProps, children: popoverTexts[sortDirection] })
  ] });
});
TableSortControl.displayName = "TableSortControl";
const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  z-index: 999;
  display: flex;

  &.drawer-enter {
    opacity: 0;
  }
  &.drawer-enter-active {
    opacity: 1;
    transition: opacity 300ms ease-in-out;
  }
  &.drawer-exit {
    opacity: 1;
  }
  &.drawer-exit-active {
    opacity: 0;
    transition: opacity 300ms ease-in-out;
  }

  ${(props) => {
  switch (props.placement) {
    case "left":
      return `justify-content: flex-start;`;
    case "right":
      return `justify-content: flex-end;`;
    case "top":
      return `justify-content: center; align-items: flex-start;`;
    case "bottom":
      return `justify-content: center; align-items: flex-end;`;
    default:
      return "";
  }
}}
`;
const Drawer$1 = styled.div`
  display: flex;
  flex-direction: column;

  ${(props) => {
  const desktopSize = `${props.desktopSize}px`;
  let exitTransform = "";
  let desktopDimensions = "";
  switch (props.placement) {
    case "left":
      exitTransform = "translateX(-100%)";
      desktopDimensions = `height: 100vh; width: ${desktopSize};`;
      break;
    case "right":
      exitTransform = "translateX(100%)";
      desktopDimensions = `height: 100vh; width: ${desktopSize};`;
      break;
    case "top":
      exitTransform = "translateY(-100%)";
      desktopDimensions = `width: 100vw; height: ${desktopSize};`;
      break;
    case "bottom":
      exitTransform = "translateY(100%)";
      desktopDimensions = `width: 100vw; height: ${desktopSize};`;
      break;
  }
  return `
      ${desktopDimensions}
      --drawer-exit-transform: ${exitTransform};
      transform: var(--drawer-exit-transform);

      @media (max-width: ${BREAKPOINTS.sm}) {
        width: 100vw; height: 100vh;
      }
    `;
}}

  .drawer-enter-active & {
    transform: translate(0, 0);
    transition: transform 300ms ease-in-out;
  }
  .drawer-enter-done & {
    transform: none;
  }
  .drawer-exit & {
    transform: translate(0, 0);
  }

  .drawer-exit-active & {
    transform: var(--drawer-exit-transform);
    transition: transform 300ms ease-in-out;
  }

  ${composeWrapper([space, layout, flexbox, background, border, position$1, typography, color])}
`;
const DrawerHeader$1 = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem;
  border-bottom: 1px solid #ddd;

  ${composeWrapper([space, layout, flexbox, background, border, position$1, typography, color])}
`;
const DrawerHeaderButton = styled(Button)`
  font-size: 1.5rem;
  padding: 4px;
`;
const DrawerBody$1 = styled.div`
  padding: 1rem;
  overflow-y: auto;
  flex-grow: 1;

  ${composeWrapper([space, layout, flexbox, background, border, position$1, typography, color])}
`;
const DrawerFooter$1 = styled.div`
  padding: 1rem;
  border-top: 1px solid #ddd;
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;

  ${composeWrapper([space, layout, flexbox, background, border, position$1, typography, color])}
`;
const DrawerHeader = forwardRef((props, ref2) => {
  const {
    children,
    showCloseButton = true,
    closeButtonProps,
    closeButtonText = "",
    ...rest
  } = props;
  const {
    close
  } = useDrawerContext();
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(DrawerHeader$1, { ref: ref2, ...rest, children: [
    children,
    showCloseButton && /* @__PURE__ */ jsxRuntimeExports.jsxs(DrawerHeaderButton, { type: "button", "aria-label": "Close drawer", title: "Close", size: "small", variant: "ghost", onClick: close, ...closeButtonProps, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(CloseIcon, { size: "sm" }),
      closeButtonText
    ] })
  ] });
});
const DrawerBody = forwardRef(({
  children,
  ...rest
}, ref2) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(DrawerBody$1, { ref: ref2, ...rest, children });
});
const DrawerFooter = forwardRef(({
  children,
  ...rest
}, ref2) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(DrawerFooter$1, { ref: ref2, ...rest, children });
});
const [DrawerProvider, useDrawerContext] = createContext({
  name: "DrawerContext",
  hookName: "useDrawerContext",
  providerName: "<DrawerProvider/>"
});
const DrawerRoot = forwardRef((props, ref2) => {
  const {
    children,
    className,
    open: pOpen,
    onClose,
    placement = "right",
    onOverlayClose = true,
    desktopSize = 400,
    shouldContainFocus = true,
    ...rest
  } = props;
  const [open, setOpen] = useControlledState$1(pOpen, false, onClose);
  const [animatedOpen, setAnimatedOpen] = useState(false);
  const drawerRef = useRef(null);
  $49c51c25361d4cd2$export$ee0f7cc6afcd1c18({
    isDisabled: !animatedOpen
  });
  const drawerContextValue = useMemo(() => ({
    placement,
    isOpen: open,
    open: () => setOpen(true),
    close: () => setOpen(false)
  }), [open, placement, setOpen]);
  const handleOverlayClick = useCallback((e3) => {
    if (onOverlayClose && e3.target === e3.currentTarget) {
      setOpen(false);
    }
  }, [onOverlayClose, setOpen]);
  const handleOnEscape = useCallback((e3) => {
    if (e3.key === "Escape") {
      setOpen(false);
    }
  }, [setOpen]);
  useImperativeHandle(ref2, () => ({
    ...drawerContextValue
  }), [drawerContextValue]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(DrawerProvider, { value: drawerContextValue, children: /* @__PURE__ */ jsxRuntimeExports.jsx(CSSTransition, { in: open, timeout: 300, classNames: "drawer", unmountOnExit: true, nodeRef: drawerRef, onEnter: () => setAnimatedOpen(true), onExited: () => setAnimatedOpen(false), children: /* @__PURE__ */ jsxRuntimeExports.jsx($9bf71ea28793e738$export$20e40289641fbbb6, { contain: shouldContainFocus, restoreFocus: true, autoFocus: true, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Overlay, { ref: drawerRef, onClick: handleOverlayClick, onKeyDown: handleOnEscape, placement, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Drawer$1, { className, placement, desktopSize, onClick: (e3) => e3.stopPropagation(), ...rest, background: `var(${TOKENS.color.background.surface0})`, children }) }) }) }) });
});
const Root$1 = DrawerRoot;
const Header = DrawerHeader;
const Body = DrawerBody;
const Footer = DrawerFooter;
Root$1.displayName = "Drawer.Root";
Header.displayName = "Drawer.Header";
Body.displayName = "Drawer.Body";
Footer.displayName = "Drawer.Footer";
const Drawer = {
  Root: Root$1,
  Header,
  Body,
  Footer
};
const TabsWrap = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  position: relative;

  row-gap: 8px;

  @media (min-width: ${BREAKPOINTS.sm}) {
    row-gap: 12px;
  }

  width: ${({
  $divider
}) => {
  if ($divider === "full-width") return "100%";
  if ($divider === "fit-content") return "fit-content";
  return "auto";
}};

  ${({
  $divider
}) => $divider === "full-width" && css$3`
      &::after {
        content: "";
        position: absolute;
        bottom: 0px;
        left: 0px;
        right: 0px;
        height: 1px;
        background-color: var(${TOKENS.color.border.default});
        z-index: 0;
      }
    `}

  ${({
  $divider
}) => $divider === "fit-content" && css$3`
      &::after {
        content: "";
        position: absolute;
        bottom: 0px;
        left: 0px;
        right: 1rem;
        height: 1px;
        background-color: var(${TOKENS.color.border.default});
        z-index: 0;

        @media (min-width: ${BREAKPOINTS.sm}) {
          right: 2rem;
        }
      }
    `}
`;
const tabStyles = css$3`
  color: var(${TOKENS.color.foreground.default});
  font-weight: 700;
  cursor: pointer;
  transition: color 0.2s, box-shadow 0.2s;
  text-decoration: none;
  white-space: nowrap;
  position: relative;
  outline: none;

  font-size: 0.75rem;
  padding: 0 0 0.75em 0;
  margin-right: 1rem;

  @media (min-width: ${BREAKPOINTS.sm}) {
    font-size: 0.8rem;
    padding: 0 0 1em 0;
    margin-right: 2rem;
  }

  font-family: var(${TOKENS.text.fontFamily.primary});

  &:focus-visible {
    outline: 2px solid var(${TOKENS.color.foreground.interaction.accent});
    outline-offset: 2px;
    border-radius: 2px;
    position: relative;
    z-index: 2;
  }

  @media (prefers-contrast: high) {
    &:focus-visible {
      outline: 3px solid var(${TOKENS.color.foreground.default});
      outline-offset: 3px;
      position: relative;
      z-index: 2;
    }
  }

  @media (prefers-reduced-motion: reduce) {
    transition: none;
  }

  &:hover:not([disabled]):not([data-disabled="true"]) {
    color: var(${TOKENS.color.foreground.interaction.accentHover});
  }
  &[disabled],
  &[data-disabled="true"] {
    cursor: not-allowed;
    color: var(${TOKENS.color.foreground.interaction.disabled});
  }
`;
const activeStyle = css$3`
  color: var(${TOKENS.color.foreground.interaction.accent});

  ${({
  $animated
}) => !$animated && css$3`
      position: relative;
      z-index: 1;
      border-bottom: 0.2em solid
        var(${TOKENS.color.foreground.interaction.accent});

      @media (min-width: ${BREAKPOINTS.sm}) {
        border-bottom: 0.25em solid
          var(${TOKENS.color.foreground.interaction.accent});
      }
    `}
`;
const disabledActiveStyle = css$3`
  color: var(${TOKENS.color.foreground.interaction.disabled});
  border-bottom: 0.25em solid transparent;
`;
const Tab = styled.a.withConfig({
  shouldForwardProp: kindredShouldForwardProp
})`
  ${tabStyles};
  &.active {
    ${activeStyle}
  }
  &.active[data-disabled="true"] {
    ${disabledActiveStyle}
  }
`;
const SimpleTab = styled.div`
  ${tabStyles}
  ${(props) => {
  if (props.active && !props.disabled) return activeStyle;
  if (props.active && props.disabled) return disabledActiveStyle;
  return "";
}}
`;
const AnimatedIndicator = styled.div`
  position: absolute;
  bottom: 0;
  height: 0.2em;
  background-color: var(${TOKENS.color.foreground.interaction.accent});
  transition: transform 0.3s ease-in-out, width 0.3s ease-in-out;
  z-index: 1;

  @media (min-width: ${BREAKPOINTS.sm}) {
    height: 0.25em;
  }

  @media (prefers-reduced-motion: reduce) {
    transition: none;
  }

  &.tab-indicator-enter {
    opacity: 0;
    transform: scale(0.8);
  }

  &.tab-indicator-enter-active {
    opacity: 1;
    transform: scale(1);
    transition: opacity 300ms ease-in-out, transform 300ms ease-in-out;
  }

  &.tab-indicator-exit {
    opacity: 1;
    transform: scale(1);
  }

  &.tab-indicator-exit-active {
    opacity: 0;
    transform: scale(0.8);
    transition: opacity 300ms ease-in-out, transform 300ms ease-in-out;
  }
`;
const TABS_DIVIDER = ["full-width", "fit-content", "disabled"];
const isTabItem = (route) => "to" in route;
const isSimpleTabItem = (route) => "onClick" in route;
const TabsComponent = forwardRef((props, ref2) => {
  const {
    withNavigation = true,
    routes,
    "aria-label": ariaLabel = "Tabs",
    animated = false,
    divider = "disabled"
  } = props;
  const linkComponent = "linkComponent" in props ? props.linkComponent : void 0;
  if (withNavigation && !linkComponent && routes.length > 0) {
    console.warn("Tabs: `withNavigation` is true but no `linkComponent` was provided. Falling back to plain anchors, which navigate with a full page load and cannot show the active tab. Pass `NavLink` from your router.");
  }
  const tabsRef = useRef();
  const indicatorRef = useRef(null);
  const [indicatorStyle, setIndicatorStyle] = useState({
    left: 0,
    width: 0
  });
  useEffect(() => {
    if (!tabsRef.current || !withNavigation) return void 0;
    const update = () => {
      var _a2;
      (_a2 = tabsRef.current) == null ? void 0 : _a2.querySelectorAll("a[role='tab']").forEach((tab) => {
        const isActive = tab.classList.contains("active");
        tab.setAttribute("aria-selected", String(isActive));
        tab.tabIndex = tab.dataset.disabled === "true" ? -1 : isActive ? 0 : -1;
      });
    };
    update();
    const observer = new MutationObserver(update);
    observer.observe(tabsRef.current, {
      attributes: true,
      attributeFilter: ["class"],
      subtree: true
    });
    return () => observer.disconnect();
  }, [routes, withNavigation]);
  const updateIndicator = useCallback(() => {
    if (!animated || !tabsRef.current) return;
    const activeTab = withNavigation ? tabsRef.current.querySelector('[role="tab"].active') : tabsRef.current.querySelector('[role="tab"][aria-selected="true"]');
    if (activeTab) {
      const tabRect = activeTab.getBoundingClientRect();
      const containerRect = tabsRef.current.getBoundingClientRect();
      setIndicatorStyle({
        left: tabRect.left - containerRect.left,
        width: tabRect.width
      });
    }
  }, [animated, withNavigation]);
  useEffect(() => {
    updateIndicator();
    if (!animated) {
      return void 0;
    }
    const observer = new MutationObserver(updateIndicator);
    if (tabsRef.current) {
      observer.observe(tabsRef.current, {
        attributes: true,
        subtree: true,
        attributeFilter: ["class", "aria-selected"]
      });
    }
    return () => observer.disconnect();
  }, [updateIndicator, routes, animated]);
  const handleKeyDown = useCallback((event) => {
    if (!tabsRef.current) return;
    const tabs = Array.from(tabsRef.current.querySelectorAll('[role="tab"]:not([data-disabled="true"])'));
    const currentIndex = tabs.findIndex((tab) => tab === document.activeElement);
    let nextIndex = currentIndex;
    switch (event.key) {
      case "ArrowRight":
      case "ArrowDown":
        event.preventDefault();
        nextIndex = currentIndex < tabs.length - 1 ? currentIndex + 1 : 0;
        break;
      case "ArrowLeft":
      case "ArrowUp":
        event.preventDefault();
        nextIndex = currentIndex > 0 ? currentIndex - 1 : tabs.length - 1;
        break;
      case "Home":
        event.preventDefault();
        nextIndex = 0;
        break;
      case "End":
        event.preventDefault();
        nextIndex = tabs.length - 1;
        break;
      case "Enter":
      case " ":
        if (document.activeElement instanceof HTMLElement) {
          event.preventDefault();
          document.activeElement.click();
        }
        return;
      default:
        return;
    }
    const nextTab = tabs[nextIndex];
    if (nextTab instanceof HTMLElement) {
      nextTab.focus();
    }
  }, []);
  const renderRoute = useCallback((route, index2) => {
    const {
      condition = true,
      disabled = false
    } = route;
    if (!condition) {
      return null;
    }
    if (withNavigation && isTabItem(route)) {
      const linkProps = linkComponent ? {
        as: linkComponent,
        to: route.to
      } : {
        href: route.to
      };
      return /* @__PURE__ */ jsxRuntimeExports.jsx(Tab, { ...linkProps, "data-disabled": disabled, onClick: disabled ? (event) => event.preventDefault() : void 0, role: "tab", "aria-controls": route["aria-controls"], $animated: animated, children: route.label }, index2);
    }
    if (!withNavigation && isSimpleTabItem(route)) {
      const isActive = route.active ?? false;
      return /* @__PURE__ */ jsxRuntimeExports.jsx(SimpleTab, { active: route.active, disabled, onClick: disabled ? void 0 : route.onClick, role: "tab", "aria-selected": isActive, "aria-controls": route["aria-controls"], tabIndex: disabled ? -1 : isActive ? 0 : -1, $animated: animated, children: route.label }, index2);
    }
    return null;
  }, [withNavigation, animated, linkComponent]);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(TabsWrap, { ref: (refNode) => {
    if (refNode) {
      tabsRef.current = refNode;
    }
    if (ref2) {
      if (typeof ref2 === "function") {
        ref2(refNode);
      } else {
        ref2.current = refNode;
      }
    }
  }, role: "tablist", "aria-label": ariaLabel, onKeyDown: handleKeyDown, $divider: divider, children: [
    routes.map((route, index2) => renderRoute(route, index2)),
    animated && /* @__PURE__ */ jsxRuntimeExports.jsx(CSSTransition, { in: animated, timeout: 300, classNames: "tab-indicator", appear: true, nodeRef: indicatorRef, children: /* @__PURE__ */ jsxRuntimeExports.jsx(AnimatedIndicator, { ref: indicatorRef, style: {
      transform: `translateX(${indicatorStyle.left}px)`,
      width: indicatorStyle.width
    } }) })
  ] });
});
TabsComponent.displayName = "Tabs";
const SEGMENT_HEIGHT = {
  default: "28px",
  large: "40px"
};
const FADE_SHADOW = "inset 10px 0 6px -6px rgba(0, 0, 0, 0.06)";
const FADE_SHADOW_RIGHT = "inset -10px 0 6px -6px rgba(0, 0, 0, 0.06)";
const FloatingIndicator = styled.span`
  position: absolute;
  top: 4px;
  left: 0;
  height: ${({
  $size
}) => SEGMENT_HEIGHT[$size]};
  border-radius: 6px;
  background: var(${TOKENS.color.background.surface0});
  box-shadow: 0px 0px 1px 0px rgba(0, 0, 0, 0.25),
    0px 2px 2px 0px rgba(0, 0, 0, 0.1);
  width: 0;
  transform: translateX(0);
  transition: transform 0.15s ease, width 0.15s ease;
  z-index: 0;

  @media (prefers-reduced-motion: reduce) {
    transition: none;
  }
`;
const Root = styled.div`
  display: inline-flex;
  gap: 2px;
  position: relative;
  padding: 4px;
  background: color-mix(
    in srgb,
    var(${TOKENS.color.background.surface2}) 60%,
    transparent
  );
  border-radius: 8px;
  width: fit-content;
  max-width: 100%;
  align-items: center;
  overflow-x: auto;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }

  &[data-fade-left="true"] {
    box-shadow: ${FADE_SHADOW};
  }
  &[data-fade-right="true"] {
    box-shadow: ${FADE_SHADOW_RIGHT};
  }
  &[data-fade-left="true"][data-fade-right="true"] {
    box-shadow: ${FADE_SHADOW}, ${FADE_SHADOW_RIGHT};
  }

  & input {
    position: absolute;
    width: 0;
    height: 0;
    opacity: 0;
    pointer-events: none;
  }

  & > label {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
    padding: ${({
  $size
}) => $size === "large" ? "8px 16px" : "4px 16px"};
    height: ${({
  $size
}) => SEGMENT_HEIGHT[$size]};
    box-sizing: border-box;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    z-index: 1;
    white-space: nowrap;
    font-family: var(${TOKENS.text.fontFamily.primary});
    font-size: ${({
  $size
}) => $size === "large" ? "1rem" : "0.875rem"};
    font-weight: 600;
    line-height: 140%;
    color: var(${TOKENS.color.foreground.default});
    transition: color 0.15s ease;
  }

  & > label:has(svg) {
    padding-left: ${({
  $size
}) => $size === "large" ? "20px" : "16px"};
    padding-right: ${({
  $size
}) => $size === "large" ? "20px" : "16px"};
  }

  & label svg {
    color: var(${TOKENS.color.foreground.default});
    fill: currentColor;
    width: ${({
  $size
}) => $size === "large" ? "24px" : "20px"};
    height: ${({
  $size
}) => $size === "large" ? "24px" : "20px"};
    flex-shrink: 0;
  }

  & label > span {
    text-box: trim-both cap alphabetic;
  }

  /* Active (checked) */
  & label:has(input:checked) {
    color: var(${TOKENS.color.foreground.interaction.accent});
  }

  & label:has(input:checked) svg {
    color: var(${TOKENS.color.foreground.interaction.accent});
  }

  /* Focus ring on indicator */
  &:has(input:focus-visible) > ${FloatingIndicator} {
    outline: 2px solid var(${TOKENS.color.border.focus});
    outline-offset: 2px;
  }

  /* Inactive hover */
  & label:not(:has(input:checked)):not(:has(input:disabled)):hover {
    color: var(${TOKENS.color.foreground.interaction.accentHover});
  }

  & label:not(:has(input:checked)):not(:has(input:disabled)):hover svg {
    color: var(${TOKENS.color.foreground.interaction.accentHover});
  }

  /* Active hover */
  & label:has(input:checked):not(:has(input:disabled)):hover {
    color: var(${TOKENS.color.foreground.interaction.accentHover});
  }

  & label:has(input:checked):not(:has(input:disabled)):hover svg {
    color: var(${TOKENS.color.foreground.interaction.accentHover});
  }

  /* Disabled */
  & label:has(input:disabled) {
    cursor: not-allowed;
    color: var(${TOKENS.color.foreground.subdued});
  }

  & label:has(input:disabled) svg {
    color: var(${TOKENS.color.foreground.subdued});
  }

  /* Active disabled indicator */
  &:has(input:disabled) > ${FloatingIndicator} {
    background: var(${TOKENS.color.background.surface1});
  }

  /* Dividers between segments — border-left is pixel-snapped by browsers,
     avoiding sub-pixel blurriness that background on a 1px element causes */
  & > label + label::before {
    content: "";
    position: absolute;
    left: -2px;
    top: 0;
    bottom: 0;
    width: 0;
    border-left: 1px solid var(${TOKENS.color.foreground.subdued});
    opacity: 0.2;
    pointer-events: none;
  }

  & > label:has(input:checked)::before,
  & > label:has(input:checked) + label::before {
    display: none;
  }

  @media (prefers-reduced-motion: reduce) {
    & label {
      transition: none;
    }
  }
`;
function updateFadeState(root2) {
  const canScroll = root2.scrollWidth > root2.clientWidth;
  const atStart = root2.scrollLeft <= 0;
  const atEnd = root2.scrollLeft >= root2.scrollWidth - root2.clientWidth - 1;
  root2.dataset.fadeLeft = String(canScroll && !atStart);
  root2.dataset.fadeRight = String(canScroll && !atEnd);
}
const SegmentedControlComponent = forwardRef((props, ref2) => {
  const {
    options: options2,
    value,
    onChange: onChange2,
    name,
    disabled,
    size: size2 = "default",
    ...rest
  } = props;
  const indicatorRef = useRef(null);
  useLayoutEffect(() => {
    let cleanup;
    const indicator = indicatorRef.current;
    const root2 = indicator == null ? void 0 : indicator.parentElement;
    const label = root2 == null ? void 0 : root2.querySelector("label:has(input:checked)");
    if (indicator && root2 && label) {
      const syncIndicator = () => {
        indicator.style.width = `${label.offsetWidth}px`;
        indicator.style.transform = `translateX(${label.offsetLeft}px)`;
      };
      const resyncIndicator = () => {
        if (indicator.style.width === `${label.offsetWidth}px`) return;
        const {
          transition: transition2
        } = indicator.style;
        indicator.style.transition = "none";
        syncIndicator();
        indicator.getBoundingClientRect();
        indicator.style.transition = transition2;
      };
      syncIndicator();
      const observer = new ResizeObserver(resyncIndicator);
      observer.observe(label);
      const labels = root2.querySelectorAll("label");
      const isFirst = label === labels[0];
      const isLast = label === labels[labels.length - 1];
      if (isFirst || isLast) {
        requestAnimationFrame(() => {
          if (isFirst) root2.scrollLeft = 0;
          else root2.scrollLeft = root2.scrollWidth - root2.clientWidth;
          updateFadeState(root2);
        });
      }
      updateFadeState(root2);
      const onScroll = () => updateFadeState(root2);
      root2.addEventListener("scroll", onScroll, {
        passive: true
      });
      cleanup = () => {
        observer.disconnect();
        root2.removeEventListener("scroll", onScroll);
      };
    }
    return cleanup;
  }, [value]);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Root, { ...rest, ref: ref2, role: "radiogroup", $size: size2, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(FloatingIndicator, { ref: indicatorRef, $size: size2 }),
    options2.map((option) => /* @__PURE__ */ jsxRuntimeExports.jsxs("label", { children: [
      option.icon,
      /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: option.label }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("input", { type: "radio", name, value: option.value, checked: option.value === value, disabled, onChange: onChange2 })
    ] }, option.value))
  ] });
});
SegmentedControlComponent.displayName = "SegmentedControl";
const SegmentedControl = SegmentedControlComponent;
const StyledButtonContainer = styled.div`
  margin-top: 20px;
`;
const StyledLinkButton$1 = styled(LinkButton)`
  margin-left: 16px;
  color: var(${TOKENS.color.foreground.default});

  &:hover {
    color: var(${TOKENS.color.foreground.default});
  }
`;
const StyledTrashIcon = styled(TrashIcon)`
  cursor: pointer;
`;
const StyledDeleteButton = styled(Button)`
  background-color: var(${TOKENS.color.background.interaction.danger});
  color: var(${TOKENS.color.foreground.interaction.onDanger});
  fill: var(${TOKENS.color.foreground.interaction.onDanger});

  &:hover {
    background-color: var(${TOKENS.color.background.interaction.dangerHover});
    color: var(${TOKENS.color.foreground.interaction.onDanger});
    fill: var(${TOKENS.color.foreground.interaction.onDanger});
  }

  &:active {
    background-color: var(${TOKENS.color.background.interaction.dangerActive});
  }
`;
const DeletePopover = ({
  handleDelete,
  heading,
  bodyText,
  deleteButtonText = "Delete",
  deleteButtonProps,
  minWidth,
  maxWidth,
  position: position2 = "bottom-start",
  ...props
}) => {
  const [isVisible, setIsVisible] = useState(false);
  const {
    Popover,
    triggerProps
  } = usePopover({
    isVisible
  });
  const [deleteButtonRef, setDeleteButtonRef] = useState();
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
    deleteButtonProps && /* @__PURE__ */ jsxRuntimeExports.jsx("button", { type: "button", ...deleteButtonProps, style: {
      display: "none"
    }, ref: setDeleteButtonRef, "aria-hidden": "true", tabIndex: -1 }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(StyledTrashIcon, { "data-cy": "delete", ...triggerProps, onClick: () => {
      setIsVisible(!isVisible);
    }, onKeyDown: (e3) => {
      if (e3.code === "Space") {
        e3.preventDefault();
        setIsVisible(!isVisible);
      }
    }, "aria-label": props["aria-label"] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      Popover,
      {
        position: position2,
        ...minWidth ? {
          minWidth
        } : {},
        ...maxWidth ? {
          maxWidth
        } : {},
        children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(Text, { element: "h3", variant: "headerSmall.responsive", children: heading }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(Text, { paddingTop: "4px", element: "p", variant: "bodySmall.responsive", children: bodyText }),
          /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledButtonContainer, { children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx(StyledDeleteButton, { "data-cy": "popover.delete", size: "small", variant: "primary", onClick: () => {
              if (deleteButtonRef) {
                deleteButtonRef.click();
              }
              setIsVisible(false);
              if (handleDelete) {
                handleDelete();
              }
            }, children: deleteButtonText }),
            /* @__PURE__ */ jsxRuntimeExports.jsx(StyledLinkButton$1, { "data-cy": "popover.cancel", onClick: () => {
              setIsVisible(false);
            }, children: "Cancel" })
          ] })
        ] })
      }
    )
  ] });
};
const MegaRadioWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;
const MegaRadioInput = styled(RadioInput)`
  ${({
  theme,
  checked,
  changeChildrenColorWhenChecked = true,
  disabled
}) => css$3`
      border-radius: ${theme.borderRadius[4]};
      isolation: isolate;
      ${disabled ? css$3`
            background-color: ${theme.colors.forms.fill.disabled};
            border: ${theme.borderWidth[1]} solid
              ${theme.colors.forms.border.default};
          ` : css$3`
            &:hover {
              background-color: ${checked ? "inherit" : theme.colors.background.surface100};
            }
            border: ${checked ? `${theme.borderWidth[2]} solid ${theme.colors.focus}` : `${theme.borderWidth[1]} solid ${theme.colors.forms.border.default}`};
          `}
      padding: ${checked ? "23px" : theme.spacing[24]};
      width: 48%;
      flex-direction: column;
      align-items: center;
      gap: ${theme.spacing[16]};

      input:checked + span.bullet {
        background-color: initial;
        border-width: ${theme.borderRadius[2]};
        height: calc(100% + 2px);
        width: calc(100% + 2px);
        left: -1px;
        top: -1px;

        & + svg {
          fill: ${changeChildrenColorWhenChecked ? theme.focusRingStyle.color : "inherit"};

          & + span {
            color: ${changeChildrenColorWhenChecked ? theme.focusRingStyle.color : "inherit"};
          }
        }
      }

      & > span.bullet {
        position: absolute;
        display: inline;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        z-index: -1;
        border: none;
        border-radius: ${theme.borderRadius[3]};

        &.disabled + svg {
          fill: ${theme.colors.forms.text.disabled};

          & + span {
            color: ${theme.colors.forms.text.disabled};
          }
        }
      }

      &.invalid {
        border-color: ${theme.colors.red[500]};
      }
    `}
`;
const MegaRadioInputText = styled(Text).attrs({
  element: "span",
  variant: "headerSmall.mobile",
  textAlign: "center"
})``;
const makeCreditCardComponent = (LargeComponent, SmallComponent) => forwardRef(({
  size: size2
}, ref2) => {
  const isMobile2 = reactResponsiveExports.useMediaQuery({
    query: "(max-width: 767px)"
  });
  if (size2 === "large") {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(LargeComponent, { ref: ref2 });
  }
  if (size2 === "small") {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(SmallComponent, { ref: ref2 });
  }
  return isMobile2 ? /* @__PURE__ */ jsxRuntimeExports.jsx(SmallComponent, {}) : /* @__PURE__ */ jsxRuntimeExports.jsx(LargeComponent, {});
});
const VisaLogo = makeCreditCardComponent(VisaLogoLarge, VisaLogoSmall);
VisaLogo.displayName = "VisaLogo";
const MastercardLogo = makeCreditCardComponent(MastercardLogoLarge, MastercardLogoSmall);
MastercardLogo.displayName = "MastercardLogo";
const AmexLogo = makeCreditCardComponent(AmexLogoLarge, AmexLogoSmall);
AmexLogo.displayName = "AmexLogo";
const DiscoverLogo = makeCreditCardComponent(DiscoverLogoLarge, DiscoverLogoSmall);
DiscoverLogo.displayName = "DiscoverLogo";
const DinersClubLogo = makeCreditCardComponent(DinersClubLogoLarge, DinersClubLogoSmall);
DinersClubLogo.displayName = "DinersClubLogo";
const BankLogo = makeCreditCardComponent(BankLogoLarge, BankLogoSmall);
BankLogo.displayName = "BankLogo";
const PaymentCardsLogo = PaymentCards;
const ModalProvider = $f57aed4a881a3485$export$bf688221f59024e5;
const checkTypographyFormat = (object2, breakpoints) => object2;
const checkEnterpriseTypography = (object2) => object2;
const KindredProvider = ({
  theme = PURPLE_THEME,
  children
}) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(StyleSheetManager, { shouldForwardProp: kindredShouldForwardProp, children: /* @__PURE__ */ jsxRuntimeExports.jsx(ThemeProvider, { theme, children }) });
};
const HeaderContainer$1 = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
const HeaderAndBadge = ({
  headerCopy,
  badgeCopy,
  badgeType
}) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(HeaderContainer$1, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Text, { element: "h2", variant: "headerMedium.responsive", children: headerCopy }),
    badgeCopy && /* @__PURE__ */ jsxRuntimeExports.jsx(Badge, { badgeType, useBodyText: true, children: badgeCopy })
  ] });
};
const ContactInfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin: 16px 0;
  gap: 4px;
  ${compose(space, color, typography, layout, background, border)};
`;
const formatPhoneForHref = (phoneNumber) => {
  return phoneNumber ? phoneNumber.replace(/-/g, "") : "";
};
const formatPhoneForDisplay = (phoneNumber) => {
  if (!phoneNumber) return "";
  if (phoneNumber.includes("-")) return phoneNumber;
  if (phoneNumber.length === 10) {
    return `${phoneNumber.slice(0, 3)}-${phoneNumber.slice(3, 6)}-${phoneNumber.slice(6)}`;
  }
  return phoneNumber;
};
const ContactInfo = ({
  contactInfo: {
    name,
    email,
    phone
  },
  label,
  ...props
}) => /* @__PURE__ */ jsxRuntimeExports.jsxs(ContactInfoContainer, { ...props, children: [
  /* @__PURE__ */ jsxRuntimeExports.jsx(Text, { element: "p", variant: "labelSmall.responsive", color: `var(${TOKENS.color.foreground.subdued})`, children: label }),
  name && /* @__PURE__ */ jsxRuntimeExports.jsx(Text, { element: "p", variant: "headerXSmall.responsive", "data-private": true, color: `var(${TOKENS.color.foreground.default})`, children: name }),
  phone && /* @__PURE__ */ jsxRuntimeExports.jsx(Link, { href: `tel:+1${formatPhoneForHref(phone)}`, underlined: true, size: "xsmall", "data-private": true, children: formatPhoneForDisplay(phone) }),
  email && /* @__PURE__ */ jsxRuntimeExports.jsx(Link, { href: `mailto:${email}`, underlined: true, size: "xsmall", "data-private": true, children: email })
] });
const TYPE_FLOW = 1;
const TYPE_SECTION = 1 << 1;
const TYPE_HEADING = 1 << 2;
const TYPE_PHRASING = 1 << 3;
const TYPE_EMBEDDED = 1 << 4;
const TYPE_INTERACTIVE = 1 << 5;
const TYPE_PALPABLE = 1 << 6;
const tagConfigs = {
  a: {
    content: TYPE_FLOW | TYPE_PHRASING,
    self: false,
    type: TYPE_FLOW | TYPE_PHRASING | TYPE_INTERACTIVE | TYPE_PALPABLE
  },
  address: {
    invalid: ["h1", "h2", "h3", "h4", "h5", "h6", "address", "article", "aside", "section", "div", "header", "footer"],
    self: false
  },
  audio: {
    children: ["track", "source"]
  },
  br: {
    type: TYPE_FLOW | TYPE_PHRASING,
    void: true
  },
  body: {
    content: TYPE_FLOW | TYPE_SECTION | TYPE_HEADING | TYPE_PHRASING | TYPE_EMBEDDED | TYPE_INTERACTIVE | TYPE_PALPABLE
  },
  button: {
    content: TYPE_PHRASING,
    type: TYPE_FLOW | TYPE_PHRASING | TYPE_INTERACTIVE | TYPE_PALPABLE
  },
  caption: {
    content: TYPE_FLOW,
    parent: ["table"]
  },
  col: {
    parent: ["colgroup"],
    void: true
  },
  colgroup: {
    children: ["col"],
    parent: ["table"]
  },
  details: {
    children: ["summary"],
    type: TYPE_FLOW | TYPE_INTERACTIVE | TYPE_PALPABLE
  },
  dd: {
    content: TYPE_FLOW,
    parent: ["dl"]
  },
  dl: {
    children: ["dt", "dd"],
    type: TYPE_FLOW
  },
  dt: {
    content: TYPE_FLOW,
    invalid: ["footer", "header"],
    parent: ["dl"]
  },
  figcaption: {
    content: TYPE_FLOW,
    parent: ["figure"]
  },
  footer: {
    invalid: ["footer", "header"]
  },
  header: {
    invalid: ["footer", "header"]
  },
  hr: {
    type: TYPE_FLOW,
    void: true
  },
  img: {
    void: true
  },
  li: {
    content: TYPE_FLOW,
    parent: ["ul", "ol", "menu"]
  },
  main: {
    self: false
  },
  ol: {
    children: ["li"],
    type: TYPE_FLOW
  },
  picture: {
    children: ["source", "img"],
    type: TYPE_FLOW | TYPE_PHRASING | TYPE_EMBEDDED
  },
  rb: {
    parent: ["ruby", "rtc"]
  },
  rp: {
    parent: ["ruby", "rtc"]
  },
  rt: {
    content: TYPE_PHRASING,
    parent: ["ruby", "rtc"]
  },
  rtc: {
    content: TYPE_PHRASING,
    parent: ["ruby"]
  },
  ruby: {
    children: ["rb", "rp", "rt", "rtc"]
  },
  source: {
    parent: ["audio", "video", "picture"],
    void: true
  },
  summary: {
    content: TYPE_PHRASING,
    parent: ["details"]
  },
  table: {
    children: ["caption", "colgroup", "thead", "tbody", "tfoot", "tr"],
    type: TYPE_FLOW
  },
  tbody: {
    parent: ["table"],
    children: ["tr"]
  },
  td: {
    content: TYPE_FLOW,
    parent: ["tr"]
  },
  tfoot: {
    parent: ["table"],
    children: ["tr"]
  },
  th: {
    content: TYPE_FLOW,
    parent: ["tr"]
  },
  thead: {
    parent: ["table"],
    children: ["tr"]
  },
  tr: {
    parent: ["table", "tbody", "thead", "tfoot"],
    children: ["th", "td"]
  },
  track: {
    parent: ["audio", "video"],
    void: true
  },
  ul: {
    children: ["li"],
    type: TYPE_FLOW
  },
  video: {
    children: ["track", "source"]
  },
  wbr: {
    type: TYPE_FLOW | TYPE_PHRASING,
    void: true
  }
};
function createConfigBuilder(config2) {
  return (tagName) => {
    tagConfigs[tagName] = {
      ...config2,
      ...tagConfigs[tagName]
    };
  };
}
["address", "main", "div", "figure", "p", "pre"].forEach(createConfigBuilder({
  content: TYPE_FLOW,
  type: TYPE_FLOW | TYPE_PALPABLE
}));
["abbr", "b", "bdi", "bdo", "cite", "code", "data", "dfn", "em", "i", "kbd", "mark", "q", "ruby", "samp", "strong", "sub", "sup", "time", "u", "var"].forEach(createConfigBuilder({
  content: TYPE_PHRASING,
  type: TYPE_FLOW | TYPE_PHRASING | TYPE_PALPABLE
}));
["p", "pre"].forEach(createConfigBuilder({
  content: TYPE_PHRASING,
  type: TYPE_FLOW | TYPE_PALPABLE
}));
["s", "small", "span", "del", "ins"].forEach(createConfigBuilder({
  content: TYPE_PHRASING,
  type: TYPE_FLOW | TYPE_PHRASING
}));
["article", "aside", "footer", "header", "nav", "section", "blockquote"].forEach(createConfigBuilder({
  content: TYPE_FLOW,
  type: TYPE_FLOW | TYPE_SECTION | TYPE_PALPABLE
}));
["h1", "h2", "h3", "h4", "h5", "h6"].forEach(createConfigBuilder({
  content: TYPE_PHRASING,
  type: TYPE_FLOW | TYPE_HEADING | TYPE_PALPABLE
}));
["audio", "canvas", "iframe", "img", "video"].forEach(createConfigBuilder({
  type: TYPE_FLOW | TYPE_PHRASING | TYPE_EMBEDDED | TYPE_PALPABLE
}));
const TAGS = Object.freeze(tagConfigs);
const BANNED_TAG_LIST = ["applet", "base", "body", "command", "embed", "frame", "frameset", "head", "html", "link", "meta", "noscript", "object", "script", "style", "title"];
const ALLOWED_TAG_LIST = Object.keys(TAGS).filter((tag) => tag !== "canvas" && tag !== "iframe");
const FILTER_ALLOW = 1;
const FILTER_DENY = 2;
const FILTER_CAST_NUMBER = 3;
const FILTER_CAST_BOOL = 4;
const FILTER_NO_CAST = 5;
const ATTRIBUTES = Object.freeze({
  alt: FILTER_ALLOW,
  cite: FILTER_ALLOW,
  class: FILTER_ALLOW,
  colspan: FILTER_CAST_NUMBER,
  controls: FILTER_CAST_BOOL,
  datetime: FILTER_ALLOW,
  default: FILTER_CAST_BOOL,
  disabled: FILTER_CAST_BOOL,
  dir: FILTER_ALLOW,
  height: FILTER_ALLOW,
  href: FILTER_ALLOW,
  id: FILTER_ALLOW,
  kind: FILTER_ALLOW,
  label: FILTER_ALLOW,
  lang: FILTER_ALLOW,
  loading: FILTER_ALLOW,
  loop: FILTER_CAST_BOOL,
  media: FILTER_ALLOW,
  muted: FILTER_CAST_BOOL,
  poster: FILTER_ALLOW,
  rel: FILTER_ALLOW,
  role: FILTER_ALLOW,
  rowspan: FILTER_CAST_NUMBER,
  scope: FILTER_ALLOW,
  sizes: FILTER_ALLOW,
  span: FILTER_CAST_NUMBER,
  start: FILTER_CAST_NUMBER,
  style: FILTER_NO_CAST,
  src: FILTER_ALLOW,
  srclang: FILTER_ALLOW,
  srcset: FILTER_ALLOW,
  tabindex: FILTER_ALLOW,
  target: FILTER_ALLOW,
  title: FILTER_ALLOW,
  type: FILTER_ALLOW,
  width: FILTER_ALLOW
});
const ATTRIBUTES_TO_PROPS = Object.freeze({
  class: "className",
  colspan: "colSpan",
  datetime: "dateTime",
  rowspan: "rowSpan",
  srclang: "srcLang",
  srcset: "srcSet",
  tabindex: "tabIndex"
});
function _extends() {
  _extends = Object.assign || function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function Element$1({
  attributes = {},
  className,
  children = null,
  selfClose = false,
  tagName
}) {
  const Tag2 = tagName;
  return selfClose ? /* @__PURE__ */ React__default.createElement(Tag2, _extends({
    className
  }, attributes)) : /* @__PURE__ */ React__default.createElement(Tag2, _extends({
    className
  }, attributes), children);
}
class Filter {
  /**
   * Filter and clean an HTML attribute value.
   */
  attribute(name, value) {
    return value;
  }
  /**
   * Filter and clean an HTML node.
   */
  node(name, node2) {
    return node2;
  }
}
/*!
 * escape-html
 * Copyright(c) 2012-2013 TJ Holowaychuk
 * Copyright(c) 2015 Andreas Lubbe
 * Copyright(c) 2015 Tiancheng "Timothy" Gu
 * MIT Licensed
 */
var matchHtmlRegExp = /["'&<>]/;
var escapeHtml_1 = escapeHtml;
function escapeHtml(string) {
  var str = "" + string;
  var match2 = matchHtmlRegExp.exec(str);
  if (!match2) {
    return str;
  }
  var escape;
  var html = "";
  var index2 = 0;
  var lastIndex = 0;
  for (index2 = match2.index; index2 < str.length; index2++) {
    switch (str.charCodeAt(index2)) {
      case 34:
        escape = "&quot;";
        break;
      case 38:
        escape = "&amp;";
        break;
      case 39:
        escape = "&#39;";
        break;
      case 60:
        escape = "&lt;";
        break;
      case 62:
        escape = "&gt;";
        break;
      default:
        continue;
    }
    if (lastIndex !== index2) {
      html += str.substring(lastIndex, index2);
    }
    lastIndex = index2 + 1;
    html += escape;
  }
  return lastIndex !== index2 ? html + str.substring(lastIndex, index2) : html;
}
var escapeHtml$1 = /* @__PURE__ */ getDefaultExportFromCjs(escapeHtml_1);
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
const INVALID_STYLES = /(url|image|image-set)\(/i;
class StyleFilter extends Filter {
  attribute(name, value) {
    if (name === "style") {
      Object.keys(value).forEach((key) => {
        if (String(value[key]).match(INVALID_STYLES)) {
          delete value[key];
        }
      });
    }
    return value;
  }
}
const ELEMENT_NODE = 1;
const TEXT_NODE = 3;
const INVALID_ROOTS = /^<(!doctype|(html|head|body)(\s|>))/i;
const ALLOWED_ATTRS = /^(aria-|data-|\w+:)/iu;
const OPEN_TOKEN = /{{{(\w+)\/?}}}/;
function createDocument() {
  if (typeof window === "undefined" || typeof document === "undefined") {
    return void 0;
  }
  return document.implementation.createHTMLDocument("Interweave");
}
class Parser2 {
  constructor(markup, props = {}, matchers = [], filters = []) {
    var _props$allowList;
    _defineProperty(this, "allowed", void 0);
    _defineProperty(this, "banned", void 0);
    _defineProperty(this, "blocked", void 0);
    _defineProperty(this, "container", void 0);
    _defineProperty(this, "content", []);
    _defineProperty(this, "props", void 0);
    _defineProperty(this, "matchers", void 0);
    _defineProperty(this, "filters", void 0);
    _defineProperty(this, "keyIndex", void 0);
    if (process.env.NODE_ENV !== "production" && markup && typeof markup !== "string") {
      throw new TypeError("Interweave parser requires a valid string.");
    }
    this.props = props;
    this.matchers = matchers;
    this.filters = [...filters, new StyleFilter()];
    this.keyIndex = -1;
    this.container = this.createContainer(markup || "");
    this.allowed = new Set((_props$allowList = props.allowList) !== null && _props$allowList !== void 0 ? _props$allowList : ALLOWED_TAG_LIST);
    this.banned = new Set(BANNED_TAG_LIST);
    this.blocked = new Set(props.blockList);
  }
  /**
   * Loop through and apply all registered attribute filters.
   */
  applyAttributeFilters(name, value) {
    return this.filters.reduce((nextValue, filter) => nextValue !== null && typeof filter.attribute === "function" ? filter.attribute(name, nextValue) : nextValue, value);
  }
  /**
   * Loop through and apply all registered node filters.
   */
  applyNodeFilters(name, node2) {
    return this.filters.reduce((nextNode, filter) => nextNode !== null && typeof filter.node === "function" ? filter.node(name, nextNode) : nextNode, node2);
  }
  /**
   * Loop through and apply all registered matchers to the string.
   * If a match is found, create a React element, and build a new array.
   * This array allows React to interpolate and render accordingly.
   */
  applyMatchers(string, parentConfig) {
    const elements = {};
    const {
      props
    } = this;
    let matchedString = string;
    let elementIndex = 0;
    let parts = null;
    this.matchers.forEach((matcher) => {
      const tagName = matcher.asTag().toLowerCase();
      const config2 = this.getTagConfig(tagName);
      if (props[matcher.inverseName] || !this.isTagAllowed(tagName)) {
        return;
      }
      if (!this.canRenderChild(parentConfig, config2)) {
        return;
      }
      let tokenizedString = "";
      while (matchedString && (parts = matcher.match(matchedString))) {
        const {
          index: index2,
          length: length2,
          match: match2,
          valid,
          void: isVoid,
          ...partProps
        } = parts;
        const tokenName = matcher.propName + String(elementIndex);
        if (index2 > 0) {
          tokenizedString += matchedString.slice(0, index2);
        }
        if (valid) {
          tokenizedString += isVoid ? `{{{${tokenName}/}}}` : `{{{${tokenName}}}}${match2}{{{/${tokenName}}}}`;
          this.keyIndex += 1;
          elementIndex += 1;
          elements[tokenName] = {
            children: match2,
            matcher,
            props: {
              ...props,
              ...partProps,
              key: this.keyIndex
            }
          };
        } else {
          tokenizedString += match2;
        }
        if (matcher.greedy) {
          matchedString = tokenizedString + matchedString.slice(index2 + length2);
          tokenizedString = "";
        } else {
          matchedString = matchedString.slice(index2 + (length2 || match2.length));
        }
      }
      if (!matcher.greedy) {
        matchedString = tokenizedString + matchedString;
      }
    });
    if (elementIndex === 0) {
      return string;
    }
    return this.replaceTokens(matchedString, elements);
  }
  /**
   * Determine whether the child can be rendered within the parent.
   */
  canRenderChild(parentConfig, childConfig) {
    if (!parentConfig.tagName || !childConfig.tagName) {
      return false;
    }
    if (parentConfig.void) {
      return false;
    }
    if (parentConfig.children.length > 0) {
      return parentConfig.children.includes(childConfig.tagName);
    }
    if (parentConfig.invalid.length > 0 && parentConfig.invalid.includes(childConfig.tagName)) {
      return false;
    }
    if (childConfig.parent.length > 0) {
      return childConfig.parent.includes(parentConfig.tagName);
    }
    if (!parentConfig.self && parentConfig.tagName === childConfig.tagName) {
      return false;
    }
    return Boolean(parentConfig && parentConfig.content & childConfig.type);
  }
  /**
   * Convert line breaks in a string to HTML `<br/>` tags.
   * If the string contains HTML, we should not convert anything,
   * as line breaks should be handled by `<br/>`s in the markup itself.
   */
  convertLineBreaks(markup) {
    const {
      noHtml,
      disableLineBreaks
    } = this.props;
    if (noHtml || disableLineBreaks || markup.match(/<((?:\/[ a-z]+)|(?:[ a-z]+\/))>/gi)) {
      return markup;
    }
    let nextMarkup = markup.replace(/\r\n/g, "\n");
    nextMarkup = nextMarkup.replace(/\n{3,}/g, "\n\n\n");
    nextMarkup = nextMarkup.replace(/\n/g, "<br/>");
    return nextMarkup;
  }
  /**
   * Create a detached HTML document that allows for easy HTML
   * parsing while not triggering scripts or loading external
   * resources.
   */
  createContainer(markup) {
    var _this$props$container;
    const factory = typeof global !== "undefined" && global.INTERWEAVE_SSR_POLYFILL || createDocument;
    const doc = factory();
    if (!doc) {
      return void 0;
    }
    const tag = (_this$props$container = this.props.containerTagName) !== null && _this$props$container !== void 0 ? _this$props$container : "body";
    const el = tag === "body" || tag === "fragment" ? doc.body : doc.createElement(tag);
    if (markup.match(INVALID_ROOTS)) {
      if (process.env.NODE_ENV !== "production") {
        throw new Error("HTML documents as Interweave content are not supported.");
      }
    } else {
      el.innerHTML = this.convertLineBreaks(this.props.escapeHtml ? escapeHtml$1(markup) : markup);
    }
    return el;
  }
  /**
   * Convert an elements attribute map to an object map.
   * Returns null if no attributes are defined.
   */
  extractAttributes(node2) {
    const {
      allowAttributes
    } = this.props;
    const attributes = {};
    let count2 = 0;
    if (node2.nodeType !== ELEMENT_NODE || !node2.attributes) {
      return null;
    }
    [...node2.attributes].forEach((attr) => {
      const {
        name,
        value
      } = attr;
      const newName = name.toLowerCase();
      const filter = ATTRIBUTES[newName] || ATTRIBUTES[name];
      if (!this.isSafe(node2)) {
        return;
      }
      if (!newName.match(ALLOWED_ATTRS) && (!allowAttributes && (!filter || filter === FILTER_DENY) || newName.startsWith("on") || value.replace(/(\s|\0|&#x0([9AD]);)/, "").match(/(javascript|vbscript|livescript|xss):/i))) {
        return;
      }
      let newValue = newName === "style" ? this.extractStyleAttribute(node2) : value;
      if (filter === FILTER_CAST_BOOL) {
        newValue = true;
      } else if (filter === FILTER_CAST_NUMBER) {
        newValue = Number.parseFloat(String(newValue));
      } else if (filter !== FILTER_NO_CAST) {
        newValue = String(newValue);
      }
      attributes[ATTRIBUTES_TO_PROPS[newName] || newName] = this.applyAttributeFilters(newName, newValue);
      count2 += 1;
    });
    if (count2 === 0) {
      return null;
    }
    return attributes;
  }
  /**
   * Extract the style attribute as an object and remove values that allow for attack vectors.
   */
  extractStyleAttribute(node2) {
    const styles = {};
    Array.from(node2.style).forEach((key) => {
      const value = node2.style[key];
      if (typeof value === "string" || typeof value === "number") {
        styles[key.replace(/-([a-z])/g, (match2, letter) => String(letter).toUpperCase())] = value;
      }
    });
    return styles;
  }
  /**
   * Return configuration for a specific tag.
   */
  getTagConfig(tagName) {
    const common = {
      children: [],
      content: 0,
      invalid: [],
      parent: [],
      self: true,
      tagName: "",
      type: 0,
      void: false
    };
    if (TAGS[tagName]) {
      return {
        ...common,
        ...TAGS[tagName],
        tagName
      };
    }
    return common;
  }
  /**
   * Verify that a node is safe from XSS and injection attacks.
   */
  isSafe(node2) {
    if (typeof HTMLAnchorElement !== "undefined" && node2 instanceof HTMLAnchorElement) {
      const href = node2.getAttribute("href");
      if (href !== null && href !== void 0 && href.startsWith("#")) {
        return true;
      }
      const protocol = node2.protocol.toLowerCase();
      return protocol === ":" || protocol === "http:" || protocol === "https:" || protocol === "mailto:" || protocol === "tel:";
    }
    return true;
  }
  /**
   * Verify that an HTML tag is allowed to render.
   */
  isTagAllowed(tagName) {
    if (this.banned.has(tagName) || this.blocked.has(tagName)) {
      return false;
    }
    return this.props.allowElements || this.allowed.has(tagName);
  }
  /**
   * Parse the markup by injecting it into a detached document,
   * while looping over all child nodes and generating an
   * array to interpolate into JSX.
   */
  parse() {
    if (!this.container) {
      return [];
    }
    return this.parseNode(this.container, this.getTagConfig(this.container.nodeName.toLowerCase()));
  }
  /**
   * Loop over the nodes children and generate a
   * list of text nodes and React elements.
   */
  parseNode(parentNode, parentConfig) {
    const {
      noHtml,
      noHtmlExceptMatchers,
      allowElements,
      transform,
      transformOnlyAllowList
    } = this.props;
    let content = [];
    let mergedText = "";
    [...parentNode.childNodes].forEach((node2) => {
      if (node2.nodeType === ELEMENT_NODE) {
        const tagName = node2.nodeName.toLowerCase();
        const config2 = this.getTagConfig(tagName);
        if (mergedText) {
          content.push(mergedText);
          mergedText = "";
        }
        const nextNode = this.applyNodeFilters(tagName, node2);
        if (!nextNode) {
          return;
        }
        let children;
        if (transform && !(transformOnlyAllowList && !this.isTagAllowed(tagName))) {
          this.keyIndex += 1;
          const key = this.keyIndex;
          children = this.parseNode(nextNode, config2);
          const transformed = transform(nextNode, children, config2);
          if (transformed === null) {
            return;
          }
          if (typeof transformed !== "undefined") {
            content.push(/* @__PURE__ */ React__default.cloneElement(transformed, {
              key
            }));
            return;
          }
          this.keyIndex = key - 1;
        }
        if (this.banned.has(tagName)) {
          return;
        }
        if (!(noHtml || noHtmlExceptMatchers && tagName !== "br") && this.isTagAllowed(tagName) && (allowElements || this.canRenderChild(parentConfig, config2))) {
          var _children;
          this.keyIndex += 1;
          const attributes = this.extractAttributes(nextNode);
          const elementProps = {
            tagName
          };
          if (attributes) {
            elementProps.attributes = attributes;
          }
          if (config2.void) {
            elementProps.selfClose = config2.void;
          }
          content.push(/* @__PURE__ */ React__default.createElement(Element$1, {
            ...elementProps,
            key: this.keyIndex
          }, (_children = children) !== null && _children !== void 0 ? _children : this.parseNode(nextNode, config2)));
        } else {
          content = [...content, ...this.parseNode(nextNode, config2.tagName ? config2 : parentConfig)];
        }
      } else if (node2.nodeType === TEXT_NODE) {
        const text = noHtml && !noHtmlExceptMatchers ? node2.textContent : (
          // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
          this.applyMatchers(node2.textContent || "", parentConfig)
        );
        if (Array.isArray(text)) {
          content = [...content, ...text];
        } else {
          mergedText += text;
        }
      }
    });
    if (mergedText) {
      content.push(mergedText);
    }
    return content;
  }
  /**
   * Deconstruct the string into an array, by replacing custom tokens with React elements,
   * so that React can render it correctly.
   */
  replaceTokens(tokenizedString, elements) {
    if (!tokenizedString.includes("{{{")) {
      return tokenizedString;
    }
    const nodes = [];
    let text = tokenizedString;
    let open = null;
    while (open = text.match(OPEN_TOKEN)) {
      const [match2, tokenName] = open;
      const startIndex = open.index;
      const isVoid = match2.includes("/");
      if (process.env.NODE_ENV !== "production" && !elements[tokenName]) {
        throw new Error(`Token "${tokenName}" found but no matching element to replace with.`);
      }
      if (startIndex > 0) {
        nodes.push(text.slice(0, startIndex));
        text = text.slice(startIndex);
      }
      const {
        children,
        matcher,
        props: elementProps
      } = elements[tokenName];
      let endIndex;
      if (isVoid) {
        endIndex = match2.length;
        nodes.push(matcher.createElement(children, elementProps));
      } else {
        const close = text.match(new RegExp(`{{{/${tokenName}}}}`));
        if (process.env.NODE_ENV !== "production" && !close) {
          throw new Error(`Closing token missing for interpolated element "${tokenName}".`);
        }
        endIndex = close.index + close[0].length;
        nodes.push(matcher.createElement(this.replaceTokens(text.slice(match2.length, close.index), elements), elementProps));
      }
      text = text.slice(endIndex);
    }
    if (text.length > 0) {
      nodes.push(text);
    }
    if (nodes.length === 0) {
      return "";
    }
    if (nodes.length === 1 && typeof nodes[0] === "string") {
      return nodes[0];
    }
    return nodes;
  }
}
function Markup(props) {
  var _ref3;
  const {
    attributes,
    className,
    containerTagName,
    content,
    emptyContent,
    parsedContent,
    tagName,
    noWrap: baseNoWrap
  } = props;
  const tag = (_ref3 = containerTagName !== null && containerTagName !== void 0 ? containerTagName : tagName) !== null && _ref3 !== void 0 ? _ref3 : "span";
  const noWrap = tag === "fragment" ? true : baseNoWrap;
  let mainContent;
  if (parsedContent) {
    mainContent = parsedContent;
  } else {
    const markup = new Parser2(content !== null && content !== void 0 ? content : "", props).parse();
    if (markup.length > 0) {
      mainContent = markup;
    }
  }
  if (!mainContent) {
    mainContent = emptyContent;
  }
  if (noWrap) {
    return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, mainContent);
  }
  return /* @__PURE__ */ React__default.createElement(Element$1, {
    attributes,
    className,
    tagName: tag
  }, mainContent);
}
function Interweave(props) {
  const {
    attributes,
    className,
    content = "",
    disableFilters = false,
    disableMatchers = false,
    emptyContent = null,
    filters = [],
    matchers = [],
    onAfterParse = null,
    onBeforeParse = null,
    tagName = "span",
    noWrap = false,
    ...parserProps
  } = props;
  const allMatchers = disableMatchers ? [] : matchers;
  const allFilters = disableFilters ? [] : filters;
  const beforeCallbacks = onBeforeParse ? [onBeforeParse] : [];
  const afterCallbacks = onAfterParse ? [onAfterParse] : [];
  allMatchers.forEach((matcher) => {
    if (matcher.onBeforeParse) {
      beforeCallbacks.push(matcher.onBeforeParse.bind(matcher));
    }
    if (matcher.onAfterParse) {
      afterCallbacks.push(matcher.onAfterParse.bind(matcher));
    }
  });
  const markup = beforeCallbacks.reduce((string, callback) => {
    const nextString = callback(string, props);
    if (process.env.NODE_ENV !== "production" && typeof nextString !== "string") {
      throw new TypeError("Interweave `onBeforeParse` must return a valid HTML string.");
    }
    return nextString;
  }, content !== null && content !== void 0 ? content : "");
  const parser = new Parser2(markup, parserProps, allMatchers, allFilters);
  const nodes = afterCallbacks.reduce((parserNodes, callback) => {
    const nextNodes = callback(parserNodes, props);
    if (process.env.NODE_ENV !== "production" && !Array.isArray(nextNodes)) {
      throw new TypeError("Interweave `onAfterParse` must return an array of strings and React elements.");
    }
    return nextNodes;
  }, parser.parse());
  return /* @__PURE__ */ React__default.createElement(Markup, {
    attributes,
    className,
    containerTagName: props.containerTagName,
    emptyContent,
    noWrap,
    parsedContent: nodes.length === 0 ? void 0 : nodes,
    tagName
  });
}
const IconOptionContainer = styled.div`
  display: flex;
  flex-direction: row;
`;
const PreselectedIconWrapper = styled.div`
  margin-right: 5px;
  margin-left: 4px;
`;
const DeclinedIconWrapper = styled.div`
  padding-top: 3px;
  margin-right: 13px; /* 5 (same as checkmark icon) + 8px to match the checkmark icon which is 8px wider (24 vs 16) */
  margin-left: 4px;
`;
const PreSelectableCheckboxInput = ({
  preSelected = false,
  declined = false,
  optedOut = false,
  children,
  ...rest
}) => {
  if (declined) {
    return /* @__PURE__ */ jsxRuntimeExports.jsxs(IconOptionContainer, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(DeclinedIconWrapper, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(ErrorIcon, { size: "sm", fill: `var(${TOKENS.color.foreground.subdued})` }) }),
      children
    ] });
  }
  if (preSelected) {
    return /* @__PURE__ */ jsxRuntimeExports.jsxs(IconOptionContainer, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(PreselectedIconWrapper, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(CheckmarkShorterIcon, {}) }),
      children
    ] });
  }
  if (optedOut) {
    return /* @__PURE__ */ jsxRuntimeExports.jsxs(IconOptionContainer, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(PreselectedIconWrapper, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(AddOptionIcon, { "data-testid": "opted-out-icon" }) }),
      children
    ] });
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx(CheckboxInput, { ...rest, children });
};
const ContentContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;
const TitlePriceContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;
const StyledTitle = styled(Text)`
  color: var(${TOKENS.color.foreground.default});
`;
const StyledDescription = styled(Text)`
  color: var(${TOKENS.color.foreground.subdued});
  sup {
    line-height: 0;
  }
`;
const CheckboxOptionWithPrice = ({
  description,
  formattedPrice,
  title,
  declined = false,
  optedOut = false,
  descriptionIsDisclaimer = false,
  showPrice = true,
  showFreeBadge = false,
  ...rest
}) => {
  const isFreeRider = formattedPrice === "Free";
  const shouldShowBadge = showPrice && !declined && (showFreeBadge || !isFreeRider);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(PreSelectableCheckboxInput, { optedOut, declined, ...rest, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(ContentContainer, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs(TitlePriceContainer, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(StyledTitle, { element: "h4", variant: "bodyMedium.responsive", children: title }),
      shouldShowBadge && /* @__PURE__ */ jsxRuntimeExports.jsx(Badge, { size: "compact", useBodyText: true, badgeType: "neutralSubduedStrong", children: formattedPrice })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(StyledDescription, { element: "p", variant: descriptionIsDisclaimer ? "disclaimerSmall.responsive" : "bodySmall.responsive", children: /* @__PURE__ */ jsxRuntimeExports.jsx(Interweave, { content: description }) })
  ] }) });
};
const HeaderSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;
const HeaderContainer = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
`;
const RidersContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;
const RiderSelectorContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;
const StyledInfoCircleIcon = styled(InfoCircleIcon)`
  fill: var(${TOKENS.color.foreground.interaction.accent});
`;
const RiderSelector = ({
  onRiderChange,
  riders,
  selectedRiders,
  title = "Additional features",
  subHeaderText,
  declined = false,
  optedOut = false,
  showPrice = true,
  showFreeBadge = false,
  popoverText,
  renderExpandedContent
}) => {
  if (!riders.length) {
    return null;
  }
  const {
    Popover,
    triggerProps
  } = usePopover();
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(RiderSelectorContainer, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs(HeaderSection, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs(HeaderContainer, { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(Text, { element: "h3", variant: "headerSmall.responsive", textAlign: "left", children: title }),
        popoverText && /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(StyledInfoCircleIcon, { size: "sm", ...triggerProps }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(Popover, { variant: "tooltip", zIndex: "10", children: popoverText })
        ] })
      ] }),
      subHeaderText && /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: subHeaderText })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(RidersContainer, { children: riders.map((rider) => {
      const {
        riderCode,
        riderName,
        riderDescription,
        formattedPrice,
        preSelected
      } = rider;
      return /* @__PURE__ */ jsxRuntimeExports.jsxs(React__default.Fragment, { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(CheckboxOptionWithPrice, { showPrice, description: riderDescription, formattedPrice, id: riderCode, checked: selectedRiders[riderCode], preSelected, name: riderCode, onChange: () => {
          onRiderChange == null ? void 0 : onRiderChange(riderCode, !selectedRiders[riderCode]);
        }, title: riderName, value: riderCode, optedOut, declined, bulletPadding: "13px", showFreeBadge }),
        renderExpandedContent && selectedRiders[riderCode] && renderExpandedContent(rider)
      ] }, riderCode);
    }) })
  ] });
};
const DividerContainer = styled.div`
  margin-left: 8px;
  width: 100%;
`;
const DetailsContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;
const DetailsRow = styled.div`
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
`;
const DetailsColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  max-width: 250px;
  overflow-wrap: anywhere;
  word-break: break-all;
`;
const StyledLabel = styled(Text)`
  display: flex;
  flex-direction: row;
  align-items: center;
  color: var(${TOKENS.color.foreground.subdued});
  text-transform: uppercase;
  height: auto;
  min-height: 24px;
`;
const StyledValue = styled(Text).attrs(() => ({
  variant: "bodyXSmall.responsive",
  element: "p"
}))`
  color: var(${TOKENS.color.foreground.default});
  max-width: ${({
  $truncate
}) => $truncate ? "140px" : "100%"};
  ${({
  $truncate
}) => $truncate && "white-space: nowrap;"}
  ${({
  $truncate
}) => $truncate && "overflow: hidden;"}
  ${({
  $truncate
}) => $truncate && "text-overflow: ellipsis;"}
`;
const AccordianDetailsHeader = ({
  itemValue = "accordion-details-header",
  fields,
  accordionOpen,
  onAccordionToggle
}) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Accordion.Root, { defaultOpenItems: accordionOpen ? [itemValue] : [], showDivider: false, rotateDeg: 90, animated: true, unmountOnExit: true, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Accordion.Item, { value: itemValue, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs(Accordion.Trigger, { paddingLeft: "0", paddingRight: "0", paddingTop: "12px", paddingBottom: "12px", onClick: onAccordionToggle, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(HorizontalDetailsDropdownIcon, { fill: `var(${TOKENS.color.border.default})`, size: "sm", width: "6px", height: "12px" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(DividerContainer, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(Divider, {}) })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Accordion.Body, { paddingLeft: "0", paddingRight: "0", paddingBottom: 32, children: /* @__PURE__ */ jsxRuntimeExports.jsx(DetailsContainer, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(DetailsRow, { children: fields.map((field) => /* @__PURE__ */ jsxRuntimeExports.jsxs(DetailsColumn, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(StyledLabel, { variant: "labelXSmall.responsive", element: "h3", children: field.label }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(StyledValue, { $truncate: field.truncateValue === true, variant: "bodyXSmall.responsive", element: "p", "data-private": field.private ? "" : void 0, children: field.href ? /* @__PURE__ */ jsxRuntimeExports.jsxs(LinkButton, { variant: "default", size: "small", underlined: true, onClick: () => window.open(field.href, "_blank"), "data-cy": field.testId, children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(Text, { variant: "bodyXSmall.responsive", element: "span", children: field.value }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(NewTabIcon, { size: "sm", style: {
          marginLeft: "4px"
        } })
      ] }) : /* @__PURE__ */ jsxRuntimeExports.jsx(Text, { variant: "bodyXSmall.responsive", element: "span", children: field.value }) })
    ] }, field.label)) }) }) })
  ] }) });
};
const StyledContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;
const StyledInsuredRow = styled.div`
  display: flex;
  width: fit-content;
  justify-self: start;
  gap: 8px;
`;
const StyledDivider = styled(Divider)`
  margin-bottom: 12px;
`;
const getVariantConfig = (variant = "base") => {
  switch (variant) {
    case "header":
      return {
        divider: false,
        displayCoverage: false,
        headerSize: "headerMedium.responsive",
        bodySize: "bodySmall.responsive"
      };
    case "label":
      return {
        divider: false,
        displayCoverage: true,
        headerSize: "headerMedium.responsive",
        bodySize: "bodyMedium.responsive"
      };
    case "label-small":
      return {
        divider: false,
        displayCoverage: true,
        headerSize: "headerSmall.responsive",
        bodySize: "bodySmall.responsive"
      };
    case "base":
    default:
      return {
        divider: true,
        displayCoverage: true,
        headerSize: "headerSmall.responsive",
        bodySize: "bodySmall.responsive"
      };
  }
};
const PolicyOverview = forwardRef((props, ref2) => {
  const {
    variant,
    policyData,
    ...rest
  } = props;
  const {
    divider,
    displayCoverage,
    headerSize,
    bodySize
  } = getVariantConfig(variant);
  const {
    productName,
    insuredName,
    coverageAmountDollars,
    coverageTermDescString,
    isActivePolicy = true
  } = policyData;
  const coverageFormatted = M$1(String(coverageAmountDollars ?? 0), {
    numeralDecimalScale: 0,
    numeralThousandsGroupStyle: v$d.THOUSAND,
    numeralPositiveOnly: true
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledContainer, { ref: ref2, ...rest, children: [
    divider && /* @__PURE__ */ jsxRuntimeExports.jsx(StyledDivider, {}),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Text, { variant: headerSize, children: productName ?? "Product Name" }),
    displayCoverage && /* @__PURE__ */ jsxRuntimeExports.jsxs(Text, { variant: bodySize, children: [
      "$",
      coverageFormatted ?? "Coverage Amount ",
      " |",
      " ",
      coverageTermDescString ?? "Coverage Term"
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledInsuredRow, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(Text, { variant: bodySize, children: isActivePolicy ? "Insured: " : "Proposed insured: " }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Badge, { useBodyText: true, badgeType: "neutralSubduedWeak", size: "compact", children: insuredName ?? "N/A" })
    ] })
  ] });
});
PolicyOverview.displayName = "PolicyOverview";
const SERVICING_DOCUMENT_TYPES = ["ADDRESS_NAME_CHANGE_FORM", "APPLICATION_AMENDMENT", "BENEFICIARY_CHANGE_FORM", "CANCELLATION_LETTER", "COLLATERAL_ASSIGNMENT", "COLLATERAL_ASSIGNMENT_CONFIRMATION", "COLLATERAL_ASSIGNMENT_RELEASE", "CONVERSION_INFO", "COVERAGE_VERIFICATION", "LEGAL_DOCS", "DT_OTHER", "OWNERSHIP_CHANGE", "POWER_OF_ATTORNEY", "REINSTATEMENT_APPLICATIONS", "REPLACEMENT_FORM", "REPLACEMENT_NOTICE", "RETURNED_CHECKS", "RETURNED_MAIL", "THIRD_PARTY_AUTH", "TRUST_AS_BENEFICIARY_FORM", "TRUST_AGREEMENT", "POLICY_CHANGE_APPLICATION", "LOAN_APPLICATION", "SURRENDER_INDEX_FORM"];
const UNDERWRITING_DOCUMENT_TYPES = ["UW_EXPLANATION", "REINSTATEMENT_APP", "REINSTATEMENT_REFLEXIVES", "MIB_DATA", "RX_DATA", "MVR_DATA", "LRC_DATA", "LABPIQTURE", "APS_1", "APS_2", "APS_3", "APS_4", "APS_5", "MILLIMAN_CLAIMS_DATA", "APPEALS", "MISSTATEMENT_ID", "ADB_CLAIM_APPROVAL_LETTER", "ADB_CLAIM_DENIAL_LETTER"];
const ACRONYMS = /* @__PURE__ */ new Set(["ID", "ADB"]);
const capitalize = (str) => {
  const upper = str.toUpperCase();
  return ACRONYMS.has(upper) ? upper : str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};
const documentTypeNameGenerator = (name) => {
  if (!name) return "Document";
  if (name === "DT_OTHER") return "Other";
  return name.split("_").map(capitalize).join(" ");
};
const isServicingDocument = (documentType) => SERVICING_DOCUMENT_TYPES.includes(documentType);
const isUnderwritingDocument = (documentType) => UNDERWRITING_DOCUMENT_TYPES.includes(documentType);
const ADMIN_DOCUMENT_TYPE_GROUPS = [{
  label: "Servicing Documents",
  searchLabel: "Search Servicing Docs",
  options: [...SERVICING_DOCUMENT_TYPES].map((value) => ({
    label: documentTypeNameGenerator(value),
    value
  }))
}, {
  label: "Underwriting Documents",
  searchLabel: "Search Underwriting Docs",
  options: [...UNDERWRITING_DOCUMENT_TYPES].map((value) => ({
    label: documentTypeNameGenerator(value),
    value
  }))
}];
const DocumentTypeSelectorWrapper = styled.div`
  position: relative;
`;
const SearchInputWrapper = styled.div`
  padding: 1rem;
`;
const DocGroup = styled.div`
  padding-right: 0.5rem;
  padding-left: 0.5rem;
`;
const GroupHeader = styled(MenuItem)``;
const DocumentTypeSelector = ({
  documentType,
  setDocumentType,
  placeholder = "+ Add document type",
  ...rest
}) => {
  const [selectedLabel, setSelectedLabel] = useState(() => {
    var _a2;
    if (!documentType) return "";
    if ("options" in rest && rest.options) {
      return ((_a2 = rest.options.find((o) => o.value === documentType)) == null ? void 0 : _a2.label) ?? documentType;
    }
    if ("groups" in rest && rest.groups) {
      const found = rest.groups.map((group) => group.options.find((o) => o.value === documentType)).find(Boolean);
      if (found) return found.label;
    }
    return documentType;
  });
  const [isMenuVisible, setIsMenuVisible] = useState(false);
  const [anchorElement, setAnchorElement] = useState();
  const groupCount = "groups" in rest && rest.groups ? rest.groups.length : 0;
  const [expandedGroups, setExpandedGroups] = useState({});
  const [searchValues, setSearchValues] = useState({});
  const [filteredOptions, setFilteredOptions] = useState(() => {
    if (!("groups" in rest) || !rest.groups) return {};
    return Object.fromEntries(rest.groups.map((g3, i) => [i, g3.options]));
  });
  const onAnchorClick = () => setIsMenuVisible(!isMenuVisible);
  const onSelect = (option) => {
    setSelectedLabel(option.label);
    setDocumentType(option.value);
    setIsMenuVisible(false);
  };
  const toggleGroup = (idx) => {
    setExpandedGroups((prev2) => ({
      ...prev2,
      [idx]: !prev2[idx]
    }));
  };
  const onGroupSearch = (groupIdx, groupOptions, value) => {
    setSearchValues((prev2) => ({
      ...prev2,
      [groupIdx]: value
    }));
    const upper = value.toUpperCase();
    setFilteredOptions((prev2) => ({
      ...prev2,
      [groupIdx]: groupOptions.filter((o) => o.label.toUpperCase().includes(upper))
    }));
  };
  const renderFlatMenu = (options2) => options2.map((option) => /* @__PURE__ */ jsxRuntimeExports.jsx(MenuItem, { onClick: () => onSelect(option), children: option.label }, option.value));
  const renderGroupedMenu = (groups) => groups.map((group, idx) => {
    const isExpanded = !!expandedGroups[idx];
    const isFirst = idx === 0;
    const isLast = idx === groups.length - 1;
    const visibleOptions = filteredOptions[idx] ?? group.options;
    return /* @__PURE__ */ jsxRuntimeExports.jsxs(DocGroup, { style: {
      paddingTop: isFirst ? "0.5rem" : void 0,
      paddingBottom: isLast ? "0.5rem" : void 0
    }, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs(GroupHeader, { onClick: () => toggleGroup(idx), children: [
        isExpanded ? /* @__PURE__ */ jsxRuntimeExports.jsx(CaretDownIcon, { size: "sm", fill: `var(${TOKENS.color.foreground.interaction.accent})` }) : /* @__PURE__ */ jsxRuntimeExports.jsx(CaretRightIcon, { size: "sm", fill: `var(${TOKENS.color.foreground.interaction.accent})` }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Text, { variant: "headerSmall.responsive", element: "p", style: {
          paddingLeft: "0.5rem"
        }, children: group.label })
      ] }),
      isExpanded && /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
        group.searchLabel && /* @__PURE__ */ jsxRuntimeExports.jsx(SearchInputWrapper, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(SearchInput, { id: `doc-type-search-${idx}`, label: group.searchLabel, placeholder: "Search", value: searchValues[idx] ?? "", onChange: (e3) => onGroupSearch(idx, group.options, e3.target.value) }) }),
        visibleOptions.map((option) => /* @__PURE__ */ jsxRuntimeExports.jsx(MenuItem, { onClick: () => onSelect(option), children: option.label }, option.value))
      ] })
    ] }, group.label);
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(DocumentTypeSelectorWrapper, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Button, { variant: "ghost", size: "small", onClick: onAnchorClick, ref: (el) => {
      if (el) setAnchorElement(el);
    }, style: {
      marginLeft: "0.5rem",
      width: "fit-content"
    }, children: selectedLabel || placeholder }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Menu$2, { zIndex: "2", onClickAway: () => setIsMenuVisible(false), visible: isMenuVisible, anchorElement, setWidthToAnchor: false, hasGroups: "groups" in rest && !!rest.groups, menuPosition: "top", overflow: "scroll", height: groupCount > 0 ? "250px" : void 0, width: groupCount > 0 ? "350px" : void 0, children: "options" in rest && rest.options ? renderFlatMenu(rest.options) : "groups" in rest && rest.groups ? renderGroupedMenu(rest.groups) : null })
  ] });
};
const DocumentUploadWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 3rem;
  background-color: var(${TOKENS.color.background.interaction.accentSubdued});
  border: 1px var(${TOKENS.color.border.brand}) dashed;
  margin-top: 0.5rem;

  &:hover {
    background-color: var(
      ${TOKENS.color.background.interaction.accentSubduedHover}
    );
    border-color: var(${TOKENS.color.border.interaction.accentHover}) dashed;
  }

  &:active {
    background-color: var(${TOKENS.color.background.interaction.accentSubdued});
    border-color: var(${TOKENS.color.border.brand});
  }
`;
const StyledLinkButton = styled(LinkButton)`
  color: var(${TOKENS.color.foreground.default});
`;
const StyledIconUpload = styled(UploadIcon)`
  margin-right: 0.75rem;
`;
const StyledIconArrowDown = styled(ArrowDownIcon)`
  margin-right: 0.5rem;
  margin-top: 0.5rem;
`;
const MAX_FILE_SIZE_BYTES = 225e5;
const DEFAULT_ACCEPT = {
  "application/pdf": [".pdf"],
  "text/plain": [".txt"],
  "image/bmp": [".bmp"],
  "image/jpeg": [".jpg", ".jpeg"],
  "image/png": [".png"]
};
const DragAndDropUpload = ({
  onDrop,
  onDropRejected,
  maxFileSize = MAX_FILE_SIZE_BYTES,
  accept = DEFAULT_ACCEPT
}) => {
  const {
    getRootProps,
    getInputProps,
    isDragActive
  } = useDropzone({
    onDrop,
    maxSize: maxFileSize,
    onDropRejected,
    accept
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(DocumentUploadWrapper, { ...getRootProps(), children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("input", { ...getInputProps() }),
    isDragActive ? /* @__PURE__ */ jsxRuntimeExports.jsxs(Text, { variant: "bodySmall.responsive", element: "p", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(StyledIconArrowDown, { size: "sm" }),
      "Drop files here"
    ] }) : /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(StyledIconUpload, {}),
      /* @__PURE__ */ jsxRuntimeExports.jsxs(Text, { variant: "bodySmall.responsive", element: "span", children: [
        "Drag and drop or",
        " ",
        /* @__PURE__ */ jsxRuntimeExports.jsx(StyledLinkButton, { variant: "default", "data-cy": "browse-for-files", fontSize: "bodySmall.responsive", underlined: true, children: "browse for files" })
      ] })
    ] })
  ] });
};
const DocumentUploadFooter = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin: 0.5rem 0;
`;
const CancelUploadButton = styled(Button)`
  margin-right: 0.5rem;
`;
const SubmitUploadButton = styled(Button)`
  white-space: nowrap;
`;
const DocumentUploadFileName = styled(Text)`
  margin: 0.25rem;
  padding: 6px;
  line-height: 0.75rem;
`;
const StyledDocumentsText = styled(Text)`
  margin-bottom: 0.5rem;
`;
const ReadyToUploadText = styled(Text)`
  color: var(${TOKENS.color.foreground.subdued});
`;
const UploadList = ({
  uploadingDocs,
  isUploading,
  removeUploadingDoc,
  setDocumentType,
  removeAllUploadingDocs,
  submitAllUploadingDocs,
  isUploadDisabled,
  selectorGroups,
  selectorOptions
}) => {
  const resolvedSelectorGroups = selectorGroups ?? ADMIN_DOCUMENT_TYPE_GROUPS;
  const containsServicingDocs = uploadingDocs.some((document2) => isServicingDocument(document2.documentType ?? ""));
  const containsUnderwritingDocs = uploadingDocs.some((document2) => isUnderwritingDocument(document2.documentType ?? ""));
  const isFlatMode = !!selectorOptions;
  const selectorProps = selectorOptions ? {
    options: selectorOptions
  } : {
    groups: resolvedSelectorGroups
  };
  const renderDocToUpload = (document2, idx) => /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { style: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between"
  }, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { style: {
      display: "flex",
      alignItems: "center"
    }, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(DocumentIcon, { height: "24", width: "24" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(DocumentTypeSelector, { documentType: document2.documentType ?? "", setDocumentType: (docType) => setDocumentType(idx, docType), ...selectorProps }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(DocumentUploadFileName, { variant: "bodySmall.responsive", element: "p", children: document2.name || "Missing Document Name" })
    ] }),
    !isUploading && /* @__PURE__ */ jsxRuntimeExports.jsx(IconButton, { variant: "destructiveGhost", size: "small", onClick: () => removeUploadingDoc(idx), children: /* @__PURE__ */ jsxRuntimeExports.jsx(CloseIcon, { size: "sm" }) })
  ] }, idx);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    isFlatMode ? uploadingDocs.map((document2, idx) => renderDocToUpload(document2, idx)) : /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
      containsServicingDocs && /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(StyledDocumentsText, { variant: "headerXSmall.desktop", element: "h2", children: "Servicing Documents" }),
        uploadingDocs.map((document2, idx) => {
          if (isServicingDocument(document2.documentType ?? "")) {
            return renderDocToUpload(document2, idx);
          }
          return null;
        })
      ] }),
      containsUnderwritingDocs && /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(StyledDocumentsText, { variant: "headerXSmall.desktop", element: "h2", children: "Underwriting Documents" }),
        uploadingDocs.map((document2, idx) => {
          if (isUnderwritingDocument(document2.documentType ?? "")) {
            return renderDocToUpload(document2, idx);
          }
          return null;
        })
      ] }),
      uploadingDocs.map((document2, idx) => {
        if (!document2.documentType) {
          return renderDocToUpload(document2, idx);
        }
        return null;
      })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(DocumentUploadFooter, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(ReadyToUploadText, { variant: "bodySmall.responsive", element: "p", children: uploadingDocs.length > 1 ? `${uploadingDocs.length} items ready to upload` : `1 item ready to upload` }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { style: {
        display: "flex"
      }, children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(CancelUploadButton, { variant: "ghost", size: "small", disabled: isUploading, onClick: removeAllUploadingDocs, children: "Cancel" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(SubmitUploadButton, { size: "small", loading: isUploading, loadingText: "Uploading...", disabled: isUploadDisabled, onClick: submitAllUploadingDocs, children: "Upload Documents" })
      ] })
    ] })
  ] });
};
const THEMES = {
  PURPLE_THEME,
  NATIONWIDE_THEME,
  USAA_THEME,
  TRANSAMERICA_THEME,
  EQUITABLE_THEME,
  LANTERN_THEME,
  BESTOW_THEME,
  AXCELUS_THEME
};
export {
  ADMIN_DOCUMENT_TYPE_GROUPS,
  APIGearIllustration,
  APlusRatingBadge,
  AXCELUS_THEME,
  AccordianDetailsHeader,
  Accordion,
  AddOptionIcon,
  AddressPinIcon,
  AdyenPaymentContainer,
  AffordableIllustration,
  AgentAppIcon,
  AgentShieldIcon,
  AmexLogo,
  AmexLogoLarge,
  AmexLogoSmall,
  ApplyOnlineStamp,
  ArrowDownIcon,
  ArrowLeftIcon,
  ArrowRightIcon,
  ArrowUpIcon,
  AuditIcon,
  AutomaticIcon,
  Avatar,
  AvatarCircle,
  AvatarIcon,
  BADGE_SIZES,
  BADGE_TEXT_TYPES,
  BADGE_TYPES,
  BANNER_VARIANTS,
  B as BASE_STATIC_BUCKET_MAP,
  BESTOW_ENTERPRISE_CONFIG,
  BESTOW_ENTERPRISE_TOKENS,
  BESTOW_THEME,
  BREAKPOINTS,
  BUTTON_GROUP_SIZES,
  Badge,
  BadgeIcon,
  BankIcon,
  BankLogo,
  BankLogoLarge,
  BankLogoSmall,
  BankWithLinesIcon,
  Banner,
  BannerEnd,
  BannerStart,
  BellIcon,
  BestowFoundationLogo,
  Button,
  ButtonGroup,
  ButtonGroupContainer,
  ButtonGroupInput,
  ButtonGroupLabel,
  ButtonLink,
  CARD_VARIANTS,
  CalendarIcon$1 as CalendarIcon,
  Card,
  CardActionFooter,
  CardBody,
  CardFooter,
  CardGutters,
  CardHeader,
  CareerDevIllustration,
  CaretDownIcon,
  CaretLeftCircleIcon,
  CaretLeftIcon,
  CaretRightCircleIcon,
  CaretRightIcon,
  CaretUpIcon,
  CashPaymentIcon,
  CertifiedRibbonIcon,
  CertifiedSSLBadge,
  ChartLegend,
  ChartTooltip,
  ChatFilledIcon,
  ChatIcon,
  CheckboxInput,
  CheckboxOptionWithPrice,
  CheckmarkCircleIcon,
  CheckmarkIcon,
  CheckmarkShorterIcon,
  ChildcareIcon,
  ClipboardIcon,
  ClockIcon,
  ClockIllustration,
  CloseIcon,
  ConfettiIcon,
  ContactInfo,
  CopyIcon,
  CreditCardIcon,
  CreditScoreIcon,
  CurrencyInput,
  CursorIcon,
  DashboardIcon,
  DateInput,
  DatePicker,
  DatePickerStyles,
  DateRangePicker,
  DecreaseFaceIcon,
  DeletePopover,
  DinersClubLogo,
  DinersClubLogoLarge,
  DinersClubLogoSmall,
  DiscoverLogo,
  DiscoverLogoLarge,
  DiscoverLogoSmall,
  Divider,
  DocumentIcon,
  DocumentLoadingIcon,
  DocumentTypeSelector,
  DollarIcon,
  DownloadDocumentIcon,
  DownloadIcon,
  DragAndDropUpload,
  Drawer,
  EQUITABLE_THEME,
  EducationIcon,
  EldercareIcon,
  EmailIcon,
  EmailMarketingIllustration,
  EncryptionIcon,
  ErrorIcon,
  EveryPolicyBackedStamp,
  ExpandIcon,
  EyeClosedIcon,
  EyeIcon,
  FileFolderIcon,
  FileUpload,
  FileUploadProvider,
  Filter$1 as Filter,
  FilterIcon,
  FlagIcon,
  FlashIcon,
  FlexPTOIllustration,
  FocusRing,
  FolderIcon,
  z as FontLoader,
  F as FontLoaderFonts,
  GearIcon,
  HandoffCompleteIcon,
  HandoffIcon,
  HeaderAndBadge,
  HeartCircleIcon,
  HelpIcon,
  HomeIcon,
  HorizontalDetailsDropdownIcon,
  HorizontalDotsIcon,
  INPUT_NUMERIC_VARIANT_STYLE_PROPS,
  INPUT_STYLE_PROPS,
  ITINInput,
  IconButton,
  IconContainer$2 as IconContainer,
  IdVerifyIcon,
  InAppTileIllustration,
  InfoCircleIcon,
  InputContainer,
  InputElementStyles,
  InputWrapperStyles,
  InstantHandIllustration,
  JobSearchIcon,
  K as KindredConfigProvider,
  KindredHead,
  KindredProvider,
  KitchenSink,
  LANTERN_THEME,
  LINK_SIZE_TYPE,
  LINK_VARIANT_TYPE,
  LOGO_COLOR_TYPES,
  LabelTextSpan,
  LabelTextStyles,
  LandersIllustration,
  Link,
  LinkButton,
  LinkIcon,
  LoadingChart,
  LoadingIcon,
  LockIcon,
  LoginIcon,
  Logo,
  LogoutIcon,
  MENU_ITEM_VARIANT,
  MailIcon,
  MastercardLogo,
  MastercardLogoLarge,
  MastercardLogoSmall,
  MedBenefitsIllustration,
  MegaRadioInput,
  MegaRadioInputText,
  MegaRadioWrapper,
  MegaphoneIcon,
  MegaphoneNewIcon,
  Menu$2 as Menu,
  MenuContext,
  MenuGroup,
  MenuIcon,
  MenuItem,
  MinusCircleIcon,
  MinusIcon,
  MobileIllustration,
  Modal,
  ModalBody,
  ModalContainer,
  ModalFooter,
  ModalProvider,
  ModalTitle,
  MoneyPaymentIcon,
  NATIONWIDE_THEME,
  NewTabIcon,
  NoMedExamIllustration,
  NumericInput,
  OpenCloseCaret,
  PHONE_INPUT_FORMATS,
  POPOVER_POSITIONS,
  PURPLE_THEME,
  PanelLeftIcon,
  PaperClipIcon,
  PasswordInput,
  PaymentCards,
  PaymentCardsLogo,
  PenIcon,
  PencilIcon,
  PercentIcon,
  PercentInput,
  PercentageBar,
  PhoneIcon,
  PhoneInput,
  PieChartIcon,
  PlusCircleIcon,
  PlusIcon,
  PolicyOverview,
  PottedPlantIcon,
  Pseudostate,
  QuestionMarkCircleIcon,
  QuestionMarkIcon,
  RESIZE_MODE_OPTIONS,
  RadioContainedInput,
  RadioInput,
  RawFocusRing,
  ReactDatePicker,
  RetryIcon,
  RiderSelector,
  SERVICING_DOCUMENT_TYPES,
  SSNInput,
  STATIC_TOKENS,
  STEPPER_SIZES,
  STEPPER_STAGES,
  SavingsBankIcon,
  ScholarshipsIllustration,
  SearchIcon,
  SearchInput,
  SegmentedControl,
  SelectInput,
  SendIcon,
  SettingsSlidersIcon,
  ShareIcon,
  ShieldIcon,
  SignDocumentIcon,
  Signature,
  SignatureExampleIcon,
  Skeleton,
  SliderInput,
  SnackIllustration,
  SortArrowBothIcon,
  SortArrowDownIcon,
  SortArrowUpIcon,
  Spinner,
  SpinnerIcon,
  Stepper,
  StepperSection,
  StripeStyleWrapper,
  StyledCalendarHeader$1 as StyledCalendarHeader,
  StyledCaretLeftIcon$1 as StyledCaretLeftIcon,
  StyledCaretRightIcon$1 as StyledCaretRightIcon,
  StyledCheckboxBullet,
  StyledCustomInput,
  StyledHeader$1 as StyledHeader,
  StyledHeaderWrapper,
  StyledTextArea,
  StyledTextInput,
  StyledWrapper$1 as StyledWrapper,
  SwagIllustration,
  TABS_DIVIDER,
  THEMES,
  TOAST_POSITIONS,
  TOAST_TYPES,
  TOKENS,
  TRANSAMERICA_THEME,
  Tab$1 as Tab,
  TabNavigation,
  TableColumnEditor,
  TableColumnEditorDropdown,
  TableSortControl,
  TableSortIcon,
  TabsComponent as Tabs,
  Tag,
  TaskListCompleteIcon,
  TaskListIcon,
  Text,
  TextAreaContainer,
  TextAreaElementStyles,
  TextAreaInput,
  TextAreaLabelTextSpan,
  TextAreaLabelTextStyles,
  TextInput,
  TextMessageIcon,
  ThirtyDayBadge,
  ThirtyDayStamp,
  Toast,
  ToastContainer,
  Toggle,
  TrashIcon,
  TrustIllustration,
  TypeaheadInput,
  UNDERWRITING_DOCUMENT_TYPES,
  USAA_THEME,
  UnderwriteIcon,
  UnlockIcon,
  UploadFileStatus,
  UploadIcon,
  UploadList,
  UserAddIcon,
  UserContactCardIcon,
  VaseIcon,
  VisaLogo,
  VisaLogoLarge,
  VisaLogoSmall,
  WarningIcon,
  WillDocumentIcon,
  B2 as addToast,
  A as checkButtonThemeFormat,
  checkEnterpriseTypography,
  checkTypographyFormat,
  clearToastWaitingQueue,
  createContext,
  currencyCleaveOptions,
  dateCleaveOptions,
  dismissToast,
  documentTypeNameGenerator,
  e as extendsType,
  fontSizeRem,
  getAvatarColor,
  getResolvedBorderValues,
  g as getStaticAssetUrl,
  getStripeInputOptions,
  getStripePaymentElementsStyles,
  isServicingDocument,
  isToastActive,
  isUnderwritingDocument,
  kindredShouldForwardProp,
  C as linksForTheme,
  radioContainedInputStates,
  ssnCleaveOptions,
  stringifyBorderProps,
  textAreaStates,
  textInputStates$1 as textInputStates,
  updateToast,
  useAccordionContext,
  useAccordionItemContext,
  useAdyenStyleConfig,
  useArrayRef,
  useCallbackRef,
  useControlledState$1 as useControlledState,
  useDrawer,
  useDrawerContext,
  useFileUpload,
  useFileUploadContext,
  useFilterContext,
  useMenu,
  usePopover,
  w as withKindredTheme
};
